// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@bcgov/bc-sans/css/BCSans.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 16%27%3e%3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M4 8h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* See Tailwind docs for distinction between base, components, and utilities - https://tailwindcss.com/docs/adding-custom-styles#using-css-and-layer */
*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/* ! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com */
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: BCSans, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
[type='text'],input:where(:not([type])),[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select{
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 rgba(0,0,0,0);
}
[type='text']:focus, input:where(:not([type])):focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(1px + 0px) #2563eb, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}
input::-moz-placeholder, textarea::-moz-placeholder{
  color: #6b7280;
  opacity: 1;
}
input::placeholder,textarea::placeholder{
  color: #6b7280;
  opacity: 1;
}
::-webkit-datetime-edit-fields-wrapper{
  padding: 0;
}
::-webkit-date-and-time-value{
  min-height: 1.5em;
  text-align: inherit;
}
::-webkit-datetime-edit{
  display: inline-flex;
}
::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field{
  padding-top: 0;
  padding-bottom: 0;
}
select{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
[multiple],[size]:where(select:not([size="1"])){
  background-image: none;
  background-image: initial;
  background-position: 0 0;
  background-position: initial;
  background-repeat: repeat;
  background-repeat: initial;
  background-size: auto auto;
  background-size: initial;
  padding-right: 0.75rem;
  -webkit-print-color-adjust: inherit;
          print-color-adjust: inherit;
}
[type='checkbox'],[type='radio']{
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  padding: 0;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #2563eb;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  --tw-shadow: 0 0 rgba(0,0,0,0);
}
[type='checkbox']{
  border-radius: 0px;
}
[type='radio']{
  border-radius: 100%;
}
[type='checkbox']:focus,[type='radio']:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(2px + 2px) #2563eb, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
[type='checkbox']:checked,[type='radio']:checked{
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
[type='checkbox']:checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@media (forced-colors: active) {
  [type='checkbox']:checked{
    -webkit-appearance: auto;
       -moz-appearance: auto;
            appearance: auto;
  }
}
[type='radio']:checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@media (forced-colors: active) {
  [type='radio']:checked{
    -webkit-appearance: auto;
       -moz-appearance: auto;
            appearance: auto;
  }
}
[type='checkbox']:checked:hover,[type='checkbox']:checked:focus,[type='radio']:checked:hover,[type='radio']:checked:focus{
  border-color: transparent;
  background-color: currentColor;
}
[type='checkbox']:indeterminate{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
@media (forced-colors: active) {
  [type='checkbox']:indeterminate{
    -webkit-appearance: auto;
       -moz-appearance: auto;
            appearance: auto;
  }
}
[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus{
  border-color: transparent;
  background-color: currentColor;
}
[type='file']{
  background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;
  background: initial;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: inherit;
  line-height: inherit;
}
[type='file']:focus{
  outline: 1px solid ButtonText;
  outline: 1px auto -webkit-focus-ring-color;
}
.wysiwyg{
  text-align: left;
}
.wysiwyg h2{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(106, 107, 112, 1);
  border-color: rgba(106, 107, 112, var(--tw-border-opacity, 1));
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgba(44, 76, 94, 1);
  color: rgba(44, 76, 94, var(--tw-text-opacity, 1));
}
.wysiwyg h3{
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgba(44, 76, 94, 1);
  color: rgba(44, 76, 94, var(--tw-text-opacity, 1));
}
.wysiwyg ol{
  list-style-type: decimal;
  padding-left: 1.5rem;
}
.wysiwyg ul{
  list-style-type: disc;
  padding-left: 1.5rem;
}
.wysiwyg div{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.wysiwyg p{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.wysiwyg a{
  --tw-text-opacity: 1;
  color: rgba(37, 99, 235, 1);
  color: rgba(37, 99, 235, var(--tw-text-opacity, 1));
  text-decoration-line: underline;
  text-underline-offset: 2px;
}
.wysiwyg a:visited{
  color: rgb(147, 51, 234);
}
.container{
  width: 100%;
}
@media (min-width: 640px){
  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){
  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){
  .container{
    max-width: 1280px;
  }
}
.aspect-h-2{
  --tw-aspect-h: 2;
}
.aspect-h-7{
  --tw-aspect-h: 7;
}
.aspect-w-10{
  position: relative;
  padding-bottom: calc(var(--tw-aspect-h) / 10 * 100%);
  padding-bottom: calc(var(--tw-aspect-h) / var(--tw-aspect-w) * 100%);
  --tw-aspect-w: 10;
}
.aspect-w-10 > *{
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.aspect-w-2{
  position: relative;
  padding-bottom: calc(var(--tw-aspect-h) / 2 * 100%);
  padding-bottom: calc(var(--tw-aspect-h) / var(--tw-aspect-w) * 100%);
  --tw-aspect-w: 2;
}
.aspect-w-2 > *{
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.ql-video{
  height: 24rem;
  width: 100%;
}
.inline-url{
  --tw-text-opacity: 1;
  color: rgba(37, 99, 235, 1);
  color: rgba(37, 99, 235, var(--tw-text-opacity, 1));
  text-decoration-line: underline;
  text-underline-offset: 2px;
}
.inline-url:visited{
  color: rgb(147, 51, 234);
}
.btn-contained{
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.btn-contained > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * 0);
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * (1 - 0));
  margin-left: calc(0.5rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(0.5rem * calc(1 - 0));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.btn-contained{
  border-radius: 0.5rem;
  border-width: 1px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgba(44, 76, 94, 1);
  background-color: rgba(44, 76, 94, var(--tw-bg-opacity, 1));
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity, 1));
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.btn-contained:hover{
  opacity: 0.8;
}
.btn-contained:active{
  opacity: 1;
}
.btn-outlined{
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.btn-outlined > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * 0);
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * (1 - 0));
  margin-left: calc(0.5rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(0.5rem * calc(1 - 0));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.btn-outlined{
  border-radius: 0.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(44, 76, 94, 1);
  border-color: rgba(44, 76, 94, var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(44, 76, 94, 1);
  color: rgba(44, 76, 94, var(--tw-text-opacity, 1));
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.btn-outlined:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(245, 245, 246, 1);
  background-color: rgba(245, 245, 246, var(--tw-bg-opacity, 1));
}
.btn-outlined:active{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
}
.btn-icon{
  height: 1.25rem;
  width: 1.25rem;
  fill: currentColor;
}
/* Button base class */
.btn{
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.btn > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * 0);
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * (1 - 0));
  margin-left: calc(0.5rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(0.5rem * calc(1 - 0));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.btn{
  border-radius: 1.5rem;
}
/* Button base class for icon only buttons */
/* Button styles */
.btn-primary{
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.btn-primary > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * 0);
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * (1 - 0));
  margin-left: calc(0.5rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(0.5rem * calc(1 - 0));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.btn-primary{
  border-radius: 1.5rem;
  --tw-bg-opacity: 1;
  background-color: rgba(48, 109, 138, 1);
  background-color: rgba(48, 109, 138, var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgba(218, 238, 243, 1);
  color: rgba(218, 238, 243, var(--tw-text-opacity, 1));
}
.btn-primary:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(44, 76, 94, 1);
  background-color: rgba(44, 76, 94, var(--tw-bg-opacity, 1));
}
.btn-primary:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(2px + 2px) #2563eb, 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(137, 197, 215, var(--tw-ring-opacity, 1));
}
.btn-secondary{
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.btn-secondary > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * 0);
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * (1 - 0));
  margin-left: calc(0.5rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(0.5rem * calc(1 - 0));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.btn-secondary{
  border-radius: 1.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(40, 65, 81, 1);
  border-color: rgba(40, 65, 81, var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgba(40, 65, 81, 1);
  color: rgba(40, 65, 81, var(--tw-text-opacity, 1));
}
.btn-secondary:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(218, 238, 243, 1);
  background-color: rgba(218, 238, 243, var(--tw-bg-opacity, 1));
}
.btn-secondary:focus{
  --tw-bg-opacity: 1;
  background-color: rgba(186, 222, 231, 1);
  background-color: rgba(186, 222, 231, var(--tw-bg-opacity, 1));
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(2px + 2px) #2563eb, 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(40, 65, 81, var(--tw-ring-opacity, 1));
}
.btn-tertiary{
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.btn-tertiary > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * 0);
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * (1 - 0));
  margin-left: calc(0.5rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(0.5rem * calc(1 - 0));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.btn-tertiary{
  border-radius: 1.5rem;
  margin: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgba(40, 65, 81, 1);
  color: rgba(40, 65, 81, var(--tw-text-opacity, 1));
}
.btn-tertiary:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(218, 238, 243, 1);
  background-color: rgba(218, 238, 243, var(--tw-bg-opacity, 1));
}
.btn-tertiary:focus{
  --tw-bg-opacity: 1;
  background-color: rgba(186, 222, 231, 1);
  background-color: rgba(186, 222, 231, var(--tw-bg-opacity, 1));
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(2px + 2px) #2563eb, 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(40, 65, 81, var(--tw-ring-opacity, 1));
}
/* Button sizes */
/* Combine with btn-primary, btn-secondary, or btn-tertiary */
.btn-sm{
  height: 2.25rem;
  min-width: 6rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 0.75rem;
  line-height: 1rem;
}
@media (min-width: 1280px){
  .btn-sm{
    height: 2rem;
    min-width: 8rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
.btn-sm { /* Desktop ~(120x32) 14px font */
  }
.btn-md{
  height: 2.75rem;
  min-width: 8rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
}
@media (min-width: 1280px){
  .btn-md{
    height: 2.5rem;
    min-width: 10rem;
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.btn-md { /* Desktop ~(160x40) 16px font */
  }
.btn-lg{
  height: 3.5rem;
  min-width: 10rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
}
@media (min-width: 1280px){
  .btn-lg{
    height: 3rem;
    min-width: 13rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}
.btn-lg { /* Desktop ~(200x48) 18px font */
  }
/* Icon only buttons */
.btn-sm-icon{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
}
.btn-sm-icon svg{
  margin: 0px;
  display: block;
  height: 100%;
  width: 100%;
  padding: 0px;
  vertical-align: middle;
}
.btn-sm-icon{
  height: 2.75rem;
  width: 2.75rem;
}
@media (min-width: 1280px){
  .btn-sm-icon{
    height: 2rem;
    width: 2rem;
  }
}
.btn-sm-icon { /* Desktop ~32x32 */
  }
.btn-md-icon{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
}
.btn-md-icon svg{
  margin: 0px;
  display: block;
  height: 100%;
  width: 100%;
  padding: 0px;
  vertical-align: middle;
}
.btn-md-icon{
  height: 3rem;
  width: 3rem;
}
@media (min-width: 768px){
  .btn-md-icon{
    height: 3.5rem;
    width: 3.5rem;
  }
}
@media (min-width: 1280px){
  .btn-md-icon{
    height: 2.5rem;
    width: 2.5rem;
  }
}
.btn-md-icon { /* Desktop ~40x40 */
  }
.btn-lg-icon{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
}
.btn-lg-icon svg{
  margin: 0px;
  display: block;
  height: 100%;
  width: 100%;
  padding: 0px;
  vertical-align: middle;
}
.btn-lg-icon{
  height: 3.5rem;
  width: 3.5rem;
}
@media (min-width: 768px){
  .btn-lg-icon{
    height: 4rem;
    width: 4rem;
  }
}
@media (min-width: 1280px){
  .btn-lg-icon{
    height: 3rem;
    width: 3rem;
  }
}
.btn-lg-icon { /* Desktop ~48x48 */
  }
.btn-xl-icon{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
}
.btn-xl-icon svg{
  margin: 0px;
  display: block;
  height: 100%;
  width: 100%;
  padding: 0px;
  vertical-align: middle;
}
.btn-xl-icon{
  height: 4rem;
  width: 4rem;
}
@media (min-width: 768px){
  .btn-xl-icon{
    height: 5rem;
    width: 5rem;
  }
}
@media (min-width: 1280px){
  .btn-xl-icon{
    height: 3.5rem;
    width: 3.5rem;
  }
}
/* Auto-formatting for icons on buttons with text (Do not use directly) */
.btn-sm svg{
  height: 0.875rem;
  width: 0.875rem;
  fill: currentColor; /* All ~14px */
}
.btn-md svg{
  height: 1rem;
  width: 1rem;
  fill: currentColor; /* All ~16px */
}
.btn-lg svg{
  height: 1.25rem;
  width: 1.25rem;
  fill: currentColor; /* All ~20px */
}
/* Auto-formatting for icon-only buttons (Do not use directly) */
.btn-sm-icon svg{
  height: 1.25rem;
  width: 1.25rem;
  fill: currentColor;
}
@media (min-width: 1280px){
  .btn-sm-icon svg{
    height: 0.75rem;
    width: 0.75rem;
  }
}
.btn-sm-icon svg { /* Desktop ~12px */
  }
.btn-md-icon svg{
  height: 1.5rem;
  width: 1.5rem;
  fill: currentColor; /* All ~24px */
}
.btn-lg-icon svg{
  height: 1.75rem;
  width: 1.75rem;
  fill: currentColor; /* All ~28px */
}
.btn-xl-icon svg{
  height: 2rem;
  width: 2rem;
  fill: currentColor; /* All ~32px */
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-1{
  bottom: -0.25rem;
}
.-bottom-12{
  bottom: -3rem;
}
.-bottom-5{
  bottom: -1.25rem;
}
.-bottom-8{
  bottom: -2rem;
}
.-left-8{
  left: -2rem;
}
.-right-1{
  right: -0.25rem;
}
.-right-4{
  right: -1rem;
}
.-top-16{
  top: -4rem;
}
.-top-7{
  top: -1.75rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-2{
  bottom: 0.5rem;
}
.bottom-24{
  bottom: 6rem;
}
.left-0{
  left: 0px;
}
.left-2{
  left: 0.5rem;
}
.right-0{
  right: 0px;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-5{
  right: 1.25rem;
}
.right-6{
  right: 1.5rem;
}
.top-0{
  top: 0px;
}
.top-10{
  top: 2.5rem;
}
.top-14{
  top: 3.5rem;
}
.top-16{
  top: 4rem;
}
.top-2{
  top: 0.5rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-5{
  top: 1.25rem;
}
.top-6{
  top: 1.5rem;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.order-first{
  order: -9999;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-11{
  grid-column: span 11 / span 11;
}
.col-span-12{
  grid-column: span 12 / span 12;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-span-4{
  grid-column: span 4 / span 4;
}
.col-span-5{
  grid-column: span 5 / span 5;
}
.col-span-6{
  grid-column: span 6 / span 6;
}
.col-span-7{
  grid-column: span 7 / span 7;
}
.col-span-8{
  grid-column: span 8 / span 8;
}
.row-auto{
  grid-row: auto;
}
.float-right{
  float: right;
}
.m-1{
  margin: 0.25rem;
}
.m-10{
  margin: 2.5rem;
}
.m-2{
  margin: 0.5rem;
}
.m-3{
  margin: 0.75rem;
}
.m-4{
  margin: 1rem;
}
.m-5{
  margin: 1.25rem;
}
.m-6{
  margin: 1.5rem;
}
.m-8{
  margin: 2rem;
}
.m-auto{
  margin: auto;
}
.-mx-1\\.5{
  margin-left: -0.375rem;
  margin-right: -0.375rem;
}
.-my-1\\.5{
  margin-top: -0.375rem;
  margin-bottom: -0.375rem;
}
.-my-2{
  margin-top: -0.5rem;
  margin-bottom: -0.5rem;
}
.mx-0\\.5{
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-10{
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-5{
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-6{
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5{
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.-mb-14{
  margin-bottom: -3.5rem;
}
.-mb-3{
  margin-bottom: -0.75rem;
}
.-ml-10{
  margin-left: -2.5rem;
}
.-ml-20{
  margin-left: -5rem;
}
.-ml-3{
  margin-left: -0.75rem;
}
.-mr-1{
  margin-right: -0.25rem;
}
.-mt-10{
  margin-top: -2.5rem;
}
.-mt-12{
  margin-top: -3rem;
}
.-mt-14{
  margin-top: -3.5rem;
}
.-mt-4{
  margin-top: -1rem;
}
.-mt-6{
  margin-top: -1.5rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-20{
  margin-bottom: 5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-10{
  margin-left: 2.5rem;
}
.ml-16{
  margin-left: 4rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-24{
  margin-left: 6rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-6{
  margin-left: 1.5rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-5{
  margin-right: 1.25rem;
}
.mr-6{
  margin-right: 1.5rem;
}
.mr-8{
  margin-right: 2rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-auto{
  margin-top: auto;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.contents{
  display: contents;
}
.hidden{
  display: none;
}
.size-10{
  width: 2.5rem;
  height: 2.5rem;
}
.size-full{
  width: 100%;
  height: 100%;
}
.h-0{
  height: 0px;
}
.h-1{
  height: 0.25rem;
}
.h-1\\/2{
  height: 50%;
}
.h-10{
  height: 2.5rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\/3-screen{
  height: 66vh;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-28{
  height: 7rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\/4{
  height: 75%;
}
.h-32{
  height: 8rem;
}
.h-36{
  height: 9rem;
}
.h-4{
  height: 1rem;
}
.h-4\\/5-screen{
  height: 80vh;
}
.h-40{
  height: 10rem;
}
.h-44{
  height: 11rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-52{
  height: 13rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-72{
  height: 18rem;
}
.h-8{
  height: 2rem;
}
.h-80{
  height: 20rem;
}
.h-9{
  height: 2.25rem;
}
.h-9\\/10-screen{
  height: 90vh;
}
.h-96{
  height: 24rem;
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-screen{
  height: 100vh;
}
.max-h-3\\/4-screen{
  max-height: 75vh;
}
.max-h-60{
  max-height: 15rem;
}
.max-h-72{
  max-height: 18rem;
}
.max-h-80{
  max-height: 20rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-0{
  min-height: 0px;
}
.min-h-36{
  min-height: 9rem;
}
.min-h-40{
  min-height: 10rem;
}
.min-h-52{
  min-height: 13rem;
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.w-0{
  width: 0px;
}
.w-1{
  width: 0.25rem;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/2-screen{
  width: 50vw;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-1\\/4{
  width: 25%;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-11\\/12{
  width: 91.666667%;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-2\\/6{
  width: 33.333333%;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\/4{
  width: 75%;
}
.w-3\\/4-screen{
  width: 75vw;
}
.w-3\\/5{
  width: 60%;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-4\\/5{
  width: 80%;
}
.w-4\\/5-screen{
  width: 80vw;
}
.w-40{
  width: 10rem;
}
.w-44{
  width: 11rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-52{
  width: 13rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-96{
  width: 24rem;
}
.w-\\[25vw\\]{
  width: 25vw;
}
.w-\\[55vw\\]{
  width: 55vw;
}
.w-\\[95vw\\]{
  width: 95vw;
}
.w-auto{
  width: auto;
}
.w-full{
  width: 100%;
}
.w-px{
  width: 1px;
}
.w-screen{
  width: 100vw;
}
.min-w-0{
  min-width: 0px;
}
.min-w-\\[10rem\\]{
  min-width: 10rem;
}
.min-w-full{
  min-width: 100%;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-96{
  max-width: 24rem;
}
.max-w-\\[378px\\]{
  max-width: 378px;
}
.max-w-\\[46rem\\]{
  max-width: 46rem;
}
.max-w-\\[760px\\]{
  max-width: 760px;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-prose{
  max-width: 65ch;
}
.max-w-screen-lg{
  max-width: 1024px;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1 0%;
}
.flex-auto{
  flex: 1 1 auto;
}
.flex-none{
  flex: none;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.table-auto{
  table-layout: auto;
}
.table-fixed{
  table-layout: fixed;
}
.origin-top{
  transform-origin: top;
}
.origin-top-right{
  transform-origin: top right;
}
.-translate-x-0{
  --tw-translate-x: -0px;
  transform: translate(-0px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-1{
  --tw-translate-x: -0.25rem;
  transform: translate(-0.25rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full{
  --tw-translate-x: -100%;
  transform: translate(-100%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(0px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(0.25rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-6{
  --tw-translate-x: 1.5rem;
  transform: translate(1.5rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full{
  --tw-translate-x: 100%;
  transform: translate(100%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-6{
  --tw-rotate: -6deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(-6deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(180deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-0{
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0) scaleY(0);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1) scaleY(1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(.95) scaleY(.95);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse-blur{
  0%, 50%, 100%{
    transform: scale(1);
    filter: blur(0px);
  }
  25%{
    transform: scale(0.6);
    filter: blur(2px);
  }
  75%{
    transform: scale(1.4);
    filter: blur(2px);
  }
}
.animate-pulse-blur{
  animation: pulse-blur 2.5s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-text{
  cursor: text;
}
.touch-auto{
  touch-action: auto;
}
.select-none{
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.resize-none{
  resize: none;
}
.list-inside{
  list-style-position: inside;
}
.list-outside{
  list-style-position: outside;
}
.list-decimal{
  list-style-type: decimal;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.columns-1{
  -moz-columns: 1;
       columns: 1;
}
.columns-2{
  -moz-columns: 2;
       columns: 2;
}
.break-inside-avoid-column{
  -moz-column-break-inside: avoid;
       break-inside: avoid-column;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-11{
  grid-template-columns: repeat(11, minmax(0, 1fr));
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-6{
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-7{
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-8{
  grid-template-columns: repeat(8, minmax(0, 1fr));
}
.grid-rows-3{
  grid-template-rows: repeat(3, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-nowrap{
  flex-wrap: nowrap;
}
.place-content-center{
  align-content: center;
  justify-content: center;
  place-content: center;
}
.content-between{
  align-content: space-between;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.justify-evenly{
  justify-content: space-evenly;
}
.justify-stretch{
  justify-content: stretch;
}
.justify-items-stretch{
  justify-items: stretch;
}
.gap-1{
  gap: 0.25rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-px{
  gap: 1px;
}
.gap-x-2{
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
}
.gap-x-3{
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
}
.gap-x-4{
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}
.gap-x-6{
  -moz-column-gap: 1.5rem;
       column-gap: 1.5rem;
}
.gap-y-4{
  row-gap: 1rem;
}
.gap-y-6{
  row-gap: 1.5rem;
}
.gap-y-8{
  row-gap: 2rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * 0);
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * (1 - 0));
  margin-left: calc(0.25rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(0.25rem * calc(1 - 0));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(2.5rem * 0);
  margin-right: calc(2.5rem * var(--tw-space-x-reverse));
  margin-left: calc(2.5rem * (1 - 0));
  margin-left: calc(2.5rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(2.5rem * calc(1 - 0));
  margin-left: calc(2.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * 0);
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * (1 - 0));
  margin-left: calc(0.5rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(0.5rem * calc(1 - 0));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * 0);
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * (1 - 0));
  margin-left: calc(0.75rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(0.75rem * calc(1 - 0));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * 0);
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * (1 - 0));
  margin-left: calc(1rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(1rem * calc(1 - 0));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1.25rem * 0);
  margin-right: calc(1.25rem * var(--tw-space-x-reverse));
  margin-left: calc(1.25rem * (1 - 0));
  margin-left: calc(1.25rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(1.25rem * calc(1 - 0));
  margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * 0);
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * (1 - 0));
  margin-left: calc(2rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(2rem * calc(1 - 0));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * (1 - 0));
  margin-top: calc(0.25rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(0.25rem * calc(1 - 0));
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * 0);
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * (1 - 0));
  margin-top: calc(2.5rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(2.5rem * calc(1 - 0));
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * 0);
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-16 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(4rem * (1 - 0));
  margin-top: calc(4rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(4rem * calc(1 - 0));
  margin-top: calc(4rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(4rem * 0);
  margin-bottom: calc(4rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * (1 - 0));
  margin-top: calc(0.5rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(0.5rem * calc(1 - 0));
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * 0);
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * (1 - 0));
  margin-top: calc(0.75rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(0.75rem * calc(1 - 0));
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * 0);
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * (1 - 0));
  margin-top: calc(1rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(1rem * calc(1 - 0));
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * 0);
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * (1 - 0));
  margin-top: calc(1.25rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(1.25rem * calc(1 - 0));
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * 0);
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * (1 - 0));
  margin-top: calc(1.5rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(1.5rem * calc(1 - 0));
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * 0);
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * (1 - 0));
  margin-top: calc(2rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(2rem * calc(1 - 0));
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * 0);
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.space-y-reverse > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 1;
}
.divide-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(2px * 0);
  border-right-width: calc(2px * var(--tw-divide-x-reverse));
  border-left-width: calc(2px * (1 - 0));
  border-left-width: calc(2px * (1 - var(--tw-divide-x-reverse)));
  border-left-width: calc(2px * calc(1 - 0));
  border-left-width: calc(2px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * (1 - 0));
  border-top-width: calc(1px * (1 - var(--tw-divide-y-reverse)));
  border-top-width: calc(1px * calc(1 - 0));
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * 0);
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-y-0 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(0px * (1 - 0));
  border-top-width: calc(0px * (1 - var(--tw-divide-y-reverse)));
  border-top-width: calc(0px * calc(1 - 0));
  border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(0px * 0);
  border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
}
.divide-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(2px * (1 - 0));
  border-top-width: calc(2px * (1 - var(--tw-divide-y-reverse)));
  border-top-width: calc(2px * calc(1 - 0));
  border-top-width: calc(2px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(2px * 0);
  border-bottom-width: calc(2px * var(--tw-divide-y-reverse));
}
.divide-charcoal-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgba(230, 230, 231, 1);
  border-color: rgba(230, 230, 231, var(--tw-divide-opacity, 1));
}
.divide-charcoal-200 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgba(207, 208, 210, 1);
  border-color: rgba(207, 208, 210, var(--tw-divide-opacity, 1));
}
.divide-charcoal-50 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgba(245, 245, 246, 1);
  border-color: rgba(245, 245, 246, var(--tw-divide-opacity, 1));
}
.divide-charcoal-500 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgba(106, 107, 112, 1);
  border-color: rgba(106, 107, 112, var(--tw-divide-opacity, 1));
}
.divide-white > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, var(--tw-divide-opacity, 1));
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-y-scroll{
  overflow-y: scroll;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal{
  white-space: normal;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-line{
  white-space: pre-line;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  word-wrap: break-word;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b{
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-b-none{
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-l-full{
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-l-lg{
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-md{
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-r-full{
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-r-lg{
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-md{
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-t{
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-lg{
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-t-none{
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.rounded-t-xl{
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-bl-lg{
  border-bottom-left-radius: 0.5rem;
}
.rounded-br-lg{
  border-bottom-right-radius: 0.5rem;
}
.rounded-br-xl{
  border-bottom-right-radius: 0.75rem;
}
.rounded-tl-lg{
  border-top-left-radius: 0.5rem;
}
.rounded-tr-lg{
  border-top-right-radius: 0.5rem;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-\\[50px\\]{
  border-width: 50px;
}
.border-thin{
  border-width: 0.5px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l-0{
  border-left-width: 0px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-l-\\[3px\\]{
  border-left-width: 3px;
}
.border-r{
  border-right-width: 1px;
}
.border-r-0{
  border-right-width: 0px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-solid{
  border-style: solid;
}
.border-dotted{
  border-style: dotted;
}
.border-\\[rgb\\(0\\2c 0\\2c 255\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(0, 0, 255, 1);
  border-color: rgba(0, 0, 255, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(0\\2c 160\\2c 0\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(0, 160, 0, 1);
  border-color: rgba(0, 160, 0, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(0\\2c 208\\2c 0\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(0, 208, 0, 1);
  border-color: rgba(0, 208, 0, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(0\\2c 208\\2c 104\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(0, 208, 104, 1);
  border-color: rgba(0, 208, 104, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(0\\2c 224\\2c 0\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(0, 224, 0, 1);
  border-color: rgba(0, 224, 0, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(0\\2c 244\\2c 112\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(0, 244, 112, 1);
  border-color: rgba(0, 244, 112, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(0\\.5\\2c 0\\.5\\2c 0\\.5\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(1, 1, 1, 1);
  border-color: rgba(1, 1, 1, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(112\\2c 255\\2c 112\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(112, 255, 112, 1);
  border-color: rgba(112, 255, 112, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(144\\2c 108\\2c 0\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(144, 108, 0, 1);
  border-color: rgba(144, 108, 0, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(144\\2c 240\\2c 0\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(144, 240, 0, 1);
  border-color: rgba(144, 240, 0, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(160\\2c 0\\2c 160\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(160, 0, 160, 1);
  border-color: rgba(160, 0, 160, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(176\\2c 176\\2c 176\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(176, 176, 176, 1);
  border-color: rgba(176, 176, 176, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(192\\2c 144\\2c 0\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(192, 144, 0, 1);
  border-color: rgba(192, 144, 0, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(192\\2c 255\\2c 96\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(192, 255, 96, 1);
  border-color: rgba(192, 255, 96, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(192\\2c 48\\2c 0\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(192, 48, 0, 1);
  border-color: rgba(192, 48, 0, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(208\\2c 156\\2c 0\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(208, 156, 0, 1);
  border-color: rgba(208, 156, 0, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(224\\2c 0\\2c 0\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(224, 0, 0, 1);
  border-color: rgba(224, 0, 0, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(224\\2c 56\\2c 0\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(224, 56, 0, 1);
  border-color: rgba(224, 56, 0, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(255\\2c 0\\2c 138\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(255, 0, 138, 1);
  border-color: rgba(255, 0, 138, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(255\\2c 0\\2c 255\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(255, 0, 255, 1);
  border-color: rgba(255, 0, 255, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(255\\2c 112\\2c 255\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(255, 112, 255, 1);
  border-color: rgba(255, 112, 255, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(255\\2c 128\\2c 0\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(255, 128, 0, 1);
  border-color: rgba(255, 128, 0, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(255\\2c 128\\2c 255\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(255, 128, 255, 1);
  border-color: rgba(255, 128, 255, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(255\\2c 168\\2c 80\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(255, 168, 80, 1);
  border-color: rgba(255, 168, 80, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(255\\2c 176\\2c 255\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(255, 176, 255, 1);
  border-color: rgba(255, 176, 255, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(255\\2c 192\\2c 0\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(255, 192, 0, 1);
  border-color: rgba(255, 192, 0, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(255\\2c 216\\2c 96\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(255, 216, 96, 1);
  border-color: rgba(255, 216, 96, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(255\\2c 244\\2c 208\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(255, 244, 208, 1);
  border-color: rgba(255, 244, 208, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(255\\2c 255\\2c 144\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 144, 1);
  border-color: rgba(255, 255, 144, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(255\\2c 88\\2c 32\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(255, 88, 32, 1);
  border-color: rgba(255, 88, 32, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(255\\2c 96\\2c 176\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(255, 96, 176, 1);
  border-color: rgba(255, 96, 176, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(255\\2c 96\\2c 96\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(255, 96, 96, 1);
  border-color: rgba(255, 96, 96, var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(80\\2c 255\\2c 80\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgba(80, 255, 80, 1);
  border-color: rgba(80, 255, 80, var(--tw-border-opacity, 1));
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgba(0, 0, 0, 1);
  border-color: rgba(0, 0, 0, var(--tw-border-opacity, 1));
}
.border-blumine-100{
  --tw-border-opacity: 1;
  border-color: rgba(218, 238, 243, 1);
  border-color: rgba(218, 238, 243, var(--tw-border-opacity, 1));
}
.border-blumine-100\\/0{
  border-color: rgba(218, 238, 243, 0);
}
.border-blumine-100\\/10{
  border-color: rgba(218, 238, 243, 0.1);
}
.border-blumine-100\\/100{
  border-color: rgb(218, 238, 243);
}
.border-blumine-100\\/15{
  border-color: rgba(218, 238, 243, 0.15);
}
.border-blumine-100\\/20{
  border-color: rgba(218, 238, 243, 0.2);
}
.border-blumine-100\\/25{
  border-color: rgba(218, 238, 243, 0.25);
}
.border-blumine-100\\/30{
  border-color: rgba(218, 238, 243, 0.3);
}
.border-blumine-100\\/35{
  border-color: rgba(218, 238, 243, 0.35);
}
.border-blumine-100\\/40{
  border-color: rgba(218, 238, 243, 0.4);
}
.border-blumine-100\\/45{
  border-color: rgba(218, 238, 243, 0.45);
}
.border-blumine-100\\/5{
  border-color: rgba(218, 238, 243, 0.05);
}
.border-blumine-100\\/50{
  border-color: rgba(218, 238, 243, 0.5);
}
.border-blumine-100\\/55{
  border-color: rgba(218, 238, 243, 0.55);
}
.border-blumine-100\\/60{
  border-color: rgba(218, 238, 243, 0.6);
}
.border-blumine-100\\/65{
  border-color: rgba(218, 238, 243, 0.65);
}
.border-blumine-100\\/70{
  border-color: rgba(218, 238, 243, 0.7);
}
.border-blumine-100\\/75{
  border-color: rgba(218, 238, 243, 0.75);
}
.border-blumine-100\\/80{
  border-color: rgba(218, 238, 243, 0.8);
}
.border-blumine-100\\/85{
  border-color: rgba(218, 238, 243, 0.85);
}
.border-blumine-100\\/90{
  border-color: rgba(218, 238, 243, 0.9);
}
.border-blumine-100\\/95{
  border-color: rgba(218, 238, 243, 0.95);
}
.border-blumine-200{
  --tw-border-opacity: 1;
  border-color: rgba(186, 222, 231, 1);
  border-color: rgba(186, 222, 231, var(--tw-border-opacity, 1));
}
.border-blumine-200\\/0{
  border-color: rgba(186, 222, 231, 0);
}
.border-blumine-200\\/10{
  border-color: rgba(186, 222, 231, 0.1);
}
.border-blumine-200\\/100{
  border-color: rgb(186, 222, 231);
}
.border-blumine-200\\/15{
  border-color: rgba(186, 222, 231, 0.15);
}
.border-blumine-200\\/20{
  border-color: rgba(186, 222, 231, 0.2);
}
.border-blumine-200\\/25{
  border-color: rgba(186, 222, 231, 0.25);
}
.border-blumine-200\\/30{
  border-color: rgba(186, 222, 231, 0.3);
}
.border-blumine-200\\/35{
  border-color: rgba(186, 222, 231, 0.35);
}
.border-blumine-200\\/40{
  border-color: rgba(186, 222, 231, 0.4);
}
.border-blumine-200\\/45{
  border-color: rgba(186, 222, 231, 0.45);
}
.border-blumine-200\\/5{
  border-color: rgba(186, 222, 231, 0.05);
}
.border-blumine-200\\/50{
  border-color: rgba(186, 222, 231, 0.5);
}
.border-blumine-200\\/55{
  border-color: rgba(186, 222, 231, 0.55);
}
.border-blumine-200\\/60{
  border-color: rgba(186, 222, 231, 0.6);
}
.border-blumine-200\\/65{
  border-color: rgba(186, 222, 231, 0.65);
}
.border-blumine-200\\/70{
  border-color: rgba(186, 222, 231, 0.7);
}
.border-blumine-200\\/75{
  border-color: rgba(186, 222, 231, 0.75);
}
.border-blumine-200\\/80{
  border-color: rgba(186, 222, 231, 0.8);
}
.border-blumine-200\\/85{
  border-color: rgba(186, 222, 231, 0.85);
}
.border-blumine-200\\/90{
  border-color: rgba(186, 222, 231, 0.9);
}
.border-blumine-200\\/95{
  border-color: rgba(186, 222, 231, 0.95);
}
.border-blumine-300{
  --tw-border-opacity: 1;
  border-color: rgba(137, 197, 215, 1);
  border-color: rgba(137, 197, 215, var(--tw-border-opacity, 1));
}
.border-blumine-300\\/0{
  border-color: rgba(137, 197, 215, 0);
}
.border-blumine-300\\/10{
  border-color: rgba(137, 197, 215, 0.1);
}
.border-blumine-300\\/100{
  border-color: rgb(137, 197, 215);
}
.border-blumine-300\\/15{
  border-color: rgba(137, 197, 215, 0.15);
}
.border-blumine-300\\/20{
  border-color: rgba(137, 197, 215, 0.2);
}
.border-blumine-300\\/25{
  border-color: rgba(137, 197, 215, 0.25);
}
.border-blumine-300\\/30{
  border-color: rgba(137, 197, 215, 0.3);
}
.border-blumine-300\\/35{
  border-color: rgba(137, 197, 215, 0.35);
}
.border-blumine-300\\/40{
  border-color: rgba(137, 197, 215, 0.4);
}
.border-blumine-300\\/45{
  border-color: rgba(137, 197, 215, 0.45);
}
.border-blumine-300\\/5{
  border-color: rgba(137, 197, 215, 0.05);
}
.border-blumine-300\\/50{
  border-color: rgba(137, 197, 215, 0.5);
}
.border-blumine-300\\/55{
  border-color: rgba(137, 197, 215, 0.55);
}
.border-blumine-300\\/60{
  border-color: rgba(137, 197, 215, 0.6);
}
.border-blumine-300\\/65{
  border-color: rgba(137, 197, 215, 0.65);
}
.border-blumine-300\\/70{
  border-color: rgba(137, 197, 215, 0.7);
}
.border-blumine-300\\/75{
  border-color: rgba(137, 197, 215, 0.75);
}
.border-blumine-300\\/80{
  border-color: rgba(137, 197, 215, 0.8);
}
.border-blumine-300\\/85{
  border-color: rgba(137, 197, 215, 0.85);
}
.border-blumine-300\\/90{
  border-color: rgba(137, 197, 215, 0.9);
}
.border-blumine-300\\/95{
  border-color: rgba(137, 197, 215, 0.95);
}
.border-blumine-400{
  --tw-border-opacity: 1;
  border-color: rgba(82, 163, 190, 1);
  border-color: rgba(82, 163, 190, var(--tw-border-opacity, 1));
}
.border-blumine-400\\/0{
  border-color: rgba(82, 163, 190, 0);
}
.border-blumine-400\\/10{
  border-color: rgba(82, 163, 190, 0.1);
}
.border-blumine-400\\/100{
  border-color: rgb(82, 163, 190);
}
.border-blumine-400\\/15{
  border-color: rgba(82, 163, 190, 0.15);
}
.border-blumine-400\\/20{
  border-color: rgba(82, 163, 190, 0.2);
}
.border-blumine-400\\/25{
  border-color: rgba(82, 163, 190, 0.25);
}
.border-blumine-400\\/30{
  border-color: rgba(82, 163, 190, 0.3);
}
.border-blumine-400\\/35{
  border-color: rgba(82, 163, 190, 0.35);
}
.border-blumine-400\\/40{
  border-color: rgba(82, 163, 190, 0.4);
}
.border-blumine-400\\/45{
  border-color: rgba(82, 163, 190, 0.45);
}
.border-blumine-400\\/5{
  border-color: rgba(82, 163, 190, 0.05);
}
.border-blumine-400\\/50{
  border-color: rgba(82, 163, 190, 0.5);
}
.border-blumine-400\\/55{
  border-color: rgba(82, 163, 190, 0.55);
}
.border-blumine-400\\/60{
  border-color: rgba(82, 163, 190, 0.6);
}
.border-blumine-400\\/65{
  border-color: rgba(82, 163, 190, 0.65);
}
.border-blumine-400\\/70{
  border-color: rgba(82, 163, 190, 0.7);
}
.border-blumine-400\\/75{
  border-color: rgba(82, 163, 190, 0.75);
}
.border-blumine-400\\/80{
  border-color: rgba(82, 163, 190, 0.8);
}
.border-blumine-400\\/85{
  border-color: rgba(82, 163, 190, 0.85);
}
.border-blumine-400\\/90{
  border-color: rgba(82, 163, 190, 0.9);
}
.border-blumine-400\\/95{
  border-color: rgba(82, 163, 190, 0.95);
}
.border-blumine-500{
  --tw-border-opacity: 1;
  border-color: rgba(55, 135, 163, 1);
  border-color: rgba(55, 135, 163, var(--tw-border-opacity, 1));
}
.border-blumine-500\\/0{
  border-color: rgba(55, 135, 163, 0);
}
.border-blumine-500\\/10{
  border-color: rgba(55, 135, 163, 0.1);
}
.border-blumine-500\\/100{
  border-color: rgb(55, 135, 163);
}
.border-blumine-500\\/15{
  border-color: rgba(55, 135, 163, 0.15);
}
.border-blumine-500\\/20{
  border-color: rgba(55, 135, 163, 0.2);
}
.border-blumine-500\\/25{
  border-color: rgba(55, 135, 163, 0.25);
}
.border-blumine-500\\/30{
  border-color: rgba(55, 135, 163, 0.3);
}
.border-blumine-500\\/35{
  border-color: rgba(55, 135, 163, 0.35);
}
.border-blumine-500\\/40{
  border-color: rgba(55, 135, 163, 0.4);
}
.border-blumine-500\\/45{
  border-color: rgba(55, 135, 163, 0.45);
}
.border-blumine-500\\/5{
  border-color: rgba(55, 135, 163, 0.05);
}
.border-blumine-500\\/50{
  border-color: rgba(55, 135, 163, 0.5);
}
.border-blumine-500\\/55{
  border-color: rgba(55, 135, 163, 0.55);
}
.border-blumine-500\\/60{
  border-color: rgba(55, 135, 163, 0.6);
}
.border-blumine-500\\/65{
  border-color: rgba(55, 135, 163, 0.65);
}
.border-blumine-500\\/70{
  border-color: rgba(55, 135, 163, 0.7);
}
.border-blumine-500\\/75{
  border-color: rgba(55, 135, 163, 0.75);
}
.border-blumine-500\\/80{
  border-color: rgba(55, 135, 163, 0.8);
}
.border-blumine-500\\/85{
  border-color: rgba(55, 135, 163, 0.85);
}
.border-blumine-500\\/90{
  border-color: rgba(55, 135, 163, 0.9);
}
.border-blumine-500\\/95{
  border-color: rgba(55, 135, 163, 0.95);
}
.border-blumine-600{
  --tw-border-opacity: 1;
  border-color: rgba(48, 109, 138, 1);
  border-color: rgba(48, 109, 138, var(--tw-border-opacity, 1));
}
.border-blumine-600\\/0{
  border-color: rgba(48, 109, 138, 0);
}
.border-blumine-600\\/10{
  border-color: rgba(48, 109, 138, 0.1);
}
.border-blumine-600\\/100{
  border-color: rgb(48, 109, 138);
}
.border-blumine-600\\/15{
  border-color: rgba(48, 109, 138, 0.15);
}
.border-blumine-600\\/20{
  border-color: rgba(48, 109, 138, 0.2);
}
.border-blumine-600\\/25{
  border-color: rgba(48, 109, 138, 0.25);
}
.border-blumine-600\\/30{
  border-color: rgba(48, 109, 138, 0.3);
}
.border-blumine-600\\/35{
  border-color: rgba(48, 109, 138, 0.35);
}
.border-blumine-600\\/40{
  border-color: rgba(48, 109, 138, 0.4);
}
.border-blumine-600\\/45{
  border-color: rgba(48, 109, 138, 0.45);
}
.border-blumine-600\\/5{
  border-color: rgba(48, 109, 138, 0.05);
}
.border-blumine-600\\/50{
  border-color: rgba(48, 109, 138, 0.5);
}
.border-blumine-600\\/55{
  border-color: rgba(48, 109, 138, 0.55);
}
.border-blumine-600\\/60{
  border-color: rgba(48, 109, 138, 0.6);
}
.border-blumine-600\\/65{
  border-color: rgba(48, 109, 138, 0.65);
}
.border-blumine-600\\/70{
  border-color: rgba(48, 109, 138, 0.7);
}
.border-blumine-600\\/75{
  border-color: rgba(48, 109, 138, 0.75);
}
.border-blumine-600\\/80{
  border-color: rgba(48, 109, 138, 0.8);
}
.border-blumine-600\\/85{
  border-color: rgba(48, 109, 138, 0.85);
}
.border-blumine-600\\/90{
  border-color: rgba(48, 109, 138, 0.9);
}
.border-blumine-600\\/95{
  border-color: rgba(48, 109, 138, 0.95);
}
.border-blumine-700{
  --tw-border-opacity: 1;
  border-color: rgba(45, 91, 114, 1);
  border-color: rgba(45, 91, 114, var(--tw-border-opacity, 1));
}
.border-blumine-700\\/0{
  border-color: rgba(45, 91, 114, 0);
}
.border-blumine-700\\/10{
  border-color: rgba(45, 91, 114, 0.1);
}
.border-blumine-700\\/100{
  border-color: rgb(45, 91, 114);
}
.border-blumine-700\\/15{
  border-color: rgba(45, 91, 114, 0.15);
}
.border-blumine-700\\/20{
  border-color: rgba(45, 91, 114, 0.2);
}
.border-blumine-700\\/25{
  border-color: rgba(45, 91, 114, 0.25);
}
.border-blumine-700\\/30{
  border-color: rgba(45, 91, 114, 0.3);
}
.border-blumine-700\\/35{
  border-color: rgba(45, 91, 114, 0.35);
}
.border-blumine-700\\/40{
  border-color: rgba(45, 91, 114, 0.4);
}
.border-blumine-700\\/45{
  border-color: rgba(45, 91, 114, 0.45);
}
.border-blumine-700\\/5{
  border-color: rgba(45, 91, 114, 0.05);
}
.border-blumine-700\\/50{
  border-color: rgba(45, 91, 114, 0.5);
}
.border-blumine-700\\/55{
  border-color: rgba(45, 91, 114, 0.55);
}
.border-blumine-700\\/60{
  border-color: rgba(45, 91, 114, 0.6);
}
.border-blumine-700\\/65{
  border-color: rgba(45, 91, 114, 0.65);
}
.border-blumine-700\\/70{
  border-color: rgba(45, 91, 114, 0.7);
}
.border-blumine-700\\/75{
  border-color: rgba(45, 91, 114, 0.75);
}
.border-blumine-700\\/80{
  border-color: rgba(45, 91, 114, 0.8);
}
.border-blumine-700\\/85{
  border-color: rgba(45, 91, 114, 0.85);
}
.border-blumine-700\\/90{
  border-color: rgba(45, 91, 114, 0.9);
}
.border-blumine-700\\/95{
  border-color: rgba(45, 91, 114, 0.95);
}
.border-blumine-800{
  --tw-border-opacity: 1;
  border-color: rgba(44, 76, 94, 1);
  border-color: rgba(44, 76, 94, var(--tw-border-opacity, 1));
}
.border-blumine-800\\/0{
  border-color: rgba(44, 76, 94, 0);
}
.border-blumine-800\\/10{
  border-color: rgba(44, 76, 94, 0.1);
}
.border-blumine-800\\/100{
  border-color: rgb(44, 76, 94);
}
.border-blumine-800\\/15{
  border-color: rgba(44, 76, 94, 0.15);
}
.border-blumine-800\\/20{
  border-color: rgba(44, 76, 94, 0.2);
}
.border-blumine-800\\/25{
  border-color: rgba(44, 76, 94, 0.25);
}
.border-blumine-800\\/30{
  border-color: rgba(44, 76, 94, 0.3);
}
.border-blumine-800\\/35{
  border-color: rgba(44, 76, 94, 0.35);
}
.border-blumine-800\\/40{
  border-color: rgba(44, 76, 94, 0.4);
}
.border-blumine-800\\/45{
  border-color: rgba(44, 76, 94, 0.45);
}
.border-blumine-800\\/5{
  border-color: rgba(44, 76, 94, 0.05);
}
.border-blumine-800\\/50{
  border-color: rgba(44, 76, 94, 0.5);
}
.border-blumine-800\\/55{
  border-color: rgba(44, 76, 94, 0.55);
}
.border-blumine-800\\/60{
  border-color: rgba(44, 76, 94, 0.6);
}
.border-blumine-800\\/65{
  border-color: rgba(44, 76, 94, 0.65);
}
.border-blumine-800\\/70{
  border-color: rgba(44, 76, 94, 0.7);
}
.border-blumine-800\\/75{
  border-color: rgba(44, 76, 94, 0.75);
}
.border-blumine-800\\/80{
  border-color: rgba(44, 76, 94, 0.8);
}
.border-blumine-800\\/85{
  border-color: rgba(44, 76, 94, 0.85);
}
.border-blumine-800\\/90{
  border-color: rgba(44, 76, 94, 0.9);
}
.border-blumine-800\\/95{
  border-color: rgba(44, 76, 94, 0.95);
}
.border-blumine-900{
  --tw-border-opacity: 1;
  border-color: rgba(40, 65, 81, 1);
  border-color: rgba(40, 65, 81, var(--tw-border-opacity, 1));
}
.border-blumine-900\\/0{
  border-color: rgba(40, 65, 81, 0);
}
.border-blumine-900\\/10{
  border-color: rgba(40, 65, 81, 0.1);
}
.border-blumine-900\\/100{
  border-color: rgb(40, 65, 81);
}
.border-blumine-900\\/15{
  border-color: rgba(40, 65, 81, 0.15);
}
.border-blumine-900\\/20{
  border-color: rgba(40, 65, 81, 0.2);
}
.border-blumine-900\\/25{
  border-color: rgba(40, 65, 81, 0.25);
}
.border-blumine-900\\/30{
  border-color: rgba(40, 65, 81, 0.3);
}
.border-blumine-900\\/35{
  border-color: rgba(40, 65, 81, 0.35);
}
.border-blumine-900\\/40{
  border-color: rgba(40, 65, 81, 0.4);
}
.border-blumine-900\\/45{
  border-color: rgba(40, 65, 81, 0.45);
}
.border-blumine-900\\/5{
  border-color: rgba(40, 65, 81, 0.05);
}
.border-blumine-900\\/50{
  border-color: rgba(40, 65, 81, 0.5);
}
.border-blumine-900\\/55{
  border-color: rgba(40, 65, 81, 0.55);
}
.border-blumine-900\\/60{
  border-color: rgba(40, 65, 81, 0.6);
}
.border-blumine-900\\/65{
  border-color: rgba(40, 65, 81, 0.65);
}
.border-blumine-900\\/70{
  border-color: rgba(40, 65, 81, 0.7);
}
.border-blumine-900\\/75{
  border-color: rgba(40, 65, 81, 0.75);
}
.border-blumine-900\\/80{
  border-color: rgba(40, 65, 81, 0.8);
}
.border-blumine-900\\/85{
  border-color: rgba(40, 65, 81, 0.85);
}
.border-blumine-900\\/90{
  border-color: rgba(40, 65, 81, 0.9);
}
.border-blumine-900\\/95{
  border-color: rgba(40, 65, 81, 0.95);
}
.border-blumine-950{
  --tw-border-opacity: 1;
  border-color: rgba(22, 41, 54, 1);
  border-color: rgba(22, 41, 54, var(--tw-border-opacity, 1));
}
.border-blumine-950\\/0{
  border-color: rgba(22, 41, 54, 0);
}
.border-blumine-950\\/10{
  border-color: rgba(22, 41, 54, 0.1);
}
.border-blumine-950\\/100{
  border-color: rgb(22, 41, 54);
}
.border-blumine-950\\/15{
  border-color: rgba(22, 41, 54, 0.15);
}
.border-blumine-950\\/20{
  border-color: rgba(22, 41, 54, 0.2);
}
.border-blumine-950\\/25{
  border-color: rgba(22, 41, 54, 0.25);
}
.border-blumine-950\\/30{
  border-color: rgba(22, 41, 54, 0.3);
}
.border-blumine-950\\/35{
  border-color: rgba(22, 41, 54, 0.35);
}
.border-blumine-950\\/40{
  border-color: rgba(22, 41, 54, 0.4);
}
.border-blumine-950\\/45{
  border-color: rgba(22, 41, 54, 0.45);
}
.border-blumine-950\\/5{
  border-color: rgba(22, 41, 54, 0.05);
}
.border-blumine-950\\/50{
  border-color: rgba(22, 41, 54, 0.5);
}
.border-blumine-950\\/55{
  border-color: rgba(22, 41, 54, 0.55);
}
.border-blumine-950\\/60{
  border-color: rgba(22, 41, 54, 0.6);
}
.border-blumine-950\\/65{
  border-color: rgba(22, 41, 54, 0.65);
}
.border-blumine-950\\/70{
  border-color: rgba(22, 41, 54, 0.7);
}
.border-blumine-950\\/75{
  border-color: rgba(22, 41, 54, 0.75);
}
.border-blumine-950\\/80{
  border-color: rgba(22, 41, 54, 0.8);
}
.border-blumine-950\\/85{
  border-color: rgba(22, 41, 54, 0.85);
}
.border-blumine-950\\/90{
  border-color: rgba(22, 41, 54, 0.9);
}
.border-blumine-950\\/95{
  border-color: rgba(22, 41, 54, 0.95);
}
.border-charcoal-100{
  --tw-border-opacity: 1;
  border-color: rgba(230, 230, 231, 1);
  border-color: rgba(230, 230, 231, var(--tw-border-opacity, 1));
}
.border-charcoal-100\\/0{
  border-color: rgba(230, 230, 231, 0);
}
.border-charcoal-100\\/10{
  border-color: rgba(230, 230, 231, 0.1);
}
.border-charcoal-100\\/100{
  border-color: rgb(230, 230, 231);
}
.border-charcoal-100\\/15{
  border-color: rgba(230, 230, 231, 0.15);
}
.border-charcoal-100\\/20{
  border-color: rgba(230, 230, 231, 0.2);
}
.border-charcoal-100\\/25{
  border-color: rgba(230, 230, 231, 0.25);
}
.border-charcoal-100\\/30{
  border-color: rgba(230, 230, 231, 0.3);
}
.border-charcoal-100\\/35{
  border-color: rgba(230, 230, 231, 0.35);
}
.border-charcoal-100\\/40{
  border-color: rgba(230, 230, 231, 0.4);
}
.border-charcoal-100\\/45{
  border-color: rgba(230, 230, 231, 0.45);
}
.border-charcoal-100\\/5{
  border-color: rgba(230, 230, 231, 0.05);
}
.border-charcoal-100\\/50{
  border-color: rgba(230, 230, 231, 0.5);
}
.border-charcoal-100\\/55{
  border-color: rgba(230, 230, 231, 0.55);
}
.border-charcoal-100\\/60{
  border-color: rgba(230, 230, 231, 0.6);
}
.border-charcoal-100\\/65{
  border-color: rgba(230, 230, 231, 0.65);
}
.border-charcoal-100\\/70{
  border-color: rgba(230, 230, 231, 0.7);
}
.border-charcoal-100\\/75{
  border-color: rgba(230, 230, 231, 0.75);
}
.border-charcoal-100\\/80{
  border-color: rgba(230, 230, 231, 0.8);
}
.border-charcoal-100\\/85{
  border-color: rgba(230, 230, 231, 0.85);
}
.border-charcoal-100\\/90{
  border-color: rgba(230, 230, 231, 0.9);
}
.border-charcoal-100\\/95{
  border-color: rgba(230, 230, 231, 0.95);
}
.border-charcoal-200{
  --tw-border-opacity: 1;
  border-color: rgba(207, 208, 210, 1);
  border-color: rgba(207, 208, 210, var(--tw-border-opacity, 1));
}
.border-charcoal-200\\/0{
  border-color: rgba(207, 208, 210, 0);
}
.border-charcoal-200\\/10{
  border-color: rgba(207, 208, 210, 0.1);
}
.border-charcoal-200\\/100{
  border-color: rgb(207, 208, 210);
}
.border-charcoal-200\\/15{
  border-color: rgba(207, 208, 210, 0.15);
}
.border-charcoal-200\\/20{
  border-color: rgba(207, 208, 210, 0.2);
}
.border-charcoal-200\\/25{
  border-color: rgba(207, 208, 210, 0.25);
}
.border-charcoal-200\\/30{
  border-color: rgba(207, 208, 210, 0.3);
}
.border-charcoal-200\\/35{
  border-color: rgba(207, 208, 210, 0.35);
}
.border-charcoal-200\\/40{
  border-color: rgba(207, 208, 210, 0.4);
}
.border-charcoal-200\\/45{
  border-color: rgba(207, 208, 210, 0.45);
}
.border-charcoal-200\\/5{
  border-color: rgba(207, 208, 210, 0.05);
}
.border-charcoal-200\\/50{
  border-color: rgba(207, 208, 210, 0.5);
}
.border-charcoal-200\\/55{
  border-color: rgba(207, 208, 210, 0.55);
}
.border-charcoal-200\\/60{
  border-color: rgba(207, 208, 210, 0.6);
}
.border-charcoal-200\\/65{
  border-color: rgba(207, 208, 210, 0.65);
}
.border-charcoal-200\\/70{
  border-color: rgba(207, 208, 210, 0.7);
}
.border-charcoal-200\\/75{
  border-color: rgba(207, 208, 210, 0.75);
}
.border-charcoal-200\\/80{
  border-color: rgba(207, 208, 210, 0.8);
}
.border-charcoal-200\\/85{
  border-color: rgba(207, 208, 210, 0.85);
}
.border-charcoal-200\\/90{
  border-color: rgba(207, 208, 210, 0.9);
}
.border-charcoal-200\\/95{
  border-color: rgba(207, 208, 210, 0.95);
}
.border-charcoal-300{
  --tw-border-opacity: 1;
  border-color: rgba(174, 175, 178, 1);
  border-color: rgba(174, 175, 178, var(--tw-border-opacity, 1));
}
.border-charcoal-300\\/0{
  border-color: rgba(174, 175, 178, 0);
}
.border-charcoal-300\\/10{
  border-color: rgba(174, 175, 178, 0.1);
}
.border-charcoal-300\\/100{
  border-color: rgb(174, 175, 178);
}
.border-charcoal-300\\/15{
  border-color: rgba(174, 175, 178, 0.15);
}
.border-charcoal-300\\/20{
  border-color: rgba(174, 175, 178, 0.2);
}
.border-charcoal-300\\/25{
  border-color: rgba(174, 175, 178, 0.25);
}
.border-charcoal-300\\/30{
  border-color: rgba(174, 175, 178, 0.3);
}
.border-charcoal-300\\/35{
  border-color: rgba(174, 175, 178, 0.35);
}
.border-charcoal-300\\/40{
  border-color: rgba(174, 175, 178, 0.4);
}
.border-charcoal-300\\/45{
  border-color: rgba(174, 175, 178, 0.45);
}
.border-charcoal-300\\/5{
  border-color: rgba(174, 175, 178, 0.05);
}
.border-charcoal-300\\/50{
  border-color: rgba(174, 175, 178, 0.5);
}
.border-charcoal-300\\/55{
  border-color: rgba(174, 175, 178, 0.55);
}
.border-charcoal-300\\/60{
  border-color: rgba(174, 175, 178, 0.6);
}
.border-charcoal-300\\/65{
  border-color: rgba(174, 175, 178, 0.65);
}
.border-charcoal-300\\/70{
  border-color: rgba(174, 175, 178, 0.7);
}
.border-charcoal-300\\/75{
  border-color: rgba(174, 175, 178, 0.75);
}
.border-charcoal-300\\/80{
  border-color: rgba(174, 175, 178, 0.8);
}
.border-charcoal-300\\/85{
  border-color: rgba(174, 175, 178, 0.85);
}
.border-charcoal-300\\/90{
  border-color: rgba(174, 175, 178, 0.9);
}
.border-charcoal-300\\/95{
  border-color: rgba(174, 175, 178, 0.95);
}
.border-charcoal-400{
  --tw-border-opacity: 1;
  border-color: rgba(133, 134, 139, 1);
  border-color: rgba(133, 134, 139, var(--tw-border-opacity, 1));
}
.border-charcoal-400\\/0{
  border-color: rgba(133, 134, 139, 0);
}
.border-charcoal-400\\/10{
  border-color: rgba(133, 134, 139, 0.1);
}
.border-charcoal-400\\/100{
  border-color: rgb(133, 134, 139);
}
.border-charcoal-400\\/15{
  border-color: rgba(133, 134, 139, 0.15);
}
.border-charcoal-400\\/20{
  border-color: rgba(133, 134, 139, 0.2);
}
.border-charcoal-400\\/25{
  border-color: rgba(133, 134, 139, 0.25);
}
.border-charcoal-400\\/30{
  border-color: rgba(133, 134, 139, 0.3);
}
.border-charcoal-400\\/35{
  border-color: rgba(133, 134, 139, 0.35);
}
.border-charcoal-400\\/40{
  border-color: rgba(133, 134, 139, 0.4);
}
.border-charcoal-400\\/45{
  border-color: rgba(133, 134, 139, 0.45);
}
.border-charcoal-400\\/5{
  border-color: rgba(133, 134, 139, 0.05);
}
.border-charcoal-400\\/50{
  border-color: rgba(133, 134, 139, 0.5);
}
.border-charcoal-400\\/55{
  border-color: rgba(133, 134, 139, 0.55);
}
.border-charcoal-400\\/60{
  border-color: rgba(133, 134, 139, 0.6);
}
.border-charcoal-400\\/65{
  border-color: rgba(133, 134, 139, 0.65);
}
.border-charcoal-400\\/70{
  border-color: rgba(133, 134, 139, 0.7);
}
.border-charcoal-400\\/75{
  border-color: rgba(133, 134, 139, 0.75);
}
.border-charcoal-400\\/80{
  border-color: rgba(133, 134, 139, 0.8);
}
.border-charcoal-400\\/85{
  border-color: rgba(133, 134, 139, 0.85);
}
.border-charcoal-400\\/90{
  border-color: rgba(133, 134, 139, 0.9);
}
.border-charcoal-400\\/95{
  border-color: rgba(133, 134, 139, 0.95);
}
.border-charcoal-50{
  --tw-border-opacity: 1;
  border-color: rgba(245, 245, 246, 1);
  border-color: rgba(245, 245, 246, var(--tw-border-opacity, 1));
}
.border-charcoal-500{
  --tw-border-opacity: 1;
  border-color: rgba(106, 107, 112, 1);
  border-color: rgba(106, 107, 112, var(--tw-border-opacity, 1));
}
.border-charcoal-500\\/0{
  border-color: rgba(106, 107, 112, 0);
}
.border-charcoal-500\\/10{
  border-color: rgba(106, 107, 112, 0.1);
}
.border-charcoal-500\\/100{
  border-color: rgb(106, 107, 112);
}
.border-charcoal-500\\/15{
  border-color: rgba(106, 107, 112, 0.15);
}
.border-charcoal-500\\/20{
  border-color: rgba(106, 107, 112, 0.2);
}
.border-charcoal-500\\/25{
  border-color: rgba(106, 107, 112, 0.25);
}
.border-charcoal-500\\/30{
  border-color: rgba(106, 107, 112, 0.3);
}
.border-charcoal-500\\/35{
  border-color: rgba(106, 107, 112, 0.35);
}
.border-charcoal-500\\/40{
  border-color: rgba(106, 107, 112, 0.4);
}
.border-charcoal-500\\/45{
  border-color: rgba(106, 107, 112, 0.45);
}
.border-charcoal-500\\/5{
  border-color: rgba(106, 107, 112, 0.05);
}
.border-charcoal-500\\/50{
  border-color: rgba(106, 107, 112, 0.5);
}
.border-charcoal-500\\/55{
  border-color: rgba(106, 107, 112, 0.55);
}
.border-charcoal-500\\/60{
  border-color: rgba(106, 107, 112, 0.6);
}
.border-charcoal-500\\/65{
  border-color: rgba(106, 107, 112, 0.65);
}
.border-charcoal-500\\/70{
  border-color: rgba(106, 107, 112, 0.7);
}
.border-charcoal-500\\/75{
  border-color: rgba(106, 107, 112, 0.75);
}
.border-charcoal-500\\/80{
  border-color: rgba(106, 107, 112, 0.8);
}
.border-charcoal-500\\/85{
  border-color: rgba(106, 107, 112, 0.85);
}
.border-charcoal-500\\/90{
  border-color: rgba(106, 107, 112, 0.9);
}
.border-charcoal-500\\/95{
  border-color: rgba(106, 107, 112, 0.95);
}
.border-charcoal-600{
  --tw-border-opacity: 1;
  border-color: rgba(90, 91, 96, 1);
  border-color: rgba(90, 91, 96, var(--tw-border-opacity, 1));
}
.border-charcoal-600\\/0{
  border-color: rgba(90, 91, 96, 0);
}
.border-charcoal-600\\/10{
  border-color: rgba(90, 91, 96, 0.1);
}
.border-charcoal-600\\/100{
  border-color: rgb(90, 91, 96);
}
.border-charcoal-600\\/15{
  border-color: rgba(90, 91, 96, 0.15);
}
.border-charcoal-600\\/20{
  border-color: rgba(90, 91, 96, 0.2);
}
.border-charcoal-600\\/25{
  border-color: rgba(90, 91, 96, 0.25);
}
.border-charcoal-600\\/30{
  border-color: rgba(90, 91, 96, 0.3);
}
.border-charcoal-600\\/35{
  border-color: rgba(90, 91, 96, 0.35);
}
.border-charcoal-600\\/40{
  border-color: rgba(90, 91, 96, 0.4);
}
.border-charcoal-600\\/45{
  border-color: rgba(90, 91, 96, 0.45);
}
.border-charcoal-600\\/5{
  border-color: rgba(90, 91, 96, 0.05);
}
.border-charcoal-600\\/50{
  border-color: rgba(90, 91, 96, 0.5);
}
.border-charcoal-600\\/55{
  border-color: rgba(90, 91, 96, 0.55);
}
.border-charcoal-600\\/60{
  border-color: rgba(90, 91, 96, 0.6);
}
.border-charcoal-600\\/65{
  border-color: rgba(90, 91, 96, 0.65);
}
.border-charcoal-600\\/70{
  border-color: rgba(90, 91, 96, 0.7);
}
.border-charcoal-600\\/75{
  border-color: rgba(90, 91, 96, 0.75);
}
.border-charcoal-600\\/80{
  border-color: rgba(90, 91, 96, 0.8);
}
.border-charcoal-600\\/85{
  border-color: rgba(90, 91, 96, 0.85);
}
.border-charcoal-600\\/90{
  border-color: rgba(90, 91, 96, 0.9);
}
.border-charcoal-600\\/95{
  border-color: rgba(90, 91, 96, 0.95);
}
.border-charcoal-700{
  --tw-border-opacity: 1;
  border-color: rgba(77, 77, 81, 1);
  border-color: rgba(77, 77, 81, var(--tw-border-opacity, 1));
}
.border-charcoal-700\\/0{
  border-color: rgba(77, 77, 81, 0);
}
.border-charcoal-700\\/10{
  border-color: rgba(77, 77, 81, 0.1);
}
.border-charcoal-700\\/100{
  border-color: rgb(77, 77, 81);
}
.border-charcoal-700\\/15{
  border-color: rgba(77, 77, 81, 0.15);
}
.border-charcoal-700\\/20{
  border-color: rgba(77, 77, 81, 0.2);
}
.border-charcoal-700\\/25{
  border-color: rgba(77, 77, 81, 0.25);
}
.border-charcoal-700\\/30{
  border-color: rgba(77, 77, 81, 0.3);
}
.border-charcoal-700\\/35{
  border-color: rgba(77, 77, 81, 0.35);
}
.border-charcoal-700\\/40{
  border-color: rgba(77, 77, 81, 0.4);
}
.border-charcoal-700\\/45{
  border-color: rgba(77, 77, 81, 0.45);
}
.border-charcoal-700\\/5{
  border-color: rgba(77, 77, 81, 0.05);
}
.border-charcoal-700\\/50{
  border-color: rgba(77, 77, 81, 0.5);
}
.border-charcoal-700\\/55{
  border-color: rgba(77, 77, 81, 0.55);
}
.border-charcoal-700\\/60{
  border-color: rgba(77, 77, 81, 0.6);
}
.border-charcoal-700\\/65{
  border-color: rgba(77, 77, 81, 0.65);
}
.border-charcoal-700\\/70{
  border-color: rgba(77, 77, 81, 0.7);
}
.border-charcoal-700\\/75{
  border-color: rgba(77, 77, 81, 0.75);
}
.border-charcoal-700\\/80{
  border-color: rgba(77, 77, 81, 0.8);
}
.border-charcoal-700\\/85{
  border-color: rgba(77, 77, 81, 0.85);
}
.border-charcoal-700\\/90{
  border-color: rgba(77, 77, 81, 0.9);
}
.border-charcoal-700\\/95{
  border-color: rgba(77, 77, 81, 0.95);
}
.border-charcoal-800{
  --tw-border-opacity: 1;
  border-color: rgba(67, 67, 71, 1);
  border-color: rgba(67, 67, 71, var(--tw-border-opacity, 1));
}
.border-charcoal-800\\/0{
  border-color: rgba(67, 67, 71, 0);
}
.border-charcoal-800\\/10{
  border-color: rgba(67, 67, 71, 0.1);
}
.border-charcoal-800\\/100{
  border-color: rgb(67, 67, 71);
}
.border-charcoal-800\\/15{
  border-color: rgba(67, 67, 71, 0.15);
}
.border-charcoal-800\\/20{
  border-color: rgba(67, 67, 71, 0.2);
}
.border-charcoal-800\\/25{
  border-color: rgba(67, 67, 71, 0.25);
}
.border-charcoal-800\\/30{
  border-color: rgba(67, 67, 71, 0.3);
}
.border-charcoal-800\\/35{
  border-color: rgba(67, 67, 71, 0.35);
}
.border-charcoal-800\\/40{
  border-color: rgba(67, 67, 71, 0.4);
}
.border-charcoal-800\\/45{
  border-color: rgba(67, 67, 71, 0.45);
}
.border-charcoal-800\\/5{
  border-color: rgba(67, 67, 71, 0.05);
}
.border-charcoal-800\\/50{
  border-color: rgba(67, 67, 71, 0.5);
}
.border-charcoal-800\\/55{
  border-color: rgba(67, 67, 71, 0.55);
}
.border-charcoal-800\\/60{
  border-color: rgba(67, 67, 71, 0.6);
}
.border-charcoal-800\\/65{
  border-color: rgba(67, 67, 71, 0.65);
}
.border-charcoal-800\\/70{
  border-color: rgba(67, 67, 71, 0.7);
}
.border-charcoal-800\\/75{
  border-color: rgba(67, 67, 71, 0.75);
}
.border-charcoal-800\\/80{
  border-color: rgba(67, 67, 71, 0.8);
}
.border-charcoal-800\\/85{
  border-color: rgba(67, 67, 71, 0.85);
}
.border-charcoal-800\\/90{
  border-color: rgba(67, 67, 71, 0.9);
}
.border-charcoal-800\\/95{
  border-color: rgba(67, 67, 71, 0.95);
}
.border-charcoal-900{
  --tw-border-opacity: 1;
  border-color: rgba(49, 49, 51, 1);
  border-color: rgba(49, 49, 51, var(--tw-border-opacity, 1));
}
.border-charcoal-900\\/0{
  border-color: rgba(49, 49, 51, 0);
}
.border-charcoal-900\\/10{
  border-color: rgba(49, 49, 51, 0.1);
}
.border-charcoal-900\\/100{
  border-color: rgb(49, 49, 51);
}
.border-charcoal-900\\/15{
  border-color: rgba(49, 49, 51, 0.15);
}
.border-charcoal-900\\/20{
  border-color: rgba(49, 49, 51, 0.2);
}
.border-charcoal-900\\/25{
  border-color: rgba(49, 49, 51, 0.25);
}
.border-charcoal-900\\/30{
  border-color: rgba(49, 49, 51, 0.3);
}
.border-charcoal-900\\/35{
  border-color: rgba(49, 49, 51, 0.35);
}
.border-charcoal-900\\/40{
  border-color: rgba(49, 49, 51, 0.4);
}
.border-charcoal-900\\/45{
  border-color: rgba(49, 49, 51, 0.45);
}
.border-charcoal-900\\/5{
  border-color: rgba(49, 49, 51, 0.05);
}
.border-charcoal-900\\/50{
  border-color: rgba(49, 49, 51, 0.5);
}
.border-charcoal-900\\/55{
  border-color: rgba(49, 49, 51, 0.55);
}
.border-charcoal-900\\/60{
  border-color: rgba(49, 49, 51, 0.6);
}
.border-charcoal-900\\/65{
  border-color: rgba(49, 49, 51, 0.65);
}
.border-charcoal-900\\/70{
  border-color: rgba(49, 49, 51, 0.7);
}
.border-charcoal-900\\/75{
  border-color: rgba(49, 49, 51, 0.75);
}
.border-charcoal-900\\/80{
  border-color: rgba(49, 49, 51, 0.8);
}
.border-charcoal-900\\/85{
  border-color: rgba(49, 49, 51, 0.85);
}
.border-charcoal-900\\/90{
  border-color: rgba(49, 49, 51, 0.9);
}
.border-charcoal-900\\/95{
  border-color: rgba(49, 49, 51, 0.95);
}
.border-charcoal-950{
  --tw-border-opacity: 1;
  border-color: rgba(37, 37, 39, 1);
  border-color: rgba(37, 37, 39, var(--tw-border-opacity, 1));
}
.border-charcoal-950\\/0{
  border-color: rgba(37, 37, 39, 0);
}
.border-charcoal-950\\/10{
  border-color: rgba(37, 37, 39, 0.1);
}
.border-charcoal-950\\/100{
  border-color: rgb(37, 37, 39);
}
.border-charcoal-950\\/15{
  border-color: rgba(37, 37, 39, 0.15);
}
.border-charcoal-950\\/20{
  border-color: rgba(37, 37, 39, 0.2);
}
.border-charcoal-950\\/25{
  border-color: rgba(37, 37, 39, 0.25);
}
.border-charcoal-950\\/30{
  border-color: rgba(37, 37, 39, 0.3);
}
.border-charcoal-950\\/35{
  border-color: rgba(37, 37, 39, 0.35);
}
.border-charcoal-950\\/40{
  border-color: rgba(37, 37, 39, 0.4);
}
.border-charcoal-950\\/45{
  border-color: rgba(37, 37, 39, 0.45);
}
.border-charcoal-950\\/5{
  border-color: rgba(37, 37, 39, 0.05);
}
.border-charcoal-950\\/50{
  border-color: rgba(37, 37, 39, 0.5);
}
.border-charcoal-950\\/55{
  border-color: rgba(37, 37, 39, 0.55);
}
.border-charcoal-950\\/60{
  border-color: rgba(37, 37, 39, 0.6);
}
.border-charcoal-950\\/65{
  border-color: rgba(37, 37, 39, 0.65);
}
.border-charcoal-950\\/70{
  border-color: rgba(37, 37, 39, 0.7);
}
.border-charcoal-950\\/75{
  border-color: rgba(37, 37, 39, 0.75);
}
.border-charcoal-950\\/80{
  border-color: rgba(37, 37, 39, 0.8);
}
.border-charcoal-950\\/85{
  border-color: rgba(37, 37, 39, 0.85);
}
.border-charcoal-950\\/90{
  border-color: rgba(37, 37, 39, 0.9);
}
.border-charcoal-950\\/95{
  border-color: rgba(37, 37, 39, 0.95);
}
.border-jade-100{
  --tw-border-opacity: 1;
  border-color: rgba(217, 242, 230, 1);
  border-color: rgba(217, 242, 230, var(--tw-border-opacity, 1));
}
.border-jade-100\\/0{
  border-color: rgba(217, 242, 230, 0);
}
.border-jade-100\\/10{
  border-color: rgba(217, 242, 230, 0.1);
}
.border-jade-100\\/100{
  border-color: rgb(217, 242, 230);
}
.border-jade-100\\/15{
  border-color: rgba(217, 242, 230, 0.15);
}
.border-jade-100\\/20{
  border-color: rgba(217, 242, 230, 0.2);
}
.border-jade-100\\/25{
  border-color: rgba(217, 242, 230, 0.25);
}
.border-jade-100\\/30{
  border-color: rgba(217, 242, 230, 0.3);
}
.border-jade-100\\/35{
  border-color: rgba(217, 242, 230, 0.35);
}
.border-jade-100\\/40{
  border-color: rgba(217, 242, 230, 0.4);
}
.border-jade-100\\/45{
  border-color: rgba(217, 242, 230, 0.45);
}
.border-jade-100\\/5{
  border-color: rgba(217, 242, 230, 0.05);
}
.border-jade-100\\/50{
  border-color: rgba(217, 242, 230, 0.5);
}
.border-jade-100\\/55{
  border-color: rgba(217, 242, 230, 0.55);
}
.border-jade-100\\/60{
  border-color: rgba(217, 242, 230, 0.6);
}
.border-jade-100\\/65{
  border-color: rgba(217, 242, 230, 0.65);
}
.border-jade-100\\/70{
  border-color: rgba(217, 242, 230, 0.7);
}
.border-jade-100\\/75{
  border-color: rgba(217, 242, 230, 0.75);
}
.border-jade-100\\/80{
  border-color: rgba(217, 242, 230, 0.8);
}
.border-jade-100\\/85{
  border-color: rgba(217, 242, 230, 0.85);
}
.border-jade-100\\/90{
  border-color: rgba(217, 242, 230, 0.9);
}
.border-jade-100\\/95{
  border-color: rgba(217, 242, 230, 0.95);
}
.border-jade-200{
  --tw-border-opacity: 1;
  border-color: rgba(182, 228, 209, 1);
  border-color: rgba(182, 228, 209, var(--tw-border-opacity, 1));
}
.border-jade-200\\/0{
  border-color: rgba(182, 228, 209, 0);
}
.border-jade-200\\/10{
  border-color: rgba(182, 228, 209, 0.1);
}
.border-jade-200\\/100{
  border-color: rgb(182, 228, 209);
}
.border-jade-200\\/15{
  border-color: rgba(182, 228, 209, 0.15);
}
.border-jade-200\\/20{
  border-color: rgba(182, 228, 209, 0.2);
}
.border-jade-200\\/25{
  border-color: rgba(182, 228, 209, 0.25);
}
.border-jade-200\\/30{
  border-color: rgba(182, 228, 209, 0.3);
}
.border-jade-200\\/35{
  border-color: rgba(182, 228, 209, 0.35);
}
.border-jade-200\\/40{
  border-color: rgba(182, 228, 209, 0.4);
}
.border-jade-200\\/45{
  border-color: rgba(182, 228, 209, 0.45);
}
.border-jade-200\\/5{
  border-color: rgba(182, 228, 209, 0.05);
}
.border-jade-200\\/50{
  border-color: rgba(182, 228, 209, 0.5);
}
.border-jade-200\\/55{
  border-color: rgba(182, 228, 209, 0.55);
}
.border-jade-200\\/60{
  border-color: rgba(182, 228, 209, 0.6);
}
.border-jade-200\\/65{
  border-color: rgba(182, 228, 209, 0.65);
}
.border-jade-200\\/70{
  border-color: rgba(182, 228, 209, 0.7);
}
.border-jade-200\\/75{
  border-color: rgba(182, 228, 209, 0.75);
}
.border-jade-200\\/80{
  border-color: rgba(182, 228, 209, 0.8);
}
.border-jade-200\\/85{
  border-color: rgba(182, 228, 209, 0.85);
}
.border-jade-200\\/90{
  border-color: rgba(182, 228, 209, 0.9);
}
.border-jade-200\\/95{
  border-color: rgba(182, 228, 209, 0.95);
}
.border-jade-300{
  --tw-border-opacity: 1;
  border-color: rgba(134, 207, 181, 1);
  border-color: rgba(134, 207, 181, var(--tw-border-opacity, 1));
}
.border-jade-300\\/0{
  border-color: rgba(134, 207, 181, 0);
}
.border-jade-300\\/10{
  border-color: rgba(134, 207, 181, 0.1);
}
.border-jade-300\\/100{
  border-color: rgb(134, 207, 181);
}
.border-jade-300\\/15{
  border-color: rgba(134, 207, 181, 0.15);
}
.border-jade-300\\/20{
  border-color: rgba(134, 207, 181, 0.2);
}
.border-jade-300\\/25{
  border-color: rgba(134, 207, 181, 0.25);
}
.border-jade-300\\/30{
  border-color: rgba(134, 207, 181, 0.3);
}
.border-jade-300\\/35{
  border-color: rgba(134, 207, 181, 0.35);
}
.border-jade-300\\/40{
  border-color: rgba(134, 207, 181, 0.4);
}
.border-jade-300\\/45{
  border-color: rgba(134, 207, 181, 0.45);
}
.border-jade-300\\/5{
  border-color: rgba(134, 207, 181, 0.05);
}
.border-jade-300\\/50{
  border-color: rgba(134, 207, 181, 0.5);
}
.border-jade-300\\/55{
  border-color: rgba(134, 207, 181, 0.55);
}
.border-jade-300\\/60{
  border-color: rgba(134, 207, 181, 0.6);
}
.border-jade-300\\/65{
  border-color: rgba(134, 207, 181, 0.65);
}
.border-jade-300\\/70{
  border-color: rgba(134, 207, 181, 0.7);
}
.border-jade-300\\/75{
  border-color: rgba(134, 207, 181, 0.75);
}
.border-jade-300\\/80{
  border-color: rgba(134, 207, 181, 0.8);
}
.border-jade-300\\/85{
  border-color: rgba(134, 207, 181, 0.85);
}
.border-jade-300\\/90{
  border-color: rgba(134, 207, 181, 0.9);
}
.border-jade-300\\/95{
  border-color: rgba(134, 207, 181, 0.95);
}
.border-jade-400{
  --tw-border-opacity: 1;
  border-color: rgba(83, 180, 148, 1);
  border-color: rgba(83, 180, 148, var(--tw-border-opacity, 1));
}
.border-jade-400\\/0{
  border-color: rgba(83, 180, 148, 0);
}
.border-jade-400\\/10{
  border-color: rgba(83, 180, 148, 0.1);
}
.border-jade-400\\/100{
  border-color: rgb(83, 180, 148);
}
.border-jade-400\\/15{
  border-color: rgba(83, 180, 148, 0.15);
}
.border-jade-400\\/20{
  border-color: rgba(83, 180, 148, 0.2);
}
.border-jade-400\\/25{
  border-color: rgba(83, 180, 148, 0.25);
}
.border-jade-400\\/30{
  border-color: rgba(83, 180, 148, 0.3);
}
.border-jade-400\\/35{
  border-color: rgba(83, 180, 148, 0.35);
}
.border-jade-400\\/40{
  border-color: rgba(83, 180, 148, 0.4);
}
.border-jade-400\\/45{
  border-color: rgba(83, 180, 148, 0.45);
}
.border-jade-400\\/5{
  border-color: rgba(83, 180, 148, 0.05);
}
.border-jade-400\\/50{
  border-color: rgba(83, 180, 148, 0.5);
}
.border-jade-400\\/55{
  border-color: rgba(83, 180, 148, 0.55);
}
.border-jade-400\\/60{
  border-color: rgba(83, 180, 148, 0.6);
}
.border-jade-400\\/65{
  border-color: rgba(83, 180, 148, 0.65);
}
.border-jade-400\\/70{
  border-color: rgba(83, 180, 148, 0.7);
}
.border-jade-400\\/75{
  border-color: rgba(83, 180, 148, 0.75);
}
.border-jade-400\\/80{
  border-color: rgba(83, 180, 148, 0.8);
}
.border-jade-400\\/85{
  border-color: rgba(83, 180, 148, 0.85);
}
.border-jade-400\\/90{
  border-color: rgba(83, 180, 148, 0.9);
}
.border-jade-400\\/95{
  border-color: rgba(83, 180, 148, 0.95);
}
.border-jade-500{
  --tw-border-opacity: 1;
  border-color: rgba(44, 135, 109, 1);
  border-color: rgba(44, 135, 109, var(--tw-border-opacity, 1));
}
.border-jade-500\\/0{
  border-color: rgba(44, 135, 109, 0);
}
.border-jade-500\\/10{
  border-color: rgba(44, 135, 109, 0.1);
}
.border-jade-500\\/100{
  border-color: rgb(44, 135, 109);
}
.border-jade-500\\/15{
  border-color: rgba(44, 135, 109, 0.15);
}
.border-jade-500\\/20{
  border-color: rgba(44, 135, 109, 0.2);
}
.border-jade-500\\/25{
  border-color: rgba(44, 135, 109, 0.25);
}
.border-jade-500\\/30{
  border-color: rgba(44, 135, 109, 0.3);
}
.border-jade-500\\/35{
  border-color: rgba(44, 135, 109, 0.35);
}
.border-jade-500\\/40{
  border-color: rgba(44, 135, 109, 0.4);
}
.border-jade-500\\/45{
  border-color: rgba(44, 135, 109, 0.45);
}
.border-jade-500\\/5{
  border-color: rgba(44, 135, 109, 0.05);
}
.border-jade-500\\/50{
  border-color: rgba(44, 135, 109, 0.5);
}
.border-jade-500\\/55{
  border-color: rgba(44, 135, 109, 0.55);
}
.border-jade-500\\/60{
  border-color: rgba(44, 135, 109, 0.6);
}
.border-jade-500\\/65{
  border-color: rgba(44, 135, 109, 0.65);
}
.border-jade-500\\/70{
  border-color: rgba(44, 135, 109, 0.7);
}
.border-jade-500\\/75{
  border-color: rgba(44, 135, 109, 0.75);
}
.border-jade-500\\/80{
  border-color: rgba(44, 135, 109, 0.8);
}
.border-jade-500\\/85{
  border-color: rgba(44, 135, 109, 0.85);
}
.border-jade-500\\/90{
  border-color: rgba(44, 135, 109, 0.9);
}
.border-jade-500\\/95{
  border-color: rgba(44, 135, 109, 0.95);
}
.border-jade-600{
  --tw-border-opacity: 1;
  border-color: rgba(34, 121, 98, 1);
  border-color: rgba(34, 121, 98, var(--tw-border-opacity, 1));
}
.border-jade-600\\/0{
  border-color: rgba(34, 121, 98, 0);
}
.border-jade-600\\/10{
  border-color: rgba(34, 121, 98, 0.1);
}
.border-jade-600\\/100{
  border-color: rgb(34, 121, 98);
}
.border-jade-600\\/15{
  border-color: rgba(34, 121, 98, 0.15);
}
.border-jade-600\\/20{
  border-color: rgba(34, 121, 98, 0.2);
}
.border-jade-600\\/25{
  border-color: rgba(34, 121, 98, 0.25);
}
.border-jade-600\\/30{
  border-color: rgba(34, 121, 98, 0.3);
}
.border-jade-600\\/35{
  border-color: rgba(34, 121, 98, 0.35);
}
.border-jade-600\\/40{
  border-color: rgba(34, 121, 98, 0.4);
}
.border-jade-600\\/45{
  border-color: rgba(34, 121, 98, 0.45);
}
.border-jade-600\\/5{
  border-color: rgba(34, 121, 98, 0.05);
}
.border-jade-600\\/50{
  border-color: rgba(34, 121, 98, 0.5);
}
.border-jade-600\\/55{
  border-color: rgba(34, 121, 98, 0.55);
}
.border-jade-600\\/60{
  border-color: rgba(34, 121, 98, 0.6);
}
.border-jade-600\\/65{
  border-color: rgba(34, 121, 98, 0.65);
}
.border-jade-600\\/70{
  border-color: rgba(34, 121, 98, 0.7);
}
.border-jade-600\\/75{
  border-color: rgba(34, 121, 98, 0.75);
}
.border-jade-600\\/80{
  border-color: rgba(34, 121, 98, 0.8);
}
.border-jade-600\\/85{
  border-color: rgba(34, 121, 98, 0.85);
}
.border-jade-600\\/90{
  border-color: rgba(34, 121, 98, 0.9);
}
.border-jade-600\\/95{
  border-color: rgba(34, 121, 98, 0.95);
}
.border-jade-700{
  --tw-border-opacity: 1;
  border-color: rgba(27, 97, 80, 1);
  border-color: rgba(27, 97, 80, var(--tw-border-opacity, 1));
}
.border-jade-700\\/0{
  border-color: rgba(27, 97, 80, 0);
}
.border-jade-700\\/10{
  border-color: rgba(27, 97, 80, 0.1);
}
.border-jade-700\\/100{
  border-color: rgb(27, 97, 80);
}
.border-jade-700\\/15{
  border-color: rgba(27, 97, 80, 0.15);
}
.border-jade-700\\/20{
  border-color: rgba(27, 97, 80, 0.2);
}
.border-jade-700\\/25{
  border-color: rgba(27, 97, 80, 0.25);
}
.border-jade-700\\/30{
  border-color: rgba(27, 97, 80, 0.3);
}
.border-jade-700\\/35{
  border-color: rgba(27, 97, 80, 0.35);
}
.border-jade-700\\/40{
  border-color: rgba(27, 97, 80, 0.4);
}
.border-jade-700\\/45{
  border-color: rgba(27, 97, 80, 0.45);
}
.border-jade-700\\/5{
  border-color: rgba(27, 97, 80, 0.05);
}
.border-jade-700\\/50{
  border-color: rgba(27, 97, 80, 0.5);
}
.border-jade-700\\/55{
  border-color: rgba(27, 97, 80, 0.55);
}
.border-jade-700\\/60{
  border-color: rgba(27, 97, 80, 0.6);
}
.border-jade-700\\/65{
  border-color: rgba(27, 97, 80, 0.65);
}
.border-jade-700\\/70{
  border-color: rgba(27, 97, 80, 0.7);
}
.border-jade-700\\/75{
  border-color: rgba(27, 97, 80, 0.75);
}
.border-jade-700\\/80{
  border-color: rgba(27, 97, 80, 0.8);
}
.border-jade-700\\/85{
  border-color: rgba(27, 97, 80, 0.85);
}
.border-jade-700\\/90{
  border-color: rgba(27, 97, 80, 0.9);
}
.border-jade-700\\/95{
  border-color: rgba(27, 97, 80, 0.95);
}
.border-jade-800{
  --tw-border-opacity: 1;
  border-color: rgba(24, 77, 64, 1);
  border-color: rgba(24, 77, 64, var(--tw-border-opacity, 1));
}
.border-jade-800\\/0{
  border-color: rgba(24, 77, 64, 0);
}
.border-jade-800\\/10{
  border-color: rgba(24, 77, 64, 0.1);
}
.border-jade-800\\/100{
  border-color: rgb(24, 77, 64);
}
.border-jade-800\\/15{
  border-color: rgba(24, 77, 64, 0.15);
}
.border-jade-800\\/20{
  border-color: rgba(24, 77, 64, 0.2);
}
.border-jade-800\\/25{
  border-color: rgba(24, 77, 64, 0.25);
}
.border-jade-800\\/30{
  border-color: rgba(24, 77, 64, 0.3);
}
.border-jade-800\\/35{
  border-color: rgba(24, 77, 64, 0.35);
}
.border-jade-800\\/40{
  border-color: rgba(24, 77, 64, 0.4);
}
.border-jade-800\\/45{
  border-color: rgba(24, 77, 64, 0.45);
}
.border-jade-800\\/5{
  border-color: rgba(24, 77, 64, 0.05);
}
.border-jade-800\\/50{
  border-color: rgba(24, 77, 64, 0.5);
}
.border-jade-800\\/55{
  border-color: rgba(24, 77, 64, 0.55);
}
.border-jade-800\\/60{
  border-color: rgba(24, 77, 64, 0.6);
}
.border-jade-800\\/65{
  border-color: rgba(24, 77, 64, 0.65);
}
.border-jade-800\\/70{
  border-color: rgba(24, 77, 64, 0.7);
}
.border-jade-800\\/75{
  border-color: rgba(24, 77, 64, 0.75);
}
.border-jade-800\\/80{
  border-color: rgba(24, 77, 64, 0.8);
}
.border-jade-800\\/85{
  border-color: rgba(24, 77, 64, 0.85);
}
.border-jade-800\\/90{
  border-color: rgba(24, 77, 64, 0.9);
}
.border-jade-800\\/95{
  border-color: rgba(24, 77, 64, 0.95);
}
.border-jade-900{
  --tw-border-opacity: 1;
  border-color: rgba(20, 64, 54, 1);
  border-color: rgba(20, 64, 54, var(--tw-border-opacity, 1));
}
.border-jade-900\\/0{
  border-color: rgba(20, 64, 54, 0);
}
.border-jade-900\\/10{
  border-color: rgba(20, 64, 54, 0.1);
}
.border-jade-900\\/100{
  border-color: rgb(20, 64, 54);
}
.border-jade-900\\/15{
  border-color: rgba(20, 64, 54, 0.15);
}
.border-jade-900\\/20{
  border-color: rgba(20, 64, 54, 0.2);
}
.border-jade-900\\/25{
  border-color: rgba(20, 64, 54, 0.25);
}
.border-jade-900\\/30{
  border-color: rgba(20, 64, 54, 0.3);
}
.border-jade-900\\/35{
  border-color: rgba(20, 64, 54, 0.35);
}
.border-jade-900\\/40{
  border-color: rgba(20, 64, 54, 0.4);
}
.border-jade-900\\/45{
  border-color: rgba(20, 64, 54, 0.45);
}
.border-jade-900\\/5{
  border-color: rgba(20, 64, 54, 0.05);
}
.border-jade-900\\/50{
  border-color: rgba(20, 64, 54, 0.5);
}
.border-jade-900\\/55{
  border-color: rgba(20, 64, 54, 0.55);
}
.border-jade-900\\/60{
  border-color: rgba(20, 64, 54, 0.6);
}
.border-jade-900\\/65{
  border-color: rgba(20, 64, 54, 0.65);
}
.border-jade-900\\/70{
  border-color: rgba(20, 64, 54, 0.7);
}
.border-jade-900\\/75{
  border-color: rgba(20, 64, 54, 0.75);
}
.border-jade-900\\/80{
  border-color: rgba(20, 64, 54, 0.8);
}
.border-jade-900\\/85{
  border-color: rgba(20, 64, 54, 0.85);
}
.border-jade-900\\/90{
  border-color: rgba(20, 64, 54, 0.9);
}
.border-jade-900\\/95{
  border-color: rgba(20, 64, 54, 0.95);
}
.border-jade-950{
  --tw-border-opacity: 1;
  border-color: rgba(10, 36, 31, 1);
  border-color: rgba(10, 36, 31, var(--tw-border-opacity, 1));
}
.border-jade-950\\/0{
  border-color: rgba(10, 36, 31, 0);
}
.border-jade-950\\/10{
  border-color: rgba(10, 36, 31, 0.1);
}
.border-jade-950\\/100{
  border-color: rgb(10, 36, 31);
}
.border-jade-950\\/15{
  border-color: rgba(10, 36, 31, 0.15);
}
.border-jade-950\\/20{
  border-color: rgba(10, 36, 31, 0.2);
}
.border-jade-950\\/25{
  border-color: rgba(10, 36, 31, 0.25);
}
.border-jade-950\\/30{
  border-color: rgba(10, 36, 31, 0.3);
}
.border-jade-950\\/35{
  border-color: rgba(10, 36, 31, 0.35);
}
.border-jade-950\\/40{
  border-color: rgba(10, 36, 31, 0.4);
}
.border-jade-950\\/45{
  border-color: rgba(10, 36, 31, 0.45);
}
.border-jade-950\\/5{
  border-color: rgba(10, 36, 31, 0.05);
}
.border-jade-950\\/50{
  border-color: rgba(10, 36, 31, 0.5);
}
.border-jade-950\\/55{
  border-color: rgba(10, 36, 31, 0.55);
}
.border-jade-950\\/60{
  border-color: rgba(10, 36, 31, 0.6);
}
.border-jade-950\\/65{
  border-color: rgba(10, 36, 31, 0.65);
}
.border-jade-950\\/70{
  border-color: rgba(10, 36, 31, 0.7);
}
.border-jade-950\\/75{
  border-color: rgba(10, 36, 31, 0.75);
}
.border-jade-950\\/80{
  border-color: rgba(10, 36, 31, 0.8);
}
.border-jade-950\\/85{
  border-color: rgba(10, 36, 31, 0.85);
}
.border-jade-950\\/90{
  border-color: rgba(10, 36, 31, 0.9);
}
.border-jade-950\\/95{
  border-color: rgba(10, 36, 31, 0.95);
}
.border-kids-alphabet-500{
  --tw-border-opacity: 1;
  border-color: rgba(55, 135, 163, 1);
  border-color: rgba(55, 135, 163, var(--tw-border-opacity, 1));
}
.border-kids-alphabet-500\\/0{
  border-color: rgba(55, 135, 163, 0);
}
.border-kids-alphabet-500\\/10{
  border-color: rgba(55, 135, 163, 0.1);
}
.border-kids-alphabet-500\\/100{
  border-color: rgb(55, 135, 163);
}
.border-kids-alphabet-500\\/15{
  border-color: rgba(55, 135, 163, 0.15);
}
.border-kids-alphabet-500\\/20{
  border-color: rgba(55, 135, 163, 0.2);
}
.border-kids-alphabet-500\\/25{
  border-color: rgba(55, 135, 163, 0.25);
}
.border-kids-alphabet-500\\/30{
  border-color: rgba(55, 135, 163, 0.3);
}
.border-kids-alphabet-500\\/35{
  border-color: rgba(55, 135, 163, 0.35);
}
.border-kids-alphabet-500\\/40{
  border-color: rgba(55, 135, 163, 0.4);
}
.border-kids-alphabet-500\\/45{
  border-color: rgba(55, 135, 163, 0.45);
}
.border-kids-alphabet-500\\/5{
  border-color: rgba(55, 135, 163, 0.05);
}
.border-kids-alphabet-500\\/50{
  border-color: rgba(55, 135, 163, 0.5);
}
.border-kids-alphabet-500\\/55{
  border-color: rgba(55, 135, 163, 0.55);
}
.border-kids-alphabet-500\\/60{
  border-color: rgba(55, 135, 163, 0.6);
}
.border-kids-alphabet-500\\/65{
  border-color: rgba(55, 135, 163, 0.65);
}
.border-kids-alphabet-500\\/70{
  border-color: rgba(55, 135, 163, 0.7);
}
.border-kids-alphabet-500\\/75{
  border-color: rgba(55, 135, 163, 0.75);
}
.border-kids-alphabet-500\\/80{
  border-color: rgba(55, 135, 163, 0.8);
}
.border-kids-alphabet-500\\/85{
  border-color: rgba(55, 135, 163, 0.85);
}
.border-kids-alphabet-500\\/90{
  border-color: rgba(55, 135, 163, 0.9);
}
.border-kids-alphabet-500\\/95{
  border-color: rgba(55, 135, 163, 0.95);
}
.border-kids-alphabet-600{
  --tw-border-opacity: 1;
  border-color: rgba(48, 109, 138, 1);
  border-color: rgba(48, 109, 138, var(--tw-border-opacity, 1));
}
.border-kids-alphabet-600\\/0{
  border-color: rgba(48, 109, 138, 0);
}
.border-kids-alphabet-600\\/10{
  border-color: rgba(48, 109, 138, 0.1);
}
.border-kids-alphabet-600\\/100{
  border-color: rgb(48, 109, 138);
}
.border-kids-alphabet-600\\/15{
  border-color: rgba(48, 109, 138, 0.15);
}
.border-kids-alphabet-600\\/20{
  border-color: rgba(48, 109, 138, 0.2);
}
.border-kids-alphabet-600\\/25{
  border-color: rgba(48, 109, 138, 0.25);
}
.border-kids-alphabet-600\\/30{
  border-color: rgba(48, 109, 138, 0.3);
}
.border-kids-alphabet-600\\/35{
  border-color: rgba(48, 109, 138, 0.35);
}
.border-kids-alphabet-600\\/40{
  border-color: rgba(48, 109, 138, 0.4);
}
.border-kids-alphabet-600\\/45{
  border-color: rgba(48, 109, 138, 0.45);
}
.border-kids-alphabet-600\\/5{
  border-color: rgba(48, 109, 138, 0.05);
}
.border-kids-alphabet-600\\/50{
  border-color: rgba(48, 109, 138, 0.5);
}
.border-kids-alphabet-600\\/55{
  border-color: rgba(48, 109, 138, 0.55);
}
.border-kids-alphabet-600\\/60{
  border-color: rgba(48, 109, 138, 0.6);
}
.border-kids-alphabet-600\\/65{
  border-color: rgba(48, 109, 138, 0.65);
}
.border-kids-alphabet-600\\/70{
  border-color: rgba(48, 109, 138, 0.7);
}
.border-kids-alphabet-600\\/75{
  border-color: rgba(48, 109, 138, 0.75);
}
.border-kids-alphabet-600\\/80{
  border-color: rgba(48, 109, 138, 0.8);
}
.border-kids-alphabet-600\\/85{
  border-color: rgba(48, 109, 138, 0.85);
}
.border-kids-alphabet-600\\/90{
  border-color: rgba(48, 109, 138, 0.9);
}
.border-kids-alphabet-600\\/95{
  border-color: rgba(48, 109, 138, 0.95);
}
.border-kids-alphabet-700{
  --tw-border-opacity: 1;
  border-color: rgba(45, 91, 114, 1);
  border-color: rgba(45, 91, 114, var(--tw-border-opacity, 1));
}
.border-kids-alphabet-700\\/0{
  border-color: rgba(45, 91, 114, 0);
}
.border-kids-alphabet-700\\/10{
  border-color: rgba(45, 91, 114, 0.1);
}
.border-kids-alphabet-700\\/100{
  border-color: rgb(45, 91, 114);
}
.border-kids-alphabet-700\\/15{
  border-color: rgba(45, 91, 114, 0.15);
}
.border-kids-alphabet-700\\/20{
  border-color: rgba(45, 91, 114, 0.2);
}
.border-kids-alphabet-700\\/25{
  border-color: rgba(45, 91, 114, 0.25);
}
.border-kids-alphabet-700\\/30{
  border-color: rgba(45, 91, 114, 0.3);
}
.border-kids-alphabet-700\\/35{
  border-color: rgba(45, 91, 114, 0.35);
}
.border-kids-alphabet-700\\/40{
  border-color: rgba(45, 91, 114, 0.4);
}
.border-kids-alphabet-700\\/45{
  border-color: rgba(45, 91, 114, 0.45);
}
.border-kids-alphabet-700\\/5{
  border-color: rgba(45, 91, 114, 0.05);
}
.border-kids-alphabet-700\\/50{
  border-color: rgba(45, 91, 114, 0.5);
}
.border-kids-alphabet-700\\/55{
  border-color: rgba(45, 91, 114, 0.55);
}
.border-kids-alphabet-700\\/60{
  border-color: rgba(45, 91, 114, 0.6);
}
.border-kids-alphabet-700\\/65{
  border-color: rgba(45, 91, 114, 0.65);
}
.border-kids-alphabet-700\\/70{
  border-color: rgba(45, 91, 114, 0.7);
}
.border-kids-alphabet-700\\/75{
  border-color: rgba(45, 91, 114, 0.75);
}
.border-kids-alphabet-700\\/80{
  border-color: rgba(45, 91, 114, 0.8);
}
.border-kids-alphabet-700\\/85{
  border-color: rgba(45, 91, 114, 0.85);
}
.border-kids-alphabet-700\\/90{
  border-color: rgba(45, 91, 114, 0.9);
}
.border-kids-alphabet-700\\/95{
  border-color: rgba(45, 91, 114, 0.95);
}
.border-kids-alphabet-800{
  --tw-border-opacity: 1;
  border-color: rgba(44, 76, 94, 1);
  border-color: rgba(44, 76, 94, var(--tw-border-opacity, 1));
}
.border-kids-alphabet-800\\/0{
  border-color: rgba(44, 76, 94, 0);
}
.border-kids-alphabet-800\\/10{
  border-color: rgba(44, 76, 94, 0.1);
}
.border-kids-alphabet-800\\/100{
  border-color: rgb(44, 76, 94);
}
.border-kids-alphabet-800\\/15{
  border-color: rgba(44, 76, 94, 0.15);
}
.border-kids-alphabet-800\\/20{
  border-color: rgba(44, 76, 94, 0.2);
}
.border-kids-alphabet-800\\/25{
  border-color: rgba(44, 76, 94, 0.25);
}
.border-kids-alphabet-800\\/30{
  border-color: rgba(44, 76, 94, 0.3);
}
.border-kids-alphabet-800\\/35{
  border-color: rgba(44, 76, 94, 0.35);
}
.border-kids-alphabet-800\\/40{
  border-color: rgba(44, 76, 94, 0.4);
}
.border-kids-alphabet-800\\/45{
  border-color: rgba(44, 76, 94, 0.45);
}
.border-kids-alphabet-800\\/5{
  border-color: rgba(44, 76, 94, 0.05);
}
.border-kids-alphabet-800\\/50{
  border-color: rgba(44, 76, 94, 0.5);
}
.border-kids-alphabet-800\\/55{
  border-color: rgba(44, 76, 94, 0.55);
}
.border-kids-alphabet-800\\/60{
  border-color: rgba(44, 76, 94, 0.6);
}
.border-kids-alphabet-800\\/65{
  border-color: rgba(44, 76, 94, 0.65);
}
.border-kids-alphabet-800\\/70{
  border-color: rgba(44, 76, 94, 0.7);
}
.border-kids-alphabet-800\\/75{
  border-color: rgba(44, 76, 94, 0.75);
}
.border-kids-alphabet-800\\/80{
  border-color: rgba(44, 76, 94, 0.8);
}
.border-kids-alphabet-800\\/85{
  border-color: rgba(44, 76, 94, 0.85);
}
.border-kids-alphabet-800\\/90{
  border-color: rgba(44, 76, 94, 0.9);
}
.border-kids-alphabet-800\\/95{
  border-color: rgba(44, 76, 94, 0.95);
}
.border-kids-alphabet-900{
  --tw-border-opacity: 1;
  border-color: rgba(40, 65, 81, 1);
  border-color: rgba(40, 65, 81, var(--tw-border-opacity, 1));
}
.border-kids-alphabet-900\\/0{
  border-color: rgba(40, 65, 81, 0);
}
.border-kids-alphabet-900\\/10{
  border-color: rgba(40, 65, 81, 0.1);
}
.border-kids-alphabet-900\\/100{
  border-color: rgb(40, 65, 81);
}
.border-kids-alphabet-900\\/15{
  border-color: rgba(40, 65, 81, 0.15);
}
.border-kids-alphabet-900\\/20{
  border-color: rgba(40, 65, 81, 0.2);
}
.border-kids-alphabet-900\\/25{
  border-color: rgba(40, 65, 81, 0.25);
}
.border-kids-alphabet-900\\/30{
  border-color: rgba(40, 65, 81, 0.3);
}
.border-kids-alphabet-900\\/35{
  border-color: rgba(40, 65, 81, 0.35);
}
.border-kids-alphabet-900\\/40{
  border-color: rgba(40, 65, 81, 0.4);
}
.border-kids-alphabet-900\\/45{
  border-color: rgba(40, 65, 81, 0.45);
}
.border-kids-alphabet-900\\/5{
  border-color: rgba(40, 65, 81, 0.05);
}
.border-kids-alphabet-900\\/50{
  border-color: rgba(40, 65, 81, 0.5);
}
.border-kids-alphabet-900\\/55{
  border-color: rgba(40, 65, 81, 0.55);
}
.border-kids-alphabet-900\\/60{
  border-color: rgba(40, 65, 81, 0.6);
}
.border-kids-alphabet-900\\/65{
  border-color: rgba(40, 65, 81, 0.65);
}
.border-kids-alphabet-900\\/70{
  border-color: rgba(40, 65, 81, 0.7);
}
.border-kids-alphabet-900\\/75{
  border-color: rgba(40, 65, 81, 0.75);
}
.border-kids-alphabet-900\\/80{
  border-color: rgba(40, 65, 81, 0.8);
}
.border-kids-alphabet-900\\/85{
  border-color: rgba(40, 65, 81, 0.85);
}
.border-kids-alphabet-900\\/90{
  border-color: rgba(40, 65, 81, 0.9);
}
.border-kids-alphabet-900\\/95{
  border-color: rgba(40, 65, 81, 0.95);
}
.border-kids-categories-500{
  --tw-border-opacity: 1;
  border-color: rgba(209, 145, 47, 1);
  border-color: rgba(209, 145, 47, var(--tw-border-opacity, 1));
}
.border-kids-categories-500\\/0{
  border-color: rgba(209, 145, 47, 0);
}
.border-kids-categories-500\\/10{
  border-color: rgba(209, 145, 47, 0.1);
}
.border-kids-categories-500\\/100{
  border-color: rgb(209, 145, 47);
}
.border-kids-categories-500\\/15{
  border-color: rgba(209, 145, 47, 0.15);
}
.border-kids-categories-500\\/20{
  border-color: rgba(209, 145, 47, 0.2);
}
.border-kids-categories-500\\/25{
  border-color: rgba(209, 145, 47, 0.25);
}
.border-kids-categories-500\\/30{
  border-color: rgba(209, 145, 47, 0.3);
}
.border-kids-categories-500\\/35{
  border-color: rgba(209, 145, 47, 0.35);
}
.border-kids-categories-500\\/40{
  border-color: rgba(209, 145, 47, 0.4);
}
.border-kids-categories-500\\/45{
  border-color: rgba(209, 145, 47, 0.45);
}
.border-kids-categories-500\\/5{
  border-color: rgba(209, 145, 47, 0.05);
}
.border-kids-categories-500\\/50{
  border-color: rgba(209, 145, 47, 0.5);
}
.border-kids-categories-500\\/55{
  border-color: rgba(209, 145, 47, 0.55);
}
.border-kids-categories-500\\/60{
  border-color: rgba(209, 145, 47, 0.6);
}
.border-kids-categories-500\\/65{
  border-color: rgba(209, 145, 47, 0.65);
}
.border-kids-categories-500\\/70{
  border-color: rgba(209, 145, 47, 0.7);
}
.border-kids-categories-500\\/75{
  border-color: rgba(209, 145, 47, 0.75);
}
.border-kids-categories-500\\/80{
  border-color: rgba(209, 145, 47, 0.8);
}
.border-kids-categories-500\\/85{
  border-color: rgba(209, 145, 47, 0.85);
}
.border-kids-categories-500\\/90{
  border-color: rgba(209, 145, 47, 0.9);
}
.border-kids-categories-500\\/95{
  border-color: rgba(209, 145, 47, 0.95);
}
.border-kids-categories-600{
  --tw-border-opacity: 1;
  border-color: rgba(195, 120, 41, 1);
  border-color: rgba(195, 120, 41, var(--tw-border-opacity, 1));
}
.border-kids-categories-600\\/0{
  border-color: rgba(195, 120, 41, 0);
}
.border-kids-categories-600\\/10{
  border-color: rgba(195, 120, 41, 0.1);
}
.border-kids-categories-600\\/100{
  border-color: rgb(195, 120, 41);
}
.border-kids-categories-600\\/15{
  border-color: rgba(195, 120, 41, 0.15);
}
.border-kids-categories-600\\/20{
  border-color: rgba(195, 120, 41, 0.2);
}
.border-kids-categories-600\\/25{
  border-color: rgba(195, 120, 41, 0.25);
}
.border-kids-categories-600\\/30{
  border-color: rgba(195, 120, 41, 0.3);
}
.border-kids-categories-600\\/35{
  border-color: rgba(195, 120, 41, 0.35);
}
.border-kids-categories-600\\/40{
  border-color: rgba(195, 120, 41, 0.4);
}
.border-kids-categories-600\\/45{
  border-color: rgba(195, 120, 41, 0.45);
}
.border-kids-categories-600\\/5{
  border-color: rgba(195, 120, 41, 0.05);
}
.border-kids-categories-600\\/50{
  border-color: rgba(195, 120, 41, 0.5);
}
.border-kids-categories-600\\/55{
  border-color: rgba(195, 120, 41, 0.55);
}
.border-kids-categories-600\\/60{
  border-color: rgba(195, 120, 41, 0.6);
}
.border-kids-categories-600\\/65{
  border-color: rgba(195, 120, 41, 0.65);
}
.border-kids-categories-600\\/70{
  border-color: rgba(195, 120, 41, 0.7);
}
.border-kids-categories-600\\/75{
  border-color: rgba(195, 120, 41, 0.75);
}
.border-kids-categories-600\\/80{
  border-color: rgba(195, 120, 41, 0.8);
}
.border-kids-categories-600\\/85{
  border-color: rgba(195, 120, 41, 0.85);
}
.border-kids-categories-600\\/90{
  border-color: rgba(195, 120, 41, 0.9);
}
.border-kids-categories-600\\/95{
  border-color: rgba(195, 120, 41, 0.95);
}
.border-kids-categories-700{
  --tw-border-opacity: 1;
  border-color: rgba(153, 84, 36, 1);
  border-color: rgba(153, 84, 36, var(--tw-border-opacity, 1));
}
.border-kids-categories-700\\/0{
  border-color: rgba(153, 84, 36, 0);
}
.border-kids-categories-700\\/10{
  border-color: rgba(153, 84, 36, 0.1);
}
.border-kids-categories-700\\/100{
  border-color: rgb(153, 84, 36);
}
.border-kids-categories-700\\/15{
  border-color: rgba(153, 84, 36, 0.15);
}
.border-kids-categories-700\\/20{
  border-color: rgba(153, 84, 36, 0.2);
}
.border-kids-categories-700\\/25{
  border-color: rgba(153, 84, 36, 0.25);
}
.border-kids-categories-700\\/30{
  border-color: rgba(153, 84, 36, 0.3);
}
.border-kids-categories-700\\/35{
  border-color: rgba(153, 84, 36, 0.35);
}
.border-kids-categories-700\\/40{
  border-color: rgba(153, 84, 36, 0.4);
}
.border-kids-categories-700\\/45{
  border-color: rgba(153, 84, 36, 0.45);
}
.border-kids-categories-700\\/5{
  border-color: rgba(153, 84, 36, 0.05);
}
.border-kids-categories-700\\/50{
  border-color: rgba(153, 84, 36, 0.5);
}
.border-kids-categories-700\\/55{
  border-color: rgba(153, 84, 36, 0.55);
}
.border-kids-categories-700\\/60{
  border-color: rgba(153, 84, 36, 0.6);
}
.border-kids-categories-700\\/65{
  border-color: rgba(153, 84, 36, 0.65);
}
.border-kids-categories-700\\/70{
  border-color: rgba(153, 84, 36, 0.7);
}
.border-kids-categories-700\\/75{
  border-color: rgba(153, 84, 36, 0.75);
}
.border-kids-categories-700\\/80{
  border-color: rgba(153, 84, 36, 0.8);
}
.border-kids-categories-700\\/85{
  border-color: rgba(153, 84, 36, 0.85);
}
.border-kids-categories-700\\/90{
  border-color: rgba(153, 84, 36, 0.9);
}
.border-kids-categories-700\\/95{
  border-color: rgba(153, 84, 36, 0.95);
}
.border-kids-categories-800{
  --tw-border-opacity: 1;
  border-color: rgba(126, 67, 34, 1);
  border-color: rgba(126, 67, 34, var(--tw-border-opacity, 1));
}
.border-kids-categories-800\\/0{
  border-color: rgba(126, 67, 34, 0);
}
.border-kids-categories-800\\/10{
  border-color: rgba(126, 67, 34, 0.1);
}
.border-kids-categories-800\\/100{
  border-color: rgb(126, 67, 34);
}
.border-kids-categories-800\\/15{
  border-color: rgba(126, 67, 34, 0.15);
}
.border-kids-categories-800\\/20{
  border-color: rgba(126, 67, 34, 0.2);
}
.border-kids-categories-800\\/25{
  border-color: rgba(126, 67, 34, 0.25);
}
.border-kids-categories-800\\/30{
  border-color: rgba(126, 67, 34, 0.3);
}
.border-kids-categories-800\\/35{
  border-color: rgba(126, 67, 34, 0.35);
}
.border-kids-categories-800\\/40{
  border-color: rgba(126, 67, 34, 0.4);
}
.border-kids-categories-800\\/45{
  border-color: rgba(126, 67, 34, 0.45);
}
.border-kids-categories-800\\/5{
  border-color: rgba(126, 67, 34, 0.05);
}
.border-kids-categories-800\\/50{
  border-color: rgba(126, 67, 34, 0.5);
}
.border-kids-categories-800\\/55{
  border-color: rgba(126, 67, 34, 0.55);
}
.border-kids-categories-800\\/60{
  border-color: rgba(126, 67, 34, 0.6);
}
.border-kids-categories-800\\/65{
  border-color: rgba(126, 67, 34, 0.65);
}
.border-kids-categories-800\\/70{
  border-color: rgba(126, 67, 34, 0.7);
}
.border-kids-categories-800\\/75{
  border-color: rgba(126, 67, 34, 0.75);
}
.border-kids-categories-800\\/80{
  border-color: rgba(126, 67, 34, 0.8);
}
.border-kids-categories-800\\/85{
  border-color: rgba(126, 67, 34, 0.85);
}
.border-kids-categories-800\\/90{
  border-color: rgba(126, 67, 34, 0.9);
}
.border-kids-categories-800\\/95{
  border-color: rgba(126, 67, 34, 0.95);
}
.border-kids-categories-900{
  --tw-border-opacity: 1;
  border-color: rgba(104, 56, 31, 1);
  border-color: rgba(104, 56, 31, var(--tw-border-opacity, 1));
}
.border-kids-categories-900\\/0{
  border-color: rgba(104, 56, 31, 0);
}
.border-kids-categories-900\\/10{
  border-color: rgba(104, 56, 31, 0.1);
}
.border-kids-categories-900\\/100{
  border-color: rgb(104, 56, 31);
}
.border-kids-categories-900\\/15{
  border-color: rgba(104, 56, 31, 0.15);
}
.border-kids-categories-900\\/20{
  border-color: rgba(104, 56, 31, 0.2);
}
.border-kids-categories-900\\/25{
  border-color: rgba(104, 56, 31, 0.25);
}
.border-kids-categories-900\\/30{
  border-color: rgba(104, 56, 31, 0.3);
}
.border-kids-categories-900\\/35{
  border-color: rgba(104, 56, 31, 0.35);
}
.border-kids-categories-900\\/40{
  border-color: rgba(104, 56, 31, 0.4);
}
.border-kids-categories-900\\/45{
  border-color: rgba(104, 56, 31, 0.45);
}
.border-kids-categories-900\\/5{
  border-color: rgba(104, 56, 31, 0.05);
}
.border-kids-categories-900\\/50{
  border-color: rgba(104, 56, 31, 0.5);
}
.border-kids-categories-900\\/55{
  border-color: rgba(104, 56, 31, 0.55);
}
.border-kids-categories-900\\/60{
  border-color: rgba(104, 56, 31, 0.6);
}
.border-kids-categories-900\\/65{
  border-color: rgba(104, 56, 31, 0.65);
}
.border-kids-categories-900\\/70{
  border-color: rgba(104, 56, 31, 0.7);
}
.border-kids-categories-900\\/75{
  border-color: rgba(104, 56, 31, 0.75);
}
.border-kids-categories-900\\/80{
  border-color: rgba(104, 56, 31, 0.8);
}
.border-kids-categories-900\\/85{
  border-color: rgba(104, 56, 31, 0.85);
}
.border-kids-categories-900\\/90{
  border-color: rgba(104, 56, 31, 0.9);
}
.border-kids-categories-900\\/95{
  border-color: rgba(104, 56, 31, 0.95);
}
.border-kids-dictionary-500{
  --tw-border-opacity: 1;
  border-color: rgba(44, 135, 109, 1);
  border-color: rgba(44, 135, 109, var(--tw-border-opacity, 1));
}
.border-kids-dictionary-500\\/0{
  border-color: rgba(44, 135, 109, 0);
}
.border-kids-dictionary-500\\/10{
  border-color: rgba(44, 135, 109, 0.1);
}
.border-kids-dictionary-500\\/100{
  border-color: rgb(44, 135, 109);
}
.border-kids-dictionary-500\\/15{
  border-color: rgba(44, 135, 109, 0.15);
}
.border-kids-dictionary-500\\/20{
  border-color: rgba(44, 135, 109, 0.2);
}
.border-kids-dictionary-500\\/25{
  border-color: rgba(44, 135, 109, 0.25);
}
.border-kids-dictionary-500\\/30{
  border-color: rgba(44, 135, 109, 0.3);
}
.border-kids-dictionary-500\\/35{
  border-color: rgba(44, 135, 109, 0.35);
}
.border-kids-dictionary-500\\/40{
  border-color: rgba(44, 135, 109, 0.4);
}
.border-kids-dictionary-500\\/45{
  border-color: rgba(44, 135, 109, 0.45);
}
.border-kids-dictionary-500\\/5{
  border-color: rgba(44, 135, 109, 0.05);
}
.border-kids-dictionary-500\\/50{
  border-color: rgba(44, 135, 109, 0.5);
}
.border-kids-dictionary-500\\/55{
  border-color: rgba(44, 135, 109, 0.55);
}
.border-kids-dictionary-500\\/60{
  border-color: rgba(44, 135, 109, 0.6);
}
.border-kids-dictionary-500\\/65{
  border-color: rgba(44, 135, 109, 0.65);
}
.border-kids-dictionary-500\\/70{
  border-color: rgba(44, 135, 109, 0.7);
}
.border-kids-dictionary-500\\/75{
  border-color: rgba(44, 135, 109, 0.75);
}
.border-kids-dictionary-500\\/80{
  border-color: rgba(44, 135, 109, 0.8);
}
.border-kids-dictionary-500\\/85{
  border-color: rgba(44, 135, 109, 0.85);
}
.border-kids-dictionary-500\\/90{
  border-color: rgba(44, 135, 109, 0.9);
}
.border-kids-dictionary-500\\/95{
  border-color: rgba(44, 135, 109, 0.95);
}
.border-kids-dictionary-600{
  --tw-border-opacity: 1;
  border-color: rgba(34, 121, 98, 1);
  border-color: rgba(34, 121, 98, var(--tw-border-opacity, 1));
}
.border-kids-dictionary-600\\/0{
  border-color: rgba(34, 121, 98, 0);
}
.border-kids-dictionary-600\\/10{
  border-color: rgba(34, 121, 98, 0.1);
}
.border-kids-dictionary-600\\/100{
  border-color: rgb(34, 121, 98);
}
.border-kids-dictionary-600\\/15{
  border-color: rgba(34, 121, 98, 0.15);
}
.border-kids-dictionary-600\\/20{
  border-color: rgba(34, 121, 98, 0.2);
}
.border-kids-dictionary-600\\/25{
  border-color: rgba(34, 121, 98, 0.25);
}
.border-kids-dictionary-600\\/30{
  border-color: rgba(34, 121, 98, 0.3);
}
.border-kids-dictionary-600\\/35{
  border-color: rgba(34, 121, 98, 0.35);
}
.border-kids-dictionary-600\\/40{
  border-color: rgba(34, 121, 98, 0.4);
}
.border-kids-dictionary-600\\/45{
  border-color: rgba(34, 121, 98, 0.45);
}
.border-kids-dictionary-600\\/5{
  border-color: rgba(34, 121, 98, 0.05);
}
.border-kids-dictionary-600\\/50{
  border-color: rgba(34, 121, 98, 0.5);
}
.border-kids-dictionary-600\\/55{
  border-color: rgba(34, 121, 98, 0.55);
}
.border-kids-dictionary-600\\/60{
  border-color: rgba(34, 121, 98, 0.6);
}
.border-kids-dictionary-600\\/65{
  border-color: rgba(34, 121, 98, 0.65);
}
.border-kids-dictionary-600\\/70{
  border-color: rgba(34, 121, 98, 0.7);
}
.border-kids-dictionary-600\\/75{
  border-color: rgba(34, 121, 98, 0.75);
}
.border-kids-dictionary-600\\/80{
  border-color: rgba(34, 121, 98, 0.8);
}
.border-kids-dictionary-600\\/85{
  border-color: rgba(34, 121, 98, 0.85);
}
.border-kids-dictionary-600\\/90{
  border-color: rgba(34, 121, 98, 0.9);
}
.border-kids-dictionary-600\\/95{
  border-color: rgba(34, 121, 98, 0.95);
}
.border-kids-dictionary-700{
  --tw-border-opacity: 1;
  border-color: rgba(27, 97, 80, 1);
  border-color: rgba(27, 97, 80, var(--tw-border-opacity, 1));
}
.border-kids-dictionary-700\\/0{
  border-color: rgba(27, 97, 80, 0);
}
.border-kids-dictionary-700\\/10{
  border-color: rgba(27, 97, 80, 0.1);
}
.border-kids-dictionary-700\\/100{
  border-color: rgb(27, 97, 80);
}
.border-kids-dictionary-700\\/15{
  border-color: rgba(27, 97, 80, 0.15);
}
.border-kids-dictionary-700\\/20{
  border-color: rgba(27, 97, 80, 0.2);
}
.border-kids-dictionary-700\\/25{
  border-color: rgba(27, 97, 80, 0.25);
}
.border-kids-dictionary-700\\/30{
  border-color: rgba(27, 97, 80, 0.3);
}
.border-kids-dictionary-700\\/35{
  border-color: rgba(27, 97, 80, 0.35);
}
.border-kids-dictionary-700\\/40{
  border-color: rgba(27, 97, 80, 0.4);
}
.border-kids-dictionary-700\\/45{
  border-color: rgba(27, 97, 80, 0.45);
}
.border-kids-dictionary-700\\/5{
  border-color: rgba(27, 97, 80, 0.05);
}
.border-kids-dictionary-700\\/50{
  border-color: rgba(27, 97, 80, 0.5);
}
.border-kids-dictionary-700\\/55{
  border-color: rgba(27, 97, 80, 0.55);
}
.border-kids-dictionary-700\\/60{
  border-color: rgba(27, 97, 80, 0.6);
}
.border-kids-dictionary-700\\/65{
  border-color: rgba(27, 97, 80, 0.65);
}
.border-kids-dictionary-700\\/70{
  border-color: rgba(27, 97, 80, 0.7);
}
.border-kids-dictionary-700\\/75{
  border-color: rgba(27, 97, 80, 0.75);
}
.border-kids-dictionary-700\\/80{
  border-color: rgba(27, 97, 80, 0.8);
}
.border-kids-dictionary-700\\/85{
  border-color: rgba(27, 97, 80, 0.85);
}
.border-kids-dictionary-700\\/90{
  border-color: rgba(27, 97, 80, 0.9);
}
.border-kids-dictionary-700\\/95{
  border-color: rgba(27, 97, 80, 0.95);
}
.border-kids-dictionary-800{
  --tw-border-opacity: 1;
  border-color: rgba(24, 77, 64, 1);
  border-color: rgba(24, 77, 64, var(--tw-border-opacity, 1));
}
.border-kids-dictionary-800\\/0{
  border-color: rgba(24, 77, 64, 0);
}
.border-kids-dictionary-800\\/10{
  border-color: rgba(24, 77, 64, 0.1);
}
.border-kids-dictionary-800\\/100{
  border-color: rgb(24, 77, 64);
}
.border-kids-dictionary-800\\/15{
  border-color: rgba(24, 77, 64, 0.15);
}
.border-kids-dictionary-800\\/20{
  border-color: rgba(24, 77, 64, 0.2);
}
.border-kids-dictionary-800\\/25{
  border-color: rgba(24, 77, 64, 0.25);
}
.border-kids-dictionary-800\\/30{
  border-color: rgba(24, 77, 64, 0.3);
}
.border-kids-dictionary-800\\/35{
  border-color: rgba(24, 77, 64, 0.35);
}
.border-kids-dictionary-800\\/40{
  border-color: rgba(24, 77, 64, 0.4);
}
.border-kids-dictionary-800\\/45{
  border-color: rgba(24, 77, 64, 0.45);
}
.border-kids-dictionary-800\\/5{
  border-color: rgba(24, 77, 64, 0.05);
}
.border-kids-dictionary-800\\/50{
  border-color: rgba(24, 77, 64, 0.5);
}
.border-kids-dictionary-800\\/55{
  border-color: rgba(24, 77, 64, 0.55);
}
.border-kids-dictionary-800\\/60{
  border-color: rgba(24, 77, 64, 0.6);
}
.border-kids-dictionary-800\\/65{
  border-color: rgba(24, 77, 64, 0.65);
}
.border-kids-dictionary-800\\/70{
  border-color: rgba(24, 77, 64, 0.7);
}
.border-kids-dictionary-800\\/75{
  border-color: rgba(24, 77, 64, 0.75);
}
.border-kids-dictionary-800\\/80{
  border-color: rgba(24, 77, 64, 0.8);
}
.border-kids-dictionary-800\\/85{
  border-color: rgba(24, 77, 64, 0.85);
}
.border-kids-dictionary-800\\/90{
  border-color: rgba(24, 77, 64, 0.9);
}
.border-kids-dictionary-800\\/95{
  border-color: rgba(24, 77, 64, 0.95);
}
.border-kids-dictionary-900{
  --tw-border-opacity: 1;
  border-color: rgba(20, 64, 54, 1);
  border-color: rgba(20, 64, 54, var(--tw-border-opacity, 1));
}
.border-kids-dictionary-900\\/0{
  border-color: rgba(20, 64, 54, 0);
}
.border-kids-dictionary-900\\/10{
  border-color: rgba(20, 64, 54, 0.1);
}
.border-kids-dictionary-900\\/100{
  border-color: rgb(20, 64, 54);
}
.border-kids-dictionary-900\\/15{
  border-color: rgba(20, 64, 54, 0.15);
}
.border-kids-dictionary-900\\/20{
  border-color: rgba(20, 64, 54, 0.2);
}
.border-kids-dictionary-900\\/25{
  border-color: rgba(20, 64, 54, 0.25);
}
.border-kids-dictionary-900\\/30{
  border-color: rgba(20, 64, 54, 0.3);
}
.border-kids-dictionary-900\\/35{
  border-color: rgba(20, 64, 54, 0.35);
}
.border-kids-dictionary-900\\/40{
  border-color: rgba(20, 64, 54, 0.4);
}
.border-kids-dictionary-900\\/45{
  border-color: rgba(20, 64, 54, 0.45);
}
.border-kids-dictionary-900\\/5{
  border-color: rgba(20, 64, 54, 0.05);
}
.border-kids-dictionary-900\\/50{
  border-color: rgba(20, 64, 54, 0.5);
}
.border-kids-dictionary-900\\/55{
  border-color: rgba(20, 64, 54, 0.55);
}
.border-kids-dictionary-900\\/60{
  border-color: rgba(20, 64, 54, 0.6);
}
.border-kids-dictionary-900\\/65{
  border-color: rgba(20, 64, 54, 0.65);
}
.border-kids-dictionary-900\\/70{
  border-color: rgba(20, 64, 54, 0.7);
}
.border-kids-dictionary-900\\/75{
  border-color: rgba(20, 64, 54, 0.75);
}
.border-kids-dictionary-900\\/80{
  border-color: rgba(20, 64, 54, 0.8);
}
.border-kids-dictionary-900\\/85{
  border-color: rgba(20, 64, 54, 0.85);
}
.border-kids-dictionary-900\\/90{
  border-color: rgba(20, 64, 54, 0.9);
}
.border-kids-dictionary-900\\/95{
  border-color: rgba(20, 64, 54, 0.95);
}
.border-kids-games-500{
  --tw-border-opacity: 1;
  border-color: rgba(81, 59, 86, 1);
  border-color: rgba(81, 59, 86, var(--tw-border-opacity, 1));
}
.border-kids-games-500\\/0{
  border-color: rgba(81, 59, 86, 0);
}
.border-kids-games-500\\/10{
  border-color: rgba(81, 59, 86, 0.1);
}
.border-kids-games-500\\/100{
  border-color: rgb(81, 59, 86);
}
.border-kids-games-500\\/15{
  border-color: rgba(81, 59, 86, 0.15);
}
.border-kids-games-500\\/20{
  border-color: rgba(81, 59, 86, 0.2);
}
.border-kids-games-500\\/25{
  border-color: rgba(81, 59, 86, 0.25);
}
.border-kids-games-500\\/30{
  border-color: rgba(81, 59, 86, 0.3);
}
.border-kids-games-500\\/35{
  border-color: rgba(81, 59, 86, 0.35);
}
.border-kids-games-500\\/40{
  border-color: rgba(81, 59, 86, 0.4);
}
.border-kids-games-500\\/45{
  border-color: rgba(81, 59, 86, 0.45);
}
.border-kids-games-500\\/5{
  border-color: rgba(81, 59, 86, 0.05);
}
.border-kids-games-500\\/50{
  border-color: rgba(81, 59, 86, 0.5);
}
.border-kids-games-500\\/55{
  border-color: rgba(81, 59, 86, 0.55);
}
.border-kids-games-500\\/60{
  border-color: rgba(81, 59, 86, 0.6);
}
.border-kids-games-500\\/65{
  border-color: rgba(81, 59, 86, 0.65);
}
.border-kids-games-500\\/70{
  border-color: rgba(81, 59, 86, 0.7);
}
.border-kids-games-500\\/75{
  border-color: rgba(81, 59, 86, 0.75);
}
.border-kids-games-500\\/80{
  border-color: rgba(81, 59, 86, 0.8);
}
.border-kids-games-500\\/85{
  border-color: rgba(81, 59, 86, 0.85);
}
.border-kids-games-500\\/90{
  border-color: rgba(81, 59, 86, 0.9);
}
.border-kids-games-500\\/95{
  border-color: rgba(81, 59, 86, 0.95);
}
.border-kids-games-900{
  --tw-border-opacity: 1;
  border-color: rgba(57, 41, 60, 1);
  border-color: rgba(57, 41, 60, var(--tw-border-opacity, 1));
}
.border-kids-games-900\\/0{
  border-color: rgba(57, 41, 60, 0);
}
.border-kids-games-900\\/10{
  border-color: rgba(57, 41, 60, 0.1);
}
.border-kids-games-900\\/100{
  border-color: rgb(57, 41, 60);
}
.border-kids-games-900\\/15{
  border-color: rgba(57, 41, 60, 0.15);
}
.border-kids-games-900\\/20{
  border-color: rgba(57, 41, 60, 0.2);
}
.border-kids-games-900\\/25{
  border-color: rgba(57, 41, 60, 0.25);
}
.border-kids-games-900\\/30{
  border-color: rgba(57, 41, 60, 0.3);
}
.border-kids-games-900\\/35{
  border-color: rgba(57, 41, 60, 0.35);
}
.border-kids-games-900\\/40{
  border-color: rgba(57, 41, 60, 0.4);
}
.border-kids-games-900\\/45{
  border-color: rgba(57, 41, 60, 0.45);
}
.border-kids-games-900\\/5{
  border-color: rgba(57, 41, 60, 0.05);
}
.border-kids-games-900\\/50{
  border-color: rgba(57, 41, 60, 0.5);
}
.border-kids-games-900\\/55{
  border-color: rgba(57, 41, 60, 0.55);
}
.border-kids-games-900\\/60{
  border-color: rgba(57, 41, 60, 0.6);
}
.border-kids-games-900\\/65{
  border-color: rgba(57, 41, 60, 0.65);
}
.border-kids-games-900\\/70{
  border-color: rgba(57, 41, 60, 0.7);
}
.border-kids-games-900\\/75{
  border-color: rgba(57, 41, 60, 0.75);
}
.border-kids-games-900\\/80{
  border-color: rgba(57, 41, 60, 0.8);
}
.border-kids-games-900\\/85{
  border-color: rgba(57, 41, 60, 0.85);
}
.border-kids-games-900\\/90{
  border-color: rgba(57, 41, 60, 0.9);
}
.border-kids-games-900\\/95{
  border-color: rgba(57, 41, 60, 0.95);
}
.border-kids-songs-500{
  --tw-border-opacity: 1;
  border-color: rgba(131, 0, 66, 1);
  border-color: rgba(131, 0, 66, var(--tw-border-opacity, 1));
}
.border-kids-songs-500\\/0{
  border-color: rgba(131, 0, 66, 0);
}
.border-kids-songs-500\\/10{
  border-color: rgba(131, 0, 66, 0.1);
}
.border-kids-songs-500\\/100{
  border-color: rgb(131, 0, 66);
}
.border-kids-songs-500\\/15{
  border-color: rgba(131, 0, 66, 0.15);
}
.border-kids-songs-500\\/20{
  border-color: rgba(131, 0, 66, 0.2);
}
.border-kids-songs-500\\/25{
  border-color: rgba(131, 0, 66, 0.25);
}
.border-kids-songs-500\\/30{
  border-color: rgba(131, 0, 66, 0.3);
}
.border-kids-songs-500\\/35{
  border-color: rgba(131, 0, 66, 0.35);
}
.border-kids-songs-500\\/40{
  border-color: rgba(131, 0, 66, 0.4);
}
.border-kids-songs-500\\/45{
  border-color: rgba(131, 0, 66, 0.45);
}
.border-kids-songs-500\\/5{
  border-color: rgba(131, 0, 66, 0.05);
}
.border-kids-songs-500\\/50{
  border-color: rgba(131, 0, 66, 0.5);
}
.border-kids-songs-500\\/55{
  border-color: rgba(131, 0, 66, 0.55);
}
.border-kids-songs-500\\/60{
  border-color: rgba(131, 0, 66, 0.6);
}
.border-kids-songs-500\\/65{
  border-color: rgba(131, 0, 66, 0.65);
}
.border-kids-songs-500\\/70{
  border-color: rgba(131, 0, 66, 0.7);
}
.border-kids-songs-500\\/75{
  border-color: rgba(131, 0, 66, 0.75);
}
.border-kids-songs-500\\/80{
  border-color: rgba(131, 0, 66, 0.8);
}
.border-kids-songs-500\\/85{
  border-color: rgba(131, 0, 66, 0.85);
}
.border-kids-songs-500\\/90{
  border-color: rgba(131, 0, 66, 0.9);
}
.border-kids-songs-500\\/95{
  border-color: rgba(131, 0, 66, 0.95);
}
.border-kids-songs-900{
  --tw-border-opacity: 1;
  border-color: rgba(92, 0, 46, 1);
  border-color: rgba(92, 0, 46, var(--tw-border-opacity, 1));
}
.border-kids-songs-900\\/0{
  border-color: rgba(92, 0, 46, 0);
}
.border-kids-songs-900\\/10{
  border-color: rgba(92, 0, 46, 0.1);
}
.border-kids-songs-900\\/100{
  border-color: rgb(92, 0, 46);
}
.border-kids-songs-900\\/15{
  border-color: rgba(92, 0, 46, 0.15);
}
.border-kids-songs-900\\/20{
  border-color: rgba(92, 0, 46, 0.2);
}
.border-kids-songs-900\\/25{
  border-color: rgba(92, 0, 46, 0.25);
}
.border-kids-songs-900\\/30{
  border-color: rgba(92, 0, 46, 0.3);
}
.border-kids-songs-900\\/35{
  border-color: rgba(92, 0, 46, 0.35);
}
.border-kids-songs-900\\/40{
  border-color: rgba(92, 0, 46, 0.4);
}
.border-kids-songs-900\\/45{
  border-color: rgba(92, 0, 46, 0.45);
}
.border-kids-songs-900\\/5{
  border-color: rgba(92, 0, 46, 0.05);
}
.border-kids-songs-900\\/50{
  border-color: rgba(92, 0, 46, 0.5);
}
.border-kids-songs-900\\/55{
  border-color: rgba(92, 0, 46, 0.55);
}
.border-kids-songs-900\\/60{
  border-color: rgba(92, 0, 46, 0.6);
}
.border-kids-songs-900\\/65{
  border-color: rgba(92, 0, 46, 0.65);
}
.border-kids-songs-900\\/70{
  border-color: rgba(92, 0, 46, 0.7);
}
.border-kids-songs-900\\/75{
  border-color: rgba(92, 0, 46, 0.75);
}
.border-kids-songs-900\\/80{
  border-color: rgba(92, 0, 46, 0.8);
}
.border-kids-songs-900\\/85{
  border-color: rgba(92, 0, 46, 0.85);
}
.border-kids-songs-900\\/90{
  border-color: rgba(92, 0, 46, 0.9);
}
.border-kids-songs-900\\/95{
  border-color: rgba(92, 0, 46, 0.95);
}
.border-kids-stories-500{
  --tw-border-opacity: 1;
  border-color: rgba(233, 196, 106, 1);
  border-color: rgba(233, 196, 106, var(--tw-border-opacity, 1));
}
.border-kids-stories-500\\/0{
  border-color: rgba(233, 196, 106, 0);
}
.border-kids-stories-500\\/10{
  border-color: rgba(233, 196, 106, 0.1);
}
.border-kids-stories-500\\/100{
  border-color: rgb(233, 196, 106);
}
.border-kids-stories-500\\/15{
  border-color: rgba(233, 196, 106, 0.15);
}
.border-kids-stories-500\\/20{
  border-color: rgba(233, 196, 106, 0.2);
}
.border-kids-stories-500\\/25{
  border-color: rgba(233, 196, 106, 0.25);
}
.border-kids-stories-500\\/30{
  border-color: rgba(233, 196, 106, 0.3);
}
.border-kids-stories-500\\/35{
  border-color: rgba(233, 196, 106, 0.35);
}
.border-kids-stories-500\\/40{
  border-color: rgba(233, 196, 106, 0.4);
}
.border-kids-stories-500\\/45{
  border-color: rgba(233, 196, 106, 0.45);
}
.border-kids-stories-500\\/5{
  border-color: rgba(233, 196, 106, 0.05);
}
.border-kids-stories-500\\/50{
  border-color: rgba(233, 196, 106, 0.5);
}
.border-kids-stories-500\\/55{
  border-color: rgba(233, 196, 106, 0.55);
}
.border-kids-stories-500\\/60{
  border-color: rgba(233, 196, 106, 0.6);
}
.border-kids-stories-500\\/65{
  border-color: rgba(233, 196, 106, 0.65);
}
.border-kids-stories-500\\/70{
  border-color: rgba(233, 196, 106, 0.7);
}
.border-kids-stories-500\\/75{
  border-color: rgba(233, 196, 106, 0.75);
}
.border-kids-stories-500\\/80{
  border-color: rgba(233, 196, 106, 0.8);
}
.border-kids-stories-500\\/85{
  border-color: rgba(233, 196, 106, 0.85);
}
.border-kids-stories-500\\/90{
  border-color: rgba(233, 196, 106, 0.9);
}
.border-kids-stories-500\\/95{
  border-color: rgba(233, 196, 106, 0.95);
}
.border-kids-stories-900{
  --tw-border-opacity: 1;
  border-color: rgba(163, 137, 74, 1);
  border-color: rgba(163, 137, 74, var(--tw-border-opacity, 1));
}
.border-kids-stories-900\\/0{
  border-color: rgba(163, 137, 74, 0);
}
.border-kids-stories-900\\/10{
  border-color: rgba(163, 137, 74, 0.1);
}
.border-kids-stories-900\\/100{
  border-color: rgb(163, 137, 74);
}
.border-kids-stories-900\\/15{
  border-color: rgba(163, 137, 74, 0.15);
}
.border-kids-stories-900\\/20{
  border-color: rgba(163, 137, 74, 0.2);
}
.border-kids-stories-900\\/25{
  border-color: rgba(163, 137, 74, 0.25);
}
.border-kids-stories-900\\/30{
  border-color: rgba(163, 137, 74, 0.3);
}
.border-kids-stories-900\\/35{
  border-color: rgba(163, 137, 74, 0.35);
}
.border-kids-stories-900\\/40{
  border-color: rgba(163, 137, 74, 0.4);
}
.border-kids-stories-900\\/45{
  border-color: rgba(163, 137, 74, 0.45);
}
.border-kids-stories-900\\/5{
  border-color: rgba(163, 137, 74, 0.05);
}
.border-kids-stories-900\\/50{
  border-color: rgba(163, 137, 74, 0.5);
}
.border-kids-stories-900\\/55{
  border-color: rgba(163, 137, 74, 0.55);
}
.border-kids-stories-900\\/60{
  border-color: rgba(163, 137, 74, 0.6);
}
.border-kids-stories-900\\/65{
  border-color: rgba(163, 137, 74, 0.65);
}
.border-kids-stories-900\\/70{
  border-color: rgba(163, 137, 74, 0.7);
}
.border-kids-stories-900\\/75{
  border-color: rgba(163, 137, 74, 0.75);
}
.border-kids-stories-900\\/80{
  border-color: rgba(163, 137, 74, 0.8);
}
.border-kids-stories-900\\/85{
  border-color: rgba(163, 137, 74, 0.85);
}
.border-kids-stories-900\\/90{
  border-color: rgba(163, 137, 74, 0.9);
}
.border-kids-stories-900\\/95{
  border-color: rgba(163, 137, 74, 0.95);
}
.border-ochre-100{
  --tw-border-opacity: 1;
  border-color: rgba(245, 237, 208, 1);
  border-color: rgba(245, 237, 208, var(--tw-border-opacity, 1));
}
.border-ochre-100\\/0{
  border-color: rgba(245, 237, 208, 0);
}
.border-ochre-100\\/10{
  border-color: rgba(245, 237, 208, 0.1);
}
.border-ochre-100\\/100{
  border-color: rgb(245, 237, 208);
}
.border-ochre-100\\/15{
  border-color: rgba(245, 237, 208, 0.15);
}
.border-ochre-100\\/20{
  border-color: rgba(245, 237, 208, 0.2);
}
.border-ochre-100\\/25{
  border-color: rgba(245, 237, 208, 0.25);
}
.border-ochre-100\\/30{
  border-color: rgba(245, 237, 208, 0.3);
}
.border-ochre-100\\/35{
  border-color: rgba(245, 237, 208, 0.35);
}
.border-ochre-100\\/40{
  border-color: rgba(245, 237, 208, 0.4);
}
.border-ochre-100\\/45{
  border-color: rgba(245, 237, 208, 0.45);
}
.border-ochre-100\\/5{
  border-color: rgba(245, 237, 208, 0.05);
}
.border-ochre-100\\/50{
  border-color: rgba(245, 237, 208, 0.5);
}
.border-ochre-100\\/55{
  border-color: rgba(245, 237, 208, 0.55);
}
.border-ochre-100\\/60{
  border-color: rgba(245, 237, 208, 0.6);
}
.border-ochre-100\\/65{
  border-color: rgba(245, 237, 208, 0.65);
}
.border-ochre-100\\/70{
  border-color: rgba(245, 237, 208, 0.7);
}
.border-ochre-100\\/75{
  border-color: rgba(245, 237, 208, 0.75);
}
.border-ochre-100\\/80{
  border-color: rgba(245, 237, 208, 0.8);
}
.border-ochre-100\\/85{
  border-color: rgba(245, 237, 208, 0.85);
}
.border-ochre-100\\/90{
  border-color: rgba(245, 237, 208, 0.9);
}
.border-ochre-100\\/95{
  border-color: rgba(245, 237, 208, 0.95);
}
.border-ochre-200{
  --tw-border-opacity: 1;
  border-color: rgba(235, 217, 156, 1);
  border-color: rgba(235, 217, 156, var(--tw-border-opacity, 1));
}
.border-ochre-200\\/0{
  border-color: rgba(235, 217, 156, 0);
}
.border-ochre-200\\/10{
  border-color: rgba(235, 217, 156, 0.1);
}
.border-ochre-200\\/100{
  border-color: rgb(235, 217, 156);
}
.border-ochre-200\\/15{
  border-color: rgba(235, 217, 156, 0.15);
}
.border-ochre-200\\/20{
  border-color: rgba(235, 217, 156, 0.2);
}
.border-ochre-200\\/25{
  border-color: rgba(235, 217, 156, 0.25);
}
.border-ochre-200\\/30{
  border-color: rgba(235, 217, 156, 0.3);
}
.border-ochre-200\\/35{
  border-color: rgba(235, 217, 156, 0.35);
}
.border-ochre-200\\/40{
  border-color: rgba(235, 217, 156, 0.4);
}
.border-ochre-200\\/45{
  border-color: rgba(235, 217, 156, 0.45);
}
.border-ochre-200\\/5{
  border-color: rgba(235, 217, 156, 0.05);
}
.border-ochre-200\\/50{
  border-color: rgba(235, 217, 156, 0.5);
}
.border-ochre-200\\/55{
  border-color: rgba(235, 217, 156, 0.55);
}
.border-ochre-200\\/60{
  border-color: rgba(235, 217, 156, 0.6);
}
.border-ochre-200\\/65{
  border-color: rgba(235, 217, 156, 0.65);
}
.border-ochre-200\\/70{
  border-color: rgba(235, 217, 156, 0.7);
}
.border-ochre-200\\/75{
  border-color: rgba(235, 217, 156, 0.75);
}
.border-ochre-200\\/80{
  border-color: rgba(235, 217, 156, 0.8);
}
.border-ochre-200\\/85{
  border-color: rgba(235, 217, 156, 0.85);
}
.border-ochre-200\\/90{
  border-color: rgba(235, 217, 156, 0.9);
}
.border-ochre-200\\/95{
  border-color: rgba(235, 217, 156, 0.95);
}
.border-ochre-300{
  --tw-border-opacity: 1;
  border-color: rgba(225, 194, 104, 1);
  border-color: rgba(225, 194, 104, var(--tw-border-opacity, 1));
}
.border-ochre-300\\/0{
  border-color: rgba(225, 194, 104, 0);
}
.border-ochre-300\\/10{
  border-color: rgba(225, 194, 104, 0.1);
}
.border-ochre-300\\/100{
  border-color: rgb(225, 194, 104);
}
.border-ochre-300\\/15{
  border-color: rgba(225, 194, 104, 0.15);
}
.border-ochre-300\\/20{
  border-color: rgba(225, 194, 104, 0.2);
}
.border-ochre-300\\/25{
  border-color: rgba(225, 194, 104, 0.25);
}
.border-ochre-300\\/30{
  border-color: rgba(225, 194, 104, 0.3);
}
.border-ochre-300\\/35{
  border-color: rgba(225, 194, 104, 0.35);
}
.border-ochre-300\\/40{
  border-color: rgba(225, 194, 104, 0.4);
}
.border-ochre-300\\/45{
  border-color: rgba(225, 194, 104, 0.45);
}
.border-ochre-300\\/5{
  border-color: rgba(225, 194, 104, 0.05);
}
.border-ochre-300\\/50{
  border-color: rgba(225, 194, 104, 0.5);
}
.border-ochre-300\\/55{
  border-color: rgba(225, 194, 104, 0.55);
}
.border-ochre-300\\/60{
  border-color: rgba(225, 194, 104, 0.6);
}
.border-ochre-300\\/65{
  border-color: rgba(225, 194, 104, 0.65);
}
.border-ochre-300\\/70{
  border-color: rgba(225, 194, 104, 0.7);
}
.border-ochre-300\\/75{
  border-color: rgba(225, 194, 104, 0.75);
}
.border-ochre-300\\/80{
  border-color: rgba(225, 194, 104, 0.8);
}
.border-ochre-300\\/85{
  border-color: rgba(225, 194, 104, 0.85);
}
.border-ochre-300\\/90{
  border-color: rgba(225, 194, 104, 0.9);
}
.border-ochre-300\\/95{
  border-color: rgba(225, 194, 104, 0.95);
}
.border-ochre-400{
  --tw-border-opacity: 1;
  border-color: rgba(218, 173, 69, 1);
  border-color: rgba(218, 173, 69, var(--tw-border-opacity, 1));
}
.border-ochre-400\\/0{
  border-color: rgba(218, 173, 69, 0);
}
.border-ochre-400\\/10{
  border-color: rgba(218, 173, 69, 0.1);
}
.border-ochre-400\\/100{
  border-color: rgb(218, 173, 69);
}
.border-ochre-400\\/15{
  border-color: rgba(218, 173, 69, 0.15);
}
.border-ochre-400\\/20{
  border-color: rgba(218, 173, 69, 0.2);
}
.border-ochre-400\\/25{
  border-color: rgba(218, 173, 69, 0.25);
}
.border-ochre-400\\/30{
  border-color: rgba(218, 173, 69, 0.3);
}
.border-ochre-400\\/35{
  border-color: rgba(218, 173, 69, 0.35);
}
.border-ochre-400\\/40{
  border-color: rgba(218, 173, 69, 0.4);
}
.border-ochre-400\\/45{
  border-color: rgba(218, 173, 69, 0.45);
}
.border-ochre-400\\/5{
  border-color: rgba(218, 173, 69, 0.05);
}
.border-ochre-400\\/50{
  border-color: rgba(218, 173, 69, 0.5);
}
.border-ochre-400\\/55{
  border-color: rgba(218, 173, 69, 0.55);
}
.border-ochre-400\\/60{
  border-color: rgba(218, 173, 69, 0.6);
}
.border-ochre-400\\/65{
  border-color: rgba(218, 173, 69, 0.65);
}
.border-ochre-400\\/70{
  border-color: rgba(218, 173, 69, 0.7);
}
.border-ochre-400\\/75{
  border-color: rgba(218, 173, 69, 0.75);
}
.border-ochre-400\\/80{
  border-color: rgba(218, 173, 69, 0.8);
}
.border-ochre-400\\/85{
  border-color: rgba(218, 173, 69, 0.85);
}
.border-ochre-400\\/90{
  border-color: rgba(218, 173, 69, 0.9);
}
.border-ochre-400\\/95{
  border-color: rgba(218, 173, 69, 0.95);
}
.border-ochre-500{
  --tw-border-opacity: 1;
  border-color: rgba(209, 145, 47, 1);
  border-color: rgba(209, 145, 47, var(--tw-border-opacity, 1));
}
.border-ochre-500\\/0{
  border-color: rgba(209, 145, 47, 0);
}
.border-ochre-500\\/10{
  border-color: rgba(209, 145, 47, 0.1);
}
.border-ochre-500\\/100{
  border-color: rgb(209, 145, 47);
}
.border-ochre-500\\/15{
  border-color: rgba(209, 145, 47, 0.15);
}
.border-ochre-500\\/20{
  border-color: rgba(209, 145, 47, 0.2);
}
.border-ochre-500\\/25{
  border-color: rgba(209, 145, 47, 0.25);
}
.border-ochre-500\\/30{
  border-color: rgba(209, 145, 47, 0.3);
}
.border-ochre-500\\/35{
  border-color: rgba(209, 145, 47, 0.35);
}
.border-ochre-500\\/40{
  border-color: rgba(209, 145, 47, 0.4);
}
.border-ochre-500\\/45{
  border-color: rgba(209, 145, 47, 0.45);
}
.border-ochre-500\\/5{
  border-color: rgba(209, 145, 47, 0.05);
}
.border-ochre-500\\/50{
  border-color: rgba(209, 145, 47, 0.5);
}
.border-ochre-500\\/55{
  border-color: rgba(209, 145, 47, 0.55);
}
.border-ochre-500\\/60{
  border-color: rgba(209, 145, 47, 0.6);
}
.border-ochre-500\\/65{
  border-color: rgba(209, 145, 47, 0.65);
}
.border-ochre-500\\/70{
  border-color: rgba(209, 145, 47, 0.7);
}
.border-ochre-500\\/75{
  border-color: rgba(209, 145, 47, 0.75);
}
.border-ochre-500\\/80{
  border-color: rgba(209, 145, 47, 0.8);
}
.border-ochre-500\\/85{
  border-color: rgba(209, 145, 47, 0.85);
}
.border-ochre-500\\/90{
  border-color: rgba(209, 145, 47, 0.9);
}
.border-ochre-500\\/95{
  border-color: rgba(209, 145, 47, 0.95);
}
.border-ochre-600{
  --tw-border-opacity: 1;
  border-color: rgba(195, 120, 41, 1);
  border-color: rgba(195, 120, 41, var(--tw-border-opacity, 1));
}
.border-ochre-600\\/0{
  border-color: rgba(195, 120, 41, 0);
}
.border-ochre-600\\/10{
  border-color: rgba(195, 120, 41, 0.1);
}
.border-ochre-600\\/100{
  border-color: rgb(195, 120, 41);
}
.border-ochre-600\\/15{
  border-color: rgba(195, 120, 41, 0.15);
}
.border-ochre-600\\/20{
  border-color: rgba(195, 120, 41, 0.2);
}
.border-ochre-600\\/25{
  border-color: rgba(195, 120, 41, 0.25);
}
.border-ochre-600\\/30{
  border-color: rgba(195, 120, 41, 0.3);
}
.border-ochre-600\\/35{
  border-color: rgba(195, 120, 41, 0.35);
}
.border-ochre-600\\/40{
  border-color: rgba(195, 120, 41, 0.4);
}
.border-ochre-600\\/45{
  border-color: rgba(195, 120, 41, 0.45);
}
.border-ochre-600\\/5{
  border-color: rgba(195, 120, 41, 0.05);
}
.border-ochre-600\\/50{
  border-color: rgba(195, 120, 41, 0.5);
}
.border-ochre-600\\/55{
  border-color: rgba(195, 120, 41, 0.55);
}
.border-ochre-600\\/60{
  border-color: rgba(195, 120, 41, 0.6);
}
.border-ochre-600\\/65{
  border-color: rgba(195, 120, 41, 0.65);
}
.border-ochre-600\\/70{
  border-color: rgba(195, 120, 41, 0.7);
}
.border-ochre-600\\/75{
  border-color: rgba(195, 120, 41, 0.75);
}
.border-ochre-600\\/80{
  border-color: rgba(195, 120, 41, 0.8);
}
.border-ochre-600\\/85{
  border-color: rgba(195, 120, 41, 0.85);
}
.border-ochre-600\\/90{
  border-color: rgba(195, 120, 41, 0.9);
}
.border-ochre-600\\/95{
  border-color: rgba(195, 120, 41, 0.95);
}
.border-ochre-700{
  --tw-border-opacity: 1;
  border-color: rgba(153, 84, 36, 1);
  border-color: rgba(153, 84, 36, var(--tw-border-opacity, 1));
}
.border-ochre-700\\/0{
  border-color: rgba(153, 84, 36, 0);
}
.border-ochre-700\\/10{
  border-color: rgba(153, 84, 36, 0.1);
}
.border-ochre-700\\/100{
  border-color: rgb(153, 84, 36);
}
.border-ochre-700\\/15{
  border-color: rgba(153, 84, 36, 0.15);
}
.border-ochre-700\\/20{
  border-color: rgba(153, 84, 36, 0.2);
}
.border-ochre-700\\/25{
  border-color: rgba(153, 84, 36, 0.25);
}
.border-ochre-700\\/30{
  border-color: rgba(153, 84, 36, 0.3);
}
.border-ochre-700\\/35{
  border-color: rgba(153, 84, 36, 0.35);
}
.border-ochre-700\\/40{
  border-color: rgba(153, 84, 36, 0.4);
}
.border-ochre-700\\/45{
  border-color: rgba(153, 84, 36, 0.45);
}
.border-ochre-700\\/5{
  border-color: rgba(153, 84, 36, 0.05);
}
.border-ochre-700\\/50{
  border-color: rgba(153, 84, 36, 0.5);
}
.border-ochre-700\\/55{
  border-color: rgba(153, 84, 36, 0.55);
}
.border-ochre-700\\/60{
  border-color: rgba(153, 84, 36, 0.6);
}
.border-ochre-700\\/65{
  border-color: rgba(153, 84, 36, 0.65);
}
.border-ochre-700\\/70{
  border-color: rgba(153, 84, 36, 0.7);
}
.border-ochre-700\\/75{
  border-color: rgba(153, 84, 36, 0.75);
}
.border-ochre-700\\/80{
  border-color: rgba(153, 84, 36, 0.8);
}
.border-ochre-700\\/85{
  border-color: rgba(153, 84, 36, 0.85);
}
.border-ochre-700\\/90{
  border-color: rgba(153, 84, 36, 0.9);
}
.border-ochre-700\\/95{
  border-color: rgba(153, 84, 36, 0.95);
}
.border-ochre-800{
  --tw-border-opacity: 1;
  border-color: rgba(126, 67, 34, 1);
  border-color: rgba(126, 67, 34, var(--tw-border-opacity, 1));
}
.border-ochre-800\\/0{
  border-color: rgba(126, 67, 34, 0);
}
.border-ochre-800\\/10{
  border-color: rgba(126, 67, 34, 0.1);
}
.border-ochre-800\\/100{
  border-color: rgb(126, 67, 34);
}
.border-ochre-800\\/15{
  border-color: rgba(126, 67, 34, 0.15);
}
.border-ochre-800\\/20{
  border-color: rgba(126, 67, 34, 0.2);
}
.border-ochre-800\\/25{
  border-color: rgba(126, 67, 34, 0.25);
}
.border-ochre-800\\/30{
  border-color: rgba(126, 67, 34, 0.3);
}
.border-ochre-800\\/35{
  border-color: rgba(126, 67, 34, 0.35);
}
.border-ochre-800\\/40{
  border-color: rgba(126, 67, 34, 0.4);
}
.border-ochre-800\\/45{
  border-color: rgba(126, 67, 34, 0.45);
}
.border-ochre-800\\/5{
  border-color: rgba(126, 67, 34, 0.05);
}
.border-ochre-800\\/50{
  border-color: rgba(126, 67, 34, 0.5);
}
.border-ochre-800\\/55{
  border-color: rgba(126, 67, 34, 0.55);
}
.border-ochre-800\\/60{
  border-color: rgba(126, 67, 34, 0.6);
}
.border-ochre-800\\/65{
  border-color: rgba(126, 67, 34, 0.65);
}
.border-ochre-800\\/70{
  border-color: rgba(126, 67, 34, 0.7);
}
.border-ochre-800\\/75{
  border-color: rgba(126, 67, 34, 0.75);
}
.border-ochre-800\\/80{
  border-color: rgba(126, 67, 34, 0.8);
}
.border-ochre-800\\/85{
  border-color: rgba(126, 67, 34, 0.85);
}
.border-ochre-800\\/90{
  border-color: rgba(126, 67, 34, 0.9);
}
.border-ochre-800\\/95{
  border-color: rgba(126, 67, 34, 0.95);
}
.border-ochre-900{
  --tw-border-opacity: 1;
  border-color: rgba(104, 56, 31, 1);
  border-color: rgba(104, 56, 31, var(--tw-border-opacity, 1));
}
.border-ochre-900\\/0{
  border-color: rgba(104, 56, 31, 0);
}
.border-ochre-900\\/10{
  border-color: rgba(104, 56, 31, 0.1);
}
.border-ochre-900\\/100{
  border-color: rgb(104, 56, 31);
}
.border-ochre-900\\/15{
  border-color: rgba(104, 56, 31, 0.15);
}
.border-ochre-900\\/20{
  border-color: rgba(104, 56, 31, 0.2);
}
.border-ochre-900\\/25{
  border-color: rgba(104, 56, 31, 0.25);
}
.border-ochre-900\\/30{
  border-color: rgba(104, 56, 31, 0.3);
}
.border-ochre-900\\/35{
  border-color: rgba(104, 56, 31, 0.35);
}
.border-ochre-900\\/40{
  border-color: rgba(104, 56, 31, 0.4);
}
.border-ochre-900\\/45{
  border-color: rgba(104, 56, 31, 0.45);
}
.border-ochre-900\\/5{
  border-color: rgba(104, 56, 31, 0.05);
}
.border-ochre-900\\/50{
  border-color: rgba(104, 56, 31, 0.5);
}
.border-ochre-900\\/55{
  border-color: rgba(104, 56, 31, 0.55);
}
.border-ochre-900\\/60{
  border-color: rgba(104, 56, 31, 0.6);
}
.border-ochre-900\\/65{
  border-color: rgba(104, 56, 31, 0.65);
}
.border-ochre-900\\/70{
  border-color: rgba(104, 56, 31, 0.7);
}
.border-ochre-900\\/75{
  border-color: rgba(104, 56, 31, 0.75);
}
.border-ochre-900\\/80{
  border-color: rgba(104, 56, 31, 0.8);
}
.border-ochre-900\\/85{
  border-color: rgba(104, 56, 31, 0.85);
}
.border-ochre-900\\/90{
  border-color: rgba(104, 56, 31, 0.9);
}
.border-ochre-900\\/95{
  border-color: rgba(104, 56, 31, 0.95);
}
.border-ochre-950{
  --tw-border-opacity: 1;
  border-color: rgba(59, 28, 13, 1);
  border-color: rgba(59, 28, 13, var(--tw-border-opacity, 1));
}
.border-ochre-950\\/0{
  border-color: rgba(59, 28, 13, 0);
}
.border-ochre-950\\/10{
  border-color: rgba(59, 28, 13, 0.1);
}
.border-ochre-950\\/100{
  border-color: rgb(59, 28, 13);
}
.border-ochre-950\\/15{
  border-color: rgba(59, 28, 13, 0.15);
}
.border-ochre-950\\/20{
  border-color: rgba(59, 28, 13, 0.2);
}
.border-ochre-950\\/25{
  border-color: rgba(59, 28, 13, 0.25);
}
.border-ochre-950\\/30{
  border-color: rgba(59, 28, 13, 0.3);
}
.border-ochre-950\\/35{
  border-color: rgba(59, 28, 13, 0.35);
}
.border-ochre-950\\/40{
  border-color: rgba(59, 28, 13, 0.4);
}
.border-ochre-950\\/45{
  border-color: rgba(59, 28, 13, 0.45);
}
.border-ochre-950\\/5{
  border-color: rgba(59, 28, 13, 0.05);
}
.border-ochre-950\\/50{
  border-color: rgba(59, 28, 13, 0.5);
}
.border-ochre-950\\/55{
  border-color: rgba(59, 28, 13, 0.55);
}
.border-ochre-950\\/60{
  border-color: rgba(59, 28, 13, 0.6);
}
.border-ochre-950\\/65{
  border-color: rgba(59, 28, 13, 0.65);
}
.border-ochre-950\\/70{
  border-color: rgba(59, 28, 13, 0.7);
}
.border-ochre-950\\/75{
  border-color: rgba(59, 28, 13, 0.75);
}
.border-ochre-950\\/80{
  border-color: rgba(59, 28, 13, 0.8);
}
.border-ochre-950\\/85{
  border-color: rgba(59, 28, 13, 0.85);
}
.border-ochre-950\\/90{
  border-color: rgba(59, 28, 13, 0.9);
}
.border-ochre-950\\/95{
  border-color: rgba(59, 28, 13, 0.95);
}
.border-phrase-color-100{
  --tw-border-opacity: 1;
  border-color: rgba(245, 237, 208, 1);
  border-color: rgba(245, 237, 208, var(--tw-border-opacity, 1));
}
.border-phrase-color-100\\/0{
  border-color: rgba(245, 237, 208, 0);
}
.border-phrase-color-100\\/10{
  border-color: rgba(245, 237, 208, 0.1);
}
.border-phrase-color-100\\/100{
  border-color: rgb(245, 237, 208);
}
.border-phrase-color-100\\/15{
  border-color: rgba(245, 237, 208, 0.15);
}
.border-phrase-color-100\\/20{
  border-color: rgba(245, 237, 208, 0.2);
}
.border-phrase-color-100\\/25{
  border-color: rgba(245, 237, 208, 0.25);
}
.border-phrase-color-100\\/30{
  border-color: rgba(245, 237, 208, 0.3);
}
.border-phrase-color-100\\/35{
  border-color: rgba(245, 237, 208, 0.35);
}
.border-phrase-color-100\\/40{
  border-color: rgba(245, 237, 208, 0.4);
}
.border-phrase-color-100\\/45{
  border-color: rgba(245, 237, 208, 0.45);
}
.border-phrase-color-100\\/5{
  border-color: rgba(245, 237, 208, 0.05);
}
.border-phrase-color-100\\/50{
  border-color: rgba(245, 237, 208, 0.5);
}
.border-phrase-color-100\\/55{
  border-color: rgba(245, 237, 208, 0.55);
}
.border-phrase-color-100\\/60{
  border-color: rgba(245, 237, 208, 0.6);
}
.border-phrase-color-100\\/65{
  border-color: rgba(245, 237, 208, 0.65);
}
.border-phrase-color-100\\/70{
  border-color: rgba(245, 237, 208, 0.7);
}
.border-phrase-color-100\\/75{
  border-color: rgba(245, 237, 208, 0.75);
}
.border-phrase-color-100\\/80{
  border-color: rgba(245, 237, 208, 0.8);
}
.border-phrase-color-100\\/85{
  border-color: rgba(245, 237, 208, 0.85);
}
.border-phrase-color-100\\/90{
  border-color: rgba(245, 237, 208, 0.9);
}
.border-phrase-color-100\\/95{
  border-color: rgba(245, 237, 208, 0.95);
}
.border-phrase-color-200{
  --tw-border-opacity: 1;
  border-color: rgba(235, 217, 156, 1);
  border-color: rgba(235, 217, 156, var(--tw-border-opacity, 1));
}
.border-phrase-color-200\\/0{
  border-color: rgba(235, 217, 156, 0);
}
.border-phrase-color-200\\/10{
  border-color: rgba(235, 217, 156, 0.1);
}
.border-phrase-color-200\\/100{
  border-color: rgb(235, 217, 156);
}
.border-phrase-color-200\\/15{
  border-color: rgba(235, 217, 156, 0.15);
}
.border-phrase-color-200\\/20{
  border-color: rgba(235, 217, 156, 0.2);
}
.border-phrase-color-200\\/25{
  border-color: rgba(235, 217, 156, 0.25);
}
.border-phrase-color-200\\/30{
  border-color: rgba(235, 217, 156, 0.3);
}
.border-phrase-color-200\\/35{
  border-color: rgba(235, 217, 156, 0.35);
}
.border-phrase-color-200\\/40{
  border-color: rgba(235, 217, 156, 0.4);
}
.border-phrase-color-200\\/45{
  border-color: rgba(235, 217, 156, 0.45);
}
.border-phrase-color-200\\/5{
  border-color: rgba(235, 217, 156, 0.05);
}
.border-phrase-color-200\\/50{
  border-color: rgba(235, 217, 156, 0.5);
}
.border-phrase-color-200\\/55{
  border-color: rgba(235, 217, 156, 0.55);
}
.border-phrase-color-200\\/60{
  border-color: rgba(235, 217, 156, 0.6);
}
.border-phrase-color-200\\/65{
  border-color: rgba(235, 217, 156, 0.65);
}
.border-phrase-color-200\\/70{
  border-color: rgba(235, 217, 156, 0.7);
}
.border-phrase-color-200\\/75{
  border-color: rgba(235, 217, 156, 0.75);
}
.border-phrase-color-200\\/80{
  border-color: rgba(235, 217, 156, 0.8);
}
.border-phrase-color-200\\/85{
  border-color: rgba(235, 217, 156, 0.85);
}
.border-phrase-color-200\\/90{
  border-color: rgba(235, 217, 156, 0.9);
}
.border-phrase-color-200\\/95{
  border-color: rgba(235, 217, 156, 0.95);
}
.border-phrase-color-300{
  --tw-border-opacity: 1;
  border-color: rgba(225, 194, 104, 1);
  border-color: rgba(225, 194, 104, var(--tw-border-opacity, 1));
}
.border-phrase-color-300\\/0{
  border-color: rgba(225, 194, 104, 0);
}
.border-phrase-color-300\\/10{
  border-color: rgba(225, 194, 104, 0.1);
}
.border-phrase-color-300\\/100{
  border-color: rgb(225, 194, 104);
}
.border-phrase-color-300\\/15{
  border-color: rgba(225, 194, 104, 0.15);
}
.border-phrase-color-300\\/20{
  border-color: rgba(225, 194, 104, 0.2);
}
.border-phrase-color-300\\/25{
  border-color: rgba(225, 194, 104, 0.25);
}
.border-phrase-color-300\\/30{
  border-color: rgba(225, 194, 104, 0.3);
}
.border-phrase-color-300\\/35{
  border-color: rgba(225, 194, 104, 0.35);
}
.border-phrase-color-300\\/40{
  border-color: rgba(225, 194, 104, 0.4);
}
.border-phrase-color-300\\/45{
  border-color: rgba(225, 194, 104, 0.45);
}
.border-phrase-color-300\\/5{
  border-color: rgba(225, 194, 104, 0.05);
}
.border-phrase-color-300\\/50{
  border-color: rgba(225, 194, 104, 0.5);
}
.border-phrase-color-300\\/55{
  border-color: rgba(225, 194, 104, 0.55);
}
.border-phrase-color-300\\/60{
  border-color: rgba(225, 194, 104, 0.6);
}
.border-phrase-color-300\\/65{
  border-color: rgba(225, 194, 104, 0.65);
}
.border-phrase-color-300\\/70{
  border-color: rgba(225, 194, 104, 0.7);
}
.border-phrase-color-300\\/75{
  border-color: rgba(225, 194, 104, 0.75);
}
.border-phrase-color-300\\/80{
  border-color: rgba(225, 194, 104, 0.8);
}
.border-phrase-color-300\\/85{
  border-color: rgba(225, 194, 104, 0.85);
}
.border-phrase-color-300\\/90{
  border-color: rgba(225, 194, 104, 0.9);
}
.border-phrase-color-300\\/95{
  border-color: rgba(225, 194, 104, 0.95);
}
.border-phrase-color-400{
  --tw-border-opacity: 1;
  border-color: rgba(218, 173, 69, 1);
  border-color: rgba(218, 173, 69, var(--tw-border-opacity, 1));
}
.border-phrase-color-400\\/0{
  border-color: rgba(218, 173, 69, 0);
}
.border-phrase-color-400\\/10{
  border-color: rgba(218, 173, 69, 0.1);
}
.border-phrase-color-400\\/100{
  border-color: rgb(218, 173, 69);
}
.border-phrase-color-400\\/15{
  border-color: rgba(218, 173, 69, 0.15);
}
.border-phrase-color-400\\/20{
  border-color: rgba(218, 173, 69, 0.2);
}
.border-phrase-color-400\\/25{
  border-color: rgba(218, 173, 69, 0.25);
}
.border-phrase-color-400\\/30{
  border-color: rgba(218, 173, 69, 0.3);
}
.border-phrase-color-400\\/35{
  border-color: rgba(218, 173, 69, 0.35);
}
.border-phrase-color-400\\/40{
  border-color: rgba(218, 173, 69, 0.4);
}
.border-phrase-color-400\\/45{
  border-color: rgba(218, 173, 69, 0.45);
}
.border-phrase-color-400\\/5{
  border-color: rgba(218, 173, 69, 0.05);
}
.border-phrase-color-400\\/50{
  border-color: rgba(218, 173, 69, 0.5);
}
.border-phrase-color-400\\/55{
  border-color: rgba(218, 173, 69, 0.55);
}
.border-phrase-color-400\\/60{
  border-color: rgba(218, 173, 69, 0.6);
}
.border-phrase-color-400\\/65{
  border-color: rgba(218, 173, 69, 0.65);
}
.border-phrase-color-400\\/70{
  border-color: rgba(218, 173, 69, 0.7);
}
.border-phrase-color-400\\/75{
  border-color: rgba(218, 173, 69, 0.75);
}
.border-phrase-color-400\\/80{
  border-color: rgba(218, 173, 69, 0.8);
}
.border-phrase-color-400\\/85{
  border-color: rgba(218, 173, 69, 0.85);
}
.border-phrase-color-400\\/90{
  border-color: rgba(218, 173, 69, 0.9);
}
.border-phrase-color-400\\/95{
  border-color: rgba(218, 173, 69, 0.95);
}
.border-phrase-color-500{
  --tw-border-opacity: 1;
  border-color: rgba(209, 145, 47, 1);
  border-color: rgba(209, 145, 47, var(--tw-border-opacity, 1));
}
.border-phrase-color-500\\/0{
  border-color: rgba(209, 145, 47, 0);
}
.border-phrase-color-500\\/10{
  border-color: rgba(209, 145, 47, 0.1);
}
.border-phrase-color-500\\/100{
  border-color: rgb(209, 145, 47);
}
.border-phrase-color-500\\/15{
  border-color: rgba(209, 145, 47, 0.15);
}
.border-phrase-color-500\\/20{
  border-color: rgba(209, 145, 47, 0.2);
}
.border-phrase-color-500\\/25{
  border-color: rgba(209, 145, 47, 0.25);
}
.border-phrase-color-500\\/30{
  border-color: rgba(209, 145, 47, 0.3);
}
.border-phrase-color-500\\/35{
  border-color: rgba(209, 145, 47, 0.35);
}
.border-phrase-color-500\\/40{
  border-color: rgba(209, 145, 47, 0.4);
}
.border-phrase-color-500\\/45{
  border-color: rgba(209, 145, 47, 0.45);
}
.border-phrase-color-500\\/5{
  border-color: rgba(209, 145, 47, 0.05);
}
.border-phrase-color-500\\/50{
  border-color: rgba(209, 145, 47, 0.5);
}
.border-phrase-color-500\\/55{
  border-color: rgba(209, 145, 47, 0.55);
}
.border-phrase-color-500\\/60{
  border-color: rgba(209, 145, 47, 0.6);
}
.border-phrase-color-500\\/65{
  border-color: rgba(209, 145, 47, 0.65);
}
.border-phrase-color-500\\/70{
  border-color: rgba(209, 145, 47, 0.7);
}
.border-phrase-color-500\\/75{
  border-color: rgba(209, 145, 47, 0.75);
}
.border-phrase-color-500\\/80{
  border-color: rgba(209, 145, 47, 0.8);
}
.border-phrase-color-500\\/85{
  border-color: rgba(209, 145, 47, 0.85);
}
.border-phrase-color-500\\/90{
  border-color: rgba(209, 145, 47, 0.9);
}
.border-phrase-color-500\\/95{
  border-color: rgba(209, 145, 47, 0.95);
}
.border-phrase-color-600{
  --tw-border-opacity: 1;
  border-color: rgba(195, 120, 41, 1);
  border-color: rgba(195, 120, 41, var(--tw-border-opacity, 1));
}
.border-phrase-color-600\\/0{
  border-color: rgba(195, 120, 41, 0);
}
.border-phrase-color-600\\/10{
  border-color: rgba(195, 120, 41, 0.1);
}
.border-phrase-color-600\\/100{
  border-color: rgb(195, 120, 41);
}
.border-phrase-color-600\\/15{
  border-color: rgba(195, 120, 41, 0.15);
}
.border-phrase-color-600\\/20{
  border-color: rgba(195, 120, 41, 0.2);
}
.border-phrase-color-600\\/25{
  border-color: rgba(195, 120, 41, 0.25);
}
.border-phrase-color-600\\/30{
  border-color: rgba(195, 120, 41, 0.3);
}
.border-phrase-color-600\\/35{
  border-color: rgba(195, 120, 41, 0.35);
}
.border-phrase-color-600\\/40{
  border-color: rgba(195, 120, 41, 0.4);
}
.border-phrase-color-600\\/45{
  border-color: rgba(195, 120, 41, 0.45);
}
.border-phrase-color-600\\/5{
  border-color: rgba(195, 120, 41, 0.05);
}
.border-phrase-color-600\\/50{
  border-color: rgba(195, 120, 41, 0.5);
}
.border-phrase-color-600\\/55{
  border-color: rgba(195, 120, 41, 0.55);
}
.border-phrase-color-600\\/60{
  border-color: rgba(195, 120, 41, 0.6);
}
.border-phrase-color-600\\/65{
  border-color: rgba(195, 120, 41, 0.65);
}
.border-phrase-color-600\\/70{
  border-color: rgba(195, 120, 41, 0.7);
}
.border-phrase-color-600\\/75{
  border-color: rgba(195, 120, 41, 0.75);
}
.border-phrase-color-600\\/80{
  border-color: rgba(195, 120, 41, 0.8);
}
.border-phrase-color-600\\/85{
  border-color: rgba(195, 120, 41, 0.85);
}
.border-phrase-color-600\\/90{
  border-color: rgba(195, 120, 41, 0.9);
}
.border-phrase-color-600\\/95{
  border-color: rgba(195, 120, 41, 0.95);
}
.border-phrase-color-700{
  --tw-border-opacity: 1;
  border-color: rgba(153, 84, 36, 1);
  border-color: rgba(153, 84, 36, var(--tw-border-opacity, 1));
}
.border-phrase-color-700\\/0{
  border-color: rgba(153, 84, 36, 0);
}
.border-phrase-color-700\\/10{
  border-color: rgba(153, 84, 36, 0.1);
}
.border-phrase-color-700\\/100{
  border-color: rgb(153, 84, 36);
}
.border-phrase-color-700\\/15{
  border-color: rgba(153, 84, 36, 0.15);
}
.border-phrase-color-700\\/20{
  border-color: rgba(153, 84, 36, 0.2);
}
.border-phrase-color-700\\/25{
  border-color: rgba(153, 84, 36, 0.25);
}
.border-phrase-color-700\\/30{
  border-color: rgba(153, 84, 36, 0.3);
}
.border-phrase-color-700\\/35{
  border-color: rgba(153, 84, 36, 0.35);
}
.border-phrase-color-700\\/40{
  border-color: rgba(153, 84, 36, 0.4);
}
.border-phrase-color-700\\/45{
  border-color: rgba(153, 84, 36, 0.45);
}
.border-phrase-color-700\\/5{
  border-color: rgba(153, 84, 36, 0.05);
}
.border-phrase-color-700\\/50{
  border-color: rgba(153, 84, 36, 0.5);
}
.border-phrase-color-700\\/55{
  border-color: rgba(153, 84, 36, 0.55);
}
.border-phrase-color-700\\/60{
  border-color: rgba(153, 84, 36, 0.6);
}
.border-phrase-color-700\\/65{
  border-color: rgba(153, 84, 36, 0.65);
}
.border-phrase-color-700\\/70{
  border-color: rgba(153, 84, 36, 0.7);
}
.border-phrase-color-700\\/75{
  border-color: rgba(153, 84, 36, 0.75);
}
.border-phrase-color-700\\/80{
  border-color: rgba(153, 84, 36, 0.8);
}
.border-phrase-color-700\\/85{
  border-color: rgba(153, 84, 36, 0.85);
}
.border-phrase-color-700\\/90{
  border-color: rgba(153, 84, 36, 0.9);
}
.border-phrase-color-700\\/95{
  border-color: rgba(153, 84, 36, 0.95);
}
.border-phrase-color-800{
  --tw-border-opacity: 1;
  border-color: rgba(126, 67, 34, 1);
  border-color: rgba(126, 67, 34, var(--tw-border-opacity, 1));
}
.border-phrase-color-800\\/0{
  border-color: rgba(126, 67, 34, 0);
}
.border-phrase-color-800\\/10{
  border-color: rgba(126, 67, 34, 0.1);
}
.border-phrase-color-800\\/100{
  border-color: rgb(126, 67, 34);
}
.border-phrase-color-800\\/15{
  border-color: rgba(126, 67, 34, 0.15);
}
.border-phrase-color-800\\/20{
  border-color: rgba(126, 67, 34, 0.2);
}
.border-phrase-color-800\\/25{
  border-color: rgba(126, 67, 34, 0.25);
}
.border-phrase-color-800\\/30{
  border-color: rgba(126, 67, 34, 0.3);
}
.border-phrase-color-800\\/35{
  border-color: rgba(126, 67, 34, 0.35);
}
.border-phrase-color-800\\/40{
  border-color: rgba(126, 67, 34, 0.4);
}
.border-phrase-color-800\\/45{
  border-color: rgba(126, 67, 34, 0.45);
}
.border-phrase-color-800\\/5{
  border-color: rgba(126, 67, 34, 0.05);
}
.border-phrase-color-800\\/50{
  border-color: rgba(126, 67, 34, 0.5);
}
.border-phrase-color-800\\/55{
  border-color: rgba(126, 67, 34, 0.55);
}
.border-phrase-color-800\\/60{
  border-color: rgba(126, 67, 34, 0.6);
}
.border-phrase-color-800\\/65{
  border-color: rgba(126, 67, 34, 0.65);
}
.border-phrase-color-800\\/70{
  border-color: rgba(126, 67, 34, 0.7);
}
.border-phrase-color-800\\/75{
  border-color: rgba(126, 67, 34, 0.75);
}
.border-phrase-color-800\\/80{
  border-color: rgba(126, 67, 34, 0.8);
}
.border-phrase-color-800\\/85{
  border-color: rgba(126, 67, 34, 0.85);
}
.border-phrase-color-800\\/90{
  border-color: rgba(126, 67, 34, 0.9);
}
.border-phrase-color-800\\/95{
  border-color: rgba(126, 67, 34, 0.95);
}
.border-phrase-color-900{
  --tw-border-opacity: 1;
  border-color: rgba(104, 56, 31, 1);
  border-color: rgba(104, 56, 31, var(--tw-border-opacity, 1));
}
.border-phrase-color-900\\/0{
  border-color: rgba(104, 56, 31, 0);
}
.border-phrase-color-900\\/10{
  border-color: rgba(104, 56, 31, 0.1);
}
.border-phrase-color-900\\/100{
  border-color: rgb(104, 56, 31);
}
.border-phrase-color-900\\/15{
  border-color: rgba(104, 56, 31, 0.15);
}
.border-phrase-color-900\\/20{
  border-color: rgba(104, 56, 31, 0.2);
}
.border-phrase-color-900\\/25{
  border-color: rgba(104, 56, 31, 0.25);
}
.border-phrase-color-900\\/30{
  border-color: rgba(104, 56, 31, 0.3);
}
.border-phrase-color-900\\/35{
  border-color: rgba(104, 56, 31, 0.35);
}
.border-phrase-color-900\\/40{
  border-color: rgba(104, 56, 31, 0.4);
}
.border-phrase-color-900\\/45{
  border-color: rgba(104, 56, 31, 0.45);
}
.border-phrase-color-900\\/5{
  border-color: rgba(104, 56, 31, 0.05);
}
.border-phrase-color-900\\/50{
  border-color: rgba(104, 56, 31, 0.5);
}
.border-phrase-color-900\\/55{
  border-color: rgba(104, 56, 31, 0.55);
}
.border-phrase-color-900\\/60{
  border-color: rgba(104, 56, 31, 0.6);
}
.border-phrase-color-900\\/65{
  border-color: rgba(104, 56, 31, 0.65);
}
.border-phrase-color-900\\/70{
  border-color: rgba(104, 56, 31, 0.7);
}
.border-phrase-color-900\\/75{
  border-color: rgba(104, 56, 31, 0.75);
}
.border-phrase-color-900\\/80{
  border-color: rgba(104, 56, 31, 0.8);
}
.border-phrase-color-900\\/85{
  border-color: rgba(104, 56, 31, 0.85);
}
.border-phrase-color-900\\/90{
  border-color: rgba(104, 56, 31, 0.9);
}
.border-phrase-color-900\\/95{
  border-color: rgba(104, 56, 31, 0.95);
}
.border-phrase-color-950{
  --tw-border-opacity: 1;
  border-color: rgba(59, 28, 13, 1);
  border-color: rgba(59, 28, 13, var(--tw-border-opacity, 1));
}
.border-phrase-color-950\\/0{
  border-color: rgba(59, 28, 13, 0);
}
.border-phrase-color-950\\/10{
  border-color: rgba(59, 28, 13, 0.1);
}
.border-phrase-color-950\\/100{
  border-color: rgb(59, 28, 13);
}
.border-phrase-color-950\\/15{
  border-color: rgba(59, 28, 13, 0.15);
}
.border-phrase-color-950\\/20{
  border-color: rgba(59, 28, 13, 0.2);
}
.border-phrase-color-950\\/25{
  border-color: rgba(59, 28, 13, 0.25);
}
.border-phrase-color-950\\/30{
  border-color: rgba(59, 28, 13, 0.3);
}
.border-phrase-color-950\\/35{
  border-color: rgba(59, 28, 13, 0.35);
}
.border-phrase-color-950\\/40{
  border-color: rgba(59, 28, 13, 0.4);
}
.border-phrase-color-950\\/45{
  border-color: rgba(59, 28, 13, 0.45);
}
.border-phrase-color-950\\/5{
  border-color: rgba(59, 28, 13, 0.05);
}
.border-phrase-color-950\\/50{
  border-color: rgba(59, 28, 13, 0.5);
}
.border-phrase-color-950\\/55{
  border-color: rgba(59, 28, 13, 0.55);
}
.border-phrase-color-950\\/60{
  border-color: rgba(59, 28, 13, 0.6);
}
.border-phrase-color-950\\/65{
  border-color: rgba(59, 28, 13, 0.65);
}
.border-phrase-color-950\\/70{
  border-color: rgba(59, 28, 13, 0.7);
}
.border-phrase-color-950\\/75{
  border-color: rgba(59, 28, 13, 0.75);
}
.border-phrase-color-950\\/80{
  border-color: rgba(59, 28, 13, 0.8);
}
.border-phrase-color-950\\/85{
  border-color: rgba(59, 28, 13, 0.85);
}
.border-phrase-color-950\\/90{
  border-color: rgba(59, 28, 13, 0.9);
}
.border-phrase-color-950\\/95{
  border-color: rgba(59, 28, 13, 0.95);
}
.border-scarlet-100{
  --tw-border-opacity: 1;
  border-color: rgba(255, 220, 223, 1);
  border-color: rgba(255, 220, 223, var(--tw-border-opacity, 1));
}
.border-scarlet-100\\/0{
  border-color: rgba(255, 220, 223, 0);
}
.border-scarlet-100\\/10{
  border-color: rgba(255, 220, 223, 0.1);
}
.border-scarlet-100\\/100{
  border-color: rgb(255, 220, 223);
}
.border-scarlet-100\\/15{
  border-color: rgba(255, 220, 223, 0.15);
}
.border-scarlet-100\\/20{
  border-color: rgba(255, 220, 223, 0.2);
}
.border-scarlet-100\\/25{
  border-color: rgba(255, 220, 223, 0.25);
}
.border-scarlet-100\\/30{
  border-color: rgba(255, 220, 223, 0.3);
}
.border-scarlet-100\\/35{
  border-color: rgba(255, 220, 223, 0.35);
}
.border-scarlet-100\\/40{
  border-color: rgba(255, 220, 223, 0.4);
}
.border-scarlet-100\\/45{
  border-color: rgba(255, 220, 223, 0.45);
}
.border-scarlet-100\\/5{
  border-color: rgba(255, 220, 223, 0.05);
}
.border-scarlet-100\\/50{
  border-color: rgba(255, 220, 223, 0.5);
}
.border-scarlet-100\\/55{
  border-color: rgba(255, 220, 223, 0.55);
}
.border-scarlet-100\\/60{
  border-color: rgba(255, 220, 223, 0.6);
}
.border-scarlet-100\\/65{
  border-color: rgba(255, 220, 223, 0.65);
}
.border-scarlet-100\\/70{
  border-color: rgba(255, 220, 223, 0.7);
}
.border-scarlet-100\\/75{
  border-color: rgba(255, 220, 223, 0.75);
}
.border-scarlet-100\\/80{
  border-color: rgba(255, 220, 223, 0.8);
}
.border-scarlet-100\\/85{
  border-color: rgba(255, 220, 223, 0.85);
}
.border-scarlet-100\\/90{
  border-color: rgba(255, 220, 223, 0.9);
}
.border-scarlet-100\\/95{
  border-color: rgba(255, 220, 223, 0.95);
}
.border-scarlet-200{
  --tw-border-opacity: 1;
  border-color: rgba(255, 192, 198, 1);
  border-color: rgba(255, 192, 198, var(--tw-border-opacity, 1));
}
.border-scarlet-200\\/0{
  border-color: rgba(255, 192, 198, 0);
}
.border-scarlet-200\\/10{
  border-color: rgba(255, 192, 198, 0.1);
}
.border-scarlet-200\\/100{
  border-color: rgb(255, 192, 198);
}
.border-scarlet-200\\/15{
  border-color: rgba(255, 192, 198, 0.15);
}
.border-scarlet-200\\/20{
  border-color: rgba(255, 192, 198, 0.2);
}
.border-scarlet-200\\/25{
  border-color: rgba(255, 192, 198, 0.25);
}
.border-scarlet-200\\/30{
  border-color: rgba(255, 192, 198, 0.3);
}
.border-scarlet-200\\/35{
  border-color: rgba(255, 192, 198, 0.35);
}
.border-scarlet-200\\/40{
  border-color: rgba(255, 192, 198, 0.4);
}
.border-scarlet-200\\/45{
  border-color: rgba(255, 192, 198, 0.45);
}
.border-scarlet-200\\/5{
  border-color: rgba(255, 192, 198, 0.05);
}
.border-scarlet-200\\/50{
  border-color: rgba(255, 192, 198, 0.5);
}
.border-scarlet-200\\/55{
  border-color: rgba(255, 192, 198, 0.55);
}
.border-scarlet-200\\/60{
  border-color: rgba(255, 192, 198, 0.6);
}
.border-scarlet-200\\/65{
  border-color: rgba(255, 192, 198, 0.65);
}
.border-scarlet-200\\/70{
  border-color: rgba(255, 192, 198, 0.7);
}
.border-scarlet-200\\/75{
  border-color: rgba(255, 192, 198, 0.75);
}
.border-scarlet-200\\/80{
  border-color: rgba(255, 192, 198, 0.8);
}
.border-scarlet-200\\/85{
  border-color: rgba(255, 192, 198, 0.85);
}
.border-scarlet-200\\/90{
  border-color: rgba(255, 192, 198, 0.9);
}
.border-scarlet-200\\/95{
  border-color: rgba(255, 192, 198, 0.95);
}
.border-scarlet-300{
  --tw-border-opacity: 1;
  border-color: rgba(255, 148, 158, 1);
  border-color: rgba(255, 148, 158, var(--tw-border-opacity, 1));
}
.border-scarlet-300\\/0{
  border-color: rgba(255, 148, 158, 0);
}
.border-scarlet-300\\/10{
  border-color: rgba(255, 148, 158, 0.1);
}
.border-scarlet-300\\/100{
  border-color: rgb(255, 148, 158);
}
.border-scarlet-300\\/15{
  border-color: rgba(255, 148, 158, 0.15);
}
.border-scarlet-300\\/20{
  border-color: rgba(255, 148, 158, 0.2);
}
.border-scarlet-300\\/25{
  border-color: rgba(255, 148, 158, 0.25);
}
.border-scarlet-300\\/30{
  border-color: rgba(255, 148, 158, 0.3);
}
.border-scarlet-300\\/35{
  border-color: rgba(255, 148, 158, 0.35);
}
.border-scarlet-300\\/40{
  border-color: rgba(255, 148, 158, 0.4);
}
.border-scarlet-300\\/45{
  border-color: rgba(255, 148, 158, 0.45);
}
.border-scarlet-300\\/5{
  border-color: rgba(255, 148, 158, 0.05);
}
.border-scarlet-300\\/50{
  border-color: rgba(255, 148, 158, 0.5);
}
.border-scarlet-300\\/55{
  border-color: rgba(255, 148, 158, 0.55);
}
.border-scarlet-300\\/60{
  border-color: rgba(255, 148, 158, 0.6);
}
.border-scarlet-300\\/65{
  border-color: rgba(255, 148, 158, 0.65);
}
.border-scarlet-300\\/70{
  border-color: rgba(255, 148, 158, 0.7);
}
.border-scarlet-300\\/75{
  border-color: rgba(255, 148, 158, 0.75);
}
.border-scarlet-300\\/80{
  border-color: rgba(255, 148, 158, 0.8);
}
.border-scarlet-300\\/85{
  border-color: rgba(255, 148, 158, 0.85);
}
.border-scarlet-300\\/90{
  border-color: rgba(255, 148, 158, 0.9);
}
.border-scarlet-300\\/95{
  border-color: rgba(255, 148, 158, 0.95);
}
.border-scarlet-400{
  --tw-border-opacity: 1;
  border-color: rgba(255, 86, 101, 1);
  border-color: rgba(255, 86, 101, var(--tw-border-opacity, 1));
}
.border-scarlet-400\\/0{
  border-color: rgba(255, 86, 101, 0);
}
.border-scarlet-400\\/10{
  border-color: rgba(255, 86, 101, 0.1);
}
.border-scarlet-400\\/100{
  border-color: rgb(255, 86, 101);
}
.border-scarlet-400\\/15{
  border-color: rgba(255, 86, 101, 0.15);
}
.border-scarlet-400\\/20{
  border-color: rgba(255, 86, 101, 0.2);
}
.border-scarlet-400\\/25{
  border-color: rgba(255, 86, 101, 0.25);
}
.border-scarlet-400\\/30{
  border-color: rgba(255, 86, 101, 0.3);
}
.border-scarlet-400\\/35{
  border-color: rgba(255, 86, 101, 0.35);
}
.border-scarlet-400\\/40{
  border-color: rgba(255, 86, 101, 0.4);
}
.border-scarlet-400\\/45{
  border-color: rgba(255, 86, 101, 0.45);
}
.border-scarlet-400\\/5{
  border-color: rgba(255, 86, 101, 0.05);
}
.border-scarlet-400\\/50{
  border-color: rgba(255, 86, 101, 0.5);
}
.border-scarlet-400\\/55{
  border-color: rgba(255, 86, 101, 0.55);
}
.border-scarlet-400\\/60{
  border-color: rgba(255, 86, 101, 0.6);
}
.border-scarlet-400\\/65{
  border-color: rgba(255, 86, 101, 0.65);
}
.border-scarlet-400\\/70{
  border-color: rgba(255, 86, 101, 0.7);
}
.border-scarlet-400\\/75{
  border-color: rgba(255, 86, 101, 0.75);
}
.border-scarlet-400\\/80{
  border-color: rgba(255, 86, 101, 0.8);
}
.border-scarlet-400\\/85{
  border-color: rgba(255, 86, 101, 0.85);
}
.border-scarlet-400\\/90{
  border-color: rgba(255, 86, 101, 0.9);
}
.border-scarlet-400\\/95{
  border-color: rgba(255, 86, 101, 0.95);
}
.border-scarlet-500{
  --tw-border-opacity: 1;
  border-color: rgba(255, 34, 54, 1);
  border-color: rgba(255, 34, 54, var(--tw-border-opacity, 1));
}
.border-scarlet-500\\/0{
  border-color: rgba(255, 34, 54, 0);
}
.border-scarlet-500\\/10{
  border-color: rgba(255, 34, 54, 0.1);
}
.border-scarlet-500\\/100{
  border-color: rgb(255, 34, 54);
}
.border-scarlet-500\\/15{
  border-color: rgba(255, 34, 54, 0.15);
}
.border-scarlet-500\\/20{
  border-color: rgba(255, 34, 54, 0.2);
}
.border-scarlet-500\\/25{
  border-color: rgba(255, 34, 54, 0.25);
}
.border-scarlet-500\\/30{
  border-color: rgba(255, 34, 54, 0.3);
}
.border-scarlet-500\\/35{
  border-color: rgba(255, 34, 54, 0.35);
}
.border-scarlet-500\\/40{
  border-color: rgba(255, 34, 54, 0.4);
}
.border-scarlet-500\\/45{
  border-color: rgba(255, 34, 54, 0.45);
}
.border-scarlet-500\\/5{
  border-color: rgba(255, 34, 54, 0.05);
}
.border-scarlet-500\\/50{
  border-color: rgba(255, 34, 54, 0.5);
}
.border-scarlet-500\\/55{
  border-color: rgba(255, 34, 54, 0.55);
}
.border-scarlet-500\\/60{
  border-color: rgba(255, 34, 54, 0.6);
}
.border-scarlet-500\\/65{
  border-color: rgba(255, 34, 54, 0.65);
}
.border-scarlet-500\\/70{
  border-color: rgba(255, 34, 54, 0.7);
}
.border-scarlet-500\\/75{
  border-color: rgba(255, 34, 54, 0.75);
}
.border-scarlet-500\\/80{
  border-color: rgba(255, 34, 54, 0.8);
}
.border-scarlet-500\\/85{
  border-color: rgba(255, 34, 54, 0.85);
}
.border-scarlet-500\\/90{
  border-color: rgba(255, 34, 54, 0.9);
}
.border-scarlet-500\\/95{
  border-color: rgba(255, 34, 54, 0.95);
}
.border-scarlet-600{
  --tw-border-opacity: 1;
  border-color: rgba(255, 2, 25, 1);
  border-color: rgba(255, 2, 25, var(--tw-border-opacity, 1));
}
.border-scarlet-600\\/0{
  border-color: rgba(255, 2, 25, 0);
}
.border-scarlet-600\\/10{
  border-color: rgba(255, 2, 25, 0.1);
}
.border-scarlet-600\\/100{
  border-color: rgb(255, 2, 25);
}
.border-scarlet-600\\/15{
  border-color: rgba(255, 2, 25, 0.15);
}
.border-scarlet-600\\/20{
  border-color: rgba(255, 2, 25, 0.2);
}
.border-scarlet-600\\/25{
  border-color: rgba(255, 2, 25, 0.25);
}
.border-scarlet-600\\/30{
  border-color: rgba(255, 2, 25, 0.3);
}
.border-scarlet-600\\/35{
  border-color: rgba(255, 2, 25, 0.35);
}
.border-scarlet-600\\/40{
  border-color: rgba(255, 2, 25, 0.4);
}
.border-scarlet-600\\/45{
  border-color: rgba(255, 2, 25, 0.45);
}
.border-scarlet-600\\/5{
  border-color: rgba(255, 2, 25, 0.05);
}
.border-scarlet-600\\/50{
  border-color: rgba(255, 2, 25, 0.5);
}
.border-scarlet-600\\/55{
  border-color: rgba(255, 2, 25, 0.55);
}
.border-scarlet-600\\/60{
  border-color: rgba(255, 2, 25, 0.6);
}
.border-scarlet-600\\/65{
  border-color: rgba(255, 2, 25, 0.65);
}
.border-scarlet-600\\/70{
  border-color: rgba(255, 2, 25, 0.7);
}
.border-scarlet-600\\/75{
  border-color: rgba(255, 2, 25, 0.75);
}
.border-scarlet-600\\/80{
  border-color: rgba(255, 2, 25, 0.8);
}
.border-scarlet-600\\/85{
  border-color: rgba(255, 2, 25, 0.85);
}
.border-scarlet-600\\/90{
  border-color: rgba(255, 2, 25, 0.9);
}
.border-scarlet-600\\/95{
  border-color: rgba(255, 2, 25, 0.95);
}
.border-scarlet-700{
  --tw-border-opacity: 1;
  border-color: rgba(216, 0, 19, 1);
  border-color: rgba(216, 0, 19, var(--tw-border-opacity, 1));
}
.border-scarlet-700\\/0{
  border-color: rgba(216, 0, 19, 0);
}
.border-scarlet-700\\/10{
  border-color: rgba(216, 0, 19, 0.1);
}
.border-scarlet-700\\/100{
  border-color: rgb(216, 0, 19);
}
.border-scarlet-700\\/15{
  border-color: rgba(216, 0, 19, 0.15);
}
.border-scarlet-700\\/20{
  border-color: rgba(216, 0, 19, 0.2);
}
.border-scarlet-700\\/25{
  border-color: rgba(216, 0, 19, 0.25);
}
.border-scarlet-700\\/30{
  border-color: rgba(216, 0, 19, 0.3);
}
.border-scarlet-700\\/35{
  border-color: rgba(216, 0, 19, 0.35);
}
.border-scarlet-700\\/40{
  border-color: rgba(216, 0, 19, 0.4);
}
.border-scarlet-700\\/45{
  border-color: rgba(216, 0, 19, 0.45);
}
.border-scarlet-700\\/5{
  border-color: rgba(216, 0, 19, 0.05);
}
.border-scarlet-700\\/50{
  border-color: rgba(216, 0, 19, 0.5);
}
.border-scarlet-700\\/55{
  border-color: rgba(216, 0, 19, 0.55);
}
.border-scarlet-700\\/60{
  border-color: rgba(216, 0, 19, 0.6);
}
.border-scarlet-700\\/65{
  border-color: rgba(216, 0, 19, 0.65);
}
.border-scarlet-700\\/70{
  border-color: rgba(216, 0, 19, 0.7);
}
.border-scarlet-700\\/75{
  border-color: rgba(216, 0, 19, 0.75);
}
.border-scarlet-700\\/80{
  border-color: rgba(216, 0, 19, 0.8);
}
.border-scarlet-700\\/85{
  border-color: rgba(216, 0, 19, 0.85);
}
.border-scarlet-700\\/90{
  border-color: rgba(216, 0, 19, 0.9);
}
.border-scarlet-700\\/95{
  border-color: rgba(216, 0, 19, 0.95);
}
.border-scarlet-800{
  --tw-border-opacity: 1;
  border-color: rgba(180, 2, 18, 1);
  border-color: rgba(180, 2, 18, var(--tw-border-opacity, 1));
}
.border-scarlet-800\\/0{
  border-color: rgba(180, 2, 18, 0);
}
.border-scarlet-800\\/10{
  border-color: rgba(180, 2, 18, 0.1);
}
.border-scarlet-800\\/100{
  border-color: rgb(180, 2, 18);
}
.border-scarlet-800\\/15{
  border-color: rgba(180, 2, 18, 0.15);
}
.border-scarlet-800\\/20{
  border-color: rgba(180, 2, 18, 0.2);
}
.border-scarlet-800\\/25{
  border-color: rgba(180, 2, 18, 0.25);
}
.border-scarlet-800\\/30{
  border-color: rgba(180, 2, 18, 0.3);
}
.border-scarlet-800\\/35{
  border-color: rgba(180, 2, 18, 0.35);
}
.border-scarlet-800\\/40{
  border-color: rgba(180, 2, 18, 0.4);
}
.border-scarlet-800\\/45{
  border-color: rgba(180, 2, 18, 0.45);
}
.border-scarlet-800\\/5{
  border-color: rgba(180, 2, 18, 0.05);
}
.border-scarlet-800\\/50{
  border-color: rgba(180, 2, 18, 0.5);
}
.border-scarlet-800\\/55{
  border-color: rgba(180, 2, 18, 0.55);
}
.border-scarlet-800\\/60{
  border-color: rgba(180, 2, 18, 0.6);
}
.border-scarlet-800\\/65{
  border-color: rgba(180, 2, 18, 0.65);
}
.border-scarlet-800\\/70{
  border-color: rgba(180, 2, 18, 0.7);
}
.border-scarlet-800\\/75{
  border-color: rgba(180, 2, 18, 0.75);
}
.border-scarlet-800\\/80{
  border-color: rgba(180, 2, 18, 0.8);
}
.border-scarlet-800\\/85{
  border-color: rgba(180, 2, 18, 0.85);
}
.border-scarlet-800\\/90{
  border-color: rgba(180, 2, 18, 0.9);
}
.border-scarlet-800\\/95{
  border-color: rgba(180, 2, 18, 0.95);
}
.border-scarlet-900{
  --tw-border-opacity: 1;
  border-color: rgba(146, 10, 22, 1);
  border-color: rgba(146, 10, 22, var(--tw-border-opacity, 1));
}
.border-scarlet-900\\/0{
  border-color: rgba(146, 10, 22, 0);
}
.border-scarlet-900\\/10{
  border-color: rgba(146, 10, 22, 0.1);
}
.border-scarlet-900\\/100{
  border-color: rgb(146, 10, 22);
}
.border-scarlet-900\\/15{
  border-color: rgba(146, 10, 22, 0.15);
}
.border-scarlet-900\\/20{
  border-color: rgba(146, 10, 22, 0.2);
}
.border-scarlet-900\\/25{
  border-color: rgba(146, 10, 22, 0.25);
}
.border-scarlet-900\\/30{
  border-color: rgba(146, 10, 22, 0.3);
}
.border-scarlet-900\\/35{
  border-color: rgba(146, 10, 22, 0.35);
}
.border-scarlet-900\\/40{
  border-color: rgba(146, 10, 22, 0.4);
}
.border-scarlet-900\\/45{
  border-color: rgba(146, 10, 22, 0.45);
}
.border-scarlet-900\\/5{
  border-color: rgba(146, 10, 22, 0.05);
}
.border-scarlet-900\\/50{
  border-color: rgba(146, 10, 22, 0.5);
}
.border-scarlet-900\\/55{
  border-color: rgba(146, 10, 22, 0.55);
}
.border-scarlet-900\\/60{
  border-color: rgba(146, 10, 22, 0.6);
}
.border-scarlet-900\\/65{
  border-color: rgba(146, 10, 22, 0.65);
}
.border-scarlet-900\\/70{
  border-color: rgba(146, 10, 22, 0.7);
}
.border-scarlet-900\\/75{
  border-color: rgba(146, 10, 22, 0.75);
}
.border-scarlet-900\\/80{
  border-color: rgba(146, 10, 22, 0.8);
}
.border-scarlet-900\\/85{
  border-color: rgba(146, 10, 22, 0.85);
}
.border-scarlet-900\\/90{
  border-color: rgba(146, 10, 22, 0.9);
}
.border-scarlet-900\\/95{
  border-color: rgba(146, 10, 22, 0.95);
}
.border-scarlet-950{
  --tw-border-opacity: 1;
  border-color: rgba(81, 0, 7, 1);
  border-color: rgba(81, 0, 7, var(--tw-border-opacity, 1));
}
.border-scarlet-950\\/0{
  border-color: rgba(81, 0, 7, 0);
}
.border-scarlet-950\\/10{
  border-color: rgba(81, 0, 7, 0.1);
}
.border-scarlet-950\\/100{
  border-color: rgb(81, 0, 7);
}
.border-scarlet-950\\/15{
  border-color: rgba(81, 0, 7, 0.15);
}
.border-scarlet-950\\/20{
  border-color: rgba(81, 0, 7, 0.2);
}
.border-scarlet-950\\/25{
  border-color: rgba(81, 0, 7, 0.25);
}
.border-scarlet-950\\/30{
  border-color: rgba(81, 0, 7, 0.3);
}
.border-scarlet-950\\/35{
  border-color: rgba(81, 0, 7, 0.35);
}
.border-scarlet-950\\/40{
  border-color: rgba(81, 0, 7, 0.4);
}
.border-scarlet-950\\/45{
  border-color: rgba(81, 0, 7, 0.45);
}
.border-scarlet-950\\/5{
  border-color: rgba(81, 0, 7, 0.05);
}
.border-scarlet-950\\/50{
  border-color: rgba(81, 0, 7, 0.5);
}
.border-scarlet-950\\/55{
  border-color: rgba(81, 0, 7, 0.55);
}
.border-scarlet-950\\/60{
  border-color: rgba(81, 0, 7, 0.6);
}
.border-scarlet-950\\/65{
  border-color: rgba(81, 0, 7, 0.65);
}
.border-scarlet-950\\/70{
  border-color: rgba(81, 0, 7, 0.7);
}
.border-scarlet-950\\/75{
  border-color: rgba(81, 0, 7, 0.75);
}
.border-scarlet-950\\/80{
  border-color: rgba(81, 0, 7, 0.8);
}
.border-scarlet-950\\/85{
  border-color: rgba(81, 0, 7, 0.85);
}
.border-scarlet-950\\/90{
  border-color: rgba(81, 0, 7, 0.9);
}
.border-scarlet-950\\/95{
  border-color: rgba(81, 0, 7, 0.95);
}
.border-song-color-100{
  --tw-border-opacity: 1;
  border-color: rgba(255, 220, 223, 1);
  border-color: rgba(255, 220, 223, var(--tw-border-opacity, 1));
}
.border-song-color-100\\/0{
  border-color: rgba(255, 220, 223, 0);
}
.border-song-color-100\\/10{
  border-color: rgba(255, 220, 223, 0.1);
}
.border-song-color-100\\/100{
  border-color: rgb(255, 220, 223);
}
.border-song-color-100\\/15{
  border-color: rgba(255, 220, 223, 0.15);
}
.border-song-color-100\\/20{
  border-color: rgba(255, 220, 223, 0.2);
}
.border-song-color-100\\/25{
  border-color: rgba(255, 220, 223, 0.25);
}
.border-song-color-100\\/30{
  border-color: rgba(255, 220, 223, 0.3);
}
.border-song-color-100\\/35{
  border-color: rgba(255, 220, 223, 0.35);
}
.border-song-color-100\\/40{
  border-color: rgba(255, 220, 223, 0.4);
}
.border-song-color-100\\/45{
  border-color: rgba(255, 220, 223, 0.45);
}
.border-song-color-100\\/5{
  border-color: rgba(255, 220, 223, 0.05);
}
.border-song-color-100\\/50{
  border-color: rgba(255, 220, 223, 0.5);
}
.border-song-color-100\\/55{
  border-color: rgba(255, 220, 223, 0.55);
}
.border-song-color-100\\/60{
  border-color: rgba(255, 220, 223, 0.6);
}
.border-song-color-100\\/65{
  border-color: rgba(255, 220, 223, 0.65);
}
.border-song-color-100\\/70{
  border-color: rgba(255, 220, 223, 0.7);
}
.border-song-color-100\\/75{
  border-color: rgba(255, 220, 223, 0.75);
}
.border-song-color-100\\/80{
  border-color: rgba(255, 220, 223, 0.8);
}
.border-song-color-100\\/85{
  border-color: rgba(255, 220, 223, 0.85);
}
.border-song-color-100\\/90{
  border-color: rgba(255, 220, 223, 0.9);
}
.border-song-color-100\\/95{
  border-color: rgba(255, 220, 223, 0.95);
}
.border-song-color-200{
  --tw-border-opacity: 1;
  border-color: rgba(255, 192, 198, 1);
  border-color: rgba(255, 192, 198, var(--tw-border-opacity, 1));
}
.border-song-color-200\\/0{
  border-color: rgba(255, 192, 198, 0);
}
.border-song-color-200\\/10{
  border-color: rgba(255, 192, 198, 0.1);
}
.border-song-color-200\\/100{
  border-color: rgb(255, 192, 198);
}
.border-song-color-200\\/15{
  border-color: rgba(255, 192, 198, 0.15);
}
.border-song-color-200\\/20{
  border-color: rgba(255, 192, 198, 0.2);
}
.border-song-color-200\\/25{
  border-color: rgba(255, 192, 198, 0.25);
}
.border-song-color-200\\/30{
  border-color: rgba(255, 192, 198, 0.3);
}
.border-song-color-200\\/35{
  border-color: rgba(255, 192, 198, 0.35);
}
.border-song-color-200\\/40{
  border-color: rgba(255, 192, 198, 0.4);
}
.border-song-color-200\\/45{
  border-color: rgba(255, 192, 198, 0.45);
}
.border-song-color-200\\/5{
  border-color: rgba(255, 192, 198, 0.05);
}
.border-song-color-200\\/50{
  border-color: rgba(255, 192, 198, 0.5);
}
.border-song-color-200\\/55{
  border-color: rgba(255, 192, 198, 0.55);
}
.border-song-color-200\\/60{
  border-color: rgba(255, 192, 198, 0.6);
}
.border-song-color-200\\/65{
  border-color: rgba(255, 192, 198, 0.65);
}
.border-song-color-200\\/70{
  border-color: rgba(255, 192, 198, 0.7);
}
.border-song-color-200\\/75{
  border-color: rgba(255, 192, 198, 0.75);
}
.border-song-color-200\\/80{
  border-color: rgba(255, 192, 198, 0.8);
}
.border-song-color-200\\/85{
  border-color: rgba(255, 192, 198, 0.85);
}
.border-song-color-200\\/90{
  border-color: rgba(255, 192, 198, 0.9);
}
.border-song-color-200\\/95{
  border-color: rgba(255, 192, 198, 0.95);
}
.border-song-color-300{
  --tw-border-opacity: 1;
  border-color: rgba(255, 148, 158, 1);
  border-color: rgba(255, 148, 158, var(--tw-border-opacity, 1));
}
.border-song-color-300\\/0{
  border-color: rgba(255, 148, 158, 0);
}
.border-song-color-300\\/10{
  border-color: rgba(255, 148, 158, 0.1);
}
.border-song-color-300\\/100{
  border-color: rgb(255, 148, 158);
}
.border-song-color-300\\/15{
  border-color: rgba(255, 148, 158, 0.15);
}
.border-song-color-300\\/20{
  border-color: rgba(255, 148, 158, 0.2);
}
.border-song-color-300\\/25{
  border-color: rgba(255, 148, 158, 0.25);
}
.border-song-color-300\\/30{
  border-color: rgba(255, 148, 158, 0.3);
}
.border-song-color-300\\/35{
  border-color: rgba(255, 148, 158, 0.35);
}
.border-song-color-300\\/40{
  border-color: rgba(255, 148, 158, 0.4);
}
.border-song-color-300\\/45{
  border-color: rgba(255, 148, 158, 0.45);
}
.border-song-color-300\\/5{
  border-color: rgba(255, 148, 158, 0.05);
}
.border-song-color-300\\/50{
  border-color: rgba(255, 148, 158, 0.5);
}
.border-song-color-300\\/55{
  border-color: rgba(255, 148, 158, 0.55);
}
.border-song-color-300\\/60{
  border-color: rgba(255, 148, 158, 0.6);
}
.border-song-color-300\\/65{
  border-color: rgba(255, 148, 158, 0.65);
}
.border-song-color-300\\/70{
  border-color: rgba(255, 148, 158, 0.7);
}
.border-song-color-300\\/75{
  border-color: rgba(255, 148, 158, 0.75);
}
.border-song-color-300\\/80{
  border-color: rgba(255, 148, 158, 0.8);
}
.border-song-color-300\\/85{
  border-color: rgba(255, 148, 158, 0.85);
}
.border-song-color-300\\/90{
  border-color: rgba(255, 148, 158, 0.9);
}
.border-song-color-300\\/95{
  border-color: rgba(255, 148, 158, 0.95);
}
.border-song-color-400{
  --tw-border-opacity: 1;
  border-color: rgba(255, 86, 101, 1);
  border-color: rgba(255, 86, 101, var(--tw-border-opacity, 1));
}
.border-song-color-400\\/0{
  border-color: rgba(255, 86, 101, 0);
}
.border-song-color-400\\/10{
  border-color: rgba(255, 86, 101, 0.1);
}
.border-song-color-400\\/100{
  border-color: rgb(255, 86, 101);
}
.border-song-color-400\\/15{
  border-color: rgba(255, 86, 101, 0.15);
}
.border-song-color-400\\/20{
  border-color: rgba(255, 86, 101, 0.2);
}
.border-song-color-400\\/25{
  border-color: rgba(255, 86, 101, 0.25);
}
.border-song-color-400\\/30{
  border-color: rgba(255, 86, 101, 0.3);
}
.border-song-color-400\\/35{
  border-color: rgba(255, 86, 101, 0.35);
}
.border-song-color-400\\/40{
  border-color: rgba(255, 86, 101, 0.4);
}
.border-song-color-400\\/45{
  border-color: rgba(255, 86, 101, 0.45);
}
.border-song-color-400\\/5{
  border-color: rgba(255, 86, 101, 0.05);
}
.border-song-color-400\\/50{
  border-color: rgba(255, 86, 101, 0.5);
}
.border-song-color-400\\/55{
  border-color: rgba(255, 86, 101, 0.55);
}
.border-song-color-400\\/60{
  border-color: rgba(255, 86, 101, 0.6);
}
.border-song-color-400\\/65{
  border-color: rgba(255, 86, 101, 0.65);
}
.border-song-color-400\\/70{
  border-color: rgba(255, 86, 101, 0.7);
}
.border-song-color-400\\/75{
  border-color: rgba(255, 86, 101, 0.75);
}
.border-song-color-400\\/80{
  border-color: rgba(255, 86, 101, 0.8);
}
.border-song-color-400\\/85{
  border-color: rgba(255, 86, 101, 0.85);
}
.border-song-color-400\\/90{
  border-color: rgba(255, 86, 101, 0.9);
}
.border-song-color-400\\/95{
  border-color: rgba(255, 86, 101, 0.95);
}
.border-song-color-500{
  --tw-border-opacity: 1;
  border-color: rgba(255, 34, 54, 1);
  border-color: rgba(255, 34, 54, var(--tw-border-opacity, 1));
}
.border-song-color-500\\/0{
  border-color: rgba(255, 34, 54, 0);
}
.border-song-color-500\\/10{
  border-color: rgba(255, 34, 54, 0.1);
}
.border-song-color-500\\/100{
  border-color: rgb(255, 34, 54);
}
.border-song-color-500\\/15{
  border-color: rgba(255, 34, 54, 0.15);
}
.border-song-color-500\\/20{
  border-color: rgba(255, 34, 54, 0.2);
}
.border-song-color-500\\/25{
  border-color: rgba(255, 34, 54, 0.25);
}
.border-song-color-500\\/30{
  border-color: rgba(255, 34, 54, 0.3);
}
.border-song-color-500\\/35{
  border-color: rgba(255, 34, 54, 0.35);
}
.border-song-color-500\\/40{
  border-color: rgba(255, 34, 54, 0.4);
}
.border-song-color-500\\/45{
  border-color: rgba(255, 34, 54, 0.45);
}
.border-song-color-500\\/5{
  border-color: rgba(255, 34, 54, 0.05);
}
.border-song-color-500\\/50{
  border-color: rgba(255, 34, 54, 0.5);
}
.border-song-color-500\\/55{
  border-color: rgba(255, 34, 54, 0.55);
}
.border-song-color-500\\/60{
  border-color: rgba(255, 34, 54, 0.6);
}
.border-song-color-500\\/65{
  border-color: rgba(255, 34, 54, 0.65);
}
.border-song-color-500\\/70{
  border-color: rgba(255, 34, 54, 0.7);
}
.border-song-color-500\\/75{
  border-color: rgba(255, 34, 54, 0.75);
}
.border-song-color-500\\/80{
  border-color: rgba(255, 34, 54, 0.8);
}
.border-song-color-500\\/85{
  border-color: rgba(255, 34, 54, 0.85);
}
.border-song-color-500\\/90{
  border-color: rgba(255, 34, 54, 0.9);
}
.border-song-color-500\\/95{
  border-color: rgba(255, 34, 54, 0.95);
}
.border-song-color-600{
  --tw-border-opacity: 1;
  border-color: rgba(255, 2, 25, 1);
  border-color: rgba(255, 2, 25, var(--tw-border-opacity, 1));
}
.border-song-color-600\\/0{
  border-color: rgba(255, 2, 25, 0);
}
.border-song-color-600\\/10{
  border-color: rgba(255, 2, 25, 0.1);
}
.border-song-color-600\\/100{
  border-color: rgb(255, 2, 25);
}
.border-song-color-600\\/15{
  border-color: rgba(255, 2, 25, 0.15);
}
.border-song-color-600\\/20{
  border-color: rgba(255, 2, 25, 0.2);
}
.border-song-color-600\\/25{
  border-color: rgba(255, 2, 25, 0.25);
}
.border-song-color-600\\/30{
  border-color: rgba(255, 2, 25, 0.3);
}
.border-song-color-600\\/35{
  border-color: rgba(255, 2, 25, 0.35);
}
.border-song-color-600\\/40{
  border-color: rgba(255, 2, 25, 0.4);
}
.border-song-color-600\\/45{
  border-color: rgba(255, 2, 25, 0.45);
}
.border-song-color-600\\/5{
  border-color: rgba(255, 2, 25, 0.05);
}
.border-song-color-600\\/50{
  border-color: rgba(255, 2, 25, 0.5);
}
.border-song-color-600\\/55{
  border-color: rgba(255, 2, 25, 0.55);
}
.border-song-color-600\\/60{
  border-color: rgba(255, 2, 25, 0.6);
}
.border-song-color-600\\/65{
  border-color: rgba(255, 2, 25, 0.65);
}
.border-song-color-600\\/70{
  border-color: rgba(255, 2, 25, 0.7);
}
.border-song-color-600\\/75{
  border-color: rgba(255, 2, 25, 0.75);
}
.border-song-color-600\\/80{
  border-color: rgba(255, 2, 25, 0.8);
}
.border-song-color-600\\/85{
  border-color: rgba(255, 2, 25, 0.85);
}
.border-song-color-600\\/90{
  border-color: rgba(255, 2, 25, 0.9);
}
.border-song-color-600\\/95{
  border-color: rgba(255, 2, 25, 0.95);
}
.border-song-color-700{
  --tw-border-opacity: 1;
  border-color: rgba(216, 0, 19, 1);
  border-color: rgba(216, 0, 19, var(--tw-border-opacity, 1));
}
.border-song-color-700\\/0{
  border-color: rgba(216, 0, 19, 0);
}
.border-song-color-700\\/10{
  border-color: rgba(216, 0, 19, 0.1);
}
.border-song-color-700\\/100{
  border-color: rgb(216, 0, 19);
}
.border-song-color-700\\/15{
  border-color: rgba(216, 0, 19, 0.15);
}
.border-song-color-700\\/20{
  border-color: rgba(216, 0, 19, 0.2);
}
.border-song-color-700\\/25{
  border-color: rgba(216, 0, 19, 0.25);
}
.border-song-color-700\\/30{
  border-color: rgba(216, 0, 19, 0.3);
}
.border-song-color-700\\/35{
  border-color: rgba(216, 0, 19, 0.35);
}
.border-song-color-700\\/40{
  border-color: rgba(216, 0, 19, 0.4);
}
.border-song-color-700\\/45{
  border-color: rgba(216, 0, 19, 0.45);
}
.border-song-color-700\\/5{
  border-color: rgba(216, 0, 19, 0.05);
}
.border-song-color-700\\/50{
  border-color: rgba(216, 0, 19, 0.5);
}
.border-song-color-700\\/55{
  border-color: rgba(216, 0, 19, 0.55);
}
.border-song-color-700\\/60{
  border-color: rgba(216, 0, 19, 0.6);
}
.border-song-color-700\\/65{
  border-color: rgba(216, 0, 19, 0.65);
}
.border-song-color-700\\/70{
  border-color: rgba(216, 0, 19, 0.7);
}
.border-song-color-700\\/75{
  border-color: rgba(216, 0, 19, 0.75);
}
.border-song-color-700\\/80{
  border-color: rgba(216, 0, 19, 0.8);
}
.border-song-color-700\\/85{
  border-color: rgba(216, 0, 19, 0.85);
}
.border-song-color-700\\/90{
  border-color: rgba(216, 0, 19, 0.9);
}
.border-song-color-700\\/95{
  border-color: rgba(216, 0, 19, 0.95);
}
.border-song-color-800{
  --tw-border-opacity: 1;
  border-color: rgba(180, 2, 18, 1);
  border-color: rgba(180, 2, 18, var(--tw-border-opacity, 1));
}
.border-song-color-800\\/0{
  border-color: rgba(180, 2, 18, 0);
}
.border-song-color-800\\/10{
  border-color: rgba(180, 2, 18, 0.1);
}
.border-song-color-800\\/100{
  border-color: rgb(180, 2, 18);
}
.border-song-color-800\\/15{
  border-color: rgba(180, 2, 18, 0.15);
}
.border-song-color-800\\/20{
  border-color: rgba(180, 2, 18, 0.2);
}
.border-song-color-800\\/25{
  border-color: rgba(180, 2, 18, 0.25);
}
.border-song-color-800\\/30{
  border-color: rgba(180, 2, 18, 0.3);
}
.border-song-color-800\\/35{
  border-color: rgba(180, 2, 18, 0.35);
}
.border-song-color-800\\/40{
  border-color: rgba(180, 2, 18, 0.4);
}
.border-song-color-800\\/45{
  border-color: rgba(180, 2, 18, 0.45);
}
.border-song-color-800\\/5{
  border-color: rgba(180, 2, 18, 0.05);
}
.border-song-color-800\\/50{
  border-color: rgba(180, 2, 18, 0.5);
}
.border-song-color-800\\/55{
  border-color: rgba(180, 2, 18, 0.55);
}
.border-song-color-800\\/60{
  border-color: rgba(180, 2, 18, 0.6);
}
.border-song-color-800\\/65{
  border-color: rgba(180, 2, 18, 0.65);
}
.border-song-color-800\\/70{
  border-color: rgba(180, 2, 18, 0.7);
}
.border-song-color-800\\/75{
  border-color: rgba(180, 2, 18, 0.75);
}
.border-song-color-800\\/80{
  border-color: rgba(180, 2, 18, 0.8);
}
.border-song-color-800\\/85{
  border-color: rgba(180, 2, 18, 0.85);
}
.border-song-color-800\\/90{
  border-color: rgba(180, 2, 18, 0.9);
}
.border-song-color-800\\/95{
  border-color: rgba(180, 2, 18, 0.95);
}
.border-song-color-900{
  --tw-border-opacity: 1;
  border-color: rgba(146, 10, 22, 1);
  border-color: rgba(146, 10, 22, var(--tw-border-opacity, 1));
}
.border-song-color-900\\/0{
  border-color: rgba(146, 10, 22, 0);
}
.border-song-color-900\\/10{
  border-color: rgba(146, 10, 22, 0.1);
}
.border-song-color-900\\/100{
  border-color: rgb(146, 10, 22);
}
.border-song-color-900\\/15{
  border-color: rgba(146, 10, 22, 0.15);
}
.border-song-color-900\\/20{
  border-color: rgba(146, 10, 22, 0.2);
}
.border-song-color-900\\/25{
  border-color: rgba(146, 10, 22, 0.25);
}
.border-song-color-900\\/30{
  border-color: rgba(146, 10, 22, 0.3);
}
.border-song-color-900\\/35{
  border-color: rgba(146, 10, 22, 0.35);
}
.border-song-color-900\\/40{
  border-color: rgba(146, 10, 22, 0.4);
}
.border-song-color-900\\/45{
  border-color: rgba(146, 10, 22, 0.45);
}
.border-song-color-900\\/5{
  border-color: rgba(146, 10, 22, 0.05);
}
.border-song-color-900\\/50{
  border-color: rgba(146, 10, 22, 0.5);
}
.border-song-color-900\\/55{
  border-color: rgba(146, 10, 22, 0.55);
}
.border-song-color-900\\/60{
  border-color: rgba(146, 10, 22, 0.6);
}
.border-song-color-900\\/65{
  border-color: rgba(146, 10, 22, 0.65);
}
.border-song-color-900\\/70{
  border-color: rgba(146, 10, 22, 0.7);
}
.border-song-color-900\\/75{
  border-color: rgba(146, 10, 22, 0.75);
}
.border-song-color-900\\/80{
  border-color: rgba(146, 10, 22, 0.8);
}
.border-song-color-900\\/85{
  border-color: rgba(146, 10, 22, 0.85);
}
.border-song-color-900\\/90{
  border-color: rgba(146, 10, 22, 0.9);
}
.border-song-color-900\\/95{
  border-color: rgba(146, 10, 22, 0.95);
}
.border-song-color-950{
  --tw-border-opacity: 1;
  border-color: rgba(81, 0, 7, 1);
  border-color: rgba(81, 0, 7, var(--tw-border-opacity, 1));
}
.border-song-color-950\\/0{
  border-color: rgba(81, 0, 7, 0);
}
.border-song-color-950\\/10{
  border-color: rgba(81, 0, 7, 0.1);
}
.border-song-color-950\\/100{
  border-color: rgb(81, 0, 7);
}
.border-song-color-950\\/15{
  border-color: rgba(81, 0, 7, 0.15);
}
.border-song-color-950\\/20{
  border-color: rgba(81, 0, 7, 0.2);
}
.border-song-color-950\\/25{
  border-color: rgba(81, 0, 7, 0.25);
}
.border-song-color-950\\/30{
  border-color: rgba(81, 0, 7, 0.3);
}
.border-song-color-950\\/35{
  border-color: rgba(81, 0, 7, 0.35);
}
.border-song-color-950\\/40{
  border-color: rgba(81, 0, 7, 0.4);
}
.border-song-color-950\\/45{
  border-color: rgba(81, 0, 7, 0.45);
}
.border-song-color-950\\/5{
  border-color: rgba(81, 0, 7, 0.05);
}
.border-song-color-950\\/50{
  border-color: rgba(81, 0, 7, 0.5);
}
.border-song-color-950\\/55{
  border-color: rgba(81, 0, 7, 0.55);
}
.border-song-color-950\\/60{
  border-color: rgba(81, 0, 7, 0.6);
}
.border-song-color-950\\/65{
  border-color: rgba(81, 0, 7, 0.65);
}
.border-song-color-950\\/70{
  border-color: rgba(81, 0, 7, 0.7);
}
.border-song-color-950\\/75{
  border-color: rgba(81, 0, 7, 0.75);
}
.border-song-color-950\\/80{
  border-color: rgba(81, 0, 7, 0.8);
}
.border-song-color-950\\/85{
  border-color: rgba(81, 0, 7, 0.85);
}
.border-song-color-950\\/90{
  border-color: rgba(81, 0, 7, 0.9);
}
.border-song-color-950\\/95{
  border-color: rgba(81, 0, 7, 0.95);
}
.border-story-color-100{
  --tw-border-opacity: 1;
  border-color: rgba(218, 238, 243, 1);
  border-color: rgba(218, 238, 243, var(--tw-border-opacity, 1));
}
.border-story-color-100\\/0{
  border-color: rgba(218, 238, 243, 0);
}
.border-story-color-100\\/10{
  border-color: rgba(218, 238, 243, 0.1);
}
.border-story-color-100\\/100{
  border-color: rgb(218, 238, 243);
}
.border-story-color-100\\/15{
  border-color: rgba(218, 238, 243, 0.15);
}
.border-story-color-100\\/20{
  border-color: rgba(218, 238, 243, 0.2);
}
.border-story-color-100\\/25{
  border-color: rgba(218, 238, 243, 0.25);
}
.border-story-color-100\\/30{
  border-color: rgba(218, 238, 243, 0.3);
}
.border-story-color-100\\/35{
  border-color: rgba(218, 238, 243, 0.35);
}
.border-story-color-100\\/40{
  border-color: rgba(218, 238, 243, 0.4);
}
.border-story-color-100\\/45{
  border-color: rgba(218, 238, 243, 0.45);
}
.border-story-color-100\\/5{
  border-color: rgba(218, 238, 243, 0.05);
}
.border-story-color-100\\/50{
  border-color: rgba(218, 238, 243, 0.5);
}
.border-story-color-100\\/55{
  border-color: rgba(218, 238, 243, 0.55);
}
.border-story-color-100\\/60{
  border-color: rgba(218, 238, 243, 0.6);
}
.border-story-color-100\\/65{
  border-color: rgba(218, 238, 243, 0.65);
}
.border-story-color-100\\/70{
  border-color: rgba(218, 238, 243, 0.7);
}
.border-story-color-100\\/75{
  border-color: rgba(218, 238, 243, 0.75);
}
.border-story-color-100\\/80{
  border-color: rgba(218, 238, 243, 0.8);
}
.border-story-color-100\\/85{
  border-color: rgba(218, 238, 243, 0.85);
}
.border-story-color-100\\/90{
  border-color: rgba(218, 238, 243, 0.9);
}
.border-story-color-100\\/95{
  border-color: rgba(218, 238, 243, 0.95);
}
.border-story-color-200{
  --tw-border-opacity: 1;
  border-color: rgba(186, 222, 231, 1);
  border-color: rgba(186, 222, 231, var(--tw-border-opacity, 1));
}
.border-story-color-200\\/0{
  border-color: rgba(186, 222, 231, 0);
}
.border-story-color-200\\/10{
  border-color: rgba(186, 222, 231, 0.1);
}
.border-story-color-200\\/100{
  border-color: rgb(186, 222, 231);
}
.border-story-color-200\\/15{
  border-color: rgba(186, 222, 231, 0.15);
}
.border-story-color-200\\/20{
  border-color: rgba(186, 222, 231, 0.2);
}
.border-story-color-200\\/25{
  border-color: rgba(186, 222, 231, 0.25);
}
.border-story-color-200\\/30{
  border-color: rgba(186, 222, 231, 0.3);
}
.border-story-color-200\\/35{
  border-color: rgba(186, 222, 231, 0.35);
}
.border-story-color-200\\/40{
  border-color: rgba(186, 222, 231, 0.4);
}
.border-story-color-200\\/45{
  border-color: rgba(186, 222, 231, 0.45);
}
.border-story-color-200\\/5{
  border-color: rgba(186, 222, 231, 0.05);
}
.border-story-color-200\\/50{
  border-color: rgba(186, 222, 231, 0.5);
}
.border-story-color-200\\/55{
  border-color: rgba(186, 222, 231, 0.55);
}
.border-story-color-200\\/60{
  border-color: rgba(186, 222, 231, 0.6);
}
.border-story-color-200\\/65{
  border-color: rgba(186, 222, 231, 0.65);
}
.border-story-color-200\\/70{
  border-color: rgba(186, 222, 231, 0.7);
}
.border-story-color-200\\/75{
  border-color: rgba(186, 222, 231, 0.75);
}
.border-story-color-200\\/80{
  border-color: rgba(186, 222, 231, 0.8);
}
.border-story-color-200\\/85{
  border-color: rgba(186, 222, 231, 0.85);
}
.border-story-color-200\\/90{
  border-color: rgba(186, 222, 231, 0.9);
}
.border-story-color-200\\/95{
  border-color: rgba(186, 222, 231, 0.95);
}
.border-story-color-300{
  --tw-border-opacity: 1;
  border-color: rgba(137, 197, 215, 1);
  border-color: rgba(137, 197, 215, var(--tw-border-opacity, 1));
}
.border-story-color-300\\/0{
  border-color: rgba(137, 197, 215, 0);
}
.border-story-color-300\\/10{
  border-color: rgba(137, 197, 215, 0.1);
}
.border-story-color-300\\/100{
  border-color: rgb(137, 197, 215);
}
.border-story-color-300\\/15{
  border-color: rgba(137, 197, 215, 0.15);
}
.border-story-color-300\\/20{
  border-color: rgba(137, 197, 215, 0.2);
}
.border-story-color-300\\/25{
  border-color: rgba(137, 197, 215, 0.25);
}
.border-story-color-300\\/30{
  border-color: rgba(137, 197, 215, 0.3);
}
.border-story-color-300\\/35{
  border-color: rgba(137, 197, 215, 0.35);
}
.border-story-color-300\\/40{
  border-color: rgba(137, 197, 215, 0.4);
}
.border-story-color-300\\/45{
  border-color: rgba(137, 197, 215, 0.45);
}
.border-story-color-300\\/5{
  border-color: rgba(137, 197, 215, 0.05);
}
.border-story-color-300\\/50{
  border-color: rgba(137, 197, 215, 0.5);
}
.border-story-color-300\\/55{
  border-color: rgba(137, 197, 215, 0.55);
}
.border-story-color-300\\/60{
  border-color: rgba(137, 197, 215, 0.6);
}
.border-story-color-300\\/65{
  border-color: rgba(137, 197, 215, 0.65);
}
.border-story-color-300\\/70{
  border-color: rgba(137, 197, 215, 0.7);
}
.border-story-color-300\\/75{
  border-color: rgba(137, 197, 215, 0.75);
}
.border-story-color-300\\/80{
  border-color: rgba(137, 197, 215, 0.8);
}
.border-story-color-300\\/85{
  border-color: rgba(137, 197, 215, 0.85);
}
.border-story-color-300\\/90{
  border-color: rgba(137, 197, 215, 0.9);
}
.border-story-color-300\\/95{
  border-color: rgba(137, 197, 215, 0.95);
}
.border-story-color-400{
  --tw-border-opacity: 1;
  border-color: rgba(82, 163, 190, 1);
  border-color: rgba(82, 163, 190, var(--tw-border-opacity, 1));
}
.border-story-color-400\\/0{
  border-color: rgba(82, 163, 190, 0);
}
.border-story-color-400\\/10{
  border-color: rgba(82, 163, 190, 0.1);
}
.border-story-color-400\\/100{
  border-color: rgb(82, 163, 190);
}
.border-story-color-400\\/15{
  border-color: rgba(82, 163, 190, 0.15);
}
.border-story-color-400\\/20{
  border-color: rgba(82, 163, 190, 0.2);
}
.border-story-color-400\\/25{
  border-color: rgba(82, 163, 190, 0.25);
}
.border-story-color-400\\/30{
  border-color: rgba(82, 163, 190, 0.3);
}
.border-story-color-400\\/35{
  border-color: rgba(82, 163, 190, 0.35);
}
.border-story-color-400\\/40{
  border-color: rgba(82, 163, 190, 0.4);
}
.border-story-color-400\\/45{
  border-color: rgba(82, 163, 190, 0.45);
}
.border-story-color-400\\/5{
  border-color: rgba(82, 163, 190, 0.05);
}
.border-story-color-400\\/50{
  border-color: rgba(82, 163, 190, 0.5);
}
.border-story-color-400\\/55{
  border-color: rgba(82, 163, 190, 0.55);
}
.border-story-color-400\\/60{
  border-color: rgba(82, 163, 190, 0.6);
}
.border-story-color-400\\/65{
  border-color: rgba(82, 163, 190, 0.65);
}
.border-story-color-400\\/70{
  border-color: rgba(82, 163, 190, 0.7);
}
.border-story-color-400\\/75{
  border-color: rgba(82, 163, 190, 0.75);
}
.border-story-color-400\\/80{
  border-color: rgba(82, 163, 190, 0.8);
}
.border-story-color-400\\/85{
  border-color: rgba(82, 163, 190, 0.85);
}
.border-story-color-400\\/90{
  border-color: rgba(82, 163, 190, 0.9);
}
.border-story-color-400\\/95{
  border-color: rgba(82, 163, 190, 0.95);
}
.border-story-color-500{
  --tw-border-opacity: 1;
  border-color: rgba(55, 135, 163, 1);
  border-color: rgba(55, 135, 163, var(--tw-border-opacity, 1));
}
.border-story-color-500\\/0{
  border-color: rgba(55, 135, 163, 0);
}
.border-story-color-500\\/10{
  border-color: rgba(55, 135, 163, 0.1);
}
.border-story-color-500\\/100{
  border-color: rgb(55, 135, 163);
}
.border-story-color-500\\/15{
  border-color: rgba(55, 135, 163, 0.15);
}
.border-story-color-500\\/20{
  border-color: rgba(55, 135, 163, 0.2);
}
.border-story-color-500\\/25{
  border-color: rgba(55, 135, 163, 0.25);
}
.border-story-color-500\\/30{
  border-color: rgba(55, 135, 163, 0.3);
}
.border-story-color-500\\/35{
  border-color: rgba(55, 135, 163, 0.35);
}
.border-story-color-500\\/40{
  border-color: rgba(55, 135, 163, 0.4);
}
.border-story-color-500\\/45{
  border-color: rgba(55, 135, 163, 0.45);
}
.border-story-color-500\\/5{
  border-color: rgba(55, 135, 163, 0.05);
}
.border-story-color-500\\/50{
  border-color: rgba(55, 135, 163, 0.5);
}
.border-story-color-500\\/55{
  border-color: rgba(55, 135, 163, 0.55);
}
.border-story-color-500\\/60{
  border-color: rgba(55, 135, 163, 0.6);
}
.border-story-color-500\\/65{
  border-color: rgba(55, 135, 163, 0.65);
}
.border-story-color-500\\/70{
  border-color: rgba(55, 135, 163, 0.7);
}
.border-story-color-500\\/75{
  border-color: rgba(55, 135, 163, 0.75);
}
.border-story-color-500\\/80{
  border-color: rgba(55, 135, 163, 0.8);
}
.border-story-color-500\\/85{
  border-color: rgba(55, 135, 163, 0.85);
}
.border-story-color-500\\/90{
  border-color: rgba(55, 135, 163, 0.9);
}
.border-story-color-500\\/95{
  border-color: rgba(55, 135, 163, 0.95);
}
.border-story-color-600{
  --tw-border-opacity: 1;
  border-color: rgba(48, 109, 138, 1);
  border-color: rgba(48, 109, 138, var(--tw-border-opacity, 1));
}
.border-story-color-600\\/0{
  border-color: rgba(48, 109, 138, 0);
}
.border-story-color-600\\/10{
  border-color: rgba(48, 109, 138, 0.1);
}
.border-story-color-600\\/100{
  border-color: rgb(48, 109, 138);
}
.border-story-color-600\\/15{
  border-color: rgba(48, 109, 138, 0.15);
}
.border-story-color-600\\/20{
  border-color: rgba(48, 109, 138, 0.2);
}
.border-story-color-600\\/25{
  border-color: rgba(48, 109, 138, 0.25);
}
.border-story-color-600\\/30{
  border-color: rgba(48, 109, 138, 0.3);
}
.border-story-color-600\\/35{
  border-color: rgba(48, 109, 138, 0.35);
}
.border-story-color-600\\/40{
  border-color: rgba(48, 109, 138, 0.4);
}
.border-story-color-600\\/45{
  border-color: rgba(48, 109, 138, 0.45);
}
.border-story-color-600\\/5{
  border-color: rgba(48, 109, 138, 0.05);
}
.border-story-color-600\\/50{
  border-color: rgba(48, 109, 138, 0.5);
}
.border-story-color-600\\/55{
  border-color: rgba(48, 109, 138, 0.55);
}
.border-story-color-600\\/60{
  border-color: rgba(48, 109, 138, 0.6);
}
.border-story-color-600\\/65{
  border-color: rgba(48, 109, 138, 0.65);
}
.border-story-color-600\\/70{
  border-color: rgba(48, 109, 138, 0.7);
}
.border-story-color-600\\/75{
  border-color: rgba(48, 109, 138, 0.75);
}
.border-story-color-600\\/80{
  border-color: rgba(48, 109, 138, 0.8);
}
.border-story-color-600\\/85{
  border-color: rgba(48, 109, 138, 0.85);
}
.border-story-color-600\\/90{
  border-color: rgba(48, 109, 138, 0.9);
}
.border-story-color-600\\/95{
  border-color: rgba(48, 109, 138, 0.95);
}
.border-story-color-700{
  --tw-border-opacity: 1;
  border-color: rgba(45, 91, 114, 1);
  border-color: rgba(45, 91, 114, var(--tw-border-opacity, 1));
}
.border-story-color-700\\/0{
  border-color: rgba(45, 91, 114, 0);
}
.border-story-color-700\\/10{
  border-color: rgba(45, 91, 114, 0.1);
}
.border-story-color-700\\/100{
  border-color: rgb(45, 91, 114);
}
.border-story-color-700\\/15{
  border-color: rgba(45, 91, 114, 0.15);
}
.border-story-color-700\\/20{
  border-color: rgba(45, 91, 114, 0.2);
}
.border-story-color-700\\/25{
  border-color: rgba(45, 91, 114, 0.25);
}
.border-story-color-700\\/30{
  border-color: rgba(45, 91, 114, 0.3);
}
.border-story-color-700\\/35{
  border-color: rgba(45, 91, 114, 0.35);
}
.border-story-color-700\\/40{
  border-color: rgba(45, 91, 114, 0.4);
}
.border-story-color-700\\/45{
  border-color: rgba(45, 91, 114, 0.45);
}
.border-story-color-700\\/5{
  border-color: rgba(45, 91, 114, 0.05);
}
.border-story-color-700\\/50{
  border-color: rgba(45, 91, 114, 0.5);
}
.border-story-color-700\\/55{
  border-color: rgba(45, 91, 114, 0.55);
}
.border-story-color-700\\/60{
  border-color: rgba(45, 91, 114, 0.6);
}
.border-story-color-700\\/65{
  border-color: rgba(45, 91, 114, 0.65);
}
.border-story-color-700\\/70{
  border-color: rgba(45, 91, 114, 0.7);
}
.border-story-color-700\\/75{
  border-color: rgba(45, 91, 114, 0.75);
}
.border-story-color-700\\/80{
  border-color: rgba(45, 91, 114, 0.8);
}
.border-story-color-700\\/85{
  border-color: rgba(45, 91, 114, 0.85);
}
.border-story-color-700\\/90{
  border-color: rgba(45, 91, 114, 0.9);
}
.border-story-color-700\\/95{
  border-color: rgba(45, 91, 114, 0.95);
}
.border-story-color-800{
  --tw-border-opacity: 1;
  border-color: rgba(44, 76, 94, 1);
  border-color: rgba(44, 76, 94, var(--tw-border-opacity, 1));
}
.border-story-color-800\\/0{
  border-color: rgba(44, 76, 94, 0);
}
.border-story-color-800\\/10{
  border-color: rgba(44, 76, 94, 0.1);
}
.border-story-color-800\\/100{
  border-color: rgb(44, 76, 94);
}
.border-story-color-800\\/15{
  border-color: rgba(44, 76, 94, 0.15);
}
.border-story-color-800\\/20{
  border-color: rgba(44, 76, 94, 0.2);
}
.border-story-color-800\\/25{
  border-color: rgba(44, 76, 94, 0.25);
}
.border-story-color-800\\/30{
  border-color: rgba(44, 76, 94, 0.3);
}
.border-story-color-800\\/35{
  border-color: rgba(44, 76, 94, 0.35);
}
.border-story-color-800\\/40{
  border-color: rgba(44, 76, 94, 0.4);
}
.border-story-color-800\\/45{
  border-color: rgba(44, 76, 94, 0.45);
}
.border-story-color-800\\/5{
  border-color: rgba(44, 76, 94, 0.05);
}
.border-story-color-800\\/50{
  border-color: rgba(44, 76, 94, 0.5);
}
.border-story-color-800\\/55{
  border-color: rgba(44, 76, 94, 0.55);
}
.border-story-color-800\\/60{
  border-color: rgba(44, 76, 94, 0.6);
}
.border-story-color-800\\/65{
  border-color: rgba(44, 76, 94, 0.65);
}
.border-story-color-800\\/70{
  border-color: rgba(44, 76, 94, 0.7);
}
.border-story-color-800\\/75{
  border-color: rgba(44, 76, 94, 0.75);
}
.border-story-color-800\\/80{
  border-color: rgba(44, 76, 94, 0.8);
}
.border-story-color-800\\/85{
  border-color: rgba(44, 76, 94, 0.85);
}
.border-story-color-800\\/90{
  border-color: rgba(44, 76, 94, 0.9);
}
.border-story-color-800\\/95{
  border-color: rgba(44, 76, 94, 0.95);
}
.border-story-color-900{
  --tw-border-opacity: 1;
  border-color: rgba(40, 65, 81, 1);
  border-color: rgba(40, 65, 81, var(--tw-border-opacity, 1));
}
.border-story-color-900\\/0{
  border-color: rgba(40, 65, 81, 0);
}
.border-story-color-900\\/10{
  border-color: rgba(40, 65, 81, 0.1);
}
.border-story-color-900\\/100{
  border-color: rgb(40, 65, 81);
}
.border-story-color-900\\/15{
  border-color: rgba(40, 65, 81, 0.15);
}
.border-story-color-900\\/20{
  border-color: rgba(40, 65, 81, 0.2);
}
.border-story-color-900\\/25{
  border-color: rgba(40, 65, 81, 0.25);
}
.border-story-color-900\\/30{
  border-color: rgba(40, 65, 81, 0.3);
}
.border-story-color-900\\/35{
  border-color: rgba(40, 65, 81, 0.35);
}
.border-story-color-900\\/40{
  border-color: rgba(40, 65, 81, 0.4);
}
.border-story-color-900\\/45{
  border-color: rgba(40, 65, 81, 0.45);
}
.border-story-color-900\\/5{
  border-color: rgba(40, 65, 81, 0.05);
}
.border-story-color-900\\/50{
  border-color: rgba(40, 65, 81, 0.5);
}
.border-story-color-900\\/55{
  border-color: rgba(40, 65, 81, 0.55);
}
.border-story-color-900\\/60{
  border-color: rgba(40, 65, 81, 0.6);
}
.border-story-color-900\\/65{
  border-color: rgba(40, 65, 81, 0.65);
}
.border-story-color-900\\/70{
  border-color: rgba(40, 65, 81, 0.7);
}
.border-story-color-900\\/75{
  border-color: rgba(40, 65, 81, 0.75);
}
.border-story-color-900\\/80{
  border-color: rgba(40, 65, 81, 0.8);
}
.border-story-color-900\\/85{
  border-color: rgba(40, 65, 81, 0.85);
}
.border-story-color-900\\/90{
  border-color: rgba(40, 65, 81, 0.9);
}
.border-story-color-900\\/95{
  border-color: rgba(40, 65, 81, 0.95);
}
.border-story-color-950{
  --tw-border-opacity: 1;
  border-color: rgba(22, 41, 54, 1);
  border-color: rgba(22, 41, 54, var(--tw-border-opacity, 1));
}
.border-story-color-950\\/0{
  border-color: rgba(22, 41, 54, 0);
}
.border-story-color-950\\/10{
  border-color: rgba(22, 41, 54, 0.1);
}
.border-story-color-950\\/100{
  border-color: rgb(22, 41, 54);
}
.border-story-color-950\\/15{
  border-color: rgba(22, 41, 54, 0.15);
}
.border-story-color-950\\/20{
  border-color: rgba(22, 41, 54, 0.2);
}
.border-story-color-950\\/25{
  border-color: rgba(22, 41, 54, 0.25);
}
.border-story-color-950\\/30{
  border-color: rgba(22, 41, 54, 0.3);
}
.border-story-color-950\\/35{
  border-color: rgba(22, 41, 54, 0.35);
}
.border-story-color-950\\/40{
  border-color: rgba(22, 41, 54, 0.4);
}
.border-story-color-950\\/45{
  border-color: rgba(22, 41, 54, 0.45);
}
.border-story-color-950\\/5{
  border-color: rgba(22, 41, 54, 0.05);
}
.border-story-color-950\\/50{
  border-color: rgba(22, 41, 54, 0.5);
}
.border-story-color-950\\/55{
  border-color: rgba(22, 41, 54, 0.55);
}
.border-story-color-950\\/60{
  border-color: rgba(22, 41, 54, 0.6);
}
.border-story-color-950\\/65{
  border-color: rgba(22, 41, 54, 0.65);
}
.border-story-color-950\\/70{
  border-color: rgba(22, 41, 54, 0.7);
}
.border-story-color-950\\/75{
  border-color: rgba(22, 41, 54, 0.75);
}
.border-story-color-950\\/80{
  border-color: rgba(22, 41, 54, 0.8);
}
.border-story-color-950\\/85{
  border-color: rgba(22, 41, 54, 0.85);
}
.border-story-color-950\\/90{
  border-color: rgba(22, 41, 54, 0.9);
}
.border-story-color-950\\/95{
  border-color: rgba(22, 41, 54, 0.95);
}
.border-transparent{
  border-color: transparent;
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, var(--tw-border-opacity, 1));
}
.border-word-color-100{
  --tw-border-opacity: 1;
  border-color: rgba(217, 242, 230, 1);
  border-color: rgba(217, 242, 230, var(--tw-border-opacity, 1));
}
.border-word-color-100\\/0{
  border-color: rgba(217, 242, 230, 0);
}
.border-word-color-100\\/10{
  border-color: rgba(217, 242, 230, 0.1);
}
.border-word-color-100\\/100{
  border-color: rgb(217, 242, 230);
}
.border-word-color-100\\/15{
  border-color: rgba(217, 242, 230, 0.15);
}
.border-word-color-100\\/20{
  border-color: rgba(217, 242, 230, 0.2);
}
.border-word-color-100\\/25{
  border-color: rgba(217, 242, 230, 0.25);
}
.border-word-color-100\\/30{
  border-color: rgba(217, 242, 230, 0.3);
}
.border-word-color-100\\/35{
  border-color: rgba(217, 242, 230, 0.35);
}
.border-word-color-100\\/40{
  border-color: rgba(217, 242, 230, 0.4);
}
.border-word-color-100\\/45{
  border-color: rgba(217, 242, 230, 0.45);
}
.border-word-color-100\\/5{
  border-color: rgba(217, 242, 230, 0.05);
}
.border-word-color-100\\/50{
  border-color: rgba(217, 242, 230, 0.5);
}
.border-word-color-100\\/55{
  border-color: rgba(217, 242, 230, 0.55);
}
.border-word-color-100\\/60{
  border-color: rgba(217, 242, 230, 0.6);
}
.border-word-color-100\\/65{
  border-color: rgba(217, 242, 230, 0.65);
}
.border-word-color-100\\/70{
  border-color: rgba(217, 242, 230, 0.7);
}
.border-word-color-100\\/75{
  border-color: rgba(217, 242, 230, 0.75);
}
.border-word-color-100\\/80{
  border-color: rgba(217, 242, 230, 0.8);
}
.border-word-color-100\\/85{
  border-color: rgba(217, 242, 230, 0.85);
}
.border-word-color-100\\/90{
  border-color: rgba(217, 242, 230, 0.9);
}
.border-word-color-100\\/95{
  border-color: rgba(217, 242, 230, 0.95);
}
.border-word-color-200{
  --tw-border-opacity: 1;
  border-color: rgba(182, 228, 209, 1);
  border-color: rgba(182, 228, 209, var(--tw-border-opacity, 1));
}
.border-word-color-200\\/0{
  border-color: rgba(182, 228, 209, 0);
}
.border-word-color-200\\/10{
  border-color: rgba(182, 228, 209, 0.1);
}
.border-word-color-200\\/100{
  border-color: rgb(182, 228, 209);
}
.border-word-color-200\\/15{
  border-color: rgba(182, 228, 209, 0.15);
}
.border-word-color-200\\/20{
  border-color: rgba(182, 228, 209, 0.2);
}
.border-word-color-200\\/25{
  border-color: rgba(182, 228, 209, 0.25);
}
.border-word-color-200\\/30{
  border-color: rgba(182, 228, 209, 0.3);
}
.border-word-color-200\\/35{
  border-color: rgba(182, 228, 209, 0.35);
}
.border-word-color-200\\/40{
  border-color: rgba(182, 228, 209, 0.4);
}
.border-word-color-200\\/45{
  border-color: rgba(182, 228, 209, 0.45);
}
.border-word-color-200\\/5{
  border-color: rgba(182, 228, 209, 0.05);
}
.border-word-color-200\\/50{
  border-color: rgba(182, 228, 209, 0.5);
}
.border-word-color-200\\/55{
  border-color: rgba(182, 228, 209, 0.55);
}
.border-word-color-200\\/60{
  border-color: rgba(182, 228, 209, 0.6);
}
.border-word-color-200\\/65{
  border-color: rgba(182, 228, 209, 0.65);
}
.border-word-color-200\\/70{
  border-color: rgba(182, 228, 209, 0.7);
}
.border-word-color-200\\/75{
  border-color: rgba(182, 228, 209, 0.75);
}
.border-word-color-200\\/80{
  border-color: rgba(182, 228, 209, 0.8);
}
.border-word-color-200\\/85{
  border-color: rgba(182, 228, 209, 0.85);
}
.border-word-color-200\\/90{
  border-color: rgba(182, 228, 209, 0.9);
}
.border-word-color-200\\/95{
  border-color: rgba(182, 228, 209, 0.95);
}
.border-word-color-300{
  --tw-border-opacity: 1;
  border-color: rgba(134, 207, 181, 1);
  border-color: rgba(134, 207, 181, var(--tw-border-opacity, 1));
}
.border-word-color-300\\/0{
  border-color: rgba(134, 207, 181, 0);
}
.border-word-color-300\\/10{
  border-color: rgba(134, 207, 181, 0.1);
}
.border-word-color-300\\/100{
  border-color: rgb(134, 207, 181);
}
.border-word-color-300\\/15{
  border-color: rgba(134, 207, 181, 0.15);
}
.border-word-color-300\\/20{
  border-color: rgba(134, 207, 181, 0.2);
}
.border-word-color-300\\/25{
  border-color: rgba(134, 207, 181, 0.25);
}
.border-word-color-300\\/30{
  border-color: rgba(134, 207, 181, 0.3);
}
.border-word-color-300\\/35{
  border-color: rgba(134, 207, 181, 0.35);
}
.border-word-color-300\\/40{
  border-color: rgba(134, 207, 181, 0.4);
}
.border-word-color-300\\/45{
  border-color: rgba(134, 207, 181, 0.45);
}
.border-word-color-300\\/5{
  border-color: rgba(134, 207, 181, 0.05);
}
.border-word-color-300\\/50{
  border-color: rgba(134, 207, 181, 0.5);
}
.border-word-color-300\\/55{
  border-color: rgba(134, 207, 181, 0.55);
}
.border-word-color-300\\/60{
  border-color: rgba(134, 207, 181, 0.6);
}
.border-word-color-300\\/65{
  border-color: rgba(134, 207, 181, 0.65);
}
.border-word-color-300\\/70{
  border-color: rgba(134, 207, 181, 0.7);
}
.border-word-color-300\\/75{
  border-color: rgba(134, 207, 181, 0.75);
}
.border-word-color-300\\/80{
  border-color: rgba(134, 207, 181, 0.8);
}
.border-word-color-300\\/85{
  border-color: rgba(134, 207, 181, 0.85);
}
.border-word-color-300\\/90{
  border-color: rgba(134, 207, 181, 0.9);
}
.border-word-color-300\\/95{
  border-color: rgba(134, 207, 181, 0.95);
}
.border-word-color-400{
  --tw-border-opacity: 1;
  border-color: rgba(83, 180, 148, 1);
  border-color: rgba(83, 180, 148, var(--tw-border-opacity, 1));
}
.border-word-color-400\\/0{
  border-color: rgba(83, 180, 148, 0);
}
.border-word-color-400\\/10{
  border-color: rgba(83, 180, 148, 0.1);
}
.border-word-color-400\\/100{
  border-color: rgb(83, 180, 148);
}
.border-word-color-400\\/15{
  border-color: rgba(83, 180, 148, 0.15);
}
.border-word-color-400\\/20{
  border-color: rgba(83, 180, 148, 0.2);
}
.border-word-color-400\\/25{
  border-color: rgba(83, 180, 148, 0.25);
}
.border-word-color-400\\/30{
  border-color: rgba(83, 180, 148, 0.3);
}
.border-word-color-400\\/35{
  border-color: rgba(83, 180, 148, 0.35);
}
.border-word-color-400\\/40{
  border-color: rgba(83, 180, 148, 0.4);
}
.border-word-color-400\\/45{
  border-color: rgba(83, 180, 148, 0.45);
}
.border-word-color-400\\/5{
  border-color: rgba(83, 180, 148, 0.05);
}
.border-word-color-400\\/50{
  border-color: rgba(83, 180, 148, 0.5);
}
.border-word-color-400\\/55{
  border-color: rgba(83, 180, 148, 0.55);
}
.border-word-color-400\\/60{
  border-color: rgba(83, 180, 148, 0.6);
}
.border-word-color-400\\/65{
  border-color: rgba(83, 180, 148, 0.65);
}
.border-word-color-400\\/70{
  border-color: rgba(83, 180, 148, 0.7);
}
.border-word-color-400\\/75{
  border-color: rgba(83, 180, 148, 0.75);
}
.border-word-color-400\\/80{
  border-color: rgba(83, 180, 148, 0.8);
}
.border-word-color-400\\/85{
  border-color: rgba(83, 180, 148, 0.85);
}
.border-word-color-400\\/90{
  border-color: rgba(83, 180, 148, 0.9);
}
.border-word-color-400\\/95{
  border-color: rgba(83, 180, 148, 0.95);
}
.border-word-color-500{
  --tw-border-opacity: 1;
  border-color: rgba(44, 135, 109, 1);
  border-color: rgba(44, 135, 109, var(--tw-border-opacity, 1));
}
.border-word-color-500\\/0{
  border-color: rgba(44, 135, 109, 0);
}
.border-word-color-500\\/10{
  border-color: rgba(44, 135, 109, 0.1);
}
.border-word-color-500\\/100{
  border-color: rgb(44, 135, 109);
}
.border-word-color-500\\/15{
  border-color: rgba(44, 135, 109, 0.15);
}
.border-word-color-500\\/20{
  border-color: rgba(44, 135, 109, 0.2);
}
.border-word-color-500\\/25{
  border-color: rgba(44, 135, 109, 0.25);
}
.border-word-color-500\\/30{
  border-color: rgba(44, 135, 109, 0.3);
}
.border-word-color-500\\/35{
  border-color: rgba(44, 135, 109, 0.35);
}
.border-word-color-500\\/40{
  border-color: rgba(44, 135, 109, 0.4);
}
.border-word-color-500\\/45{
  border-color: rgba(44, 135, 109, 0.45);
}
.border-word-color-500\\/5{
  border-color: rgba(44, 135, 109, 0.05);
}
.border-word-color-500\\/50{
  border-color: rgba(44, 135, 109, 0.5);
}
.border-word-color-500\\/55{
  border-color: rgba(44, 135, 109, 0.55);
}
.border-word-color-500\\/60{
  border-color: rgba(44, 135, 109, 0.6);
}
.border-word-color-500\\/65{
  border-color: rgba(44, 135, 109, 0.65);
}
.border-word-color-500\\/70{
  border-color: rgba(44, 135, 109, 0.7);
}
.border-word-color-500\\/75{
  border-color: rgba(44, 135, 109, 0.75);
}
.border-word-color-500\\/80{
  border-color: rgba(44, 135, 109, 0.8);
}
.border-word-color-500\\/85{
  border-color: rgba(44, 135, 109, 0.85);
}
.border-word-color-500\\/90{
  border-color: rgba(44, 135, 109, 0.9);
}
.border-word-color-500\\/95{
  border-color: rgba(44, 135, 109, 0.95);
}
.border-word-color-600{
  --tw-border-opacity: 1;
  border-color: rgba(34, 121, 98, 1);
  border-color: rgba(34, 121, 98, var(--tw-border-opacity, 1));
}
.border-word-color-600\\/0{
  border-color: rgba(34, 121, 98, 0);
}
.border-word-color-600\\/10{
  border-color: rgba(34, 121, 98, 0.1);
}
.border-word-color-600\\/100{
  border-color: rgb(34, 121, 98);
}
.border-word-color-600\\/15{
  border-color: rgba(34, 121, 98, 0.15);
}
.border-word-color-600\\/20{
  border-color: rgba(34, 121, 98, 0.2);
}
.border-word-color-600\\/25{
  border-color: rgba(34, 121, 98, 0.25);
}
.border-word-color-600\\/30{
  border-color: rgba(34, 121, 98, 0.3);
}
.border-word-color-600\\/35{
  border-color: rgba(34, 121, 98, 0.35);
}
.border-word-color-600\\/40{
  border-color: rgba(34, 121, 98, 0.4);
}
.border-word-color-600\\/45{
  border-color: rgba(34, 121, 98, 0.45);
}
.border-word-color-600\\/5{
  border-color: rgba(34, 121, 98, 0.05);
}
.border-word-color-600\\/50{
  border-color: rgba(34, 121, 98, 0.5);
}
.border-word-color-600\\/55{
  border-color: rgba(34, 121, 98, 0.55);
}
.border-word-color-600\\/60{
  border-color: rgba(34, 121, 98, 0.6);
}
.border-word-color-600\\/65{
  border-color: rgba(34, 121, 98, 0.65);
}
.border-word-color-600\\/70{
  border-color: rgba(34, 121, 98, 0.7);
}
.border-word-color-600\\/75{
  border-color: rgba(34, 121, 98, 0.75);
}
.border-word-color-600\\/80{
  border-color: rgba(34, 121, 98, 0.8);
}
.border-word-color-600\\/85{
  border-color: rgba(34, 121, 98, 0.85);
}
.border-word-color-600\\/90{
  border-color: rgba(34, 121, 98, 0.9);
}
.border-word-color-600\\/95{
  border-color: rgba(34, 121, 98, 0.95);
}
.border-word-color-700{
  --tw-border-opacity: 1;
  border-color: rgba(27, 97, 80, 1);
  border-color: rgba(27, 97, 80, var(--tw-border-opacity, 1));
}
.border-word-color-700\\/0{
  border-color: rgba(27, 97, 80, 0);
}
.border-word-color-700\\/10{
  border-color: rgba(27, 97, 80, 0.1);
}
.border-word-color-700\\/100{
  border-color: rgb(27, 97, 80);
}
.border-word-color-700\\/15{
  border-color: rgba(27, 97, 80, 0.15);
}
.border-word-color-700\\/20{
  border-color: rgba(27, 97, 80, 0.2);
}
.border-word-color-700\\/25{
  border-color: rgba(27, 97, 80, 0.25);
}
.border-word-color-700\\/30{
  border-color: rgba(27, 97, 80, 0.3);
}
.border-word-color-700\\/35{
  border-color: rgba(27, 97, 80, 0.35);
}
.border-word-color-700\\/40{
  border-color: rgba(27, 97, 80, 0.4);
}
.border-word-color-700\\/45{
  border-color: rgba(27, 97, 80, 0.45);
}
.border-word-color-700\\/5{
  border-color: rgba(27, 97, 80, 0.05);
}
.border-word-color-700\\/50{
  border-color: rgba(27, 97, 80, 0.5);
}
.border-word-color-700\\/55{
  border-color: rgba(27, 97, 80, 0.55);
}
.border-word-color-700\\/60{
  border-color: rgba(27, 97, 80, 0.6);
}
.border-word-color-700\\/65{
  border-color: rgba(27, 97, 80, 0.65);
}
.border-word-color-700\\/70{
  border-color: rgba(27, 97, 80, 0.7);
}
.border-word-color-700\\/75{
  border-color: rgba(27, 97, 80, 0.75);
}
.border-word-color-700\\/80{
  border-color: rgba(27, 97, 80, 0.8);
}
.border-word-color-700\\/85{
  border-color: rgba(27, 97, 80, 0.85);
}
.border-word-color-700\\/90{
  border-color: rgba(27, 97, 80, 0.9);
}
.border-word-color-700\\/95{
  border-color: rgba(27, 97, 80, 0.95);
}
.border-word-color-800{
  --tw-border-opacity: 1;
  border-color: rgba(24, 77, 64, 1);
  border-color: rgba(24, 77, 64, var(--tw-border-opacity, 1));
}
.border-word-color-800\\/0{
  border-color: rgba(24, 77, 64, 0);
}
.border-word-color-800\\/10{
  border-color: rgba(24, 77, 64, 0.1);
}
.border-word-color-800\\/100{
  border-color: rgb(24, 77, 64);
}
.border-word-color-800\\/15{
  border-color: rgba(24, 77, 64, 0.15);
}
.border-word-color-800\\/20{
  border-color: rgba(24, 77, 64, 0.2);
}
.border-word-color-800\\/25{
  border-color: rgba(24, 77, 64, 0.25);
}
.border-word-color-800\\/30{
  border-color: rgba(24, 77, 64, 0.3);
}
.border-word-color-800\\/35{
  border-color: rgba(24, 77, 64, 0.35);
}
.border-word-color-800\\/40{
  border-color: rgba(24, 77, 64, 0.4);
}
.border-word-color-800\\/45{
  border-color: rgba(24, 77, 64, 0.45);
}
.border-word-color-800\\/5{
  border-color: rgba(24, 77, 64, 0.05);
}
.border-word-color-800\\/50{
  border-color: rgba(24, 77, 64, 0.5);
}
.border-word-color-800\\/55{
  border-color: rgba(24, 77, 64, 0.55);
}
.border-word-color-800\\/60{
  border-color: rgba(24, 77, 64, 0.6);
}
.border-word-color-800\\/65{
  border-color: rgba(24, 77, 64, 0.65);
}
.border-word-color-800\\/70{
  border-color: rgba(24, 77, 64, 0.7);
}
.border-word-color-800\\/75{
  border-color: rgba(24, 77, 64, 0.75);
}
.border-word-color-800\\/80{
  border-color: rgba(24, 77, 64, 0.8);
}
.border-word-color-800\\/85{
  border-color: rgba(24, 77, 64, 0.85);
}
.border-word-color-800\\/90{
  border-color: rgba(24, 77, 64, 0.9);
}
.border-word-color-800\\/95{
  border-color: rgba(24, 77, 64, 0.95);
}
.border-word-color-900{
  --tw-border-opacity: 1;
  border-color: rgba(20, 64, 54, 1);
  border-color: rgba(20, 64, 54, var(--tw-border-opacity, 1));
}
.border-word-color-900\\/0{
  border-color: rgba(20, 64, 54, 0);
}
.border-word-color-900\\/10{
  border-color: rgba(20, 64, 54, 0.1);
}
.border-word-color-900\\/100{
  border-color: rgb(20, 64, 54);
}
.border-word-color-900\\/15{
  border-color: rgba(20, 64, 54, 0.15);
}
.border-word-color-900\\/20{
  border-color: rgba(20, 64, 54, 0.2);
}
.border-word-color-900\\/25{
  border-color: rgba(20, 64, 54, 0.25);
}
.border-word-color-900\\/30{
  border-color: rgba(20, 64, 54, 0.3);
}
.border-word-color-900\\/35{
  border-color: rgba(20, 64, 54, 0.35);
}
.border-word-color-900\\/40{
  border-color: rgba(20, 64, 54, 0.4);
}
.border-word-color-900\\/45{
  border-color: rgba(20, 64, 54, 0.45);
}
.border-word-color-900\\/5{
  border-color: rgba(20, 64, 54, 0.05);
}
.border-word-color-900\\/50{
  border-color: rgba(20, 64, 54, 0.5);
}
.border-word-color-900\\/55{
  border-color: rgba(20, 64, 54, 0.55);
}
.border-word-color-900\\/60{
  border-color: rgba(20, 64, 54, 0.6);
}
.border-word-color-900\\/65{
  border-color: rgba(20, 64, 54, 0.65);
}
.border-word-color-900\\/70{
  border-color: rgba(20, 64, 54, 0.7);
}
.border-word-color-900\\/75{
  border-color: rgba(20, 64, 54, 0.75);
}
.border-word-color-900\\/80{
  border-color: rgba(20, 64, 54, 0.8);
}
.border-word-color-900\\/85{
  border-color: rgba(20, 64, 54, 0.85);
}
.border-word-color-900\\/90{
  border-color: rgba(20, 64, 54, 0.9);
}
.border-word-color-900\\/95{
  border-color: rgba(20, 64, 54, 0.95);
}
.border-word-color-950{
  --tw-border-opacity: 1;
  border-color: rgba(10, 36, 31, 1);
  border-color: rgba(10, 36, 31, var(--tw-border-opacity, 1));
}
.border-word-color-950\\/0{
  border-color: rgba(10, 36, 31, 0);
}
.border-word-color-950\\/10{
  border-color: rgba(10, 36, 31, 0.1);
}
.border-word-color-950\\/100{
  border-color: rgb(10, 36, 31);
}
.border-word-color-950\\/15{
  border-color: rgba(10, 36, 31, 0.15);
}
.border-word-color-950\\/20{
  border-color: rgba(10, 36, 31, 0.2);
}
.border-word-color-950\\/25{
  border-color: rgba(10, 36, 31, 0.25);
}
.border-word-color-950\\/30{
  border-color: rgba(10, 36, 31, 0.3);
}
.border-word-color-950\\/35{
  border-color: rgba(10, 36, 31, 0.35);
}
.border-word-color-950\\/40{
  border-color: rgba(10, 36, 31, 0.4);
}
.border-word-color-950\\/45{
  border-color: rgba(10, 36, 31, 0.45);
}
.border-word-color-950\\/5{
  border-color: rgba(10, 36, 31, 0.05);
}
.border-word-color-950\\/50{
  border-color: rgba(10, 36, 31, 0.5);
}
.border-word-color-950\\/55{
  border-color: rgba(10, 36, 31, 0.55);
}
.border-word-color-950\\/60{
  border-color: rgba(10, 36, 31, 0.6);
}
.border-word-color-950\\/65{
  border-color: rgba(10, 36, 31, 0.65);
}
.border-word-color-950\\/70{
  border-color: rgba(10, 36, 31, 0.7);
}
.border-word-color-950\\/75{
  border-color: rgba(10, 36, 31, 0.75);
}
.border-word-color-950\\/80{
  border-color: rgba(10, 36, 31, 0.8);
}
.border-word-color-950\\/85{
  border-color: rgba(10, 36, 31, 0.85);
}
.border-word-color-950\\/90{
  border-color: rgba(10, 36, 31, 0.9);
}
.border-word-color-950\\/95{
  border-color: rgba(10, 36, 31, 0.95);
}
.border-wordsy-correct{
  --tw-border-opacity: 1;
  border-color: rgba(44, 135, 109, 1);
  border-color: rgba(44, 135, 109, var(--tw-border-opacity, 1));
}
.border-wordsy-present{
  --tw-border-opacity: 1;
  border-color: rgba(195, 120, 41, 1);
  border-color: rgba(195, 120, 41, var(--tw-border-opacity, 1));
}
.border-y-transparent{
  border-top-color: transparent;
  border-bottom-color: transparent;
}
.border-l-white{
  --tw-border-opacity: 1;
  border-left-color: rgba(255, 255, 255, 1);
  border-left-color: rgba(255, 255, 255, var(--tw-border-opacity, 1));
}
.border-r-transparent{
  border-right-color: transparent;
}
.border-opacity-10{
  --tw-border-opacity: 0.1;
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, 1);
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity, 1));
}
.bg-blumine-100{
  --tw-bg-opacity: 1;
  background-color: rgba(218, 238, 243, 1);
  background-color: rgba(218, 238, 243, var(--tw-bg-opacity, 1));
}
.bg-blumine-100\\/0{
  background-color: rgba(218, 238, 243, 0);
}
.bg-blumine-100\\/10{
  background-color: rgba(218, 238, 243, 0.1);
}
.bg-blumine-100\\/100{
  background-color: rgb(218, 238, 243);
}
.bg-blumine-100\\/15{
  background-color: rgba(218, 238, 243, 0.15);
}
.bg-blumine-100\\/20{
  background-color: rgba(218, 238, 243, 0.2);
}
.bg-blumine-100\\/25{
  background-color: rgba(218, 238, 243, 0.25);
}
.bg-blumine-100\\/30{
  background-color: rgba(218, 238, 243, 0.3);
}
.bg-blumine-100\\/35{
  background-color: rgba(218, 238, 243, 0.35);
}
.bg-blumine-100\\/40{
  background-color: rgba(218, 238, 243, 0.4);
}
.bg-blumine-100\\/45{
  background-color: rgba(218, 238, 243, 0.45);
}
.bg-blumine-100\\/5{
  background-color: rgba(218, 238, 243, 0.05);
}
.bg-blumine-100\\/50{
  background-color: rgba(218, 238, 243, 0.5);
}
.bg-blumine-100\\/55{
  background-color: rgba(218, 238, 243, 0.55);
}
.bg-blumine-100\\/60{
  background-color: rgba(218, 238, 243, 0.6);
}
.bg-blumine-100\\/65{
  background-color: rgba(218, 238, 243, 0.65);
}
.bg-blumine-100\\/70{
  background-color: rgba(218, 238, 243, 0.7);
}
.bg-blumine-100\\/75{
  background-color: rgba(218, 238, 243, 0.75);
}
.bg-blumine-100\\/80{
  background-color: rgba(218, 238, 243, 0.8);
}
.bg-blumine-100\\/85{
  background-color: rgba(218, 238, 243, 0.85);
}
.bg-blumine-100\\/90{
  background-color: rgba(218, 238, 243, 0.9);
}
.bg-blumine-100\\/95{
  background-color: rgba(218, 238, 243, 0.95);
}
.bg-blumine-200{
  --tw-bg-opacity: 1;
  background-color: rgba(186, 222, 231, 1);
  background-color: rgba(186, 222, 231, var(--tw-bg-opacity, 1));
}
.bg-blumine-200\\/0{
  background-color: rgba(186, 222, 231, 0);
}
.bg-blumine-200\\/10{
  background-color: rgba(186, 222, 231, 0.1);
}
.bg-blumine-200\\/100{
  background-color: rgb(186, 222, 231);
}
.bg-blumine-200\\/15{
  background-color: rgba(186, 222, 231, 0.15);
}
.bg-blumine-200\\/20{
  background-color: rgba(186, 222, 231, 0.2);
}
.bg-blumine-200\\/25{
  background-color: rgba(186, 222, 231, 0.25);
}
.bg-blumine-200\\/30{
  background-color: rgba(186, 222, 231, 0.3);
}
.bg-blumine-200\\/35{
  background-color: rgba(186, 222, 231, 0.35);
}
.bg-blumine-200\\/40{
  background-color: rgba(186, 222, 231, 0.4);
}
.bg-blumine-200\\/45{
  background-color: rgba(186, 222, 231, 0.45);
}
.bg-blumine-200\\/5{
  background-color: rgba(186, 222, 231, 0.05);
}
.bg-blumine-200\\/50{
  background-color: rgba(186, 222, 231, 0.5);
}
.bg-blumine-200\\/55{
  background-color: rgba(186, 222, 231, 0.55);
}
.bg-blumine-200\\/60{
  background-color: rgba(186, 222, 231, 0.6);
}
.bg-blumine-200\\/65{
  background-color: rgba(186, 222, 231, 0.65);
}
.bg-blumine-200\\/70{
  background-color: rgba(186, 222, 231, 0.7);
}
.bg-blumine-200\\/75{
  background-color: rgba(186, 222, 231, 0.75);
}
.bg-blumine-200\\/80{
  background-color: rgba(186, 222, 231, 0.8);
}
.bg-blumine-200\\/85{
  background-color: rgba(186, 222, 231, 0.85);
}
.bg-blumine-200\\/90{
  background-color: rgba(186, 222, 231, 0.9);
}
.bg-blumine-200\\/95{
  background-color: rgba(186, 222, 231, 0.95);
}
.bg-blumine-300{
  --tw-bg-opacity: 1;
  background-color: rgba(137, 197, 215, 1);
  background-color: rgba(137, 197, 215, var(--tw-bg-opacity, 1));
}
.bg-blumine-300\\/0{
  background-color: rgba(137, 197, 215, 0);
}
.bg-blumine-300\\/10{
  background-color: rgba(137, 197, 215, 0.1);
}
.bg-blumine-300\\/100{
  background-color: rgb(137, 197, 215);
}
.bg-blumine-300\\/15{
  background-color: rgba(137, 197, 215, 0.15);
}
.bg-blumine-300\\/20{
  background-color: rgba(137, 197, 215, 0.2);
}
.bg-blumine-300\\/25{
  background-color: rgba(137, 197, 215, 0.25);
}
.bg-blumine-300\\/30{
  background-color: rgba(137, 197, 215, 0.3);
}
.bg-blumine-300\\/35{
  background-color: rgba(137, 197, 215, 0.35);
}
.bg-blumine-300\\/40{
  background-color: rgba(137, 197, 215, 0.4);
}
.bg-blumine-300\\/45{
  background-color: rgba(137, 197, 215, 0.45);
}
.bg-blumine-300\\/5{
  background-color: rgba(137, 197, 215, 0.05);
}
.bg-blumine-300\\/50{
  background-color: rgba(137, 197, 215, 0.5);
}
.bg-blumine-300\\/55{
  background-color: rgba(137, 197, 215, 0.55);
}
.bg-blumine-300\\/60{
  background-color: rgba(137, 197, 215, 0.6);
}
.bg-blumine-300\\/65{
  background-color: rgba(137, 197, 215, 0.65);
}
.bg-blumine-300\\/70{
  background-color: rgba(137, 197, 215, 0.7);
}
.bg-blumine-300\\/75{
  background-color: rgba(137, 197, 215, 0.75);
}
.bg-blumine-300\\/80{
  background-color: rgba(137, 197, 215, 0.8);
}
.bg-blumine-300\\/85{
  background-color: rgba(137, 197, 215, 0.85);
}
.bg-blumine-300\\/90{
  background-color: rgba(137, 197, 215, 0.9);
}
.bg-blumine-300\\/95{
  background-color: rgba(137, 197, 215, 0.95);
}
.bg-blumine-400{
  --tw-bg-opacity: 1;
  background-color: rgba(82, 163, 190, 1);
  background-color: rgba(82, 163, 190, var(--tw-bg-opacity, 1));
}
.bg-blumine-400\\/0{
  background-color: rgba(82, 163, 190, 0);
}
.bg-blumine-400\\/10{
  background-color: rgba(82, 163, 190, 0.1);
}
.bg-blumine-400\\/100{
  background-color: rgb(82, 163, 190);
}
.bg-blumine-400\\/15{
  background-color: rgba(82, 163, 190, 0.15);
}
.bg-blumine-400\\/20{
  background-color: rgba(82, 163, 190, 0.2);
}
.bg-blumine-400\\/25{
  background-color: rgba(82, 163, 190, 0.25);
}
.bg-blumine-400\\/30{
  background-color: rgba(82, 163, 190, 0.3);
}
.bg-blumine-400\\/35{
  background-color: rgba(82, 163, 190, 0.35);
}
.bg-blumine-400\\/40{
  background-color: rgba(82, 163, 190, 0.4);
}
.bg-blumine-400\\/45{
  background-color: rgba(82, 163, 190, 0.45);
}
.bg-blumine-400\\/5{
  background-color: rgba(82, 163, 190, 0.05);
}
.bg-blumine-400\\/50{
  background-color: rgba(82, 163, 190, 0.5);
}
.bg-blumine-400\\/55{
  background-color: rgba(82, 163, 190, 0.55);
}
.bg-blumine-400\\/60{
  background-color: rgba(82, 163, 190, 0.6);
}
.bg-blumine-400\\/65{
  background-color: rgba(82, 163, 190, 0.65);
}
.bg-blumine-400\\/70{
  background-color: rgba(82, 163, 190, 0.7);
}
.bg-blumine-400\\/75{
  background-color: rgba(82, 163, 190, 0.75);
}
.bg-blumine-400\\/80{
  background-color: rgba(82, 163, 190, 0.8);
}
.bg-blumine-400\\/85{
  background-color: rgba(82, 163, 190, 0.85);
}
.bg-blumine-400\\/90{
  background-color: rgba(82, 163, 190, 0.9);
}
.bg-blumine-400\\/95{
  background-color: rgba(82, 163, 190, 0.95);
}
.bg-blumine-50{
  --tw-bg-opacity: 1;
  background-color: rgba(240, 249, 251, 1);
  background-color: rgba(240, 249, 251, var(--tw-bg-opacity, 1));
}
.bg-blumine-500{
  --tw-bg-opacity: 1;
  background-color: rgba(55, 135, 163, 1);
  background-color: rgba(55, 135, 163, var(--tw-bg-opacity, 1));
}
.bg-blumine-500\\/0{
  background-color: rgba(55, 135, 163, 0);
}
.bg-blumine-500\\/10{
  background-color: rgba(55, 135, 163, 0.1);
}
.bg-blumine-500\\/100{
  background-color: rgb(55, 135, 163);
}
.bg-blumine-500\\/15{
  background-color: rgba(55, 135, 163, 0.15);
}
.bg-blumine-500\\/20{
  background-color: rgba(55, 135, 163, 0.2);
}
.bg-blumine-500\\/25{
  background-color: rgba(55, 135, 163, 0.25);
}
.bg-blumine-500\\/30{
  background-color: rgba(55, 135, 163, 0.3);
}
.bg-blumine-500\\/35{
  background-color: rgba(55, 135, 163, 0.35);
}
.bg-blumine-500\\/40{
  background-color: rgba(55, 135, 163, 0.4);
}
.bg-blumine-500\\/45{
  background-color: rgba(55, 135, 163, 0.45);
}
.bg-blumine-500\\/5{
  background-color: rgba(55, 135, 163, 0.05);
}
.bg-blumine-500\\/50{
  background-color: rgba(55, 135, 163, 0.5);
}
.bg-blumine-500\\/55{
  background-color: rgba(55, 135, 163, 0.55);
}
.bg-blumine-500\\/60{
  background-color: rgba(55, 135, 163, 0.6);
}
.bg-blumine-500\\/65{
  background-color: rgba(55, 135, 163, 0.65);
}
.bg-blumine-500\\/70{
  background-color: rgba(55, 135, 163, 0.7);
}
.bg-blumine-500\\/75{
  background-color: rgba(55, 135, 163, 0.75);
}
.bg-blumine-500\\/80{
  background-color: rgba(55, 135, 163, 0.8);
}
.bg-blumine-500\\/85{
  background-color: rgba(55, 135, 163, 0.85);
}
.bg-blumine-500\\/90{
  background-color: rgba(55, 135, 163, 0.9);
}
.bg-blumine-500\\/95{
  background-color: rgba(55, 135, 163, 0.95);
}
.bg-blumine-600{
  --tw-bg-opacity: 1;
  background-color: rgba(48, 109, 138, 1);
  background-color: rgba(48, 109, 138, var(--tw-bg-opacity, 1));
}
.bg-blumine-600\\/0{
  background-color: rgba(48, 109, 138, 0);
}
.bg-blumine-600\\/10{
  background-color: rgba(48, 109, 138, 0.1);
}
.bg-blumine-600\\/100{
  background-color: rgb(48, 109, 138);
}
.bg-blumine-600\\/15{
  background-color: rgba(48, 109, 138, 0.15);
}
.bg-blumine-600\\/20{
  background-color: rgba(48, 109, 138, 0.2);
}
.bg-blumine-600\\/25{
  background-color: rgba(48, 109, 138, 0.25);
}
.bg-blumine-600\\/30{
  background-color: rgba(48, 109, 138, 0.3);
}
.bg-blumine-600\\/35{
  background-color: rgba(48, 109, 138, 0.35);
}
.bg-blumine-600\\/40{
  background-color: rgba(48, 109, 138, 0.4);
}
.bg-blumine-600\\/45{
  background-color: rgba(48, 109, 138, 0.45);
}
.bg-blumine-600\\/5{
  background-color: rgba(48, 109, 138, 0.05);
}
.bg-blumine-600\\/50{
  background-color: rgba(48, 109, 138, 0.5);
}
.bg-blumine-600\\/55{
  background-color: rgba(48, 109, 138, 0.55);
}
.bg-blumine-600\\/60{
  background-color: rgba(48, 109, 138, 0.6);
}
.bg-blumine-600\\/65{
  background-color: rgba(48, 109, 138, 0.65);
}
.bg-blumine-600\\/70{
  background-color: rgba(48, 109, 138, 0.7);
}
.bg-blumine-600\\/75{
  background-color: rgba(48, 109, 138, 0.75);
}
.bg-blumine-600\\/80{
  background-color: rgba(48, 109, 138, 0.8);
}
.bg-blumine-600\\/85{
  background-color: rgba(48, 109, 138, 0.85);
}
.bg-blumine-600\\/90{
  background-color: rgba(48, 109, 138, 0.9);
}
.bg-blumine-600\\/95{
  background-color: rgba(48, 109, 138, 0.95);
}
.bg-blumine-700{
  --tw-bg-opacity: 1;
  background-color: rgba(45, 91, 114, 1);
  background-color: rgba(45, 91, 114, var(--tw-bg-opacity, 1));
}
.bg-blumine-700\\/0{
  background-color: rgba(45, 91, 114, 0);
}
.bg-blumine-700\\/10{
  background-color: rgba(45, 91, 114, 0.1);
}
.bg-blumine-700\\/100{
  background-color: rgb(45, 91, 114);
}
.bg-blumine-700\\/15{
  background-color: rgba(45, 91, 114, 0.15);
}
.bg-blumine-700\\/20{
  background-color: rgba(45, 91, 114, 0.2);
}
.bg-blumine-700\\/25{
  background-color: rgba(45, 91, 114, 0.25);
}
.bg-blumine-700\\/30{
  background-color: rgba(45, 91, 114, 0.3);
}
.bg-blumine-700\\/35{
  background-color: rgba(45, 91, 114, 0.35);
}
.bg-blumine-700\\/40{
  background-color: rgba(45, 91, 114, 0.4);
}
.bg-blumine-700\\/45{
  background-color: rgba(45, 91, 114, 0.45);
}
.bg-blumine-700\\/5{
  background-color: rgba(45, 91, 114, 0.05);
}
.bg-blumine-700\\/50{
  background-color: rgba(45, 91, 114, 0.5);
}
.bg-blumine-700\\/55{
  background-color: rgba(45, 91, 114, 0.55);
}
.bg-blumine-700\\/60{
  background-color: rgba(45, 91, 114, 0.6);
}
.bg-blumine-700\\/65{
  background-color: rgba(45, 91, 114, 0.65);
}
.bg-blumine-700\\/70{
  background-color: rgba(45, 91, 114, 0.7);
}
.bg-blumine-700\\/75{
  background-color: rgba(45, 91, 114, 0.75);
}
.bg-blumine-700\\/80{
  background-color: rgba(45, 91, 114, 0.8);
}
.bg-blumine-700\\/85{
  background-color: rgba(45, 91, 114, 0.85);
}
.bg-blumine-700\\/90{
  background-color: rgba(45, 91, 114, 0.9);
}
.bg-blumine-700\\/95{
  background-color: rgba(45, 91, 114, 0.95);
}
.bg-blumine-800{
  --tw-bg-opacity: 1;
  background-color: rgba(44, 76, 94, 1);
  background-color: rgba(44, 76, 94, var(--tw-bg-opacity, 1));
}
.bg-blumine-800\\/0{
  background-color: rgba(44, 76, 94, 0);
}
.bg-blumine-800\\/10{
  background-color: rgba(44, 76, 94, 0.1);
}
.bg-blumine-800\\/100{
  background-color: rgb(44, 76, 94);
}
.bg-blumine-800\\/15{
  background-color: rgba(44, 76, 94, 0.15);
}
.bg-blumine-800\\/20{
  background-color: rgba(44, 76, 94, 0.2);
}
.bg-blumine-800\\/25{
  background-color: rgba(44, 76, 94, 0.25);
}
.bg-blumine-800\\/30{
  background-color: rgba(44, 76, 94, 0.3);
}
.bg-blumine-800\\/35{
  background-color: rgba(44, 76, 94, 0.35);
}
.bg-blumine-800\\/40{
  background-color: rgba(44, 76, 94, 0.4);
}
.bg-blumine-800\\/45{
  background-color: rgba(44, 76, 94, 0.45);
}
.bg-blumine-800\\/5{
  background-color: rgba(44, 76, 94, 0.05);
}
.bg-blumine-800\\/50{
  background-color: rgba(44, 76, 94, 0.5);
}
.bg-blumine-800\\/55{
  background-color: rgba(44, 76, 94, 0.55);
}
.bg-blumine-800\\/60{
  background-color: rgba(44, 76, 94, 0.6);
}
.bg-blumine-800\\/65{
  background-color: rgba(44, 76, 94, 0.65);
}
.bg-blumine-800\\/70{
  background-color: rgba(44, 76, 94, 0.7);
}
.bg-blumine-800\\/75{
  background-color: rgba(44, 76, 94, 0.75);
}
.bg-blumine-800\\/80{
  background-color: rgba(44, 76, 94, 0.8);
}
.bg-blumine-800\\/85{
  background-color: rgba(44, 76, 94, 0.85);
}
.bg-blumine-800\\/90{
  background-color: rgba(44, 76, 94, 0.9);
}
.bg-blumine-800\\/95{
  background-color: rgba(44, 76, 94, 0.95);
}
.bg-blumine-900{
  --tw-bg-opacity: 1;
  background-color: rgba(40, 65, 81, 1);
  background-color: rgba(40, 65, 81, var(--tw-bg-opacity, 1));
}
.bg-blumine-900\\/0{
  background-color: rgba(40, 65, 81, 0);
}
.bg-blumine-900\\/10{
  background-color: rgba(40, 65, 81, 0.1);
}
.bg-blumine-900\\/100{
  background-color: rgb(40, 65, 81);
}
.bg-blumine-900\\/15{
  background-color: rgba(40, 65, 81, 0.15);
}
.bg-blumine-900\\/20{
  background-color: rgba(40, 65, 81, 0.2);
}
.bg-blumine-900\\/25{
  background-color: rgba(40, 65, 81, 0.25);
}
.bg-blumine-900\\/30{
  background-color: rgba(40, 65, 81, 0.3);
}
.bg-blumine-900\\/35{
  background-color: rgba(40, 65, 81, 0.35);
}
.bg-blumine-900\\/40{
  background-color: rgba(40, 65, 81, 0.4);
}
.bg-blumine-900\\/45{
  background-color: rgba(40, 65, 81, 0.45);
}
.bg-blumine-900\\/5{
  background-color: rgba(40, 65, 81, 0.05);
}
.bg-blumine-900\\/50{
  background-color: rgba(40, 65, 81, 0.5);
}
.bg-blumine-900\\/55{
  background-color: rgba(40, 65, 81, 0.55);
}
.bg-blumine-900\\/60{
  background-color: rgba(40, 65, 81, 0.6);
}
.bg-blumine-900\\/65{
  background-color: rgba(40, 65, 81, 0.65);
}
.bg-blumine-900\\/70{
  background-color: rgba(40, 65, 81, 0.7);
}
.bg-blumine-900\\/75{
  background-color: rgba(40, 65, 81, 0.75);
}
.bg-blumine-900\\/80{
  background-color: rgba(40, 65, 81, 0.8);
}
.bg-blumine-900\\/85{
  background-color: rgba(40, 65, 81, 0.85);
}
.bg-blumine-900\\/90{
  background-color: rgba(40, 65, 81, 0.9);
}
.bg-blumine-900\\/95{
  background-color: rgba(40, 65, 81, 0.95);
}
.bg-blumine-950{
  --tw-bg-opacity: 1;
  background-color: rgba(22, 41, 54, 1);
  background-color: rgba(22, 41, 54, var(--tw-bg-opacity, 1));
}
.bg-blumine-950\\/0{
  background-color: rgba(22, 41, 54, 0);
}
.bg-blumine-950\\/10{
  background-color: rgba(22, 41, 54, 0.1);
}
.bg-blumine-950\\/100{
  background-color: rgb(22, 41, 54);
}
.bg-blumine-950\\/15{
  background-color: rgba(22, 41, 54, 0.15);
}
.bg-blumine-950\\/20{
  background-color: rgba(22, 41, 54, 0.2);
}
.bg-blumine-950\\/25{
  background-color: rgba(22, 41, 54, 0.25);
}
.bg-blumine-950\\/30{
  background-color: rgba(22, 41, 54, 0.3);
}
.bg-blumine-950\\/35{
  background-color: rgba(22, 41, 54, 0.35);
}
.bg-blumine-950\\/40{
  background-color: rgba(22, 41, 54, 0.4);
}
.bg-blumine-950\\/45{
  background-color: rgba(22, 41, 54, 0.45);
}
.bg-blumine-950\\/5{
  background-color: rgba(22, 41, 54, 0.05);
}
.bg-blumine-950\\/50{
  background-color: rgba(22, 41, 54, 0.5);
}
.bg-blumine-950\\/55{
  background-color: rgba(22, 41, 54, 0.55);
}
.bg-blumine-950\\/60{
  background-color: rgba(22, 41, 54, 0.6);
}
.bg-blumine-950\\/65{
  background-color: rgba(22, 41, 54, 0.65);
}
.bg-blumine-950\\/70{
  background-color: rgba(22, 41, 54, 0.7);
}
.bg-blumine-950\\/75{
  background-color: rgba(22, 41, 54, 0.75);
}
.bg-blumine-950\\/80{
  background-color: rgba(22, 41, 54, 0.8);
}
.bg-blumine-950\\/85{
  background-color: rgba(22, 41, 54, 0.85);
}
.bg-blumine-950\\/90{
  background-color: rgba(22, 41, 54, 0.9);
}
.bg-blumine-950\\/95{
  background-color: rgba(22, 41, 54, 0.95);
}
.bg-charcoal-100{
  --tw-bg-opacity: 1;
  background-color: rgba(230, 230, 231, 1);
  background-color: rgba(230, 230, 231, var(--tw-bg-opacity, 1));
}
.bg-charcoal-100\\/0{
  background-color: rgba(230, 230, 231, 0);
}
.bg-charcoal-100\\/10{
  background-color: rgba(230, 230, 231, 0.1);
}
.bg-charcoal-100\\/100{
  background-color: rgb(230, 230, 231);
}
.bg-charcoal-100\\/15{
  background-color: rgba(230, 230, 231, 0.15);
}
.bg-charcoal-100\\/20{
  background-color: rgba(230, 230, 231, 0.2);
}
.bg-charcoal-100\\/25{
  background-color: rgba(230, 230, 231, 0.25);
}
.bg-charcoal-100\\/30{
  background-color: rgba(230, 230, 231, 0.3);
}
.bg-charcoal-100\\/35{
  background-color: rgba(230, 230, 231, 0.35);
}
.bg-charcoal-100\\/40{
  background-color: rgba(230, 230, 231, 0.4);
}
.bg-charcoal-100\\/45{
  background-color: rgba(230, 230, 231, 0.45);
}
.bg-charcoal-100\\/5{
  background-color: rgba(230, 230, 231, 0.05);
}
.bg-charcoal-100\\/50{
  background-color: rgba(230, 230, 231, 0.5);
}
.bg-charcoal-100\\/55{
  background-color: rgba(230, 230, 231, 0.55);
}
.bg-charcoal-100\\/60{
  background-color: rgba(230, 230, 231, 0.6);
}
.bg-charcoal-100\\/65{
  background-color: rgba(230, 230, 231, 0.65);
}
.bg-charcoal-100\\/70{
  background-color: rgba(230, 230, 231, 0.7);
}
.bg-charcoal-100\\/75{
  background-color: rgba(230, 230, 231, 0.75);
}
.bg-charcoal-100\\/80{
  background-color: rgba(230, 230, 231, 0.8);
}
.bg-charcoal-100\\/85{
  background-color: rgba(230, 230, 231, 0.85);
}
.bg-charcoal-100\\/90{
  background-color: rgba(230, 230, 231, 0.9);
}
.bg-charcoal-100\\/95{
  background-color: rgba(230, 230, 231, 0.95);
}
.bg-charcoal-200{
  --tw-bg-opacity: 1;
  background-color: rgba(207, 208, 210, 1);
  background-color: rgba(207, 208, 210, var(--tw-bg-opacity, 1));
}
.bg-charcoal-200\\/0{
  background-color: rgba(207, 208, 210, 0);
}
.bg-charcoal-200\\/10{
  background-color: rgba(207, 208, 210, 0.1);
}
.bg-charcoal-200\\/100{
  background-color: rgb(207, 208, 210);
}
.bg-charcoal-200\\/15{
  background-color: rgba(207, 208, 210, 0.15);
}
.bg-charcoal-200\\/20{
  background-color: rgba(207, 208, 210, 0.2);
}
.bg-charcoal-200\\/25{
  background-color: rgba(207, 208, 210, 0.25);
}
.bg-charcoal-200\\/30{
  background-color: rgba(207, 208, 210, 0.3);
}
.bg-charcoal-200\\/35{
  background-color: rgba(207, 208, 210, 0.35);
}
.bg-charcoal-200\\/40{
  background-color: rgba(207, 208, 210, 0.4);
}
.bg-charcoal-200\\/45{
  background-color: rgba(207, 208, 210, 0.45);
}
.bg-charcoal-200\\/5{
  background-color: rgba(207, 208, 210, 0.05);
}
.bg-charcoal-200\\/50{
  background-color: rgba(207, 208, 210, 0.5);
}
.bg-charcoal-200\\/55{
  background-color: rgba(207, 208, 210, 0.55);
}
.bg-charcoal-200\\/60{
  background-color: rgba(207, 208, 210, 0.6);
}
.bg-charcoal-200\\/65{
  background-color: rgba(207, 208, 210, 0.65);
}
.bg-charcoal-200\\/70{
  background-color: rgba(207, 208, 210, 0.7);
}
.bg-charcoal-200\\/75{
  background-color: rgba(207, 208, 210, 0.75);
}
.bg-charcoal-200\\/80{
  background-color: rgba(207, 208, 210, 0.8);
}
.bg-charcoal-200\\/85{
  background-color: rgba(207, 208, 210, 0.85);
}
.bg-charcoal-200\\/90{
  background-color: rgba(207, 208, 210, 0.9);
}
.bg-charcoal-200\\/95{
  background-color: rgba(207, 208, 210, 0.95);
}
.bg-charcoal-300{
  --tw-bg-opacity: 1;
  background-color: rgba(174, 175, 178, 1);
  background-color: rgba(174, 175, 178, var(--tw-bg-opacity, 1));
}
.bg-charcoal-300\\/0{
  background-color: rgba(174, 175, 178, 0);
}
.bg-charcoal-300\\/10{
  background-color: rgba(174, 175, 178, 0.1);
}
.bg-charcoal-300\\/100{
  background-color: rgb(174, 175, 178);
}
.bg-charcoal-300\\/15{
  background-color: rgba(174, 175, 178, 0.15);
}
.bg-charcoal-300\\/20{
  background-color: rgba(174, 175, 178, 0.2);
}
.bg-charcoal-300\\/25{
  background-color: rgba(174, 175, 178, 0.25);
}
.bg-charcoal-300\\/30{
  background-color: rgba(174, 175, 178, 0.3);
}
.bg-charcoal-300\\/35{
  background-color: rgba(174, 175, 178, 0.35);
}
.bg-charcoal-300\\/40{
  background-color: rgba(174, 175, 178, 0.4);
}
.bg-charcoal-300\\/45{
  background-color: rgba(174, 175, 178, 0.45);
}
.bg-charcoal-300\\/5{
  background-color: rgba(174, 175, 178, 0.05);
}
.bg-charcoal-300\\/50{
  background-color: rgba(174, 175, 178, 0.5);
}
.bg-charcoal-300\\/55{
  background-color: rgba(174, 175, 178, 0.55);
}
.bg-charcoal-300\\/60{
  background-color: rgba(174, 175, 178, 0.6);
}
.bg-charcoal-300\\/65{
  background-color: rgba(174, 175, 178, 0.65);
}
.bg-charcoal-300\\/70{
  background-color: rgba(174, 175, 178, 0.7);
}
.bg-charcoal-300\\/75{
  background-color: rgba(174, 175, 178, 0.75);
}
.bg-charcoal-300\\/80{
  background-color: rgba(174, 175, 178, 0.8);
}
.bg-charcoal-300\\/85{
  background-color: rgba(174, 175, 178, 0.85);
}
.bg-charcoal-300\\/90{
  background-color: rgba(174, 175, 178, 0.9);
}
.bg-charcoal-300\\/95{
  background-color: rgba(174, 175, 178, 0.95);
}
.bg-charcoal-400{
  --tw-bg-opacity: 1;
  background-color: rgba(133, 134, 139, 1);
  background-color: rgba(133, 134, 139, var(--tw-bg-opacity, 1));
}
.bg-charcoal-400\\/0{
  background-color: rgba(133, 134, 139, 0);
}
.bg-charcoal-400\\/10{
  background-color: rgba(133, 134, 139, 0.1);
}
.bg-charcoal-400\\/100{
  background-color: rgb(133, 134, 139);
}
.bg-charcoal-400\\/15{
  background-color: rgba(133, 134, 139, 0.15);
}
.bg-charcoal-400\\/20{
  background-color: rgba(133, 134, 139, 0.2);
}
.bg-charcoal-400\\/25{
  background-color: rgba(133, 134, 139, 0.25);
}
.bg-charcoal-400\\/30{
  background-color: rgba(133, 134, 139, 0.3);
}
.bg-charcoal-400\\/35{
  background-color: rgba(133, 134, 139, 0.35);
}
.bg-charcoal-400\\/40{
  background-color: rgba(133, 134, 139, 0.4);
}
.bg-charcoal-400\\/45{
  background-color: rgba(133, 134, 139, 0.45);
}
.bg-charcoal-400\\/5{
  background-color: rgba(133, 134, 139, 0.05);
}
.bg-charcoal-400\\/50{
  background-color: rgba(133, 134, 139, 0.5);
}
.bg-charcoal-400\\/55{
  background-color: rgba(133, 134, 139, 0.55);
}
.bg-charcoal-400\\/60{
  background-color: rgba(133, 134, 139, 0.6);
}
.bg-charcoal-400\\/65{
  background-color: rgba(133, 134, 139, 0.65);
}
.bg-charcoal-400\\/70{
  background-color: rgba(133, 134, 139, 0.7);
}
.bg-charcoal-400\\/75{
  background-color: rgba(133, 134, 139, 0.75);
}
.bg-charcoal-400\\/80{
  background-color: rgba(133, 134, 139, 0.8);
}
.bg-charcoal-400\\/85{
  background-color: rgba(133, 134, 139, 0.85);
}
.bg-charcoal-400\\/90{
  background-color: rgba(133, 134, 139, 0.9);
}
.bg-charcoal-400\\/95{
  background-color: rgba(133, 134, 139, 0.95);
}
.bg-charcoal-50{
  --tw-bg-opacity: 1;
  background-color: rgba(245, 245, 246, 1);
  background-color: rgba(245, 245, 246, var(--tw-bg-opacity, 1));
}
.bg-charcoal-500{
  --tw-bg-opacity: 1;
  background-color: rgba(106, 107, 112, 1);
  background-color: rgba(106, 107, 112, var(--tw-bg-opacity, 1));
}
.bg-charcoal-500\\/0{
  background-color: rgba(106, 107, 112, 0);
}
.bg-charcoal-500\\/10{
  background-color: rgba(106, 107, 112, 0.1);
}
.bg-charcoal-500\\/100{
  background-color: rgb(106, 107, 112);
}
.bg-charcoal-500\\/15{
  background-color: rgba(106, 107, 112, 0.15);
}
.bg-charcoal-500\\/20{
  background-color: rgba(106, 107, 112, 0.2);
}
.bg-charcoal-500\\/25{
  background-color: rgba(106, 107, 112, 0.25);
}
.bg-charcoal-500\\/30{
  background-color: rgba(106, 107, 112, 0.3);
}
.bg-charcoal-500\\/35{
  background-color: rgba(106, 107, 112, 0.35);
}
.bg-charcoal-500\\/40{
  background-color: rgba(106, 107, 112, 0.4);
}
.bg-charcoal-500\\/45{
  background-color: rgba(106, 107, 112, 0.45);
}
.bg-charcoal-500\\/5{
  background-color: rgba(106, 107, 112, 0.05);
}
.bg-charcoal-500\\/50{
  background-color: rgba(106, 107, 112, 0.5);
}
.bg-charcoal-500\\/55{
  background-color: rgba(106, 107, 112, 0.55);
}
.bg-charcoal-500\\/60{
  background-color: rgba(106, 107, 112, 0.6);
}
.bg-charcoal-500\\/65{
  background-color: rgba(106, 107, 112, 0.65);
}
.bg-charcoal-500\\/70{
  background-color: rgba(106, 107, 112, 0.7);
}
.bg-charcoal-500\\/75{
  background-color: rgba(106, 107, 112, 0.75);
}
.bg-charcoal-500\\/80{
  background-color: rgba(106, 107, 112, 0.8);
}
.bg-charcoal-500\\/85{
  background-color: rgba(106, 107, 112, 0.85);
}
.bg-charcoal-500\\/90{
  background-color: rgba(106, 107, 112, 0.9);
}
.bg-charcoal-500\\/95{
  background-color: rgba(106, 107, 112, 0.95);
}
.bg-charcoal-600{
  --tw-bg-opacity: 1;
  background-color: rgba(90, 91, 96, 1);
  background-color: rgba(90, 91, 96, var(--tw-bg-opacity, 1));
}
.bg-charcoal-600\\/0{
  background-color: rgba(90, 91, 96, 0);
}
.bg-charcoal-600\\/10{
  background-color: rgba(90, 91, 96, 0.1);
}
.bg-charcoal-600\\/100{
  background-color: rgb(90, 91, 96);
}
.bg-charcoal-600\\/15{
  background-color: rgba(90, 91, 96, 0.15);
}
.bg-charcoal-600\\/20{
  background-color: rgba(90, 91, 96, 0.2);
}
.bg-charcoal-600\\/25{
  background-color: rgba(90, 91, 96, 0.25);
}
.bg-charcoal-600\\/30{
  background-color: rgba(90, 91, 96, 0.3);
}
.bg-charcoal-600\\/35{
  background-color: rgba(90, 91, 96, 0.35);
}
.bg-charcoal-600\\/40{
  background-color: rgba(90, 91, 96, 0.4);
}
.bg-charcoal-600\\/45{
  background-color: rgba(90, 91, 96, 0.45);
}
.bg-charcoal-600\\/5{
  background-color: rgba(90, 91, 96, 0.05);
}
.bg-charcoal-600\\/50{
  background-color: rgba(90, 91, 96, 0.5);
}
.bg-charcoal-600\\/55{
  background-color: rgba(90, 91, 96, 0.55);
}
.bg-charcoal-600\\/60{
  background-color: rgba(90, 91, 96, 0.6);
}
.bg-charcoal-600\\/65{
  background-color: rgba(90, 91, 96, 0.65);
}
.bg-charcoal-600\\/70{
  background-color: rgba(90, 91, 96, 0.7);
}
.bg-charcoal-600\\/75{
  background-color: rgba(90, 91, 96, 0.75);
}
.bg-charcoal-600\\/80{
  background-color: rgba(90, 91, 96, 0.8);
}
.bg-charcoal-600\\/85{
  background-color: rgba(90, 91, 96, 0.85);
}
.bg-charcoal-600\\/90{
  background-color: rgba(90, 91, 96, 0.9);
}
.bg-charcoal-600\\/95{
  background-color: rgba(90, 91, 96, 0.95);
}
.bg-charcoal-700{
  --tw-bg-opacity: 1;
  background-color: rgba(77, 77, 81, 1);
  background-color: rgba(77, 77, 81, var(--tw-bg-opacity, 1));
}
.bg-charcoal-700\\/0{
  background-color: rgba(77, 77, 81, 0);
}
.bg-charcoal-700\\/10{
  background-color: rgba(77, 77, 81, 0.1);
}
.bg-charcoal-700\\/100{
  background-color: rgb(77, 77, 81);
}
.bg-charcoal-700\\/15{
  background-color: rgba(77, 77, 81, 0.15);
}
.bg-charcoal-700\\/20{
  background-color: rgba(77, 77, 81, 0.2);
}
.bg-charcoal-700\\/25{
  background-color: rgba(77, 77, 81, 0.25);
}
.bg-charcoal-700\\/30{
  background-color: rgba(77, 77, 81, 0.3);
}
.bg-charcoal-700\\/35{
  background-color: rgba(77, 77, 81, 0.35);
}
.bg-charcoal-700\\/40{
  background-color: rgba(77, 77, 81, 0.4);
}
.bg-charcoal-700\\/45{
  background-color: rgba(77, 77, 81, 0.45);
}
.bg-charcoal-700\\/5{
  background-color: rgba(77, 77, 81, 0.05);
}
.bg-charcoal-700\\/50{
  background-color: rgba(77, 77, 81, 0.5);
}
.bg-charcoal-700\\/55{
  background-color: rgba(77, 77, 81, 0.55);
}
.bg-charcoal-700\\/60{
  background-color: rgba(77, 77, 81, 0.6);
}
.bg-charcoal-700\\/65{
  background-color: rgba(77, 77, 81, 0.65);
}
.bg-charcoal-700\\/70{
  background-color: rgba(77, 77, 81, 0.7);
}
.bg-charcoal-700\\/75{
  background-color: rgba(77, 77, 81, 0.75);
}
.bg-charcoal-700\\/80{
  background-color: rgba(77, 77, 81, 0.8);
}
.bg-charcoal-700\\/85{
  background-color: rgba(77, 77, 81, 0.85);
}
.bg-charcoal-700\\/90{
  background-color: rgba(77, 77, 81, 0.9);
}
.bg-charcoal-700\\/95{
  background-color: rgba(77, 77, 81, 0.95);
}
.bg-charcoal-800{
  --tw-bg-opacity: 1;
  background-color: rgba(67, 67, 71, 1);
  background-color: rgba(67, 67, 71, var(--tw-bg-opacity, 1));
}
.bg-charcoal-800\\/0{
  background-color: rgba(67, 67, 71, 0);
}
.bg-charcoal-800\\/10{
  background-color: rgba(67, 67, 71, 0.1);
}
.bg-charcoal-800\\/100{
  background-color: rgb(67, 67, 71);
}
.bg-charcoal-800\\/15{
  background-color: rgba(67, 67, 71, 0.15);
}
.bg-charcoal-800\\/20{
  background-color: rgba(67, 67, 71, 0.2);
}
.bg-charcoal-800\\/25{
  background-color: rgba(67, 67, 71, 0.25);
}
.bg-charcoal-800\\/30{
  background-color: rgba(67, 67, 71, 0.3);
}
.bg-charcoal-800\\/35{
  background-color: rgba(67, 67, 71, 0.35);
}
.bg-charcoal-800\\/40{
  background-color: rgba(67, 67, 71, 0.4);
}
.bg-charcoal-800\\/45{
  background-color: rgba(67, 67, 71, 0.45);
}
.bg-charcoal-800\\/5{
  background-color: rgba(67, 67, 71, 0.05);
}
.bg-charcoal-800\\/50{
  background-color: rgba(67, 67, 71, 0.5);
}
.bg-charcoal-800\\/55{
  background-color: rgba(67, 67, 71, 0.55);
}
.bg-charcoal-800\\/60{
  background-color: rgba(67, 67, 71, 0.6);
}
.bg-charcoal-800\\/65{
  background-color: rgba(67, 67, 71, 0.65);
}
.bg-charcoal-800\\/70{
  background-color: rgba(67, 67, 71, 0.7);
}
.bg-charcoal-800\\/75{
  background-color: rgba(67, 67, 71, 0.75);
}
.bg-charcoal-800\\/80{
  background-color: rgba(67, 67, 71, 0.8);
}
.bg-charcoal-800\\/85{
  background-color: rgba(67, 67, 71, 0.85);
}
.bg-charcoal-800\\/90{
  background-color: rgba(67, 67, 71, 0.9);
}
.bg-charcoal-800\\/95{
  background-color: rgba(67, 67, 71, 0.95);
}
.bg-charcoal-900{
  --tw-bg-opacity: 1;
  background-color: rgba(49, 49, 51, 1);
  background-color: rgba(49, 49, 51, var(--tw-bg-opacity, 1));
}
.bg-charcoal-900\\/0{
  background-color: rgba(49, 49, 51, 0);
}
.bg-charcoal-900\\/10{
  background-color: rgba(49, 49, 51, 0.1);
}
.bg-charcoal-900\\/100{
  background-color: rgb(49, 49, 51);
}
.bg-charcoal-900\\/15{
  background-color: rgba(49, 49, 51, 0.15);
}
.bg-charcoal-900\\/20{
  background-color: rgba(49, 49, 51, 0.2);
}
.bg-charcoal-900\\/25{
  background-color: rgba(49, 49, 51, 0.25);
}
.bg-charcoal-900\\/30{
  background-color: rgba(49, 49, 51, 0.3);
}
.bg-charcoal-900\\/35{
  background-color: rgba(49, 49, 51, 0.35);
}
.bg-charcoal-900\\/40{
  background-color: rgba(49, 49, 51, 0.4);
}
.bg-charcoal-900\\/45{
  background-color: rgba(49, 49, 51, 0.45);
}
.bg-charcoal-900\\/5{
  background-color: rgba(49, 49, 51, 0.05);
}
.bg-charcoal-900\\/50{
  background-color: rgba(49, 49, 51, 0.5);
}
.bg-charcoal-900\\/55{
  background-color: rgba(49, 49, 51, 0.55);
}
.bg-charcoal-900\\/60{
  background-color: rgba(49, 49, 51, 0.6);
}
.bg-charcoal-900\\/65{
  background-color: rgba(49, 49, 51, 0.65);
}
.bg-charcoal-900\\/70{
  background-color: rgba(49, 49, 51, 0.7);
}
.bg-charcoal-900\\/75{
  background-color: rgba(49, 49, 51, 0.75);
}
.bg-charcoal-900\\/80{
  background-color: rgba(49, 49, 51, 0.8);
}
.bg-charcoal-900\\/85{
  background-color: rgba(49, 49, 51, 0.85);
}
.bg-charcoal-900\\/90{
  background-color: rgba(49, 49, 51, 0.9);
}
.bg-charcoal-900\\/95{
  background-color: rgba(49, 49, 51, 0.95);
}
.bg-charcoal-950{
  --tw-bg-opacity: 1;
  background-color: rgba(37, 37, 39, 1);
  background-color: rgba(37, 37, 39, var(--tw-bg-opacity, 1));
}
.bg-charcoal-950\\/0{
  background-color: rgba(37, 37, 39, 0);
}
.bg-charcoal-950\\/10{
  background-color: rgba(37, 37, 39, 0.1);
}
.bg-charcoal-950\\/100{
  background-color: rgb(37, 37, 39);
}
.bg-charcoal-950\\/15{
  background-color: rgba(37, 37, 39, 0.15);
}
.bg-charcoal-950\\/20{
  background-color: rgba(37, 37, 39, 0.2);
}
.bg-charcoal-950\\/25{
  background-color: rgba(37, 37, 39, 0.25);
}
.bg-charcoal-950\\/30{
  background-color: rgba(37, 37, 39, 0.3);
}
.bg-charcoal-950\\/35{
  background-color: rgba(37, 37, 39, 0.35);
}
.bg-charcoal-950\\/40{
  background-color: rgba(37, 37, 39, 0.4);
}
.bg-charcoal-950\\/45{
  background-color: rgba(37, 37, 39, 0.45);
}
.bg-charcoal-950\\/5{
  background-color: rgba(37, 37, 39, 0.05);
}
.bg-charcoal-950\\/50{
  background-color: rgba(37, 37, 39, 0.5);
}
.bg-charcoal-950\\/55{
  background-color: rgba(37, 37, 39, 0.55);
}
.bg-charcoal-950\\/60{
  background-color: rgba(37, 37, 39, 0.6);
}
.bg-charcoal-950\\/65{
  background-color: rgba(37, 37, 39, 0.65);
}
.bg-charcoal-950\\/70{
  background-color: rgba(37, 37, 39, 0.7);
}
.bg-charcoal-950\\/75{
  background-color: rgba(37, 37, 39, 0.75);
}
.bg-charcoal-950\\/80{
  background-color: rgba(37, 37, 39, 0.8);
}
.bg-charcoal-950\\/85{
  background-color: rgba(37, 37, 39, 0.85);
}
.bg-charcoal-950\\/90{
  background-color: rgba(37, 37, 39, 0.9);
}
.bg-charcoal-950\\/95{
  background-color: rgba(37, 37, 39, 0.95);
}
.bg-inherit{
  background-color: inherit;
}
.bg-jade-100{
  --tw-bg-opacity: 1;
  background-color: rgba(217, 242, 230, 1);
  background-color: rgba(217, 242, 230, var(--tw-bg-opacity, 1));
}
.bg-jade-100\\/0{
  background-color: rgba(217, 242, 230, 0);
}
.bg-jade-100\\/10{
  background-color: rgba(217, 242, 230, 0.1);
}
.bg-jade-100\\/100{
  background-color: rgb(217, 242, 230);
}
.bg-jade-100\\/15{
  background-color: rgba(217, 242, 230, 0.15);
}
.bg-jade-100\\/20{
  background-color: rgba(217, 242, 230, 0.2);
}
.bg-jade-100\\/25{
  background-color: rgba(217, 242, 230, 0.25);
}
.bg-jade-100\\/30{
  background-color: rgba(217, 242, 230, 0.3);
}
.bg-jade-100\\/35{
  background-color: rgba(217, 242, 230, 0.35);
}
.bg-jade-100\\/40{
  background-color: rgba(217, 242, 230, 0.4);
}
.bg-jade-100\\/45{
  background-color: rgba(217, 242, 230, 0.45);
}
.bg-jade-100\\/5{
  background-color: rgba(217, 242, 230, 0.05);
}
.bg-jade-100\\/50{
  background-color: rgba(217, 242, 230, 0.5);
}
.bg-jade-100\\/55{
  background-color: rgba(217, 242, 230, 0.55);
}
.bg-jade-100\\/60{
  background-color: rgba(217, 242, 230, 0.6);
}
.bg-jade-100\\/65{
  background-color: rgba(217, 242, 230, 0.65);
}
.bg-jade-100\\/70{
  background-color: rgba(217, 242, 230, 0.7);
}
.bg-jade-100\\/75{
  background-color: rgba(217, 242, 230, 0.75);
}
.bg-jade-100\\/80{
  background-color: rgba(217, 242, 230, 0.8);
}
.bg-jade-100\\/85{
  background-color: rgba(217, 242, 230, 0.85);
}
.bg-jade-100\\/90{
  background-color: rgba(217, 242, 230, 0.9);
}
.bg-jade-100\\/95{
  background-color: rgba(217, 242, 230, 0.95);
}
.bg-jade-200{
  --tw-bg-opacity: 1;
  background-color: rgba(182, 228, 209, 1);
  background-color: rgba(182, 228, 209, var(--tw-bg-opacity, 1));
}
.bg-jade-200\\/0{
  background-color: rgba(182, 228, 209, 0);
}
.bg-jade-200\\/10{
  background-color: rgba(182, 228, 209, 0.1);
}
.bg-jade-200\\/100{
  background-color: rgb(182, 228, 209);
}
.bg-jade-200\\/15{
  background-color: rgba(182, 228, 209, 0.15);
}
.bg-jade-200\\/20{
  background-color: rgba(182, 228, 209, 0.2);
}
.bg-jade-200\\/25{
  background-color: rgba(182, 228, 209, 0.25);
}
.bg-jade-200\\/30{
  background-color: rgba(182, 228, 209, 0.3);
}
.bg-jade-200\\/35{
  background-color: rgba(182, 228, 209, 0.35);
}
.bg-jade-200\\/40{
  background-color: rgba(182, 228, 209, 0.4);
}
.bg-jade-200\\/45{
  background-color: rgba(182, 228, 209, 0.45);
}
.bg-jade-200\\/5{
  background-color: rgba(182, 228, 209, 0.05);
}
.bg-jade-200\\/50{
  background-color: rgba(182, 228, 209, 0.5);
}
.bg-jade-200\\/55{
  background-color: rgba(182, 228, 209, 0.55);
}
.bg-jade-200\\/60{
  background-color: rgba(182, 228, 209, 0.6);
}
.bg-jade-200\\/65{
  background-color: rgba(182, 228, 209, 0.65);
}
.bg-jade-200\\/70{
  background-color: rgba(182, 228, 209, 0.7);
}
.bg-jade-200\\/75{
  background-color: rgba(182, 228, 209, 0.75);
}
.bg-jade-200\\/80{
  background-color: rgba(182, 228, 209, 0.8);
}
.bg-jade-200\\/85{
  background-color: rgba(182, 228, 209, 0.85);
}
.bg-jade-200\\/90{
  background-color: rgba(182, 228, 209, 0.9);
}
.bg-jade-200\\/95{
  background-color: rgba(182, 228, 209, 0.95);
}
.bg-jade-300{
  --tw-bg-opacity: 1;
  background-color: rgba(134, 207, 181, 1);
  background-color: rgba(134, 207, 181, var(--tw-bg-opacity, 1));
}
.bg-jade-300\\/0{
  background-color: rgba(134, 207, 181, 0);
}
.bg-jade-300\\/10{
  background-color: rgba(134, 207, 181, 0.1);
}
.bg-jade-300\\/100{
  background-color: rgb(134, 207, 181);
}
.bg-jade-300\\/15{
  background-color: rgba(134, 207, 181, 0.15);
}
.bg-jade-300\\/20{
  background-color: rgba(134, 207, 181, 0.2);
}
.bg-jade-300\\/25{
  background-color: rgba(134, 207, 181, 0.25);
}
.bg-jade-300\\/30{
  background-color: rgba(134, 207, 181, 0.3);
}
.bg-jade-300\\/35{
  background-color: rgba(134, 207, 181, 0.35);
}
.bg-jade-300\\/40{
  background-color: rgba(134, 207, 181, 0.4);
}
.bg-jade-300\\/45{
  background-color: rgba(134, 207, 181, 0.45);
}
.bg-jade-300\\/5{
  background-color: rgba(134, 207, 181, 0.05);
}
.bg-jade-300\\/50{
  background-color: rgba(134, 207, 181, 0.5);
}
.bg-jade-300\\/55{
  background-color: rgba(134, 207, 181, 0.55);
}
.bg-jade-300\\/60{
  background-color: rgba(134, 207, 181, 0.6);
}
.bg-jade-300\\/65{
  background-color: rgba(134, 207, 181, 0.65);
}
.bg-jade-300\\/70{
  background-color: rgba(134, 207, 181, 0.7);
}
.bg-jade-300\\/75{
  background-color: rgba(134, 207, 181, 0.75);
}
.bg-jade-300\\/80{
  background-color: rgba(134, 207, 181, 0.8);
}
.bg-jade-300\\/85{
  background-color: rgba(134, 207, 181, 0.85);
}
.bg-jade-300\\/90{
  background-color: rgba(134, 207, 181, 0.9);
}
.bg-jade-300\\/95{
  background-color: rgba(134, 207, 181, 0.95);
}
.bg-jade-400{
  --tw-bg-opacity: 1;
  background-color: rgba(83, 180, 148, 1);
  background-color: rgba(83, 180, 148, var(--tw-bg-opacity, 1));
}
.bg-jade-400\\/0{
  background-color: rgba(83, 180, 148, 0);
}
.bg-jade-400\\/10{
  background-color: rgba(83, 180, 148, 0.1);
}
.bg-jade-400\\/100{
  background-color: rgb(83, 180, 148);
}
.bg-jade-400\\/15{
  background-color: rgba(83, 180, 148, 0.15);
}
.bg-jade-400\\/20{
  background-color: rgba(83, 180, 148, 0.2);
}
.bg-jade-400\\/25{
  background-color: rgba(83, 180, 148, 0.25);
}
.bg-jade-400\\/30{
  background-color: rgba(83, 180, 148, 0.3);
}
.bg-jade-400\\/35{
  background-color: rgba(83, 180, 148, 0.35);
}
.bg-jade-400\\/40{
  background-color: rgba(83, 180, 148, 0.4);
}
.bg-jade-400\\/45{
  background-color: rgba(83, 180, 148, 0.45);
}
.bg-jade-400\\/5{
  background-color: rgba(83, 180, 148, 0.05);
}
.bg-jade-400\\/50{
  background-color: rgba(83, 180, 148, 0.5);
}
.bg-jade-400\\/55{
  background-color: rgba(83, 180, 148, 0.55);
}
.bg-jade-400\\/60{
  background-color: rgba(83, 180, 148, 0.6);
}
.bg-jade-400\\/65{
  background-color: rgba(83, 180, 148, 0.65);
}
.bg-jade-400\\/70{
  background-color: rgba(83, 180, 148, 0.7);
}
.bg-jade-400\\/75{
  background-color: rgba(83, 180, 148, 0.75);
}
.bg-jade-400\\/80{
  background-color: rgba(83, 180, 148, 0.8);
}
.bg-jade-400\\/85{
  background-color: rgba(83, 180, 148, 0.85);
}
.bg-jade-400\\/90{
  background-color: rgba(83, 180, 148, 0.9);
}
.bg-jade-400\\/95{
  background-color: rgba(83, 180, 148, 0.95);
}
.bg-jade-50{
  --tw-bg-opacity: 1;
  background-color: rgba(239, 250, 246, 1);
  background-color: rgba(239, 250, 246, var(--tw-bg-opacity, 1));
}
.bg-jade-500{
  --tw-bg-opacity: 1;
  background-color: rgba(44, 135, 109, 1);
  background-color: rgba(44, 135, 109, var(--tw-bg-opacity, 1));
}
.bg-jade-500\\/0{
  background-color: rgba(44, 135, 109, 0);
}
.bg-jade-500\\/10{
  background-color: rgba(44, 135, 109, 0.1);
}
.bg-jade-500\\/100{
  background-color: rgb(44, 135, 109);
}
.bg-jade-500\\/15{
  background-color: rgba(44, 135, 109, 0.15);
}
.bg-jade-500\\/20{
  background-color: rgba(44, 135, 109, 0.2);
}
.bg-jade-500\\/25{
  background-color: rgba(44, 135, 109, 0.25);
}
.bg-jade-500\\/30{
  background-color: rgba(44, 135, 109, 0.3);
}
.bg-jade-500\\/35{
  background-color: rgba(44, 135, 109, 0.35);
}
.bg-jade-500\\/40{
  background-color: rgba(44, 135, 109, 0.4);
}
.bg-jade-500\\/45{
  background-color: rgba(44, 135, 109, 0.45);
}
.bg-jade-500\\/5{
  background-color: rgba(44, 135, 109, 0.05);
}
.bg-jade-500\\/50{
  background-color: rgba(44, 135, 109, 0.5);
}
.bg-jade-500\\/55{
  background-color: rgba(44, 135, 109, 0.55);
}
.bg-jade-500\\/60{
  background-color: rgba(44, 135, 109, 0.6);
}
.bg-jade-500\\/65{
  background-color: rgba(44, 135, 109, 0.65);
}
.bg-jade-500\\/70{
  background-color: rgba(44, 135, 109, 0.7);
}
.bg-jade-500\\/75{
  background-color: rgba(44, 135, 109, 0.75);
}
.bg-jade-500\\/80{
  background-color: rgba(44, 135, 109, 0.8);
}
.bg-jade-500\\/85{
  background-color: rgba(44, 135, 109, 0.85);
}
.bg-jade-500\\/90{
  background-color: rgba(44, 135, 109, 0.9);
}
.bg-jade-500\\/95{
  background-color: rgba(44, 135, 109, 0.95);
}
.bg-jade-600{
  --tw-bg-opacity: 1;
  background-color: rgba(34, 121, 98, 1);
  background-color: rgba(34, 121, 98, var(--tw-bg-opacity, 1));
}
.bg-jade-600\\/0{
  background-color: rgba(34, 121, 98, 0);
}
.bg-jade-600\\/10{
  background-color: rgba(34, 121, 98, 0.1);
}
.bg-jade-600\\/100{
  background-color: rgb(34, 121, 98);
}
.bg-jade-600\\/15{
  background-color: rgba(34, 121, 98, 0.15);
}
.bg-jade-600\\/20{
  background-color: rgba(34, 121, 98, 0.2);
}
.bg-jade-600\\/25{
  background-color: rgba(34, 121, 98, 0.25);
}
.bg-jade-600\\/30{
  background-color: rgba(34, 121, 98, 0.3);
}
.bg-jade-600\\/35{
  background-color: rgba(34, 121, 98, 0.35);
}
.bg-jade-600\\/40{
  background-color: rgba(34, 121, 98, 0.4);
}
.bg-jade-600\\/45{
  background-color: rgba(34, 121, 98, 0.45);
}
.bg-jade-600\\/5{
  background-color: rgba(34, 121, 98, 0.05);
}
.bg-jade-600\\/50{
  background-color: rgba(34, 121, 98, 0.5);
}
.bg-jade-600\\/55{
  background-color: rgba(34, 121, 98, 0.55);
}
.bg-jade-600\\/60{
  background-color: rgba(34, 121, 98, 0.6);
}
.bg-jade-600\\/65{
  background-color: rgba(34, 121, 98, 0.65);
}
.bg-jade-600\\/70{
  background-color: rgba(34, 121, 98, 0.7);
}
.bg-jade-600\\/75{
  background-color: rgba(34, 121, 98, 0.75);
}
.bg-jade-600\\/80{
  background-color: rgba(34, 121, 98, 0.8);
}
.bg-jade-600\\/85{
  background-color: rgba(34, 121, 98, 0.85);
}
.bg-jade-600\\/90{
  background-color: rgba(34, 121, 98, 0.9);
}
.bg-jade-600\\/95{
  background-color: rgba(34, 121, 98, 0.95);
}
.bg-jade-700{
  --tw-bg-opacity: 1;
  background-color: rgba(27, 97, 80, 1);
  background-color: rgba(27, 97, 80, var(--tw-bg-opacity, 1));
}
.bg-jade-700\\/0{
  background-color: rgba(27, 97, 80, 0);
}
.bg-jade-700\\/10{
  background-color: rgba(27, 97, 80, 0.1);
}
.bg-jade-700\\/100{
  background-color: rgb(27, 97, 80);
}
.bg-jade-700\\/15{
  background-color: rgba(27, 97, 80, 0.15);
}
.bg-jade-700\\/20{
  background-color: rgba(27, 97, 80, 0.2);
}
.bg-jade-700\\/25{
  background-color: rgba(27, 97, 80, 0.25);
}
.bg-jade-700\\/30{
  background-color: rgba(27, 97, 80, 0.3);
}
.bg-jade-700\\/35{
  background-color: rgba(27, 97, 80, 0.35);
}
.bg-jade-700\\/40{
  background-color: rgba(27, 97, 80, 0.4);
}
.bg-jade-700\\/45{
  background-color: rgba(27, 97, 80, 0.45);
}
.bg-jade-700\\/5{
  background-color: rgba(27, 97, 80, 0.05);
}
.bg-jade-700\\/50{
  background-color: rgba(27, 97, 80, 0.5);
}
.bg-jade-700\\/55{
  background-color: rgba(27, 97, 80, 0.55);
}
.bg-jade-700\\/60{
  background-color: rgba(27, 97, 80, 0.6);
}
.bg-jade-700\\/65{
  background-color: rgba(27, 97, 80, 0.65);
}
.bg-jade-700\\/70{
  background-color: rgba(27, 97, 80, 0.7);
}
.bg-jade-700\\/75{
  background-color: rgba(27, 97, 80, 0.75);
}
.bg-jade-700\\/80{
  background-color: rgba(27, 97, 80, 0.8);
}
.bg-jade-700\\/85{
  background-color: rgba(27, 97, 80, 0.85);
}
.bg-jade-700\\/90{
  background-color: rgba(27, 97, 80, 0.9);
}
.bg-jade-700\\/95{
  background-color: rgba(27, 97, 80, 0.95);
}
.bg-jade-800{
  --tw-bg-opacity: 1;
  background-color: rgba(24, 77, 64, 1);
  background-color: rgba(24, 77, 64, var(--tw-bg-opacity, 1));
}
.bg-jade-800\\/0{
  background-color: rgba(24, 77, 64, 0);
}
.bg-jade-800\\/10{
  background-color: rgba(24, 77, 64, 0.1);
}
.bg-jade-800\\/100{
  background-color: rgb(24, 77, 64);
}
.bg-jade-800\\/15{
  background-color: rgba(24, 77, 64, 0.15);
}
.bg-jade-800\\/20{
  background-color: rgba(24, 77, 64, 0.2);
}
.bg-jade-800\\/25{
  background-color: rgba(24, 77, 64, 0.25);
}
.bg-jade-800\\/30{
  background-color: rgba(24, 77, 64, 0.3);
}
.bg-jade-800\\/35{
  background-color: rgba(24, 77, 64, 0.35);
}
.bg-jade-800\\/40{
  background-color: rgba(24, 77, 64, 0.4);
}
.bg-jade-800\\/45{
  background-color: rgba(24, 77, 64, 0.45);
}
.bg-jade-800\\/5{
  background-color: rgba(24, 77, 64, 0.05);
}
.bg-jade-800\\/50{
  background-color: rgba(24, 77, 64, 0.5);
}
.bg-jade-800\\/55{
  background-color: rgba(24, 77, 64, 0.55);
}
.bg-jade-800\\/60{
  background-color: rgba(24, 77, 64, 0.6);
}
.bg-jade-800\\/65{
  background-color: rgba(24, 77, 64, 0.65);
}
.bg-jade-800\\/70{
  background-color: rgba(24, 77, 64, 0.7);
}
.bg-jade-800\\/75{
  background-color: rgba(24, 77, 64, 0.75);
}
.bg-jade-800\\/80{
  background-color: rgba(24, 77, 64, 0.8);
}
.bg-jade-800\\/85{
  background-color: rgba(24, 77, 64, 0.85);
}
.bg-jade-800\\/90{
  background-color: rgba(24, 77, 64, 0.9);
}
.bg-jade-800\\/95{
  background-color: rgba(24, 77, 64, 0.95);
}
.bg-jade-900{
  --tw-bg-opacity: 1;
  background-color: rgba(20, 64, 54, 1);
  background-color: rgba(20, 64, 54, var(--tw-bg-opacity, 1));
}
.bg-jade-900\\/0{
  background-color: rgba(20, 64, 54, 0);
}
.bg-jade-900\\/10{
  background-color: rgba(20, 64, 54, 0.1);
}
.bg-jade-900\\/100{
  background-color: rgb(20, 64, 54);
}
.bg-jade-900\\/15{
  background-color: rgba(20, 64, 54, 0.15);
}
.bg-jade-900\\/20{
  background-color: rgba(20, 64, 54, 0.2);
}
.bg-jade-900\\/25{
  background-color: rgba(20, 64, 54, 0.25);
}
.bg-jade-900\\/30{
  background-color: rgba(20, 64, 54, 0.3);
}
.bg-jade-900\\/35{
  background-color: rgba(20, 64, 54, 0.35);
}
.bg-jade-900\\/40{
  background-color: rgba(20, 64, 54, 0.4);
}
.bg-jade-900\\/45{
  background-color: rgba(20, 64, 54, 0.45);
}
.bg-jade-900\\/5{
  background-color: rgba(20, 64, 54, 0.05);
}
.bg-jade-900\\/50{
  background-color: rgba(20, 64, 54, 0.5);
}
.bg-jade-900\\/55{
  background-color: rgba(20, 64, 54, 0.55);
}
.bg-jade-900\\/60{
  background-color: rgba(20, 64, 54, 0.6);
}
.bg-jade-900\\/65{
  background-color: rgba(20, 64, 54, 0.65);
}
.bg-jade-900\\/70{
  background-color: rgba(20, 64, 54, 0.7);
}
.bg-jade-900\\/75{
  background-color: rgba(20, 64, 54, 0.75);
}
.bg-jade-900\\/80{
  background-color: rgba(20, 64, 54, 0.8);
}
.bg-jade-900\\/85{
  background-color: rgba(20, 64, 54, 0.85);
}
.bg-jade-900\\/90{
  background-color: rgba(20, 64, 54, 0.9);
}
.bg-jade-900\\/95{
  background-color: rgba(20, 64, 54, 0.95);
}
.bg-jade-950{
  --tw-bg-opacity: 1;
  background-color: rgba(10, 36, 31, 1);
  background-color: rgba(10, 36, 31, var(--tw-bg-opacity, 1));
}
.bg-jade-950\\/0{
  background-color: rgba(10, 36, 31, 0);
}
.bg-jade-950\\/10{
  background-color: rgba(10, 36, 31, 0.1);
}
.bg-jade-950\\/100{
  background-color: rgb(10, 36, 31);
}
.bg-jade-950\\/15{
  background-color: rgba(10, 36, 31, 0.15);
}
.bg-jade-950\\/20{
  background-color: rgba(10, 36, 31, 0.2);
}
.bg-jade-950\\/25{
  background-color: rgba(10, 36, 31, 0.25);
}
.bg-jade-950\\/30{
  background-color: rgba(10, 36, 31, 0.3);
}
.bg-jade-950\\/35{
  background-color: rgba(10, 36, 31, 0.35);
}
.bg-jade-950\\/40{
  background-color: rgba(10, 36, 31, 0.4);
}
.bg-jade-950\\/45{
  background-color: rgba(10, 36, 31, 0.45);
}
.bg-jade-950\\/5{
  background-color: rgba(10, 36, 31, 0.05);
}
.bg-jade-950\\/50{
  background-color: rgba(10, 36, 31, 0.5);
}
.bg-jade-950\\/55{
  background-color: rgba(10, 36, 31, 0.55);
}
.bg-jade-950\\/60{
  background-color: rgba(10, 36, 31, 0.6);
}
.bg-jade-950\\/65{
  background-color: rgba(10, 36, 31, 0.65);
}
.bg-jade-950\\/70{
  background-color: rgba(10, 36, 31, 0.7);
}
.bg-jade-950\\/75{
  background-color: rgba(10, 36, 31, 0.75);
}
.bg-jade-950\\/80{
  background-color: rgba(10, 36, 31, 0.8);
}
.bg-jade-950\\/85{
  background-color: rgba(10, 36, 31, 0.85);
}
.bg-jade-950\\/90{
  background-color: rgba(10, 36, 31, 0.9);
}
.bg-jade-950\\/95{
  background-color: rgba(10, 36, 31, 0.95);
}
.bg-kids-alphabet-500{
  --tw-bg-opacity: 1;
  background-color: rgba(55, 135, 163, 1);
  background-color: rgba(55, 135, 163, var(--tw-bg-opacity, 1));
}
.bg-kids-alphabet-500\\/0{
  background-color: rgba(55, 135, 163, 0);
}
.bg-kids-alphabet-500\\/10{
  background-color: rgba(55, 135, 163, 0.1);
}
.bg-kids-alphabet-500\\/100{
  background-color: rgb(55, 135, 163);
}
.bg-kids-alphabet-500\\/15{
  background-color: rgba(55, 135, 163, 0.15);
}
.bg-kids-alphabet-500\\/20{
  background-color: rgba(55, 135, 163, 0.2);
}
.bg-kids-alphabet-500\\/25{
  background-color: rgba(55, 135, 163, 0.25);
}
.bg-kids-alphabet-500\\/30{
  background-color: rgba(55, 135, 163, 0.3);
}
.bg-kids-alphabet-500\\/35{
  background-color: rgba(55, 135, 163, 0.35);
}
.bg-kids-alphabet-500\\/40{
  background-color: rgba(55, 135, 163, 0.4);
}
.bg-kids-alphabet-500\\/45{
  background-color: rgba(55, 135, 163, 0.45);
}
.bg-kids-alphabet-500\\/5{
  background-color: rgba(55, 135, 163, 0.05);
}
.bg-kids-alphabet-500\\/50{
  background-color: rgba(55, 135, 163, 0.5);
}
.bg-kids-alphabet-500\\/55{
  background-color: rgba(55, 135, 163, 0.55);
}
.bg-kids-alphabet-500\\/60{
  background-color: rgba(55, 135, 163, 0.6);
}
.bg-kids-alphabet-500\\/65{
  background-color: rgba(55, 135, 163, 0.65);
}
.bg-kids-alphabet-500\\/70{
  background-color: rgba(55, 135, 163, 0.7);
}
.bg-kids-alphabet-500\\/75{
  background-color: rgba(55, 135, 163, 0.75);
}
.bg-kids-alphabet-500\\/80{
  background-color: rgba(55, 135, 163, 0.8);
}
.bg-kids-alphabet-500\\/85{
  background-color: rgba(55, 135, 163, 0.85);
}
.bg-kids-alphabet-500\\/90{
  background-color: rgba(55, 135, 163, 0.9);
}
.bg-kids-alphabet-500\\/95{
  background-color: rgba(55, 135, 163, 0.95);
}
.bg-kids-alphabet-600{
  --tw-bg-opacity: 1;
  background-color: rgba(48, 109, 138, 1);
  background-color: rgba(48, 109, 138, var(--tw-bg-opacity, 1));
}
.bg-kids-alphabet-600\\/0{
  background-color: rgba(48, 109, 138, 0);
}
.bg-kids-alphabet-600\\/10{
  background-color: rgba(48, 109, 138, 0.1);
}
.bg-kids-alphabet-600\\/100{
  background-color: rgb(48, 109, 138);
}
.bg-kids-alphabet-600\\/15{
  background-color: rgba(48, 109, 138, 0.15);
}
.bg-kids-alphabet-600\\/20{
  background-color: rgba(48, 109, 138, 0.2);
}
.bg-kids-alphabet-600\\/25{
  background-color: rgba(48, 109, 138, 0.25);
}
.bg-kids-alphabet-600\\/30{
  background-color: rgba(48, 109, 138, 0.3);
}
.bg-kids-alphabet-600\\/35{
  background-color: rgba(48, 109, 138, 0.35);
}
.bg-kids-alphabet-600\\/40{
  background-color: rgba(48, 109, 138, 0.4);
}
.bg-kids-alphabet-600\\/45{
  background-color: rgba(48, 109, 138, 0.45);
}
.bg-kids-alphabet-600\\/5{
  background-color: rgba(48, 109, 138, 0.05);
}
.bg-kids-alphabet-600\\/50{
  background-color: rgba(48, 109, 138, 0.5);
}
.bg-kids-alphabet-600\\/55{
  background-color: rgba(48, 109, 138, 0.55);
}
.bg-kids-alphabet-600\\/60{
  background-color: rgba(48, 109, 138, 0.6);
}
.bg-kids-alphabet-600\\/65{
  background-color: rgba(48, 109, 138, 0.65);
}
.bg-kids-alphabet-600\\/70{
  background-color: rgba(48, 109, 138, 0.7);
}
.bg-kids-alphabet-600\\/75{
  background-color: rgba(48, 109, 138, 0.75);
}
.bg-kids-alphabet-600\\/80{
  background-color: rgba(48, 109, 138, 0.8);
}
.bg-kids-alphabet-600\\/85{
  background-color: rgba(48, 109, 138, 0.85);
}
.bg-kids-alphabet-600\\/90{
  background-color: rgba(48, 109, 138, 0.9);
}
.bg-kids-alphabet-600\\/95{
  background-color: rgba(48, 109, 138, 0.95);
}
.bg-kids-alphabet-700{
  --tw-bg-opacity: 1;
  background-color: rgba(45, 91, 114, 1);
  background-color: rgba(45, 91, 114, var(--tw-bg-opacity, 1));
}
.bg-kids-alphabet-700\\/0{
  background-color: rgba(45, 91, 114, 0);
}
.bg-kids-alphabet-700\\/10{
  background-color: rgba(45, 91, 114, 0.1);
}
.bg-kids-alphabet-700\\/100{
  background-color: rgb(45, 91, 114);
}
.bg-kids-alphabet-700\\/15{
  background-color: rgba(45, 91, 114, 0.15);
}
.bg-kids-alphabet-700\\/20{
  background-color: rgba(45, 91, 114, 0.2);
}
.bg-kids-alphabet-700\\/25{
  background-color: rgba(45, 91, 114, 0.25);
}
.bg-kids-alphabet-700\\/30{
  background-color: rgba(45, 91, 114, 0.3);
}
.bg-kids-alphabet-700\\/35{
  background-color: rgba(45, 91, 114, 0.35);
}
.bg-kids-alphabet-700\\/40{
  background-color: rgba(45, 91, 114, 0.4);
}
.bg-kids-alphabet-700\\/45{
  background-color: rgba(45, 91, 114, 0.45);
}
.bg-kids-alphabet-700\\/5{
  background-color: rgba(45, 91, 114, 0.05);
}
.bg-kids-alphabet-700\\/50{
  background-color: rgba(45, 91, 114, 0.5);
}
.bg-kids-alphabet-700\\/55{
  background-color: rgba(45, 91, 114, 0.55);
}
.bg-kids-alphabet-700\\/60{
  background-color: rgba(45, 91, 114, 0.6);
}
.bg-kids-alphabet-700\\/65{
  background-color: rgba(45, 91, 114, 0.65);
}
.bg-kids-alphabet-700\\/70{
  background-color: rgba(45, 91, 114, 0.7);
}
.bg-kids-alphabet-700\\/75{
  background-color: rgba(45, 91, 114, 0.75);
}
.bg-kids-alphabet-700\\/80{
  background-color: rgba(45, 91, 114, 0.8);
}
.bg-kids-alphabet-700\\/85{
  background-color: rgba(45, 91, 114, 0.85);
}
.bg-kids-alphabet-700\\/90{
  background-color: rgba(45, 91, 114, 0.9);
}
.bg-kids-alphabet-700\\/95{
  background-color: rgba(45, 91, 114, 0.95);
}
.bg-kids-alphabet-800{
  --tw-bg-opacity: 1;
  background-color: rgba(44, 76, 94, 1);
  background-color: rgba(44, 76, 94, var(--tw-bg-opacity, 1));
}
.bg-kids-alphabet-800\\/0{
  background-color: rgba(44, 76, 94, 0);
}
.bg-kids-alphabet-800\\/10{
  background-color: rgba(44, 76, 94, 0.1);
}
.bg-kids-alphabet-800\\/100{
  background-color: rgb(44, 76, 94);
}
.bg-kids-alphabet-800\\/15{
  background-color: rgba(44, 76, 94, 0.15);
}
.bg-kids-alphabet-800\\/20{
  background-color: rgba(44, 76, 94, 0.2);
}
.bg-kids-alphabet-800\\/25{
  background-color: rgba(44, 76, 94, 0.25);
}
.bg-kids-alphabet-800\\/30{
  background-color: rgba(44, 76, 94, 0.3);
}
.bg-kids-alphabet-800\\/35{
  background-color: rgba(44, 76, 94, 0.35);
}
.bg-kids-alphabet-800\\/40{
  background-color: rgba(44, 76, 94, 0.4);
}
.bg-kids-alphabet-800\\/45{
  background-color: rgba(44, 76, 94, 0.45);
}
.bg-kids-alphabet-800\\/5{
  background-color: rgba(44, 76, 94, 0.05);
}
.bg-kids-alphabet-800\\/50{
  background-color: rgba(44, 76, 94, 0.5);
}
.bg-kids-alphabet-800\\/55{
  background-color: rgba(44, 76, 94, 0.55);
}
.bg-kids-alphabet-800\\/60{
  background-color: rgba(44, 76, 94, 0.6);
}
.bg-kids-alphabet-800\\/65{
  background-color: rgba(44, 76, 94, 0.65);
}
.bg-kids-alphabet-800\\/70{
  background-color: rgba(44, 76, 94, 0.7);
}
.bg-kids-alphabet-800\\/75{
  background-color: rgba(44, 76, 94, 0.75);
}
.bg-kids-alphabet-800\\/80{
  background-color: rgba(44, 76, 94, 0.8);
}
.bg-kids-alphabet-800\\/85{
  background-color: rgba(44, 76, 94, 0.85);
}
.bg-kids-alphabet-800\\/90{
  background-color: rgba(44, 76, 94, 0.9);
}
.bg-kids-alphabet-800\\/95{
  background-color: rgba(44, 76, 94, 0.95);
}
.bg-kids-alphabet-900{
  --tw-bg-opacity: 1;
  background-color: rgba(40, 65, 81, 1);
  background-color: rgba(40, 65, 81, var(--tw-bg-opacity, 1));
}
.bg-kids-alphabet-900\\/0{
  background-color: rgba(40, 65, 81, 0);
}
.bg-kids-alphabet-900\\/10{
  background-color: rgba(40, 65, 81, 0.1);
}
.bg-kids-alphabet-900\\/100{
  background-color: rgb(40, 65, 81);
}
.bg-kids-alphabet-900\\/15{
  background-color: rgba(40, 65, 81, 0.15);
}
.bg-kids-alphabet-900\\/20{
  background-color: rgba(40, 65, 81, 0.2);
}
.bg-kids-alphabet-900\\/25{
  background-color: rgba(40, 65, 81, 0.25);
}
.bg-kids-alphabet-900\\/30{
  background-color: rgba(40, 65, 81, 0.3);
}
.bg-kids-alphabet-900\\/35{
  background-color: rgba(40, 65, 81, 0.35);
}
.bg-kids-alphabet-900\\/40{
  background-color: rgba(40, 65, 81, 0.4);
}
.bg-kids-alphabet-900\\/45{
  background-color: rgba(40, 65, 81, 0.45);
}
.bg-kids-alphabet-900\\/5{
  background-color: rgba(40, 65, 81, 0.05);
}
.bg-kids-alphabet-900\\/50{
  background-color: rgba(40, 65, 81, 0.5);
}
.bg-kids-alphabet-900\\/55{
  background-color: rgba(40, 65, 81, 0.55);
}
.bg-kids-alphabet-900\\/60{
  background-color: rgba(40, 65, 81, 0.6);
}
.bg-kids-alphabet-900\\/65{
  background-color: rgba(40, 65, 81, 0.65);
}
.bg-kids-alphabet-900\\/70{
  background-color: rgba(40, 65, 81, 0.7);
}
.bg-kids-alphabet-900\\/75{
  background-color: rgba(40, 65, 81, 0.75);
}
.bg-kids-alphabet-900\\/80{
  background-color: rgba(40, 65, 81, 0.8);
}
.bg-kids-alphabet-900\\/85{
  background-color: rgba(40, 65, 81, 0.85);
}
.bg-kids-alphabet-900\\/90{
  background-color: rgba(40, 65, 81, 0.9);
}
.bg-kids-alphabet-900\\/95{
  background-color: rgba(40, 65, 81, 0.95);
}
.bg-kids-categories-500{
  --tw-bg-opacity: 1;
  background-color: rgba(209, 145, 47, 1);
  background-color: rgba(209, 145, 47, var(--tw-bg-opacity, 1));
}
.bg-kids-categories-500\\/0{
  background-color: rgba(209, 145, 47, 0);
}
.bg-kids-categories-500\\/10{
  background-color: rgba(209, 145, 47, 0.1);
}
.bg-kids-categories-500\\/100{
  background-color: rgb(209, 145, 47);
}
.bg-kids-categories-500\\/15{
  background-color: rgba(209, 145, 47, 0.15);
}
.bg-kids-categories-500\\/20{
  background-color: rgba(209, 145, 47, 0.2);
}
.bg-kids-categories-500\\/25{
  background-color: rgba(209, 145, 47, 0.25);
}
.bg-kids-categories-500\\/30{
  background-color: rgba(209, 145, 47, 0.3);
}
.bg-kids-categories-500\\/35{
  background-color: rgba(209, 145, 47, 0.35);
}
.bg-kids-categories-500\\/40{
  background-color: rgba(209, 145, 47, 0.4);
}
.bg-kids-categories-500\\/45{
  background-color: rgba(209, 145, 47, 0.45);
}
.bg-kids-categories-500\\/5{
  background-color: rgba(209, 145, 47, 0.05);
}
.bg-kids-categories-500\\/50{
  background-color: rgba(209, 145, 47, 0.5);
}
.bg-kids-categories-500\\/55{
  background-color: rgba(209, 145, 47, 0.55);
}
.bg-kids-categories-500\\/60{
  background-color: rgba(209, 145, 47, 0.6);
}
.bg-kids-categories-500\\/65{
  background-color: rgba(209, 145, 47, 0.65);
}
.bg-kids-categories-500\\/70{
  background-color: rgba(209, 145, 47, 0.7);
}
.bg-kids-categories-500\\/75{
  background-color: rgba(209, 145, 47, 0.75);
}
.bg-kids-categories-500\\/80{
  background-color: rgba(209, 145, 47, 0.8);
}
.bg-kids-categories-500\\/85{
  background-color: rgba(209, 145, 47, 0.85);
}
.bg-kids-categories-500\\/90{
  background-color: rgba(209, 145, 47, 0.9);
}
.bg-kids-categories-500\\/95{
  background-color: rgba(209, 145, 47, 0.95);
}
.bg-kids-categories-600{
  --tw-bg-opacity: 1;
  background-color: rgba(195, 120, 41, 1);
  background-color: rgba(195, 120, 41, var(--tw-bg-opacity, 1));
}
.bg-kids-categories-600\\/0{
  background-color: rgba(195, 120, 41, 0);
}
.bg-kids-categories-600\\/10{
  background-color: rgba(195, 120, 41, 0.1);
}
.bg-kids-categories-600\\/100{
  background-color: rgb(195, 120, 41);
}
.bg-kids-categories-600\\/15{
  background-color: rgba(195, 120, 41, 0.15);
}
.bg-kids-categories-600\\/20{
  background-color: rgba(195, 120, 41, 0.2);
}
.bg-kids-categories-600\\/25{
  background-color: rgba(195, 120, 41, 0.25);
}
.bg-kids-categories-600\\/30{
  background-color: rgba(195, 120, 41, 0.3);
}
.bg-kids-categories-600\\/35{
  background-color: rgba(195, 120, 41, 0.35);
}
.bg-kids-categories-600\\/40{
  background-color: rgba(195, 120, 41, 0.4);
}
.bg-kids-categories-600\\/45{
  background-color: rgba(195, 120, 41, 0.45);
}
.bg-kids-categories-600\\/5{
  background-color: rgba(195, 120, 41, 0.05);
}
.bg-kids-categories-600\\/50{
  background-color: rgba(195, 120, 41, 0.5);
}
.bg-kids-categories-600\\/55{
  background-color: rgba(195, 120, 41, 0.55);
}
.bg-kids-categories-600\\/60{
  background-color: rgba(195, 120, 41, 0.6);
}
.bg-kids-categories-600\\/65{
  background-color: rgba(195, 120, 41, 0.65);
}
.bg-kids-categories-600\\/70{
  background-color: rgba(195, 120, 41, 0.7);
}
.bg-kids-categories-600\\/75{
  background-color: rgba(195, 120, 41, 0.75);
}
.bg-kids-categories-600\\/80{
  background-color: rgba(195, 120, 41, 0.8);
}
.bg-kids-categories-600\\/85{
  background-color: rgba(195, 120, 41, 0.85);
}
.bg-kids-categories-600\\/90{
  background-color: rgba(195, 120, 41, 0.9);
}
.bg-kids-categories-600\\/95{
  background-color: rgba(195, 120, 41, 0.95);
}
.bg-kids-categories-700{
  --tw-bg-opacity: 1;
  background-color: rgba(153, 84, 36, 1);
  background-color: rgba(153, 84, 36, var(--tw-bg-opacity, 1));
}
.bg-kids-categories-700\\/0{
  background-color: rgba(153, 84, 36, 0);
}
.bg-kids-categories-700\\/10{
  background-color: rgba(153, 84, 36, 0.1);
}
.bg-kids-categories-700\\/100{
  background-color: rgb(153, 84, 36);
}
.bg-kids-categories-700\\/15{
  background-color: rgba(153, 84, 36, 0.15);
}
.bg-kids-categories-700\\/20{
  background-color: rgba(153, 84, 36, 0.2);
}
.bg-kids-categories-700\\/25{
  background-color: rgba(153, 84, 36, 0.25);
}
.bg-kids-categories-700\\/30{
  background-color: rgba(153, 84, 36, 0.3);
}
.bg-kids-categories-700\\/35{
  background-color: rgba(153, 84, 36, 0.35);
}
.bg-kids-categories-700\\/40{
  background-color: rgba(153, 84, 36, 0.4);
}
.bg-kids-categories-700\\/45{
  background-color: rgba(153, 84, 36, 0.45);
}
.bg-kids-categories-700\\/5{
  background-color: rgba(153, 84, 36, 0.05);
}
.bg-kids-categories-700\\/50{
  background-color: rgba(153, 84, 36, 0.5);
}
.bg-kids-categories-700\\/55{
  background-color: rgba(153, 84, 36, 0.55);
}
.bg-kids-categories-700\\/60{
  background-color: rgba(153, 84, 36, 0.6);
}
.bg-kids-categories-700\\/65{
  background-color: rgba(153, 84, 36, 0.65);
}
.bg-kids-categories-700\\/70{
  background-color: rgba(153, 84, 36, 0.7);
}
.bg-kids-categories-700\\/75{
  background-color: rgba(153, 84, 36, 0.75);
}
.bg-kids-categories-700\\/80{
  background-color: rgba(153, 84, 36, 0.8);
}
.bg-kids-categories-700\\/85{
  background-color: rgba(153, 84, 36, 0.85);
}
.bg-kids-categories-700\\/90{
  background-color: rgba(153, 84, 36, 0.9);
}
.bg-kids-categories-700\\/95{
  background-color: rgba(153, 84, 36, 0.95);
}
.bg-kids-categories-800{
  --tw-bg-opacity: 1;
  background-color: rgba(126, 67, 34, 1);
  background-color: rgba(126, 67, 34, var(--tw-bg-opacity, 1));
}
.bg-kids-categories-800\\/0{
  background-color: rgba(126, 67, 34, 0);
}
.bg-kids-categories-800\\/10{
  background-color: rgba(126, 67, 34, 0.1);
}
.bg-kids-categories-800\\/100{
  background-color: rgb(126, 67, 34);
}
.bg-kids-categories-800\\/15{
  background-color: rgba(126, 67, 34, 0.15);
}
.bg-kids-categories-800\\/20{
  background-color: rgba(126, 67, 34, 0.2);
}
.bg-kids-categories-800\\/25{
  background-color: rgba(126, 67, 34, 0.25);
}
.bg-kids-categories-800\\/30{
  background-color: rgba(126, 67, 34, 0.3);
}
.bg-kids-categories-800\\/35{
  background-color: rgba(126, 67, 34, 0.35);
}
.bg-kids-categories-800\\/40{
  background-color: rgba(126, 67, 34, 0.4);
}
.bg-kids-categories-800\\/45{
  background-color: rgba(126, 67, 34, 0.45);
}
.bg-kids-categories-800\\/5{
  background-color: rgba(126, 67, 34, 0.05);
}
.bg-kids-categories-800\\/50{
  background-color: rgba(126, 67, 34, 0.5);
}
.bg-kids-categories-800\\/55{
  background-color: rgba(126, 67, 34, 0.55);
}
.bg-kids-categories-800\\/60{
  background-color: rgba(126, 67, 34, 0.6);
}
.bg-kids-categories-800\\/65{
  background-color: rgba(126, 67, 34, 0.65);
}
.bg-kids-categories-800\\/70{
  background-color: rgba(126, 67, 34, 0.7);
}
.bg-kids-categories-800\\/75{
  background-color: rgba(126, 67, 34, 0.75);
}
.bg-kids-categories-800\\/80{
  background-color: rgba(126, 67, 34, 0.8);
}
.bg-kids-categories-800\\/85{
  background-color: rgba(126, 67, 34, 0.85);
}
.bg-kids-categories-800\\/90{
  background-color: rgba(126, 67, 34, 0.9);
}
.bg-kids-categories-800\\/95{
  background-color: rgba(126, 67, 34, 0.95);
}
.bg-kids-categories-900{
  --tw-bg-opacity: 1;
  background-color: rgba(104, 56, 31, 1);
  background-color: rgba(104, 56, 31, var(--tw-bg-opacity, 1));
}
.bg-kids-categories-900\\/0{
  background-color: rgba(104, 56, 31, 0);
}
.bg-kids-categories-900\\/10{
  background-color: rgba(104, 56, 31, 0.1);
}
.bg-kids-categories-900\\/100{
  background-color: rgb(104, 56, 31);
}
.bg-kids-categories-900\\/15{
  background-color: rgba(104, 56, 31, 0.15);
}
.bg-kids-categories-900\\/20{
  background-color: rgba(104, 56, 31, 0.2);
}
.bg-kids-categories-900\\/25{
  background-color: rgba(104, 56, 31, 0.25);
}
.bg-kids-categories-900\\/30{
  background-color: rgba(104, 56, 31, 0.3);
}
.bg-kids-categories-900\\/35{
  background-color: rgba(104, 56, 31, 0.35);
}
.bg-kids-categories-900\\/40{
  background-color: rgba(104, 56, 31, 0.4);
}
.bg-kids-categories-900\\/45{
  background-color: rgba(104, 56, 31, 0.45);
}
.bg-kids-categories-900\\/5{
  background-color: rgba(104, 56, 31, 0.05);
}
.bg-kids-categories-900\\/50{
  background-color: rgba(104, 56, 31, 0.5);
}
.bg-kids-categories-900\\/55{
  background-color: rgba(104, 56, 31, 0.55);
}
.bg-kids-categories-900\\/60{
  background-color: rgba(104, 56, 31, 0.6);
}
.bg-kids-categories-900\\/65{
  background-color: rgba(104, 56, 31, 0.65);
}
.bg-kids-categories-900\\/70{
  background-color: rgba(104, 56, 31, 0.7);
}
.bg-kids-categories-900\\/75{
  background-color: rgba(104, 56, 31, 0.75);
}
.bg-kids-categories-900\\/80{
  background-color: rgba(104, 56, 31, 0.8);
}
.bg-kids-categories-900\\/85{
  background-color: rgba(104, 56, 31, 0.85);
}
.bg-kids-categories-900\\/90{
  background-color: rgba(104, 56, 31, 0.9);
}
.bg-kids-categories-900\\/95{
  background-color: rgba(104, 56, 31, 0.95);
}
.bg-kids-dictionary-500{
  --tw-bg-opacity: 1;
  background-color: rgba(44, 135, 109, 1);
  background-color: rgba(44, 135, 109, var(--tw-bg-opacity, 1));
}
.bg-kids-dictionary-500\\/0{
  background-color: rgba(44, 135, 109, 0);
}
.bg-kids-dictionary-500\\/10{
  background-color: rgba(44, 135, 109, 0.1);
}
.bg-kids-dictionary-500\\/100{
  background-color: rgb(44, 135, 109);
}
.bg-kids-dictionary-500\\/15{
  background-color: rgba(44, 135, 109, 0.15);
}
.bg-kids-dictionary-500\\/20{
  background-color: rgba(44, 135, 109, 0.2);
}
.bg-kids-dictionary-500\\/25{
  background-color: rgba(44, 135, 109, 0.25);
}
.bg-kids-dictionary-500\\/30{
  background-color: rgba(44, 135, 109, 0.3);
}
.bg-kids-dictionary-500\\/35{
  background-color: rgba(44, 135, 109, 0.35);
}
.bg-kids-dictionary-500\\/40{
  background-color: rgba(44, 135, 109, 0.4);
}
.bg-kids-dictionary-500\\/45{
  background-color: rgba(44, 135, 109, 0.45);
}
.bg-kids-dictionary-500\\/5{
  background-color: rgba(44, 135, 109, 0.05);
}
.bg-kids-dictionary-500\\/50{
  background-color: rgba(44, 135, 109, 0.5);
}
.bg-kids-dictionary-500\\/55{
  background-color: rgba(44, 135, 109, 0.55);
}
.bg-kids-dictionary-500\\/60{
  background-color: rgba(44, 135, 109, 0.6);
}
.bg-kids-dictionary-500\\/65{
  background-color: rgba(44, 135, 109, 0.65);
}
.bg-kids-dictionary-500\\/70{
  background-color: rgba(44, 135, 109, 0.7);
}
.bg-kids-dictionary-500\\/75{
  background-color: rgba(44, 135, 109, 0.75);
}
.bg-kids-dictionary-500\\/80{
  background-color: rgba(44, 135, 109, 0.8);
}
.bg-kids-dictionary-500\\/85{
  background-color: rgba(44, 135, 109, 0.85);
}
.bg-kids-dictionary-500\\/90{
  background-color: rgba(44, 135, 109, 0.9);
}
.bg-kids-dictionary-500\\/95{
  background-color: rgba(44, 135, 109, 0.95);
}
.bg-kids-dictionary-600{
  --tw-bg-opacity: 1;
  background-color: rgba(34, 121, 98, 1);
  background-color: rgba(34, 121, 98, var(--tw-bg-opacity, 1));
}
.bg-kids-dictionary-600\\/0{
  background-color: rgba(34, 121, 98, 0);
}
.bg-kids-dictionary-600\\/10{
  background-color: rgba(34, 121, 98, 0.1);
}
.bg-kids-dictionary-600\\/100{
  background-color: rgb(34, 121, 98);
}
.bg-kids-dictionary-600\\/15{
  background-color: rgba(34, 121, 98, 0.15);
}
.bg-kids-dictionary-600\\/20{
  background-color: rgba(34, 121, 98, 0.2);
}
.bg-kids-dictionary-600\\/25{
  background-color: rgba(34, 121, 98, 0.25);
}
.bg-kids-dictionary-600\\/30{
  background-color: rgba(34, 121, 98, 0.3);
}
.bg-kids-dictionary-600\\/35{
  background-color: rgba(34, 121, 98, 0.35);
}
.bg-kids-dictionary-600\\/40{
  background-color: rgba(34, 121, 98, 0.4);
}
.bg-kids-dictionary-600\\/45{
  background-color: rgba(34, 121, 98, 0.45);
}
.bg-kids-dictionary-600\\/5{
  background-color: rgba(34, 121, 98, 0.05);
}
.bg-kids-dictionary-600\\/50{
  background-color: rgba(34, 121, 98, 0.5);
}
.bg-kids-dictionary-600\\/55{
  background-color: rgba(34, 121, 98, 0.55);
}
.bg-kids-dictionary-600\\/60{
  background-color: rgba(34, 121, 98, 0.6);
}
.bg-kids-dictionary-600\\/65{
  background-color: rgba(34, 121, 98, 0.65);
}
.bg-kids-dictionary-600\\/70{
  background-color: rgba(34, 121, 98, 0.7);
}
.bg-kids-dictionary-600\\/75{
  background-color: rgba(34, 121, 98, 0.75);
}
.bg-kids-dictionary-600\\/80{
  background-color: rgba(34, 121, 98, 0.8);
}
.bg-kids-dictionary-600\\/85{
  background-color: rgba(34, 121, 98, 0.85);
}
.bg-kids-dictionary-600\\/90{
  background-color: rgba(34, 121, 98, 0.9);
}
.bg-kids-dictionary-600\\/95{
  background-color: rgba(34, 121, 98, 0.95);
}
.bg-kids-dictionary-700{
  --tw-bg-opacity: 1;
  background-color: rgba(27, 97, 80, 1);
  background-color: rgba(27, 97, 80, var(--tw-bg-opacity, 1));
}
.bg-kids-dictionary-700\\/0{
  background-color: rgba(27, 97, 80, 0);
}
.bg-kids-dictionary-700\\/10{
  background-color: rgba(27, 97, 80, 0.1);
}
.bg-kids-dictionary-700\\/100{
  background-color: rgb(27, 97, 80);
}
.bg-kids-dictionary-700\\/15{
  background-color: rgba(27, 97, 80, 0.15);
}
.bg-kids-dictionary-700\\/20{
  background-color: rgba(27, 97, 80, 0.2);
}
.bg-kids-dictionary-700\\/25{
  background-color: rgba(27, 97, 80, 0.25);
}
.bg-kids-dictionary-700\\/30{
  background-color: rgba(27, 97, 80, 0.3);
}
.bg-kids-dictionary-700\\/35{
  background-color: rgba(27, 97, 80, 0.35);
}
.bg-kids-dictionary-700\\/40{
  background-color: rgba(27, 97, 80, 0.4);
}
.bg-kids-dictionary-700\\/45{
  background-color: rgba(27, 97, 80, 0.45);
}
.bg-kids-dictionary-700\\/5{
  background-color: rgba(27, 97, 80, 0.05);
}
.bg-kids-dictionary-700\\/50{
  background-color: rgba(27, 97, 80, 0.5);
}
.bg-kids-dictionary-700\\/55{
  background-color: rgba(27, 97, 80, 0.55);
}
.bg-kids-dictionary-700\\/60{
  background-color: rgba(27, 97, 80, 0.6);
}
.bg-kids-dictionary-700\\/65{
  background-color: rgba(27, 97, 80, 0.65);
}
.bg-kids-dictionary-700\\/70{
  background-color: rgba(27, 97, 80, 0.7);
}
.bg-kids-dictionary-700\\/75{
  background-color: rgba(27, 97, 80, 0.75);
}
.bg-kids-dictionary-700\\/80{
  background-color: rgba(27, 97, 80, 0.8);
}
.bg-kids-dictionary-700\\/85{
  background-color: rgba(27, 97, 80, 0.85);
}
.bg-kids-dictionary-700\\/90{
  background-color: rgba(27, 97, 80, 0.9);
}
.bg-kids-dictionary-700\\/95{
  background-color: rgba(27, 97, 80, 0.95);
}
.bg-kids-dictionary-800{
  --tw-bg-opacity: 1;
  background-color: rgba(24, 77, 64, 1);
  background-color: rgba(24, 77, 64, var(--tw-bg-opacity, 1));
}
.bg-kids-dictionary-800\\/0{
  background-color: rgba(24, 77, 64, 0);
}
.bg-kids-dictionary-800\\/10{
  background-color: rgba(24, 77, 64, 0.1);
}
.bg-kids-dictionary-800\\/100{
  background-color: rgb(24, 77, 64);
}
.bg-kids-dictionary-800\\/15{
  background-color: rgba(24, 77, 64, 0.15);
}
.bg-kids-dictionary-800\\/20{
  background-color: rgba(24, 77, 64, 0.2);
}
.bg-kids-dictionary-800\\/25{
  background-color: rgba(24, 77, 64, 0.25);
}
.bg-kids-dictionary-800\\/30{
  background-color: rgba(24, 77, 64, 0.3);
}
.bg-kids-dictionary-800\\/35{
  background-color: rgba(24, 77, 64, 0.35);
}
.bg-kids-dictionary-800\\/40{
  background-color: rgba(24, 77, 64, 0.4);
}
.bg-kids-dictionary-800\\/45{
  background-color: rgba(24, 77, 64, 0.45);
}
.bg-kids-dictionary-800\\/5{
  background-color: rgba(24, 77, 64, 0.05);
}
.bg-kids-dictionary-800\\/50{
  background-color: rgba(24, 77, 64, 0.5);
}
.bg-kids-dictionary-800\\/55{
  background-color: rgba(24, 77, 64, 0.55);
}
.bg-kids-dictionary-800\\/60{
  background-color: rgba(24, 77, 64, 0.6);
}
.bg-kids-dictionary-800\\/65{
  background-color: rgba(24, 77, 64, 0.65);
}
.bg-kids-dictionary-800\\/70{
  background-color: rgba(24, 77, 64, 0.7);
}
.bg-kids-dictionary-800\\/75{
  background-color: rgba(24, 77, 64, 0.75);
}
.bg-kids-dictionary-800\\/80{
  background-color: rgba(24, 77, 64, 0.8);
}
.bg-kids-dictionary-800\\/85{
  background-color: rgba(24, 77, 64, 0.85);
}
.bg-kids-dictionary-800\\/90{
  background-color: rgba(24, 77, 64, 0.9);
}
.bg-kids-dictionary-800\\/95{
  background-color: rgba(24, 77, 64, 0.95);
}
.bg-kids-dictionary-900{
  --tw-bg-opacity: 1;
  background-color: rgba(20, 64, 54, 1);
  background-color: rgba(20, 64, 54, var(--tw-bg-opacity, 1));
}
.bg-kids-dictionary-900\\/0{
  background-color: rgba(20, 64, 54, 0);
}
.bg-kids-dictionary-900\\/10{
  background-color: rgba(20, 64, 54, 0.1);
}
.bg-kids-dictionary-900\\/100{
  background-color: rgb(20, 64, 54);
}
.bg-kids-dictionary-900\\/15{
  background-color: rgba(20, 64, 54, 0.15);
}
.bg-kids-dictionary-900\\/20{
  background-color: rgba(20, 64, 54, 0.2);
}
.bg-kids-dictionary-900\\/25{
  background-color: rgba(20, 64, 54, 0.25);
}
.bg-kids-dictionary-900\\/30{
  background-color: rgba(20, 64, 54, 0.3);
}
.bg-kids-dictionary-900\\/35{
  background-color: rgba(20, 64, 54, 0.35);
}
.bg-kids-dictionary-900\\/40{
  background-color: rgba(20, 64, 54, 0.4);
}
.bg-kids-dictionary-900\\/45{
  background-color: rgba(20, 64, 54, 0.45);
}
.bg-kids-dictionary-900\\/5{
  background-color: rgba(20, 64, 54, 0.05);
}
.bg-kids-dictionary-900\\/50{
  background-color: rgba(20, 64, 54, 0.5);
}
.bg-kids-dictionary-900\\/55{
  background-color: rgba(20, 64, 54, 0.55);
}
.bg-kids-dictionary-900\\/60{
  background-color: rgba(20, 64, 54, 0.6);
}
.bg-kids-dictionary-900\\/65{
  background-color: rgba(20, 64, 54, 0.65);
}
.bg-kids-dictionary-900\\/70{
  background-color: rgba(20, 64, 54, 0.7);
}
.bg-kids-dictionary-900\\/75{
  background-color: rgba(20, 64, 54, 0.75);
}
.bg-kids-dictionary-900\\/80{
  background-color: rgba(20, 64, 54, 0.8);
}
.bg-kids-dictionary-900\\/85{
  background-color: rgba(20, 64, 54, 0.85);
}
.bg-kids-dictionary-900\\/90{
  background-color: rgba(20, 64, 54, 0.9);
}
.bg-kids-dictionary-900\\/95{
  background-color: rgba(20, 64, 54, 0.95);
}
.bg-kids-games-500{
  --tw-bg-opacity: 1;
  background-color: rgba(81, 59, 86, 1);
  background-color: rgba(81, 59, 86, var(--tw-bg-opacity, 1));
}
.bg-kids-games-500\\/0{
  background-color: rgba(81, 59, 86, 0);
}
.bg-kids-games-500\\/10{
  background-color: rgba(81, 59, 86, 0.1);
}
.bg-kids-games-500\\/100{
  background-color: rgb(81, 59, 86);
}
.bg-kids-games-500\\/15{
  background-color: rgba(81, 59, 86, 0.15);
}
.bg-kids-games-500\\/20{
  background-color: rgba(81, 59, 86, 0.2);
}
.bg-kids-games-500\\/25{
  background-color: rgba(81, 59, 86, 0.25);
}
.bg-kids-games-500\\/30{
  background-color: rgba(81, 59, 86, 0.3);
}
.bg-kids-games-500\\/35{
  background-color: rgba(81, 59, 86, 0.35);
}
.bg-kids-games-500\\/40{
  background-color: rgba(81, 59, 86, 0.4);
}
.bg-kids-games-500\\/45{
  background-color: rgba(81, 59, 86, 0.45);
}
.bg-kids-games-500\\/5{
  background-color: rgba(81, 59, 86, 0.05);
}
.bg-kids-games-500\\/50{
  background-color: rgba(81, 59, 86, 0.5);
}
.bg-kids-games-500\\/55{
  background-color: rgba(81, 59, 86, 0.55);
}
.bg-kids-games-500\\/60{
  background-color: rgba(81, 59, 86, 0.6);
}
.bg-kids-games-500\\/65{
  background-color: rgba(81, 59, 86, 0.65);
}
.bg-kids-games-500\\/70{
  background-color: rgba(81, 59, 86, 0.7);
}
.bg-kids-games-500\\/75{
  background-color: rgba(81, 59, 86, 0.75);
}
.bg-kids-games-500\\/80{
  background-color: rgba(81, 59, 86, 0.8);
}
.bg-kids-games-500\\/85{
  background-color: rgba(81, 59, 86, 0.85);
}
.bg-kids-games-500\\/90{
  background-color: rgba(81, 59, 86, 0.9);
}
.bg-kids-games-500\\/95{
  background-color: rgba(81, 59, 86, 0.95);
}
.bg-kids-games-900{
  --tw-bg-opacity: 1;
  background-color: rgba(57, 41, 60, 1);
  background-color: rgba(57, 41, 60, var(--tw-bg-opacity, 1));
}
.bg-kids-games-900\\/0{
  background-color: rgba(57, 41, 60, 0);
}
.bg-kids-games-900\\/10{
  background-color: rgba(57, 41, 60, 0.1);
}
.bg-kids-games-900\\/100{
  background-color: rgb(57, 41, 60);
}
.bg-kids-games-900\\/15{
  background-color: rgba(57, 41, 60, 0.15);
}
.bg-kids-games-900\\/20{
  background-color: rgba(57, 41, 60, 0.2);
}
.bg-kids-games-900\\/25{
  background-color: rgba(57, 41, 60, 0.25);
}
.bg-kids-games-900\\/30{
  background-color: rgba(57, 41, 60, 0.3);
}
.bg-kids-games-900\\/35{
  background-color: rgba(57, 41, 60, 0.35);
}
.bg-kids-games-900\\/40{
  background-color: rgba(57, 41, 60, 0.4);
}
.bg-kids-games-900\\/45{
  background-color: rgba(57, 41, 60, 0.45);
}
.bg-kids-games-900\\/5{
  background-color: rgba(57, 41, 60, 0.05);
}
.bg-kids-games-900\\/50{
  background-color: rgba(57, 41, 60, 0.5);
}
.bg-kids-games-900\\/55{
  background-color: rgba(57, 41, 60, 0.55);
}
.bg-kids-games-900\\/60{
  background-color: rgba(57, 41, 60, 0.6);
}
.bg-kids-games-900\\/65{
  background-color: rgba(57, 41, 60, 0.65);
}
.bg-kids-games-900\\/70{
  background-color: rgba(57, 41, 60, 0.7);
}
.bg-kids-games-900\\/75{
  background-color: rgba(57, 41, 60, 0.75);
}
.bg-kids-games-900\\/80{
  background-color: rgba(57, 41, 60, 0.8);
}
.bg-kids-games-900\\/85{
  background-color: rgba(57, 41, 60, 0.85);
}
.bg-kids-games-900\\/90{
  background-color: rgba(57, 41, 60, 0.9);
}
.bg-kids-games-900\\/95{
  background-color: rgba(57, 41, 60, 0.95);
}
.bg-kids-songs-500{
  --tw-bg-opacity: 1;
  background-color: rgba(131, 0, 66, 1);
  background-color: rgba(131, 0, 66, var(--tw-bg-opacity, 1));
}
.bg-kids-songs-500\\/0{
  background-color: rgba(131, 0, 66, 0);
}
.bg-kids-songs-500\\/10{
  background-color: rgba(131, 0, 66, 0.1);
}
.bg-kids-songs-500\\/100{
  background-color: rgb(131, 0, 66);
}
.bg-kids-songs-500\\/15{
  background-color: rgba(131, 0, 66, 0.15);
}
.bg-kids-songs-500\\/20{
  background-color: rgba(131, 0, 66, 0.2);
}
.bg-kids-songs-500\\/25{
  background-color: rgba(131, 0, 66, 0.25);
}
.bg-kids-songs-500\\/30{
  background-color: rgba(131, 0, 66, 0.3);
}
.bg-kids-songs-500\\/35{
  background-color: rgba(131, 0, 66, 0.35);
}
.bg-kids-songs-500\\/40{
  background-color: rgba(131, 0, 66, 0.4);
}
.bg-kids-songs-500\\/45{
  background-color: rgba(131, 0, 66, 0.45);
}
.bg-kids-songs-500\\/5{
  background-color: rgba(131, 0, 66, 0.05);
}
.bg-kids-songs-500\\/50{
  background-color: rgba(131, 0, 66, 0.5);
}
.bg-kids-songs-500\\/55{
  background-color: rgba(131, 0, 66, 0.55);
}
.bg-kids-songs-500\\/60{
  background-color: rgba(131, 0, 66, 0.6);
}
.bg-kids-songs-500\\/65{
  background-color: rgba(131, 0, 66, 0.65);
}
.bg-kids-songs-500\\/70{
  background-color: rgba(131, 0, 66, 0.7);
}
.bg-kids-songs-500\\/75{
  background-color: rgba(131, 0, 66, 0.75);
}
.bg-kids-songs-500\\/80{
  background-color: rgba(131, 0, 66, 0.8);
}
.bg-kids-songs-500\\/85{
  background-color: rgba(131, 0, 66, 0.85);
}
.bg-kids-songs-500\\/90{
  background-color: rgba(131, 0, 66, 0.9);
}
.bg-kids-songs-500\\/95{
  background-color: rgba(131, 0, 66, 0.95);
}
.bg-kids-songs-900{
  --tw-bg-opacity: 1;
  background-color: rgba(92, 0, 46, 1);
  background-color: rgba(92, 0, 46, var(--tw-bg-opacity, 1));
}
.bg-kids-songs-900\\/0{
  background-color: rgba(92, 0, 46, 0);
}
.bg-kids-songs-900\\/10{
  background-color: rgba(92, 0, 46, 0.1);
}
.bg-kids-songs-900\\/100{
  background-color: rgb(92, 0, 46);
}
.bg-kids-songs-900\\/15{
  background-color: rgba(92, 0, 46, 0.15);
}
.bg-kids-songs-900\\/20{
  background-color: rgba(92, 0, 46, 0.2);
}
.bg-kids-songs-900\\/25{
  background-color: rgba(92, 0, 46, 0.25);
}
.bg-kids-songs-900\\/30{
  background-color: rgba(92, 0, 46, 0.3);
}
.bg-kids-songs-900\\/35{
  background-color: rgba(92, 0, 46, 0.35);
}
.bg-kids-songs-900\\/40{
  background-color: rgba(92, 0, 46, 0.4);
}
.bg-kids-songs-900\\/45{
  background-color: rgba(92, 0, 46, 0.45);
}
.bg-kids-songs-900\\/5{
  background-color: rgba(92, 0, 46, 0.05);
}
.bg-kids-songs-900\\/50{
  background-color: rgba(92, 0, 46, 0.5);
}
.bg-kids-songs-900\\/55{
  background-color: rgba(92, 0, 46, 0.55);
}
.bg-kids-songs-900\\/60{
  background-color: rgba(92, 0, 46, 0.6);
}
.bg-kids-songs-900\\/65{
  background-color: rgba(92, 0, 46, 0.65);
}
.bg-kids-songs-900\\/70{
  background-color: rgba(92, 0, 46, 0.7);
}
.bg-kids-songs-900\\/75{
  background-color: rgba(92, 0, 46, 0.75);
}
.bg-kids-songs-900\\/80{
  background-color: rgba(92, 0, 46, 0.8);
}
.bg-kids-songs-900\\/85{
  background-color: rgba(92, 0, 46, 0.85);
}
.bg-kids-songs-900\\/90{
  background-color: rgba(92, 0, 46, 0.9);
}
.bg-kids-songs-900\\/95{
  background-color: rgba(92, 0, 46, 0.95);
}
.bg-kids-stories-500{
  --tw-bg-opacity: 1;
  background-color: rgba(233, 196, 106, 1);
  background-color: rgba(233, 196, 106, var(--tw-bg-opacity, 1));
}
.bg-kids-stories-500\\/0{
  background-color: rgba(233, 196, 106, 0);
}
.bg-kids-stories-500\\/10{
  background-color: rgba(233, 196, 106, 0.1);
}
.bg-kids-stories-500\\/100{
  background-color: rgb(233, 196, 106);
}
.bg-kids-stories-500\\/15{
  background-color: rgba(233, 196, 106, 0.15);
}
.bg-kids-stories-500\\/20{
  background-color: rgba(233, 196, 106, 0.2);
}
.bg-kids-stories-500\\/25{
  background-color: rgba(233, 196, 106, 0.25);
}
.bg-kids-stories-500\\/30{
  background-color: rgba(233, 196, 106, 0.3);
}
.bg-kids-stories-500\\/35{
  background-color: rgba(233, 196, 106, 0.35);
}
.bg-kids-stories-500\\/40{
  background-color: rgba(233, 196, 106, 0.4);
}
.bg-kids-stories-500\\/45{
  background-color: rgba(233, 196, 106, 0.45);
}
.bg-kids-stories-500\\/5{
  background-color: rgba(233, 196, 106, 0.05);
}
.bg-kids-stories-500\\/50{
  background-color: rgba(233, 196, 106, 0.5);
}
.bg-kids-stories-500\\/55{
  background-color: rgba(233, 196, 106, 0.55);
}
.bg-kids-stories-500\\/60{
  background-color: rgba(233, 196, 106, 0.6);
}
.bg-kids-stories-500\\/65{
  background-color: rgba(233, 196, 106, 0.65);
}
.bg-kids-stories-500\\/70{
  background-color: rgba(233, 196, 106, 0.7);
}
.bg-kids-stories-500\\/75{
  background-color: rgba(233, 196, 106, 0.75);
}
.bg-kids-stories-500\\/80{
  background-color: rgba(233, 196, 106, 0.8);
}
.bg-kids-stories-500\\/85{
  background-color: rgba(233, 196, 106, 0.85);
}
.bg-kids-stories-500\\/90{
  background-color: rgba(233, 196, 106, 0.9);
}
.bg-kids-stories-500\\/95{
  background-color: rgba(233, 196, 106, 0.95);
}
.bg-kids-stories-900{
  --tw-bg-opacity: 1;
  background-color: rgba(163, 137, 74, 1);
  background-color: rgba(163, 137, 74, var(--tw-bg-opacity, 1));
}
.bg-kids-stories-900\\/0{
  background-color: rgba(163, 137, 74, 0);
}
.bg-kids-stories-900\\/10{
  background-color: rgba(163, 137, 74, 0.1);
}
.bg-kids-stories-900\\/100{
  background-color: rgb(163, 137, 74);
}
.bg-kids-stories-900\\/15{
  background-color: rgba(163, 137, 74, 0.15);
}
.bg-kids-stories-900\\/20{
  background-color: rgba(163, 137, 74, 0.2);
}
.bg-kids-stories-900\\/25{
  background-color: rgba(163, 137, 74, 0.25);
}
.bg-kids-stories-900\\/30{
  background-color: rgba(163, 137, 74, 0.3);
}
.bg-kids-stories-900\\/35{
  background-color: rgba(163, 137, 74, 0.35);
}
.bg-kids-stories-900\\/40{
  background-color: rgba(163, 137, 74, 0.4);
}
.bg-kids-stories-900\\/45{
  background-color: rgba(163, 137, 74, 0.45);
}
.bg-kids-stories-900\\/5{
  background-color: rgba(163, 137, 74, 0.05);
}
.bg-kids-stories-900\\/50{
  background-color: rgba(163, 137, 74, 0.5);
}
.bg-kids-stories-900\\/55{
  background-color: rgba(163, 137, 74, 0.55);
}
.bg-kids-stories-900\\/60{
  background-color: rgba(163, 137, 74, 0.6);
}
.bg-kids-stories-900\\/65{
  background-color: rgba(163, 137, 74, 0.65);
}
.bg-kids-stories-900\\/70{
  background-color: rgba(163, 137, 74, 0.7);
}
.bg-kids-stories-900\\/75{
  background-color: rgba(163, 137, 74, 0.75);
}
.bg-kids-stories-900\\/80{
  background-color: rgba(163, 137, 74, 0.8);
}
.bg-kids-stories-900\\/85{
  background-color: rgba(163, 137, 74, 0.85);
}
.bg-kids-stories-900\\/90{
  background-color: rgba(163, 137, 74, 0.9);
}
.bg-kids-stories-900\\/95{
  background-color: rgba(163, 137, 74, 0.95);
}
.bg-ochre-100{
  --tw-bg-opacity: 1;
  background-color: rgba(245, 237, 208, 1);
  background-color: rgba(245, 237, 208, var(--tw-bg-opacity, 1));
}
.bg-ochre-100\\/0{
  background-color: rgba(245, 237, 208, 0);
}
.bg-ochre-100\\/10{
  background-color: rgba(245, 237, 208, 0.1);
}
.bg-ochre-100\\/100{
  background-color: rgb(245, 237, 208);
}
.bg-ochre-100\\/15{
  background-color: rgba(245, 237, 208, 0.15);
}
.bg-ochre-100\\/20{
  background-color: rgba(245, 237, 208, 0.2);
}
.bg-ochre-100\\/25{
  background-color: rgba(245, 237, 208, 0.25);
}
.bg-ochre-100\\/30{
  background-color: rgba(245, 237, 208, 0.3);
}
.bg-ochre-100\\/35{
  background-color: rgba(245, 237, 208, 0.35);
}
.bg-ochre-100\\/40{
  background-color: rgba(245, 237, 208, 0.4);
}
.bg-ochre-100\\/45{
  background-color: rgba(245, 237, 208, 0.45);
}
.bg-ochre-100\\/5{
  background-color: rgba(245, 237, 208, 0.05);
}
.bg-ochre-100\\/50{
  background-color: rgba(245, 237, 208, 0.5);
}
.bg-ochre-100\\/55{
  background-color: rgba(245, 237, 208, 0.55);
}
.bg-ochre-100\\/60{
  background-color: rgba(245, 237, 208, 0.6);
}
.bg-ochre-100\\/65{
  background-color: rgba(245, 237, 208, 0.65);
}
.bg-ochre-100\\/70{
  background-color: rgba(245, 237, 208, 0.7);
}
.bg-ochre-100\\/75{
  background-color: rgba(245, 237, 208, 0.75);
}
.bg-ochre-100\\/80{
  background-color: rgba(245, 237, 208, 0.8);
}
.bg-ochre-100\\/85{
  background-color: rgba(245, 237, 208, 0.85);
}
.bg-ochre-100\\/90{
  background-color: rgba(245, 237, 208, 0.9);
}
.bg-ochre-100\\/95{
  background-color: rgba(245, 237, 208, 0.95);
}
.bg-ochre-200{
  --tw-bg-opacity: 1;
  background-color: rgba(235, 217, 156, 1);
  background-color: rgba(235, 217, 156, var(--tw-bg-opacity, 1));
}
.bg-ochre-200\\/0{
  background-color: rgba(235, 217, 156, 0);
}
.bg-ochre-200\\/10{
  background-color: rgba(235, 217, 156, 0.1);
}
.bg-ochre-200\\/100{
  background-color: rgb(235, 217, 156);
}
.bg-ochre-200\\/15{
  background-color: rgba(235, 217, 156, 0.15);
}
.bg-ochre-200\\/20{
  background-color: rgba(235, 217, 156, 0.2);
}
.bg-ochre-200\\/25{
  background-color: rgba(235, 217, 156, 0.25);
}
.bg-ochre-200\\/30{
  background-color: rgba(235, 217, 156, 0.3);
}
.bg-ochre-200\\/35{
  background-color: rgba(235, 217, 156, 0.35);
}
.bg-ochre-200\\/40{
  background-color: rgba(235, 217, 156, 0.4);
}
.bg-ochre-200\\/45{
  background-color: rgba(235, 217, 156, 0.45);
}
.bg-ochre-200\\/5{
  background-color: rgba(235, 217, 156, 0.05);
}
.bg-ochre-200\\/50{
  background-color: rgba(235, 217, 156, 0.5);
}
.bg-ochre-200\\/55{
  background-color: rgba(235, 217, 156, 0.55);
}
.bg-ochre-200\\/60{
  background-color: rgba(235, 217, 156, 0.6);
}
.bg-ochre-200\\/65{
  background-color: rgba(235, 217, 156, 0.65);
}
.bg-ochre-200\\/70{
  background-color: rgba(235, 217, 156, 0.7);
}
.bg-ochre-200\\/75{
  background-color: rgba(235, 217, 156, 0.75);
}
.bg-ochre-200\\/80{
  background-color: rgba(235, 217, 156, 0.8);
}
.bg-ochre-200\\/85{
  background-color: rgba(235, 217, 156, 0.85);
}
.bg-ochre-200\\/90{
  background-color: rgba(235, 217, 156, 0.9);
}
.bg-ochre-200\\/95{
  background-color: rgba(235, 217, 156, 0.95);
}
.bg-ochre-300{
  --tw-bg-opacity: 1;
  background-color: rgba(225, 194, 104, 1);
  background-color: rgba(225, 194, 104, var(--tw-bg-opacity, 1));
}
.bg-ochre-300\\/0{
  background-color: rgba(225, 194, 104, 0);
}
.bg-ochre-300\\/10{
  background-color: rgba(225, 194, 104, 0.1);
}
.bg-ochre-300\\/100{
  background-color: rgb(225, 194, 104);
}
.bg-ochre-300\\/15{
  background-color: rgba(225, 194, 104, 0.15);
}
.bg-ochre-300\\/20{
  background-color: rgba(225, 194, 104, 0.2);
}
.bg-ochre-300\\/25{
  background-color: rgba(225, 194, 104, 0.25);
}
.bg-ochre-300\\/30{
  background-color: rgba(225, 194, 104, 0.3);
}
.bg-ochre-300\\/35{
  background-color: rgba(225, 194, 104, 0.35);
}
.bg-ochre-300\\/40{
  background-color: rgba(225, 194, 104, 0.4);
}
.bg-ochre-300\\/45{
  background-color: rgba(225, 194, 104, 0.45);
}
.bg-ochre-300\\/5{
  background-color: rgba(225, 194, 104, 0.05);
}
.bg-ochre-300\\/50{
  background-color: rgba(225, 194, 104, 0.5);
}
.bg-ochre-300\\/55{
  background-color: rgba(225, 194, 104, 0.55);
}
.bg-ochre-300\\/60{
  background-color: rgba(225, 194, 104, 0.6);
}
.bg-ochre-300\\/65{
  background-color: rgba(225, 194, 104, 0.65);
}
.bg-ochre-300\\/70{
  background-color: rgba(225, 194, 104, 0.7);
}
.bg-ochre-300\\/75{
  background-color: rgba(225, 194, 104, 0.75);
}
.bg-ochre-300\\/80{
  background-color: rgba(225, 194, 104, 0.8);
}
.bg-ochre-300\\/85{
  background-color: rgba(225, 194, 104, 0.85);
}
.bg-ochre-300\\/90{
  background-color: rgba(225, 194, 104, 0.9);
}
.bg-ochre-300\\/95{
  background-color: rgba(225, 194, 104, 0.95);
}
.bg-ochre-400{
  --tw-bg-opacity: 1;
  background-color: rgba(218, 173, 69, 1);
  background-color: rgba(218, 173, 69, var(--tw-bg-opacity, 1));
}
.bg-ochre-400\\/0{
  background-color: rgba(218, 173, 69, 0);
}
.bg-ochre-400\\/10{
  background-color: rgba(218, 173, 69, 0.1);
}
.bg-ochre-400\\/100{
  background-color: rgb(218, 173, 69);
}
.bg-ochre-400\\/15{
  background-color: rgba(218, 173, 69, 0.15);
}
.bg-ochre-400\\/20{
  background-color: rgba(218, 173, 69, 0.2);
}
.bg-ochre-400\\/25{
  background-color: rgba(218, 173, 69, 0.25);
}
.bg-ochre-400\\/30{
  background-color: rgba(218, 173, 69, 0.3);
}
.bg-ochre-400\\/35{
  background-color: rgba(218, 173, 69, 0.35);
}
.bg-ochre-400\\/40{
  background-color: rgba(218, 173, 69, 0.4);
}
.bg-ochre-400\\/45{
  background-color: rgba(218, 173, 69, 0.45);
}
.bg-ochre-400\\/5{
  background-color: rgba(218, 173, 69, 0.05);
}
.bg-ochre-400\\/50{
  background-color: rgba(218, 173, 69, 0.5);
}
.bg-ochre-400\\/55{
  background-color: rgba(218, 173, 69, 0.55);
}
.bg-ochre-400\\/60{
  background-color: rgba(218, 173, 69, 0.6);
}
.bg-ochre-400\\/65{
  background-color: rgba(218, 173, 69, 0.65);
}
.bg-ochre-400\\/70{
  background-color: rgba(218, 173, 69, 0.7);
}
.bg-ochre-400\\/75{
  background-color: rgba(218, 173, 69, 0.75);
}
.bg-ochre-400\\/80{
  background-color: rgba(218, 173, 69, 0.8);
}
.bg-ochre-400\\/85{
  background-color: rgba(218, 173, 69, 0.85);
}
.bg-ochre-400\\/90{
  background-color: rgba(218, 173, 69, 0.9);
}
.bg-ochre-400\\/95{
  background-color: rgba(218, 173, 69, 0.95);
}
.bg-ochre-50{
  --tw-bg-opacity: 1;
  background-color: rgba(252, 249, 238, 1);
  background-color: rgba(252, 249, 238, var(--tw-bg-opacity, 1));
}
.bg-ochre-500{
  --tw-bg-opacity: 1;
  background-color: rgba(209, 145, 47, 1);
  background-color: rgba(209, 145, 47, var(--tw-bg-opacity, 1));
}
.bg-ochre-500\\/0{
  background-color: rgba(209, 145, 47, 0);
}
.bg-ochre-500\\/10{
  background-color: rgba(209, 145, 47, 0.1);
}
.bg-ochre-500\\/100{
  background-color: rgb(209, 145, 47);
}
.bg-ochre-500\\/15{
  background-color: rgba(209, 145, 47, 0.15);
}
.bg-ochre-500\\/20{
  background-color: rgba(209, 145, 47, 0.2);
}
.bg-ochre-500\\/25{
  background-color: rgba(209, 145, 47, 0.25);
}
.bg-ochre-500\\/30{
  background-color: rgba(209, 145, 47, 0.3);
}
.bg-ochre-500\\/35{
  background-color: rgba(209, 145, 47, 0.35);
}
.bg-ochre-500\\/40{
  background-color: rgba(209, 145, 47, 0.4);
}
.bg-ochre-500\\/45{
  background-color: rgba(209, 145, 47, 0.45);
}
.bg-ochre-500\\/5{
  background-color: rgba(209, 145, 47, 0.05);
}
.bg-ochre-500\\/50{
  background-color: rgba(209, 145, 47, 0.5);
}
.bg-ochre-500\\/55{
  background-color: rgba(209, 145, 47, 0.55);
}
.bg-ochre-500\\/60{
  background-color: rgba(209, 145, 47, 0.6);
}
.bg-ochre-500\\/65{
  background-color: rgba(209, 145, 47, 0.65);
}
.bg-ochre-500\\/70{
  background-color: rgba(209, 145, 47, 0.7);
}
.bg-ochre-500\\/75{
  background-color: rgba(209, 145, 47, 0.75);
}
.bg-ochre-500\\/80{
  background-color: rgba(209, 145, 47, 0.8);
}
.bg-ochre-500\\/85{
  background-color: rgba(209, 145, 47, 0.85);
}
.bg-ochre-500\\/90{
  background-color: rgba(209, 145, 47, 0.9);
}
.bg-ochre-500\\/95{
  background-color: rgba(209, 145, 47, 0.95);
}
.bg-ochre-600{
  --tw-bg-opacity: 1;
  background-color: rgba(195, 120, 41, 1);
  background-color: rgba(195, 120, 41, var(--tw-bg-opacity, 1));
}
.bg-ochre-600\\/0{
  background-color: rgba(195, 120, 41, 0);
}
.bg-ochre-600\\/10{
  background-color: rgba(195, 120, 41, 0.1);
}
.bg-ochre-600\\/100{
  background-color: rgb(195, 120, 41);
}
.bg-ochre-600\\/15{
  background-color: rgba(195, 120, 41, 0.15);
}
.bg-ochre-600\\/20{
  background-color: rgba(195, 120, 41, 0.2);
}
.bg-ochre-600\\/25{
  background-color: rgba(195, 120, 41, 0.25);
}
.bg-ochre-600\\/30{
  background-color: rgba(195, 120, 41, 0.3);
}
.bg-ochre-600\\/35{
  background-color: rgba(195, 120, 41, 0.35);
}
.bg-ochre-600\\/40{
  background-color: rgba(195, 120, 41, 0.4);
}
.bg-ochre-600\\/45{
  background-color: rgba(195, 120, 41, 0.45);
}
.bg-ochre-600\\/5{
  background-color: rgba(195, 120, 41, 0.05);
}
.bg-ochre-600\\/50{
  background-color: rgba(195, 120, 41, 0.5);
}
.bg-ochre-600\\/55{
  background-color: rgba(195, 120, 41, 0.55);
}
.bg-ochre-600\\/60{
  background-color: rgba(195, 120, 41, 0.6);
}
.bg-ochre-600\\/65{
  background-color: rgba(195, 120, 41, 0.65);
}
.bg-ochre-600\\/70{
  background-color: rgba(195, 120, 41, 0.7);
}
.bg-ochre-600\\/75{
  background-color: rgba(195, 120, 41, 0.75);
}
.bg-ochre-600\\/80{
  background-color: rgba(195, 120, 41, 0.8);
}
.bg-ochre-600\\/85{
  background-color: rgba(195, 120, 41, 0.85);
}
.bg-ochre-600\\/90{
  background-color: rgba(195, 120, 41, 0.9);
}
.bg-ochre-600\\/95{
  background-color: rgba(195, 120, 41, 0.95);
}
.bg-ochre-700{
  --tw-bg-opacity: 1;
  background-color: rgba(153, 84, 36, 1);
  background-color: rgba(153, 84, 36, var(--tw-bg-opacity, 1));
}
.bg-ochre-700\\/0{
  background-color: rgba(153, 84, 36, 0);
}
.bg-ochre-700\\/10{
  background-color: rgba(153, 84, 36, 0.1);
}
.bg-ochre-700\\/100{
  background-color: rgb(153, 84, 36);
}
.bg-ochre-700\\/15{
  background-color: rgba(153, 84, 36, 0.15);
}
.bg-ochre-700\\/20{
  background-color: rgba(153, 84, 36, 0.2);
}
.bg-ochre-700\\/25{
  background-color: rgba(153, 84, 36, 0.25);
}
.bg-ochre-700\\/30{
  background-color: rgba(153, 84, 36, 0.3);
}
.bg-ochre-700\\/35{
  background-color: rgba(153, 84, 36, 0.35);
}
.bg-ochre-700\\/40{
  background-color: rgba(153, 84, 36, 0.4);
}
.bg-ochre-700\\/45{
  background-color: rgba(153, 84, 36, 0.45);
}
.bg-ochre-700\\/5{
  background-color: rgba(153, 84, 36, 0.05);
}
.bg-ochre-700\\/50{
  background-color: rgba(153, 84, 36, 0.5);
}
.bg-ochre-700\\/55{
  background-color: rgba(153, 84, 36, 0.55);
}
.bg-ochre-700\\/60{
  background-color: rgba(153, 84, 36, 0.6);
}
.bg-ochre-700\\/65{
  background-color: rgba(153, 84, 36, 0.65);
}
.bg-ochre-700\\/70{
  background-color: rgba(153, 84, 36, 0.7);
}
.bg-ochre-700\\/75{
  background-color: rgba(153, 84, 36, 0.75);
}
.bg-ochre-700\\/80{
  background-color: rgba(153, 84, 36, 0.8);
}
.bg-ochre-700\\/85{
  background-color: rgba(153, 84, 36, 0.85);
}
.bg-ochre-700\\/90{
  background-color: rgba(153, 84, 36, 0.9);
}
.bg-ochre-700\\/95{
  background-color: rgba(153, 84, 36, 0.95);
}
.bg-ochre-800{
  --tw-bg-opacity: 1;
  background-color: rgba(126, 67, 34, 1);
  background-color: rgba(126, 67, 34, var(--tw-bg-opacity, 1));
}
.bg-ochre-800\\/0{
  background-color: rgba(126, 67, 34, 0);
}
.bg-ochre-800\\/10{
  background-color: rgba(126, 67, 34, 0.1);
}
.bg-ochre-800\\/100{
  background-color: rgb(126, 67, 34);
}
.bg-ochre-800\\/15{
  background-color: rgba(126, 67, 34, 0.15);
}
.bg-ochre-800\\/20{
  background-color: rgba(126, 67, 34, 0.2);
}
.bg-ochre-800\\/25{
  background-color: rgba(126, 67, 34, 0.25);
}
.bg-ochre-800\\/30{
  background-color: rgba(126, 67, 34, 0.3);
}
.bg-ochre-800\\/35{
  background-color: rgba(126, 67, 34, 0.35);
}
.bg-ochre-800\\/40{
  background-color: rgba(126, 67, 34, 0.4);
}
.bg-ochre-800\\/45{
  background-color: rgba(126, 67, 34, 0.45);
}
.bg-ochre-800\\/5{
  background-color: rgba(126, 67, 34, 0.05);
}
.bg-ochre-800\\/50{
  background-color: rgba(126, 67, 34, 0.5);
}
.bg-ochre-800\\/55{
  background-color: rgba(126, 67, 34, 0.55);
}
.bg-ochre-800\\/60{
  background-color: rgba(126, 67, 34, 0.6);
}
.bg-ochre-800\\/65{
  background-color: rgba(126, 67, 34, 0.65);
}
.bg-ochre-800\\/70{
  background-color: rgba(126, 67, 34, 0.7);
}
.bg-ochre-800\\/75{
  background-color: rgba(126, 67, 34, 0.75);
}
.bg-ochre-800\\/80{
  background-color: rgba(126, 67, 34, 0.8);
}
.bg-ochre-800\\/85{
  background-color: rgba(126, 67, 34, 0.85);
}
.bg-ochre-800\\/90{
  background-color: rgba(126, 67, 34, 0.9);
}
.bg-ochre-800\\/95{
  background-color: rgba(126, 67, 34, 0.95);
}
.bg-ochre-900{
  --tw-bg-opacity: 1;
  background-color: rgba(104, 56, 31, 1);
  background-color: rgba(104, 56, 31, var(--tw-bg-opacity, 1));
}
.bg-ochre-900\\/0{
  background-color: rgba(104, 56, 31, 0);
}
.bg-ochre-900\\/10{
  background-color: rgba(104, 56, 31, 0.1);
}
.bg-ochre-900\\/100{
  background-color: rgb(104, 56, 31);
}
.bg-ochre-900\\/15{
  background-color: rgba(104, 56, 31, 0.15);
}
.bg-ochre-900\\/20{
  background-color: rgba(104, 56, 31, 0.2);
}
.bg-ochre-900\\/25{
  background-color: rgba(104, 56, 31, 0.25);
}
.bg-ochre-900\\/30{
  background-color: rgba(104, 56, 31, 0.3);
}
.bg-ochre-900\\/35{
  background-color: rgba(104, 56, 31, 0.35);
}
.bg-ochre-900\\/40{
  background-color: rgba(104, 56, 31, 0.4);
}
.bg-ochre-900\\/45{
  background-color: rgba(104, 56, 31, 0.45);
}
.bg-ochre-900\\/5{
  background-color: rgba(104, 56, 31, 0.05);
}
.bg-ochre-900\\/50{
  background-color: rgba(104, 56, 31, 0.5);
}
.bg-ochre-900\\/55{
  background-color: rgba(104, 56, 31, 0.55);
}
.bg-ochre-900\\/60{
  background-color: rgba(104, 56, 31, 0.6);
}
.bg-ochre-900\\/65{
  background-color: rgba(104, 56, 31, 0.65);
}
.bg-ochre-900\\/70{
  background-color: rgba(104, 56, 31, 0.7);
}
.bg-ochre-900\\/75{
  background-color: rgba(104, 56, 31, 0.75);
}
.bg-ochre-900\\/80{
  background-color: rgba(104, 56, 31, 0.8);
}
.bg-ochre-900\\/85{
  background-color: rgba(104, 56, 31, 0.85);
}
.bg-ochre-900\\/90{
  background-color: rgba(104, 56, 31, 0.9);
}
.bg-ochre-900\\/95{
  background-color: rgba(104, 56, 31, 0.95);
}
.bg-ochre-950{
  --tw-bg-opacity: 1;
  background-color: rgba(59, 28, 13, 1);
  background-color: rgba(59, 28, 13, var(--tw-bg-opacity, 1));
}
.bg-ochre-950\\/0{
  background-color: rgba(59, 28, 13, 0);
}
.bg-ochre-950\\/10{
  background-color: rgba(59, 28, 13, 0.1);
}
.bg-ochre-950\\/100{
  background-color: rgb(59, 28, 13);
}
.bg-ochre-950\\/15{
  background-color: rgba(59, 28, 13, 0.15);
}
.bg-ochre-950\\/20{
  background-color: rgba(59, 28, 13, 0.2);
}
.bg-ochre-950\\/25{
  background-color: rgba(59, 28, 13, 0.25);
}
.bg-ochre-950\\/30{
  background-color: rgba(59, 28, 13, 0.3);
}
.bg-ochre-950\\/35{
  background-color: rgba(59, 28, 13, 0.35);
}
.bg-ochre-950\\/40{
  background-color: rgba(59, 28, 13, 0.4);
}
.bg-ochre-950\\/45{
  background-color: rgba(59, 28, 13, 0.45);
}
.bg-ochre-950\\/5{
  background-color: rgba(59, 28, 13, 0.05);
}
.bg-ochre-950\\/50{
  background-color: rgba(59, 28, 13, 0.5);
}
.bg-ochre-950\\/55{
  background-color: rgba(59, 28, 13, 0.55);
}
.bg-ochre-950\\/60{
  background-color: rgba(59, 28, 13, 0.6);
}
.bg-ochre-950\\/65{
  background-color: rgba(59, 28, 13, 0.65);
}
.bg-ochre-950\\/70{
  background-color: rgba(59, 28, 13, 0.7);
}
.bg-ochre-950\\/75{
  background-color: rgba(59, 28, 13, 0.75);
}
.bg-ochre-950\\/80{
  background-color: rgba(59, 28, 13, 0.8);
}
.bg-ochre-950\\/85{
  background-color: rgba(59, 28, 13, 0.85);
}
.bg-ochre-950\\/90{
  background-color: rgba(59, 28, 13, 0.9);
}
.bg-ochre-950\\/95{
  background-color: rgba(59, 28, 13, 0.95);
}
.bg-phrase-color-100{
  --tw-bg-opacity: 1;
  background-color: rgba(245, 237, 208, 1);
  background-color: rgba(245, 237, 208, var(--tw-bg-opacity, 1));
}
.bg-phrase-color-100\\/0{
  background-color: rgba(245, 237, 208, 0);
}
.bg-phrase-color-100\\/10{
  background-color: rgba(245, 237, 208, 0.1);
}
.bg-phrase-color-100\\/100{
  background-color: rgb(245, 237, 208);
}
.bg-phrase-color-100\\/15{
  background-color: rgba(245, 237, 208, 0.15);
}
.bg-phrase-color-100\\/20{
  background-color: rgba(245, 237, 208, 0.2);
}
.bg-phrase-color-100\\/25{
  background-color: rgba(245, 237, 208, 0.25);
}
.bg-phrase-color-100\\/30{
  background-color: rgba(245, 237, 208, 0.3);
}
.bg-phrase-color-100\\/35{
  background-color: rgba(245, 237, 208, 0.35);
}
.bg-phrase-color-100\\/40{
  background-color: rgba(245, 237, 208, 0.4);
}
.bg-phrase-color-100\\/45{
  background-color: rgba(245, 237, 208, 0.45);
}
.bg-phrase-color-100\\/5{
  background-color: rgba(245, 237, 208, 0.05);
}
.bg-phrase-color-100\\/50{
  background-color: rgba(245, 237, 208, 0.5);
}
.bg-phrase-color-100\\/55{
  background-color: rgba(245, 237, 208, 0.55);
}
.bg-phrase-color-100\\/60{
  background-color: rgba(245, 237, 208, 0.6);
}
.bg-phrase-color-100\\/65{
  background-color: rgba(245, 237, 208, 0.65);
}
.bg-phrase-color-100\\/70{
  background-color: rgba(245, 237, 208, 0.7);
}
.bg-phrase-color-100\\/75{
  background-color: rgba(245, 237, 208, 0.75);
}
.bg-phrase-color-100\\/80{
  background-color: rgba(245, 237, 208, 0.8);
}
.bg-phrase-color-100\\/85{
  background-color: rgba(245, 237, 208, 0.85);
}
.bg-phrase-color-100\\/90{
  background-color: rgba(245, 237, 208, 0.9);
}
.bg-phrase-color-100\\/95{
  background-color: rgba(245, 237, 208, 0.95);
}
.bg-phrase-color-200{
  --tw-bg-opacity: 1;
  background-color: rgba(235, 217, 156, 1);
  background-color: rgba(235, 217, 156, var(--tw-bg-opacity, 1));
}
.bg-phrase-color-200\\/0{
  background-color: rgba(235, 217, 156, 0);
}
.bg-phrase-color-200\\/10{
  background-color: rgba(235, 217, 156, 0.1);
}
.bg-phrase-color-200\\/100{
  background-color: rgb(235, 217, 156);
}
.bg-phrase-color-200\\/15{
  background-color: rgba(235, 217, 156, 0.15);
}
.bg-phrase-color-200\\/20{
  background-color: rgba(235, 217, 156, 0.2);
}
.bg-phrase-color-200\\/25{
  background-color: rgba(235, 217, 156, 0.25);
}
.bg-phrase-color-200\\/30{
  background-color: rgba(235, 217, 156, 0.3);
}
.bg-phrase-color-200\\/35{
  background-color: rgba(235, 217, 156, 0.35);
}
.bg-phrase-color-200\\/40{
  background-color: rgba(235, 217, 156, 0.4);
}
.bg-phrase-color-200\\/45{
  background-color: rgba(235, 217, 156, 0.45);
}
.bg-phrase-color-200\\/5{
  background-color: rgba(235, 217, 156, 0.05);
}
.bg-phrase-color-200\\/50{
  background-color: rgba(235, 217, 156, 0.5);
}
.bg-phrase-color-200\\/55{
  background-color: rgba(235, 217, 156, 0.55);
}
.bg-phrase-color-200\\/60{
  background-color: rgba(235, 217, 156, 0.6);
}
.bg-phrase-color-200\\/65{
  background-color: rgba(235, 217, 156, 0.65);
}
.bg-phrase-color-200\\/70{
  background-color: rgba(235, 217, 156, 0.7);
}
.bg-phrase-color-200\\/75{
  background-color: rgba(235, 217, 156, 0.75);
}
.bg-phrase-color-200\\/80{
  background-color: rgba(235, 217, 156, 0.8);
}
.bg-phrase-color-200\\/85{
  background-color: rgba(235, 217, 156, 0.85);
}
.bg-phrase-color-200\\/90{
  background-color: rgba(235, 217, 156, 0.9);
}
.bg-phrase-color-200\\/95{
  background-color: rgba(235, 217, 156, 0.95);
}
.bg-phrase-color-300{
  --tw-bg-opacity: 1;
  background-color: rgba(225, 194, 104, 1);
  background-color: rgba(225, 194, 104, var(--tw-bg-opacity, 1));
}
.bg-phrase-color-300\\/0{
  background-color: rgba(225, 194, 104, 0);
}
.bg-phrase-color-300\\/10{
  background-color: rgba(225, 194, 104, 0.1);
}
.bg-phrase-color-300\\/100{
  background-color: rgb(225, 194, 104);
}
.bg-phrase-color-300\\/15{
  background-color: rgba(225, 194, 104, 0.15);
}
.bg-phrase-color-300\\/20{
  background-color: rgba(225, 194, 104, 0.2);
}
.bg-phrase-color-300\\/25{
  background-color: rgba(225, 194, 104, 0.25);
}
.bg-phrase-color-300\\/30{
  background-color: rgba(225, 194, 104, 0.3);
}
.bg-phrase-color-300\\/35{
  background-color: rgba(225, 194, 104, 0.35);
}
.bg-phrase-color-300\\/40{
  background-color: rgba(225, 194, 104, 0.4);
}
.bg-phrase-color-300\\/45{
  background-color: rgba(225, 194, 104, 0.45);
}
.bg-phrase-color-300\\/5{
  background-color: rgba(225, 194, 104, 0.05);
}
.bg-phrase-color-300\\/50{
  background-color: rgba(225, 194, 104, 0.5);
}
.bg-phrase-color-300\\/55{
  background-color: rgba(225, 194, 104, 0.55);
}
.bg-phrase-color-300\\/60{
  background-color: rgba(225, 194, 104, 0.6);
}
.bg-phrase-color-300\\/65{
  background-color: rgba(225, 194, 104, 0.65);
}
.bg-phrase-color-300\\/70{
  background-color: rgba(225, 194, 104, 0.7);
}
.bg-phrase-color-300\\/75{
  background-color: rgba(225, 194, 104, 0.75);
}
.bg-phrase-color-300\\/80{
  background-color: rgba(225, 194, 104, 0.8);
}
.bg-phrase-color-300\\/85{
  background-color: rgba(225, 194, 104, 0.85);
}
.bg-phrase-color-300\\/90{
  background-color: rgba(225, 194, 104, 0.9);
}
.bg-phrase-color-300\\/95{
  background-color: rgba(225, 194, 104, 0.95);
}
.bg-phrase-color-400{
  --tw-bg-opacity: 1;
  background-color: rgba(218, 173, 69, 1);
  background-color: rgba(218, 173, 69, var(--tw-bg-opacity, 1));
}
.bg-phrase-color-400\\/0{
  background-color: rgba(218, 173, 69, 0);
}
.bg-phrase-color-400\\/10{
  background-color: rgba(218, 173, 69, 0.1);
}
.bg-phrase-color-400\\/100{
  background-color: rgb(218, 173, 69);
}
.bg-phrase-color-400\\/15{
  background-color: rgba(218, 173, 69, 0.15);
}
.bg-phrase-color-400\\/20{
  background-color: rgba(218, 173, 69, 0.2);
}
.bg-phrase-color-400\\/25{
  background-color: rgba(218, 173, 69, 0.25);
}
.bg-phrase-color-400\\/30{
  background-color: rgba(218, 173, 69, 0.3);
}
.bg-phrase-color-400\\/35{
  background-color: rgba(218, 173, 69, 0.35);
}
.bg-phrase-color-400\\/40{
  background-color: rgba(218, 173, 69, 0.4);
}
.bg-phrase-color-400\\/45{
  background-color: rgba(218, 173, 69, 0.45);
}
.bg-phrase-color-400\\/5{
  background-color: rgba(218, 173, 69, 0.05);
}
.bg-phrase-color-400\\/50{
  background-color: rgba(218, 173, 69, 0.5);
}
.bg-phrase-color-400\\/55{
  background-color: rgba(218, 173, 69, 0.55);
}
.bg-phrase-color-400\\/60{
  background-color: rgba(218, 173, 69, 0.6);
}
.bg-phrase-color-400\\/65{
  background-color: rgba(218, 173, 69, 0.65);
}
.bg-phrase-color-400\\/70{
  background-color: rgba(218, 173, 69, 0.7);
}
.bg-phrase-color-400\\/75{
  background-color: rgba(218, 173, 69, 0.75);
}
.bg-phrase-color-400\\/80{
  background-color: rgba(218, 173, 69, 0.8);
}
.bg-phrase-color-400\\/85{
  background-color: rgba(218, 173, 69, 0.85);
}
.bg-phrase-color-400\\/90{
  background-color: rgba(218, 173, 69, 0.9);
}
.bg-phrase-color-400\\/95{
  background-color: rgba(218, 173, 69, 0.95);
}
.bg-phrase-color-500{
  --tw-bg-opacity: 1;
  background-color: rgba(209, 145, 47, 1);
  background-color: rgba(209, 145, 47, var(--tw-bg-opacity, 1));
}
.bg-phrase-color-500\\/0{
  background-color: rgba(209, 145, 47, 0);
}
.bg-phrase-color-500\\/10{
  background-color: rgba(209, 145, 47, 0.1);
}
.bg-phrase-color-500\\/100{
  background-color: rgb(209, 145, 47);
}
.bg-phrase-color-500\\/15{
  background-color: rgba(209, 145, 47, 0.15);
}
.bg-phrase-color-500\\/20{
  background-color: rgba(209, 145, 47, 0.2);
}
.bg-phrase-color-500\\/25{
  background-color: rgba(209, 145, 47, 0.25);
}
.bg-phrase-color-500\\/30{
  background-color: rgba(209, 145, 47, 0.3);
}
.bg-phrase-color-500\\/35{
  background-color: rgba(209, 145, 47, 0.35);
}
.bg-phrase-color-500\\/40{
  background-color: rgba(209, 145, 47, 0.4);
}
.bg-phrase-color-500\\/45{
  background-color: rgba(209, 145, 47, 0.45);
}
.bg-phrase-color-500\\/5{
  background-color: rgba(209, 145, 47, 0.05);
}
.bg-phrase-color-500\\/50{
  background-color: rgba(209, 145, 47, 0.5);
}
.bg-phrase-color-500\\/55{
  background-color: rgba(209, 145, 47, 0.55);
}
.bg-phrase-color-500\\/60{
  background-color: rgba(209, 145, 47, 0.6);
}
.bg-phrase-color-500\\/65{
  background-color: rgba(209, 145, 47, 0.65);
}
.bg-phrase-color-500\\/70{
  background-color: rgba(209, 145, 47, 0.7);
}
.bg-phrase-color-500\\/75{
  background-color: rgba(209, 145, 47, 0.75);
}
.bg-phrase-color-500\\/80{
  background-color: rgba(209, 145, 47, 0.8);
}
.bg-phrase-color-500\\/85{
  background-color: rgba(209, 145, 47, 0.85);
}
.bg-phrase-color-500\\/90{
  background-color: rgba(209, 145, 47, 0.9);
}
.bg-phrase-color-500\\/95{
  background-color: rgba(209, 145, 47, 0.95);
}
.bg-phrase-color-600{
  --tw-bg-opacity: 1;
  background-color: rgba(195, 120, 41, 1);
  background-color: rgba(195, 120, 41, var(--tw-bg-opacity, 1));
}
.bg-phrase-color-600\\/0{
  background-color: rgba(195, 120, 41, 0);
}
.bg-phrase-color-600\\/10{
  background-color: rgba(195, 120, 41, 0.1);
}
.bg-phrase-color-600\\/100{
  background-color: rgb(195, 120, 41);
}
.bg-phrase-color-600\\/15{
  background-color: rgba(195, 120, 41, 0.15);
}
.bg-phrase-color-600\\/20{
  background-color: rgba(195, 120, 41, 0.2);
}
.bg-phrase-color-600\\/25{
  background-color: rgba(195, 120, 41, 0.25);
}
.bg-phrase-color-600\\/30{
  background-color: rgba(195, 120, 41, 0.3);
}
.bg-phrase-color-600\\/35{
  background-color: rgba(195, 120, 41, 0.35);
}
.bg-phrase-color-600\\/40{
  background-color: rgba(195, 120, 41, 0.4);
}
.bg-phrase-color-600\\/45{
  background-color: rgba(195, 120, 41, 0.45);
}
.bg-phrase-color-600\\/5{
  background-color: rgba(195, 120, 41, 0.05);
}
.bg-phrase-color-600\\/50{
  background-color: rgba(195, 120, 41, 0.5);
}
.bg-phrase-color-600\\/55{
  background-color: rgba(195, 120, 41, 0.55);
}
.bg-phrase-color-600\\/60{
  background-color: rgba(195, 120, 41, 0.6);
}
.bg-phrase-color-600\\/65{
  background-color: rgba(195, 120, 41, 0.65);
}
.bg-phrase-color-600\\/70{
  background-color: rgba(195, 120, 41, 0.7);
}
.bg-phrase-color-600\\/75{
  background-color: rgba(195, 120, 41, 0.75);
}
.bg-phrase-color-600\\/80{
  background-color: rgba(195, 120, 41, 0.8);
}
.bg-phrase-color-600\\/85{
  background-color: rgba(195, 120, 41, 0.85);
}
.bg-phrase-color-600\\/90{
  background-color: rgba(195, 120, 41, 0.9);
}
.bg-phrase-color-600\\/95{
  background-color: rgba(195, 120, 41, 0.95);
}
.bg-phrase-color-700{
  --tw-bg-opacity: 1;
  background-color: rgba(153, 84, 36, 1);
  background-color: rgba(153, 84, 36, var(--tw-bg-opacity, 1));
}
.bg-phrase-color-700\\/0{
  background-color: rgba(153, 84, 36, 0);
}
.bg-phrase-color-700\\/10{
  background-color: rgba(153, 84, 36, 0.1);
}
.bg-phrase-color-700\\/100{
  background-color: rgb(153, 84, 36);
}
.bg-phrase-color-700\\/15{
  background-color: rgba(153, 84, 36, 0.15);
}
.bg-phrase-color-700\\/20{
  background-color: rgba(153, 84, 36, 0.2);
}
.bg-phrase-color-700\\/25{
  background-color: rgba(153, 84, 36, 0.25);
}
.bg-phrase-color-700\\/30{
  background-color: rgba(153, 84, 36, 0.3);
}
.bg-phrase-color-700\\/35{
  background-color: rgba(153, 84, 36, 0.35);
}
.bg-phrase-color-700\\/40{
  background-color: rgba(153, 84, 36, 0.4);
}
.bg-phrase-color-700\\/45{
  background-color: rgba(153, 84, 36, 0.45);
}
.bg-phrase-color-700\\/5{
  background-color: rgba(153, 84, 36, 0.05);
}
.bg-phrase-color-700\\/50{
  background-color: rgba(153, 84, 36, 0.5);
}
.bg-phrase-color-700\\/55{
  background-color: rgba(153, 84, 36, 0.55);
}
.bg-phrase-color-700\\/60{
  background-color: rgba(153, 84, 36, 0.6);
}
.bg-phrase-color-700\\/65{
  background-color: rgba(153, 84, 36, 0.65);
}
.bg-phrase-color-700\\/70{
  background-color: rgba(153, 84, 36, 0.7);
}
.bg-phrase-color-700\\/75{
  background-color: rgba(153, 84, 36, 0.75);
}
.bg-phrase-color-700\\/80{
  background-color: rgba(153, 84, 36, 0.8);
}
.bg-phrase-color-700\\/85{
  background-color: rgba(153, 84, 36, 0.85);
}
.bg-phrase-color-700\\/90{
  background-color: rgba(153, 84, 36, 0.9);
}
.bg-phrase-color-700\\/95{
  background-color: rgba(153, 84, 36, 0.95);
}
.bg-phrase-color-800{
  --tw-bg-opacity: 1;
  background-color: rgba(126, 67, 34, 1);
  background-color: rgba(126, 67, 34, var(--tw-bg-opacity, 1));
}
.bg-phrase-color-800\\/0{
  background-color: rgba(126, 67, 34, 0);
}
.bg-phrase-color-800\\/10{
  background-color: rgba(126, 67, 34, 0.1);
}
.bg-phrase-color-800\\/100{
  background-color: rgb(126, 67, 34);
}
.bg-phrase-color-800\\/15{
  background-color: rgba(126, 67, 34, 0.15);
}
.bg-phrase-color-800\\/20{
  background-color: rgba(126, 67, 34, 0.2);
}
.bg-phrase-color-800\\/25{
  background-color: rgba(126, 67, 34, 0.25);
}
.bg-phrase-color-800\\/30{
  background-color: rgba(126, 67, 34, 0.3);
}
.bg-phrase-color-800\\/35{
  background-color: rgba(126, 67, 34, 0.35);
}
.bg-phrase-color-800\\/40{
  background-color: rgba(126, 67, 34, 0.4);
}
.bg-phrase-color-800\\/45{
  background-color: rgba(126, 67, 34, 0.45);
}
.bg-phrase-color-800\\/5{
  background-color: rgba(126, 67, 34, 0.05);
}
.bg-phrase-color-800\\/50{
  background-color: rgba(126, 67, 34, 0.5);
}
.bg-phrase-color-800\\/55{
  background-color: rgba(126, 67, 34, 0.55);
}
.bg-phrase-color-800\\/60{
  background-color: rgba(126, 67, 34, 0.6);
}
.bg-phrase-color-800\\/65{
  background-color: rgba(126, 67, 34, 0.65);
}
.bg-phrase-color-800\\/70{
  background-color: rgba(126, 67, 34, 0.7);
}
.bg-phrase-color-800\\/75{
  background-color: rgba(126, 67, 34, 0.75);
}
.bg-phrase-color-800\\/80{
  background-color: rgba(126, 67, 34, 0.8);
}
.bg-phrase-color-800\\/85{
  background-color: rgba(126, 67, 34, 0.85);
}
.bg-phrase-color-800\\/90{
  background-color: rgba(126, 67, 34, 0.9);
}
.bg-phrase-color-800\\/95{
  background-color: rgba(126, 67, 34, 0.95);
}
.bg-phrase-color-900{
  --tw-bg-opacity: 1;
  background-color: rgba(104, 56, 31, 1);
  background-color: rgba(104, 56, 31, var(--tw-bg-opacity, 1));
}
.bg-phrase-color-900\\/0{
  background-color: rgba(104, 56, 31, 0);
}
.bg-phrase-color-900\\/10{
  background-color: rgba(104, 56, 31, 0.1);
}
.bg-phrase-color-900\\/100{
  background-color: rgb(104, 56, 31);
}
.bg-phrase-color-900\\/15{
  background-color: rgba(104, 56, 31, 0.15);
}
.bg-phrase-color-900\\/20{
  background-color: rgba(104, 56, 31, 0.2);
}
.bg-phrase-color-900\\/25{
  background-color: rgba(104, 56, 31, 0.25);
}
.bg-phrase-color-900\\/30{
  background-color: rgba(104, 56, 31, 0.3);
}
.bg-phrase-color-900\\/35{
  background-color: rgba(104, 56, 31, 0.35);
}
.bg-phrase-color-900\\/40{
  background-color: rgba(104, 56, 31, 0.4);
}
.bg-phrase-color-900\\/45{
  background-color: rgba(104, 56, 31, 0.45);
}
.bg-phrase-color-900\\/5{
  background-color: rgba(104, 56, 31, 0.05);
}
.bg-phrase-color-900\\/50{
  background-color: rgba(104, 56, 31, 0.5);
}
.bg-phrase-color-900\\/55{
  background-color: rgba(104, 56, 31, 0.55);
}
.bg-phrase-color-900\\/60{
  background-color: rgba(104, 56, 31, 0.6);
}
.bg-phrase-color-900\\/65{
  background-color: rgba(104, 56, 31, 0.65);
}
.bg-phrase-color-900\\/70{
  background-color: rgba(104, 56, 31, 0.7);
}
.bg-phrase-color-900\\/75{
  background-color: rgba(104, 56, 31, 0.75);
}
.bg-phrase-color-900\\/80{
  background-color: rgba(104, 56, 31, 0.8);
}
.bg-phrase-color-900\\/85{
  background-color: rgba(104, 56, 31, 0.85);
}
.bg-phrase-color-900\\/90{
  background-color: rgba(104, 56, 31, 0.9);
}
.bg-phrase-color-900\\/95{
  background-color: rgba(104, 56, 31, 0.95);
}
.bg-phrase-color-950{
  --tw-bg-opacity: 1;
  background-color: rgba(59, 28, 13, 1);
  background-color: rgba(59, 28, 13, var(--tw-bg-opacity, 1));
}
.bg-phrase-color-950\\/0{
  background-color: rgba(59, 28, 13, 0);
}
.bg-phrase-color-950\\/10{
  background-color: rgba(59, 28, 13, 0.1);
}
.bg-phrase-color-950\\/100{
  background-color: rgb(59, 28, 13);
}
.bg-phrase-color-950\\/15{
  background-color: rgba(59, 28, 13, 0.15);
}
.bg-phrase-color-950\\/20{
  background-color: rgba(59, 28, 13, 0.2);
}
.bg-phrase-color-950\\/25{
  background-color: rgba(59, 28, 13, 0.25);
}
.bg-phrase-color-950\\/30{
  background-color: rgba(59, 28, 13, 0.3);
}
.bg-phrase-color-950\\/35{
  background-color: rgba(59, 28, 13, 0.35);
}
.bg-phrase-color-950\\/40{
  background-color: rgba(59, 28, 13, 0.4);
}
.bg-phrase-color-950\\/45{
  background-color: rgba(59, 28, 13, 0.45);
}
.bg-phrase-color-950\\/5{
  background-color: rgba(59, 28, 13, 0.05);
}
.bg-phrase-color-950\\/50{
  background-color: rgba(59, 28, 13, 0.5);
}
.bg-phrase-color-950\\/55{
  background-color: rgba(59, 28, 13, 0.55);
}
.bg-phrase-color-950\\/60{
  background-color: rgba(59, 28, 13, 0.6);
}
.bg-phrase-color-950\\/65{
  background-color: rgba(59, 28, 13, 0.65);
}
.bg-phrase-color-950\\/70{
  background-color: rgba(59, 28, 13, 0.7);
}
.bg-phrase-color-950\\/75{
  background-color: rgba(59, 28, 13, 0.75);
}
.bg-phrase-color-950\\/80{
  background-color: rgba(59, 28, 13, 0.8);
}
.bg-phrase-color-950\\/85{
  background-color: rgba(59, 28, 13, 0.85);
}
.bg-phrase-color-950\\/90{
  background-color: rgba(59, 28, 13, 0.9);
}
.bg-phrase-color-950\\/95{
  background-color: rgba(59, 28, 13, 0.95);
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgba(254, 226, 226, 1);
  background-color: rgba(254, 226, 226, var(--tw-bg-opacity, 1));
}
.bg-scarlet-100{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 220, 223, 1);
  background-color: rgba(255, 220, 223, var(--tw-bg-opacity, 1));
}
.bg-scarlet-100\\/0{
  background-color: rgba(255, 220, 223, 0);
}
.bg-scarlet-100\\/10{
  background-color: rgba(255, 220, 223, 0.1);
}
.bg-scarlet-100\\/100{
  background-color: rgb(255, 220, 223);
}
.bg-scarlet-100\\/15{
  background-color: rgba(255, 220, 223, 0.15);
}
.bg-scarlet-100\\/20{
  background-color: rgba(255, 220, 223, 0.2);
}
.bg-scarlet-100\\/25{
  background-color: rgba(255, 220, 223, 0.25);
}
.bg-scarlet-100\\/30{
  background-color: rgba(255, 220, 223, 0.3);
}
.bg-scarlet-100\\/35{
  background-color: rgba(255, 220, 223, 0.35);
}
.bg-scarlet-100\\/40{
  background-color: rgba(255, 220, 223, 0.4);
}
.bg-scarlet-100\\/45{
  background-color: rgba(255, 220, 223, 0.45);
}
.bg-scarlet-100\\/5{
  background-color: rgba(255, 220, 223, 0.05);
}
.bg-scarlet-100\\/50{
  background-color: rgba(255, 220, 223, 0.5);
}
.bg-scarlet-100\\/55{
  background-color: rgba(255, 220, 223, 0.55);
}
.bg-scarlet-100\\/60{
  background-color: rgba(255, 220, 223, 0.6);
}
.bg-scarlet-100\\/65{
  background-color: rgba(255, 220, 223, 0.65);
}
.bg-scarlet-100\\/70{
  background-color: rgba(255, 220, 223, 0.7);
}
.bg-scarlet-100\\/75{
  background-color: rgba(255, 220, 223, 0.75);
}
.bg-scarlet-100\\/80{
  background-color: rgba(255, 220, 223, 0.8);
}
.bg-scarlet-100\\/85{
  background-color: rgba(255, 220, 223, 0.85);
}
.bg-scarlet-100\\/90{
  background-color: rgba(255, 220, 223, 0.9);
}
.bg-scarlet-100\\/95{
  background-color: rgba(255, 220, 223, 0.95);
}
.bg-scarlet-200{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 192, 198, 1);
  background-color: rgba(255, 192, 198, var(--tw-bg-opacity, 1));
}
.bg-scarlet-200\\/0{
  background-color: rgba(255, 192, 198, 0);
}
.bg-scarlet-200\\/10{
  background-color: rgba(255, 192, 198, 0.1);
}
.bg-scarlet-200\\/100{
  background-color: rgb(255, 192, 198);
}
.bg-scarlet-200\\/15{
  background-color: rgba(255, 192, 198, 0.15);
}
.bg-scarlet-200\\/20{
  background-color: rgba(255, 192, 198, 0.2);
}
.bg-scarlet-200\\/25{
  background-color: rgba(255, 192, 198, 0.25);
}
.bg-scarlet-200\\/30{
  background-color: rgba(255, 192, 198, 0.3);
}
.bg-scarlet-200\\/35{
  background-color: rgba(255, 192, 198, 0.35);
}
.bg-scarlet-200\\/40{
  background-color: rgba(255, 192, 198, 0.4);
}
.bg-scarlet-200\\/45{
  background-color: rgba(255, 192, 198, 0.45);
}
.bg-scarlet-200\\/5{
  background-color: rgba(255, 192, 198, 0.05);
}
.bg-scarlet-200\\/50{
  background-color: rgba(255, 192, 198, 0.5);
}
.bg-scarlet-200\\/55{
  background-color: rgba(255, 192, 198, 0.55);
}
.bg-scarlet-200\\/60{
  background-color: rgba(255, 192, 198, 0.6);
}
.bg-scarlet-200\\/65{
  background-color: rgba(255, 192, 198, 0.65);
}
.bg-scarlet-200\\/70{
  background-color: rgba(255, 192, 198, 0.7);
}
.bg-scarlet-200\\/75{
  background-color: rgba(255, 192, 198, 0.75);
}
.bg-scarlet-200\\/80{
  background-color: rgba(255, 192, 198, 0.8);
}
.bg-scarlet-200\\/85{
  background-color: rgba(255, 192, 198, 0.85);
}
.bg-scarlet-200\\/90{
  background-color: rgba(255, 192, 198, 0.9);
}
.bg-scarlet-200\\/95{
  background-color: rgba(255, 192, 198, 0.95);
}
.bg-scarlet-300{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 148, 158, 1);
  background-color: rgba(255, 148, 158, var(--tw-bg-opacity, 1));
}
.bg-scarlet-300\\/0{
  background-color: rgba(255, 148, 158, 0);
}
.bg-scarlet-300\\/10{
  background-color: rgba(255, 148, 158, 0.1);
}
.bg-scarlet-300\\/100{
  background-color: rgb(255, 148, 158);
}
.bg-scarlet-300\\/15{
  background-color: rgba(255, 148, 158, 0.15);
}
.bg-scarlet-300\\/20{
  background-color: rgba(255, 148, 158, 0.2);
}
.bg-scarlet-300\\/25{
  background-color: rgba(255, 148, 158, 0.25);
}
.bg-scarlet-300\\/30{
  background-color: rgba(255, 148, 158, 0.3);
}
.bg-scarlet-300\\/35{
  background-color: rgba(255, 148, 158, 0.35);
}
.bg-scarlet-300\\/40{
  background-color: rgba(255, 148, 158, 0.4);
}
.bg-scarlet-300\\/45{
  background-color: rgba(255, 148, 158, 0.45);
}
.bg-scarlet-300\\/5{
  background-color: rgba(255, 148, 158, 0.05);
}
.bg-scarlet-300\\/50{
  background-color: rgba(255, 148, 158, 0.5);
}
.bg-scarlet-300\\/55{
  background-color: rgba(255, 148, 158, 0.55);
}
.bg-scarlet-300\\/60{
  background-color: rgba(255, 148, 158, 0.6);
}
.bg-scarlet-300\\/65{
  background-color: rgba(255, 148, 158, 0.65);
}
.bg-scarlet-300\\/70{
  background-color: rgba(255, 148, 158, 0.7);
}
.bg-scarlet-300\\/75{
  background-color: rgba(255, 148, 158, 0.75);
}
.bg-scarlet-300\\/80{
  background-color: rgba(255, 148, 158, 0.8);
}
.bg-scarlet-300\\/85{
  background-color: rgba(255, 148, 158, 0.85);
}
.bg-scarlet-300\\/90{
  background-color: rgba(255, 148, 158, 0.9);
}
.bg-scarlet-300\\/95{
  background-color: rgba(255, 148, 158, 0.95);
}
.bg-scarlet-400{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 86, 101, 1);
  background-color: rgba(255, 86, 101, var(--tw-bg-opacity, 1));
}
.bg-scarlet-400\\/0{
  background-color: rgba(255, 86, 101, 0);
}
.bg-scarlet-400\\/10{
  background-color: rgba(255, 86, 101, 0.1);
}
.bg-scarlet-400\\/100{
  background-color: rgb(255, 86, 101);
}
.bg-scarlet-400\\/15{
  background-color: rgba(255, 86, 101, 0.15);
}
.bg-scarlet-400\\/20{
  background-color: rgba(255, 86, 101, 0.2);
}
.bg-scarlet-400\\/25{
  background-color: rgba(255, 86, 101, 0.25);
}
.bg-scarlet-400\\/30{
  background-color: rgba(255, 86, 101, 0.3);
}
.bg-scarlet-400\\/35{
  background-color: rgba(255, 86, 101, 0.35);
}
.bg-scarlet-400\\/40{
  background-color: rgba(255, 86, 101, 0.4);
}
.bg-scarlet-400\\/45{
  background-color: rgba(255, 86, 101, 0.45);
}
.bg-scarlet-400\\/5{
  background-color: rgba(255, 86, 101, 0.05);
}
.bg-scarlet-400\\/50{
  background-color: rgba(255, 86, 101, 0.5);
}
.bg-scarlet-400\\/55{
  background-color: rgba(255, 86, 101, 0.55);
}
.bg-scarlet-400\\/60{
  background-color: rgba(255, 86, 101, 0.6);
}
.bg-scarlet-400\\/65{
  background-color: rgba(255, 86, 101, 0.65);
}
.bg-scarlet-400\\/70{
  background-color: rgba(255, 86, 101, 0.7);
}
.bg-scarlet-400\\/75{
  background-color: rgba(255, 86, 101, 0.75);
}
.bg-scarlet-400\\/80{
  background-color: rgba(255, 86, 101, 0.8);
}
.bg-scarlet-400\\/85{
  background-color: rgba(255, 86, 101, 0.85);
}
.bg-scarlet-400\\/90{
  background-color: rgba(255, 86, 101, 0.9);
}
.bg-scarlet-400\\/95{
  background-color: rgba(255, 86, 101, 0.95);
}
.bg-scarlet-50{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 240, 241, 1);
  background-color: rgba(255, 240, 241, var(--tw-bg-opacity, 1));
}
.bg-scarlet-500{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 34, 54, 1);
  background-color: rgba(255, 34, 54, var(--tw-bg-opacity, 1));
}
.bg-scarlet-500\\/0{
  background-color: rgba(255, 34, 54, 0);
}
.bg-scarlet-500\\/10{
  background-color: rgba(255, 34, 54, 0.1);
}
.bg-scarlet-500\\/100{
  background-color: rgb(255, 34, 54);
}
.bg-scarlet-500\\/15{
  background-color: rgba(255, 34, 54, 0.15);
}
.bg-scarlet-500\\/20{
  background-color: rgba(255, 34, 54, 0.2);
}
.bg-scarlet-500\\/25{
  background-color: rgba(255, 34, 54, 0.25);
}
.bg-scarlet-500\\/30{
  background-color: rgba(255, 34, 54, 0.3);
}
.bg-scarlet-500\\/35{
  background-color: rgba(255, 34, 54, 0.35);
}
.bg-scarlet-500\\/40{
  background-color: rgba(255, 34, 54, 0.4);
}
.bg-scarlet-500\\/45{
  background-color: rgba(255, 34, 54, 0.45);
}
.bg-scarlet-500\\/5{
  background-color: rgba(255, 34, 54, 0.05);
}
.bg-scarlet-500\\/50{
  background-color: rgba(255, 34, 54, 0.5);
}
.bg-scarlet-500\\/55{
  background-color: rgba(255, 34, 54, 0.55);
}
.bg-scarlet-500\\/60{
  background-color: rgba(255, 34, 54, 0.6);
}
.bg-scarlet-500\\/65{
  background-color: rgba(255, 34, 54, 0.65);
}
.bg-scarlet-500\\/70{
  background-color: rgba(255, 34, 54, 0.7);
}
.bg-scarlet-500\\/75{
  background-color: rgba(255, 34, 54, 0.75);
}
.bg-scarlet-500\\/80{
  background-color: rgba(255, 34, 54, 0.8);
}
.bg-scarlet-500\\/85{
  background-color: rgba(255, 34, 54, 0.85);
}
.bg-scarlet-500\\/90{
  background-color: rgba(255, 34, 54, 0.9);
}
.bg-scarlet-500\\/95{
  background-color: rgba(255, 34, 54, 0.95);
}
.bg-scarlet-600{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 2, 25, 1);
  background-color: rgba(255, 2, 25, var(--tw-bg-opacity, 1));
}
.bg-scarlet-600\\/0{
  background-color: rgba(255, 2, 25, 0);
}
.bg-scarlet-600\\/10{
  background-color: rgba(255, 2, 25, 0.1);
}
.bg-scarlet-600\\/100{
  background-color: rgb(255, 2, 25);
}
.bg-scarlet-600\\/15{
  background-color: rgba(255, 2, 25, 0.15);
}
.bg-scarlet-600\\/20{
  background-color: rgba(255, 2, 25, 0.2);
}
.bg-scarlet-600\\/25{
  background-color: rgba(255, 2, 25, 0.25);
}
.bg-scarlet-600\\/30{
  background-color: rgba(255, 2, 25, 0.3);
}
.bg-scarlet-600\\/35{
  background-color: rgba(255, 2, 25, 0.35);
}
.bg-scarlet-600\\/40{
  background-color: rgba(255, 2, 25, 0.4);
}
.bg-scarlet-600\\/45{
  background-color: rgba(255, 2, 25, 0.45);
}
.bg-scarlet-600\\/5{
  background-color: rgba(255, 2, 25, 0.05);
}
.bg-scarlet-600\\/50{
  background-color: rgba(255, 2, 25, 0.5);
}
.bg-scarlet-600\\/55{
  background-color: rgba(255, 2, 25, 0.55);
}
.bg-scarlet-600\\/60{
  background-color: rgba(255, 2, 25, 0.6);
}
.bg-scarlet-600\\/65{
  background-color: rgba(255, 2, 25, 0.65);
}
.bg-scarlet-600\\/70{
  background-color: rgba(255, 2, 25, 0.7);
}
.bg-scarlet-600\\/75{
  background-color: rgba(255, 2, 25, 0.75);
}
.bg-scarlet-600\\/80{
  background-color: rgba(255, 2, 25, 0.8);
}
.bg-scarlet-600\\/85{
  background-color: rgba(255, 2, 25, 0.85);
}
.bg-scarlet-600\\/90{
  background-color: rgba(255, 2, 25, 0.9);
}
.bg-scarlet-600\\/95{
  background-color: rgba(255, 2, 25, 0.95);
}
.bg-scarlet-700{
  --tw-bg-opacity: 1;
  background-color: rgba(216, 0, 19, 1);
  background-color: rgba(216, 0, 19, var(--tw-bg-opacity, 1));
}
.bg-scarlet-700\\/0{
  background-color: rgba(216, 0, 19, 0);
}
.bg-scarlet-700\\/10{
  background-color: rgba(216, 0, 19, 0.1);
}
.bg-scarlet-700\\/100{
  background-color: rgb(216, 0, 19);
}
.bg-scarlet-700\\/15{
  background-color: rgba(216, 0, 19, 0.15);
}
.bg-scarlet-700\\/20{
  background-color: rgba(216, 0, 19, 0.2);
}
.bg-scarlet-700\\/25{
  background-color: rgba(216, 0, 19, 0.25);
}
.bg-scarlet-700\\/30{
  background-color: rgba(216, 0, 19, 0.3);
}
.bg-scarlet-700\\/35{
  background-color: rgba(216, 0, 19, 0.35);
}
.bg-scarlet-700\\/40{
  background-color: rgba(216, 0, 19, 0.4);
}
.bg-scarlet-700\\/45{
  background-color: rgba(216, 0, 19, 0.45);
}
.bg-scarlet-700\\/5{
  background-color: rgba(216, 0, 19, 0.05);
}
.bg-scarlet-700\\/50{
  background-color: rgba(216, 0, 19, 0.5);
}
.bg-scarlet-700\\/55{
  background-color: rgba(216, 0, 19, 0.55);
}
.bg-scarlet-700\\/60{
  background-color: rgba(216, 0, 19, 0.6);
}
.bg-scarlet-700\\/65{
  background-color: rgba(216, 0, 19, 0.65);
}
.bg-scarlet-700\\/70{
  background-color: rgba(216, 0, 19, 0.7);
}
.bg-scarlet-700\\/75{
  background-color: rgba(216, 0, 19, 0.75);
}
.bg-scarlet-700\\/80{
  background-color: rgba(216, 0, 19, 0.8);
}
.bg-scarlet-700\\/85{
  background-color: rgba(216, 0, 19, 0.85);
}
.bg-scarlet-700\\/90{
  background-color: rgba(216, 0, 19, 0.9);
}
.bg-scarlet-700\\/95{
  background-color: rgba(216, 0, 19, 0.95);
}
.bg-scarlet-800{
  --tw-bg-opacity: 1;
  background-color: rgba(180, 2, 18, 1);
  background-color: rgba(180, 2, 18, var(--tw-bg-opacity, 1));
}
.bg-scarlet-800\\/0{
  background-color: rgba(180, 2, 18, 0);
}
.bg-scarlet-800\\/10{
  background-color: rgba(180, 2, 18, 0.1);
}
.bg-scarlet-800\\/100{
  background-color: rgb(180, 2, 18);
}
.bg-scarlet-800\\/15{
  background-color: rgba(180, 2, 18, 0.15);
}
.bg-scarlet-800\\/20{
  background-color: rgba(180, 2, 18, 0.2);
}
.bg-scarlet-800\\/25{
  background-color: rgba(180, 2, 18, 0.25);
}
.bg-scarlet-800\\/30{
  background-color: rgba(180, 2, 18, 0.3);
}
.bg-scarlet-800\\/35{
  background-color: rgba(180, 2, 18, 0.35);
}
.bg-scarlet-800\\/40{
  background-color: rgba(180, 2, 18, 0.4);
}
.bg-scarlet-800\\/45{
  background-color: rgba(180, 2, 18, 0.45);
}
.bg-scarlet-800\\/5{
  background-color: rgba(180, 2, 18, 0.05);
}
.bg-scarlet-800\\/50{
  background-color: rgba(180, 2, 18, 0.5);
}
.bg-scarlet-800\\/55{
  background-color: rgba(180, 2, 18, 0.55);
}
.bg-scarlet-800\\/60{
  background-color: rgba(180, 2, 18, 0.6);
}
.bg-scarlet-800\\/65{
  background-color: rgba(180, 2, 18, 0.65);
}
.bg-scarlet-800\\/70{
  background-color: rgba(180, 2, 18, 0.7);
}
.bg-scarlet-800\\/75{
  background-color: rgba(180, 2, 18, 0.75);
}
.bg-scarlet-800\\/80{
  background-color: rgba(180, 2, 18, 0.8);
}
.bg-scarlet-800\\/85{
  background-color: rgba(180, 2, 18, 0.85);
}
.bg-scarlet-800\\/90{
  background-color: rgba(180, 2, 18, 0.9);
}
.bg-scarlet-800\\/95{
  background-color: rgba(180, 2, 18, 0.95);
}
.bg-scarlet-900{
  --tw-bg-opacity: 1;
  background-color: rgba(146, 10, 22, 1);
  background-color: rgba(146, 10, 22, var(--tw-bg-opacity, 1));
}
.bg-scarlet-900\\/0{
  background-color: rgba(146, 10, 22, 0);
}
.bg-scarlet-900\\/10{
  background-color: rgba(146, 10, 22, 0.1);
}
.bg-scarlet-900\\/100{
  background-color: rgb(146, 10, 22);
}
.bg-scarlet-900\\/15{
  background-color: rgba(146, 10, 22, 0.15);
}
.bg-scarlet-900\\/20{
  background-color: rgba(146, 10, 22, 0.2);
}
.bg-scarlet-900\\/25{
  background-color: rgba(146, 10, 22, 0.25);
}
.bg-scarlet-900\\/30{
  background-color: rgba(146, 10, 22, 0.3);
}
.bg-scarlet-900\\/35{
  background-color: rgba(146, 10, 22, 0.35);
}
.bg-scarlet-900\\/40{
  background-color: rgba(146, 10, 22, 0.4);
}
.bg-scarlet-900\\/45{
  background-color: rgba(146, 10, 22, 0.45);
}
.bg-scarlet-900\\/5{
  background-color: rgba(146, 10, 22, 0.05);
}
.bg-scarlet-900\\/50{
  background-color: rgba(146, 10, 22, 0.5);
}
.bg-scarlet-900\\/55{
  background-color: rgba(146, 10, 22, 0.55);
}
.bg-scarlet-900\\/60{
  background-color: rgba(146, 10, 22, 0.6);
}
.bg-scarlet-900\\/65{
  background-color: rgba(146, 10, 22, 0.65);
}
.bg-scarlet-900\\/70{
  background-color: rgba(146, 10, 22, 0.7);
}
.bg-scarlet-900\\/75{
  background-color: rgba(146, 10, 22, 0.75);
}
.bg-scarlet-900\\/80{
  background-color: rgba(146, 10, 22, 0.8);
}
.bg-scarlet-900\\/85{
  background-color: rgba(146, 10, 22, 0.85);
}
.bg-scarlet-900\\/90{
  background-color: rgba(146, 10, 22, 0.9);
}
.bg-scarlet-900\\/95{
  background-color: rgba(146, 10, 22, 0.95);
}
.bg-scarlet-950{
  --tw-bg-opacity: 1;
  background-color: rgba(81, 0, 7, 1);
  background-color: rgba(81, 0, 7, var(--tw-bg-opacity, 1));
}
.bg-scarlet-950\\/0{
  background-color: rgba(81, 0, 7, 0);
}
.bg-scarlet-950\\/10{
  background-color: rgba(81, 0, 7, 0.1);
}
.bg-scarlet-950\\/100{
  background-color: rgb(81, 0, 7);
}
.bg-scarlet-950\\/15{
  background-color: rgba(81, 0, 7, 0.15);
}
.bg-scarlet-950\\/20{
  background-color: rgba(81, 0, 7, 0.2);
}
.bg-scarlet-950\\/25{
  background-color: rgba(81, 0, 7, 0.25);
}
.bg-scarlet-950\\/30{
  background-color: rgba(81, 0, 7, 0.3);
}
.bg-scarlet-950\\/35{
  background-color: rgba(81, 0, 7, 0.35);
}
.bg-scarlet-950\\/40{
  background-color: rgba(81, 0, 7, 0.4);
}
.bg-scarlet-950\\/45{
  background-color: rgba(81, 0, 7, 0.45);
}
.bg-scarlet-950\\/5{
  background-color: rgba(81, 0, 7, 0.05);
}
.bg-scarlet-950\\/50{
  background-color: rgba(81, 0, 7, 0.5);
}
.bg-scarlet-950\\/55{
  background-color: rgba(81, 0, 7, 0.55);
}
.bg-scarlet-950\\/60{
  background-color: rgba(81, 0, 7, 0.6);
}
.bg-scarlet-950\\/65{
  background-color: rgba(81, 0, 7, 0.65);
}
.bg-scarlet-950\\/70{
  background-color: rgba(81, 0, 7, 0.7);
}
.bg-scarlet-950\\/75{
  background-color: rgba(81, 0, 7, 0.75);
}
.bg-scarlet-950\\/80{
  background-color: rgba(81, 0, 7, 0.8);
}
.bg-scarlet-950\\/85{
  background-color: rgba(81, 0, 7, 0.85);
}
.bg-scarlet-950\\/90{
  background-color: rgba(81, 0, 7, 0.9);
}
.bg-scarlet-950\\/95{
  background-color: rgba(81, 0, 7, 0.95);
}
.bg-song-color-100{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 220, 223, 1);
  background-color: rgba(255, 220, 223, var(--tw-bg-opacity, 1));
}
.bg-song-color-100\\/0{
  background-color: rgba(255, 220, 223, 0);
}
.bg-song-color-100\\/10{
  background-color: rgba(255, 220, 223, 0.1);
}
.bg-song-color-100\\/100{
  background-color: rgb(255, 220, 223);
}
.bg-song-color-100\\/15{
  background-color: rgba(255, 220, 223, 0.15);
}
.bg-song-color-100\\/20{
  background-color: rgba(255, 220, 223, 0.2);
}
.bg-song-color-100\\/25{
  background-color: rgba(255, 220, 223, 0.25);
}
.bg-song-color-100\\/30{
  background-color: rgba(255, 220, 223, 0.3);
}
.bg-song-color-100\\/35{
  background-color: rgba(255, 220, 223, 0.35);
}
.bg-song-color-100\\/40{
  background-color: rgba(255, 220, 223, 0.4);
}
.bg-song-color-100\\/45{
  background-color: rgba(255, 220, 223, 0.45);
}
.bg-song-color-100\\/5{
  background-color: rgba(255, 220, 223, 0.05);
}
.bg-song-color-100\\/50{
  background-color: rgba(255, 220, 223, 0.5);
}
.bg-song-color-100\\/55{
  background-color: rgba(255, 220, 223, 0.55);
}
.bg-song-color-100\\/60{
  background-color: rgba(255, 220, 223, 0.6);
}
.bg-song-color-100\\/65{
  background-color: rgba(255, 220, 223, 0.65);
}
.bg-song-color-100\\/70{
  background-color: rgba(255, 220, 223, 0.7);
}
.bg-song-color-100\\/75{
  background-color: rgba(255, 220, 223, 0.75);
}
.bg-song-color-100\\/80{
  background-color: rgba(255, 220, 223, 0.8);
}
.bg-song-color-100\\/85{
  background-color: rgba(255, 220, 223, 0.85);
}
.bg-song-color-100\\/90{
  background-color: rgba(255, 220, 223, 0.9);
}
.bg-song-color-100\\/95{
  background-color: rgba(255, 220, 223, 0.95);
}
.bg-song-color-200{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 192, 198, 1);
  background-color: rgba(255, 192, 198, var(--tw-bg-opacity, 1));
}
.bg-song-color-200\\/0{
  background-color: rgba(255, 192, 198, 0);
}
.bg-song-color-200\\/10{
  background-color: rgba(255, 192, 198, 0.1);
}
.bg-song-color-200\\/100{
  background-color: rgb(255, 192, 198);
}
.bg-song-color-200\\/15{
  background-color: rgba(255, 192, 198, 0.15);
}
.bg-song-color-200\\/20{
  background-color: rgba(255, 192, 198, 0.2);
}
.bg-song-color-200\\/25{
  background-color: rgba(255, 192, 198, 0.25);
}
.bg-song-color-200\\/30{
  background-color: rgba(255, 192, 198, 0.3);
}
.bg-song-color-200\\/35{
  background-color: rgba(255, 192, 198, 0.35);
}
.bg-song-color-200\\/40{
  background-color: rgba(255, 192, 198, 0.4);
}
.bg-song-color-200\\/45{
  background-color: rgba(255, 192, 198, 0.45);
}
.bg-song-color-200\\/5{
  background-color: rgba(255, 192, 198, 0.05);
}
.bg-song-color-200\\/50{
  background-color: rgba(255, 192, 198, 0.5);
}
.bg-song-color-200\\/55{
  background-color: rgba(255, 192, 198, 0.55);
}
.bg-song-color-200\\/60{
  background-color: rgba(255, 192, 198, 0.6);
}
.bg-song-color-200\\/65{
  background-color: rgba(255, 192, 198, 0.65);
}
.bg-song-color-200\\/70{
  background-color: rgba(255, 192, 198, 0.7);
}
.bg-song-color-200\\/75{
  background-color: rgba(255, 192, 198, 0.75);
}
.bg-song-color-200\\/80{
  background-color: rgba(255, 192, 198, 0.8);
}
.bg-song-color-200\\/85{
  background-color: rgba(255, 192, 198, 0.85);
}
.bg-song-color-200\\/90{
  background-color: rgba(255, 192, 198, 0.9);
}
.bg-song-color-200\\/95{
  background-color: rgba(255, 192, 198, 0.95);
}
.bg-song-color-300{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 148, 158, 1);
  background-color: rgba(255, 148, 158, var(--tw-bg-opacity, 1));
}
.bg-song-color-300\\/0{
  background-color: rgba(255, 148, 158, 0);
}
.bg-song-color-300\\/10{
  background-color: rgba(255, 148, 158, 0.1);
}
.bg-song-color-300\\/100{
  background-color: rgb(255, 148, 158);
}
.bg-song-color-300\\/15{
  background-color: rgba(255, 148, 158, 0.15);
}
.bg-song-color-300\\/20{
  background-color: rgba(255, 148, 158, 0.2);
}
.bg-song-color-300\\/25{
  background-color: rgba(255, 148, 158, 0.25);
}
.bg-song-color-300\\/30{
  background-color: rgba(255, 148, 158, 0.3);
}
.bg-song-color-300\\/35{
  background-color: rgba(255, 148, 158, 0.35);
}
.bg-song-color-300\\/40{
  background-color: rgba(255, 148, 158, 0.4);
}
.bg-song-color-300\\/45{
  background-color: rgba(255, 148, 158, 0.45);
}
.bg-song-color-300\\/5{
  background-color: rgba(255, 148, 158, 0.05);
}
.bg-song-color-300\\/50{
  background-color: rgba(255, 148, 158, 0.5);
}
.bg-song-color-300\\/55{
  background-color: rgba(255, 148, 158, 0.55);
}
.bg-song-color-300\\/60{
  background-color: rgba(255, 148, 158, 0.6);
}
.bg-song-color-300\\/65{
  background-color: rgba(255, 148, 158, 0.65);
}
.bg-song-color-300\\/70{
  background-color: rgba(255, 148, 158, 0.7);
}
.bg-song-color-300\\/75{
  background-color: rgba(255, 148, 158, 0.75);
}
.bg-song-color-300\\/80{
  background-color: rgba(255, 148, 158, 0.8);
}
.bg-song-color-300\\/85{
  background-color: rgba(255, 148, 158, 0.85);
}
.bg-song-color-300\\/90{
  background-color: rgba(255, 148, 158, 0.9);
}
.bg-song-color-300\\/95{
  background-color: rgba(255, 148, 158, 0.95);
}
.bg-song-color-400{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 86, 101, 1);
  background-color: rgba(255, 86, 101, var(--tw-bg-opacity, 1));
}
.bg-song-color-400\\/0{
  background-color: rgba(255, 86, 101, 0);
}
.bg-song-color-400\\/10{
  background-color: rgba(255, 86, 101, 0.1);
}
.bg-song-color-400\\/100{
  background-color: rgb(255, 86, 101);
}
.bg-song-color-400\\/15{
  background-color: rgba(255, 86, 101, 0.15);
}
.bg-song-color-400\\/20{
  background-color: rgba(255, 86, 101, 0.2);
}
.bg-song-color-400\\/25{
  background-color: rgba(255, 86, 101, 0.25);
}
.bg-song-color-400\\/30{
  background-color: rgba(255, 86, 101, 0.3);
}
.bg-song-color-400\\/35{
  background-color: rgba(255, 86, 101, 0.35);
}
.bg-song-color-400\\/40{
  background-color: rgba(255, 86, 101, 0.4);
}
.bg-song-color-400\\/45{
  background-color: rgba(255, 86, 101, 0.45);
}
.bg-song-color-400\\/5{
  background-color: rgba(255, 86, 101, 0.05);
}
.bg-song-color-400\\/50{
  background-color: rgba(255, 86, 101, 0.5);
}
.bg-song-color-400\\/55{
  background-color: rgba(255, 86, 101, 0.55);
}
.bg-song-color-400\\/60{
  background-color: rgba(255, 86, 101, 0.6);
}
.bg-song-color-400\\/65{
  background-color: rgba(255, 86, 101, 0.65);
}
.bg-song-color-400\\/70{
  background-color: rgba(255, 86, 101, 0.7);
}
.bg-song-color-400\\/75{
  background-color: rgba(255, 86, 101, 0.75);
}
.bg-song-color-400\\/80{
  background-color: rgba(255, 86, 101, 0.8);
}
.bg-song-color-400\\/85{
  background-color: rgba(255, 86, 101, 0.85);
}
.bg-song-color-400\\/90{
  background-color: rgba(255, 86, 101, 0.9);
}
.bg-song-color-400\\/95{
  background-color: rgba(255, 86, 101, 0.95);
}
.bg-song-color-500{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 34, 54, 1);
  background-color: rgba(255, 34, 54, var(--tw-bg-opacity, 1));
}
.bg-song-color-500\\/0{
  background-color: rgba(255, 34, 54, 0);
}
.bg-song-color-500\\/10{
  background-color: rgba(255, 34, 54, 0.1);
}
.bg-song-color-500\\/100{
  background-color: rgb(255, 34, 54);
}
.bg-song-color-500\\/15{
  background-color: rgba(255, 34, 54, 0.15);
}
.bg-song-color-500\\/20{
  background-color: rgba(255, 34, 54, 0.2);
}
.bg-song-color-500\\/25{
  background-color: rgba(255, 34, 54, 0.25);
}
.bg-song-color-500\\/30{
  background-color: rgba(255, 34, 54, 0.3);
}
.bg-song-color-500\\/35{
  background-color: rgba(255, 34, 54, 0.35);
}
.bg-song-color-500\\/40{
  background-color: rgba(255, 34, 54, 0.4);
}
.bg-song-color-500\\/45{
  background-color: rgba(255, 34, 54, 0.45);
}
.bg-song-color-500\\/5{
  background-color: rgba(255, 34, 54, 0.05);
}
.bg-song-color-500\\/50{
  background-color: rgba(255, 34, 54, 0.5);
}
.bg-song-color-500\\/55{
  background-color: rgba(255, 34, 54, 0.55);
}
.bg-song-color-500\\/60{
  background-color: rgba(255, 34, 54, 0.6);
}
.bg-song-color-500\\/65{
  background-color: rgba(255, 34, 54, 0.65);
}
.bg-song-color-500\\/70{
  background-color: rgba(255, 34, 54, 0.7);
}
.bg-song-color-500\\/75{
  background-color: rgba(255, 34, 54, 0.75);
}
.bg-song-color-500\\/80{
  background-color: rgba(255, 34, 54, 0.8);
}
.bg-song-color-500\\/85{
  background-color: rgba(255, 34, 54, 0.85);
}
.bg-song-color-500\\/90{
  background-color: rgba(255, 34, 54, 0.9);
}
.bg-song-color-500\\/95{
  background-color: rgba(255, 34, 54, 0.95);
}
.bg-song-color-600{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 2, 25, 1);
  background-color: rgba(255, 2, 25, var(--tw-bg-opacity, 1));
}
.bg-song-color-600\\/0{
  background-color: rgba(255, 2, 25, 0);
}
.bg-song-color-600\\/10{
  background-color: rgba(255, 2, 25, 0.1);
}
.bg-song-color-600\\/100{
  background-color: rgb(255, 2, 25);
}
.bg-song-color-600\\/15{
  background-color: rgba(255, 2, 25, 0.15);
}
.bg-song-color-600\\/20{
  background-color: rgba(255, 2, 25, 0.2);
}
.bg-song-color-600\\/25{
  background-color: rgba(255, 2, 25, 0.25);
}
.bg-song-color-600\\/30{
  background-color: rgba(255, 2, 25, 0.3);
}
.bg-song-color-600\\/35{
  background-color: rgba(255, 2, 25, 0.35);
}
.bg-song-color-600\\/40{
  background-color: rgba(255, 2, 25, 0.4);
}
.bg-song-color-600\\/45{
  background-color: rgba(255, 2, 25, 0.45);
}
.bg-song-color-600\\/5{
  background-color: rgba(255, 2, 25, 0.05);
}
.bg-song-color-600\\/50{
  background-color: rgba(255, 2, 25, 0.5);
}
.bg-song-color-600\\/55{
  background-color: rgba(255, 2, 25, 0.55);
}
.bg-song-color-600\\/60{
  background-color: rgba(255, 2, 25, 0.6);
}
.bg-song-color-600\\/65{
  background-color: rgba(255, 2, 25, 0.65);
}
.bg-song-color-600\\/70{
  background-color: rgba(255, 2, 25, 0.7);
}
.bg-song-color-600\\/75{
  background-color: rgba(255, 2, 25, 0.75);
}
.bg-song-color-600\\/80{
  background-color: rgba(255, 2, 25, 0.8);
}
.bg-song-color-600\\/85{
  background-color: rgba(255, 2, 25, 0.85);
}
.bg-song-color-600\\/90{
  background-color: rgba(255, 2, 25, 0.9);
}
.bg-song-color-600\\/95{
  background-color: rgba(255, 2, 25, 0.95);
}
.bg-song-color-700{
  --tw-bg-opacity: 1;
  background-color: rgba(216, 0, 19, 1);
  background-color: rgba(216, 0, 19, var(--tw-bg-opacity, 1));
}
.bg-song-color-700\\/0{
  background-color: rgba(216, 0, 19, 0);
}
.bg-song-color-700\\/10{
  background-color: rgba(216, 0, 19, 0.1);
}
.bg-song-color-700\\/100{
  background-color: rgb(216, 0, 19);
}
.bg-song-color-700\\/15{
  background-color: rgba(216, 0, 19, 0.15);
}
.bg-song-color-700\\/20{
  background-color: rgba(216, 0, 19, 0.2);
}
.bg-song-color-700\\/25{
  background-color: rgba(216, 0, 19, 0.25);
}
.bg-song-color-700\\/30{
  background-color: rgba(216, 0, 19, 0.3);
}
.bg-song-color-700\\/35{
  background-color: rgba(216, 0, 19, 0.35);
}
.bg-song-color-700\\/40{
  background-color: rgba(216, 0, 19, 0.4);
}
.bg-song-color-700\\/45{
  background-color: rgba(216, 0, 19, 0.45);
}
.bg-song-color-700\\/5{
  background-color: rgba(216, 0, 19, 0.05);
}
.bg-song-color-700\\/50{
  background-color: rgba(216, 0, 19, 0.5);
}
.bg-song-color-700\\/55{
  background-color: rgba(216, 0, 19, 0.55);
}
.bg-song-color-700\\/60{
  background-color: rgba(216, 0, 19, 0.6);
}
.bg-song-color-700\\/65{
  background-color: rgba(216, 0, 19, 0.65);
}
.bg-song-color-700\\/70{
  background-color: rgba(216, 0, 19, 0.7);
}
.bg-song-color-700\\/75{
  background-color: rgba(216, 0, 19, 0.75);
}
.bg-song-color-700\\/80{
  background-color: rgba(216, 0, 19, 0.8);
}
.bg-song-color-700\\/85{
  background-color: rgba(216, 0, 19, 0.85);
}
.bg-song-color-700\\/90{
  background-color: rgba(216, 0, 19, 0.9);
}
.bg-song-color-700\\/95{
  background-color: rgba(216, 0, 19, 0.95);
}
.bg-song-color-800{
  --tw-bg-opacity: 1;
  background-color: rgba(180, 2, 18, 1);
  background-color: rgba(180, 2, 18, var(--tw-bg-opacity, 1));
}
.bg-song-color-800\\/0{
  background-color: rgba(180, 2, 18, 0);
}
.bg-song-color-800\\/10{
  background-color: rgba(180, 2, 18, 0.1);
}
.bg-song-color-800\\/100{
  background-color: rgb(180, 2, 18);
}
.bg-song-color-800\\/15{
  background-color: rgba(180, 2, 18, 0.15);
}
.bg-song-color-800\\/20{
  background-color: rgba(180, 2, 18, 0.2);
}
.bg-song-color-800\\/25{
  background-color: rgba(180, 2, 18, 0.25);
}
.bg-song-color-800\\/30{
  background-color: rgba(180, 2, 18, 0.3);
}
.bg-song-color-800\\/35{
  background-color: rgba(180, 2, 18, 0.35);
}
.bg-song-color-800\\/40{
  background-color: rgba(180, 2, 18, 0.4);
}
.bg-song-color-800\\/45{
  background-color: rgba(180, 2, 18, 0.45);
}
.bg-song-color-800\\/5{
  background-color: rgba(180, 2, 18, 0.05);
}
.bg-song-color-800\\/50{
  background-color: rgba(180, 2, 18, 0.5);
}
.bg-song-color-800\\/55{
  background-color: rgba(180, 2, 18, 0.55);
}
.bg-song-color-800\\/60{
  background-color: rgba(180, 2, 18, 0.6);
}
.bg-song-color-800\\/65{
  background-color: rgba(180, 2, 18, 0.65);
}
.bg-song-color-800\\/70{
  background-color: rgba(180, 2, 18, 0.7);
}
.bg-song-color-800\\/75{
  background-color: rgba(180, 2, 18, 0.75);
}
.bg-song-color-800\\/80{
  background-color: rgba(180, 2, 18, 0.8);
}
.bg-song-color-800\\/85{
  background-color: rgba(180, 2, 18, 0.85);
}
.bg-song-color-800\\/90{
  background-color: rgba(180, 2, 18, 0.9);
}
.bg-song-color-800\\/95{
  background-color: rgba(180, 2, 18, 0.95);
}
.bg-song-color-900{
  --tw-bg-opacity: 1;
  background-color: rgba(146, 10, 22, 1);
  background-color: rgba(146, 10, 22, var(--tw-bg-opacity, 1));
}
.bg-song-color-900\\/0{
  background-color: rgba(146, 10, 22, 0);
}
.bg-song-color-900\\/10{
  background-color: rgba(146, 10, 22, 0.1);
}
.bg-song-color-900\\/100{
  background-color: rgb(146, 10, 22);
}
.bg-song-color-900\\/15{
  background-color: rgba(146, 10, 22, 0.15);
}
.bg-song-color-900\\/20{
  background-color: rgba(146, 10, 22, 0.2);
}
.bg-song-color-900\\/25{
  background-color: rgba(146, 10, 22, 0.25);
}
.bg-song-color-900\\/30{
  background-color: rgba(146, 10, 22, 0.3);
}
.bg-song-color-900\\/35{
  background-color: rgba(146, 10, 22, 0.35);
}
.bg-song-color-900\\/40{
  background-color: rgba(146, 10, 22, 0.4);
}
.bg-song-color-900\\/45{
  background-color: rgba(146, 10, 22, 0.45);
}
.bg-song-color-900\\/5{
  background-color: rgba(146, 10, 22, 0.05);
}
.bg-song-color-900\\/50{
  background-color: rgba(146, 10, 22, 0.5);
}
.bg-song-color-900\\/55{
  background-color: rgba(146, 10, 22, 0.55);
}
.bg-song-color-900\\/60{
  background-color: rgba(146, 10, 22, 0.6);
}
.bg-song-color-900\\/65{
  background-color: rgba(146, 10, 22, 0.65);
}
.bg-song-color-900\\/70{
  background-color: rgba(146, 10, 22, 0.7);
}
.bg-song-color-900\\/75{
  background-color: rgba(146, 10, 22, 0.75);
}
.bg-song-color-900\\/80{
  background-color: rgba(146, 10, 22, 0.8);
}
.bg-song-color-900\\/85{
  background-color: rgba(146, 10, 22, 0.85);
}
.bg-song-color-900\\/90{
  background-color: rgba(146, 10, 22, 0.9);
}
.bg-song-color-900\\/95{
  background-color: rgba(146, 10, 22, 0.95);
}
.bg-song-color-950{
  --tw-bg-opacity: 1;
  background-color: rgba(81, 0, 7, 1);
  background-color: rgba(81, 0, 7, var(--tw-bg-opacity, 1));
}
.bg-song-color-950\\/0{
  background-color: rgba(81, 0, 7, 0);
}
.bg-song-color-950\\/10{
  background-color: rgba(81, 0, 7, 0.1);
}
.bg-song-color-950\\/100{
  background-color: rgb(81, 0, 7);
}
.bg-song-color-950\\/15{
  background-color: rgba(81, 0, 7, 0.15);
}
.bg-song-color-950\\/20{
  background-color: rgba(81, 0, 7, 0.2);
}
.bg-song-color-950\\/25{
  background-color: rgba(81, 0, 7, 0.25);
}
.bg-song-color-950\\/30{
  background-color: rgba(81, 0, 7, 0.3);
}
.bg-song-color-950\\/35{
  background-color: rgba(81, 0, 7, 0.35);
}
.bg-song-color-950\\/40{
  background-color: rgba(81, 0, 7, 0.4);
}
.bg-song-color-950\\/45{
  background-color: rgba(81, 0, 7, 0.45);
}
.bg-song-color-950\\/5{
  background-color: rgba(81, 0, 7, 0.05);
}
.bg-song-color-950\\/50{
  background-color: rgba(81, 0, 7, 0.5);
}
.bg-song-color-950\\/55{
  background-color: rgba(81, 0, 7, 0.55);
}
.bg-song-color-950\\/60{
  background-color: rgba(81, 0, 7, 0.6);
}
.bg-song-color-950\\/65{
  background-color: rgba(81, 0, 7, 0.65);
}
.bg-song-color-950\\/70{
  background-color: rgba(81, 0, 7, 0.7);
}
.bg-song-color-950\\/75{
  background-color: rgba(81, 0, 7, 0.75);
}
.bg-song-color-950\\/80{
  background-color: rgba(81, 0, 7, 0.8);
}
.bg-song-color-950\\/85{
  background-color: rgba(81, 0, 7, 0.85);
}
.bg-song-color-950\\/90{
  background-color: rgba(81, 0, 7, 0.9);
}
.bg-song-color-950\\/95{
  background-color: rgba(81, 0, 7, 0.95);
}
.bg-story-color-100{
  --tw-bg-opacity: 1;
  background-color: rgba(218, 238, 243, 1);
  background-color: rgba(218, 238, 243, var(--tw-bg-opacity, 1));
}
.bg-story-color-100\\/0{
  background-color: rgba(218, 238, 243, 0);
}
.bg-story-color-100\\/10{
  background-color: rgba(218, 238, 243, 0.1);
}
.bg-story-color-100\\/100{
  background-color: rgb(218, 238, 243);
}
.bg-story-color-100\\/15{
  background-color: rgba(218, 238, 243, 0.15);
}
.bg-story-color-100\\/20{
  background-color: rgba(218, 238, 243, 0.2);
}
.bg-story-color-100\\/25{
  background-color: rgba(218, 238, 243, 0.25);
}
.bg-story-color-100\\/30{
  background-color: rgba(218, 238, 243, 0.3);
}
.bg-story-color-100\\/35{
  background-color: rgba(218, 238, 243, 0.35);
}
.bg-story-color-100\\/40{
  background-color: rgba(218, 238, 243, 0.4);
}
.bg-story-color-100\\/45{
  background-color: rgba(218, 238, 243, 0.45);
}
.bg-story-color-100\\/5{
  background-color: rgba(218, 238, 243, 0.05);
}
.bg-story-color-100\\/50{
  background-color: rgba(218, 238, 243, 0.5);
}
.bg-story-color-100\\/55{
  background-color: rgba(218, 238, 243, 0.55);
}
.bg-story-color-100\\/60{
  background-color: rgba(218, 238, 243, 0.6);
}
.bg-story-color-100\\/65{
  background-color: rgba(218, 238, 243, 0.65);
}
.bg-story-color-100\\/70{
  background-color: rgba(218, 238, 243, 0.7);
}
.bg-story-color-100\\/75{
  background-color: rgba(218, 238, 243, 0.75);
}
.bg-story-color-100\\/80{
  background-color: rgba(218, 238, 243, 0.8);
}
.bg-story-color-100\\/85{
  background-color: rgba(218, 238, 243, 0.85);
}
.bg-story-color-100\\/90{
  background-color: rgba(218, 238, 243, 0.9);
}
.bg-story-color-100\\/95{
  background-color: rgba(218, 238, 243, 0.95);
}
.bg-story-color-200{
  --tw-bg-opacity: 1;
  background-color: rgba(186, 222, 231, 1);
  background-color: rgba(186, 222, 231, var(--tw-bg-opacity, 1));
}
.bg-story-color-200\\/0{
  background-color: rgba(186, 222, 231, 0);
}
.bg-story-color-200\\/10{
  background-color: rgba(186, 222, 231, 0.1);
}
.bg-story-color-200\\/100{
  background-color: rgb(186, 222, 231);
}
.bg-story-color-200\\/15{
  background-color: rgba(186, 222, 231, 0.15);
}
.bg-story-color-200\\/20{
  background-color: rgba(186, 222, 231, 0.2);
}
.bg-story-color-200\\/25{
  background-color: rgba(186, 222, 231, 0.25);
}
.bg-story-color-200\\/30{
  background-color: rgba(186, 222, 231, 0.3);
}
.bg-story-color-200\\/35{
  background-color: rgba(186, 222, 231, 0.35);
}
.bg-story-color-200\\/40{
  background-color: rgba(186, 222, 231, 0.4);
}
.bg-story-color-200\\/45{
  background-color: rgba(186, 222, 231, 0.45);
}
.bg-story-color-200\\/5{
  background-color: rgba(186, 222, 231, 0.05);
}
.bg-story-color-200\\/50{
  background-color: rgba(186, 222, 231, 0.5);
}
.bg-story-color-200\\/55{
  background-color: rgba(186, 222, 231, 0.55);
}
.bg-story-color-200\\/60{
  background-color: rgba(186, 222, 231, 0.6);
}
.bg-story-color-200\\/65{
  background-color: rgba(186, 222, 231, 0.65);
}
.bg-story-color-200\\/70{
  background-color: rgba(186, 222, 231, 0.7);
}
.bg-story-color-200\\/75{
  background-color: rgba(186, 222, 231, 0.75);
}
.bg-story-color-200\\/80{
  background-color: rgba(186, 222, 231, 0.8);
}
.bg-story-color-200\\/85{
  background-color: rgba(186, 222, 231, 0.85);
}
.bg-story-color-200\\/90{
  background-color: rgba(186, 222, 231, 0.9);
}
.bg-story-color-200\\/95{
  background-color: rgba(186, 222, 231, 0.95);
}
.bg-story-color-300{
  --tw-bg-opacity: 1;
  background-color: rgba(137, 197, 215, 1);
  background-color: rgba(137, 197, 215, var(--tw-bg-opacity, 1));
}
.bg-story-color-300\\/0{
  background-color: rgba(137, 197, 215, 0);
}
.bg-story-color-300\\/10{
  background-color: rgba(137, 197, 215, 0.1);
}
.bg-story-color-300\\/100{
  background-color: rgb(137, 197, 215);
}
.bg-story-color-300\\/15{
  background-color: rgba(137, 197, 215, 0.15);
}
.bg-story-color-300\\/20{
  background-color: rgba(137, 197, 215, 0.2);
}
.bg-story-color-300\\/25{
  background-color: rgba(137, 197, 215, 0.25);
}
.bg-story-color-300\\/30{
  background-color: rgba(137, 197, 215, 0.3);
}
.bg-story-color-300\\/35{
  background-color: rgba(137, 197, 215, 0.35);
}
.bg-story-color-300\\/40{
  background-color: rgba(137, 197, 215, 0.4);
}
.bg-story-color-300\\/45{
  background-color: rgba(137, 197, 215, 0.45);
}
.bg-story-color-300\\/5{
  background-color: rgba(137, 197, 215, 0.05);
}
.bg-story-color-300\\/50{
  background-color: rgba(137, 197, 215, 0.5);
}
.bg-story-color-300\\/55{
  background-color: rgba(137, 197, 215, 0.55);
}
.bg-story-color-300\\/60{
  background-color: rgba(137, 197, 215, 0.6);
}
.bg-story-color-300\\/65{
  background-color: rgba(137, 197, 215, 0.65);
}
.bg-story-color-300\\/70{
  background-color: rgba(137, 197, 215, 0.7);
}
.bg-story-color-300\\/75{
  background-color: rgba(137, 197, 215, 0.75);
}
.bg-story-color-300\\/80{
  background-color: rgba(137, 197, 215, 0.8);
}
.bg-story-color-300\\/85{
  background-color: rgba(137, 197, 215, 0.85);
}
.bg-story-color-300\\/90{
  background-color: rgba(137, 197, 215, 0.9);
}
.bg-story-color-300\\/95{
  background-color: rgba(137, 197, 215, 0.95);
}
.bg-story-color-400{
  --tw-bg-opacity: 1;
  background-color: rgba(82, 163, 190, 1);
  background-color: rgba(82, 163, 190, var(--tw-bg-opacity, 1));
}
.bg-story-color-400\\/0{
  background-color: rgba(82, 163, 190, 0);
}
.bg-story-color-400\\/10{
  background-color: rgba(82, 163, 190, 0.1);
}
.bg-story-color-400\\/100{
  background-color: rgb(82, 163, 190);
}
.bg-story-color-400\\/15{
  background-color: rgba(82, 163, 190, 0.15);
}
.bg-story-color-400\\/20{
  background-color: rgba(82, 163, 190, 0.2);
}
.bg-story-color-400\\/25{
  background-color: rgba(82, 163, 190, 0.25);
}
.bg-story-color-400\\/30{
  background-color: rgba(82, 163, 190, 0.3);
}
.bg-story-color-400\\/35{
  background-color: rgba(82, 163, 190, 0.35);
}
.bg-story-color-400\\/40{
  background-color: rgba(82, 163, 190, 0.4);
}
.bg-story-color-400\\/45{
  background-color: rgba(82, 163, 190, 0.45);
}
.bg-story-color-400\\/5{
  background-color: rgba(82, 163, 190, 0.05);
}
.bg-story-color-400\\/50{
  background-color: rgba(82, 163, 190, 0.5);
}
.bg-story-color-400\\/55{
  background-color: rgba(82, 163, 190, 0.55);
}
.bg-story-color-400\\/60{
  background-color: rgba(82, 163, 190, 0.6);
}
.bg-story-color-400\\/65{
  background-color: rgba(82, 163, 190, 0.65);
}
.bg-story-color-400\\/70{
  background-color: rgba(82, 163, 190, 0.7);
}
.bg-story-color-400\\/75{
  background-color: rgba(82, 163, 190, 0.75);
}
.bg-story-color-400\\/80{
  background-color: rgba(82, 163, 190, 0.8);
}
.bg-story-color-400\\/85{
  background-color: rgba(82, 163, 190, 0.85);
}
.bg-story-color-400\\/90{
  background-color: rgba(82, 163, 190, 0.9);
}
.bg-story-color-400\\/95{
  background-color: rgba(82, 163, 190, 0.95);
}
.bg-story-color-500{
  --tw-bg-opacity: 1;
  background-color: rgba(55, 135, 163, 1);
  background-color: rgba(55, 135, 163, var(--tw-bg-opacity, 1));
}
.bg-story-color-500\\/0{
  background-color: rgba(55, 135, 163, 0);
}
.bg-story-color-500\\/10{
  background-color: rgba(55, 135, 163, 0.1);
}
.bg-story-color-500\\/100{
  background-color: rgb(55, 135, 163);
}
.bg-story-color-500\\/15{
  background-color: rgba(55, 135, 163, 0.15);
}
.bg-story-color-500\\/20{
  background-color: rgba(55, 135, 163, 0.2);
}
.bg-story-color-500\\/25{
  background-color: rgba(55, 135, 163, 0.25);
}
.bg-story-color-500\\/30{
  background-color: rgba(55, 135, 163, 0.3);
}
.bg-story-color-500\\/35{
  background-color: rgba(55, 135, 163, 0.35);
}
.bg-story-color-500\\/40{
  background-color: rgba(55, 135, 163, 0.4);
}
.bg-story-color-500\\/45{
  background-color: rgba(55, 135, 163, 0.45);
}
.bg-story-color-500\\/5{
  background-color: rgba(55, 135, 163, 0.05);
}
.bg-story-color-500\\/50{
  background-color: rgba(55, 135, 163, 0.5);
}
.bg-story-color-500\\/55{
  background-color: rgba(55, 135, 163, 0.55);
}
.bg-story-color-500\\/60{
  background-color: rgba(55, 135, 163, 0.6);
}
.bg-story-color-500\\/65{
  background-color: rgba(55, 135, 163, 0.65);
}
.bg-story-color-500\\/70{
  background-color: rgba(55, 135, 163, 0.7);
}
.bg-story-color-500\\/75{
  background-color: rgba(55, 135, 163, 0.75);
}
.bg-story-color-500\\/80{
  background-color: rgba(55, 135, 163, 0.8);
}
.bg-story-color-500\\/85{
  background-color: rgba(55, 135, 163, 0.85);
}
.bg-story-color-500\\/90{
  background-color: rgba(55, 135, 163, 0.9);
}
.bg-story-color-500\\/95{
  background-color: rgba(55, 135, 163, 0.95);
}
.bg-story-color-600{
  --tw-bg-opacity: 1;
  background-color: rgba(48, 109, 138, 1);
  background-color: rgba(48, 109, 138, var(--tw-bg-opacity, 1));
}
.bg-story-color-600\\/0{
  background-color: rgba(48, 109, 138, 0);
}
.bg-story-color-600\\/10{
  background-color: rgba(48, 109, 138, 0.1);
}
.bg-story-color-600\\/100{
  background-color: rgb(48, 109, 138);
}
.bg-story-color-600\\/15{
  background-color: rgba(48, 109, 138, 0.15);
}
.bg-story-color-600\\/20{
  background-color: rgba(48, 109, 138, 0.2);
}
.bg-story-color-600\\/25{
  background-color: rgba(48, 109, 138, 0.25);
}
.bg-story-color-600\\/30{
  background-color: rgba(48, 109, 138, 0.3);
}
.bg-story-color-600\\/35{
  background-color: rgba(48, 109, 138, 0.35);
}
.bg-story-color-600\\/40{
  background-color: rgba(48, 109, 138, 0.4);
}
.bg-story-color-600\\/45{
  background-color: rgba(48, 109, 138, 0.45);
}
.bg-story-color-600\\/5{
  background-color: rgba(48, 109, 138, 0.05);
}
.bg-story-color-600\\/50{
  background-color: rgba(48, 109, 138, 0.5);
}
.bg-story-color-600\\/55{
  background-color: rgba(48, 109, 138, 0.55);
}
.bg-story-color-600\\/60{
  background-color: rgba(48, 109, 138, 0.6);
}
.bg-story-color-600\\/65{
  background-color: rgba(48, 109, 138, 0.65);
}
.bg-story-color-600\\/70{
  background-color: rgba(48, 109, 138, 0.7);
}
.bg-story-color-600\\/75{
  background-color: rgba(48, 109, 138, 0.75);
}
.bg-story-color-600\\/80{
  background-color: rgba(48, 109, 138, 0.8);
}
.bg-story-color-600\\/85{
  background-color: rgba(48, 109, 138, 0.85);
}
.bg-story-color-600\\/90{
  background-color: rgba(48, 109, 138, 0.9);
}
.bg-story-color-600\\/95{
  background-color: rgba(48, 109, 138, 0.95);
}
.bg-story-color-700{
  --tw-bg-opacity: 1;
  background-color: rgba(45, 91, 114, 1);
  background-color: rgba(45, 91, 114, var(--tw-bg-opacity, 1));
}
.bg-story-color-700\\/0{
  background-color: rgba(45, 91, 114, 0);
}
.bg-story-color-700\\/10{
  background-color: rgba(45, 91, 114, 0.1);
}
.bg-story-color-700\\/100{
  background-color: rgb(45, 91, 114);
}
.bg-story-color-700\\/15{
  background-color: rgba(45, 91, 114, 0.15);
}
.bg-story-color-700\\/20{
  background-color: rgba(45, 91, 114, 0.2);
}
.bg-story-color-700\\/25{
  background-color: rgba(45, 91, 114, 0.25);
}
.bg-story-color-700\\/30{
  background-color: rgba(45, 91, 114, 0.3);
}
.bg-story-color-700\\/35{
  background-color: rgba(45, 91, 114, 0.35);
}
.bg-story-color-700\\/40{
  background-color: rgba(45, 91, 114, 0.4);
}
.bg-story-color-700\\/45{
  background-color: rgba(45, 91, 114, 0.45);
}
.bg-story-color-700\\/5{
  background-color: rgba(45, 91, 114, 0.05);
}
.bg-story-color-700\\/50{
  background-color: rgba(45, 91, 114, 0.5);
}
.bg-story-color-700\\/55{
  background-color: rgba(45, 91, 114, 0.55);
}
.bg-story-color-700\\/60{
  background-color: rgba(45, 91, 114, 0.6);
}
.bg-story-color-700\\/65{
  background-color: rgba(45, 91, 114, 0.65);
}
.bg-story-color-700\\/70{
  background-color: rgba(45, 91, 114, 0.7);
}
.bg-story-color-700\\/75{
  background-color: rgba(45, 91, 114, 0.75);
}
.bg-story-color-700\\/80{
  background-color: rgba(45, 91, 114, 0.8);
}
.bg-story-color-700\\/85{
  background-color: rgba(45, 91, 114, 0.85);
}
.bg-story-color-700\\/90{
  background-color: rgba(45, 91, 114, 0.9);
}
.bg-story-color-700\\/95{
  background-color: rgba(45, 91, 114, 0.95);
}
.bg-story-color-800{
  --tw-bg-opacity: 1;
  background-color: rgba(44, 76, 94, 1);
  background-color: rgba(44, 76, 94, var(--tw-bg-opacity, 1));
}
.bg-story-color-800\\/0{
  background-color: rgba(44, 76, 94, 0);
}
.bg-story-color-800\\/10{
  background-color: rgba(44, 76, 94, 0.1);
}
.bg-story-color-800\\/100{
  background-color: rgb(44, 76, 94);
}
.bg-story-color-800\\/15{
  background-color: rgba(44, 76, 94, 0.15);
}
.bg-story-color-800\\/20{
  background-color: rgba(44, 76, 94, 0.2);
}
.bg-story-color-800\\/25{
  background-color: rgba(44, 76, 94, 0.25);
}
.bg-story-color-800\\/30{
  background-color: rgba(44, 76, 94, 0.3);
}
.bg-story-color-800\\/35{
  background-color: rgba(44, 76, 94, 0.35);
}
.bg-story-color-800\\/40{
  background-color: rgba(44, 76, 94, 0.4);
}
.bg-story-color-800\\/45{
  background-color: rgba(44, 76, 94, 0.45);
}
.bg-story-color-800\\/5{
  background-color: rgba(44, 76, 94, 0.05);
}
.bg-story-color-800\\/50{
  background-color: rgba(44, 76, 94, 0.5);
}
.bg-story-color-800\\/55{
  background-color: rgba(44, 76, 94, 0.55);
}
.bg-story-color-800\\/60{
  background-color: rgba(44, 76, 94, 0.6);
}
.bg-story-color-800\\/65{
  background-color: rgba(44, 76, 94, 0.65);
}
.bg-story-color-800\\/70{
  background-color: rgba(44, 76, 94, 0.7);
}
.bg-story-color-800\\/75{
  background-color: rgba(44, 76, 94, 0.75);
}
.bg-story-color-800\\/80{
  background-color: rgba(44, 76, 94, 0.8);
}
.bg-story-color-800\\/85{
  background-color: rgba(44, 76, 94, 0.85);
}
.bg-story-color-800\\/90{
  background-color: rgba(44, 76, 94, 0.9);
}
.bg-story-color-800\\/95{
  background-color: rgba(44, 76, 94, 0.95);
}
.bg-story-color-900{
  --tw-bg-opacity: 1;
  background-color: rgba(40, 65, 81, 1);
  background-color: rgba(40, 65, 81, var(--tw-bg-opacity, 1));
}
.bg-story-color-900\\/0{
  background-color: rgba(40, 65, 81, 0);
}
.bg-story-color-900\\/10{
  background-color: rgba(40, 65, 81, 0.1);
}
.bg-story-color-900\\/100{
  background-color: rgb(40, 65, 81);
}
.bg-story-color-900\\/15{
  background-color: rgba(40, 65, 81, 0.15);
}
.bg-story-color-900\\/20{
  background-color: rgba(40, 65, 81, 0.2);
}
.bg-story-color-900\\/25{
  background-color: rgba(40, 65, 81, 0.25);
}
.bg-story-color-900\\/30{
  background-color: rgba(40, 65, 81, 0.3);
}
.bg-story-color-900\\/35{
  background-color: rgba(40, 65, 81, 0.35);
}
.bg-story-color-900\\/40{
  background-color: rgba(40, 65, 81, 0.4);
}
.bg-story-color-900\\/45{
  background-color: rgba(40, 65, 81, 0.45);
}
.bg-story-color-900\\/5{
  background-color: rgba(40, 65, 81, 0.05);
}
.bg-story-color-900\\/50{
  background-color: rgba(40, 65, 81, 0.5);
}
.bg-story-color-900\\/55{
  background-color: rgba(40, 65, 81, 0.55);
}
.bg-story-color-900\\/60{
  background-color: rgba(40, 65, 81, 0.6);
}
.bg-story-color-900\\/65{
  background-color: rgba(40, 65, 81, 0.65);
}
.bg-story-color-900\\/70{
  background-color: rgba(40, 65, 81, 0.7);
}
.bg-story-color-900\\/75{
  background-color: rgba(40, 65, 81, 0.75);
}
.bg-story-color-900\\/80{
  background-color: rgba(40, 65, 81, 0.8);
}
.bg-story-color-900\\/85{
  background-color: rgba(40, 65, 81, 0.85);
}
.bg-story-color-900\\/90{
  background-color: rgba(40, 65, 81, 0.9);
}
.bg-story-color-900\\/95{
  background-color: rgba(40, 65, 81, 0.95);
}
.bg-story-color-950{
  --tw-bg-opacity: 1;
  background-color: rgba(22, 41, 54, 1);
  background-color: rgba(22, 41, 54, var(--tw-bg-opacity, 1));
}
.bg-story-color-950\\/0{
  background-color: rgba(22, 41, 54, 0);
}
.bg-story-color-950\\/10{
  background-color: rgba(22, 41, 54, 0.1);
}
.bg-story-color-950\\/100{
  background-color: rgb(22, 41, 54);
}
.bg-story-color-950\\/15{
  background-color: rgba(22, 41, 54, 0.15);
}
.bg-story-color-950\\/20{
  background-color: rgba(22, 41, 54, 0.2);
}
.bg-story-color-950\\/25{
  background-color: rgba(22, 41, 54, 0.25);
}
.bg-story-color-950\\/30{
  background-color: rgba(22, 41, 54, 0.3);
}
.bg-story-color-950\\/35{
  background-color: rgba(22, 41, 54, 0.35);
}
.bg-story-color-950\\/40{
  background-color: rgba(22, 41, 54, 0.4);
}
.bg-story-color-950\\/45{
  background-color: rgba(22, 41, 54, 0.45);
}
.bg-story-color-950\\/5{
  background-color: rgba(22, 41, 54, 0.05);
}
.bg-story-color-950\\/50{
  background-color: rgba(22, 41, 54, 0.5);
}
.bg-story-color-950\\/55{
  background-color: rgba(22, 41, 54, 0.55);
}
.bg-story-color-950\\/60{
  background-color: rgba(22, 41, 54, 0.6);
}
.bg-story-color-950\\/65{
  background-color: rgba(22, 41, 54, 0.65);
}
.bg-story-color-950\\/70{
  background-color: rgba(22, 41, 54, 0.7);
}
.bg-story-color-950\\/75{
  background-color: rgba(22, 41, 54, 0.75);
}
.bg-story-color-950\\/80{
  background-color: rgba(22, 41, 54, 0.8);
}
.bg-story-color-950\\/85{
  background-color: rgba(22, 41, 54, 0.85);
}
.bg-story-color-950\\/90{
  background-color: rgba(22, 41, 54, 0.9);
}
.bg-story-color-950\\/95{
  background-color: rgba(22, 41, 54, 0.95);
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
}
.bg-word-color-100{
  --tw-bg-opacity: 1;
  background-color: rgba(217, 242, 230, 1);
  background-color: rgba(217, 242, 230, var(--tw-bg-opacity, 1));
}
.bg-word-color-100\\/0{
  background-color: rgba(217, 242, 230, 0);
}
.bg-word-color-100\\/10{
  background-color: rgba(217, 242, 230, 0.1);
}
.bg-word-color-100\\/100{
  background-color: rgb(217, 242, 230);
}
.bg-word-color-100\\/15{
  background-color: rgba(217, 242, 230, 0.15);
}
.bg-word-color-100\\/20{
  background-color: rgba(217, 242, 230, 0.2);
}
.bg-word-color-100\\/25{
  background-color: rgba(217, 242, 230, 0.25);
}
.bg-word-color-100\\/30{
  background-color: rgba(217, 242, 230, 0.3);
}
.bg-word-color-100\\/35{
  background-color: rgba(217, 242, 230, 0.35);
}
.bg-word-color-100\\/40{
  background-color: rgba(217, 242, 230, 0.4);
}
.bg-word-color-100\\/45{
  background-color: rgba(217, 242, 230, 0.45);
}
.bg-word-color-100\\/5{
  background-color: rgba(217, 242, 230, 0.05);
}
.bg-word-color-100\\/50{
  background-color: rgba(217, 242, 230, 0.5);
}
.bg-word-color-100\\/55{
  background-color: rgba(217, 242, 230, 0.55);
}
.bg-word-color-100\\/60{
  background-color: rgba(217, 242, 230, 0.6);
}
.bg-word-color-100\\/65{
  background-color: rgba(217, 242, 230, 0.65);
}
.bg-word-color-100\\/70{
  background-color: rgba(217, 242, 230, 0.7);
}
.bg-word-color-100\\/75{
  background-color: rgba(217, 242, 230, 0.75);
}
.bg-word-color-100\\/80{
  background-color: rgba(217, 242, 230, 0.8);
}
.bg-word-color-100\\/85{
  background-color: rgba(217, 242, 230, 0.85);
}
.bg-word-color-100\\/90{
  background-color: rgba(217, 242, 230, 0.9);
}
.bg-word-color-100\\/95{
  background-color: rgba(217, 242, 230, 0.95);
}
.bg-word-color-200{
  --tw-bg-opacity: 1;
  background-color: rgba(182, 228, 209, 1);
  background-color: rgba(182, 228, 209, var(--tw-bg-opacity, 1));
}
.bg-word-color-200\\/0{
  background-color: rgba(182, 228, 209, 0);
}
.bg-word-color-200\\/10{
  background-color: rgba(182, 228, 209, 0.1);
}
.bg-word-color-200\\/100{
  background-color: rgb(182, 228, 209);
}
.bg-word-color-200\\/15{
  background-color: rgba(182, 228, 209, 0.15);
}
.bg-word-color-200\\/20{
  background-color: rgba(182, 228, 209, 0.2);
}
.bg-word-color-200\\/25{
  background-color: rgba(182, 228, 209, 0.25);
}
.bg-word-color-200\\/30{
  background-color: rgba(182, 228, 209, 0.3);
}
.bg-word-color-200\\/35{
  background-color: rgba(182, 228, 209, 0.35);
}
.bg-word-color-200\\/40{
  background-color: rgba(182, 228, 209, 0.4);
}
.bg-word-color-200\\/45{
  background-color: rgba(182, 228, 209, 0.45);
}
.bg-word-color-200\\/5{
  background-color: rgba(182, 228, 209, 0.05);
}
.bg-word-color-200\\/50{
  background-color: rgba(182, 228, 209, 0.5);
}
.bg-word-color-200\\/55{
  background-color: rgba(182, 228, 209, 0.55);
}
.bg-word-color-200\\/60{
  background-color: rgba(182, 228, 209, 0.6);
}
.bg-word-color-200\\/65{
  background-color: rgba(182, 228, 209, 0.65);
}
.bg-word-color-200\\/70{
  background-color: rgba(182, 228, 209, 0.7);
}
.bg-word-color-200\\/75{
  background-color: rgba(182, 228, 209, 0.75);
}
.bg-word-color-200\\/80{
  background-color: rgba(182, 228, 209, 0.8);
}
.bg-word-color-200\\/85{
  background-color: rgba(182, 228, 209, 0.85);
}
.bg-word-color-200\\/90{
  background-color: rgba(182, 228, 209, 0.9);
}
.bg-word-color-200\\/95{
  background-color: rgba(182, 228, 209, 0.95);
}
.bg-word-color-300{
  --tw-bg-opacity: 1;
  background-color: rgba(134, 207, 181, 1);
  background-color: rgba(134, 207, 181, var(--tw-bg-opacity, 1));
}
.bg-word-color-300\\/0{
  background-color: rgba(134, 207, 181, 0);
}
.bg-word-color-300\\/10{
  background-color: rgba(134, 207, 181, 0.1);
}
.bg-word-color-300\\/100{
  background-color: rgb(134, 207, 181);
}
.bg-word-color-300\\/15{
  background-color: rgba(134, 207, 181, 0.15);
}
.bg-word-color-300\\/20{
  background-color: rgba(134, 207, 181, 0.2);
}
.bg-word-color-300\\/25{
  background-color: rgba(134, 207, 181, 0.25);
}
.bg-word-color-300\\/30{
  background-color: rgba(134, 207, 181, 0.3);
}
.bg-word-color-300\\/35{
  background-color: rgba(134, 207, 181, 0.35);
}
.bg-word-color-300\\/40{
  background-color: rgba(134, 207, 181, 0.4);
}
.bg-word-color-300\\/45{
  background-color: rgba(134, 207, 181, 0.45);
}
.bg-word-color-300\\/5{
  background-color: rgba(134, 207, 181, 0.05);
}
.bg-word-color-300\\/50{
  background-color: rgba(134, 207, 181, 0.5);
}
.bg-word-color-300\\/55{
  background-color: rgba(134, 207, 181, 0.55);
}
.bg-word-color-300\\/60{
  background-color: rgba(134, 207, 181, 0.6);
}
.bg-word-color-300\\/65{
  background-color: rgba(134, 207, 181, 0.65);
}
.bg-word-color-300\\/70{
  background-color: rgba(134, 207, 181, 0.7);
}
.bg-word-color-300\\/75{
  background-color: rgba(134, 207, 181, 0.75);
}
.bg-word-color-300\\/80{
  background-color: rgba(134, 207, 181, 0.8);
}
.bg-word-color-300\\/85{
  background-color: rgba(134, 207, 181, 0.85);
}
.bg-word-color-300\\/90{
  background-color: rgba(134, 207, 181, 0.9);
}
.bg-word-color-300\\/95{
  background-color: rgba(134, 207, 181, 0.95);
}
.bg-word-color-400{
  --tw-bg-opacity: 1;
  background-color: rgba(83, 180, 148, 1);
  background-color: rgba(83, 180, 148, var(--tw-bg-opacity, 1));
}
.bg-word-color-400\\/0{
  background-color: rgba(83, 180, 148, 0);
}
.bg-word-color-400\\/10{
  background-color: rgba(83, 180, 148, 0.1);
}
.bg-word-color-400\\/100{
  background-color: rgb(83, 180, 148);
}
.bg-word-color-400\\/15{
  background-color: rgba(83, 180, 148, 0.15);
}
.bg-word-color-400\\/20{
  background-color: rgba(83, 180, 148, 0.2);
}
.bg-word-color-400\\/25{
  background-color: rgba(83, 180, 148, 0.25);
}
.bg-word-color-400\\/30{
  background-color: rgba(83, 180, 148, 0.3);
}
.bg-word-color-400\\/35{
  background-color: rgba(83, 180, 148, 0.35);
}
.bg-word-color-400\\/40{
  background-color: rgba(83, 180, 148, 0.4);
}
.bg-word-color-400\\/45{
  background-color: rgba(83, 180, 148, 0.45);
}
.bg-word-color-400\\/5{
  background-color: rgba(83, 180, 148, 0.05);
}
.bg-word-color-400\\/50{
  background-color: rgba(83, 180, 148, 0.5);
}
.bg-word-color-400\\/55{
  background-color: rgba(83, 180, 148, 0.55);
}
.bg-word-color-400\\/60{
  background-color: rgba(83, 180, 148, 0.6);
}
.bg-word-color-400\\/65{
  background-color: rgba(83, 180, 148, 0.65);
}
.bg-word-color-400\\/70{
  background-color: rgba(83, 180, 148, 0.7);
}
.bg-word-color-400\\/75{
  background-color: rgba(83, 180, 148, 0.75);
}
.bg-word-color-400\\/80{
  background-color: rgba(83, 180, 148, 0.8);
}
.bg-word-color-400\\/85{
  background-color: rgba(83, 180, 148, 0.85);
}
.bg-word-color-400\\/90{
  background-color: rgba(83, 180, 148, 0.9);
}
.bg-word-color-400\\/95{
  background-color: rgba(83, 180, 148, 0.95);
}
.bg-word-color-500{
  --tw-bg-opacity: 1;
  background-color: rgba(44, 135, 109, 1);
  background-color: rgba(44, 135, 109, var(--tw-bg-opacity, 1));
}
.bg-word-color-500\\/0{
  background-color: rgba(44, 135, 109, 0);
}
.bg-word-color-500\\/10{
  background-color: rgba(44, 135, 109, 0.1);
}
.bg-word-color-500\\/100{
  background-color: rgb(44, 135, 109);
}
.bg-word-color-500\\/15{
  background-color: rgba(44, 135, 109, 0.15);
}
.bg-word-color-500\\/20{
  background-color: rgba(44, 135, 109, 0.2);
}
.bg-word-color-500\\/25{
  background-color: rgba(44, 135, 109, 0.25);
}
.bg-word-color-500\\/30{
  background-color: rgba(44, 135, 109, 0.3);
}
.bg-word-color-500\\/35{
  background-color: rgba(44, 135, 109, 0.35);
}
.bg-word-color-500\\/40{
  background-color: rgba(44, 135, 109, 0.4);
}
.bg-word-color-500\\/45{
  background-color: rgba(44, 135, 109, 0.45);
}
.bg-word-color-500\\/5{
  background-color: rgba(44, 135, 109, 0.05);
}
.bg-word-color-500\\/50{
  background-color: rgba(44, 135, 109, 0.5);
}
.bg-word-color-500\\/55{
  background-color: rgba(44, 135, 109, 0.55);
}
.bg-word-color-500\\/60{
  background-color: rgba(44, 135, 109, 0.6);
}
.bg-word-color-500\\/65{
  background-color: rgba(44, 135, 109, 0.65);
}
.bg-word-color-500\\/70{
  background-color: rgba(44, 135, 109, 0.7);
}
.bg-word-color-500\\/75{
  background-color: rgba(44, 135, 109, 0.75);
}
.bg-word-color-500\\/80{
  background-color: rgba(44, 135, 109, 0.8);
}
.bg-word-color-500\\/85{
  background-color: rgba(44, 135, 109, 0.85);
}
.bg-word-color-500\\/90{
  background-color: rgba(44, 135, 109, 0.9);
}
.bg-word-color-500\\/95{
  background-color: rgba(44, 135, 109, 0.95);
}
.bg-word-color-600{
  --tw-bg-opacity: 1;
  background-color: rgba(34, 121, 98, 1);
  background-color: rgba(34, 121, 98, var(--tw-bg-opacity, 1));
}
.bg-word-color-600\\/0{
  background-color: rgba(34, 121, 98, 0);
}
.bg-word-color-600\\/10{
  background-color: rgba(34, 121, 98, 0.1);
}
.bg-word-color-600\\/100{
  background-color: rgb(34, 121, 98);
}
.bg-word-color-600\\/15{
  background-color: rgba(34, 121, 98, 0.15);
}
.bg-word-color-600\\/20{
  background-color: rgba(34, 121, 98, 0.2);
}
.bg-word-color-600\\/25{
  background-color: rgba(34, 121, 98, 0.25);
}
.bg-word-color-600\\/30{
  background-color: rgba(34, 121, 98, 0.3);
}
.bg-word-color-600\\/35{
  background-color: rgba(34, 121, 98, 0.35);
}
.bg-word-color-600\\/40{
  background-color: rgba(34, 121, 98, 0.4);
}
.bg-word-color-600\\/45{
  background-color: rgba(34, 121, 98, 0.45);
}
.bg-word-color-600\\/5{
  background-color: rgba(34, 121, 98, 0.05);
}
.bg-word-color-600\\/50{
  background-color: rgba(34, 121, 98, 0.5);
}
.bg-word-color-600\\/55{
  background-color: rgba(34, 121, 98, 0.55);
}
.bg-word-color-600\\/60{
  background-color: rgba(34, 121, 98, 0.6);
}
.bg-word-color-600\\/65{
  background-color: rgba(34, 121, 98, 0.65);
}
.bg-word-color-600\\/70{
  background-color: rgba(34, 121, 98, 0.7);
}
.bg-word-color-600\\/75{
  background-color: rgba(34, 121, 98, 0.75);
}
.bg-word-color-600\\/80{
  background-color: rgba(34, 121, 98, 0.8);
}
.bg-word-color-600\\/85{
  background-color: rgba(34, 121, 98, 0.85);
}
.bg-word-color-600\\/90{
  background-color: rgba(34, 121, 98, 0.9);
}
.bg-word-color-600\\/95{
  background-color: rgba(34, 121, 98, 0.95);
}
.bg-word-color-700{
  --tw-bg-opacity: 1;
  background-color: rgba(27, 97, 80, 1);
  background-color: rgba(27, 97, 80, var(--tw-bg-opacity, 1));
}
.bg-word-color-700\\/0{
  background-color: rgba(27, 97, 80, 0);
}
.bg-word-color-700\\/10{
  background-color: rgba(27, 97, 80, 0.1);
}
.bg-word-color-700\\/100{
  background-color: rgb(27, 97, 80);
}
.bg-word-color-700\\/15{
  background-color: rgba(27, 97, 80, 0.15);
}
.bg-word-color-700\\/20{
  background-color: rgba(27, 97, 80, 0.2);
}
.bg-word-color-700\\/25{
  background-color: rgba(27, 97, 80, 0.25);
}
.bg-word-color-700\\/30{
  background-color: rgba(27, 97, 80, 0.3);
}
.bg-word-color-700\\/35{
  background-color: rgba(27, 97, 80, 0.35);
}
.bg-word-color-700\\/40{
  background-color: rgba(27, 97, 80, 0.4);
}
.bg-word-color-700\\/45{
  background-color: rgba(27, 97, 80, 0.45);
}
.bg-word-color-700\\/5{
  background-color: rgba(27, 97, 80, 0.05);
}
.bg-word-color-700\\/50{
  background-color: rgba(27, 97, 80, 0.5);
}
.bg-word-color-700\\/55{
  background-color: rgba(27, 97, 80, 0.55);
}
.bg-word-color-700\\/60{
  background-color: rgba(27, 97, 80, 0.6);
}
.bg-word-color-700\\/65{
  background-color: rgba(27, 97, 80, 0.65);
}
.bg-word-color-700\\/70{
  background-color: rgba(27, 97, 80, 0.7);
}
.bg-word-color-700\\/75{
  background-color: rgba(27, 97, 80, 0.75);
}
.bg-word-color-700\\/80{
  background-color: rgba(27, 97, 80, 0.8);
}
.bg-word-color-700\\/85{
  background-color: rgba(27, 97, 80, 0.85);
}
.bg-word-color-700\\/90{
  background-color: rgba(27, 97, 80, 0.9);
}
.bg-word-color-700\\/95{
  background-color: rgba(27, 97, 80, 0.95);
}
.bg-word-color-800{
  --tw-bg-opacity: 1;
  background-color: rgba(24, 77, 64, 1);
  background-color: rgba(24, 77, 64, var(--tw-bg-opacity, 1));
}
.bg-word-color-800\\/0{
  background-color: rgba(24, 77, 64, 0);
}
.bg-word-color-800\\/10{
  background-color: rgba(24, 77, 64, 0.1);
}
.bg-word-color-800\\/100{
  background-color: rgb(24, 77, 64);
}
.bg-word-color-800\\/15{
  background-color: rgba(24, 77, 64, 0.15);
}
.bg-word-color-800\\/20{
  background-color: rgba(24, 77, 64, 0.2);
}
.bg-word-color-800\\/25{
  background-color: rgba(24, 77, 64, 0.25);
}
.bg-word-color-800\\/30{
  background-color: rgba(24, 77, 64, 0.3);
}
.bg-word-color-800\\/35{
  background-color: rgba(24, 77, 64, 0.35);
}
.bg-word-color-800\\/40{
  background-color: rgba(24, 77, 64, 0.4);
}
.bg-word-color-800\\/45{
  background-color: rgba(24, 77, 64, 0.45);
}
.bg-word-color-800\\/5{
  background-color: rgba(24, 77, 64, 0.05);
}
.bg-word-color-800\\/50{
  background-color: rgba(24, 77, 64, 0.5);
}
.bg-word-color-800\\/55{
  background-color: rgba(24, 77, 64, 0.55);
}
.bg-word-color-800\\/60{
  background-color: rgba(24, 77, 64, 0.6);
}
.bg-word-color-800\\/65{
  background-color: rgba(24, 77, 64, 0.65);
}
.bg-word-color-800\\/70{
  background-color: rgba(24, 77, 64, 0.7);
}
.bg-word-color-800\\/75{
  background-color: rgba(24, 77, 64, 0.75);
}
.bg-word-color-800\\/80{
  background-color: rgba(24, 77, 64, 0.8);
}
.bg-word-color-800\\/85{
  background-color: rgba(24, 77, 64, 0.85);
}
.bg-word-color-800\\/90{
  background-color: rgba(24, 77, 64, 0.9);
}
.bg-word-color-800\\/95{
  background-color: rgba(24, 77, 64, 0.95);
}
.bg-word-color-900{
  --tw-bg-opacity: 1;
  background-color: rgba(20, 64, 54, 1);
  background-color: rgba(20, 64, 54, var(--tw-bg-opacity, 1));
}
.bg-word-color-900\\/0{
  background-color: rgba(20, 64, 54, 0);
}
.bg-word-color-900\\/10{
  background-color: rgba(20, 64, 54, 0.1);
}
.bg-word-color-900\\/100{
  background-color: rgb(20, 64, 54);
}
.bg-word-color-900\\/15{
  background-color: rgba(20, 64, 54, 0.15);
}
.bg-word-color-900\\/20{
  background-color: rgba(20, 64, 54, 0.2);
}
.bg-word-color-900\\/25{
  background-color: rgba(20, 64, 54, 0.25);
}
.bg-word-color-900\\/30{
  background-color: rgba(20, 64, 54, 0.3);
}
.bg-word-color-900\\/35{
  background-color: rgba(20, 64, 54, 0.35);
}
.bg-word-color-900\\/40{
  background-color: rgba(20, 64, 54, 0.4);
}
.bg-word-color-900\\/45{
  background-color: rgba(20, 64, 54, 0.45);
}
.bg-word-color-900\\/5{
  background-color: rgba(20, 64, 54, 0.05);
}
.bg-word-color-900\\/50{
  background-color: rgba(20, 64, 54, 0.5);
}
.bg-word-color-900\\/55{
  background-color: rgba(20, 64, 54, 0.55);
}
.bg-word-color-900\\/60{
  background-color: rgba(20, 64, 54, 0.6);
}
.bg-word-color-900\\/65{
  background-color: rgba(20, 64, 54, 0.65);
}
.bg-word-color-900\\/70{
  background-color: rgba(20, 64, 54, 0.7);
}
.bg-word-color-900\\/75{
  background-color: rgba(20, 64, 54, 0.75);
}
.bg-word-color-900\\/80{
  background-color: rgba(20, 64, 54, 0.8);
}
.bg-word-color-900\\/85{
  background-color: rgba(20, 64, 54, 0.85);
}
.bg-word-color-900\\/90{
  background-color: rgba(20, 64, 54, 0.9);
}
.bg-word-color-900\\/95{
  background-color: rgba(20, 64, 54, 0.95);
}
.bg-word-color-950{
  --tw-bg-opacity: 1;
  background-color: rgba(10, 36, 31, 1);
  background-color: rgba(10, 36, 31, var(--tw-bg-opacity, 1));
}
.bg-word-color-950\\/0{
  background-color: rgba(10, 36, 31, 0);
}
.bg-word-color-950\\/10{
  background-color: rgba(10, 36, 31, 0.1);
}
.bg-word-color-950\\/100{
  background-color: rgb(10, 36, 31);
}
.bg-word-color-950\\/15{
  background-color: rgba(10, 36, 31, 0.15);
}
.bg-word-color-950\\/20{
  background-color: rgba(10, 36, 31, 0.2);
}
.bg-word-color-950\\/25{
  background-color: rgba(10, 36, 31, 0.25);
}
.bg-word-color-950\\/30{
  background-color: rgba(10, 36, 31, 0.3);
}
.bg-word-color-950\\/35{
  background-color: rgba(10, 36, 31, 0.35);
}
.bg-word-color-950\\/40{
  background-color: rgba(10, 36, 31, 0.4);
}
.bg-word-color-950\\/45{
  background-color: rgba(10, 36, 31, 0.45);
}
.bg-word-color-950\\/5{
  background-color: rgba(10, 36, 31, 0.05);
}
.bg-word-color-950\\/50{
  background-color: rgba(10, 36, 31, 0.5);
}
.bg-word-color-950\\/55{
  background-color: rgba(10, 36, 31, 0.55);
}
.bg-word-color-950\\/60{
  background-color: rgba(10, 36, 31, 0.6);
}
.bg-word-color-950\\/65{
  background-color: rgba(10, 36, 31, 0.65);
}
.bg-word-color-950\\/70{
  background-color: rgba(10, 36, 31, 0.7);
}
.bg-word-color-950\\/75{
  background-color: rgba(10, 36, 31, 0.75);
}
.bg-word-color-950\\/80{
  background-color: rgba(10, 36, 31, 0.8);
}
.bg-word-color-950\\/85{
  background-color: rgba(10, 36, 31, 0.85);
}
.bg-word-color-950\\/90{
  background-color: rgba(10, 36, 31, 0.9);
}
.bg-word-color-950\\/95{
  background-color: rgba(10, 36, 31, 0.95);
}
.bg-wordsy-correct{
  --tw-bg-opacity: 1;
  background-color: rgba(44, 135, 109, 1);
  background-color: rgba(44, 135, 109, var(--tw-bg-opacity, 1));
}
.bg-wordsy-present{
  --tw-bg-opacity: 1;
  background-color: rgba(195, 120, 41, 1);
  background-color: rgba(195, 120, 41, var(--tw-bg-opacity, 1));
}
.bg-opacity-75{
  --tw-bg-opacity: 0.75;
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-none{
  background-image: none;
}
.from-blumine-100{
  --tw-gradient-from: #daeef3 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/0{
  --tw-gradient-from: rgba(218, 238, 243, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/10{
  --tw-gradient-from: rgba(218, 238, 243, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/100{
  --tw-gradient-from: rgb(218, 238, 243) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/15{
  --tw-gradient-from: rgba(218, 238, 243, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/20{
  --tw-gradient-from: rgba(218, 238, 243, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/25{
  --tw-gradient-from: rgba(218, 238, 243, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/30{
  --tw-gradient-from: rgba(218, 238, 243, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/35{
  --tw-gradient-from: rgba(218, 238, 243, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/40{
  --tw-gradient-from: rgba(218, 238, 243, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/45{
  --tw-gradient-from: rgba(218, 238, 243, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/5{
  --tw-gradient-from: rgba(218, 238, 243, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/50{
  --tw-gradient-from: rgba(218, 238, 243, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/55{
  --tw-gradient-from: rgba(218, 238, 243, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/60{
  --tw-gradient-from: rgba(218, 238, 243, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/65{
  --tw-gradient-from: rgba(218, 238, 243, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/70{
  --tw-gradient-from: rgba(218, 238, 243, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/75{
  --tw-gradient-from: rgba(218, 238, 243, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/80{
  --tw-gradient-from: rgba(218, 238, 243, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/85{
  --tw-gradient-from: rgba(218, 238, 243, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/90{
  --tw-gradient-from: rgba(218, 238, 243, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-100\\/95{
  --tw-gradient-from: rgba(218, 238, 243, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200{
  --tw-gradient-from: #badee7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/0{
  --tw-gradient-from: rgba(186, 222, 231, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/10{
  --tw-gradient-from: rgba(186, 222, 231, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/100{
  --tw-gradient-from: rgb(186, 222, 231) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/15{
  --tw-gradient-from: rgba(186, 222, 231, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/20{
  --tw-gradient-from: rgba(186, 222, 231, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/25{
  --tw-gradient-from: rgba(186, 222, 231, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/30{
  --tw-gradient-from: rgba(186, 222, 231, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/35{
  --tw-gradient-from: rgba(186, 222, 231, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/40{
  --tw-gradient-from: rgba(186, 222, 231, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/45{
  --tw-gradient-from: rgba(186, 222, 231, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/5{
  --tw-gradient-from: rgba(186, 222, 231, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/50{
  --tw-gradient-from: rgba(186, 222, 231, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/55{
  --tw-gradient-from: rgba(186, 222, 231, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/60{
  --tw-gradient-from: rgba(186, 222, 231, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/65{
  --tw-gradient-from: rgba(186, 222, 231, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/70{
  --tw-gradient-from: rgba(186, 222, 231, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/75{
  --tw-gradient-from: rgba(186, 222, 231, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/80{
  --tw-gradient-from: rgba(186, 222, 231, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/85{
  --tw-gradient-from: rgba(186, 222, 231, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/90{
  --tw-gradient-from: rgba(186, 222, 231, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-200\\/95{
  --tw-gradient-from: rgba(186, 222, 231, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300{
  --tw-gradient-from: #89c5d7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/0{
  --tw-gradient-from: rgba(137, 197, 215, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/10{
  --tw-gradient-from: rgba(137, 197, 215, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/100{
  --tw-gradient-from: rgb(137, 197, 215) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/15{
  --tw-gradient-from: rgba(137, 197, 215, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/20{
  --tw-gradient-from: rgba(137, 197, 215, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/25{
  --tw-gradient-from: rgba(137, 197, 215, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/30{
  --tw-gradient-from: rgba(137, 197, 215, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/35{
  --tw-gradient-from: rgba(137, 197, 215, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/40{
  --tw-gradient-from: rgba(137, 197, 215, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/45{
  --tw-gradient-from: rgba(137, 197, 215, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/5{
  --tw-gradient-from: rgba(137, 197, 215, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/50{
  --tw-gradient-from: rgba(137, 197, 215, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/55{
  --tw-gradient-from: rgba(137, 197, 215, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/60{
  --tw-gradient-from: rgba(137, 197, 215, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/65{
  --tw-gradient-from: rgba(137, 197, 215, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/70{
  --tw-gradient-from: rgba(137, 197, 215, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/75{
  --tw-gradient-from: rgba(137, 197, 215, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/80{
  --tw-gradient-from: rgba(137, 197, 215, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/85{
  --tw-gradient-from: rgba(137, 197, 215, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/90{
  --tw-gradient-from: rgba(137, 197, 215, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-300\\/95{
  --tw-gradient-from: rgba(137, 197, 215, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400{
  --tw-gradient-from: #52a3be var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/0{
  --tw-gradient-from: rgba(82, 163, 190, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/10{
  --tw-gradient-from: rgba(82, 163, 190, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/100{
  --tw-gradient-from: rgb(82, 163, 190) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/15{
  --tw-gradient-from: rgba(82, 163, 190, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/20{
  --tw-gradient-from: rgba(82, 163, 190, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/25{
  --tw-gradient-from: rgba(82, 163, 190, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/30{
  --tw-gradient-from: rgba(82, 163, 190, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/35{
  --tw-gradient-from: rgba(82, 163, 190, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/40{
  --tw-gradient-from: rgba(82, 163, 190, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/45{
  --tw-gradient-from: rgba(82, 163, 190, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/5{
  --tw-gradient-from: rgba(82, 163, 190, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/50{
  --tw-gradient-from: rgba(82, 163, 190, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/55{
  --tw-gradient-from: rgba(82, 163, 190, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/60{
  --tw-gradient-from: rgba(82, 163, 190, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/65{
  --tw-gradient-from: rgba(82, 163, 190, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/70{
  --tw-gradient-from: rgba(82, 163, 190, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/75{
  --tw-gradient-from: rgba(82, 163, 190, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/80{
  --tw-gradient-from: rgba(82, 163, 190, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/85{
  --tw-gradient-from: rgba(82, 163, 190, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/90{
  --tw-gradient-from: rgba(82, 163, 190, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-400\\/95{
  --tw-gradient-from: rgba(82, 163, 190, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500{
  --tw-gradient-from: #3787a3 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/0{
  --tw-gradient-from: rgba(55, 135, 163, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/10{
  --tw-gradient-from: rgba(55, 135, 163, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/100{
  --tw-gradient-from: rgb(55, 135, 163) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/15{
  --tw-gradient-from: rgba(55, 135, 163, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/20{
  --tw-gradient-from: rgba(55, 135, 163, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/25{
  --tw-gradient-from: rgba(55, 135, 163, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/30{
  --tw-gradient-from: rgba(55, 135, 163, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/35{
  --tw-gradient-from: rgba(55, 135, 163, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/40{
  --tw-gradient-from: rgba(55, 135, 163, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/45{
  --tw-gradient-from: rgba(55, 135, 163, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/5{
  --tw-gradient-from: rgba(55, 135, 163, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/50{
  --tw-gradient-from: rgba(55, 135, 163, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/55{
  --tw-gradient-from: rgba(55, 135, 163, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/60{
  --tw-gradient-from: rgba(55, 135, 163, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/65{
  --tw-gradient-from: rgba(55, 135, 163, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/70{
  --tw-gradient-from: rgba(55, 135, 163, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/75{
  --tw-gradient-from: rgba(55, 135, 163, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/80{
  --tw-gradient-from: rgba(55, 135, 163, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/85{
  --tw-gradient-from: rgba(55, 135, 163, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/90{
  --tw-gradient-from: rgba(55, 135, 163, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-500\\/95{
  --tw-gradient-from: rgba(55, 135, 163, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600{
  --tw-gradient-from: #306d8a var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/0{
  --tw-gradient-from: rgba(48, 109, 138, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/10{
  --tw-gradient-from: rgba(48, 109, 138, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/100{
  --tw-gradient-from: rgb(48, 109, 138) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/15{
  --tw-gradient-from: rgba(48, 109, 138, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/20{
  --tw-gradient-from: rgba(48, 109, 138, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/25{
  --tw-gradient-from: rgba(48, 109, 138, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/30{
  --tw-gradient-from: rgba(48, 109, 138, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/35{
  --tw-gradient-from: rgba(48, 109, 138, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/40{
  --tw-gradient-from: rgba(48, 109, 138, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/45{
  --tw-gradient-from: rgba(48, 109, 138, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/5{
  --tw-gradient-from: rgba(48, 109, 138, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/50{
  --tw-gradient-from: rgba(48, 109, 138, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/55{
  --tw-gradient-from: rgba(48, 109, 138, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/60{
  --tw-gradient-from: rgba(48, 109, 138, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/65{
  --tw-gradient-from: rgba(48, 109, 138, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/70{
  --tw-gradient-from: rgba(48, 109, 138, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/75{
  --tw-gradient-from: rgba(48, 109, 138, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/80{
  --tw-gradient-from: rgba(48, 109, 138, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/85{
  --tw-gradient-from: rgba(48, 109, 138, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/90{
  --tw-gradient-from: rgba(48, 109, 138, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-600\\/95{
  --tw-gradient-from: rgba(48, 109, 138, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700{
  --tw-gradient-from: #2d5b72 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/0{
  --tw-gradient-from: rgba(45, 91, 114, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/10{
  --tw-gradient-from: rgba(45, 91, 114, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/100{
  --tw-gradient-from: rgb(45, 91, 114) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/15{
  --tw-gradient-from: rgba(45, 91, 114, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/20{
  --tw-gradient-from: rgba(45, 91, 114, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/25{
  --tw-gradient-from: rgba(45, 91, 114, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/30{
  --tw-gradient-from: rgba(45, 91, 114, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/35{
  --tw-gradient-from: rgba(45, 91, 114, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/40{
  --tw-gradient-from: rgba(45, 91, 114, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/45{
  --tw-gradient-from: rgba(45, 91, 114, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/5{
  --tw-gradient-from: rgba(45, 91, 114, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/50{
  --tw-gradient-from: rgba(45, 91, 114, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/55{
  --tw-gradient-from: rgba(45, 91, 114, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/60{
  --tw-gradient-from: rgba(45, 91, 114, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/65{
  --tw-gradient-from: rgba(45, 91, 114, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/70{
  --tw-gradient-from: rgba(45, 91, 114, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/75{
  --tw-gradient-from: rgba(45, 91, 114, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/80{
  --tw-gradient-from: rgba(45, 91, 114, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/85{
  --tw-gradient-from: rgba(45, 91, 114, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/90{
  --tw-gradient-from: rgba(45, 91, 114, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-700\\/95{
  --tw-gradient-from: rgba(45, 91, 114, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800{
  --tw-gradient-from: #2c4c5e var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/0{
  --tw-gradient-from: rgba(44, 76, 94, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/10{
  --tw-gradient-from: rgba(44, 76, 94, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/100{
  --tw-gradient-from: rgb(44, 76, 94) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/15{
  --tw-gradient-from: rgba(44, 76, 94, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/20{
  --tw-gradient-from: rgba(44, 76, 94, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/25{
  --tw-gradient-from: rgba(44, 76, 94, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/30{
  --tw-gradient-from: rgba(44, 76, 94, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/35{
  --tw-gradient-from: rgba(44, 76, 94, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/40{
  --tw-gradient-from: rgba(44, 76, 94, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/45{
  --tw-gradient-from: rgba(44, 76, 94, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/5{
  --tw-gradient-from: rgba(44, 76, 94, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/50{
  --tw-gradient-from: rgba(44, 76, 94, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/55{
  --tw-gradient-from: rgba(44, 76, 94, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/60{
  --tw-gradient-from: rgba(44, 76, 94, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/65{
  --tw-gradient-from: rgba(44, 76, 94, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/70{
  --tw-gradient-from: rgba(44, 76, 94, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/75{
  --tw-gradient-from: rgba(44, 76, 94, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/80{
  --tw-gradient-from: rgba(44, 76, 94, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/85{
  --tw-gradient-from: rgba(44, 76, 94, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/90{
  --tw-gradient-from: rgba(44, 76, 94, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-800\\/95{
  --tw-gradient-from: rgba(44, 76, 94, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900{
  --tw-gradient-from: #284151 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/0{
  --tw-gradient-from: rgba(40, 65, 81, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/10{
  --tw-gradient-from: rgba(40, 65, 81, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/100{
  --tw-gradient-from: rgb(40, 65, 81) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/15{
  --tw-gradient-from: rgba(40, 65, 81, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/20{
  --tw-gradient-from: rgba(40, 65, 81, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/25{
  --tw-gradient-from: rgba(40, 65, 81, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/30{
  --tw-gradient-from: rgba(40, 65, 81, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/35{
  --tw-gradient-from: rgba(40, 65, 81, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/40{
  --tw-gradient-from: rgba(40, 65, 81, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/45{
  --tw-gradient-from: rgba(40, 65, 81, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/5{
  --tw-gradient-from: rgba(40, 65, 81, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/50{
  --tw-gradient-from: rgba(40, 65, 81, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/55{
  --tw-gradient-from: rgba(40, 65, 81, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/60{
  --tw-gradient-from: rgba(40, 65, 81, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/65{
  --tw-gradient-from: rgba(40, 65, 81, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/70{
  --tw-gradient-from: rgba(40, 65, 81, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/75{
  --tw-gradient-from: rgba(40, 65, 81, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/80{
  --tw-gradient-from: rgba(40, 65, 81, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/85{
  --tw-gradient-from: rgba(40, 65, 81, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/90{
  --tw-gradient-from: rgba(40, 65, 81, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-900\\/95{
  --tw-gradient-from: rgba(40, 65, 81, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950{
  --tw-gradient-from: #162936 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/0{
  --tw-gradient-from: rgba(22, 41, 54, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/10{
  --tw-gradient-from: rgba(22, 41, 54, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/100{
  --tw-gradient-from: rgb(22, 41, 54) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/15{
  --tw-gradient-from: rgba(22, 41, 54, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/20{
  --tw-gradient-from: rgba(22, 41, 54, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/25{
  --tw-gradient-from: rgba(22, 41, 54, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/30{
  --tw-gradient-from: rgba(22, 41, 54, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/35{
  --tw-gradient-from: rgba(22, 41, 54, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/40{
  --tw-gradient-from: rgba(22, 41, 54, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/45{
  --tw-gradient-from: rgba(22, 41, 54, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/5{
  --tw-gradient-from: rgba(22, 41, 54, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/50{
  --tw-gradient-from: rgba(22, 41, 54, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/55{
  --tw-gradient-from: rgba(22, 41, 54, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/60{
  --tw-gradient-from: rgba(22, 41, 54, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/65{
  --tw-gradient-from: rgba(22, 41, 54, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/70{
  --tw-gradient-from: rgba(22, 41, 54, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/75{
  --tw-gradient-from: rgba(22, 41, 54, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/80{
  --tw-gradient-from: rgba(22, 41, 54, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/85{
  --tw-gradient-from: rgba(22, 41, 54, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/90{
  --tw-gradient-from: rgba(22, 41, 54, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blumine-950\\/95{
  --tw-gradient-from: rgba(22, 41, 54, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100{
  --tw-gradient-from: #e6e6e7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/0{
  --tw-gradient-from: rgba(230, 230, 231, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/10{
  --tw-gradient-from: rgba(230, 230, 231, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/100{
  --tw-gradient-from: rgb(230, 230, 231) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/15{
  --tw-gradient-from: rgba(230, 230, 231, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/20{
  --tw-gradient-from: rgba(230, 230, 231, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/25{
  --tw-gradient-from: rgba(230, 230, 231, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/30{
  --tw-gradient-from: rgba(230, 230, 231, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/35{
  --tw-gradient-from: rgba(230, 230, 231, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/40{
  --tw-gradient-from: rgba(230, 230, 231, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/45{
  --tw-gradient-from: rgba(230, 230, 231, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/5{
  --tw-gradient-from: rgba(230, 230, 231, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/50{
  --tw-gradient-from: rgba(230, 230, 231, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/55{
  --tw-gradient-from: rgba(230, 230, 231, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/60{
  --tw-gradient-from: rgba(230, 230, 231, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/65{
  --tw-gradient-from: rgba(230, 230, 231, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/70{
  --tw-gradient-from: rgba(230, 230, 231, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/75{
  --tw-gradient-from: rgba(230, 230, 231, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/80{
  --tw-gradient-from: rgba(230, 230, 231, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/85{
  --tw-gradient-from: rgba(230, 230, 231, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/90{
  --tw-gradient-from: rgba(230, 230, 231, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-100\\/95{
  --tw-gradient-from: rgba(230, 230, 231, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200{
  --tw-gradient-from: #cfd0d2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/0{
  --tw-gradient-from: rgba(207, 208, 210, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/10{
  --tw-gradient-from: rgba(207, 208, 210, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/100{
  --tw-gradient-from: rgb(207, 208, 210) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/15{
  --tw-gradient-from: rgba(207, 208, 210, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/20{
  --tw-gradient-from: rgba(207, 208, 210, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/25{
  --tw-gradient-from: rgba(207, 208, 210, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/30{
  --tw-gradient-from: rgba(207, 208, 210, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/35{
  --tw-gradient-from: rgba(207, 208, 210, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/40{
  --tw-gradient-from: rgba(207, 208, 210, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/45{
  --tw-gradient-from: rgba(207, 208, 210, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/5{
  --tw-gradient-from: rgba(207, 208, 210, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/50{
  --tw-gradient-from: rgba(207, 208, 210, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/55{
  --tw-gradient-from: rgba(207, 208, 210, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/60{
  --tw-gradient-from: rgba(207, 208, 210, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/65{
  --tw-gradient-from: rgba(207, 208, 210, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/70{
  --tw-gradient-from: rgba(207, 208, 210, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/75{
  --tw-gradient-from: rgba(207, 208, 210, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/80{
  --tw-gradient-from: rgba(207, 208, 210, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/85{
  --tw-gradient-from: rgba(207, 208, 210, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/90{
  --tw-gradient-from: rgba(207, 208, 210, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-200\\/95{
  --tw-gradient-from: rgba(207, 208, 210, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300{
  --tw-gradient-from: #aeafb2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/0{
  --tw-gradient-from: rgba(174, 175, 178, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/10{
  --tw-gradient-from: rgba(174, 175, 178, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/100{
  --tw-gradient-from: rgb(174, 175, 178) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/15{
  --tw-gradient-from: rgba(174, 175, 178, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/20{
  --tw-gradient-from: rgba(174, 175, 178, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/25{
  --tw-gradient-from: rgba(174, 175, 178, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/30{
  --tw-gradient-from: rgba(174, 175, 178, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/35{
  --tw-gradient-from: rgba(174, 175, 178, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/40{
  --tw-gradient-from: rgba(174, 175, 178, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/45{
  --tw-gradient-from: rgba(174, 175, 178, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/5{
  --tw-gradient-from: rgba(174, 175, 178, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/50{
  --tw-gradient-from: rgba(174, 175, 178, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/55{
  --tw-gradient-from: rgba(174, 175, 178, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/60{
  --tw-gradient-from: rgba(174, 175, 178, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/65{
  --tw-gradient-from: rgba(174, 175, 178, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/70{
  --tw-gradient-from: rgba(174, 175, 178, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/75{
  --tw-gradient-from: rgba(174, 175, 178, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/80{
  --tw-gradient-from: rgba(174, 175, 178, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/85{
  --tw-gradient-from: rgba(174, 175, 178, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/90{
  --tw-gradient-from: rgba(174, 175, 178, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-300\\/95{
  --tw-gradient-from: rgba(174, 175, 178, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400{
  --tw-gradient-from: #85868b var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/0{
  --tw-gradient-from: rgba(133, 134, 139, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/10{
  --tw-gradient-from: rgba(133, 134, 139, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/100{
  --tw-gradient-from: rgb(133, 134, 139) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/15{
  --tw-gradient-from: rgba(133, 134, 139, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/20{
  --tw-gradient-from: rgba(133, 134, 139, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/25{
  --tw-gradient-from: rgba(133, 134, 139, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/30{
  --tw-gradient-from: rgba(133, 134, 139, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/35{
  --tw-gradient-from: rgba(133, 134, 139, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/40{
  --tw-gradient-from: rgba(133, 134, 139, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/45{
  --tw-gradient-from: rgba(133, 134, 139, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/5{
  --tw-gradient-from: rgba(133, 134, 139, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/50{
  --tw-gradient-from: rgba(133, 134, 139, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/55{
  --tw-gradient-from: rgba(133, 134, 139, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/60{
  --tw-gradient-from: rgba(133, 134, 139, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/65{
  --tw-gradient-from: rgba(133, 134, 139, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/70{
  --tw-gradient-from: rgba(133, 134, 139, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/75{
  --tw-gradient-from: rgba(133, 134, 139, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/80{
  --tw-gradient-from: rgba(133, 134, 139, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/85{
  --tw-gradient-from: rgba(133, 134, 139, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/90{
  --tw-gradient-from: rgba(133, 134, 139, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-400\\/95{
  --tw-gradient-from: rgba(133, 134, 139, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500{
  --tw-gradient-from: #6a6b70 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/0{
  --tw-gradient-from: rgba(106, 107, 112, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/10{
  --tw-gradient-from: rgba(106, 107, 112, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/100{
  --tw-gradient-from: rgb(106, 107, 112) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/15{
  --tw-gradient-from: rgba(106, 107, 112, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/20{
  --tw-gradient-from: rgba(106, 107, 112, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/25{
  --tw-gradient-from: rgba(106, 107, 112, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/30{
  --tw-gradient-from: rgba(106, 107, 112, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/35{
  --tw-gradient-from: rgba(106, 107, 112, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/40{
  --tw-gradient-from: rgba(106, 107, 112, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/45{
  --tw-gradient-from: rgba(106, 107, 112, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/5{
  --tw-gradient-from: rgba(106, 107, 112, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/50{
  --tw-gradient-from: rgba(106, 107, 112, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/55{
  --tw-gradient-from: rgba(106, 107, 112, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/60{
  --tw-gradient-from: rgba(106, 107, 112, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/65{
  --tw-gradient-from: rgba(106, 107, 112, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/70{
  --tw-gradient-from: rgba(106, 107, 112, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/75{
  --tw-gradient-from: rgba(106, 107, 112, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/80{
  --tw-gradient-from: rgba(106, 107, 112, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/85{
  --tw-gradient-from: rgba(106, 107, 112, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/90{
  --tw-gradient-from: rgba(106, 107, 112, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-500\\/95{
  --tw-gradient-from: rgba(106, 107, 112, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600{
  --tw-gradient-from: #5a5b60 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/0{
  --tw-gradient-from: rgba(90, 91, 96, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/10{
  --tw-gradient-from: rgba(90, 91, 96, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/100{
  --tw-gradient-from: rgb(90, 91, 96) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/15{
  --tw-gradient-from: rgba(90, 91, 96, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/20{
  --tw-gradient-from: rgba(90, 91, 96, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/25{
  --tw-gradient-from: rgba(90, 91, 96, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/30{
  --tw-gradient-from: rgba(90, 91, 96, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/35{
  --tw-gradient-from: rgba(90, 91, 96, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/40{
  --tw-gradient-from: rgba(90, 91, 96, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/45{
  --tw-gradient-from: rgba(90, 91, 96, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/5{
  --tw-gradient-from: rgba(90, 91, 96, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/50{
  --tw-gradient-from: rgba(90, 91, 96, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/55{
  --tw-gradient-from: rgba(90, 91, 96, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/60{
  --tw-gradient-from: rgba(90, 91, 96, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/65{
  --tw-gradient-from: rgba(90, 91, 96, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/70{
  --tw-gradient-from: rgba(90, 91, 96, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/75{
  --tw-gradient-from: rgba(90, 91, 96, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/80{
  --tw-gradient-from: rgba(90, 91, 96, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/85{
  --tw-gradient-from: rgba(90, 91, 96, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/90{
  --tw-gradient-from: rgba(90, 91, 96, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-600\\/95{
  --tw-gradient-from: rgba(90, 91, 96, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700{
  --tw-gradient-from: #4d4d51 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/0{
  --tw-gradient-from: rgba(77, 77, 81, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/10{
  --tw-gradient-from: rgba(77, 77, 81, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/100{
  --tw-gradient-from: rgb(77, 77, 81) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/15{
  --tw-gradient-from: rgba(77, 77, 81, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/20{
  --tw-gradient-from: rgba(77, 77, 81, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/25{
  --tw-gradient-from: rgba(77, 77, 81, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/30{
  --tw-gradient-from: rgba(77, 77, 81, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/35{
  --tw-gradient-from: rgba(77, 77, 81, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/40{
  --tw-gradient-from: rgba(77, 77, 81, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/45{
  --tw-gradient-from: rgba(77, 77, 81, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/5{
  --tw-gradient-from: rgba(77, 77, 81, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/50{
  --tw-gradient-from: rgba(77, 77, 81, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/55{
  --tw-gradient-from: rgba(77, 77, 81, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/60{
  --tw-gradient-from: rgba(77, 77, 81, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/65{
  --tw-gradient-from: rgba(77, 77, 81, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/70{
  --tw-gradient-from: rgba(77, 77, 81, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/75{
  --tw-gradient-from: rgba(77, 77, 81, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/80{
  --tw-gradient-from: rgba(77, 77, 81, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/85{
  --tw-gradient-from: rgba(77, 77, 81, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/90{
  --tw-gradient-from: rgba(77, 77, 81, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-700\\/95{
  --tw-gradient-from: rgba(77, 77, 81, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800{
  --tw-gradient-from: #434347 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/0{
  --tw-gradient-from: rgba(67, 67, 71, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/10{
  --tw-gradient-from: rgba(67, 67, 71, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/100{
  --tw-gradient-from: rgb(67, 67, 71) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/15{
  --tw-gradient-from: rgba(67, 67, 71, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/20{
  --tw-gradient-from: rgba(67, 67, 71, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/25{
  --tw-gradient-from: rgba(67, 67, 71, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/30{
  --tw-gradient-from: rgba(67, 67, 71, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/35{
  --tw-gradient-from: rgba(67, 67, 71, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/40{
  --tw-gradient-from: rgba(67, 67, 71, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/45{
  --tw-gradient-from: rgba(67, 67, 71, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/5{
  --tw-gradient-from: rgba(67, 67, 71, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/50{
  --tw-gradient-from: rgba(67, 67, 71, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/55{
  --tw-gradient-from: rgba(67, 67, 71, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/60{
  --tw-gradient-from: rgba(67, 67, 71, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/65{
  --tw-gradient-from: rgba(67, 67, 71, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/70{
  --tw-gradient-from: rgba(67, 67, 71, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/75{
  --tw-gradient-from: rgba(67, 67, 71, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/80{
  --tw-gradient-from: rgba(67, 67, 71, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/85{
  --tw-gradient-from: rgba(67, 67, 71, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/90{
  --tw-gradient-from: rgba(67, 67, 71, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-800\\/95{
  --tw-gradient-from: rgba(67, 67, 71, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900{
  --tw-gradient-from: #313133 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/0{
  --tw-gradient-from: rgba(49, 49, 51, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/10{
  --tw-gradient-from: rgba(49, 49, 51, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/100{
  --tw-gradient-from: rgb(49, 49, 51) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/15{
  --tw-gradient-from: rgba(49, 49, 51, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/20{
  --tw-gradient-from: rgba(49, 49, 51, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/25{
  --tw-gradient-from: rgba(49, 49, 51, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/30{
  --tw-gradient-from: rgba(49, 49, 51, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/35{
  --tw-gradient-from: rgba(49, 49, 51, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/40{
  --tw-gradient-from: rgba(49, 49, 51, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/45{
  --tw-gradient-from: rgba(49, 49, 51, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/5{
  --tw-gradient-from: rgba(49, 49, 51, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/50{
  --tw-gradient-from: rgba(49, 49, 51, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/55{
  --tw-gradient-from: rgba(49, 49, 51, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/60{
  --tw-gradient-from: rgba(49, 49, 51, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/65{
  --tw-gradient-from: rgba(49, 49, 51, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/70{
  --tw-gradient-from: rgba(49, 49, 51, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/75{
  --tw-gradient-from: rgba(49, 49, 51, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/80{
  --tw-gradient-from: rgba(49, 49, 51, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/85{
  --tw-gradient-from: rgba(49, 49, 51, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/90{
  --tw-gradient-from: rgba(49, 49, 51, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-900\\/95{
  --tw-gradient-from: rgba(49, 49, 51, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950{
  --tw-gradient-from: #252527 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/0{
  --tw-gradient-from: rgba(37, 37, 39, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/10{
  --tw-gradient-from: rgba(37, 37, 39, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/100{
  --tw-gradient-from: rgb(37, 37, 39) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/15{
  --tw-gradient-from: rgba(37, 37, 39, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/20{
  --tw-gradient-from: rgba(37, 37, 39, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/25{
  --tw-gradient-from: rgba(37, 37, 39, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/30{
  --tw-gradient-from: rgba(37, 37, 39, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/35{
  --tw-gradient-from: rgba(37, 37, 39, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/40{
  --tw-gradient-from: rgba(37, 37, 39, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/45{
  --tw-gradient-from: rgba(37, 37, 39, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/5{
  --tw-gradient-from: rgba(37, 37, 39, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/50{
  --tw-gradient-from: rgba(37, 37, 39, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/55{
  --tw-gradient-from: rgba(37, 37, 39, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/60{
  --tw-gradient-from: rgba(37, 37, 39, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/65{
  --tw-gradient-from: rgba(37, 37, 39, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/70{
  --tw-gradient-from: rgba(37, 37, 39, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/75{
  --tw-gradient-from: rgba(37, 37, 39, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/80{
  --tw-gradient-from: rgba(37, 37, 39, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/85{
  --tw-gradient-from: rgba(37, 37, 39, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/90{
  --tw-gradient-from: rgba(37, 37, 39, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-charcoal-950\\/95{
  --tw-gradient-from: rgba(37, 37, 39, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100{
  --tw-gradient-from: #d9f2e6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/0{
  --tw-gradient-from: rgba(217, 242, 230, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/10{
  --tw-gradient-from: rgba(217, 242, 230, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/100{
  --tw-gradient-from: rgb(217, 242, 230) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/15{
  --tw-gradient-from: rgba(217, 242, 230, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/20{
  --tw-gradient-from: rgba(217, 242, 230, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/25{
  --tw-gradient-from: rgba(217, 242, 230, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/30{
  --tw-gradient-from: rgba(217, 242, 230, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/35{
  --tw-gradient-from: rgba(217, 242, 230, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/40{
  --tw-gradient-from: rgba(217, 242, 230, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/45{
  --tw-gradient-from: rgba(217, 242, 230, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/5{
  --tw-gradient-from: rgba(217, 242, 230, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/50{
  --tw-gradient-from: rgba(217, 242, 230, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/55{
  --tw-gradient-from: rgba(217, 242, 230, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/60{
  --tw-gradient-from: rgba(217, 242, 230, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/65{
  --tw-gradient-from: rgba(217, 242, 230, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/70{
  --tw-gradient-from: rgba(217, 242, 230, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/75{
  --tw-gradient-from: rgba(217, 242, 230, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/80{
  --tw-gradient-from: rgba(217, 242, 230, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/85{
  --tw-gradient-from: rgba(217, 242, 230, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/90{
  --tw-gradient-from: rgba(217, 242, 230, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-100\\/95{
  --tw-gradient-from: rgba(217, 242, 230, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200{
  --tw-gradient-from: #b6e4d1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/0{
  --tw-gradient-from: rgba(182, 228, 209, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/10{
  --tw-gradient-from: rgba(182, 228, 209, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/100{
  --tw-gradient-from: rgb(182, 228, 209) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/15{
  --tw-gradient-from: rgba(182, 228, 209, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/20{
  --tw-gradient-from: rgba(182, 228, 209, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/25{
  --tw-gradient-from: rgba(182, 228, 209, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/30{
  --tw-gradient-from: rgba(182, 228, 209, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/35{
  --tw-gradient-from: rgba(182, 228, 209, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/40{
  --tw-gradient-from: rgba(182, 228, 209, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/45{
  --tw-gradient-from: rgba(182, 228, 209, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/5{
  --tw-gradient-from: rgba(182, 228, 209, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/50{
  --tw-gradient-from: rgba(182, 228, 209, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/55{
  --tw-gradient-from: rgba(182, 228, 209, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/60{
  --tw-gradient-from: rgba(182, 228, 209, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/65{
  --tw-gradient-from: rgba(182, 228, 209, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/70{
  --tw-gradient-from: rgba(182, 228, 209, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/75{
  --tw-gradient-from: rgba(182, 228, 209, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/80{
  --tw-gradient-from: rgba(182, 228, 209, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/85{
  --tw-gradient-from: rgba(182, 228, 209, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/90{
  --tw-gradient-from: rgba(182, 228, 209, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-200\\/95{
  --tw-gradient-from: rgba(182, 228, 209, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300{
  --tw-gradient-from: #86cfb5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/0{
  --tw-gradient-from: rgba(134, 207, 181, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/10{
  --tw-gradient-from: rgba(134, 207, 181, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/100{
  --tw-gradient-from: rgb(134, 207, 181) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/15{
  --tw-gradient-from: rgba(134, 207, 181, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/20{
  --tw-gradient-from: rgba(134, 207, 181, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/25{
  --tw-gradient-from: rgba(134, 207, 181, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/30{
  --tw-gradient-from: rgba(134, 207, 181, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/35{
  --tw-gradient-from: rgba(134, 207, 181, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/40{
  --tw-gradient-from: rgba(134, 207, 181, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/45{
  --tw-gradient-from: rgba(134, 207, 181, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/5{
  --tw-gradient-from: rgba(134, 207, 181, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/50{
  --tw-gradient-from: rgba(134, 207, 181, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/55{
  --tw-gradient-from: rgba(134, 207, 181, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/60{
  --tw-gradient-from: rgba(134, 207, 181, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/65{
  --tw-gradient-from: rgba(134, 207, 181, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/70{
  --tw-gradient-from: rgba(134, 207, 181, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/75{
  --tw-gradient-from: rgba(134, 207, 181, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/80{
  --tw-gradient-from: rgba(134, 207, 181, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/85{
  --tw-gradient-from: rgba(134, 207, 181, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/90{
  --tw-gradient-from: rgba(134, 207, 181, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-300\\/95{
  --tw-gradient-from: rgba(134, 207, 181, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400{
  --tw-gradient-from: #53b494 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/0{
  --tw-gradient-from: rgba(83, 180, 148, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/10{
  --tw-gradient-from: rgba(83, 180, 148, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/100{
  --tw-gradient-from: rgb(83, 180, 148) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/15{
  --tw-gradient-from: rgba(83, 180, 148, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/20{
  --tw-gradient-from: rgba(83, 180, 148, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/25{
  --tw-gradient-from: rgba(83, 180, 148, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/30{
  --tw-gradient-from: rgba(83, 180, 148, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/35{
  --tw-gradient-from: rgba(83, 180, 148, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/40{
  --tw-gradient-from: rgba(83, 180, 148, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/45{
  --tw-gradient-from: rgba(83, 180, 148, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/5{
  --tw-gradient-from: rgba(83, 180, 148, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/50{
  --tw-gradient-from: rgba(83, 180, 148, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/55{
  --tw-gradient-from: rgba(83, 180, 148, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/60{
  --tw-gradient-from: rgba(83, 180, 148, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/65{
  --tw-gradient-from: rgba(83, 180, 148, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/70{
  --tw-gradient-from: rgba(83, 180, 148, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/75{
  --tw-gradient-from: rgba(83, 180, 148, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/80{
  --tw-gradient-from: rgba(83, 180, 148, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/85{
  --tw-gradient-from: rgba(83, 180, 148, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/90{
  --tw-gradient-from: rgba(83, 180, 148, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-400\\/95{
  --tw-gradient-from: rgba(83, 180, 148, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500{
  --tw-gradient-from: #2c876d var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/0{
  --tw-gradient-from: rgba(44, 135, 109, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/10{
  --tw-gradient-from: rgba(44, 135, 109, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/100{
  --tw-gradient-from: rgb(44, 135, 109) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/15{
  --tw-gradient-from: rgba(44, 135, 109, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/20{
  --tw-gradient-from: rgba(44, 135, 109, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/25{
  --tw-gradient-from: rgba(44, 135, 109, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/30{
  --tw-gradient-from: rgba(44, 135, 109, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/35{
  --tw-gradient-from: rgba(44, 135, 109, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/40{
  --tw-gradient-from: rgba(44, 135, 109, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/45{
  --tw-gradient-from: rgba(44, 135, 109, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/5{
  --tw-gradient-from: rgba(44, 135, 109, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/50{
  --tw-gradient-from: rgba(44, 135, 109, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/55{
  --tw-gradient-from: rgba(44, 135, 109, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/60{
  --tw-gradient-from: rgba(44, 135, 109, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/65{
  --tw-gradient-from: rgba(44, 135, 109, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/70{
  --tw-gradient-from: rgba(44, 135, 109, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/75{
  --tw-gradient-from: rgba(44, 135, 109, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/80{
  --tw-gradient-from: rgba(44, 135, 109, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/85{
  --tw-gradient-from: rgba(44, 135, 109, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/90{
  --tw-gradient-from: rgba(44, 135, 109, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-500\\/95{
  --tw-gradient-from: rgba(44, 135, 109, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600{
  --tw-gradient-from: #227962 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/0{
  --tw-gradient-from: rgba(34, 121, 98, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/10{
  --tw-gradient-from: rgba(34, 121, 98, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/100{
  --tw-gradient-from: rgb(34, 121, 98) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/15{
  --tw-gradient-from: rgba(34, 121, 98, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/20{
  --tw-gradient-from: rgba(34, 121, 98, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/25{
  --tw-gradient-from: rgba(34, 121, 98, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/30{
  --tw-gradient-from: rgba(34, 121, 98, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/35{
  --tw-gradient-from: rgba(34, 121, 98, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/40{
  --tw-gradient-from: rgba(34, 121, 98, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/45{
  --tw-gradient-from: rgba(34, 121, 98, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/5{
  --tw-gradient-from: rgba(34, 121, 98, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/50{
  --tw-gradient-from: rgba(34, 121, 98, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/55{
  --tw-gradient-from: rgba(34, 121, 98, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/60{
  --tw-gradient-from: rgba(34, 121, 98, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/65{
  --tw-gradient-from: rgba(34, 121, 98, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/70{
  --tw-gradient-from: rgba(34, 121, 98, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/75{
  --tw-gradient-from: rgba(34, 121, 98, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/80{
  --tw-gradient-from: rgba(34, 121, 98, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/85{
  --tw-gradient-from: rgba(34, 121, 98, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/90{
  --tw-gradient-from: rgba(34, 121, 98, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-600\\/95{
  --tw-gradient-from: rgba(34, 121, 98, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700{
  --tw-gradient-from: #1b6150 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/0{
  --tw-gradient-from: rgba(27, 97, 80, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/10{
  --tw-gradient-from: rgba(27, 97, 80, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/100{
  --tw-gradient-from: rgb(27, 97, 80) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/15{
  --tw-gradient-from: rgba(27, 97, 80, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/20{
  --tw-gradient-from: rgba(27, 97, 80, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/25{
  --tw-gradient-from: rgba(27, 97, 80, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/30{
  --tw-gradient-from: rgba(27, 97, 80, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/35{
  --tw-gradient-from: rgba(27, 97, 80, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/40{
  --tw-gradient-from: rgba(27, 97, 80, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/45{
  --tw-gradient-from: rgba(27, 97, 80, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/5{
  --tw-gradient-from: rgba(27, 97, 80, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/50{
  --tw-gradient-from: rgba(27, 97, 80, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/55{
  --tw-gradient-from: rgba(27, 97, 80, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/60{
  --tw-gradient-from: rgba(27, 97, 80, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/65{
  --tw-gradient-from: rgba(27, 97, 80, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/70{
  --tw-gradient-from: rgba(27, 97, 80, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/75{
  --tw-gradient-from: rgba(27, 97, 80, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/80{
  --tw-gradient-from: rgba(27, 97, 80, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/85{
  --tw-gradient-from: rgba(27, 97, 80, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/90{
  --tw-gradient-from: rgba(27, 97, 80, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-700\\/95{
  --tw-gradient-from: rgba(27, 97, 80, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800{
  --tw-gradient-from: #184d40 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/0{
  --tw-gradient-from: rgba(24, 77, 64, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/10{
  --tw-gradient-from: rgba(24, 77, 64, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/100{
  --tw-gradient-from: rgb(24, 77, 64) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/15{
  --tw-gradient-from: rgba(24, 77, 64, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/20{
  --tw-gradient-from: rgba(24, 77, 64, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/25{
  --tw-gradient-from: rgba(24, 77, 64, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/30{
  --tw-gradient-from: rgba(24, 77, 64, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/35{
  --tw-gradient-from: rgba(24, 77, 64, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/40{
  --tw-gradient-from: rgba(24, 77, 64, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/45{
  --tw-gradient-from: rgba(24, 77, 64, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/5{
  --tw-gradient-from: rgba(24, 77, 64, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/50{
  --tw-gradient-from: rgba(24, 77, 64, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/55{
  --tw-gradient-from: rgba(24, 77, 64, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/60{
  --tw-gradient-from: rgba(24, 77, 64, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/65{
  --tw-gradient-from: rgba(24, 77, 64, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/70{
  --tw-gradient-from: rgba(24, 77, 64, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/75{
  --tw-gradient-from: rgba(24, 77, 64, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/80{
  --tw-gradient-from: rgba(24, 77, 64, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/85{
  --tw-gradient-from: rgba(24, 77, 64, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/90{
  --tw-gradient-from: rgba(24, 77, 64, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-800\\/95{
  --tw-gradient-from: rgba(24, 77, 64, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900{
  --tw-gradient-from: #144036 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/0{
  --tw-gradient-from: rgba(20, 64, 54, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/10{
  --tw-gradient-from: rgba(20, 64, 54, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/100{
  --tw-gradient-from: rgb(20, 64, 54) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/15{
  --tw-gradient-from: rgba(20, 64, 54, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/20{
  --tw-gradient-from: rgba(20, 64, 54, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/25{
  --tw-gradient-from: rgba(20, 64, 54, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/30{
  --tw-gradient-from: rgba(20, 64, 54, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/35{
  --tw-gradient-from: rgba(20, 64, 54, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/40{
  --tw-gradient-from: rgba(20, 64, 54, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/45{
  --tw-gradient-from: rgba(20, 64, 54, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/5{
  --tw-gradient-from: rgba(20, 64, 54, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/50{
  --tw-gradient-from: rgba(20, 64, 54, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/55{
  --tw-gradient-from: rgba(20, 64, 54, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/60{
  --tw-gradient-from: rgba(20, 64, 54, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/65{
  --tw-gradient-from: rgba(20, 64, 54, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/70{
  --tw-gradient-from: rgba(20, 64, 54, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/75{
  --tw-gradient-from: rgba(20, 64, 54, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/80{
  --tw-gradient-from: rgba(20, 64, 54, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/85{
  --tw-gradient-from: rgba(20, 64, 54, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/90{
  --tw-gradient-from: rgba(20, 64, 54, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-900\\/95{
  --tw-gradient-from: rgba(20, 64, 54, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950{
  --tw-gradient-from: #0a241f var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/0{
  --tw-gradient-from: rgba(10, 36, 31, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/10{
  --tw-gradient-from: rgba(10, 36, 31, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/100{
  --tw-gradient-from: rgb(10, 36, 31) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/15{
  --tw-gradient-from: rgba(10, 36, 31, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/20{
  --tw-gradient-from: rgba(10, 36, 31, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/25{
  --tw-gradient-from: rgba(10, 36, 31, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/30{
  --tw-gradient-from: rgba(10, 36, 31, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/35{
  --tw-gradient-from: rgba(10, 36, 31, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/40{
  --tw-gradient-from: rgba(10, 36, 31, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/45{
  --tw-gradient-from: rgba(10, 36, 31, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/5{
  --tw-gradient-from: rgba(10, 36, 31, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/50{
  --tw-gradient-from: rgba(10, 36, 31, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/55{
  --tw-gradient-from: rgba(10, 36, 31, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/60{
  --tw-gradient-from: rgba(10, 36, 31, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/65{
  --tw-gradient-from: rgba(10, 36, 31, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/70{
  --tw-gradient-from: rgba(10, 36, 31, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/75{
  --tw-gradient-from: rgba(10, 36, 31, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/80{
  --tw-gradient-from: rgba(10, 36, 31, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/85{
  --tw-gradient-from: rgba(10, 36, 31, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/90{
  --tw-gradient-from: rgba(10, 36, 31, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-jade-950\\/95{
  --tw-gradient-from: rgba(10, 36, 31, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500{
  --tw-gradient-from: #3787a3 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/0{
  --tw-gradient-from: rgba(55, 135, 163, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/10{
  --tw-gradient-from: rgba(55, 135, 163, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/100{
  --tw-gradient-from: rgb(55, 135, 163) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/15{
  --tw-gradient-from: rgba(55, 135, 163, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/20{
  --tw-gradient-from: rgba(55, 135, 163, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/25{
  --tw-gradient-from: rgba(55, 135, 163, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/30{
  --tw-gradient-from: rgba(55, 135, 163, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/35{
  --tw-gradient-from: rgba(55, 135, 163, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/40{
  --tw-gradient-from: rgba(55, 135, 163, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/45{
  --tw-gradient-from: rgba(55, 135, 163, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/5{
  --tw-gradient-from: rgba(55, 135, 163, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/50{
  --tw-gradient-from: rgba(55, 135, 163, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/55{
  --tw-gradient-from: rgba(55, 135, 163, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/60{
  --tw-gradient-from: rgba(55, 135, 163, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/65{
  --tw-gradient-from: rgba(55, 135, 163, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/70{
  --tw-gradient-from: rgba(55, 135, 163, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/75{
  --tw-gradient-from: rgba(55, 135, 163, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/80{
  --tw-gradient-from: rgba(55, 135, 163, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/85{
  --tw-gradient-from: rgba(55, 135, 163, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/90{
  --tw-gradient-from: rgba(55, 135, 163, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-500\\/95{
  --tw-gradient-from: rgba(55, 135, 163, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600{
  --tw-gradient-from: #306d8a var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/0{
  --tw-gradient-from: rgba(48, 109, 138, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/10{
  --tw-gradient-from: rgba(48, 109, 138, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/100{
  --tw-gradient-from: rgb(48, 109, 138) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/15{
  --tw-gradient-from: rgba(48, 109, 138, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/20{
  --tw-gradient-from: rgba(48, 109, 138, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/25{
  --tw-gradient-from: rgba(48, 109, 138, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/30{
  --tw-gradient-from: rgba(48, 109, 138, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/35{
  --tw-gradient-from: rgba(48, 109, 138, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/40{
  --tw-gradient-from: rgba(48, 109, 138, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/45{
  --tw-gradient-from: rgba(48, 109, 138, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/5{
  --tw-gradient-from: rgba(48, 109, 138, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/50{
  --tw-gradient-from: rgba(48, 109, 138, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/55{
  --tw-gradient-from: rgba(48, 109, 138, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/60{
  --tw-gradient-from: rgba(48, 109, 138, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/65{
  --tw-gradient-from: rgba(48, 109, 138, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/70{
  --tw-gradient-from: rgba(48, 109, 138, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/75{
  --tw-gradient-from: rgba(48, 109, 138, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/80{
  --tw-gradient-from: rgba(48, 109, 138, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/85{
  --tw-gradient-from: rgba(48, 109, 138, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/90{
  --tw-gradient-from: rgba(48, 109, 138, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-600\\/95{
  --tw-gradient-from: rgba(48, 109, 138, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700{
  --tw-gradient-from: #2d5b72 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/0{
  --tw-gradient-from: rgba(45, 91, 114, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/10{
  --tw-gradient-from: rgba(45, 91, 114, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/100{
  --tw-gradient-from: rgb(45, 91, 114) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/15{
  --tw-gradient-from: rgba(45, 91, 114, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/20{
  --tw-gradient-from: rgba(45, 91, 114, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/25{
  --tw-gradient-from: rgba(45, 91, 114, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/30{
  --tw-gradient-from: rgba(45, 91, 114, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/35{
  --tw-gradient-from: rgba(45, 91, 114, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/40{
  --tw-gradient-from: rgba(45, 91, 114, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/45{
  --tw-gradient-from: rgba(45, 91, 114, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/5{
  --tw-gradient-from: rgba(45, 91, 114, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/50{
  --tw-gradient-from: rgba(45, 91, 114, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/55{
  --tw-gradient-from: rgba(45, 91, 114, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/60{
  --tw-gradient-from: rgba(45, 91, 114, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/65{
  --tw-gradient-from: rgba(45, 91, 114, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/70{
  --tw-gradient-from: rgba(45, 91, 114, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/75{
  --tw-gradient-from: rgba(45, 91, 114, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/80{
  --tw-gradient-from: rgba(45, 91, 114, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/85{
  --tw-gradient-from: rgba(45, 91, 114, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/90{
  --tw-gradient-from: rgba(45, 91, 114, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-700\\/95{
  --tw-gradient-from: rgba(45, 91, 114, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800{
  --tw-gradient-from: #2c4c5e var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/0{
  --tw-gradient-from: rgba(44, 76, 94, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/10{
  --tw-gradient-from: rgba(44, 76, 94, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/100{
  --tw-gradient-from: rgb(44, 76, 94) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/15{
  --tw-gradient-from: rgba(44, 76, 94, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/20{
  --tw-gradient-from: rgba(44, 76, 94, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/25{
  --tw-gradient-from: rgba(44, 76, 94, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/30{
  --tw-gradient-from: rgba(44, 76, 94, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/35{
  --tw-gradient-from: rgba(44, 76, 94, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/40{
  --tw-gradient-from: rgba(44, 76, 94, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/45{
  --tw-gradient-from: rgba(44, 76, 94, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/5{
  --tw-gradient-from: rgba(44, 76, 94, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/50{
  --tw-gradient-from: rgba(44, 76, 94, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/55{
  --tw-gradient-from: rgba(44, 76, 94, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/60{
  --tw-gradient-from: rgba(44, 76, 94, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/65{
  --tw-gradient-from: rgba(44, 76, 94, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/70{
  --tw-gradient-from: rgba(44, 76, 94, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/75{
  --tw-gradient-from: rgba(44, 76, 94, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/80{
  --tw-gradient-from: rgba(44, 76, 94, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/85{
  --tw-gradient-from: rgba(44, 76, 94, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/90{
  --tw-gradient-from: rgba(44, 76, 94, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-800\\/95{
  --tw-gradient-from: rgba(44, 76, 94, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900{
  --tw-gradient-from: #284151 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/0{
  --tw-gradient-from: rgba(40, 65, 81, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/10{
  --tw-gradient-from: rgba(40, 65, 81, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/100{
  --tw-gradient-from: rgb(40, 65, 81) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/15{
  --tw-gradient-from: rgba(40, 65, 81, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/20{
  --tw-gradient-from: rgba(40, 65, 81, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/25{
  --tw-gradient-from: rgba(40, 65, 81, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/30{
  --tw-gradient-from: rgba(40, 65, 81, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/35{
  --tw-gradient-from: rgba(40, 65, 81, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/40{
  --tw-gradient-from: rgba(40, 65, 81, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/45{
  --tw-gradient-from: rgba(40, 65, 81, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/5{
  --tw-gradient-from: rgba(40, 65, 81, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/50{
  --tw-gradient-from: rgba(40, 65, 81, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/55{
  --tw-gradient-from: rgba(40, 65, 81, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/60{
  --tw-gradient-from: rgba(40, 65, 81, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/65{
  --tw-gradient-from: rgba(40, 65, 81, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/70{
  --tw-gradient-from: rgba(40, 65, 81, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/75{
  --tw-gradient-from: rgba(40, 65, 81, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/80{
  --tw-gradient-from: rgba(40, 65, 81, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/85{
  --tw-gradient-from: rgba(40, 65, 81, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/90{
  --tw-gradient-from: rgba(40, 65, 81, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-alphabet-900\\/95{
  --tw-gradient-from: rgba(40, 65, 81, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500{
  --tw-gradient-from: #d1912f var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/0{
  --tw-gradient-from: rgba(209, 145, 47, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/10{
  --tw-gradient-from: rgba(209, 145, 47, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/100{
  --tw-gradient-from: rgb(209, 145, 47) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/15{
  --tw-gradient-from: rgba(209, 145, 47, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/20{
  --tw-gradient-from: rgba(209, 145, 47, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/25{
  --tw-gradient-from: rgba(209, 145, 47, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/30{
  --tw-gradient-from: rgba(209, 145, 47, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/35{
  --tw-gradient-from: rgba(209, 145, 47, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/40{
  --tw-gradient-from: rgba(209, 145, 47, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/45{
  --tw-gradient-from: rgba(209, 145, 47, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/5{
  --tw-gradient-from: rgba(209, 145, 47, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/50{
  --tw-gradient-from: rgba(209, 145, 47, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/55{
  --tw-gradient-from: rgba(209, 145, 47, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/60{
  --tw-gradient-from: rgba(209, 145, 47, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/65{
  --tw-gradient-from: rgba(209, 145, 47, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/70{
  --tw-gradient-from: rgba(209, 145, 47, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/75{
  --tw-gradient-from: rgba(209, 145, 47, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/80{
  --tw-gradient-from: rgba(209, 145, 47, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/85{
  --tw-gradient-from: rgba(209, 145, 47, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/90{
  --tw-gradient-from: rgba(209, 145, 47, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-500\\/95{
  --tw-gradient-from: rgba(209, 145, 47, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600{
  --tw-gradient-from: #c37829 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/0{
  --tw-gradient-from: rgba(195, 120, 41, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/10{
  --tw-gradient-from: rgba(195, 120, 41, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/100{
  --tw-gradient-from: rgb(195, 120, 41) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/15{
  --tw-gradient-from: rgba(195, 120, 41, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/20{
  --tw-gradient-from: rgba(195, 120, 41, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/25{
  --tw-gradient-from: rgba(195, 120, 41, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/30{
  --tw-gradient-from: rgba(195, 120, 41, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/35{
  --tw-gradient-from: rgba(195, 120, 41, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/40{
  --tw-gradient-from: rgba(195, 120, 41, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/45{
  --tw-gradient-from: rgba(195, 120, 41, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/5{
  --tw-gradient-from: rgba(195, 120, 41, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/50{
  --tw-gradient-from: rgba(195, 120, 41, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/55{
  --tw-gradient-from: rgba(195, 120, 41, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/60{
  --tw-gradient-from: rgba(195, 120, 41, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/65{
  --tw-gradient-from: rgba(195, 120, 41, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/70{
  --tw-gradient-from: rgba(195, 120, 41, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/75{
  --tw-gradient-from: rgba(195, 120, 41, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/80{
  --tw-gradient-from: rgba(195, 120, 41, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/85{
  --tw-gradient-from: rgba(195, 120, 41, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/90{
  --tw-gradient-from: rgba(195, 120, 41, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-600\\/95{
  --tw-gradient-from: rgba(195, 120, 41, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700{
  --tw-gradient-from: #995424 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/0{
  --tw-gradient-from: rgba(153, 84, 36, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/10{
  --tw-gradient-from: rgba(153, 84, 36, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/100{
  --tw-gradient-from: rgb(153, 84, 36) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/15{
  --tw-gradient-from: rgba(153, 84, 36, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/20{
  --tw-gradient-from: rgba(153, 84, 36, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/25{
  --tw-gradient-from: rgba(153, 84, 36, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/30{
  --tw-gradient-from: rgba(153, 84, 36, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/35{
  --tw-gradient-from: rgba(153, 84, 36, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/40{
  --tw-gradient-from: rgba(153, 84, 36, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/45{
  --tw-gradient-from: rgba(153, 84, 36, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/5{
  --tw-gradient-from: rgba(153, 84, 36, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/50{
  --tw-gradient-from: rgba(153, 84, 36, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/55{
  --tw-gradient-from: rgba(153, 84, 36, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/60{
  --tw-gradient-from: rgba(153, 84, 36, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/65{
  --tw-gradient-from: rgba(153, 84, 36, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/70{
  --tw-gradient-from: rgba(153, 84, 36, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/75{
  --tw-gradient-from: rgba(153, 84, 36, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/80{
  --tw-gradient-from: rgba(153, 84, 36, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/85{
  --tw-gradient-from: rgba(153, 84, 36, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/90{
  --tw-gradient-from: rgba(153, 84, 36, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-700\\/95{
  --tw-gradient-from: rgba(153, 84, 36, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800{
  --tw-gradient-from: #7e4322 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/0{
  --tw-gradient-from: rgba(126, 67, 34, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/10{
  --tw-gradient-from: rgba(126, 67, 34, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/100{
  --tw-gradient-from: rgb(126, 67, 34) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/15{
  --tw-gradient-from: rgba(126, 67, 34, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/20{
  --tw-gradient-from: rgba(126, 67, 34, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/25{
  --tw-gradient-from: rgba(126, 67, 34, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/30{
  --tw-gradient-from: rgba(126, 67, 34, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/35{
  --tw-gradient-from: rgba(126, 67, 34, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/40{
  --tw-gradient-from: rgba(126, 67, 34, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/45{
  --tw-gradient-from: rgba(126, 67, 34, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/5{
  --tw-gradient-from: rgba(126, 67, 34, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/50{
  --tw-gradient-from: rgba(126, 67, 34, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/55{
  --tw-gradient-from: rgba(126, 67, 34, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/60{
  --tw-gradient-from: rgba(126, 67, 34, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/65{
  --tw-gradient-from: rgba(126, 67, 34, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/70{
  --tw-gradient-from: rgba(126, 67, 34, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/75{
  --tw-gradient-from: rgba(126, 67, 34, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/80{
  --tw-gradient-from: rgba(126, 67, 34, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/85{
  --tw-gradient-from: rgba(126, 67, 34, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/90{
  --tw-gradient-from: rgba(126, 67, 34, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-800\\/95{
  --tw-gradient-from: rgba(126, 67, 34, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900{
  --tw-gradient-from: #68381f var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/0{
  --tw-gradient-from: rgba(104, 56, 31, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/10{
  --tw-gradient-from: rgba(104, 56, 31, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/100{
  --tw-gradient-from: rgb(104, 56, 31) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/15{
  --tw-gradient-from: rgba(104, 56, 31, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/20{
  --tw-gradient-from: rgba(104, 56, 31, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/25{
  --tw-gradient-from: rgba(104, 56, 31, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/30{
  --tw-gradient-from: rgba(104, 56, 31, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/35{
  --tw-gradient-from: rgba(104, 56, 31, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/40{
  --tw-gradient-from: rgba(104, 56, 31, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/45{
  --tw-gradient-from: rgba(104, 56, 31, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/5{
  --tw-gradient-from: rgba(104, 56, 31, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/50{
  --tw-gradient-from: rgba(104, 56, 31, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/55{
  --tw-gradient-from: rgba(104, 56, 31, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/60{
  --tw-gradient-from: rgba(104, 56, 31, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/65{
  --tw-gradient-from: rgba(104, 56, 31, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/70{
  --tw-gradient-from: rgba(104, 56, 31, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/75{
  --tw-gradient-from: rgba(104, 56, 31, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/80{
  --tw-gradient-from: rgba(104, 56, 31, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/85{
  --tw-gradient-from: rgba(104, 56, 31, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/90{
  --tw-gradient-from: rgba(104, 56, 31, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-categories-900\\/95{
  --tw-gradient-from: rgba(104, 56, 31, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500{
  --tw-gradient-from: #2c876d var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/0{
  --tw-gradient-from: rgba(44, 135, 109, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/10{
  --tw-gradient-from: rgba(44, 135, 109, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/100{
  --tw-gradient-from: rgb(44, 135, 109) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/15{
  --tw-gradient-from: rgba(44, 135, 109, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/20{
  --tw-gradient-from: rgba(44, 135, 109, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/25{
  --tw-gradient-from: rgba(44, 135, 109, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/30{
  --tw-gradient-from: rgba(44, 135, 109, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/35{
  --tw-gradient-from: rgba(44, 135, 109, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/40{
  --tw-gradient-from: rgba(44, 135, 109, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/45{
  --tw-gradient-from: rgba(44, 135, 109, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/5{
  --tw-gradient-from: rgba(44, 135, 109, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/50{
  --tw-gradient-from: rgba(44, 135, 109, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/55{
  --tw-gradient-from: rgba(44, 135, 109, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/60{
  --tw-gradient-from: rgba(44, 135, 109, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/65{
  --tw-gradient-from: rgba(44, 135, 109, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/70{
  --tw-gradient-from: rgba(44, 135, 109, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/75{
  --tw-gradient-from: rgba(44, 135, 109, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/80{
  --tw-gradient-from: rgba(44, 135, 109, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/85{
  --tw-gradient-from: rgba(44, 135, 109, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/90{
  --tw-gradient-from: rgba(44, 135, 109, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-500\\/95{
  --tw-gradient-from: rgba(44, 135, 109, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600{
  --tw-gradient-from: #227962 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/0{
  --tw-gradient-from: rgba(34, 121, 98, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/10{
  --tw-gradient-from: rgba(34, 121, 98, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/100{
  --tw-gradient-from: rgb(34, 121, 98) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/15{
  --tw-gradient-from: rgba(34, 121, 98, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/20{
  --tw-gradient-from: rgba(34, 121, 98, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/25{
  --tw-gradient-from: rgba(34, 121, 98, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/30{
  --tw-gradient-from: rgba(34, 121, 98, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/35{
  --tw-gradient-from: rgba(34, 121, 98, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/40{
  --tw-gradient-from: rgba(34, 121, 98, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/45{
  --tw-gradient-from: rgba(34, 121, 98, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/5{
  --tw-gradient-from: rgba(34, 121, 98, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/50{
  --tw-gradient-from: rgba(34, 121, 98, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/55{
  --tw-gradient-from: rgba(34, 121, 98, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/60{
  --tw-gradient-from: rgba(34, 121, 98, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/65{
  --tw-gradient-from: rgba(34, 121, 98, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/70{
  --tw-gradient-from: rgba(34, 121, 98, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/75{
  --tw-gradient-from: rgba(34, 121, 98, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/80{
  --tw-gradient-from: rgba(34, 121, 98, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/85{
  --tw-gradient-from: rgba(34, 121, 98, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/90{
  --tw-gradient-from: rgba(34, 121, 98, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-600\\/95{
  --tw-gradient-from: rgba(34, 121, 98, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700{
  --tw-gradient-from: #1b6150 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/0{
  --tw-gradient-from: rgba(27, 97, 80, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/10{
  --tw-gradient-from: rgba(27, 97, 80, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/100{
  --tw-gradient-from: rgb(27, 97, 80) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/15{
  --tw-gradient-from: rgba(27, 97, 80, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/20{
  --tw-gradient-from: rgba(27, 97, 80, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/25{
  --tw-gradient-from: rgba(27, 97, 80, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/30{
  --tw-gradient-from: rgba(27, 97, 80, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/35{
  --tw-gradient-from: rgba(27, 97, 80, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/40{
  --tw-gradient-from: rgba(27, 97, 80, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/45{
  --tw-gradient-from: rgba(27, 97, 80, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/5{
  --tw-gradient-from: rgba(27, 97, 80, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/50{
  --tw-gradient-from: rgba(27, 97, 80, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/55{
  --tw-gradient-from: rgba(27, 97, 80, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/60{
  --tw-gradient-from: rgba(27, 97, 80, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/65{
  --tw-gradient-from: rgba(27, 97, 80, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/70{
  --tw-gradient-from: rgba(27, 97, 80, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/75{
  --tw-gradient-from: rgba(27, 97, 80, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/80{
  --tw-gradient-from: rgba(27, 97, 80, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/85{
  --tw-gradient-from: rgba(27, 97, 80, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/90{
  --tw-gradient-from: rgba(27, 97, 80, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-700\\/95{
  --tw-gradient-from: rgba(27, 97, 80, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800{
  --tw-gradient-from: #184d40 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/0{
  --tw-gradient-from: rgba(24, 77, 64, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/10{
  --tw-gradient-from: rgba(24, 77, 64, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/100{
  --tw-gradient-from: rgb(24, 77, 64) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/15{
  --tw-gradient-from: rgba(24, 77, 64, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/20{
  --tw-gradient-from: rgba(24, 77, 64, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/25{
  --tw-gradient-from: rgba(24, 77, 64, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/30{
  --tw-gradient-from: rgba(24, 77, 64, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/35{
  --tw-gradient-from: rgba(24, 77, 64, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/40{
  --tw-gradient-from: rgba(24, 77, 64, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/45{
  --tw-gradient-from: rgba(24, 77, 64, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/5{
  --tw-gradient-from: rgba(24, 77, 64, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/50{
  --tw-gradient-from: rgba(24, 77, 64, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/55{
  --tw-gradient-from: rgba(24, 77, 64, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/60{
  --tw-gradient-from: rgba(24, 77, 64, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/65{
  --tw-gradient-from: rgba(24, 77, 64, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/70{
  --tw-gradient-from: rgba(24, 77, 64, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/75{
  --tw-gradient-from: rgba(24, 77, 64, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/80{
  --tw-gradient-from: rgba(24, 77, 64, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/85{
  --tw-gradient-from: rgba(24, 77, 64, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/90{
  --tw-gradient-from: rgba(24, 77, 64, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-800\\/95{
  --tw-gradient-from: rgba(24, 77, 64, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900{
  --tw-gradient-from: #144036 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/0{
  --tw-gradient-from: rgba(20, 64, 54, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/10{
  --tw-gradient-from: rgba(20, 64, 54, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/100{
  --tw-gradient-from: rgb(20, 64, 54) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/15{
  --tw-gradient-from: rgba(20, 64, 54, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/20{
  --tw-gradient-from: rgba(20, 64, 54, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/25{
  --tw-gradient-from: rgba(20, 64, 54, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/30{
  --tw-gradient-from: rgba(20, 64, 54, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/35{
  --tw-gradient-from: rgba(20, 64, 54, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/40{
  --tw-gradient-from: rgba(20, 64, 54, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/45{
  --tw-gradient-from: rgba(20, 64, 54, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/5{
  --tw-gradient-from: rgba(20, 64, 54, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/50{
  --tw-gradient-from: rgba(20, 64, 54, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/55{
  --tw-gradient-from: rgba(20, 64, 54, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/60{
  --tw-gradient-from: rgba(20, 64, 54, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/65{
  --tw-gradient-from: rgba(20, 64, 54, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/70{
  --tw-gradient-from: rgba(20, 64, 54, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/75{
  --tw-gradient-from: rgba(20, 64, 54, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/80{
  --tw-gradient-from: rgba(20, 64, 54, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/85{
  --tw-gradient-from: rgba(20, 64, 54, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/90{
  --tw-gradient-from: rgba(20, 64, 54, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-dictionary-900\\/95{
  --tw-gradient-from: rgba(20, 64, 54, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500{
  --tw-gradient-from: #513B56 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/0{
  --tw-gradient-from: rgba(81, 59, 86, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/10{
  --tw-gradient-from: rgba(81, 59, 86, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/100{
  --tw-gradient-from: rgb(81, 59, 86) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/15{
  --tw-gradient-from: rgba(81, 59, 86, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/20{
  --tw-gradient-from: rgba(81, 59, 86, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/25{
  --tw-gradient-from: rgba(81, 59, 86, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/30{
  --tw-gradient-from: rgba(81, 59, 86, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/35{
  --tw-gradient-from: rgba(81, 59, 86, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/40{
  --tw-gradient-from: rgba(81, 59, 86, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/45{
  --tw-gradient-from: rgba(81, 59, 86, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/5{
  --tw-gradient-from: rgba(81, 59, 86, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/50{
  --tw-gradient-from: rgba(81, 59, 86, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/55{
  --tw-gradient-from: rgba(81, 59, 86, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/60{
  --tw-gradient-from: rgba(81, 59, 86, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/65{
  --tw-gradient-from: rgba(81, 59, 86, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/70{
  --tw-gradient-from: rgba(81, 59, 86, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/75{
  --tw-gradient-from: rgba(81, 59, 86, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/80{
  --tw-gradient-from: rgba(81, 59, 86, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/85{
  --tw-gradient-from: rgba(81, 59, 86, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/90{
  --tw-gradient-from: rgba(81, 59, 86, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-500\\/95{
  --tw-gradient-from: rgba(81, 59, 86, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900{
  --tw-gradient-from: #39293c var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/0{
  --tw-gradient-from: rgba(57, 41, 60, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/10{
  --tw-gradient-from: rgba(57, 41, 60, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/100{
  --tw-gradient-from: rgb(57, 41, 60) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/15{
  --tw-gradient-from: rgba(57, 41, 60, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/20{
  --tw-gradient-from: rgba(57, 41, 60, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/25{
  --tw-gradient-from: rgba(57, 41, 60, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/30{
  --tw-gradient-from: rgba(57, 41, 60, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/35{
  --tw-gradient-from: rgba(57, 41, 60, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/40{
  --tw-gradient-from: rgba(57, 41, 60, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/45{
  --tw-gradient-from: rgba(57, 41, 60, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/5{
  --tw-gradient-from: rgba(57, 41, 60, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/50{
  --tw-gradient-from: rgba(57, 41, 60, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/55{
  --tw-gradient-from: rgba(57, 41, 60, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/60{
  --tw-gradient-from: rgba(57, 41, 60, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/65{
  --tw-gradient-from: rgba(57, 41, 60, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/70{
  --tw-gradient-from: rgba(57, 41, 60, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/75{
  --tw-gradient-from: rgba(57, 41, 60, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/80{
  --tw-gradient-from: rgba(57, 41, 60, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/85{
  --tw-gradient-from: rgba(57, 41, 60, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/90{
  --tw-gradient-from: rgba(57, 41, 60, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-games-900\\/95{
  --tw-gradient-from: rgba(57, 41, 60, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500{
  --tw-gradient-from: #830042 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/0{
  --tw-gradient-from: rgba(131, 0, 66, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/10{
  --tw-gradient-from: rgba(131, 0, 66, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/100{
  --tw-gradient-from: rgb(131, 0, 66) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/15{
  --tw-gradient-from: rgba(131, 0, 66, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/20{
  --tw-gradient-from: rgba(131, 0, 66, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/25{
  --tw-gradient-from: rgba(131, 0, 66, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/30{
  --tw-gradient-from: rgba(131, 0, 66, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/35{
  --tw-gradient-from: rgba(131, 0, 66, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/40{
  --tw-gradient-from: rgba(131, 0, 66, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/45{
  --tw-gradient-from: rgba(131, 0, 66, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/5{
  --tw-gradient-from: rgba(131, 0, 66, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/50{
  --tw-gradient-from: rgba(131, 0, 66, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/55{
  --tw-gradient-from: rgba(131, 0, 66, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/60{
  --tw-gradient-from: rgba(131, 0, 66, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/65{
  --tw-gradient-from: rgba(131, 0, 66, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/70{
  --tw-gradient-from: rgba(131, 0, 66, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/75{
  --tw-gradient-from: rgba(131, 0, 66, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/80{
  --tw-gradient-from: rgba(131, 0, 66, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/85{
  --tw-gradient-from: rgba(131, 0, 66, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/90{
  --tw-gradient-from: rgba(131, 0, 66, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-500\\/95{
  --tw-gradient-from: rgba(131, 0, 66, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900{
  --tw-gradient-from: #5c002e var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/0{
  --tw-gradient-from: rgba(92, 0, 46, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/10{
  --tw-gradient-from: rgba(92, 0, 46, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/100{
  --tw-gradient-from: rgb(92, 0, 46) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/15{
  --tw-gradient-from: rgba(92, 0, 46, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/20{
  --tw-gradient-from: rgba(92, 0, 46, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/25{
  --tw-gradient-from: rgba(92, 0, 46, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/30{
  --tw-gradient-from: rgba(92, 0, 46, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/35{
  --tw-gradient-from: rgba(92, 0, 46, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/40{
  --tw-gradient-from: rgba(92, 0, 46, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/45{
  --tw-gradient-from: rgba(92, 0, 46, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/5{
  --tw-gradient-from: rgba(92, 0, 46, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/50{
  --tw-gradient-from: rgba(92, 0, 46, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/55{
  --tw-gradient-from: rgba(92, 0, 46, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/60{
  --tw-gradient-from: rgba(92, 0, 46, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/65{
  --tw-gradient-from: rgba(92, 0, 46, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/70{
  --tw-gradient-from: rgba(92, 0, 46, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/75{
  --tw-gradient-from: rgba(92, 0, 46, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/80{
  --tw-gradient-from: rgba(92, 0, 46, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/85{
  --tw-gradient-from: rgba(92, 0, 46, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/90{
  --tw-gradient-from: rgba(92, 0, 46, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-songs-900\\/95{
  --tw-gradient-from: rgba(92, 0, 46, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500{
  --tw-gradient-from: #E9C46A var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/0{
  --tw-gradient-from: rgba(233, 196, 106, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/10{
  --tw-gradient-from: rgba(233, 196, 106, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/100{
  --tw-gradient-from: rgb(233, 196, 106) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/15{
  --tw-gradient-from: rgba(233, 196, 106, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/20{
  --tw-gradient-from: rgba(233, 196, 106, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/25{
  --tw-gradient-from: rgba(233, 196, 106, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/30{
  --tw-gradient-from: rgba(233, 196, 106, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/35{
  --tw-gradient-from: rgba(233, 196, 106, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/40{
  --tw-gradient-from: rgba(233, 196, 106, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/45{
  --tw-gradient-from: rgba(233, 196, 106, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/5{
  --tw-gradient-from: rgba(233, 196, 106, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/50{
  --tw-gradient-from: rgba(233, 196, 106, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/55{
  --tw-gradient-from: rgba(233, 196, 106, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/60{
  --tw-gradient-from: rgba(233, 196, 106, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/65{
  --tw-gradient-from: rgba(233, 196, 106, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/70{
  --tw-gradient-from: rgba(233, 196, 106, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/75{
  --tw-gradient-from: rgba(233, 196, 106, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/80{
  --tw-gradient-from: rgba(233, 196, 106, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/85{
  --tw-gradient-from: rgba(233, 196, 106, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/90{
  --tw-gradient-from: rgba(233, 196, 106, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-500\\/95{
  --tw-gradient-from: rgba(233, 196, 106, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900{
  --tw-gradient-from: #a3894a var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/0{
  --tw-gradient-from: rgba(163, 137, 74, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/10{
  --tw-gradient-from: rgba(163, 137, 74, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/100{
  --tw-gradient-from: rgb(163, 137, 74) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/15{
  --tw-gradient-from: rgba(163, 137, 74, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/20{
  --tw-gradient-from: rgba(163, 137, 74, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/25{
  --tw-gradient-from: rgba(163, 137, 74, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/30{
  --tw-gradient-from: rgba(163, 137, 74, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/35{
  --tw-gradient-from: rgba(163, 137, 74, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/40{
  --tw-gradient-from: rgba(163, 137, 74, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/45{
  --tw-gradient-from: rgba(163, 137, 74, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/5{
  --tw-gradient-from: rgba(163, 137, 74, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/50{
  --tw-gradient-from: rgba(163, 137, 74, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/55{
  --tw-gradient-from: rgba(163, 137, 74, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/60{
  --tw-gradient-from: rgba(163, 137, 74, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/65{
  --tw-gradient-from: rgba(163, 137, 74, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/70{
  --tw-gradient-from: rgba(163, 137, 74, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/75{
  --tw-gradient-from: rgba(163, 137, 74, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/80{
  --tw-gradient-from: rgba(163, 137, 74, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/85{
  --tw-gradient-from: rgba(163, 137, 74, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/90{
  --tw-gradient-from: rgba(163, 137, 74, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kids-stories-900\\/95{
  --tw-gradient-from: rgba(163, 137, 74, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100{
  --tw-gradient-from: #f5edd0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/0{
  --tw-gradient-from: rgba(245, 237, 208, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/10{
  --tw-gradient-from: rgba(245, 237, 208, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/100{
  --tw-gradient-from: rgb(245, 237, 208) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/15{
  --tw-gradient-from: rgba(245, 237, 208, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/20{
  --tw-gradient-from: rgba(245, 237, 208, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/25{
  --tw-gradient-from: rgba(245, 237, 208, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/30{
  --tw-gradient-from: rgba(245, 237, 208, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/35{
  --tw-gradient-from: rgba(245, 237, 208, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/40{
  --tw-gradient-from: rgba(245, 237, 208, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/45{
  --tw-gradient-from: rgba(245, 237, 208, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/5{
  --tw-gradient-from: rgba(245, 237, 208, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/50{
  --tw-gradient-from: rgba(245, 237, 208, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/55{
  --tw-gradient-from: rgba(245, 237, 208, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/60{
  --tw-gradient-from: rgba(245, 237, 208, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/65{
  --tw-gradient-from: rgba(245, 237, 208, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/70{
  --tw-gradient-from: rgba(245, 237, 208, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/75{
  --tw-gradient-from: rgba(245, 237, 208, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/80{
  --tw-gradient-from: rgba(245, 237, 208, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/85{
  --tw-gradient-from: rgba(245, 237, 208, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/90{
  --tw-gradient-from: rgba(245, 237, 208, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-100\\/95{
  --tw-gradient-from: rgba(245, 237, 208, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200{
  --tw-gradient-from: #ebd99c var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/0{
  --tw-gradient-from: rgba(235, 217, 156, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/10{
  --tw-gradient-from: rgba(235, 217, 156, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/100{
  --tw-gradient-from: rgb(235, 217, 156) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/15{
  --tw-gradient-from: rgba(235, 217, 156, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/20{
  --tw-gradient-from: rgba(235, 217, 156, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/25{
  --tw-gradient-from: rgba(235, 217, 156, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/30{
  --tw-gradient-from: rgba(235, 217, 156, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/35{
  --tw-gradient-from: rgba(235, 217, 156, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/40{
  --tw-gradient-from: rgba(235, 217, 156, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/45{
  --tw-gradient-from: rgba(235, 217, 156, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/5{
  --tw-gradient-from: rgba(235, 217, 156, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/50{
  --tw-gradient-from: rgba(235, 217, 156, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/55{
  --tw-gradient-from: rgba(235, 217, 156, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/60{
  --tw-gradient-from: rgba(235, 217, 156, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/65{
  --tw-gradient-from: rgba(235, 217, 156, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/70{
  --tw-gradient-from: rgba(235, 217, 156, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/75{
  --tw-gradient-from: rgba(235, 217, 156, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/80{
  --tw-gradient-from: rgba(235, 217, 156, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/85{
  --tw-gradient-from: rgba(235, 217, 156, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/90{
  --tw-gradient-from: rgba(235, 217, 156, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-200\\/95{
  --tw-gradient-from: rgba(235, 217, 156, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300{
  --tw-gradient-from: #e1c268 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/0{
  --tw-gradient-from: rgba(225, 194, 104, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/10{
  --tw-gradient-from: rgba(225, 194, 104, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/100{
  --tw-gradient-from: rgb(225, 194, 104) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/15{
  --tw-gradient-from: rgba(225, 194, 104, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/20{
  --tw-gradient-from: rgba(225, 194, 104, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/25{
  --tw-gradient-from: rgba(225, 194, 104, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/30{
  --tw-gradient-from: rgba(225, 194, 104, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/35{
  --tw-gradient-from: rgba(225, 194, 104, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/40{
  --tw-gradient-from: rgba(225, 194, 104, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/45{
  --tw-gradient-from: rgba(225, 194, 104, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/5{
  --tw-gradient-from: rgba(225, 194, 104, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/50{
  --tw-gradient-from: rgba(225, 194, 104, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/55{
  --tw-gradient-from: rgba(225, 194, 104, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/60{
  --tw-gradient-from: rgba(225, 194, 104, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/65{
  --tw-gradient-from: rgba(225, 194, 104, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/70{
  --tw-gradient-from: rgba(225, 194, 104, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/75{
  --tw-gradient-from: rgba(225, 194, 104, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/80{
  --tw-gradient-from: rgba(225, 194, 104, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/85{
  --tw-gradient-from: rgba(225, 194, 104, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/90{
  --tw-gradient-from: rgba(225, 194, 104, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-300\\/95{
  --tw-gradient-from: rgba(225, 194, 104, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400{
  --tw-gradient-from: #daad45 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/0{
  --tw-gradient-from: rgba(218, 173, 69, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/10{
  --tw-gradient-from: rgba(218, 173, 69, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/100{
  --tw-gradient-from: rgb(218, 173, 69) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/15{
  --tw-gradient-from: rgba(218, 173, 69, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/20{
  --tw-gradient-from: rgba(218, 173, 69, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/25{
  --tw-gradient-from: rgba(218, 173, 69, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/30{
  --tw-gradient-from: rgba(218, 173, 69, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/35{
  --tw-gradient-from: rgba(218, 173, 69, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/40{
  --tw-gradient-from: rgba(218, 173, 69, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/45{
  --tw-gradient-from: rgba(218, 173, 69, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/5{
  --tw-gradient-from: rgba(218, 173, 69, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/50{
  --tw-gradient-from: rgba(218, 173, 69, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/55{
  --tw-gradient-from: rgba(218, 173, 69, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/60{
  --tw-gradient-from: rgba(218, 173, 69, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/65{
  --tw-gradient-from: rgba(218, 173, 69, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/70{
  --tw-gradient-from: rgba(218, 173, 69, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/75{
  --tw-gradient-from: rgba(218, 173, 69, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/80{
  --tw-gradient-from: rgba(218, 173, 69, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/85{
  --tw-gradient-from: rgba(218, 173, 69, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/90{
  --tw-gradient-from: rgba(218, 173, 69, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-400\\/95{
  --tw-gradient-from: rgba(218, 173, 69, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500{
  --tw-gradient-from: #d1912f var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/0{
  --tw-gradient-from: rgba(209, 145, 47, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/10{
  --tw-gradient-from: rgba(209, 145, 47, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/100{
  --tw-gradient-from: rgb(209, 145, 47) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/15{
  --tw-gradient-from: rgba(209, 145, 47, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/20{
  --tw-gradient-from: rgba(209, 145, 47, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/25{
  --tw-gradient-from: rgba(209, 145, 47, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/30{
  --tw-gradient-from: rgba(209, 145, 47, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/35{
  --tw-gradient-from: rgba(209, 145, 47, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/40{
  --tw-gradient-from: rgba(209, 145, 47, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/45{
  --tw-gradient-from: rgba(209, 145, 47, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/5{
  --tw-gradient-from: rgba(209, 145, 47, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/50{
  --tw-gradient-from: rgba(209, 145, 47, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/55{
  --tw-gradient-from: rgba(209, 145, 47, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/60{
  --tw-gradient-from: rgba(209, 145, 47, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/65{
  --tw-gradient-from: rgba(209, 145, 47, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/70{
  --tw-gradient-from: rgba(209, 145, 47, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/75{
  --tw-gradient-from: rgba(209, 145, 47, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/80{
  --tw-gradient-from: rgba(209, 145, 47, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/85{
  --tw-gradient-from: rgba(209, 145, 47, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/90{
  --tw-gradient-from: rgba(209, 145, 47, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-500\\/95{
  --tw-gradient-from: rgba(209, 145, 47, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600{
  --tw-gradient-from: #c37829 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/0{
  --tw-gradient-from: rgba(195, 120, 41, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/10{
  --tw-gradient-from: rgba(195, 120, 41, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/100{
  --tw-gradient-from: rgb(195, 120, 41) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/15{
  --tw-gradient-from: rgba(195, 120, 41, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/20{
  --tw-gradient-from: rgba(195, 120, 41, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/25{
  --tw-gradient-from: rgba(195, 120, 41, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/30{
  --tw-gradient-from: rgba(195, 120, 41, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/35{
  --tw-gradient-from: rgba(195, 120, 41, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/40{
  --tw-gradient-from: rgba(195, 120, 41, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/45{
  --tw-gradient-from: rgba(195, 120, 41, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/5{
  --tw-gradient-from: rgba(195, 120, 41, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/50{
  --tw-gradient-from: rgba(195, 120, 41, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/55{
  --tw-gradient-from: rgba(195, 120, 41, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/60{
  --tw-gradient-from: rgba(195, 120, 41, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/65{
  --tw-gradient-from: rgba(195, 120, 41, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/70{
  --tw-gradient-from: rgba(195, 120, 41, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/75{
  --tw-gradient-from: rgba(195, 120, 41, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/80{
  --tw-gradient-from: rgba(195, 120, 41, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/85{
  --tw-gradient-from: rgba(195, 120, 41, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/90{
  --tw-gradient-from: rgba(195, 120, 41, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-600\\/95{
  --tw-gradient-from: rgba(195, 120, 41, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700{
  --tw-gradient-from: #995424 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/0{
  --tw-gradient-from: rgba(153, 84, 36, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/10{
  --tw-gradient-from: rgba(153, 84, 36, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/100{
  --tw-gradient-from: rgb(153, 84, 36) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/15{
  --tw-gradient-from: rgba(153, 84, 36, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/20{
  --tw-gradient-from: rgba(153, 84, 36, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/25{
  --tw-gradient-from: rgba(153, 84, 36, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/30{
  --tw-gradient-from: rgba(153, 84, 36, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/35{
  --tw-gradient-from: rgba(153, 84, 36, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/40{
  --tw-gradient-from: rgba(153, 84, 36, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/45{
  --tw-gradient-from: rgba(153, 84, 36, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/5{
  --tw-gradient-from: rgba(153, 84, 36, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/50{
  --tw-gradient-from: rgba(153, 84, 36, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/55{
  --tw-gradient-from: rgba(153, 84, 36, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/60{
  --tw-gradient-from: rgba(153, 84, 36, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/65{
  --tw-gradient-from: rgba(153, 84, 36, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/70{
  --tw-gradient-from: rgba(153, 84, 36, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/75{
  --tw-gradient-from: rgba(153, 84, 36, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/80{
  --tw-gradient-from: rgba(153, 84, 36, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/85{
  --tw-gradient-from: rgba(153, 84, 36, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/90{
  --tw-gradient-from: rgba(153, 84, 36, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-700\\/95{
  --tw-gradient-from: rgba(153, 84, 36, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800{
  --tw-gradient-from: #7e4322 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/0{
  --tw-gradient-from: rgba(126, 67, 34, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/10{
  --tw-gradient-from: rgba(126, 67, 34, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/100{
  --tw-gradient-from: rgb(126, 67, 34) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/15{
  --tw-gradient-from: rgba(126, 67, 34, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/20{
  --tw-gradient-from: rgba(126, 67, 34, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/25{
  --tw-gradient-from: rgba(126, 67, 34, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/30{
  --tw-gradient-from: rgba(126, 67, 34, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/35{
  --tw-gradient-from: rgba(126, 67, 34, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/40{
  --tw-gradient-from: rgba(126, 67, 34, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/45{
  --tw-gradient-from: rgba(126, 67, 34, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/5{
  --tw-gradient-from: rgba(126, 67, 34, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/50{
  --tw-gradient-from: rgba(126, 67, 34, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/55{
  --tw-gradient-from: rgba(126, 67, 34, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/60{
  --tw-gradient-from: rgba(126, 67, 34, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/65{
  --tw-gradient-from: rgba(126, 67, 34, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/70{
  --tw-gradient-from: rgba(126, 67, 34, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/75{
  --tw-gradient-from: rgba(126, 67, 34, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/80{
  --tw-gradient-from: rgba(126, 67, 34, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/85{
  --tw-gradient-from: rgba(126, 67, 34, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/90{
  --tw-gradient-from: rgba(126, 67, 34, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-800\\/95{
  --tw-gradient-from: rgba(126, 67, 34, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900{
  --tw-gradient-from: #68381f var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/0{
  --tw-gradient-from: rgba(104, 56, 31, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/10{
  --tw-gradient-from: rgba(104, 56, 31, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/100{
  --tw-gradient-from: rgb(104, 56, 31) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/15{
  --tw-gradient-from: rgba(104, 56, 31, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/20{
  --tw-gradient-from: rgba(104, 56, 31, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/25{
  --tw-gradient-from: rgba(104, 56, 31, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/30{
  --tw-gradient-from: rgba(104, 56, 31, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/35{
  --tw-gradient-from: rgba(104, 56, 31, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/40{
  --tw-gradient-from: rgba(104, 56, 31, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/45{
  --tw-gradient-from: rgba(104, 56, 31, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/5{
  --tw-gradient-from: rgba(104, 56, 31, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/50{
  --tw-gradient-from: rgba(104, 56, 31, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/55{
  --tw-gradient-from: rgba(104, 56, 31, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/60{
  --tw-gradient-from: rgba(104, 56, 31, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/65{
  --tw-gradient-from: rgba(104, 56, 31, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/70{
  --tw-gradient-from: rgba(104, 56, 31, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/75{
  --tw-gradient-from: rgba(104, 56, 31, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/80{
  --tw-gradient-from: rgba(104, 56, 31, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/85{
  --tw-gradient-from: rgba(104, 56, 31, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/90{
  --tw-gradient-from: rgba(104, 56, 31, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-900\\/95{
  --tw-gradient-from: rgba(104, 56, 31, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950{
  --tw-gradient-from: #3b1c0d var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/0{
  --tw-gradient-from: rgba(59, 28, 13, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/10{
  --tw-gradient-from: rgba(59, 28, 13, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/100{
  --tw-gradient-from: rgb(59, 28, 13) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/15{
  --tw-gradient-from: rgba(59, 28, 13, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/20{
  --tw-gradient-from: rgba(59, 28, 13, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/25{
  --tw-gradient-from: rgba(59, 28, 13, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/30{
  --tw-gradient-from: rgba(59, 28, 13, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/35{
  --tw-gradient-from: rgba(59, 28, 13, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/40{
  --tw-gradient-from: rgba(59, 28, 13, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/45{
  --tw-gradient-from: rgba(59, 28, 13, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/5{
  --tw-gradient-from: rgba(59, 28, 13, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/50{
  --tw-gradient-from: rgba(59, 28, 13, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/55{
  --tw-gradient-from: rgba(59, 28, 13, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/60{
  --tw-gradient-from: rgba(59, 28, 13, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/65{
  --tw-gradient-from: rgba(59, 28, 13, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/70{
  --tw-gradient-from: rgba(59, 28, 13, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/75{
  --tw-gradient-from: rgba(59, 28, 13, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/80{
  --tw-gradient-from: rgba(59, 28, 13, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/85{
  --tw-gradient-from: rgba(59, 28, 13, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/90{
  --tw-gradient-from: rgba(59, 28, 13, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ochre-950\\/95{
  --tw-gradient-from: rgba(59, 28, 13, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100{
  --tw-gradient-from: #f5edd0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/0{
  --tw-gradient-from: rgba(245, 237, 208, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/10{
  --tw-gradient-from: rgba(245, 237, 208, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/100{
  --tw-gradient-from: rgb(245, 237, 208) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/15{
  --tw-gradient-from: rgba(245, 237, 208, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/20{
  --tw-gradient-from: rgba(245, 237, 208, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/25{
  --tw-gradient-from: rgba(245, 237, 208, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/30{
  --tw-gradient-from: rgba(245, 237, 208, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/35{
  --tw-gradient-from: rgba(245, 237, 208, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/40{
  --tw-gradient-from: rgba(245, 237, 208, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/45{
  --tw-gradient-from: rgba(245, 237, 208, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/5{
  --tw-gradient-from: rgba(245, 237, 208, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/50{
  --tw-gradient-from: rgba(245, 237, 208, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/55{
  --tw-gradient-from: rgba(245, 237, 208, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/60{
  --tw-gradient-from: rgba(245, 237, 208, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/65{
  --tw-gradient-from: rgba(245, 237, 208, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/70{
  --tw-gradient-from: rgba(245, 237, 208, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/75{
  --tw-gradient-from: rgba(245, 237, 208, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/80{
  --tw-gradient-from: rgba(245, 237, 208, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/85{
  --tw-gradient-from: rgba(245, 237, 208, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/90{
  --tw-gradient-from: rgba(245, 237, 208, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-100\\/95{
  --tw-gradient-from: rgba(245, 237, 208, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200{
  --tw-gradient-from: #ebd99c var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/0{
  --tw-gradient-from: rgba(235, 217, 156, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/10{
  --tw-gradient-from: rgba(235, 217, 156, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/100{
  --tw-gradient-from: rgb(235, 217, 156) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/15{
  --tw-gradient-from: rgba(235, 217, 156, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/20{
  --tw-gradient-from: rgba(235, 217, 156, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/25{
  --tw-gradient-from: rgba(235, 217, 156, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/30{
  --tw-gradient-from: rgba(235, 217, 156, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/35{
  --tw-gradient-from: rgba(235, 217, 156, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/40{
  --tw-gradient-from: rgba(235, 217, 156, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/45{
  --tw-gradient-from: rgba(235, 217, 156, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/5{
  --tw-gradient-from: rgba(235, 217, 156, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/50{
  --tw-gradient-from: rgba(235, 217, 156, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/55{
  --tw-gradient-from: rgba(235, 217, 156, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/60{
  --tw-gradient-from: rgba(235, 217, 156, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/65{
  --tw-gradient-from: rgba(235, 217, 156, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/70{
  --tw-gradient-from: rgba(235, 217, 156, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/75{
  --tw-gradient-from: rgba(235, 217, 156, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/80{
  --tw-gradient-from: rgba(235, 217, 156, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/85{
  --tw-gradient-from: rgba(235, 217, 156, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/90{
  --tw-gradient-from: rgba(235, 217, 156, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-200\\/95{
  --tw-gradient-from: rgba(235, 217, 156, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300{
  --tw-gradient-from: #e1c268 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/0{
  --tw-gradient-from: rgba(225, 194, 104, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/10{
  --tw-gradient-from: rgba(225, 194, 104, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/100{
  --tw-gradient-from: rgb(225, 194, 104) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/15{
  --tw-gradient-from: rgba(225, 194, 104, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/20{
  --tw-gradient-from: rgba(225, 194, 104, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/25{
  --tw-gradient-from: rgba(225, 194, 104, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/30{
  --tw-gradient-from: rgba(225, 194, 104, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/35{
  --tw-gradient-from: rgba(225, 194, 104, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/40{
  --tw-gradient-from: rgba(225, 194, 104, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/45{
  --tw-gradient-from: rgba(225, 194, 104, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/5{
  --tw-gradient-from: rgba(225, 194, 104, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/50{
  --tw-gradient-from: rgba(225, 194, 104, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/55{
  --tw-gradient-from: rgba(225, 194, 104, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/60{
  --tw-gradient-from: rgba(225, 194, 104, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/65{
  --tw-gradient-from: rgba(225, 194, 104, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/70{
  --tw-gradient-from: rgba(225, 194, 104, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/75{
  --tw-gradient-from: rgba(225, 194, 104, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/80{
  --tw-gradient-from: rgba(225, 194, 104, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/85{
  --tw-gradient-from: rgba(225, 194, 104, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/90{
  --tw-gradient-from: rgba(225, 194, 104, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-300\\/95{
  --tw-gradient-from: rgba(225, 194, 104, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400{
  --tw-gradient-from: #daad45 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/0{
  --tw-gradient-from: rgba(218, 173, 69, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/10{
  --tw-gradient-from: rgba(218, 173, 69, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/100{
  --tw-gradient-from: rgb(218, 173, 69) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/15{
  --tw-gradient-from: rgba(218, 173, 69, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/20{
  --tw-gradient-from: rgba(218, 173, 69, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/25{
  --tw-gradient-from: rgba(218, 173, 69, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/30{
  --tw-gradient-from: rgba(218, 173, 69, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/35{
  --tw-gradient-from: rgba(218, 173, 69, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/40{
  --tw-gradient-from: rgba(218, 173, 69, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/45{
  --tw-gradient-from: rgba(218, 173, 69, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/5{
  --tw-gradient-from: rgba(218, 173, 69, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/50{
  --tw-gradient-from: rgba(218, 173, 69, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/55{
  --tw-gradient-from: rgba(218, 173, 69, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/60{
  --tw-gradient-from: rgba(218, 173, 69, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/65{
  --tw-gradient-from: rgba(218, 173, 69, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/70{
  --tw-gradient-from: rgba(218, 173, 69, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/75{
  --tw-gradient-from: rgba(218, 173, 69, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/80{
  --tw-gradient-from: rgba(218, 173, 69, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/85{
  --tw-gradient-from: rgba(218, 173, 69, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/90{
  --tw-gradient-from: rgba(218, 173, 69, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-400\\/95{
  --tw-gradient-from: rgba(218, 173, 69, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500{
  --tw-gradient-from: #d1912f var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/0{
  --tw-gradient-from: rgba(209, 145, 47, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/10{
  --tw-gradient-from: rgba(209, 145, 47, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/100{
  --tw-gradient-from: rgb(209, 145, 47) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/15{
  --tw-gradient-from: rgba(209, 145, 47, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/20{
  --tw-gradient-from: rgba(209, 145, 47, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/25{
  --tw-gradient-from: rgba(209, 145, 47, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/30{
  --tw-gradient-from: rgba(209, 145, 47, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/35{
  --tw-gradient-from: rgba(209, 145, 47, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/40{
  --tw-gradient-from: rgba(209, 145, 47, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/45{
  --tw-gradient-from: rgba(209, 145, 47, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/5{
  --tw-gradient-from: rgba(209, 145, 47, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/50{
  --tw-gradient-from: rgba(209, 145, 47, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/55{
  --tw-gradient-from: rgba(209, 145, 47, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/60{
  --tw-gradient-from: rgba(209, 145, 47, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/65{
  --tw-gradient-from: rgba(209, 145, 47, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/70{
  --tw-gradient-from: rgba(209, 145, 47, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/75{
  --tw-gradient-from: rgba(209, 145, 47, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/80{
  --tw-gradient-from: rgba(209, 145, 47, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/85{
  --tw-gradient-from: rgba(209, 145, 47, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/90{
  --tw-gradient-from: rgba(209, 145, 47, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-500\\/95{
  --tw-gradient-from: rgba(209, 145, 47, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600{
  --tw-gradient-from: #c37829 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/0{
  --tw-gradient-from: rgba(195, 120, 41, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/10{
  --tw-gradient-from: rgba(195, 120, 41, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/100{
  --tw-gradient-from: rgb(195, 120, 41) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/15{
  --tw-gradient-from: rgba(195, 120, 41, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/20{
  --tw-gradient-from: rgba(195, 120, 41, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/25{
  --tw-gradient-from: rgba(195, 120, 41, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/30{
  --tw-gradient-from: rgba(195, 120, 41, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/35{
  --tw-gradient-from: rgba(195, 120, 41, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/40{
  --tw-gradient-from: rgba(195, 120, 41, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/45{
  --tw-gradient-from: rgba(195, 120, 41, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/5{
  --tw-gradient-from: rgba(195, 120, 41, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/50{
  --tw-gradient-from: rgba(195, 120, 41, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/55{
  --tw-gradient-from: rgba(195, 120, 41, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/60{
  --tw-gradient-from: rgba(195, 120, 41, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/65{
  --tw-gradient-from: rgba(195, 120, 41, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/70{
  --tw-gradient-from: rgba(195, 120, 41, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/75{
  --tw-gradient-from: rgba(195, 120, 41, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/80{
  --tw-gradient-from: rgba(195, 120, 41, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/85{
  --tw-gradient-from: rgba(195, 120, 41, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/90{
  --tw-gradient-from: rgba(195, 120, 41, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-600\\/95{
  --tw-gradient-from: rgba(195, 120, 41, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700{
  --tw-gradient-from: #995424 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/0{
  --tw-gradient-from: rgba(153, 84, 36, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/10{
  --tw-gradient-from: rgba(153, 84, 36, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/100{
  --tw-gradient-from: rgb(153, 84, 36) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/15{
  --tw-gradient-from: rgba(153, 84, 36, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/20{
  --tw-gradient-from: rgba(153, 84, 36, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/25{
  --tw-gradient-from: rgba(153, 84, 36, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/30{
  --tw-gradient-from: rgba(153, 84, 36, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/35{
  --tw-gradient-from: rgba(153, 84, 36, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/40{
  --tw-gradient-from: rgba(153, 84, 36, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/45{
  --tw-gradient-from: rgba(153, 84, 36, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/5{
  --tw-gradient-from: rgba(153, 84, 36, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/50{
  --tw-gradient-from: rgba(153, 84, 36, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/55{
  --tw-gradient-from: rgba(153, 84, 36, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/60{
  --tw-gradient-from: rgba(153, 84, 36, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/65{
  --tw-gradient-from: rgba(153, 84, 36, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/70{
  --tw-gradient-from: rgba(153, 84, 36, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/75{
  --tw-gradient-from: rgba(153, 84, 36, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/80{
  --tw-gradient-from: rgba(153, 84, 36, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/85{
  --tw-gradient-from: rgba(153, 84, 36, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/90{
  --tw-gradient-from: rgba(153, 84, 36, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-700\\/95{
  --tw-gradient-from: rgba(153, 84, 36, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800{
  --tw-gradient-from: #7e4322 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/0{
  --tw-gradient-from: rgba(126, 67, 34, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/10{
  --tw-gradient-from: rgba(126, 67, 34, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/100{
  --tw-gradient-from: rgb(126, 67, 34) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/15{
  --tw-gradient-from: rgba(126, 67, 34, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/20{
  --tw-gradient-from: rgba(126, 67, 34, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/25{
  --tw-gradient-from: rgba(126, 67, 34, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/30{
  --tw-gradient-from: rgba(126, 67, 34, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/35{
  --tw-gradient-from: rgba(126, 67, 34, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/40{
  --tw-gradient-from: rgba(126, 67, 34, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/45{
  --tw-gradient-from: rgba(126, 67, 34, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/5{
  --tw-gradient-from: rgba(126, 67, 34, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/50{
  --tw-gradient-from: rgba(126, 67, 34, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/55{
  --tw-gradient-from: rgba(126, 67, 34, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/60{
  --tw-gradient-from: rgba(126, 67, 34, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/65{
  --tw-gradient-from: rgba(126, 67, 34, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/70{
  --tw-gradient-from: rgba(126, 67, 34, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/75{
  --tw-gradient-from: rgba(126, 67, 34, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/80{
  --tw-gradient-from: rgba(126, 67, 34, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/85{
  --tw-gradient-from: rgba(126, 67, 34, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/90{
  --tw-gradient-from: rgba(126, 67, 34, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-800\\/95{
  --tw-gradient-from: rgba(126, 67, 34, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900{
  --tw-gradient-from: #68381f var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/0{
  --tw-gradient-from: rgba(104, 56, 31, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/10{
  --tw-gradient-from: rgba(104, 56, 31, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/100{
  --tw-gradient-from: rgb(104, 56, 31) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/15{
  --tw-gradient-from: rgba(104, 56, 31, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/20{
  --tw-gradient-from: rgba(104, 56, 31, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/25{
  --tw-gradient-from: rgba(104, 56, 31, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/30{
  --tw-gradient-from: rgba(104, 56, 31, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/35{
  --tw-gradient-from: rgba(104, 56, 31, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/40{
  --tw-gradient-from: rgba(104, 56, 31, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/45{
  --tw-gradient-from: rgba(104, 56, 31, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/5{
  --tw-gradient-from: rgba(104, 56, 31, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/50{
  --tw-gradient-from: rgba(104, 56, 31, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/55{
  --tw-gradient-from: rgba(104, 56, 31, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/60{
  --tw-gradient-from: rgba(104, 56, 31, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/65{
  --tw-gradient-from: rgba(104, 56, 31, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/70{
  --tw-gradient-from: rgba(104, 56, 31, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/75{
  --tw-gradient-from: rgba(104, 56, 31, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/80{
  --tw-gradient-from: rgba(104, 56, 31, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/85{
  --tw-gradient-from: rgba(104, 56, 31, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/90{
  --tw-gradient-from: rgba(104, 56, 31, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-900\\/95{
  --tw-gradient-from: rgba(104, 56, 31, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950{
  --tw-gradient-from: #3b1c0d var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/0{
  --tw-gradient-from: rgba(59, 28, 13, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/10{
  --tw-gradient-from: rgba(59, 28, 13, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/100{
  --tw-gradient-from: rgb(59, 28, 13) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/15{
  --tw-gradient-from: rgba(59, 28, 13, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/20{
  --tw-gradient-from: rgba(59, 28, 13, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/25{
  --tw-gradient-from: rgba(59, 28, 13, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/30{
  --tw-gradient-from: rgba(59, 28, 13, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/35{
  --tw-gradient-from: rgba(59, 28, 13, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/40{
  --tw-gradient-from: rgba(59, 28, 13, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/45{
  --tw-gradient-from: rgba(59, 28, 13, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/5{
  --tw-gradient-from: rgba(59, 28, 13, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/50{
  --tw-gradient-from: rgba(59, 28, 13, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/55{
  --tw-gradient-from: rgba(59, 28, 13, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/60{
  --tw-gradient-from: rgba(59, 28, 13, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/65{
  --tw-gradient-from: rgba(59, 28, 13, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/70{
  --tw-gradient-from: rgba(59, 28, 13, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/75{
  --tw-gradient-from: rgba(59, 28, 13, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/80{
  --tw-gradient-from: rgba(59, 28, 13, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/85{
  --tw-gradient-from: rgba(59, 28, 13, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/90{
  --tw-gradient-from: rgba(59, 28, 13, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-phrase-color-950\\/95{
  --tw-gradient-from: rgba(59, 28, 13, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100{
  --tw-gradient-from: #ffdcdf var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/0{
  --tw-gradient-from: rgba(255, 220, 223, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/10{
  --tw-gradient-from: rgba(255, 220, 223, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/100{
  --tw-gradient-from: rgb(255, 220, 223) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/15{
  --tw-gradient-from: rgba(255, 220, 223, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/20{
  --tw-gradient-from: rgba(255, 220, 223, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/25{
  --tw-gradient-from: rgba(255, 220, 223, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/30{
  --tw-gradient-from: rgba(255, 220, 223, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/35{
  --tw-gradient-from: rgba(255, 220, 223, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/40{
  --tw-gradient-from: rgba(255, 220, 223, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/45{
  --tw-gradient-from: rgba(255, 220, 223, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/5{
  --tw-gradient-from: rgba(255, 220, 223, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/50{
  --tw-gradient-from: rgba(255, 220, 223, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/55{
  --tw-gradient-from: rgba(255, 220, 223, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/60{
  --tw-gradient-from: rgba(255, 220, 223, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/65{
  --tw-gradient-from: rgba(255, 220, 223, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/70{
  --tw-gradient-from: rgba(255, 220, 223, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/75{
  --tw-gradient-from: rgba(255, 220, 223, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/80{
  --tw-gradient-from: rgba(255, 220, 223, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/85{
  --tw-gradient-from: rgba(255, 220, 223, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/90{
  --tw-gradient-from: rgba(255, 220, 223, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-100\\/95{
  --tw-gradient-from: rgba(255, 220, 223, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200{
  --tw-gradient-from: #ffc0c6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/0{
  --tw-gradient-from: rgba(255, 192, 198, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/10{
  --tw-gradient-from: rgba(255, 192, 198, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/100{
  --tw-gradient-from: rgb(255, 192, 198) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/15{
  --tw-gradient-from: rgba(255, 192, 198, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/20{
  --tw-gradient-from: rgba(255, 192, 198, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/25{
  --tw-gradient-from: rgba(255, 192, 198, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/30{
  --tw-gradient-from: rgba(255, 192, 198, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/35{
  --tw-gradient-from: rgba(255, 192, 198, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/40{
  --tw-gradient-from: rgba(255, 192, 198, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/45{
  --tw-gradient-from: rgba(255, 192, 198, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/5{
  --tw-gradient-from: rgba(255, 192, 198, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/50{
  --tw-gradient-from: rgba(255, 192, 198, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/55{
  --tw-gradient-from: rgba(255, 192, 198, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/60{
  --tw-gradient-from: rgba(255, 192, 198, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/65{
  --tw-gradient-from: rgba(255, 192, 198, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/70{
  --tw-gradient-from: rgba(255, 192, 198, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/75{
  --tw-gradient-from: rgba(255, 192, 198, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/80{
  --tw-gradient-from: rgba(255, 192, 198, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/85{
  --tw-gradient-from: rgba(255, 192, 198, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/90{
  --tw-gradient-from: rgba(255, 192, 198, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-200\\/95{
  --tw-gradient-from: rgba(255, 192, 198, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300{
  --tw-gradient-from: #ff949e var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/0{
  --tw-gradient-from: rgba(255, 148, 158, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/10{
  --tw-gradient-from: rgba(255, 148, 158, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/100{
  --tw-gradient-from: rgb(255, 148, 158) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/15{
  --tw-gradient-from: rgba(255, 148, 158, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/20{
  --tw-gradient-from: rgba(255, 148, 158, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/25{
  --tw-gradient-from: rgba(255, 148, 158, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/30{
  --tw-gradient-from: rgba(255, 148, 158, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/35{
  --tw-gradient-from: rgba(255, 148, 158, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/40{
  --tw-gradient-from: rgba(255, 148, 158, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/45{
  --tw-gradient-from: rgba(255, 148, 158, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/5{
  --tw-gradient-from: rgba(255, 148, 158, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/50{
  --tw-gradient-from: rgba(255, 148, 158, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/55{
  --tw-gradient-from: rgba(255, 148, 158, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/60{
  --tw-gradient-from: rgba(255, 148, 158, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/65{
  --tw-gradient-from: rgba(255, 148, 158, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/70{
  --tw-gradient-from: rgba(255, 148, 158, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/75{
  --tw-gradient-from: rgba(255, 148, 158, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/80{
  --tw-gradient-from: rgba(255, 148, 158, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/85{
  --tw-gradient-from: rgba(255, 148, 158, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/90{
  --tw-gradient-from: rgba(255, 148, 158, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-300\\/95{
  --tw-gradient-from: rgba(255, 148, 158, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400{
  --tw-gradient-from: #ff5665 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/0{
  --tw-gradient-from: rgba(255, 86, 101, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/10{
  --tw-gradient-from: rgba(255, 86, 101, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/100{
  --tw-gradient-from: rgb(255, 86, 101) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/15{
  --tw-gradient-from: rgba(255, 86, 101, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/20{
  --tw-gradient-from: rgba(255, 86, 101, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/25{
  --tw-gradient-from: rgba(255, 86, 101, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/30{
  --tw-gradient-from: rgba(255, 86, 101, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/35{
  --tw-gradient-from: rgba(255, 86, 101, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/40{
  --tw-gradient-from: rgba(255, 86, 101, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/45{
  --tw-gradient-from: rgba(255, 86, 101, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/5{
  --tw-gradient-from: rgba(255, 86, 101, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/50{
  --tw-gradient-from: rgba(255, 86, 101, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/55{
  --tw-gradient-from: rgba(255, 86, 101, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/60{
  --tw-gradient-from: rgba(255, 86, 101, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/65{
  --tw-gradient-from: rgba(255, 86, 101, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/70{
  --tw-gradient-from: rgba(255, 86, 101, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/75{
  --tw-gradient-from: rgba(255, 86, 101, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/80{
  --tw-gradient-from: rgba(255, 86, 101, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/85{
  --tw-gradient-from: rgba(255, 86, 101, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/90{
  --tw-gradient-from: rgba(255, 86, 101, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-400\\/95{
  --tw-gradient-from: rgba(255, 86, 101, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500{
  --tw-gradient-from: #ff2236 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/0{
  --tw-gradient-from: rgba(255, 34, 54, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/10{
  --tw-gradient-from: rgba(255, 34, 54, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/100{
  --tw-gradient-from: rgb(255, 34, 54) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/15{
  --tw-gradient-from: rgba(255, 34, 54, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/20{
  --tw-gradient-from: rgba(255, 34, 54, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/25{
  --tw-gradient-from: rgba(255, 34, 54, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/30{
  --tw-gradient-from: rgba(255, 34, 54, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/35{
  --tw-gradient-from: rgba(255, 34, 54, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/40{
  --tw-gradient-from: rgba(255, 34, 54, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/45{
  --tw-gradient-from: rgba(255, 34, 54, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/5{
  --tw-gradient-from: rgba(255, 34, 54, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/50{
  --tw-gradient-from: rgba(255, 34, 54, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/55{
  --tw-gradient-from: rgba(255, 34, 54, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/60{
  --tw-gradient-from: rgba(255, 34, 54, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/65{
  --tw-gradient-from: rgba(255, 34, 54, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/70{
  --tw-gradient-from: rgba(255, 34, 54, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/75{
  --tw-gradient-from: rgba(255, 34, 54, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/80{
  --tw-gradient-from: rgba(255, 34, 54, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/85{
  --tw-gradient-from: rgba(255, 34, 54, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/90{
  --tw-gradient-from: rgba(255, 34, 54, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-500\\/95{
  --tw-gradient-from: rgba(255, 34, 54, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600{
  --tw-gradient-from: #ff0219 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/0{
  --tw-gradient-from: rgba(255, 2, 25, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/10{
  --tw-gradient-from: rgba(255, 2, 25, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/100{
  --tw-gradient-from: rgb(255, 2, 25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/15{
  --tw-gradient-from: rgba(255, 2, 25, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/20{
  --tw-gradient-from: rgba(255, 2, 25, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/25{
  --tw-gradient-from: rgba(255, 2, 25, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/30{
  --tw-gradient-from: rgba(255, 2, 25, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/35{
  --tw-gradient-from: rgba(255, 2, 25, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/40{
  --tw-gradient-from: rgba(255, 2, 25, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/45{
  --tw-gradient-from: rgba(255, 2, 25, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/5{
  --tw-gradient-from: rgba(255, 2, 25, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/50{
  --tw-gradient-from: rgba(255, 2, 25, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/55{
  --tw-gradient-from: rgba(255, 2, 25, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/60{
  --tw-gradient-from: rgba(255, 2, 25, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/65{
  --tw-gradient-from: rgba(255, 2, 25, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/70{
  --tw-gradient-from: rgba(255, 2, 25, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/75{
  --tw-gradient-from: rgba(255, 2, 25, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/80{
  --tw-gradient-from: rgba(255, 2, 25, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/85{
  --tw-gradient-from: rgba(255, 2, 25, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/90{
  --tw-gradient-from: rgba(255, 2, 25, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-600\\/95{
  --tw-gradient-from: rgba(255, 2, 25, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700{
  --tw-gradient-from: #d80013 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/0{
  --tw-gradient-from: rgba(216, 0, 19, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/10{
  --tw-gradient-from: rgba(216, 0, 19, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/100{
  --tw-gradient-from: rgb(216, 0, 19) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/15{
  --tw-gradient-from: rgba(216, 0, 19, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/20{
  --tw-gradient-from: rgba(216, 0, 19, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/25{
  --tw-gradient-from: rgba(216, 0, 19, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/30{
  --tw-gradient-from: rgba(216, 0, 19, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/35{
  --tw-gradient-from: rgba(216, 0, 19, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/40{
  --tw-gradient-from: rgba(216, 0, 19, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/45{
  --tw-gradient-from: rgba(216, 0, 19, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/5{
  --tw-gradient-from: rgba(216, 0, 19, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/50{
  --tw-gradient-from: rgba(216, 0, 19, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/55{
  --tw-gradient-from: rgba(216, 0, 19, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/60{
  --tw-gradient-from: rgba(216, 0, 19, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/65{
  --tw-gradient-from: rgba(216, 0, 19, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/70{
  --tw-gradient-from: rgba(216, 0, 19, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/75{
  --tw-gradient-from: rgba(216, 0, 19, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/80{
  --tw-gradient-from: rgba(216, 0, 19, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/85{
  --tw-gradient-from: rgba(216, 0, 19, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/90{
  --tw-gradient-from: rgba(216, 0, 19, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-700\\/95{
  --tw-gradient-from: rgba(216, 0, 19, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800{
  --tw-gradient-from: #b40212 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/0{
  --tw-gradient-from: rgba(180, 2, 18, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/10{
  --tw-gradient-from: rgba(180, 2, 18, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/100{
  --tw-gradient-from: rgb(180, 2, 18) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/15{
  --tw-gradient-from: rgba(180, 2, 18, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/20{
  --tw-gradient-from: rgba(180, 2, 18, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/25{
  --tw-gradient-from: rgba(180, 2, 18, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/30{
  --tw-gradient-from: rgba(180, 2, 18, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/35{
  --tw-gradient-from: rgba(180, 2, 18, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/40{
  --tw-gradient-from: rgba(180, 2, 18, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/45{
  --tw-gradient-from: rgba(180, 2, 18, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/5{
  --tw-gradient-from: rgba(180, 2, 18, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/50{
  --tw-gradient-from: rgba(180, 2, 18, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/55{
  --tw-gradient-from: rgba(180, 2, 18, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/60{
  --tw-gradient-from: rgba(180, 2, 18, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/65{
  --tw-gradient-from: rgba(180, 2, 18, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/70{
  --tw-gradient-from: rgba(180, 2, 18, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/75{
  --tw-gradient-from: rgba(180, 2, 18, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/80{
  --tw-gradient-from: rgba(180, 2, 18, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/85{
  --tw-gradient-from: rgba(180, 2, 18, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/90{
  --tw-gradient-from: rgba(180, 2, 18, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-800\\/95{
  --tw-gradient-from: rgba(180, 2, 18, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900{
  --tw-gradient-from: #920a16 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/0{
  --tw-gradient-from: rgba(146, 10, 22, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/10{
  --tw-gradient-from: rgba(146, 10, 22, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/100{
  --tw-gradient-from: rgb(146, 10, 22) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/15{
  --tw-gradient-from: rgba(146, 10, 22, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/20{
  --tw-gradient-from: rgba(146, 10, 22, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/25{
  --tw-gradient-from: rgba(146, 10, 22, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/30{
  --tw-gradient-from: rgba(146, 10, 22, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/35{
  --tw-gradient-from: rgba(146, 10, 22, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/40{
  --tw-gradient-from: rgba(146, 10, 22, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/45{
  --tw-gradient-from: rgba(146, 10, 22, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/5{
  --tw-gradient-from: rgba(146, 10, 22, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/50{
  --tw-gradient-from: rgba(146, 10, 22, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/55{
  --tw-gradient-from: rgba(146, 10, 22, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/60{
  --tw-gradient-from: rgba(146, 10, 22, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/65{
  --tw-gradient-from: rgba(146, 10, 22, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/70{
  --tw-gradient-from: rgba(146, 10, 22, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/75{
  --tw-gradient-from: rgba(146, 10, 22, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/80{
  --tw-gradient-from: rgba(146, 10, 22, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/85{
  --tw-gradient-from: rgba(146, 10, 22, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/90{
  --tw-gradient-from: rgba(146, 10, 22, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-900\\/95{
  --tw-gradient-from: rgba(146, 10, 22, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950{
  --tw-gradient-from: #510007 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/0{
  --tw-gradient-from: rgba(81, 0, 7, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/10{
  --tw-gradient-from: rgba(81, 0, 7, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/100{
  --tw-gradient-from: rgb(81, 0, 7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/15{
  --tw-gradient-from: rgba(81, 0, 7, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/20{
  --tw-gradient-from: rgba(81, 0, 7, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/25{
  --tw-gradient-from: rgba(81, 0, 7, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/30{
  --tw-gradient-from: rgba(81, 0, 7, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/35{
  --tw-gradient-from: rgba(81, 0, 7, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/40{
  --tw-gradient-from: rgba(81, 0, 7, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/45{
  --tw-gradient-from: rgba(81, 0, 7, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/5{
  --tw-gradient-from: rgba(81, 0, 7, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/50{
  --tw-gradient-from: rgba(81, 0, 7, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/55{
  --tw-gradient-from: rgba(81, 0, 7, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/60{
  --tw-gradient-from: rgba(81, 0, 7, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/65{
  --tw-gradient-from: rgba(81, 0, 7, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/70{
  --tw-gradient-from: rgba(81, 0, 7, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/75{
  --tw-gradient-from: rgba(81, 0, 7, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/80{
  --tw-gradient-from: rgba(81, 0, 7, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/85{
  --tw-gradient-from: rgba(81, 0, 7, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/90{
  --tw-gradient-from: rgba(81, 0, 7, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-scarlet-950\\/95{
  --tw-gradient-from: rgba(81, 0, 7, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100{
  --tw-gradient-from: #ffdcdf var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/0{
  --tw-gradient-from: rgba(255, 220, 223, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/10{
  --tw-gradient-from: rgba(255, 220, 223, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/100{
  --tw-gradient-from: rgb(255, 220, 223) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/15{
  --tw-gradient-from: rgba(255, 220, 223, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/20{
  --tw-gradient-from: rgba(255, 220, 223, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/25{
  --tw-gradient-from: rgba(255, 220, 223, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/30{
  --tw-gradient-from: rgba(255, 220, 223, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/35{
  --tw-gradient-from: rgba(255, 220, 223, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/40{
  --tw-gradient-from: rgba(255, 220, 223, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/45{
  --tw-gradient-from: rgba(255, 220, 223, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/5{
  --tw-gradient-from: rgba(255, 220, 223, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/50{
  --tw-gradient-from: rgba(255, 220, 223, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/55{
  --tw-gradient-from: rgba(255, 220, 223, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/60{
  --tw-gradient-from: rgba(255, 220, 223, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/65{
  --tw-gradient-from: rgba(255, 220, 223, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/70{
  --tw-gradient-from: rgba(255, 220, 223, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/75{
  --tw-gradient-from: rgba(255, 220, 223, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/80{
  --tw-gradient-from: rgba(255, 220, 223, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/85{
  --tw-gradient-from: rgba(255, 220, 223, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/90{
  --tw-gradient-from: rgba(255, 220, 223, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-100\\/95{
  --tw-gradient-from: rgba(255, 220, 223, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200{
  --tw-gradient-from: #ffc0c6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/0{
  --tw-gradient-from: rgba(255, 192, 198, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/10{
  --tw-gradient-from: rgba(255, 192, 198, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/100{
  --tw-gradient-from: rgb(255, 192, 198) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/15{
  --tw-gradient-from: rgba(255, 192, 198, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/20{
  --tw-gradient-from: rgba(255, 192, 198, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/25{
  --tw-gradient-from: rgba(255, 192, 198, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/30{
  --tw-gradient-from: rgba(255, 192, 198, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/35{
  --tw-gradient-from: rgba(255, 192, 198, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/40{
  --tw-gradient-from: rgba(255, 192, 198, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/45{
  --tw-gradient-from: rgba(255, 192, 198, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/5{
  --tw-gradient-from: rgba(255, 192, 198, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/50{
  --tw-gradient-from: rgba(255, 192, 198, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/55{
  --tw-gradient-from: rgba(255, 192, 198, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/60{
  --tw-gradient-from: rgba(255, 192, 198, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/65{
  --tw-gradient-from: rgba(255, 192, 198, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/70{
  --tw-gradient-from: rgba(255, 192, 198, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/75{
  --tw-gradient-from: rgba(255, 192, 198, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/80{
  --tw-gradient-from: rgba(255, 192, 198, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/85{
  --tw-gradient-from: rgba(255, 192, 198, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/90{
  --tw-gradient-from: rgba(255, 192, 198, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-200\\/95{
  --tw-gradient-from: rgba(255, 192, 198, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300{
  --tw-gradient-from: #ff949e var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/0{
  --tw-gradient-from: rgba(255, 148, 158, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/10{
  --tw-gradient-from: rgba(255, 148, 158, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/100{
  --tw-gradient-from: rgb(255, 148, 158) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/15{
  --tw-gradient-from: rgba(255, 148, 158, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/20{
  --tw-gradient-from: rgba(255, 148, 158, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/25{
  --tw-gradient-from: rgba(255, 148, 158, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/30{
  --tw-gradient-from: rgba(255, 148, 158, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/35{
  --tw-gradient-from: rgba(255, 148, 158, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/40{
  --tw-gradient-from: rgba(255, 148, 158, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/45{
  --tw-gradient-from: rgba(255, 148, 158, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/5{
  --tw-gradient-from: rgba(255, 148, 158, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/50{
  --tw-gradient-from: rgba(255, 148, 158, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/55{
  --tw-gradient-from: rgba(255, 148, 158, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/60{
  --tw-gradient-from: rgba(255, 148, 158, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/65{
  --tw-gradient-from: rgba(255, 148, 158, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/70{
  --tw-gradient-from: rgba(255, 148, 158, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/75{
  --tw-gradient-from: rgba(255, 148, 158, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/80{
  --tw-gradient-from: rgba(255, 148, 158, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/85{
  --tw-gradient-from: rgba(255, 148, 158, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/90{
  --tw-gradient-from: rgba(255, 148, 158, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-300\\/95{
  --tw-gradient-from: rgba(255, 148, 158, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400{
  --tw-gradient-from: #ff5665 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/0{
  --tw-gradient-from: rgba(255, 86, 101, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/10{
  --tw-gradient-from: rgba(255, 86, 101, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/100{
  --tw-gradient-from: rgb(255, 86, 101) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/15{
  --tw-gradient-from: rgba(255, 86, 101, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/20{
  --tw-gradient-from: rgba(255, 86, 101, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/25{
  --tw-gradient-from: rgba(255, 86, 101, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/30{
  --tw-gradient-from: rgba(255, 86, 101, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/35{
  --tw-gradient-from: rgba(255, 86, 101, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/40{
  --tw-gradient-from: rgba(255, 86, 101, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/45{
  --tw-gradient-from: rgba(255, 86, 101, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/5{
  --tw-gradient-from: rgba(255, 86, 101, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/50{
  --tw-gradient-from: rgba(255, 86, 101, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/55{
  --tw-gradient-from: rgba(255, 86, 101, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/60{
  --tw-gradient-from: rgba(255, 86, 101, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/65{
  --tw-gradient-from: rgba(255, 86, 101, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/70{
  --tw-gradient-from: rgba(255, 86, 101, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/75{
  --tw-gradient-from: rgba(255, 86, 101, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/80{
  --tw-gradient-from: rgba(255, 86, 101, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/85{
  --tw-gradient-from: rgba(255, 86, 101, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/90{
  --tw-gradient-from: rgba(255, 86, 101, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-400\\/95{
  --tw-gradient-from: rgba(255, 86, 101, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500{
  --tw-gradient-from: #ff2236 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/0{
  --tw-gradient-from: rgba(255, 34, 54, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/10{
  --tw-gradient-from: rgba(255, 34, 54, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/100{
  --tw-gradient-from: rgb(255, 34, 54) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/15{
  --tw-gradient-from: rgba(255, 34, 54, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/20{
  --tw-gradient-from: rgba(255, 34, 54, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/25{
  --tw-gradient-from: rgba(255, 34, 54, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/30{
  --tw-gradient-from: rgba(255, 34, 54, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/35{
  --tw-gradient-from: rgba(255, 34, 54, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/40{
  --tw-gradient-from: rgba(255, 34, 54, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/45{
  --tw-gradient-from: rgba(255, 34, 54, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/5{
  --tw-gradient-from: rgba(255, 34, 54, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/50{
  --tw-gradient-from: rgba(255, 34, 54, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/55{
  --tw-gradient-from: rgba(255, 34, 54, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/60{
  --tw-gradient-from: rgba(255, 34, 54, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/65{
  --tw-gradient-from: rgba(255, 34, 54, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/70{
  --tw-gradient-from: rgba(255, 34, 54, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/75{
  --tw-gradient-from: rgba(255, 34, 54, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/80{
  --tw-gradient-from: rgba(255, 34, 54, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/85{
  --tw-gradient-from: rgba(255, 34, 54, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/90{
  --tw-gradient-from: rgba(255, 34, 54, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-500\\/95{
  --tw-gradient-from: rgba(255, 34, 54, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600{
  --tw-gradient-from: #ff0219 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/0{
  --tw-gradient-from: rgba(255, 2, 25, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/10{
  --tw-gradient-from: rgba(255, 2, 25, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/100{
  --tw-gradient-from: rgb(255, 2, 25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/15{
  --tw-gradient-from: rgba(255, 2, 25, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/20{
  --tw-gradient-from: rgba(255, 2, 25, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/25{
  --tw-gradient-from: rgba(255, 2, 25, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/30{
  --tw-gradient-from: rgba(255, 2, 25, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/35{
  --tw-gradient-from: rgba(255, 2, 25, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/40{
  --tw-gradient-from: rgba(255, 2, 25, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/45{
  --tw-gradient-from: rgba(255, 2, 25, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/5{
  --tw-gradient-from: rgba(255, 2, 25, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/50{
  --tw-gradient-from: rgba(255, 2, 25, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/55{
  --tw-gradient-from: rgba(255, 2, 25, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/60{
  --tw-gradient-from: rgba(255, 2, 25, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/65{
  --tw-gradient-from: rgba(255, 2, 25, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/70{
  --tw-gradient-from: rgba(255, 2, 25, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/75{
  --tw-gradient-from: rgba(255, 2, 25, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/80{
  --tw-gradient-from: rgba(255, 2, 25, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/85{
  --tw-gradient-from: rgba(255, 2, 25, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/90{
  --tw-gradient-from: rgba(255, 2, 25, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-600\\/95{
  --tw-gradient-from: rgba(255, 2, 25, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700{
  --tw-gradient-from: #d80013 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/0{
  --tw-gradient-from: rgba(216, 0, 19, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/10{
  --tw-gradient-from: rgba(216, 0, 19, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/100{
  --tw-gradient-from: rgb(216, 0, 19) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/15{
  --tw-gradient-from: rgba(216, 0, 19, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/20{
  --tw-gradient-from: rgba(216, 0, 19, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/25{
  --tw-gradient-from: rgba(216, 0, 19, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/30{
  --tw-gradient-from: rgba(216, 0, 19, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/35{
  --tw-gradient-from: rgba(216, 0, 19, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/40{
  --tw-gradient-from: rgba(216, 0, 19, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/45{
  --tw-gradient-from: rgba(216, 0, 19, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/5{
  --tw-gradient-from: rgba(216, 0, 19, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/50{
  --tw-gradient-from: rgba(216, 0, 19, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/55{
  --tw-gradient-from: rgba(216, 0, 19, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/60{
  --tw-gradient-from: rgba(216, 0, 19, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/65{
  --tw-gradient-from: rgba(216, 0, 19, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/70{
  --tw-gradient-from: rgba(216, 0, 19, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/75{
  --tw-gradient-from: rgba(216, 0, 19, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/80{
  --tw-gradient-from: rgba(216, 0, 19, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/85{
  --tw-gradient-from: rgba(216, 0, 19, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/90{
  --tw-gradient-from: rgba(216, 0, 19, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-700\\/95{
  --tw-gradient-from: rgba(216, 0, 19, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800{
  --tw-gradient-from: #b40212 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/0{
  --tw-gradient-from: rgba(180, 2, 18, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/10{
  --tw-gradient-from: rgba(180, 2, 18, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/100{
  --tw-gradient-from: rgb(180, 2, 18) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/15{
  --tw-gradient-from: rgba(180, 2, 18, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/20{
  --tw-gradient-from: rgba(180, 2, 18, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/25{
  --tw-gradient-from: rgba(180, 2, 18, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/30{
  --tw-gradient-from: rgba(180, 2, 18, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/35{
  --tw-gradient-from: rgba(180, 2, 18, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/40{
  --tw-gradient-from: rgba(180, 2, 18, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/45{
  --tw-gradient-from: rgba(180, 2, 18, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/5{
  --tw-gradient-from: rgba(180, 2, 18, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/50{
  --tw-gradient-from: rgba(180, 2, 18, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/55{
  --tw-gradient-from: rgba(180, 2, 18, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/60{
  --tw-gradient-from: rgba(180, 2, 18, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/65{
  --tw-gradient-from: rgba(180, 2, 18, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/70{
  --tw-gradient-from: rgba(180, 2, 18, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/75{
  --tw-gradient-from: rgba(180, 2, 18, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/80{
  --tw-gradient-from: rgba(180, 2, 18, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/85{
  --tw-gradient-from: rgba(180, 2, 18, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/90{
  --tw-gradient-from: rgba(180, 2, 18, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-800\\/95{
  --tw-gradient-from: rgba(180, 2, 18, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900{
  --tw-gradient-from: #920a16 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/0{
  --tw-gradient-from: rgba(146, 10, 22, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/10{
  --tw-gradient-from: rgba(146, 10, 22, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/100{
  --tw-gradient-from: rgb(146, 10, 22) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/15{
  --tw-gradient-from: rgba(146, 10, 22, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/20{
  --tw-gradient-from: rgba(146, 10, 22, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/25{
  --tw-gradient-from: rgba(146, 10, 22, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/30{
  --tw-gradient-from: rgba(146, 10, 22, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/35{
  --tw-gradient-from: rgba(146, 10, 22, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/40{
  --tw-gradient-from: rgba(146, 10, 22, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/45{
  --tw-gradient-from: rgba(146, 10, 22, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/5{
  --tw-gradient-from: rgba(146, 10, 22, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/50{
  --tw-gradient-from: rgba(146, 10, 22, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/55{
  --tw-gradient-from: rgba(146, 10, 22, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/60{
  --tw-gradient-from: rgba(146, 10, 22, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/65{
  --tw-gradient-from: rgba(146, 10, 22, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/70{
  --tw-gradient-from: rgba(146, 10, 22, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/75{
  --tw-gradient-from: rgba(146, 10, 22, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/80{
  --tw-gradient-from: rgba(146, 10, 22, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/85{
  --tw-gradient-from: rgba(146, 10, 22, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/90{
  --tw-gradient-from: rgba(146, 10, 22, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-900\\/95{
  --tw-gradient-from: rgba(146, 10, 22, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950{
  --tw-gradient-from: #510007 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/0{
  --tw-gradient-from: rgba(81, 0, 7, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/10{
  --tw-gradient-from: rgba(81, 0, 7, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/100{
  --tw-gradient-from: rgb(81, 0, 7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/15{
  --tw-gradient-from: rgba(81, 0, 7, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/20{
  --tw-gradient-from: rgba(81, 0, 7, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/25{
  --tw-gradient-from: rgba(81, 0, 7, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/30{
  --tw-gradient-from: rgba(81, 0, 7, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/35{
  --tw-gradient-from: rgba(81, 0, 7, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/40{
  --tw-gradient-from: rgba(81, 0, 7, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/45{
  --tw-gradient-from: rgba(81, 0, 7, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/5{
  --tw-gradient-from: rgba(81, 0, 7, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/50{
  --tw-gradient-from: rgba(81, 0, 7, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/55{
  --tw-gradient-from: rgba(81, 0, 7, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/60{
  --tw-gradient-from: rgba(81, 0, 7, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/65{
  --tw-gradient-from: rgba(81, 0, 7, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/70{
  --tw-gradient-from: rgba(81, 0, 7, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/75{
  --tw-gradient-from: rgba(81, 0, 7, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/80{
  --tw-gradient-from: rgba(81, 0, 7, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/85{
  --tw-gradient-from: rgba(81, 0, 7, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/90{
  --tw-gradient-from: rgba(81, 0, 7, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-song-color-950\\/95{
  --tw-gradient-from: rgba(81, 0, 7, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100{
  --tw-gradient-from: #daeef3 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/0{
  --tw-gradient-from: rgba(218, 238, 243, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/10{
  --tw-gradient-from: rgba(218, 238, 243, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/100{
  --tw-gradient-from: rgb(218, 238, 243) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/15{
  --tw-gradient-from: rgba(218, 238, 243, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/20{
  --tw-gradient-from: rgba(218, 238, 243, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/25{
  --tw-gradient-from: rgba(218, 238, 243, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/30{
  --tw-gradient-from: rgba(218, 238, 243, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/35{
  --tw-gradient-from: rgba(218, 238, 243, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/40{
  --tw-gradient-from: rgba(218, 238, 243, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/45{
  --tw-gradient-from: rgba(218, 238, 243, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/5{
  --tw-gradient-from: rgba(218, 238, 243, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/50{
  --tw-gradient-from: rgba(218, 238, 243, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/55{
  --tw-gradient-from: rgba(218, 238, 243, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/60{
  --tw-gradient-from: rgba(218, 238, 243, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/65{
  --tw-gradient-from: rgba(218, 238, 243, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/70{
  --tw-gradient-from: rgba(218, 238, 243, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/75{
  --tw-gradient-from: rgba(218, 238, 243, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/80{
  --tw-gradient-from: rgba(218, 238, 243, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/85{
  --tw-gradient-from: rgba(218, 238, 243, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/90{
  --tw-gradient-from: rgba(218, 238, 243, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-100\\/95{
  --tw-gradient-from: rgba(218, 238, 243, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200{
  --tw-gradient-from: #badee7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/0{
  --tw-gradient-from: rgba(186, 222, 231, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/10{
  --tw-gradient-from: rgba(186, 222, 231, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/100{
  --tw-gradient-from: rgb(186, 222, 231) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/15{
  --tw-gradient-from: rgba(186, 222, 231, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/20{
  --tw-gradient-from: rgba(186, 222, 231, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/25{
  --tw-gradient-from: rgba(186, 222, 231, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/30{
  --tw-gradient-from: rgba(186, 222, 231, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/35{
  --tw-gradient-from: rgba(186, 222, 231, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/40{
  --tw-gradient-from: rgba(186, 222, 231, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/45{
  --tw-gradient-from: rgba(186, 222, 231, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/5{
  --tw-gradient-from: rgba(186, 222, 231, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/50{
  --tw-gradient-from: rgba(186, 222, 231, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/55{
  --tw-gradient-from: rgba(186, 222, 231, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/60{
  --tw-gradient-from: rgba(186, 222, 231, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/65{
  --tw-gradient-from: rgba(186, 222, 231, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/70{
  --tw-gradient-from: rgba(186, 222, 231, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/75{
  --tw-gradient-from: rgba(186, 222, 231, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/80{
  --tw-gradient-from: rgba(186, 222, 231, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/85{
  --tw-gradient-from: rgba(186, 222, 231, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/90{
  --tw-gradient-from: rgba(186, 222, 231, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-200\\/95{
  --tw-gradient-from: rgba(186, 222, 231, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300{
  --tw-gradient-from: #89c5d7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/0{
  --tw-gradient-from: rgba(137, 197, 215, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/10{
  --tw-gradient-from: rgba(137, 197, 215, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/100{
  --tw-gradient-from: rgb(137, 197, 215) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/15{
  --tw-gradient-from: rgba(137, 197, 215, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/20{
  --tw-gradient-from: rgba(137, 197, 215, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/25{
  --tw-gradient-from: rgba(137, 197, 215, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/30{
  --tw-gradient-from: rgba(137, 197, 215, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/35{
  --tw-gradient-from: rgba(137, 197, 215, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/40{
  --tw-gradient-from: rgba(137, 197, 215, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/45{
  --tw-gradient-from: rgba(137, 197, 215, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/5{
  --tw-gradient-from: rgba(137, 197, 215, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/50{
  --tw-gradient-from: rgba(137, 197, 215, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/55{
  --tw-gradient-from: rgba(137, 197, 215, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/60{
  --tw-gradient-from: rgba(137, 197, 215, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/65{
  --tw-gradient-from: rgba(137, 197, 215, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/70{
  --tw-gradient-from: rgba(137, 197, 215, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/75{
  --tw-gradient-from: rgba(137, 197, 215, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/80{
  --tw-gradient-from: rgba(137, 197, 215, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/85{
  --tw-gradient-from: rgba(137, 197, 215, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/90{
  --tw-gradient-from: rgba(137, 197, 215, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-300\\/95{
  --tw-gradient-from: rgba(137, 197, 215, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400{
  --tw-gradient-from: #52a3be var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/0{
  --tw-gradient-from: rgba(82, 163, 190, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/10{
  --tw-gradient-from: rgba(82, 163, 190, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/100{
  --tw-gradient-from: rgb(82, 163, 190) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/15{
  --tw-gradient-from: rgba(82, 163, 190, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/20{
  --tw-gradient-from: rgba(82, 163, 190, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/25{
  --tw-gradient-from: rgba(82, 163, 190, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/30{
  --tw-gradient-from: rgba(82, 163, 190, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/35{
  --tw-gradient-from: rgba(82, 163, 190, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/40{
  --tw-gradient-from: rgba(82, 163, 190, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/45{
  --tw-gradient-from: rgba(82, 163, 190, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/5{
  --tw-gradient-from: rgba(82, 163, 190, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/50{
  --tw-gradient-from: rgba(82, 163, 190, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/55{
  --tw-gradient-from: rgba(82, 163, 190, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/60{
  --tw-gradient-from: rgba(82, 163, 190, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/65{
  --tw-gradient-from: rgba(82, 163, 190, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/70{
  --tw-gradient-from: rgba(82, 163, 190, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/75{
  --tw-gradient-from: rgba(82, 163, 190, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/80{
  --tw-gradient-from: rgba(82, 163, 190, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/85{
  --tw-gradient-from: rgba(82, 163, 190, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/90{
  --tw-gradient-from: rgba(82, 163, 190, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-400\\/95{
  --tw-gradient-from: rgba(82, 163, 190, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500{
  --tw-gradient-from: #3787a3 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/0{
  --tw-gradient-from: rgba(55, 135, 163, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/10{
  --tw-gradient-from: rgba(55, 135, 163, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/100{
  --tw-gradient-from: rgb(55, 135, 163) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/15{
  --tw-gradient-from: rgba(55, 135, 163, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/20{
  --tw-gradient-from: rgba(55, 135, 163, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/25{
  --tw-gradient-from: rgba(55, 135, 163, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/30{
  --tw-gradient-from: rgba(55, 135, 163, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/35{
  --tw-gradient-from: rgba(55, 135, 163, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/40{
  --tw-gradient-from: rgba(55, 135, 163, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/45{
  --tw-gradient-from: rgba(55, 135, 163, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/5{
  --tw-gradient-from: rgba(55, 135, 163, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/50{
  --tw-gradient-from: rgba(55, 135, 163, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/55{
  --tw-gradient-from: rgba(55, 135, 163, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/60{
  --tw-gradient-from: rgba(55, 135, 163, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/65{
  --tw-gradient-from: rgba(55, 135, 163, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/70{
  --tw-gradient-from: rgba(55, 135, 163, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/75{
  --tw-gradient-from: rgba(55, 135, 163, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/80{
  --tw-gradient-from: rgba(55, 135, 163, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/85{
  --tw-gradient-from: rgba(55, 135, 163, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/90{
  --tw-gradient-from: rgba(55, 135, 163, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-500\\/95{
  --tw-gradient-from: rgba(55, 135, 163, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600{
  --tw-gradient-from: #306d8a var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/0{
  --tw-gradient-from: rgba(48, 109, 138, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/10{
  --tw-gradient-from: rgba(48, 109, 138, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/100{
  --tw-gradient-from: rgb(48, 109, 138) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/15{
  --tw-gradient-from: rgba(48, 109, 138, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/20{
  --tw-gradient-from: rgba(48, 109, 138, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/25{
  --tw-gradient-from: rgba(48, 109, 138, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/30{
  --tw-gradient-from: rgba(48, 109, 138, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/35{
  --tw-gradient-from: rgba(48, 109, 138, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/40{
  --tw-gradient-from: rgba(48, 109, 138, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/45{
  --tw-gradient-from: rgba(48, 109, 138, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/5{
  --tw-gradient-from: rgba(48, 109, 138, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/50{
  --tw-gradient-from: rgba(48, 109, 138, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/55{
  --tw-gradient-from: rgba(48, 109, 138, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/60{
  --tw-gradient-from: rgba(48, 109, 138, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/65{
  --tw-gradient-from: rgba(48, 109, 138, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/70{
  --tw-gradient-from: rgba(48, 109, 138, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/75{
  --tw-gradient-from: rgba(48, 109, 138, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/80{
  --tw-gradient-from: rgba(48, 109, 138, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/85{
  --tw-gradient-from: rgba(48, 109, 138, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/90{
  --tw-gradient-from: rgba(48, 109, 138, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-600\\/95{
  --tw-gradient-from: rgba(48, 109, 138, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700{
  --tw-gradient-from: #2d5b72 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/0{
  --tw-gradient-from: rgba(45, 91, 114, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/10{
  --tw-gradient-from: rgba(45, 91, 114, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/100{
  --tw-gradient-from: rgb(45, 91, 114) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/15{
  --tw-gradient-from: rgba(45, 91, 114, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/20{
  --tw-gradient-from: rgba(45, 91, 114, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/25{
  --tw-gradient-from: rgba(45, 91, 114, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/30{
  --tw-gradient-from: rgba(45, 91, 114, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/35{
  --tw-gradient-from: rgba(45, 91, 114, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/40{
  --tw-gradient-from: rgba(45, 91, 114, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/45{
  --tw-gradient-from: rgba(45, 91, 114, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/5{
  --tw-gradient-from: rgba(45, 91, 114, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/50{
  --tw-gradient-from: rgba(45, 91, 114, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/55{
  --tw-gradient-from: rgba(45, 91, 114, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/60{
  --tw-gradient-from: rgba(45, 91, 114, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/65{
  --tw-gradient-from: rgba(45, 91, 114, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/70{
  --tw-gradient-from: rgba(45, 91, 114, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/75{
  --tw-gradient-from: rgba(45, 91, 114, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/80{
  --tw-gradient-from: rgba(45, 91, 114, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/85{
  --tw-gradient-from: rgba(45, 91, 114, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/90{
  --tw-gradient-from: rgba(45, 91, 114, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-700\\/95{
  --tw-gradient-from: rgba(45, 91, 114, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800{
  --tw-gradient-from: #2c4c5e var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/0{
  --tw-gradient-from: rgba(44, 76, 94, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/10{
  --tw-gradient-from: rgba(44, 76, 94, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/100{
  --tw-gradient-from: rgb(44, 76, 94) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/15{
  --tw-gradient-from: rgba(44, 76, 94, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/20{
  --tw-gradient-from: rgba(44, 76, 94, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/25{
  --tw-gradient-from: rgba(44, 76, 94, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/30{
  --tw-gradient-from: rgba(44, 76, 94, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/35{
  --tw-gradient-from: rgba(44, 76, 94, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/40{
  --tw-gradient-from: rgba(44, 76, 94, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/45{
  --tw-gradient-from: rgba(44, 76, 94, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/5{
  --tw-gradient-from: rgba(44, 76, 94, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/50{
  --tw-gradient-from: rgba(44, 76, 94, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/55{
  --tw-gradient-from: rgba(44, 76, 94, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/60{
  --tw-gradient-from: rgba(44, 76, 94, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/65{
  --tw-gradient-from: rgba(44, 76, 94, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/70{
  --tw-gradient-from: rgba(44, 76, 94, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/75{
  --tw-gradient-from: rgba(44, 76, 94, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/80{
  --tw-gradient-from: rgba(44, 76, 94, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/85{
  --tw-gradient-from: rgba(44, 76, 94, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/90{
  --tw-gradient-from: rgba(44, 76, 94, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-800\\/95{
  --tw-gradient-from: rgba(44, 76, 94, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900{
  --tw-gradient-from: #284151 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/0{
  --tw-gradient-from: rgba(40, 65, 81, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/10{
  --tw-gradient-from: rgba(40, 65, 81, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/100{
  --tw-gradient-from: rgb(40, 65, 81) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/15{
  --tw-gradient-from: rgba(40, 65, 81, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/20{
  --tw-gradient-from: rgba(40, 65, 81, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/25{
  --tw-gradient-from: rgba(40, 65, 81, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/30{
  --tw-gradient-from: rgba(40, 65, 81, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/35{
  --tw-gradient-from: rgba(40, 65, 81, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/40{
  --tw-gradient-from: rgba(40, 65, 81, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/45{
  --tw-gradient-from: rgba(40, 65, 81, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/5{
  --tw-gradient-from: rgba(40, 65, 81, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/50{
  --tw-gradient-from: rgba(40, 65, 81, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/55{
  --tw-gradient-from: rgba(40, 65, 81, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/60{
  --tw-gradient-from: rgba(40, 65, 81, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/65{
  --tw-gradient-from: rgba(40, 65, 81, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/70{
  --tw-gradient-from: rgba(40, 65, 81, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/75{
  --tw-gradient-from: rgba(40, 65, 81, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/80{
  --tw-gradient-from: rgba(40, 65, 81, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/85{
  --tw-gradient-from: rgba(40, 65, 81, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/90{
  --tw-gradient-from: rgba(40, 65, 81, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-900\\/95{
  --tw-gradient-from: rgba(40, 65, 81, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950{
  --tw-gradient-from: #162936 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/0{
  --tw-gradient-from: rgba(22, 41, 54, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/10{
  --tw-gradient-from: rgba(22, 41, 54, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/100{
  --tw-gradient-from: rgb(22, 41, 54) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/15{
  --tw-gradient-from: rgba(22, 41, 54, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/20{
  --tw-gradient-from: rgba(22, 41, 54, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/25{
  --tw-gradient-from: rgba(22, 41, 54, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/30{
  --tw-gradient-from: rgba(22, 41, 54, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/35{
  --tw-gradient-from: rgba(22, 41, 54, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/40{
  --tw-gradient-from: rgba(22, 41, 54, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/45{
  --tw-gradient-from: rgba(22, 41, 54, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/5{
  --tw-gradient-from: rgba(22, 41, 54, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/50{
  --tw-gradient-from: rgba(22, 41, 54, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/55{
  --tw-gradient-from: rgba(22, 41, 54, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/60{
  --tw-gradient-from: rgba(22, 41, 54, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/65{
  --tw-gradient-from: rgba(22, 41, 54, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/70{
  --tw-gradient-from: rgba(22, 41, 54, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/75{
  --tw-gradient-from: rgba(22, 41, 54, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/80{
  --tw-gradient-from: rgba(22, 41, 54, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/85{
  --tw-gradient-from: rgba(22, 41, 54, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/90{
  --tw-gradient-from: rgba(22, 41, 54, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-story-color-950\\/95{
  --tw-gradient-from: rgba(22, 41, 54, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 255, 255, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100{
  --tw-gradient-from: #d9f2e6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/0{
  --tw-gradient-from: rgba(217, 242, 230, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/10{
  --tw-gradient-from: rgba(217, 242, 230, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/100{
  --tw-gradient-from: rgb(217, 242, 230) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/15{
  --tw-gradient-from: rgba(217, 242, 230, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/20{
  --tw-gradient-from: rgba(217, 242, 230, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/25{
  --tw-gradient-from: rgba(217, 242, 230, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/30{
  --tw-gradient-from: rgba(217, 242, 230, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/35{
  --tw-gradient-from: rgba(217, 242, 230, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/40{
  --tw-gradient-from: rgba(217, 242, 230, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/45{
  --tw-gradient-from: rgba(217, 242, 230, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/5{
  --tw-gradient-from: rgba(217, 242, 230, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/50{
  --tw-gradient-from: rgba(217, 242, 230, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/55{
  --tw-gradient-from: rgba(217, 242, 230, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/60{
  --tw-gradient-from: rgba(217, 242, 230, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/65{
  --tw-gradient-from: rgba(217, 242, 230, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/70{
  --tw-gradient-from: rgba(217, 242, 230, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/75{
  --tw-gradient-from: rgba(217, 242, 230, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/80{
  --tw-gradient-from: rgba(217, 242, 230, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/85{
  --tw-gradient-from: rgba(217, 242, 230, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/90{
  --tw-gradient-from: rgba(217, 242, 230, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-100\\/95{
  --tw-gradient-from: rgba(217, 242, 230, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200{
  --tw-gradient-from: #b6e4d1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/0{
  --tw-gradient-from: rgba(182, 228, 209, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/10{
  --tw-gradient-from: rgba(182, 228, 209, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/100{
  --tw-gradient-from: rgb(182, 228, 209) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/15{
  --tw-gradient-from: rgba(182, 228, 209, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/20{
  --tw-gradient-from: rgba(182, 228, 209, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/25{
  --tw-gradient-from: rgba(182, 228, 209, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/30{
  --tw-gradient-from: rgba(182, 228, 209, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/35{
  --tw-gradient-from: rgba(182, 228, 209, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/40{
  --tw-gradient-from: rgba(182, 228, 209, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/45{
  --tw-gradient-from: rgba(182, 228, 209, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/5{
  --tw-gradient-from: rgba(182, 228, 209, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/50{
  --tw-gradient-from: rgba(182, 228, 209, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/55{
  --tw-gradient-from: rgba(182, 228, 209, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/60{
  --tw-gradient-from: rgba(182, 228, 209, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/65{
  --tw-gradient-from: rgba(182, 228, 209, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/70{
  --tw-gradient-from: rgba(182, 228, 209, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/75{
  --tw-gradient-from: rgba(182, 228, 209, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/80{
  --tw-gradient-from: rgba(182, 228, 209, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/85{
  --tw-gradient-from: rgba(182, 228, 209, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/90{
  --tw-gradient-from: rgba(182, 228, 209, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-200\\/95{
  --tw-gradient-from: rgba(182, 228, 209, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300{
  --tw-gradient-from: #86cfb5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/0{
  --tw-gradient-from: rgba(134, 207, 181, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/10{
  --tw-gradient-from: rgba(134, 207, 181, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/100{
  --tw-gradient-from: rgb(134, 207, 181) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/15{
  --tw-gradient-from: rgba(134, 207, 181, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/20{
  --tw-gradient-from: rgba(134, 207, 181, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/25{
  --tw-gradient-from: rgba(134, 207, 181, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/30{
  --tw-gradient-from: rgba(134, 207, 181, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/35{
  --tw-gradient-from: rgba(134, 207, 181, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/40{
  --tw-gradient-from: rgba(134, 207, 181, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/45{
  --tw-gradient-from: rgba(134, 207, 181, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/5{
  --tw-gradient-from: rgba(134, 207, 181, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/50{
  --tw-gradient-from: rgba(134, 207, 181, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/55{
  --tw-gradient-from: rgba(134, 207, 181, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/60{
  --tw-gradient-from: rgba(134, 207, 181, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/65{
  --tw-gradient-from: rgba(134, 207, 181, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/70{
  --tw-gradient-from: rgba(134, 207, 181, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/75{
  --tw-gradient-from: rgba(134, 207, 181, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/80{
  --tw-gradient-from: rgba(134, 207, 181, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/85{
  --tw-gradient-from: rgba(134, 207, 181, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/90{
  --tw-gradient-from: rgba(134, 207, 181, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-300\\/95{
  --tw-gradient-from: rgba(134, 207, 181, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400{
  --tw-gradient-from: #53b494 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/0{
  --tw-gradient-from: rgba(83, 180, 148, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/10{
  --tw-gradient-from: rgba(83, 180, 148, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/100{
  --tw-gradient-from: rgb(83, 180, 148) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/15{
  --tw-gradient-from: rgba(83, 180, 148, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/20{
  --tw-gradient-from: rgba(83, 180, 148, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/25{
  --tw-gradient-from: rgba(83, 180, 148, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/30{
  --tw-gradient-from: rgba(83, 180, 148, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/35{
  --tw-gradient-from: rgba(83, 180, 148, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/40{
  --tw-gradient-from: rgba(83, 180, 148, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/45{
  --tw-gradient-from: rgba(83, 180, 148, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/5{
  --tw-gradient-from: rgba(83, 180, 148, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/50{
  --tw-gradient-from: rgba(83, 180, 148, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/55{
  --tw-gradient-from: rgba(83, 180, 148, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/60{
  --tw-gradient-from: rgba(83, 180, 148, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/65{
  --tw-gradient-from: rgba(83, 180, 148, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/70{
  --tw-gradient-from: rgba(83, 180, 148, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/75{
  --tw-gradient-from: rgba(83, 180, 148, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/80{
  --tw-gradient-from: rgba(83, 180, 148, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/85{
  --tw-gradient-from: rgba(83, 180, 148, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/90{
  --tw-gradient-from: rgba(83, 180, 148, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-400\\/95{
  --tw-gradient-from: rgba(83, 180, 148, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500{
  --tw-gradient-from: #2c876d var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/0{
  --tw-gradient-from: rgba(44, 135, 109, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/10{
  --tw-gradient-from: rgba(44, 135, 109, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/100{
  --tw-gradient-from: rgb(44, 135, 109) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/15{
  --tw-gradient-from: rgba(44, 135, 109, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/20{
  --tw-gradient-from: rgba(44, 135, 109, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/25{
  --tw-gradient-from: rgba(44, 135, 109, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/30{
  --tw-gradient-from: rgba(44, 135, 109, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/35{
  --tw-gradient-from: rgba(44, 135, 109, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/40{
  --tw-gradient-from: rgba(44, 135, 109, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/45{
  --tw-gradient-from: rgba(44, 135, 109, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/5{
  --tw-gradient-from: rgba(44, 135, 109, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/50{
  --tw-gradient-from: rgba(44, 135, 109, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/55{
  --tw-gradient-from: rgba(44, 135, 109, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/60{
  --tw-gradient-from: rgba(44, 135, 109, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/65{
  --tw-gradient-from: rgba(44, 135, 109, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/70{
  --tw-gradient-from: rgba(44, 135, 109, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/75{
  --tw-gradient-from: rgba(44, 135, 109, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/80{
  --tw-gradient-from: rgba(44, 135, 109, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/85{
  --tw-gradient-from: rgba(44, 135, 109, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/90{
  --tw-gradient-from: rgba(44, 135, 109, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-500\\/95{
  --tw-gradient-from: rgba(44, 135, 109, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600{
  --tw-gradient-from: #227962 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/0{
  --tw-gradient-from: rgba(34, 121, 98, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/10{
  --tw-gradient-from: rgba(34, 121, 98, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/100{
  --tw-gradient-from: rgb(34, 121, 98) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/15{
  --tw-gradient-from: rgba(34, 121, 98, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/20{
  --tw-gradient-from: rgba(34, 121, 98, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/25{
  --tw-gradient-from: rgba(34, 121, 98, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/30{
  --tw-gradient-from: rgba(34, 121, 98, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/35{
  --tw-gradient-from: rgba(34, 121, 98, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/40{
  --tw-gradient-from: rgba(34, 121, 98, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/45{
  --tw-gradient-from: rgba(34, 121, 98, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/5{
  --tw-gradient-from: rgba(34, 121, 98, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/50{
  --tw-gradient-from: rgba(34, 121, 98, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/55{
  --tw-gradient-from: rgba(34, 121, 98, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/60{
  --tw-gradient-from: rgba(34, 121, 98, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/65{
  --tw-gradient-from: rgba(34, 121, 98, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/70{
  --tw-gradient-from: rgba(34, 121, 98, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/75{
  --tw-gradient-from: rgba(34, 121, 98, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/80{
  --tw-gradient-from: rgba(34, 121, 98, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/85{
  --tw-gradient-from: rgba(34, 121, 98, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/90{
  --tw-gradient-from: rgba(34, 121, 98, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-600\\/95{
  --tw-gradient-from: rgba(34, 121, 98, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700{
  --tw-gradient-from: #1b6150 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/0{
  --tw-gradient-from: rgba(27, 97, 80, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/10{
  --tw-gradient-from: rgba(27, 97, 80, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/100{
  --tw-gradient-from: rgb(27, 97, 80) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/15{
  --tw-gradient-from: rgba(27, 97, 80, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/20{
  --tw-gradient-from: rgba(27, 97, 80, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/25{
  --tw-gradient-from: rgba(27, 97, 80, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/30{
  --tw-gradient-from: rgba(27, 97, 80, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/35{
  --tw-gradient-from: rgba(27, 97, 80, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/40{
  --tw-gradient-from: rgba(27, 97, 80, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/45{
  --tw-gradient-from: rgba(27, 97, 80, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/5{
  --tw-gradient-from: rgba(27, 97, 80, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/50{
  --tw-gradient-from: rgba(27, 97, 80, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/55{
  --tw-gradient-from: rgba(27, 97, 80, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/60{
  --tw-gradient-from: rgba(27, 97, 80, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/65{
  --tw-gradient-from: rgba(27, 97, 80, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/70{
  --tw-gradient-from: rgba(27, 97, 80, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/75{
  --tw-gradient-from: rgba(27, 97, 80, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/80{
  --tw-gradient-from: rgba(27, 97, 80, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/85{
  --tw-gradient-from: rgba(27, 97, 80, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/90{
  --tw-gradient-from: rgba(27, 97, 80, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-700\\/95{
  --tw-gradient-from: rgba(27, 97, 80, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800{
  --tw-gradient-from: #184d40 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/0{
  --tw-gradient-from: rgba(24, 77, 64, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/10{
  --tw-gradient-from: rgba(24, 77, 64, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/100{
  --tw-gradient-from: rgb(24, 77, 64) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/15{
  --tw-gradient-from: rgba(24, 77, 64, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/20{
  --tw-gradient-from: rgba(24, 77, 64, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/25{
  --tw-gradient-from: rgba(24, 77, 64, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/30{
  --tw-gradient-from: rgba(24, 77, 64, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/35{
  --tw-gradient-from: rgba(24, 77, 64, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/40{
  --tw-gradient-from: rgba(24, 77, 64, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/45{
  --tw-gradient-from: rgba(24, 77, 64, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/5{
  --tw-gradient-from: rgba(24, 77, 64, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/50{
  --tw-gradient-from: rgba(24, 77, 64, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/55{
  --tw-gradient-from: rgba(24, 77, 64, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/60{
  --tw-gradient-from: rgba(24, 77, 64, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/65{
  --tw-gradient-from: rgba(24, 77, 64, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/70{
  --tw-gradient-from: rgba(24, 77, 64, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/75{
  --tw-gradient-from: rgba(24, 77, 64, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/80{
  --tw-gradient-from: rgba(24, 77, 64, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/85{
  --tw-gradient-from: rgba(24, 77, 64, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/90{
  --tw-gradient-from: rgba(24, 77, 64, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-800\\/95{
  --tw-gradient-from: rgba(24, 77, 64, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900{
  --tw-gradient-from: #144036 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/0{
  --tw-gradient-from: rgba(20, 64, 54, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/10{
  --tw-gradient-from: rgba(20, 64, 54, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/100{
  --tw-gradient-from: rgb(20, 64, 54) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/15{
  --tw-gradient-from: rgba(20, 64, 54, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/20{
  --tw-gradient-from: rgba(20, 64, 54, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/25{
  --tw-gradient-from: rgba(20, 64, 54, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/30{
  --tw-gradient-from: rgba(20, 64, 54, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/35{
  --tw-gradient-from: rgba(20, 64, 54, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/40{
  --tw-gradient-from: rgba(20, 64, 54, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/45{
  --tw-gradient-from: rgba(20, 64, 54, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/5{
  --tw-gradient-from: rgba(20, 64, 54, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/50{
  --tw-gradient-from: rgba(20, 64, 54, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/55{
  --tw-gradient-from: rgba(20, 64, 54, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/60{
  --tw-gradient-from: rgba(20, 64, 54, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/65{
  --tw-gradient-from: rgba(20, 64, 54, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/70{
  --tw-gradient-from: rgba(20, 64, 54, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/75{
  --tw-gradient-from: rgba(20, 64, 54, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/80{
  --tw-gradient-from: rgba(20, 64, 54, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/85{
  --tw-gradient-from: rgba(20, 64, 54, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/90{
  --tw-gradient-from: rgba(20, 64, 54, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-900\\/95{
  --tw-gradient-from: rgba(20, 64, 54, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950{
  --tw-gradient-from: #0a241f var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/0{
  --tw-gradient-from: rgba(10, 36, 31, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/10{
  --tw-gradient-from: rgba(10, 36, 31, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/100{
  --tw-gradient-from: rgb(10, 36, 31) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/15{
  --tw-gradient-from: rgba(10, 36, 31, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/20{
  --tw-gradient-from: rgba(10, 36, 31, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/25{
  --tw-gradient-from: rgba(10, 36, 31, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/30{
  --tw-gradient-from: rgba(10, 36, 31, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/35{
  --tw-gradient-from: rgba(10, 36, 31, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/40{
  --tw-gradient-from: rgba(10, 36, 31, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/45{
  --tw-gradient-from: rgba(10, 36, 31, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/5{
  --tw-gradient-from: rgba(10, 36, 31, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/50{
  --tw-gradient-from: rgba(10, 36, 31, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/55{
  --tw-gradient-from: rgba(10, 36, 31, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/60{
  --tw-gradient-from: rgba(10, 36, 31, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/65{
  --tw-gradient-from: rgba(10, 36, 31, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/70{
  --tw-gradient-from: rgba(10, 36, 31, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/75{
  --tw-gradient-from: rgba(10, 36, 31, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/80{
  --tw-gradient-from: rgba(10, 36, 31, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/85{
  --tw-gradient-from: rgba(10, 36, 31, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/90{
  --tw-gradient-from: rgba(10, 36, 31, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-word-color-950\\/95{
  --tw-gradient-from: rgba(10, 36, 31, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-blumine-100{
  --tw-gradient-to: #daeef3 var(--tw-gradient-to-position);
}
.to-blumine-100\\/0{
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
}
.to-blumine-100\\/10{
  --tw-gradient-to: rgba(218, 238, 243, 0.1) var(--tw-gradient-to-position);
}
.to-blumine-100\\/100{
  --tw-gradient-to: rgb(218, 238, 243) var(--tw-gradient-to-position);
}
.to-blumine-100\\/15{
  --tw-gradient-to: rgba(218, 238, 243, 0.15) var(--tw-gradient-to-position);
}
.to-blumine-100\\/20{
  --tw-gradient-to: rgba(218, 238, 243, 0.2) var(--tw-gradient-to-position);
}
.to-blumine-100\\/25{
  --tw-gradient-to: rgba(218, 238, 243, 0.25) var(--tw-gradient-to-position);
}
.to-blumine-100\\/30{
  --tw-gradient-to: rgba(218, 238, 243, 0.3) var(--tw-gradient-to-position);
}
.to-blumine-100\\/35{
  --tw-gradient-to: rgba(218, 238, 243, 0.35) var(--tw-gradient-to-position);
}
.to-blumine-100\\/40{
  --tw-gradient-to: rgba(218, 238, 243, 0.4) var(--tw-gradient-to-position);
}
.to-blumine-100\\/45{
  --tw-gradient-to: rgba(218, 238, 243, 0.45) var(--tw-gradient-to-position);
}
.to-blumine-100\\/5{
  --tw-gradient-to: rgba(218, 238, 243, 0.05) var(--tw-gradient-to-position);
}
.to-blumine-100\\/50{
  --tw-gradient-to: rgba(218, 238, 243, 0.5) var(--tw-gradient-to-position);
}
.to-blumine-100\\/55{
  --tw-gradient-to: rgba(218, 238, 243, 0.55) var(--tw-gradient-to-position);
}
.to-blumine-100\\/60{
  --tw-gradient-to: rgba(218, 238, 243, 0.6) var(--tw-gradient-to-position);
}
.to-blumine-100\\/65{
  --tw-gradient-to: rgba(218, 238, 243, 0.65) var(--tw-gradient-to-position);
}
.to-blumine-100\\/70{
  --tw-gradient-to: rgba(218, 238, 243, 0.7) var(--tw-gradient-to-position);
}
.to-blumine-100\\/75{
  --tw-gradient-to: rgba(218, 238, 243, 0.75) var(--tw-gradient-to-position);
}
.to-blumine-100\\/80{
  --tw-gradient-to: rgba(218, 238, 243, 0.8) var(--tw-gradient-to-position);
}
.to-blumine-100\\/85{
  --tw-gradient-to: rgba(218, 238, 243, 0.85) var(--tw-gradient-to-position);
}
.to-blumine-100\\/90{
  --tw-gradient-to: rgba(218, 238, 243, 0.9) var(--tw-gradient-to-position);
}
.to-blumine-100\\/95{
  --tw-gradient-to: rgba(218, 238, 243, 0.95) var(--tw-gradient-to-position);
}
.to-blumine-200{
  --tw-gradient-to: #badee7 var(--tw-gradient-to-position);
}
.to-blumine-200\\/0{
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
}
.to-blumine-200\\/10{
  --tw-gradient-to: rgba(186, 222, 231, 0.1) var(--tw-gradient-to-position);
}
.to-blumine-200\\/100{
  --tw-gradient-to: rgb(186, 222, 231) var(--tw-gradient-to-position);
}
.to-blumine-200\\/15{
  --tw-gradient-to: rgba(186, 222, 231, 0.15) var(--tw-gradient-to-position);
}
.to-blumine-200\\/20{
  --tw-gradient-to: rgba(186, 222, 231, 0.2) var(--tw-gradient-to-position);
}
.to-blumine-200\\/25{
  --tw-gradient-to: rgba(186, 222, 231, 0.25) var(--tw-gradient-to-position);
}
.to-blumine-200\\/30{
  --tw-gradient-to: rgba(186, 222, 231, 0.3) var(--tw-gradient-to-position);
}
.to-blumine-200\\/35{
  --tw-gradient-to: rgba(186, 222, 231, 0.35) var(--tw-gradient-to-position);
}
.to-blumine-200\\/40{
  --tw-gradient-to: rgba(186, 222, 231, 0.4) var(--tw-gradient-to-position);
}
.to-blumine-200\\/45{
  --tw-gradient-to: rgba(186, 222, 231, 0.45) var(--tw-gradient-to-position);
}
.to-blumine-200\\/5{
  --tw-gradient-to: rgba(186, 222, 231, 0.05) var(--tw-gradient-to-position);
}
.to-blumine-200\\/50{
  --tw-gradient-to: rgba(186, 222, 231, 0.5) var(--tw-gradient-to-position);
}
.to-blumine-200\\/55{
  --tw-gradient-to: rgba(186, 222, 231, 0.55) var(--tw-gradient-to-position);
}
.to-blumine-200\\/60{
  --tw-gradient-to: rgba(186, 222, 231, 0.6) var(--tw-gradient-to-position);
}
.to-blumine-200\\/65{
  --tw-gradient-to: rgba(186, 222, 231, 0.65) var(--tw-gradient-to-position);
}
.to-blumine-200\\/70{
  --tw-gradient-to: rgba(186, 222, 231, 0.7) var(--tw-gradient-to-position);
}
.to-blumine-200\\/75{
  --tw-gradient-to: rgba(186, 222, 231, 0.75) var(--tw-gradient-to-position);
}
.to-blumine-200\\/80{
  --tw-gradient-to: rgba(186, 222, 231, 0.8) var(--tw-gradient-to-position);
}
.to-blumine-200\\/85{
  --tw-gradient-to: rgba(186, 222, 231, 0.85) var(--tw-gradient-to-position);
}
.to-blumine-200\\/90{
  --tw-gradient-to: rgba(186, 222, 231, 0.9) var(--tw-gradient-to-position);
}
.to-blumine-200\\/95{
  --tw-gradient-to: rgba(186, 222, 231, 0.95) var(--tw-gradient-to-position);
}
.to-blumine-300{
  --tw-gradient-to: #89c5d7 var(--tw-gradient-to-position);
}
.to-blumine-300\\/0{
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
}
.to-blumine-300\\/10{
  --tw-gradient-to: rgba(137, 197, 215, 0.1) var(--tw-gradient-to-position);
}
.to-blumine-300\\/100{
  --tw-gradient-to: rgb(137, 197, 215) var(--tw-gradient-to-position);
}
.to-blumine-300\\/15{
  --tw-gradient-to: rgba(137, 197, 215, 0.15) var(--tw-gradient-to-position);
}
.to-blumine-300\\/20{
  --tw-gradient-to: rgba(137, 197, 215, 0.2) var(--tw-gradient-to-position);
}
.to-blumine-300\\/25{
  --tw-gradient-to: rgba(137, 197, 215, 0.25) var(--tw-gradient-to-position);
}
.to-blumine-300\\/30{
  --tw-gradient-to: rgba(137, 197, 215, 0.3) var(--tw-gradient-to-position);
}
.to-blumine-300\\/35{
  --tw-gradient-to: rgba(137, 197, 215, 0.35) var(--tw-gradient-to-position);
}
.to-blumine-300\\/40{
  --tw-gradient-to: rgba(137, 197, 215, 0.4) var(--tw-gradient-to-position);
}
.to-blumine-300\\/45{
  --tw-gradient-to: rgba(137, 197, 215, 0.45) var(--tw-gradient-to-position);
}
.to-blumine-300\\/5{
  --tw-gradient-to: rgba(137, 197, 215, 0.05) var(--tw-gradient-to-position);
}
.to-blumine-300\\/50{
  --tw-gradient-to: rgba(137, 197, 215, 0.5) var(--tw-gradient-to-position);
}
.to-blumine-300\\/55{
  --tw-gradient-to: rgba(137, 197, 215, 0.55) var(--tw-gradient-to-position);
}
.to-blumine-300\\/60{
  --tw-gradient-to: rgba(137, 197, 215, 0.6) var(--tw-gradient-to-position);
}
.to-blumine-300\\/65{
  --tw-gradient-to: rgba(137, 197, 215, 0.65) var(--tw-gradient-to-position);
}
.to-blumine-300\\/70{
  --tw-gradient-to: rgba(137, 197, 215, 0.7) var(--tw-gradient-to-position);
}
.to-blumine-300\\/75{
  --tw-gradient-to: rgba(137, 197, 215, 0.75) var(--tw-gradient-to-position);
}
.to-blumine-300\\/80{
  --tw-gradient-to: rgba(137, 197, 215, 0.8) var(--tw-gradient-to-position);
}
.to-blumine-300\\/85{
  --tw-gradient-to: rgba(137, 197, 215, 0.85) var(--tw-gradient-to-position);
}
.to-blumine-300\\/90{
  --tw-gradient-to: rgba(137, 197, 215, 0.9) var(--tw-gradient-to-position);
}
.to-blumine-300\\/95{
  --tw-gradient-to: rgba(137, 197, 215, 0.95) var(--tw-gradient-to-position);
}
.to-blumine-400{
  --tw-gradient-to: #52a3be var(--tw-gradient-to-position);
}
.to-blumine-400\\/0{
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
}
.to-blumine-400\\/10{
  --tw-gradient-to: rgba(82, 163, 190, 0.1) var(--tw-gradient-to-position);
}
.to-blumine-400\\/100{
  --tw-gradient-to: rgb(82, 163, 190) var(--tw-gradient-to-position);
}
.to-blumine-400\\/15{
  --tw-gradient-to: rgba(82, 163, 190, 0.15) var(--tw-gradient-to-position);
}
.to-blumine-400\\/20{
  --tw-gradient-to: rgba(82, 163, 190, 0.2) var(--tw-gradient-to-position);
}
.to-blumine-400\\/25{
  --tw-gradient-to: rgba(82, 163, 190, 0.25) var(--tw-gradient-to-position);
}
.to-blumine-400\\/30{
  --tw-gradient-to: rgba(82, 163, 190, 0.3) var(--tw-gradient-to-position);
}
.to-blumine-400\\/35{
  --tw-gradient-to: rgba(82, 163, 190, 0.35) var(--tw-gradient-to-position);
}
.to-blumine-400\\/40{
  --tw-gradient-to: rgba(82, 163, 190, 0.4) var(--tw-gradient-to-position);
}
.to-blumine-400\\/45{
  --tw-gradient-to: rgba(82, 163, 190, 0.45) var(--tw-gradient-to-position);
}
.to-blumine-400\\/5{
  --tw-gradient-to: rgba(82, 163, 190, 0.05) var(--tw-gradient-to-position);
}
.to-blumine-400\\/50{
  --tw-gradient-to: rgba(82, 163, 190, 0.5) var(--tw-gradient-to-position);
}
.to-blumine-400\\/55{
  --tw-gradient-to: rgba(82, 163, 190, 0.55) var(--tw-gradient-to-position);
}
.to-blumine-400\\/60{
  --tw-gradient-to: rgba(82, 163, 190, 0.6) var(--tw-gradient-to-position);
}
.to-blumine-400\\/65{
  --tw-gradient-to: rgba(82, 163, 190, 0.65) var(--tw-gradient-to-position);
}
.to-blumine-400\\/70{
  --tw-gradient-to: rgba(82, 163, 190, 0.7) var(--tw-gradient-to-position);
}
.to-blumine-400\\/75{
  --tw-gradient-to: rgba(82, 163, 190, 0.75) var(--tw-gradient-to-position);
}
.to-blumine-400\\/80{
  --tw-gradient-to: rgba(82, 163, 190, 0.8) var(--tw-gradient-to-position);
}
.to-blumine-400\\/85{
  --tw-gradient-to: rgba(82, 163, 190, 0.85) var(--tw-gradient-to-position);
}
.to-blumine-400\\/90{
  --tw-gradient-to: rgba(82, 163, 190, 0.9) var(--tw-gradient-to-position);
}
.to-blumine-400\\/95{
  --tw-gradient-to: rgba(82, 163, 190, 0.95) var(--tw-gradient-to-position);
}
.to-blumine-500{
  --tw-gradient-to: #3787a3 var(--tw-gradient-to-position);
}
.to-blumine-500\\/0{
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
}
.to-blumine-500\\/10{
  --tw-gradient-to: rgba(55, 135, 163, 0.1) var(--tw-gradient-to-position);
}
.to-blumine-500\\/100{
  --tw-gradient-to: rgb(55, 135, 163) var(--tw-gradient-to-position);
}
.to-blumine-500\\/15{
  --tw-gradient-to: rgba(55, 135, 163, 0.15) var(--tw-gradient-to-position);
}
.to-blumine-500\\/20{
  --tw-gradient-to: rgba(55, 135, 163, 0.2) var(--tw-gradient-to-position);
}
.to-blumine-500\\/25{
  --tw-gradient-to: rgba(55, 135, 163, 0.25) var(--tw-gradient-to-position);
}
.to-blumine-500\\/30{
  --tw-gradient-to: rgba(55, 135, 163, 0.3) var(--tw-gradient-to-position);
}
.to-blumine-500\\/35{
  --tw-gradient-to: rgba(55, 135, 163, 0.35) var(--tw-gradient-to-position);
}
.to-blumine-500\\/40{
  --tw-gradient-to: rgba(55, 135, 163, 0.4) var(--tw-gradient-to-position);
}
.to-blumine-500\\/45{
  --tw-gradient-to: rgba(55, 135, 163, 0.45) var(--tw-gradient-to-position);
}
.to-blumine-500\\/5{
  --tw-gradient-to: rgba(55, 135, 163, 0.05) var(--tw-gradient-to-position);
}
.to-blumine-500\\/50{
  --tw-gradient-to: rgba(55, 135, 163, 0.5) var(--tw-gradient-to-position);
}
.to-blumine-500\\/55{
  --tw-gradient-to: rgba(55, 135, 163, 0.55) var(--tw-gradient-to-position);
}
.to-blumine-500\\/60{
  --tw-gradient-to: rgba(55, 135, 163, 0.6) var(--tw-gradient-to-position);
}
.to-blumine-500\\/65{
  --tw-gradient-to: rgba(55, 135, 163, 0.65) var(--tw-gradient-to-position);
}
.to-blumine-500\\/70{
  --tw-gradient-to: rgba(55, 135, 163, 0.7) var(--tw-gradient-to-position);
}
.to-blumine-500\\/75{
  --tw-gradient-to: rgba(55, 135, 163, 0.75) var(--tw-gradient-to-position);
}
.to-blumine-500\\/80{
  --tw-gradient-to: rgba(55, 135, 163, 0.8) var(--tw-gradient-to-position);
}
.to-blumine-500\\/85{
  --tw-gradient-to: rgba(55, 135, 163, 0.85) var(--tw-gradient-to-position);
}
.to-blumine-500\\/90{
  --tw-gradient-to: rgba(55, 135, 163, 0.9) var(--tw-gradient-to-position);
}
.to-blumine-500\\/95{
  --tw-gradient-to: rgba(55, 135, 163, 0.95) var(--tw-gradient-to-position);
}
.to-blumine-600{
  --tw-gradient-to: #306d8a var(--tw-gradient-to-position);
}
.to-blumine-600\\/0{
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
}
.to-blumine-600\\/10{
  --tw-gradient-to: rgba(48, 109, 138, 0.1) var(--tw-gradient-to-position);
}
.to-blumine-600\\/100{
  --tw-gradient-to: rgb(48, 109, 138) var(--tw-gradient-to-position);
}
.to-blumine-600\\/15{
  --tw-gradient-to: rgba(48, 109, 138, 0.15) var(--tw-gradient-to-position);
}
.to-blumine-600\\/20{
  --tw-gradient-to: rgba(48, 109, 138, 0.2) var(--tw-gradient-to-position);
}
.to-blumine-600\\/25{
  --tw-gradient-to: rgba(48, 109, 138, 0.25) var(--tw-gradient-to-position);
}
.to-blumine-600\\/30{
  --tw-gradient-to: rgba(48, 109, 138, 0.3) var(--tw-gradient-to-position);
}
.to-blumine-600\\/35{
  --tw-gradient-to: rgba(48, 109, 138, 0.35) var(--tw-gradient-to-position);
}
.to-blumine-600\\/40{
  --tw-gradient-to: rgba(48, 109, 138, 0.4) var(--tw-gradient-to-position);
}
.to-blumine-600\\/45{
  --tw-gradient-to: rgba(48, 109, 138, 0.45) var(--tw-gradient-to-position);
}
.to-blumine-600\\/5{
  --tw-gradient-to: rgba(48, 109, 138, 0.05) var(--tw-gradient-to-position);
}
.to-blumine-600\\/50{
  --tw-gradient-to: rgba(48, 109, 138, 0.5) var(--tw-gradient-to-position);
}
.to-blumine-600\\/55{
  --tw-gradient-to: rgba(48, 109, 138, 0.55) var(--tw-gradient-to-position);
}
.to-blumine-600\\/60{
  --tw-gradient-to: rgba(48, 109, 138, 0.6) var(--tw-gradient-to-position);
}
.to-blumine-600\\/65{
  --tw-gradient-to: rgba(48, 109, 138, 0.65) var(--tw-gradient-to-position);
}
.to-blumine-600\\/70{
  --tw-gradient-to: rgba(48, 109, 138, 0.7) var(--tw-gradient-to-position);
}
.to-blumine-600\\/75{
  --tw-gradient-to: rgba(48, 109, 138, 0.75) var(--tw-gradient-to-position);
}
.to-blumine-600\\/80{
  --tw-gradient-to: rgba(48, 109, 138, 0.8) var(--tw-gradient-to-position);
}
.to-blumine-600\\/85{
  --tw-gradient-to: rgba(48, 109, 138, 0.85) var(--tw-gradient-to-position);
}
.to-blumine-600\\/90{
  --tw-gradient-to: rgba(48, 109, 138, 0.9) var(--tw-gradient-to-position);
}
.to-blumine-600\\/95{
  --tw-gradient-to: rgba(48, 109, 138, 0.95) var(--tw-gradient-to-position);
}
.to-blumine-700{
  --tw-gradient-to: #2d5b72 var(--tw-gradient-to-position);
}
.to-blumine-700\\/0{
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
}
.to-blumine-700\\/10{
  --tw-gradient-to: rgba(45, 91, 114, 0.1) var(--tw-gradient-to-position);
}
.to-blumine-700\\/100{
  --tw-gradient-to: rgb(45, 91, 114) var(--tw-gradient-to-position);
}
.to-blumine-700\\/15{
  --tw-gradient-to: rgba(45, 91, 114, 0.15) var(--tw-gradient-to-position);
}
.to-blumine-700\\/20{
  --tw-gradient-to: rgba(45, 91, 114, 0.2) var(--tw-gradient-to-position);
}
.to-blumine-700\\/25{
  --tw-gradient-to: rgba(45, 91, 114, 0.25) var(--tw-gradient-to-position);
}
.to-blumine-700\\/30{
  --tw-gradient-to: rgba(45, 91, 114, 0.3) var(--tw-gradient-to-position);
}
.to-blumine-700\\/35{
  --tw-gradient-to: rgba(45, 91, 114, 0.35) var(--tw-gradient-to-position);
}
.to-blumine-700\\/40{
  --tw-gradient-to: rgba(45, 91, 114, 0.4) var(--tw-gradient-to-position);
}
.to-blumine-700\\/45{
  --tw-gradient-to: rgba(45, 91, 114, 0.45) var(--tw-gradient-to-position);
}
.to-blumine-700\\/5{
  --tw-gradient-to: rgba(45, 91, 114, 0.05) var(--tw-gradient-to-position);
}
.to-blumine-700\\/50{
  --tw-gradient-to: rgba(45, 91, 114, 0.5) var(--tw-gradient-to-position);
}
.to-blumine-700\\/55{
  --tw-gradient-to: rgba(45, 91, 114, 0.55) var(--tw-gradient-to-position);
}
.to-blumine-700\\/60{
  --tw-gradient-to: rgba(45, 91, 114, 0.6) var(--tw-gradient-to-position);
}
.to-blumine-700\\/65{
  --tw-gradient-to: rgba(45, 91, 114, 0.65) var(--tw-gradient-to-position);
}
.to-blumine-700\\/70{
  --tw-gradient-to: rgba(45, 91, 114, 0.7) var(--tw-gradient-to-position);
}
.to-blumine-700\\/75{
  --tw-gradient-to: rgba(45, 91, 114, 0.75) var(--tw-gradient-to-position);
}
.to-blumine-700\\/80{
  --tw-gradient-to: rgba(45, 91, 114, 0.8) var(--tw-gradient-to-position);
}
.to-blumine-700\\/85{
  --tw-gradient-to: rgba(45, 91, 114, 0.85) var(--tw-gradient-to-position);
}
.to-blumine-700\\/90{
  --tw-gradient-to: rgba(45, 91, 114, 0.9) var(--tw-gradient-to-position);
}
.to-blumine-700\\/95{
  --tw-gradient-to: rgba(45, 91, 114, 0.95) var(--tw-gradient-to-position);
}
.to-blumine-800{
  --tw-gradient-to: #2c4c5e var(--tw-gradient-to-position);
}
.to-blumine-800\\/0{
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
}
.to-blumine-800\\/10{
  --tw-gradient-to: rgba(44, 76, 94, 0.1) var(--tw-gradient-to-position);
}
.to-blumine-800\\/100{
  --tw-gradient-to: rgb(44, 76, 94) var(--tw-gradient-to-position);
}
.to-blumine-800\\/15{
  --tw-gradient-to: rgba(44, 76, 94, 0.15) var(--tw-gradient-to-position);
}
.to-blumine-800\\/20{
  --tw-gradient-to: rgba(44, 76, 94, 0.2) var(--tw-gradient-to-position);
}
.to-blumine-800\\/25{
  --tw-gradient-to: rgba(44, 76, 94, 0.25) var(--tw-gradient-to-position);
}
.to-blumine-800\\/30{
  --tw-gradient-to: rgba(44, 76, 94, 0.3) var(--tw-gradient-to-position);
}
.to-blumine-800\\/35{
  --tw-gradient-to: rgba(44, 76, 94, 0.35) var(--tw-gradient-to-position);
}
.to-blumine-800\\/40{
  --tw-gradient-to: rgba(44, 76, 94, 0.4) var(--tw-gradient-to-position);
}
.to-blumine-800\\/45{
  --tw-gradient-to: rgba(44, 76, 94, 0.45) var(--tw-gradient-to-position);
}
.to-blumine-800\\/5{
  --tw-gradient-to: rgba(44, 76, 94, 0.05) var(--tw-gradient-to-position);
}
.to-blumine-800\\/50{
  --tw-gradient-to: rgba(44, 76, 94, 0.5) var(--tw-gradient-to-position);
}
.to-blumine-800\\/55{
  --tw-gradient-to: rgba(44, 76, 94, 0.55) var(--tw-gradient-to-position);
}
.to-blumine-800\\/60{
  --tw-gradient-to: rgba(44, 76, 94, 0.6) var(--tw-gradient-to-position);
}
.to-blumine-800\\/65{
  --tw-gradient-to: rgba(44, 76, 94, 0.65) var(--tw-gradient-to-position);
}
.to-blumine-800\\/70{
  --tw-gradient-to: rgba(44, 76, 94, 0.7) var(--tw-gradient-to-position);
}
.to-blumine-800\\/75{
  --tw-gradient-to: rgba(44, 76, 94, 0.75) var(--tw-gradient-to-position);
}
.to-blumine-800\\/80{
  --tw-gradient-to: rgba(44, 76, 94, 0.8) var(--tw-gradient-to-position);
}
.to-blumine-800\\/85{
  --tw-gradient-to: rgba(44, 76, 94, 0.85) var(--tw-gradient-to-position);
}
.to-blumine-800\\/90{
  --tw-gradient-to: rgba(44, 76, 94, 0.9) var(--tw-gradient-to-position);
}
.to-blumine-800\\/95{
  --tw-gradient-to: rgba(44, 76, 94, 0.95) var(--tw-gradient-to-position);
}
.to-blumine-900{
  --tw-gradient-to: #284151 var(--tw-gradient-to-position);
}
.to-blumine-900\\/0{
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
}
.to-blumine-900\\/10{
  --tw-gradient-to: rgba(40, 65, 81, 0.1) var(--tw-gradient-to-position);
}
.to-blumine-900\\/100{
  --tw-gradient-to: rgb(40, 65, 81) var(--tw-gradient-to-position);
}
.to-blumine-900\\/15{
  --tw-gradient-to: rgba(40, 65, 81, 0.15) var(--tw-gradient-to-position);
}
.to-blumine-900\\/20{
  --tw-gradient-to: rgba(40, 65, 81, 0.2) var(--tw-gradient-to-position);
}
.to-blumine-900\\/25{
  --tw-gradient-to: rgba(40, 65, 81, 0.25) var(--tw-gradient-to-position);
}
.to-blumine-900\\/30{
  --tw-gradient-to: rgba(40, 65, 81, 0.3) var(--tw-gradient-to-position);
}
.to-blumine-900\\/35{
  --tw-gradient-to: rgba(40, 65, 81, 0.35) var(--tw-gradient-to-position);
}
.to-blumine-900\\/40{
  --tw-gradient-to: rgba(40, 65, 81, 0.4) var(--tw-gradient-to-position);
}
.to-blumine-900\\/45{
  --tw-gradient-to: rgba(40, 65, 81, 0.45) var(--tw-gradient-to-position);
}
.to-blumine-900\\/5{
  --tw-gradient-to: rgba(40, 65, 81, 0.05) var(--tw-gradient-to-position);
}
.to-blumine-900\\/50{
  --tw-gradient-to: rgba(40, 65, 81, 0.5) var(--tw-gradient-to-position);
}
.to-blumine-900\\/55{
  --tw-gradient-to: rgba(40, 65, 81, 0.55) var(--tw-gradient-to-position);
}
.to-blumine-900\\/60{
  --tw-gradient-to: rgba(40, 65, 81, 0.6) var(--tw-gradient-to-position);
}
.to-blumine-900\\/65{
  --tw-gradient-to: rgba(40, 65, 81, 0.65) var(--tw-gradient-to-position);
}
.to-blumine-900\\/70{
  --tw-gradient-to: rgba(40, 65, 81, 0.7) var(--tw-gradient-to-position);
}
.to-blumine-900\\/75{
  --tw-gradient-to: rgba(40, 65, 81, 0.75) var(--tw-gradient-to-position);
}
.to-blumine-900\\/80{
  --tw-gradient-to: rgba(40, 65, 81, 0.8) var(--tw-gradient-to-position);
}
.to-blumine-900\\/85{
  --tw-gradient-to: rgba(40, 65, 81, 0.85) var(--tw-gradient-to-position);
}
.to-blumine-900\\/90{
  --tw-gradient-to: rgba(40, 65, 81, 0.9) var(--tw-gradient-to-position);
}
.to-blumine-900\\/95{
  --tw-gradient-to: rgba(40, 65, 81, 0.95) var(--tw-gradient-to-position);
}
.to-blumine-950{
  --tw-gradient-to: #162936 var(--tw-gradient-to-position);
}
.to-blumine-950\\/0{
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
}
.to-blumine-950\\/10{
  --tw-gradient-to: rgba(22, 41, 54, 0.1) var(--tw-gradient-to-position);
}
.to-blumine-950\\/100{
  --tw-gradient-to: rgb(22, 41, 54) var(--tw-gradient-to-position);
}
.to-blumine-950\\/15{
  --tw-gradient-to: rgba(22, 41, 54, 0.15) var(--tw-gradient-to-position);
}
.to-blumine-950\\/20{
  --tw-gradient-to: rgba(22, 41, 54, 0.2) var(--tw-gradient-to-position);
}
.to-blumine-950\\/25{
  --tw-gradient-to: rgba(22, 41, 54, 0.25) var(--tw-gradient-to-position);
}
.to-blumine-950\\/30{
  --tw-gradient-to: rgba(22, 41, 54, 0.3) var(--tw-gradient-to-position);
}
.to-blumine-950\\/35{
  --tw-gradient-to: rgba(22, 41, 54, 0.35) var(--tw-gradient-to-position);
}
.to-blumine-950\\/40{
  --tw-gradient-to: rgba(22, 41, 54, 0.4) var(--tw-gradient-to-position);
}
.to-blumine-950\\/45{
  --tw-gradient-to: rgba(22, 41, 54, 0.45) var(--tw-gradient-to-position);
}
.to-blumine-950\\/5{
  --tw-gradient-to: rgba(22, 41, 54, 0.05) var(--tw-gradient-to-position);
}
.to-blumine-950\\/50{
  --tw-gradient-to: rgba(22, 41, 54, 0.5) var(--tw-gradient-to-position);
}
.to-blumine-950\\/55{
  --tw-gradient-to: rgba(22, 41, 54, 0.55) var(--tw-gradient-to-position);
}
.to-blumine-950\\/60{
  --tw-gradient-to: rgba(22, 41, 54, 0.6) var(--tw-gradient-to-position);
}
.to-blumine-950\\/65{
  --tw-gradient-to: rgba(22, 41, 54, 0.65) var(--tw-gradient-to-position);
}
.to-blumine-950\\/70{
  --tw-gradient-to: rgba(22, 41, 54, 0.7) var(--tw-gradient-to-position);
}
.to-blumine-950\\/75{
  --tw-gradient-to: rgba(22, 41, 54, 0.75) var(--tw-gradient-to-position);
}
.to-blumine-950\\/80{
  --tw-gradient-to: rgba(22, 41, 54, 0.8) var(--tw-gradient-to-position);
}
.to-blumine-950\\/85{
  --tw-gradient-to: rgba(22, 41, 54, 0.85) var(--tw-gradient-to-position);
}
.to-blumine-950\\/90{
  --tw-gradient-to: rgba(22, 41, 54, 0.9) var(--tw-gradient-to-position);
}
.to-blumine-950\\/95{
  --tw-gradient-to: rgba(22, 41, 54, 0.95) var(--tw-gradient-to-position);
}
.to-charcoal-100{
  --tw-gradient-to: #e6e6e7 var(--tw-gradient-to-position);
}
.to-charcoal-100\\/0{
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/10{
  --tw-gradient-to: rgba(230, 230, 231, 0.1) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/100{
  --tw-gradient-to: rgb(230, 230, 231) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/15{
  --tw-gradient-to: rgba(230, 230, 231, 0.15) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/20{
  --tw-gradient-to: rgba(230, 230, 231, 0.2) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/25{
  --tw-gradient-to: rgba(230, 230, 231, 0.25) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/30{
  --tw-gradient-to: rgba(230, 230, 231, 0.3) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/35{
  --tw-gradient-to: rgba(230, 230, 231, 0.35) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/40{
  --tw-gradient-to: rgba(230, 230, 231, 0.4) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/45{
  --tw-gradient-to: rgba(230, 230, 231, 0.45) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/5{
  --tw-gradient-to: rgba(230, 230, 231, 0.05) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/50{
  --tw-gradient-to: rgba(230, 230, 231, 0.5) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/55{
  --tw-gradient-to: rgba(230, 230, 231, 0.55) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/60{
  --tw-gradient-to: rgba(230, 230, 231, 0.6) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/65{
  --tw-gradient-to: rgba(230, 230, 231, 0.65) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/70{
  --tw-gradient-to: rgba(230, 230, 231, 0.7) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/75{
  --tw-gradient-to: rgba(230, 230, 231, 0.75) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/80{
  --tw-gradient-to: rgba(230, 230, 231, 0.8) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/85{
  --tw-gradient-to: rgba(230, 230, 231, 0.85) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/90{
  --tw-gradient-to: rgba(230, 230, 231, 0.9) var(--tw-gradient-to-position);
}
.to-charcoal-100\\/95{
  --tw-gradient-to: rgba(230, 230, 231, 0.95) var(--tw-gradient-to-position);
}
.to-charcoal-200{
  --tw-gradient-to: #cfd0d2 var(--tw-gradient-to-position);
}
.to-charcoal-200\\/0{
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/10{
  --tw-gradient-to: rgba(207, 208, 210, 0.1) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/100{
  --tw-gradient-to: rgb(207, 208, 210) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/15{
  --tw-gradient-to: rgba(207, 208, 210, 0.15) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/20{
  --tw-gradient-to: rgba(207, 208, 210, 0.2) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/25{
  --tw-gradient-to: rgba(207, 208, 210, 0.25) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/30{
  --tw-gradient-to: rgba(207, 208, 210, 0.3) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/35{
  --tw-gradient-to: rgba(207, 208, 210, 0.35) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/40{
  --tw-gradient-to: rgba(207, 208, 210, 0.4) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/45{
  --tw-gradient-to: rgba(207, 208, 210, 0.45) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/5{
  --tw-gradient-to: rgba(207, 208, 210, 0.05) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/50{
  --tw-gradient-to: rgba(207, 208, 210, 0.5) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/55{
  --tw-gradient-to: rgba(207, 208, 210, 0.55) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/60{
  --tw-gradient-to: rgba(207, 208, 210, 0.6) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/65{
  --tw-gradient-to: rgba(207, 208, 210, 0.65) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/70{
  --tw-gradient-to: rgba(207, 208, 210, 0.7) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/75{
  --tw-gradient-to: rgba(207, 208, 210, 0.75) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/80{
  --tw-gradient-to: rgba(207, 208, 210, 0.8) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/85{
  --tw-gradient-to: rgba(207, 208, 210, 0.85) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/90{
  --tw-gradient-to: rgba(207, 208, 210, 0.9) var(--tw-gradient-to-position);
}
.to-charcoal-200\\/95{
  --tw-gradient-to: rgba(207, 208, 210, 0.95) var(--tw-gradient-to-position);
}
.to-charcoal-300{
  --tw-gradient-to: #aeafb2 var(--tw-gradient-to-position);
}
.to-charcoal-300\\/0{
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/10{
  --tw-gradient-to: rgba(174, 175, 178, 0.1) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/100{
  --tw-gradient-to: rgb(174, 175, 178) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/15{
  --tw-gradient-to: rgba(174, 175, 178, 0.15) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/20{
  --tw-gradient-to: rgba(174, 175, 178, 0.2) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/25{
  --tw-gradient-to: rgba(174, 175, 178, 0.25) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/30{
  --tw-gradient-to: rgba(174, 175, 178, 0.3) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/35{
  --tw-gradient-to: rgba(174, 175, 178, 0.35) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/40{
  --tw-gradient-to: rgba(174, 175, 178, 0.4) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/45{
  --tw-gradient-to: rgba(174, 175, 178, 0.45) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/5{
  --tw-gradient-to: rgba(174, 175, 178, 0.05) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/50{
  --tw-gradient-to: rgba(174, 175, 178, 0.5) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/55{
  --tw-gradient-to: rgba(174, 175, 178, 0.55) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/60{
  --tw-gradient-to: rgba(174, 175, 178, 0.6) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/65{
  --tw-gradient-to: rgba(174, 175, 178, 0.65) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/70{
  --tw-gradient-to: rgba(174, 175, 178, 0.7) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/75{
  --tw-gradient-to: rgba(174, 175, 178, 0.75) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/80{
  --tw-gradient-to: rgba(174, 175, 178, 0.8) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/85{
  --tw-gradient-to: rgba(174, 175, 178, 0.85) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/90{
  --tw-gradient-to: rgba(174, 175, 178, 0.9) var(--tw-gradient-to-position);
}
.to-charcoal-300\\/95{
  --tw-gradient-to: rgba(174, 175, 178, 0.95) var(--tw-gradient-to-position);
}
.to-charcoal-400{
  --tw-gradient-to: #85868b var(--tw-gradient-to-position);
}
.to-charcoal-400\\/0{
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/10{
  --tw-gradient-to: rgba(133, 134, 139, 0.1) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/100{
  --tw-gradient-to: rgb(133, 134, 139) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/15{
  --tw-gradient-to: rgba(133, 134, 139, 0.15) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/20{
  --tw-gradient-to: rgba(133, 134, 139, 0.2) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/25{
  --tw-gradient-to: rgba(133, 134, 139, 0.25) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/30{
  --tw-gradient-to: rgba(133, 134, 139, 0.3) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/35{
  --tw-gradient-to: rgba(133, 134, 139, 0.35) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/40{
  --tw-gradient-to: rgba(133, 134, 139, 0.4) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/45{
  --tw-gradient-to: rgba(133, 134, 139, 0.45) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/5{
  --tw-gradient-to: rgba(133, 134, 139, 0.05) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/50{
  --tw-gradient-to: rgba(133, 134, 139, 0.5) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/55{
  --tw-gradient-to: rgba(133, 134, 139, 0.55) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/60{
  --tw-gradient-to: rgba(133, 134, 139, 0.6) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/65{
  --tw-gradient-to: rgba(133, 134, 139, 0.65) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/70{
  --tw-gradient-to: rgba(133, 134, 139, 0.7) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/75{
  --tw-gradient-to: rgba(133, 134, 139, 0.75) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/80{
  --tw-gradient-to: rgba(133, 134, 139, 0.8) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/85{
  --tw-gradient-to: rgba(133, 134, 139, 0.85) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/90{
  --tw-gradient-to: rgba(133, 134, 139, 0.9) var(--tw-gradient-to-position);
}
.to-charcoal-400\\/95{
  --tw-gradient-to: rgba(133, 134, 139, 0.95) var(--tw-gradient-to-position);
}
.to-charcoal-50{
  --tw-gradient-to: #f5f5f6 var(--tw-gradient-to-position);
}
.to-charcoal-500{
  --tw-gradient-to: #6a6b70 var(--tw-gradient-to-position);
}
.to-charcoal-500\\/0{
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/10{
  --tw-gradient-to: rgba(106, 107, 112, 0.1) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/100{
  --tw-gradient-to: rgb(106, 107, 112) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/15{
  --tw-gradient-to: rgba(106, 107, 112, 0.15) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/20{
  --tw-gradient-to: rgba(106, 107, 112, 0.2) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/25{
  --tw-gradient-to: rgba(106, 107, 112, 0.25) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/30{
  --tw-gradient-to: rgba(106, 107, 112, 0.3) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/35{
  --tw-gradient-to: rgba(106, 107, 112, 0.35) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/40{
  --tw-gradient-to: rgba(106, 107, 112, 0.4) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/45{
  --tw-gradient-to: rgba(106, 107, 112, 0.45) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/5{
  --tw-gradient-to: rgba(106, 107, 112, 0.05) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/50{
  --tw-gradient-to: rgba(106, 107, 112, 0.5) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/55{
  --tw-gradient-to: rgba(106, 107, 112, 0.55) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/60{
  --tw-gradient-to: rgba(106, 107, 112, 0.6) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/65{
  --tw-gradient-to: rgba(106, 107, 112, 0.65) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/70{
  --tw-gradient-to: rgba(106, 107, 112, 0.7) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/75{
  --tw-gradient-to: rgba(106, 107, 112, 0.75) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/80{
  --tw-gradient-to: rgba(106, 107, 112, 0.8) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/85{
  --tw-gradient-to: rgba(106, 107, 112, 0.85) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/90{
  --tw-gradient-to: rgba(106, 107, 112, 0.9) var(--tw-gradient-to-position);
}
.to-charcoal-500\\/95{
  --tw-gradient-to: rgba(106, 107, 112, 0.95) var(--tw-gradient-to-position);
}
.to-charcoal-600{
  --tw-gradient-to: #5a5b60 var(--tw-gradient-to-position);
}
.to-charcoal-600\\/0{
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/10{
  --tw-gradient-to: rgba(90, 91, 96, 0.1) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/100{
  --tw-gradient-to: rgb(90, 91, 96) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/15{
  --tw-gradient-to: rgba(90, 91, 96, 0.15) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/20{
  --tw-gradient-to: rgba(90, 91, 96, 0.2) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/25{
  --tw-gradient-to: rgba(90, 91, 96, 0.25) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/30{
  --tw-gradient-to: rgba(90, 91, 96, 0.3) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/35{
  --tw-gradient-to: rgba(90, 91, 96, 0.35) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/40{
  --tw-gradient-to: rgba(90, 91, 96, 0.4) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/45{
  --tw-gradient-to: rgba(90, 91, 96, 0.45) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/5{
  --tw-gradient-to: rgba(90, 91, 96, 0.05) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/50{
  --tw-gradient-to: rgba(90, 91, 96, 0.5) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/55{
  --tw-gradient-to: rgba(90, 91, 96, 0.55) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/60{
  --tw-gradient-to: rgba(90, 91, 96, 0.6) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/65{
  --tw-gradient-to: rgba(90, 91, 96, 0.65) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/70{
  --tw-gradient-to: rgba(90, 91, 96, 0.7) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/75{
  --tw-gradient-to: rgba(90, 91, 96, 0.75) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/80{
  --tw-gradient-to: rgba(90, 91, 96, 0.8) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/85{
  --tw-gradient-to: rgba(90, 91, 96, 0.85) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/90{
  --tw-gradient-to: rgba(90, 91, 96, 0.9) var(--tw-gradient-to-position);
}
.to-charcoal-600\\/95{
  --tw-gradient-to: rgba(90, 91, 96, 0.95) var(--tw-gradient-to-position);
}
.to-charcoal-700{
  --tw-gradient-to: #4d4d51 var(--tw-gradient-to-position);
}
.to-charcoal-700\\/0{
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/10{
  --tw-gradient-to: rgba(77, 77, 81, 0.1) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/100{
  --tw-gradient-to: rgb(77, 77, 81) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/15{
  --tw-gradient-to: rgba(77, 77, 81, 0.15) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/20{
  --tw-gradient-to: rgba(77, 77, 81, 0.2) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/25{
  --tw-gradient-to: rgba(77, 77, 81, 0.25) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/30{
  --tw-gradient-to: rgba(77, 77, 81, 0.3) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/35{
  --tw-gradient-to: rgba(77, 77, 81, 0.35) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/40{
  --tw-gradient-to: rgba(77, 77, 81, 0.4) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/45{
  --tw-gradient-to: rgba(77, 77, 81, 0.45) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/5{
  --tw-gradient-to: rgba(77, 77, 81, 0.05) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/50{
  --tw-gradient-to: rgba(77, 77, 81, 0.5) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/55{
  --tw-gradient-to: rgba(77, 77, 81, 0.55) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/60{
  --tw-gradient-to: rgba(77, 77, 81, 0.6) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/65{
  --tw-gradient-to: rgba(77, 77, 81, 0.65) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/70{
  --tw-gradient-to: rgba(77, 77, 81, 0.7) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/75{
  --tw-gradient-to: rgba(77, 77, 81, 0.75) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/80{
  --tw-gradient-to: rgba(77, 77, 81, 0.8) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/85{
  --tw-gradient-to: rgba(77, 77, 81, 0.85) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/90{
  --tw-gradient-to: rgba(77, 77, 81, 0.9) var(--tw-gradient-to-position);
}
.to-charcoal-700\\/95{
  --tw-gradient-to: rgba(77, 77, 81, 0.95) var(--tw-gradient-to-position);
}
.to-charcoal-800{
  --tw-gradient-to: #434347 var(--tw-gradient-to-position);
}
.to-charcoal-800\\/0{
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/10{
  --tw-gradient-to: rgba(67, 67, 71, 0.1) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/100{
  --tw-gradient-to: rgb(67, 67, 71) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/15{
  --tw-gradient-to: rgba(67, 67, 71, 0.15) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/20{
  --tw-gradient-to: rgba(67, 67, 71, 0.2) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/25{
  --tw-gradient-to: rgba(67, 67, 71, 0.25) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/30{
  --tw-gradient-to: rgba(67, 67, 71, 0.3) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/35{
  --tw-gradient-to: rgba(67, 67, 71, 0.35) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/40{
  --tw-gradient-to: rgba(67, 67, 71, 0.4) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/45{
  --tw-gradient-to: rgba(67, 67, 71, 0.45) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/5{
  --tw-gradient-to: rgba(67, 67, 71, 0.05) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/50{
  --tw-gradient-to: rgba(67, 67, 71, 0.5) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/55{
  --tw-gradient-to: rgba(67, 67, 71, 0.55) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/60{
  --tw-gradient-to: rgba(67, 67, 71, 0.6) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/65{
  --tw-gradient-to: rgba(67, 67, 71, 0.65) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/70{
  --tw-gradient-to: rgba(67, 67, 71, 0.7) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/75{
  --tw-gradient-to: rgba(67, 67, 71, 0.75) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/80{
  --tw-gradient-to: rgba(67, 67, 71, 0.8) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/85{
  --tw-gradient-to: rgba(67, 67, 71, 0.85) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/90{
  --tw-gradient-to: rgba(67, 67, 71, 0.9) var(--tw-gradient-to-position);
}
.to-charcoal-800\\/95{
  --tw-gradient-to: rgba(67, 67, 71, 0.95) var(--tw-gradient-to-position);
}
.to-charcoal-900{
  --tw-gradient-to: #313133 var(--tw-gradient-to-position);
}
.to-charcoal-900\\/0{
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/10{
  --tw-gradient-to: rgba(49, 49, 51, 0.1) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/100{
  --tw-gradient-to: rgb(49, 49, 51) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/15{
  --tw-gradient-to: rgba(49, 49, 51, 0.15) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/20{
  --tw-gradient-to: rgba(49, 49, 51, 0.2) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/25{
  --tw-gradient-to: rgba(49, 49, 51, 0.25) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/30{
  --tw-gradient-to: rgba(49, 49, 51, 0.3) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/35{
  --tw-gradient-to: rgba(49, 49, 51, 0.35) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/40{
  --tw-gradient-to: rgba(49, 49, 51, 0.4) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/45{
  --tw-gradient-to: rgba(49, 49, 51, 0.45) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/5{
  --tw-gradient-to: rgba(49, 49, 51, 0.05) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/50{
  --tw-gradient-to: rgba(49, 49, 51, 0.5) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/55{
  --tw-gradient-to: rgba(49, 49, 51, 0.55) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/60{
  --tw-gradient-to: rgba(49, 49, 51, 0.6) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/65{
  --tw-gradient-to: rgba(49, 49, 51, 0.65) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/70{
  --tw-gradient-to: rgba(49, 49, 51, 0.7) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/75{
  --tw-gradient-to: rgba(49, 49, 51, 0.75) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/80{
  --tw-gradient-to: rgba(49, 49, 51, 0.8) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/85{
  --tw-gradient-to: rgba(49, 49, 51, 0.85) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/90{
  --tw-gradient-to: rgba(49, 49, 51, 0.9) var(--tw-gradient-to-position);
}
.to-charcoal-900\\/95{
  --tw-gradient-to: rgba(49, 49, 51, 0.95) var(--tw-gradient-to-position);
}
.to-charcoal-950{
  --tw-gradient-to: #252527 var(--tw-gradient-to-position);
}
.to-charcoal-950\\/0{
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/10{
  --tw-gradient-to: rgba(37, 37, 39, 0.1) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/100{
  --tw-gradient-to: rgb(37, 37, 39) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/15{
  --tw-gradient-to: rgba(37, 37, 39, 0.15) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/20{
  --tw-gradient-to: rgba(37, 37, 39, 0.2) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/25{
  --tw-gradient-to: rgba(37, 37, 39, 0.25) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/30{
  --tw-gradient-to: rgba(37, 37, 39, 0.3) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/35{
  --tw-gradient-to: rgba(37, 37, 39, 0.35) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/40{
  --tw-gradient-to: rgba(37, 37, 39, 0.4) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/45{
  --tw-gradient-to: rgba(37, 37, 39, 0.45) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/5{
  --tw-gradient-to: rgba(37, 37, 39, 0.05) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/50{
  --tw-gradient-to: rgba(37, 37, 39, 0.5) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/55{
  --tw-gradient-to: rgba(37, 37, 39, 0.55) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/60{
  --tw-gradient-to: rgba(37, 37, 39, 0.6) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/65{
  --tw-gradient-to: rgba(37, 37, 39, 0.65) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/70{
  --tw-gradient-to: rgba(37, 37, 39, 0.7) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/75{
  --tw-gradient-to: rgba(37, 37, 39, 0.75) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/80{
  --tw-gradient-to: rgba(37, 37, 39, 0.8) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/85{
  --tw-gradient-to: rgba(37, 37, 39, 0.85) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/90{
  --tw-gradient-to: rgba(37, 37, 39, 0.9) var(--tw-gradient-to-position);
}
.to-charcoal-950\\/95{
  --tw-gradient-to: rgba(37, 37, 39, 0.95) var(--tw-gradient-to-position);
}
.to-jade-100{
  --tw-gradient-to: #d9f2e6 var(--tw-gradient-to-position);
}
.to-jade-100\\/0{
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
}
.to-jade-100\\/10{
  --tw-gradient-to: rgba(217, 242, 230, 0.1) var(--tw-gradient-to-position);
}
.to-jade-100\\/100{
  --tw-gradient-to: rgb(217, 242, 230) var(--tw-gradient-to-position);
}
.to-jade-100\\/15{
  --tw-gradient-to: rgba(217, 242, 230, 0.15) var(--tw-gradient-to-position);
}
.to-jade-100\\/20{
  --tw-gradient-to: rgba(217, 242, 230, 0.2) var(--tw-gradient-to-position);
}
.to-jade-100\\/25{
  --tw-gradient-to: rgba(217, 242, 230, 0.25) var(--tw-gradient-to-position);
}
.to-jade-100\\/30{
  --tw-gradient-to: rgba(217, 242, 230, 0.3) var(--tw-gradient-to-position);
}
.to-jade-100\\/35{
  --tw-gradient-to: rgba(217, 242, 230, 0.35) var(--tw-gradient-to-position);
}
.to-jade-100\\/40{
  --tw-gradient-to: rgba(217, 242, 230, 0.4) var(--tw-gradient-to-position);
}
.to-jade-100\\/45{
  --tw-gradient-to: rgba(217, 242, 230, 0.45) var(--tw-gradient-to-position);
}
.to-jade-100\\/5{
  --tw-gradient-to: rgba(217, 242, 230, 0.05) var(--tw-gradient-to-position);
}
.to-jade-100\\/50{
  --tw-gradient-to: rgba(217, 242, 230, 0.5) var(--tw-gradient-to-position);
}
.to-jade-100\\/55{
  --tw-gradient-to: rgba(217, 242, 230, 0.55) var(--tw-gradient-to-position);
}
.to-jade-100\\/60{
  --tw-gradient-to: rgba(217, 242, 230, 0.6) var(--tw-gradient-to-position);
}
.to-jade-100\\/65{
  --tw-gradient-to: rgba(217, 242, 230, 0.65) var(--tw-gradient-to-position);
}
.to-jade-100\\/70{
  --tw-gradient-to: rgba(217, 242, 230, 0.7) var(--tw-gradient-to-position);
}
.to-jade-100\\/75{
  --tw-gradient-to: rgba(217, 242, 230, 0.75) var(--tw-gradient-to-position);
}
.to-jade-100\\/80{
  --tw-gradient-to: rgba(217, 242, 230, 0.8) var(--tw-gradient-to-position);
}
.to-jade-100\\/85{
  --tw-gradient-to: rgba(217, 242, 230, 0.85) var(--tw-gradient-to-position);
}
.to-jade-100\\/90{
  --tw-gradient-to: rgba(217, 242, 230, 0.9) var(--tw-gradient-to-position);
}
.to-jade-100\\/95{
  --tw-gradient-to: rgba(217, 242, 230, 0.95) var(--tw-gradient-to-position);
}
.to-jade-200{
  --tw-gradient-to: #b6e4d1 var(--tw-gradient-to-position);
}
.to-jade-200\\/0{
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
}
.to-jade-200\\/10{
  --tw-gradient-to: rgba(182, 228, 209, 0.1) var(--tw-gradient-to-position);
}
.to-jade-200\\/100{
  --tw-gradient-to: rgb(182, 228, 209) var(--tw-gradient-to-position);
}
.to-jade-200\\/15{
  --tw-gradient-to: rgba(182, 228, 209, 0.15) var(--tw-gradient-to-position);
}
.to-jade-200\\/20{
  --tw-gradient-to: rgba(182, 228, 209, 0.2) var(--tw-gradient-to-position);
}
.to-jade-200\\/25{
  --tw-gradient-to: rgba(182, 228, 209, 0.25) var(--tw-gradient-to-position);
}
.to-jade-200\\/30{
  --tw-gradient-to: rgba(182, 228, 209, 0.3) var(--tw-gradient-to-position);
}
.to-jade-200\\/35{
  --tw-gradient-to: rgba(182, 228, 209, 0.35) var(--tw-gradient-to-position);
}
.to-jade-200\\/40{
  --tw-gradient-to: rgba(182, 228, 209, 0.4) var(--tw-gradient-to-position);
}
.to-jade-200\\/45{
  --tw-gradient-to: rgba(182, 228, 209, 0.45) var(--tw-gradient-to-position);
}
.to-jade-200\\/5{
  --tw-gradient-to: rgba(182, 228, 209, 0.05) var(--tw-gradient-to-position);
}
.to-jade-200\\/50{
  --tw-gradient-to: rgba(182, 228, 209, 0.5) var(--tw-gradient-to-position);
}
.to-jade-200\\/55{
  --tw-gradient-to: rgba(182, 228, 209, 0.55) var(--tw-gradient-to-position);
}
.to-jade-200\\/60{
  --tw-gradient-to: rgba(182, 228, 209, 0.6) var(--tw-gradient-to-position);
}
.to-jade-200\\/65{
  --tw-gradient-to: rgba(182, 228, 209, 0.65) var(--tw-gradient-to-position);
}
.to-jade-200\\/70{
  --tw-gradient-to: rgba(182, 228, 209, 0.7) var(--tw-gradient-to-position);
}
.to-jade-200\\/75{
  --tw-gradient-to: rgba(182, 228, 209, 0.75) var(--tw-gradient-to-position);
}
.to-jade-200\\/80{
  --tw-gradient-to: rgba(182, 228, 209, 0.8) var(--tw-gradient-to-position);
}
.to-jade-200\\/85{
  --tw-gradient-to: rgba(182, 228, 209, 0.85) var(--tw-gradient-to-position);
}
.to-jade-200\\/90{
  --tw-gradient-to: rgba(182, 228, 209, 0.9) var(--tw-gradient-to-position);
}
.to-jade-200\\/95{
  --tw-gradient-to: rgba(182, 228, 209, 0.95) var(--tw-gradient-to-position);
}
.to-jade-300{
  --tw-gradient-to: #86cfb5 var(--tw-gradient-to-position);
}
.to-jade-300\\/0{
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
}
.to-jade-300\\/10{
  --tw-gradient-to: rgba(134, 207, 181, 0.1) var(--tw-gradient-to-position);
}
.to-jade-300\\/100{
  --tw-gradient-to: rgb(134, 207, 181) var(--tw-gradient-to-position);
}
.to-jade-300\\/15{
  --tw-gradient-to: rgba(134, 207, 181, 0.15) var(--tw-gradient-to-position);
}
.to-jade-300\\/20{
  --tw-gradient-to: rgba(134, 207, 181, 0.2) var(--tw-gradient-to-position);
}
.to-jade-300\\/25{
  --tw-gradient-to: rgba(134, 207, 181, 0.25) var(--tw-gradient-to-position);
}
.to-jade-300\\/30{
  --tw-gradient-to: rgba(134, 207, 181, 0.3) var(--tw-gradient-to-position);
}
.to-jade-300\\/35{
  --tw-gradient-to: rgba(134, 207, 181, 0.35) var(--tw-gradient-to-position);
}
.to-jade-300\\/40{
  --tw-gradient-to: rgba(134, 207, 181, 0.4) var(--tw-gradient-to-position);
}
.to-jade-300\\/45{
  --tw-gradient-to: rgba(134, 207, 181, 0.45) var(--tw-gradient-to-position);
}
.to-jade-300\\/5{
  --tw-gradient-to: rgba(134, 207, 181, 0.05) var(--tw-gradient-to-position);
}
.to-jade-300\\/50{
  --tw-gradient-to: rgba(134, 207, 181, 0.5) var(--tw-gradient-to-position);
}
.to-jade-300\\/55{
  --tw-gradient-to: rgba(134, 207, 181, 0.55) var(--tw-gradient-to-position);
}
.to-jade-300\\/60{
  --tw-gradient-to: rgba(134, 207, 181, 0.6) var(--tw-gradient-to-position);
}
.to-jade-300\\/65{
  --tw-gradient-to: rgba(134, 207, 181, 0.65) var(--tw-gradient-to-position);
}
.to-jade-300\\/70{
  --tw-gradient-to: rgba(134, 207, 181, 0.7) var(--tw-gradient-to-position);
}
.to-jade-300\\/75{
  --tw-gradient-to: rgba(134, 207, 181, 0.75) var(--tw-gradient-to-position);
}
.to-jade-300\\/80{
  --tw-gradient-to: rgba(134, 207, 181, 0.8) var(--tw-gradient-to-position);
}
.to-jade-300\\/85{
  --tw-gradient-to: rgba(134, 207, 181, 0.85) var(--tw-gradient-to-position);
}
.to-jade-300\\/90{
  --tw-gradient-to: rgba(134, 207, 181, 0.9) var(--tw-gradient-to-position);
}
.to-jade-300\\/95{
  --tw-gradient-to: rgba(134, 207, 181, 0.95) var(--tw-gradient-to-position);
}
.to-jade-400{
  --tw-gradient-to: #53b494 var(--tw-gradient-to-position);
}
.to-jade-400\\/0{
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
}
.to-jade-400\\/10{
  --tw-gradient-to: rgba(83, 180, 148, 0.1) var(--tw-gradient-to-position);
}
.to-jade-400\\/100{
  --tw-gradient-to: rgb(83, 180, 148) var(--tw-gradient-to-position);
}
.to-jade-400\\/15{
  --tw-gradient-to: rgba(83, 180, 148, 0.15) var(--tw-gradient-to-position);
}
.to-jade-400\\/20{
  --tw-gradient-to: rgba(83, 180, 148, 0.2) var(--tw-gradient-to-position);
}
.to-jade-400\\/25{
  --tw-gradient-to: rgba(83, 180, 148, 0.25) var(--tw-gradient-to-position);
}
.to-jade-400\\/30{
  --tw-gradient-to: rgba(83, 180, 148, 0.3) var(--tw-gradient-to-position);
}
.to-jade-400\\/35{
  --tw-gradient-to: rgba(83, 180, 148, 0.35) var(--tw-gradient-to-position);
}
.to-jade-400\\/40{
  --tw-gradient-to: rgba(83, 180, 148, 0.4) var(--tw-gradient-to-position);
}
.to-jade-400\\/45{
  --tw-gradient-to: rgba(83, 180, 148, 0.45) var(--tw-gradient-to-position);
}
.to-jade-400\\/5{
  --tw-gradient-to: rgba(83, 180, 148, 0.05) var(--tw-gradient-to-position);
}
.to-jade-400\\/50{
  --tw-gradient-to: rgba(83, 180, 148, 0.5) var(--tw-gradient-to-position);
}
.to-jade-400\\/55{
  --tw-gradient-to: rgba(83, 180, 148, 0.55) var(--tw-gradient-to-position);
}
.to-jade-400\\/60{
  --tw-gradient-to: rgba(83, 180, 148, 0.6) var(--tw-gradient-to-position);
}
.to-jade-400\\/65{
  --tw-gradient-to: rgba(83, 180, 148, 0.65) var(--tw-gradient-to-position);
}
.to-jade-400\\/70{
  --tw-gradient-to: rgba(83, 180, 148, 0.7) var(--tw-gradient-to-position);
}
.to-jade-400\\/75{
  --tw-gradient-to: rgba(83, 180, 148, 0.75) var(--tw-gradient-to-position);
}
.to-jade-400\\/80{
  --tw-gradient-to: rgba(83, 180, 148, 0.8) var(--tw-gradient-to-position);
}
.to-jade-400\\/85{
  --tw-gradient-to: rgba(83, 180, 148, 0.85) var(--tw-gradient-to-position);
}
.to-jade-400\\/90{
  --tw-gradient-to: rgba(83, 180, 148, 0.9) var(--tw-gradient-to-position);
}
.to-jade-400\\/95{
  --tw-gradient-to: rgba(83, 180, 148, 0.95) var(--tw-gradient-to-position);
}
.to-jade-500{
  --tw-gradient-to: #2c876d var(--tw-gradient-to-position);
}
.to-jade-500\\/0{
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
}
.to-jade-500\\/10{
  --tw-gradient-to: rgba(44, 135, 109, 0.1) var(--tw-gradient-to-position);
}
.to-jade-500\\/100{
  --tw-gradient-to: rgb(44, 135, 109) var(--tw-gradient-to-position);
}
.to-jade-500\\/15{
  --tw-gradient-to: rgba(44, 135, 109, 0.15) var(--tw-gradient-to-position);
}
.to-jade-500\\/20{
  --tw-gradient-to: rgba(44, 135, 109, 0.2) var(--tw-gradient-to-position);
}
.to-jade-500\\/25{
  --tw-gradient-to: rgba(44, 135, 109, 0.25) var(--tw-gradient-to-position);
}
.to-jade-500\\/30{
  --tw-gradient-to: rgba(44, 135, 109, 0.3) var(--tw-gradient-to-position);
}
.to-jade-500\\/35{
  --tw-gradient-to: rgba(44, 135, 109, 0.35) var(--tw-gradient-to-position);
}
.to-jade-500\\/40{
  --tw-gradient-to: rgba(44, 135, 109, 0.4) var(--tw-gradient-to-position);
}
.to-jade-500\\/45{
  --tw-gradient-to: rgba(44, 135, 109, 0.45) var(--tw-gradient-to-position);
}
.to-jade-500\\/5{
  --tw-gradient-to: rgba(44, 135, 109, 0.05) var(--tw-gradient-to-position);
}
.to-jade-500\\/50{
  --tw-gradient-to: rgba(44, 135, 109, 0.5) var(--tw-gradient-to-position);
}
.to-jade-500\\/55{
  --tw-gradient-to: rgba(44, 135, 109, 0.55) var(--tw-gradient-to-position);
}
.to-jade-500\\/60{
  --tw-gradient-to: rgba(44, 135, 109, 0.6) var(--tw-gradient-to-position);
}
.to-jade-500\\/65{
  --tw-gradient-to: rgba(44, 135, 109, 0.65) var(--tw-gradient-to-position);
}
.to-jade-500\\/70{
  --tw-gradient-to: rgba(44, 135, 109, 0.7) var(--tw-gradient-to-position);
}
.to-jade-500\\/75{
  --tw-gradient-to: rgba(44, 135, 109, 0.75) var(--tw-gradient-to-position);
}
.to-jade-500\\/80{
  --tw-gradient-to: rgba(44, 135, 109, 0.8) var(--tw-gradient-to-position);
}
.to-jade-500\\/85{
  --tw-gradient-to: rgba(44, 135, 109, 0.85) var(--tw-gradient-to-position);
}
.to-jade-500\\/90{
  --tw-gradient-to: rgba(44, 135, 109, 0.9) var(--tw-gradient-to-position);
}
.to-jade-500\\/95{
  --tw-gradient-to: rgba(44, 135, 109, 0.95) var(--tw-gradient-to-position);
}
.to-jade-600{
  --tw-gradient-to: #227962 var(--tw-gradient-to-position);
}
.to-jade-600\\/0{
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
}
.to-jade-600\\/10{
  --tw-gradient-to: rgba(34, 121, 98, 0.1) var(--tw-gradient-to-position);
}
.to-jade-600\\/100{
  --tw-gradient-to: rgb(34, 121, 98) var(--tw-gradient-to-position);
}
.to-jade-600\\/15{
  --tw-gradient-to: rgba(34, 121, 98, 0.15) var(--tw-gradient-to-position);
}
.to-jade-600\\/20{
  --tw-gradient-to: rgba(34, 121, 98, 0.2) var(--tw-gradient-to-position);
}
.to-jade-600\\/25{
  --tw-gradient-to: rgba(34, 121, 98, 0.25) var(--tw-gradient-to-position);
}
.to-jade-600\\/30{
  --tw-gradient-to: rgba(34, 121, 98, 0.3) var(--tw-gradient-to-position);
}
.to-jade-600\\/35{
  --tw-gradient-to: rgba(34, 121, 98, 0.35) var(--tw-gradient-to-position);
}
.to-jade-600\\/40{
  --tw-gradient-to: rgba(34, 121, 98, 0.4) var(--tw-gradient-to-position);
}
.to-jade-600\\/45{
  --tw-gradient-to: rgba(34, 121, 98, 0.45) var(--tw-gradient-to-position);
}
.to-jade-600\\/5{
  --tw-gradient-to: rgba(34, 121, 98, 0.05) var(--tw-gradient-to-position);
}
.to-jade-600\\/50{
  --tw-gradient-to: rgba(34, 121, 98, 0.5) var(--tw-gradient-to-position);
}
.to-jade-600\\/55{
  --tw-gradient-to: rgba(34, 121, 98, 0.55) var(--tw-gradient-to-position);
}
.to-jade-600\\/60{
  --tw-gradient-to: rgba(34, 121, 98, 0.6) var(--tw-gradient-to-position);
}
.to-jade-600\\/65{
  --tw-gradient-to: rgba(34, 121, 98, 0.65) var(--tw-gradient-to-position);
}
.to-jade-600\\/70{
  --tw-gradient-to: rgba(34, 121, 98, 0.7) var(--tw-gradient-to-position);
}
.to-jade-600\\/75{
  --tw-gradient-to: rgba(34, 121, 98, 0.75) var(--tw-gradient-to-position);
}
.to-jade-600\\/80{
  --tw-gradient-to: rgba(34, 121, 98, 0.8) var(--tw-gradient-to-position);
}
.to-jade-600\\/85{
  --tw-gradient-to: rgba(34, 121, 98, 0.85) var(--tw-gradient-to-position);
}
.to-jade-600\\/90{
  --tw-gradient-to: rgba(34, 121, 98, 0.9) var(--tw-gradient-to-position);
}
.to-jade-600\\/95{
  --tw-gradient-to: rgba(34, 121, 98, 0.95) var(--tw-gradient-to-position);
}
.to-jade-700{
  --tw-gradient-to: #1b6150 var(--tw-gradient-to-position);
}
.to-jade-700\\/0{
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
}
.to-jade-700\\/10{
  --tw-gradient-to: rgba(27, 97, 80, 0.1) var(--tw-gradient-to-position);
}
.to-jade-700\\/100{
  --tw-gradient-to: rgb(27, 97, 80) var(--tw-gradient-to-position);
}
.to-jade-700\\/15{
  --tw-gradient-to: rgba(27, 97, 80, 0.15) var(--tw-gradient-to-position);
}
.to-jade-700\\/20{
  --tw-gradient-to: rgba(27, 97, 80, 0.2) var(--tw-gradient-to-position);
}
.to-jade-700\\/25{
  --tw-gradient-to: rgba(27, 97, 80, 0.25) var(--tw-gradient-to-position);
}
.to-jade-700\\/30{
  --tw-gradient-to: rgba(27, 97, 80, 0.3) var(--tw-gradient-to-position);
}
.to-jade-700\\/35{
  --tw-gradient-to: rgba(27, 97, 80, 0.35) var(--tw-gradient-to-position);
}
.to-jade-700\\/40{
  --tw-gradient-to: rgba(27, 97, 80, 0.4) var(--tw-gradient-to-position);
}
.to-jade-700\\/45{
  --tw-gradient-to: rgba(27, 97, 80, 0.45) var(--tw-gradient-to-position);
}
.to-jade-700\\/5{
  --tw-gradient-to: rgba(27, 97, 80, 0.05) var(--tw-gradient-to-position);
}
.to-jade-700\\/50{
  --tw-gradient-to: rgba(27, 97, 80, 0.5) var(--tw-gradient-to-position);
}
.to-jade-700\\/55{
  --tw-gradient-to: rgba(27, 97, 80, 0.55) var(--tw-gradient-to-position);
}
.to-jade-700\\/60{
  --tw-gradient-to: rgba(27, 97, 80, 0.6) var(--tw-gradient-to-position);
}
.to-jade-700\\/65{
  --tw-gradient-to: rgba(27, 97, 80, 0.65) var(--tw-gradient-to-position);
}
.to-jade-700\\/70{
  --tw-gradient-to: rgba(27, 97, 80, 0.7) var(--tw-gradient-to-position);
}
.to-jade-700\\/75{
  --tw-gradient-to: rgba(27, 97, 80, 0.75) var(--tw-gradient-to-position);
}
.to-jade-700\\/80{
  --tw-gradient-to: rgba(27, 97, 80, 0.8) var(--tw-gradient-to-position);
}
.to-jade-700\\/85{
  --tw-gradient-to: rgba(27, 97, 80, 0.85) var(--tw-gradient-to-position);
}
.to-jade-700\\/90{
  --tw-gradient-to: rgba(27, 97, 80, 0.9) var(--tw-gradient-to-position);
}
.to-jade-700\\/95{
  --tw-gradient-to: rgba(27, 97, 80, 0.95) var(--tw-gradient-to-position);
}
.to-jade-800{
  --tw-gradient-to: #184d40 var(--tw-gradient-to-position);
}
.to-jade-800\\/0{
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
}
.to-jade-800\\/10{
  --tw-gradient-to: rgba(24, 77, 64, 0.1) var(--tw-gradient-to-position);
}
.to-jade-800\\/100{
  --tw-gradient-to: rgb(24, 77, 64) var(--tw-gradient-to-position);
}
.to-jade-800\\/15{
  --tw-gradient-to: rgba(24, 77, 64, 0.15) var(--tw-gradient-to-position);
}
.to-jade-800\\/20{
  --tw-gradient-to: rgba(24, 77, 64, 0.2) var(--tw-gradient-to-position);
}
.to-jade-800\\/25{
  --tw-gradient-to: rgba(24, 77, 64, 0.25) var(--tw-gradient-to-position);
}
.to-jade-800\\/30{
  --tw-gradient-to: rgba(24, 77, 64, 0.3) var(--tw-gradient-to-position);
}
.to-jade-800\\/35{
  --tw-gradient-to: rgba(24, 77, 64, 0.35) var(--tw-gradient-to-position);
}
.to-jade-800\\/40{
  --tw-gradient-to: rgba(24, 77, 64, 0.4) var(--tw-gradient-to-position);
}
.to-jade-800\\/45{
  --tw-gradient-to: rgba(24, 77, 64, 0.45) var(--tw-gradient-to-position);
}
.to-jade-800\\/5{
  --tw-gradient-to: rgba(24, 77, 64, 0.05) var(--tw-gradient-to-position);
}
.to-jade-800\\/50{
  --tw-gradient-to: rgba(24, 77, 64, 0.5) var(--tw-gradient-to-position);
}
.to-jade-800\\/55{
  --tw-gradient-to: rgba(24, 77, 64, 0.55) var(--tw-gradient-to-position);
}
.to-jade-800\\/60{
  --tw-gradient-to: rgba(24, 77, 64, 0.6) var(--tw-gradient-to-position);
}
.to-jade-800\\/65{
  --tw-gradient-to: rgba(24, 77, 64, 0.65) var(--tw-gradient-to-position);
}
.to-jade-800\\/70{
  --tw-gradient-to: rgba(24, 77, 64, 0.7) var(--tw-gradient-to-position);
}
.to-jade-800\\/75{
  --tw-gradient-to: rgba(24, 77, 64, 0.75) var(--tw-gradient-to-position);
}
.to-jade-800\\/80{
  --tw-gradient-to: rgba(24, 77, 64, 0.8) var(--tw-gradient-to-position);
}
.to-jade-800\\/85{
  --tw-gradient-to: rgba(24, 77, 64, 0.85) var(--tw-gradient-to-position);
}
.to-jade-800\\/90{
  --tw-gradient-to: rgba(24, 77, 64, 0.9) var(--tw-gradient-to-position);
}
.to-jade-800\\/95{
  --tw-gradient-to: rgba(24, 77, 64, 0.95) var(--tw-gradient-to-position);
}
.to-jade-900{
  --tw-gradient-to: #144036 var(--tw-gradient-to-position);
}
.to-jade-900\\/0{
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
}
.to-jade-900\\/10{
  --tw-gradient-to: rgba(20, 64, 54, 0.1) var(--tw-gradient-to-position);
}
.to-jade-900\\/100{
  --tw-gradient-to: rgb(20, 64, 54) var(--tw-gradient-to-position);
}
.to-jade-900\\/15{
  --tw-gradient-to: rgba(20, 64, 54, 0.15) var(--tw-gradient-to-position);
}
.to-jade-900\\/20{
  --tw-gradient-to: rgba(20, 64, 54, 0.2) var(--tw-gradient-to-position);
}
.to-jade-900\\/25{
  --tw-gradient-to: rgba(20, 64, 54, 0.25) var(--tw-gradient-to-position);
}
.to-jade-900\\/30{
  --tw-gradient-to: rgba(20, 64, 54, 0.3) var(--tw-gradient-to-position);
}
.to-jade-900\\/35{
  --tw-gradient-to: rgba(20, 64, 54, 0.35) var(--tw-gradient-to-position);
}
.to-jade-900\\/40{
  --tw-gradient-to: rgba(20, 64, 54, 0.4) var(--tw-gradient-to-position);
}
.to-jade-900\\/45{
  --tw-gradient-to: rgba(20, 64, 54, 0.45) var(--tw-gradient-to-position);
}
.to-jade-900\\/5{
  --tw-gradient-to: rgba(20, 64, 54, 0.05) var(--tw-gradient-to-position);
}
.to-jade-900\\/50{
  --tw-gradient-to: rgba(20, 64, 54, 0.5) var(--tw-gradient-to-position);
}
.to-jade-900\\/55{
  --tw-gradient-to: rgba(20, 64, 54, 0.55) var(--tw-gradient-to-position);
}
.to-jade-900\\/60{
  --tw-gradient-to: rgba(20, 64, 54, 0.6) var(--tw-gradient-to-position);
}
.to-jade-900\\/65{
  --tw-gradient-to: rgba(20, 64, 54, 0.65) var(--tw-gradient-to-position);
}
.to-jade-900\\/70{
  --tw-gradient-to: rgba(20, 64, 54, 0.7) var(--tw-gradient-to-position);
}
.to-jade-900\\/75{
  --tw-gradient-to: rgba(20, 64, 54, 0.75) var(--tw-gradient-to-position);
}
.to-jade-900\\/80{
  --tw-gradient-to: rgba(20, 64, 54, 0.8) var(--tw-gradient-to-position);
}
.to-jade-900\\/85{
  --tw-gradient-to: rgba(20, 64, 54, 0.85) var(--tw-gradient-to-position);
}
.to-jade-900\\/90{
  --tw-gradient-to: rgba(20, 64, 54, 0.9) var(--tw-gradient-to-position);
}
.to-jade-900\\/95{
  --tw-gradient-to: rgba(20, 64, 54, 0.95) var(--tw-gradient-to-position);
}
.to-jade-950{
  --tw-gradient-to: #0a241f var(--tw-gradient-to-position);
}
.to-jade-950\\/0{
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
}
.to-jade-950\\/10{
  --tw-gradient-to: rgba(10, 36, 31, 0.1) var(--tw-gradient-to-position);
}
.to-jade-950\\/100{
  --tw-gradient-to: rgb(10, 36, 31) var(--tw-gradient-to-position);
}
.to-jade-950\\/15{
  --tw-gradient-to: rgba(10, 36, 31, 0.15) var(--tw-gradient-to-position);
}
.to-jade-950\\/20{
  --tw-gradient-to: rgba(10, 36, 31, 0.2) var(--tw-gradient-to-position);
}
.to-jade-950\\/25{
  --tw-gradient-to: rgba(10, 36, 31, 0.25) var(--tw-gradient-to-position);
}
.to-jade-950\\/30{
  --tw-gradient-to: rgba(10, 36, 31, 0.3) var(--tw-gradient-to-position);
}
.to-jade-950\\/35{
  --tw-gradient-to: rgba(10, 36, 31, 0.35) var(--tw-gradient-to-position);
}
.to-jade-950\\/40{
  --tw-gradient-to: rgba(10, 36, 31, 0.4) var(--tw-gradient-to-position);
}
.to-jade-950\\/45{
  --tw-gradient-to: rgba(10, 36, 31, 0.45) var(--tw-gradient-to-position);
}
.to-jade-950\\/5{
  --tw-gradient-to: rgba(10, 36, 31, 0.05) var(--tw-gradient-to-position);
}
.to-jade-950\\/50{
  --tw-gradient-to: rgba(10, 36, 31, 0.5) var(--tw-gradient-to-position);
}
.to-jade-950\\/55{
  --tw-gradient-to: rgba(10, 36, 31, 0.55) var(--tw-gradient-to-position);
}
.to-jade-950\\/60{
  --tw-gradient-to: rgba(10, 36, 31, 0.6) var(--tw-gradient-to-position);
}
.to-jade-950\\/65{
  --tw-gradient-to: rgba(10, 36, 31, 0.65) var(--tw-gradient-to-position);
}
.to-jade-950\\/70{
  --tw-gradient-to: rgba(10, 36, 31, 0.7) var(--tw-gradient-to-position);
}
.to-jade-950\\/75{
  --tw-gradient-to: rgba(10, 36, 31, 0.75) var(--tw-gradient-to-position);
}
.to-jade-950\\/80{
  --tw-gradient-to: rgba(10, 36, 31, 0.8) var(--tw-gradient-to-position);
}
.to-jade-950\\/85{
  --tw-gradient-to: rgba(10, 36, 31, 0.85) var(--tw-gradient-to-position);
}
.to-jade-950\\/90{
  --tw-gradient-to: rgba(10, 36, 31, 0.9) var(--tw-gradient-to-position);
}
.to-jade-950\\/95{
  --tw-gradient-to: rgba(10, 36, 31, 0.95) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500{
  --tw-gradient-to: #3787a3 var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/0{
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/10{
  --tw-gradient-to: rgba(55, 135, 163, 0.1) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/100{
  --tw-gradient-to: rgb(55, 135, 163) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/15{
  --tw-gradient-to: rgba(55, 135, 163, 0.15) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/20{
  --tw-gradient-to: rgba(55, 135, 163, 0.2) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/25{
  --tw-gradient-to: rgba(55, 135, 163, 0.25) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/30{
  --tw-gradient-to: rgba(55, 135, 163, 0.3) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/35{
  --tw-gradient-to: rgba(55, 135, 163, 0.35) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/40{
  --tw-gradient-to: rgba(55, 135, 163, 0.4) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/45{
  --tw-gradient-to: rgba(55, 135, 163, 0.45) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/5{
  --tw-gradient-to: rgba(55, 135, 163, 0.05) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/50{
  --tw-gradient-to: rgba(55, 135, 163, 0.5) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/55{
  --tw-gradient-to: rgba(55, 135, 163, 0.55) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/60{
  --tw-gradient-to: rgba(55, 135, 163, 0.6) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/65{
  --tw-gradient-to: rgba(55, 135, 163, 0.65) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/70{
  --tw-gradient-to: rgba(55, 135, 163, 0.7) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/75{
  --tw-gradient-to: rgba(55, 135, 163, 0.75) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/80{
  --tw-gradient-to: rgba(55, 135, 163, 0.8) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/85{
  --tw-gradient-to: rgba(55, 135, 163, 0.85) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/90{
  --tw-gradient-to: rgba(55, 135, 163, 0.9) var(--tw-gradient-to-position);
}
.to-kids-alphabet-500\\/95{
  --tw-gradient-to: rgba(55, 135, 163, 0.95) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600{
  --tw-gradient-to: #306d8a var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/0{
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/10{
  --tw-gradient-to: rgba(48, 109, 138, 0.1) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/100{
  --tw-gradient-to: rgb(48, 109, 138) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/15{
  --tw-gradient-to: rgba(48, 109, 138, 0.15) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/20{
  --tw-gradient-to: rgba(48, 109, 138, 0.2) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/25{
  --tw-gradient-to: rgba(48, 109, 138, 0.25) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/30{
  --tw-gradient-to: rgba(48, 109, 138, 0.3) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/35{
  --tw-gradient-to: rgba(48, 109, 138, 0.35) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/40{
  --tw-gradient-to: rgba(48, 109, 138, 0.4) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/45{
  --tw-gradient-to: rgba(48, 109, 138, 0.45) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/5{
  --tw-gradient-to: rgba(48, 109, 138, 0.05) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/50{
  --tw-gradient-to: rgba(48, 109, 138, 0.5) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/55{
  --tw-gradient-to: rgba(48, 109, 138, 0.55) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/60{
  --tw-gradient-to: rgba(48, 109, 138, 0.6) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/65{
  --tw-gradient-to: rgba(48, 109, 138, 0.65) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/70{
  --tw-gradient-to: rgba(48, 109, 138, 0.7) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/75{
  --tw-gradient-to: rgba(48, 109, 138, 0.75) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/80{
  --tw-gradient-to: rgba(48, 109, 138, 0.8) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/85{
  --tw-gradient-to: rgba(48, 109, 138, 0.85) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/90{
  --tw-gradient-to: rgba(48, 109, 138, 0.9) var(--tw-gradient-to-position);
}
.to-kids-alphabet-600\\/95{
  --tw-gradient-to: rgba(48, 109, 138, 0.95) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700{
  --tw-gradient-to: #2d5b72 var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/0{
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/10{
  --tw-gradient-to: rgba(45, 91, 114, 0.1) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/100{
  --tw-gradient-to: rgb(45, 91, 114) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/15{
  --tw-gradient-to: rgba(45, 91, 114, 0.15) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/20{
  --tw-gradient-to: rgba(45, 91, 114, 0.2) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/25{
  --tw-gradient-to: rgba(45, 91, 114, 0.25) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/30{
  --tw-gradient-to: rgba(45, 91, 114, 0.3) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/35{
  --tw-gradient-to: rgba(45, 91, 114, 0.35) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/40{
  --tw-gradient-to: rgba(45, 91, 114, 0.4) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/45{
  --tw-gradient-to: rgba(45, 91, 114, 0.45) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/5{
  --tw-gradient-to: rgba(45, 91, 114, 0.05) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/50{
  --tw-gradient-to: rgba(45, 91, 114, 0.5) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/55{
  --tw-gradient-to: rgba(45, 91, 114, 0.55) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/60{
  --tw-gradient-to: rgba(45, 91, 114, 0.6) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/65{
  --tw-gradient-to: rgba(45, 91, 114, 0.65) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/70{
  --tw-gradient-to: rgba(45, 91, 114, 0.7) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/75{
  --tw-gradient-to: rgba(45, 91, 114, 0.75) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/80{
  --tw-gradient-to: rgba(45, 91, 114, 0.8) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/85{
  --tw-gradient-to: rgba(45, 91, 114, 0.85) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/90{
  --tw-gradient-to: rgba(45, 91, 114, 0.9) var(--tw-gradient-to-position);
}
.to-kids-alphabet-700\\/95{
  --tw-gradient-to: rgba(45, 91, 114, 0.95) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800{
  --tw-gradient-to: #2c4c5e var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/0{
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/10{
  --tw-gradient-to: rgba(44, 76, 94, 0.1) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/100{
  --tw-gradient-to: rgb(44, 76, 94) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/15{
  --tw-gradient-to: rgba(44, 76, 94, 0.15) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/20{
  --tw-gradient-to: rgba(44, 76, 94, 0.2) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/25{
  --tw-gradient-to: rgba(44, 76, 94, 0.25) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/30{
  --tw-gradient-to: rgba(44, 76, 94, 0.3) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/35{
  --tw-gradient-to: rgba(44, 76, 94, 0.35) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/40{
  --tw-gradient-to: rgba(44, 76, 94, 0.4) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/45{
  --tw-gradient-to: rgba(44, 76, 94, 0.45) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/5{
  --tw-gradient-to: rgba(44, 76, 94, 0.05) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/50{
  --tw-gradient-to: rgba(44, 76, 94, 0.5) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/55{
  --tw-gradient-to: rgba(44, 76, 94, 0.55) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/60{
  --tw-gradient-to: rgba(44, 76, 94, 0.6) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/65{
  --tw-gradient-to: rgba(44, 76, 94, 0.65) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/70{
  --tw-gradient-to: rgba(44, 76, 94, 0.7) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/75{
  --tw-gradient-to: rgba(44, 76, 94, 0.75) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/80{
  --tw-gradient-to: rgba(44, 76, 94, 0.8) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/85{
  --tw-gradient-to: rgba(44, 76, 94, 0.85) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/90{
  --tw-gradient-to: rgba(44, 76, 94, 0.9) var(--tw-gradient-to-position);
}
.to-kids-alphabet-800\\/95{
  --tw-gradient-to: rgba(44, 76, 94, 0.95) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900{
  --tw-gradient-to: #284151 var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/0{
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/10{
  --tw-gradient-to: rgba(40, 65, 81, 0.1) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/100{
  --tw-gradient-to: rgb(40, 65, 81) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/15{
  --tw-gradient-to: rgba(40, 65, 81, 0.15) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/20{
  --tw-gradient-to: rgba(40, 65, 81, 0.2) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/25{
  --tw-gradient-to: rgba(40, 65, 81, 0.25) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/30{
  --tw-gradient-to: rgba(40, 65, 81, 0.3) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/35{
  --tw-gradient-to: rgba(40, 65, 81, 0.35) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/40{
  --tw-gradient-to: rgba(40, 65, 81, 0.4) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/45{
  --tw-gradient-to: rgba(40, 65, 81, 0.45) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/5{
  --tw-gradient-to: rgba(40, 65, 81, 0.05) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/50{
  --tw-gradient-to: rgba(40, 65, 81, 0.5) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/55{
  --tw-gradient-to: rgba(40, 65, 81, 0.55) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/60{
  --tw-gradient-to: rgba(40, 65, 81, 0.6) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/65{
  --tw-gradient-to: rgba(40, 65, 81, 0.65) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/70{
  --tw-gradient-to: rgba(40, 65, 81, 0.7) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/75{
  --tw-gradient-to: rgba(40, 65, 81, 0.75) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/80{
  --tw-gradient-to: rgba(40, 65, 81, 0.8) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/85{
  --tw-gradient-to: rgba(40, 65, 81, 0.85) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/90{
  --tw-gradient-to: rgba(40, 65, 81, 0.9) var(--tw-gradient-to-position);
}
.to-kids-alphabet-900\\/95{
  --tw-gradient-to: rgba(40, 65, 81, 0.95) var(--tw-gradient-to-position);
}
.to-kids-categories-500{
  --tw-gradient-to: #d1912f var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/0{
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/10{
  --tw-gradient-to: rgba(209, 145, 47, 0.1) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/100{
  --tw-gradient-to: rgb(209, 145, 47) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/15{
  --tw-gradient-to: rgba(209, 145, 47, 0.15) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/20{
  --tw-gradient-to: rgba(209, 145, 47, 0.2) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/25{
  --tw-gradient-to: rgba(209, 145, 47, 0.25) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/30{
  --tw-gradient-to: rgba(209, 145, 47, 0.3) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/35{
  --tw-gradient-to: rgba(209, 145, 47, 0.35) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/40{
  --tw-gradient-to: rgba(209, 145, 47, 0.4) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/45{
  --tw-gradient-to: rgba(209, 145, 47, 0.45) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/5{
  --tw-gradient-to: rgba(209, 145, 47, 0.05) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/50{
  --tw-gradient-to: rgba(209, 145, 47, 0.5) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/55{
  --tw-gradient-to: rgba(209, 145, 47, 0.55) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/60{
  --tw-gradient-to: rgba(209, 145, 47, 0.6) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/65{
  --tw-gradient-to: rgba(209, 145, 47, 0.65) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/70{
  --tw-gradient-to: rgba(209, 145, 47, 0.7) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/75{
  --tw-gradient-to: rgba(209, 145, 47, 0.75) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/80{
  --tw-gradient-to: rgba(209, 145, 47, 0.8) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/85{
  --tw-gradient-to: rgba(209, 145, 47, 0.85) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/90{
  --tw-gradient-to: rgba(209, 145, 47, 0.9) var(--tw-gradient-to-position);
}
.to-kids-categories-500\\/95{
  --tw-gradient-to: rgba(209, 145, 47, 0.95) var(--tw-gradient-to-position);
}
.to-kids-categories-600{
  --tw-gradient-to: #c37829 var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/0{
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/10{
  --tw-gradient-to: rgba(195, 120, 41, 0.1) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/100{
  --tw-gradient-to: rgb(195, 120, 41) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/15{
  --tw-gradient-to: rgba(195, 120, 41, 0.15) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/20{
  --tw-gradient-to: rgba(195, 120, 41, 0.2) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/25{
  --tw-gradient-to: rgba(195, 120, 41, 0.25) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/30{
  --tw-gradient-to: rgba(195, 120, 41, 0.3) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/35{
  --tw-gradient-to: rgba(195, 120, 41, 0.35) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/40{
  --tw-gradient-to: rgba(195, 120, 41, 0.4) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/45{
  --tw-gradient-to: rgba(195, 120, 41, 0.45) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/5{
  --tw-gradient-to: rgba(195, 120, 41, 0.05) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/50{
  --tw-gradient-to: rgba(195, 120, 41, 0.5) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/55{
  --tw-gradient-to: rgba(195, 120, 41, 0.55) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/60{
  --tw-gradient-to: rgba(195, 120, 41, 0.6) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/65{
  --tw-gradient-to: rgba(195, 120, 41, 0.65) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/70{
  --tw-gradient-to: rgba(195, 120, 41, 0.7) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/75{
  --tw-gradient-to: rgba(195, 120, 41, 0.75) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/80{
  --tw-gradient-to: rgba(195, 120, 41, 0.8) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/85{
  --tw-gradient-to: rgba(195, 120, 41, 0.85) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/90{
  --tw-gradient-to: rgba(195, 120, 41, 0.9) var(--tw-gradient-to-position);
}
.to-kids-categories-600\\/95{
  --tw-gradient-to: rgba(195, 120, 41, 0.95) var(--tw-gradient-to-position);
}
.to-kids-categories-700{
  --tw-gradient-to: #995424 var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/0{
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/10{
  --tw-gradient-to: rgba(153, 84, 36, 0.1) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/100{
  --tw-gradient-to: rgb(153, 84, 36) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/15{
  --tw-gradient-to: rgba(153, 84, 36, 0.15) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/20{
  --tw-gradient-to: rgba(153, 84, 36, 0.2) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/25{
  --tw-gradient-to: rgba(153, 84, 36, 0.25) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/30{
  --tw-gradient-to: rgba(153, 84, 36, 0.3) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/35{
  --tw-gradient-to: rgba(153, 84, 36, 0.35) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/40{
  --tw-gradient-to: rgba(153, 84, 36, 0.4) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/45{
  --tw-gradient-to: rgba(153, 84, 36, 0.45) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/5{
  --tw-gradient-to: rgba(153, 84, 36, 0.05) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/50{
  --tw-gradient-to: rgba(153, 84, 36, 0.5) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/55{
  --tw-gradient-to: rgba(153, 84, 36, 0.55) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/60{
  --tw-gradient-to: rgba(153, 84, 36, 0.6) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/65{
  --tw-gradient-to: rgba(153, 84, 36, 0.65) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/70{
  --tw-gradient-to: rgba(153, 84, 36, 0.7) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/75{
  --tw-gradient-to: rgba(153, 84, 36, 0.75) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/80{
  --tw-gradient-to: rgba(153, 84, 36, 0.8) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/85{
  --tw-gradient-to: rgba(153, 84, 36, 0.85) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/90{
  --tw-gradient-to: rgba(153, 84, 36, 0.9) var(--tw-gradient-to-position);
}
.to-kids-categories-700\\/95{
  --tw-gradient-to: rgba(153, 84, 36, 0.95) var(--tw-gradient-to-position);
}
.to-kids-categories-800{
  --tw-gradient-to: #7e4322 var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/0{
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/10{
  --tw-gradient-to: rgba(126, 67, 34, 0.1) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/100{
  --tw-gradient-to: rgb(126, 67, 34) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/15{
  --tw-gradient-to: rgba(126, 67, 34, 0.15) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/20{
  --tw-gradient-to: rgba(126, 67, 34, 0.2) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/25{
  --tw-gradient-to: rgba(126, 67, 34, 0.25) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/30{
  --tw-gradient-to: rgba(126, 67, 34, 0.3) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/35{
  --tw-gradient-to: rgba(126, 67, 34, 0.35) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/40{
  --tw-gradient-to: rgba(126, 67, 34, 0.4) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/45{
  --tw-gradient-to: rgba(126, 67, 34, 0.45) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/5{
  --tw-gradient-to: rgba(126, 67, 34, 0.05) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/50{
  --tw-gradient-to: rgba(126, 67, 34, 0.5) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/55{
  --tw-gradient-to: rgba(126, 67, 34, 0.55) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/60{
  --tw-gradient-to: rgba(126, 67, 34, 0.6) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/65{
  --tw-gradient-to: rgba(126, 67, 34, 0.65) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/70{
  --tw-gradient-to: rgba(126, 67, 34, 0.7) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/75{
  --tw-gradient-to: rgba(126, 67, 34, 0.75) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/80{
  --tw-gradient-to: rgba(126, 67, 34, 0.8) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/85{
  --tw-gradient-to: rgba(126, 67, 34, 0.85) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/90{
  --tw-gradient-to: rgba(126, 67, 34, 0.9) var(--tw-gradient-to-position);
}
.to-kids-categories-800\\/95{
  --tw-gradient-to: rgba(126, 67, 34, 0.95) var(--tw-gradient-to-position);
}
.to-kids-categories-900{
  --tw-gradient-to: #68381f var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/0{
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/10{
  --tw-gradient-to: rgba(104, 56, 31, 0.1) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/100{
  --tw-gradient-to: rgb(104, 56, 31) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/15{
  --tw-gradient-to: rgba(104, 56, 31, 0.15) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/20{
  --tw-gradient-to: rgba(104, 56, 31, 0.2) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/25{
  --tw-gradient-to: rgba(104, 56, 31, 0.25) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/30{
  --tw-gradient-to: rgba(104, 56, 31, 0.3) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/35{
  --tw-gradient-to: rgba(104, 56, 31, 0.35) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/40{
  --tw-gradient-to: rgba(104, 56, 31, 0.4) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/45{
  --tw-gradient-to: rgba(104, 56, 31, 0.45) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/5{
  --tw-gradient-to: rgba(104, 56, 31, 0.05) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/50{
  --tw-gradient-to: rgba(104, 56, 31, 0.5) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/55{
  --tw-gradient-to: rgba(104, 56, 31, 0.55) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/60{
  --tw-gradient-to: rgba(104, 56, 31, 0.6) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/65{
  --tw-gradient-to: rgba(104, 56, 31, 0.65) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/70{
  --tw-gradient-to: rgba(104, 56, 31, 0.7) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/75{
  --tw-gradient-to: rgba(104, 56, 31, 0.75) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/80{
  --tw-gradient-to: rgba(104, 56, 31, 0.8) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/85{
  --tw-gradient-to: rgba(104, 56, 31, 0.85) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/90{
  --tw-gradient-to: rgba(104, 56, 31, 0.9) var(--tw-gradient-to-position);
}
.to-kids-categories-900\\/95{
  --tw-gradient-to: rgba(104, 56, 31, 0.95) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500{
  --tw-gradient-to: #2c876d var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/0{
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/10{
  --tw-gradient-to: rgba(44, 135, 109, 0.1) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/100{
  --tw-gradient-to: rgb(44, 135, 109) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/15{
  --tw-gradient-to: rgba(44, 135, 109, 0.15) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/20{
  --tw-gradient-to: rgba(44, 135, 109, 0.2) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/25{
  --tw-gradient-to: rgba(44, 135, 109, 0.25) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/30{
  --tw-gradient-to: rgba(44, 135, 109, 0.3) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/35{
  --tw-gradient-to: rgba(44, 135, 109, 0.35) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/40{
  --tw-gradient-to: rgba(44, 135, 109, 0.4) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/45{
  --tw-gradient-to: rgba(44, 135, 109, 0.45) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/5{
  --tw-gradient-to: rgba(44, 135, 109, 0.05) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/50{
  --tw-gradient-to: rgba(44, 135, 109, 0.5) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/55{
  --tw-gradient-to: rgba(44, 135, 109, 0.55) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/60{
  --tw-gradient-to: rgba(44, 135, 109, 0.6) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/65{
  --tw-gradient-to: rgba(44, 135, 109, 0.65) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/70{
  --tw-gradient-to: rgba(44, 135, 109, 0.7) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/75{
  --tw-gradient-to: rgba(44, 135, 109, 0.75) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/80{
  --tw-gradient-to: rgba(44, 135, 109, 0.8) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/85{
  --tw-gradient-to: rgba(44, 135, 109, 0.85) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/90{
  --tw-gradient-to: rgba(44, 135, 109, 0.9) var(--tw-gradient-to-position);
}
.to-kids-dictionary-500\\/95{
  --tw-gradient-to: rgba(44, 135, 109, 0.95) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600{
  --tw-gradient-to: #227962 var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/0{
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/10{
  --tw-gradient-to: rgba(34, 121, 98, 0.1) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/100{
  --tw-gradient-to: rgb(34, 121, 98) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/15{
  --tw-gradient-to: rgba(34, 121, 98, 0.15) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/20{
  --tw-gradient-to: rgba(34, 121, 98, 0.2) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/25{
  --tw-gradient-to: rgba(34, 121, 98, 0.25) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/30{
  --tw-gradient-to: rgba(34, 121, 98, 0.3) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/35{
  --tw-gradient-to: rgba(34, 121, 98, 0.35) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/40{
  --tw-gradient-to: rgba(34, 121, 98, 0.4) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/45{
  --tw-gradient-to: rgba(34, 121, 98, 0.45) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/5{
  --tw-gradient-to: rgba(34, 121, 98, 0.05) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/50{
  --tw-gradient-to: rgba(34, 121, 98, 0.5) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/55{
  --tw-gradient-to: rgba(34, 121, 98, 0.55) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/60{
  --tw-gradient-to: rgba(34, 121, 98, 0.6) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/65{
  --tw-gradient-to: rgba(34, 121, 98, 0.65) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/70{
  --tw-gradient-to: rgba(34, 121, 98, 0.7) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/75{
  --tw-gradient-to: rgba(34, 121, 98, 0.75) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/80{
  --tw-gradient-to: rgba(34, 121, 98, 0.8) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/85{
  --tw-gradient-to: rgba(34, 121, 98, 0.85) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/90{
  --tw-gradient-to: rgba(34, 121, 98, 0.9) var(--tw-gradient-to-position);
}
.to-kids-dictionary-600\\/95{
  --tw-gradient-to: rgba(34, 121, 98, 0.95) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700{
  --tw-gradient-to: #1b6150 var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/0{
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/10{
  --tw-gradient-to: rgba(27, 97, 80, 0.1) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/100{
  --tw-gradient-to: rgb(27, 97, 80) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/15{
  --tw-gradient-to: rgba(27, 97, 80, 0.15) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/20{
  --tw-gradient-to: rgba(27, 97, 80, 0.2) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/25{
  --tw-gradient-to: rgba(27, 97, 80, 0.25) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/30{
  --tw-gradient-to: rgba(27, 97, 80, 0.3) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/35{
  --tw-gradient-to: rgba(27, 97, 80, 0.35) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/40{
  --tw-gradient-to: rgba(27, 97, 80, 0.4) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/45{
  --tw-gradient-to: rgba(27, 97, 80, 0.45) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/5{
  --tw-gradient-to: rgba(27, 97, 80, 0.05) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/50{
  --tw-gradient-to: rgba(27, 97, 80, 0.5) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/55{
  --tw-gradient-to: rgba(27, 97, 80, 0.55) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/60{
  --tw-gradient-to: rgba(27, 97, 80, 0.6) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/65{
  --tw-gradient-to: rgba(27, 97, 80, 0.65) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/70{
  --tw-gradient-to: rgba(27, 97, 80, 0.7) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/75{
  --tw-gradient-to: rgba(27, 97, 80, 0.75) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/80{
  --tw-gradient-to: rgba(27, 97, 80, 0.8) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/85{
  --tw-gradient-to: rgba(27, 97, 80, 0.85) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/90{
  --tw-gradient-to: rgba(27, 97, 80, 0.9) var(--tw-gradient-to-position);
}
.to-kids-dictionary-700\\/95{
  --tw-gradient-to: rgba(27, 97, 80, 0.95) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800{
  --tw-gradient-to: #184d40 var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/0{
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/10{
  --tw-gradient-to: rgba(24, 77, 64, 0.1) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/100{
  --tw-gradient-to: rgb(24, 77, 64) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/15{
  --tw-gradient-to: rgba(24, 77, 64, 0.15) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/20{
  --tw-gradient-to: rgba(24, 77, 64, 0.2) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/25{
  --tw-gradient-to: rgba(24, 77, 64, 0.25) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/30{
  --tw-gradient-to: rgba(24, 77, 64, 0.3) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/35{
  --tw-gradient-to: rgba(24, 77, 64, 0.35) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/40{
  --tw-gradient-to: rgba(24, 77, 64, 0.4) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/45{
  --tw-gradient-to: rgba(24, 77, 64, 0.45) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/5{
  --tw-gradient-to: rgba(24, 77, 64, 0.05) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/50{
  --tw-gradient-to: rgba(24, 77, 64, 0.5) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/55{
  --tw-gradient-to: rgba(24, 77, 64, 0.55) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/60{
  --tw-gradient-to: rgba(24, 77, 64, 0.6) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/65{
  --tw-gradient-to: rgba(24, 77, 64, 0.65) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/70{
  --tw-gradient-to: rgba(24, 77, 64, 0.7) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/75{
  --tw-gradient-to: rgba(24, 77, 64, 0.75) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/80{
  --tw-gradient-to: rgba(24, 77, 64, 0.8) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/85{
  --tw-gradient-to: rgba(24, 77, 64, 0.85) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/90{
  --tw-gradient-to: rgba(24, 77, 64, 0.9) var(--tw-gradient-to-position);
}
.to-kids-dictionary-800\\/95{
  --tw-gradient-to: rgba(24, 77, 64, 0.95) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900{
  --tw-gradient-to: #144036 var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/0{
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/10{
  --tw-gradient-to: rgba(20, 64, 54, 0.1) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/100{
  --tw-gradient-to: rgb(20, 64, 54) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/15{
  --tw-gradient-to: rgba(20, 64, 54, 0.15) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/20{
  --tw-gradient-to: rgba(20, 64, 54, 0.2) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/25{
  --tw-gradient-to: rgba(20, 64, 54, 0.25) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/30{
  --tw-gradient-to: rgba(20, 64, 54, 0.3) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/35{
  --tw-gradient-to: rgba(20, 64, 54, 0.35) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/40{
  --tw-gradient-to: rgba(20, 64, 54, 0.4) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/45{
  --tw-gradient-to: rgba(20, 64, 54, 0.45) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/5{
  --tw-gradient-to: rgba(20, 64, 54, 0.05) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/50{
  --tw-gradient-to: rgba(20, 64, 54, 0.5) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/55{
  --tw-gradient-to: rgba(20, 64, 54, 0.55) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/60{
  --tw-gradient-to: rgba(20, 64, 54, 0.6) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/65{
  --tw-gradient-to: rgba(20, 64, 54, 0.65) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/70{
  --tw-gradient-to: rgba(20, 64, 54, 0.7) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/75{
  --tw-gradient-to: rgba(20, 64, 54, 0.75) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/80{
  --tw-gradient-to: rgba(20, 64, 54, 0.8) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/85{
  --tw-gradient-to: rgba(20, 64, 54, 0.85) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/90{
  --tw-gradient-to: rgba(20, 64, 54, 0.9) var(--tw-gradient-to-position);
}
.to-kids-dictionary-900\\/95{
  --tw-gradient-to: rgba(20, 64, 54, 0.95) var(--tw-gradient-to-position);
}
.to-kids-games-500{
  --tw-gradient-to: #513B56 var(--tw-gradient-to-position);
}
.to-kids-games-500\\/0{
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/10{
  --tw-gradient-to: rgba(81, 59, 86, 0.1) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/100{
  --tw-gradient-to: rgb(81, 59, 86) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/15{
  --tw-gradient-to: rgba(81, 59, 86, 0.15) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/20{
  --tw-gradient-to: rgba(81, 59, 86, 0.2) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/25{
  --tw-gradient-to: rgba(81, 59, 86, 0.25) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/30{
  --tw-gradient-to: rgba(81, 59, 86, 0.3) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/35{
  --tw-gradient-to: rgba(81, 59, 86, 0.35) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/40{
  --tw-gradient-to: rgba(81, 59, 86, 0.4) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/45{
  --tw-gradient-to: rgba(81, 59, 86, 0.45) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/5{
  --tw-gradient-to: rgba(81, 59, 86, 0.05) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/50{
  --tw-gradient-to: rgba(81, 59, 86, 0.5) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/55{
  --tw-gradient-to: rgba(81, 59, 86, 0.55) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/60{
  --tw-gradient-to: rgba(81, 59, 86, 0.6) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/65{
  --tw-gradient-to: rgba(81, 59, 86, 0.65) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/70{
  --tw-gradient-to: rgba(81, 59, 86, 0.7) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/75{
  --tw-gradient-to: rgba(81, 59, 86, 0.75) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/80{
  --tw-gradient-to: rgba(81, 59, 86, 0.8) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/85{
  --tw-gradient-to: rgba(81, 59, 86, 0.85) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/90{
  --tw-gradient-to: rgba(81, 59, 86, 0.9) var(--tw-gradient-to-position);
}
.to-kids-games-500\\/95{
  --tw-gradient-to: rgba(81, 59, 86, 0.95) var(--tw-gradient-to-position);
}
.to-kids-games-900{
  --tw-gradient-to: #39293c var(--tw-gradient-to-position);
}
.to-kids-games-900\\/0{
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/10{
  --tw-gradient-to: rgba(57, 41, 60, 0.1) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/100{
  --tw-gradient-to: rgb(57, 41, 60) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/15{
  --tw-gradient-to: rgba(57, 41, 60, 0.15) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/20{
  --tw-gradient-to: rgba(57, 41, 60, 0.2) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/25{
  --tw-gradient-to: rgba(57, 41, 60, 0.25) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/30{
  --tw-gradient-to: rgba(57, 41, 60, 0.3) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/35{
  --tw-gradient-to: rgba(57, 41, 60, 0.35) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/40{
  --tw-gradient-to: rgba(57, 41, 60, 0.4) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/45{
  --tw-gradient-to: rgba(57, 41, 60, 0.45) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/5{
  --tw-gradient-to: rgba(57, 41, 60, 0.05) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/50{
  --tw-gradient-to: rgba(57, 41, 60, 0.5) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/55{
  --tw-gradient-to: rgba(57, 41, 60, 0.55) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/60{
  --tw-gradient-to: rgba(57, 41, 60, 0.6) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/65{
  --tw-gradient-to: rgba(57, 41, 60, 0.65) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/70{
  --tw-gradient-to: rgba(57, 41, 60, 0.7) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/75{
  --tw-gradient-to: rgba(57, 41, 60, 0.75) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/80{
  --tw-gradient-to: rgba(57, 41, 60, 0.8) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/85{
  --tw-gradient-to: rgba(57, 41, 60, 0.85) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/90{
  --tw-gradient-to: rgba(57, 41, 60, 0.9) var(--tw-gradient-to-position);
}
.to-kids-games-900\\/95{
  --tw-gradient-to: rgba(57, 41, 60, 0.95) var(--tw-gradient-to-position);
}
.to-kids-songs-500{
  --tw-gradient-to: #830042 var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/0{
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/10{
  --tw-gradient-to: rgba(131, 0, 66, 0.1) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/100{
  --tw-gradient-to: rgb(131, 0, 66) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/15{
  --tw-gradient-to: rgba(131, 0, 66, 0.15) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/20{
  --tw-gradient-to: rgba(131, 0, 66, 0.2) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/25{
  --tw-gradient-to: rgba(131, 0, 66, 0.25) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/30{
  --tw-gradient-to: rgba(131, 0, 66, 0.3) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/35{
  --tw-gradient-to: rgba(131, 0, 66, 0.35) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/40{
  --tw-gradient-to: rgba(131, 0, 66, 0.4) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/45{
  --tw-gradient-to: rgba(131, 0, 66, 0.45) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/5{
  --tw-gradient-to: rgba(131, 0, 66, 0.05) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/50{
  --tw-gradient-to: rgba(131, 0, 66, 0.5) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/55{
  --tw-gradient-to: rgba(131, 0, 66, 0.55) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/60{
  --tw-gradient-to: rgba(131, 0, 66, 0.6) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/65{
  --tw-gradient-to: rgba(131, 0, 66, 0.65) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/70{
  --tw-gradient-to: rgba(131, 0, 66, 0.7) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/75{
  --tw-gradient-to: rgba(131, 0, 66, 0.75) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/80{
  --tw-gradient-to: rgba(131, 0, 66, 0.8) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/85{
  --tw-gradient-to: rgba(131, 0, 66, 0.85) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/90{
  --tw-gradient-to: rgba(131, 0, 66, 0.9) var(--tw-gradient-to-position);
}
.to-kids-songs-500\\/95{
  --tw-gradient-to: rgba(131, 0, 66, 0.95) var(--tw-gradient-to-position);
}
.to-kids-songs-900{
  --tw-gradient-to: #5c002e var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/0{
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/10{
  --tw-gradient-to: rgba(92, 0, 46, 0.1) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/100{
  --tw-gradient-to: rgb(92, 0, 46) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/15{
  --tw-gradient-to: rgba(92, 0, 46, 0.15) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/20{
  --tw-gradient-to: rgba(92, 0, 46, 0.2) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/25{
  --tw-gradient-to: rgba(92, 0, 46, 0.25) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/30{
  --tw-gradient-to: rgba(92, 0, 46, 0.3) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/35{
  --tw-gradient-to: rgba(92, 0, 46, 0.35) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/40{
  --tw-gradient-to: rgba(92, 0, 46, 0.4) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/45{
  --tw-gradient-to: rgba(92, 0, 46, 0.45) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/5{
  --tw-gradient-to: rgba(92, 0, 46, 0.05) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/50{
  --tw-gradient-to: rgba(92, 0, 46, 0.5) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/55{
  --tw-gradient-to: rgba(92, 0, 46, 0.55) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/60{
  --tw-gradient-to: rgba(92, 0, 46, 0.6) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/65{
  --tw-gradient-to: rgba(92, 0, 46, 0.65) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/70{
  --tw-gradient-to: rgba(92, 0, 46, 0.7) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/75{
  --tw-gradient-to: rgba(92, 0, 46, 0.75) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/80{
  --tw-gradient-to: rgba(92, 0, 46, 0.8) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/85{
  --tw-gradient-to: rgba(92, 0, 46, 0.85) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/90{
  --tw-gradient-to: rgba(92, 0, 46, 0.9) var(--tw-gradient-to-position);
}
.to-kids-songs-900\\/95{
  --tw-gradient-to: rgba(92, 0, 46, 0.95) var(--tw-gradient-to-position);
}
.to-kids-stories-500{
  --tw-gradient-to: #E9C46A var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/0{
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/10{
  --tw-gradient-to: rgba(233, 196, 106, 0.1) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/100{
  --tw-gradient-to: rgb(233, 196, 106) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/15{
  --tw-gradient-to: rgba(233, 196, 106, 0.15) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/20{
  --tw-gradient-to: rgba(233, 196, 106, 0.2) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/25{
  --tw-gradient-to: rgba(233, 196, 106, 0.25) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/30{
  --tw-gradient-to: rgba(233, 196, 106, 0.3) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/35{
  --tw-gradient-to: rgba(233, 196, 106, 0.35) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/40{
  --tw-gradient-to: rgba(233, 196, 106, 0.4) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/45{
  --tw-gradient-to: rgba(233, 196, 106, 0.45) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/5{
  --tw-gradient-to: rgba(233, 196, 106, 0.05) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/50{
  --tw-gradient-to: rgba(233, 196, 106, 0.5) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/55{
  --tw-gradient-to: rgba(233, 196, 106, 0.55) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/60{
  --tw-gradient-to: rgba(233, 196, 106, 0.6) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/65{
  --tw-gradient-to: rgba(233, 196, 106, 0.65) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/70{
  --tw-gradient-to: rgba(233, 196, 106, 0.7) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/75{
  --tw-gradient-to: rgba(233, 196, 106, 0.75) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/80{
  --tw-gradient-to: rgba(233, 196, 106, 0.8) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/85{
  --tw-gradient-to: rgba(233, 196, 106, 0.85) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/90{
  --tw-gradient-to: rgba(233, 196, 106, 0.9) var(--tw-gradient-to-position);
}
.to-kids-stories-500\\/95{
  --tw-gradient-to: rgba(233, 196, 106, 0.95) var(--tw-gradient-to-position);
}
.to-kids-stories-900{
  --tw-gradient-to: #a3894a var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/0{
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/10{
  --tw-gradient-to: rgba(163, 137, 74, 0.1) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/100{
  --tw-gradient-to: rgb(163, 137, 74) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/15{
  --tw-gradient-to: rgba(163, 137, 74, 0.15) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/20{
  --tw-gradient-to: rgba(163, 137, 74, 0.2) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/25{
  --tw-gradient-to: rgba(163, 137, 74, 0.25) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/30{
  --tw-gradient-to: rgba(163, 137, 74, 0.3) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/35{
  --tw-gradient-to: rgba(163, 137, 74, 0.35) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/40{
  --tw-gradient-to: rgba(163, 137, 74, 0.4) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/45{
  --tw-gradient-to: rgba(163, 137, 74, 0.45) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/5{
  --tw-gradient-to: rgba(163, 137, 74, 0.05) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/50{
  --tw-gradient-to: rgba(163, 137, 74, 0.5) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/55{
  --tw-gradient-to: rgba(163, 137, 74, 0.55) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/60{
  --tw-gradient-to: rgba(163, 137, 74, 0.6) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/65{
  --tw-gradient-to: rgba(163, 137, 74, 0.65) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/70{
  --tw-gradient-to: rgba(163, 137, 74, 0.7) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/75{
  --tw-gradient-to: rgba(163, 137, 74, 0.75) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/80{
  --tw-gradient-to: rgba(163, 137, 74, 0.8) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/85{
  --tw-gradient-to: rgba(163, 137, 74, 0.85) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/90{
  --tw-gradient-to: rgba(163, 137, 74, 0.9) var(--tw-gradient-to-position);
}
.to-kids-stories-900\\/95{
  --tw-gradient-to: rgba(163, 137, 74, 0.95) var(--tw-gradient-to-position);
}
.to-ochre-100{
  --tw-gradient-to: #f5edd0 var(--tw-gradient-to-position);
}
.to-ochre-100\\/0{
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
}
.to-ochre-100\\/10{
  --tw-gradient-to: rgba(245, 237, 208, 0.1) var(--tw-gradient-to-position);
}
.to-ochre-100\\/100{
  --tw-gradient-to: rgb(245, 237, 208) var(--tw-gradient-to-position);
}
.to-ochre-100\\/15{
  --tw-gradient-to: rgba(245, 237, 208, 0.15) var(--tw-gradient-to-position);
}
.to-ochre-100\\/20{
  --tw-gradient-to: rgba(245, 237, 208, 0.2) var(--tw-gradient-to-position);
}
.to-ochre-100\\/25{
  --tw-gradient-to: rgba(245, 237, 208, 0.25) var(--tw-gradient-to-position);
}
.to-ochre-100\\/30{
  --tw-gradient-to: rgba(245, 237, 208, 0.3) var(--tw-gradient-to-position);
}
.to-ochre-100\\/35{
  --tw-gradient-to: rgba(245, 237, 208, 0.35) var(--tw-gradient-to-position);
}
.to-ochre-100\\/40{
  --tw-gradient-to: rgba(245, 237, 208, 0.4) var(--tw-gradient-to-position);
}
.to-ochre-100\\/45{
  --tw-gradient-to: rgba(245, 237, 208, 0.45) var(--tw-gradient-to-position);
}
.to-ochre-100\\/5{
  --tw-gradient-to: rgba(245, 237, 208, 0.05) var(--tw-gradient-to-position);
}
.to-ochre-100\\/50{
  --tw-gradient-to: rgba(245, 237, 208, 0.5) var(--tw-gradient-to-position);
}
.to-ochre-100\\/55{
  --tw-gradient-to: rgba(245, 237, 208, 0.55) var(--tw-gradient-to-position);
}
.to-ochre-100\\/60{
  --tw-gradient-to: rgba(245, 237, 208, 0.6) var(--tw-gradient-to-position);
}
.to-ochre-100\\/65{
  --tw-gradient-to: rgba(245, 237, 208, 0.65) var(--tw-gradient-to-position);
}
.to-ochre-100\\/70{
  --tw-gradient-to: rgba(245, 237, 208, 0.7) var(--tw-gradient-to-position);
}
.to-ochre-100\\/75{
  --tw-gradient-to: rgba(245, 237, 208, 0.75) var(--tw-gradient-to-position);
}
.to-ochre-100\\/80{
  --tw-gradient-to: rgba(245, 237, 208, 0.8) var(--tw-gradient-to-position);
}
.to-ochre-100\\/85{
  --tw-gradient-to: rgba(245, 237, 208, 0.85) var(--tw-gradient-to-position);
}
.to-ochre-100\\/90{
  --tw-gradient-to: rgba(245, 237, 208, 0.9) var(--tw-gradient-to-position);
}
.to-ochre-100\\/95{
  --tw-gradient-to: rgba(245, 237, 208, 0.95) var(--tw-gradient-to-position);
}
.to-ochre-200{
  --tw-gradient-to: #ebd99c var(--tw-gradient-to-position);
}
.to-ochre-200\\/0{
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
}
.to-ochre-200\\/10{
  --tw-gradient-to: rgba(235, 217, 156, 0.1) var(--tw-gradient-to-position);
}
.to-ochre-200\\/100{
  --tw-gradient-to: rgb(235, 217, 156) var(--tw-gradient-to-position);
}
.to-ochre-200\\/15{
  --tw-gradient-to: rgba(235, 217, 156, 0.15) var(--tw-gradient-to-position);
}
.to-ochre-200\\/20{
  --tw-gradient-to: rgba(235, 217, 156, 0.2) var(--tw-gradient-to-position);
}
.to-ochre-200\\/25{
  --tw-gradient-to: rgba(235, 217, 156, 0.25) var(--tw-gradient-to-position);
}
.to-ochre-200\\/30{
  --tw-gradient-to: rgba(235, 217, 156, 0.3) var(--tw-gradient-to-position);
}
.to-ochre-200\\/35{
  --tw-gradient-to: rgba(235, 217, 156, 0.35) var(--tw-gradient-to-position);
}
.to-ochre-200\\/40{
  --tw-gradient-to: rgba(235, 217, 156, 0.4) var(--tw-gradient-to-position);
}
.to-ochre-200\\/45{
  --tw-gradient-to: rgba(235, 217, 156, 0.45) var(--tw-gradient-to-position);
}
.to-ochre-200\\/5{
  --tw-gradient-to: rgba(235, 217, 156, 0.05) var(--tw-gradient-to-position);
}
.to-ochre-200\\/50{
  --tw-gradient-to: rgba(235, 217, 156, 0.5) var(--tw-gradient-to-position);
}
.to-ochre-200\\/55{
  --tw-gradient-to: rgba(235, 217, 156, 0.55) var(--tw-gradient-to-position);
}
.to-ochre-200\\/60{
  --tw-gradient-to: rgba(235, 217, 156, 0.6) var(--tw-gradient-to-position);
}
.to-ochre-200\\/65{
  --tw-gradient-to: rgba(235, 217, 156, 0.65) var(--tw-gradient-to-position);
}
.to-ochre-200\\/70{
  --tw-gradient-to: rgba(235, 217, 156, 0.7) var(--tw-gradient-to-position);
}
.to-ochre-200\\/75{
  --tw-gradient-to: rgba(235, 217, 156, 0.75) var(--tw-gradient-to-position);
}
.to-ochre-200\\/80{
  --tw-gradient-to: rgba(235, 217, 156, 0.8) var(--tw-gradient-to-position);
}
.to-ochre-200\\/85{
  --tw-gradient-to: rgba(235, 217, 156, 0.85) var(--tw-gradient-to-position);
}
.to-ochre-200\\/90{
  --tw-gradient-to: rgba(235, 217, 156, 0.9) var(--tw-gradient-to-position);
}
.to-ochre-200\\/95{
  --tw-gradient-to: rgba(235, 217, 156, 0.95) var(--tw-gradient-to-position);
}
.to-ochre-300{
  --tw-gradient-to: #e1c268 var(--tw-gradient-to-position);
}
.to-ochre-300\\/0{
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
}
.to-ochre-300\\/10{
  --tw-gradient-to: rgba(225, 194, 104, 0.1) var(--tw-gradient-to-position);
}
.to-ochre-300\\/100{
  --tw-gradient-to: rgb(225, 194, 104) var(--tw-gradient-to-position);
}
.to-ochre-300\\/15{
  --tw-gradient-to: rgba(225, 194, 104, 0.15) var(--tw-gradient-to-position);
}
.to-ochre-300\\/20{
  --tw-gradient-to: rgba(225, 194, 104, 0.2) var(--tw-gradient-to-position);
}
.to-ochre-300\\/25{
  --tw-gradient-to: rgba(225, 194, 104, 0.25) var(--tw-gradient-to-position);
}
.to-ochre-300\\/30{
  --tw-gradient-to: rgba(225, 194, 104, 0.3) var(--tw-gradient-to-position);
}
.to-ochre-300\\/35{
  --tw-gradient-to: rgba(225, 194, 104, 0.35) var(--tw-gradient-to-position);
}
.to-ochre-300\\/40{
  --tw-gradient-to: rgba(225, 194, 104, 0.4) var(--tw-gradient-to-position);
}
.to-ochre-300\\/45{
  --tw-gradient-to: rgba(225, 194, 104, 0.45) var(--tw-gradient-to-position);
}
.to-ochre-300\\/5{
  --tw-gradient-to: rgba(225, 194, 104, 0.05) var(--tw-gradient-to-position);
}
.to-ochre-300\\/50{
  --tw-gradient-to: rgba(225, 194, 104, 0.5) var(--tw-gradient-to-position);
}
.to-ochre-300\\/55{
  --tw-gradient-to: rgba(225, 194, 104, 0.55) var(--tw-gradient-to-position);
}
.to-ochre-300\\/60{
  --tw-gradient-to: rgba(225, 194, 104, 0.6) var(--tw-gradient-to-position);
}
.to-ochre-300\\/65{
  --tw-gradient-to: rgba(225, 194, 104, 0.65) var(--tw-gradient-to-position);
}
.to-ochre-300\\/70{
  --tw-gradient-to: rgba(225, 194, 104, 0.7) var(--tw-gradient-to-position);
}
.to-ochre-300\\/75{
  --tw-gradient-to: rgba(225, 194, 104, 0.75) var(--tw-gradient-to-position);
}
.to-ochre-300\\/80{
  --tw-gradient-to: rgba(225, 194, 104, 0.8) var(--tw-gradient-to-position);
}
.to-ochre-300\\/85{
  --tw-gradient-to: rgba(225, 194, 104, 0.85) var(--tw-gradient-to-position);
}
.to-ochre-300\\/90{
  --tw-gradient-to: rgba(225, 194, 104, 0.9) var(--tw-gradient-to-position);
}
.to-ochre-300\\/95{
  --tw-gradient-to: rgba(225, 194, 104, 0.95) var(--tw-gradient-to-position);
}
.to-ochre-400{
  --tw-gradient-to: #daad45 var(--tw-gradient-to-position);
}
.to-ochre-400\\/0{
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
}
.to-ochre-400\\/10{
  --tw-gradient-to: rgba(218, 173, 69, 0.1) var(--tw-gradient-to-position);
}
.to-ochre-400\\/100{
  --tw-gradient-to: rgb(218, 173, 69) var(--tw-gradient-to-position);
}
.to-ochre-400\\/15{
  --tw-gradient-to: rgba(218, 173, 69, 0.15) var(--tw-gradient-to-position);
}
.to-ochre-400\\/20{
  --tw-gradient-to: rgba(218, 173, 69, 0.2) var(--tw-gradient-to-position);
}
.to-ochre-400\\/25{
  --tw-gradient-to: rgba(218, 173, 69, 0.25) var(--tw-gradient-to-position);
}
.to-ochre-400\\/30{
  --tw-gradient-to: rgba(218, 173, 69, 0.3) var(--tw-gradient-to-position);
}
.to-ochre-400\\/35{
  --tw-gradient-to: rgba(218, 173, 69, 0.35) var(--tw-gradient-to-position);
}
.to-ochre-400\\/40{
  --tw-gradient-to: rgba(218, 173, 69, 0.4) var(--tw-gradient-to-position);
}
.to-ochre-400\\/45{
  --tw-gradient-to: rgba(218, 173, 69, 0.45) var(--tw-gradient-to-position);
}
.to-ochre-400\\/5{
  --tw-gradient-to: rgba(218, 173, 69, 0.05) var(--tw-gradient-to-position);
}
.to-ochre-400\\/50{
  --tw-gradient-to: rgba(218, 173, 69, 0.5) var(--tw-gradient-to-position);
}
.to-ochre-400\\/55{
  --tw-gradient-to: rgba(218, 173, 69, 0.55) var(--tw-gradient-to-position);
}
.to-ochre-400\\/60{
  --tw-gradient-to: rgba(218, 173, 69, 0.6) var(--tw-gradient-to-position);
}
.to-ochre-400\\/65{
  --tw-gradient-to: rgba(218, 173, 69, 0.65) var(--tw-gradient-to-position);
}
.to-ochre-400\\/70{
  --tw-gradient-to: rgba(218, 173, 69, 0.7) var(--tw-gradient-to-position);
}
.to-ochre-400\\/75{
  --tw-gradient-to: rgba(218, 173, 69, 0.75) var(--tw-gradient-to-position);
}
.to-ochre-400\\/80{
  --tw-gradient-to: rgba(218, 173, 69, 0.8) var(--tw-gradient-to-position);
}
.to-ochre-400\\/85{
  --tw-gradient-to: rgba(218, 173, 69, 0.85) var(--tw-gradient-to-position);
}
.to-ochre-400\\/90{
  --tw-gradient-to: rgba(218, 173, 69, 0.9) var(--tw-gradient-to-position);
}
.to-ochre-400\\/95{
  --tw-gradient-to: rgba(218, 173, 69, 0.95) var(--tw-gradient-to-position);
}
.to-ochre-500{
  --tw-gradient-to: #d1912f var(--tw-gradient-to-position);
}
.to-ochre-500\\/0{
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
}
.to-ochre-500\\/10{
  --tw-gradient-to: rgba(209, 145, 47, 0.1) var(--tw-gradient-to-position);
}
.to-ochre-500\\/100{
  --tw-gradient-to: rgb(209, 145, 47) var(--tw-gradient-to-position);
}
.to-ochre-500\\/15{
  --tw-gradient-to: rgba(209, 145, 47, 0.15) var(--tw-gradient-to-position);
}
.to-ochre-500\\/20{
  --tw-gradient-to: rgba(209, 145, 47, 0.2) var(--tw-gradient-to-position);
}
.to-ochre-500\\/25{
  --tw-gradient-to: rgba(209, 145, 47, 0.25) var(--tw-gradient-to-position);
}
.to-ochre-500\\/30{
  --tw-gradient-to: rgba(209, 145, 47, 0.3) var(--tw-gradient-to-position);
}
.to-ochre-500\\/35{
  --tw-gradient-to: rgba(209, 145, 47, 0.35) var(--tw-gradient-to-position);
}
.to-ochre-500\\/40{
  --tw-gradient-to: rgba(209, 145, 47, 0.4) var(--tw-gradient-to-position);
}
.to-ochre-500\\/45{
  --tw-gradient-to: rgba(209, 145, 47, 0.45) var(--tw-gradient-to-position);
}
.to-ochre-500\\/5{
  --tw-gradient-to: rgba(209, 145, 47, 0.05) var(--tw-gradient-to-position);
}
.to-ochre-500\\/50{
  --tw-gradient-to: rgba(209, 145, 47, 0.5) var(--tw-gradient-to-position);
}
.to-ochre-500\\/55{
  --tw-gradient-to: rgba(209, 145, 47, 0.55) var(--tw-gradient-to-position);
}
.to-ochre-500\\/60{
  --tw-gradient-to: rgba(209, 145, 47, 0.6) var(--tw-gradient-to-position);
}
.to-ochre-500\\/65{
  --tw-gradient-to: rgba(209, 145, 47, 0.65) var(--tw-gradient-to-position);
}
.to-ochre-500\\/70{
  --tw-gradient-to: rgba(209, 145, 47, 0.7) var(--tw-gradient-to-position);
}
.to-ochre-500\\/75{
  --tw-gradient-to: rgba(209, 145, 47, 0.75) var(--tw-gradient-to-position);
}
.to-ochre-500\\/80{
  --tw-gradient-to: rgba(209, 145, 47, 0.8) var(--tw-gradient-to-position);
}
.to-ochre-500\\/85{
  --tw-gradient-to: rgba(209, 145, 47, 0.85) var(--tw-gradient-to-position);
}
.to-ochre-500\\/90{
  --tw-gradient-to: rgba(209, 145, 47, 0.9) var(--tw-gradient-to-position);
}
.to-ochre-500\\/95{
  --tw-gradient-to: rgba(209, 145, 47, 0.95) var(--tw-gradient-to-position);
}
.to-ochre-600{
  --tw-gradient-to: #c37829 var(--tw-gradient-to-position);
}
.to-ochre-600\\/0{
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
}
.to-ochre-600\\/10{
  --tw-gradient-to: rgba(195, 120, 41, 0.1) var(--tw-gradient-to-position);
}
.to-ochre-600\\/100{
  --tw-gradient-to: rgb(195, 120, 41) var(--tw-gradient-to-position);
}
.to-ochre-600\\/15{
  --tw-gradient-to: rgba(195, 120, 41, 0.15) var(--tw-gradient-to-position);
}
.to-ochre-600\\/20{
  --tw-gradient-to: rgba(195, 120, 41, 0.2) var(--tw-gradient-to-position);
}
.to-ochre-600\\/25{
  --tw-gradient-to: rgba(195, 120, 41, 0.25) var(--tw-gradient-to-position);
}
.to-ochre-600\\/30{
  --tw-gradient-to: rgba(195, 120, 41, 0.3) var(--tw-gradient-to-position);
}
.to-ochre-600\\/35{
  --tw-gradient-to: rgba(195, 120, 41, 0.35) var(--tw-gradient-to-position);
}
.to-ochre-600\\/40{
  --tw-gradient-to: rgba(195, 120, 41, 0.4) var(--tw-gradient-to-position);
}
.to-ochre-600\\/45{
  --tw-gradient-to: rgba(195, 120, 41, 0.45) var(--tw-gradient-to-position);
}
.to-ochre-600\\/5{
  --tw-gradient-to: rgba(195, 120, 41, 0.05) var(--tw-gradient-to-position);
}
.to-ochre-600\\/50{
  --tw-gradient-to: rgba(195, 120, 41, 0.5) var(--tw-gradient-to-position);
}
.to-ochre-600\\/55{
  --tw-gradient-to: rgba(195, 120, 41, 0.55) var(--tw-gradient-to-position);
}
.to-ochre-600\\/60{
  --tw-gradient-to: rgba(195, 120, 41, 0.6) var(--tw-gradient-to-position);
}
.to-ochre-600\\/65{
  --tw-gradient-to: rgba(195, 120, 41, 0.65) var(--tw-gradient-to-position);
}
.to-ochre-600\\/70{
  --tw-gradient-to: rgba(195, 120, 41, 0.7) var(--tw-gradient-to-position);
}
.to-ochre-600\\/75{
  --tw-gradient-to: rgba(195, 120, 41, 0.75) var(--tw-gradient-to-position);
}
.to-ochre-600\\/80{
  --tw-gradient-to: rgba(195, 120, 41, 0.8) var(--tw-gradient-to-position);
}
.to-ochre-600\\/85{
  --tw-gradient-to: rgba(195, 120, 41, 0.85) var(--tw-gradient-to-position);
}
.to-ochre-600\\/90{
  --tw-gradient-to: rgba(195, 120, 41, 0.9) var(--tw-gradient-to-position);
}
.to-ochre-600\\/95{
  --tw-gradient-to: rgba(195, 120, 41, 0.95) var(--tw-gradient-to-position);
}
.to-ochre-700{
  --tw-gradient-to: #995424 var(--tw-gradient-to-position);
}
.to-ochre-700\\/0{
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
}
.to-ochre-700\\/10{
  --tw-gradient-to: rgba(153, 84, 36, 0.1) var(--tw-gradient-to-position);
}
.to-ochre-700\\/100{
  --tw-gradient-to: rgb(153, 84, 36) var(--tw-gradient-to-position);
}
.to-ochre-700\\/15{
  --tw-gradient-to: rgba(153, 84, 36, 0.15) var(--tw-gradient-to-position);
}
.to-ochre-700\\/20{
  --tw-gradient-to: rgba(153, 84, 36, 0.2) var(--tw-gradient-to-position);
}
.to-ochre-700\\/25{
  --tw-gradient-to: rgba(153, 84, 36, 0.25) var(--tw-gradient-to-position);
}
.to-ochre-700\\/30{
  --tw-gradient-to: rgba(153, 84, 36, 0.3) var(--tw-gradient-to-position);
}
.to-ochre-700\\/35{
  --tw-gradient-to: rgba(153, 84, 36, 0.35) var(--tw-gradient-to-position);
}
.to-ochre-700\\/40{
  --tw-gradient-to: rgba(153, 84, 36, 0.4) var(--tw-gradient-to-position);
}
.to-ochre-700\\/45{
  --tw-gradient-to: rgba(153, 84, 36, 0.45) var(--tw-gradient-to-position);
}
.to-ochre-700\\/5{
  --tw-gradient-to: rgba(153, 84, 36, 0.05) var(--tw-gradient-to-position);
}
.to-ochre-700\\/50{
  --tw-gradient-to: rgba(153, 84, 36, 0.5) var(--tw-gradient-to-position);
}
.to-ochre-700\\/55{
  --tw-gradient-to: rgba(153, 84, 36, 0.55) var(--tw-gradient-to-position);
}
.to-ochre-700\\/60{
  --tw-gradient-to: rgba(153, 84, 36, 0.6) var(--tw-gradient-to-position);
}
.to-ochre-700\\/65{
  --tw-gradient-to: rgba(153, 84, 36, 0.65) var(--tw-gradient-to-position);
}
.to-ochre-700\\/70{
  --tw-gradient-to: rgba(153, 84, 36, 0.7) var(--tw-gradient-to-position);
}
.to-ochre-700\\/75{
  --tw-gradient-to: rgba(153, 84, 36, 0.75) var(--tw-gradient-to-position);
}
.to-ochre-700\\/80{
  --tw-gradient-to: rgba(153, 84, 36, 0.8) var(--tw-gradient-to-position);
}
.to-ochre-700\\/85{
  --tw-gradient-to: rgba(153, 84, 36, 0.85) var(--tw-gradient-to-position);
}
.to-ochre-700\\/90{
  --tw-gradient-to: rgba(153, 84, 36, 0.9) var(--tw-gradient-to-position);
}
.to-ochre-700\\/95{
  --tw-gradient-to: rgba(153, 84, 36, 0.95) var(--tw-gradient-to-position);
}
.to-ochre-800{
  --tw-gradient-to: #7e4322 var(--tw-gradient-to-position);
}
.to-ochre-800\\/0{
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
}
.to-ochre-800\\/10{
  --tw-gradient-to: rgba(126, 67, 34, 0.1) var(--tw-gradient-to-position);
}
.to-ochre-800\\/100{
  --tw-gradient-to: rgb(126, 67, 34) var(--tw-gradient-to-position);
}
.to-ochre-800\\/15{
  --tw-gradient-to: rgba(126, 67, 34, 0.15) var(--tw-gradient-to-position);
}
.to-ochre-800\\/20{
  --tw-gradient-to: rgba(126, 67, 34, 0.2) var(--tw-gradient-to-position);
}
.to-ochre-800\\/25{
  --tw-gradient-to: rgba(126, 67, 34, 0.25) var(--tw-gradient-to-position);
}
.to-ochre-800\\/30{
  --tw-gradient-to: rgba(126, 67, 34, 0.3) var(--tw-gradient-to-position);
}
.to-ochre-800\\/35{
  --tw-gradient-to: rgba(126, 67, 34, 0.35) var(--tw-gradient-to-position);
}
.to-ochre-800\\/40{
  --tw-gradient-to: rgba(126, 67, 34, 0.4) var(--tw-gradient-to-position);
}
.to-ochre-800\\/45{
  --tw-gradient-to: rgba(126, 67, 34, 0.45) var(--tw-gradient-to-position);
}
.to-ochre-800\\/5{
  --tw-gradient-to: rgba(126, 67, 34, 0.05) var(--tw-gradient-to-position);
}
.to-ochre-800\\/50{
  --tw-gradient-to: rgba(126, 67, 34, 0.5) var(--tw-gradient-to-position);
}
.to-ochre-800\\/55{
  --tw-gradient-to: rgba(126, 67, 34, 0.55) var(--tw-gradient-to-position);
}
.to-ochre-800\\/60{
  --tw-gradient-to: rgba(126, 67, 34, 0.6) var(--tw-gradient-to-position);
}
.to-ochre-800\\/65{
  --tw-gradient-to: rgba(126, 67, 34, 0.65) var(--tw-gradient-to-position);
}
.to-ochre-800\\/70{
  --tw-gradient-to: rgba(126, 67, 34, 0.7) var(--tw-gradient-to-position);
}
.to-ochre-800\\/75{
  --tw-gradient-to: rgba(126, 67, 34, 0.75) var(--tw-gradient-to-position);
}
.to-ochre-800\\/80{
  --tw-gradient-to: rgba(126, 67, 34, 0.8) var(--tw-gradient-to-position);
}
.to-ochre-800\\/85{
  --tw-gradient-to: rgba(126, 67, 34, 0.85) var(--tw-gradient-to-position);
}
.to-ochre-800\\/90{
  --tw-gradient-to: rgba(126, 67, 34, 0.9) var(--tw-gradient-to-position);
}
.to-ochre-800\\/95{
  --tw-gradient-to: rgba(126, 67, 34, 0.95) var(--tw-gradient-to-position);
}
.to-ochre-900{
  --tw-gradient-to: #68381f var(--tw-gradient-to-position);
}
.to-ochre-900\\/0{
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
}
.to-ochre-900\\/10{
  --tw-gradient-to: rgba(104, 56, 31, 0.1) var(--tw-gradient-to-position);
}
.to-ochre-900\\/100{
  --tw-gradient-to: rgb(104, 56, 31) var(--tw-gradient-to-position);
}
.to-ochre-900\\/15{
  --tw-gradient-to: rgba(104, 56, 31, 0.15) var(--tw-gradient-to-position);
}
.to-ochre-900\\/20{
  --tw-gradient-to: rgba(104, 56, 31, 0.2) var(--tw-gradient-to-position);
}
.to-ochre-900\\/25{
  --tw-gradient-to: rgba(104, 56, 31, 0.25) var(--tw-gradient-to-position);
}
.to-ochre-900\\/30{
  --tw-gradient-to: rgba(104, 56, 31, 0.3) var(--tw-gradient-to-position);
}
.to-ochre-900\\/35{
  --tw-gradient-to: rgba(104, 56, 31, 0.35) var(--tw-gradient-to-position);
}
.to-ochre-900\\/40{
  --tw-gradient-to: rgba(104, 56, 31, 0.4) var(--tw-gradient-to-position);
}
.to-ochre-900\\/45{
  --tw-gradient-to: rgba(104, 56, 31, 0.45) var(--tw-gradient-to-position);
}
.to-ochre-900\\/5{
  --tw-gradient-to: rgba(104, 56, 31, 0.05) var(--tw-gradient-to-position);
}
.to-ochre-900\\/50{
  --tw-gradient-to: rgba(104, 56, 31, 0.5) var(--tw-gradient-to-position);
}
.to-ochre-900\\/55{
  --tw-gradient-to: rgba(104, 56, 31, 0.55) var(--tw-gradient-to-position);
}
.to-ochre-900\\/60{
  --tw-gradient-to: rgba(104, 56, 31, 0.6) var(--tw-gradient-to-position);
}
.to-ochre-900\\/65{
  --tw-gradient-to: rgba(104, 56, 31, 0.65) var(--tw-gradient-to-position);
}
.to-ochre-900\\/70{
  --tw-gradient-to: rgba(104, 56, 31, 0.7) var(--tw-gradient-to-position);
}
.to-ochre-900\\/75{
  --tw-gradient-to: rgba(104, 56, 31, 0.75) var(--tw-gradient-to-position);
}
.to-ochre-900\\/80{
  --tw-gradient-to: rgba(104, 56, 31, 0.8) var(--tw-gradient-to-position);
}
.to-ochre-900\\/85{
  --tw-gradient-to: rgba(104, 56, 31, 0.85) var(--tw-gradient-to-position);
}
.to-ochre-900\\/90{
  --tw-gradient-to: rgba(104, 56, 31, 0.9) var(--tw-gradient-to-position);
}
.to-ochre-900\\/95{
  --tw-gradient-to: rgba(104, 56, 31, 0.95) var(--tw-gradient-to-position);
}
.to-ochre-950{
  --tw-gradient-to: #3b1c0d var(--tw-gradient-to-position);
}
.to-ochre-950\\/0{
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
}
.to-ochre-950\\/10{
  --tw-gradient-to: rgba(59, 28, 13, 0.1) var(--tw-gradient-to-position);
}
.to-ochre-950\\/100{
  --tw-gradient-to: rgb(59, 28, 13) var(--tw-gradient-to-position);
}
.to-ochre-950\\/15{
  --tw-gradient-to: rgba(59, 28, 13, 0.15) var(--tw-gradient-to-position);
}
.to-ochre-950\\/20{
  --tw-gradient-to: rgba(59, 28, 13, 0.2) var(--tw-gradient-to-position);
}
.to-ochre-950\\/25{
  --tw-gradient-to: rgba(59, 28, 13, 0.25) var(--tw-gradient-to-position);
}
.to-ochre-950\\/30{
  --tw-gradient-to: rgba(59, 28, 13, 0.3) var(--tw-gradient-to-position);
}
.to-ochre-950\\/35{
  --tw-gradient-to: rgba(59, 28, 13, 0.35) var(--tw-gradient-to-position);
}
.to-ochre-950\\/40{
  --tw-gradient-to: rgba(59, 28, 13, 0.4) var(--tw-gradient-to-position);
}
.to-ochre-950\\/45{
  --tw-gradient-to: rgba(59, 28, 13, 0.45) var(--tw-gradient-to-position);
}
.to-ochre-950\\/5{
  --tw-gradient-to: rgba(59, 28, 13, 0.05) var(--tw-gradient-to-position);
}
.to-ochre-950\\/50{
  --tw-gradient-to: rgba(59, 28, 13, 0.5) var(--tw-gradient-to-position);
}
.to-ochre-950\\/55{
  --tw-gradient-to: rgba(59, 28, 13, 0.55) var(--tw-gradient-to-position);
}
.to-ochre-950\\/60{
  --tw-gradient-to: rgba(59, 28, 13, 0.6) var(--tw-gradient-to-position);
}
.to-ochre-950\\/65{
  --tw-gradient-to: rgba(59, 28, 13, 0.65) var(--tw-gradient-to-position);
}
.to-ochre-950\\/70{
  --tw-gradient-to: rgba(59, 28, 13, 0.7) var(--tw-gradient-to-position);
}
.to-ochre-950\\/75{
  --tw-gradient-to: rgba(59, 28, 13, 0.75) var(--tw-gradient-to-position);
}
.to-ochre-950\\/80{
  --tw-gradient-to: rgba(59, 28, 13, 0.8) var(--tw-gradient-to-position);
}
.to-ochre-950\\/85{
  --tw-gradient-to: rgba(59, 28, 13, 0.85) var(--tw-gradient-to-position);
}
.to-ochre-950\\/90{
  --tw-gradient-to: rgba(59, 28, 13, 0.9) var(--tw-gradient-to-position);
}
.to-ochre-950\\/95{
  --tw-gradient-to: rgba(59, 28, 13, 0.95) var(--tw-gradient-to-position);
}
.to-phrase-color-100{
  --tw-gradient-to: #f5edd0 var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/0{
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/10{
  --tw-gradient-to: rgba(245, 237, 208, 0.1) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/100{
  --tw-gradient-to: rgb(245, 237, 208) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/15{
  --tw-gradient-to: rgba(245, 237, 208, 0.15) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/20{
  --tw-gradient-to: rgba(245, 237, 208, 0.2) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/25{
  --tw-gradient-to: rgba(245, 237, 208, 0.25) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/30{
  --tw-gradient-to: rgba(245, 237, 208, 0.3) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/35{
  --tw-gradient-to: rgba(245, 237, 208, 0.35) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/40{
  --tw-gradient-to: rgba(245, 237, 208, 0.4) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/45{
  --tw-gradient-to: rgba(245, 237, 208, 0.45) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/5{
  --tw-gradient-to: rgba(245, 237, 208, 0.05) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/50{
  --tw-gradient-to: rgba(245, 237, 208, 0.5) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/55{
  --tw-gradient-to: rgba(245, 237, 208, 0.55) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/60{
  --tw-gradient-to: rgba(245, 237, 208, 0.6) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/65{
  --tw-gradient-to: rgba(245, 237, 208, 0.65) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/70{
  --tw-gradient-to: rgba(245, 237, 208, 0.7) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/75{
  --tw-gradient-to: rgba(245, 237, 208, 0.75) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/80{
  --tw-gradient-to: rgba(245, 237, 208, 0.8) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/85{
  --tw-gradient-to: rgba(245, 237, 208, 0.85) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/90{
  --tw-gradient-to: rgba(245, 237, 208, 0.9) var(--tw-gradient-to-position);
}
.to-phrase-color-100\\/95{
  --tw-gradient-to: rgba(245, 237, 208, 0.95) var(--tw-gradient-to-position);
}
.to-phrase-color-200{
  --tw-gradient-to: #ebd99c var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/0{
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/10{
  --tw-gradient-to: rgba(235, 217, 156, 0.1) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/100{
  --tw-gradient-to: rgb(235, 217, 156) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/15{
  --tw-gradient-to: rgba(235, 217, 156, 0.15) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/20{
  --tw-gradient-to: rgba(235, 217, 156, 0.2) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/25{
  --tw-gradient-to: rgba(235, 217, 156, 0.25) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/30{
  --tw-gradient-to: rgba(235, 217, 156, 0.3) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/35{
  --tw-gradient-to: rgba(235, 217, 156, 0.35) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/40{
  --tw-gradient-to: rgba(235, 217, 156, 0.4) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/45{
  --tw-gradient-to: rgba(235, 217, 156, 0.45) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/5{
  --tw-gradient-to: rgba(235, 217, 156, 0.05) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/50{
  --tw-gradient-to: rgba(235, 217, 156, 0.5) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/55{
  --tw-gradient-to: rgba(235, 217, 156, 0.55) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/60{
  --tw-gradient-to: rgba(235, 217, 156, 0.6) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/65{
  --tw-gradient-to: rgba(235, 217, 156, 0.65) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/70{
  --tw-gradient-to: rgba(235, 217, 156, 0.7) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/75{
  --tw-gradient-to: rgba(235, 217, 156, 0.75) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/80{
  --tw-gradient-to: rgba(235, 217, 156, 0.8) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/85{
  --tw-gradient-to: rgba(235, 217, 156, 0.85) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/90{
  --tw-gradient-to: rgba(235, 217, 156, 0.9) var(--tw-gradient-to-position);
}
.to-phrase-color-200\\/95{
  --tw-gradient-to: rgba(235, 217, 156, 0.95) var(--tw-gradient-to-position);
}
.to-phrase-color-300{
  --tw-gradient-to: #e1c268 var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/0{
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/10{
  --tw-gradient-to: rgba(225, 194, 104, 0.1) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/100{
  --tw-gradient-to: rgb(225, 194, 104) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/15{
  --tw-gradient-to: rgba(225, 194, 104, 0.15) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/20{
  --tw-gradient-to: rgba(225, 194, 104, 0.2) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/25{
  --tw-gradient-to: rgba(225, 194, 104, 0.25) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/30{
  --tw-gradient-to: rgba(225, 194, 104, 0.3) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/35{
  --tw-gradient-to: rgba(225, 194, 104, 0.35) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/40{
  --tw-gradient-to: rgba(225, 194, 104, 0.4) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/45{
  --tw-gradient-to: rgba(225, 194, 104, 0.45) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/5{
  --tw-gradient-to: rgba(225, 194, 104, 0.05) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/50{
  --tw-gradient-to: rgba(225, 194, 104, 0.5) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/55{
  --tw-gradient-to: rgba(225, 194, 104, 0.55) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/60{
  --tw-gradient-to: rgba(225, 194, 104, 0.6) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/65{
  --tw-gradient-to: rgba(225, 194, 104, 0.65) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/70{
  --tw-gradient-to: rgba(225, 194, 104, 0.7) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/75{
  --tw-gradient-to: rgba(225, 194, 104, 0.75) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/80{
  --tw-gradient-to: rgba(225, 194, 104, 0.8) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/85{
  --tw-gradient-to: rgba(225, 194, 104, 0.85) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/90{
  --tw-gradient-to: rgba(225, 194, 104, 0.9) var(--tw-gradient-to-position);
}
.to-phrase-color-300\\/95{
  --tw-gradient-to: rgba(225, 194, 104, 0.95) var(--tw-gradient-to-position);
}
.to-phrase-color-400{
  --tw-gradient-to: #daad45 var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/0{
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/10{
  --tw-gradient-to: rgba(218, 173, 69, 0.1) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/100{
  --tw-gradient-to: rgb(218, 173, 69) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/15{
  --tw-gradient-to: rgba(218, 173, 69, 0.15) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/20{
  --tw-gradient-to: rgba(218, 173, 69, 0.2) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/25{
  --tw-gradient-to: rgba(218, 173, 69, 0.25) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/30{
  --tw-gradient-to: rgba(218, 173, 69, 0.3) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/35{
  --tw-gradient-to: rgba(218, 173, 69, 0.35) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/40{
  --tw-gradient-to: rgba(218, 173, 69, 0.4) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/45{
  --tw-gradient-to: rgba(218, 173, 69, 0.45) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/5{
  --tw-gradient-to: rgba(218, 173, 69, 0.05) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/50{
  --tw-gradient-to: rgba(218, 173, 69, 0.5) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/55{
  --tw-gradient-to: rgba(218, 173, 69, 0.55) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/60{
  --tw-gradient-to: rgba(218, 173, 69, 0.6) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/65{
  --tw-gradient-to: rgba(218, 173, 69, 0.65) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/70{
  --tw-gradient-to: rgba(218, 173, 69, 0.7) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/75{
  --tw-gradient-to: rgba(218, 173, 69, 0.75) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/80{
  --tw-gradient-to: rgba(218, 173, 69, 0.8) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/85{
  --tw-gradient-to: rgba(218, 173, 69, 0.85) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/90{
  --tw-gradient-to: rgba(218, 173, 69, 0.9) var(--tw-gradient-to-position);
}
.to-phrase-color-400\\/95{
  --tw-gradient-to: rgba(218, 173, 69, 0.95) var(--tw-gradient-to-position);
}
.to-phrase-color-500{
  --tw-gradient-to: #d1912f var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/0{
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/10{
  --tw-gradient-to: rgba(209, 145, 47, 0.1) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/100{
  --tw-gradient-to: rgb(209, 145, 47) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/15{
  --tw-gradient-to: rgba(209, 145, 47, 0.15) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/20{
  --tw-gradient-to: rgba(209, 145, 47, 0.2) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/25{
  --tw-gradient-to: rgba(209, 145, 47, 0.25) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/30{
  --tw-gradient-to: rgba(209, 145, 47, 0.3) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/35{
  --tw-gradient-to: rgba(209, 145, 47, 0.35) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/40{
  --tw-gradient-to: rgba(209, 145, 47, 0.4) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/45{
  --tw-gradient-to: rgba(209, 145, 47, 0.45) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/5{
  --tw-gradient-to: rgba(209, 145, 47, 0.05) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/50{
  --tw-gradient-to: rgba(209, 145, 47, 0.5) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/55{
  --tw-gradient-to: rgba(209, 145, 47, 0.55) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/60{
  --tw-gradient-to: rgba(209, 145, 47, 0.6) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/65{
  --tw-gradient-to: rgba(209, 145, 47, 0.65) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/70{
  --tw-gradient-to: rgba(209, 145, 47, 0.7) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/75{
  --tw-gradient-to: rgba(209, 145, 47, 0.75) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/80{
  --tw-gradient-to: rgba(209, 145, 47, 0.8) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/85{
  --tw-gradient-to: rgba(209, 145, 47, 0.85) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/90{
  --tw-gradient-to: rgba(209, 145, 47, 0.9) var(--tw-gradient-to-position);
}
.to-phrase-color-500\\/95{
  --tw-gradient-to: rgba(209, 145, 47, 0.95) var(--tw-gradient-to-position);
}
.to-phrase-color-600{
  --tw-gradient-to: #c37829 var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/0{
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/10{
  --tw-gradient-to: rgba(195, 120, 41, 0.1) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/100{
  --tw-gradient-to: rgb(195, 120, 41) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/15{
  --tw-gradient-to: rgba(195, 120, 41, 0.15) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/20{
  --tw-gradient-to: rgba(195, 120, 41, 0.2) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/25{
  --tw-gradient-to: rgba(195, 120, 41, 0.25) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/30{
  --tw-gradient-to: rgba(195, 120, 41, 0.3) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/35{
  --tw-gradient-to: rgba(195, 120, 41, 0.35) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/40{
  --tw-gradient-to: rgba(195, 120, 41, 0.4) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/45{
  --tw-gradient-to: rgba(195, 120, 41, 0.45) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/5{
  --tw-gradient-to: rgba(195, 120, 41, 0.05) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/50{
  --tw-gradient-to: rgba(195, 120, 41, 0.5) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/55{
  --tw-gradient-to: rgba(195, 120, 41, 0.55) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/60{
  --tw-gradient-to: rgba(195, 120, 41, 0.6) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/65{
  --tw-gradient-to: rgba(195, 120, 41, 0.65) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/70{
  --tw-gradient-to: rgba(195, 120, 41, 0.7) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/75{
  --tw-gradient-to: rgba(195, 120, 41, 0.75) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/80{
  --tw-gradient-to: rgba(195, 120, 41, 0.8) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/85{
  --tw-gradient-to: rgba(195, 120, 41, 0.85) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/90{
  --tw-gradient-to: rgba(195, 120, 41, 0.9) var(--tw-gradient-to-position);
}
.to-phrase-color-600\\/95{
  --tw-gradient-to: rgba(195, 120, 41, 0.95) var(--tw-gradient-to-position);
}
.to-phrase-color-700{
  --tw-gradient-to: #995424 var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/0{
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/10{
  --tw-gradient-to: rgba(153, 84, 36, 0.1) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/100{
  --tw-gradient-to: rgb(153, 84, 36) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/15{
  --tw-gradient-to: rgba(153, 84, 36, 0.15) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/20{
  --tw-gradient-to: rgba(153, 84, 36, 0.2) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/25{
  --tw-gradient-to: rgba(153, 84, 36, 0.25) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/30{
  --tw-gradient-to: rgba(153, 84, 36, 0.3) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/35{
  --tw-gradient-to: rgba(153, 84, 36, 0.35) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/40{
  --tw-gradient-to: rgba(153, 84, 36, 0.4) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/45{
  --tw-gradient-to: rgba(153, 84, 36, 0.45) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/5{
  --tw-gradient-to: rgba(153, 84, 36, 0.05) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/50{
  --tw-gradient-to: rgba(153, 84, 36, 0.5) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/55{
  --tw-gradient-to: rgba(153, 84, 36, 0.55) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/60{
  --tw-gradient-to: rgba(153, 84, 36, 0.6) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/65{
  --tw-gradient-to: rgba(153, 84, 36, 0.65) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/70{
  --tw-gradient-to: rgba(153, 84, 36, 0.7) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/75{
  --tw-gradient-to: rgba(153, 84, 36, 0.75) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/80{
  --tw-gradient-to: rgba(153, 84, 36, 0.8) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/85{
  --tw-gradient-to: rgba(153, 84, 36, 0.85) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/90{
  --tw-gradient-to: rgba(153, 84, 36, 0.9) var(--tw-gradient-to-position);
}
.to-phrase-color-700\\/95{
  --tw-gradient-to: rgba(153, 84, 36, 0.95) var(--tw-gradient-to-position);
}
.to-phrase-color-800{
  --tw-gradient-to: #7e4322 var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/0{
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/10{
  --tw-gradient-to: rgba(126, 67, 34, 0.1) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/100{
  --tw-gradient-to: rgb(126, 67, 34) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/15{
  --tw-gradient-to: rgba(126, 67, 34, 0.15) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/20{
  --tw-gradient-to: rgba(126, 67, 34, 0.2) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/25{
  --tw-gradient-to: rgba(126, 67, 34, 0.25) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/30{
  --tw-gradient-to: rgba(126, 67, 34, 0.3) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/35{
  --tw-gradient-to: rgba(126, 67, 34, 0.35) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/40{
  --tw-gradient-to: rgba(126, 67, 34, 0.4) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/45{
  --tw-gradient-to: rgba(126, 67, 34, 0.45) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/5{
  --tw-gradient-to: rgba(126, 67, 34, 0.05) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/50{
  --tw-gradient-to: rgba(126, 67, 34, 0.5) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/55{
  --tw-gradient-to: rgba(126, 67, 34, 0.55) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/60{
  --tw-gradient-to: rgba(126, 67, 34, 0.6) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/65{
  --tw-gradient-to: rgba(126, 67, 34, 0.65) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/70{
  --tw-gradient-to: rgba(126, 67, 34, 0.7) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/75{
  --tw-gradient-to: rgba(126, 67, 34, 0.75) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/80{
  --tw-gradient-to: rgba(126, 67, 34, 0.8) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/85{
  --tw-gradient-to: rgba(126, 67, 34, 0.85) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/90{
  --tw-gradient-to: rgba(126, 67, 34, 0.9) var(--tw-gradient-to-position);
}
.to-phrase-color-800\\/95{
  --tw-gradient-to: rgba(126, 67, 34, 0.95) var(--tw-gradient-to-position);
}
.to-phrase-color-900{
  --tw-gradient-to: #68381f var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/0{
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/10{
  --tw-gradient-to: rgba(104, 56, 31, 0.1) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/100{
  --tw-gradient-to: rgb(104, 56, 31) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/15{
  --tw-gradient-to: rgba(104, 56, 31, 0.15) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/20{
  --tw-gradient-to: rgba(104, 56, 31, 0.2) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/25{
  --tw-gradient-to: rgba(104, 56, 31, 0.25) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/30{
  --tw-gradient-to: rgba(104, 56, 31, 0.3) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/35{
  --tw-gradient-to: rgba(104, 56, 31, 0.35) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/40{
  --tw-gradient-to: rgba(104, 56, 31, 0.4) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/45{
  --tw-gradient-to: rgba(104, 56, 31, 0.45) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/5{
  --tw-gradient-to: rgba(104, 56, 31, 0.05) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/50{
  --tw-gradient-to: rgba(104, 56, 31, 0.5) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/55{
  --tw-gradient-to: rgba(104, 56, 31, 0.55) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/60{
  --tw-gradient-to: rgba(104, 56, 31, 0.6) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/65{
  --tw-gradient-to: rgba(104, 56, 31, 0.65) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/70{
  --tw-gradient-to: rgba(104, 56, 31, 0.7) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/75{
  --tw-gradient-to: rgba(104, 56, 31, 0.75) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/80{
  --tw-gradient-to: rgba(104, 56, 31, 0.8) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/85{
  --tw-gradient-to: rgba(104, 56, 31, 0.85) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/90{
  --tw-gradient-to: rgba(104, 56, 31, 0.9) var(--tw-gradient-to-position);
}
.to-phrase-color-900\\/95{
  --tw-gradient-to: rgba(104, 56, 31, 0.95) var(--tw-gradient-to-position);
}
.to-phrase-color-950{
  --tw-gradient-to: #3b1c0d var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/0{
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/10{
  --tw-gradient-to: rgba(59, 28, 13, 0.1) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/100{
  --tw-gradient-to: rgb(59, 28, 13) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/15{
  --tw-gradient-to: rgba(59, 28, 13, 0.15) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/20{
  --tw-gradient-to: rgba(59, 28, 13, 0.2) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/25{
  --tw-gradient-to: rgba(59, 28, 13, 0.25) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/30{
  --tw-gradient-to: rgba(59, 28, 13, 0.3) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/35{
  --tw-gradient-to: rgba(59, 28, 13, 0.35) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/40{
  --tw-gradient-to: rgba(59, 28, 13, 0.4) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/45{
  --tw-gradient-to: rgba(59, 28, 13, 0.45) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/5{
  --tw-gradient-to: rgba(59, 28, 13, 0.05) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/50{
  --tw-gradient-to: rgba(59, 28, 13, 0.5) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/55{
  --tw-gradient-to: rgba(59, 28, 13, 0.55) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/60{
  --tw-gradient-to: rgba(59, 28, 13, 0.6) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/65{
  --tw-gradient-to: rgba(59, 28, 13, 0.65) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/70{
  --tw-gradient-to: rgba(59, 28, 13, 0.7) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/75{
  --tw-gradient-to: rgba(59, 28, 13, 0.75) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/80{
  --tw-gradient-to: rgba(59, 28, 13, 0.8) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/85{
  --tw-gradient-to: rgba(59, 28, 13, 0.85) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/90{
  --tw-gradient-to: rgba(59, 28, 13, 0.9) var(--tw-gradient-to-position);
}
.to-phrase-color-950\\/95{
  --tw-gradient-to: rgba(59, 28, 13, 0.95) var(--tw-gradient-to-position);
}
.to-scarlet-100{
  --tw-gradient-to: #ffdcdf var(--tw-gradient-to-position);
}
.to-scarlet-100\\/0{
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/10{
  --tw-gradient-to: rgba(255, 220, 223, 0.1) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/100{
  --tw-gradient-to: rgb(255, 220, 223) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/15{
  --tw-gradient-to: rgba(255, 220, 223, 0.15) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/20{
  --tw-gradient-to: rgba(255, 220, 223, 0.2) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/25{
  --tw-gradient-to: rgba(255, 220, 223, 0.25) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/30{
  --tw-gradient-to: rgba(255, 220, 223, 0.3) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/35{
  --tw-gradient-to: rgba(255, 220, 223, 0.35) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/40{
  --tw-gradient-to: rgba(255, 220, 223, 0.4) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/45{
  --tw-gradient-to: rgba(255, 220, 223, 0.45) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/5{
  --tw-gradient-to: rgba(255, 220, 223, 0.05) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/50{
  --tw-gradient-to: rgba(255, 220, 223, 0.5) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/55{
  --tw-gradient-to: rgba(255, 220, 223, 0.55) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/60{
  --tw-gradient-to: rgba(255, 220, 223, 0.6) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/65{
  --tw-gradient-to: rgba(255, 220, 223, 0.65) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/70{
  --tw-gradient-to: rgba(255, 220, 223, 0.7) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/75{
  --tw-gradient-to: rgba(255, 220, 223, 0.75) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/80{
  --tw-gradient-to: rgba(255, 220, 223, 0.8) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/85{
  --tw-gradient-to: rgba(255, 220, 223, 0.85) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/90{
  --tw-gradient-to: rgba(255, 220, 223, 0.9) var(--tw-gradient-to-position);
}
.to-scarlet-100\\/95{
  --tw-gradient-to: rgba(255, 220, 223, 0.95) var(--tw-gradient-to-position);
}
.to-scarlet-200{
  --tw-gradient-to: #ffc0c6 var(--tw-gradient-to-position);
}
.to-scarlet-200\\/0{
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/10{
  --tw-gradient-to: rgba(255, 192, 198, 0.1) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/100{
  --tw-gradient-to: rgb(255, 192, 198) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/15{
  --tw-gradient-to: rgba(255, 192, 198, 0.15) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/20{
  --tw-gradient-to: rgba(255, 192, 198, 0.2) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/25{
  --tw-gradient-to: rgba(255, 192, 198, 0.25) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/30{
  --tw-gradient-to: rgba(255, 192, 198, 0.3) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/35{
  --tw-gradient-to: rgba(255, 192, 198, 0.35) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/40{
  --tw-gradient-to: rgba(255, 192, 198, 0.4) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/45{
  --tw-gradient-to: rgba(255, 192, 198, 0.45) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/5{
  --tw-gradient-to: rgba(255, 192, 198, 0.05) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/50{
  --tw-gradient-to: rgba(255, 192, 198, 0.5) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/55{
  --tw-gradient-to: rgba(255, 192, 198, 0.55) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/60{
  --tw-gradient-to: rgba(255, 192, 198, 0.6) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/65{
  --tw-gradient-to: rgba(255, 192, 198, 0.65) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/70{
  --tw-gradient-to: rgba(255, 192, 198, 0.7) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/75{
  --tw-gradient-to: rgba(255, 192, 198, 0.75) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/80{
  --tw-gradient-to: rgba(255, 192, 198, 0.8) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/85{
  --tw-gradient-to: rgba(255, 192, 198, 0.85) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/90{
  --tw-gradient-to: rgba(255, 192, 198, 0.9) var(--tw-gradient-to-position);
}
.to-scarlet-200\\/95{
  --tw-gradient-to: rgba(255, 192, 198, 0.95) var(--tw-gradient-to-position);
}
.to-scarlet-300{
  --tw-gradient-to: #ff949e var(--tw-gradient-to-position);
}
.to-scarlet-300\\/0{
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/10{
  --tw-gradient-to: rgba(255, 148, 158, 0.1) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/100{
  --tw-gradient-to: rgb(255, 148, 158) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/15{
  --tw-gradient-to: rgba(255, 148, 158, 0.15) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/20{
  --tw-gradient-to: rgba(255, 148, 158, 0.2) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/25{
  --tw-gradient-to: rgba(255, 148, 158, 0.25) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/30{
  --tw-gradient-to: rgba(255, 148, 158, 0.3) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/35{
  --tw-gradient-to: rgba(255, 148, 158, 0.35) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/40{
  --tw-gradient-to: rgba(255, 148, 158, 0.4) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/45{
  --tw-gradient-to: rgba(255, 148, 158, 0.45) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/5{
  --tw-gradient-to: rgba(255, 148, 158, 0.05) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/50{
  --tw-gradient-to: rgba(255, 148, 158, 0.5) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/55{
  --tw-gradient-to: rgba(255, 148, 158, 0.55) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/60{
  --tw-gradient-to: rgba(255, 148, 158, 0.6) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/65{
  --tw-gradient-to: rgba(255, 148, 158, 0.65) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/70{
  --tw-gradient-to: rgba(255, 148, 158, 0.7) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/75{
  --tw-gradient-to: rgba(255, 148, 158, 0.75) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/80{
  --tw-gradient-to: rgba(255, 148, 158, 0.8) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/85{
  --tw-gradient-to: rgba(255, 148, 158, 0.85) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/90{
  --tw-gradient-to: rgba(255, 148, 158, 0.9) var(--tw-gradient-to-position);
}
.to-scarlet-300\\/95{
  --tw-gradient-to: rgba(255, 148, 158, 0.95) var(--tw-gradient-to-position);
}
.to-scarlet-400{
  --tw-gradient-to: #ff5665 var(--tw-gradient-to-position);
}
.to-scarlet-400\\/0{
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/10{
  --tw-gradient-to: rgba(255, 86, 101, 0.1) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/100{
  --tw-gradient-to: rgb(255, 86, 101) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/15{
  --tw-gradient-to: rgba(255, 86, 101, 0.15) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/20{
  --tw-gradient-to: rgba(255, 86, 101, 0.2) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/25{
  --tw-gradient-to: rgba(255, 86, 101, 0.25) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/30{
  --tw-gradient-to: rgba(255, 86, 101, 0.3) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/35{
  --tw-gradient-to: rgba(255, 86, 101, 0.35) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/40{
  --tw-gradient-to: rgba(255, 86, 101, 0.4) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/45{
  --tw-gradient-to: rgba(255, 86, 101, 0.45) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/5{
  --tw-gradient-to: rgba(255, 86, 101, 0.05) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/50{
  --tw-gradient-to: rgba(255, 86, 101, 0.5) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/55{
  --tw-gradient-to: rgba(255, 86, 101, 0.55) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/60{
  --tw-gradient-to: rgba(255, 86, 101, 0.6) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/65{
  --tw-gradient-to: rgba(255, 86, 101, 0.65) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/70{
  --tw-gradient-to: rgba(255, 86, 101, 0.7) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/75{
  --tw-gradient-to: rgba(255, 86, 101, 0.75) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/80{
  --tw-gradient-to: rgba(255, 86, 101, 0.8) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/85{
  --tw-gradient-to: rgba(255, 86, 101, 0.85) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/90{
  --tw-gradient-to: rgba(255, 86, 101, 0.9) var(--tw-gradient-to-position);
}
.to-scarlet-400\\/95{
  --tw-gradient-to: rgba(255, 86, 101, 0.95) var(--tw-gradient-to-position);
}
.to-scarlet-500{
  --tw-gradient-to: #ff2236 var(--tw-gradient-to-position);
}
.to-scarlet-500\\/0{
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/10{
  --tw-gradient-to: rgba(255, 34, 54, 0.1) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/100{
  --tw-gradient-to: rgb(255, 34, 54) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/15{
  --tw-gradient-to: rgba(255, 34, 54, 0.15) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/20{
  --tw-gradient-to: rgba(255, 34, 54, 0.2) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/25{
  --tw-gradient-to: rgba(255, 34, 54, 0.25) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/30{
  --tw-gradient-to: rgba(255, 34, 54, 0.3) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/35{
  --tw-gradient-to: rgba(255, 34, 54, 0.35) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/40{
  --tw-gradient-to: rgba(255, 34, 54, 0.4) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/45{
  --tw-gradient-to: rgba(255, 34, 54, 0.45) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/5{
  --tw-gradient-to: rgba(255, 34, 54, 0.05) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/50{
  --tw-gradient-to: rgba(255, 34, 54, 0.5) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/55{
  --tw-gradient-to: rgba(255, 34, 54, 0.55) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/60{
  --tw-gradient-to: rgba(255, 34, 54, 0.6) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/65{
  --tw-gradient-to: rgba(255, 34, 54, 0.65) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/70{
  --tw-gradient-to: rgba(255, 34, 54, 0.7) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/75{
  --tw-gradient-to: rgba(255, 34, 54, 0.75) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/80{
  --tw-gradient-to: rgba(255, 34, 54, 0.8) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/85{
  --tw-gradient-to: rgba(255, 34, 54, 0.85) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/90{
  --tw-gradient-to: rgba(255, 34, 54, 0.9) var(--tw-gradient-to-position);
}
.to-scarlet-500\\/95{
  --tw-gradient-to: rgba(255, 34, 54, 0.95) var(--tw-gradient-to-position);
}
.to-scarlet-600{
  --tw-gradient-to: #ff0219 var(--tw-gradient-to-position);
}
.to-scarlet-600\\/0{
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/10{
  --tw-gradient-to: rgba(255, 2, 25, 0.1) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/100{
  --tw-gradient-to: rgb(255, 2, 25) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/15{
  --tw-gradient-to: rgba(255, 2, 25, 0.15) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/20{
  --tw-gradient-to: rgba(255, 2, 25, 0.2) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/25{
  --tw-gradient-to: rgba(255, 2, 25, 0.25) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/30{
  --tw-gradient-to: rgba(255, 2, 25, 0.3) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/35{
  --tw-gradient-to: rgba(255, 2, 25, 0.35) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/40{
  --tw-gradient-to: rgba(255, 2, 25, 0.4) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/45{
  --tw-gradient-to: rgba(255, 2, 25, 0.45) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/5{
  --tw-gradient-to: rgba(255, 2, 25, 0.05) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/50{
  --tw-gradient-to: rgba(255, 2, 25, 0.5) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/55{
  --tw-gradient-to: rgba(255, 2, 25, 0.55) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/60{
  --tw-gradient-to: rgba(255, 2, 25, 0.6) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/65{
  --tw-gradient-to: rgba(255, 2, 25, 0.65) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/70{
  --tw-gradient-to: rgba(255, 2, 25, 0.7) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/75{
  --tw-gradient-to: rgba(255, 2, 25, 0.75) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/80{
  --tw-gradient-to: rgba(255, 2, 25, 0.8) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/85{
  --tw-gradient-to: rgba(255, 2, 25, 0.85) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/90{
  --tw-gradient-to: rgba(255, 2, 25, 0.9) var(--tw-gradient-to-position);
}
.to-scarlet-600\\/95{
  --tw-gradient-to: rgba(255, 2, 25, 0.95) var(--tw-gradient-to-position);
}
.to-scarlet-700{
  --tw-gradient-to: #d80013 var(--tw-gradient-to-position);
}
.to-scarlet-700\\/0{
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/10{
  --tw-gradient-to: rgba(216, 0, 19, 0.1) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/100{
  --tw-gradient-to: rgb(216, 0, 19) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/15{
  --tw-gradient-to: rgba(216, 0, 19, 0.15) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/20{
  --tw-gradient-to: rgba(216, 0, 19, 0.2) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/25{
  --tw-gradient-to: rgba(216, 0, 19, 0.25) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/30{
  --tw-gradient-to: rgba(216, 0, 19, 0.3) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/35{
  --tw-gradient-to: rgba(216, 0, 19, 0.35) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/40{
  --tw-gradient-to: rgba(216, 0, 19, 0.4) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/45{
  --tw-gradient-to: rgba(216, 0, 19, 0.45) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/5{
  --tw-gradient-to: rgba(216, 0, 19, 0.05) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/50{
  --tw-gradient-to: rgba(216, 0, 19, 0.5) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/55{
  --tw-gradient-to: rgba(216, 0, 19, 0.55) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/60{
  --tw-gradient-to: rgba(216, 0, 19, 0.6) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/65{
  --tw-gradient-to: rgba(216, 0, 19, 0.65) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/70{
  --tw-gradient-to: rgba(216, 0, 19, 0.7) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/75{
  --tw-gradient-to: rgba(216, 0, 19, 0.75) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/80{
  --tw-gradient-to: rgba(216, 0, 19, 0.8) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/85{
  --tw-gradient-to: rgba(216, 0, 19, 0.85) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/90{
  --tw-gradient-to: rgba(216, 0, 19, 0.9) var(--tw-gradient-to-position);
}
.to-scarlet-700\\/95{
  --tw-gradient-to: rgba(216, 0, 19, 0.95) var(--tw-gradient-to-position);
}
.to-scarlet-800{
  --tw-gradient-to: #b40212 var(--tw-gradient-to-position);
}
.to-scarlet-800\\/0{
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/10{
  --tw-gradient-to: rgba(180, 2, 18, 0.1) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/100{
  --tw-gradient-to: rgb(180, 2, 18) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/15{
  --tw-gradient-to: rgba(180, 2, 18, 0.15) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/20{
  --tw-gradient-to: rgba(180, 2, 18, 0.2) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/25{
  --tw-gradient-to: rgba(180, 2, 18, 0.25) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/30{
  --tw-gradient-to: rgba(180, 2, 18, 0.3) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/35{
  --tw-gradient-to: rgba(180, 2, 18, 0.35) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/40{
  --tw-gradient-to: rgba(180, 2, 18, 0.4) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/45{
  --tw-gradient-to: rgba(180, 2, 18, 0.45) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/5{
  --tw-gradient-to: rgba(180, 2, 18, 0.05) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/50{
  --tw-gradient-to: rgba(180, 2, 18, 0.5) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/55{
  --tw-gradient-to: rgba(180, 2, 18, 0.55) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/60{
  --tw-gradient-to: rgba(180, 2, 18, 0.6) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/65{
  --tw-gradient-to: rgba(180, 2, 18, 0.65) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/70{
  --tw-gradient-to: rgba(180, 2, 18, 0.7) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/75{
  --tw-gradient-to: rgba(180, 2, 18, 0.75) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/80{
  --tw-gradient-to: rgba(180, 2, 18, 0.8) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/85{
  --tw-gradient-to: rgba(180, 2, 18, 0.85) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/90{
  --tw-gradient-to: rgba(180, 2, 18, 0.9) var(--tw-gradient-to-position);
}
.to-scarlet-800\\/95{
  --tw-gradient-to: rgba(180, 2, 18, 0.95) var(--tw-gradient-to-position);
}
.to-scarlet-900{
  --tw-gradient-to: #920a16 var(--tw-gradient-to-position);
}
.to-scarlet-900\\/0{
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/10{
  --tw-gradient-to: rgba(146, 10, 22, 0.1) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/100{
  --tw-gradient-to: rgb(146, 10, 22) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/15{
  --tw-gradient-to: rgba(146, 10, 22, 0.15) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/20{
  --tw-gradient-to: rgba(146, 10, 22, 0.2) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/25{
  --tw-gradient-to: rgba(146, 10, 22, 0.25) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/30{
  --tw-gradient-to: rgba(146, 10, 22, 0.3) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/35{
  --tw-gradient-to: rgba(146, 10, 22, 0.35) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/40{
  --tw-gradient-to: rgba(146, 10, 22, 0.4) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/45{
  --tw-gradient-to: rgba(146, 10, 22, 0.45) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/5{
  --tw-gradient-to: rgba(146, 10, 22, 0.05) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/50{
  --tw-gradient-to: rgba(146, 10, 22, 0.5) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/55{
  --tw-gradient-to: rgba(146, 10, 22, 0.55) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/60{
  --tw-gradient-to: rgba(146, 10, 22, 0.6) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/65{
  --tw-gradient-to: rgba(146, 10, 22, 0.65) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/70{
  --tw-gradient-to: rgba(146, 10, 22, 0.7) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/75{
  --tw-gradient-to: rgba(146, 10, 22, 0.75) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/80{
  --tw-gradient-to: rgba(146, 10, 22, 0.8) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/85{
  --tw-gradient-to: rgba(146, 10, 22, 0.85) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/90{
  --tw-gradient-to: rgba(146, 10, 22, 0.9) var(--tw-gradient-to-position);
}
.to-scarlet-900\\/95{
  --tw-gradient-to: rgba(146, 10, 22, 0.95) var(--tw-gradient-to-position);
}
.to-scarlet-950{
  --tw-gradient-to: #510007 var(--tw-gradient-to-position);
}
.to-scarlet-950\\/0{
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/10{
  --tw-gradient-to: rgba(81, 0, 7, 0.1) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/100{
  --tw-gradient-to: rgb(81, 0, 7) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/15{
  --tw-gradient-to: rgba(81, 0, 7, 0.15) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/20{
  --tw-gradient-to: rgba(81, 0, 7, 0.2) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/25{
  --tw-gradient-to: rgba(81, 0, 7, 0.25) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/30{
  --tw-gradient-to: rgba(81, 0, 7, 0.3) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/35{
  --tw-gradient-to: rgba(81, 0, 7, 0.35) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/40{
  --tw-gradient-to: rgba(81, 0, 7, 0.4) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/45{
  --tw-gradient-to: rgba(81, 0, 7, 0.45) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/5{
  --tw-gradient-to: rgba(81, 0, 7, 0.05) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/50{
  --tw-gradient-to: rgba(81, 0, 7, 0.5) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/55{
  --tw-gradient-to: rgba(81, 0, 7, 0.55) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/60{
  --tw-gradient-to: rgba(81, 0, 7, 0.6) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/65{
  --tw-gradient-to: rgba(81, 0, 7, 0.65) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/70{
  --tw-gradient-to: rgba(81, 0, 7, 0.7) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/75{
  --tw-gradient-to: rgba(81, 0, 7, 0.75) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/80{
  --tw-gradient-to: rgba(81, 0, 7, 0.8) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/85{
  --tw-gradient-to: rgba(81, 0, 7, 0.85) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/90{
  --tw-gradient-to: rgba(81, 0, 7, 0.9) var(--tw-gradient-to-position);
}
.to-scarlet-950\\/95{
  --tw-gradient-to: rgba(81, 0, 7, 0.95) var(--tw-gradient-to-position);
}
.to-song-color-100{
  --tw-gradient-to: #ffdcdf var(--tw-gradient-to-position);
}
.to-song-color-100\\/0{
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
}
.to-song-color-100\\/10{
  --tw-gradient-to: rgba(255, 220, 223, 0.1) var(--tw-gradient-to-position);
}
.to-song-color-100\\/100{
  --tw-gradient-to: rgb(255, 220, 223) var(--tw-gradient-to-position);
}
.to-song-color-100\\/15{
  --tw-gradient-to: rgba(255, 220, 223, 0.15) var(--tw-gradient-to-position);
}
.to-song-color-100\\/20{
  --tw-gradient-to: rgba(255, 220, 223, 0.2) var(--tw-gradient-to-position);
}
.to-song-color-100\\/25{
  --tw-gradient-to: rgba(255, 220, 223, 0.25) var(--tw-gradient-to-position);
}
.to-song-color-100\\/30{
  --tw-gradient-to: rgba(255, 220, 223, 0.3) var(--tw-gradient-to-position);
}
.to-song-color-100\\/35{
  --tw-gradient-to: rgba(255, 220, 223, 0.35) var(--tw-gradient-to-position);
}
.to-song-color-100\\/40{
  --tw-gradient-to: rgba(255, 220, 223, 0.4) var(--tw-gradient-to-position);
}
.to-song-color-100\\/45{
  --tw-gradient-to: rgba(255, 220, 223, 0.45) var(--tw-gradient-to-position);
}
.to-song-color-100\\/5{
  --tw-gradient-to: rgba(255, 220, 223, 0.05) var(--tw-gradient-to-position);
}
.to-song-color-100\\/50{
  --tw-gradient-to: rgba(255, 220, 223, 0.5) var(--tw-gradient-to-position);
}
.to-song-color-100\\/55{
  --tw-gradient-to: rgba(255, 220, 223, 0.55) var(--tw-gradient-to-position);
}
.to-song-color-100\\/60{
  --tw-gradient-to: rgba(255, 220, 223, 0.6) var(--tw-gradient-to-position);
}
.to-song-color-100\\/65{
  --tw-gradient-to: rgba(255, 220, 223, 0.65) var(--tw-gradient-to-position);
}
.to-song-color-100\\/70{
  --tw-gradient-to: rgba(255, 220, 223, 0.7) var(--tw-gradient-to-position);
}
.to-song-color-100\\/75{
  --tw-gradient-to: rgba(255, 220, 223, 0.75) var(--tw-gradient-to-position);
}
.to-song-color-100\\/80{
  --tw-gradient-to: rgba(255, 220, 223, 0.8) var(--tw-gradient-to-position);
}
.to-song-color-100\\/85{
  --tw-gradient-to: rgba(255, 220, 223, 0.85) var(--tw-gradient-to-position);
}
.to-song-color-100\\/90{
  --tw-gradient-to: rgba(255, 220, 223, 0.9) var(--tw-gradient-to-position);
}
.to-song-color-100\\/95{
  --tw-gradient-to: rgba(255, 220, 223, 0.95) var(--tw-gradient-to-position);
}
.to-song-color-200{
  --tw-gradient-to: #ffc0c6 var(--tw-gradient-to-position);
}
.to-song-color-200\\/0{
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
}
.to-song-color-200\\/10{
  --tw-gradient-to: rgba(255, 192, 198, 0.1) var(--tw-gradient-to-position);
}
.to-song-color-200\\/100{
  --tw-gradient-to: rgb(255, 192, 198) var(--tw-gradient-to-position);
}
.to-song-color-200\\/15{
  --tw-gradient-to: rgba(255, 192, 198, 0.15) var(--tw-gradient-to-position);
}
.to-song-color-200\\/20{
  --tw-gradient-to: rgba(255, 192, 198, 0.2) var(--tw-gradient-to-position);
}
.to-song-color-200\\/25{
  --tw-gradient-to: rgba(255, 192, 198, 0.25) var(--tw-gradient-to-position);
}
.to-song-color-200\\/30{
  --tw-gradient-to: rgba(255, 192, 198, 0.3) var(--tw-gradient-to-position);
}
.to-song-color-200\\/35{
  --tw-gradient-to: rgba(255, 192, 198, 0.35) var(--tw-gradient-to-position);
}
.to-song-color-200\\/40{
  --tw-gradient-to: rgba(255, 192, 198, 0.4) var(--tw-gradient-to-position);
}
.to-song-color-200\\/45{
  --tw-gradient-to: rgba(255, 192, 198, 0.45) var(--tw-gradient-to-position);
}
.to-song-color-200\\/5{
  --tw-gradient-to: rgba(255, 192, 198, 0.05) var(--tw-gradient-to-position);
}
.to-song-color-200\\/50{
  --tw-gradient-to: rgba(255, 192, 198, 0.5) var(--tw-gradient-to-position);
}
.to-song-color-200\\/55{
  --tw-gradient-to: rgba(255, 192, 198, 0.55) var(--tw-gradient-to-position);
}
.to-song-color-200\\/60{
  --tw-gradient-to: rgba(255, 192, 198, 0.6) var(--tw-gradient-to-position);
}
.to-song-color-200\\/65{
  --tw-gradient-to: rgba(255, 192, 198, 0.65) var(--tw-gradient-to-position);
}
.to-song-color-200\\/70{
  --tw-gradient-to: rgba(255, 192, 198, 0.7) var(--tw-gradient-to-position);
}
.to-song-color-200\\/75{
  --tw-gradient-to: rgba(255, 192, 198, 0.75) var(--tw-gradient-to-position);
}
.to-song-color-200\\/80{
  --tw-gradient-to: rgba(255, 192, 198, 0.8) var(--tw-gradient-to-position);
}
.to-song-color-200\\/85{
  --tw-gradient-to: rgba(255, 192, 198, 0.85) var(--tw-gradient-to-position);
}
.to-song-color-200\\/90{
  --tw-gradient-to: rgba(255, 192, 198, 0.9) var(--tw-gradient-to-position);
}
.to-song-color-200\\/95{
  --tw-gradient-to: rgba(255, 192, 198, 0.95) var(--tw-gradient-to-position);
}
.to-song-color-300{
  --tw-gradient-to: #ff949e var(--tw-gradient-to-position);
}
.to-song-color-300\\/0{
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
}
.to-song-color-300\\/10{
  --tw-gradient-to: rgba(255, 148, 158, 0.1) var(--tw-gradient-to-position);
}
.to-song-color-300\\/100{
  --tw-gradient-to: rgb(255, 148, 158) var(--tw-gradient-to-position);
}
.to-song-color-300\\/15{
  --tw-gradient-to: rgba(255, 148, 158, 0.15) var(--tw-gradient-to-position);
}
.to-song-color-300\\/20{
  --tw-gradient-to: rgba(255, 148, 158, 0.2) var(--tw-gradient-to-position);
}
.to-song-color-300\\/25{
  --tw-gradient-to: rgba(255, 148, 158, 0.25) var(--tw-gradient-to-position);
}
.to-song-color-300\\/30{
  --tw-gradient-to: rgba(255, 148, 158, 0.3) var(--tw-gradient-to-position);
}
.to-song-color-300\\/35{
  --tw-gradient-to: rgba(255, 148, 158, 0.35) var(--tw-gradient-to-position);
}
.to-song-color-300\\/40{
  --tw-gradient-to: rgba(255, 148, 158, 0.4) var(--tw-gradient-to-position);
}
.to-song-color-300\\/45{
  --tw-gradient-to: rgba(255, 148, 158, 0.45) var(--tw-gradient-to-position);
}
.to-song-color-300\\/5{
  --tw-gradient-to: rgba(255, 148, 158, 0.05) var(--tw-gradient-to-position);
}
.to-song-color-300\\/50{
  --tw-gradient-to: rgba(255, 148, 158, 0.5) var(--tw-gradient-to-position);
}
.to-song-color-300\\/55{
  --tw-gradient-to: rgba(255, 148, 158, 0.55) var(--tw-gradient-to-position);
}
.to-song-color-300\\/60{
  --tw-gradient-to: rgba(255, 148, 158, 0.6) var(--tw-gradient-to-position);
}
.to-song-color-300\\/65{
  --tw-gradient-to: rgba(255, 148, 158, 0.65) var(--tw-gradient-to-position);
}
.to-song-color-300\\/70{
  --tw-gradient-to: rgba(255, 148, 158, 0.7) var(--tw-gradient-to-position);
}
.to-song-color-300\\/75{
  --tw-gradient-to: rgba(255, 148, 158, 0.75) var(--tw-gradient-to-position);
}
.to-song-color-300\\/80{
  --tw-gradient-to: rgba(255, 148, 158, 0.8) var(--tw-gradient-to-position);
}
.to-song-color-300\\/85{
  --tw-gradient-to: rgba(255, 148, 158, 0.85) var(--tw-gradient-to-position);
}
.to-song-color-300\\/90{
  --tw-gradient-to: rgba(255, 148, 158, 0.9) var(--tw-gradient-to-position);
}
.to-song-color-300\\/95{
  --tw-gradient-to: rgba(255, 148, 158, 0.95) var(--tw-gradient-to-position);
}
.to-song-color-400{
  --tw-gradient-to: #ff5665 var(--tw-gradient-to-position);
}
.to-song-color-400\\/0{
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
}
.to-song-color-400\\/10{
  --tw-gradient-to: rgba(255, 86, 101, 0.1) var(--tw-gradient-to-position);
}
.to-song-color-400\\/100{
  --tw-gradient-to: rgb(255, 86, 101) var(--tw-gradient-to-position);
}
.to-song-color-400\\/15{
  --tw-gradient-to: rgba(255, 86, 101, 0.15) var(--tw-gradient-to-position);
}
.to-song-color-400\\/20{
  --tw-gradient-to: rgba(255, 86, 101, 0.2) var(--tw-gradient-to-position);
}
.to-song-color-400\\/25{
  --tw-gradient-to: rgba(255, 86, 101, 0.25) var(--tw-gradient-to-position);
}
.to-song-color-400\\/30{
  --tw-gradient-to: rgba(255, 86, 101, 0.3) var(--tw-gradient-to-position);
}
.to-song-color-400\\/35{
  --tw-gradient-to: rgba(255, 86, 101, 0.35) var(--tw-gradient-to-position);
}
.to-song-color-400\\/40{
  --tw-gradient-to: rgba(255, 86, 101, 0.4) var(--tw-gradient-to-position);
}
.to-song-color-400\\/45{
  --tw-gradient-to: rgba(255, 86, 101, 0.45) var(--tw-gradient-to-position);
}
.to-song-color-400\\/5{
  --tw-gradient-to: rgba(255, 86, 101, 0.05) var(--tw-gradient-to-position);
}
.to-song-color-400\\/50{
  --tw-gradient-to: rgba(255, 86, 101, 0.5) var(--tw-gradient-to-position);
}
.to-song-color-400\\/55{
  --tw-gradient-to: rgba(255, 86, 101, 0.55) var(--tw-gradient-to-position);
}
.to-song-color-400\\/60{
  --tw-gradient-to: rgba(255, 86, 101, 0.6) var(--tw-gradient-to-position);
}
.to-song-color-400\\/65{
  --tw-gradient-to: rgba(255, 86, 101, 0.65) var(--tw-gradient-to-position);
}
.to-song-color-400\\/70{
  --tw-gradient-to: rgba(255, 86, 101, 0.7) var(--tw-gradient-to-position);
}
.to-song-color-400\\/75{
  --tw-gradient-to: rgba(255, 86, 101, 0.75) var(--tw-gradient-to-position);
}
.to-song-color-400\\/80{
  --tw-gradient-to: rgba(255, 86, 101, 0.8) var(--tw-gradient-to-position);
}
.to-song-color-400\\/85{
  --tw-gradient-to: rgba(255, 86, 101, 0.85) var(--tw-gradient-to-position);
}
.to-song-color-400\\/90{
  --tw-gradient-to: rgba(255, 86, 101, 0.9) var(--tw-gradient-to-position);
}
.to-song-color-400\\/95{
  --tw-gradient-to: rgba(255, 86, 101, 0.95) var(--tw-gradient-to-position);
}
.to-song-color-500{
  --tw-gradient-to: #ff2236 var(--tw-gradient-to-position);
}
.to-song-color-500\\/0{
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
}
.to-song-color-500\\/10{
  --tw-gradient-to: rgba(255, 34, 54, 0.1) var(--tw-gradient-to-position);
}
.to-song-color-500\\/100{
  --tw-gradient-to: rgb(255, 34, 54) var(--tw-gradient-to-position);
}
.to-song-color-500\\/15{
  --tw-gradient-to: rgba(255, 34, 54, 0.15) var(--tw-gradient-to-position);
}
.to-song-color-500\\/20{
  --tw-gradient-to: rgba(255, 34, 54, 0.2) var(--tw-gradient-to-position);
}
.to-song-color-500\\/25{
  --tw-gradient-to: rgba(255, 34, 54, 0.25) var(--tw-gradient-to-position);
}
.to-song-color-500\\/30{
  --tw-gradient-to: rgba(255, 34, 54, 0.3) var(--tw-gradient-to-position);
}
.to-song-color-500\\/35{
  --tw-gradient-to: rgba(255, 34, 54, 0.35) var(--tw-gradient-to-position);
}
.to-song-color-500\\/40{
  --tw-gradient-to: rgba(255, 34, 54, 0.4) var(--tw-gradient-to-position);
}
.to-song-color-500\\/45{
  --tw-gradient-to: rgba(255, 34, 54, 0.45) var(--tw-gradient-to-position);
}
.to-song-color-500\\/5{
  --tw-gradient-to: rgba(255, 34, 54, 0.05) var(--tw-gradient-to-position);
}
.to-song-color-500\\/50{
  --tw-gradient-to: rgba(255, 34, 54, 0.5) var(--tw-gradient-to-position);
}
.to-song-color-500\\/55{
  --tw-gradient-to: rgba(255, 34, 54, 0.55) var(--tw-gradient-to-position);
}
.to-song-color-500\\/60{
  --tw-gradient-to: rgba(255, 34, 54, 0.6) var(--tw-gradient-to-position);
}
.to-song-color-500\\/65{
  --tw-gradient-to: rgba(255, 34, 54, 0.65) var(--tw-gradient-to-position);
}
.to-song-color-500\\/70{
  --tw-gradient-to: rgba(255, 34, 54, 0.7) var(--tw-gradient-to-position);
}
.to-song-color-500\\/75{
  --tw-gradient-to: rgba(255, 34, 54, 0.75) var(--tw-gradient-to-position);
}
.to-song-color-500\\/80{
  --tw-gradient-to: rgba(255, 34, 54, 0.8) var(--tw-gradient-to-position);
}
.to-song-color-500\\/85{
  --tw-gradient-to: rgba(255, 34, 54, 0.85) var(--tw-gradient-to-position);
}
.to-song-color-500\\/90{
  --tw-gradient-to: rgba(255, 34, 54, 0.9) var(--tw-gradient-to-position);
}
.to-song-color-500\\/95{
  --tw-gradient-to: rgba(255, 34, 54, 0.95) var(--tw-gradient-to-position);
}
.to-song-color-600{
  --tw-gradient-to: #ff0219 var(--tw-gradient-to-position);
}
.to-song-color-600\\/0{
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
}
.to-song-color-600\\/10{
  --tw-gradient-to: rgba(255, 2, 25, 0.1) var(--tw-gradient-to-position);
}
.to-song-color-600\\/100{
  --tw-gradient-to: rgb(255, 2, 25) var(--tw-gradient-to-position);
}
.to-song-color-600\\/15{
  --tw-gradient-to: rgba(255, 2, 25, 0.15) var(--tw-gradient-to-position);
}
.to-song-color-600\\/20{
  --tw-gradient-to: rgba(255, 2, 25, 0.2) var(--tw-gradient-to-position);
}
.to-song-color-600\\/25{
  --tw-gradient-to: rgba(255, 2, 25, 0.25) var(--tw-gradient-to-position);
}
.to-song-color-600\\/30{
  --tw-gradient-to: rgba(255, 2, 25, 0.3) var(--tw-gradient-to-position);
}
.to-song-color-600\\/35{
  --tw-gradient-to: rgba(255, 2, 25, 0.35) var(--tw-gradient-to-position);
}
.to-song-color-600\\/40{
  --tw-gradient-to: rgba(255, 2, 25, 0.4) var(--tw-gradient-to-position);
}
.to-song-color-600\\/45{
  --tw-gradient-to: rgba(255, 2, 25, 0.45) var(--tw-gradient-to-position);
}
.to-song-color-600\\/5{
  --tw-gradient-to: rgba(255, 2, 25, 0.05) var(--tw-gradient-to-position);
}
.to-song-color-600\\/50{
  --tw-gradient-to: rgba(255, 2, 25, 0.5) var(--tw-gradient-to-position);
}
.to-song-color-600\\/55{
  --tw-gradient-to: rgba(255, 2, 25, 0.55) var(--tw-gradient-to-position);
}
.to-song-color-600\\/60{
  --tw-gradient-to: rgba(255, 2, 25, 0.6) var(--tw-gradient-to-position);
}
.to-song-color-600\\/65{
  --tw-gradient-to: rgba(255, 2, 25, 0.65) var(--tw-gradient-to-position);
}
.to-song-color-600\\/70{
  --tw-gradient-to: rgba(255, 2, 25, 0.7) var(--tw-gradient-to-position);
}
.to-song-color-600\\/75{
  --tw-gradient-to: rgba(255, 2, 25, 0.75) var(--tw-gradient-to-position);
}
.to-song-color-600\\/80{
  --tw-gradient-to: rgba(255, 2, 25, 0.8) var(--tw-gradient-to-position);
}
.to-song-color-600\\/85{
  --tw-gradient-to: rgba(255, 2, 25, 0.85) var(--tw-gradient-to-position);
}
.to-song-color-600\\/90{
  --tw-gradient-to: rgba(255, 2, 25, 0.9) var(--tw-gradient-to-position);
}
.to-song-color-600\\/95{
  --tw-gradient-to: rgba(255, 2, 25, 0.95) var(--tw-gradient-to-position);
}
.to-song-color-700{
  --tw-gradient-to: #d80013 var(--tw-gradient-to-position);
}
.to-song-color-700\\/0{
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
}
.to-song-color-700\\/10{
  --tw-gradient-to: rgba(216, 0, 19, 0.1) var(--tw-gradient-to-position);
}
.to-song-color-700\\/100{
  --tw-gradient-to: rgb(216, 0, 19) var(--tw-gradient-to-position);
}
.to-song-color-700\\/15{
  --tw-gradient-to: rgba(216, 0, 19, 0.15) var(--tw-gradient-to-position);
}
.to-song-color-700\\/20{
  --tw-gradient-to: rgba(216, 0, 19, 0.2) var(--tw-gradient-to-position);
}
.to-song-color-700\\/25{
  --tw-gradient-to: rgba(216, 0, 19, 0.25) var(--tw-gradient-to-position);
}
.to-song-color-700\\/30{
  --tw-gradient-to: rgba(216, 0, 19, 0.3) var(--tw-gradient-to-position);
}
.to-song-color-700\\/35{
  --tw-gradient-to: rgba(216, 0, 19, 0.35) var(--tw-gradient-to-position);
}
.to-song-color-700\\/40{
  --tw-gradient-to: rgba(216, 0, 19, 0.4) var(--tw-gradient-to-position);
}
.to-song-color-700\\/45{
  --tw-gradient-to: rgba(216, 0, 19, 0.45) var(--tw-gradient-to-position);
}
.to-song-color-700\\/5{
  --tw-gradient-to: rgba(216, 0, 19, 0.05) var(--tw-gradient-to-position);
}
.to-song-color-700\\/50{
  --tw-gradient-to: rgba(216, 0, 19, 0.5) var(--tw-gradient-to-position);
}
.to-song-color-700\\/55{
  --tw-gradient-to: rgba(216, 0, 19, 0.55) var(--tw-gradient-to-position);
}
.to-song-color-700\\/60{
  --tw-gradient-to: rgba(216, 0, 19, 0.6) var(--tw-gradient-to-position);
}
.to-song-color-700\\/65{
  --tw-gradient-to: rgba(216, 0, 19, 0.65) var(--tw-gradient-to-position);
}
.to-song-color-700\\/70{
  --tw-gradient-to: rgba(216, 0, 19, 0.7) var(--tw-gradient-to-position);
}
.to-song-color-700\\/75{
  --tw-gradient-to: rgba(216, 0, 19, 0.75) var(--tw-gradient-to-position);
}
.to-song-color-700\\/80{
  --tw-gradient-to: rgba(216, 0, 19, 0.8) var(--tw-gradient-to-position);
}
.to-song-color-700\\/85{
  --tw-gradient-to: rgba(216, 0, 19, 0.85) var(--tw-gradient-to-position);
}
.to-song-color-700\\/90{
  --tw-gradient-to: rgba(216, 0, 19, 0.9) var(--tw-gradient-to-position);
}
.to-song-color-700\\/95{
  --tw-gradient-to: rgba(216, 0, 19, 0.95) var(--tw-gradient-to-position);
}
.to-song-color-800{
  --tw-gradient-to: #b40212 var(--tw-gradient-to-position);
}
.to-song-color-800\\/0{
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
}
.to-song-color-800\\/10{
  --tw-gradient-to: rgba(180, 2, 18, 0.1) var(--tw-gradient-to-position);
}
.to-song-color-800\\/100{
  --tw-gradient-to: rgb(180, 2, 18) var(--tw-gradient-to-position);
}
.to-song-color-800\\/15{
  --tw-gradient-to: rgba(180, 2, 18, 0.15) var(--tw-gradient-to-position);
}
.to-song-color-800\\/20{
  --tw-gradient-to: rgba(180, 2, 18, 0.2) var(--tw-gradient-to-position);
}
.to-song-color-800\\/25{
  --tw-gradient-to: rgba(180, 2, 18, 0.25) var(--tw-gradient-to-position);
}
.to-song-color-800\\/30{
  --tw-gradient-to: rgba(180, 2, 18, 0.3) var(--tw-gradient-to-position);
}
.to-song-color-800\\/35{
  --tw-gradient-to: rgba(180, 2, 18, 0.35) var(--tw-gradient-to-position);
}
.to-song-color-800\\/40{
  --tw-gradient-to: rgba(180, 2, 18, 0.4) var(--tw-gradient-to-position);
}
.to-song-color-800\\/45{
  --tw-gradient-to: rgba(180, 2, 18, 0.45) var(--tw-gradient-to-position);
}
.to-song-color-800\\/5{
  --tw-gradient-to: rgba(180, 2, 18, 0.05) var(--tw-gradient-to-position);
}
.to-song-color-800\\/50{
  --tw-gradient-to: rgba(180, 2, 18, 0.5) var(--tw-gradient-to-position);
}
.to-song-color-800\\/55{
  --tw-gradient-to: rgba(180, 2, 18, 0.55) var(--tw-gradient-to-position);
}
.to-song-color-800\\/60{
  --tw-gradient-to: rgba(180, 2, 18, 0.6) var(--tw-gradient-to-position);
}
.to-song-color-800\\/65{
  --tw-gradient-to: rgba(180, 2, 18, 0.65) var(--tw-gradient-to-position);
}
.to-song-color-800\\/70{
  --tw-gradient-to: rgba(180, 2, 18, 0.7) var(--tw-gradient-to-position);
}
.to-song-color-800\\/75{
  --tw-gradient-to: rgba(180, 2, 18, 0.75) var(--tw-gradient-to-position);
}
.to-song-color-800\\/80{
  --tw-gradient-to: rgba(180, 2, 18, 0.8) var(--tw-gradient-to-position);
}
.to-song-color-800\\/85{
  --tw-gradient-to: rgba(180, 2, 18, 0.85) var(--tw-gradient-to-position);
}
.to-song-color-800\\/90{
  --tw-gradient-to: rgba(180, 2, 18, 0.9) var(--tw-gradient-to-position);
}
.to-song-color-800\\/95{
  --tw-gradient-to: rgba(180, 2, 18, 0.95) var(--tw-gradient-to-position);
}
.to-song-color-900{
  --tw-gradient-to: #920a16 var(--tw-gradient-to-position);
}
.to-song-color-900\\/0{
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
}
.to-song-color-900\\/10{
  --tw-gradient-to: rgba(146, 10, 22, 0.1) var(--tw-gradient-to-position);
}
.to-song-color-900\\/100{
  --tw-gradient-to: rgb(146, 10, 22) var(--tw-gradient-to-position);
}
.to-song-color-900\\/15{
  --tw-gradient-to: rgba(146, 10, 22, 0.15) var(--tw-gradient-to-position);
}
.to-song-color-900\\/20{
  --tw-gradient-to: rgba(146, 10, 22, 0.2) var(--tw-gradient-to-position);
}
.to-song-color-900\\/25{
  --tw-gradient-to: rgba(146, 10, 22, 0.25) var(--tw-gradient-to-position);
}
.to-song-color-900\\/30{
  --tw-gradient-to: rgba(146, 10, 22, 0.3) var(--tw-gradient-to-position);
}
.to-song-color-900\\/35{
  --tw-gradient-to: rgba(146, 10, 22, 0.35) var(--tw-gradient-to-position);
}
.to-song-color-900\\/40{
  --tw-gradient-to: rgba(146, 10, 22, 0.4) var(--tw-gradient-to-position);
}
.to-song-color-900\\/45{
  --tw-gradient-to: rgba(146, 10, 22, 0.45) var(--tw-gradient-to-position);
}
.to-song-color-900\\/5{
  --tw-gradient-to: rgba(146, 10, 22, 0.05) var(--tw-gradient-to-position);
}
.to-song-color-900\\/50{
  --tw-gradient-to: rgba(146, 10, 22, 0.5) var(--tw-gradient-to-position);
}
.to-song-color-900\\/55{
  --tw-gradient-to: rgba(146, 10, 22, 0.55) var(--tw-gradient-to-position);
}
.to-song-color-900\\/60{
  --tw-gradient-to: rgba(146, 10, 22, 0.6) var(--tw-gradient-to-position);
}
.to-song-color-900\\/65{
  --tw-gradient-to: rgba(146, 10, 22, 0.65) var(--tw-gradient-to-position);
}
.to-song-color-900\\/70{
  --tw-gradient-to: rgba(146, 10, 22, 0.7) var(--tw-gradient-to-position);
}
.to-song-color-900\\/75{
  --tw-gradient-to: rgba(146, 10, 22, 0.75) var(--tw-gradient-to-position);
}
.to-song-color-900\\/80{
  --tw-gradient-to: rgba(146, 10, 22, 0.8) var(--tw-gradient-to-position);
}
.to-song-color-900\\/85{
  --tw-gradient-to: rgba(146, 10, 22, 0.85) var(--tw-gradient-to-position);
}
.to-song-color-900\\/90{
  --tw-gradient-to: rgba(146, 10, 22, 0.9) var(--tw-gradient-to-position);
}
.to-song-color-900\\/95{
  --tw-gradient-to: rgba(146, 10, 22, 0.95) var(--tw-gradient-to-position);
}
.to-song-color-950{
  --tw-gradient-to: #510007 var(--tw-gradient-to-position);
}
.to-song-color-950\\/0{
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
}
.to-song-color-950\\/10{
  --tw-gradient-to: rgba(81, 0, 7, 0.1) var(--tw-gradient-to-position);
}
.to-song-color-950\\/100{
  --tw-gradient-to: rgb(81, 0, 7) var(--tw-gradient-to-position);
}
.to-song-color-950\\/15{
  --tw-gradient-to: rgba(81, 0, 7, 0.15) var(--tw-gradient-to-position);
}
.to-song-color-950\\/20{
  --tw-gradient-to: rgba(81, 0, 7, 0.2) var(--tw-gradient-to-position);
}
.to-song-color-950\\/25{
  --tw-gradient-to: rgba(81, 0, 7, 0.25) var(--tw-gradient-to-position);
}
.to-song-color-950\\/30{
  --tw-gradient-to: rgba(81, 0, 7, 0.3) var(--tw-gradient-to-position);
}
.to-song-color-950\\/35{
  --tw-gradient-to: rgba(81, 0, 7, 0.35) var(--tw-gradient-to-position);
}
.to-song-color-950\\/40{
  --tw-gradient-to: rgba(81, 0, 7, 0.4) var(--tw-gradient-to-position);
}
.to-song-color-950\\/45{
  --tw-gradient-to: rgba(81, 0, 7, 0.45) var(--tw-gradient-to-position);
}
.to-song-color-950\\/5{
  --tw-gradient-to: rgba(81, 0, 7, 0.05) var(--tw-gradient-to-position);
}
.to-song-color-950\\/50{
  --tw-gradient-to: rgba(81, 0, 7, 0.5) var(--tw-gradient-to-position);
}
.to-song-color-950\\/55{
  --tw-gradient-to: rgba(81, 0, 7, 0.55) var(--tw-gradient-to-position);
}
.to-song-color-950\\/60{
  --tw-gradient-to: rgba(81, 0, 7, 0.6) var(--tw-gradient-to-position);
}
.to-song-color-950\\/65{
  --tw-gradient-to: rgba(81, 0, 7, 0.65) var(--tw-gradient-to-position);
}
.to-song-color-950\\/70{
  --tw-gradient-to: rgba(81, 0, 7, 0.7) var(--tw-gradient-to-position);
}
.to-song-color-950\\/75{
  --tw-gradient-to: rgba(81, 0, 7, 0.75) var(--tw-gradient-to-position);
}
.to-song-color-950\\/80{
  --tw-gradient-to: rgba(81, 0, 7, 0.8) var(--tw-gradient-to-position);
}
.to-song-color-950\\/85{
  --tw-gradient-to: rgba(81, 0, 7, 0.85) var(--tw-gradient-to-position);
}
.to-song-color-950\\/90{
  --tw-gradient-to: rgba(81, 0, 7, 0.9) var(--tw-gradient-to-position);
}
.to-song-color-950\\/95{
  --tw-gradient-to: rgba(81, 0, 7, 0.95) var(--tw-gradient-to-position);
}
.to-story-color-100{
  --tw-gradient-to: #daeef3 var(--tw-gradient-to-position);
}
.to-story-color-100\\/0{
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
}
.to-story-color-100\\/10{
  --tw-gradient-to: rgba(218, 238, 243, 0.1) var(--tw-gradient-to-position);
}
.to-story-color-100\\/100{
  --tw-gradient-to: rgb(218, 238, 243) var(--tw-gradient-to-position);
}
.to-story-color-100\\/15{
  --tw-gradient-to: rgba(218, 238, 243, 0.15) var(--tw-gradient-to-position);
}
.to-story-color-100\\/20{
  --tw-gradient-to: rgba(218, 238, 243, 0.2) var(--tw-gradient-to-position);
}
.to-story-color-100\\/25{
  --tw-gradient-to: rgba(218, 238, 243, 0.25) var(--tw-gradient-to-position);
}
.to-story-color-100\\/30{
  --tw-gradient-to: rgba(218, 238, 243, 0.3) var(--tw-gradient-to-position);
}
.to-story-color-100\\/35{
  --tw-gradient-to: rgba(218, 238, 243, 0.35) var(--tw-gradient-to-position);
}
.to-story-color-100\\/40{
  --tw-gradient-to: rgba(218, 238, 243, 0.4) var(--tw-gradient-to-position);
}
.to-story-color-100\\/45{
  --tw-gradient-to: rgba(218, 238, 243, 0.45) var(--tw-gradient-to-position);
}
.to-story-color-100\\/5{
  --tw-gradient-to: rgba(218, 238, 243, 0.05) var(--tw-gradient-to-position);
}
.to-story-color-100\\/50{
  --tw-gradient-to: rgba(218, 238, 243, 0.5) var(--tw-gradient-to-position);
}
.to-story-color-100\\/55{
  --tw-gradient-to: rgba(218, 238, 243, 0.55) var(--tw-gradient-to-position);
}
.to-story-color-100\\/60{
  --tw-gradient-to: rgba(218, 238, 243, 0.6) var(--tw-gradient-to-position);
}
.to-story-color-100\\/65{
  --tw-gradient-to: rgba(218, 238, 243, 0.65) var(--tw-gradient-to-position);
}
.to-story-color-100\\/70{
  --tw-gradient-to: rgba(218, 238, 243, 0.7) var(--tw-gradient-to-position);
}
.to-story-color-100\\/75{
  --tw-gradient-to: rgba(218, 238, 243, 0.75) var(--tw-gradient-to-position);
}
.to-story-color-100\\/80{
  --tw-gradient-to: rgba(218, 238, 243, 0.8) var(--tw-gradient-to-position);
}
.to-story-color-100\\/85{
  --tw-gradient-to: rgba(218, 238, 243, 0.85) var(--tw-gradient-to-position);
}
.to-story-color-100\\/90{
  --tw-gradient-to: rgba(218, 238, 243, 0.9) var(--tw-gradient-to-position);
}
.to-story-color-100\\/95{
  --tw-gradient-to: rgba(218, 238, 243, 0.95) var(--tw-gradient-to-position);
}
.to-story-color-200{
  --tw-gradient-to: #badee7 var(--tw-gradient-to-position);
}
.to-story-color-200\\/0{
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
}
.to-story-color-200\\/10{
  --tw-gradient-to: rgba(186, 222, 231, 0.1) var(--tw-gradient-to-position);
}
.to-story-color-200\\/100{
  --tw-gradient-to: rgb(186, 222, 231) var(--tw-gradient-to-position);
}
.to-story-color-200\\/15{
  --tw-gradient-to: rgba(186, 222, 231, 0.15) var(--tw-gradient-to-position);
}
.to-story-color-200\\/20{
  --tw-gradient-to: rgba(186, 222, 231, 0.2) var(--tw-gradient-to-position);
}
.to-story-color-200\\/25{
  --tw-gradient-to: rgba(186, 222, 231, 0.25) var(--tw-gradient-to-position);
}
.to-story-color-200\\/30{
  --tw-gradient-to: rgba(186, 222, 231, 0.3) var(--tw-gradient-to-position);
}
.to-story-color-200\\/35{
  --tw-gradient-to: rgba(186, 222, 231, 0.35) var(--tw-gradient-to-position);
}
.to-story-color-200\\/40{
  --tw-gradient-to: rgba(186, 222, 231, 0.4) var(--tw-gradient-to-position);
}
.to-story-color-200\\/45{
  --tw-gradient-to: rgba(186, 222, 231, 0.45) var(--tw-gradient-to-position);
}
.to-story-color-200\\/5{
  --tw-gradient-to: rgba(186, 222, 231, 0.05) var(--tw-gradient-to-position);
}
.to-story-color-200\\/50{
  --tw-gradient-to: rgba(186, 222, 231, 0.5) var(--tw-gradient-to-position);
}
.to-story-color-200\\/55{
  --tw-gradient-to: rgba(186, 222, 231, 0.55) var(--tw-gradient-to-position);
}
.to-story-color-200\\/60{
  --tw-gradient-to: rgba(186, 222, 231, 0.6) var(--tw-gradient-to-position);
}
.to-story-color-200\\/65{
  --tw-gradient-to: rgba(186, 222, 231, 0.65) var(--tw-gradient-to-position);
}
.to-story-color-200\\/70{
  --tw-gradient-to: rgba(186, 222, 231, 0.7) var(--tw-gradient-to-position);
}
.to-story-color-200\\/75{
  --tw-gradient-to: rgba(186, 222, 231, 0.75) var(--tw-gradient-to-position);
}
.to-story-color-200\\/80{
  --tw-gradient-to: rgba(186, 222, 231, 0.8) var(--tw-gradient-to-position);
}
.to-story-color-200\\/85{
  --tw-gradient-to: rgba(186, 222, 231, 0.85) var(--tw-gradient-to-position);
}
.to-story-color-200\\/90{
  --tw-gradient-to: rgba(186, 222, 231, 0.9) var(--tw-gradient-to-position);
}
.to-story-color-200\\/95{
  --tw-gradient-to: rgba(186, 222, 231, 0.95) var(--tw-gradient-to-position);
}
.to-story-color-300{
  --tw-gradient-to: #89c5d7 var(--tw-gradient-to-position);
}
.to-story-color-300\\/0{
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
}
.to-story-color-300\\/10{
  --tw-gradient-to: rgba(137, 197, 215, 0.1) var(--tw-gradient-to-position);
}
.to-story-color-300\\/100{
  --tw-gradient-to: rgb(137, 197, 215) var(--tw-gradient-to-position);
}
.to-story-color-300\\/15{
  --tw-gradient-to: rgba(137, 197, 215, 0.15) var(--tw-gradient-to-position);
}
.to-story-color-300\\/20{
  --tw-gradient-to: rgba(137, 197, 215, 0.2) var(--tw-gradient-to-position);
}
.to-story-color-300\\/25{
  --tw-gradient-to: rgba(137, 197, 215, 0.25) var(--tw-gradient-to-position);
}
.to-story-color-300\\/30{
  --tw-gradient-to: rgba(137, 197, 215, 0.3) var(--tw-gradient-to-position);
}
.to-story-color-300\\/35{
  --tw-gradient-to: rgba(137, 197, 215, 0.35) var(--tw-gradient-to-position);
}
.to-story-color-300\\/40{
  --tw-gradient-to: rgba(137, 197, 215, 0.4) var(--tw-gradient-to-position);
}
.to-story-color-300\\/45{
  --tw-gradient-to: rgba(137, 197, 215, 0.45) var(--tw-gradient-to-position);
}
.to-story-color-300\\/5{
  --tw-gradient-to: rgba(137, 197, 215, 0.05) var(--tw-gradient-to-position);
}
.to-story-color-300\\/50{
  --tw-gradient-to: rgba(137, 197, 215, 0.5) var(--tw-gradient-to-position);
}
.to-story-color-300\\/55{
  --tw-gradient-to: rgba(137, 197, 215, 0.55) var(--tw-gradient-to-position);
}
.to-story-color-300\\/60{
  --tw-gradient-to: rgba(137, 197, 215, 0.6) var(--tw-gradient-to-position);
}
.to-story-color-300\\/65{
  --tw-gradient-to: rgba(137, 197, 215, 0.65) var(--tw-gradient-to-position);
}
.to-story-color-300\\/70{
  --tw-gradient-to: rgba(137, 197, 215, 0.7) var(--tw-gradient-to-position);
}
.to-story-color-300\\/75{
  --tw-gradient-to: rgba(137, 197, 215, 0.75) var(--tw-gradient-to-position);
}
.to-story-color-300\\/80{
  --tw-gradient-to: rgba(137, 197, 215, 0.8) var(--tw-gradient-to-position);
}
.to-story-color-300\\/85{
  --tw-gradient-to: rgba(137, 197, 215, 0.85) var(--tw-gradient-to-position);
}
.to-story-color-300\\/90{
  --tw-gradient-to: rgba(137, 197, 215, 0.9) var(--tw-gradient-to-position);
}
.to-story-color-300\\/95{
  --tw-gradient-to: rgba(137, 197, 215, 0.95) var(--tw-gradient-to-position);
}
.to-story-color-400{
  --tw-gradient-to: #52a3be var(--tw-gradient-to-position);
}
.to-story-color-400\\/0{
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
}
.to-story-color-400\\/10{
  --tw-gradient-to: rgba(82, 163, 190, 0.1) var(--tw-gradient-to-position);
}
.to-story-color-400\\/100{
  --tw-gradient-to: rgb(82, 163, 190) var(--tw-gradient-to-position);
}
.to-story-color-400\\/15{
  --tw-gradient-to: rgba(82, 163, 190, 0.15) var(--tw-gradient-to-position);
}
.to-story-color-400\\/20{
  --tw-gradient-to: rgba(82, 163, 190, 0.2) var(--tw-gradient-to-position);
}
.to-story-color-400\\/25{
  --tw-gradient-to: rgba(82, 163, 190, 0.25) var(--tw-gradient-to-position);
}
.to-story-color-400\\/30{
  --tw-gradient-to: rgba(82, 163, 190, 0.3) var(--tw-gradient-to-position);
}
.to-story-color-400\\/35{
  --tw-gradient-to: rgba(82, 163, 190, 0.35) var(--tw-gradient-to-position);
}
.to-story-color-400\\/40{
  --tw-gradient-to: rgba(82, 163, 190, 0.4) var(--tw-gradient-to-position);
}
.to-story-color-400\\/45{
  --tw-gradient-to: rgba(82, 163, 190, 0.45) var(--tw-gradient-to-position);
}
.to-story-color-400\\/5{
  --tw-gradient-to: rgba(82, 163, 190, 0.05) var(--tw-gradient-to-position);
}
.to-story-color-400\\/50{
  --tw-gradient-to: rgba(82, 163, 190, 0.5) var(--tw-gradient-to-position);
}
.to-story-color-400\\/55{
  --tw-gradient-to: rgba(82, 163, 190, 0.55) var(--tw-gradient-to-position);
}
.to-story-color-400\\/60{
  --tw-gradient-to: rgba(82, 163, 190, 0.6) var(--tw-gradient-to-position);
}
.to-story-color-400\\/65{
  --tw-gradient-to: rgba(82, 163, 190, 0.65) var(--tw-gradient-to-position);
}
.to-story-color-400\\/70{
  --tw-gradient-to: rgba(82, 163, 190, 0.7) var(--tw-gradient-to-position);
}
.to-story-color-400\\/75{
  --tw-gradient-to: rgba(82, 163, 190, 0.75) var(--tw-gradient-to-position);
}
.to-story-color-400\\/80{
  --tw-gradient-to: rgba(82, 163, 190, 0.8) var(--tw-gradient-to-position);
}
.to-story-color-400\\/85{
  --tw-gradient-to: rgba(82, 163, 190, 0.85) var(--tw-gradient-to-position);
}
.to-story-color-400\\/90{
  --tw-gradient-to: rgba(82, 163, 190, 0.9) var(--tw-gradient-to-position);
}
.to-story-color-400\\/95{
  --tw-gradient-to: rgba(82, 163, 190, 0.95) var(--tw-gradient-to-position);
}
.to-story-color-500{
  --tw-gradient-to: #3787a3 var(--tw-gradient-to-position);
}
.to-story-color-500\\/0{
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
}
.to-story-color-500\\/10{
  --tw-gradient-to: rgba(55, 135, 163, 0.1) var(--tw-gradient-to-position);
}
.to-story-color-500\\/100{
  --tw-gradient-to: rgb(55, 135, 163) var(--tw-gradient-to-position);
}
.to-story-color-500\\/15{
  --tw-gradient-to: rgba(55, 135, 163, 0.15) var(--tw-gradient-to-position);
}
.to-story-color-500\\/20{
  --tw-gradient-to: rgba(55, 135, 163, 0.2) var(--tw-gradient-to-position);
}
.to-story-color-500\\/25{
  --tw-gradient-to: rgba(55, 135, 163, 0.25) var(--tw-gradient-to-position);
}
.to-story-color-500\\/30{
  --tw-gradient-to: rgba(55, 135, 163, 0.3) var(--tw-gradient-to-position);
}
.to-story-color-500\\/35{
  --tw-gradient-to: rgba(55, 135, 163, 0.35) var(--tw-gradient-to-position);
}
.to-story-color-500\\/40{
  --tw-gradient-to: rgba(55, 135, 163, 0.4) var(--tw-gradient-to-position);
}
.to-story-color-500\\/45{
  --tw-gradient-to: rgba(55, 135, 163, 0.45) var(--tw-gradient-to-position);
}
.to-story-color-500\\/5{
  --tw-gradient-to: rgba(55, 135, 163, 0.05) var(--tw-gradient-to-position);
}
.to-story-color-500\\/50{
  --tw-gradient-to: rgba(55, 135, 163, 0.5) var(--tw-gradient-to-position);
}
.to-story-color-500\\/55{
  --tw-gradient-to: rgba(55, 135, 163, 0.55) var(--tw-gradient-to-position);
}
.to-story-color-500\\/60{
  --tw-gradient-to: rgba(55, 135, 163, 0.6) var(--tw-gradient-to-position);
}
.to-story-color-500\\/65{
  --tw-gradient-to: rgba(55, 135, 163, 0.65) var(--tw-gradient-to-position);
}
.to-story-color-500\\/70{
  --tw-gradient-to: rgba(55, 135, 163, 0.7) var(--tw-gradient-to-position);
}
.to-story-color-500\\/75{
  --tw-gradient-to: rgba(55, 135, 163, 0.75) var(--tw-gradient-to-position);
}
.to-story-color-500\\/80{
  --tw-gradient-to: rgba(55, 135, 163, 0.8) var(--tw-gradient-to-position);
}
.to-story-color-500\\/85{
  --tw-gradient-to: rgba(55, 135, 163, 0.85) var(--tw-gradient-to-position);
}
.to-story-color-500\\/90{
  --tw-gradient-to: rgba(55, 135, 163, 0.9) var(--tw-gradient-to-position);
}
.to-story-color-500\\/95{
  --tw-gradient-to: rgba(55, 135, 163, 0.95) var(--tw-gradient-to-position);
}
.to-story-color-600{
  --tw-gradient-to: #306d8a var(--tw-gradient-to-position);
}
.to-story-color-600\\/0{
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
}
.to-story-color-600\\/10{
  --tw-gradient-to: rgba(48, 109, 138, 0.1) var(--tw-gradient-to-position);
}
.to-story-color-600\\/100{
  --tw-gradient-to: rgb(48, 109, 138) var(--tw-gradient-to-position);
}
.to-story-color-600\\/15{
  --tw-gradient-to: rgba(48, 109, 138, 0.15) var(--tw-gradient-to-position);
}
.to-story-color-600\\/20{
  --tw-gradient-to: rgba(48, 109, 138, 0.2) var(--tw-gradient-to-position);
}
.to-story-color-600\\/25{
  --tw-gradient-to: rgba(48, 109, 138, 0.25) var(--tw-gradient-to-position);
}
.to-story-color-600\\/30{
  --tw-gradient-to: rgba(48, 109, 138, 0.3) var(--tw-gradient-to-position);
}
.to-story-color-600\\/35{
  --tw-gradient-to: rgba(48, 109, 138, 0.35) var(--tw-gradient-to-position);
}
.to-story-color-600\\/40{
  --tw-gradient-to: rgba(48, 109, 138, 0.4) var(--tw-gradient-to-position);
}
.to-story-color-600\\/45{
  --tw-gradient-to: rgba(48, 109, 138, 0.45) var(--tw-gradient-to-position);
}
.to-story-color-600\\/5{
  --tw-gradient-to: rgba(48, 109, 138, 0.05) var(--tw-gradient-to-position);
}
.to-story-color-600\\/50{
  --tw-gradient-to: rgba(48, 109, 138, 0.5) var(--tw-gradient-to-position);
}
.to-story-color-600\\/55{
  --tw-gradient-to: rgba(48, 109, 138, 0.55) var(--tw-gradient-to-position);
}
.to-story-color-600\\/60{
  --tw-gradient-to: rgba(48, 109, 138, 0.6) var(--tw-gradient-to-position);
}
.to-story-color-600\\/65{
  --tw-gradient-to: rgba(48, 109, 138, 0.65) var(--tw-gradient-to-position);
}
.to-story-color-600\\/70{
  --tw-gradient-to: rgba(48, 109, 138, 0.7) var(--tw-gradient-to-position);
}
.to-story-color-600\\/75{
  --tw-gradient-to: rgba(48, 109, 138, 0.75) var(--tw-gradient-to-position);
}
.to-story-color-600\\/80{
  --tw-gradient-to: rgba(48, 109, 138, 0.8) var(--tw-gradient-to-position);
}
.to-story-color-600\\/85{
  --tw-gradient-to: rgba(48, 109, 138, 0.85) var(--tw-gradient-to-position);
}
.to-story-color-600\\/90{
  --tw-gradient-to: rgba(48, 109, 138, 0.9) var(--tw-gradient-to-position);
}
.to-story-color-600\\/95{
  --tw-gradient-to: rgba(48, 109, 138, 0.95) var(--tw-gradient-to-position);
}
.to-story-color-700{
  --tw-gradient-to: #2d5b72 var(--tw-gradient-to-position);
}
.to-story-color-700\\/0{
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
}
.to-story-color-700\\/10{
  --tw-gradient-to: rgba(45, 91, 114, 0.1) var(--tw-gradient-to-position);
}
.to-story-color-700\\/100{
  --tw-gradient-to: rgb(45, 91, 114) var(--tw-gradient-to-position);
}
.to-story-color-700\\/15{
  --tw-gradient-to: rgba(45, 91, 114, 0.15) var(--tw-gradient-to-position);
}
.to-story-color-700\\/20{
  --tw-gradient-to: rgba(45, 91, 114, 0.2) var(--tw-gradient-to-position);
}
.to-story-color-700\\/25{
  --tw-gradient-to: rgba(45, 91, 114, 0.25) var(--tw-gradient-to-position);
}
.to-story-color-700\\/30{
  --tw-gradient-to: rgba(45, 91, 114, 0.3) var(--tw-gradient-to-position);
}
.to-story-color-700\\/35{
  --tw-gradient-to: rgba(45, 91, 114, 0.35) var(--tw-gradient-to-position);
}
.to-story-color-700\\/40{
  --tw-gradient-to: rgba(45, 91, 114, 0.4) var(--tw-gradient-to-position);
}
.to-story-color-700\\/45{
  --tw-gradient-to: rgba(45, 91, 114, 0.45) var(--tw-gradient-to-position);
}
.to-story-color-700\\/5{
  --tw-gradient-to: rgba(45, 91, 114, 0.05) var(--tw-gradient-to-position);
}
.to-story-color-700\\/50{
  --tw-gradient-to: rgba(45, 91, 114, 0.5) var(--tw-gradient-to-position);
}
.to-story-color-700\\/55{
  --tw-gradient-to: rgba(45, 91, 114, 0.55) var(--tw-gradient-to-position);
}
.to-story-color-700\\/60{
  --tw-gradient-to: rgba(45, 91, 114, 0.6) var(--tw-gradient-to-position);
}
.to-story-color-700\\/65{
  --tw-gradient-to: rgba(45, 91, 114, 0.65) var(--tw-gradient-to-position);
}
.to-story-color-700\\/70{
  --tw-gradient-to: rgba(45, 91, 114, 0.7) var(--tw-gradient-to-position);
}
.to-story-color-700\\/75{
  --tw-gradient-to: rgba(45, 91, 114, 0.75) var(--tw-gradient-to-position);
}
.to-story-color-700\\/80{
  --tw-gradient-to: rgba(45, 91, 114, 0.8) var(--tw-gradient-to-position);
}
.to-story-color-700\\/85{
  --tw-gradient-to: rgba(45, 91, 114, 0.85) var(--tw-gradient-to-position);
}
.to-story-color-700\\/90{
  --tw-gradient-to: rgba(45, 91, 114, 0.9) var(--tw-gradient-to-position);
}
.to-story-color-700\\/95{
  --tw-gradient-to: rgba(45, 91, 114, 0.95) var(--tw-gradient-to-position);
}
.to-story-color-800{
  --tw-gradient-to: #2c4c5e var(--tw-gradient-to-position);
}
.to-story-color-800\\/0{
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
}
.to-story-color-800\\/10{
  --tw-gradient-to: rgba(44, 76, 94, 0.1) var(--tw-gradient-to-position);
}
.to-story-color-800\\/100{
  --tw-gradient-to: rgb(44, 76, 94) var(--tw-gradient-to-position);
}
.to-story-color-800\\/15{
  --tw-gradient-to: rgba(44, 76, 94, 0.15) var(--tw-gradient-to-position);
}
.to-story-color-800\\/20{
  --tw-gradient-to: rgba(44, 76, 94, 0.2) var(--tw-gradient-to-position);
}
.to-story-color-800\\/25{
  --tw-gradient-to: rgba(44, 76, 94, 0.25) var(--tw-gradient-to-position);
}
.to-story-color-800\\/30{
  --tw-gradient-to: rgba(44, 76, 94, 0.3) var(--tw-gradient-to-position);
}
.to-story-color-800\\/35{
  --tw-gradient-to: rgba(44, 76, 94, 0.35) var(--tw-gradient-to-position);
}
.to-story-color-800\\/40{
  --tw-gradient-to: rgba(44, 76, 94, 0.4) var(--tw-gradient-to-position);
}
.to-story-color-800\\/45{
  --tw-gradient-to: rgba(44, 76, 94, 0.45) var(--tw-gradient-to-position);
}
.to-story-color-800\\/5{
  --tw-gradient-to: rgba(44, 76, 94, 0.05) var(--tw-gradient-to-position);
}
.to-story-color-800\\/50{
  --tw-gradient-to: rgba(44, 76, 94, 0.5) var(--tw-gradient-to-position);
}
.to-story-color-800\\/55{
  --tw-gradient-to: rgba(44, 76, 94, 0.55) var(--tw-gradient-to-position);
}
.to-story-color-800\\/60{
  --tw-gradient-to: rgba(44, 76, 94, 0.6) var(--tw-gradient-to-position);
}
.to-story-color-800\\/65{
  --tw-gradient-to: rgba(44, 76, 94, 0.65) var(--tw-gradient-to-position);
}
.to-story-color-800\\/70{
  --tw-gradient-to: rgba(44, 76, 94, 0.7) var(--tw-gradient-to-position);
}
.to-story-color-800\\/75{
  --tw-gradient-to: rgba(44, 76, 94, 0.75) var(--tw-gradient-to-position);
}
.to-story-color-800\\/80{
  --tw-gradient-to: rgba(44, 76, 94, 0.8) var(--tw-gradient-to-position);
}
.to-story-color-800\\/85{
  --tw-gradient-to: rgba(44, 76, 94, 0.85) var(--tw-gradient-to-position);
}
.to-story-color-800\\/90{
  --tw-gradient-to: rgba(44, 76, 94, 0.9) var(--tw-gradient-to-position);
}
.to-story-color-800\\/95{
  --tw-gradient-to: rgba(44, 76, 94, 0.95) var(--tw-gradient-to-position);
}
.to-story-color-900{
  --tw-gradient-to: #284151 var(--tw-gradient-to-position);
}
.to-story-color-900\\/0{
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
}
.to-story-color-900\\/10{
  --tw-gradient-to: rgba(40, 65, 81, 0.1) var(--tw-gradient-to-position);
}
.to-story-color-900\\/100{
  --tw-gradient-to: rgb(40, 65, 81) var(--tw-gradient-to-position);
}
.to-story-color-900\\/15{
  --tw-gradient-to: rgba(40, 65, 81, 0.15) var(--tw-gradient-to-position);
}
.to-story-color-900\\/20{
  --tw-gradient-to: rgba(40, 65, 81, 0.2) var(--tw-gradient-to-position);
}
.to-story-color-900\\/25{
  --tw-gradient-to: rgba(40, 65, 81, 0.25) var(--tw-gradient-to-position);
}
.to-story-color-900\\/30{
  --tw-gradient-to: rgba(40, 65, 81, 0.3) var(--tw-gradient-to-position);
}
.to-story-color-900\\/35{
  --tw-gradient-to: rgba(40, 65, 81, 0.35) var(--tw-gradient-to-position);
}
.to-story-color-900\\/40{
  --tw-gradient-to: rgba(40, 65, 81, 0.4) var(--tw-gradient-to-position);
}
.to-story-color-900\\/45{
  --tw-gradient-to: rgba(40, 65, 81, 0.45) var(--tw-gradient-to-position);
}
.to-story-color-900\\/5{
  --tw-gradient-to: rgba(40, 65, 81, 0.05) var(--tw-gradient-to-position);
}
.to-story-color-900\\/50{
  --tw-gradient-to: rgba(40, 65, 81, 0.5) var(--tw-gradient-to-position);
}
.to-story-color-900\\/55{
  --tw-gradient-to: rgba(40, 65, 81, 0.55) var(--tw-gradient-to-position);
}
.to-story-color-900\\/60{
  --tw-gradient-to: rgba(40, 65, 81, 0.6) var(--tw-gradient-to-position);
}
.to-story-color-900\\/65{
  --tw-gradient-to: rgba(40, 65, 81, 0.65) var(--tw-gradient-to-position);
}
.to-story-color-900\\/70{
  --tw-gradient-to: rgba(40, 65, 81, 0.7) var(--tw-gradient-to-position);
}
.to-story-color-900\\/75{
  --tw-gradient-to: rgba(40, 65, 81, 0.75) var(--tw-gradient-to-position);
}
.to-story-color-900\\/80{
  --tw-gradient-to: rgba(40, 65, 81, 0.8) var(--tw-gradient-to-position);
}
.to-story-color-900\\/85{
  --tw-gradient-to: rgba(40, 65, 81, 0.85) var(--tw-gradient-to-position);
}
.to-story-color-900\\/90{
  --tw-gradient-to: rgba(40, 65, 81, 0.9) var(--tw-gradient-to-position);
}
.to-story-color-900\\/95{
  --tw-gradient-to: rgba(40, 65, 81, 0.95) var(--tw-gradient-to-position);
}
.to-story-color-950{
  --tw-gradient-to: #162936 var(--tw-gradient-to-position);
}
.to-story-color-950\\/0{
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
}
.to-story-color-950\\/10{
  --tw-gradient-to: rgba(22, 41, 54, 0.1) var(--tw-gradient-to-position);
}
.to-story-color-950\\/100{
  --tw-gradient-to: rgb(22, 41, 54) var(--tw-gradient-to-position);
}
.to-story-color-950\\/15{
  --tw-gradient-to: rgba(22, 41, 54, 0.15) var(--tw-gradient-to-position);
}
.to-story-color-950\\/20{
  --tw-gradient-to: rgba(22, 41, 54, 0.2) var(--tw-gradient-to-position);
}
.to-story-color-950\\/25{
  --tw-gradient-to: rgba(22, 41, 54, 0.25) var(--tw-gradient-to-position);
}
.to-story-color-950\\/30{
  --tw-gradient-to: rgba(22, 41, 54, 0.3) var(--tw-gradient-to-position);
}
.to-story-color-950\\/35{
  --tw-gradient-to: rgba(22, 41, 54, 0.35) var(--tw-gradient-to-position);
}
.to-story-color-950\\/40{
  --tw-gradient-to: rgba(22, 41, 54, 0.4) var(--tw-gradient-to-position);
}
.to-story-color-950\\/45{
  --tw-gradient-to: rgba(22, 41, 54, 0.45) var(--tw-gradient-to-position);
}
.to-story-color-950\\/5{
  --tw-gradient-to: rgba(22, 41, 54, 0.05) var(--tw-gradient-to-position);
}
.to-story-color-950\\/50{
  --tw-gradient-to: rgba(22, 41, 54, 0.5) var(--tw-gradient-to-position);
}
.to-story-color-950\\/55{
  --tw-gradient-to: rgba(22, 41, 54, 0.55) var(--tw-gradient-to-position);
}
.to-story-color-950\\/60{
  --tw-gradient-to: rgba(22, 41, 54, 0.6) var(--tw-gradient-to-position);
}
.to-story-color-950\\/65{
  --tw-gradient-to: rgba(22, 41, 54, 0.65) var(--tw-gradient-to-position);
}
.to-story-color-950\\/70{
  --tw-gradient-to: rgba(22, 41, 54, 0.7) var(--tw-gradient-to-position);
}
.to-story-color-950\\/75{
  --tw-gradient-to: rgba(22, 41, 54, 0.75) var(--tw-gradient-to-position);
}
.to-story-color-950\\/80{
  --tw-gradient-to: rgba(22, 41, 54, 0.8) var(--tw-gradient-to-position);
}
.to-story-color-950\\/85{
  --tw-gradient-to: rgba(22, 41, 54, 0.85) var(--tw-gradient-to-position);
}
.to-story-color-950\\/90{
  --tw-gradient-to: rgba(22, 41, 54, 0.9) var(--tw-gradient-to-position);
}
.to-story-color-950\\/95{
  --tw-gradient-to: rgba(22, 41, 54, 0.95) var(--tw-gradient-to-position);
}
.to-word-color-100{
  --tw-gradient-to: #d9f2e6 var(--tw-gradient-to-position);
}
.to-word-color-100\\/0{
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
}
.to-word-color-100\\/10{
  --tw-gradient-to: rgba(217, 242, 230, 0.1) var(--tw-gradient-to-position);
}
.to-word-color-100\\/100{
  --tw-gradient-to: rgb(217, 242, 230) var(--tw-gradient-to-position);
}
.to-word-color-100\\/15{
  --tw-gradient-to: rgba(217, 242, 230, 0.15) var(--tw-gradient-to-position);
}
.to-word-color-100\\/20{
  --tw-gradient-to: rgba(217, 242, 230, 0.2) var(--tw-gradient-to-position);
}
.to-word-color-100\\/25{
  --tw-gradient-to: rgba(217, 242, 230, 0.25) var(--tw-gradient-to-position);
}
.to-word-color-100\\/30{
  --tw-gradient-to: rgba(217, 242, 230, 0.3) var(--tw-gradient-to-position);
}
.to-word-color-100\\/35{
  --tw-gradient-to: rgba(217, 242, 230, 0.35) var(--tw-gradient-to-position);
}
.to-word-color-100\\/40{
  --tw-gradient-to: rgba(217, 242, 230, 0.4) var(--tw-gradient-to-position);
}
.to-word-color-100\\/45{
  --tw-gradient-to: rgba(217, 242, 230, 0.45) var(--tw-gradient-to-position);
}
.to-word-color-100\\/5{
  --tw-gradient-to: rgba(217, 242, 230, 0.05) var(--tw-gradient-to-position);
}
.to-word-color-100\\/50{
  --tw-gradient-to: rgba(217, 242, 230, 0.5) var(--tw-gradient-to-position);
}
.to-word-color-100\\/55{
  --tw-gradient-to: rgba(217, 242, 230, 0.55) var(--tw-gradient-to-position);
}
.to-word-color-100\\/60{
  --tw-gradient-to: rgba(217, 242, 230, 0.6) var(--tw-gradient-to-position);
}
.to-word-color-100\\/65{
  --tw-gradient-to: rgba(217, 242, 230, 0.65) var(--tw-gradient-to-position);
}
.to-word-color-100\\/70{
  --tw-gradient-to: rgba(217, 242, 230, 0.7) var(--tw-gradient-to-position);
}
.to-word-color-100\\/75{
  --tw-gradient-to: rgba(217, 242, 230, 0.75) var(--tw-gradient-to-position);
}
.to-word-color-100\\/80{
  --tw-gradient-to: rgba(217, 242, 230, 0.8) var(--tw-gradient-to-position);
}
.to-word-color-100\\/85{
  --tw-gradient-to: rgba(217, 242, 230, 0.85) var(--tw-gradient-to-position);
}
.to-word-color-100\\/90{
  --tw-gradient-to: rgba(217, 242, 230, 0.9) var(--tw-gradient-to-position);
}
.to-word-color-100\\/95{
  --tw-gradient-to: rgba(217, 242, 230, 0.95) var(--tw-gradient-to-position);
}
.to-word-color-200{
  --tw-gradient-to: #b6e4d1 var(--tw-gradient-to-position);
}
.to-word-color-200\\/0{
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
}
.to-word-color-200\\/10{
  --tw-gradient-to: rgba(182, 228, 209, 0.1) var(--tw-gradient-to-position);
}
.to-word-color-200\\/100{
  --tw-gradient-to: rgb(182, 228, 209) var(--tw-gradient-to-position);
}
.to-word-color-200\\/15{
  --tw-gradient-to: rgba(182, 228, 209, 0.15) var(--tw-gradient-to-position);
}
.to-word-color-200\\/20{
  --tw-gradient-to: rgba(182, 228, 209, 0.2) var(--tw-gradient-to-position);
}
.to-word-color-200\\/25{
  --tw-gradient-to: rgba(182, 228, 209, 0.25) var(--tw-gradient-to-position);
}
.to-word-color-200\\/30{
  --tw-gradient-to: rgba(182, 228, 209, 0.3) var(--tw-gradient-to-position);
}
.to-word-color-200\\/35{
  --tw-gradient-to: rgba(182, 228, 209, 0.35) var(--tw-gradient-to-position);
}
.to-word-color-200\\/40{
  --tw-gradient-to: rgba(182, 228, 209, 0.4) var(--tw-gradient-to-position);
}
.to-word-color-200\\/45{
  --tw-gradient-to: rgba(182, 228, 209, 0.45) var(--tw-gradient-to-position);
}
.to-word-color-200\\/5{
  --tw-gradient-to: rgba(182, 228, 209, 0.05) var(--tw-gradient-to-position);
}
.to-word-color-200\\/50{
  --tw-gradient-to: rgba(182, 228, 209, 0.5) var(--tw-gradient-to-position);
}
.to-word-color-200\\/55{
  --tw-gradient-to: rgba(182, 228, 209, 0.55) var(--tw-gradient-to-position);
}
.to-word-color-200\\/60{
  --tw-gradient-to: rgba(182, 228, 209, 0.6) var(--tw-gradient-to-position);
}
.to-word-color-200\\/65{
  --tw-gradient-to: rgba(182, 228, 209, 0.65) var(--tw-gradient-to-position);
}
.to-word-color-200\\/70{
  --tw-gradient-to: rgba(182, 228, 209, 0.7) var(--tw-gradient-to-position);
}
.to-word-color-200\\/75{
  --tw-gradient-to: rgba(182, 228, 209, 0.75) var(--tw-gradient-to-position);
}
.to-word-color-200\\/80{
  --tw-gradient-to: rgba(182, 228, 209, 0.8) var(--tw-gradient-to-position);
}
.to-word-color-200\\/85{
  --tw-gradient-to: rgba(182, 228, 209, 0.85) var(--tw-gradient-to-position);
}
.to-word-color-200\\/90{
  --tw-gradient-to: rgba(182, 228, 209, 0.9) var(--tw-gradient-to-position);
}
.to-word-color-200\\/95{
  --tw-gradient-to: rgba(182, 228, 209, 0.95) var(--tw-gradient-to-position);
}
.to-word-color-300{
  --tw-gradient-to: #86cfb5 var(--tw-gradient-to-position);
}
.to-word-color-300\\/0{
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
}
.to-word-color-300\\/10{
  --tw-gradient-to: rgba(134, 207, 181, 0.1) var(--tw-gradient-to-position);
}
.to-word-color-300\\/100{
  --tw-gradient-to: rgb(134, 207, 181) var(--tw-gradient-to-position);
}
.to-word-color-300\\/15{
  --tw-gradient-to: rgba(134, 207, 181, 0.15) var(--tw-gradient-to-position);
}
.to-word-color-300\\/20{
  --tw-gradient-to: rgba(134, 207, 181, 0.2) var(--tw-gradient-to-position);
}
.to-word-color-300\\/25{
  --tw-gradient-to: rgba(134, 207, 181, 0.25) var(--tw-gradient-to-position);
}
.to-word-color-300\\/30{
  --tw-gradient-to: rgba(134, 207, 181, 0.3) var(--tw-gradient-to-position);
}
.to-word-color-300\\/35{
  --tw-gradient-to: rgba(134, 207, 181, 0.35) var(--tw-gradient-to-position);
}
.to-word-color-300\\/40{
  --tw-gradient-to: rgba(134, 207, 181, 0.4) var(--tw-gradient-to-position);
}
.to-word-color-300\\/45{
  --tw-gradient-to: rgba(134, 207, 181, 0.45) var(--tw-gradient-to-position);
}
.to-word-color-300\\/5{
  --tw-gradient-to: rgba(134, 207, 181, 0.05) var(--tw-gradient-to-position);
}
.to-word-color-300\\/50{
  --tw-gradient-to: rgba(134, 207, 181, 0.5) var(--tw-gradient-to-position);
}
.to-word-color-300\\/55{
  --tw-gradient-to: rgba(134, 207, 181, 0.55) var(--tw-gradient-to-position);
}
.to-word-color-300\\/60{
  --tw-gradient-to: rgba(134, 207, 181, 0.6) var(--tw-gradient-to-position);
}
.to-word-color-300\\/65{
  --tw-gradient-to: rgba(134, 207, 181, 0.65) var(--tw-gradient-to-position);
}
.to-word-color-300\\/70{
  --tw-gradient-to: rgba(134, 207, 181, 0.7) var(--tw-gradient-to-position);
}
.to-word-color-300\\/75{
  --tw-gradient-to: rgba(134, 207, 181, 0.75) var(--tw-gradient-to-position);
}
.to-word-color-300\\/80{
  --tw-gradient-to: rgba(134, 207, 181, 0.8) var(--tw-gradient-to-position);
}
.to-word-color-300\\/85{
  --tw-gradient-to: rgba(134, 207, 181, 0.85) var(--tw-gradient-to-position);
}
.to-word-color-300\\/90{
  --tw-gradient-to: rgba(134, 207, 181, 0.9) var(--tw-gradient-to-position);
}
.to-word-color-300\\/95{
  --tw-gradient-to: rgba(134, 207, 181, 0.95) var(--tw-gradient-to-position);
}
.to-word-color-400{
  --tw-gradient-to: #53b494 var(--tw-gradient-to-position);
}
.to-word-color-400\\/0{
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
}
.to-word-color-400\\/10{
  --tw-gradient-to: rgba(83, 180, 148, 0.1) var(--tw-gradient-to-position);
}
.to-word-color-400\\/100{
  --tw-gradient-to: rgb(83, 180, 148) var(--tw-gradient-to-position);
}
.to-word-color-400\\/15{
  --tw-gradient-to: rgba(83, 180, 148, 0.15) var(--tw-gradient-to-position);
}
.to-word-color-400\\/20{
  --tw-gradient-to: rgba(83, 180, 148, 0.2) var(--tw-gradient-to-position);
}
.to-word-color-400\\/25{
  --tw-gradient-to: rgba(83, 180, 148, 0.25) var(--tw-gradient-to-position);
}
.to-word-color-400\\/30{
  --tw-gradient-to: rgba(83, 180, 148, 0.3) var(--tw-gradient-to-position);
}
.to-word-color-400\\/35{
  --tw-gradient-to: rgba(83, 180, 148, 0.35) var(--tw-gradient-to-position);
}
.to-word-color-400\\/40{
  --tw-gradient-to: rgba(83, 180, 148, 0.4) var(--tw-gradient-to-position);
}
.to-word-color-400\\/45{
  --tw-gradient-to: rgba(83, 180, 148, 0.45) var(--tw-gradient-to-position);
}
.to-word-color-400\\/5{
  --tw-gradient-to: rgba(83, 180, 148, 0.05) var(--tw-gradient-to-position);
}
.to-word-color-400\\/50{
  --tw-gradient-to: rgba(83, 180, 148, 0.5) var(--tw-gradient-to-position);
}
.to-word-color-400\\/55{
  --tw-gradient-to: rgba(83, 180, 148, 0.55) var(--tw-gradient-to-position);
}
.to-word-color-400\\/60{
  --tw-gradient-to: rgba(83, 180, 148, 0.6) var(--tw-gradient-to-position);
}
.to-word-color-400\\/65{
  --tw-gradient-to: rgba(83, 180, 148, 0.65) var(--tw-gradient-to-position);
}
.to-word-color-400\\/70{
  --tw-gradient-to: rgba(83, 180, 148, 0.7) var(--tw-gradient-to-position);
}
.to-word-color-400\\/75{
  --tw-gradient-to: rgba(83, 180, 148, 0.75) var(--tw-gradient-to-position);
}
.to-word-color-400\\/80{
  --tw-gradient-to: rgba(83, 180, 148, 0.8) var(--tw-gradient-to-position);
}
.to-word-color-400\\/85{
  --tw-gradient-to: rgba(83, 180, 148, 0.85) var(--tw-gradient-to-position);
}
.to-word-color-400\\/90{
  --tw-gradient-to: rgba(83, 180, 148, 0.9) var(--tw-gradient-to-position);
}
.to-word-color-400\\/95{
  --tw-gradient-to: rgba(83, 180, 148, 0.95) var(--tw-gradient-to-position);
}
.to-word-color-500{
  --tw-gradient-to: #2c876d var(--tw-gradient-to-position);
}
.to-word-color-500\\/0{
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
}
.to-word-color-500\\/10{
  --tw-gradient-to: rgba(44, 135, 109, 0.1) var(--tw-gradient-to-position);
}
.to-word-color-500\\/100{
  --tw-gradient-to: rgb(44, 135, 109) var(--tw-gradient-to-position);
}
.to-word-color-500\\/15{
  --tw-gradient-to: rgba(44, 135, 109, 0.15) var(--tw-gradient-to-position);
}
.to-word-color-500\\/20{
  --tw-gradient-to: rgba(44, 135, 109, 0.2) var(--tw-gradient-to-position);
}
.to-word-color-500\\/25{
  --tw-gradient-to: rgba(44, 135, 109, 0.25) var(--tw-gradient-to-position);
}
.to-word-color-500\\/30{
  --tw-gradient-to: rgba(44, 135, 109, 0.3) var(--tw-gradient-to-position);
}
.to-word-color-500\\/35{
  --tw-gradient-to: rgba(44, 135, 109, 0.35) var(--tw-gradient-to-position);
}
.to-word-color-500\\/40{
  --tw-gradient-to: rgba(44, 135, 109, 0.4) var(--tw-gradient-to-position);
}
.to-word-color-500\\/45{
  --tw-gradient-to: rgba(44, 135, 109, 0.45) var(--tw-gradient-to-position);
}
.to-word-color-500\\/5{
  --tw-gradient-to: rgba(44, 135, 109, 0.05) var(--tw-gradient-to-position);
}
.to-word-color-500\\/50{
  --tw-gradient-to: rgba(44, 135, 109, 0.5) var(--tw-gradient-to-position);
}
.to-word-color-500\\/55{
  --tw-gradient-to: rgba(44, 135, 109, 0.55) var(--tw-gradient-to-position);
}
.to-word-color-500\\/60{
  --tw-gradient-to: rgba(44, 135, 109, 0.6) var(--tw-gradient-to-position);
}
.to-word-color-500\\/65{
  --tw-gradient-to: rgba(44, 135, 109, 0.65) var(--tw-gradient-to-position);
}
.to-word-color-500\\/70{
  --tw-gradient-to: rgba(44, 135, 109, 0.7) var(--tw-gradient-to-position);
}
.to-word-color-500\\/75{
  --tw-gradient-to: rgba(44, 135, 109, 0.75) var(--tw-gradient-to-position);
}
.to-word-color-500\\/80{
  --tw-gradient-to: rgba(44, 135, 109, 0.8) var(--tw-gradient-to-position);
}
.to-word-color-500\\/85{
  --tw-gradient-to: rgba(44, 135, 109, 0.85) var(--tw-gradient-to-position);
}
.to-word-color-500\\/90{
  --tw-gradient-to: rgba(44, 135, 109, 0.9) var(--tw-gradient-to-position);
}
.to-word-color-500\\/95{
  --tw-gradient-to: rgba(44, 135, 109, 0.95) var(--tw-gradient-to-position);
}
.to-word-color-600{
  --tw-gradient-to: #227962 var(--tw-gradient-to-position);
}
.to-word-color-600\\/0{
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
}
.to-word-color-600\\/10{
  --tw-gradient-to: rgba(34, 121, 98, 0.1) var(--tw-gradient-to-position);
}
.to-word-color-600\\/100{
  --tw-gradient-to: rgb(34, 121, 98) var(--tw-gradient-to-position);
}
.to-word-color-600\\/15{
  --tw-gradient-to: rgba(34, 121, 98, 0.15) var(--tw-gradient-to-position);
}
.to-word-color-600\\/20{
  --tw-gradient-to: rgba(34, 121, 98, 0.2) var(--tw-gradient-to-position);
}
.to-word-color-600\\/25{
  --tw-gradient-to: rgba(34, 121, 98, 0.25) var(--tw-gradient-to-position);
}
.to-word-color-600\\/30{
  --tw-gradient-to: rgba(34, 121, 98, 0.3) var(--tw-gradient-to-position);
}
.to-word-color-600\\/35{
  --tw-gradient-to: rgba(34, 121, 98, 0.35) var(--tw-gradient-to-position);
}
.to-word-color-600\\/40{
  --tw-gradient-to: rgba(34, 121, 98, 0.4) var(--tw-gradient-to-position);
}
.to-word-color-600\\/45{
  --tw-gradient-to: rgba(34, 121, 98, 0.45) var(--tw-gradient-to-position);
}
.to-word-color-600\\/5{
  --tw-gradient-to: rgba(34, 121, 98, 0.05) var(--tw-gradient-to-position);
}
.to-word-color-600\\/50{
  --tw-gradient-to: rgba(34, 121, 98, 0.5) var(--tw-gradient-to-position);
}
.to-word-color-600\\/55{
  --tw-gradient-to: rgba(34, 121, 98, 0.55) var(--tw-gradient-to-position);
}
.to-word-color-600\\/60{
  --tw-gradient-to: rgba(34, 121, 98, 0.6) var(--tw-gradient-to-position);
}
.to-word-color-600\\/65{
  --tw-gradient-to: rgba(34, 121, 98, 0.65) var(--tw-gradient-to-position);
}
.to-word-color-600\\/70{
  --tw-gradient-to: rgba(34, 121, 98, 0.7) var(--tw-gradient-to-position);
}
.to-word-color-600\\/75{
  --tw-gradient-to: rgba(34, 121, 98, 0.75) var(--tw-gradient-to-position);
}
.to-word-color-600\\/80{
  --tw-gradient-to: rgba(34, 121, 98, 0.8) var(--tw-gradient-to-position);
}
.to-word-color-600\\/85{
  --tw-gradient-to: rgba(34, 121, 98, 0.85) var(--tw-gradient-to-position);
}
.to-word-color-600\\/90{
  --tw-gradient-to: rgba(34, 121, 98, 0.9) var(--tw-gradient-to-position);
}
.to-word-color-600\\/95{
  --tw-gradient-to: rgba(34, 121, 98, 0.95) var(--tw-gradient-to-position);
}
.to-word-color-700{
  --tw-gradient-to: #1b6150 var(--tw-gradient-to-position);
}
.to-word-color-700\\/0{
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
}
.to-word-color-700\\/10{
  --tw-gradient-to: rgba(27, 97, 80, 0.1) var(--tw-gradient-to-position);
}
.to-word-color-700\\/100{
  --tw-gradient-to: rgb(27, 97, 80) var(--tw-gradient-to-position);
}
.to-word-color-700\\/15{
  --tw-gradient-to: rgba(27, 97, 80, 0.15) var(--tw-gradient-to-position);
}
.to-word-color-700\\/20{
  --tw-gradient-to: rgba(27, 97, 80, 0.2) var(--tw-gradient-to-position);
}
.to-word-color-700\\/25{
  --tw-gradient-to: rgba(27, 97, 80, 0.25) var(--tw-gradient-to-position);
}
.to-word-color-700\\/30{
  --tw-gradient-to: rgba(27, 97, 80, 0.3) var(--tw-gradient-to-position);
}
.to-word-color-700\\/35{
  --tw-gradient-to: rgba(27, 97, 80, 0.35) var(--tw-gradient-to-position);
}
.to-word-color-700\\/40{
  --tw-gradient-to: rgba(27, 97, 80, 0.4) var(--tw-gradient-to-position);
}
.to-word-color-700\\/45{
  --tw-gradient-to: rgba(27, 97, 80, 0.45) var(--tw-gradient-to-position);
}
.to-word-color-700\\/5{
  --tw-gradient-to: rgba(27, 97, 80, 0.05) var(--tw-gradient-to-position);
}
.to-word-color-700\\/50{
  --tw-gradient-to: rgba(27, 97, 80, 0.5) var(--tw-gradient-to-position);
}
.to-word-color-700\\/55{
  --tw-gradient-to: rgba(27, 97, 80, 0.55) var(--tw-gradient-to-position);
}
.to-word-color-700\\/60{
  --tw-gradient-to: rgba(27, 97, 80, 0.6) var(--tw-gradient-to-position);
}
.to-word-color-700\\/65{
  --tw-gradient-to: rgba(27, 97, 80, 0.65) var(--tw-gradient-to-position);
}
.to-word-color-700\\/70{
  --tw-gradient-to: rgba(27, 97, 80, 0.7) var(--tw-gradient-to-position);
}
.to-word-color-700\\/75{
  --tw-gradient-to: rgba(27, 97, 80, 0.75) var(--tw-gradient-to-position);
}
.to-word-color-700\\/80{
  --tw-gradient-to: rgba(27, 97, 80, 0.8) var(--tw-gradient-to-position);
}
.to-word-color-700\\/85{
  --tw-gradient-to: rgba(27, 97, 80, 0.85) var(--tw-gradient-to-position);
}
.to-word-color-700\\/90{
  --tw-gradient-to: rgba(27, 97, 80, 0.9) var(--tw-gradient-to-position);
}
.to-word-color-700\\/95{
  --tw-gradient-to: rgba(27, 97, 80, 0.95) var(--tw-gradient-to-position);
}
.to-word-color-800{
  --tw-gradient-to: #184d40 var(--tw-gradient-to-position);
}
.to-word-color-800\\/0{
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
}
.to-word-color-800\\/10{
  --tw-gradient-to: rgba(24, 77, 64, 0.1) var(--tw-gradient-to-position);
}
.to-word-color-800\\/100{
  --tw-gradient-to: rgb(24, 77, 64) var(--tw-gradient-to-position);
}
.to-word-color-800\\/15{
  --tw-gradient-to: rgba(24, 77, 64, 0.15) var(--tw-gradient-to-position);
}
.to-word-color-800\\/20{
  --tw-gradient-to: rgba(24, 77, 64, 0.2) var(--tw-gradient-to-position);
}
.to-word-color-800\\/25{
  --tw-gradient-to: rgba(24, 77, 64, 0.25) var(--tw-gradient-to-position);
}
.to-word-color-800\\/30{
  --tw-gradient-to: rgba(24, 77, 64, 0.3) var(--tw-gradient-to-position);
}
.to-word-color-800\\/35{
  --tw-gradient-to: rgba(24, 77, 64, 0.35) var(--tw-gradient-to-position);
}
.to-word-color-800\\/40{
  --tw-gradient-to: rgba(24, 77, 64, 0.4) var(--tw-gradient-to-position);
}
.to-word-color-800\\/45{
  --tw-gradient-to: rgba(24, 77, 64, 0.45) var(--tw-gradient-to-position);
}
.to-word-color-800\\/5{
  --tw-gradient-to: rgba(24, 77, 64, 0.05) var(--tw-gradient-to-position);
}
.to-word-color-800\\/50{
  --tw-gradient-to: rgba(24, 77, 64, 0.5) var(--tw-gradient-to-position);
}
.to-word-color-800\\/55{
  --tw-gradient-to: rgba(24, 77, 64, 0.55) var(--tw-gradient-to-position);
}
.to-word-color-800\\/60{
  --tw-gradient-to: rgba(24, 77, 64, 0.6) var(--tw-gradient-to-position);
}
.to-word-color-800\\/65{
  --tw-gradient-to: rgba(24, 77, 64, 0.65) var(--tw-gradient-to-position);
}
.to-word-color-800\\/70{
  --tw-gradient-to: rgba(24, 77, 64, 0.7) var(--tw-gradient-to-position);
}
.to-word-color-800\\/75{
  --tw-gradient-to: rgba(24, 77, 64, 0.75) var(--tw-gradient-to-position);
}
.to-word-color-800\\/80{
  --tw-gradient-to: rgba(24, 77, 64, 0.8) var(--tw-gradient-to-position);
}
.to-word-color-800\\/85{
  --tw-gradient-to: rgba(24, 77, 64, 0.85) var(--tw-gradient-to-position);
}
.to-word-color-800\\/90{
  --tw-gradient-to: rgba(24, 77, 64, 0.9) var(--tw-gradient-to-position);
}
.to-word-color-800\\/95{
  --tw-gradient-to: rgba(24, 77, 64, 0.95) var(--tw-gradient-to-position);
}
.to-word-color-900{
  --tw-gradient-to: #144036 var(--tw-gradient-to-position);
}
.to-word-color-900\\/0{
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
}
.to-word-color-900\\/10{
  --tw-gradient-to: rgba(20, 64, 54, 0.1) var(--tw-gradient-to-position);
}
.to-word-color-900\\/100{
  --tw-gradient-to: rgb(20, 64, 54) var(--tw-gradient-to-position);
}
.to-word-color-900\\/15{
  --tw-gradient-to: rgba(20, 64, 54, 0.15) var(--tw-gradient-to-position);
}
.to-word-color-900\\/20{
  --tw-gradient-to: rgba(20, 64, 54, 0.2) var(--tw-gradient-to-position);
}
.to-word-color-900\\/25{
  --tw-gradient-to: rgba(20, 64, 54, 0.25) var(--tw-gradient-to-position);
}
.to-word-color-900\\/30{
  --tw-gradient-to: rgba(20, 64, 54, 0.3) var(--tw-gradient-to-position);
}
.to-word-color-900\\/35{
  --tw-gradient-to: rgba(20, 64, 54, 0.35) var(--tw-gradient-to-position);
}
.to-word-color-900\\/40{
  --tw-gradient-to: rgba(20, 64, 54, 0.4) var(--tw-gradient-to-position);
}
.to-word-color-900\\/45{
  --tw-gradient-to: rgba(20, 64, 54, 0.45) var(--tw-gradient-to-position);
}
.to-word-color-900\\/5{
  --tw-gradient-to: rgba(20, 64, 54, 0.05) var(--tw-gradient-to-position);
}
.to-word-color-900\\/50{
  --tw-gradient-to: rgba(20, 64, 54, 0.5) var(--tw-gradient-to-position);
}
.to-word-color-900\\/55{
  --tw-gradient-to: rgba(20, 64, 54, 0.55) var(--tw-gradient-to-position);
}
.to-word-color-900\\/60{
  --tw-gradient-to: rgba(20, 64, 54, 0.6) var(--tw-gradient-to-position);
}
.to-word-color-900\\/65{
  --tw-gradient-to: rgba(20, 64, 54, 0.65) var(--tw-gradient-to-position);
}
.to-word-color-900\\/70{
  --tw-gradient-to: rgba(20, 64, 54, 0.7) var(--tw-gradient-to-position);
}
.to-word-color-900\\/75{
  --tw-gradient-to: rgba(20, 64, 54, 0.75) var(--tw-gradient-to-position);
}
.to-word-color-900\\/80{
  --tw-gradient-to: rgba(20, 64, 54, 0.8) var(--tw-gradient-to-position);
}
.to-word-color-900\\/85{
  --tw-gradient-to: rgba(20, 64, 54, 0.85) var(--tw-gradient-to-position);
}
.to-word-color-900\\/90{
  --tw-gradient-to: rgba(20, 64, 54, 0.9) var(--tw-gradient-to-position);
}
.to-word-color-900\\/95{
  --tw-gradient-to: rgba(20, 64, 54, 0.95) var(--tw-gradient-to-position);
}
.to-word-color-950{
  --tw-gradient-to: #0a241f var(--tw-gradient-to-position);
}
.to-word-color-950\\/0{
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
}
.to-word-color-950\\/10{
  --tw-gradient-to: rgba(10, 36, 31, 0.1) var(--tw-gradient-to-position);
}
.to-word-color-950\\/100{
  --tw-gradient-to: rgb(10, 36, 31) var(--tw-gradient-to-position);
}
.to-word-color-950\\/15{
  --tw-gradient-to: rgba(10, 36, 31, 0.15) var(--tw-gradient-to-position);
}
.to-word-color-950\\/20{
  --tw-gradient-to: rgba(10, 36, 31, 0.2) var(--tw-gradient-to-position);
}
.to-word-color-950\\/25{
  --tw-gradient-to: rgba(10, 36, 31, 0.25) var(--tw-gradient-to-position);
}
.to-word-color-950\\/30{
  --tw-gradient-to: rgba(10, 36, 31, 0.3) var(--tw-gradient-to-position);
}
.to-word-color-950\\/35{
  --tw-gradient-to: rgba(10, 36, 31, 0.35) var(--tw-gradient-to-position);
}
.to-word-color-950\\/40{
  --tw-gradient-to: rgba(10, 36, 31, 0.4) var(--tw-gradient-to-position);
}
.to-word-color-950\\/45{
  --tw-gradient-to: rgba(10, 36, 31, 0.45) var(--tw-gradient-to-position);
}
.to-word-color-950\\/5{
  --tw-gradient-to: rgba(10, 36, 31, 0.05) var(--tw-gradient-to-position);
}
.to-word-color-950\\/50{
  --tw-gradient-to: rgba(10, 36, 31, 0.5) var(--tw-gradient-to-position);
}
.to-word-color-950\\/55{
  --tw-gradient-to: rgba(10, 36, 31, 0.55) var(--tw-gradient-to-position);
}
.to-word-color-950\\/60{
  --tw-gradient-to: rgba(10, 36, 31, 0.6) var(--tw-gradient-to-position);
}
.to-word-color-950\\/65{
  --tw-gradient-to: rgba(10, 36, 31, 0.65) var(--tw-gradient-to-position);
}
.to-word-color-950\\/70{
  --tw-gradient-to: rgba(10, 36, 31, 0.7) var(--tw-gradient-to-position);
}
.to-word-color-950\\/75{
  --tw-gradient-to: rgba(10, 36, 31, 0.75) var(--tw-gradient-to-position);
}
.to-word-color-950\\/80{
  --tw-gradient-to: rgba(10, 36, 31, 0.8) var(--tw-gradient-to-position);
}
.to-word-color-950\\/85{
  --tw-gradient-to: rgba(10, 36, 31, 0.85) var(--tw-gradient-to-position);
}
.to-word-color-950\\/90{
  --tw-gradient-to: rgba(10, 36, 31, 0.9) var(--tw-gradient-to-position);
}
.to-word-color-950\\/95{
  --tw-gradient-to: rgba(10, 36, 31, 0.95) var(--tw-gradient-to-position);
}
.bg-cover{
  background-size: cover;
}
.bg-center{
  background-position: center;
}
.bg-right{
  background-position: right;
}
.bg-no-repeat{
  background-repeat: no-repeat;
}
.fill-blumine-100{
  fill: #daeef3;
}
.fill-blumine-100\\/0{
  fill: rgba(218, 238, 243, 0);
}
.fill-blumine-100\\/10{
  fill: rgba(218, 238, 243, 0.1);
}
.fill-blumine-100\\/100{
  fill: rgb(218, 238, 243);
}
.fill-blumine-100\\/15{
  fill: rgba(218, 238, 243, 0.15);
}
.fill-blumine-100\\/20{
  fill: rgba(218, 238, 243, 0.2);
}
.fill-blumine-100\\/25{
  fill: rgba(218, 238, 243, 0.25);
}
.fill-blumine-100\\/30{
  fill: rgba(218, 238, 243, 0.3);
}
.fill-blumine-100\\/35{
  fill: rgba(218, 238, 243, 0.35);
}
.fill-blumine-100\\/40{
  fill: rgba(218, 238, 243, 0.4);
}
.fill-blumine-100\\/45{
  fill: rgba(218, 238, 243, 0.45);
}
.fill-blumine-100\\/5{
  fill: rgba(218, 238, 243, 0.05);
}
.fill-blumine-100\\/50{
  fill: rgba(218, 238, 243, 0.5);
}
.fill-blumine-100\\/55{
  fill: rgba(218, 238, 243, 0.55);
}
.fill-blumine-100\\/60{
  fill: rgba(218, 238, 243, 0.6);
}
.fill-blumine-100\\/65{
  fill: rgba(218, 238, 243, 0.65);
}
.fill-blumine-100\\/70{
  fill: rgba(218, 238, 243, 0.7);
}
.fill-blumine-100\\/75{
  fill: rgba(218, 238, 243, 0.75);
}
.fill-blumine-100\\/80{
  fill: rgba(218, 238, 243, 0.8);
}
.fill-blumine-100\\/85{
  fill: rgba(218, 238, 243, 0.85);
}
.fill-blumine-100\\/90{
  fill: rgba(218, 238, 243, 0.9);
}
.fill-blumine-100\\/95{
  fill: rgba(218, 238, 243, 0.95);
}
.fill-blumine-200{
  fill: #badee7;
}
.fill-blumine-200\\/0{
  fill: rgba(186, 222, 231, 0);
}
.fill-blumine-200\\/10{
  fill: rgba(186, 222, 231, 0.1);
}
.fill-blumine-200\\/100{
  fill: rgb(186, 222, 231);
}
.fill-blumine-200\\/15{
  fill: rgba(186, 222, 231, 0.15);
}
.fill-blumine-200\\/20{
  fill: rgba(186, 222, 231, 0.2);
}
.fill-blumine-200\\/25{
  fill: rgba(186, 222, 231, 0.25);
}
.fill-blumine-200\\/30{
  fill: rgba(186, 222, 231, 0.3);
}
.fill-blumine-200\\/35{
  fill: rgba(186, 222, 231, 0.35);
}
.fill-blumine-200\\/40{
  fill: rgba(186, 222, 231, 0.4);
}
.fill-blumine-200\\/45{
  fill: rgba(186, 222, 231, 0.45);
}
.fill-blumine-200\\/5{
  fill: rgba(186, 222, 231, 0.05);
}
.fill-blumine-200\\/50{
  fill: rgba(186, 222, 231, 0.5);
}
.fill-blumine-200\\/55{
  fill: rgba(186, 222, 231, 0.55);
}
.fill-blumine-200\\/60{
  fill: rgba(186, 222, 231, 0.6);
}
.fill-blumine-200\\/65{
  fill: rgba(186, 222, 231, 0.65);
}
.fill-blumine-200\\/70{
  fill: rgba(186, 222, 231, 0.7);
}
.fill-blumine-200\\/75{
  fill: rgba(186, 222, 231, 0.75);
}
.fill-blumine-200\\/80{
  fill: rgba(186, 222, 231, 0.8);
}
.fill-blumine-200\\/85{
  fill: rgba(186, 222, 231, 0.85);
}
.fill-blumine-200\\/90{
  fill: rgba(186, 222, 231, 0.9);
}
.fill-blumine-200\\/95{
  fill: rgba(186, 222, 231, 0.95);
}
.fill-blumine-300{
  fill: #89c5d7;
}
.fill-blumine-300\\/0{
  fill: rgba(137, 197, 215, 0);
}
.fill-blumine-300\\/10{
  fill: rgba(137, 197, 215, 0.1);
}
.fill-blumine-300\\/100{
  fill: rgb(137, 197, 215);
}
.fill-blumine-300\\/15{
  fill: rgba(137, 197, 215, 0.15);
}
.fill-blumine-300\\/20{
  fill: rgba(137, 197, 215, 0.2);
}
.fill-blumine-300\\/25{
  fill: rgba(137, 197, 215, 0.25);
}
.fill-blumine-300\\/30{
  fill: rgba(137, 197, 215, 0.3);
}
.fill-blumine-300\\/35{
  fill: rgba(137, 197, 215, 0.35);
}
.fill-blumine-300\\/40{
  fill: rgba(137, 197, 215, 0.4);
}
.fill-blumine-300\\/45{
  fill: rgba(137, 197, 215, 0.45);
}
.fill-blumine-300\\/5{
  fill: rgba(137, 197, 215, 0.05);
}
.fill-blumine-300\\/50{
  fill: rgba(137, 197, 215, 0.5);
}
.fill-blumine-300\\/55{
  fill: rgba(137, 197, 215, 0.55);
}
.fill-blumine-300\\/60{
  fill: rgba(137, 197, 215, 0.6);
}
.fill-blumine-300\\/65{
  fill: rgba(137, 197, 215, 0.65);
}
.fill-blumine-300\\/70{
  fill: rgba(137, 197, 215, 0.7);
}
.fill-blumine-300\\/75{
  fill: rgba(137, 197, 215, 0.75);
}
.fill-blumine-300\\/80{
  fill: rgba(137, 197, 215, 0.8);
}
.fill-blumine-300\\/85{
  fill: rgba(137, 197, 215, 0.85);
}
.fill-blumine-300\\/90{
  fill: rgba(137, 197, 215, 0.9);
}
.fill-blumine-300\\/95{
  fill: rgba(137, 197, 215, 0.95);
}
.fill-blumine-400{
  fill: #52a3be;
}
.fill-blumine-400\\/0{
  fill: rgba(82, 163, 190, 0);
}
.fill-blumine-400\\/10{
  fill: rgba(82, 163, 190, 0.1);
}
.fill-blumine-400\\/100{
  fill: rgb(82, 163, 190);
}
.fill-blumine-400\\/15{
  fill: rgba(82, 163, 190, 0.15);
}
.fill-blumine-400\\/20{
  fill: rgba(82, 163, 190, 0.2);
}
.fill-blumine-400\\/25{
  fill: rgba(82, 163, 190, 0.25);
}
.fill-blumine-400\\/30{
  fill: rgba(82, 163, 190, 0.3);
}
.fill-blumine-400\\/35{
  fill: rgba(82, 163, 190, 0.35);
}
.fill-blumine-400\\/40{
  fill: rgba(82, 163, 190, 0.4);
}
.fill-blumine-400\\/45{
  fill: rgba(82, 163, 190, 0.45);
}
.fill-blumine-400\\/5{
  fill: rgba(82, 163, 190, 0.05);
}
.fill-blumine-400\\/50{
  fill: rgba(82, 163, 190, 0.5);
}
.fill-blumine-400\\/55{
  fill: rgba(82, 163, 190, 0.55);
}
.fill-blumine-400\\/60{
  fill: rgba(82, 163, 190, 0.6);
}
.fill-blumine-400\\/65{
  fill: rgba(82, 163, 190, 0.65);
}
.fill-blumine-400\\/70{
  fill: rgba(82, 163, 190, 0.7);
}
.fill-blumine-400\\/75{
  fill: rgba(82, 163, 190, 0.75);
}
.fill-blumine-400\\/80{
  fill: rgba(82, 163, 190, 0.8);
}
.fill-blumine-400\\/85{
  fill: rgba(82, 163, 190, 0.85);
}
.fill-blumine-400\\/90{
  fill: rgba(82, 163, 190, 0.9);
}
.fill-blumine-400\\/95{
  fill: rgba(82, 163, 190, 0.95);
}
.fill-blumine-500{
  fill: #3787a3;
}
.fill-blumine-500\\/0{
  fill: rgba(55, 135, 163, 0);
}
.fill-blumine-500\\/10{
  fill: rgba(55, 135, 163, 0.1);
}
.fill-blumine-500\\/100{
  fill: rgb(55, 135, 163);
}
.fill-blumine-500\\/15{
  fill: rgba(55, 135, 163, 0.15);
}
.fill-blumine-500\\/20{
  fill: rgba(55, 135, 163, 0.2);
}
.fill-blumine-500\\/25{
  fill: rgba(55, 135, 163, 0.25);
}
.fill-blumine-500\\/30{
  fill: rgba(55, 135, 163, 0.3);
}
.fill-blumine-500\\/35{
  fill: rgba(55, 135, 163, 0.35);
}
.fill-blumine-500\\/40{
  fill: rgba(55, 135, 163, 0.4);
}
.fill-blumine-500\\/45{
  fill: rgba(55, 135, 163, 0.45);
}
.fill-blumine-500\\/5{
  fill: rgba(55, 135, 163, 0.05);
}
.fill-blumine-500\\/50{
  fill: rgba(55, 135, 163, 0.5);
}
.fill-blumine-500\\/55{
  fill: rgba(55, 135, 163, 0.55);
}
.fill-blumine-500\\/60{
  fill: rgba(55, 135, 163, 0.6);
}
.fill-blumine-500\\/65{
  fill: rgba(55, 135, 163, 0.65);
}
.fill-blumine-500\\/70{
  fill: rgba(55, 135, 163, 0.7);
}
.fill-blumine-500\\/75{
  fill: rgba(55, 135, 163, 0.75);
}
.fill-blumine-500\\/80{
  fill: rgba(55, 135, 163, 0.8);
}
.fill-blumine-500\\/85{
  fill: rgba(55, 135, 163, 0.85);
}
.fill-blumine-500\\/90{
  fill: rgba(55, 135, 163, 0.9);
}
.fill-blumine-500\\/95{
  fill: rgba(55, 135, 163, 0.95);
}
.fill-blumine-600{
  fill: #306d8a;
}
.fill-blumine-600\\/0{
  fill: rgba(48, 109, 138, 0);
}
.fill-blumine-600\\/10{
  fill: rgba(48, 109, 138, 0.1);
}
.fill-blumine-600\\/100{
  fill: rgb(48, 109, 138);
}
.fill-blumine-600\\/15{
  fill: rgba(48, 109, 138, 0.15);
}
.fill-blumine-600\\/20{
  fill: rgba(48, 109, 138, 0.2);
}
.fill-blumine-600\\/25{
  fill: rgba(48, 109, 138, 0.25);
}
.fill-blumine-600\\/30{
  fill: rgba(48, 109, 138, 0.3);
}
.fill-blumine-600\\/35{
  fill: rgba(48, 109, 138, 0.35);
}
.fill-blumine-600\\/40{
  fill: rgba(48, 109, 138, 0.4);
}
.fill-blumine-600\\/45{
  fill: rgba(48, 109, 138, 0.45);
}
.fill-blumine-600\\/5{
  fill: rgba(48, 109, 138, 0.05);
}
.fill-blumine-600\\/50{
  fill: rgba(48, 109, 138, 0.5);
}
.fill-blumine-600\\/55{
  fill: rgba(48, 109, 138, 0.55);
}
.fill-blumine-600\\/60{
  fill: rgba(48, 109, 138, 0.6);
}
.fill-blumine-600\\/65{
  fill: rgba(48, 109, 138, 0.65);
}
.fill-blumine-600\\/70{
  fill: rgba(48, 109, 138, 0.7);
}
.fill-blumine-600\\/75{
  fill: rgba(48, 109, 138, 0.75);
}
.fill-blumine-600\\/80{
  fill: rgba(48, 109, 138, 0.8);
}
.fill-blumine-600\\/85{
  fill: rgba(48, 109, 138, 0.85);
}
.fill-blumine-600\\/90{
  fill: rgba(48, 109, 138, 0.9);
}
.fill-blumine-600\\/95{
  fill: rgba(48, 109, 138, 0.95);
}
.fill-blumine-700{
  fill: #2d5b72;
}
.fill-blumine-700\\/0{
  fill: rgba(45, 91, 114, 0);
}
.fill-blumine-700\\/10{
  fill: rgba(45, 91, 114, 0.1);
}
.fill-blumine-700\\/100{
  fill: rgb(45, 91, 114);
}
.fill-blumine-700\\/15{
  fill: rgba(45, 91, 114, 0.15);
}
.fill-blumine-700\\/20{
  fill: rgba(45, 91, 114, 0.2);
}
.fill-blumine-700\\/25{
  fill: rgba(45, 91, 114, 0.25);
}
.fill-blumine-700\\/30{
  fill: rgba(45, 91, 114, 0.3);
}
.fill-blumine-700\\/35{
  fill: rgba(45, 91, 114, 0.35);
}
.fill-blumine-700\\/40{
  fill: rgba(45, 91, 114, 0.4);
}
.fill-blumine-700\\/45{
  fill: rgba(45, 91, 114, 0.45);
}
.fill-blumine-700\\/5{
  fill: rgba(45, 91, 114, 0.05);
}
.fill-blumine-700\\/50{
  fill: rgba(45, 91, 114, 0.5);
}
.fill-blumine-700\\/55{
  fill: rgba(45, 91, 114, 0.55);
}
.fill-blumine-700\\/60{
  fill: rgba(45, 91, 114, 0.6);
}
.fill-blumine-700\\/65{
  fill: rgba(45, 91, 114, 0.65);
}
.fill-blumine-700\\/70{
  fill: rgba(45, 91, 114, 0.7);
}
.fill-blumine-700\\/75{
  fill: rgba(45, 91, 114, 0.75);
}
.fill-blumine-700\\/80{
  fill: rgba(45, 91, 114, 0.8);
}
.fill-blumine-700\\/85{
  fill: rgba(45, 91, 114, 0.85);
}
.fill-blumine-700\\/90{
  fill: rgba(45, 91, 114, 0.9);
}
.fill-blumine-700\\/95{
  fill: rgba(45, 91, 114, 0.95);
}
.fill-blumine-800{
  fill: #2c4c5e;
}
.fill-blumine-800\\/0{
  fill: rgba(44, 76, 94, 0);
}
.fill-blumine-800\\/10{
  fill: rgba(44, 76, 94, 0.1);
}
.fill-blumine-800\\/100{
  fill: rgb(44, 76, 94);
}
.fill-blumine-800\\/15{
  fill: rgba(44, 76, 94, 0.15);
}
.fill-blumine-800\\/20{
  fill: rgba(44, 76, 94, 0.2);
}
.fill-blumine-800\\/25{
  fill: rgba(44, 76, 94, 0.25);
}
.fill-blumine-800\\/30{
  fill: rgba(44, 76, 94, 0.3);
}
.fill-blumine-800\\/35{
  fill: rgba(44, 76, 94, 0.35);
}
.fill-blumine-800\\/40{
  fill: rgba(44, 76, 94, 0.4);
}
.fill-blumine-800\\/45{
  fill: rgba(44, 76, 94, 0.45);
}
.fill-blumine-800\\/5{
  fill: rgba(44, 76, 94, 0.05);
}
.fill-blumine-800\\/50{
  fill: rgba(44, 76, 94, 0.5);
}
.fill-blumine-800\\/55{
  fill: rgba(44, 76, 94, 0.55);
}
.fill-blumine-800\\/60{
  fill: rgba(44, 76, 94, 0.6);
}
.fill-blumine-800\\/65{
  fill: rgba(44, 76, 94, 0.65);
}
.fill-blumine-800\\/70{
  fill: rgba(44, 76, 94, 0.7);
}
.fill-blumine-800\\/75{
  fill: rgba(44, 76, 94, 0.75);
}
.fill-blumine-800\\/80{
  fill: rgba(44, 76, 94, 0.8);
}
.fill-blumine-800\\/85{
  fill: rgba(44, 76, 94, 0.85);
}
.fill-blumine-800\\/90{
  fill: rgba(44, 76, 94, 0.9);
}
.fill-blumine-800\\/95{
  fill: rgba(44, 76, 94, 0.95);
}
.fill-blumine-900{
  fill: #284151;
}
.fill-blumine-900\\/0{
  fill: rgba(40, 65, 81, 0);
}
.fill-blumine-900\\/10{
  fill: rgba(40, 65, 81, 0.1);
}
.fill-blumine-900\\/100{
  fill: rgb(40, 65, 81);
}
.fill-blumine-900\\/15{
  fill: rgba(40, 65, 81, 0.15);
}
.fill-blumine-900\\/20{
  fill: rgba(40, 65, 81, 0.2);
}
.fill-blumine-900\\/25{
  fill: rgba(40, 65, 81, 0.25);
}
.fill-blumine-900\\/30{
  fill: rgba(40, 65, 81, 0.3);
}
.fill-blumine-900\\/35{
  fill: rgba(40, 65, 81, 0.35);
}
.fill-blumine-900\\/40{
  fill: rgba(40, 65, 81, 0.4);
}
.fill-blumine-900\\/45{
  fill: rgba(40, 65, 81, 0.45);
}
.fill-blumine-900\\/5{
  fill: rgba(40, 65, 81, 0.05);
}
.fill-blumine-900\\/50{
  fill: rgba(40, 65, 81, 0.5);
}
.fill-blumine-900\\/55{
  fill: rgba(40, 65, 81, 0.55);
}
.fill-blumine-900\\/60{
  fill: rgba(40, 65, 81, 0.6);
}
.fill-blumine-900\\/65{
  fill: rgba(40, 65, 81, 0.65);
}
.fill-blumine-900\\/70{
  fill: rgba(40, 65, 81, 0.7);
}
.fill-blumine-900\\/75{
  fill: rgba(40, 65, 81, 0.75);
}
.fill-blumine-900\\/80{
  fill: rgba(40, 65, 81, 0.8);
}
.fill-blumine-900\\/85{
  fill: rgba(40, 65, 81, 0.85);
}
.fill-blumine-900\\/90{
  fill: rgba(40, 65, 81, 0.9);
}
.fill-blumine-900\\/95{
  fill: rgba(40, 65, 81, 0.95);
}
.fill-blumine-950{
  fill: #162936;
}
.fill-blumine-950\\/0{
  fill: rgba(22, 41, 54, 0);
}
.fill-blumine-950\\/10{
  fill: rgba(22, 41, 54, 0.1);
}
.fill-blumine-950\\/100{
  fill: rgb(22, 41, 54);
}
.fill-blumine-950\\/15{
  fill: rgba(22, 41, 54, 0.15);
}
.fill-blumine-950\\/20{
  fill: rgba(22, 41, 54, 0.2);
}
.fill-blumine-950\\/25{
  fill: rgba(22, 41, 54, 0.25);
}
.fill-blumine-950\\/30{
  fill: rgba(22, 41, 54, 0.3);
}
.fill-blumine-950\\/35{
  fill: rgba(22, 41, 54, 0.35);
}
.fill-blumine-950\\/40{
  fill: rgba(22, 41, 54, 0.4);
}
.fill-blumine-950\\/45{
  fill: rgba(22, 41, 54, 0.45);
}
.fill-blumine-950\\/5{
  fill: rgba(22, 41, 54, 0.05);
}
.fill-blumine-950\\/50{
  fill: rgba(22, 41, 54, 0.5);
}
.fill-blumine-950\\/55{
  fill: rgba(22, 41, 54, 0.55);
}
.fill-blumine-950\\/60{
  fill: rgba(22, 41, 54, 0.6);
}
.fill-blumine-950\\/65{
  fill: rgba(22, 41, 54, 0.65);
}
.fill-blumine-950\\/70{
  fill: rgba(22, 41, 54, 0.7);
}
.fill-blumine-950\\/75{
  fill: rgba(22, 41, 54, 0.75);
}
.fill-blumine-950\\/80{
  fill: rgba(22, 41, 54, 0.8);
}
.fill-blumine-950\\/85{
  fill: rgba(22, 41, 54, 0.85);
}
.fill-blumine-950\\/90{
  fill: rgba(22, 41, 54, 0.9);
}
.fill-blumine-950\\/95{
  fill: rgba(22, 41, 54, 0.95);
}
.fill-charcoal-100{
  fill: #e6e6e7;
}
.fill-charcoal-100\\/0{
  fill: rgba(230, 230, 231, 0);
}
.fill-charcoal-100\\/10{
  fill: rgba(230, 230, 231, 0.1);
}
.fill-charcoal-100\\/100{
  fill: rgb(230, 230, 231);
}
.fill-charcoal-100\\/15{
  fill: rgba(230, 230, 231, 0.15);
}
.fill-charcoal-100\\/20{
  fill: rgba(230, 230, 231, 0.2);
}
.fill-charcoal-100\\/25{
  fill: rgba(230, 230, 231, 0.25);
}
.fill-charcoal-100\\/30{
  fill: rgba(230, 230, 231, 0.3);
}
.fill-charcoal-100\\/35{
  fill: rgba(230, 230, 231, 0.35);
}
.fill-charcoal-100\\/40{
  fill: rgba(230, 230, 231, 0.4);
}
.fill-charcoal-100\\/45{
  fill: rgba(230, 230, 231, 0.45);
}
.fill-charcoal-100\\/5{
  fill: rgba(230, 230, 231, 0.05);
}
.fill-charcoal-100\\/50{
  fill: rgba(230, 230, 231, 0.5);
}
.fill-charcoal-100\\/55{
  fill: rgba(230, 230, 231, 0.55);
}
.fill-charcoal-100\\/60{
  fill: rgba(230, 230, 231, 0.6);
}
.fill-charcoal-100\\/65{
  fill: rgba(230, 230, 231, 0.65);
}
.fill-charcoal-100\\/70{
  fill: rgba(230, 230, 231, 0.7);
}
.fill-charcoal-100\\/75{
  fill: rgba(230, 230, 231, 0.75);
}
.fill-charcoal-100\\/80{
  fill: rgba(230, 230, 231, 0.8);
}
.fill-charcoal-100\\/85{
  fill: rgba(230, 230, 231, 0.85);
}
.fill-charcoal-100\\/90{
  fill: rgba(230, 230, 231, 0.9);
}
.fill-charcoal-100\\/95{
  fill: rgba(230, 230, 231, 0.95);
}
.fill-charcoal-200{
  fill: #cfd0d2;
}
.fill-charcoal-200\\/0{
  fill: rgba(207, 208, 210, 0);
}
.fill-charcoal-200\\/10{
  fill: rgba(207, 208, 210, 0.1);
}
.fill-charcoal-200\\/100{
  fill: rgb(207, 208, 210);
}
.fill-charcoal-200\\/15{
  fill: rgba(207, 208, 210, 0.15);
}
.fill-charcoal-200\\/20{
  fill: rgba(207, 208, 210, 0.2);
}
.fill-charcoal-200\\/25{
  fill: rgba(207, 208, 210, 0.25);
}
.fill-charcoal-200\\/30{
  fill: rgba(207, 208, 210, 0.3);
}
.fill-charcoal-200\\/35{
  fill: rgba(207, 208, 210, 0.35);
}
.fill-charcoal-200\\/40{
  fill: rgba(207, 208, 210, 0.4);
}
.fill-charcoal-200\\/45{
  fill: rgba(207, 208, 210, 0.45);
}
.fill-charcoal-200\\/5{
  fill: rgba(207, 208, 210, 0.05);
}
.fill-charcoal-200\\/50{
  fill: rgba(207, 208, 210, 0.5);
}
.fill-charcoal-200\\/55{
  fill: rgba(207, 208, 210, 0.55);
}
.fill-charcoal-200\\/60{
  fill: rgba(207, 208, 210, 0.6);
}
.fill-charcoal-200\\/65{
  fill: rgba(207, 208, 210, 0.65);
}
.fill-charcoal-200\\/70{
  fill: rgba(207, 208, 210, 0.7);
}
.fill-charcoal-200\\/75{
  fill: rgba(207, 208, 210, 0.75);
}
.fill-charcoal-200\\/80{
  fill: rgba(207, 208, 210, 0.8);
}
.fill-charcoal-200\\/85{
  fill: rgba(207, 208, 210, 0.85);
}
.fill-charcoal-200\\/90{
  fill: rgba(207, 208, 210, 0.9);
}
.fill-charcoal-200\\/95{
  fill: rgba(207, 208, 210, 0.95);
}
.fill-charcoal-300{
  fill: #aeafb2;
}
.fill-charcoal-300\\/0{
  fill: rgba(174, 175, 178, 0);
}
.fill-charcoal-300\\/10{
  fill: rgba(174, 175, 178, 0.1);
}
.fill-charcoal-300\\/100{
  fill: rgb(174, 175, 178);
}
.fill-charcoal-300\\/15{
  fill: rgba(174, 175, 178, 0.15);
}
.fill-charcoal-300\\/20{
  fill: rgba(174, 175, 178, 0.2);
}
.fill-charcoal-300\\/25{
  fill: rgba(174, 175, 178, 0.25);
}
.fill-charcoal-300\\/30{
  fill: rgba(174, 175, 178, 0.3);
}
.fill-charcoal-300\\/35{
  fill: rgba(174, 175, 178, 0.35);
}
.fill-charcoal-300\\/40{
  fill: rgba(174, 175, 178, 0.4);
}
.fill-charcoal-300\\/45{
  fill: rgba(174, 175, 178, 0.45);
}
.fill-charcoal-300\\/5{
  fill: rgba(174, 175, 178, 0.05);
}
.fill-charcoal-300\\/50{
  fill: rgba(174, 175, 178, 0.5);
}
.fill-charcoal-300\\/55{
  fill: rgba(174, 175, 178, 0.55);
}
.fill-charcoal-300\\/60{
  fill: rgba(174, 175, 178, 0.6);
}
.fill-charcoal-300\\/65{
  fill: rgba(174, 175, 178, 0.65);
}
.fill-charcoal-300\\/70{
  fill: rgba(174, 175, 178, 0.7);
}
.fill-charcoal-300\\/75{
  fill: rgba(174, 175, 178, 0.75);
}
.fill-charcoal-300\\/80{
  fill: rgba(174, 175, 178, 0.8);
}
.fill-charcoal-300\\/85{
  fill: rgba(174, 175, 178, 0.85);
}
.fill-charcoal-300\\/90{
  fill: rgba(174, 175, 178, 0.9);
}
.fill-charcoal-300\\/95{
  fill: rgba(174, 175, 178, 0.95);
}
.fill-charcoal-400{
  fill: #85868b;
}
.fill-charcoal-400\\/0{
  fill: rgba(133, 134, 139, 0);
}
.fill-charcoal-400\\/10{
  fill: rgba(133, 134, 139, 0.1);
}
.fill-charcoal-400\\/100{
  fill: rgb(133, 134, 139);
}
.fill-charcoal-400\\/15{
  fill: rgba(133, 134, 139, 0.15);
}
.fill-charcoal-400\\/20{
  fill: rgba(133, 134, 139, 0.2);
}
.fill-charcoal-400\\/25{
  fill: rgba(133, 134, 139, 0.25);
}
.fill-charcoal-400\\/30{
  fill: rgba(133, 134, 139, 0.3);
}
.fill-charcoal-400\\/35{
  fill: rgba(133, 134, 139, 0.35);
}
.fill-charcoal-400\\/40{
  fill: rgba(133, 134, 139, 0.4);
}
.fill-charcoal-400\\/45{
  fill: rgba(133, 134, 139, 0.45);
}
.fill-charcoal-400\\/5{
  fill: rgba(133, 134, 139, 0.05);
}
.fill-charcoal-400\\/50{
  fill: rgba(133, 134, 139, 0.5);
}
.fill-charcoal-400\\/55{
  fill: rgba(133, 134, 139, 0.55);
}
.fill-charcoal-400\\/60{
  fill: rgba(133, 134, 139, 0.6);
}
.fill-charcoal-400\\/65{
  fill: rgba(133, 134, 139, 0.65);
}
.fill-charcoal-400\\/70{
  fill: rgba(133, 134, 139, 0.7);
}
.fill-charcoal-400\\/75{
  fill: rgba(133, 134, 139, 0.75);
}
.fill-charcoal-400\\/80{
  fill: rgba(133, 134, 139, 0.8);
}
.fill-charcoal-400\\/85{
  fill: rgba(133, 134, 139, 0.85);
}
.fill-charcoal-400\\/90{
  fill: rgba(133, 134, 139, 0.9);
}
.fill-charcoal-400\\/95{
  fill: rgba(133, 134, 139, 0.95);
}
.fill-charcoal-500{
  fill: #6a6b70;
}
.fill-charcoal-500\\/0{
  fill: rgba(106, 107, 112, 0);
}
.fill-charcoal-500\\/10{
  fill: rgba(106, 107, 112, 0.1);
}
.fill-charcoal-500\\/100{
  fill: rgb(106, 107, 112);
}
.fill-charcoal-500\\/15{
  fill: rgba(106, 107, 112, 0.15);
}
.fill-charcoal-500\\/20{
  fill: rgba(106, 107, 112, 0.2);
}
.fill-charcoal-500\\/25{
  fill: rgba(106, 107, 112, 0.25);
}
.fill-charcoal-500\\/30{
  fill: rgba(106, 107, 112, 0.3);
}
.fill-charcoal-500\\/35{
  fill: rgba(106, 107, 112, 0.35);
}
.fill-charcoal-500\\/40{
  fill: rgba(106, 107, 112, 0.4);
}
.fill-charcoal-500\\/45{
  fill: rgba(106, 107, 112, 0.45);
}
.fill-charcoal-500\\/5{
  fill: rgba(106, 107, 112, 0.05);
}
.fill-charcoal-500\\/50{
  fill: rgba(106, 107, 112, 0.5);
}
.fill-charcoal-500\\/55{
  fill: rgba(106, 107, 112, 0.55);
}
.fill-charcoal-500\\/60{
  fill: rgba(106, 107, 112, 0.6);
}
.fill-charcoal-500\\/65{
  fill: rgba(106, 107, 112, 0.65);
}
.fill-charcoal-500\\/70{
  fill: rgba(106, 107, 112, 0.7);
}
.fill-charcoal-500\\/75{
  fill: rgba(106, 107, 112, 0.75);
}
.fill-charcoal-500\\/80{
  fill: rgba(106, 107, 112, 0.8);
}
.fill-charcoal-500\\/85{
  fill: rgba(106, 107, 112, 0.85);
}
.fill-charcoal-500\\/90{
  fill: rgba(106, 107, 112, 0.9);
}
.fill-charcoal-500\\/95{
  fill: rgba(106, 107, 112, 0.95);
}
.fill-charcoal-600{
  fill: #5a5b60;
}
.fill-charcoal-600\\/0{
  fill: rgba(90, 91, 96, 0);
}
.fill-charcoal-600\\/10{
  fill: rgba(90, 91, 96, 0.1);
}
.fill-charcoal-600\\/100{
  fill: rgb(90, 91, 96);
}
.fill-charcoal-600\\/15{
  fill: rgba(90, 91, 96, 0.15);
}
.fill-charcoal-600\\/20{
  fill: rgba(90, 91, 96, 0.2);
}
.fill-charcoal-600\\/25{
  fill: rgba(90, 91, 96, 0.25);
}
.fill-charcoal-600\\/30{
  fill: rgba(90, 91, 96, 0.3);
}
.fill-charcoal-600\\/35{
  fill: rgba(90, 91, 96, 0.35);
}
.fill-charcoal-600\\/40{
  fill: rgba(90, 91, 96, 0.4);
}
.fill-charcoal-600\\/45{
  fill: rgba(90, 91, 96, 0.45);
}
.fill-charcoal-600\\/5{
  fill: rgba(90, 91, 96, 0.05);
}
.fill-charcoal-600\\/50{
  fill: rgba(90, 91, 96, 0.5);
}
.fill-charcoal-600\\/55{
  fill: rgba(90, 91, 96, 0.55);
}
.fill-charcoal-600\\/60{
  fill: rgba(90, 91, 96, 0.6);
}
.fill-charcoal-600\\/65{
  fill: rgba(90, 91, 96, 0.65);
}
.fill-charcoal-600\\/70{
  fill: rgba(90, 91, 96, 0.7);
}
.fill-charcoal-600\\/75{
  fill: rgba(90, 91, 96, 0.75);
}
.fill-charcoal-600\\/80{
  fill: rgba(90, 91, 96, 0.8);
}
.fill-charcoal-600\\/85{
  fill: rgba(90, 91, 96, 0.85);
}
.fill-charcoal-600\\/90{
  fill: rgba(90, 91, 96, 0.9);
}
.fill-charcoal-600\\/95{
  fill: rgba(90, 91, 96, 0.95);
}
.fill-charcoal-700{
  fill: #4d4d51;
}
.fill-charcoal-700\\/0{
  fill: rgba(77, 77, 81, 0);
}
.fill-charcoal-700\\/10{
  fill: rgba(77, 77, 81, 0.1);
}
.fill-charcoal-700\\/100{
  fill: rgb(77, 77, 81);
}
.fill-charcoal-700\\/15{
  fill: rgba(77, 77, 81, 0.15);
}
.fill-charcoal-700\\/20{
  fill: rgba(77, 77, 81, 0.2);
}
.fill-charcoal-700\\/25{
  fill: rgba(77, 77, 81, 0.25);
}
.fill-charcoal-700\\/30{
  fill: rgba(77, 77, 81, 0.3);
}
.fill-charcoal-700\\/35{
  fill: rgba(77, 77, 81, 0.35);
}
.fill-charcoal-700\\/40{
  fill: rgba(77, 77, 81, 0.4);
}
.fill-charcoal-700\\/45{
  fill: rgba(77, 77, 81, 0.45);
}
.fill-charcoal-700\\/5{
  fill: rgba(77, 77, 81, 0.05);
}
.fill-charcoal-700\\/50{
  fill: rgba(77, 77, 81, 0.5);
}
.fill-charcoal-700\\/55{
  fill: rgba(77, 77, 81, 0.55);
}
.fill-charcoal-700\\/60{
  fill: rgba(77, 77, 81, 0.6);
}
.fill-charcoal-700\\/65{
  fill: rgba(77, 77, 81, 0.65);
}
.fill-charcoal-700\\/70{
  fill: rgba(77, 77, 81, 0.7);
}
.fill-charcoal-700\\/75{
  fill: rgba(77, 77, 81, 0.75);
}
.fill-charcoal-700\\/80{
  fill: rgba(77, 77, 81, 0.8);
}
.fill-charcoal-700\\/85{
  fill: rgba(77, 77, 81, 0.85);
}
.fill-charcoal-700\\/90{
  fill: rgba(77, 77, 81, 0.9);
}
.fill-charcoal-700\\/95{
  fill: rgba(77, 77, 81, 0.95);
}
.fill-charcoal-800{
  fill: #434347;
}
.fill-charcoal-800\\/0{
  fill: rgba(67, 67, 71, 0);
}
.fill-charcoal-800\\/10{
  fill: rgba(67, 67, 71, 0.1);
}
.fill-charcoal-800\\/100{
  fill: rgb(67, 67, 71);
}
.fill-charcoal-800\\/15{
  fill: rgba(67, 67, 71, 0.15);
}
.fill-charcoal-800\\/20{
  fill: rgba(67, 67, 71, 0.2);
}
.fill-charcoal-800\\/25{
  fill: rgba(67, 67, 71, 0.25);
}
.fill-charcoal-800\\/30{
  fill: rgba(67, 67, 71, 0.3);
}
.fill-charcoal-800\\/35{
  fill: rgba(67, 67, 71, 0.35);
}
.fill-charcoal-800\\/40{
  fill: rgba(67, 67, 71, 0.4);
}
.fill-charcoal-800\\/45{
  fill: rgba(67, 67, 71, 0.45);
}
.fill-charcoal-800\\/5{
  fill: rgba(67, 67, 71, 0.05);
}
.fill-charcoal-800\\/50{
  fill: rgba(67, 67, 71, 0.5);
}
.fill-charcoal-800\\/55{
  fill: rgba(67, 67, 71, 0.55);
}
.fill-charcoal-800\\/60{
  fill: rgba(67, 67, 71, 0.6);
}
.fill-charcoal-800\\/65{
  fill: rgba(67, 67, 71, 0.65);
}
.fill-charcoal-800\\/70{
  fill: rgba(67, 67, 71, 0.7);
}
.fill-charcoal-800\\/75{
  fill: rgba(67, 67, 71, 0.75);
}
.fill-charcoal-800\\/80{
  fill: rgba(67, 67, 71, 0.8);
}
.fill-charcoal-800\\/85{
  fill: rgba(67, 67, 71, 0.85);
}
.fill-charcoal-800\\/90{
  fill: rgba(67, 67, 71, 0.9);
}
.fill-charcoal-800\\/95{
  fill: rgba(67, 67, 71, 0.95);
}
.fill-charcoal-900{
  fill: #313133;
}
.fill-charcoal-900\\/0{
  fill: rgba(49, 49, 51, 0);
}
.fill-charcoal-900\\/10{
  fill: rgba(49, 49, 51, 0.1);
}
.fill-charcoal-900\\/100{
  fill: rgb(49, 49, 51);
}
.fill-charcoal-900\\/15{
  fill: rgba(49, 49, 51, 0.15);
}
.fill-charcoal-900\\/20{
  fill: rgba(49, 49, 51, 0.2);
}
.fill-charcoal-900\\/25{
  fill: rgba(49, 49, 51, 0.25);
}
.fill-charcoal-900\\/30{
  fill: rgba(49, 49, 51, 0.3);
}
.fill-charcoal-900\\/35{
  fill: rgba(49, 49, 51, 0.35);
}
.fill-charcoal-900\\/40{
  fill: rgba(49, 49, 51, 0.4);
}
.fill-charcoal-900\\/45{
  fill: rgba(49, 49, 51, 0.45);
}
.fill-charcoal-900\\/5{
  fill: rgba(49, 49, 51, 0.05);
}
.fill-charcoal-900\\/50{
  fill: rgba(49, 49, 51, 0.5);
}
.fill-charcoal-900\\/55{
  fill: rgba(49, 49, 51, 0.55);
}
.fill-charcoal-900\\/60{
  fill: rgba(49, 49, 51, 0.6);
}
.fill-charcoal-900\\/65{
  fill: rgba(49, 49, 51, 0.65);
}
.fill-charcoal-900\\/70{
  fill: rgba(49, 49, 51, 0.7);
}
.fill-charcoal-900\\/75{
  fill: rgba(49, 49, 51, 0.75);
}
.fill-charcoal-900\\/80{
  fill: rgba(49, 49, 51, 0.8);
}
.fill-charcoal-900\\/85{
  fill: rgba(49, 49, 51, 0.85);
}
.fill-charcoal-900\\/90{
  fill: rgba(49, 49, 51, 0.9);
}
.fill-charcoal-900\\/95{
  fill: rgba(49, 49, 51, 0.95);
}
.fill-charcoal-950{
  fill: #252527;
}
.fill-charcoal-950\\/0{
  fill: rgba(37, 37, 39, 0);
}
.fill-charcoal-950\\/10{
  fill: rgba(37, 37, 39, 0.1);
}
.fill-charcoal-950\\/100{
  fill: rgb(37, 37, 39);
}
.fill-charcoal-950\\/15{
  fill: rgba(37, 37, 39, 0.15);
}
.fill-charcoal-950\\/20{
  fill: rgba(37, 37, 39, 0.2);
}
.fill-charcoal-950\\/25{
  fill: rgba(37, 37, 39, 0.25);
}
.fill-charcoal-950\\/30{
  fill: rgba(37, 37, 39, 0.3);
}
.fill-charcoal-950\\/35{
  fill: rgba(37, 37, 39, 0.35);
}
.fill-charcoal-950\\/40{
  fill: rgba(37, 37, 39, 0.4);
}
.fill-charcoal-950\\/45{
  fill: rgba(37, 37, 39, 0.45);
}
.fill-charcoal-950\\/5{
  fill: rgba(37, 37, 39, 0.05);
}
.fill-charcoal-950\\/50{
  fill: rgba(37, 37, 39, 0.5);
}
.fill-charcoal-950\\/55{
  fill: rgba(37, 37, 39, 0.55);
}
.fill-charcoal-950\\/60{
  fill: rgba(37, 37, 39, 0.6);
}
.fill-charcoal-950\\/65{
  fill: rgba(37, 37, 39, 0.65);
}
.fill-charcoal-950\\/70{
  fill: rgba(37, 37, 39, 0.7);
}
.fill-charcoal-950\\/75{
  fill: rgba(37, 37, 39, 0.75);
}
.fill-charcoal-950\\/80{
  fill: rgba(37, 37, 39, 0.8);
}
.fill-charcoal-950\\/85{
  fill: rgba(37, 37, 39, 0.85);
}
.fill-charcoal-950\\/90{
  fill: rgba(37, 37, 39, 0.9);
}
.fill-charcoal-950\\/95{
  fill: rgba(37, 37, 39, 0.95);
}
.fill-current{
  fill: currentColor;
}
.fill-jade-100{
  fill: #d9f2e6;
}
.fill-jade-100\\/0{
  fill: rgba(217, 242, 230, 0);
}
.fill-jade-100\\/10{
  fill: rgba(217, 242, 230, 0.1);
}
.fill-jade-100\\/100{
  fill: rgb(217, 242, 230);
}
.fill-jade-100\\/15{
  fill: rgba(217, 242, 230, 0.15);
}
.fill-jade-100\\/20{
  fill: rgba(217, 242, 230, 0.2);
}
.fill-jade-100\\/25{
  fill: rgba(217, 242, 230, 0.25);
}
.fill-jade-100\\/30{
  fill: rgba(217, 242, 230, 0.3);
}
.fill-jade-100\\/35{
  fill: rgba(217, 242, 230, 0.35);
}
.fill-jade-100\\/40{
  fill: rgba(217, 242, 230, 0.4);
}
.fill-jade-100\\/45{
  fill: rgba(217, 242, 230, 0.45);
}
.fill-jade-100\\/5{
  fill: rgba(217, 242, 230, 0.05);
}
.fill-jade-100\\/50{
  fill: rgba(217, 242, 230, 0.5);
}
.fill-jade-100\\/55{
  fill: rgba(217, 242, 230, 0.55);
}
.fill-jade-100\\/60{
  fill: rgba(217, 242, 230, 0.6);
}
.fill-jade-100\\/65{
  fill: rgba(217, 242, 230, 0.65);
}
.fill-jade-100\\/70{
  fill: rgba(217, 242, 230, 0.7);
}
.fill-jade-100\\/75{
  fill: rgba(217, 242, 230, 0.75);
}
.fill-jade-100\\/80{
  fill: rgba(217, 242, 230, 0.8);
}
.fill-jade-100\\/85{
  fill: rgba(217, 242, 230, 0.85);
}
.fill-jade-100\\/90{
  fill: rgba(217, 242, 230, 0.9);
}
.fill-jade-100\\/95{
  fill: rgba(217, 242, 230, 0.95);
}
.fill-jade-200{
  fill: #b6e4d1;
}
.fill-jade-200\\/0{
  fill: rgba(182, 228, 209, 0);
}
.fill-jade-200\\/10{
  fill: rgba(182, 228, 209, 0.1);
}
.fill-jade-200\\/100{
  fill: rgb(182, 228, 209);
}
.fill-jade-200\\/15{
  fill: rgba(182, 228, 209, 0.15);
}
.fill-jade-200\\/20{
  fill: rgba(182, 228, 209, 0.2);
}
.fill-jade-200\\/25{
  fill: rgba(182, 228, 209, 0.25);
}
.fill-jade-200\\/30{
  fill: rgba(182, 228, 209, 0.3);
}
.fill-jade-200\\/35{
  fill: rgba(182, 228, 209, 0.35);
}
.fill-jade-200\\/40{
  fill: rgba(182, 228, 209, 0.4);
}
.fill-jade-200\\/45{
  fill: rgba(182, 228, 209, 0.45);
}
.fill-jade-200\\/5{
  fill: rgba(182, 228, 209, 0.05);
}
.fill-jade-200\\/50{
  fill: rgba(182, 228, 209, 0.5);
}
.fill-jade-200\\/55{
  fill: rgba(182, 228, 209, 0.55);
}
.fill-jade-200\\/60{
  fill: rgba(182, 228, 209, 0.6);
}
.fill-jade-200\\/65{
  fill: rgba(182, 228, 209, 0.65);
}
.fill-jade-200\\/70{
  fill: rgba(182, 228, 209, 0.7);
}
.fill-jade-200\\/75{
  fill: rgba(182, 228, 209, 0.75);
}
.fill-jade-200\\/80{
  fill: rgba(182, 228, 209, 0.8);
}
.fill-jade-200\\/85{
  fill: rgba(182, 228, 209, 0.85);
}
.fill-jade-200\\/90{
  fill: rgba(182, 228, 209, 0.9);
}
.fill-jade-200\\/95{
  fill: rgba(182, 228, 209, 0.95);
}
.fill-jade-300{
  fill: #86cfb5;
}
.fill-jade-300\\/0{
  fill: rgba(134, 207, 181, 0);
}
.fill-jade-300\\/10{
  fill: rgba(134, 207, 181, 0.1);
}
.fill-jade-300\\/100{
  fill: rgb(134, 207, 181);
}
.fill-jade-300\\/15{
  fill: rgba(134, 207, 181, 0.15);
}
.fill-jade-300\\/20{
  fill: rgba(134, 207, 181, 0.2);
}
.fill-jade-300\\/25{
  fill: rgba(134, 207, 181, 0.25);
}
.fill-jade-300\\/30{
  fill: rgba(134, 207, 181, 0.3);
}
.fill-jade-300\\/35{
  fill: rgba(134, 207, 181, 0.35);
}
.fill-jade-300\\/40{
  fill: rgba(134, 207, 181, 0.4);
}
.fill-jade-300\\/45{
  fill: rgba(134, 207, 181, 0.45);
}
.fill-jade-300\\/5{
  fill: rgba(134, 207, 181, 0.05);
}
.fill-jade-300\\/50{
  fill: rgba(134, 207, 181, 0.5);
}
.fill-jade-300\\/55{
  fill: rgba(134, 207, 181, 0.55);
}
.fill-jade-300\\/60{
  fill: rgba(134, 207, 181, 0.6);
}
.fill-jade-300\\/65{
  fill: rgba(134, 207, 181, 0.65);
}
.fill-jade-300\\/70{
  fill: rgba(134, 207, 181, 0.7);
}
.fill-jade-300\\/75{
  fill: rgba(134, 207, 181, 0.75);
}
.fill-jade-300\\/80{
  fill: rgba(134, 207, 181, 0.8);
}
.fill-jade-300\\/85{
  fill: rgba(134, 207, 181, 0.85);
}
.fill-jade-300\\/90{
  fill: rgba(134, 207, 181, 0.9);
}
.fill-jade-300\\/95{
  fill: rgba(134, 207, 181, 0.95);
}
.fill-jade-400{
  fill: #53b494;
}
.fill-jade-400\\/0{
  fill: rgba(83, 180, 148, 0);
}
.fill-jade-400\\/10{
  fill: rgba(83, 180, 148, 0.1);
}
.fill-jade-400\\/100{
  fill: rgb(83, 180, 148);
}
.fill-jade-400\\/15{
  fill: rgba(83, 180, 148, 0.15);
}
.fill-jade-400\\/20{
  fill: rgba(83, 180, 148, 0.2);
}
.fill-jade-400\\/25{
  fill: rgba(83, 180, 148, 0.25);
}
.fill-jade-400\\/30{
  fill: rgba(83, 180, 148, 0.3);
}
.fill-jade-400\\/35{
  fill: rgba(83, 180, 148, 0.35);
}
.fill-jade-400\\/40{
  fill: rgba(83, 180, 148, 0.4);
}
.fill-jade-400\\/45{
  fill: rgba(83, 180, 148, 0.45);
}
.fill-jade-400\\/5{
  fill: rgba(83, 180, 148, 0.05);
}
.fill-jade-400\\/50{
  fill: rgba(83, 180, 148, 0.5);
}
.fill-jade-400\\/55{
  fill: rgba(83, 180, 148, 0.55);
}
.fill-jade-400\\/60{
  fill: rgba(83, 180, 148, 0.6);
}
.fill-jade-400\\/65{
  fill: rgba(83, 180, 148, 0.65);
}
.fill-jade-400\\/70{
  fill: rgba(83, 180, 148, 0.7);
}
.fill-jade-400\\/75{
  fill: rgba(83, 180, 148, 0.75);
}
.fill-jade-400\\/80{
  fill: rgba(83, 180, 148, 0.8);
}
.fill-jade-400\\/85{
  fill: rgba(83, 180, 148, 0.85);
}
.fill-jade-400\\/90{
  fill: rgba(83, 180, 148, 0.9);
}
.fill-jade-400\\/95{
  fill: rgba(83, 180, 148, 0.95);
}
.fill-jade-500{
  fill: #2c876d;
}
.fill-jade-500\\/0{
  fill: rgba(44, 135, 109, 0);
}
.fill-jade-500\\/10{
  fill: rgba(44, 135, 109, 0.1);
}
.fill-jade-500\\/100{
  fill: rgb(44, 135, 109);
}
.fill-jade-500\\/15{
  fill: rgba(44, 135, 109, 0.15);
}
.fill-jade-500\\/20{
  fill: rgba(44, 135, 109, 0.2);
}
.fill-jade-500\\/25{
  fill: rgba(44, 135, 109, 0.25);
}
.fill-jade-500\\/30{
  fill: rgba(44, 135, 109, 0.3);
}
.fill-jade-500\\/35{
  fill: rgba(44, 135, 109, 0.35);
}
.fill-jade-500\\/40{
  fill: rgba(44, 135, 109, 0.4);
}
.fill-jade-500\\/45{
  fill: rgba(44, 135, 109, 0.45);
}
.fill-jade-500\\/5{
  fill: rgba(44, 135, 109, 0.05);
}
.fill-jade-500\\/50{
  fill: rgba(44, 135, 109, 0.5);
}
.fill-jade-500\\/55{
  fill: rgba(44, 135, 109, 0.55);
}
.fill-jade-500\\/60{
  fill: rgba(44, 135, 109, 0.6);
}
.fill-jade-500\\/65{
  fill: rgba(44, 135, 109, 0.65);
}
.fill-jade-500\\/70{
  fill: rgba(44, 135, 109, 0.7);
}
.fill-jade-500\\/75{
  fill: rgba(44, 135, 109, 0.75);
}
.fill-jade-500\\/80{
  fill: rgba(44, 135, 109, 0.8);
}
.fill-jade-500\\/85{
  fill: rgba(44, 135, 109, 0.85);
}
.fill-jade-500\\/90{
  fill: rgba(44, 135, 109, 0.9);
}
.fill-jade-500\\/95{
  fill: rgba(44, 135, 109, 0.95);
}
.fill-jade-600{
  fill: #227962;
}
.fill-jade-600\\/0{
  fill: rgba(34, 121, 98, 0);
}
.fill-jade-600\\/10{
  fill: rgba(34, 121, 98, 0.1);
}
.fill-jade-600\\/100{
  fill: rgb(34, 121, 98);
}
.fill-jade-600\\/15{
  fill: rgba(34, 121, 98, 0.15);
}
.fill-jade-600\\/20{
  fill: rgba(34, 121, 98, 0.2);
}
.fill-jade-600\\/25{
  fill: rgba(34, 121, 98, 0.25);
}
.fill-jade-600\\/30{
  fill: rgba(34, 121, 98, 0.3);
}
.fill-jade-600\\/35{
  fill: rgba(34, 121, 98, 0.35);
}
.fill-jade-600\\/40{
  fill: rgba(34, 121, 98, 0.4);
}
.fill-jade-600\\/45{
  fill: rgba(34, 121, 98, 0.45);
}
.fill-jade-600\\/5{
  fill: rgba(34, 121, 98, 0.05);
}
.fill-jade-600\\/50{
  fill: rgba(34, 121, 98, 0.5);
}
.fill-jade-600\\/55{
  fill: rgba(34, 121, 98, 0.55);
}
.fill-jade-600\\/60{
  fill: rgba(34, 121, 98, 0.6);
}
.fill-jade-600\\/65{
  fill: rgba(34, 121, 98, 0.65);
}
.fill-jade-600\\/70{
  fill: rgba(34, 121, 98, 0.7);
}
.fill-jade-600\\/75{
  fill: rgba(34, 121, 98, 0.75);
}
.fill-jade-600\\/80{
  fill: rgba(34, 121, 98, 0.8);
}
.fill-jade-600\\/85{
  fill: rgba(34, 121, 98, 0.85);
}
.fill-jade-600\\/90{
  fill: rgba(34, 121, 98, 0.9);
}
.fill-jade-600\\/95{
  fill: rgba(34, 121, 98, 0.95);
}
.fill-jade-700{
  fill: #1b6150;
}
.fill-jade-700\\/0{
  fill: rgba(27, 97, 80, 0);
}
.fill-jade-700\\/10{
  fill: rgba(27, 97, 80, 0.1);
}
.fill-jade-700\\/100{
  fill: rgb(27, 97, 80);
}
.fill-jade-700\\/15{
  fill: rgba(27, 97, 80, 0.15);
}
.fill-jade-700\\/20{
  fill: rgba(27, 97, 80, 0.2);
}
.fill-jade-700\\/25{
  fill: rgba(27, 97, 80, 0.25);
}
.fill-jade-700\\/30{
  fill: rgba(27, 97, 80, 0.3);
}
.fill-jade-700\\/35{
  fill: rgba(27, 97, 80, 0.35);
}
.fill-jade-700\\/40{
  fill: rgba(27, 97, 80, 0.4);
}
.fill-jade-700\\/45{
  fill: rgba(27, 97, 80, 0.45);
}
.fill-jade-700\\/5{
  fill: rgba(27, 97, 80, 0.05);
}
.fill-jade-700\\/50{
  fill: rgba(27, 97, 80, 0.5);
}
.fill-jade-700\\/55{
  fill: rgba(27, 97, 80, 0.55);
}
.fill-jade-700\\/60{
  fill: rgba(27, 97, 80, 0.6);
}
.fill-jade-700\\/65{
  fill: rgba(27, 97, 80, 0.65);
}
.fill-jade-700\\/70{
  fill: rgba(27, 97, 80, 0.7);
}
.fill-jade-700\\/75{
  fill: rgba(27, 97, 80, 0.75);
}
.fill-jade-700\\/80{
  fill: rgba(27, 97, 80, 0.8);
}
.fill-jade-700\\/85{
  fill: rgba(27, 97, 80, 0.85);
}
.fill-jade-700\\/90{
  fill: rgba(27, 97, 80, 0.9);
}
.fill-jade-700\\/95{
  fill: rgba(27, 97, 80, 0.95);
}
.fill-jade-800{
  fill: #184d40;
}
.fill-jade-800\\/0{
  fill: rgba(24, 77, 64, 0);
}
.fill-jade-800\\/10{
  fill: rgba(24, 77, 64, 0.1);
}
.fill-jade-800\\/100{
  fill: rgb(24, 77, 64);
}
.fill-jade-800\\/15{
  fill: rgba(24, 77, 64, 0.15);
}
.fill-jade-800\\/20{
  fill: rgba(24, 77, 64, 0.2);
}
.fill-jade-800\\/25{
  fill: rgba(24, 77, 64, 0.25);
}
.fill-jade-800\\/30{
  fill: rgba(24, 77, 64, 0.3);
}
.fill-jade-800\\/35{
  fill: rgba(24, 77, 64, 0.35);
}
.fill-jade-800\\/40{
  fill: rgba(24, 77, 64, 0.4);
}
.fill-jade-800\\/45{
  fill: rgba(24, 77, 64, 0.45);
}
.fill-jade-800\\/5{
  fill: rgba(24, 77, 64, 0.05);
}
.fill-jade-800\\/50{
  fill: rgba(24, 77, 64, 0.5);
}
.fill-jade-800\\/55{
  fill: rgba(24, 77, 64, 0.55);
}
.fill-jade-800\\/60{
  fill: rgba(24, 77, 64, 0.6);
}
.fill-jade-800\\/65{
  fill: rgba(24, 77, 64, 0.65);
}
.fill-jade-800\\/70{
  fill: rgba(24, 77, 64, 0.7);
}
.fill-jade-800\\/75{
  fill: rgba(24, 77, 64, 0.75);
}
.fill-jade-800\\/80{
  fill: rgba(24, 77, 64, 0.8);
}
.fill-jade-800\\/85{
  fill: rgba(24, 77, 64, 0.85);
}
.fill-jade-800\\/90{
  fill: rgba(24, 77, 64, 0.9);
}
.fill-jade-800\\/95{
  fill: rgba(24, 77, 64, 0.95);
}
.fill-jade-900{
  fill: #144036;
}
.fill-jade-900\\/0{
  fill: rgba(20, 64, 54, 0);
}
.fill-jade-900\\/10{
  fill: rgba(20, 64, 54, 0.1);
}
.fill-jade-900\\/100{
  fill: rgb(20, 64, 54);
}
.fill-jade-900\\/15{
  fill: rgba(20, 64, 54, 0.15);
}
.fill-jade-900\\/20{
  fill: rgba(20, 64, 54, 0.2);
}
.fill-jade-900\\/25{
  fill: rgba(20, 64, 54, 0.25);
}
.fill-jade-900\\/30{
  fill: rgba(20, 64, 54, 0.3);
}
.fill-jade-900\\/35{
  fill: rgba(20, 64, 54, 0.35);
}
.fill-jade-900\\/40{
  fill: rgba(20, 64, 54, 0.4);
}
.fill-jade-900\\/45{
  fill: rgba(20, 64, 54, 0.45);
}
.fill-jade-900\\/5{
  fill: rgba(20, 64, 54, 0.05);
}
.fill-jade-900\\/50{
  fill: rgba(20, 64, 54, 0.5);
}
.fill-jade-900\\/55{
  fill: rgba(20, 64, 54, 0.55);
}
.fill-jade-900\\/60{
  fill: rgba(20, 64, 54, 0.6);
}
.fill-jade-900\\/65{
  fill: rgba(20, 64, 54, 0.65);
}
.fill-jade-900\\/70{
  fill: rgba(20, 64, 54, 0.7);
}
.fill-jade-900\\/75{
  fill: rgba(20, 64, 54, 0.75);
}
.fill-jade-900\\/80{
  fill: rgba(20, 64, 54, 0.8);
}
.fill-jade-900\\/85{
  fill: rgba(20, 64, 54, 0.85);
}
.fill-jade-900\\/90{
  fill: rgba(20, 64, 54, 0.9);
}
.fill-jade-900\\/95{
  fill: rgba(20, 64, 54, 0.95);
}
.fill-jade-950{
  fill: #0a241f;
}
.fill-jade-950\\/0{
  fill: rgba(10, 36, 31, 0);
}
.fill-jade-950\\/10{
  fill: rgba(10, 36, 31, 0.1);
}
.fill-jade-950\\/100{
  fill: rgb(10, 36, 31);
}
.fill-jade-950\\/15{
  fill: rgba(10, 36, 31, 0.15);
}
.fill-jade-950\\/20{
  fill: rgba(10, 36, 31, 0.2);
}
.fill-jade-950\\/25{
  fill: rgba(10, 36, 31, 0.25);
}
.fill-jade-950\\/30{
  fill: rgba(10, 36, 31, 0.3);
}
.fill-jade-950\\/35{
  fill: rgba(10, 36, 31, 0.35);
}
.fill-jade-950\\/40{
  fill: rgba(10, 36, 31, 0.4);
}
.fill-jade-950\\/45{
  fill: rgba(10, 36, 31, 0.45);
}
.fill-jade-950\\/5{
  fill: rgba(10, 36, 31, 0.05);
}
.fill-jade-950\\/50{
  fill: rgba(10, 36, 31, 0.5);
}
.fill-jade-950\\/55{
  fill: rgba(10, 36, 31, 0.55);
}
.fill-jade-950\\/60{
  fill: rgba(10, 36, 31, 0.6);
}
.fill-jade-950\\/65{
  fill: rgba(10, 36, 31, 0.65);
}
.fill-jade-950\\/70{
  fill: rgba(10, 36, 31, 0.7);
}
.fill-jade-950\\/75{
  fill: rgba(10, 36, 31, 0.75);
}
.fill-jade-950\\/80{
  fill: rgba(10, 36, 31, 0.8);
}
.fill-jade-950\\/85{
  fill: rgba(10, 36, 31, 0.85);
}
.fill-jade-950\\/90{
  fill: rgba(10, 36, 31, 0.9);
}
.fill-jade-950\\/95{
  fill: rgba(10, 36, 31, 0.95);
}
.fill-kids-alphabet-500{
  fill: #3787a3;
}
.fill-kids-alphabet-500\\/0{
  fill: rgba(55, 135, 163, 0);
}
.fill-kids-alphabet-500\\/10{
  fill: rgba(55, 135, 163, 0.1);
}
.fill-kids-alphabet-500\\/100{
  fill: rgb(55, 135, 163);
}
.fill-kids-alphabet-500\\/15{
  fill: rgba(55, 135, 163, 0.15);
}
.fill-kids-alphabet-500\\/20{
  fill: rgba(55, 135, 163, 0.2);
}
.fill-kids-alphabet-500\\/25{
  fill: rgba(55, 135, 163, 0.25);
}
.fill-kids-alphabet-500\\/30{
  fill: rgba(55, 135, 163, 0.3);
}
.fill-kids-alphabet-500\\/35{
  fill: rgba(55, 135, 163, 0.35);
}
.fill-kids-alphabet-500\\/40{
  fill: rgba(55, 135, 163, 0.4);
}
.fill-kids-alphabet-500\\/45{
  fill: rgba(55, 135, 163, 0.45);
}
.fill-kids-alphabet-500\\/5{
  fill: rgba(55, 135, 163, 0.05);
}
.fill-kids-alphabet-500\\/50{
  fill: rgba(55, 135, 163, 0.5);
}
.fill-kids-alphabet-500\\/55{
  fill: rgba(55, 135, 163, 0.55);
}
.fill-kids-alphabet-500\\/60{
  fill: rgba(55, 135, 163, 0.6);
}
.fill-kids-alphabet-500\\/65{
  fill: rgba(55, 135, 163, 0.65);
}
.fill-kids-alphabet-500\\/70{
  fill: rgba(55, 135, 163, 0.7);
}
.fill-kids-alphabet-500\\/75{
  fill: rgba(55, 135, 163, 0.75);
}
.fill-kids-alphabet-500\\/80{
  fill: rgba(55, 135, 163, 0.8);
}
.fill-kids-alphabet-500\\/85{
  fill: rgba(55, 135, 163, 0.85);
}
.fill-kids-alphabet-500\\/90{
  fill: rgba(55, 135, 163, 0.9);
}
.fill-kids-alphabet-500\\/95{
  fill: rgba(55, 135, 163, 0.95);
}
.fill-kids-alphabet-600{
  fill: #306d8a;
}
.fill-kids-alphabet-600\\/0{
  fill: rgba(48, 109, 138, 0);
}
.fill-kids-alphabet-600\\/10{
  fill: rgba(48, 109, 138, 0.1);
}
.fill-kids-alphabet-600\\/100{
  fill: rgb(48, 109, 138);
}
.fill-kids-alphabet-600\\/15{
  fill: rgba(48, 109, 138, 0.15);
}
.fill-kids-alphabet-600\\/20{
  fill: rgba(48, 109, 138, 0.2);
}
.fill-kids-alphabet-600\\/25{
  fill: rgba(48, 109, 138, 0.25);
}
.fill-kids-alphabet-600\\/30{
  fill: rgba(48, 109, 138, 0.3);
}
.fill-kids-alphabet-600\\/35{
  fill: rgba(48, 109, 138, 0.35);
}
.fill-kids-alphabet-600\\/40{
  fill: rgba(48, 109, 138, 0.4);
}
.fill-kids-alphabet-600\\/45{
  fill: rgba(48, 109, 138, 0.45);
}
.fill-kids-alphabet-600\\/5{
  fill: rgba(48, 109, 138, 0.05);
}
.fill-kids-alphabet-600\\/50{
  fill: rgba(48, 109, 138, 0.5);
}
.fill-kids-alphabet-600\\/55{
  fill: rgba(48, 109, 138, 0.55);
}
.fill-kids-alphabet-600\\/60{
  fill: rgba(48, 109, 138, 0.6);
}
.fill-kids-alphabet-600\\/65{
  fill: rgba(48, 109, 138, 0.65);
}
.fill-kids-alphabet-600\\/70{
  fill: rgba(48, 109, 138, 0.7);
}
.fill-kids-alphabet-600\\/75{
  fill: rgba(48, 109, 138, 0.75);
}
.fill-kids-alphabet-600\\/80{
  fill: rgba(48, 109, 138, 0.8);
}
.fill-kids-alphabet-600\\/85{
  fill: rgba(48, 109, 138, 0.85);
}
.fill-kids-alphabet-600\\/90{
  fill: rgba(48, 109, 138, 0.9);
}
.fill-kids-alphabet-600\\/95{
  fill: rgba(48, 109, 138, 0.95);
}
.fill-kids-alphabet-700{
  fill: #2d5b72;
}
.fill-kids-alphabet-700\\/0{
  fill: rgba(45, 91, 114, 0);
}
.fill-kids-alphabet-700\\/10{
  fill: rgba(45, 91, 114, 0.1);
}
.fill-kids-alphabet-700\\/100{
  fill: rgb(45, 91, 114);
}
.fill-kids-alphabet-700\\/15{
  fill: rgba(45, 91, 114, 0.15);
}
.fill-kids-alphabet-700\\/20{
  fill: rgba(45, 91, 114, 0.2);
}
.fill-kids-alphabet-700\\/25{
  fill: rgba(45, 91, 114, 0.25);
}
.fill-kids-alphabet-700\\/30{
  fill: rgba(45, 91, 114, 0.3);
}
.fill-kids-alphabet-700\\/35{
  fill: rgba(45, 91, 114, 0.35);
}
.fill-kids-alphabet-700\\/40{
  fill: rgba(45, 91, 114, 0.4);
}
.fill-kids-alphabet-700\\/45{
  fill: rgba(45, 91, 114, 0.45);
}
.fill-kids-alphabet-700\\/5{
  fill: rgba(45, 91, 114, 0.05);
}
.fill-kids-alphabet-700\\/50{
  fill: rgba(45, 91, 114, 0.5);
}
.fill-kids-alphabet-700\\/55{
  fill: rgba(45, 91, 114, 0.55);
}
.fill-kids-alphabet-700\\/60{
  fill: rgba(45, 91, 114, 0.6);
}
.fill-kids-alphabet-700\\/65{
  fill: rgba(45, 91, 114, 0.65);
}
.fill-kids-alphabet-700\\/70{
  fill: rgba(45, 91, 114, 0.7);
}
.fill-kids-alphabet-700\\/75{
  fill: rgba(45, 91, 114, 0.75);
}
.fill-kids-alphabet-700\\/80{
  fill: rgba(45, 91, 114, 0.8);
}
.fill-kids-alphabet-700\\/85{
  fill: rgba(45, 91, 114, 0.85);
}
.fill-kids-alphabet-700\\/90{
  fill: rgba(45, 91, 114, 0.9);
}
.fill-kids-alphabet-700\\/95{
  fill: rgba(45, 91, 114, 0.95);
}
.fill-kids-alphabet-800{
  fill: #2c4c5e;
}
.fill-kids-alphabet-800\\/0{
  fill: rgba(44, 76, 94, 0);
}
.fill-kids-alphabet-800\\/10{
  fill: rgba(44, 76, 94, 0.1);
}
.fill-kids-alphabet-800\\/100{
  fill: rgb(44, 76, 94);
}
.fill-kids-alphabet-800\\/15{
  fill: rgba(44, 76, 94, 0.15);
}
.fill-kids-alphabet-800\\/20{
  fill: rgba(44, 76, 94, 0.2);
}
.fill-kids-alphabet-800\\/25{
  fill: rgba(44, 76, 94, 0.25);
}
.fill-kids-alphabet-800\\/30{
  fill: rgba(44, 76, 94, 0.3);
}
.fill-kids-alphabet-800\\/35{
  fill: rgba(44, 76, 94, 0.35);
}
.fill-kids-alphabet-800\\/40{
  fill: rgba(44, 76, 94, 0.4);
}
.fill-kids-alphabet-800\\/45{
  fill: rgba(44, 76, 94, 0.45);
}
.fill-kids-alphabet-800\\/5{
  fill: rgba(44, 76, 94, 0.05);
}
.fill-kids-alphabet-800\\/50{
  fill: rgba(44, 76, 94, 0.5);
}
.fill-kids-alphabet-800\\/55{
  fill: rgba(44, 76, 94, 0.55);
}
.fill-kids-alphabet-800\\/60{
  fill: rgba(44, 76, 94, 0.6);
}
.fill-kids-alphabet-800\\/65{
  fill: rgba(44, 76, 94, 0.65);
}
.fill-kids-alphabet-800\\/70{
  fill: rgba(44, 76, 94, 0.7);
}
.fill-kids-alphabet-800\\/75{
  fill: rgba(44, 76, 94, 0.75);
}
.fill-kids-alphabet-800\\/80{
  fill: rgba(44, 76, 94, 0.8);
}
.fill-kids-alphabet-800\\/85{
  fill: rgba(44, 76, 94, 0.85);
}
.fill-kids-alphabet-800\\/90{
  fill: rgba(44, 76, 94, 0.9);
}
.fill-kids-alphabet-800\\/95{
  fill: rgba(44, 76, 94, 0.95);
}
.fill-kids-alphabet-900{
  fill: #284151;
}
.fill-kids-alphabet-900\\/0{
  fill: rgba(40, 65, 81, 0);
}
.fill-kids-alphabet-900\\/10{
  fill: rgba(40, 65, 81, 0.1);
}
.fill-kids-alphabet-900\\/100{
  fill: rgb(40, 65, 81);
}
.fill-kids-alphabet-900\\/15{
  fill: rgba(40, 65, 81, 0.15);
}
.fill-kids-alphabet-900\\/20{
  fill: rgba(40, 65, 81, 0.2);
}
.fill-kids-alphabet-900\\/25{
  fill: rgba(40, 65, 81, 0.25);
}
.fill-kids-alphabet-900\\/30{
  fill: rgba(40, 65, 81, 0.3);
}
.fill-kids-alphabet-900\\/35{
  fill: rgba(40, 65, 81, 0.35);
}
.fill-kids-alphabet-900\\/40{
  fill: rgba(40, 65, 81, 0.4);
}
.fill-kids-alphabet-900\\/45{
  fill: rgba(40, 65, 81, 0.45);
}
.fill-kids-alphabet-900\\/5{
  fill: rgba(40, 65, 81, 0.05);
}
.fill-kids-alphabet-900\\/50{
  fill: rgba(40, 65, 81, 0.5);
}
.fill-kids-alphabet-900\\/55{
  fill: rgba(40, 65, 81, 0.55);
}
.fill-kids-alphabet-900\\/60{
  fill: rgba(40, 65, 81, 0.6);
}
.fill-kids-alphabet-900\\/65{
  fill: rgba(40, 65, 81, 0.65);
}
.fill-kids-alphabet-900\\/70{
  fill: rgba(40, 65, 81, 0.7);
}
.fill-kids-alphabet-900\\/75{
  fill: rgba(40, 65, 81, 0.75);
}
.fill-kids-alphabet-900\\/80{
  fill: rgba(40, 65, 81, 0.8);
}
.fill-kids-alphabet-900\\/85{
  fill: rgba(40, 65, 81, 0.85);
}
.fill-kids-alphabet-900\\/90{
  fill: rgba(40, 65, 81, 0.9);
}
.fill-kids-alphabet-900\\/95{
  fill: rgba(40, 65, 81, 0.95);
}
.fill-kids-categories-500{
  fill: #d1912f;
}
.fill-kids-categories-500\\/0{
  fill: rgba(209, 145, 47, 0);
}
.fill-kids-categories-500\\/10{
  fill: rgba(209, 145, 47, 0.1);
}
.fill-kids-categories-500\\/100{
  fill: rgb(209, 145, 47);
}
.fill-kids-categories-500\\/15{
  fill: rgba(209, 145, 47, 0.15);
}
.fill-kids-categories-500\\/20{
  fill: rgba(209, 145, 47, 0.2);
}
.fill-kids-categories-500\\/25{
  fill: rgba(209, 145, 47, 0.25);
}
.fill-kids-categories-500\\/30{
  fill: rgba(209, 145, 47, 0.3);
}
.fill-kids-categories-500\\/35{
  fill: rgba(209, 145, 47, 0.35);
}
.fill-kids-categories-500\\/40{
  fill: rgba(209, 145, 47, 0.4);
}
.fill-kids-categories-500\\/45{
  fill: rgba(209, 145, 47, 0.45);
}
.fill-kids-categories-500\\/5{
  fill: rgba(209, 145, 47, 0.05);
}
.fill-kids-categories-500\\/50{
  fill: rgba(209, 145, 47, 0.5);
}
.fill-kids-categories-500\\/55{
  fill: rgba(209, 145, 47, 0.55);
}
.fill-kids-categories-500\\/60{
  fill: rgba(209, 145, 47, 0.6);
}
.fill-kids-categories-500\\/65{
  fill: rgba(209, 145, 47, 0.65);
}
.fill-kids-categories-500\\/70{
  fill: rgba(209, 145, 47, 0.7);
}
.fill-kids-categories-500\\/75{
  fill: rgba(209, 145, 47, 0.75);
}
.fill-kids-categories-500\\/80{
  fill: rgba(209, 145, 47, 0.8);
}
.fill-kids-categories-500\\/85{
  fill: rgba(209, 145, 47, 0.85);
}
.fill-kids-categories-500\\/90{
  fill: rgba(209, 145, 47, 0.9);
}
.fill-kids-categories-500\\/95{
  fill: rgba(209, 145, 47, 0.95);
}
.fill-kids-categories-600{
  fill: #c37829;
}
.fill-kids-categories-600\\/0{
  fill: rgba(195, 120, 41, 0);
}
.fill-kids-categories-600\\/10{
  fill: rgba(195, 120, 41, 0.1);
}
.fill-kids-categories-600\\/100{
  fill: rgb(195, 120, 41);
}
.fill-kids-categories-600\\/15{
  fill: rgba(195, 120, 41, 0.15);
}
.fill-kids-categories-600\\/20{
  fill: rgba(195, 120, 41, 0.2);
}
.fill-kids-categories-600\\/25{
  fill: rgba(195, 120, 41, 0.25);
}
.fill-kids-categories-600\\/30{
  fill: rgba(195, 120, 41, 0.3);
}
.fill-kids-categories-600\\/35{
  fill: rgba(195, 120, 41, 0.35);
}
.fill-kids-categories-600\\/40{
  fill: rgba(195, 120, 41, 0.4);
}
.fill-kids-categories-600\\/45{
  fill: rgba(195, 120, 41, 0.45);
}
.fill-kids-categories-600\\/5{
  fill: rgba(195, 120, 41, 0.05);
}
.fill-kids-categories-600\\/50{
  fill: rgba(195, 120, 41, 0.5);
}
.fill-kids-categories-600\\/55{
  fill: rgba(195, 120, 41, 0.55);
}
.fill-kids-categories-600\\/60{
  fill: rgba(195, 120, 41, 0.6);
}
.fill-kids-categories-600\\/65{
  fill: rgba(195, 120, 41, 0.65);
}
.fill-kids-categories-600\\/70{
  fill: rgba(195, 120, 41, 0.7);
}
.fill-kids-categories-600\\/75{
  fill: rgba(195, 120, 41, 0.75);
}
.fill-kids-categories-600\\/80{
  fill: rgba(195, 120, 41, 0.8);
}
.fill-kids-categories-600\\/85{
  fill: rgba(195, 120, 41, 0.85);
}
.fill-kids-categories-600\\/90{
  fill: rgba(195, 120, 41, 0.9);
}
.fill-kids-categories-600\\/95{
  fill: rgba(195, 120, 41, 0.95);
}
.fill-kids-categories-700{
  fill: #995424;
}
.fill-kids-categories-700\\/0{
  fill: rgba(153, 84, 36, 0);
}
.fill-kids-categories-700\\/10{
  fill: rgba(153, 84, 36, 0.1);
}
.fill-kids-categories-700\\/100{
  fill: rgb(153, 84, 36);
}
.fill-kids-categories-700\\/15{
  fill: rgba(153, 84, 36, 0.15);
}
.fill-kids-categories-700\\/20{
  fill: rgba(153, 84, 36, 0.2);
}
.fill-kids-categories-700\\/25{
  fill: rgba(153, 84, 36, 0.25);
}
.fill-kids-categories-700\\/30{
  fill: rgba(153, 84, 36, 0.3);
}
.fill-kids-categories-700\\/35{
  fill: rgba(153, 84, 36, 0.35);
}
.fill-kids-categories-700\\/40{
  fill: rgba(153, 84, 36, 0.4);
}
.fill-kids-categories-700\\/45{
  fill: rgba(153, 84, 36, 0.45);
}
.fill-kids-categories-700\\/5{
  fill: rgba(153, 84, 36, 0.05);
}
.fill-kids-categories-700\\/50{
  fill: rgba(153, 84, 36, 0.5);
}
.fill-kids-categories-700\\/55{
  fill: rgba(153, 84, 36, 0.55);
}
.fill-kids-categories-700\\/60{
  fill: rgba(153, 84, 36, 0.6);
}
.fill-kids-categories-700\\/65{
  fill: rgba(153, 84, 36, 0.65);
}
.fill-kids-categories-700\\/70{
  fill: rgba(153, 84, 36, 0.7);
}
.fill-kids-categories-700\\/75{
  fill: rgba(153, 84, 36, 0.75);
}
.fill-kids-categories-700\\/80{
  fill: rgba(153, 84, 36, 0.8);
}
.fill-kids-categories-700\\/85{
  fill: rgba(153, 84, 36, 0.85);
}
.fill-kids-categories-700\\/90{
  fill: rgba(153, 84, 36, 0.9);
}
.fill-kids-categories-700\\/95{
  fill: rgba(153, 84, 36, 0.95);
}
.fill-kids-categories-800{
  fill: #7e4322;
}
.fill-kids-categories-800\\/0{
  fill: rgba(126, 67, 34, 0);
}
.fill-kids-categories-800\\/10{
  fill: rgba(126, 67, 34, 0.1);
}
.fill-kids-categories-800\\/100{
  fill: rgb(126, 67, 34);
}
.fill-kids-categories-800\\/15{
  fill: rgba(126, 67, 34, 0.15);
}
.fill-kids-categories-800\\/20{
  fill: rgba(126, 67, 34, 0.2);
}
.fill-kids-categories-800\\/25{
  fill: rgba(126, 67, 34, 0.25);
}
.fill-kids-categories-800\\/30{
  fill: rgba(126, 67, 34, 0.3);
}
.fill-kids-categories-800\\/35{
  fill: rgba(126, 67, 34, 0.35);
}
.fill-kids-categories-800\\/40{
  fill: rgba(126, 67, 34, 0.4);
}
.fill-kids-categories-800\\/45{
  fill: rgba(126, 67, 34, 0.45);
}
.fill-kids-categories-800\\/5{
  fill: rgba(126, 67, 34, 0.05);
}
.fill-kids-categories-800\\/50{
  fill: rgba(126, 67, 34, 0.5);
}
.fill-kids-categories-800\\/55{
  fill: rgba(126, 67, 34, 0.55);
}
.fill-kids-categories-800\\/60{
  fill: rgba(126, 67, 34, 0.6);
}
.fill-kids-categories-800\\/65{
  fill: rgba(126, 67, 34, 0.65);
}
.fill-kids-categories-800\\/70{
  fill: rgba(126, 67, 34, 0.7);
}
.fill-kids-categories-800\\/75{
  fill: rgba(126, 67, 34, 0.75);
}
.fill-kids-categories-800\\/80{
  fill: rgba(126, 67, 34, 0.8);
}
.fill-kids-categories-800\\/85{
  fill: rgba(126, 67, 34, 0.85);
}
.fill-kids-categories-800\\/90{
  fill: rgba(126, 67, 34, 0.9);
}
.fill-kids-categories-800\\/95{
  fill: rgba(126, 67, 34, 0.95);
}
.fill-kids-categories-900{
  fill: #68381f;
}
.fill-kids-categories-900\\/0{
  fill: rgba(104, 56, 31, 0);
}
.fill-kids-categories-900\\/10{
  fill: rgba(104, 56, 31, 0.1);
}
.fill-kids-categories-900\\/100{
  fill: rgb(104, 56, 31);
}
.fill-kids-categories-900\\/15{
  fill: rgba(104, 56, 31, 0.15);
}
.fill-kids-categories-900\\/20{
  fill: rgba(104, 56, 31, 0.2);
}
.fill-kids-categories-900\\/25{
  fill: rgba(104, 56, 31, 0.25);
}
.fill-kids-categories-900\\/30{
  fill: rgba(104, 56, 31, 0.3);
}
.fill-kids-categories-900\\/35{
  fill: rgba(104, 56, 31, 0.35);
}
.fill-kids-categories-900\\/40{
  fill: rgba(104, 56, 31, 0.4);
}
.fill-kids-categories-900\\/45{
  fill: rgba(104, 56, 31, 0.45);
}
.fill-kids-categories-900\\/5{
  fill: rgba(104, 56, 31, 0.05);
}
.fill-kids-categories-900\\/50{
  fill: rgba(104, 56, 31, 0.5);
}
.fill-kids-categories-900\\/55{
  fill: rgba(104, 56, 31, 0.55);
}
.fill-kids-categories-900\\/60{
  fill: rgba(104, 56, 31, 0.6);
}
.fill-kids-categories-900\\/65{
  fill: rgba(104, 56, 31, 0.65);
}
.fill-kids-categories-900\\/70{
  fill: rgba(104, 56, 31, 0.7);
}
.fill-kids-categories-900\\/75{
  fill: rgba(104, 56, 31, 0.75);
}
.fill-kids-categories-900\\/80{
  fill: rgba(104, 56, 31, 0.8);
}
.fill-kids-categories-900\\/85{
  fill: rgba(104, 56, 31, 0.85);
}
.fill-kids-categories-900\\/90{
  fill: rgba(104, 56, 31, 0.9);
}
.fill-kids-categories-900\\/95{
  fill: rgba(104, 56, 31, 0.95);
}
.fill-kids-dictionary-500{
  fill: #2c876d;
}
.fill-kids-dictionary-500\\/0{
  fill: rgba(44, 135, 109, 0);
}
.fill-kids-dictionary-500\\/10{
  fill: rgba(44, 135, 109, 0.1);
}
.fill-kids-dictionary-500\\/100{
  fill: rgb(44, 135, 109);
}
.fill-kids-dictionary-500\\/15{
  fill: rgba(44, 135, 109, 0.15);
}
.fill-kids-dictionary-500\\/20{
  fill: rgba(44, 135, 109, 0.2);
}
.fill-kids-dictionary-500\\/25{
  fill: rgba(44, 135, 109, 0.25);
}
.fill-kids-dictionary-500\\/30{
  fill: rgba(44, 135, 109, 0.3);
}
.fill-kids-dictionary-500\\/35{
  fill: rgba(44, 135, 109, 0.35);
}
.fill-kids-dictionary-500\\/40{
  fill: rgba(44, 135, 109, 0.4);
}
.fill-kids-dictionary-500\\/45{
  fill: rgba(44, 135, 109, 0.45);
}
.fill-kids-dictionary-500\\/5{
  fill: rgba(44, 135, 109, 0.05);
}
.fill-kids-dictionary-500\\/50{
  fill: rgba(44, 135, 109, 0.5);
}
.fill-kids-dictionary-500\\/55{
  fill: rgba(44, 135, 109, 0.55);
}
.fill-kids-dictionary-500\\/60{
  fill: rgba(44, 135, 109, 0.6);
}
.fill-kids-dictionary-500\\/65{
  fill: rgba(44, 135, 109, 0.65);
}
.fill-kids-dictionary-500\\/70{
  fill: rgba(44, 135, 109, 0.7);
}
.fill-kids-dictionary-500\\/75{
  fill: rgba(44, 135, 109, 0.75);
}
.fill-kids-dictionary-500\\/80{
  fill: rgba(44, 135, 109, 0.8);
}
.fill-kids-dictionary-500\\/85{
  fill: rgba(44, 135, 109, 0.85);
}
.fill-kids-dictionary-500\\/90{
  fill: rgba(44, 135, 109, 0.9);
}
.fill-kids-dictionary-500\\/95{
  fill: rgba(44, 135, 109, 0.95);
}
.fill-kids-dictionary-600{
  fill: #227962;
}
.fill-kids-dictionary-600\\/0{
  fill: rgba(34, 121, 98, 0);
}
.fill-kids-dictionary-600\\/10{
  fill: rgba(34, 121, 98, 0.1);
}
.fill-kids-dictionary-600\\/100{
  fill: rgb(34, 121, 98);
}
.fill-kids-dictionary-600\\/15{
  fill: rgba(34, 121, 98, 0.15);
}
.fill-kids-dictionary-600\\/20{
  fill: rgba(34, 121, 98, 0.2);
}
.fill-kids-dictionary-600\\/25{
  fill: rgba(34, 121, 98, 0.25);
}
.fill-kids-dictionary-600\\/30{
  fill: rgba(34, 121, 98, 0.3);
}
.fill-kids-dictionary-600\\/35{
  fill: rgba(34, 121, 98, 0.35);
}
.fill-kids-dictionary-600\\/40{
  fill: rgba(34, 121, 98, 0.4);
}
.fill-kids-dictionary-600\\/45{
  fill: rgba(34, 121, 98, 0.45);
}
.fill-kids-dictionary-600\\/5{
  fill: rgba(34, 121, 98, 0.05);
}
.fill-kids-dictionary-600\\/50{
  fill: rgba(34, 121, 98, 0.5);
}
.fill-kids-dictionary-600\\/55{
  fill: rgba(34, 121, 98, 0.55);
}
.fill-kids-dictionary-600\\/60{
  fill: rgba(34, 121, 98, 0.6);
}
.fill-kids-dictionary-600\\/65{
  fill: rgba(34, 121, 98, 0.65);
}
.fill-kids-dictionary-600\\/70{
  fill: rgba(34, 121, 98, 0.7);
}
.fill-kids-dictionary-600\\/75{
  fill: rgba(34, 121, 98, 0.75);
}
.fill-kids-dictionary-600\\/80{
  fill: rgba(34, 121, 98, 0.8);
}
.fill-kids-dictionary-600\\/85{
  fill: rgba(34, 121, 98, 0.85);
}
.fill-kids-dictionary-600\\/90{
  fill: rgba(34, 121, 98, 0.9);
}
.fill-kids-dictionary-600\\/95{
  fill: rgba(34, 121, 98, 0.95);
}
.fill-kids-dictionary-700{
  fill: #1b6150;
}
.fill-kids-dictionary-700\\/0{
  fill: rgba(27, 97, 80, 0);
}
.fill-kids-dictionary-700\\/10{
  fill: rgba(27, 97, 80, 0.1);
}
.fill-kids-dictionary-700\\/100{
  fill: rgb(27, 97, 80);
}
.fill-kids-dictionary-700\\/15{
  fill: rgba(27, 97, 80, 0.15);
}
.fill-kids-dictionary-700\\/20{
  fill: rgba(27, 97, 80, 0.2);
}
.fill-kids-dictionary-700\\/25{
  fill: rgba(27, 97, 80, 0.25);
}
.fill-kids-dictionary-700\\/30{
  fill: rgba(27, 97, 80, 0.3);
}
.fill-kids-dictionary-700\\/35{
  fill: rgba(27, 97, 80, 0.35);
}
.fill-kids-dictionary-700\\/40{
  fill: rgba(27, 97, 80, 0.4);
}
.fill-kids-dictionary-700\\/45{
  fill: rgba(27, 97, 80, 0.45);
}
.fill-kids-dictionary-700\\/5{
  fill: rgba(27, 97, 80, 0.05);
}
.fill-kids-dictionary-700\\/50{
  fill: rgba(27, 97, 80, 0.5);
}
.fill-kids-dictionary-700\\/55{
  fill: rgba(27, 97, 80, 0.55);
}
.fill-kids-dictionary-700\\/60{
  fill: rgba(27, 97, 80, 0.6);
}
.fill-kids-dictionary-700\\/65{
  fill: rgba(27, 97, 80, 0.65);
}
.fill-kids-dictionary-700\\/70{
  fill: rgba(27, 97, 80, 0.7);
}
.fill-kids-dictionary-700\\/75{
  fill: rgba(27, 97, 80, 0.75);
}
.fill-kids-dictionary-700\\/80{
  fill: rgba(27, 97, 80, 0.8);
}
.fill-kids-dictionary-700\\/85{
  fill: rgba(27, 97, 80, 0.85);
}
.fill-kids-dictionary-700\\/90{
  fill: rgba(27, 97, 80, 0.9);
}
.fill-kids-dictionary-700\\/95{
  fill: rgba(27, 97, 80, 0.95);
}
.fill-kids-dictionary-800{
  fill: #184d40;
}
.fill-kids-dictionary-800\\/0{
  fill: rgba(24, 77, 64, 0);
}
.fill-kids-dictionary-800\\/10{
  fill: rgba(24, 77, 64, 0.1);
}
.fill-kids-dictionary-800\\/100{
  fill: rgb(24, 77, 64);
}
.fill-kids-dictionary-800\\/15{
  fill: rgba(24, 77, 64, 0.15);
}
.fill-kids-dictionary-800\\/20{
  fill: rgba(24, 77, 64, 0.2);
}
.fill-kids-dictionary-800\\/25{
  fill: rgba(24, 77, 64, 0.25);
}
.fill-kids-dictionary-800\\/30{
  fill: rgba(24, 77, 64, 0.3);
}
.fill-kids-dictionary-800\\/35{
  fill: rgba(24, 77, 64, 0.35);
}
.fill-kids-dictionary-800\\/40{
  fill: rgba(24, 77, 64, 0.4);
}
.fill-kids-dictionary-800\\/45{
  fill: rgba(24, 77, 64, 0.45);
}
.fill-kids-dictionary-800\\/5{
  fill: rgba(24, 77, 64, 0.05);
}
.fill-kids-dictionary-800\\/50{
  fill: rgba(24, 77, 64, 0.5);
}
.fill-kids-dictionary-800\\/55{
  fill: rgba(24, 77, 64, 0.55);
}
.fill-kids-dictionary-800\\/60{
  fill: rgba(24, 77, 64, 0.6);
}
.fill-kids-dictionary-800\\/65{
  fill: rgba(24, 77, 64, 0.65);
}
.fill-kids-dictionary-800\\/70{
  fill: rgba(24, 77, 64, 0.7);
}
.fill-kids-dictionary-800\\/75{
  fill: rgba(24, 77, 64, 0.75);
}
.fill-kids-dictionary-800\\/80{
  fill: rgba(24, 77, 64, 0.8);
}
.fill-kids-dictionary-800\\/85{
  fill: rgba(24, 77, 64, 0.85);
}
.fill-kids-dictionary-800\\/90{
  fill: rgba(24, 77, 64, 0.9);
}
.fill-kids-dictionary-800\\/95{
  fill: rgba(24, 77, 64, 0.95);
}
.fill-kids-dictionary-900{
  fill: #144036;
}
.fill-kids-dictionary-900\\/0{
  fill: rgba(20, 64, 54, 0);
}
.fill-kids-dictionary-900\\/10{
  fill: rgba(20, 64, 54, 0.1);
}
.fill-kids-dictionary-900\\/100{
  fill: rgb(20, 64, 54);
}
.fill-kids-dictionary-900\\/15{
  fill: rgba(20, 64, 54, 0.15);
}
.fill-kids-dictionary-900\\/20{
  fill: rgba(20, 64, 54, 0.2);
}
.fill-kids-dictionary-900\\/25{
  fill: rgba(20, 64, 54, 0.25);
}
.fill-kids-dictionary-900\\/30{
  fill: rgba(20, 64, 54, 0.3);
}
.fill-kids-dictionary-900\\/35{
  fill: rgba(20, 64, 54, 0.35);
}
.fill-kids-dictionary-900\\/40{
  fill: rgba(20, 64, 54, 0.4);
}
.fill-kids-dictionary-900\\/45{
  fill: rgba(20, 64, 54, 0.45);
}
.fill-kids-dictionary-900\\/5{
  fill: rgba(20, 64, 54, 0.05);
}
.fill-kids-dictionary-900\\/50{
  fill: rgba(20, 64, 54, 0.5);
}
.fill-kids-dictionary-900\\/55{
  fill: rgba(20, 64, 54, 0.55);
}
.fill-kids-dictionary-900\\/60{
  fill: rgba(20, 64, 54, 0.6);
}
.fill-kids-dictionary-900\\/65{
  fill: rgba(20, 64, 54, 0.65);
}
.fill-kids-dictionary-900\\/70{
  fill: rgba(20, 64, 54, 0.7);
}
.fill-kids-dictionary-900\\/75{
  fill: rgba(20, 64, 54, 0.75);
}
.fill-kids-dictionary-900\\/80{
  fill: rgba(20, 64, 54, 0.8);
}
.fill-kids-dictionary-900\\/85{
  fill: rgba(20, 64, 54, 0.85);
}
.fill-kids-dictionary-900\\/90{
  fill: rgba(20, 64, 54, 0.9);
}
.fill-kids-dictionary-900\\/95{
  fill: rgba(20, 64, 54, 0.95);
}
.fill-kids-games-500{
  fill: #513B56;
}
.fill-kids-games-500\\/0{
  fill: rgba(81, 59, 86, 0);
}
.fill-kids-games-500\\/10{
  fill: rgba(81, 59, 86, 0.1);
}
.fill-kids-games-500\\/100{
  fill: rgb(81, 59, 86);
}
.fill-kids-games-500\\/15{
  fill: rgba(81, 59, 86, 0.15);
}
.fill-kids-games-500\\/20{
  fill: rgba(81, 59, 86, 0.2);
}
.fill-kids-games-500\\/25{
  fill: rgba(81, 59, 86, 0.25);
}
.fill-kids-games-500\\/30{
  fill: rgba(81, 59, 86, 0.3);
}
.fill-kids-games-500\\/35{
  fill: rgba(81, 59, 86, 0.35);
}
.fill-kids-games-500\\/40{
  fill: rgba(81, 59, 86, 0.4);
}
.fill-kids-games-500\\/45{
  fill: rgba(81, 59, 86, 0.45);
}
.fill-kids-games-500\\/5{
  fill: rgba(81, 59, 86, 0.05);
}
.fill-kids-games-500\\/50{
  fill: rgba(81, 59, 86, 0.5);
}
.fill-kids-games-500\\/55{
  fill: rgba(81, 59, 86, 0.55);
}
.fill-kids-games-500\\/60{
  fill: rgba(81, 59, 86, 0.6);
}
.fill-kids-games-500\\/65{
  fill: rgba(81, 59, 86, 0.65);
}
.fill-kids-games-500\\/70{
  fill: rgba(81, 59, 86, 0.7);
}
.fill-kids-games-500\\/75{
  fill: rgba(81, 59, 86, 0.75);
}
.fill-kids-games-500\\/80{
  fill: rgba(81, 59, 86, 0.8);
}
.fill-kids-games-500\\/85{
  fill: rgba(81, 59, 86, 0.85);
}
.fill-kids-games-500\\/90{
  fill: rgba(81, 59, 86, 0.9);
}
.fill-kids-games-500\\/95{
  fill: rgba(81, 59, 86, 0.95);
}
.fill-kids-games-900{
  fill: #39293c;
}
.fill-kids-games-900\\/0{
  fill: rgba(57, 41, 60, 0);
}
.fill-kids-games-900\\/10{
  fill: rgba(57, 41, 60, 0.1);
}
.fill-kids-games-900\\/100{
  fill: rgb(57, 41, 60);
}
.fill-kids-games-900\\/15{
  fill: rgba(57, 41, 60, 0.15);
}
.fill-kids-games-900\\/20{
  fill: rgba(57, 41, 60, 0.2);
}
.fill-kids-games-900\\/25{
  fill: rgba(57, 41, 60, 0.25);
}
.fill-kids-games-900\\/30{
  fill: rgba(57, 41, 60, 0.3);
}
.fill-kids-games-900\\/35{
  fill: rgba(57, 41, 60, 0.35);
}
.fill-kids-games-900\\/40{
  fill: rgba(57, 41, 60, 0.4);
}
.fill-kids-games-900\\/45{
  fill: rgba(57, 41, 60, 0.45);
}
.fill-kids-games-900\\/5{
  fill: rgba(57, 41, 60, 0.05);
}
.fill-kids-games-900\\/50{
  fill: rgba(57, 41, 60, 0.5);
}
.fill-kids-games-900\\/55{
  fill: rgba(57, 41, 60, 0.55);
}
.fill-kids-games-900\\/60{
  fill: rgba(57, 41, 60, 0.6);
}
.fill-kids-games-900\\/65{
  fill: rgba(57, 41, 60, 0.65);
}
.fill-kids-games-900\\/70{
  fill: rgba(57, 41, 60, 0.7);
}
.fill-kids-games-900\\/75{
  fill: rgba(57, 41, 60, 0.75);
}
.fill-kids-games-900\\/80{
  fill: rgba(57, 41, 60, 0.8);
}
.fill-kids-games-900\\/85{
  fill: rgba(57, 41, 60, 0.85);
}
.fill-kids-games-900\\/90{
  fill: rgba(57, 41, 60, 0.9);
}
.fill-kids-games-900\\/95{
  fill: rgba(57, 41, 60, 0.95);
}
.fill-kids-songs-500{
  fill: #830042;
}
.fill-kids-songs-500\\/0{
  fill: rgba(131, 0, 66, 0);
}
.fill-kids-songs-500\\/10{
  fill: rgba(131, 0, 66, 0.1);
}
.fill-kids-songs-500\\/100{
  fill: rgb(131, 0, 66);
}
.fill-kids-songs-500\\/15{
  fill: rgba(131, 0, 66, 0.15);
}
.fill-kids-songs-500\\/20{
  fill: rgba(131, 0, 66, 0.2);
}
.fill-kids-songs-500\\/25{
  fill: rgba(131, 0, 66, 0.25);
}
.fill-kids-songs-500\\/30{
  fill: rgba(131, 0, 66, 0.3);
}
.fill-kids-songs-500\\/35{
  fill: rgba(131, 0, 66, 0.35);
}
.fill-kids-songs-500\\/40{
  fill: rgba(131, 0, 66, 0.4);
}
.fill-kids-songs-500\\/45{
  fill: rgba(131, 0, 66, 0.45);
}
.fill-kids-songs-500\\/5{
  fill: rgba(131, 0, 66, 0.05);
}
.fill-kids-songs-500\\/50{
  fill: rgba(131, 0, 66, 0.5);
}
.fill-kids-songs-500\\/55{
  fill: rgba(131, 0, 66, 0.55);
}
.fill-kids-songs-500\\/60{
  fill: rgba(131, 0, 66, 0.6);
}
.fill-kids-songs-500\\/65{
  fill: rgba(131, 0, 66, 0.65);
}
.fill-kids-songs-500\\/70{
  fill: rgba(131, 0, 66, 0.7);
}
.fill-kids-songs-500\\/75{
  fill: rgba(131, 0, 66, 0.75);
}
.fill-kids-songs-500\\/80{
  fill: rgba(131, 0, 66, 0.8);
}
.fill-kids-songs-500\\/85{
  fill: rgba(131, 0, 66, 0.85);
}
.fill-kids-songs-500\\/90{
  fill: rgba(131, 0, 66, 0.9);
}
.fill-kids-songs-500\\/95{
  fill: rgba(131, 0, 66, 0.95);
}
.fill-kids-songs-900{
  fill: #5c002e;
}
.fill-kids-songs-900\\/0{
  fill: rgba(92, 0, 46, 0);
}
.fill-kids-songs-900\\/10{
  fill: rgba(92, 0, 46, 0.1);
}
.fill-kids-songs-900\\/100{
  fill: rgb(92, 0, 46);
}
.fill-kids-songs-900\\/15{
  fill: rgba(92, 0, 46, 0.15);
}
.fill-kids-songs-900\\/20{
  fill: rgba(92, 0, 46, 0.2);
}
.fill-kids-songs-900\\/25{
  fill: rgba(92, 0, 46, 0.25);
}
.fill-kids-songs-900\\/30{
  fill: rgba(92, 0, 46, 0.3);
}
.fill-kids-songs-900\\/35{
  fill: rgba(92, 0, 46, 0.35);
}
.fill-kids-songs-900\\/40{
  fill: rgba(92, 0, 46, 0.4);
}
.fill-kids-songs-900\\/45{
  fill: rgba(92, 0, 46, 0.45);
}
.fill-kids-songs-900\\/5{
  fill: rgba(92, 0, 46, 0.05);
}
.fill-kids-songs-900\\/50{
  fill: rgba(92, 0, 46, 0.5);
}
.fill-kids-songs-900\\/55{
  fill: rgba(92, 0, 46, 0.55);
}
.fill-kids-songs-900\\/60{
  fill: rgba(92, 0, 46, 0.6);
}
.fill-kids-songs-900\\/65{
  fill: rgba(92, 0, 46, 0.65);
}
.fill-kids-songs-900\\/70{
  fill: rgba(92, 0, 46, 0.7);
}
.fill-kids-songs-900\\/75{
  fill: rgba(92, 0, 46, 0.75);
}
.fill-kids-songs-900\\/80{
  fill: rgba(92, 0, 46, 0.8);
}
.fill-kids-songs-900\\/85{
  fill: rgba(92, 0, 46, 0.85);
}
.fill-kids-songs-900\\/90{
  fill: rgba(92, 0, 46, 0.9);
}
.fill-kids-songs-900\\/95{
  fill: rgba(92, 0, 46, 0.95);
}
.fill-kids-stories-500{
  fill: #E9C46A;
}
.fill-kids-stories-500\\/0{
  fill: rgba(233, 196, 106, 0);
}
.fill-kids-stories-500\\/10{
  fill: rgba(233, 196, 106, 0.1);
}
.fill-kids-stories-500\\/100{
  fill: rgb(233, 196, 106);
}
.fill-kids-stories-500\\/15{
  fill: rgba(233, 196, 106, 0.15);
}
.fill-kids-stories-500\\/20{
  fill: rgba(233, 196, 106, 0.2);
}
.fill-kids-stories-500\\/25{
  fill: rgba(233, 196, 106, 0.25);
}
.fill-kids-stories-500\\/30{
  fill: rgba(233, 196, 106, 0.3);
}
.fill-kids-stories-500\\/35{
  fill: rgba(233, 196, 106, 0.35);
}
.fill-kids-stories-500\\/40{
  fill: rgba(233, 196, 106, 0.4);
}
.fill-kids-stories-500\\/45{
  fill: rgba(233, 196, 106, 0.45);
}
.fill-kids-stories-500\\/5{
  fill: rgba(233, 196, 106, 0.05);
}
.fill-kids-stories-500\\/50{
  fill: rgba(233, 196, 106, 0.5);
}
.fill-kids-stories-500\\/55{
  fill: rgba(233, 196, 106, 0.55);
}
.fill-kids-stories-500\\/60{
  fill: rgba(233, 196, 106, 0.6);
}
.fill-kids-stories-500\\/65{
  fill: rgba(233, 196, 106, 0.65);
}
.fill-kids-stories-500\\/70{
  fill: rgba(233, 196, 106, 0.7);
}
.fill-kids-stories-500\\/75{
  fill: rgba(233, 196, 106, 0.75);
}
.fill-kids-stories-500\\/80{
  fill: rgba(233, 196, 106, 0.8);
}
.fill-kids-stories-500\\/85{
  fill: rgba(233, 196, 106, 0.85);
}
.fill-kids-stories-500\\/90{
  fill: rgba(233, 196, 106, 0.9);
}
.fill-kids-stories-500\\/95{
  fill: rgba(233, 196, 106, 0.95);
}
.fill-kids-stories-900{
  fill: #a3894a;
}
.fill-kids-stories-900\\/0{
  fill: rgba(163, 137, 74, 0);
}
.fill-kids-stories-900\\/10{
  fill: rgba(163, 137, 74, 0.1);
}
.fill-kids-stories-900\\/100{
  fill: rgb(163, 137, 74);
}
.fill-kids-stories-900\\/15{
  fill: rgba(163, 137, 74, 0.15);
}
.fill-kids-stories-900\\/20{
  fill: rgba(163, 137, 74, 0.2);
}
.fill-kids-stories-900\\/25{
  fill: rgba(163, 137, 74, 0.25);
}
.fill-kids-stories-900\\/30{
  fill: rgba(163, 137, 74, 0.3);
}
.fill-kids-stories-900\\/35{
  fill: rgba(163, 137, 74, 0.35);
}
.fill-kids-stories-900\\/40{
  fill: rgba(163, 137, 74, 0.4);
}
.fill-kids-stories-900\\/45{
  fill: rgba(163, 137, 74, 0.45);
}
.fill-kids-stories-900\\/5{
  fill: rgba(163, 137, 74, 0.05);
}
.fill-kids-stories-900\\/50{
  fill: rgba(163, 137, 74, 0.5);
}
.fill-kids-stories-900\\/55{
  fill: rgba(163, 137, 74, 0.55);
}
.fill-kids-stories-900\\/60{
  fill: rgba(163, 137, 74, 0.6);
}
.fill-kids-stories-900\\/65{
  fill: rgba(163, 137, 74, 0.65);
}
.fill-kids-stories-900\\/70{
  fill: rgba(163, 137, 74, 0.7);
}
.fill-kids-stories-900\\/75{
  fill: rgba(163, 137, 74, 0.75);
}
.fill-kids-stories-900\\/80{
  fill: rgba(163, 137, 74, 0.8);
}
.fill-kids-stories-900\\/85{
  fill: rgba(163, 137, 74, 0.85);
}
.fill-kids-stories-900\\/90{
  fill: rgba(163, 137, 74, 0.9);
}
.fill-kids-stories-900\\/95{
  fill: rgba(163, 137, 74, 0.95);
}
.fill-ochre-100{
  fill: #f5edd0;
}
.fill-ochre-100\\/0{
  fill: rgba(245, 237, 208, 0);
}
.fill-ochre-100\\/10{
  fill: rgba(245, 237, 208, 0.1);
}
.fill-ochre-100\\/100{
  fill: rgb(245, 237, 208);
}
.fill-ochre-100\\/15{
  fill: rgba(245, 237, 208, 0.15);
}
.fill-ochre-100\\/20{
  fill: rgba(245, 237, 208, 0.2);
}
.fill-ochre-100\\/25{
  fill: rgba(245, 237, 208, 0.25);
}
.fill-ochre-100\\/30{
  fill: rgba(245, 237, 208, 0.3);
}
.fill-ochre-100\\/35{
  fill: rgba(245, 237, 208, 0.35);
}
.fill-ochre-100\\/40{
  fill: rgba(245, 237, 208, 0.4);
}
.fill-ochre-100\\/45{
  fill: rgba(245, 237, 208, 0.45);
}
.fill-ochre-100\\/5{
  fill: rgba(245, 237, 208, 0.05);
}
.fill-ochre-100\\/50{
  fill: rgba(245, 237, 208, 0.5);
}
.fill-ochre-100\\/55{
  fill: rgba(245, 237, 208, 0.55);
}
.fill-ochre-100\\/60{
  fill: rgba(245, 237, 208, 0.6);
}
.fill-ochre-100\\/65{
  fill: rgba(245, 237, 208, 0.65);
}
.fill-ochre-100\\/70{
  fill: rgba(245, 237, 208, 0.7);
}
.fill-ochre-100\\/75{
  fill: rgba(245, 237, 208, 0.75);
}
.fill-ochre-100\\/80{
  fill: rgba(245, 237, 208, 0.8);
}
.fill-ochre-100\\/85{
  fill: rgba(245, 237, 208, 0.85);
}
.fill-ochre-100\\/90{
  fill: rgba(245, 237, 208, 0.9);
}
.fill-ochre-100\\/95{
  fill: rgba(245, 237, 208, 0.95);
}
.fill-ochre-200{
  fill: #ebd99c;
}
.fill-ochre-200\\/0{
  fill: rgba(235, 217, 156, 0);
}
.fill-ochre-200\\/10{
  fill: rgba(235, 217, 156, 0.1);
}
.fill-ochre-200\\/100{
  fill: rgb(235, 217, 156);
}
.fill-ochre-200\\/15{
  fill: rgba(235, 217, 156, 0.15);
}
.fill-ochre-200\\/20{
  fill: rgba(235, 217, 156, 0.2);
}
.fill-ochre-200\\/25{
  fill: rgba(235, 217, 156, 0.25);
}
.fill-ochre-200\\/30{
  fill: rgba(235, 217, 156, 0.3);
}
.fill-ochre-200\\/35{
  fill: rgba(235, 217, 156, 0.35);
}
.fill-ochre-200\\/40{
  fill: rgba(235, 217, 156, 0.4);
}
.fill-ochre-200\\/45{
  fill: rgba(235, 217, 156, 0.45);
}
.fill-ochre-200\\/5{
  fill: rgba(235, 217, 156, 0.05);
}
.fill-ochre-200\\/50{
  fill: rgba(235, 217, 156, 0.5);
}
.fill-ochre-200\\/55{
  fill: rgba(235, 217, 156, 0.55);
}
.fill-ochre-200\\/60{
  fill: rgba(235, 217, 156, 0.6);
}
.fill-ochre-200\\/65{
  fill: rgba(235, 217, 156, 0.65);
}
.fill-ochre-200\\/70{
  fill: rgba(235, 217, 156, 0.7);
}
.fill-ochre-200\\/75{
  fill: rgba(235, 217, 156, 0.75);
}
.fill-ochre-200\\/80{
  fill: rgba(235, 217, 156, 0.8);
}
.fill-ochre-200\\/85{
  fill: rgba(235, 217, 156, 0.85);
}
.fill-ochre-200\\/90{
  fill: rgba(235, 217, 156, 0.9);
}
.fill-ochre-200\\/95{
  fill: rgba(235, 217, 156, 0.95);
}
.fill-ochre-300{
  fill: #e1c268;
}
.fill-ochre-300\\/0{
  fill: rgba(225, 194, 104, 0);
}
.fill-ochre-300\\/10{
  fill: rgba(225, 194, 104, 0.1);
}
.fill-ochre-300\\/100{
  fill: rgb(225, 194, 104);
}
.fill-ochre-300\\/15{
  fill: rgba(225, 194, 104, 0.15);
}
.fill-ochre-300\\/20{
  fill: rgba(225, 194, 104, 0.2);
}
.fill-ochre-300\\/25{
  fill: rgba(225, 194, 104, 0.25);
}
.fill-ochre-300\\/30{
  fill: rgba(225, 194, 104, 0.3);
}
.fill-ochre-300\\/35{
  fill: rgba(225, 194, 104, 0.35);
}
.fill-ochre-300\\/40{
  fill: rgba(225, 194, 104, 0.4);
}
.fill-ochre-300\\/45{
  fill: rgba(225, 194, 104, 0.45);
}
.fill-ochre-300\\/5{
  fill: rgba(225, 194, 104, 0.05);
}
.fill-ochre-300\\/50{
  fill: rgba(225, 194, 104, 0.5);
}
.fill-ochre-300\\/55{
  fill: rgba(225, 194, 104, 0.55);
}
.fill-ochre-300\\/60{
  fill: rgba(225, 194, 104, 0.6);
}
.fill-ochre-300\\/65{
  fill: rgba(225, 194, 104, 0.65);
}
.fill-ochre-300\\/70{
  fill: rgba(225, 194, 104, 0.7);
}
.fill-ochre-300\\/75{
  fill: rgba(225, 194, 104, 0.75);
}
.fill-ochre-300\\/80{
  fill: rgba(225, 194, 104, 0.8);
}
.fill-ochre-300\\/85{
  fill: rgba(225, 194, 104, 0.85);
}
.fill-ochre-300\\/90{
  fill: rgba(225, 194, 104, 0.9);
}
.fill-ochre-300\\/95{
  fill: rgba(225, 194, 104, 0.95);
}
.fill-ochre-400{
  fill: #daad45;
}
.fill-ochre-400\\/0{
  fill: rgba(218, 173, 69, 0);
}
.fill-ochre-400\\/10{
  fill: rgba(218, 173, 69, 0.1);
}
.fill-ochre-400\\/100{
  fill: rgb(218, 173, 69);
}
.fill-ochre-400\\/15{
  fill: rgba(218, 173, 69, 0.15);
}
.fill-ochre-400\\/20{
  fill: rgba(218, 173, 69, 0.2);
}
.fill-ochre-400\\/25{
  fill: rgba(218, 173, 69, 0.25);
}
.fill-ochre-400\\/30{
  fill: rgba(218, 173, 69, 0.3);
}
.fill-ochre-400\\/35{
  fill: rgba(218, 173, 69, 0.35);
}
.fill-ochre-400\\/40{
  fill: rgba(218, 173, 69, 0.4);
}
.fill-ochre-400\\/45{
  fill: rgba(218, 173, 69, 0.45);
}
.fill-ochre-400\\/5{
  fill: rgba(218, 173, 69, 0.05);
}
.fill-ochre-400\\/50{
  fill: rgba(218, 173, 69, 0.5);
}
.fill-ochre-400\\/55{
  fill: rgba(218, 173, 69, 0.55);
}
.fill-ochre-400\\/60{
  fill: rgba(218, 173, 69, 0.6);
}
.fill-ochre-400\\/65{
  fill: rgba(218, 173, 69, 0.65);
}
.fill-ochre-400\\/70{
  fill: rgba(218, 173, 69, 0.7);
}
.fill-ochre-400\\/75{
  fill: rgba(218, 173, 69, 0.75);
}
.fill-ochre-400\\/80{
  fill: rgba(218, 173, 69, 0.8);
}
.fill-ochre-400\\/85{
  fill: rgba(218, 173, 69, 0.85);
}
.fill-ochre-400\\/90{
  fill: rgba(218, 173, 69, 0.9);
}
.fill-ochre-400\\/95{
  fill: rgba(218, 173, 69, 0.95);
}
.fill-ochre-500{
  fill: #d1912f;
}
.fill-ochre-500\\/0{
  fill: rgba(209, 145, 47, 0);
}
.fill-ochre-500\\/10{
  fill: rgba(209, 145, 47, 0.1);
}
.fill-ochre-500\\/100{
  fill: rgb(209, 145, 47);
}
.fill-ochre-500\\/15{
  fill: rgba(209, 145, 47, 0.15);
}
.fill-ochre-500\\/20{
  fill: rgba(209, 145, 47, 0.2);
}
.fill-ochre-500\\/25{
  fill: rgba(209, 145, 47, 0.25);
}
.fill-ochre-500\\/30{
  fill: rgba(209, 145, 47, 0.3);
}
.fill-ochre-500\\/35{
  fill: rgba(209, 145, 47, 0.35);
}
.fill-ochre-500\\/40{
  fill: rgba(209, 145, 47, 0.4);
}
.fill-ochre-500\\/45{
  fill: rgba(209, 145, 47, 0.45);
}
.fill-ochre-500\\/5{
  fill: rgba(209, 145, 47, 0.05);
}
.fill-ochre-500\\/50{
  fill: rgba(209, 145, 47, 0.5);
}
.fill-ochre-500\\/55{
  fill: rgba(209, 145, 47, 0.55);
}
.fill-ochre-500\\/60{
  fill: rgba(209, 145, 47, 0.6);
}
.fill-ochre-500\\/65{
  fill: rgba(209, 145, 47, 0.65);
}
.fill-ochre-500\\/70{
  fill: rgba(209, 145, 47, 0.7);
}
.fill-ochre-500\\/75{
  fill: rgba(209, 145, 47, 0.75);
}
.fill-ochre-500\\/80{
  fill: rgba(209, 145, 47, 0.8);
}
.fill-ochre-500\\/85{
  fill: rgba(209, 145, 47, 0.85);
}
.fill-ochre-500\\/90{
  fill: rgba(209, 145, 47, 0.9);
}
.fill-ochre-500\\/95{
  fill: rgba(209, 145, 47, 0.95);
}
.fill-ochre-600{
  fill: #c37829;
}
.fill-ochre-600\\/0{
  fill: rgba(195, 120, 41, 0);
}
.fill-ochre-600\\/10{
  fill: rgba(195, 120, 41, 0.1);
}
.fill-ochre-600\\/100{
  fill: rgb(195, 120, 41);
}
.fill-ochre-600\\/15{
  fill: rgba(195, 120, 41, 0.15);
}
.fill-ochre-600\\/20{
  fill: rgba(195, 120, 41, 0.2);
}
.fill-ochre-600\\/25{
  fill: rgba(195, 120, 41, 0.25);
}
.fill-ochre-600\\/30{
  fill: rgba(195, 120, 41, 0.3);
}
.fill-ochre-600\\/35{
  fill: rgba(195, 120, 41, 0.35);
}
.fill-ochre-600\\/40{
  fill: rgba(195, 120, 41, 0.4);
}
.fill-ochre-600\\/45{
  fill: rgba(195, 120, 41, 0.45);
}
.fill-ochre-600\\/5{
  fill: rgba(195, 120, 41, 0.05);
}
.fill-ochre-600\\/50{
  fill: rgba(195, 120, 41, 0.5);
}
.fill-ochre-600\\/55{
  fill: rgba(195, 120, 41, 0.55);
}
.fill-ochre-600\\/60{
  fill: rgba(195, 120, 41, 0.6);
}
.fill-ochre-600\\/65{
  fill: rgba(195, 120, 41, 0.65);
}
.fill-ochre-600\\/70{
  fill: rgba(195, 120, 41, 0.7);
}
.fill-ochre-600\\/75{
  fill: rgba(195, 120, 41, 0.75);
}
.fill-ochre-600\\/80{
  fill: rgba(195, 120, 41, 0.8);
}
.fill-ochre-600\\/85{
  fill: rgba(195, 120, 41, 0.85);
}
.fill-ochre-600\\/90{
  fill: rgba(195, 120, 41, 0.9);
}
.fill-ochre-600\\/95{
  fill: rgba(195, 120, 41, 0.95);
}
.fill-ochre-700{
  fill: #995424;
}
.fill-ochre-700\\/0{
  fill: rgba(153, 84, 36, 0);
}
.fill-ochre-700\\/10{
  fill: rgba(153, 84, 36, 0.1);
}
.fill-ochre-700\\/100{
  fill: rgb(153, 84, 36);
}
.fill-ochre-700\\/15{
  fill: rgba(153, 84, 36, 0.15);
}
.fill-ochre-700\\/20{
  fill: rgba(153, 84, 36, 0.2);
}
.fill-ochre-700\\/25{
  fill: rgba(153, 84, 36, 0.25);
}
.fill-ochre-700\\/30{
  fill: rgba(153, 84, 36, 0.3);
}
.fill-ochre-700\\/35{
  fill: rgba(153, 84, 36, 0.35);
}
.fill-ochre-700\\/40{
  fill: rgba(153, 84, 36, 0.4);
}
.fill-ochre-700\\/45{
  fill: rgba(153, 84, 36, 0.45);
}
.fill-ochre-700\\/5{
  fill: rgba(153, 84, 36, 0.05);
}
.fill-ochre-700\\/50{
  fill: rgba(153, 84, 36, 0.5);
}
.fill-ochre-700\\/55{
  fill: rgba(153, 84, 36, 0.55);
}
.fill-ochre-700\\/60{
  fill: rgba(153, 84, 36, 0.6);
}
.fill-ochre-700\\/65{
  fill: rgba(153, 84, 36, 0.65);
}
.fill-ochre-700\\/70{
  fill: rgba(153, 84, 36, 0.7);
}
.fill-ochre-700\\/75{
  fill: rgba(153, 84, 36, 0.75);
}
.fill-ochre-700\\/80{
  fill: rgba(153, 84, 36, 0.8);
}
.fill-ochre-700\\/85{
  fill: rgba(153, 84, 36, 0.85);
}
.fill-ochre-700\\/90{
  fill: rgba(153, 84, 36, 0.9);
}
.fill-ochre-700\\/95{
  fill: rgba(153, 84, 36, 0.95);
}
.fill-ochre-800{
  fill: #7e4322;
}
.fill-ochre-800\\/0{
  fill: rgba(126, 67, 34, 0);
}
.fill-ochre-800\\/10{
  fill: rgba(126, 67, 34, 0.1);
}
.fill-ochre-800\\/100{
  fill: rgb(126, 67, 34);
}
.fill-ochre-800\\/15{
  fill: rgba(126, 67, 34, 0.15);
}
.fill-ochre-800\\/20{
  fill: rgba(126, 67, 34, 0.2);
}
.fill-ochre-800\\/25{
  fill: rgba(126, 67, 34, 0.25);
}
.fill-ochre-800\\/30{
  fill: rgba(126, 67, 34, 0.3);
}
.fill-ochre-800\\/35{
  fill: rgba(126, 67, 34, 0.35);
}
.fill-ochre-800\\/40{
  fill: rgba(126, 67, 34, 0.4);
}
.fill-ochre-800\\/45{
  fill: rgba(126, 67, 34, 0.45);
}
.fill-ochre-800\\/5{
  fill: rgba(126, 67, 34, 0.05);
}
.fill-ochre-800\\/50{
  fill: rgba(126, 67, 34, 0.5);
}
.fill-ochre-800\\/55{
  fill: rgba(126, 67, 34, 0.55);
}
.fill-ochre-800\\/60{
  fill: rgba(126, 67, 34, 0.6);
}
.fill-ochre-800\\/65{
  fill: rgba(126, 67, 34, 0.65);
}
.fill-ochre-800\\/70{
  fill: rgba(126, 67, 34, 0.7);
}
.fill-ochre-800\\/75{
  fill: rgba(126, 67, 34, 0.75);
}
.fill-ochre-800\\/80{
  fill: rgba(126, 67, 34, 0.8);
}
.fill-ochre-800\\/85{
  fill: rgba(126, 67, 34, 0.85);
}
.fill-ochre-800\\/90{
  fill: rgba(126, 67, 34, 0.9);
}
.fill-ochre-800\\/95{
  fill: rgba(126, 67, 34, 0.95);
}
.fill-ochre-900{
  fill: #68381f;
}
.fill-ochre-900\\/0{
  fill: rgba(104, 56, 31, 0);
}
.fill-ochre-900\\/10{
  fill: rgba(104, 56, 31, 0.1);
}
.fill-ochre-900\\/100{
  fill: rgb(104, 56, 31);
}
.fill-ochre-900\\/15{
  fill: rgba(104, 56, 31, 0.15);
}
.fill-ochre-900\\/20{
  fill: rgba(104, 56, 31, 0.2);
}
.fill-ochre-900\\/25{
  fill: rgba(104, 56, 31, 0.25);
}
.fill-ochre-900\\/30{
  fill: rgba(104, 56, 31, 0.3);
}
.fill-ochre-900\\/35{
  fill: rgba(104, 56, 31, 0.35);
}
.fill-ochre-900\\/40{
  fill: rgba(104, 56, 31, 0.4);
}
.fill-ochre-900\\/45{
  fill: rgba(104, 56, 31, 0.45);
}
.fill-ochre-900\\/5{
  fill: rgba(104, 56, 31, 0.05);
}
.fill-ochre-900\\/50{
  fill: rgba(104, 56, 31, 0.5);
}
.fill-ochre-900\\/55{
  fill: rgba(104, 56, 31, 0.55);
}
.fill-ochre-900\\/60{
  fill: rgba(104, 56, 31, 0.6);
}
.fill-ochre-900\\/65{
  fill: rgba(104, 56, 31, 0.65);
}
.fill-ochre-900\\/70{
  fill: rgba(104, 56, 31, 0.7);
}
.fill-ochre-900\\/75{
  fill: rgba(104, 56, 31, 0.75);
}
.fill-ochre-900\\/80{
  fill: rgba(104, 56, 31, 0.8);
}
.fill-ochre-900\\/85{
  fill: rgba(104, 56, 31, 0.85);
}
.fill-ochre-900\\/90{
  fill: rgba(104, 56, 31, 0.9);
}
.fill-ochre-900\\/95{
  fill: rgba(104, 56, 31, 0.95);
}
.fill-ochre-950{
  fill: #3b1c0d;
}
.fill-ochre-950\\/0{
  fill: rgba(59, 28, 13, 0);
}
.fill-ochre-950\\/10{
  fill: rgba(59, 28, 13, 0.1);
}
.fill-ochre-950\\/100{
  fill: rgb(59, 28, 13);
}
.fill-ochre-950\\/15{
  fill: rgba(59, 28, 13, 0.15);
}
.fill-ochre-950\\/20{
  fill: rgba(59, 28, 13, 0.2);
}
.fill-ochre-950\\/25{
  fill: rgba(59, 28, 13, 0.25);
}
.fill-ochre-950\\/30{
  fill: rgba(59, 28, 13, 0.3);
}
.fill-ochre-950\\/35{
  fill: rgba(59, 28, 13, 0.35);
}
.fill-ochre-950\\/40{
  fill: rgba(59, 28, 13, 0.4);
}
.fill-ochre-950\\/45{
  fill: rgba(59, 28, 13, 0.45);
}
.fill-ochre-950\\/5{
  fill: rgba(59, 28, 13, 0.05);
}
.fill-ochre-950\\/50{
  fill: rgba(59, 28, 13, 0.5);
}
.fill-ochre-950\\/55{
  fill: rgba(59, 28, 13, 0.55);
}
.fill-ochre-950\\/60{
  fill: rgba(59, 28, 13, 0.6);
}
.fill-ochre-950\\/65{
  fill: rgba(59, 28, 13, 0.65);
}
.fill-ochre-950\\/70{
  fill: rgba(59, 28, 13, 0.7);
}
.fill-ochre-950\\/75{
  fill: rgba(59, 28, 13, 0.75);
}
.fill-ochre-950\\/80{
  fill: rgba(59, 28, 13, 0.8);
}
.fill-ochre-950\\/85{
  fill: rgba(59, 28, 13, 0.85);
}
.fill-ochre-950\\/90{
  fill: rgba(59, 28, 13, 0.9);
}
.fill-ochre-950\\/95{
  fill: rgba(59, 28, 13, 0.95);
}
.fill-phrase-color-100{
  fill: #f5edd0;
}
.fill-phrase-color-100\\/0{
  fill: rgba(245, 237, 208, 0);
}
.fill-phrase-color-100\\/10{
  fill: rgba(245, 237, 208, 0.1);
}
.fill-phrase-color-100\\/100{
  fill: rgb(245, 237, 208);
}
.fill-phrase-color-100\\/15{
  fill: rgba(245, 237, 208, 0.15);
}
.fill-phrase-color-100\\/20{
  fill: rgba(245, 237, 208, 0.2);
}
.fill-phrase-color-100\\/25{
  fill: rgba(245, 237, 208, 0.25);
}
.fill-phrase-color-100\\/30{
  fill: rgba(245, 237, 208, 0.3);
}
.fill-phrase-color-100\\/35{
  fill: rgba(245, 237, 208, 0.35);
}
.fill-phrase-color-100\\/40{
  fill: rgba(245, 237, 208, 0.4);
}
.fill-phrase-color-100\\/45{
  fill: rgba(245, 237, 208, 0.45);
}
.fill-phrase-color-100\\/5{
  fill: rgba(245, 237, 208, 0.05);
}
.fill-phrase-color-100\\/50{
  fill: rgba(245, 237, 208, 0.5);
}
.fill-phrase-color-100\\/55{
  fill: rgba(245, 237, 208, 0.55);
}
.fill-phrase-color-100\\/60{
  fill: rgba(245, 237, 208, 0.6);
}
.fill-phrase-color-100\\/65{
  fill: rgba(245, 237, 208, 0.65);
}
.fill-phrase-color-100\\/70{
  fill: rgba(245, 237, 208, 0.7);
}
.fill-phrase-color-100\\/75{
  fill: rgba(245, 237, 208, 0.75);
}
.fill-phrase-color-100\\/80{
  fill: rgba(245, 237, 208, 0.8);
}
.fill-phrase-color-100\\/85{
  fill: rgba(245, 237, 208, 0.85);
}
.fill-phrase-color-100\\/90{
  fill: rgba(245, 237, 208, 0.9);
}
.fill-phrase-color-100\\/95{
  fill: rgba(245, 237, 208, 0.95);
}
.fill-phrase-color-200{
  fill: #ebd99c;
}
.fill-phrase-color-200\\/0{
  fill: rgba(235, 217, 156, 0);
}
.fill-phrase-color-200\\/10{
  fill: rgba(235, 217, 156, 0.1);
}
.fill-phrase-color-200\\/100{
  fill: rgb(235, 217, 156);
}
.fill-phrase-color-200\\/15{
  fill: rgba(235, 217, 156, 0.15);
}
.fill-phrase-color-200\\/20{
  fill: rgba(235, 217, 156, 0.2);
}
.fill-phrase-color-200\\/25{
  fill: rgba(235, 217, 156, 0.25);
}
.fill-phrase-color-200\\/30{
  fill: rgba(235, 217, 156, 0.3);
}
.fill-phrase-color-200\\/35{
  fill: rgba(235, 217, 156, 0.35);
}
.fill-phrase-color-200\\/40{
  fill: rgba(235, 217, 156, 0.4);
}
.fill-phrase-color-200\\/45{
  fill: rgba(235, 217, 156, 0.45);
}
.fill-phrase-color-200\\/5{
  fill: rgba(235, 217, 156, 0.05);
}
.fill-phrase-color-200\\/50{
  fill: rgba(235, 217, 156, 0.5);
}
.fill-phrase-color-200\\/55{
  fill: rgba(235, 217, 156, 0.55);
}
.fill-phrase-color-200\\/60{
  fill: rgba(235, 217, 156, 0.6);
}
.fill-phrase-color-200\\/65{
  fill: rgba(235, 217, 156, 0.65);
}
.fill-phrase-color-200\\/70{
  fill: rgba(235, 217, 156, 0.7);
}
.fill-phrase-color-200\\/75{
  fill: rgba(235, 217, 156, 0.75);
}
.fill-phrase-color-200\\/80{
  fill: rgba(235, 217, 156, 0.8);
}
.fill-phrase-color-200\\/85{
  fill: rgba(235, 217, 156, 0.85);
}
.fill-phrase-color-200\\/90{
  fill: rgba(235, 217, 156, 0.9);
}
.fill-phrase-color-200\\/95{
  fill: rgba(235, 217, 156, 0.95);
}
.fill-phrase-color-300{
  fill: #e1c268;
}
.fill-phrase-color-300\\/0{
  fill: rgba(225, 194, 104, 0);
}
.fill-phrase-color-300\\/10{
  fill: rgba(225, 194, 104, 0.1);
}
.fill-phrase-color-300\\/100{
  fill: rgb(225, 194, 104);
}
.fill-phrase-color-300\\/15{
  fill: rgba(225, 194, 104, 0.15);
}
.fill-phrase-color-300\\/20{
  fill: rgba(225, 194, 104, 0.2);
}
.fill-phrase-color-300\\/25{
  fill: rgba(225, 194, 104, 0.25);
}
.fill-phrase-color-300\\/30{
  fill: rgba(225, 194, 104, 0.3);
}
.fill-phrase-color-300\\/35{
  fill: rgba(225, 194, 104, 0.35);
}
.fill-phrase-color-300\\/40{
  fill: rgba(225, 194, 104, 0.4);
}
.fill-phrase-color-300\\/45{
  fill: rgba(225, 194, 104, 0.45);
}
.fill-phrase-color-300\\/5{
  fill: rgba(225, 194, 104, 0.05);
}
.fill-phrase-color-300\\/50{
  fill: rgba(225, 194, 104, 0.5);
}
.fill-phrase-color-300\\/55{
  fill: rgba(225, 194, 104, 0.55);
}
.fill-phrase-color-300\\/60{
  fill: rgba(225, 194, 104, 0.6);
}
.fill-phrase-color-300\\/65{
  fill: rgba(225, 194, 104, 0.65);
}
.fill-phrase-color-300\\/70{
  fill: rgba(225, 194, 104, 0.7);
}
.fill-phrase-color-300\\/75{
  fill: rgba(225, 194, 104, 0.75);
}
.fill-phrase-color-300\\/80{
  fill: rgba(225, 194, 104, 0.8);
}
.fill-phrase-color-300\\/85{
  fill: rgba(225, 194, 104, 0.85);
}
.fill-phrase-color-300\\/90{
  fill: rgba(225, 194, 104, 0.9);
}
.fill-phrase-color-300\\/95{
  fill: rgba(225, 194, 104, 0.95);
}
.fill-phrase-color-400{
  fill: #daad45;
}
.fill-phrase-color-400\\/0{
  fill: rgba(218, 173, 69, 0);
}
.fill-phrase-color-400\\/10{
  fill: rgba(218, 173, 69, 0.1);
}
.fill-phrase-color-400\\/100{
  fill: rgb(218, 173, 69);
}
.fill-phrase-color-400\\/15{
  fill: rgba(218, 173, 69, 0.15);
}
.fill-phrase-color-400\\/20{
  fill: rgba(218, 173, 69, 0.2);
}
.fill-phrase-color-400\\/25{
  fill: rgba(218, 173, 69, 0.25);
}
.fill-phrase-color-400\\/30{
  fill: rgba(218, 173, 69, 0.3);
}
.fill-phrase-color-400\\/35{
  fill: rgba(218, 173, 69, 0.35);
}
.fill-phrase-color-400\\/40{
  fill: rgba(218, 173, 69, 0.4);
}
.fill-phrase-color-400\\/45{
  fill: rgba(218, 173, 69, 0.45);
}
.fill-phrase-color-400\\/5{
  fill: rgba(218, 173, 69, 0.05);
}
.fill-phrase-color-400\\/50{
  fill: rgba(218, 173, 69, 0.5);
}
.fill-phrase-color-400\\/55{
  fill: rgba(218, 173, 69, 0.55);
}
.fill-phrase-color-400\\/60{
  fill: rgba(218, 173, 69, 0.6);
}
.fill-phrase-color-400\\/65{
  fill: rgba(218, 173, 69, 0.65);
}
.fill-phrase-color-400\\/70{
  fill: rgba(218, 173, 69, 0.7);
}
.fill-phrase-color-400\\/75{
  fill: rgba(218, 173, 69, 0.75);
}
.fill-phrase-color-400\\/80{
  fill: rgba(218, 173, 69, 0.8);
}
.fill-phrase-color-400\\/85{
  fill: rgba(218, 173, 69, 0.85);
}
.fill-phrase-color-400\\/90{
  fill: rgba(218, 173, 69, 0.9);
}
.fill-phrase-color-400\\/95{
  fill: rgba(218, 173, 69, 0.95);
}
.fill-phrase-color-500{
  fill: #d1912f;
}
.fill-phrase-color-500\\/0{
  fill: rgba(209, 145, 47, 0);
}
.fill-phrase-color-500\\/10{
  fill: rgba(209, 145, 47, 0.1);
}
.fill-phrase-color-500\\/100{
  fill: rgb(209, 145, 47);
}
.fill-phrase-color-500\\/15{
  fill: rgba(209, 145, 47, 0.15);
}
.fill-phrase-color-500\\/20{
  fill: rgba(209, 145, 47, 0.2);
}
.fill-phrase-color-500\\/25{
  fill: rgba(209, 145, 47, 0.25);
}
.fill-phrase-color-500\\/30{
  fill: rgba(209, 145, 47, 0.3);
}
.fill-phrase-color-500\\/35{
  fill: rgba(209, 145, 47, 0.35);
}
.fill-phrase-color-500\\/40{
  fill: rgba(209, 145, 47, 0.4);
}
.fill-phrase-color-500\\/45{
  fill: rgba(209, 145, 47, 0.45);
}
.fill-phrase-color-500\\/5{
  fill: rgba(209, 145, 47, 0.05);
}
.fill-phrase-color-500\\/50{
  fill: rgba(209, 145, 47, 0.5);
}
.fill-phrase-color-500\\/55{
  fill: rgba(209, 145, 47, 0.55);
}
.fill-phrase-color-500\\/60{
  fill: rgba(209, 145, 47, 0.6);
}
.fill-phrase-color-500\\/65{
  fill: rgba(209, 145, 47, 0.65);
}
.fill-phrase-color-500\\/70{
  fill: rgba(209, 145, 47, 0.7);
}
.fill-phrase-color-500\\/75{
  fill: rgba(209, 145, 47, 0.75);
}
.fill-phrase-color-500\\/80{
  fill: rgba(209, 145, 47, 0.8);
}
.fill-phrase-color-500\\/85{
  fill: rgba(209, 145, 47, 0.85);
}
.fill-phrase-color-500\\/90{
  fill: rgba(209, 145, 47, 0.9);
}
.fill-phrase-color-500\\/95{
  fill: rgba(209, 145, 47, 0.95);
}
.fill-phrase-color-600{
  fill: #c37829;
}
.fill-phrase-color-600\\/0{
  fill: rgba(195, 120, 41, 0);
}
.fill-phrase-color-600\\/10{
  fill: rgba(195, 120, 41, 0.1);
}
.fill-phrase-color-600\\/100{
  fill: rgb(195, 120, 41);
}
.fill-phrase-color-600\\/15{
  fill: rgba(195, 120, 41, 0.15);
}
.fill-phrase-color-600\\/20{
  fill: rgba(195, 120, 41, 0.2);
}
.fill-phrase-color-600\\/25{
  fill: rgba(195, 120, 41, 0.25);
}
.fill-phrase-color-600\\/30{
  fill: rgba(195, 120, 41, 0.3);
}
.fill-phrase-color-600\\/35{
  fill: rgba(195, 120, 41, 0.35);
}
.fill-phrase-color-600\\/40{
  fill: rgba(195, 120, 41, 0.4);
}
.fill-phrase-color-600\\/45{
  fill: rgba(195, 120, 41, 0.45);
}
.fill-phrase-color-600\\/5{
  fill: rgba(195, 120, 41, 0.05);
}
.fill-phrase-color-600\\/50{
  fill: rgba(195, 120, 41, 0.5);
}
.fill-phrase-color-600\\/55{
  fill: rgba(195, 120, 41, 0.55);
}
.fill-phrase-color-600\\/60{
  fill: rgba(195, 120, 41, 0.6);
}
.fill-phrase-color-600\\/65{
  fill: rgba(195, 120, 41, 0.65);
}
.fill-phrase-color-600\\/70{
  fill: rgba(195, 120, 41, 0.7);
}
.fill-phrase-color-600\\/75{
  fill: rgba(195, 120, 41, 0.75);
}
.fill-phrase-color-600\\/80{
  fill: rgba(195, 120, 41, 0.8);
}
.fill-phrase-color-600\\/85{
  fill: rgba(195, 120, 41, 0.85);
}
.fill-phrase-color-600\\/90{
  fill: rgba(195, 120, 41, 0.9);
}
.fill-phrase-color-600\\/95{
  fill: rgba(195, 120, 41, 0.95);
}
.fill-phrase-color-700{
  fill: #995424;
}
.fill-phrase-color-700\\/0{
  fill: rgba(153, 84, 36, 0);
}
.fill-phrase-color-700\\/10{
  fill: rgba(153, 84, 36, 0.1);
}
.fill-phrase-color-700\\/100{
  fill: rgb(153, 84, 36);
}
.fill-phrase-color-700\\/15{
  fill: rgba(153, 84, 36, 0.15);
}
.fill-phrase-color-700\\/20{
  fill: rgba(153, 84, 36, 0.2);
}
.fill-phrase-color-700\\/25{
  fill: rgba(153, 84, 36, 0.25);
}
.fill-phrase-color-700\\/30{
  fill: rgba(153, 84, 36, 0.3);
}
.fill-phrase-color-700\\/35{
  fill: rgba(153, 84, 36, 0.35);
}
.fill-phrase-color-700\\/40{
  fill: rgba(153, 84, 36, 0.4);
}
.fill-phrase-color-700\\/45{
  fill: rgba(153, 84, 36, 0.45);
}
.fill-phrase-color-700\\/5{
  fill: rgba(153, 84, 36, 0.05);
}
.fill-phrase-color-700\\/50{
  fill: rgba(153, 84, 36, 0.5);
}
.fill-phrase-color-700\\/55{
  fill: rgba(153, 84, 36, 0.55);
}
.fill-phrase-color-700\\/60{
  fill: rgba(153, 84, 36, 0.6);
}
.fill-phrase-color-700\\/65{
  fill: rgba(153, 84, 36, 0.65);
}
.fill-phrase-color-700\\/70{
  fill: rgba(153, 84, 36, 0.7);
}
.fill-phrase-color-700\\/75{
  fill: rgba(153, 84, 36, 0.75);
}
.fill-phrase-color-700\\/80{
  fill: rgba(153, 84, 36, 0.8);
}
.fill-phrase-color-700\\/85{
  fill: rgba(153, 84, 36, 0.85);
}
.fill-phrase-color-700\\/90{
  fill: rgba(153, 84, 36, 0.9);
}
.fill-phrase-color-700\\/95{
  fill: rgba(153, 84, 36, 0.95);
}
.fill-phrase-color-800{
  fill: #7e4322;
}
.fill-phrase-color-800\\/0{
  fill: rgba(126, 67, 34, 0);
}
.fill-phrase-color-800\\/10{
  fill: rgba(126, 67, 34, 0.1);
}
.fill-phrase-color-800\\/100{
  fill: rgb(126, 67, 34);
}
.fill-phrase-color-800\\/15{
  fill: rgba(126, 67, 34, 0.15);
}
.fill-phrase-color-800\\/20{
  fill: rgba(126, 67, 34, 0.2);
}
.fill-phrase-color-800\\/25{
  fill: rgba(126, 67, 34, 0.25);
}
.fill-phrase-color-800\\/30{
  fill: rgba(126, 67, 34, 0.3);
}
.fill-phrase-color-800\\/35{
  fill: rgba(126, 67, 34, 0.35);
}
.fill-phrase-color-800\\/40{
  fill: rgba(126, 67, 34, 0.4);
}
.fill-phrase-color-800\\/45{
  fill: rgba(126, 67, 34, 0.45);
}
.fill-phrase-color-800\\/5{
  fill: rgba(126, 67, 34, 0.05);
}
.fill-phrase-color-800\\/50{
  fill: rgba(126, 67, 34, 0.5);
}
.fill-phrase-color-800\\/55{
  fill: rgba(126, 67, 34, 0.55);
}
.fill-phrase-color-800\\/60{
  fill: rgba(126, 67, 34, 0.6);
}
.fill-phrase-color-800\\/65{
  fill: rgba(126, 67, 34, 0.65);
}
.fill-phrase-color-800\\/70{
  fill: rgba(126, 67, 34, 0.7);
}
.fill-phrase-color-800\\/75{
  fill: rgba(126, 67, 34, 0.75);
}
.fill-phrase-color-800\\/80{
  fill: rgba(126, 67, 34, 0.8);
}
.fill-phrase-color-800\\/85{
  fill: rgba(126, 67, 34, 0.85);
}
.fill-phrase-color-800\\/90{
  fill: rgba(126, 67, 34, 0.9);
}
.fill-phrase-color-800\\/95{
  fill: rgba(126, 67, 34, 0.95);
}
.fill-phrase-color-900{
  fill: #68381f;
}
.fill-phrase-color-900\\/0{
  fill: rgba(104, 56, 31, 0);
}
.fill-phrase-color-900\\/10{
  fill: rgba(104, 56, 31, 0.1);
}
.fill-phrase-color-900\\/100{
  fill: rgb(104, 56, 31);
}
.fill-phrase-color-900\\/15{
  fill: rgba(104, 56, 31, 0.15);
}
.fill-phrase-color-900\\/20{
  fill: rgba(104, 56, 31, 0.2);
}
.fill-phrase-color-900\\/25{
  fill: rgba(104, 56, 31, 0.25);
}
.fill-phrase-color-900\\/30{
  fill: rgba(104, 56, 31, 0.3);
}
.fill-phrase-color-900\\/35{
  fill: rgba(104, 56, 31, 0.35);
}
.fill-phrase-color-900\\/40{
  fill: rgba(104, 56, 31, 0.4);
}
.fill-phrase-color-900\\/45{
  fill: rgba(104, 56, 31, 0.45);
}
.fill-phrase-color-900\\/5{
  fill: rgba(104, 56, 31, 0.05);
}
.fill-phrase-color-900\\/50{
  fill: rgba(104, 56, 31, 0.5);
}
.fill-phrase-color-900\\/55{
  fill: rgba(104, 56, 31, 0.55);
}
.fill-phrase-color-900\\/60{
  fill: rgba(104, 56, 31, 0.6);
}
.fill-phrase-color-900\\/65{
  fill: rgba(104, 56, 31, 0.65);
}
.fill-phrase-color-900\\/70{
  fill: rgba(104, 56, 31, 0.7);
}
.fill-phrase-color-900\\/75{
  fill: rgba(104, 56, 31, 0.75);
}
.fill-phrase-color-900\\/80{
  fill: rgba(104, 56, 31, 0.8);
}
.fill-phrase-color-900\\/85{
  fill: rgba(104, 56, 31, 0.85);
}
.fill-phrase-color-900\\/90{
  fill: rgba(104, 56, 31, 0.9);
}
.fill-phrase-color-900\\/95{
  fill: rgba(104, 56, 31, 0.95);
}
.fill-phrase-color-950{
  fill: #3b1c0d;
}
.fill-phrase-color-950\\/0{
  fill: rgba(59, 28, 13, 0);
}
.fill-phrase-color-950\\/10{
  fill: rgba(59, 28, 13, 0.1);
}
.fill-phrase-color-950\\/100{
  fill: rgb(59, 28, 13);
}
.fill-phrase-color-950\\/15{
  fill: rgba(59, 28, 13, 0.15);
}
.fill-phrase-color-950\\/20{
  fill: rgba(59, 28, 13, 0.2);
}
.fill-phrase-color-950\\/25{
  fill: rgba(59, 28, 13, 0.25);
}
.fill-phrase-color-950\\/30{
  fill: rgba(59, 28, 13, 0.3);
}
.fill-phrase-color-950\\/35{
  fill: rgba(59, 28, 13, 0.35);
}
.fill-phrase-color-950\\/40{
  fill: rgba(59, 28, 13, 0.4);
}
.fill-phrase-color-950\\/45{
  fill: rgba(59, 28, 13, 0.45);
}
.fill-phrase-color-950\\/5{
  fill: rgba(59, 28, 13, 0.05);
}
.fill-phrase-color-950\\/50{
  fill: rgba(59, 28, 13, 0.5);
}
.fill-phrase-color-950\\/55{
  fill: rgba(59, 28, 13, 0.55);
}
.fill-phrase-color-950\\/60{
  fill: rgba(59, 28, 13, 0.6);
}
.fill-phrase-color-950\\/65{
  fill: rgba(59, 28, 13, 0.65);
}
.fill-phrase-color-950\\/70{
  fill: rgba(59, 28, 13, 0.7);
}
.fill-phrase-color-950\\/75{
  fill: rgba(59, 28, 13, 0.75);
}
.fill-phrase-color-950\\/80{
  fill: rgba(59, 28, 13, 0.8);
}
.fill-phrase-color-950\\/85{
  fill: rgba(59, 28, 13, 0.85);
}
.fill-phrase-color-950\\/90{
  fill: rgba(59, 28, 13, 0.9);
}
.fill-phrase-color-950\\/95{
  fill: rgba(59, 28, 13, 0.95);
}
.fill-scarlet-100{
  fill: #ffdcdf;
}
.fill-scarlet-100\\/0{
  fill: rgba(255, 220, 223, 0);
}
.fill-scarlet-100\\/10{
  fill: rgba(255, 220, 223, 0.1);
}
.fill-scarlet-100\\/100{
  fill: rgb(255, 220, 223);
}
.fill-scarlet-100\\/15{
  fill: rgba(255, 220, 223, 0.15);
}
.fill-scarlet-100\\/20{
  fill: rgba(255, 220, 223, 0.2);
}
.fill-scarlet-100\\/25{
  fill: rgba(255, 220, 223, 0.25);
}
.fill-scarlet-100\\/30{
  fill: rgba(255, 220, 223, 0.3);
}
.fill-scarlet-100\\/35{
  fill: rgba(255, 220, 223, 0.35);
}
.fill-scarlet-100\\/40{
  fill: rgba(255, 220, 223, 0.4);
}
.fill-scarlet-100\\/45{
  fill: rgba(255, 220, 223, 0.45);
}
.fill-scarlet-100\\/5{
  fill: rgba(255, 220, 223, 0.05);
}
.fill-scarlet-100\\/50{
  fill: rgba(255, 220, 223, 0.5);
}
.fill-scarlet-100\\/55{
  fill: rgba(255, 220, 223, 0.55);
}
.fill-scarlet-100\\/60{
  fill: rgba(255, 220, 223, 0.6);
}
.fill-scarlet-100\\/65{
  fill: rgba(255, 220, 223, 0.65);
}
.fill-scarlet-100\\/70{
  fill: rgba(255, 220, 223, 0.7);
}
.fill-scarlet-100\\/75{
  fill: rgba(255, 220, 223, 0.75);
}
.fill-scarlet-100\\/80{
  fill: rgba(255, 220, 223, 0.8);
}
.fill-scarlet-100\\/85{
  fill: rgba(255, 220, 223, 0.85);
}
.fill-scarlet-100\\/90{
  fill: rgba(255, 220, 223, 0.9);
}
.fill-scarlet-100\\/95{
  fill: rgba(255, 220, 223, 0.95);
}
.fill-scarlet-200{
  fill: #ffc0c6;
}
.fill-scarlet-200\\/0{
  fill: rgba(255, 192, 198, 0);
}
.fill-scarlet-200\\/10{
  fill: rgba(255, 192, 198, 0.1);
}
.fill-scarlet-200\\/100{
  fill: rgb(255, 192, 198);
}
.fill-scarlet-200\\/15{
  fill: rgba(255, 192, 198, 0.15);
}
.fill-scarlet-200\\/20{
  fill: rgba(255, 192, 198, 0.2);
}
.fill-scarlet-200\\/25{
  fill: rgba(255, 192, 198, 0.25);
}
.fill-scarlet-200\\/30{
  fill: rgba(255, 192, 198, 0.3);
}
.fill-scarlet-200\\/35{
  fill: rgba(255, 192, 198, 0.35);
}
.fill-scarlet-200\\/40{
  fill: rgba(255, 192, 198, 0.4);
}
.fill-scarlet-200\\/45{
  fill: rgba(255, 192, 198, 0.45);
}
.fill-scarlet-200\\/5{
  fill: rgba(255, 192, 198, 0.05);
}
.fill-scarlet-200\\/50{
  fill: rgba(255, 192, 198, 0.5);
}
.fill-scarlet-200\\/55{
  fill: rgba(255, 192, 198, 0.55);
}
.fill-scarlet-200\\/60{
  fill: rgba(255, 192, 198, 0.6);
}
.fill-scarlet-200\\/65{
  fill: rgba(255, 192, 198, 0.65);
}
.fill-scarlet-200\\/70{
  fill: rgba(255, 192, 198, 0.7);
}
.fill-scarlet-200\\/75{
  fill: rgba(255, 192, 198, 0.75);
}
.fill-scarlet-200\\/80{
  fill: rgba(255, 192, 198, 0.8);
}
.fill-scarlet-200\\/85{
  fill: rgba(255, 192, 198, 0.85);
}
.fill-scarlet-200\\/90{
  fill: rgba(255, 192, 198, 0.9);
}
.fill-scarlet-200\\/95{
  fill: rgba(255, 192, 198, 0.95);
}
.fill-scarlet-300{
  fill: #ff949e;
}
.fill-scarlet-300\\/0{
  fill: rgba(255, 148, 158, 0);
}
.fill-scarlet-300\\/10{
  fill: rgba(255, 148, 158, 0.1);
}
.fill-scarlet-300\\/100{
  fill: rgb(255, 148, 158);
}
.fill-scarlet-300\\/15{
  fill: rgba(255, 148, 158, 0.15);
}
.fill-scarlet-300\\/20{
  fill: rgba(255, 148, 158, 0.2);
}
.fill-scarlet-300\\/25{
  fill: rgba(255, 148, 158, 0.25);
}
.fill-scarlet-300\\/30{
  fill: rgba(255, 148, 158, 0.3);
}
.fill-scarlet-300\\/35{
  fill: rgba(255, 148, 158, 0.35);
}
.fill-scarlet-300\\/40{
  fill: rgba(255, 148, 158, 0.4);
}
.fill-scarlet-300\\/45{
  fill: rgba(255, 148, 158, 0.45);
}
.fill-scarlet-300\\/5{
  fill: rgba(255, 148, 158, 0.05);
}
.fill-scarlet-300\\/50{
  fill: rgba(255, 148, 158, 0.5);
}
.fill-scarlet-300\\/55{
  fill: rgba(255, 148, 158, 0.55);
}
.fill-scarlet-300\\/60{
  fill: rgba(255, 148, 158, 0.6);
}
.fill-scarlet-300\\/65{
  fill: rgba(255, 148, 158, 0.65);
}
.fill-scarlet-300\\/70{
  fill: rgba(255, 148, 158, 0.7);
}
.fill-scarlet-300\\/75{
  fill: rgba(255, 148, 158, 0.75);
}
.fill-scarlet-300\\/80{
  fill: rgba(255, 148, 158, 0.8);
}
.fill-scarlet-300\\/85{
  fill: rgba(255, 148, 158, 0.85);
}
.fill-scarlet-300\\/90{
  fill: rgba(255, 148, 158, 0.9);
}
.fill-scarlet-300\\/95{
  fill: rgba(255, 148, 158, 0.95);
}
.fill-scarlet-400{
  fill: #ff5665;
}
.fill-scarlet-400\\/0{
  fill: rgba(255, 86, 101, 0);
}
.fill-scarlet-400\\/10{
  fill: rgba(255, 86, 101, 0.1);
}
.fill-scarlet-400\\/100{
  fill: rgb(255, 86, 101);
}
.fill-scarlet-400\\/15{
  fill: rgba(255, 86, 101, 0.15);
}
.fill-scarlet-400\\/20{
  fill: rgba(255, 86, 101, 0.2);
}
.fill-scarlet-400\\/25{
  fill: rgba(255, 86, 101, 0.25);
}
.fill-scarlet-400\\/30{
  fill: rgba(255, 86, 101, 0.3);
}
.fill-scarlet-400\\/35{
  fill: rgba(255, 86, 101, 0.35);
}
.fill-scarlet-400\\/40{
  fill: rgba(255, 86, 101, 0.4);
}
.fill-scarlet-400\\/45{
  fill: rgba(255, 86, 101, 0.45);
}
.fill-scarlet-400\\/5{
  fill: rgba(255, 86, 101, 0.05);
}
.fill-scarlet-400\\/50{
  fill: rgba(255, 86, 101, 0.5);
}
.fill-scarlet-400\\/55{
  fill: rgba(255, 86, 101, 0.55);
}
.fill-scarlet-400\\/60{
  fill: rgba(255, 86, 101, 0.6);
}
.fill-scarlet-400\\/65{
  fill: rgba(255, 86, 101, 0.65);
}
.fill-scarlet-400\\/70{
  fill: rgba(255, 86, 101, 0.7);
}
.fill-scarlet-400\\/75{
  fill: rgba(255, 86, 101, 0.75);
}
.fill-scarlet-400\\/80{
  fill: rgba(255, 86, 101, 0.8);
}
.fill-scarlet-400\\/85{
  fill: rgba(255, 86, 101, 0.85);
}
.fill-scarlet-400\\/90{
  fill: rgba(255, 86, 101, 0.9);
}
.fill-scarlet-400\\/95{
  fill: rgba(255, 86, 101, 0.95);
}
.fill-scarlet-500{
  fill: #ff2236;
}
.fill-scarlet-500\\/0{
  fill: rgba(255, 34, 54, 0);
}
.fill-scarlet-500\\/10{
  fill: rgba(255, 34, 54, 0.1);
}
.fill-scarlet-500\\/100{
  fill: rgb(255, 34, 54);
}
.fill-scarlet-500\\/15{
  fill: rgba(255, 34, 54, 0.15);
}
.fill-scarlet-500\\/20{
  fill: rgba(255, 34, 54, 0.2);
}
.fill-scarlet-500\\/25{
  fill: rgba(255, 34, 54, 0.25);
}
.fill-scarlet-500\\/30{
  fill: rgba(255, 34, 54, 0.3);
}
.fill-scarlet-500\\/35{
  fill: rgba(255, 34, 54, 0.35);
}
.fill-scarlet-500\\/40{
  fill: rgba(255, 34, 54, 0.4);
}
.fill-scarlet-500\\/45{
  fill: rgba(255, 34, 54, 0.45);
}
.fill-scarlet-500\\/5{
  fill: rgba(255, 34, 54, 0.05);
}
.fill-scarlet-500\\/50{
  fill: rgba(255, 34, 54, 0.5);
}
.fill-scarlet-500\\/55{
  fill: rgba(255, 34, 54, 0.55);
}
.fill-scarlet-500\\/60{
  fill: rgba(255, 34, 54, 0.6);
}
.fill-scarlet-500\\/65{
  fill: rgba(255, 34, 54, 0.65);
}
.fill-scarlet-500\\/70{
  fill: rgba(255, 34, 54, 0.7);
}
.fill-scarlet-500\\/75{
  fill: rgba(255, 34, 54, 0.75);
}
.fill-scarlet-500\\/80{
  fill: rgba(255, 34, 54, 0.8);
}
.fill-scarlet-500\\/85{
  fill: rgba(255, 34, 54, 0.85);
}
.fill-scarlet-500\\/90{
  fill: rgba(255, 34, 54, 0.9);
}
.fill-scarlet-500\\/95{
  fill: rgba(255, 34, 54, 0.95);
}
.fill-scarlet-600{
  fill: #ff0219;
}
.fill-scarlet-600\\/0{
  fill: rgba(255, 2, 25, 0);
}
.fill-scarlet-600\\/10{
  fill: rgba(255, 2, 25, 0.1);
}
.fill-scarlet-600\\/100{
  fill: rgb(255, 2, 25);
}
.fill-scarlet-600\\/15{
  fill: rgba(255, 2, 25, 0.15);
}
.fill-scarlet-600\\/20{
  fill: rgba(255, 2, 25, 0.2);
}
.fill-scarlet-600\\/25{
  fill: rgba(255, 2, 25, 0.25);
}
.fill-scarlet-600\\/30{
  fill: rgba(255, 2, 25, 0.3);
}
.fill-scarlet-600\\/35{
  fill: rgba(255, 2, 25, 0.35);
}
.fill-scarlet-600\\/40{
  fill: rgba(255, 2, 25, 0.4);
}
.fill-scarlet-600\\/45{
  fill: rgba(255, 2, 25, 0.45);
}
.fill-scarlet-600\\/5{
  fill: rgba(255, 2, 25, 0.05);
}
.fill-scarlet-600\\/50{
  fill: rgba(255, 2, 25, 0.5);
}
.fill-scarlet-600\\/55{
  fill: rgba(255, 2, 25, 0.55);
}
.fill-scarlet-600\\/60{
  fill: rgba(255, 2, 25, 0.6);
}
.fill-scarlet-600\\/65{
  fill: rgba(255, 2, 25, 0.65);
}
.fill-scarlet-600\\/70{
  fill: rgba(255, 2, 25, 0.7);
}
.fill-scarlet-600\\/75{
  fill: rgba(255, 2, 25, 0.75);
}
.fill-scarlet-600\\/80{
  fill: rgba(255, 2, 25, 0.8);
}
.fill-scarlet-600\\/85{
  fill: rgba(255, 2, 25, 0.85);
}
.fill-scarlet-600\\/90{
  fill: rgba(255, 2, 25, 0.9);
}
.fill-scarlet-600\\/95{
  fill: rgba(255, 2, 25, 0.95);
}
.fill-scarlet-700{
  fill: #d80013;
}
.fill-scarlet-700\\/0{
  fill: rgba(216, 0, 19, 0);
}
.fill-scarlet-700\\/10{
  fill: rgba(216, 0, 19, 0.1);
}
.fill-scarlet-700\\/100{
  fill: rgb(216, 0, 19);
}
.fill-scarlet-700\\/15{
  fill: rgba(216, 0, 19, 0.15);
}
.fill-scarlet-700\\/20{
  fill: rgba(216, 0, 19, 0.2);
}
.fill-scarlet-700\\/25{
  fill: rgba(216, 0, 19, 0.25);
}
.fill-scarlet-700\\/30{
  fill: rgba(216, 0, 19, 0.3);
}
.fill-scarlet-700\\/35{
  fill: rgba(216, 0, 19, 0.35);
}
.fill-scarlet-700\\/40{
  fill: rgba(216, 0, 19, 0.4);
}
.fill-scarlet-700\\/45{
  fill: rgba(216, 0, 19, 0.45);
}
.fill-scarlet-700\\/5{
  fill: rgba(216, 0, 19, 0.05);
}
.fill-scarlet-700\\/50{
  fill: rgba(216, 0, 19, 0.5);
}
.fill-scarlet-700\\/55{
  fill: rgba(216, 0, 19, 0.55);
}
.fill-scarlet-700\\/60{
  fill: rgba(216, 0, 19, 0.6);
}
.fill-scarlet-700\\/65{
  fill: rgba(216, 0, 19, 0.65);
}
.fill-scarlet-700\\/70{
  fill: rgba(216, 0, 19, 0.7);
}
.fill-scarlet-700\\/75{
  fill: rgba(216, 0, 19, 0.75);
}
.fill-scarlet-700\\/80{
  fill: rgba(216, 0, 19, 0.8);
}
.fill-scarlet-700\\/85{
  fill: rgba(216, 0, 19, 0.85);
}
.fill-scarlet-700\\/90{
  fill: rgba(216, 0, 19, 0.9);
}
.fill-scarlet-700\\/95{
  fill: rgba(216, 0, 19, 0.95);
}
.fill-scarlet-800{
  fill: #b40212;
}
.fill-scarlet-800\\/0{
  fill: rgba(180, 2, 18, 0);
}
.fill-scarlet-800\\/10{
  fill: rgba(180, 2, 18, 0.1);
}
.fill-scarlet-800\\/100{
  fill: rgb(180, 2, 18);
}
.fill-scarlet-800\\/15{
  fill: rgba(180, 2, 18, 0.15);
}
.fill-scarlet-800\\/20{
  fill: rgba(180, 2, 18, 0.2);
}
.fill-scarlet-800\\/25{
  fill: rgba(180, 2, 18, 0.25);
}
.fill-scarlet-800\\/30{
  fill: rgba(180, 2, 18, 0.3);
}
.fill-scarlet-800\\/35{
  fill: rgba(180, 2, 18, 0.35);
}
.fill-scarlet-800\\/40{
  fill: rgba(180, 2, 18, 0.4);
}
.fill-scarlet-800\\/45{
  fill: rgba(180, 2, 18, 0.45);
}
.fill-scarlet-800\\/5{
  fill: rgba(180, 2, 18, 0.05);
}
.fill-scarlet-800\\/50{
  fill: rgba(180, 2, 18, 0.5);
}
.fill-scarlet-800\\/55{
  fill: rgba(180, 2, 18, 0.55);
}
.fill-scarlet-800\\/60{
  fill: rgba(180, 2, 18, 0.6);
}
.fill-scarlet-800\\/65{
  fill: rgba(180, 2, 18, 0.65);
}
.fill-scarlet-800\\/70{
  fill: rgba(180, 2, 18, 0.7);
}
.fill-scarlet-800\\/75{
  fill: rgba(180, 2, 18, 0.75);
}
.fill-scarlet-800\\/80{
  fill: rgba(180, 2, 18, 0.8);
}
.fill-scarlet-800\\/85{
  fill: rgba(180, 2, 18, 0.85);
}
.fill-scarlet-800\\/90{
  fill: rgba(180, 2, 18, 0.9);
}
.fill-scarlet-800\\/95{
  fill: rgba(180, 2, 18, 0.95);
}
.fill-scarlet-900{
  fill: #920a16;
}
.fill-scarlet-900\\/0{
  fill: rgba(146, 10, 22, 0);
}
.fill-scarlet-900\\/10{
  fill: rgba(146, 10, 22, 0.1);
}
.fill-scarlet-900\\/100{
  fill: rgb(146, 10, 22);
}
.fill-scarlet-900\\/15{
  fill: rgba(146, 10, 22, 0.15);
}
.fill-scarlet-900\\/20{
  fill: rgba(146, 10, 22, 0.2);
}
.fill-scarlet-900\\/25{
  fill: rgba(146, 10, 22, 0.25);
}
.fill-scarlet-900\\/30{
  fill: rgba(146, 10, 22, 0.3);
}
.fill-scarlet-900\\/35{
  fill: rgba(146, 10, 22, 0.35);
}
.fill-scarlet-900\\/40{
  fill: rgba(146, 10, 22, 0.4);
}
.fill-scarlet-900\\/45{
  fill: rgba(146, 10, 22, 0.45);
}
.fill-scarlet-900\\/5{
  fill: rgba(146, 10, 22, 0.05);
}
.fill-scarlet-900\\/50{
  fill: rgba(146, 10, 22, 0.5);
}
.fill-scarlet-900\\/55{
  fill: rgba(146, 10, 22, 0.55);
}
.fill-scarlet-900\\/60{
  fill: rgba(146, 10, 22, 0.6);
}
.fill-scarlet-900\\/65{
  fill: rgba(146, 10, 22, 0.65);
}
.fill-scarlet-900\\/70{
  fill: rgba(146, 10, 22, 0.7);
}
.fill-scarlet-900\\/75{
  fill: rgba(146, 10, 22, 0.75);
}
.fill-scarlet-900\\/80{
  fill: rgba(146, 10, 22, 0.8);
}
.fill-scarlet-900\\/85{
  fill: rgba(146, 10, 22, 0.85);
}
.fill-scarlet-900\\/90{
  fill: rgba(146, 10, 22, 0.9);
}
.fill-scarlet-900\\/95{
  fill: rgba(146, 10, 22, 0.95);
}
.fill-scarlet-950{
  fill: #510007;
}
.fill-scarlet-950\\/0{
  fill: rgba(81, 0, 7, 0);
}
.fill-scarlet-950\\/10{
  fill: rgba(81, 0, 7, 0.1);
}
.fill-scarlet-950\\/100{
  fill: rgb(81, 0, 7);
}
.fill-scarlet-950\\/15{
  fill: rgba(81, 0, 7, 0.15);
}
.fill-scarlet-950\\/20{
  fill: rgba(81, 0, 7, 0.2);
}
.fill-scarlet-950\\/25{
  fill: rgba(81, 0, 7, 0.25);
}
.fill-scarlet-950\\/30{
  fill: rgba(81, 0, 7, 0.3);
}
.fill-scarlet-950\\/35{
  fill: rgba(81, 0, 7, 0.35);
}
.fill-scarlet-950\\/40{
  fill: rgba(81, 0, 7, 0.4);
}
.fill-scarlet-950\\/45{
  fill: rgba(81, 0, 7, 0.45);
}
.fill-scarlet-950\\/5{
  fill: rgba(81, 0, 7, 0.05);
}
.fill-scarlet-950\\/50{
  fill: rgba(81, 0, 7, 0.5);
}
.fill-scarlet-950\\/55{
  fill: rgba(81, 0, 7, 0.55);
}
.fill-scarlet-950\\/60{
  fill: rgba(81, 0, 7, 0.6);
}
.fill-scarlet-950\\/65{
  fill: rgba(81, 0, 7, 0.65);
}
.fill-scarlet-950\\/70{
  fill: rgba(81, 0, 7, 0.7);
}
.fill-scarlet-950\\/75{
  fill: rgba(81, 0, 7, 0.75);
}
.fill-scarlet-950\\/80{
  fill: rgba(81, 0, 7, 0.8);
}
.fill-scarlet-950\\/85{
  fill: rgba(81, 0, 7, 0.85);
}
.fill-scarlet-950\\/90{
  fill: rgba(81, 0, 7, 0.9);
}
.fill-scarlet-950\\/95{
  fill: rgba(81, 0, 7, 0.95);
}
.fill-song-color-100{
  fill: #ffdcdf;
}
.fill-song-color-100\\/0{
  fill: rgba(255, 220, 223, 0);
}
.fill-song-color-100\\/10{
  fill: rgba(255, 220, 223, 0.1);
}
.fill-song-color-100\\/100{
  fill: rgb(255, 220, 223);
}
.fill-song-color-100\\/15{
  fill: rgba(255, 220, 223, 0.15);
}
.fill-song-color-100\\/20{
  fill: rgba(255, 220, 223, 0.2);
}
.fill-song-color-100\\/25{
  fill: rgba(255, 220, 223, 0.25);
}
.fill-song-color-100\\/30{
  fill: rgba(255, 220, 223, 0.3);
}
.fill-song-color-100\\/35{
  fill: rgba(255, 220, 223, 0.35);
}
.fill-song-color-100\\/40{
  fill: rgba(255, 220, 223, 0.4);
}
.fill-song-color-100\\/45{
  fill: rgba(255, 220, 223, 0.45);
}
.fill-song-color-100\\/5{
  fill: rgba(255, 220, 223, 0.05);
}
.fill-song-color-100\\/50{
  fill: rgba(255, 220, 223, 0.5);
}
.fill-song-color-100\\/55{
  fill: rgba(255, 220, 223, 0.55);
}
.fill-song-color-100\\/60{
  fill: rgba(255, 220, 223, 0.6);
}
.fill-song-color-100\\/65{
  fill: rgba(255, 220, 223, 0.65);
}
.fill-song-color-100\\/70{
  fill: rgba(255, 220, 223, 0.7);
}
.fill-song-color-100\\/75{
  fill: rgba(255, 220, 223, 0.75);
}
.fill-song-color-100\\/80{
  fill: rgba(255, 220, 223, 0.8);
}
.fill-song-color-100\\/85{
  fill: rgba(255, 220, 223, 0.85);
}
.fill-song-color-100\\/90{
  fill: rgba(255, 220, 223, 0.9);
}
.fill-song-color-100\\/95{
  fill: rgba(255, 220, 223, 0.95);
}
.fill-song-color-200{
  fill: #ffc0c6;
}
.fill-song-color-200\\/0{
  fill: rgba(255, 192, 198, 0);
}
.fill-song-color-200\\/10{
  fill: rgba(255, 192, 198, 0.1);
}
.fill-song-color-200\\/100{
  fill: rgb(255, 192, 198);
}
.fill-song-color-200\\/15{
  fill: rgba(255, 192, 198, 0.15);
}
.fill-song-color-200\\/20{
  fill: rgba(255, 192, 198, 0.2);
}
.fill-song-color-200\\/25{
  fill: rgba(255, 192, 198, 0.25);
}
.fill-song-color-200\\/30{
  fill: rgba(255, 192, 198, 0.3);
}
.fill-song-color-200\\/35{
  fill: rgba(255, 192, 198, 0.35);
}
.fill-song-color-200\\/40{
  fill: rgba(255, 192, 198, 0.4);
}
.fill-song-color-200\\/45{
  fill: rgba(255, 192, 198, 0.45);
}
.fill-song-color-200\\/5{
  fill: rgba(255, 192, 198, 0.05);
}
.fill-song-color-200\\/50{
  fill: rgba(255, 192, 198, 0.5);
}
.fill-song-color-200\\/55{
  fill: rgba(255, 192, 198, 0.55);
}
.fill-song-color-200\\/60{
  fill: rgba(255, 192, 198, 0.6);
}
.fill-song-color-200\\/65{
  fill: rgba(255, 192, 198, 0.65);
}
.fill-song-color-200\\/70{
  fill: rgba(255, 192, 198, 0.7);
}
.fill-song-color-200\\/75{
  fill: rgba(255, 192, 198, 0.75);
}
.fill-song-color-200\\/80{
  fill: rgba(255, 192, 198, 0.8);
}
.fill-song-color-200\\/85{
  fill: rgba(255, 192, 198, 0.85);
}
.fill-song-color-200\\/90{
  fill: rgba(255, 192, 198, 0.9);
}
.fill-song-color-200\\/95{
  fill: rgba(255, 192, 198, 0.95);
}
.fill-song-color-300{
  fill: #ff949e;
}
.fill-song-color-300\\/0{
  fill: rgba(255, 148, 158, 0);
}
.fill-song-color-300\\/10{
  fill: rgba(255, 148, 158, 0.1);
}
.fill-song-color-300\\/100{
  fill: rgb(255, 148, 158);
}
.fill-song-color-300\\/15{
  fill: rgba(255, 148, 158, 0.15);
}
.fill-song-color-300\\/20{
  fill: rgba(255, 148, 158, 0.2);
}
.fill-song-color-300\\/25{
  fill: rgba(255, 148, 158, 0.25);
}
.fill-song-color-300\\/30{
  fill: rgba(255, 148, 158, 0.3);
}
.fill-song-color-300\\/35{
  fill: rgba(255, 148, 158, 0.35);
}
.fill-song-color-300\\/40{
  fill: rgba(255, 148, 158, 0.4);
}
.fill-song-color-300\\/45{
  fill: rgba(255, 148, 158, 0.45);
}
.fill-song-color-300\\/5{
  fill: rgba(255, 148, 158, 0.05);
}
.fill-song-color-300\\/50{
  fill: rgba(255, 148, 158, 0.5);
}
.fill-song-color-300\\/55{
  fill: rgba(255, 148, 158, 0.55);
}
.fill-song-color-300\\/60{
  fill: rgba(255, 148, 158, 0.6);
}
.fill-song-color-300\\/65{
  fill: rgba(255, 148, 158, 0.65);
}
.fill-song-color-300\\/70{
  fill: rgba(255, 148, 158, 0.7);
}
.fill-song-color-300\\/75{
  fill: rgba(255, 148, 158, 0.75);
}
.fill-song-color-300\\/80{
  fill: rgba(255, 148, 158, 0.8);
}
.fill-song-color-300\\/85{
  fill: rgba(255, 148, 158, 0.85);
}
.fill-song-color-300\\/90{
  fill: rgba(255, 148, 158, 0.9);
}
.fill-song-color-300\\/95{
  fill: rgba(255, 148, 158, 0.95);
}
.fill-song-color-400{
  fill: #ff5665;
}
.fill-song-color-400\\/0{
  fill: rgba(255, 86, 101, 0);
}
.fill-song-color-400\\/10{
  fill: rgba(255, 86, 101, 0.1);
}
.fill-song-color-400\\/100{
  fill: rgb(255, 86, 101);
}
.fill-song-color-400\\/15{
  fill: rgba(255, 86, 101, 0.15);
}
.fill-song-color-400\\/20{
  fill: rgba(255, 86, 101, 0.2);
}
.fill-song-color-400\\/25{
  fill: rgba(255, 86, 101, 0.25);
}
.fill-song-color-400\\/30{
  fill: rgba(255, 86, 101, 0.3);
}
.fill-song-color-400\\/35{
  fill: rgba(255, 86, 101, 0.35);
}
.fill-song-color-400\\/40{
  fill: rgba(255, 86, 101, 0.4);
}
.fill-song-color-400\\/45{
  fill: rgba(255, 86, 101, 0.45);
}
.fill-song-color-400\\/5{
  fill: rgba(255, 86, 101, 0.05);
}
.fill-song-color-400\\/50{
  fill: rgba(255, 86, 101, 0.5);
}
.fill-song-color-400\\/55{
  fill: rgba(255, 86, 101, 0.55);
}
.fill-song-color-400\\/60{
  fill: rgba(255, 86, 101, 0.6);
}
.fill-song-color-400\\/65{
  fill: rgba(255, 86, 101, 0.65);
}
.fill-song-color-400\\/70{
  fill: rgba(255, 86, 101, 0.7);
}
.fill-song-color-400\\/75{
  fill: rgba(255, 86, 101, 0.75);
}
.fill-song-color-400\\/80{
  fill: rgba(255, 86, 101, 0.8);
}
.fill-song-color-400\\/85{
  fill: rgba(255, 86, 101, 0.85);
}
.fill-song-color-400\\/90{
  fill: rgba(255, 86, 101, 0.9);
}
.fill-song-color-400\\/95{
  fill: rgba(255, 86, 101, 0.95);
}
.fill-song-color-500{
  fill: #ff2236;
}
.fill-song-color-500\\/0{
  fill: rgba(255, 34, 54, 0);
}
.fill-song-color-500\\/10{
  fill: rgba(255, 34, 54, 0.1);
}
.fill-song-color-500\\/100{
  fill: rgb(255, 34, 54);
}
.fill-song-color-500\\/15{
  fill: rgba(255, 34, 54, 0.15);
}
.fill-song-color-500\\/20{
  fill: rgba(255, 34, 54, 0.2);
}
.fill-song-color-500\\/25{
  fill: rgba(255, 34, 54, 0.25);
}
.fill-song-color-500\\/30{
  fill: rgba(255, 34, 54, 0.3);
}
.fill-song-color-500\\/35{
  fill: rgba(255, 34, 54, 0.35);
}
.fill-song-color-500\\/40{
  fill: rgba(255, 34, 54, 0.4);
}
.fill-song-color-500\\/45{
  fill: rgba(255, 34, 54, 0.45);
}
.fill-song-color-500\\/5{
  fill: rgba(255, 34, 54, 0.05);
}
.fill-song-color-500\\/50{
  fill: rgba(255, 34, 54, 0.5);
}
.fill-song-color-500\\/55{
  fill: rgba(255, 34, 54, 0.55);
}
.fill-song-color-500\\/60{
  fill: rgba(255, 34, 54, 0.6);
}
.fill-song-color-500\\/65{
  fill: rgba(255, 34, 54, 0.65);
}
.fill-song-color-500\\/70{
  fill: rgba(255, 34, 54, 0.7);
}
.fill-song-color-500\\/75{
  fill: rgba(255, 34, 54, 0.75);
}
.fill-song-color-500\\/80{
  fill: rgba(255, 34, 54, 0.8);
}
.fill-song-color-500\\/85{
  fill: rgba(255, 34, 54, 0.85);
}
.fill-song-color-500\\/90{
  fill: rgba(255, 34, 54, 0.9);
}
.fill-song-color-500\\/95{
  fill: rgba(255, 34, 54, 0.95);
}
.fill-song-color-600{
  fill: #ff0219;
}
.fill-song-color-600\\/0{
  fill: rgba(255, 2, 25, 0);
}
.fill-song-color-600\\/10{
  fill: rgba(255, 2, 25, 0.1);
}
.fill-song-color-600\\/100{
  fill: rgb(255, 2, 25);
}
.fill-song-color-600\\/15{
  fill: rgba(255, 2, 25, 0.15);
}
.fill-song-color-600\\/20{
  fill: rgba(255, 2, 25, 0.2);
}
.fill-song-color-600\\/25{
  fill: rgba(255, 2, 25, 0.25);
}
.fill-song-color-600\\/30{
  fill: rgba(255, 2, 25, 0.3);
}
.fill-song-color-600\\/35{
  fill: rgba(255, 2, 25, 0.35);
}
.fill-song-color-600\\/40{
  fill: rgba(255, 2, 25, 0.4);
}
.fill-song-color-600\\/45{
  fill: rgba(255, 2, 25, 0.45);
}
.fill-song-color-600\\/5{
  fill: rgba(255, 2, 25, 0.05);
}
.fill-song-color-600\\/50{
  fill: rgba(255, 2, 25, 0.5);
}
.fill-song-color-600\\/55{
  fill: rgba(255, 2, 25, 0.55);
}
.fill-song-color-600\\/60{
  fill: rgba(255, 2, 25, 0.6);
}
.fill-song-color-600\\/65{
  fill: rgba(255, 2, 25, 0.65);
}
.fill-song-color-600\\/70{
  fill: rgba(255, 2, 25, 0.7);
}
.fill-song-color-600\\/75{
  fill: rgba(255, 2, 25, 0.75);
}
.fill-song-color-600\\/80{
  fill: rgba(255, 2, 25, 0.8);
}
.fill-song-color-600\\/85{
  fill: rgba(255, 2, 25, 0.85);
}
.fill-song-color-600\\/90{
  fill: rgba(255, 2, 25, 0.9);
}
.fill-song-color-600\\/95{
  fill: rgba(255, 2, 25, 0.95);
}
.fill-song-color-700{
  fill: #d80013;
}
.fill-song-color-700\\/0{
  fill: rgba(216, 0, 19, 0);
}
.fill-song-color-700\\/10{
  fill: rgba(216, 0, 19, 0.1);
}
.fill-song-color-700\\/100{
  fill: rgb(216, 0, 19);
}
.fill-song-color-700\\/15{
  fill: rgba(216, 0, 19, 0.15);
}
.fill-song-color-700\\/20{
  fill: rgba(216, 0, 19, 0.2);
}
.fill-song-color-700\\/25{
  fill: rgba(216, 0, 19, 0.25);
}
.fill-song-color-700\\/30{
  fill: rgba(216, 0, 19, 0.3);
}
.fill-song-color-700\\/35{
  fill: rgba(216, 0, 19, 0.35);
}
.fill-song-color-700\\/40{
  fill: rgba(216, 0, 19, 0.4);
}
.fill-song-color-700\\/45{
  fill: rgba(216, 0, 19, 0.45);
}
.fill-song-color-700\\/5{
  fill: rgba(216, 0, 19, 0.05);
}
.fill-song-color-700\\/50{
  fill: rgba(216, 0, 19, 0.5);
}
.fill-song-color-700\\/55{
  fill: rgba(216, 0, 19, 0.55);
}
.fill-song-color-700\\/60{
  fill: rgba(216, 0, 19, 0.6);
}
.fill-song-color-700\\/65{
  fill: rgba(216, 0, 19, 0.65);
}
.fill-song-color-700\\/70{
  fill: rgba(216, 0, 19, 0.7);
}
.fill-song-color-700\\/75{
  fill: rgba(216, 0, 19, 0.75);
}
.fill-song-color-700\\/80{
  fill: rgba(216, 0, 19, 0.8);
}
.fill-song-color-700\\/85{
  fill: rgba(216, 0, 19, 0.85);
}
.fill-song-color-700\\/90{
  fill: rgba(216, 0, 19, 0.9);
}
.fill-song-color-700\\/95{
  fill: rgba(216, 0, 19, 0.95);
}
.fill-song-color-800{
  fill: #b40212;
}
.fill-song-color-800\\/0{
  fill: rgba(180, 2, 18, 0);
}
.fill-song-color-800\\/10{
  fill: rgba(180, 2, 18, 0.1);
}
.fill-song-color-800\\/100{
  fill: rgb(180, 2, 18);
}
.fill-song-color-800\\/15{
  fill: rgba(180, 2, 18, 0.15);
}
.fill-song-color-800\\/20{
  fill: rgba(180, 2, 18, 0.2);
}
.fill-song-color-800\\/25{
  fill: rgba(180, 2, 18, 0.25);
}
.fill-song-color-800\\/30{
  fill: rgba(180, 2, 18, 0.3);
}
.fill-song-color-800\\/35{
  fill: rgba(180, 2, 18, 0.35);
}
.fill-song-color-800\\/40{
  fill: rgba(180, 2, 18, 0.4);
}
.fill-song-color-800\\/45{
  fill: rgba(180, 2, 18, 0.45);
}
.fill-song-color-800\\/5{
  fill: rgba(180, 2, 18, 0.05);
}
.fill-song-color-800\\/50{
  fill: rgba(180, 2, 18, 0.5);
}
.fill-song-color-800\\/55{
  fill: rgba(180, 2, 18, 0.55);
}
.fill-song-color-800\\/60{
  fill: rgba(180, 2, 18, 0.6);
}
.fill-song-color-800\\/65{
  fill: rgba(180, 2, 18, 0.65);
}
.fill-song-color-800\\/70{
  fill: rgba(180, 2, 18, 0.7);
}
.fill-song-color-800\\/75{
  fill: rgba(180, 2, 18, 0.75);
}
.fill-song-color-800\\/80{
  fill: rgba(180, 2, 18, 0.8);
}
.fill-song-color-800\\/85{
  fill: rgba(180, 2, 18, 0.85);
}
.fill-song-color-800\\/90{
  fill: rgba(180, 2, 18, 0.9);
}
.fill-song-color-800\\/95{
  fill: rgba(180, 2, 18, 0.95);
}
.fill-song-color-900{
  fill: #920a16;
}
.fill-song-color-900\\/0{
  fill: rgba(146, 10, 22, 0);
}
.fill-song-color-900\\/10{
  fill: rgba(146, 10, 22, 0.1);
}
.fill-song-color-900\\/100{
  fill: rgb(146, 10, 22);
}
.fill-song-color-900\\/15{
  fill: rgba(146, 10, 22, 0.15);
}
.fill-song-color-900\\/20{
  fill: rgba(146, 10, 22, 0.2);
}
.fill-song-color-900\\/25{
  fill: rgba(146, 10, 22, 0.25);
}
.fill-song-color-900\\/30{
  fill: rgba(146, 10, 22, 0.3);
}
.fill-song-color-900\\/35{
  fill: rgba(146, 10, 22, 0.35);
}
.fill-song-color-900\\/40{
  fill: rgba(146, 10, 22, 0.4);
}
.fill-song-color-900\\/45{
  fill: rgba(146, 10, 22, 0.45);
}
.fill-song-color-900\\/5{
  fill: rgba(146, 10, 22, 0.05);
}
.fill-song-color-900\\/50{
  fill: rgba(146, 10, 22, 0.5);
}
.fill-song-color-900\\/55{
  fill: rgba(146, 10, 22, 0.55);
}
.fill-song-color-900\\/60{
  fill: rgba(146, 10, 22, 0.6);
}
.fill-song-color-900\\/65{
  fill: rgba(146, 10, 22, 0.65);
}
.fill-song-color-900\\/70{
  fill: rgba(146, 10, 22, 0.7);
}
.fill-song-color-900\\/75{
  fill: rgba(146, 10, 22, 0.75);
}
.fill-song-color-900\\/80{
  fill: rgba(146, 10, 22, 0.8);
}
.fill-song-color-900\\/85{
  fill: rgba(146, 10, 22, 0.85);
}
.fill-song-color-900\\/90{
  fill: rgba(146, 10, 22, 0.9);
}
.fill-song-color-900\\/95{
  fill: rgba(146, 10, 22, 0.95);
}
.fill-song-color-950{
  fill: #510007;
}
.fill-song-color-950\\/0{
  fill: rgba(81, 0, 7, 0);
}
.fill-song-color-950\\/10{
  fill: rgba(81, 0, 7, 0.1);
}
.fill-song-color-950\\/100{
  fill: rgb(81, 0, 7);
}
.fill-song-color-950\\/15{
  fill: rgba(81, 0, 7, 0.15);
}
.fill-song-color-950\\/20{
  fill: rgba(81, 0, 7, 0.2);
}
.fill-song-color-950\\/25{
  fill: rgba(81, 0, 7, 0.25);
}
.fill-song-color-950\\/30{
  fill: rgba(81, 0, 7, 0.3);
}
.fill-song-color-950\\/35{
  fill: rgba(81, 0, 7, 0.35);
}
.fill-song-color-950\\/40{
  fill: rgba(81, 0, 7, 0.4);
}
.fill-song-color-950\\/45{
  fill: rgba(81, 0, 7, 0.45);
}
.fill-song-color-950\\/5{
  fill: rgba(81, 0, 7, 0.05);
}
.fill-song-color-950\\/50{
  fill: rgba(81, 0, 7, 0.5);
}
.fill-song-color-950\\/55{
  fill: rgba(81, 0, 7, 0.55);
}
.fill-song-color-950\\/60{
  fill: rgba(81, 0, 7, 0.6);
}
.fill-song-color-950\\/65{
  fill: rgba(81, 0, 7, 0.65);
}
.fill-song-color-950\\/70{
  fill: rgba(81, 0, 7, 0.7);
}
.fill-song-color-950\\/75{
  fill: rgba(81, 0, 7, 0.75);
}
.fill-song-color-950\\/80{
  fill: rgba(81, 0, 7, 0.8);
}
.fill-song-color-950\\/85{
  fill: rgba(81, 0, 7, 0.85);
}
.fill-song-color-950\\/90{
  fill: rgba(81, 0, 7, 0.9);
}
.fill-song-color-950\\/95{
  fill: rgba(81, 0, 7, 0.95);
}
.fill-story-color-100{
  fill: #daeef3;
}
.fill-story-color-100\\/0{
  fill: rgba(218, 238, 243, 0);
}
.fill-story-color-100\\/10{
  fill: rgba(218, 238, 243, 0.1);
}
.fill-story-color-100\\/100{
  fill: rgb(218, 238, 243);
}
.fill-story-color-100\\/15{
  fill: rgba(218, 238, 243, 0.15);
}
.fill-story-color-100\\/20{
  fill: rgba(218, 238, 243, 0.2);
}
.fill-story-color-100\\/25{
  fill: rgba(218, 238, 243, 0.25);
}
.fill-story-color-100\\/30{
  fill: rgba(218, 238, 243, 0.3);
}
.fill-story-color-100\\/35{
  fill: rgba(218, 238, 243, 0.35);
}
.fill-story-color-100\\/40{
  fill: rgba(218, 238, 243, 0.4);
}
.fill-story-color-100\\/45{
  fill: rgba(218, 238, 243, 0.45);
}
.fill-story-color-100\\/5{
  fill: rgba(218, 238, 243, 0.05);
}
.fill-story-color-100\\/50{
  fill: rgba(218, 238, 243, 0.5);
}
.fill-story-color-100\\/55{
  fill: rgba(218, 238, 243, 0.55);
}
.fill-story-color-100\\/60{
  fill: rgba(218, 238, 243, 0.6);
}
.fill-story-color-100\\/65{
  fill: rgba(218, 238, 243, 0.65);
}
.fill-story-color-100\\/70{
  fill: rgba(218, 238, 243, 0.7);
}
.fill-story-color-100\\/75{
  fill: rgba(218, 238, 243, 0.75);
}
.fill-story-color-100\\/80{
  fill: rgba(218, 238, 243, 0.8);
}
.fill-story-color-100\\/85{
  fill: rgba(218, 238, 243, 0.85);
}
.fill-story-color-100\\/90{
  fill: rgba(218, 238, 243, 0.9);
}
.fill-story-color-100\\/95{
  fill: rgba(218, 238, 243, 0.95);
}
.fill-story-color-200{
  fill: #badee7;
}
.fill-story-color-200\\/0{
  fill: rgba(186, 222, 231, 0);
}
.fill-story-color-200\\/10{
  fill: rgba(186, 222, 231, 0.1);
}
.fill-story-color-200\\/100{
  fill: rgb(186, 222, 231);
}
.fill-story-color-200\\/15{
  fill: rgba(186, 222, 231, 0.15);
}
.fill-story-color-200\\/20{
  fill: rgba(186, 222, 231, 0.2);
}
.fill-story-color-200\\/25{
  fill: rgba(186, 222, 231, 0.25);
}
.fill-story-color-200\\/30{
  fill: rgba(186, 222, 231, 0.3);
}
.fill-story-color-200\\/35{
  fill: rgba(186, 222, 231, 0.35);
}
.fill-story-color-200\\/40{
  fill: rgba(186, 222, 231, 0.4);
}
.fill-story-color-200\\/45{
  fill: rgba(186, 222, 231, 0.45);
}
.fill-story-color-200\\/5{
  fill: rgba(186, 222, 231, 0.05);
}
.fill-story-color-200\\/50{
  fill: rgba(186, 222, 231, 0.5);
}
.fill-story-color-200\\/55{
  fill: rgba(186, 222, 231, 0.55);
}
.fill-story-color-200\\/60{
  fill: rgba(186, 222, 231, 0.6);
}
.fill-story-color-200\\/65{
  fill: rgba(186, 222, 231, 0.65);
}
.fill-story-color-200\\/70{
  fill: rgba(186, 222, 231, 0.7);
}
.fill-story-color-200\\/75{
  fill: rgba(186, 222, 231, 0.75);
}
.fill-story-color-200\\/80{
  fill: rgba(186, 222, 231, 0.8);
}
.fill-story-color-200\\/85{
  fill: rgba(186, 222, 231, 0.85);
}
.fill-story-color-200\\/90{
  fill: rgba(186, 222, 231, 0.9);
}
.fill-story-color-200\\/95{
  fill: rgba(186, 222, 231, 0.95);
}
.fill-story-color-300{
  fill: #89c5d7;
}
.fill-story-color-300\\/0{
  fill: rgba(137, 197, 215, 0);
}
.fill-story-color-300\\/10{
  fill: rgba(137, 197, 215, 0.1);
}
.fill-story-color-300\\/100{
  fill: rgb(137, 197, 215);
}
.fill-story-color-300\\/15{
  fill: rgba(137, 197, 215, 0.15);
}
.fill-story-color-300\\/20{
  fill: rgba(137, 197, 215, 0.2);
}
.fill-story-color-300\\/25{
  fill: rgba(137, 197, 215, 0.25);
}
.fill-story-color-300\\/30{
  fill: rgba(137, 197, 215, 0.3);
}
.fill-story-color-300\\/35{
  fill: rgba(137, 197, 215, 0.35);
}
.fill-story-color-300\\/40{
  fill: rgba(137, 197, 215, 0.4);
}
.fill-story-color-300\\/45{
  fill: rgba(137, 197, 215, 0.45);
}
.fill-story-color-300\\/5{
  fill: rgba(137, 197, 215, 0.05);
}
.fill-story-color-300\\/50{
  fill: rgba(137, 197, 215, 0.5);
}
.fill-story-color-300\\/55{
  fill: rgba(137, 197, 215, 0.55);
}
.fill-story-color-300\\/60{
  fill: rgba(137, 197, 215, 0.6);
}
.fill-story-color-300\\/65{
  fill: rgba(137, 197, 215, 0.65);
}
.fill-story-color-300\\/70{
  fill: rgba(137, 197, 215, 0.7);
}
.fill-story-color-300\\/75{
  fill: rgba(137, 197, 215, 0.75);
}
.fill-story-color-300\\/80{
  fill: rgba(137, 197, 215, 0.8);
}
.fill-story-color-300\\/85{
  fill: rgba(137, 197, 215, 0.85);
}
.fill-story-color-300\\/90{
  fill: rgba(137, 197, 215, 0.9);
}
.fill-story-color-300\\/95{
  fill: rgba(137, 197, 215, 0.95);
}
.fill-story-color-400{
  fill: #52a3be;
}
.fill-story-color-400\\/0{
  fill: rgba(82, 163, 190, 0);
}
.fill-story-color-400\\/10{
  fill: rgba(82, 163, 190, 0.1);
}
.fill-story-color-400\\/100{
  fill: rgb(82, 163, 190);
}
.fill-story-color-400\\/15{
  fill: rgba(82, 163, 190, 0.15);
}
.fill-story-color-400\\/20{
  fill: rgba(82, 163, 190, 0.2);
}
.fill-story-color-400\\/25{
  fill: rgba(82, 163, 190, 0.25);
}
.fill-story-color-400\\/30{
  fill: rgba(82, 163, 190, 0.3);
}
.fill-story-color-400\\/35{
  fill: rgba(82, 163, 190, 0.35);
}
.fill-story-color-400\\/40{
  fill: rgba(82, 163, 190, 0.4);
}
.fill-story-color-400\\/45{
  fill: rgba(82, 163, 190, 0.45);
}
.fill-story-color-400\\/5{
  fill: rgba(82, 163, 190, 0.05);
}
.fill-story-color-400\\/50{
  fill: rgba(82, 163, 190, 0.5);
}
.fill-story-color-400\\/55{
  fill: rgba(82, 163, 190, 0.55);
}
.fill-story-color-400\\/60{
  fill: rgba(82, 163, 190, 0.6);
}
.fill-story-color-400\\/65{
  fill: rgba(82, 163, 190, 0.65);
}
.fill-story-color-400\\/70{
  fill: rgba(82, 163, 190, 0.7);
}
.fill-story-color-400\\/75{
  fill: rgba(82, 163, 190, 0.75);
}
.fill-story-color-400\\/80{
  fill: rgba(82, 163, 190, 0.8);
}
.fill-story-color-400\\/85{
  fill: rgba(82, 163, 190, 0.85);
}
.fill-story-color-400\\/90{
  fill: rgba(82, 163, 190, 0.9);
}
.fill-story-color-400\\/95{
  fill: rgba(82, 163, 190, 0.95);
}
.fill-story-color-500{
  fill: #3787a3;
}
.fill-story-color-500\\/0{
  fill: rgba(55, 135, 163, 0);
}
.fill-story-color-500\\/10{
  fill: rgba(55, 135, 163, 0.1);
}
.fill-story-color-500\\/100{
  fill: rgb(55, 135, 163);
}
.fill-story-color-500\\/15{
  fill: rgba(55, 135, 163, 0.15);
}
.fill-story-color-500\\/20{
  fill: rgba(55, 135, 163, 0.2);
}
.fill-story-color-500\\/25{
  fill: rgba(55, 135, 163, 0.25);
}
.fill-story-color-500\\/30{
  fill: rgba(55, 135, 163, 0.3);
}
.fill-story-color-500\\/35{
  fill: rgba(55, 135, 163, 0.35);
}
.fill-story-color-500\\/40{
  fill: rgba(55, 135, 163, 0.4);
}
.fill-story-color-500\\/45{
  fill: rgba(55, 135, 163, 0.45);
}
.fill-story-color-500\\/5{
  fill: rgba(55, 135, 163, 0.05);
}
.fill-story-color-500\\/50{
  fill: rgba(55, 135, 163, 0.5);
}
.fill-story-color-500\\/55{
  fill: rgba(55, 135, 163, 0.55);
}
.fill-story-color-500\\/60{
  fill: rgba(55, 135, 163, 0.6);
}
.fill-story-color-500\\/65{
  fill: rgba(55, 135, 163, 0.65);
}
.fill-story-color-500\\/70{
  fill: rgba(55, 135, 163, 0.7);
}
.fill-story-color-500\\/75{
  fill: rgba(55, 135, 163, 0.75);
}
.fill-story-color-500\\/80{
  fill: rgba(55, 135, 163, 0.8);
}
.fill-story-color-500\\/85{
  fill: rgba(55, 135, 163, 0.85);
}
.fill-story-color-500\\/90{
  fill: rgba(55, 135, 163, 0.9);
}
.fill-story-color-500\\/95{
  fill: rgba(55, 135, 163, 0.95);
}
.fill-story-color-600{
  fill: #306d8a;
}
.fill-story-color-600\\/0{
  fill: rgba(48, 109, 138, 0);
}
.fill-story-color-600\\/10{
  fill: rgba(48, 109, 138, 0.1);
}
.fill-story-color-600\\/100{
  fill: rgb(48, 109, 138);
}
.fill-story-color-600\\/15{
  fill: rgba(48, 109, 138, 0.15);
}
.fill-story-color-600\\/20{
  fill: rgba(48, 109, 138, 0.2);
}
.fill-story-color-600\\/25{
  fill: rgba(48, 109, 138, 0.25);
}
.fill-story-color-600\\/30{
  fill: rgba(48, 109, 138, 0.3);
}
.fill-story-color-600\\/35{
  fill: rgba(48, 109, 138, 0.35);
}
.fill-story-color-600\\/40{
  fill: rgba(48, 109, 138, 0.4);
}
.fill-story-color-600\\/45{
  fill: rgba(48, 109, 138, 0.45);
}
.fill-story-color-600\\/5{
  fill: rgba(48, 109, 138, 0.05);
}
.fill-story-color-600\\/50{
  fill: rgba(48, 109, 138, 0.5);
}
.fill-story-color-600\\/55{
  fill: rgba(48, 109, 138, 0.55);
}
.fill-story-color-600\\/60{
  fill: rgba(48, 109, 138, 0.6);
}
.fill-story-color-600\\/65{
  fill: rgba(48, 109, 138, 0.65);
}
.fill-story-color-600\\/70{
  fill: rgba(48, 109, 138, 0.7);
}
.fill-story-color-600\\/75{
  fill: rgba(48, 109, 138, 0.75);
}
.fill-story-color-600\\/80{
  fill: rgba(48, 109, 138, 0.8);
}
.fill-story-color-600\\/85{
  fill: rgba(48, 109, 138, 0.85);
}
.fill-story-color-600\\/90{
  fill: rgba(48, 109, 138, 0.9);
}
.fill-story-color-600\\/95{
  fill: rgba(48, 109, 138, 0.95);
}
.fill-story-color-700{
  fill: #2d5b72;
}
.fill-story-color-700\\/0{
  fill: rgba(45, 91, 114, 0);
}
.fill-story-color-700\\/10{
  fill: rgba(45, 91, 114, 0.1);
}
.fill-story-color-700\\/100{
  fill: rgb(45, 91, 114);
}
.fill-story-color-700\\/15{
  fill: rgba(45, 91, 114, 0.15);
}
.fill-story-color-700\\/20{
  fill: rgba(45, 91, 114, 0.2);
}
.fill-story-color-700\\/25{
  fill: rgba(45, 91, 114, 0.25);
}
.fill-story-color-700\\/30{
  fill: rgba(45, 91, 114, 0.3);
}
.fill-story-color-700\\/35{
  fill: rgba(45, 91, 114, 0.35);
}
.fill-story-color-700\\/40{
  fill: rgba(45, 91, 114, 0.4);
}
.fill-story-color-700\\/45{
  fill: rgba(45, 91, 114, 0.45);
}
.fill-story-color-700\\/5{
  fill: rgba(45, 91, 114, 0.05);
}
.fill-story-color-700\\/50{
  fill: rgba(45, 91, 114, 0.5);
}
.fill-story-color-700\\/55{
  fill: rgba(45, 91, 114, 0.55);
}
.fill-story-color-700\\/60{
  fill: rgba(45, 91, 114, 0.6);
}
.fill-story-color-700\\/65{
  fill: rgba(45, 91, 114, 0.65);
}
.fill-story-color-700\\/70{
  fill: rgba(45, 91, 114, 0.7);
}
.fill-story-color-700\\/75{
  fill: rgba(45, 91, 114, 0.75);
}
.fill-story-color-700\\/80{
  fill: rgba(45, 91, 114, 0.8);
}
.fill-story-color-700\\/85{
  fill: rgba(45, 91, 114, 0.85);
}
.fill-story-color-700\\/90{
  fill: rgba(45, 91, 114, 0.9);
}
.fill-story-color-700\\/95{
  fill: rgba(45, 91, 114, 0.95);
}
.fill-story-color-800{
  fill: #2c4c5e;
}
.fill-story-color-800\\/0{
  fill: rgba(44, 76, 94, 0);
}
.fill-story-color-800\\/10{
  fill: rgba(44, 76, 94, 0.1);
}
.fill-story-color-800\\/100{
  fill: rgb(44, 76, 94);
}
.fill-story-color-800\\/15{
  fill: rgba(44, 76, 94, 0.15);
}
.fill-story-color-800\\/20{
  fill: rgba(44, 76, 94, 0.2);
}
.fill-story-color-800\\/25{
  fill: rgba(44, 76, 94, 0.25);
}
.fill-story-color-800\\/30{
  fill: rgba(44, 76, 94, 0.3);
}
.fill-story-color-800\\/35{
  fill: rgba(44, 76, 94, 0.35);
}
.fill-story-color-800\\/40{
  fill: rgba(44, 76, 94, 0.4);
}
.fill-story-color-800\\/45{
  fill: rgba(44, 76, 94, 0.45);
}
.fill-story-color-800\\/5{
  fill: rgba(44, 76, 94, 0.05);
}
.fill-story-color-800\\/50{
  fill: rgba(44, 76, 94, 0.5);
}
.fill-story-color-800\\/55{
  fill: rgba(44, 76, 94, 0.55);
}
.fill-story-color-800\\/60{
  fill: rgba(44, 76, 94, 0.6);
}
.fill-story-color-800\\/65{
  fill: rgba(44, 76, 94, 0.65);
}
.fill-story-color-800\\/70{
  fill: rgba(44, 76, 94, 0.7);
}
.fill-story-color-800\\/75{
  fill: rgba(44, 76, 94, 0.75);
}
.fill-story-color-800\\/80{
  fill: rgba(44, 76, 94, 0.8);
}
.fill-story-color-800\\/85{
  fill: rgba(44, 76, 94, 0.85);
}
.fill-story-color-800\\/90{
  fill: rgba(44, 76, 94, 0.9);
}
.fill-story-color-800\\/95{
  fill: rgba(44, 76, 94, 0.95);
}
.fill-story-color-900{
  fill: #284151;
}
.fill-story-color-900\\/0{
  fill: rgba(40, 65, 81, 0);
}
.fill-story-color-900\\/10{
  fill: rgba(40, 65, 81, 0.1);
}
.fill-story-color-900\\/100{
  fill: rgb(40, 65, 81);
}
.fill-story-color-900\\/15{
  fill: rgba(40, 65, 81, 0.15);
}
.fill-story-color-900\\/20{
  fill: rgba(40, 65, 81, 0.2);
}
.fill-story-color-900\\/25{
  fill: rgba(40, 65, 81, 0.25);
}
.fill-story-color-900\\/30{
  fill: rgba(40, 65, 81, 0.3);
}
.fill-story-color-900\\/35{
  fill: rgba(40, 65, 81, 0.35);
}
.fill-story-color-900\\/40{
  fill: rgba(40, 65, 81, 0.4);
}
.fill-story-color-900\\/45{
  fill: rgba(40, 65, 81, 0.45);
}
.fill-story-color-900\\/5{
  fill: rgba(40, 65, 81, 0.05);
}
.fill-story-color-900\\/50{
  fill: rgba(40, 65, 81, 0.5);
}
.fill-story-color-900\\/55{
  fill: rgba(40, 65, 81, 0.55);
}
.fill-story-color-900\\/60{
  fill: rgba(40, 65, 81, 0.6);
}
.fill-story-color-900\\/65{
  fill: rgba(40, 65, 81, 0.65);
}
.fill-story-color-900\\/70{
  fill: rgba(40, 65, 81, 0.7);
}
.fill-story-color-900\\/75{
  fill: rgba(40, 65, 81, 0.75);
}
.fill-story-color-900\\/80{
  fill: rgba(40, 65, 81, 0.8);
}
.fill-story-color-900\\/85{
  fill: rgba(40, 65, 81, 0.85);
}
.fill-story-color-900\\/90{
  fill: rgba(40, 65, 81, 0.9);
}
.fill-story-color-900\\/95{
  fill: rgba(40, 65, 81, 0.95);
}
.fill-story-color-950{
  fill: #162936;
}
.fill-story-color-950\\/0{
  fill: rgba(22, 41, 54, 0);
}
.fill-story-color-950\\/10{
  fill: rgba(22, 41, 54, 0.1);
}
.fill-story-color-950\\/100{
  fill: rgb(22, 41, 54);
}
.fill-story-color-950\\/15{
  fill: rgba(22, 41, 54, 0.15);
}
.fill-story-color-950\\/20{
  fill: rgba(22, 41, 54, 0.2);
}
.fill-story-color-950\\/25{
  fill: rgba(22, 41, 54, 0.25);
}
.fill-story-color-950\\/30{
  fill: rgba(22, 41, 54, 0.3);
}
.fill-story-color-950\\/35{
  fill: rgba(22, 41, 54, 0.35);
}
.fill-story-color-950\\/40{
  fill: rgba(22, 41, 54, 0.4);
}
.fill-story-color-950\\/45{
  fill: rgba(22, 41, 54, 0.45);
}
.fill-story-color-950\\/5{
  fill: rgba(22, 41, 54, 0.05);
}
.fill-story-color-950\\/50{
  fill: rgba(22, 41, 54, 0.5);
}
.fill-story-color-950\\/55{
  fill: rgba(22, 41, 54, 0.55);
}
.fill-story-color-950\\/60{
  fill: rgba(22, 41, 54, 0.6);
}
.fill-story-color-950\\/65{
  fill: rgba(22, 41, 54, 0.65);
}
.fill-story-color-950\\/70{
  fill: rgba(22, 41, 54, 0.7);
}
.fill-story-color-950\\/75{
  fill: rgba(22, 41, 54, 0.75);
}
.fill-story-color-950\\/80{
  fill: rgba(22, 41, 54, 0.8);
}
.fill-story-color-950\\/85{
  fill: rgba(22, 41, 54, 0.85);
}
.fill-story-color-950\\/90{
  fill: rgba(22, 41, 54, 0.9);
}
.fill-story-color-950\\/95{
  fill: rgba(22, 41, 54, 0.95);
}
.fill-white{
  fill: #fff;
}
.fill-word-color-100{
  fill: #d9f2e6;
}
.fill-word-color-100\\/0{
  fill: rgba(217, 242, 230, 0);
}
.fill-word-color-100\\/10{
  fill: rgba(217, 242, 230, 0.1);
}
.fill-word-color-100\\/100{
  fill: rgb(217, 242, 230);
}
.fill-word-color-100\\/15{
  fill: rgba(217, 242, 230, 0.15);
}
.fill-word-color-100\\/20{
  fill: rgba(217, 242, 230, 0.2);
}
.fill-word-color-100\\/25{
  fill: rgba(217, 242, 230, 0.25);
}
.fill-word-color-100\\/30{
  fill: rgba(217, 242, 230, 0.3);
}
.fill-word-color-100\\/35{
  fill: rgba(217, 242, 230, 0.35);
}
.fill-word-color-100\\/40{
  fill: rgba(217, 242, 230, 0.4);
}
.fill-word-color-100\\/45{
  fill: rgba(217, 242, 230, 0.45);
}
.fill-word-color-100\\/5{
  fill: rgba(217, 242, 230, 0.05);
}
.fill-word-color-100\\/50{
  fill: rgba(217, 242, 230, 0.5);
}
.fill-word-color-100\\/55{
  fill: rgba(217, 242, 230, 0.55);
}
.fill-word-color-100\\/60{
  fill: rgba(217, 242, 230, 0.6);
}
.fill-word-color-100\\/65{
  fill: rgba(217, 242, 230, 0.65);
}
.fill-word-color-100\\/70{
  fill: rgba(217, 242, 230, 0.7);
}
.fill-word-color-100\\/75{
  fill: rgba(217, 242, 230, 0.75);
}
.fill-word-color-100\\/80{
  fill: rgba(217, 242, 230, 0.8);
}
.fill-word-color-100\\/85{
  fill: rgba(217, 242, 230, 0.85);
}
.fill-word-color-100\\/90{
  fill: rgba(217, 242, 230, 0.9);
}
.fill-word-color-100\\/95{
  fill: rgba(217, 242, 230, 0.95);
}
.fill-word-color-200{
  fill: #b6e4d1;
}
.fill-word-color-200\\/0{
  fill: rgba(182, 228, 209, 0);
}
.fill-word-color-200\\/10{
  fill: rgba(182, 228, 209, 0.1);
}
.fill-word-color-200\\/100{
  fill: rgb(182, 228, 209);
}
.fill-word-color-200\\/15{
  fill: rgba(182, 228, 209, 0.15);
}
.fill-word-color-200\\/20{
  fill: rgba(182, 228, 209, 0.2);
}
.fill-word-color-200\\/25{
  fill: rgba(182, 228, 209, 0.25);
}
.fill-word-color-200\\/30{
  fill: rgba(182, 228, 209, 0.3);
}
.fill-word-color-200\\/35{
  fill: rgba(182, 228, 209, 0.35);
}
.fill-word-color-200\\/40{
  fill: rgba(182, 228, 209, 0.4);
}
.fill-word-color-200\\/45{
  fill: rgba(182, 228, 209, 0.45);
}
.fill-word-color-200\\/5{
  fill: rgba(182, 228, 209, 0.05);
}
.fill-word-color-200\\/50{
  fill: rgba(182, 228, 209, 0.5);
}
.fill-word-color-200\\/55{
  fill: rgba(182, 228, 209, 0.55);
}
.fill-word-color-200\\/60{
  fill: rgba(182, 228, 209, 0.6);
}
.fill-word-color-200\\/65{
  fill: rgba(182, 228, 209, 0.65);
}
.fill-word-color-200\\/70{
  fill: rgba(182, 228, 209, 0.7);
}
.fill-word-color-200\\/75{
  fill: rgba(182, 228, 209, 0.75);
}
.fill-word-color-200\\/80{
  fill: rgba(182, 228, 209, 0.8);
}
.fill-word-color-200\\/85{
  fill: rgba(182, 228, 209, 0.85);
}
.fill-word-color-200\\/90{
  fill: rgba(182, 228, 209, 0.9);
}
.fill-word-color-200\\/95{
  fill: rgba(182, 228, 209, 0.95);
}
.fill-word-color-300{
  fill: #86cfb5;
}
.fill-word-color-300\\/0{
  fill: rgba(134, 207, 181, 0);
}
.fill-word-color-300\\/10{
  fill: rgba(134, 207, 181, 0.1);
}
.fill-word-color-300\\/100{
  fill: rgb(134, 207, 181);
}
.fill-word-color-300\\/15{
  fill: rgba(134, 207, 181, 0.15);
}
.fill-word-color-300\\/20{
  fill: rgba(134, 207, 181, 0.2);
}
.fill-word-color-300\\/25{
  fill: rgba(134, 207, 181, 0.25);
}
.fill-word-color-300\\/30{
  fill: rgba(134, 207, 181, 0.3);
}
.fill-word-color-300\\/35{
  fill: rgba(134, 207, 181, 0.35);
}
.fill-word-color-300\\/40{
  fill: rgba(134, 207, 181, 0.4);
}
.fill-word-color-300\\/45{
  fill: rgba(134, 207, 181, 0.45);
}
.fill-word-color-300\\/5{
  fill: rgba(134, 207, 181, 0.05);
}
.fill-word-color-300\\/50{
  fill: rgba(134, 207, 181, 0.5);
}
.fill-word-color-300\\/55{
  fill: rgba(134, 207, 181, 0.55);
}
.fill-word-color-300\\/60{
  fill: rgba(134, 207, 181, 0.6);
}
.fill-word-color-300\\/65{
  fill: rgba(134, 207, 181, 0.65);
}
.fill-word-color-300\\/70{
  fill: rgba(134, 207, 181, 0.7);
}
.fill-word-color-300\\/75{
  fill: rgba(134, 207, 181, 0.75);
}
.fill-word-color-300\\/80{
  fill: rgba(134, 207, 181, 0.8);
}
.fill-word-color-300\\/85{
  fill: rgba(134, 207, 181, 0.85);
}
.fill-word-color-300\\/90{
  fill: rgba(134, 207, 181, 0.9);
}
.fill-word-color-300\\/95{
  fill: rgba(134, 207, 181, 0.95);
}
.fill-word-color-400{
  fill: #53b494;
}
.fill-word-color-400\\/0{
  fill: rgba(83, 180, 148, 0);
}
.fill-word-color-400\\/10{
  fill: rgba(83, 180, 148, 0.1);
}
.fill-word-color-400\\/100{
  fill: rgb(83, 180, 148);
}
.fill-word-color-400\\/15{
  fill: rgba(83, 180, 148, 0.15);
}
.fill-word-color-400\\/20{
  fill: rgba(83, 180, 148, 0.2);
}
.fill-word-color-400\\/25{
  fill: rgba(83, 180, 148, 0.25);
}
.fill-word-color-400\\/30{
  fill: rgba(83, 180, 148, 0.3);
}
.fill-word-color-400\\/35{
  fill: rgba(83, 180, 148, 0.35);
}
.fill-word-color-400\\/40{
  fill: rgba(83, 180, 148, 0.4);
}
.fill-word-color-400\\/45{
  fill: rgba(83, 180, 148, 0.45);
}
.fill-word-color-400\\/5{
  fill: rgba(83, 180, 148, 0.05);
}
.fill-word-color-400\\/50{
  fill: rgba(83, 180, 148, 0.5);
}
.fill-word-color-400\\/55{
  fill: rgba(83, 180, 148, 0.55);
}
.fill-word-color-400\\/60{
  fill: rgba(83, 180, 148, 0.6);
}
.fill-word-color-400\\/65{
  fill: rgba(83, 180, 148, 0.65);
}
.fill-word-color-400\\/70{
  fill: rgba(83, 180, 148, 0.7);
}
.fill-word-color-400\\/75{
  fill: rgba(83, 180, 148, 0.75);
}
.fill-word-color-400\\/80{
  fill: rgba(83, 180, 148, 0.8);
}
.fill-word-color-400\\/85{
  fill: rgba(83, 180, 148, 0.85);
}
.fill-word-color-400\\/90{
  fill: rgba(83, 180, 148, 0.9);
}
.fill-word-color-400\\/95{
  fill: rgba(83, 180, 148, 0.95);
}
.fill-word-color-500{
  fill: #2c876d;
}
.fill-word-color-500\\/0{
  fill: rgba(44, 135, 109, 0);
}
.fill-word-color-500\\/10{
  fill: rgba(44, 135, 109, 0.1);
}
.fill-word-color-500\\/100{
  fill: rgb(44, 135, 109);
}
.fill-word-color-500\\/15{
  fill: rgba(44, 135, 109, 0.15);
}
.fill-word-color-500\\/20{
  fill: rgba(44, 135, 109, 0.2);
}
.fill-word-color-500\\/25{
  fill: rgba(44, 135, 109, 0.25);
}
.fill-word-color-500\\/30{
  fill: rgba(44, 135, 109, 0.3);
}
.fill-word-color-500\\/35{
  fill: rgba(44, 135, 109, 0.35);
}
.fill-word-color-500\\/40{
  fill: rgba(44, 135, 109, 0.4);
}
.fill-word-color-500\\/45{
  fill: rgba(44, 135, 109, 0.45);
}
.fill-word-color-500\\/5{
  fill: rgba(44, 135, 109, 0.05);
}
.fill-word-color-500\\/50{
  fill: rgba(44, 135, 109, 0.5);
}
.fill-word-color-500\\/55{
  fill: rgba(44, 135, 109, 0.55);
}
.fill-word-color-500\\/60{
  fill: rgba(44, 135, 109, 0.6);
}
.fill-word-color-500\\/65{
  fill: rgba(44, 135, 109, 0.65);
}
.fill-word-color-500\\/70{
  fill: rgba(44, 135, 109, 0.7);
}
.fill-word-color-500\\/75{
  fill: rgba(44, 135, 109, 0.75);
}
.fill-word-color-500\\/80{
  fill: rgba(44, 135, 109, 0.8);
}
.fill-word-color-500\\/85{
  fill: rgba(44, 135, 109, 0.85);
}
.fill-word-color-500\\/90{
  fill: rgba(44, 135, 109, 0.9);
}
.fill-word-color-500\\/95{
  fill: rgba(44, 135, 109, 0.95);
}
.fill-word-color-600{
  fill: #227962;
}
.fill-word-color-600\\/0{
  fill: rgba(34, 121, 98, 0);
}
.fill-word-color-600\\/10{
  fill: rgba(34, 121, 98, 0.1);
}
.fill-word-color-600\\/100{
  fill: rgb(34, 121, 98);
}
.fill-word-color-600\\/15{
  fill: rgba(34, 121, 98, 0.15);
}
.fill-word-color-600\\/20{
  fill: rgba(34, 121, 98, 0.2);
}
.fill-word-color-600\\/25{
  fill: rgba(34, 121, 98, 0.25);
}
.fill-word-color-600\\/30{
  fill: rgba(34, 121, 98, 0.3);
}
.fill-word-color-600\\/35{
  fill: rgba(34, 121, 98, 0.35);
}
.fill-word-color-600\\/40{
  fill: rgba(34, 121, 98, 0.4);
}
.fill-word-color-600\\/45{
  fill: rgba(34, 121, 98, 0.45);
}
.fill-word-color-600\\/5{
  fill: rgba(34, 121, 98, 0.05);
}
.fill-word-color-600\\/50{
  fill: rgba(34, 121, 98, 0.5);
}
.fill-word-color-600\\/55{
  fill: rgba(34, 121, 98, 0.55);
}
.fill-word-color-600\\/60{
  fill: rgba(34, 121, 98, 0.6);
}
.fill-word-color-600\\/65{
  fill: rgba(34, 121, 98, 0.65);
}
.fill-word-color-600\\/70{
  fill: rgba(34, 121, 98, 0.7);
}
.fill-word-color-600\\/75{
  fill: rgba(34, 121, 98, 0.75);
}
.fill-word-color-600\\/80{
  fill: rgba(34, 121, 98, 0.8);
}
.fill-word-color-600\\/85{
  fill: rgba(34, 121, 98, 0.85);
}
.fill-word-color-600\\/90{
  fill: rgba(34, 121, 98, 0.9);
}
.fill-word-color-600\\/95{
  fill: rgba(34, 121, 98, 0.95);
}
.fill-word-color-700{
  fill: #1b6150;
}
.fill-word-color-700\\/0{
  fill: rgba(27, 97, 80, 0);
}
.fill-word-color-700\\/10{
  fill: rgba(27, 97, 80, 0.1);
}
.fill-word-color-700\\/100{
  fill: rgb(27, 97, 80);
}
.fill-word-color-700\\/15{
  fill: rgba(27, 97, 80, 0.15);
}
.fill-word-color-700\\/20{
  fill: rgba(27, 97, 80, 0.2);
}
.fill-word-color-700\\/25{
  fill: rgba(27, 97, 80, 0.25);
}
.fill-word-color-700\\/30{
  fill: rgba(27, 97, 80, 0.3);
}
.fill-word-color-700\\/35{
  fill: rgba(27, 97, 80, 0.35);
}
.fill-word-color-700\\/40{
  fill: rgba(27, 97, 80, 0.4);
}
.fill-word-color-700\\/45{
  fill: rgba(27, 97, 80, 0.45);
}
.fill-word-color-700\\/5{
  fill: rgba(27, 97, 80, 0.05);
}
.fill-word-color-700\\/50{
  fill: rgba(27, 97, 80, 0.5);
}
.fill-word-color-700\\/55{
  fill: rgba(27, 97, 80, 0.55);
}
.fill-word-color-700\\/60{
  fill: rgba(27, 97, 80, 0.6);
}
.fill-word-color-700\\/65{
  fill: rgba(27, 97, 80, 0.65);
}
.fill-word-color-700\\/70{
  fill: rgba(27, 97, 80, 0.7);
}
.fill-word-color-700\\/75{
  fill: rgba(27, 97, 80, 0.75);
}
.fill-word-color-700\\/80{
  fill: rgba(27, 97, 80, 0.8);
}
.fill-word-color-700\\/85{
  fill: rgba(27, 97, 80, 0.85);
}
.fill-word-color-700\\/90{
  fill: rgba(27, 97, 80, 0.9);
}
.fill-word-color-700\\/95{
  fill: rgba(27, 97, 80, 0.95);
}
.fill-word-color-800{
  fill: #184d40;
}
.fill-word-color-800\\/0{
  fill: rgba(24, 77, 64, 0);
}
.fill-word-color-800\\/10{
  fill: rgba(24, 77, 64, 0.1);
}
.fill-word-color-800\\/100{
  fill: rgb(24, 77, 64);
}
.fill-word-color-800\\/15{
  fill: rgba(24, 77, 64, 0.15);
}
.fill-word-color-800\\/20{
  fill: rgba(24, 77, 64, 0.2);
}
.fill-word-color-800\\/25{
  fill: rgba(24, 77, 64, 0.25);
}
.fill-word-color-800\\/30{
  fill: rgba(24, 77, 64, 0.3);
}
.fill-word-color-800\\/35{
  fill: rgba(24, 77, 64, 0.35);
}
.fill-word-color-800\\/40{
  fill: rgba(24, 77, 64, 0.4);
}
.fill-word-color-800\\/45{
  fill: rgba(24, 77, 64, 0.45);
}
.fill-word-color-800\\/5{
  fill: rgba(24, 77, 64, 0.05);
}
.fill-word-color-800\\/50{
  fill: rgba(24, 77, 64, 0.5);
}
.fill-word-color-800\\/55{
  fill: rgba(24, 77, 64, 0.55);
}
.fill-word-color-800\\/60{
  fill: rgba(24, 77, 64, 0.6);
}
.fill-word-color-800\\/65{
  fill: rgba(24, 77, 64, 0.65);
}
.fill-word-color-800\\/70{
  fill: rgba(24, 77, 64, 0.7);
}
.fill-word-color-800\\/75{
  fill: rgba(24, 77, 64, 0.75);
}
.fill-word-color-800\\/80{
  fill: rgba(24, 77, 64, 0.8);
}
.fill-word-color-800\\/85{
  fill: rgba(24, 77, 64, 0.85);
}
.fill-word-color-800\\/90{
  fill: rgba(24, 77, 64, 0.9);
}
.fill-word-color-800\\/95{
  fill: rgba(24, 77, 64, 0.95);
}
.fill-word-color-900{
  fill: #144036;
}
.fill-word-color-900\\/0{
  fill: rgba(20, 64, 54, 0);
}
.fill-word-color-900\\/10{
  fill: rgba(20, 64, 54, 0.1);
}
.fill-word-color-900\\/100{
  fill: rgb(20, 64, 54);
}
.fill-word-color-900\\/15{
  fill: rgba(20, 64, 54, 0.15);
}
.fill-word-color-900\\/20{
  fill: rgba(20, 64, 54, 0.2);
}
.fill-word-color-900\\/25{
  fill: rgba(20, 64, 54, 0.25);
}
.fill-word-color-900\\/30{
  fill: rgba(20, 64, 54, 0.3);
}
.fill-word-color-900\\/35{
  fill: rgba(20, 64, 54, 0.35);
}
.fill-word-color-900\\/40{
  fill: rgba(20, 64, 54, 0.4);
}
.fill-word-color-900\\/45{
  fill: rgba(20, 64, 54, 0.45);
}
.fill-word-color-900\\/5{
  fill: rgba(20, 64, 54, 0.05);
}
.fill-word-color-900\\/50{
  fill: rgba(20, 64, 54, 0.5);
}
.fill-word-color-900\\/55{
  fill: rgba(20, 64, 54, 0.55);
}
.fill-word-color-900\\/60{
  fill: rgba(20, 64, 54, 0.6);
}
.fill-word-color-900\\/65{
  fill: rgba(20, 64, 54, 0.65);
}
.fill-word-color-900\\/70{
  fill: rgba(20, 64, 54, 0.7);
}
.fill-word-color-900\\/75{
  fill: rgba(20, 64, 54, 0.75);
}
.fill-word-color-900\\/80{
  fill: rgba(20, 64, 54, 0.8);
}
.fill-word-color-900\\/85{
  fill: rgba(20, 64, 54, 0.85);
}
.fill-word-color-900\\/90{
  fill: rgba(20, 64, 54, 0.9);
}
.fill-word-color-900\\/95{
  fill: rgba(20, 64, 54, 0.95);
}
.fill-word-color-950{
  fill: #0a241f;
}
.fill-word-color-950\\/0{
  fill: rgba(10, 36, 31, 0);
}
.fill-word-color-950\\/10{
  fill: rgba(10, 36, 31, 0.1);
}
.fill-word-color-950\\/100{
  fill: rgb(10, 36, 31);
}
.fill-word-color-950\\/15{
  fill: rgba(10, 36, 31, 0.15);
}
.fill-word-color-950\\/20{
  fill: rgba(10, 36, 31, 0.2);
}
.fill-word-color-950\\/25{
  fill: rgba(10, 36, 31, 0.25);
}
.fill-word-color-950\\/30{
  fill: rgba(10, 36, 31, 0.3);
}
.fill-word-color-950\\/35{
  fill: rgba(10, 36, 31, 0.35);
}
.fill-word-color-950\\/40{
  fill: rgba(10, 36, 31, 0.4);
}
.fill-word-color-950\\/45{
  fill: rgba(10, 36, 31, 0.45);
}
.fill-word-color-950\\/5{
  fill: rgba(10, 36, 31, 0.05);
}
.fill-word-color-950\\/50{
  fill: rgba(10, 36, 31, 0.5);
}
.fill-word-color-950\\/55{
  fill: rgba(10, 36, 31, 0.55);
}
.fill-word-color-950\\/60{
  fill: rgba(10, 36, 31, 0.6);
}
.fill-word-color-950\\/65{
  fill: rgba(10, 36, 31, 0.65);
}
.fill-word-color-950\\/70{
  fill: rgba(10, 36, 31, 0.7);
}
.fill-word-color-950\\/75{
  fill: rgba(10, 36, 31, 0.75);
}
.fill-word-color-950\\/80{
  fill: rgba(10, 36, 31, 0.8);
}
.fill-word-color-950\\/85{
  fill: rgba(10, 36, 31, 0.85);
}
.fill-word-color-950\\/90{
  fill: rgba(10, 36, 31, 0.9);
}
.fill-word-color-950\\/95{
  fill: rgba(10, 36, 31, 0.95);
}
.stroke-2{
  stroke-width: 2;
}
.object-contain{
  -o-object-fit: contain;
     object-fit: contain;
}
.object-cover{
  -o-object-fit: cover;
     object-fit: cover;
}
.object-center{
  -o-object-position: center;
     object-position: center;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-16{
  padding: 4rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-16{
  padding-left: 4rem;
  padding-right: 4rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-20{
  padding-left: 5rem;
  padding-right: 5rem;
}
.px-28{
  padding-left: 7rem;
  padding-right: 7rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-16{
  padding-bottom: 4rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-20{
  padding-bottom: 5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pb-videoAspect{
  padding-bottom: 56.25%;
}
.pl-0{
  padding-left: 0px;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-14{
  padding-left: 3.5rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-64{
  padding-left: 16rem;
}
.pl-8{
  padding-left: 2rem;
}
.pr-0{
  padding-right: 0px;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-\\[2\\.5rem\\]{
  padding-right: 2.5rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-16{
  padding-top: 4rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-32{
  padding-top: 8rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-middle{
  vertical-align: middle;
}
.align-bottom{
  vertical-align: bottom;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.font-thin{
  font-weight: 100;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.leading-10{
  line-height: 2.5rem;
}
.leading-4{
  line-height: 1rem;
}
.leading-5{
  line-height: 1.25rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-7{
  line-height: 1.75rem;
}
.leading-8{
  line-height: 2rem;
}
.leading-loose{
  line-height: 2;
}
.leading-none{
  line-height: 1;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.text-black{
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--tw-text-opacity, 1));
}
.text-blue-300{
  --tw-text-opacity: 1;
  color: rgba(147, 197, 253, 1);
  color: rgba(147, 197, 253, var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgba(29, 78, 216, 1);
  color: rgba(29, 78, 216, var(--tw-text-opacity, 1));
}
.text-blue-900{
  --tw-text-opacity: 1;
  color: rgba(30, 58, 138, 1);
  color: rgba(30, 58, 138, var(--tw-text-opacity, 1));
}
.text-blumine-100{
  --tw-text-opacity: 1;
  color: rgba(218, 238, 243, 1);
  color: rgba(218, 238, 243, var(--tw-text-opacity, 1));
}
.text-blumine-100\\/0{
  color: rgba(218, 238, 243, 0);
}
.text-blumine-100\\/10{
  color: rgba(218, 238, 243, 0.1);
}
.text-blumine-100\\/100{
  color: rgb(218, 238, 243);
}
.text-blumine-100\\/15{
  color: rgba(218, 238, 243, 0.15);
}
.text-blumine-100\\/20{
  color: rgba(218, 238, 243, 0.2);
}
.text-blumine-100\\/25{
  color: rgba(218, 238, 243, 0.25);
}
.text-blumine-100\\/30{
  color: rgba(218, 238, 243, 0.3);
}
.text-blumine-100\\/35{
  color: rgba(218, 238, 243, 0.35);
}
.text-blumine-100\\/40{
  color: rgba(218, 238, 243, 0.4);
}
.text-blumine-100\\/45{
  color: rgba(218, 238, 243, 0.45);
}
.text-blumine-100\\/5{
  color: rgba(218, 238, 243, 0.05);
}
.text-blumine-100\\/50{
  color: rgba(218, 238, 243, 0.5);
}
.text-blumine-100\\/55{
  color: rgba(218, 238, 243, 0.55);
}
.text-blumine-100\\/60{
  color: rgba(218, 238, 243, 0.6);
}
.text-blumine-100\\/65{
  color: rgba(218, 238, 243, 0.65);
}
.text-blumine-100\\/70{
  color: rgba(218, 238, 243, 0.7);
}
.text-blumine-100\\/75{
  color: rgba(218, 238, 243, 0.75);
}
.text-blumine-100\\/80{
  color: rgba(218, 238, 243, 0.8);
}
.text-blumine-100\\/85{
  color: rgba(218, 238, 243, 0.85);
}
.text-blumine-100\\/90{
  color: rgba(218, 238, 243, 0.9);
}
.text-blumine-100\\/95{
  color: rgba(218, 238, 243, 0.95);
}
.text-blumine-200{
  --tw-text-opacity: 1;
  color: rgba(186, 222, 231, 1);
  color: rgba(186, 222, 231, var(--tw-text-opacity, 1));
}
.text-blumine-200\\/0{
  color: rgba(186, 222, 231, 0);
}
.text-blumine-200\\/10{
  color: rgba(186, 222, 231, 0.1);
}
.text-blumine-200\\/100{
  color: rgb(186, 222, 231);
}
.text-blumine-200\\/15{
  color: rgba(186, 222, 231, 0.15);
}
.text-blumine-200\\/20{
  color: rgba(186, 222, 231, 0.2);
}
.text-blumine-200\\/25{
  color: rgba(186, 222, 231, 0.25);
}
.text-blumine-200\\/30{
  color: rgba(186, 222, 231, 0.3);
}
.text-blumine-200\\/35{
  color: rgba(186, 222, 231, 0.35);
}
.text-blumine-200\\/40{
  color: rgba(186, 222, 231, 0.4);
}
.text-blumine-200\\/45{
  color: rgba(186, 222, 231, 0.45);
}
.text-blumine-200\\/5{
  color: rgba(186, 222, 231, 0.05);
}
.text-blumine-200\\/50{
  color: rgba(186, 222, 231, 0.5);
}
.text-blumine-200\\/55{
  color: rgba(186, 222, 231, 0.55);
}
.text-blumine-200\\/60{
  color: rgba(186, 222, 231, 0.6);
}
.text-blumine-200\\/65{
  color: rgba(186, 222, 231, 0.65);
}
.text-blumine-200\\/70{
  color: rgba(186, 222, 231, 0.7);
}
.text-blumine-200\\/75{
  color: rgba(186, 222, 231, 0.75);
}
.text-blumine-200\\/80{
  color: rgba(186, 222, 231, 0.8);
}
.text-blumine-200\\/85{
  color: rgba(186, 222, 231, 0.85);
}
.text-blumine-200\\/90{
  color: rgba(186, 222, 231, 0.9);
}
.text-blumine-200\\/95{
  color: rgba(186, 222, 231, 0.95);
}
.text-blumine-300{
  --tw-text-opacity: 1;
  color: rgba(137, 197, 215, 1);
  color: rgba(137, 197, 215, var(--tw-text-opacity, 1));
}
.text-blumine-300\\/0{
  color: rgba(137, 197, 215, 0);
}
.text-blumine-300\\/10{
  color: rgba(137, 197, 215, 0.1);
}
.text-blumine-300\\/100{
  color: rgb(137, 197, 215);
}
.text-blumine-300\\/15{
  color: rgba(137, 197, 215, 0.15);
}
.text-blumine-300\\/20{
  color: rgba(137, 197, 215, 0.2);
}
.text-blumine-300\\/25{
  color: rgba(137, 197, 215, 0.25);
}
.text-blumine-300\\/30{
  color: rgba(137, 197, 215, 0.3);
}
.text-blumine-300\\/35{
  color: rgba(137, 197, 215, 0.35);
}
.text-blumine-300\\/40{
  color: rgba(137, 197, 215, 0.4);
}
.text-blumine-300\\/45{
  color: rgba(137, 197, 215, 0.45);
}
.text-blumine-300\\/5{
  color: rgba(137, 197, 215, 0.05);
}
.text-blumine-300\\/50{
  color: rgba(137, 197, 215, 0.5);
}
.text-blumine-300\\/55{
  color: rgba(137, 197, 215, 0.55);
}
.text-blumine-300\\/60{
  color: rgba(137, 197, 215, 0.6);
}
.text-blumine-300\\/65{
  color: rgba(137, 197, 215, 0.65);
}
.text-blumine-300\\/70{
  color: rgba(137, 197, 215, 0.7);
}
.text-blumine-300\\/75{
  color: rgba(137, 197, 215, 0.75);
}
.text-blumine-300\\/80{
  color: rgba(137, 197, 215, 0.8);
}
.text-blumine-300\\/85{
  color: rgba(137, 197, 215, 0.85);
}
.text-blumine-300\\/90{
  color: rgba(137, 197, 215, 0.9);
}
.text-blumine-300\\/95{
  color: rgba(137, 197, 215, 0.95);
}
.text-blumine-400{
  --tw-text-opacity: 1;
  color: rgba(82, 163, 190, 1);
  color: rgba(82, 163, 190, var(--tw-text-opacity, 1));
}
.text-blumine-400\\/0{
  color: rgba(82, 163, 190, 0);
}
.text-blumine-400\\/10{
  color: rgba(82, 163, 190, 0.1);
}
.text-blumine-400\\/100{
  color: rgb(82, 163, 190);
}
.text-blumine-400\\/15{
  color: rgba(82, 163, 190, 0.15);
}
.text-blumine-400\\/20{
  color: rgba(82, 163, 190, 0.2);
}
.text-blumine-400\\/25{
  color: rgba(82, 163, 190, 0.25);
}
.text-blumine-400\\/30{
  color: rgba(82, 163, 190, 0.3);
}
.text-blumine-400\\/35{
  color: rgba(82, 163, 190, 0.35);
}
.text-blumine-400\\/40{
  color: rgba(82, 163, 190, 0.4);
}
.text-blumine-400\\/45{
  color: rgba(82, 163, 190, 0.45);
}
.text-blumine-400\\/5{
  color: rgba(82, 163, 190, 0.05);
}
.text-blumine-400\\/50{
  color: rgba(82, 163, 190, 0.5);
}
.text-blumine-400\\/55{
  color: rgba(82, 163, 190, 0.55);
}
.text-blumine-400\\/60{
  color: rgba(82, 163, 190, 0.6);
}
.text-blumine-400\\/65{
  color: rgba(82, 163, 190, 0.65);
}
.text-blumine-400\\/70{
  color: rgba(82, 163, 190, 0.7);
}
.text-blumine-400\\/75{
  color: rgba(82, 163, 190, 0.75);
}
.text-blumine-400\\/80{
  color: rgba(82, 163, 190, 0.8);
}
.text-blumine-400\\/85{
  color: rgba(82, 163, 190, 0.85);
}
.text-blumine-400\\/90{
  color: rgba(82, 163, 190, 0.9);
}
.text-blumine-400\\/95{
  color: rgba(82, 163, 190, 0.95);
}
.text-blumine-500{
  --tw-text-opacity: 1;
  color: rgba(55, 135, 163, 1);
  color: rgba(55, 135, 163, var(--tw-text-opacity, 1));
}
.text-blumine-500\\/0{
  color: rgba(55, 135, 163, 0);
}
.text-blumine-500\\/10{
  color: rgba(55, 135, 163, 0.1);
}
.text-blumine-500\\/100{
  color: rgb(55, 135, 163);
}
.text-blumine-500\\/15{
  color: rgba(55, 135, 163, 0.15);
}
.text-blumine-500\\/20{
  color: rgba(55, 135, 163, 0.2);
}
.text-blumine-500\\/25{
  color: rgba(55, 135, 163, 0.25);
}
.text-blumine-500\\/30{
  color: rgba(55, 135, 163, 0.3);
}
.text-blumine-500\\/35{
  color: rgba(55, 135, 163, 0.35);
}
.text-blumine-500\\/40{
  color: rgba(55, 135, 163, 0.4);
}
.text-blumine-500\\/45{
  color: rgba(55, 135, 163, 0.45);
}
.text-blumine-500\\/5{
  color: rgba(55, 135, 163, 0.05);
}
.text-blumine-500\\/50{
  color: rgba(55, 135, 163, 0.5);
}
.text-blumine-500\\/55{
  color: rgba(55, 135, 163, 0.55);
}
.text-blumine-500\\/60{
  color: rgba(55, 135, 163, 0.6);
}
.text-blumine-500\\/65{
  color: rgba(55, 135, 163, 0.65);
}
.text-blumine-500\\/70{
  color: rgba(55, 135, 163, 0.7);
}
.text-blumine-500\\/75{
  color: rgba(55, 135, 163, 0.75);
}
.text-blumine-500\\/80{
  color: rgba(55, 135, 163, 0.8);
}
.text-blumine-500\\/85{
  color: rgba(55, 135, 163, 0.85);
}
.text-blumine-500\\/90{
  color: rgba(55, 135, 163, 0.9);
}
.text-blumine-500\\/95{
  color: rgba(55, 135, 163, 0.95);
}
.text-blumine-600{
  --tw-text-opacity: 1;
  color: rgba(48, 109, 138, 1);
  color: rgba(48, 109, 138, var(--tw-text-opacity, 1));
}
.text-blumine-600\\/0{
  color: rgba(48, 109, 138, 0);
}
.text-blumine-600\\/10{
  color: rgba(48, 109, 138, 0.1);
}
.text-blumine-600\\/100{
  color: rgb(48, 109, 138);
}
.text-blumine-600\\/15{
  color: rgba(48, 109, 138, 0.15);
}
.text-blumine-600\\/20{
  color: rgba(48, 109, 138, 0.2);
}
.text-blumine-600\\/25{
  color: rgba(48, 109, 138, 0.25);
}
.text-blumine-600\\/30{
  color: rgba(48, 109, 138, 0.3);
}
.text-blumine-600\\/35{
  color: rgba(48, 109, 138, 0.35);
}
.text-blumine-600\\/40{
  color: rgba(48, 109, 138, 0.4);
}
.text-blumine-600\\/45{
  color: rgba(48, 109, 138, 0.45);
}
.text-blumine-600\\/5{
  color: rgba(48, 109, 138, 0.05);
}
.text-blumine-600\\/50{
  color: rgba(48, 109, 138, 0.5);
}
.text-blumine-600\\/55{
  color: rgba(48, 109, 138, 0.55);
}
.text-blumine-600\\/60{
  color: rgba(48, 109, 138, 0.6);
}
.text-blumine-600\\/65{
  color: rgba(48, 109, 138, 0.65);
}
.text-blumine-600\\/70{
  color: rgba(48, 109, 138, 0.7);
}
.text-blumine-600\\/75{
  color: rgba(48, 109, 138, 0.75);
}
.text-blumine-600\\/80{
  color: rgba(48, 109, 138, 0.8);
}
.text-blumine-600\\/85{
  color: rgba(48, 109, 138, 0.85);
}
.text-blumine-600\\/90{
  color: rgba(48, 109, 138, 0.9);
}
.text-blumine-600\\/95{
  color: rgba(48, 109, 138, 0.95);
}
.text-blumine-700{
  --tw-text-opacity: 1;
  color: rgba(45, 91, 114, 1);
  color: rgba(45, 91, 114, var(--tw-text-opacity, 1));
}
.text-blumine-700\\/0{
  color: rgba(45, 91, 114, 0);
}
.text-blumine-700\\/10{
  color: rgba(45, 91, 114, 0.1);
}
.text-blumine-700\\/100{
  color: rgb(45, 91, 114);
}
.text-blumine-700\\/15{
  color: rgba(45, 91, 114, 0.15);
}
.text-blumine-700\\/20{
  color: rgba(45, 91, 114, 0.2);
}
.text-blumine-700\\/25{
  color: rgba(45, 91, 114, 0.25);
}
.text-blumine-700\\/30{
  color: rgba(45, 91, 114, 0.3);
}
.text-blumine-700\\/35{
  color: rgba(45, 91, 114, 0.35);
}
.text-blumine-700\\/40{
  color: rgba(45, 91, 114, 0.4);
}
.text-blumine-700\\/45{
  color: rgba(45, 91, 114, 0.45);
}
.text-blumine-700\\/5{
  color: rgba(45, 91, 114, 0.05);
}
.text-blumine-700\\/50{
  color: rgba(45, 91, 114, 0.5);
}
.text-blumine-700\\/55{
  color: rgba(45, 91, 114, 0.55);
}
.text-blumine-700\\/60{
  color: rgba(45, 91, 114, 0.6);
}
.text-blumine-700\\/65{
  color: rgba(45, 91, 114, 0.65);
}
.text-blumine-700\\/70{
  color: rgba(45, 91, 114, 0.7);
}
.text-blumine-700\\/75{
  color: rgba(45, 91, 114, 0.75);
}
.text-blumine-700\\/80{
  color: rgba(45, 91, 114, 0.8);
}
.text-blumine-700\\/85{
  color: rgba(45, 91, 114, 0.85);
}
.text-blumine-700\\/90{
  color: rgba(45, 91, 114, 0.9);
}
.text-blumine-700\\/95{
  color: rgba(45, 91, 114, 0.95);
}
.text-blumine-800{
  --tw-text-opacity: 1;
  color: rgba(44, 76, 94, 1);
  color: rgba(44, 76, 94, var(--tw-text-opacity, 1));
}
.text-blumine-800\\/0{
  color: rgba(44, 76, 94, 0);
}
.text-blumine-800\\/10{
  color: rgba(44, 76, 94, 0.1);
}
.text-blumine-800\\/100{
  color: rgb(44, 76, 94);
}
.text-blumine-800\\/15{
  color: rgba(44, 76, 94, 0.15);
}
.text-blumine-800\\/20{
  color: rgba(44, 76, 94, 0.2);
}
.text-blumine-800\\/25{
  color: rgba(44, 76, 94, 0.25);
}
.text-blumine-800\\/30{
  color: rgba(44, 76, 94, 0.3);
}
.text-blumine-800\\/35{
  color: rgba(44, 76, 94, 0.35);
}
.text-blumine-800\\/40{
  color: rgba(44, 76, 94, 0.4);
}
.text-blumine-800\\/45{
  color: rgba(44, 76, 94, 0.45);
}
.text-blumine-800\\/5{
  color: rgba(44, 76, 94, 0.05);
}
.text-blumine-800\\/50{
  color: rgba(44, 76, 94, 0.5);
}
.text-blumine-800\\/55{
  color: rgba(44, 76, 94, 0.55);
}
.text-blumine-800\\/60{
  color: rgba(44, 76, 94, 0.6);
}
.text-blumine-800\\/65{
  color: rgba(44, 76, 94, 0.65);
}
.text-blumine-800\\/70{
  color: rgba(44, 76, 94, 0.7);
}
.text-blumine-800\\/75{
  color: rgba(44, 76, 94, 0.75);
}
.text-blumine-800\\/80{
  color: rgba(44, 76, 94, 0.8);
}
.text-blumine-800\\/85{
  color: rgba(44, 76, 94, 0.85);
}
.text-blumine-800\\/90{
  color: rgba(44, 76, 94, 0.9);
}
.text-blumine-800\\/95{
  color: rgba(44, 76, 94, 0.95);
}
.text-blumine-900{
  --tw-text-opacity: 1;
  color: rgba(40, 65, 81, 1);
  color: rgba(40, 65, 81, var(--tw-text-opacity, 1));
}
.text-blumine-900\\/0{
  color: rgba(40, 65, 81, 0);
}
.text-blumine-900\\/10{
  color: rgba(40, 65, 81, 0.1);
}
.text-blumine-900\\/100{
  color: rgb(40, 65, 81);
}
.text-blumine-900\\/15{
  color: rgba(40, 65, 81, 0.15);
}
.text-blumine-900\\/20{
  color: rgba(40, 65, 81, 0.2);
}
.text-blumine-900\\/25{
  color: rgba(40, 65, 81, 0.25);
}
.text-blumine-900\\/30{
  color: rgba(40, 65, 81, 0.3);
}
.text-blumine-900\\/35{
  color: rgba(40, 65, 81, 0.35);
}
.text-blumine-900\\/40{
  color: rgba(40, 65, 81, 0.4);
}
.text-blumine-900\\/45{
  color: rgba(40, 65, 81, 0.45);
}
.text-blumine-900\\/5{
  color: rgba(40, 65, 81, 0.05);
}
.text-blumine-900\\/50{
  color: rgba(40, 65, 81, 0.5);
}
.text-blumine-900\\/55{
  color: rgba(40, 65, 81, 0.55);
}
.text-blumine-900\\/60{
  color: rgba(40, 65, 81, 0.6);
}
.text-blumine-900\\/65{
  color: rgba(40, 65, 81, 0.65);
}
.text-blumine-900\\/70{
  color: rgba(40, 65, 81, 0.7);
}
.text-blumine-900\\/75{
  color: rgba(40, 65, 81, 0.75);
}
.text-blumine-900\\/80{
  color: rgba(40, 65, 81, 0.8);
}
.text-blumine-900\\/85{
  color: rgba(40, 65, 81, 0.85);
}
.text-blumine-900\\/90{
  color: rgba(40, 65, 81, 0.9);
}
.text-blumine-900\\/95{
  color: rgba(40, 65, 81, 0.95);
}
.text-blumine-950{
  --tw-text-opacity: 1;
  color: rgba(22, 41, 54, 1);
  color: rgba(22, 41, 54, var(--tw-text-opacity, 1));
}
.text-blumine-950\\/0{
  color: rgba(22, 41, 54, 0);
}
.text-blumine-950\\/10{
  color: rgba(22, 41, 54, 0.1);
}
.text-blumine-950\\/100{
  color: rgb(22, 41, 54);
}
.text-blumine-950\\/15{
  color: rgba(22, 41, 54, 0.15);
}
.text-blumine-950\\/20{
  color: rgba(22, 41, 54, 0.2);
}
.text-blumine-950\\/25{
  color: rgba(22, 41, 54, 0.25);
}
.text-blumine-950\\/30{
  color: rgba(22, 41, 54, 0.3);
}
.text-blumine-950\\/35{
  color: rgba(22, 41, 54, 0.35);
}
.text-blumine-950\\/40{
  color: rgba(22, 41, 54, 0.4);
}
.text-blumine-950\\/45{
  color: rgba(22, 41, 54, 0.45);
}
.text-blumine-950\\/5{
  color: rgba(22, 41, 54, 0.05);
}
.text-blumine-950\\/50{
  color: rgba(22, 41, 54, 0.5);
}
.text-blumine-950\\/55{
  color: rgba(22, 41, 54, 0.55);
}
.text-blumine-950\\/60{
  color: rgba(22, 41, 54, 0.6);
}
.text-blumine-950\\/65{
  color: rgba(22, 41, 54, 0.65);
}
.text-blumine-950\\/70{
  color: rgba(22, 41, 54, 0.7);
}
.text-blumine-950\\/75{
  color: rgba(22, 41, 54, 0.75);
}
.text-blumine-950\\/80{
  color: rgba(22, 41, 54, 0.8);
}
.text-blumine-950\\/85{
  color: rgba(22, 41, 54, 0.85);
}
.text-blumine-950\\/90{
  color: rgba(22, 41, 54, 0.9);
}
.text-blumine-950\\/95{
  color: rgba(22, 41, 54, 0.95);
}
.text-charcoal-100{
  --tw-text-opacity: 1;
  color: rgba(230, 230, 231, 1);
  color: rgba(230, 230, 231, var(--tw-text-opacity, 1));
}
.text-charcoal-100\\/0{
  color: rgba(230, 230, 231, 0);
}
.text-charcoal-100\\/10{
  color: rgba(230, 230, 231, 0.1);
}
.text-charcoal-100\\/100{
  color: rgb(230, 230, 231);
}
.text-charcoal-100\\/15{
  color: rgba(230, 230, 231, 0.15);
}
.text-charcoal-100\\/20{
  color: rgba(230, 230, 231, 0.2);
}
.text-charcoal-100\\/25{
  color: rgba(230, 230, 231, 0.25);
}
.text-charcoal-100\\/30{
  color: rgba(230, 230, 231, 0.3);
}
.text-charcoal-100\\/35{
  color: rgba(230, 230, 231, 0.35);
}
.text-charcoal-100\\/40{
  color: rgba(230, 230, 231, 0.4);
}
.text-charcoal-100\\/45{
  color: rgba(230, 230, 231, 0.45);
}
.text-charcoal-100\\/5{
  color: rgba(230, 230, 231, 0.05);
}
.text-charcoal-100\\/50{
  color: rgba(230, 230, 231, 0.5);
}
.text-charcoal-100\\/55{
  color: rgba(230, 230, 231, 0.55);
}
.text-charcoal-100\\/60{
  color: rgba(230, 230, 231, 0.6);
}
.text-charcoal-100\\/65{
  color: rgba(230, 230, 231, 0.65);
}
.text-charcoal-100\\/70{
  color: rgba(230, 230, 231, 0.7);
}
.text-charcoal-100\\/75{
  color: rgba(230, 230, 231, 0.75);
}
.text-charcoal-100\\/80{
  color: rgba(230, 230, 231, 0.8);
}
.text-charcoal-100\\/85{
  color: rgba(230, 230, 231, 0.85);
}
.text-charcoal-100\\/90{
  color: rgba(230, 230, 231, 0.9);
}
.text-charcoal-100\\/95{
  color: rgba(230, 230, 231, 0.95);
}
.text-charcoal-200{
  --tw-text-opacity: 1;
  color: rgba(207, 208, 210, 1);
  color: rgba(207, 208, 210, var(--tw-text-opacity, 1));
}
.text-charcoal-200\\/0{
  color: rgba(207, 208, 210, 0);
}
.text-charcoal-200\\/10{
  color: rgba(207, 208, 210, 0.1);
}
.text-charcoal-200\\/100{
  color: rgb(207, 208, 210);
}
.text-charcoal-200\\/15{
  color: rgba(207, 208, 210, 0.15);
}
.text-charcoal-200\\/20{
  color: rgba(207, 208, 210, 0.2);
}
.text-charcoal-200\\/25{
  color: rgba(207, 208, 210, 0.25);
}
.text-charcoal-200\\/30{
  color: rgba(207, 208, 210, 0.3);
}
.text-charcoal-200\\/35{
  color: rgba(207, 208, 210, 0.35);
}
.text-charcoal-200\\/40{
  color: rgba(207, 208, 210, 0.4);
}
.text-charcoal-200\\/45{
  color: rgba(207, 208, 210, 0.45);
}
.text-charcoal-200\\/5{
  color: rgba(207, 208, 210, 0.05);
}
.text-charcoal-200\\/50{
  color: rgba(207, 208, 210, 0.5);
}
.text-charcoal-200\\/55{
  color: rgba(207, 208, 210, 0.55);
}
.text-charcoal-200\\/60{
  color: rgba(207, 208, 210, 0.6);
}
.text-charcoal-200\\/65{
  color: rgba(207, 208, 210, 0.65);
}
.text-charcoal-200\\/70{
  color: rgba(207, 208, 210, 0.7);
}
.text-charcoal-200\\/75{
  color: rgba(207, 208, 210, 0.75);
}
.text-charcoal-200\\/80{
  color: rgba(207, 208, 210, 0.8);
}
.text-charcoal-200\\/85{
  color: rgba(207, 208, 210, 0.85);
}
.text-charcoal-200\\/90{
  color: rgba(207, 208, 210, 0.9);
}
.text-charcoal-200\\/95{
  color: rgba(207, 208, 210, 0.95);
}
.text-charcoal-300{
  --tw-text-opacity: 1;
  color: rgba(174, 175, 178, 1);
  color: rgba(174, 175, 178, var(--tw-text-opacity, 1));
}
.text-charcoal-300\\/0{
  color: rgba(174, 175, 178, 0);
}
.text-charcoal-300\\/10{
  color: rgba(174, 175, 178, 0.1);
}
.text-charcoal-300\\/100{
  color: rgb(174, 175, 178);
}
.text-charcoal-300\\/15{
  color: rgba(174, 175, 178, 0.15);
}
.text-charcoal-300\\/20{
  color: rgba(174, 175, 178, 0.2);
}
.text-charcoal-300\\/25{
  color: rgba(174, 175, 178, 0.25);
}
.text-charcoal-300\\/30{
  color: rgba(174, 175, 178, 0.3);
}
.text-charcoal-300\\/35{
  color: rgba(174, 175, 178, 0.35);
}
.text-charcoal-300\\/40{
  color: rgba(174, 175, 178, 0.4);
}
.text-charcoal-300\\/45{
  color: rgba(174, 175, 178, 0.45);
}
.text-charcoal-300\\/5{
  color: rgba(174, 175, 178, 0.05);
}
.text-charcoal-300\\/50{
  color: rgba(174, 175, 178, 0.5);
}
.text-charcoal-300\\/55{
  color: rgba(174, 175, 178, 0.55);
}
.text-charcoal-300\\/60{
  color: rgba(174, 175, 178, 0.6);
}
.text-charcoal-300\\/65{
  color: rgba(174, 175, 178, 0.65);
}
.text-charcoal-300\\/70{
  color: rgba(174, 175, 178, 0.7);
}
.text-charcoal-300\\/75{
  color: rgba(174, 175, 178, 0.75);
}
.text-charcoal-300\\/80{
  color: rgba(174, 175, 178, 0.8);
}
.text-charcoal-300\\/85{
  color: rgba(174, 175, 178, 0.85);
}
.text-charcoal-300\\/90{
  color: rgba(174, 175, 178, 0.9);
}
.text-charcoal-300\\/95{
  color: rgba(174, 175, 178, 0.95);
}
.text-charcoal-400{
  --tw-text-opacity: 1;
  color: rgba(133, 134, 139, 1);
  color: rgba(133, 134, 139, var(--tw-text-opacity, 1));
}
.text-charcoal-400\\/0{
  color: rgba(133, 134, 139, 0);
}
.text-charcoal-400\\/10{
  color: rgba(133, 134, 139, 0.1);
}
.text-charcoal-400\\/100{
  color: rgb(133, 134, 139);
}
.text-charcoal-400\\/15{
  color: rgba(133, 134, 139, 0.15);
}
.text-charcoal-400\\/20{
  color: rgba(133, 134, 139, 0.2);
}
.text-charcoal-400\\/25{
  color: rgba(133, 134, 139, 0.25);
}
.text-charcoal-400\\/30{
  color: rgba(133, 134, 139, 0.3);
}
.text-charcoal-400\\/35{
  color: rgba(133, 134, 139, 0.35);
}
.text-charcoal-400\\/40{
  color: rgba(133, 134, 139, 0.4);
}
.text-charcoal-400\\/45{
  color: rgba(133, 134, 139, 0.45);
}
.text-charcoal-400\\/5{
  color: rgba(133, 134, 139, 0.05);
}
.text-charcoal-400\\/50{
  color: rgba(133, 134, 139, 0.5);
}
.text-charcoal-400\\/55{
  color: rgba(133, 134, 139, 0.55);
}
.text-charcoal-400\\/60{
  color: rgba(133, 134, 139, 0.6);
}
.text-charcoal-400\\/65{
  color: rgba(133, 134, 139, 0.65);
}
.text-charcoal-400\\/70{
  color: rgba(133, 134, 139, 0.7);
}
.text-charcoal-400\\/75{
  color: rgba(133, 134, 139, 0.75);
}
.text-charcoal-400\\/80{
  color: rgba(133, 134, 139, 0.8);
}
.text-charcoal-400\\/85{
  color: rgba(133, 134, 139, 0.85);
}
.text-charcoal-400\\/90{
  color: rgba(133, 134, 139, 0.9);
}
.text-charcoal-400\\/95{
  color: rgba(133, 134, 139, 0.95);
}
.text-charcoal-50{
  --tw-text-opacity: 1;
  color: rgba(245, 245, 246, 1);
  color: rgba(245, 245, 246, var(--tw-text-opacity, 1));
}
.text-charcoal-500{
  --tw-text-opacity: 1;
  color: rgba(106, 107, 112, 1);
  color: rgba(106, 107, 112, var(--tw-text-opacity, 1));
}
.text-charcoal-500\\/0{
  color: rgba(106, 107, 112, 0);
}
.text-charcoal-500\\/10{
  color: rgba(106, 107, 112, 0.1);
}
.text-charcoal-500\\/100{
  color: rgb(106, 107, 112);
}
.text-charcoal-500\\/15{
  color: rgba(106, 107, 112, 0.15);
}
.text-charcoal-500\\/20{
  color: rgba(106, 107, 112, 0.2);
}
.text-charcoal-500\\/25{
  color: rgba(106, 107, 112, 0.25);
}
.text-charcoal-500\\/30{
  color: rgba(106, 107, 112, 0.3);
}
.text-charcoal-500\\/35{
  color: rgba(106, 107, 112, 0.35);
}
.text-charcoal-500\\/40{
  color: rgba(106, 107, 112, 0.4);
}
.text-charcoal-500\\/45{
  color: rgba(106, 107, 112, 0.45);
}
.text-charcoal-500\\/5{
  color: rgba(106, 107, 112, 0.05);
}
.text-charcoal-500\\/50{
  color: rgba(106, 107, 112, 0.5);
}
.text-charcoal-500\\/55{
  color: rgba(106, 107, 112, 0.55);
}
.text-charcoal-500\\/60{
  color: rgba(106, 107, 112, 0.6);
}
.text-charcoal-500\\/65{
  color: rgba(106, 107, 112, 0.65);
}
.text-charcoal-500\\/70{
  color: rgba(106, 107, 112, 0.7);
}
.text-charcoal-500\\/75{
  color: rgba(106, 107, 112, 0.75);
}
.text-charcoal-500\\/80{
  color: rgba(106, 107, 112, 0.8);
}
.text-charcoal-500\\/85{
  color: rgba(106, 107, 112, 0.85);
}
.text-charcoal-500\\/90{
  color: rgba(106, 107, 112, 0.9);
}
.text-charcoal-500\\/95{
  color: rgba(106, 107, 112, 0.95);
}
.text-charcoal-600{
  --tw-text-opacity: 1;
  color: rgba(90, 91, 96, 1);
  color: rgba(90, 91, 96, var(--tw-text-opacity, 1));
}
.text-charcoal-600\\/0{
  color: rgba(90, 91, 96, 0);
}
.text-charcoal-600\\/10{
  color: rgba(90, 91, 96, 0.1);
}
.text-charcoal-600\\/100{
  color: rgb(90, 91, 96);
}
.text-charcoal-600\\/15{
  color: rgba(90, 91, 96, 0.15);
}
.text-charcoal-600\\/20{
  color: rgba(90, 91, 96, 0.2);
}
.text-charcoal-600\\/25{
  color: rgba(90, 91, 96, 0.25);
}
.text-charcoal-600\\/30{
  color: rgba(90, 91, 96, 0.3);
}
.text-charcoal-600\\/35{
  color: rgba(90, 91, 96, 0.35);
}
.text-charcoal-600\\/40{
  color: rgba(90, 91, 96, 0.4);
}
.text-charcoal-600\\/45{
  color: rgba(90, 91, 96, 0.45);
}
.text-charcoal-600\\/5{
  color: rgba(90, 91, 96, 0.05);
}
.text-charcoal-600\\/50{
  color: rgba(90, 91, 96, 0.5);
}
.text-charcoal-600\\/55{
  color: rgba(90, 91, 96, 0.55);
}
.text-charcoal-600\\/60{
  color: rgba(90, 91, 96, 0.6);
}
.text-charcoal-600\\/65{
  color: rgba(90, 91, 96, 0.65);
}
.text-charcoal-600\\/70{
  color: rgba(90, 91, 96, 0.7);
}
.text-charcoal-600\\/75{
  color: rgba(90, 91, 96, 0.75);
}
.text-charcoal-600\\/80{
  color: rgba(90, 91, 96, 0.8);
}
.text-charcoal-600\\/85{
  color: rgba(90, 91, 96, 0.85);
}
.text-charcoal-600\\/90{
  color: rgba(90, 91, 96, 0.9);
}
.text-charcoal-600\\/95{
  color: rgba(90, 91, 96, 0.95);
}
.text-charcoal-700{
  --tw-text-opacity: 1;
  color: rgba(77, 77, 81, 1);
  color: rgba(77, 77, 81, var(--tw-text-opacity, 1));
}
.text-charcoal-700\\/0{
  color: rgba(77, 77, 81, 0);
}
.text-charcoal-700\\/10{
  color: rgba(77, 77, 81, 0.1);
}
.text-charcoal-700\\/100{
  color: rgb(77, 77, 81);
}
.text-charcoal-700\\/15{
  color: rgba(77, 77, 81, 0.15);
}
.text-charcoal-700\\/20{
  color: rgba(77, 77, 81, 0.2);
}
.text-charcoal-700\\/25{
  color: rgba(77, 77, 81, 0.25);
}
.text-charcoal-700\\/30{
  color: rgba(77, 77, 81, 0.3);
}
.text-charcoal-700\\/35{
  color: rgba(77, 77, 81, 0.35);
}
.text-charcoal-700\\/40{
  color: rgba(77, 77, 81, 0.4);
}
.text-charcoal-700\\/45{
  color: rgba(77, 77, 81, 0.45);
}
.text-charcoal-700\\/5{
  color: rgba(77, 77, 81, 0.05);
}
.text-charcoal-700\\/50{
  color: rgba(77, 77, 81, 0.5);
}
.text-charcoal-700\\/55{
  color: rgba(77, 77, 81, 0.55);
}
.text-charcoal-700\\/60{
  color: rgba(77, 77, 81, 0.6);
}
.text-charcoal-700\\/65{
  color: rgba(77, 77, 81, 0.65);
}
.text-charcoal-700\\/70{
  color: rgba(77, 77, 81, 0.7);
}
.text-charcoal-700\\/75{
  color: rgba(77, 77, 81, 0.75);
}
.text-charcoal-700\\/80{
  color: rgba(77, 77, 81, 0.8);
}
.text-charcoal-700\\/85{
  color: rgba(77, 77, 81, 0.85);
}
.text-charcoal-700\\/90{
  color: rgba(77, 77, 81, 0.9);
}
.text-charcoal-700\\/95{
  color: rgba(77, 77, 81, 0.95);
}
.text-charcoal-800{
  --tw-text-opacity: 1;
  color: rgba(67, 67, 71, 1);
  color: rgba(67, 67, 71, var(--tw-text-opacity, 1));
}
.text-charcoal-800\\/0{
  color: rgba(67, 67, 71, 0);
}
.text-charcoal-800\\/10{
  color: rgba(67, 67, 71, 0.1);
}
.text-charcoal-800\\/100{
  color: rgb(67, 67, 71);
}
.text-charcoal-800\\/15{
  color: rgba(67, 67, 71, 0.15);
}
.text-charcoal-800\\/20{
  color: rgba(67, 67, 71, 0.2);
}
.text-charcoal-800\\/25{
  color: rgba(67, 67, 71, 0.25);
}
.text-charcoal-800\\/30{
  color: rgba(67, 67, 71, 0.3);
}
.text-charcoal-800\\/35{
  color: rgba(67, 67, 71, 0.35);
}
.text-charcoal-800\\/40{
  color: rgba(67, 67, 71, 0.4);
}
.text-charcoal-800\\/45{
  color: rgba(67, 67, 71, 0.45);
}
.text-charcoal-800\\/5{
  color: rgba(67, 67, 71, 0.05);
}
.text-charcoal-800\\/50{
  color: rgba(67, 67, 71, 0.5);
}
.text-charcoal-800\\/55{
  color: rgba(67, 67, 71, 0.55);
}
.text-charcoal-800\\/60{
  color: rgba(67, 67, 71, 0.6);
}
.text-charcoal-800\\/65{
  color: rgba(67, 67, 71, 0.65);
}
.text-charcoal-800\\/70{
  color: rgba(67, 67, 71, 0.7);
}
.text-charcoal-800\\/75{
  color: rgba(67, 67, 71, 0.75);
}
.text-charcoal-800\\/80{
  color: rgba(67, 67, 71, 0.8);
}
.text-charcoal-800\\/85{
  color: rgba(67, 67, 71, 0.85);
}
.text-charcoal-800\\/90{
  color: rgba(67, 67, 71, 0.9);
}
.text-charcoal-800\\/95{
  color: rgba(67, 67, 71, 0.95);
}
.text-charcoal-900{
  --tw-text-opacity: 1;
  color: rgba(49, 49, 51, 1);
  color: rgba(49, 49, 51, var(--tw-text-opacity, 1));
}
.text-charcoal-900\\/0{
  color: rgba(49, 49, 51, 0);
}
.text-charcoal-900\\/10{
  color: rgba(49, 49, 51, 0.1);
}
.text-charcoal-900\\/100{
  color: rgb(49, 49, 51);
}
.text-charcoal-900\\/15{
  color: rgba(49, 49, 51, 0.15);
}
.text-charcoal-900\\/20{
  color: rgba(49, 49, 51, 0.2);
}
.text-charcoal-900\\/25{
  color: rgba(49, 49, 51, 0.25);
}
.text-charcoal-900\\/30{
  color: rgba(49, 49, 51, 0.3);
}
.text-charcoal-900\\/35{
  color: rgba(49, 49, 51, 0.35);
}
.text-charcoal-900\\/40{
  color: rgba(49, 49, 51, 0.4);
}
.text-charcoal-900\\/45{
  color: rgba(49, 49, 51, 0.45);
}
.text-charcoal-900\\/5{
  color: rgba(49, 49, 51, 0.05);
}
.text-charcoal-900\\/50{
  color: rgba(49, 49, 51, 0.5);
}
.text-charcoal-900\\/55{
  color: rgba(49, 49, 51, 0.55);
}
.text-charcoal-900\\/60{
  color: rgba(49, 49, 51, 0.6);
}
.text-charcoal-900\\/65{
  color: rgba(49, 49, 51, 0.65);
}
.text-charcoal-900\\/70{
  color: rgba(49, 49, 51, 0.7);
}
.text-charcoal-900\\/75{
  color: rgba(49, 49, 51, 0.75);
}
.text-charcoal-900\\/80{
  color: rgba(49, 49, 51, 0.8);
}
.text-charcoal-900\\/85{
  color: rgba(49, 49, 51, 0.85);
}
.text-charcoal-900\\/90{
  color: rgba(49, 49, 51, 0.9);
}
.text-charcoal-900\\/95{
  color: rgba(49, 49, 51, 0.95);
}
.text-charcoal-950{
  --tw-text-opacity: 1;
  color: rgba(37, 37, 39, 1);
  color: rgba(37, 37, 39, var(--tw-text-opacity, 1));
}
.text-charcoal-950\\/0{
  color: rgba(37, 37, 39, 0);
}
.text-charcoal-950\\/10{
  color: rgba(37, 37, 39, 0.1);
}
.text-charcoal-950\\/100{
  color: rgb(37, 37, 39);
}
.text-charcoal-950\\/15{
  color: rgba(37, 37, 39, 0.15);
}
.text-charcoal-950\\/20{
  color: rgba(37, 37, 39, 0.2);
}
.text-charcoal-950\\/25{
  color: rgba(37, 37, 39, 0.25);
}
.text-charcoal-950\\/30{
  color: rgba(37, 37, 39, 0.3);
}
.text-charcoal-950\\/35{
  color: rgba(37, 37, 39, 0.35);
}
.text-charcoal-950\\/40{
  color: rgba(37, 37, 39, 0.4);
}
.text-charcoal-950\\/45{
  color: rgba(37, 37, 39, 0.45);
}
.text-charcoal-950\\/5{
  color: rgba(37, 37, 39, 0.05);
}
.text-charcoal-950\\/50{
  color: rgba(37, 37, 39, 0.5);
}
.text-charcoal-950\\/55{
  color: rgba(37, 37, 39, 0.55);
}
.text-charcoal-950\\/60{
  color: rgba(37, 37, 39, 0.6);
}
.text-charcoal-950\\/65{
  color: rgba(37, 37, 39, 0.65);
}
.text-charcoal-950\\/70{
  color: rgba(37, 37, 39, 0.7);
}
.text-charcoal-950\\/75{
  color: rgba(37, 37, 39, 0.75);
}
.text-charcoal-950\\/80{
  color: rgba(37, 37, 39, 0.8);
}
.text-charcoal-950\\/85{
  color: rgba(37, 37, 39, 0.85);
}
.text-charcoal-950\\/90{
  color: rgba(37, 37, 39, 0.9);
}
.text-charcoal-950\\/95{
  color: rgba(37, 37, 39, 0.95);
}
.text-jade-100{
  --tw-text-opacity: 1;
  color: rgba(217, 242, 230, 1);
  color: rgba(217, 242, 230, var(--tw-text-opacity, 1));
}
.text-jade-100\\/0{
  color: rgba(217, 242, 230, 0);
}
.text-jade-100\\/10{
  color: rgba(217, 242, 230, 0.1);
}
.text-jade-100\\/100{
  color: rgb(217, 242, 230);
}
.text-jade-100\\/15{
  color: rgba(217, 242, 230, 0.15);
}
.text-jade-100\\/20{
  color: rgba(217, 242, 230, 0.2);
}
.text-jade-100\\/25{
  color: rgba(217, 242, 230, 0.25);
}
.text-jade-100\\/30{
  color: rgba(217, 242, 230, 0.3);
}
.text-jade-100\\/35{
  color: rgba(217, 242, 230, 0.35);
}
.text-jade-100\\/40{
  color: rgba(217, 242, 230, 0.4);
}
.text-jade-100\\/45{
  color: rgba(217, 242, 230, 0.45);
}
.text-jade-100\\/5{
  color: rgba(217, 242, 230, 0.05);
}
.text-jade-100\\/50{
  color: rgba(217, 242, 230, 0.5);
}
.text-jade-100\\/55{
  color: rgba(217, 242, 230, 0.55);
}
.text-jade-100\\/60{
  color: rgba(217, 242, 230, 0.6);
}
.text-jade-100\\/65{
  color: rgba(217, 242, 230, 0.65);
}
.text-jade-100\\/70{
  color: rgba(217, 242, 230, 0.7);
}
.text-jade-100\\/75{
  color: rgba(217, 242, 230, 0.75);
}
.text-jade-100\\/80{
  color: rgba(217, 242, 230, 0.8);
}
.text-jade-100\\/85{
  color: rgba(217, 242, 230, 0.85);
}
.text-jade-100\\/90{
  color: rgba(217, 242, 230, 0.9);
}
.text-jade-100\\/95{
  color: rgba(217, 242, 230, 0.95);
}
.text-jade-200{
  --tw-text-opacity: 1;
  color: rgba(182, 228, 209, 1);
  color: rgba(182, 228, 209, var(--tw-text-opacity, 1));
}
.text-jade-200\\/0{
  color: rgba(182, 228, 209, 0);
}
.text-jade-200\\/10{
  color: rgba(182, 228, 209, 0.1);
}
.text-jade-200\\/100{
  color: rgb(182, 228, 209);
}
.text-jade-200\\/15{
  color: rgba(182, 228, 209, 0.15);
}
.text-jade-200\\/20{
  color: rgba(182, 228, 209, 0.2);
}
.text-jade-200\\/25{
  color: rgba(182, 228, 209, 0.25);
}
.text-jade-200\\/30{
  color: rgba(182, 228, 209, 0.3);
}
.text-jade-200\\/35{
  color: rgba(182, 228, 209, 0.35);
}
.text-jade-200\\/40{
  color: rgba(182, 228, 209, 0.4);
}
.text-jade-200\\/45{
  color: rgba(182, 228, 209, 0.45);
}
.text-jade-200\\/5{
  color: rgba(182, 228, 209, 0.05);
}
.text-jade-200\\/50{
  color: rgba(182, 228, 209, 0.5);
}
.text-jade-200\\/55{
  color: rgba(182, 228, 209, 0.55);
}
.text-jade-200\\/60{
  color: rgba(182, 228, 209, 0.6);
}
.text-jade-200\\/65{
  color: rgba(182, 228, 209, 0.65);
}
.text-jade-200\\/70{
  color: rgba(182, 228, 209, 0.7);
}
.text-jade-200\\/75{
  color: rgba(182, 228, 209, 0.75);
}
.text-jade-200\\/80{
  color: rgba(182, 228, 209, 0.8);
}
.text-jade-200\\/85{
  color: rgba(182, 228, 209, 0.85);
}
.text-jade-200\\/90{
  color: rgba(182, 228, 209, 0.9);
}
.text-jade-200\\/95{
  color: rgba(182, 228, 209, 0.95);
}
.text-jade-300{
  --tw-text-opacity: 1;
  color: rgba(134, 207, 181, 1);
  color: rgba(134, 207, 181, var(--tw-text-opacity, 1));
}
.text-jade-300\\/0{
  color: rgba(134, 207, 181, 0);
}
.text-jade-300\\/10{
  color: rgba(134, 207, 181, 0.1);
}
.text-jade-300\\/100{
  color: rgb(134, 207, 181);
}
.text-jade-300\\/15{
  color: rgba(134, 207, 181, 0.15);
}
.text-jade-300\\/20{
  color: rgba(134, 207, 181, 0.2);
}
.text-jade-300\\/25{
  color: rgba(134, 207, 181, 0.25);
}
.text-jade-300\\/30{
  color: rgba(134, 207, 181, 0.3);
}
.text-jade-300\\/35{
  color: rgba(134, 207, 181, 0.35);
}
.text-jade-300\\/40{
  color: rgba(134, 207, 181, 0.4);
}
.text-jade-300\\/45{
  color: rgba(134, 207, 181, 0.45);
}
.text-jade-300\\/5{
  color: rgba(134, 207, 181, 0.05);
}
.text-jade-300\\/50{
  color: rgba(134, 207, 181, 0.5);
}
.text-jade-300\\/55{
  color: rgba(134, 207, 181, 0.55);
}
.text-jade-300\\/60{
  color: rgba(134, 207, 181, 0.6);
}
.text-jade-300\\/65{
  color: rgba(134, 207, 181, 0.65);
}
.text-jade-300\\/70{
  color: rgba(134, 207, 181, 0.7);
}
.text-jade-300\\/75{
  color: rgba(134, 207, 181, 0.75);
}
.text-jade-300\\/80{
  color: rgba(134, 207, 181, 0.8);
}
.text-jade-300\\/85{
  color: rgba(134, 207, 181, 0.85);
}
.text-jade-300\\/90{
  color: rgba(134, 207, 181, 0.9);
}
.text-jade-300\\/95{
  color: rgba(134, 207, 181, 0.95);
}
.text-jade-400{
  --tw-text-opacity: 1;
  color: rgba(83, 180, 148, 1);
  color: rgba(83, 180, 148, var(--tw-text-opacity, 1));
}
.text-jade-400\\/0{
  color: rgba(83, 180, 148, 0);
}
.text-jade-400\\/10{
  color: rgba(83, 180, 148, 0.1);
}
.text-jade-400\\/100{
  color: rgb(83, 180, 148);
}
.text-jade-400\\/15{
  color: rgba(83, 180, 148, 0.15);
}
.text-jade-400\\/20{
  color: rgba(83, 180, 148, 0.2);
}
.text-jade-400\\/25{
  color: rgba(83, 180, 148, 0.25);
}
.text-jade-400\\/30{
  color: rgba(83, 180, 148, 0.3);
}
.text-jade-400\\/35{
  color: rgba(83, 180, 148, 0.35);
}
.text-jade-400\\/40{
  color: rgba(83, 180, 148, 0.4);
}
.text-jade-400\\/45{
  color: rgba(83, 180, 148, 0.45);
}
.text-jade-400\\/5{
  color: rgba(83, 180, 148, 0.05);
}
.text-jade-400\\/50{
  color: rgba(83, 180, 148, 0.5);
}
.text-jade-400\\/55{
  color: rgba(83, 180, 148, 0.55);
}
.text-jade-400\\/60{
  color: rgba(83, 180, 148, 0.6);
}
.text-jade-400\\/65{
  color: rgba(83, 180, 148, 0.65);
}
.text-jade-400\\/70{
  color: rgba(83, 180, 148, 0.7);
}
.text-jade-400\\/75{
  color: rgba(83, 180, 148, 0.75);
}
.text-jade-400\\/80{
  color: rgba(83, 180, 148, 0.8);
}
.text-jade-400\\/85{
  color: rgba(83, 180, 148, 0.85);
}
.text-jade-400\\/90{
  color: rgba(83, 180, 148, 0.9);
}
.text-jade-400\\/95{
  color: rgba(83, 180, 148, 0.95);
}
.text-jade-500{
  --tw-text-opacity: 1;
  color: rgba(44, 135, 109, 1);
  color: rgba(44, 135, 109, var(--tw-text-opacity, 1));
}
.text-jade-500\\/0{
  color: rgba(44, 135, 109, 0);
}
.text-jade-500\\/10{
  color: rgba(44, 135, 109, 0.1);
}
.text-jade-500\\/100{
  color: rgb(44, 135, 109);
}
.text-jade-500\\/15{
  color: rgba(44, 135, 109, 0.15);
}
.text-jade-500\\/20{
  color: rgba(44, 135, 109, 0.2);
}
.text-jade-500\\/25{
  color: rgba(44, 135, 109, 0.25);
}
.text-jade-500\\/30{
  color: rgba(44, 135, 109, 0.3);
}
.text-jade-500\\/35{
  color: rgba(44, 135, 109, 0.35);
}
.text-jade-500\\/40{
  color: rgba(44, 135, 109, 0.4);
}
.text-jade-500\\/45{
  color: rgba(44, 135, 109, 0.45);
}
.text-jade-500\\/5{
  color: rgba(44, 135, 109, 0.05);
}
.text-jade-500\\/50{
  color: rgba(44, 135, 109, 0.5);
}
.text-jade-500\\/55{
  color: rgba(44, 135, 109, 0.55);
}
.text-jade-500\\/60{
  color: rgba(44, 135, 109, 0.6);
}
.text-jade-500\\/65{
  color: rgba(44, 135, 109, 0.65);
}
.text-jade-500\\/70{
  color: rgba(44, 135, 109, 0.7);
}
.text-jade-500\\/75{
  color: rgba(44, 135, 109, 0.75);
}
.text-jade-500\\/80{
  color: rgba(44, 135, 109, 0.8);
}
.text-jade-500\\/85{
  color: rgba(44, 135, 109, 0.85);
}
.text-jade-500\\/90{
  color: rgba(44, 135, 109, 0.9);
}
.text-jade-500\\/95{
  color: rgba(44, 135, 109, 0.95);
}
.text-jade-600{
  --tw-text-opacity: 1;
  color: rgba(34, 121, 98, 1);
  color: rgba(34, 121, 98, var(--tw-text-opacity, 1));
}
.text-jade-600\\/0{
  color: rgba(34, 121, 98, 0);
}
.text-jade-600\\/10{
  color: rgba(34, 121, 98, 0.1);
}
.text-jade-600\\/100{
  color: rgb(34, 121, 98);
}
.text-jade-600\\/15{
  color: rgba(34, 121, 98, 0.15);
}
.text-jade-600\\/20{
  color: rgba(34, 121, 98, 0.2);
}
.text-jade-600\\/25{
  color: rgba(34, 121, 98, 0.25);
}
.text-jade-600\\/30{
  color: rgba(34, 121, 98, 0.3);
}
.text-jade-600\\/35{
  color: rgba(34, 121, 98, 0.35);
}
.text-jade-600\\/40{
  color: rgba(34, 121, 98, 0.4);
}
.text-jade-600\\/45{
  color: rgba(34, 121, 98, 0.45);
}
.text-jade-600\\/5{
  color: rgba(34, 121, 98, 0.05);
}
.text-jade-600\\/50{
  color: rgba(34, 121, 98, 0.5);
}
.text-jade-600\\/55{
  color: rgba(34, 121, 98, 0.55);
}
.text-jade-600\\/60{
  color: rgba(34, 121, 98, 0.6);
}
.text-jade-600\\/65{
  color: rgba(34, 121, 98, 0.65);
}
.text-jade-600\\/70{
  color: rgba(34, 121, 98, 0.7);
}
.text-jade-600\\/75{
  color: rgba(34, 121, 98, 0.75);
}
.text-jade-600\\/80{
  color: rgba(34, 121, 98, 0.8);
}
.text-jade-600\\/85{
  color: rgba(34, 121, 98, 0.85);
}
.text-jade-600\\/90{
  color: rgba(34, 121, 98, 0.9);
}
.text-jade-600\\/95{
  color: rgba(34, 121, 98, 0.95);
}
.text-jade-700{
  --tw-text-opacity: 1;
  color: rgba(27, 97, 80, 1);
  color: rgba(27, 97, 80, var(--tw-text-opacity, 1));
}
.text-jade-700\\/0{
  color: rgba(27, 97, 80, 0);
}
.text-jade-700\\/10{
  color: rgba(27, 97, 80, 0.1);
}
.text-jade-700\\/100{
  color: rgb(27, 97, 80);
}
.text-jade-700\\/15{
  color: rgba(27, 97, 80, 0.15);
}
.text-jade-700\\/20{
  color: rgba(27, 97, 80, 0.2);
}
.text-jade-700\\/25{
  color: rgba(27, 97, 80, 0.25);
}
.text-jade-700\\/30{
  color: rgba(27, 97, 80, 0.3);
}
.text-jade-700\\/35{
  color: rgba(27, 97, 80, 0.35);
}
.text-jade-700\\/40{
  color: rgba(27, 97, 80, 0.4);
}
.text-jade-700\\/45{
  color: rgba(27, 97, 80, 0.45);
}
.text-jade-700\\/5{
  color: rgba(27, 97, 80, 0.05);
}
.text-jade-700\\/50{
  color: rgba(27, 97, 80, 0.5);
}
.text-jade-700\\/55{
  color: rgba(27, 97, 80, 0.55);
}
.text-jade-700\\/60{
  color: rgba(27, 97, 80, 0.6);
}
.text-jade-700\\/65{
  color: rgba(27, 97, 80, 0.65);
}
.text-jade-700\\/70{
  color: rgba(27, 97, 80, 0.7);
}
.text-jade-700\\/75{
  color: rgba(27, 97, 80, 0.75);
}
.text-jade-700\\/80{
  color: rgba(27, 97, 80, 0.8);
}
.text-jade-700\\/85{
  color: rgba(27, 97, 80, 0.85);
}
.text-jade-700\\/90{
  color: rgba(27, 97, 80, 0.9);
}
.text-jade-700\\/95{
  color: rgba(27, 97, 80, 0.95);
}
.text-jade-800{
  --tw-text-opacity: 1;
  color: rgba(24, 77, 64, 1);
  color: rgba(24, 77, 64, var(--tw-text-opacity, 1));
}
.text-jade-800\\/0{
  color: rgba(24, 77, 64, 0);
}
.text-jade-800\\/10{
  color: rgba(24, 77, 64, 0.1);
}
.text-jade-800\\/100{
  color: rgb(24, 77, 64);
}
.text-jade-800\\/15{
  color: rgba(24, 77, 64, 0.15);
}
.text-jade-800\\/20{
  color: rgba(24, 77, 64, 0.2);
}
.text-jade-800\\/25{
  color: rgba(24, 77, 64, 0.25);
}
.text-jade-800\\/30{
  color: rgba(24, 77, 64, 0.3);
}
.text-jade-800\\/35{
  color: rgba(24, 77, 64, 0.35);
}
.text-jade-800\\/40{
  color: rgba(24, 77, 64, 0.4);
}
.text-jade-800\\/45{
  color: rgba(24, 77, 64, 0.45);
}
.text-jade-800\\/5{
  color: rgba(24, 77, 64, 0.05);
}
.text-jade-800\\/50{
  color: rgba(24, 77, 64, 0.5);
}
.text-jade-800\\/55{
  color: rgba(24, 77, 64, 0.55);
}
.text-jade-800\\/60{
  color: rgba(24, 77, 64, 0.6);
}
.text-jade-800\\/65{
  color: rgba(24, 77, 64, 0.65);
}
.text-jade-800\\/70{
  color: rgba(24, 77, 64, 0.7);
}
.text-jade-800\\/75{
  color: rgba(24, 77, 64, 0.75);
}
.text-jade-800\\/80{
  color: rgba(24, 77, 64, 0.8);
}
.text-jade-800\\/85{
  color: rgba(24, 77, 64, 0.85);
}
.text-jade-800\\/90{
  color: rgba(24, 77, 64, 0.9);
}
.text-jade-800\\/95{
  color: rgba(24, 77, 64, 0.95);
}
.text-jade-900{
  --tw-text-opacity: 1;
  color: rgba(20, 64, 54, 1);
  color: rgba(20, 64, 54, var(--tw-text-opacity, 1));
}
.text-jade-900\\/0{
  color: rgba(20, 64, 54, 0);
}
.text-jade-900\\/10{
  color: rgba(20, 64, 54, 0.1);
}
.text-jade-900\\/100{
  color: rgb(20, 64, 54);
}
.text-jade-900\\/15{
  color: rgba(20, 64, 54, 0.15);
}
.text-jade-900\\/20{
  color: rgba(20, 64, 54, 0.2);
}
.text-jade-900\\/25{
  color: rgba(20, 64, 54, 0.25);
}
.text-jade-900\\/30{
  color: rgba(20, 64, 54, 0.3);
}
.text-jade-900\\/35{
  color: rgba(20, 64, 54, 0.35);
}
.text-jade-900\\/40{
  color: rgba(20, 64, 54, 0.4);
}
.text-jade-900\\/45{
  color: rgba(20, 64, 54, 0.45);
}
.text-jade-900\\/5{
  color: rgba(20, 64, 54, 0.05);
}
.text-jade-900\\/50{
  color: rgba(20, 64, 54, 0.5);
}
.text-jade-900\\/55{
  color: rgba(20, 64, 54, 0.55);
}
.text-jade-900\\/60{
  color: rgba(20, 64, 54, 0.6);
}
.text-jade-900\\/65{
  color: rgba(20, 64, 54, 0.65);
}
.text-jade-900\\/70{
  color: rgba(20, 64, 54, 0.7);
}
.text-jade-900\\/75{
  color: rgba(20, 64, 54, 0.75);
}
.text-jade-900\\/80{
  color: rgba(20, 64, 54, 0.8);
}
.text-jade-900\\/85{
  color: rgba(20, 64, 54, 0.85);
}
.text-jade-900\\/90{
  color: rgba(20, 64, 54, 0.9);
}
.text-jade-900\\/95{
  color: rgba(20, 64, 54, 0.95);
}
.text-jade-950{
  --tw-text-opacity: 1;
  color: rgba(10, 36, 31, 1);
  color: rgba(10, 36, 31, var(--tw-text-opacity, 1));
}
.text-jade-950\\/0{
  color: rgba(10, 36, 31, 0);
}
.text-jade-950\\/10{
  color: rgba(10, 36, 31, 0.1);
}
.text-jade-950\\/100{
  color: rgb(10, 36, 31);
}
.text-jade-950\\/15{
  color: rgba(10, 36, 31, 0.15);
}
.text-jade-950\\/20{
  color: rgba(10, 36, 31, 0.2);
}
.text-jade-950\\/25{
  color: rgba(10, 36, 31, 0.25);
}
.text-jade-950\\/30{
  color: rgba(10, 36, 31, 0.3);
}
.text-jade-950\\/35{
  color: rgba(10, 36, 31, 0.35);
}
.text-jade-950\\/40{
  color: rgba(10, 36, 31, 0.4);
}
.text-jade-950\\/45{
  color: rgba(10, 36, 31, 0.45);
}
.text-jade-950\\/5{
  color: rgba(10, 36, 31, 0.05);
}
.text-jade-950\\/50{
  color: rgba(10, 36, 31, 0.5);
}
.text-jade-950\\/55{
  color: rgba(10, 36, 31, 0.55);
}
.text-jade-950\\/60{
  color: rgba(10, 36, 31, 0.6);
}
.text-jade-950\\/65{
  color: rgba(10, 36, 31, 0.65);
}
.text-jade-950\\/70{
  color: rgba(10, 36, 31, 0.7);
}
.text-jade-950\\/75{
  color: rgba(10, 36, 31, 0.75);
}
.text-jade-950\\/80{
  color: rgba(10, 36, 31, 0.8);
}
.text-jade-950\\/85{
  color: rgba(10, 36, 31, 0.85);
}
.text-jade-950\\/90{
  color: rgba(10, 36, 31, 0.9);
}
.text-jade-950\\/95{
  color: rgba(10, 36, 31, 0.95);
}
.text-kids-alphabet-500{
  --tw-text-opacity: 1;
  color: rgba(55, 135, 163, 1);
  color: rgba(55, 135, 163, var(--tw-text-opacity, 1));
}
.text-kids-alphabet-500\\/0{
  color: rgba(55, 135, 163, 0);
}
.text-kids-alphabet-500\\/10{
  color: rgba(55, 135, 163, 0.1);
}
.text-kids-alphabet-500\\/100{
  color: rgb(55, 135, 163);
}
.text-kids-alphabet-500\\/15{
  color: rgba(55, 135, 163, 0.15);
}
.text-kids-alphabet-500\\/20{
  color: rgba(55, 135, 163, 0.2);
}
.text-kids-alphabet-500\\/25{
  color: rgba(55, 135, 163, 0.25);
}
.text-kids-alphabet-500\\/30{
  color: rgba(55, 135, 163, 0.3);
}
.text-kids-alphabet-500\\/35{
  color: rgba(55, 135, 163, 0.35);
}
.text-kids-alphabet-500\\/40{
  color: rgba(55, 135, 163, 0.4);
}
.text-kids-alphabet-500\\/45{
  color: rgba(55, 135, 163, 0.45);
}
.text-kids-alphabet-500\\/5{
  color: rgba(55, 135, 163, 0.05);
}
.text-kids-alphabet-500\\/50{
  color: rgba(55, 135, 163, 0.5);
}
.text-kids-alphabet-500\\/55{
  color: rgba(55, 135, 163, 0.55);
}
.text-kids-alphabet-500\\/60{
  color: rgba(55, 135, 163, 0.6);
}
.text-kids-alphabet-500\\/65{
  color: rgba(55, 135, 163, 0.65);
}
.text-kids-alphabet-500\\/70{
  color: rgba(55, 135, 163, 0.7);
}
.text-kids-alphabet-500\\/75{
  color: rgba(55, 135, 163, 0.75);
}
.text-kids-alphabet-500\\/80{
  color: rgba(55, 135, 163, 0.8);
}
.text-kids-alphabet-500\\/85{
  color: rgba(55, 135, 163, 0.85);
}
.text-kids-alphabet-500\\/90{
  color: rgba(55, 135, 163, 0.9);
}
.text-kids-alphabet-500\\/95{
  color: rgba(55, 135, 163, 0.95);
}
.text-kids-alphabet-600{
  --tw-text-opacity: 1;
  color: rgba(48, 109, 138, 1);
  color: rgba(48, 109, 138, var(--tw-text-opacity, 1));
}
.text-kids-alphabet-600\\/0{
  color: rgba(48, 109, 138, 0);
}
.text-kids-alphabet-600\\/10{
  color: rgba(48, 109, 138, 0.1);
}
.text-kids-alphabet-600\\/100{
  color: rgb(48, 109, 138);
}
.text-kids-alphabet-600\\/15{
  color: rgba(48, 109, 138, 0.15);
}
.text-kids-alphabet-600\\/20{
  color: rgba(48, 109, 138, 0.2);
}
.text-kids-alphabet-600\\/25{
  color: rgba(48, 109, 138, 0.25);
}
.text-kids-alphabet-600\\/30{
  color: rgba(48, 109, 138, 0.3);
}
.text-kids-alphabet-600\\/35{
  color: rgba(48, 109, 138, 0.35);
}
.text-kids-alphabet-600\\/40{
  color: rgba(48, 109, 138, 0.4);
}
.text-kids-alphabet-600\\/45{
  color: rgba(48, 109, 138, 0.45);
}
.text-kids-alphabet-600\\/5{
  color: rgba(48, 109, 138, 0.05);
}
.text-kids-alphabet-600\\/50{
  color: rgba(48, 109, 138, 0.5);
}
.text-kids-alphabet-600\\/55{
  color: rgba(48, 109, 138, 0.55);
}
.text-kids-alphabet-600\\/60{
  color: rgba(48, 109, 138, 0.6);
}
.text-kids-alphabet-600\\/65{
  color: rgba(48, 109, 138, 0.65);
}
.text-kids-alphabet-600\\/70{
  color: rgba(48, 109, 138, 0.7);
}
.text-kids-alphabet-600\\/75{
  color: rgba(48, 109, 138, 0.75);
}
.text-kids-alphabet-600\\/80{
  color: rgba(48, 109, 138, 0.8);
}
.text-kids-alphabet-600\\/85{
  color: rgba(48, 109, 138, 0.85);
}
.text-kids-alphabet-600\\/90{
  color: rgba(48, 109, 138, 0.9);
}
.text-kids-alphabet-600\\/95{
  color: rgba(48, 109, 138, 0.95);
}
.text-kids-alphabet-700{
  --tw-text-opacity: 1;
  color: rgba(45, 91, 114, 1);
  color: rgba(45, 91, 114, var(--tw-text-opacity, 1));
}
.text-kids-alphabet-700\\/0{
  color: rgba(45, 91, 114, 0);
}
.text-kids-alphabet-700\\/10{
  color: rgba(45, 91, 114, 0.1);
}
.text-kids-alphabet-700\\/100{
  color: rgb(45, 91, 114);
}
.text-kids-alphabet-700\\/15{
  color: rgba(45, 91, 114, 0.15);
}
.text-kids-alphabet-700\\/20{
  color: rgba(45, 91, 114, 0.2);
}
.text-kids-alphabet-700\\/25{
  color: rgba(45, 91, 114, 0.25);
}
.text-kids-alphabet-700\\/30{
  color: rgba(45, 91, 114, 0.3);
}
.text-kids-alphabet-700\\/35{
  color: rgba(45, 91, 114, 0.35);
}
.text-kids-alphabet-700\\/40{
  color: rgba(45, 91, 114, 0.4);
}
.text-kids-alphabet-700\\/45{
  color: rgba(45, 91, 114, 0.45);
}
.text-kids-alphabet-700\\/5{
  color: rgba(45, 91, 114, 0.05);
}
.text-kids-alphabet-700\\/50{
  color: rgba(45, 91, 114, 0.5);
}
.text-kids-alphabet-700\\/55{
  color: rgba(45, 91, 114, 0.55);
}
.text-kids-alphabet-700\\/60{
  color: rgba(45, 91, 114, 0.6);
}
.text-kids-alphabet-700\\/65{
  color: rgba(45, 91, 114, 0.65);
}
.text-kids-alphabet-700\\/70{
  color: rgba(45, 91, 114, 0.7);
}
.text-kids-alphabet-700\\/75{
  color: rgba(45, 91, 114, 0.75);
}
.text-kids-alphabet-700\\/80{
  color: rgba(45, 91, 114, 0.8);
}
.text-kids-alphabet-700\\/85{
  color: rgba(45, 91, 114, 0.85);
}
.text-kids-alphabet-700\\/90{
  color: rgba(45, 91, 114, 0.9);
}
.text-kids-alphabet-700\\/95{
  color: rgba(45, 91, 114, 0.95);
}
.text-kids-alphabet-800{
  --tw-text-opacity: 1;
  color: rgba(44, 76, 94, 1);
  color: rgba(44, 76, 94, var(--tw-text-opacity, 1));
}
.text-kids-alphabet-800\\/0{
  color: rgba(44, 76, 94, 0);
}
.text-kids-alphabet-800\\/10{
  color: rgba(44, 76, 94, 0.1);
}
.text-kids-alphabet-800\\/100{
  color: rgb(44, 76, 94);
}
.text-kids-alphabet-800\\/15{
  color: rgba(44, 76, 94, 0.15);
}
.text-kids-alphabet-800\\/20{
  color: rgba(44, 76, 94, 0.2);
}
.text-kids-alphabet-800\\/25{
  color: rgba(44, 76, 94, 0.25);
}
.text-kids-alphabet-800\\/30{
  color: rgba(44, 76, 94, 0.3);
}
.text-kids-alphabet-800\\/35{
  color: rgba(44, 76, 94, 0.35);
}
.text-kids-alphabet-800\\/40{
  color: rgba(44, 76, 94, 0.4);
}
.text-kids-alphabet-800\\/45{
  color: rgba(44, 76, 94, 0.45);
}
.text-kids-alphabet-800\\/5{
  color: rgba(44, 76, 94, 0.05);
}
.text-kids-alphabet-800\\/50{
  color: rgba(44, 76, 94, 0.5);
}
.text-kids-alphabet-800\\/55{
  color: rgba(44, 76, 94, 0.55);
}
.text-kids-alphabet-800\\/60{
  color: rgba(44, 76, 94, 0.6);
}
.text-kids-alphabet-800\\/65{
  color: rgba(44, 76, 94, 0.65);
}
.text-kids-alphabet-800\\/70{
  color: rgba(44, 76, 94, 0.7);
}
.text-kids-alphabet-800\\/75{
  color: rgba(44, 76, 94, 0.75);
}
.text-kids-alphabet-800\\/80{
  color: rgba(44, 76, 94, 0.8);
}
.text-kids-alphabet-800\\/85{
  color: rgba(44, 76, 94, 0.85);
}
.text-kids-alphabet-800\\/90{
  color: rgba(44, 76, 94, 0.9);
}
.text-kids-alphabet-800\\/95{
  color: rgba(44, 76, 94, 0.95);
}
.text-kids-alphabet-900{
  --tw-text-opacity: 1;
  color: rgba(40, 65, 81, 1);
  color: rgba(40, 65, 81, var(--tw-text-opacity, 1));
}
.text-kids-alphabet-900\\/0{
  color: rgba(40, 65, 81, 0);
}
.text-kids-alphabet-900\\/10{
  color: rgba(40, 65, 81, 0.1);
}
.text-kids-alphabet-900\\/100{
  color: rgb(40, 65, 81);
}
.text-kids-alphabet-900\\/15{
  color: rgba(40, 65, 81, 0.15);
}
.text-kids-alphabet-900\\/20{
  color: rgba(40, 65, 81, 0.2);
}
.text-kids-alphabet-900\\/25{
  color: rgba(40, 65, 81, 0.25);
}
.text-kids-alphabet-900\\/30{
  color: rgba(40, 65, 81, 0.3);
}
.text-kids-alphabet-900\\/35{
  color: rgba(40, 65, 81, 0.35);
}
.text-kids-alphabet-900\\/40{
  color: rgba(40, 65, 81, 0.4);
}
.text-kids-alphabet-900\\/45{
  color: rgba(40, 65, 81, 0.45);
}
.text-kids-alphabet-900\\/5{
  color: rgba(40, 65, 81, 0.05);
}
.text-kids-alphabet-900\\/50{
  color: rgba(40, 65, 81, 0.5);
}
.text-kids-alphabet-900\\/55{
  color: rgba(40, 65, 81, 0.55);
}
.text-kids-alphabet-900\\/60{
  color: rgba(40, 65, 81, 0.6);
}
.text-kids-alphabet-900\\/65{
  color: rgba(40, 65, 81, 0.65);
}
.text-kids-alphabet-900\\/70{
  color: rgba(40, 65, 81, 0.7);
}
.text-kids-alphabet-900\\/75{
  color: rgba(40, 65, 81, 0.75);
}
.text-kids-alphabet-900\\/80{
  color: rgba(40, 65, 81, 0.8);
}
.text-kids-alphabet-900\\/85{
  color: rgba(40, 65, 81, 0.85);
}
.text-kids-alphabet-900\\/90{
  color: rgba(40, 65, 81, 0.9);
}
.text-kids-alphabet-900\\/95{
  color: rgba(40, 65, 81, 0.95);
}
.text-kids-categories-500{
  --tw-text-opacity: 1;
  color: rgba(209, 145, 47, 1);
  color: rgba(209, 145, 47, var(--tw-text-opacity, 1));
}
.text-kids-categories-500\\/0{
  color: rgba(209, 145, 47, 0);
}
.text-kids-categories-500\\/10{
  color: rgba(209, 145, 47, 0.1);
}
.text-kids-categories-500\\/100{
  color: rgb(209, 145, 47);
}
.text-kids-categories-500\\/15{
  color: rgba(209, 145, 47, 0.15);
}
.text-kids-categories-500\\/20{
  color: rgba(209, 145, 47, 0.2);
}
.text-kids-categories-500\\/25{
  color: rgba(209, 145, 47, 0.25);
}
.text-kids-categories-500\\/30{
  color: rgba(209, 145, 47, 0.3);
}
.text-kids-categories-500\\/35{
  color: rgba(209, 145, 47, 0.35);
}
.text-kids-categories-500\\/40{
  color: rgba(209, 145, 47, 0.4);
}
.text-kids-categories-500\\/45{
  color: rgba(209, 145, 47, 0.45);
}
.text-kids-categories-500\\/5{
  color: rgba(209, 145, 47, 0.05);
}
.text-kids-categories-500\\/50{
  color: rgba(209, 145, 47, 0.5);
}
.text-kids-categories-500\\/55{
  color: rgba(209, 145, 47, 0.55);
}
.text-kids-categories-500\\/60{
  color: rgba(209, 145, 47, 0.6);
}
.text-kids-categories-500\\/65{
  color: rgba(209, 145, 47, 0.65);
}
.text-kids-categories-500\\/70{
  color: rgba(209, 145, 47, 0.7);
}
.text-kids-categories-500\\/75{
  color: rgba(209, 145, 47, 0.75);
}
.text-kids-categories-500\\/80{
  color: rgba(209, 145, 47, 0.8);
}
.text-kids-categories-500\\/85{
  color: rgba(209, 145, 47, 0.85);
}
.text-kids-categories-500\\/90{
  color: rgba(209, 145, 47, 0.9);
}
.text-kids-categories-500\\/95{
  color: rgba(209, 145, 47, 0.95);
}
.text-kids-categories-600{
  --tw-text-opacity: 1;
  color: rgba(195, 120, 41, 1);
  color: rgba(195, 120, 41, var(--tw-text-opacity, 1));
}
.text-kids-categories-600\\/0{
  color: rgba(195, 120, 41, 0);
}
.text-kids-categories-600\\/10{
  color: rgba(195, 120, 41, 0.1);
}
.text-kids-categories-600\\/100{
  color: rgb(195, 120, 41);
}
.text-kids-categories-600\\/15{
  color: rgba(195, 120, 41, 0.15);
}
.text-kids-categories-600\\/20{
  color: rgba(195, 120, 41, 0.2);
}
.text-kids-categories-600\\/25{
  color: rgba(195, 120, 41, 0.25);
}
.text-kids-categories-600\\/30{
  color: rgba(195, 120, 41, 0.3);
}
.text-kids-categories-600\\/35{
  color: rgba(195, 120, 41, 0.35);
}
.text-kids-categories-600\\/40{
  color: rgba(195, 120, 41, 0.4);
}
.text-kids-categories-600\\/45{
  color: rgba(195, 120, 41, 0.45);
}
.text-kids-categories-600\\/5{
  color: rgba(195, 120, 41, 0.05);
}
.text-kids-categories-600\\/50{
  color: rgba(195, 120, 41, 0.5);
}
.text-kids-categories-600\\/55{
  color: rgba(195, 120, 41, 0.55);
}
.text-kids-categories-600\\/60{
  color: rgba(195, 120, 41, 0.6);
}
.text-kids-categories-600\\/65{
  color: rgba(195, 120, 41, 0.65);
}
.text-kids-categories-600\\/70{
  color: rgba(195, 120, 41, 0.7);
}
.text-kids-categories-600\\/75{
  color: rgba(195, 120, 41, 0.75);
}
.text-kids-categories-600\\/80{
  color: rgba(195, 120, 41, 0.8);
}
.text-kids-categories-600\\/85{
  color: rgba(195, 120, 41, 0.85);
}
.text-kids-categories-600\\/90{
  color: rgba(195, 120, 41, 0.9);
}
.text-kids-categories-600\\/95{
  color: rgba(195, 120, 41, 0.95);
}
.text-kids-categories-700{
  --tw-text-opacity: 1;
  color: rgba(153, 84, 36, 1);
  color: rgba(153, 84, 36, var(--tw-text-opacity, 1));
}
.text-kids-categories-700\\/0{
  color: rgba(153, 84, 36, 0);
}
.text-kids-categories-700\\/10{
  color: rgba(153, 84, 36, 0.1);
}
.text-kids-categories-700\\/100{
  color: rgb(153, 84, 36);
}
.text-kids-categories-700\\/15{
  color: rgba(153, 84, 36, 0.15);
}
.text-kids-categories-700\\/20{
  color: rgba(153, 84, 36, 0.2);
}
.text-kids-categories-700\\/25{
  color: rgba(153, 84, 36, 0.25);
}
.text-kids-categories-700\\/30{
  color: rgba(153, 84, 36, 0.3);
}
.text-kids-categories-700\\/35{
  color: rgba(153, 84, 36, 0.35);
}
.text-kids-categories-700\\/40{
  color: rgba(153, 84, 36, 0.4);
}
.text-kids-categories-700\\/45{
  color: rgba(153, 84, 36, 0.45);
}
.text-kids-categories-700\\/5{
  color: rgba(153, 84, 36, 0.05);
}
.text-kids-categories-700\\/50{
  color: rgba(153, 84, 36, 0.5);
}
.text-kids-categories-700\\/55{
  color: rgba(153, 84, 36, 0.55);
}
.text-kids-categories-700\\/60{
  color: rgba(153, 84, 36, 0.6);
}
.text-kids-categories-700\\/65{
  color: rgba(153, 84, 36, 0.65);
}
.text-kids-categories-700\\/70{
  color: rgba(153, 84, 36, 0.7);
}
.text-kids-categories-700\\/75{
  color: rgba(153, 84, 36, 0.75);
}
.text-kids-categories-700\\/80{
  color: rgba(153, 84, 36, 0.8);
}
.text-kids-categories-700\\/85{
  color: rgba(153, 84, 36, 0.85);
}
.text-kids-categories-700\\/90{
  color: rgba(153, 84, 36, 0.9);
}
.text-kids-categories-700\\/95{
  color: rgba(153, 84, 36, 0.95);
}
.text-kids-categories-800{
  --tw-text-opacity: 1;
  color: rgba(126, 67, 34, 1);
  color: rgba(126, 67, 34, var(--tw-text-opacity, 1));
}
.text-kids-categories-800\\/0{
  color: rgba(126, 67, 34, 0);
}
.text-kids-categories-800\\/10{
  color: rgba(126, 67, 34, 0.1);
}
.text-kids-categories-800\\/100{
  color: rgb(126, 67, 34);
}
.text-kids-categories-800\\/15{
  color: rgba(126, 67, 34, 0.15);
}
.text-kids-categories-800\\/20{
  color: rgba(126, 67, 34, 0.2);
}
.text-kids-categories-800\\/25{
  color: rgba(126, 67, 34, 0.25);
}
.text-kids-categories-800\\/30{
  color: rgba(126, 67, 34, 0.3);
}
.text-kids-categories-800\\/35{
  color: rgba(126, 67, 34, 0.35);
}
.text-kids-categories-800\\/40{
  color: rgba(126, 67, 34, 0.4);
}
.text-kids-categories-800\\/45{
  color: rgba(126, 67, 34, 0.45);
}
.text-kids-categories-800\\/5{
  color: rgba(126, 67, 34, 0.05);
}
.text-kids-categories-800\\/50{
  color: rgba(126, 67, 34, 0.5);
}
.text-kids-categories-800\\/55{
  color: rgba(126, 67, 34, 0.55);
}
.text-kids-categories-800\\/60{
  color: rgba(126, 67, 34, 0.6);
}
.text-kids-categories-800\\/65{
  color: rgba(126, 67, 34, 0.65);
}
.text-kids-categories-800\\/70{
  color: rgba(126, 67, 34, 0.7);
}
.text-kids-categories-800\\/75{
  color: rgba(126, 67, 34, 0.75);
}
.text-kids-categories-800\\/80{
  color: rgba(126, 67, 34, 0.8);
}
.text-kids-categories-800\\/85{
  color: rgba(126, 67, 34, 0.85);
}
.text-kids-categories-800\\/90{
  color: rgba(126, 67, 34, 0.9);
}
.text-kids-categories-800\\/95{
  color: rgba(126, 67, 34, 0.95);
}
.text-kids-categories-900{
  --tw-text-opacity: 1;
  color: rgba(104, 56, 31, 1);
  color: rgba(104, 56, 31, var(--tw-text-opacity, 1));
}
.text-kids-categories-900\\/0{
  color: rgba(104, 56, 31, 0);
}
.text-kids-categories-900\\/10{
  color: rgba(104, 56, 31, 0.1);
}
.text-kids-categories-900\\/100{
  color: rgb(104, 56, 31);
}
.text-kids-categories-900\\/15{
  color: rgba(104, 56, 31, 0.15);
}
.text-kids-categories-900\\/20{
  color: rgba(104, 56, 31, 0.2);
}
.text-kids-categories-900\\/25{
  color: rgba(104, 56, 31, 0.25);
}
.text-kids-categories-900\\/30{
  color: rgba(104, 56, 31, 0.3);
}
.text-kids-categories-900\\/35{
  color: rgba(104, 56, 31, 0.35);
}
.text-kids-categories-900\\/40{
  color: rgba(104, 56, 31, 0.4);
}
.text-kids-categories-900\\/45{
  color: rgba(104, 56, 31, 0.45);
}
.text-kids-categories-900\\/5{
  color: rgba(104, 56, 31, 0.05);
}
.text-kids-categories-900\\/50{
  color: rgba(104, 56, 31, 0.5);
}
.text-kids-categories-900\\/55{
  color: rgba(104, 56, 31, 0.55);
}
.text-kids-categories-900\\/60{
  color: rgba(104, 56, 31, 0.6);
}
.text-kids-categories-900\\/65{
  color: rgba(104, 56, 31, 0.65);
}
.text-kids-categories-900\\/70{
  color: rgba(104, 56, 31, 0.7);
}
.text-kids-categories-900\\/75{
  color: rgba(104, 56, 31, 0.75);
}
.text-kids-categories-900\\/80{
  color: rgba(104, 56, 31, 0.8);
}
.text-kids-categories-900\\/85{
  color: rgba(104, 56, 31, 0.85);
}
.text-kids-categories-900\\/90{
  color: rgba(104, 56, 31, 0.9);
}
.text-kids-categories-900\\/95{
  color: rgba(104, 56, 31, 0.95);
}
.text-kids-dictionary-500{
  --tw-text-opacity: 1;
  color: rgba(44, 135, 109, 1);
  color: rgba(44, 135, 109, var(--tw-text-opacity, 1));
}
.text-kids-dictionary-500\\/0{
  color: rgba(44, 135, 109, 0);
}
.text-kids-dictionary-500\\/10{
  color: rgba(44, 135, 109, 0.1);
}
.text-kids-dictionary-500\\/100{
  color: rgb(44, 135, 109);
}
.text-kids-dictionary-500\\/15{
  color: rgba(44, 135, 109, 0.15);
}
.text-kids-dictionary-500\\/20{
  color: rgba(44, 135, 109, 0.2);
}
.text-kids-dictionary-500\\/25{
  color: rgba(44, 135, 109, 0.25);
}
.text-kids-dictionary-500\\/30{
  color: rgba(44, 135, 109, 0.3);
}
.text-kids-dictionary-500\\/35{
  color: rgba(44, 135, 109, 0.35);
}
.text-kids-dictionary-500\\/40{
  color: rgba(44, 135, 109, 0.4);
}
.text-kids-dictionary-500\\/45{
  color: rgba(44, 135, 109, 0.45);
}
.text-kids-dictionary-500\\/5{
  color: rgba(44, 135, 109, 0.05);
}
.text-kids-dictionary-500\\/50{
  color: rgba(44, 135, 109, 0.5);
}
.text-kids-dictionary-500\\/55{
  color: rgba(44, 135, 109, 0.55);
}
.text-kids-dictionary-500\\/60{
  color: rgba(44, 135, 109, 0.6);
}
.text-kids-dictionary-500\\/65{
  color: rgba(44, 135, 109, 0.65);
}
.text-kids-dictionary-500\\/70{
  color: rgba(44, 135, 109, 0.7);
}
.text-kids-dictionary-500\\/75{
  color: rgba(44, 135, 109, 0.75);
}
.text-kids-dictionary-500\\/80{
  color: rgba(44, 135, 109, 0.8);
}
.text-kids-dictionary-500\\/85{
  color: rgba(44, 135, 109, 0.85);
}
.text-kids-dictionary-500\\/90{
  color: rgba(44, 135, 109, 0.9);
}
.text-kids-dictionary-500\\/95{
  color: rgba(44, 135, 109, 0.95);
}
.text-kids-dictionary-600{
  --tw-text-opacity: 1;
  color: rgba(34, 121, 98, 1);
  color: rgba(34, 121, 98, var(--tw-text-opacity, 1));
}
.text-kids-dictionary-600\\/0{
  color: rgba(34, 121, 98, 0);
}
.text-kids-dictionary-600\\/10{
  color: rgba(34, 121, 98, 0.1);
}
.text-kids-dictionary-600\\/100{
  color: rgb(34, 121, 98);
}
.text-kids-dictionary-600\\/15{
  color: rgba(34, 121, 98, 0.15);
}
.text-kids-dictionary-600\\/20{
  color: rgba(34, 121, 98, 0.2);
}
.text-kids-dictionary-600\\/25{
  color: rgba(34, 121, 98, 0.25);
}
.text-kids-dictionary-600\\/30{
  color: rgba(34, 121, 98, 0.3);
}
.text-kids-dictionary-600\\/35{
  color: rgba(34, 121, 98, 0.35);
}
.text-kids-dictionary-600\\/40{
  color: rgba(34, 121, 98, 0.4);
}
.text-kids-dictionary-600\\/45{
  color: rgba(34, 121, 98, 0.45);
}
.text-kids-dictionary-600\\/5{
  color: rgba(34, 121, 98, 0.05);
}
.text-kids-dictionary-600\\/50{
  color: rgba(34, 121, 98, 0.5);
}
.text-kids-dictionary-600\\/55{
  color: rgba(34, 121, 98, 0.55);
}
.text-kids-dictionary-600\\/60{
  color: rgba(34, 121, 98, 0.6);
}
.text-kids-dictionary-600\\/65{
  color: rgba(34, 121, 98, 0.65);
}
.text-kids-dictionary-600\\/70{
  color: rgba(34, 121, 98, 0.7);
}
.text-kids-dictionary-600\\/75{
  color: rgba(34, 121, 98, 0.75);
}
.text-kids-dictionary-600\\/80{
  color: rgba(34, 121, 98, 0.8);
}
.text-kids-dictionary-600\\/85{
  color: rgba(34, 121, 98, 0.85);
}
.text-kids-dictionary-600\\/90{
  color: rgba(34, 121, 98, 0.9);
}
.text-kids-dictionary-600\\/95{
  color: rgba(34, 121, 98, 0.95);
}
.text-kids-dictionary-700{
  --tw-text-opacity: 1;
  color: rgba(27, 97, 80, 1);
  color: rgba(27, 97, 80, var(--tw-text-opacity, 1));
}
.text-kids-dictionary-700\\/0{
  color: rgba(27, 97, 80, 0);
}
.text-kids-dictionary-700\\/10{
  color: rgba(27, 97, 80, 0.1);
}
.text-kids-dictionary-700\\/100{
  color: rgb(27, 97, 80);
}
.text-kids-dictionary-700\\/15{
  color: rgba(27, 97, 80, 0.15);
}
.text-kids-dictionary-700\\/20{
  color: rgba(27, 97, 80, 0.2);
}
.text-kids-dictionary-700\\/25{
  color: rgba(27, 97, 80, 0.25);
}
.text-kids-dictionary-700\\/30{
  color: rgba(27, 97, 80, 0.3);
}
.text-kids-dictionary-700\\/35{
  color: rgba(27, 97, 80, 0.35);
}
.text-kids-dictionary-700\\/40{
  color: rgba(27, 97, 80, 0.4);
}
.text-kids-dictionary-700\\/45{
  color: rgba(27, 97, 80, 0.45);
}
.text-kids-dictionary-700\\/5{
  color: rgba(27, 97, 80, 0.05);
}
.text-kids-dictionary-700\\/50{
  color: rgba(27, 97, 80, 0.5);
}
.text-kids-dictionary-700\\/55{
  color: rgba(27, 97, 80, 0.55);
}
.text-kids-dictionary-700\\/60{
  color: rgba(27, 97, 80, 0.6);
}
.text-kids-dictionary-700\\/65{
  color: rgba(27, 97, 80, 0.65);
}
.text-kids-dictionary-700\\/70{
  color: rgba(27, 97, 80, 0.7);
}
.text-kids-dictionary-700\\/75{
  color: rgba(27, 97, 80, 0.75);
}
.text-kids-dictionary-700\\/80{
  color: rgba(27, 97, 80, 0.8);
}
.text-kids-dictionary-700\\/85{
  color: rgba(27, 97, 80, 0.85);
}
.text-kids-dictionary-700\\/90{
  color: rgba(27, 97, 80, 0.9);
}
.text-kids-dictionary-700\\/95{
  color: rgba(27, 97, 80, 0.95);
}
.text-kids-dictionary-800{
  --tw-text-opacity: 1;
  color: rgba(24, 77, 64, 1);
  color: rgba(24, 77, 64, var(--tw-text-opacity, 1));
}
.text-kids-dictionary-800\\/0{
  color: rgba(24, 77, 64, 0);
}
.text-kids-dictionary-800\\/10{
  color: rgba(24, 77, 64, 0.1);
}
.text-kids-dictionary-800\\/100{
  color: rgb(24, 77, 64);
}
.text-kids-dictionary-800\\/15{
  color: rgba(24, 77, 64, 0.15);
}
.text-kids-dictionary-800\\/20{
  color: rgba(24, 77, 64, 0.2);
}
.text-kids-dictionary-800\\/25{
  color: rgba(24, 77, 64, 0.25);
}
.text-kids-dictionary-800\\/30{
  color: rgba(24, 77, 64, 0.3);
}
.text-kids-dictionary-800\\/35{
  color: rgba(24, 77, 64, 0.35);
}
.text-kids-dictionary-800\\/40{
  color: rgba(24, 77, 64, 0.4);
}
.text-kids-dictionary-800\\/45{
  color: rgba(24, 77, 64, 0.45);
}
.text-kids-dictionary-800\\/5{
  color: rgba(24, 77, 64, 0.05);
}
.text-kids-dictionary-800\\/50{
  color: rgba(24, 77, 64, 0.5);
}
.text-kids-dictionary-800\\/55{
  color: rgba(24, 77, 64, 0.55);
}
.text-kids-dictionary-800\\/60{
  color: rgba(24, 77, 64, 0.6);
}
.text-kids-dictionary-800\\/65{
  color: rgba(24, 77, 64, 0.65);
}
.text-kids-dictionary-800\\/70{
  color: rgba(24, 77, 64, 0.7);
}
.text-kids-dictionary-800\\/75{
  color: rgba(24, 77, 64, 0.75);
}
.text-kids-dictionary-800\\/80{
  color: rgba(24, 77, 64, 0.8);
}
.text-kids-dictionary-800\\/85{
  color: rgba(24, 77, 64, 0.85);
}
.text-kids-dictionary-800\\/90{
  color: rgba(24, 77, 64, 0.9);
}
.text-kids-dictionary-800\\/95{
  color: rgba(24, 77, 64, 0.95);
}
.text-kids-dictionary-900{
  --tw-text-opacity: 1;
  color: rgba(20, 64, 54, 1);
  color: rgba(20, 64, 54, var(--tw-text-opacity, 1));
}
.text-kids-dictionary-900\\/0{
  color: rgba(20, 64, 54, 0);
}
.text-kids-dictionary-900\\/10{
  color: rgba(20, 64, 54, 0.1);
}
.text-kids-dictionary-900\\/100{
  color: rgb(20, 64, 54);
}
.text-kids-dictionary-900\\/15{
  color: rgba(20, 64, 54, 0.15);
}
.text-kids-dictionary-900\\/20{
  color: rgba(20, 64, 54, 0.2);
}
.text-kids-dictionary-900\\/25{
  color: rgba(20, 64, 54, 0.25);
}
.text-kids-dictionary-900\\/30{
  color: rgba(20, 64, 54, 0.3);
}
.text-kids-dictionary-900\\/35{
  color: rgba(20, 64, 54, 0.35);
}
.text-kids-dictionary-900\\/40{
  color: rgba(20, 64, 54, 0.4);
}
.text-kids-dictionary-900\\/45{
  color: rgba(20, 64, 54, 0.45);
}
.text-kids-dictionary-900\\/5{
  color: rgba(20, 64, 54, 0.05);
}
.text-kids-dictionary-900\\/50{
  color: rgba(20, 64, 54, 0.5);
}
.text-kids-dictionary-900\\/55{
  color: rgba(20, 64, 54, 0.55);
}
.text-kids-dictionary-900\\/60{
  color: rgba(20, 64, 54, 0.6);
}
.text-kids-dictionary-900\\/65{
  color: rgba(20, 64, 54, 0.65);
}
.text-kids-dictionary-900\\/70{
  color: rgba(20, 64, 54, 0.7);
}
.text-kids-dictionary-900\\/75{
  color: rgba(20, 64, 54, 0.75);
}
.text-kids-dictionary-900\\/80{
  color: rgba(20, 64, 54, 0.8);
}
.text-kids-dictionary-900\\/85{
  color: rgba(20, 64, 54, 0.85);
}
.text-kids-dictionary-900\\/90{
  color: rgba(20, 64, 54, 0.9);
}
.text-kids-dictionary-900\\/95{
  color: rgba(20, 64, 54, 0.95);
}
.text-kids-games-500{
  --tw-text-opacity: 1;
  color: rgba(81, 59, 86, 1);
  color: rgba(81, 59, 86, var(--tw-text-opacity, 1));
}
.text-kids-games-500\\/0{
  color: rgba(81, 59, 86, 0);
}
.text-kids-games-500\\/10{
  color: rgba(81, 59, 86, 0.1);
}
.text-kids-games-500\\/100{
  color: rgb(81, 59, 86);
}
.text-kids-games-500\\/15{
  color: rgba(81, 59, 86, 0.15);
}
.text-kids-games-500\\/20{
  color: rgba(81, 59, 86, 0.2);
}
.text-kids-games-500\\/25{
  color: rgba(81, 59, 86, 0.25);
}
.text-kids-games-500\\/30{
  color: rgba(81, 59, 86, 0.3);
}
.text-kids-games-500\\/35{
  color: rgba(81, 59, 86, 0.35);
}
.text-kids-games-500\\/40{
  color: rgba(81, 59, 86, 0.4);
}
.text-kids-games-500\\/45{
  color: rgba(81, 59, 86, 0.45);
}
.text-kids-games-500\\/5{
  color: rgba(81, 59, 86, 0.05);
}
.text-kids-games-500\\/50{
  color: rgba(81, 59, 86, 0.5);
}
.text-kids-games-500\\/55{
  color: rgba(81, 59, 86, 0.55);
}
.text-kids-games-500\\/60{
  color: rgba(81, 59, 86, 0.6);
}
.text-kids-games-500\\/65{
  color: rgba(81, 59, 86, 0.65);
}
.text-kids-games-500\\/70{
  color: rgba(81, 59, 86, 0.7);
}
.text-kids-games-500\\/75{
  color: rgba(81, 59, 86, 0.75);
}
.text-kids-games-500\\/80{
  color: rgba(81, 59, 86, 0.8);
}
.text-kids-games-500\\/85{
  color: rgba(81, 59, 86, 0.85);
}
.text-kids-games-500\\/90{
  color: rgba(81, 59, 86, 0.9);
}
.text-kids-games-500\\/95{
  color: rgba(81, 59, 86, 0.95);
}
.text-kids-games-900{
  --tw-text-opacity: 1;
  color: rgba(57, 41, 60, 1);
  color: rgba(57, 41, 60, var(--tw-text-opacity, 1));
}
.text-kids-games-900\\/0{
  color: rgba(57, 41, 60, 0);
}
.text-kids-games-900\\/10{
  color: rgba(57, 41, 60, 0.1);
}
.text-kids-games-900\\/100{
  color: rgb(57, 41, 60);
}
.text-kids-games-900\\/15{
  color: rgba(57, 41, 60, 0.15);
}
.text-kids-games-900\\/20{
  color: rgba(57, 41, 60, 0.2);
}
.text-kids-games-900\\/25{
  color: rgba(57, 41, 60, 0.25);
}
.text-kids-games-900\\/30{
  color: rgba(57, 41, 60, 0.3);
}
.text-kids-games-900\\/35{
  color: rgba(57, 41, 60, 0.35);
}
.text-kids-games-900\\/40{
  color: rgba(57, 41, 60, 0.4);
}
.text-kids-games-900\\/45{
  color: rgba(57, 41, 60, 0.45);
}
.text-kids-games-900\\/5{
  color: rgba(57, 41, 60, 0.05);
}
.text-kids-games-900\\/50{
  color: rgba(57, 41, 60, 0.5);
}
.text-kids-games-900\\/55{
  color: rgba(57, 41, 60, 0.55);
}
.text-kids-games-900\\/60{
  color: rgba(57, 41, 60, 0.6);
}
.text-kids-games-900\\/65{
  color: rgba(57, 41, 60, 0.65);
}
.text-kids-games-900\\/70{
  color: rgba(57, 41, 60, 0.7);
}
.text-kids-games-900\\/75{
  color: rgba(57, 41, 60, 0.75);
}
.text-kids-games-900\\/80{
  color: rgba(57, 41, 60, 0.8);
}
.text-kids-games-900\\/85{
  color: rgba(57, 41, 60, 0.85);
}
.text-kids-games-900\\/90{
  color: rgba(57, 41, 60, 0.9);
}
.text-kids-games-900\\/95{
  color: rgba(57, 41, 60, 0.95);
}
.text-kids-songs-500{
  --tw-text-opacity: 1;
  color: rgba(131, 0, 66, 1);
  color: rgba(131, 0, 66, var(--tw-text-opacity, 1));
}
.text-kids-songs-500\\/0{
  color: rgba(131, 0, 66, 0);
}
.text-kids-songs-500\\/10{
  color: rgba(131, 0, 66, 0.1);
}
.text-kids-songs-500\\/100{
  color: rgb(131, 0, 66);
}
.text-kids-songs-500\\/15{
  color: rgba(131, 0, 66, 0.15);
}
.text-kids-songs-500\\/20{
  color: rgba(131, 0, 66, 0.2);
}
.text-kids-songs-500\\/25{
  color: rgba(131, 0, 66, 0.25);
}
.text-kids-songs-500\\/30{
  color: rgba(131, 0, 66, 0.3);
}
.text-kids-songs-500\\/35{
  color: rgba(131, 0, 66, 0.35);
}
.text-kids-songs-500\\/40{
  color: rgba(131, 0, 66, 0.4);
}
.text-kids-songs-500\\/45{
  color: rgba(131, 0, 66, 0.45);
}
.text-kids-songs-500\\/5{
  color: rgba(131, 0, 66, 0.05);
}
.text-kids-songs-500\\/50{
  color: rgba(131, 0, 66, 0.5);
}
.text-kids-songs-500\\/55{
  color: rgba(131, 0, 66, 0.55);
}
.text-kids-songs-500\\/60{
  color: rgba(131, 0, 66, 0.6);
}
.text-kids-songs-500\\/65{
  color: rgba(131, 0, 66, 0.65);
}
.text-kids-songs-500\\/70{
  color: rgba(131, 0, 66, 0.7);
}
.text-kids-songs-500\\/75{
  color: rgba(131, 0, 66, 0.75);
}
.text-kids-songs-500\\/80{
  color: rgba(131, 0, 66, 0.8);
}
.text-kids-songs-500\\/85{
  color: rgba(131, 0, 66, 0.85);
}
.text-kids-songs-500\\/90{
  color: rgba(131, 0, 66, 0.9);
}
.text-kids-songs-500\\/95{
  color: rgba(131, 0, 66, 0.95);
}
.text-kids-songs-900{
  --tw-text-opacity: 1;
  color: rgba(92, 0, 46, 1);
  color: rgba(92, 0, 46, var(--tw-text-opacity, 1));
}
.text-kids-songs-900\\/0{
  color: rgba(92, 0, 46, 0);
}
.text-kids-songs-900\\/10{
  color: rgba(92, 0, 46, 0.1);
}
.text-kids-songs-900\\/100{
  color: rgb(92, 0, 46);
}
.text-kids-songs-900\\/15{
  color: rgba(92, 0, 46, 0.15);
}
.text-kids-songs-900\\/20{
  color: rgba(92, 0, 46, 0.2);
}
.text-kids-songs-900\\/25{
  color: rgba(92, 0, 46, 0.25);
}
.text-kids-songs-900\\/30{
  color: rgba(92, 0, 46, 0.3);
}
.text-kids-songs-900\\/35{
  color: rgba(92, 0, 46, 0.35);
}
.text-kids-songs-900\\/40{
  color: rgba(92, 0, 46, 0.4);
}
.text-kids-songs-900\\/45{
  color: rgba(92, 0, 46, 0.45);
}
.text-kids-songs-900\\/5{
  color: rgba(92, 0, 46, 0.05);
}
.text-kids-songs-900\\/50{
  color: rgba(92, 0, 46, 0.5);
}
.text-kids-songs-900\\/55{
  color: rgba(92, 0, 46, 0.55);
}
.text-kids-songs-900\\/60{
  color: rgba(92, 0, 46, 0.6);
}
.text-kids-songs-900\\/65{
  color: rgba(92, 0, 46, 0.65);
}
.text-kids-songs-900\\/70{
  color: rgba(92, 0, 46, 0.7);
}
.text-kids-songs-900\\/75{
  color: rgba(92, 0, 46, 0.75);
}
.text-kids-songs-900\\/80{
  color: rgba(92, 0, 46, 0.8);
}
.text-kids-songs-900\\/85{
  color: rgba(92, 0, 46, 0.85);
}
.text-kids-songs-900\\/90{
  color: rgba(92, 0, 46, 0.9);
}
.text-kids-songs-900\\/95{
  color: rgba(92, 0, 46, 0.95);
}
.text-kids-stories-500{
  --tw-text-opacity: 1;
  color: rgba(233, 196, 106, 1);
  color: rgba(233, 196, 106, var(--tw-text-opacity, 1));
}
.text-kids-stories-500\\/0{
  color: rgba(233, 196, 106, 0);
}
.text-kids-stories-500\\/10{
  color: rgba(233, 196, 106, 0.1);
}
.text-kids-stories-500\\/100{
  color: rgb(233, 196, 106);
}
.text-kids-stories-500\\/15{
  color: rgba(233, 196, 106, 0.15);
}
.text-kids-stories-500\\/20{
  color: rgba(233, 196, 106, 0.2);
}
.text-kids-stories-500\\/25{
  color: rgba(233, 196, 106, 0.25);
}
.text-kids-stories-500\\/30{
  color: rgba(233, 196, 106, 0.3);
}
.text-kids-stories-500\\/35{
  color: rgba(233, 196, 106, 0.35);
}
.text-kids-stories-500\\/40{
  color: rgba(233, 196, 106, 0.4);
}
.text-kids-stories-500\\/45{
  color: rgba(233, 196, 106, 0.45);
}
.text-kids-stories-500\\/5{
  color: rgba(233, 196, 106, 0.05);
}
.text-kids-stories-500\\/50{
  color: rgba(233, 196, 106, 0.5);
}
.text-kids-stories-500\\/55{
  color: rgba(233, 196, 106, 0.55);
}
.text-kids-stories-500\\/60{
  color: rgba(233, 196, 106, 0.6);
}
.text-kids-stories-500\\/65{
  color: rgba(233, 196, 106, 0.65);
}
.text-kids-stories-500\\/70{
  color: rgba(233, 196, 106, 0.7);
}
.text-kids-stories-500\\/75{
  color: rgba(233, 196, 106, 0.75);
}
.text-kids-stories-500\\/80{
  color: rgba(233, 196, 106, 0.8);
}
.text-kids-stories-500\\/85{
  color: rgba(233, 196, 106, 0.85);
}
.text-kids-stories-500\\/90{
  color: rgba(233, 196, 106, 0.9);
}
.text-kids-stories-500\\/95{
  color: rgba(233, 196, 106, 0.95);
}
.text-kids-stories-900{
  --tw-text-opacity: 1;
  color: rgba(163, 137, 74, 1);
  color: rgba(163, 137, 74, var(--tw-text-opacity, 1));
}
.text-kids-stories-900\\/0{
  color: rgba(163, 137, 74, 0);
}
.text-kids-stories-900\\/10{
  color: rgba(163, 137, 74, 0.1);
}
.text-kids-stories-900\\/100{
  color: rgb(163, 137, 74);
}
.text-kids-stories-900\\/15{
  color: rgba(163, 137, 74, 0.15);
}
.text-kids-stories-900\\/20{
  color: rgba(163, 137, 74, 0.2);
}
.text-kids-stories-900\\/25{
  color: rgba(163, 137, 74, 0.25);
}
.text-kids-stories-900\\/30{
  color: rgba(163, 137, 74, 0.3);
}
.text-kids-stories-900\\/35{
  color: rgba(163, 137, 74, 0.35);
}
.text-kids-stories-900\\/40{
  color: rgba(163, 137, 74, 0.4);
}
.text-kids-stories-900\\/45{
  color: rgba(163, 137, 74, 0.45);
}
.text-kids-stories-900\\/5{
  color: rgba(163, 137, 74, 0.05);
}
.text-kids-stories-900\\/50{
  color: rgba(163, 137, 74, 0.5);
}
.text-kids-stories-900\\/55{
  color: rgba(163, 137, 74, 0.55);
}
.text-kids-stories-900\\/60{
  color: rgba(163, 137, 74, 0.6);
}
.text-kids-stories-900\\/65{
  color: rgba(163, 137, 74, 0.65);
}
.text-kids-stories-900\\/70{
  color: rgba(163, 137, 74, 0.7);
}
.text-kids-stories-900\\/75{
  color: rgba(163, 137, 74, 0.75);
}
.text-kids-stories-900\\/80{
  color: rgba(163, 137, 74, 0.8);
}
.text-kids-stories-900\\/85{
  color: rgba(163, 137, 74, 0.85);
}
.text-kids-stories-900\\/90{
  color: rgba(163, 137, 74, 0.9);
}
.text-kids-stories-900\\/95{
  color: rgba(163, 137, 74, 0.95);
}
.text-ochre-100{
  --tw-text-opacity: 1;
  color: rgba(245, 237, 208, 1);
  color: rgba(245, 237, 208, var(--tw-text-opacity, 1));
}
.text-ochre-100\\/0{
  color: rgba(245, 237, 208, 0);
}
.text-ochre-100\\/10{
  color: rgba(245, 237, 208, 0.1);
}
.text-ochre-100\\/100{
  color: rgb(245, 237, 208);
}
.text-ochre-100\\/15{
  color: rgba(245, 237, 208, 0.15);
}
.text-ochre-100\\/20{
  color: rgba(245, 237, 208, 0.2);
}
.text-ochre-100\\/25{
  color: rgba(245, 237, 208, 0.25);
}
.text-ochre-100\\/30{
  color: rgba(245, 237, 208, 0.3);
}
.text-ochre-100\\/35{
  color: rgba(245, 237, 208, 0.35);
}
.text-ochre-100\\/40{
  color: rgba(245, 237, 208, 0.4);
}
.text-ochre-100\\/45{
  color: rgba(245, 237, 208, 0.45);
}
.text-ochre-100\\/5{
  color: rgba(245, 237, 208, 0.05);
}
.text-ochre-100\\/50{
  color: rgba(245, 237, 208, 0.5);
}
.text-ochre-100\\/55{
  color: rgba(245, 237, 208, 0.55);
}
.text-ochre-100\\/60{
  color: rgba(245, 237, 208, 0.6);
}
.text-ochre-100\\/65{
  color: rgba(245, 237, 208, 0.65);
}
.text-ochre-100\\/70{
  color: rgba(245, 237, 208, 0.7);
}
.text-ochre-100\\/75{
  color: rgba(245, 237, 208, 0.75);
}
.text-ochre-100\\/80{
  color: rgba(245, 237, 208, 0.8);
}
.text-ochre-100\\/85{
  color: rgba(245, 237, 208, 0.85);
}
.text-ochre-100\\/90{
  color: rgba(245, 237, 208, 0.9);
}
.text-ochre-100\\/95{
  color: rgba(245, 237, 208, 0.95);
}
.text-ochre-200{
  --tw-text-opacity: 1;
  color: rgba(235, 217, 156, 1);
  color: rgba(235, 217, 156, var(--tw-text-opacity, 1));
}
.text-ochre-200\\/0{
  color: rgba(235, 217, 156, 0);
}
.text-ochre-200\\/10{
  color: rgba(235, 217, 156, 0.1);
}
.text-ochre-200\\/100{
  color: rgb(235, 217, 156);
}
.text-ochre-200\\/15{
  color: rgba(235, 217, 156, 0.15);
}
.text-ochre-200\\/20{
  color: rgba(235, 217, 156, 0.2);
}
.text-ochre-200\\/25{
  color: rgba(235, 217, 156, 0.25);
}
.text-ochre-200\\/30{
  color: rgba(235, 217, 156, 0.3);
}
.text-ochre-200\\/35{
  color: rgba(235, 217, 156, 0.35);
}
.text-ochre-200\\/40{
  color: rgba(235, 217, 156, 0.4);
}
.text-ochre-200\\/45{
  color: rgba(235, 217, 156, 0.45);
}
.text-ochre-200\\/5{
  color: rgba(235, 217, 156, 0.05);
}
.text-ochre-200\\/50{
  color: rgba(235, 217, 156, 0.5);
}
.text-ochre-200\\/55{
  color: rgba(235, 217, 156, 0.55);
}
.text-ochre-200\\/60{
  color: rgba(235, 217, 156, 0.6);
}
.text-ochre-200\\/65{
  color: rgba(235, 217, 156, 0.65);
}
.text-ochre-200\\/70{
  color: rgba(235, 217, 156, 0.7);
}
.text-ochre-200\\/75{
  color: rgba(235, 217, 156, 0.75);
}
.text-ochre-200\\/80{
  color: rgba(235, 217, 156, 0.8);
}
.text-ochre-200\\/85{
  color: rgba(235, 217, 156, 0.85);
}
.text-ochre-200\\/90{
  color: rgba(235, 217, 156, 0.9);
}
.text-ochre-200\\/95{
  color: rgba(235, 217, 156, 0.95);
}
.text-ochre-300{
  --tw-text-opacity: 1;
  color: rgba(225, 194, 104, 1);
  color: rgba(225, 194, 104, var(--tw-text-opacity, 1));
}
.text-ochre-300\\/0{
  color: rgba(225, 194, 104, 0);
}
.text-ochre-300\\/10{
  color: rgba(225, 194, 104, 0.1);
}
.text-ochre-300\\/100{
  color: rgb(225, 194, 104);
}
.text-ochre-300\\/15{
  color: rgba(225, 194, 104, 0.15);
}
.text-ochre-300\\/20{
  color: rgba(225, 194, 104, 0.2);
}
.text-ochre-300\\/25{
  color: rgba(225, 194, 104, 0.25);
}
.text-ochre-300\\/30{
  color: rgba(225, 194, 104, 0.3);
}
.text-ochre-300\\/35{
  color: rgba(225, 194, 104, 0.35);
}
.text-ochre-300\\/40{
  color: rgba(225, 194, 104, 0.4);
}
.text-ochre-300\\/45{
  color: rgba(225, 194, 104, 0.45);
}
.text-ochre-300\\/5{
  color: rgba(225, 194, 104, 0.05);
}
.text-ochre-300\\/50{
  color: rgba(225, 194, 104, 0.5);
}
.text-ochre-300\\/55{
  color: rgba(225, 194, 104, 0.55);
}
.text-ochre-300\\/60{
  color: rgba(225, 194, 104, 0.6);
}
.text-ochre-300\\/65{
  color: rgba(225, 194, 104, 0.65);
}
.text-ochre-300\\/70{
  color: rgba(225, 194, 104, 0.7);
}
.text-ochre-300\\/75{
  color: rgba(225, 194, 104, 0.75);
}
.text-ochre-300\\/80{
  color: rgba(225, 194, 104, 0.8);
}
.text-ochre-300\\/85{
  color: rgba(225, 194, 104, 0.85);
}
.text-ochre-300\\/90{
  color: rgba(225, 194, 104, 0.9);
}
.text-ochre-300\\/95{
  color: rgba(225, 194, 104, 0.95);
}
.text-ochre-400{
  --tw-text-opacity: 1;
  color: rgba(218, 173, 69, 1);
  color: rgba(218, 173, 69, var(--tw-text-opacity, 1));
}
.text-ochre-400\\/0{
  color: rgba(218, 173, 69, 0);
}
.text-ochre-400\\/10{
  color: rgba(218, 173, 69, 0.1);
}
.text-ochre-400\\/100{
  color: rgb(218, 173, 69);
}
.text-ochre-400\\/15{
  color: rgba(218, 173, 69, 0.15);
}
.text-ochre-400\\/20{
  color: rgba(218, 173, 69, 0.2);
}
.text-ochre-400\\/25{
  color: rgba(218, 173, 69, 0.25);
}
.text-ochre-400\\/30{
  color: rgba(218, 173, 69, 0.3);
}
.text-ochre-400\\/35{
  color: rgba(218, 173, 69, 0.35);
}
.text-ochre-400\\/40{
  color: rgba(218, 173, 69, 0.4);
}
.text-ochre-400\\/45{
  color: rgba(218, 173, 69, 0.45);
}
.text-ochre-400\\/5{
  color: rgba(218, 173, 69, 0.05);
}
.text-ochre-400\\/50{
  color: rgba(218, 173, 69, 0.5);
}
.text-ochre-400\\/55{
  color: rgba(218, 173, 69, 0.55);
}
.text-ochre-400\\/60{
  color: rgba(218, 173, 69, 0.6);
}
.text-ochre-400\\/65{
  color: rgba(218, 173, 69, 0.65);
}
.text-ochre-400\\/70{
  color: rgba(218, 173, 69, 0.7);
}
.text-ochre-400\\/75{
  color: rgba(218, 173, 69, 0.75);
}
.text-ochre-400\\/80{
  color: rgba(218, 173, 69, 0.8);
}
.text-ochre-400\\/85{
  color: rgba(218, 173, 69, 0.85);
}
.text-ochre-400\\/90{
  color: rgba(218, 173, 69, 0.9);
}
.text-ochre-400\\/95{
  color: rgba(218, 173, 69, 0.95);
}
.text-ochre-500{
  --tw-text-opacity: 1;
  color: rgba(209, 145, 47, 1);
  color: rgba(209, 145, 47, var(--tw-text-opacity, 1));
}
.text-ochre-500\\/0{
  color: rgba(209, 145, 47, 0);
}
.text-ochre-500\\/10{
  color: rgba(209, 145, 47, 0.1);
}
.text-ochre-500\\/100{
  color: rgb(209, 145, 47);
}
.text-ochre-500\\/15{
  color: rgba(209, 145, 47, 0.15);
}
.text-ochre-500\\/20{
  color: rgba(209, 145, 47, 0.2);
}
.text-ochre-500\\/25{
  color: rgba(209, 145, 47, 0.25);
}
.text-ochre-500\\/30{
  color: rgba(209, 145, 47, 0.3);
}
.text-ochre-500\\/35{
  color: rgba(209, 145, 47, 0.35);
}
.text-ochre-500\\/40{
  color: rgba(209, 145, 47, 0.4);
}
.text-ochre-500\\/45{
  color: rgba(209, 145, 47, 0.45);
}
.text-ochre-500\\/5{
  color: rgba(209, 145, 47, 0.05);
}
.text-ochre-500\\/50{
  color: rgba(209, 145, 47, 0.5);
}
.text-ochre-500\\/55{
  color: rgba(209, 145, 47, 0.55);
}
.text-ochre-500\\/60{
  color: rgba(209, 145, 47, 0.6);
}
.text-ochre-500\\/65{
  color: rgba(209, 145, 47, 0.65);
}
.text-ochre-500\\/70{
  color: rgba(209, 145, 47, 0.7);
}
.text-ochre-500\\/75{
  color: rgba(209, 145, 47, 0.75);
}
.text-ochre-500\\/80{
  color: rgba(209, 145, 47, 0.8);
}
.text-ochre-500\\/85{
  color: rgba(209, 145, 47, 0.85);
}
.text-ochre-500\\/90{
  color: rgba(209, 145, 47, 0.9);
}
.text-ochre-500\\/95{
  color: rgba(209, 145, 47, 0.95);
}
.text-ochre-600{
  --tw-text-opacity: 1;
  color: rgba(195, 120, 41, 1);
  color: rgba(195, 120, 41, var(--tw-text-opacity, 1));
}
.text-ochre-600\\/0{
  color: rgba(195, 120, 41, 0);
}
.text-ochre-600\\/10{
  color: rgba(195, 120, 41, 0.1);
}
.text-ochre-600\\/100{
  color: rgb(195, 120, 41);
}
.text-ochre-600\\/15{
  color: rgba(195, 120, 41, 0.15);
}
.text-ochre-600\\/20{
  color: rgba(195, 120, 41, 0.2);
}
.text-ochre-600\\/25{
  color: rgba(195, 120, 41, 0.25);
}
.text-ochre-600\\/30{
  color: rgba(195, 120, 41, 0.3);
}
.text-ochre-600\\/35{
  color: rgba(195, 120, 41, 0.35);
}
.text-ochre-600\\/40{
  color: rgba(195, 120, 41, 0.4);
}
.text-ochre-600\\/45{
  color: rgba(195, 120, 41, 0.45);
}
.text-ochre-600\\/5{
  color: rgba(195, 120, 41, 0.05);
}
.text-ochre-600\\/50{
  color: rgba(195, 120, 41, 0.5);
}
.text-ochre-600\\/55{
  color: rgba(195, 120, 41, 0.55);
}
.text-ochre-600\\/60{
  color: rgba(195, 120, 41, 0.6);
}
.text-ochre-600\\/65{
  color: rgba(195, 120, 41, 0.65);
}
.text-ochre-600\\/70{
  color: rgba(195, 120, 41, 0.7);
}
.text-ochre-600\\/75{
  color: rgba(195, 120, 41, 0.75);
}
.text-ochre-600\\/80{
  color: rgba(195, 120, 41, 0.8);
}
.text-ochre-600\\/85{
  color: rgba(195, 120, 41, 0.85);
}
.text-ochre-600\\/90{
  color: rgba(195, 120, 41, 0.9);
}
.text-ochre-600\\/95{
  color: rgba(195, 120, 41, 0.95);
}
.text-ochre-700{
  --tw-text-opacity: 1;
  color: rgba(153, 84, 36, 1);
  color: rgba(153, 84, 36, var(--tw-text-opacity, 1));
}
.text-ochre-700\\/0{
  color: rgba(153, 84, 36, 0);
}
.text-ochre-700\\/10{
  color: rgba(153, 84, 36, 0.1);
}
.text-ochre-700\\/100{
  color: rgb(153, 84, 36);
}
.text-ochre-700\\/15{
  color: rgba(153, 84, 36, 0.15);
}
.text-ochre-700\\/20{
  color: rgba(153, 84, 36, 0.2);
}
.text-ochre-700\\/25{
  color: rgba(153, 84, 36, 0.25);
}
.text-ochre-700\\/30{
  color: rgba(153, 84, 36, 0.3);
}
.text-ochre-700\\/35{
  color: rgba(153, 84, 36, 0.35);
}
.text-ochre-700\\/40{
  color: rgba(153, 84, 36, 0.4);
}
.text-ochre-700\\/45{
  color: rgba(153, 84, 36, 0.45);
}
.text-ochre-700\\/5{
  color: rgba(153, 84, 36, 0.05);
}
.text-ochre-700\\/50{
  color: rgba(153, 84, 36, 0.5);
}
.text-ochre-700\\/55{
  color: rgba(153, 84, 36, 0.55);
}
.text-ochre-700\\/60{
  color: rgba(153, 84, 36, 0.6);
}
.text-ochre-700\\/65{
  color: rgba(153, 84, 36, 0.65);
}
.text-ochre-700\\/70{
  color: rgba(153, 84, 36, 0.7);
}
.text-ochre-700\\/75{
  color: rgba(153, 84, 36, 0.75);
}
.text-ochre-700\\/80{
  color: rgba(153, 84, 36, 0.8);
}
.text-ochre-700\\/85{
  color: rgba(153, 84, 36, 0.85);
}
.text-ochre-700\\/90{
  color: rgba(153, 84, 36, 0.9);
}
.text-ochre-700\\/95{
  color: rgba(153, 84, 36, 0.95);
}
.text-ochre-800{
  --tw-text-opacity: 1;
  color: rgba(126, 67, 34, 1);
  color: rgba(126, 67, 34, var(--tw-text-opacity, 1));
}
.text-ochre-800\\/0{
  color: rgba(126, 67, 34, 0);
}
.text-ochre-800\\/10{
  color: rgba(126, 67, 34, 0.1);
}
.text-ochre-800\\/100{
  color: rgb(126, 67, 34);
}
.text-ochre-800\\/15{
  color: rgba(126, 67, 34, 0.15);
}
.text-ochre-800\\/20{
  color: rgba(126, 67, 34, 0.2);
}
.text-ochre-800\\/25{
  color: rgba(126, 67, 34, 0.25);
}
.text-ochre-800\\/30{
  color: rgba(126, 67, 34, 0.3);
}
.text-ochre-800\\/35{
  color: rgba(126, 67, 34, 0.35);
}
.text-ochre-800\\/40{
  color: rgba(126, 67, 34, 0.4);
}
.text-ochre-800\\/45{
  color: rgba(126, 67, 34, 0.45);
}
.text-ochre-800\\/5{
  color: rgba(126, 67, 34, 0.05);
}
.text-ochre-800\\/50{
  color: rgba(126, 67, 34, 0.5);
}
.text-ochre-800\\/55{
  color: rgba(126, 67, 34, 0.55);
}
.text-ochre-800\\/60{
  color: rgba(126, 67, 34, 0.6);
}
.text-ochre-800\\/65{
  color: rgba(126, 67, 34, 0.65);
}
.text-ochre-800\\/70{
  color: rgba(126, 67, 34, 0.7);
}
.text-ochre-800\\/75{
  color: rgba(126, 67, 34, 0.75);
}
.text-ochre-800\\/80{
  color: rgba(126, 67, 34, 0.8);
}
.text-ochre-800\\/85{
  color: rgba(126, 67, 34, 0.85);
}
.text-ochre-800\\/90{
  color: rgba(126, 67, 34, 0.9);
}
.text-ochre-800\\/95{
  color: rgba(126, 67, 34, 0.95);
}
.text-ochre-900{
  --tw-text-opacity: 1;
  color: rgba(104, 56, 31, 1);
  color: rgba(104, 56, 31, var(--tw-text-opacity, 1));
}
.text-ochre-900\\/0{
  color: rgba(104, 56, 31, 0);
}
.text-ochre-900\\/10{
  color: rgba(104, 56, 31, 0.1);
}
.text-ochre-900\\/100{
  color: rgb(104, 56, 31);
}
.text-ochre-900\\/15{
  color: rgba(104, 56, 31, 0.15);
}
.text-ochre-900\\/20{
  color: rgba(104, 56, 31, 0.2);
}
.text-ochre-900\\/25{
  color: rgba(104, 56, 31, 0.25);
}
.text-ochre-900\\/30{
  color: rgba(104, 56, 31, 0.3);
}
.text-ochre-900\\/35{
  color: rgba(104, 56, 31, 0.35);
}
.text-ochre-900\\/40{
  color: rgba(104, 56, 31, 0.4);
}
.text-ochre-900\\/45{
  color: rgba(104, 56, 31, 0.45);
}
.text-ochre-900\\/5{
  color: rgba(104, 56, 31, 0.05);
}
.text-ochre-900\\/50{
  color: rgba(104, 56, 31, 0.5);
}
.text-ochre-900\\/55{
  color: rgba(104, 56, 31, 0.55);
}
.text-ochre-900\\/60{
  color: rgba(104, 56, 31, 0.6);
}
.text-ochre-900\\/65{
  color: rgba(104, 56, 31, 0.65);
}
.text-ochre-900\\/70{
  color: rgba(104, 56, 31, 0.7);
}
.text-ochre-900\\/75{
  color: rgba(104, 56, 31, 0.75);
}
.text-ochre-900\\/80{
  color: rgba(104, 56, 31, 0.8);
}
.text-ochre-900\\/85{
  color: rgba(104, 56, 31, 0.85);
}
.text-ochre-900\\/90{
  color: rgba(104, 56, 31, 0.9);
}
.text-ochre-900\\/95{
  color: rgba(104, 56, 31, 0.95);
}
.text-ochre-950{
  --tw-text-opacity: 1;
  color: rgba(59, 28, 13, 1);
  color: rgba(59, 28, 13, var(--tw-text-opacity, 1));
}
.text-ochre-950\\/0{
  color: rgba(59, 28, 13, 0);
}
.text-ochre-950\\/10{
  color: rgba(59, 28, 13, 0.1);
}
.text-ochre-950\\/100{
  color: rgb(59, 28, 13);
}
.text-ochre-950\\/15{
  color: rgba(59, 28, 13, 0.15);
}
.text-ochre-950\\/20{
  color: rgba(59, 28, 13, 0.2);
}
.text-ochre-950\\/25{
  color: rgba(59, 28, 13, 0.25);
}
.text-ochre-950\\/30{
  color: rgba(59, 28, 13, 0.3);
}
.text-ochre-950\\/35{
  color: rgba(59, 28, 13, 0.35);
}
.text-ochre-950\\/40{
  color: rgba(59, 28, 13, 0.4);
}
.text-ochre-950\\/45{
  color: rgba(59, 28, 13, 0.45);
}
.text-ochre-950\\/5{
  color: rgba(59, 28, 13, 0.05);
}
.text-ochre-950\\/50{
  color: rgba(59, 28, 13, 0.5);
}
.text-ochre-950\\/55{
  color: rgba(59, 28, 13, 0.55);
}
.text-ochre-950\\/60{
  color: rgba(59, 28, 13, 0.6);
}
.text-ochre-950\\/65{
  color: rgba(59, 28, 13, 0.65);
}
.text-ochre-950\\/70{
  color: rgba(59, 28, 13, 0.7);
}
.text-ochre-950\\/75{
  color: rgba(59, 28, 13, 0.75);
}
.text-ochre-950\\/80{
  color: rgba(59, 28, 13, 0.8);
}
.text-ochre-950\\/85{
  color: rgba(59, 28, 13, 0.85);
}
.text-ochre-950\\/90{
  color: rgba(59, 28, 13, 0.9);
}
.text-ochre-950\\/95{
  color: rgba(59, 28, 13, 0.95);
}
.text-phrase-color-100{
  --tw-text-opacity: 1;
  color: rgba(245, 237, 208, 1);
  color: rgba(245, 237, 208, var(--tw-text-opacity, 1));
}
.text-phrase-color-100\\/0{
  color: rgba(245, 237, 208, 0);
}
.text-phrase-color-100\\/10{
  color: rgba(245, 237, 208, 0.1);
}
.text-phrase-color-100\\/100{
  color: rgb(245, 237, 208);
}
.text-phrase-color-100\\/15{
  color: rgba(245, 237, 208, 0.15);
}
.text-phrase-color-100\\/20{
  color: rgba(245, 237, 208, 0.2);
}
.text-phrase-color-100\\/25{
  color: rgba(245, 237, 208, 0.25);
}
.text-phrase-color-100\\/30{
  color: rgba(245, 237, 208, 0.3);
}
.text-phrase-color-100\\/35{
  color: rgba(245, 237, 208, 0.35);
}
.text-phrase-color-100\\/40{
  color: rgba(245, 237, 208, 0.4);
}
.text-phrase-color-100\\/45{
  color: rgba(245, 237, 208, 0.45);
}
.text-phrase-color-100\\/5{
  color: rgba(245, 237, 208, 0.05);
}
.text-phrase-color-100\\/50{
  color: rgba(245, 237, 208, 0.5);
}
.text-phrase-color-100\\/55{
  color: rgba(245, 237, 208, 0.55);
}
.text-phrase-color-100\\/60{
  color: rgba(245, 237, 208, 0.6);
}
.text-phrase-color-100\\/65{
  color: rgba(245, 237, 208, 0.65);
}
.text-phrase-color-100\\/70{
  color: rgba(245, 237, 208, 0.7);
}
.text-phrase-color-100\\/75{
  color: rgba(245, 237, 208, 0.75);
}
.text-phrase-color-100\\/80{
  color: rgba(245, 237, 208, 0.8);
}
.text-phrase-color-100\\/85{
  color: rgba(245, 237, 208, 0.85);
}
.text-phrase-color-100\\/90{
  color: rgba(245, 237, 208, 0.9);
}
.text-phrase-color-100\\/95{
  color: rgba(245, 237, 208, 0.95);
}
.text-phrase-color-200{
  --tw-text-opacity: 1;
  color: rgba(235, 217, 156, 1);
  color: rgba(235, 217, 156, var(--tw-text-opacity, 1));
}
.text-phrase-color-200\\/0{
  color: rgba(235, 217, 156, 0);
}
.text-phrase-color-200\\/10{
  color: rgba(235, 217, 156, 0.1);
}
.text-phrase-color-200\\/100{
  color: rgb(235, 217, 156);
}
.text-phrase-color-200\\/15{
  color: rgba(235, 217, 156, 0.15);
}
.text-phrase-color-200\\/20{
  color: rgba(235, 217, 156, 0.2);
}
.text-phrase-color-200\\/25{
  color: rgba(235, 217, 156, 0.25);
}
.text-phrase-color-200\\/30{
  color: rgba(235, 217, 156, 0.3);
}
.text-phrase-color-200\\/35{
  color: rgba(235, 217, 156, 0.35);
}
.text-phrase-color-200\\/40{
  color: rgba(235, 217, 156, 0.4);
}
.text-phrase-color-200\\/45{
  color: rgba(235, 217, 156, 0.45);
}
.text-phrase-color-200\\/5{
  color: rgba(235, 217, 156, 0.05);
}
.text-phrase-color-200\\/50{
  color: rgba(235, 217, 156, 0.5);
}
.text-phrase-color-200\\/55{
  color: rgba(235, 217, 156, 0.55);
}
.text-phrase-color-200\\/60{
  color: rgba(235, 217, 156, 0.6);
}
.text-phrase-color-200\\/65{
  color: rgba(235, 217, 156, 0.65);
}
.text-phrase-color-200\\/70{
  color: rgba(235, 217, 156, 0.7);
}
.text-phrase-color-200\\/75{
  color: rgba(235, 217, 156, 0.75);
}
.text-phrase-color-200\\/80{
  color: rgba(235, 217, 156, 0.8);
}
.text-phrase-color-200\\/85{
  color: rgba(235, 217, 156, 0.85);
}
.text-phrase-color-200\\/90{
  color: rgba(235, 217, 156, 0.9);
}
.text-phrase-color-200\\/95{
  color: rgba(235, 217, 156, 0.95);
}
.text-phrase-color-300{
  --tw-text-opacity: 1;
  color: rgba(225, 194, 104, 1);
  color: rgba(225, 194, 104, var(--tw-text-opacity, 1));
}
.text-phrase-color-300\\/0{
  color: rgba(225, 194, 104, 0);
}
.text-phrase-color-300\\/10{
  color: rgba(225, 194, 104, 0.1);
}
.text-phrase-color-300\\/100{
  color: rgb(225, 194, 104);
}
.text-phrase-color-300\\/15{
  color: rgba(225, 194, 104, 0.15);
}
.text-phrase-color-300\\/20{
  color: rgba(225, 194, 104, 0.2);
}
.text-phrase-color-300\\/25{
  color: rgba(225, 194, 104, 0.25);
}
.text-phrase-color-300\\/30{
  color: rgba(225, 194, 104, 0.3);
}
.text-phrase-color-300\\/35{
  color: rgba(225, 194, 104, 0.35);
}
.text-phrase-color-300\\/40{
  color: rgba(225, 194, 104, 0.4);
}
.text-phrase-color-300\\/45{
  color: rgba(225, 194, 104, 0.45);
}
.text-phrase-color-300\\/5{
  color: rgba(225, 194, 104, 0.05);
}
.text-phrase-color-300\\/50{
  color: rgba(225, 194, 104, 0.5);
}
.text-phrase-color-300\\/55{
  color: rgba(225, 194, 104, 0.55);
}
.text-phrase-color-300\\/60{
  color: rgba(225, 194, 104, 0.6);
}
.text-phrase-color-300\\/65{
  color: rgba(225, 194, 104, 0.65);
}
.text-phrase-color-300\\/70{
  color: rgba(225, 194, 104, 0.7);
}
.text-phrase-color-300\\/75{
  color: rgba(225, 194, 104, 0.75);
}
.text-phrase-color-300\\/80{
  color: rgba(225, 194, 104, 0.8);
}
.text-phrase-color-300\\/85{
  color: rgba(225, 194, 104, 0.85);
}
.text-phrase-color-300\\/90{
  color: rgba(225, 194, 104, 0.9);
}
.text-phrase-color-300\\/95{
  color: rgba(225, 194, 104, 0.95);
}
.text-phrase-color-400{
  --tw-text-opacity: 1;
  color: rgba(218, 173, 69, 1);
  color: rgba(218, 173, 69, var(--tw-text-opacity, 1));
}
.text-phrase-color-400\\/0{
  color: rgba(218, 173, 69, 0);
}
.text-phrase-color-400\\/10{
  color: rgba(218, 173, 69, 0.1);
}
.text-phrase-color-400\\/100{
  color: rgb(218, 173, 69);
}
.text-phrase-color-400\\/15{
  color: rgba(218, 173, 69, 0.15);
}
.text-phrase-color-400\\/20{
  color: rgba(218, 173, 69, 0.2);
}
.text-phrase-color-400\\/25{
  color: rgba(218, 173, 69, 0.25);
}
.text-phrase-color-400\\/30{
  color: rgba(218, 173, 69, 0.3);
}
.text-phrase-color-400\\/35{
  color: rgba(218, 173, 69, 0.35);
}
.text-phrase-color-400\\/40{
  color: rgba(218, 173, 69, 0.4);
}
.text-phrase-color-400\\/45{
  color: rgba(218, 173, 69, 0.45);
}
.text-phrase-color-400\\/5{
  color: rgba(218, 173, 69, 0.05);
}
.text-phrase-color-400\\/50{
  color: rgba(218, 173, 69, 0.5);
}
.text-phrase-color-400\\/55{
  color: rgba(218, 173, 69, 0.55);
}
.text-phrase-color-400\\/60{
  color: rgba(218, 173, 69, 0.6);
}
.text-phrase-color-400\\/65{
  color: rgba(218, 173, 69, 0.65);
}
.text-phrase-color-400\\/70{
  color: rgba(218, 173, 69, 0.7);
}
.text-phrase-color-400\\/75{
  color: rgba(218, 173, 69, 0.75);
}
.text-phrase-color-400\\/80{
  color: rgba(218, 173, 69, 0.8);
}
.text-phrase-color-400\\/85{
  color: rgba(218, 173, 69, 0.85);
}
.text-phrase-color-400\\/90{
  color: rgba(218, 173, 69, 0.9);
}
.text-phrase-color-400\\/95{
  color: rgba(218, 173, 69, 0.95);
}
.text-phrase-color-500{
  --tw-text-opacity: 1;
  color: rgba(209, 145, 47, 1);
  color: rgba(209, 145, 47, var(--tw-text-opacity, 1));
}
.text-phrase-color-500\\/0{
  color: rgba(209, 145, 47, 0);
}
.text-phrase-color-500\\/10{
  color: rgba(209, 145, 47, 0.1);
}
.text-phrase-color-500\\/100{
  color: rgb(209, 145, 47);
}
.text-phrase-color-500\\/15{
  color: rgba(209, 145, 47, 0.15);
}
.text-phrase-color-500\\/20{
  color: rgba(209, 145, 47, 0.2);
}
.text-phrase-color-500\\/25{
  color: rgba(209, 145, 47, 0.25);
}
.text-phrase-color-500\\/30{
  color: rgba(209, 145, 47, 0.3);
}
.text-phrase-color-500\\/35{
  color: rgba(209, 145, 47, 0.35);
}
.text-phrase-color-500\\/40{
  color: rgba(209, 145, 47, 0.4);
}
.text-phrase-color-500\\/45{
  color: rgba(209, 145, 47, 0.45);
}
.text-phrase-color-500\\/5{
  color: rgba(209, 145, 47, 0.05);
}
.text-phrase-color-500\\/50{
  color: rgba(209, 145, 47, 0.5);
}
.text-phrase-color-500\\/55{
  color: rgba(209, 145, 47, 0.55);
}
.text-phrase-color-500\\/60{
  color: rgba(209, 145, 47, 0.6);
}
.text-phrase-color-500\\/65{
  color: rgba(209, 145, 47, 0.65);
}
.text-phrase-color-500\\/70{
  color: rgba(209, 145, 47, 0.7);
}
.text-phrase-color-500\\/75{
  color: rgba(209, 145, 47, 0.75);
}
.text-phrase-color-500\\/80{
  color: rgba(209, 145, 47, 0.8);
}
.text-phrase-color-500\\/85{
  color: rgba(209, 145, 47, 0.85);
}
.text-phrase-color-500\\/90{
  color: rgba(209, 145, 47, 0.9);
}
.text-phrase-color-500\\/95{
  color: rgba(209, 145, 47, 0.95);
}
.text-phrase-color-600{
  --tw-text-opacity: 1;
  color: rgba(195, 120, 41, 1);
  color: rgba(195, 120, 41, var(--tw-text-opacity, 1));
}
.text-phrase-color-600\\/0{
  color: rgba(195, 120, 41, 0);
}
.text-phrase-color-600\\/10{
  color: rgba(195, 120, 41, 0.1);
}
.text-phrase-color-600\\/100{
  color: rgb(195, 120, 41);
}
.text-phrase-color-600\\/15{
  color: rgba(195, 120, 41, 0.15);
}
.text-phrase-color-600\\/20{
  color: rgba(195, 120, 41, 0.2);
}
.text-phrase-color-600\\/25{
  color: rgba(195, 120, 41, 0.25);
}
.text-phrase-color-600\\/30{
  color: rgba(195, 120, 41, 0.3);
}
.text-phrase-color-600\\/35{
  color: rgba(195, 120, 41, 0.35);
}
.text-phrase-color-600\\/40{
  color: rgba(195, 120, 41, 0.4);
}
.text-phrase-color-600\\/45{
  color: rgba(195, 120, 41, 0.45);
}
.text-phrase-color-600\\/5{
  color: rgba(195, 120, 41, 0.05);
}
.text-phrase-color-600\\/50{
  color: rgba(195, 120, 41, 0.5);
}
.text-phrase-color-600\\/55{
  color: rgba(195, 120, 41, 0.55);
}
.text-phrase-color-600\\/60{
  color: rgba(195, 120, 41, 0.6);
}
.text-phrase-color-600\\/65{
  color: rgba(195, 120, 41, 0.65);
}
.text-phrase-color-600\\/70{
  color: rgba(195, 120, 41, 0.7);
}
.text-phrase-color-600\\/75{
  color: rgba(195, 120, 41, 0.75);
}
.text-phrase-color-600\\/80{
  color: rgba(195, 120, 41, 0.8);
}
.text-phrase-color-600\\/85{
  color: rgba(195, 120, 41, 0.85);
}
.text-phrase-color-600\\/90{
  color: rgba(195, 120, 41, 0.9);
}
.text-phrase-color-600\\/95{
  color: rgba(195, 120, 41, 0.95);
}
.text-phrase-color-700{
  --tw-text-opacity: 1;
  color: rgba(153, 84, 36, 1);
  color: rgba(153, 84, 36, var(--tw-text-opacity, 1));
}
.text-phrase-color-700\\/0{
  color: rgba(153, 84, 36, 0);
}
.text-phrase-color-700\\/10{
  color: rgba(153, 84, 36, 0.1);
}
.text-phrase-color-700\\/100{
  color: rgb(153, 84, 36);
}
.text-phrase-color-700\\/15{
  color: rgba(153, 84, 36, 0.15);
}
.text-phrase-color-700\\/20{
  color: rgba(153, 84, 36, 0.2);
}
.text-phrase-color-700\\/25{
  color: rgba(153, 84, 36, 0.25);
}
.text-phrase-color-700\\/30{
  color: rgba(153, 84, 36, 0.3);
}
.text-phrase-color-700\\/35{
  color: rgba(153, 84, 36, 0.35);
}
.text-phrase-color-700\\/40{
  color: rgba(153, 84, 36, 0.4);
}
.text-phrase-color-700\\/45{
  color: rgba(153, 84, 36, 0.45);
}
.text-phrase-color-700\\/5{
  color: rgba(153, 84, 36, 0.05);
}
.text-phrase-color-700\\/50{
  color: rgba(153, 84, 36, 0.5);
}
.text-phrase-color-700\\/55{
  color: rgba(153, 84, 36, 0.55);
}
.text-phrase-color-700\\/60{
  color: rgba(153, 84, 36, 0.6);
}
.text-phrase-color-700\\/65{
  color: rgba(153, 84, 36, 0.65);
}
.text-phrase-color-700\\/70{
  color: rgba(153, 84, 36, 0.7);
}
.text-phrase-color-700\\/75{
  color: rgba(153, 84, 36, 0.75);
}
.text-phrase-color-700\\/80{
  color: rgba(153, 84, 36, 0.8);
}
.text-phrase-color-700\\/85{
  color: rgba(153, 84, 36, 0.85);
}
.text-phrase-color-700\\/90{
  color: rgba(153, 84, 36, 0.9);
}
.text-phrase-color-700\\/95{
  color: rgba(153, 84, 36, 0.95);
}
.text-phrase-color-800{
  --tw-text-opacity: 1;
  color: rgba(126, 67, 34, 1);
  color: rgba(126, 67, 34, var(--tw-text-opacity, 1));
}
.text-phrase-color-800\\/0{
  color: rgba(126, 67, 34, 0);
}
.text-phrase-color-800\\/10{
  color: rgba(126, 67, 34, 0.1);
}
.text-phrase-color-800\\/100{
  color: rgb(126, 67, 34);
}
.text-phrase-color-800\\/15{
  color: rgba(126, 67, 34, 0.15);
}
.text-phrase-color-800\\/20{
  color: rgba(126, 67, 34, 0.2);
}
.text-phrase-color-800\\/25{
  color: rgba(126, 67, 34, 0.25);
}
.text-phrase-color-800\\/30{
  color: rgba(126, 67, 34, 0.3);
}
.text-phrase-color-800\\/35{
  color: rgba(126, 67, 34, 0.35);
}
.text-phrase-color-800\\/40{
  color: rgba(126, 67, 34, 0.4);
}
.text-phrase-color-800\\/45{
  color: rgba(126, 67, 34, 0.45);
}
.text-phrase-color-800\\/5{
  color: rgba(126, 67, 34, 0.05);
}
.text-phrase-color-800\\/50{
  color: rgba(126, 67, 34, 0.5);
}
.text-phrase-color-800\\/55{
  color: rgba(126, 67, 34, 0.55);
}
.text-phrase-color-800\\/60{
  color: rgba(126, 67, 34, 0.6);
}
.text-phrase-color-800\\/65{
  color: rgba(126, 67, 34, 0.65);
}
.text-phrase-color-800\\/70{
  color: rgba(126, 67, 34, 0.7);
}
.text-phrase-color-800\\/75{
  color: rgba(126, 67, 34, 0.75);
}
.text-phrase-color-800\\/80{
  color: rgba(126, 67, 34, 0.8);
}
.text-phrase-color-800\\/85{
  color: rgba(126, 67, 34, 0.85);
}
.text-phrase-color-800\\/90{
  color: rgba(126, 67, 34, 0.9);
}
.text-phrase-color-800\\/95{
  color: rgba(126, 67, 34, 0.95);
}
.text-phrase-color-900{
  --tw-text-opacity: 1;
  color: rgba(104, 56, 31, 1);
  color: rgba(104, 56, 31, var(--tw-text-opacity, 1));
}
.text-phrase-color-900\\/0{
  color: rgba(104, 56, 31, 0);
}
.text-phrase-color-900\\/10{
  color: rgba(104, 56, 31, 0.1);
}
.text-phrase-color-900\\/100{
  color: rgb(104, 56, 31);
}
.text-phrase-color-900\\/15{
  color: rgba(104, 56, 31, 0.15);
}
.text-phrase-color-900\\/20{
  color: rgba(104, 56, 31, 0.2);
}
.text-phrase-color-900\\/25{
  color: rgba(104, 56, 31, 0.25);
}
.text-phrase-color-900\\/30{
  color: rgba(104, 56, 31, 0.3);
}
.text-phrase-color-900\\/35{
  color: rgba(104, 56, 31, 0.35);
}
.text-phrase-color-900\\/40{
  color: rgba(104, 56, 31, 0.4);
}
.text-phrase-color-900\\/45{
  color: rgba(104, 56, 31, 0.45);
}
.text-phrase-color-900\\/5{
  color: rgba(104, 56, 31, 0.05);
}
.text-phrase-color-900\\/50{
  color: rgba(104, 56, 31, 0.5);
}
.text-phrase-color-900\\/55{
  color: rgba(104, 56, 31, 0.55);
}
.text-phrase-color-900\\/60{
  color: rgba(104, 56, 31, 0.6);
}
.text-phrase-color-900\\/65{
  color: rgba(104, 56, 31, 0.65);
}
.text-phrase-color-900\\/70{
  color: rgba(104, 56, 31, 0.7);
}
.text-phrase-color-900\\/75{
  color: rgba(104, 56, 31, 0.75);
}
.text-phrase-color-900\\/80{
  color: rgba(104, 56, 31, 0.8);
}
.text-phrase-color-900\\/85{
  color: rgba(104, 56, 31, 0.85);
}
.text-phrase-color-900\\/90{
  color: rgba(104, 56, 31, 0.9);
}
.text-phrase-color-900\\/95{
  color: rgba(104, 56, 31, 0.95);
}
.text-phrase-color-950{
  --tw-text-opacity: 1;
  color: rgba(59, 28, 13, 1);
  color: rgba(59, 28, 13, var(--tw-text-opacity, 1));
}
.text-phrase-color-950\\/0{
  color: rgba(59, 28, 13, 0);
}
.text-phrase-color-950\\/10{
  color: rgba(59, 28, 13, 0.1);
}
.text-phrase-color-950\\/100{
  color: rgb(59, 28, 13);
}
.text-phrase-color-950\\/15{
  color: rgba(59, 28, 13, 0.15);
}
.text-phrase-color-950\\/20{
  color: rgba(59, 28, 13, 0.2);
}
.text-phrase-color-950\\/25{
  color: rgba(59, 28, 13, 0.25);
}
.text-phrase-color-950\\/30{
  color: rgba(59, 28, 13, 0.3);
}
.text-phrase-color-950\\/35{
  color: rgba(59, 28, 13, 0.35);
}
.text-phrase-color-950\\/40{
  color: rgba(59, 28, 13, 0.4);
}
.text-phrase-color-950\\/45{
  color: rgba(59, 28, 13, 0.45);
}
.text-phrase-color-950\\/5{
  color: rgba(59, 28, 13, 0.05);
}
.text-phrase-color-950\\/50{
  color: rgba(59, 28, 13, 0.5);
}
.text-phrase-color-950\\/55{
  color: rgba(59, 28, 13, 0.55);
}
.text-phrase-color-950\\/60{
  color: rgba(59, 28, 13, 0.6);
}
.text-phrase-color-950\\/65{
  color: rgba(59, 28, 13, 0.65);
}
.text-phrase-color-950\\/70{
  color: rgba(59, 28, 13, 0.7);
}
.text-phrase-color-950\\/75{
  color: rgba(59, 28, 13, 0.75);
}
.text-phrase-color-950\\/80{
  color: rgba(59, 28, 13, 0.8);
}
.text-phrase-color-950\\/85{
  color: rgba(59, 28, 13, 0.85);
}
.text-phrase-color-950\\/90{
  color: rgba(59, 28, 13, 0.9);
}
.text-phrase-color-950\\/95{
  color: rgba(59, 28, 13, 0.95);
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgba(185, 28, 28, 1);
  color: rgba(185, 28, 28, var(--tw-text-opacity, 1));
}
.text-scarlet-100{
  --tw-text-opacity: 1;
  color: rgba(255, 220, 223, 1);
  color: rgba(255, 220, 223, var(--tw-text-opacity, 1));
}
.text-scarlet-100\\/0{
  color: rgba(255, 220, 223, 0);
}
.text-scarlet-100\\/10{
  color: rgba(255, 220, 223, 0.1);
}
.text-scarlet-100\\/100{
  color: rgb(255, 220, 223);
}
.text-scarlet-100\\/15{
  color: rgba(255, 220, 223, 0.15);
}
.text-scarlet-100\\/20{
  color: rgba(255, 220, 223, 0.2);
}
.text-scarlet-100\\/25{
  color: rgba(255, 220, 223, 0.25);
}
.text-scarlet-100\\/30{
  color: rgba(255, 220, 223, 0.3);
}
.text-scarlet-100\\/35{
  color: rgba(255, 220, 223, 0.35);
}
.text-scarlet-100\\/40{
  color: rgba(255, 220, 223, 0.4);
}
.text-scarlet-100\\/45{
  color: rgba(255, 220, 223, 0.45);
}
.text-scarlet-100\\/5{
  color: rgba(255, 220, 223, 0.05);
}
.text-scarlet-100\\/50{
  color: rgba(255, 220, 223, 0.5);
}
.text-scarlet-100\\/55{
  color: rgba(255, 220, 223, 0.55);
}
.text-scarlet-100\\/60{
  color: rgba(255, 220, 223, 0.6);
}
.text-scarlet-100\\/65{
  color: rgba(255, 220, 223, 0.65);
}
.text-scarlet-100\\/70{
  color: rgba(255, 220, 223, 0.7);
}
.text-scarlet-100\\/75{
  color: rgba(255, 220, 223, 0.75);
}
.text-scarlet-100\\/80{
  color: rgba(255, 220, 223, 0.8);
}
.text-scarlet-100\\/85{
  color: rgba(255, 220, 223, 0.85);
}
.text-scarlet-100\\/90{
  color: rgba(255, 220, 223, 0.9);
}
.text-scarlet-100\\/95{
  color: rgba(255, 220, 223, 0.95);
}
.text-scarlet-200{
  --tw-text-opacity: 1;
  color: rgba(255, 192, 198, 1);
  color: rgba(255, 192, 198, var(--tw-text-opacity, 1));
}
.text-scarlet-200\\/0{
  color: rgba(255, 192, 198, 0);
}
.text-scarlet-200\\/10{
  color: rgba(255, 192, 198, 0.1);
}
.text-scarlet-200\\/100{
  color: rgb(255, 192, 198);
}
.text-scarlet-200\\/15{
  color: rgba(255, 192, 198, 0.15);
}
.text-scarlet-200\\/20{
  color: rgba(255, 192, 198, 0.2);
}
.text-scarlet-200\\/25{
  color: rgba(255, 192, 198, 0.25);
}
.text-scarlet-200\\/30{
  color: rgba(255, 192, 198, 0.3);
}
.text-scarlet-200\\/35{
  color: rgba(255, 192, 198, 0.35);
}
.text-scarlet-200\\/40{
  color: rgba(255, 192, 198, 0.4);
}
.text-scarlet-200\\/45{
  color: rgba(255, 192, 198, 0.45);
}
.text-scarlet-200\\/5{
  color: rgba(255, 192, 198, 0.05);
}
.text-scarlet-200\\/50{
  color: rgba(255, 192, 198, 0.5);
}
.text-scarlet-200\\/55{
  color: rgba(255, 192, 198, 0.55);
}
.text-scarlet-200\\/60{
  color: rgba(255, 192, 198, 0.6);
}
.text-scarlet-200\\/65{
  color: rgba(255, 192, 198, 0.65);
}
.text-scarlet-200\\/70{
  color: rgba(255, 192, 198, 0.7);
}
.text-scarlet-200\\/75{
  color: rgba(255, 192, 198, 0.75);
}
.text-scarlet-200\\/80{
  color: rgba(255, 192, 198, 0.8);
}
.text-scarlet-200\\/85{
  color: rgba(255, 192, 198, 0.85);
}
.text-scarlet-200\\/90{
  color: rgba(255, 192, 198, 0.9);
}
.text-scarlet-200\\/95{
  color: rgba(255, 192, 198, 0.95);
}
.text-scarlet-300{
  --tw-text-opacity: 1;
  color: rgba(255, 148, 158, 1);
  color: rgba(255, 148, 158, var(--tw-text-opacity, 1));
}
.text-scarlet-300\\/0{
  color: rgba(255, 148, 158, 0);
}
.text-scarlet-300\\/10{
  color: rgba(255, 148, 158, 0.1);
}
.text-scarlet-300\\/100{
  color: rgb(255, 148, 158);
}
.text-scarlet-300\\/15{
  color: rgba(255, 148, 158, 0.15);
}
.text-scarlet-300\\/20{
  color: rgba(255, 148, 158, 0.2);
}
.text-scarlet-300\\/25{
  color: rgba(255, 148, 158, 0.25);
}
.text-scarlet-300\\/30{
  color: rgba(255, 148, 158, 0.3);
}
.text-scarlet-300\\/35{
  color: rgba(255, 148, 158, 0.35);
}
.text-scarlet-300\\/40{
  color: rgba(255, 148, 158, 0.4);
}
.text-scarlet-300\\/45{
  color: rgba(255, 148, 158, 0.45);
}
.text-scarlet-300\\/5{
  color: rgba(255, 148, 158, 0.05);
}
.text-scarlet-300\\/50{
  color: rgba(255, 148, 158, 0.5);
}
.text-scarlet-300\\/55{
  color: rgba(255, 148, 158, 0.55);
}
.text-scarlet-300\\/60{
  color: rgba(255, 148, 158, 0.6);
}
.text-scarlet-300\\/65{
  color: rgba(255, 148, 158, 0.65);
}
.text-scarlet-300\\/70{
  color: rgba(255, 148, 158, 0.7);
}
.text-scarlet-300\\/75{
  color: rgba(255, 148, 158, 0.75);
}
.text-scarlet-300\\/80{
  color: rgba(255, 148, 158, 0.8);
}
.text-scarlet-300\\/85{
  color: rgba(255, 148, 158, 0.85);
}
.text-scarlet-300\\/90{
  color: rgba(255, 148, 158, 0.9);
}
.text-scarlet-300\\/95{
  color: rgba(255, 148, 158, 0.95);
}
.text-scarlet-400{
  --tw-text-opacity: 1;
  color: rgba(255, 86, 101, 1);
  color: rgba(255, 86, 101, var(--tw-text-opacity, 1));
}
.text-scarlet-400\\/0{
  color: rgba(255, 86, 101, 0);
}
.text-scarlet-400\\/10{
  color: rgba(255, 86, 101, 0.1);
}
.text-scarlet-400\\/100{
  color: rgb(255, 86, 101);
}
.text-scarlet-400\\/15{
  color: rgba(255, 86, 101, 0.15);
}
.text-scarlet-400\\/20{
  color: rgba(255, 86, 101, 0.2);
}
.text-scarlet-400\\/25{
  color: rgba(255, 86, 101, 0.25);
}
.text-scarlet-400\\/30{
  color: rgba(255, 86, 101, 0.3);
}
.text-scarlet-400\\/35{
  color: rgba(255, 86, 101, 0.35);
}
.text-scarlet-400\\/40{
  color: rgba(255, 86, 101, 0.4);
}
.text-scarlet-400\\/45{
  color: rgba(255, 86, 101, 0.45);
}
.text-scarlet-400\\/5{
  color: rgba(255, 86, 101, 0.05);
}
.text-scarlet-400\\/50{
  color: rgba(255, 86, 101, 0.5);
}
.text-scarlet-400\\/55{
  color: rgba(255, 86, 101, 0.55);
}
.text-scarlet-400\\/60{
  color: rgba(255, 86, 101, 0.6);
}
.text-scarlet-400\\/65{
  color: rgba(255, 86, 101, 0.65);
}
.text-scarlet-400\\/70{
  color: rgba(255, 86, 101, 0.7);
}
.text-scarlet-400\\/75{
  color: rgba(255, 86, 101, 0.75);
}
.text-scarlet-400\\/80{
  color: rgba(255, 86, 101, 0.8);
}
.text-scarlet-400\\/85{
  color: rgba(255, 86, 101, 0.85);
}
.text-scarlet-400\\/90{
  color: rgba(255, 86, 101, 0.9);
}
.text-scarlet-400\\/95{
  color: rgba(255, 86, 101, 0.95);
}
.text-scarlet-500{
  --tw-text-opacity: 1;
  color: rgba(255, 34, 54, 1);
  color: rgba(255, 34, 54, var(--tw-text-opacity, 1));
}
.text-scarlet-500\\/0{
  color: rgba(255, 34, 54, 0);
}
.text-scarlet-500\\/10{
  color: rgba(255, 34, 54, 0.1);
}
.text-scarlet-500\\/100{
  color: rgb(255, 34, 54);
}
.text-scarlet-500\\/15{
  color: rgba(255, 34, 54, 0.15);
}
.text-scarlet-500\\/20{
  color: rgba(255, 34, 54, 0.2);
}
.text-scarlet-500\\/25{
  color: rgba(255, 34, 54, 0.25);
}
.text-scarlet-500\\/30{
  color: rgba(255, 34, 54, 0.3);
}
.text-scarlet-500\\/35{
  color: rgba(255, 34, 54, 0.35);
}
.text-scarlet-500\\/40{
  color: rgba(255, 34, 54, 0.4);
}
.text-scarlet-500\\/45{
  color: rgba(255, 34, 54, 0.45);
}
.text-scarlet-500\\/5{
  color: rgba(255, 34, 54, 0.05);
}
.text-scarlet-500\\/50{
  color: rgba(255, 34, 54, 0.5);
}
.text-scarlet-500\\/55{
  color: rgba(255, 34, 54, 0.55);
}
.text-scarlet-500\\/60{
  color: rgba(255, 34, 54, 0.6);
}
.text-scarlet-500\\/65{
  color: rgba(255, 34, 54, 0.65);
}
.text-scarlet-500\\/70{
  color: rgba(255, 34, 54, 0.7);
}
.text-scarlet-500\\/75{
  color: rgba(255, 34, 54, 0.75);
}
.text-scarlet-500\\/80{
  color: rgba(255, 34, 54, 0.8);
}
.text-scarlet-500\\/85{
  color: rgba(255, 34, 54, 0.85);
}
.text-scarlet-500\\/90{
  color: rgba(255, 34, 54, 0.9);
}
.text-scarlet-500\\/95{
  color: rgba(255, 34, 54, 0.95);
}
.text-scarlet-600{
  --tw-text-opacity: 1;
  color: rgba(255, 2, 25, 1);
  color: rgba(255, 2, 25, var(--tw-text-opacity, 1));
}
.text-scarlet-600\\/0{
  color: rgba(255, 2, 25, 0);
}
.text-scarlet-600\\/10{
  color: rgba(255, 2, 25, 0.1);
}
.text-scarlet-600\\/100{
  color: rgb(255, 2, 25);
}
.text-scarlet-600\\/15{
  color: rgba(255, 2, 25, 0.15);
}
.text-scarlet-600\\/20{
  color: rgba(255, 2, 25, 0.2);
}
.text-scarlet-600\\/25{
  color: rgba(255, 2, 25, 0.25);
}
.text-scarlet-600\\/30{
  color: rgba(255, 2, 25, 0.3);
}
.text-scarlet-600\\/35{
  color: rgba(255, 2, 25, 0.35);
}
.text-scarlet-600\\/40{
  color: rgba(255, 2, 25, 0.4);
}
.text-scarlet-600\\/45{
  color: rgba(255, 2, 25, 0.45);
}
.text-scarlet-600\\/5{
  color: rgba(255, 2, 25, 0.05);
}
.text-scarlet-600\\/50{
  color: rgba(255, 2, 25, 0.5);
}
.text-scarlet-600\\/55{
  color: rgba(255, 2, 25, 0.55);
}
.text-scarlet-600\\/60{
  color: rgba(255, 2, 25, 0.6);
}
.text-scarlet-600\\/65{
  color: rgba(255, 2, 25, 0.65);
}
.text-scarlet-600\\/70{
  color: rgba(255, 2, 25, 0.7);
}
.text-scarlet-600\\/75{
  color: rgba(255, 2, 25, 0.75);
}
.text-scarlet-600\\/80{
  color: rgba(255, 2, 25, 0.8);
}
.text-scarlet-600\\/85{
  color: rgba(255, 2, 25, 0.85);
}
.text-scarlet-600\\/90{
  color: rgba(255, 2, 25, 0.9);
}
.text-scarlet-600\\/95{
  color: rgba(255, 2, 25, 0.95);
}
.text-scarlet-700{
  --tw-text-opacity: 1;
  color: rgba(216, 0, 19, 1);
  color: rgba(216, 0, 19, var(--tw-text-opacity, 1));
}
.text-scarlet-700\\/0{
  color: rgba(216, 0, 19, 0);
}
.text-scarlet-700\\/10{
  color: rgba(216, 0, 19, 0.1);
}
.text-scarlet-700\\/100{
  color: rgb(216, 0, 19);
}
.text-scarlet-700\\/15{
  color: rgba(216, 0, 19, 0.15);
}
.text-scarlet-700\\/20{
  color: rgba(216, 0, 19, 0.2);
}
.text-scarlet-700\\/25{
  color: rgba(216, 0, 19, 0.25);
}
.text-scarlet-700\\/30{
  color: rgba(216, 0, 19, 0.3);
}
.text-scarlet-700\\/35{
  color: rgba(216, 0, 19, 0.35);
}
.text-scarlet-700\\/40{
  color: rgba(216, 0, 19, 0.4);
}
.text-scarlet-700\\/45{
  color: rgba(216, 0, 19, 0.45);
}
.text-scarlet-700\\/5{
  color: rgba(216, 0, 19, 0.05);
}
.text-scarlet-700\\/50{
  color: rgba(216, 0, 19, 0.5);
}
.text-scarlet-700\\/55{
  color: rgba(216, 0, 19, 0.55);
}
.text-scarlet-700\\/60{
  color: rgba(216, 0, 19, 0.6);
}
.text-scarlet-700\\/65{
  color: rgba(216, 0, 19, 0.65);
}
.text-scarlet-700\\/70{
  color: rgba(216, 0, 19, 0.7);
}
.text-scarlet-700\\/75{
  color: rgba(216, 0, 19, 0.75);
}
.text-scarlet-700\\/80{
  color: rgba(216, 0, 19, 0.8);
}
.text-scarlet-700\\/85{
  color: rgba(216, 0, 19, 0.85);
}
.text-scarlet-700\\/90{
  color: rgba(216, 0, 19, 0.9);
}
.text-scarlet-700\\/95{
  color: rgba(216, 0, 19, 0.95);
}
.text-scarlet-800{
  --tw-text-opacity: 1;
  color: rgba(180, 2, 18, 1);
  color: rgba(180, 2, 18, var(--tw-text-opacity, 1));
}
.text-scarlet-800\\/0{
  color: rgba(180, 2, 18, 0);
}
.text-scarlet-800\\/10{
  color: rgba(180, 2, 18, 0.1);
}
.text-scarlet-800\\/100{
  color: rgb(180, 2, 18);
}
.text-scarlet-800\\/15{
  color: rgba(180, 2, 18, 0.15);
}
.text-scarlet-800\\/20{
  color: rgba(180, 2, 18, 0.2);
}
.text-scarlet-800\\/25{
  color: rgba(180, 2, 18, 0.25);
}
.text-scarlet-800\\/30{
  color: rgba(180, 2, 18, 0.3);
}
.text-scarlet-800\\/35{
  color: rgba(180, 2, 18, 0.35);
}
.text-scarlet-800\\/40{
  color: rgba(180, 2, 18, 0.4);
}
.text-scarlet-800\\/45{
  color: rgba(180, 2, 18, 0.45);
}
.text-scarlet-800\\/5{
  color: rgba(180, 2, 18, 0.05);
}
.text-scarlet-800\\/50{
  color: rgba(180, 2, 18, 0.5);
}
.text-scarlet-800\\/55{
  color: rgba(180, 2, 18, 0.55);
}
.text-scarlet-800\\/60{
  color: rgba(180, 2, 18, 0.6);
}
.text-scarlet-800\\/65{
  color: rgba(180, 2, 18, 0.65);
}
.text-scarlet-800\\/70{
  color: rgba(180, 2, 18, 0.7);
}
.text-scarlet-800\\/75{
  color: rgba(180, 2, 18, 0.75);
}
.text-scarlet-800\\/80{
  color: rgba(180, 2, 18, 0.8);
}
.text-scarlet-800\\/85{
  color: rgba(180, 2, 18, 0.85);
}
.text-scarlet-800\\/90{
  color: rgba(180, 2, 18, 0.9);
}
.text-scarlet-800\\/95{
  color: rgba(180, 2, 18, 0.95);
}
.text-scarlet-900{
  --tw-text-opacity: 1;
  color: rgba(146, 10, 22, 1);
  color: rgba(146, 10, 22, var(--tw-text-opacity, 1));
}
.text-scarlet-900\\/0{
  color: rgba(146, 10, 22, 0);
}
.text-scarlet-900\\/10{
  color: rgba(146, 10, 22, 0.1);
}
.text-scarlet-900\\/100{
  color: rgb(146, 10, 22);
}
.text-scarlet-900\\/15{
  color: rgba(146, 10, 22, 0.15);
}
.text-scarlet-900\\/20{
  color: rgba(146, 10, 22, 0.2);
}
.text-scarlet-900\\/25{
  color: rgba(146, 10, 22, 0.25);
}
.text-scarlet-900\\/30{
  color: rgba(146, 10, 22, 0.3);
}
.text-scarlet-900\\/35{
  color: rgba(146, 10, 22, 0.35);
}
.text-scarlet-900\\/40{
  color: rgba(146, 10, 22, 0.4);
}
.text-scarlet-900\\/45{
  color: rgba(146, 10, 22, 0.45);
}
.text-scarlet-900\\/5{
  color: rgba(146, 10, 22, 0.05);
}
.text-scarlet-900\\/50{
  color: rgba(146, 10, 22, 0.5);
}
.text-scarlet-900\\/55{
  color: rgba(146, 10, 22, 0.55);
}
.text-scarlet-900\\/60{
  color: rgba(146, 10, 22, 0.6);
}
.text-scarlet-900\\/65{
  color: rgba(146, 10, 22, 0.65);
}
.text-scarlet-900\\/70{
  color: rgba(146, 10, 22, 0.7);
}
.text-scarlet-900\\/75{
  color: rgba(146, 10, 22, 0.75);
}
.text-scarlet-900\\/80{
  color: rgba(146, 10, 22, 0.8);
}
.text-scarlet-900\\/85{
  color: rgba(146, 10, 22, 0.85);
}
.text-scarlet-900\\/90{
  color: rgba(146, 10, 22, 0.9);
}
.text-scarlet-900\\/95{
  color: rgba(146, 10, 22, 0.95);
}
.text-scarlet-950{
  --tw-text-opacity: 1;
  color: rgba(81, 0, 7, 1);
  color: rgba(81, 0, 7, var(--tw-text-opacity, 1));
}
.text-scarlet-950\\/0{
  color: rgba(81, 0, 7, 0);
}
.text-scarlet-950\\/10{
  color: rgba(81, 0, 7, 0.1);
}
.text-scarlet-950\\/100{
  color: rgb(81, 0, 7);
}
.text-scarlet-950\\/15{
  color: rgba(81, 0, 7, 0.15);
}
.text-scarlet-950\\/20{
  color: rgba(81, 0, 7, 0.2);
}
.text-scarlet-950\\/25{
  color: rgba(81, 0, 7, 0.25);
}
.text-scarlet-950\\/30{
  color: rgba(81, 0, 7, 0.3);
}
.text-scarlet-950\\/35{
  color: rgba(81, 0, 7, 0.35);
}
.text-scarlet-950\\/40{
  color: rgba(81, 0, 7, 0.4);
}
.text-scarlet-950\\/45{
  color: rgba(81, 0, 7, 0.45);
}
.text-scarlet-950\\/5{
  color: rgba(81, 0, 7, 0.05);
}
.text-scarlet-950\\/50{
  color: rgba(81, 0, 7, 0.5);
}
.text-scarlet-950\\/55{
  color: rgba(81, 0, 7, 0.55);
}
.text-scarlet-950\\/60{
  color: rgba(81, 0, 7, 0.6);
}
.text-scarlet-950\\/65{
  color: rgba(81, 0, 7, 0.65);
}
.text-scarlet-950\\/70{
  color: rgba(81, 0, 7, 0.7);
}
.text-scarlet-950\\/75{
  color: rgba(81, 0, 7, 0.75);
}
.text-scarlet-950\\/80{
  color: rgba(81, 0, 7, 0.8);
}
.text-scarlet-950\\/85{
  color: rgba(81, 0, 7, 0.85);
}
.text-scarlet-950\\/90{
  color: rgba(81, 0, 7, 0.9);
}
.text-scarlet-950\\/95{
  color: rgba(81, 0, 7, 0.95);
}
.text-song-color-100{
  --tw-text-opacity: 1;
  color: rgba(255, 220, 223, 1);
  color: rgba(255, 220, 223, var(--tw-text-opacity, 1));
}
.text-song-color-100\\/0{
  color: rgba(255, 220, 223, 0);
}
.text-song-color-100\\/10{
  color: rgba(255, 220, 223, 0.1);
}
.text-song-color-100\\/100{
  color: rgb(255, 220, 223);
}
.text-song-color-100\\/15{
  color: rgba(255, 220, 223, 0.15);
}
.text-song-color-100\\/20{
  color: rgba(255, 220, 223, 0.2);
}
.text-song-color-100\\/25{
  color: rgba(255, 220, 223, 0.25);
}
.text-song-color-100\\/30{
  color: rgba(255, 220, 223, 0.3);
}
.text-song-color-100\\/35{
  color: rgba(255, 220, 223, 0.35);
}
.text-song-color-100\\/40{
  color: rgba(255, 220, 223, 0.4);
}
.text-song-color-100\\/45{
  color: rgba(255, 220, 223, 0.45);
}
.text-song-color-100\\/5{
  color: rgba(255, 220, 223, 0.05);
}
.text-song-color-100\\/50{
  color: rgba(255, 220, 223, 0.5);
}
.text-song-color-100\\/55{
  color: rgba(255, 220, 223, 0.55);
}
.text-song-color-100\\/60{
  color: rgba(255, 220, 223, 0.6);
}
.text-song-color-100\\/65{
  color: rgba(255, 220, 223, 0.65);
}
.text-song-color-100\\/70{
  color: rgba(255, 220, 223, 0.7);
}
.text-song-color-100\\/75{
  color: rgba(255, 220, 223, 0.75);
}
.text-song-color-100\\/80{
  color: rgba(255, 220, 223, 0.8);
}
.text-song-color-100\\/85{
  color: rgba(255, 220, 223, 0.85);
}
.text-song-color-100\\/90{
  color: rgba(255, 220, 223, 0.9);
}
.text-song-color-100\\/95{
  color: rgba(255, 220, 223, 0.95);
}
.text-song-color-200{
  --tw-text-opacity: 1;
  color: rgba(255, 192, 198, 1);
  color: rgba(255, 192, 198, var(--tw-text-opacity, 1));
}
.text-song-color-200\\/0{
  color: rgba(255, 192, 198, 0);
}
.text-song-color-200\\/10{
  color: rgba(255, 192, 198, 0.1);
}
.text-song-color-200\\/100{
  color: rgb(255, 192, 198);
}
.text-song-color-200\\/15{
  color: rgba(255, 192, 198, 0.15);
}
.text-song-color-200\\/20{
  color: rgba(255, 192, 198, 0.2);
}
.text-song-color-200\\/25{
  color: rgba(255, 192, 198, 0.25);
}
.text-song-color-200\\/30{
  color: rgba(255, 192, 198, 0.3);
}
.text-song-color-200\\/35{
  color: rgba(255, 192, 198, 0.35);
}
.text-song-color-200\\/40{
  color: rgba(255, 192, 198, 0.4);
}
.text-song-color-200\\/45{
  color: rgba(255, 192, 198, 0.45);
}
.text-song-color-200\\/5{
  color: rgba(255, 192, 198, 0.05);
}
.text-song-color-200\\/50{
  color: rgba(255, 192, 198, 0.5);
}
.text-song-color-200\\/55{
  color: rgba(255, 192, 198, 0.55);
}
.text-song-color-200\\/60{
  color: rgba(255, 192, 198, 0.6);
}
.text-song-color-200\\/65{
  color: rgba(255, 192, 198, 0.65);
}
.text-song-color-200\\/70{
  color: rgba(255, 192, 198, 0.7);
}
.text-song-color-200\\/75{
  color: rgba(255, 192, 198, 0.75);
}
.text-song-color-200\\/80{
  color: rgba(255, 192, 198, 0.8);
}
.text-song-color-200\\/85{
  color: rgba(255, 192, 198, 0.85);
}
.text-song-color-200\\/90{
  color: rgba(255, 192, 198, 0.9);
}
.text-song-color-200\\/95{
  color: rgba(255, 192, 198, 0.95);
}
.text-song-color-300{
  --tw-text-opacity: 1;
  color: rgba(255, 148, 158, 1);
  color: rgba(255, 148, 158, var(--tw-text-opacity, 1));
}
.text-song-color-300\\/0{
  color: rgba(255, 148, 158, 0);
}
.text-song-color-300\\/10{
  color: rgba(255, 148, 158, 0.1);
}
.text-song-color-300\\/100{
  color: rgb(255, 148, 158);
}
.text-song-color-300\\/15{
  color: rgba(255, 148, 158, 0.15);
}
.text-song-color-300\\/20{
  color: rgba(255, 148, 158, 0.2);
}
.text-song-color-300\\/25{
  color: rgba(255, 148, 158, 0.25);
}
.text-song-color-300\\/30{
  color: rgba(255, 148, 158, 0.3);
}
.text-song-color-300\\/35{
  color: rgba(255, 148, 158, 0.35);
}
.text-song-color-300\\/40{
  color: rgba(255, 148, 158, 0.4);
}
.text-song-color-300\\/45{
  color: rgba(255, 148, 158, 0.45);
}
.text-song-color-300\\/5{
  color: rgba(255, 148, 158, 0.05);
}
.text-song-color-300\\/50{
  color: rgba(255, 148, 158, 0.5);
}
.text-song-color-300\\/55{
  color: rgba(255, 148, 158, 0.55);
}
.text-song-color-300\\/60{
  color: rgba(255, 148, 158, 0.6);
}
.text-song-color-300\\/65{
  color: rgba(255, 148, 158, 0.65);
}
.text-song-color-300\\/70{
  color: rgba(255, 148, 158, 0.7);
}
.text-song-color-300\\/75{
  color: rgba(255, 148, 158, 0.75);
}
.text-song-color-300\\/80{
  color: rgba(255, 148, 158, 0.8);
}
.text-song-color-300\\/85{
  color: rgba(255, 148, 158, 0.85);
}
.text-song-color-300\\/90{
  color: rgba(255, 148, 158, 0.9);
}
.text-song-color-300\\/95{
  color: rgba(255, 148, 158, 0.95);
}
.text-song-color-400{
  --tw-text-opacity: 1;
  color: rgba(255, 86, 101, 1);
  color: rgba(255, 86, 101, var(--tw-text-opacity, 1));
}
.text-song-color-400\\/0{
  color: rgba(255, 86, 101, 0);
}
.text-song-color-400\\/10{
  color: rgba(255, 86, 101, 0.1);
}
.text-song-color-400\\/100{
  color: rgb(255, 86, 101);
}
.text-song-color-400\\/15{
  color: rgba(255, 86, 101, 0.15);
}
.text-song-color-400\\/20{
  color: rgba(255, 86, 101, 0.2);
}
.text-song-color-400\\/25{
  color: rgba(255, 86, 101, 0.25);
}
.text-song-color-400\\/30{
  color: rgba(255, 86, 101, 0.3);
}
.text-song-color-400\\/35{
  color: rgba(255, 86, 101, 0.35);
}
.text-song-color-400\\/40{
  color: rgba(255, 86, 101, 0.4);
}
.text-song-color-400\\/45{
  color: rgba(255, 86, 101, 0.45);
}
.text-song-color-400\\/5{
  color: rgba(255, 86, 101, 0.05);
}
.text-song-color-400\\/50{
  color: rgba(255, 86, 101, 0.5);
}
.text-song-color-400\\/55{
  color: rgba(255, 86, 101, 0.55);
}
.text-song-color-400\\/60{
  color: rgba(255, 86, 101, 0.6);
}
.text-song-color-400\\/65{
  color: rgba(255, 86, 101, 0.65);
}
.text-song-color-400\\/70{
  color: rgba(255, 86, 101, 0.7);
}
.text-song-color-400\\/75{
  color: rgba(255, 86, 101, 0.75);
}
.text-song-color-400\\/80{
  color: rgba(255, 86, 101, 0.8);
}
.text-song-color-400\\/85{
  color: rgba(255, 86, 101, 0.85);
}
.text-song-color-400\\/90{
  color: rgba(255, 86, 101, 0.9);
}
.text-song-color-400\\/95{
  color: rgba(255, 86, 101, 0.95);
}
.text-song-color-500{
  --tw-text-opacity: 1;
  color: rgba(255, 34, 54, 1);
  color: rgba(255, 34, 54, var(--tw-text-opacity, 1));
}
.text-song-color-500\\/0{
  color: rgba(255, 34, 54, 0);
}
.text-song-color-500\\/10{
  color: rgba(255, 34, 54, 0.1);
}
.text-song-color-500\\/100{
  color: rgb(255, 34, 54);
}
.text-song-color-500\\/15{
  color: rgba(255, 34, 54, 0.15);
}
.text-song-color-500\\/20{
  color: rgba(255, 34, 54, 0.2);
}
.text-song-color-500\\/25{
  color: rgba(255, 34, 54, 0.25);
}
.text-song-color-500\\/30{
  color: rgba(255, 34, 54, 0.3);
}
.text-song-color-500\\/35{
  color: rgba(255, 34, 54, 0.35);
}
.text-song-color-500\\/40{
  color: rgba(255, 34, 54, 0.4);
}
.text-song-color-500\\/45{
  color: rgba(255, 34, 54, 0.45);
}
.text-song-color-500\\/5{
  color: rgba(255, 34, 54, 0.05);
}
.text-song-color-500\\/50{
  color: rgba(255, 34, 54, 0.5);
}
.text-song-color-500\\/55{
  color: rgba(255, 34, 54, 0.55);
}
.text-song-color-500\\/60{
  color: rgba(255, 34, 54, 0.6);
}
.text-song-color-500\\/65{
  color: rgba(255, 34, 54, 0.65);
}
.text-song-color-500\\/70{
  color: rgba(255, 34, 54, 0.7);
}
.text-song-color-500\\/75{
  color: rgba(255, 34, 54, 0.75);
}
.text-song-color-500\\/80{
  color: rgba(255, 34, 54, 0.8);
}
.text-song-color-500\\/85{
  color: rgba(255, 34, 54, 0.85);
}
.text-song-color-500\\/90{
  color: rgba(255, 34, 54, 0.9);
}
.text-song-color-500\\/95{
  color: rgba(255, 34, 54, 0.95);
}
.text-song-color-600{
  --tw-text-opacity: 1;
  color: rgba(255, 2, 25, 1);
  color: rgba(255, 2, 25, var(--tw-text-opacity, 1));
}
.text-song-color-600\\/0{
  color: rgba(255, 2, 25, 0);
}
.text-song-color-600\\/10{
  color: rgba(255, 2, 25, 0.1);
}
.text-song-color-600\\/100{
  color: rgb(255, 2, 25);
}
.text-song-color-600\\/15{
  color: rgba(255, 2, 25, 0.15);
}
.text-song-color-600\\/20{
  color: rgba(255, 2, 25, 0.2);
}
.text-song-color-600\\/25{
  color: rgba(255, 2, 25, 0.25);
}
.text-song-color-600\\/30{
  color: rgba(255, 2, 25, 0.3);
}
.text-song-color-600\\/35{
  color: rgba(255, 2, 25, 0.35);
}
.text-song-color-600\\/40{
  color: rgba(255, 2, 25, 0.4);
}
.text-song-color-600\\/45{
  color: rgba(255, 2, 25, 0.45);
}
.text-song-color-600\\/5{
  color: rgba(255, 2, 25, 0.05);
}
.text-song-color-600\\/50{
  color: rgba(255, 2, 25, 0.5);
}
.text-song-color-600\\/55{
  color: rgba(255, 2, 25, 0.55);
}
.text-song-color-600\\/60{
  color: rgba(255, 2, 25, 0.6);
}
.text-song-color-600\\/65{
  color: rgba(255, 2, 25, 0.65);
}
.text-song-color-600\\/70{
  color: rgba(255, 2, 25, 0.7);
}
.text-song-color-600\\/75{
  color: rgba(255, 2, 25, 0.75);
}
.text-song-color-600\\/80{
  color: rgba(255, 2, 25, 0.8);
}
.text-song-color-600\\/85{
  color: rgba(255, 2, 25, 0.85);
}
.text-song-color-600\\/90{
  color: rgba(255, 2, 25, 0.9);
}
.text-song-color-600\\/95{
  color: rgba(255, 2, 25, 0.95);
}
.text-song-color-700{
  --tw-text-opacity: 1;
  color: rgba(216, 0, 19, 1);
  color: rgba(216, 0, 19, var(--tw-text-opacity, 1));
}
.text-song-color-700\\/0{
  color: rgba(216, 0, 19, 0);
}
.text-song-color-700\\/10{
  color: rgba(216, 0, 19, 0.1);
}
.text-song-color-700\\/100{
  color: rgb(216, 0, 19);
}
.text-song-color-700\\/15{
  color: rgba(216, 0, 19, 0.15);
}
.text-song-color-700\\/20{
  color: rgba(216, 0, 19, 0.2);
}
.text-song-color-700\\/25{
  color: rgba(216, 0, 19, 0.25);
}
.text-song-color-700\\/30{
  color: rgba(216, 0, 19, 0.3);
}
.text-song-color-700\\/35{
  color: rgba(216, 0, 19, 0.35);
}
.text-song-color-700\\/40{
  color: rgba(216, 0, 19, 0.4);
}
.text-song-color-700\\/45{
  color: rgba(216, 0, 19, 0.45);
}
.text-song-color-700\\/5{
  color: rgba(216, 0, 19, 0.05);
}
.text-song-color-700\\/50{
  color: rgba(216, 0, 19, 0.5);
}
.text-song-color-700\\/55{
  color: rgba(216, 0, 19, 0.55);
}
.text-song-color-700\\/60{
  color: rgba(216, 0, 19, 0.6);
}
.text-song-color-700\\/65{
  color: rgba(216, 0, 19, 0.65);
}
.text-song-color-700\\/70{
  color: rgba(216, 0, 19, 0.7);
}
.text-song-color-700\\/75{
  color: rgba(216, 0, 19, 0.75);
}
.text-song-color-700\\/80{
  color: rgba(216, 0, 19, 0.8);
}
.text-song-color-700\\/85{
  color: rgba(216, 0, 19, 0.85);
}
.text-song-color-700\\/90{
  color: rgba(216, 0, 19, 0.9);
}
.text-song-color-700\\/95{
  color: rgba(216, 0, 19, 0.95);
}
.text-song-color-800{
  --tw-text-opacity: 1;
  color: rgba(180, 2, 18, 1);
  color: rgba(180, 2, 18, var(--tw-text-opacity, 1));
}
.text-song-color-800\\/0{
  color: rgba(180, 2, 18, 0);
}
.text-song-color-800\\/10{
  color: rgba(180, 2, 18, 0.1);
}
.text-song-color-800\\/100{
  color: rgb(180, 2, 18);
}
.text-song-color-800\\/15{
  color: rgba(180, 2, 18, 0.15);
}
.text-song-color-800\\/20{
  color: rgba(180, 2, 18, 0.2);
}
.text-song-color-800\\/25{
  color: rgba(180, 2, 18, 0.25);
}
.text-song-color-800\\/30{
  color: rgba(180, 2, 18, 0.3);
}
.text-song-color-800\\/35{
  color: rgba(180, 2, 18, 0.35);
}
.text-song-color-800\\/40{
  color: rgba(180, 2, 18, 0.4);
}
.text-song-color-800\\/45{
  color: rgba(180, 2, 18, 0.45);
}
.text-song-color-800\\/5{
  color: rgba(180, 2, 18, 0.05);
}
.text-song-color-800\\/50{
  color: rgba(180, 2, 18, 0.5);
}
.text-song-color-800\\/55{
  color: rgba(180, 2, 18, 0.55);
}
.text-song-color-800\\/60{
  color: rgba(180, 2, 18, 0.6);
}
.text-song-color-800\\/65{
  color: rgba(180, 2, 18, 0.65);
}
.text-song-color-800\\/70{
  color: rgba(180, 2, 18, 0.7);
}
.text-song-color-800\\/75{
  color: rgba(180, 2, 18, 0.75);
}
.text-song-color-800\\/80{
  color: rgba(180, 2, 18, 0.8);
}
.text-song-color-800\\/85{
  color: rgba(180, 2, 18, 0.85);
}
.text-song-color-800\\/90{
  color: rgba(180, 2, 18, 0.9);
}
.text-song-color-800\\/95{
  color: rgba(180, 2, 18, 0.95);
}
.text-song-color-900{
  --tw-text-opacity: 1;
  color: rgba(146, 10, 22, 1);
  color: rgba(146, 10, 22, var(--tw-text-opacity, 1));
}
.text-song-color-900\\/0{
  color: rgba(146, 10, 22, 0);
}
.text-song-color-900\\/10{
  color: rgba(146, 10, 22, 0.1);
}
.text-song-color-900\\/100{
  color: rgb(146, 10, 22);
}
.text-song-color-900\\/15{
  color: rgba(146, 10, 22, 0.15);
}
.text-song-color-900\\/20{
  color: rgba(146, 10, 22, 0.2);
}
.text-song-color-900\\/25{
  color: rgba(146, 10, 22, 0.25);
}
.text-song-color-900\\/30{
  color: rgba(146, 10, 22, 0.3);
}
.text-song-color-900\\/35{
  color: rgba(146, 10, 22, 0.35);
}
.text-song-color-900\\/40{
  color: rgba(146, 10, 22, 0.4);
}
.text-song-color-900\\/45{
  color: rgba(146, 10, 22, 0.45);
}
.text-song-color-900\\/5{
  color: rgba(146, 10, 22, 0.05);
}
.text-song-color-900\\/50{
  color: rgba(146, 10, 22, 0.5);
}
.text-song-color-900\\/55{
  color: rgba(146, 10, 22, 0.55);
}
.text-song-color-900\\/60{
  color: rgba(146, 10, 22, 0.6);
}
.text-song-color-900\\/65{
  color: rgba(146, 10, 22, 0.65);
}
.text-song-color-900\\/70{
  color: rgba(146, 10, 22, 0.7);
}
.text-song-color-900\\/75{
  color: rgba(146, 10, 22, 0.75);
}
.text-song-color-900\\/80{
  color: rgba(146, 10, 22, 0.8);
}
.text-song-color-900\\/85{
  color: rgba(146, 10, 22, 0.85);
}
.text-song-color-900\\/90{
  color: rgba(146, 10, 22, 0.9);
}
.text-song-color-900\\/95{
  color: rgba(146, 10, 22, 0.95);
}
.text-song-color-950{
  --tw-text-opacity: 1;
  color: rgba(81, 0, 7, 1);
  color: rgba(81, 0, 7, var(--tw-text-opacity, 1));
}
.text-song-color-950\\/0{
  color: rgba(81, 0, 7, 0);
}
.text-song-color-950\\/10{
  color: rgba(81, 0, 7, 0.1);
}
.text-song-color-950\\/100{
  color: rgb(81, 0, 7);
}
.text-song-color-950\\/15{
  color: rgba(81, 0, 7, 0.15);
}
.text-song-color-950\\/20{
  color: rgba(81, 0, 7, 0.2);
}
.text-song-color-950\\/25{
  color: rgba(81, 0, 7, 0.25);
}
.text-song-color-950\\/30{
  color: rgba(81, 0, 7, 0.3);
}
.text-song-color-950\\/35{
  color: rgba(81, 0, 7, 0.35);
}
.text-song-color-950\\/40{
  color: rgba(81, 0, 7, 0.4);
}
.text-song-color-950\\/45{
  color: rgba(81, 0, 7, 0.45);
}
.text-song-color-950\\/5{
  color: rgba(81, 0, 7, 0.05);
}
.text-song-color-950\\/50{
  color: rgba(81, 0, 7, 0.5);
}
.text-song-color-950\\/55{
  color: rgba(81, 0, 7, 0.55);
}
.text-song-color-950\\/60{
  color: rgba(81, 0, 7, 0.6);
}
.text-song-color-950\\/65{
  color: rgba(81, 0, 7, 0.65);
}
.text-song-color-950\\/70{
  color: rgba(81, 0, 7, 0.7);
}
.text-song-color-950\\/75{
  color: rgba(81, 0, 7, 0.75);
}
.text-song-color-950\\/80{
  color: rgba(81, 0, 7, 0.8);
}
.text-song-color-950\\/85{
  color: rgba(81, 0, 7, 0.85);
}
.text-song-color-950\\/90{
  color: rgba(81, 0, 7, 0.9);
}
.text-song-color-950\\/95{
  color: rgba(81, 0, 7, 0.95);
}
.text-story-color-100{
  --tw-text-opacity: 1;
  color: rgba(218, 238, 243, 1);
  color: rgba(218, 238, 243, var(--tw-text-opacity, 1));
}
.text-story-color-100\\/0{
  color: rgba(218, 238, 243, 0);
}
.text-story-color-100\\/10{
  color: rgba(218, 238, 243, 0.1);
}
.text-story-color-100\\/100{
  color: rgb(218, 238, 243);
}
.text-story-color-100\\/15{
  color: rgba(218, 238, 243, 0.15);
}
.text-story-color-100\\/20{
  color: rgba(218, 238, 243, 0.2);
}
.text-story-color-100\\/25{
  color: rgba(218, 238, 243, 0.25);
}
.text-story-color-100\\/30{
  color: rgba(218, 238, 243, 0.3);
}
.text-story-color-100\\/35{
  color: rgba(218, 238, 243, 0.35);
}
.text-story-color-100\\/40{
  color: rgba(218, 238, 243, 0.4);
}
.text-story-color-100\\/45{
  color: rgba(218, 238, 243, 0.45);
}
.text-story-color-100\\/5{
  color: rgba(218, 238, 243, 0.05);
}
.text-story-color-100\\/50{
  color: rgba(218, 238, 243, 0.5);
}
.text-story-color-100\\/55{
  color: rgba(218, 238, 243, 0.55);
}
.text-story-color-100\\/60{
  color: rgba(218, 238, 243, 0.6);
}
.text-story-color-100\\/65{
  color: rgba(218, 238, 243, 0.65);
}
.text-story-color-100\\/70{
  color: rgba(218, 238, 243, 0.7);
}
.text-story-color-100\\/75{
  color: rgba(218, 238, 243, 0.75);
}
.text-story-color-100\\/80{
  color: rgba(218, 238, 243, 0.8);
}
.text-story-color-100\\/85{
  color: rgba(218, 238, 243, 0.85);
}
.text-story-color-100\\/90{
  color: rgba(218, 238, 243, 0.9);
}
.text-story-color-100\\/95{
  color: rgba(218, 238, 243, 0.95);
}
.text-story-color-200{
  --tw-text-opacity: 1;
  color: rgba(186, 222, 231, 1);
  color: rgba(186, 222, 231, var(--tw-text-opacity, 1));
}
.text-story-color-200\\/0{
  color: rgba(186, 222, 231, 0);
}
.text-story-color-200\\/10{
  color: rgba(186, 222, 231, 0.1);
}
.text-story-color-200\\/100{
  color: rgb(186, 222, 231);
}
.text-story-color-200\\/15{
  color: rgba(186, 222, 231, 0.15);
}
.text-story-color-200\\/20{
  color: rgba(186, 222, 231, 0.2);
}
.text-story-color-200\\/25{
  color: rgba(186, 222, 231, 0.25);
}
.text-story-color-200\\/30{
  color: rgba(186, 222, 231, 0.3);
}
.text-story-color-200\\/35{
  color: rgba(186, 222, 231, 0.35);
}
.text-story-color-200\\/40{
  color: rgba(186, 222, 231, 0.4);
}
.text-story-color-200\\/45{
  color: rgba(186, 222, 231, 0.45);
}
.text-story-color-200\\/5{
  color: rgba(186, 222, 231, 0.05);
}
.text-story-color-200\\/50{
  color: rgba(186, 222, 231, 0.5);
}
.text-story-color-200\\/55{
  color: rgba(186, 222, 231, 0.55);
}
.text-story-color-200\\/60{
  color: rgba(186, 222, 231, 0.6);
}
.text-story-color-200\\/65{
  color: rgba(186, 222, 231, 0.65);
}
.text-story-color-200\\/70{
  color: rgba(186, 222, 231, 0.7);
}
.text-story-color-200\\/75{
  color: rgba(186, 222, 231, 0.75);
}
.text-story-color-200\\/80{
  color: rgba(186, 222, 231, 0.8);
}
.text-story-color-200\\/85{
  color: rgba(186, 222, 231, 0.85);
}
.text-story-color-200\\/90{
  color: rgba(186, 222, 231, 0.9);
}
.text-story-color-200\\/95{
  color: rgba(186, 222, 231, 0.95);
}
.text-story-color-300{
  --tw-text-opacity: 1;
  color: rgba(137, 197, 215, 1);
  color: rgba(137, 197, 215, var(--tw-text-opacity, 1));
}
.text-story-color-300\\/0{
  color: rgba(137, 197, 215, 0);
}
.text-story-color-300\\/10{
  color: rgba(137, 197, 215, 0.1);
}
.text-story-color-300\\/100{
  color: rgb(137, 197, 215);
}
.text-story-color-300\\/15{
  color: rgba(137, 197, 215, 0.15);
}
.text-story-color-300\\/20{
  color: rgba(137, 197, 215, 0.2);
}
.text-story-color-300\\/25{
  color: rgba(137, 197, 215, 0.25);
}
.text-story-color-300\\/30{
  color: rgba(137, 197, 215, 0.3);
}
.text-story-color-300\\/35{
  color: rgba(137, 197, 215, 0.35);
}
.text-story-color-300\\/40{
  color: rgba(137, 197, 215, 0.4);
}
.text-story-color-300\\/45{
  color: rgba(137, 197, 215, 0.45);
}
.text-story-color-300\\/5{
  color: rgba(137, 197, 215, 0.05);
}
.text-story-color-300\\/50{
  color: rgba(137, 197, 215, 0.5);
}
.text-story-color-300\\/55{
  color: rgba(137, 197, 215, 0.55);
}
.text-story-color-300\\/60{
  color: rgba(137, 197, 215, 0.6);
}
.text-story-color-300\\/65{
  color: rgba(137, 197, 215, 0.65);
}
.text-story-color-300\\/70{
  color: rgba(137, 197, 215, 0.7);
}
.text-story-color-300\\/75{
  color: rgba(137, 197, 215, 0.75);
}
.text-story-color-300\\/80{
  color: rgba(137, 197, 215, 0.8);
}
.text-story-color-300\\/85{
  color: rgba(137, 197, 215, 0.85);
}
.text-story-color-300\\/90{
  color: rgba(137, 197, 215, 0.9);
}
.text-story-color-300\\/95{
  color: rgba(137, 197, 215, 0.95);
}
.text-story-color-400{
  --tw-text-opacity: 1;
  color: rgba(82, 163, 190, 1);
  color: rgba(82, 163, 190, var(--tw-text-opacity, 1));
}
.text-story-color-400\\/0{
  color: rgba(82, 163, 190, 0);
}
.text-story-color-400\\/10{
  color: rgba(82, 163, 190, 0.1);
}
.text-story-color-400\\/100{
  color: rgb(82, 163, 190);
}
.text-story-color-400\\/15{
  color: rgba(82, 163, 190, 0.15);
}
.text-story-color-400\\/20{
  color: rgba(82, 163, 190, 0.2);
}
.text-story-color-400\\/25{
  color: rgba(82, 163, 190, 0.25);
}
.text-story-color-400\\/30{
  color: rgba(82, 163, 190, 0.3);
}
.text-story-color-400\\/35{
  color: rgba(82, 163, 190, 0.35);
}
.text-story-color-400\\/40{
  color: rgba(82, 163, 190, 0.4);
}
.text-story-color-400\\/45{
  color: rgba(82, 163, 190, 0.45);
}
.text-story-color-400\\/5{
  color: rgba(82, 163, 190, 0.05);
}
.text-story-color-400\\/50{
  color: rgba(82, 163, 190, 0.5);
}
.text-story-color-400\\/55{
  color: rgba(82, 163, 190, 0.55);
}
.text-story-color-400\\/60{
  color: rgba(82, 163, 190, 0.6);
}
.text-story-color-400\\/65{
  color: rgba(82, 163, 190, 0.65);
}
.text-story-color-400\\/70{
  color: rgba(82, 163, 190, 0.7);
}
.text-story-color-400\\/75{
  color: rgba(82, 163, 190, 0.75);
}
.text-story-color-400\\/80{
  color: rgba(82, 163, 190, 0.8);
}
.text-story-color-400\\/85{
  color: rgba(82, 163, 190, 0.85);
}
.text-story-color-400\\/90{
  color: rgba(82, 163, 190, 0.9);
}
.text-story-color-400\\/95{
  color: rgba(82, 163, 190, 0.95);
}
.text-story-color-500{
  --tw-text-opacity: 1;
  color: rgba(55, 135, 163, 1);
  color: rgba(55, 135, 163, var(--tw-text-opacity, 1));
}
.text-story-color-500\\/0{
  color: rgba(55, 135, 163, 0);
}
.text-story-color-500\\/10{
  color: rgba(55, 135, 163, 0.1);
}
.text-story-color-500\\/100{
  color: rgb(55, 135, 163);
}
.text-story-color-500\\/15{
  color: rgba(55, 135, 163, 0.15);
}
.text-story-color-500\\/20{
  color: rgba(55, 135, 163, 0.2);
}
.text-story-color-500\\/25{
  color: rgba(55, 135, 163, 0.25);
}
.text-story-color-500\\/30{
  color: rgba(55, 135, 163, 0.3);
}
.text-story-color-500\\/35{
  color: rgba(55, 135, 163, 0.35);
}
.text-story-color-500\\/40{
  color: rgba(55, 135, 163, 0.4);
}
.text-story-color-500\\/45{
  color: rgba(55, 135, 163, 0.45);
}
.text-story-color-500\\/5{
  color: rgba(55, 135, 163, 0.05);
}
.text-story-color-500\\/50{
  color: rgba(55, 135, 163, 0.5);
}
.text-story-color-500\\/55{
  color: rgba(55, 135, 163, 0.55);
}
.text-story-color-500\\/60{
  color: rgba(55, 135, 163, 0.6);
}
.text-story-color-500\\/65{
  color: rgba(55, 135, 163, 0.65);
}
.text-story-color-500\\/70{
  color: rgba(55, 135, 163, 0.7);
}
.text-story-color-500\\/75{
  color: rgba(55, 135, 163, 0.75);
}
.text-story-color-500\\/80{
  color: rgba(55, 135, 163, 0.8);
}
.text-story-color-500\\/85{
  color: rgba(55, 135, 163, 0.85);
}
.text-story-color-500\\/90{
  color: rgba(55, 135, 163, 0.9);
}
.text-story-color-500\\/95{
  color: rgba(55, 135, 163, 0.95);
}
.text-story-color-600{
  --tw-text-opacity: 1;
  color: rgba(48, 109, 138, 1);
  color: rgba(48, 109, 138, var(--tw-text-opacity, 1));
}
.text-story-color-600\\/0{
  color: rgba(48, 109, 138, 0);
}
.text-story-color-600\\/10{
  color: rgba(48, 109, 138, 0.1);
}
.text-story-color-600\\/100{
  color: rgb(48, 109, 138);
}
.text-story-color-600\\/15{
  color: rgba(48, 109, 138, 0.15);
}
.text-story-color-600\\/20{
  color: rgba(48, 109, 138, 0.2);
}
.text-story-color-600\\/25{
  color: rgba(48, 109, 138, 0.25);
}
.text-story-color-600\\/30{
  color: rgba(48, 109, 138, 0.3);
}
.text-story-color-600\\/35{
  color: rgba(48, 109, 138, 0.35);
}
.text-story-color-600\\/40{
  color: rgba(48, 109, 138, 0.4);
}
.text-story-color-600\\/45{
  color: rgba(48, 109, 138, 0.45);
}
.text-story-color-600\\/5{
  color: rgba(48, 109, 138, 0.05);
}
.text-story-color-600\\/50{
  color: rgba(48, 109, 138, 0.5);
}
.text-story-color-600\\/55{
  color: rgba(48, 109, 138, 0.55);
}
.text-story-color-600\\/60{
  color: rgba(48, 109, 138, 0.6);
}
.text-story-color-600\\/65{
  color: rgba(48, 109, 138, 0.65);
}
.text-story-color-600\\/70{
  color: rgba(48, 109, 138, 0.7);
}
.text-story-color-600\\/75{
  color: rgba(48, 109, 138, 0.75);
}
.text-story-color-600\\/80{
  color: rgba(48, 109, 138, 0.8);
}
.text-story-color-600\\/85{
  color: rgba(48, 109, 138, 0.85);
}
.text-story-color-600\\/90{
  color: rgba(48, 109, 138, 0.9);
}
.text-story-color-600\\/95{
  color: rgba(48, 109, 138, 0.95);
}
.text-story-color-700{
  --tw-text-opacity: 1;
  color: rgba(45, 91, 114, 1);
  color: rgba(45, 91, 114, var(--tw-text-opacity, 1));
}
.text-story-color-700\\/0{
  color: rgba(45, 91, 114, 0);
}
.text-story-color-700\\/10{
  color: rgba(45, 91, 114, 0.1);
}
.text-story-color-700\\/100{
  color: rgb(45, 91, 114);
}
.text-story-color-700\\/15{
  color: rgba(45, 91, 114, 0.15);
}
.text-story-color-700\\/20{
  color: rgba(45, 91, 114, 0.2);
}
.text-story-color-700\\/25{
  color: rgba(45, 91, 114, 0.25);
}
.text-story-color-700\\/30{
  color: rgba(45, 91, 114, 0.3);
}
.text-story-color-700\\/35{
  color: rgba(45, 91, 114, 0.35);
}
.text-story-color-700\\/40{
  color: rgba(45, 91, 114, 0.4);
}
.text-story-color-700\\/45{
  color: rgba(45, 91, 114, 0.45);
}
.text-story-color-700\\/5{
  color: rgba(45, 91, 114, 0.05);
}
.text-story-color-700\\/50{
  color: rgba(45, 91, 114, 0.5);
}
.text-story-color-700\\/55{
  color: rgba(45, 91, 114, 0.55);
}
.text-story-color-700\\/60{
  color: rgba(45, 91, 114, 0.6);
}
.text-story-color-700\\/65{
  color: rgba(45, 91, 114, 0.65);
}
.text-story-color-700\\/70{
  color: rgba(45, 91, 114, 0.7);
}
.text-story-color-700\\/75{
  color: rgba(45, 91, 114, 0.75);
}
.text-story-color-700\\/80{
  color: rgba(45, 91, 114, 0.8);
}
.text-story-color-700\\/85{
  color: rgba(45, 91, 114, 0.85);
}
.text-story-color-700\\/90{
  color: rgba(45, 91, 114, 0.9);
}
.text-story-color-700\\/95{
  color: rgba(45, 91, 114, 0.95);
}
.text-story-color-800{
  --tw-text-opacity: 1;
  color: rgba(44, 76, 94, 1);
  color: rgba(44, 76, 94, var(--tw-text-opacity, 1));
}
.text-story-color-800\\/0{
  color: rgba(44, 76, 94, 0);
}
.text-story-color-800\\/10{
  color: rgba(44, 76, 94, 0.1);
}
.text-story-color-800\\/100{
  color: rgb(44, 76, 94);
}
.text-story-color-800\\/15{
  color: rgba(44, 76, 94, 0.15);
}
.text-story-color-800\\/20{
  color: rgba(44, 76, 94, 0.2);
}
.text-story-color-800\\/25{
  color: rgba(44, 76, 94, 0.25);
}
.text-story-color-800\\/30{
  color: rgba(44, 76, 94, 0.3);
}
.text-story-color-800\\/35{
  color: rgba(44, 76, 94, 0.35);
}
.text-story-color-800\\/40{
  color: rgba(44, 76, 94, 0.4);
}
.text-story-color-800\\/45{
  color: rgba(44, 76, 94, 0.45);
}
.text-story-color-800\\/5{
  color: rgba(44, 76, 94, 0.05);
}
.text-story-color-800\\/50{
  color: rgba(44, 76, 94, 0.5);
}
.text-story-color-800\\/55{
  color: rgba(44, 76, 94, 0.55);
}
.text-story-color-800\\/60{
  color: rgba(44, 76, 94, 0.6);
}
.text-story-color-800\\/65{
  color: rgba(44, 76, 94, 0.65);
}
.text-story-color-800\\/70{
  color: rgba(44, 76, 94, 0.7);
}
.text-story-color-800\\/75{
  color: rgba(44, 76, 94, 0.75);
}
.text-story-color-800\\/80{
  color: rgba(44, 76, 94, 0.8);
}
.text-story-color-800\\/85{
  color: rgba(44, 76, 94, 0.85);
}
.text-story-color-800\\/90{
  color: rgba(44, 76, 94, 0.9);
}
.text-story-color-800\\/95{
  color: rgba(44, 76, 94, 0.95);
}
.text-story-color-900{
  --tw-text-opacity: 1;
  color: rgba(40, 65, 81, 1);
  color: rgba(40, 65, 81, var(--tw-text-opacity, 1));
}
.text-story-color-900\\/0{
  color: rgba(40, 65, 81, 0);
}
.text-story-color-900\\/10{
  color: rgba(40, 65, 81, 0.1);
}
.text-story-color-900\\/100{
  color: rgb(40, 65, 81);
}
.text-story-color-900\\/15{
  color: rgba(40, 65, 81, 0.15);
}
.text-story-color-900\\/20{
  color: rgba(40, 65, 81, 0.2);
}
.text-story-color-900\\/25{
  color: rgba(40, 65, 81, 0.25);
}
.text-story-color-900\\/30{
  color: rgba(40, 65, 81, 0.3);
}
.text-story-color-900\\/35{
  color: rgba(40, 65, 81, 0.35);
}
.text-story-color-900\\/40{
  color: rgba(40, 65, 81, 0.4);
}
.text-story-color-900\\/45{
  color: rgba(40, 65, 81, 0.45);
}
.text-story-color-900\\/5{
  color: rgba(40, 65, 81, 0.05);
}
.text-story-color-900\\/50{
  color: rgba(40, 65, 81, 0.5);
}
.text-story-color-900\\/55{
  color: rgba(40, 65, 81, 0.55);
}
.text-story-color-900\\/60{
  color: rgba(40, 65, 81, 0.6);
}
.text-story-color-900\\/65{
  color: rgba(40, 65, 81, 0.65);
}
.text-story-color-900\\/70{
  color: rgba(40, 65, 81, 0.7);
}
.text-story-color-900\\/75{
  color: rgba(40, 65, 81, 0.75);
}
.text-story-color-900\\/80{
  color: rgba(40, 65, 81, 0.8);
}
.text-story-color-900\\/85{
  color: rgba(40, 65, 81, 0.85);
}
.text-story-color-900\\/90{
  color: rgba(40, 65, 81, 0.9);
}
.text-story-color-900\\/95{
  color: rgba(40, 65, 81, 0.95);
}
.text-story-color-950{
  --tw-text-opacity: 1;
  color: rgba(22, 41, 54, 1);
  color: rgba(22, 41, 54, var(--tw-text-opacity, 1));
}
.text-story-color-950\\/0{
  color: rgba(22, 41, 54, 0);
}
.text-story-color-950\\/10{
  color: rgba(22, 41, 54, 0.1);
}
.text-story-color-950\\/100{
  color: rgb(22, 41, 54);
}
.text-story-color-950\\/15{
  color: rgba(22, 41, 54, 0.15);
}
.text-story-color-950\\/20{
  color: rgba(22, 41, 54, 0.2);
}
.text-story-color-950\\/25{
  color: rgba(22, 41, 54, 0.25);
}
.text-story-color-950\\/30{
  color: rgba(22, 41, 54, 0.3);
}
.text-story-color-950\\/35{
  color: rgba(22, 41, 54, 0.35);
}
.text-story-color-950\\/40{
  color: rgba(22, 41, 54, 0.4);
}
.text-story-color-950\\/45{
  color: rgba(22, 41, 54, 0.45);
}
.text-story-color-950\\/5{
  color: rgba(22, 41, 54, 0.05);
}
.text-story-color-950\\/50{
  color: rgba(22, 41, 54, 0.5);
}
.text-story-color-950\\/55{
  color: rgba(22, 41, 54, 0.55);
}
.text-story-color-950\\/60{
  color: rgba(22, 41, 54, 0.6);
}
.text-story-color-950\\/65{
  color: rgba(22, 41, 54, 0.65);
}
.text-story-color-950\\/70{
  color: rgba(22, 41, 54, 0.7);
}
.text-story-color-950\\/75{
  color: rgba(22, 41, 54, 0.75);
}
.text-story-color-950\\/80{
  color: rgba(22, 41, 54, 0.8);
}
.text-story-color-950\\/85{
  color: rgba(22, 41, 54, 0.85);
}
.text-story-color-950\\/90{
  color: rgba(22, 41, 54, 0.9);
}
.text-story-color-950\\/95{
  color: rgba(22, 41, 54, 0.95);
}
.text-violet-200{
  --tw-text-opacity: 1;
  color: rgba(221, 214, 254, 1);
  color: rgba(221, 214, 254, var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity, 1));
}
.text-word-color-100{
  --tw-text-opacity: 1;
  color: rgba(217, 242, 230, 1);
  color: rgba(217, 242, 230, var(--tw-text-opacity, 1));
}
.text-word-color-100\\/0{
  color: rgba(217, 242, 230, 0);
}
.text-word-color-100\\/10{
  color: rgba(217, 242, 230, 0.1);
}
.text-word-color-100\\/100{
  color: rgb(217, 242, 230);
}
.text-word-color-100\\/15{
  color: rgba(217, 242, 230, 0.15);
}
.text-word-color-100\\/20{
  color: rgba(217, 242, 230, 0.2);
}
.text-word-color-100\\/25{
  color: rgba(217, 242, 230, 0.25);
}
.text-word-color-100\\/30{
  color: rgba(217, 242, 230, 0.3);
}
.text-word-color-100\\/35{
  color: rgba(217, 242, 230, 0.35);
}
.text-word-color-100\\/40{
  color: rgba(217, 242, 230, 0.4);
}
.text-word-color-100\\/45{
  color: rgba(217, 242, 230, 0.45);
}
.text-word-color-100\\/5{
  color: rgba(217, 242, 230, 0.05);
}
.text-word-color-100\\/50{
  color: rgba(217, 242, 230, 0.5);
}
.text-word-color-100\\/55{
  color: rgba(217, 242, 230, 0.55);
}
.text-word-color-100\\/60{
  color: rgba(217, 242, 230, 0.6);
}
.text-word-color-100\\/65{
  color: rgba(217, 242, 230, 0.65);
}
.text-word-color-100\\/70{
  color: rgba(217, 242, 230, 0.7);
}
.text-word-color-100\\/75{
  color: rgba(217, 242, 230, 0.75);
}
.text-word-color-100\\/80{
  color: rgba(217, 242, 230, 0.8);
}
.text-word-color-100\\/85{
  color: rgba(217, 242, 230, 0.85);
}
.text-word-color-100\\/90{
  color: rgba(217, 242, 230, 0.9);
}
.text-word-color-100\\/95{
  color: rgba(217, 242, 230, 0.95);
}
.text-word-color-200{
  --tw-text-opacity: 1;
  color: rgba(182, 228, 209, 1);
  color: rgba(182, 228, 209, var(--tw-text-opacity, 1));
}
.text-word-color-200\\/0{
  color: rgba(182, 228, 209, 0);
}
.text-word-color-200\\/10{
  color: rgba(182, 228, 209, 0.1);
}
.text-word-color-200\\/100{
  color: rgb(182, 228, 209);
}
.text-word-color-200\\/15{
  color: rgba(182, 228, 209, 0.15);
}
.text-word-color-200\\/20{
  color: rgba(182, 228, 209, 0.2);
}
.text-word-color-200\\/25{
  color: rgba(182, 228, 209, 0.25);
}
.text-word-color-200\\/30{
  color: rgba(182, 228, 209, 0.3);
}
.text-word-color-200\\/35{
  color: rgba(182, 228, 209, 0.35);
}
.text-word-color-200\\/40{
  color: rgba(182, 228, 209, 0.4);
}
.text-word-color-200\\/45{
  color: rgba(182, 228, 209, 0.45);
}
.text-word-color-200\\/5{
  color: rgba(182, 228, 209, 0.05);
}
.text-word-color-200\\/50{
  color: rgba(182, 228, 209, 0.5);
}
.text-word-color-200\\/55{
  color: rgba(182, 228, 209, 0.55);
}
.text-word-color-200\\/60{
  color: rgba(182, 228, 209, 0.6);
}
.text-word-color-200\\/65{
  color: rgba(182, 228, 209, 0.65);
}
.text-word-color-200\\/70{
  color: rgba(182, 228, 209, 0.7);
}
.text-word-color-200\\/75{
  color: rgba(182, 228, 209, 0.75);
}
.text-word-color-200\\/80{
  color: rgba(182, 228, 209, 0.8);
}
.text-word-color-200\\/85{
  color: rgba(182, 228, 209, 0.85);
}
.text-word-color-200\\/90{
  color: rgba(182, 228, 209, 0.9);
}
.text-word-color-200\\/95{
  color: rgba(182, 228, 209, 0.95);
}
.text-word-color-300{
  --tw-text-opacity: 1;
  color: rgba(134, 207, 181, 1);
  color: rgba(134, 207, 181, var(--tw-text-opacity, 1));
}
.text-word-color-300\\/0{
  color: rgba(134, 207, 181, 0);
}
.text-word-color-300\\/10{
  color: rgba(134, 207, 181, 0.1);
}
.text-word-color-300\\/100{
  color: rgb(134, 207, 181);
}
.text-word-color-300\\/15{
  color: rgba(134, 207, 181, 0.15);
}
.text-word-color-300\\/20{
  color: rgba(134, 207, 181, 0.2);
}
.text-word-color-300\\/25{
  color: rgba(134, 207, 181, 0.25);
}
.text-word-color-300\\/30{
  color: rgba(134, 207, 181, 0.3);
}
.text-word-color-300\\/35{
  color: rgba(134, 207, 181, 0.35);
}
.text-word-color-300\\/40{
  color: rgba(134, 207, 181, 0.4);
}
.text-word-color-300\\/45{
  color: rgba(134, 207, 181, 0.45);
}
.text-word-color-300\\/5{
  color: rgba(134, 207, 181, 0.05);
}
.text-word-color-300\\/50{
  color: rgba(134, 207, 181, 0.5);
}
.text-word-color-300\\/55{
  color: rgba(134, 207, 181, 0.55);
}
.text-word-color-300\\/60{
  color: rgba(134, 207, 181, 0.6);
}
.text-word-color-300\\/65{
  color: rgba(134, 207, 181, 0.65);
}
.text-word-color-300\\/70{
  color: rgba(134, 207, 181, 0.7);
}
.text-word-color-300\\/75{
  color: rgba(134, 207, 181, 0.75);
}
.text-word-color-300\\/80{
  color: rgba(134, 207, 181, 0.8);
}
.text-word-color-300\\/85{
  color: rgba(134, 207, 181, 0.85);
}
.text-word-color-300\\/90{
  color: rgba(134, 207, 181, 0.9);
}
.text-word-color-300\\/95{
  color: rgba(134, 207, 181, 0.95);
}
.text-word-color-400{
  --tw-text-opacity: 1;
  color: rgba(83, 180, 148, 1);
  color: rgba(83, 180, 148, var(--tw-text-opacity, 1));
}
.text-word-color-400\\/0{
  color: rgba(83, 180, 148, 0);
}
.text-word-color-400\\/10{
  color: rgba(83, 180, 148, 0.1);
}
.text-word-color-400\\/100{
  color: rgb(83, 180, 148);
}
.text-word-color-400\\/15{
  color: rgba(83, 180, 148, 0.15);
}
.text-word-color-400\\/20{
  color: rgba(83, 180, 148, 0.2);
}
.text-word-color-400\\/25{
  color: rgba(83, 180, 148, 0.25);
}
.text-word-color-400\\/30{
  color: rgba(83, 180, 148, 0.3);
}
.text-word-color-400\\/35{
  color: rgba(83, 180, 148, 0.35);
}
.text-word-color-400\\/40{
  color: rgba(83, 180, 148, 0.4);
}
.text-word-color-400\\/45{
  color: rgba(83, 180, 148, 0.45);
}
.text-word-color-400\\/5{
  color: rgba(83, 180, 148, 0.05);
}
.text-word-color-400\\/50{
  color: rgba(83, 180, 148, 0.5);
}
.text-word-color-400\\/55{
  color: rgba(83, 180, 148, 0.55);
}
.text-word-color-400\\/60{
  color: rgba(83, 180, 148, 0.6);
}
.text-word-color-400\\/65{
  color: rgba(83, 180, 148, 0.65);
}
.text-word-color-400\\/70{
  color: rgba(83, 180, 148, 0.7);
}
.text-word-color-400\\/75{
  color: rgba(83, 180, 148, 0.75);
}
.text-word-color-400\\/80{
  color: rgba(83, 180, 148, 0.8);
}
.text-word-color-400\\/85{
  color: rgba(83, 180, 148, 0.85);
}
.text-word-color-400\\/90{
  color: rgba(83, 180, 148, 0.9);
}
.text-word-color-400\\/95{
  color: rgba(83, 180, 148, 0.95);
}
.text-word-color-500{
  --tw-text-opacity: 1;
  color: rgba(44, 135, 109, 1);
  color: rgba(44, 135, 109, var(--tw-text-opacity, 1));
}
.text-word-color-500\\/0{
  color: rgba(44, 135, 109, 0);
}
.text-word-color-500\\/10{
  color: rgba(44, 135, 109, 0.1);
}
.text-word-color-500\\/100{
  color: rgb(44, 135, 109);
}
.text-word-color-500\\/15{
  color: rgba(44, 135, 109, 0.15);
}
.text-word-color-500\\/20{
  color: rgba(44, 135, 109, 0.2);
}
.text-word-color-500\\/25{
  color: rgba(44, 135, 109, 0.25);
}
.text-word-color-500\\/30{
  color: rgba(44, 135, 109, 0.3);
}
.text-word-color-500\\/35{
  color: rgba(44, 135, 109, 0.35);
}
.text-word-color-500\\/40{
  color: rgba(44, 135, 109, 0.4);
}
.text-word-color-500\\/45{
  color: rgba(44, 135, 109, 0.45);
}
.text-word-color-500\\/5{
  color: rgba(44, 135, 109, 0.05);
}
.text-word-color-500\\/50{
  color: rgba(44, 135, 109, 0.5);
}
.text-word-color-500\\/55{
  color: rgba(44, 135, 109, 0.55);
}
.text-word-color-500\\/60{
  color: rgba(44, 135, 109, 0.6);
}
.text-word-color-500\\/65{
  color: rgba(44, 135, 109, 0.65);
}
.text-word-color-500\\/70{
  color: rgba(44, 135, 109, 0.7);
}
.text-word-color-500\\/75{
  color: rgba(44, 135, 109, 0.75);
}
.text-word-color-500\\/80{
  color: rgba(44, 135, 109, 0.8);
}
.text-word-color-500\\/85{
  color: rgba(44, 135, 109, 0.85);
}
.text-word-color-500\\/90{
  color: rgba(44, 135, 109, 0.9);
}
.text-word-color-500\\/95{
  color: rgba(44, 135, 109, 0.95);
}
.text-word-color-600{
  --tw-text-opacity: 1;
  color: rgba(34, 121, 98, 1);
  color: rgba(34, 121, 98, var(--tw-text-opacity, 1));
}
.text-word-color-600\\/0{
  color: rgba(34, 121, 98, 0);
}
.text-word-color-600\\/10{
  color: rgba(34, 121, 98, 0.1);
}
.text-word-color-600\\/100{
  color: rgb(34, 121, 98);
}
.text-word-color-600\\/15{
  color: rgba(34, 121, 98, 0.15);
}
.text-word-color-600\\/20{
  color: rgba(34, 121, 98, 0.2);
}
.text-word-color-600\\/25{
  color: rgba(34, 121, 98, 0.25);
}
.text-word-color-600\\/30{
  color: rgba(34, 121, 98, 0.3);
}
.text-word-color-600\\/35{
  color: rgba(34, 121, 98, 0.35);
}
.text-word-color-600\\/40{
  color: rgba(34, 121, 98, 0.4);
}
.text-word-color-600\\/45{
  color: rgba(34, 121, 98, 0.45);
}
.text-word-color-600\\/5{
  color: rgba(34, 121, 98, 0.05);
}
.text-word-color-600\\/50{
  color: rgba(34, 121, 98, 0.5);
}
.text-word-color-600\\/55{
  color: rgba(34, 121, 98, 0.55);
}
.text-word-color-600\\/60{
  color: rgba(34, 121, 98, 0.6);
}
.text-word-color-600\\/65{
  color: rgba(34, 121, 98, 0.65);
}
.text-word-color-600\\/70{
  color: rgba(34, 121, 98, 0.7);
}
.text-word-color-600\\/75{
  color: rgba(34, 121, 98, 0.75);
}
.text-word-color-600\\/80{
  color: rgba(34, 121, 98, 0.8);
}
.text-word-color-600\\/85{
  color: rgba(34, 121, 98, 0.85);
}
.text-word-color-600\\/90{
  color: rgba(34, 121, 98, 0.9);
}
.text-word-color-600\\/95{
  color: rgba(34, 121, 98, 0.95);
}
.text-word-color-700{
  --tw-text-opacity: 1;
  color: rgba(27, 97, 80, 1);
  color: rgba(27, 97, 80, var(--tw-text-opacity, 1));
}
.text-word-color-700\\/0{
  color: rgba(27, 97, 80, 0);
}
.text-word-color-700\\/10{
  color: rgba(27, 97, 80, 0.1);
}
.text-word-color-700\\/100{
  color: rgb(27, 97, 80);
}
.text-word-color-700\\/15{
  color: rgba(27, 97, 80, 0.15);
}
.text-word-color-700\\/20{
  color: rgba(27, 97, 80, 0.2);
}
.text-word-color-700\\/25{
  color: rgba(27, 97, 80, 0.25);
}
.text-word-color-700\\/30{
  color: rgba(27, 97, 80, 0.3);
}
.text-word-color-700\\/35{
  color: rgba(27, 97, 80, 0.35);
}
.text-word-color-700\\/40{
  color: rgba(27, 97, 80, 0.4);
}
.text-word-color-700\\/45{
  color: rgba(27, 97, 80, 0.45);
}
.text-word-color-700\\/5{
  color: rgba(27, 97, 80, 0.05);
}
.text-word-color-700\\/50{
  color: rgba(27, 97, 80, 0.5);
}
.text-word-color-700\\/55{
  color: rgba(27, 97, 80, 0.55);
}
.text-word-color-700\\/60{
  color: rgba(27, 97, 80, 0.6);
}
.text-word-color-700\\/65{
  color: rgba(27, 97, 80, 0.65);
}
.text-word-color-700\\/70{
  color: rgba(27, 97, 80, 0.7);
}
.text-word-color-700\\/75{
  color: rgba(27, 97, 80, 0.75);
}
.text-word-color-700\\/80{
  color: rgba(27, 97, 80, 0.8);
}
.text-word-color-700\\/85{
  color: rgba(27, 97, 80, 0.85);
}
.text-word-color-700\\/90{
  color: rgba(27, 97, 80, 0.9);
}
.text-word-color-700\\/95{
  color: rgba(27, 97, 80, 0.95);
}
.text-word-color-800{
  --tw-text-opacity: 1;
  color: rgba(24, 77, 64, 1);
  color: rgba(24, 77, 64, var(--tw-text-opacity, 1));
}
.text-word-color-800\\/0{
  color: rgba(24, 77, 64, 0);
}
.text-word-color-800\\/10{
  color: rgba(24, 77, 64, 0.1);
}
.text-word-color-800\\/100{
  color: rgb(24, 77, 64);
}
.text-word-color-800\\/15{
  color: rgba(24, 77, 64, 0.15);
}
.text-word-color-800\\/20{
  color: rgba(24, 77, 64, 0.2);
}
.text-word-color-800\\/25{
  color: rgba(24, 77, 64, 0.25);
}
.text-word-color-800\\/30{
  color: rgba(24, 77, 64, 0.3);
}
.text-word-color-800\\/35{
  color: rgba(24, 77, 64, 0.35);
}
.text-word-color-800\\/40{
  color: rgba(24, 77, 64, 0.4);
}
.text-word-color-800\\/45{
  color: rgba(24, 77, 64, 0.45);
}
.text-word-color-800\\/5{
  color: rgba(24, 77, 64, 0.05);
}
.text-word-color-800\\/50{
  color: rgba(24, 77, 64, 0.5);
}
.text-word-color-800\\/55{
  color: rgba(24, 77, 64, 0.55);
}
.text-word-color-800\\/60{
  color: rgba(24, 77, 64, 0.6);
}
.text-word-color-800\\/65{
  color: rgba(24, 77, 64, 0.65);
}
.text-word-color-800\\/70{
  color: rgba(24, 77, 64, 0.7);
}
.text-word-color-800\\/75{
  color: rgba(24, 77, 64, 0.75);
}
.text-word-color-800\\/80{
  color: rgba(24, 77, 64, 0.8);
}
.text-word-color-800\\/85{
  color: rgba(24, 77, 64, 0.85);
}
.text-word-color-800\\/90{
  color: rgba(24, 77, 64, 0.9);
}
.text-word-color-800\\/95{
  color: rgba(24, 77, 64, 0.95);
}
.text-word-color-900{
  --tw-text-opacity: 1;
  color: rgba(20, 64, 54, 1);
  color: rgba(20, 64, 54, var(--tw-text-opacity, 1));
}
.text-word-color-900\\/0{
  color: rgba(20, 64, 54, 0);
}
.text-word-color-900\\/10{
  color: rgba(20, 64, 54, 0.1);
}
.text-word-color-900\\/100{
  color: rgb(20, 64, 54);
}
.text-word-color-900\\/15{
  color: rgba(20, 64, 54, 0.15);
}
.text-word-color-900\\/20{
  color: rgba(20, 64, 54, 0.2);
}
.text-word-color-900\\/25{
  color: rgba(20, 64, 54, 0.25);
}
.text-word-color-900\\/30{
  color: rgba(20, 64, 54, 0.3);
}
.text-word-color-900\\/35{
  color: rgba(20, 64, 54, 0.35);
}
.text-word-color-900\\/40{
  color: rgba(20, 64, 54, 0.4);
}
.text-word-color-900\\/45{
  color: rgba(20, 64, 54, 0.45);
}
.text-word-color-900\\/5{
  color: rgba(20, 64, 54, 0.05);
}
.text-word-color-900\\/50{
  color: rgba(20, 64, 54, 0.5);
}
.text-word-color-900\\/55{
  color: rgba(20, 64, 54, 0.55);
}
.text-word-color-900\\/60{
  color: rgba(20, 64, 54, 0.6);
}
.text-word-color-900\\/65{
  color: rgba(20, 64, 54, 0.65);
}
.text-word-color-900\\/70{
  color: rgba(20, 64, 54, 0.7);
}
.text-word-color-900\\/75{
  color: rgba(20, 64, 54, 0.75);
}
.text-word-color-900\\/80{
  color: rgba(20, 64, 54, 0.8);
}
.text-word-color-900\\/85{
  color: rgba(20, 64, 54, 0.85);
}
.text-word-color-900\\/90{
  color: rgba(20, 64, 54, 0.9);
}
.text-word-color-900\\/95{
  color: rgba(20, 64, 54, 0.95);
}
.text-word-color-950{
  --tw-text-opacity: 1;
  color: rgba(10, 36, 31, 1);
  color: rgba(10, 36, 31, var(--tw-text-opacity, 1));
}
.text-word-color-950\\/0{
  color: rgba(10, 36, 31, 0);
}
.text-word-color-950\\/10{
  color: rgba(10, 36, 31, 0.1);
}
.text-word-color-950\\/100{
  color: rgb(10, 36, 31);
}
.text-word-color-950\\/15{
  color: rgba(10, 36, 31, 0.15);
}
.text-word-color-950\\/20{
  color: rgba(10, 36, 31, 0.2);
}
.text-word-color-950\\/25{
  color: rgba(10, 36, 31, 0.25);
}
.text-word-color-950\\/30{
  color: rgba(10, 36, 31, 0.3);
}
.text-word-color-950\\/35{
  color: rgba(10, 36, 31, 0.35);
}
.text-word-color-950\\/40{
  color: rgba(10, 36, 31, 0.4);
}
.text-word-color-950\\/45{
  color: rgba(10, 36, 31, 0.45);
}
.text-word-color-950\\/5{
  color: rgba(10, 36, 31, 0.05);
}
.text-word-color-950\\/50{
  color: rgba(10, 36, 31, 0.5);
}
.text-word-color-950\\/55{
  color: rgba(10, 36, 31, 0.55);
}
.text-word-color-950\\/60{
  color: rgba(10, 36, 31, 0.6);
}
.text-word-color-950\\/65{
  color: rgba(10, 36, 31, 0.65);
}
.text-word-color-950\\/70{
  color: rgba(10, 36, 31, 0.7);
}
.text-word-color-950\\/75{
  color: rgba(10, 36, 31, 0.75);
}
.text-word-color-950\\/80{
  color: rgba(10, 36, 31, 0.8);
}
.text-word-color-950\\/85{
  color: rgba(10, 36, 31, 0.85);
}
.text-word-color-950\\/90{
  color: rgba(10, 36, 31, 0.9);
}
.text-word-color-950\\/95{
  color: rgba(10, 36, 31, 0.95);
}
.text-wordsy-present{
  --tw-text-opacity: 1;
  color: rgba(195, 120, 41, 1);
  color: rgba(195, 120, 41, var(--tw-text-opacity, 1));
}
.text-opacity-80{
  --tw-text-opacity: 0.8;
}
.underline{
  text-decoration-line: underline;
}
.placeholder-charcoal-500::-moz-placeholder{
  --tw-placeholder-opacity: 1;
  color: rgba(106, 107, 112, 1);
  color: rgba(106, 107, 112, var(--tw-placeholder-opacity, 1));
}
.placeholder-charcoal-500::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgba(106, 107, 112, 1);
  color: rgba(106, 107, 112, var(--tw-placeholder-opacity, 1));
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-75{
  opacity: 0.75;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(1px + 0px) #2563eb, 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(2px + 2px) #2563eb, 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.ring-4{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.ring-black{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(0, 0, 0, var(--tw-ring-opacity, 1));
}
.ring-charcoal-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(230, 230, 231, var(--tw-ring-opacity, 1));
}
.ring-jade-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(44, 135, 109, var(--tw-ring-opacity, 1));
}
.ring-scarlet-800{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(180, 2, 18, var(--tw-ring-opacity, 1));
}
.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(255, 255, 255, var(--tw-ring-opacity, 1));
}
.ring-opacity-5{
  --tw-ring-opacity: 0.05;
}
.ring-offset-2{
  --tw-ring-offset-width: 2px;
}
.blur{
  --tw-blur: blur(8px);
  filter: blur(8px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md{
  --tw-drop-shadow: drop-shadow(0 4px 3px rgba(0, 0, 0, 0.07)) drop-shadow(0 2px 2px rgba(0, 0, 0, 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) drop-shadow(0 4px 3px rgba(0, 0, 0, 0.07)) drop-shadow(0 2px 2px rgba(0, 0, 0, 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-brightness-65{
  --tw-backdrop-brightness: brightness(.65);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) brightness(.65) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) brightness(.65) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100{
  transition-duration: 100ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-75{
  transition-duration: 75ms;
}
.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.breakAfter {
    page-break-after: always;
  }
.tooltip{
  visibility: hidden;
  position: absolute;
}
.has-tooltip:hover .tooltip{
  visibility: visible;
  z-index: 50;
}

/* Changes to wysiwyg classes need to be mirrored in the function passed to the editor e.g.\`frontend/app_v2/src/components/Form/WysiwygField.js\` */

/* Prevent blue focus outline in tiptap editor */
.wysiwyg .ProseMirror:focus {
  outline: none;
  box-shadow: none;
}

/* These component rules can be over-ridden using utility classes. 
For example over-ride the colour of the btn-contained backgound using bg-scarlet-800 */

.hover\\:btn-primary:hover{
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.hover\\:btn-primary:hover > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * 0);
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * (1 - 0));
  margin-left: calc(0.5rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(0.5rem * calc(1 - 0));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}

.hover\\:btn-primary:hover{
  border-radius: 1.5rem;
  --tw-bg-opacity: 1;
  background-color: rgba(48, 109, 138, 1);
  background-color: rgba(48, 109, 138, var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgba(218, 238, 243, 1);
  color: rgba(218, 238, 243, var(--tw-text-opacity, 1));
}

.hover\\:btn-primary:hover:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(44, 76, 94, 1);
  background-color: rgba(44, 76, 94, var(--tw-bg-opacity, 1));
}

.hover\\:btn-primary:hover:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(2px + 2px) #2563eb, 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(137, 197, 215, var(--tw-ring-opacity, 1));
}

@media (min-width: 1024px){
  .lg\\:aspect-w-3{
    position: relative;
    padding-bottom: calc(var(--tw-aspect-h) / 3 * 100%);
    padding-bottom: calc(var(--tw-aspect-h) / var(--tw-aspect-w) * 100%);
    --tw-aspect-w: 3;
  }
  .lg\\:aspect-w-3 > *{
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
}

@media (min-width: 1280px){
  .xl\\:aspect-w-3{
    position: relative;
    padding-bottom: calc(var(--tw-aspect-h) / 3 * 100%);
    padding-bottom: calc(var(--tw-aspect-h) / var(--tw-aspect-w) * 100%);
    --tw-aspect-w: 3;
  }
  .xl\\:aspect-w-3 > *{
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
}

.placeholder\\:italic::-moz-placeholder{
  font-style: italic;
}

.placeholder\\:italic::placeholder{
  font-style: italic;
}

.placeholder\\:text-charcoal-400::-moz-placeholder{
  --tw-text-opacity: 1;
  color: rgba(133, 134, 139, 1);
  color: rgba(133, 134, 139, var(--tw-text-opacity, 1));
}

.placeholder\\:text-charcoal-400::placeholder{
  --tw-text-opacity: 1;
  color: rgba(133, 134, 139, 1);
  color: rgba(133, 134, 139, var(--tw-text-opacity, 1));
}

.placeholder\\:text-charcoal-500::-moz-placeholder{
  --tw-text-opacity: 1;
  color: rgba(106, 107, 112, 1);
  color: rgba(106, 107, 112, var(--tw-text-opacity, 1));
}

.placeholder\\:text-charcoal-500::placeholder{
  --tw-text-opacity: 1;
  color: rgba(106, 107, 112, 1);
  color: rgba(106, 107, 112, var(--tw-text-opacity, 1));
}

.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}

.focus-within\\:text-charcoal-700:focus-within{
  --tw-text-opacity: 1;
  color: rgba(77, 77, 81, 1);
  color: rgba(77, 77, 81, var(--tw-text-opacity, 1));
}

.focus-within\\:ring-2:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(2px + 2px) #2563eb, 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus-within\\:ring-inset:focus-within{
  --tw-ring-inset: inset;
}

.focus-within\\:ring-blumine-800:focus-within{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(44, 76, 94, var(--tw-ring-opacity, 1));
}

.focus-within\\:ring-charcoal-500:focus-within{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(106, 107, 112, var(--tw-ring-opacity, 1));
}

.focus-within\\:ring-ochre-800:focus-within{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(126, 67, 34, var(--tw-ring-opacity, 1));
}

.focus-within\\:ring-scarlet-800:focus-within{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(180, 2, 18, var(--tw-ring-opacity, 1));
}

.focus-within\\:ring-offset-1:focus-within{
  --tw-ring-offset-width: 1px;
}

.focus-within\\:ring-offset-2:focus-within{
  --tw-ring-offset-width: 2px;
}

.focus-within\\:ring-offset-charcoal-50:focus-within{
  --tw-ring-offset-color: #f5f5f6;
}

.hover\\:scale-110:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.1) scaleY(1.1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:cursor-pointer:hover{
  cursor: pointer;
}

.hover\\:border-blumine-100:hover{
  --tw-border-opacity: 1;
  border-color: rgba(218, 238, 243, 1);
  border-color: rgba(218, 238, 243, var(--tw-border-opacity, 1));
}

.hover\\:border-blumine-100\\/0:hover{
  border-color: rgba(218, 238, 243, 0);
}

.hover\\:border-blumine-100\\/10:hover{
  border-color: rgba(218, 238, 243, 0.1);
}

.hover\\:border-blumine-100\\/100:hover{
  border-color: rgb(218, 238, 243);
}

.hover\\:border-blumine-100\\/15:hover{
  border-color: rgba(218, 238, 243, 0.15);
}

.hover\\:border-blumine-100\\/20:hover{
  border-color: rgba(218, 238, 243, 0.2);
}

.hover\\:border-blumine-100\\/25:hover{
  border-color: rgba(218, 238, 243, 0.25);
}

.hover\\:border-blumine-100\\/30:hover{
  border-color: rgba(218, 238, 243, 0.3);
}

.hover\\:border-blumine-100\\/35:hover{
  border-color: rgba(218, 238, 243, 0.35);
}

.hover\\:border-blumine-100\\/40:hover{
  border-color: rgba(218, 238, 243, 0.4);
}

.hover\\:border-blumine-100\\/45:hover{
  border-color: rgba(218, 238, 243, 0.45);
}

.hover\\:border-blumine-100\\/5:hover{
  border-color: rgba(218, 238, 243, 0.05);
}

.hover\\:border-blumine-100\\/50:hover{
  border-color: rgba(218, 238, 243, 0.5);
}

.hover\\:border-blumine-100\\/55:hover{
  border-color: rgba(218, 238, 243, 0.55);
}

.hover\\:border-blumine-100\\/60:hover{
  border-color: rgba(218, 238, 243, 0.6);
}

.hover\\:border-blumine-100\\/65:hover{
  border-color: rgba(218, 238, 243, 0.65);
}

.hover\\:border-blumine-100\\/70:hover{
  border-color: rgba(218, 238, 243, 0.7);
}

.hover\\:border-blumine-100\\/75:hover{
  border-color: rgba(218, 238, 243, 0.75);
}

.hover\\:border-blumine-100\\/80:hover{
  border-color: rgba(218, 238, 243, 0.8);
}

.hover\\:border-blumine-100\\/85:hover{
  border-color: rgba(218, 238, 243, 0.85);
}

.hover\\:border-blumine-100\\/90:hover{
  border-color: rgba(218, 238, 243, 0.9);
}

.hover\\:border-blumine-100\\/95:hover{
  border-color: rgba(218, 238, 243, 0.95);
}

.hover\\:border-blumine-200:hover{
  --tw-border-opacity: 1;
  border-color: rgba(186, 222, 231, 1);
  border-color: rgba(186, 222, 231, var(--tw-border-opacity, 1));
}

.hover\\:border-blumine-200\\/0:hover{
  border-color: rgba(186, 222, 231, 0);
}

.hover\\:border-blumine-200\\/10:hover{
  border-color: rgba(186, 222, 231, 0.1);
}

.hover\\:border-blumine-200\\/100:hover{
  border-color: rgb(186, 222, 231);
}

.hover\\:border-blumine-200\\/15:hover{
  border-color: rgba(186, 222, 231, 0.15);
}

.hover\\:border-blumine-200\\/20:hover{
  border-color: rgba(186, 222, 231, 0.2);
}

.hover\\:border-blumine-200\\/25:hover{
  border-color: rgba(186, 222, 231, 0.25);
}

.hover\\:border-blumine-200\\/30:hover{
  border-color: rgba(186, 222, 231, 0.3);
}

.hover\\:border-blumine-200\\/35:hover{
  border-color: rgba(186, 222, 231, 0.35);
}

.hover\\:border-blumine-200\\/40:hover{
  border-color: rgba(186, 222, 231, 0.4);
}

.hover\\:border-blumine-200\\/45:hover{
  border-color: rgba(186, 222, 231, 0.45);
}

.hover\\:border-blumine-200\\/5:hover{
  border-color: rgba(186, 222, 231, 0.05);
}

.hover\\:border-blumine-200\\/50:hover{
  border-color: rgba(186, 222, 231, 0.5);
}

.hover\\:border-blumine-200\\/55:hover{
  border-color: rgba(186, 222, 231, 0.55);
}

.hover\\:border-blumine-200\\/60:hover{
  border-color: rgba(186, 222, 231, 0.6);
}

.hover\\:border-blumine-200\\/65:hover{
  border-color: rgba(186, 222, 231, 0.65);
}

.hover\\:border-blumine-200\\/70:hover{
  border-color: rgba(186, 222, 231, 0.7);
}

.hover\\:border-blumine-200\\/75:hover{
  border-color: rgba(186, 222, 231, 0.75);
}

.hover\\:border-blumine-200\\/80:hover{
  border-color: rgba(186, 222, 231, 0.8);
}

.hover\\:border-blumine-200\\/85:hover{
  border-color: rgba(186, 222, 231, 0.85);
}

.hover\\:border-blumine-200\\/90:hover{
  border-color: rgba(186, 222, 231, 0.9);
}

.hover\\:border-blumine-200\\/95:hover{
  border-color: rgba(186, 222, 231, 0.95);
}

.hover\\:border-blumine-300:hover{
  --tw-border-opacity: 1;
  border-color: rgba(137, 197, 215, 1);
  border-color: rgba(137, 197, 215, var(--tw-border-opacity, 1));
}

.hover\\:border-blumine-300\\/0:hover{
  border-color: rgba(137, 197, 215, 0);
}

.hover\\:border-blumine-300\\/10:hover{
  border-color: rgba(137, 197, 215, 0.1);
}

.hover\\:border-blumine-300\\/100:hover{
  border-color: rgb(137, 197, 215);
}

.hover\\:border-blumine-300\\/15:hover{
  border-color: rgba(137, 197, 215, 0.15);
}

.hover\\:border-blumine-300\\/20:hover{
  border-color: rgba(137, 197, 215, 0.2);
}

.hover\\:border-blumine-300\\/25:hover{
  border-color: rgba(137, 197, 215, 0.25);
}

.hover\\:border-blumine-300\\/30:hover{
  border-color: rgba(137, 197, 215, 0.3);
}

.hover\\:border-blumine-300\\/35:hover{
  border-color: rgba(137, 197, 215, 0.35);
}

.hover\\:border-blumine-300\\/40:hover{
  border-color: rgba(137, 197, 215, 0.4);
}

.hover\\:border-blumine-300\\/45:hover{
  border-color: rgba(137, 197, 215, 0.45);
}

.hover\\:border-blumine-300\\/5:hover{
  border-color: rgba(137, 197, 215, 0.05);
}

.hover\\:border-blumine-300\\/50:hover{
  border-color: rgba(137, 197, 215, 0.5);
}

.hover\\:border-blumine-300\\/55:hover{
  border-color: rgba(137, 197, 215, 0.55);
}

.hover\\:border-blumine-300\\/60:hover{
  border-color: rgba(137, 197, 215, 0.6);
}

.hover\\:border-blumine-300\\/65:hover{
  border-color: rgba(137, 197, 215, 0.65);
}

.hover\\:border-blumine-300\\/70:hover{
  border-color: rgba(137, 197, 215, 0.7);
}

.hover\\:border-blumine-300\\/75:hover{
  border-color: rgba(137, 197, 215, 0.75);
}

.hover\\:border-blumine-300\\/80:hover{
  border-color: rgba(137, 197, 215, 0.8);
}

.hover\\:border-blumine-300\\/85:hover{
  border-color: rgba(137, 197, 215, 0.85);
}

.hover\\:border-blumine-300\\/90:hover{
  border-color: rgba(137, 197, 215, 0.9);
}

.hover\\:border-blumine-300\\/95:hover{
  border-color: rgba(137, 197, 215, 0.95);
}

.hover\\:border-blumine-400:hover{
  --tw-border-opacity: 1;
  border-color: rgba(82, 163, 190, 1);
  border-color: rgba(82, 163, 190, var(--tw-border-opacity, 1));
}

.hover\\:border-blumine-400\\/0:hover{
  border-color: rgba(82, 163, 190, 0);
}

.hover\\:border-blumine-400\\/10:hover{
  border-color: rgba(82, 163, 190, 0.1);
}

.hover\\:border-blumine-400\\/100:hover{
  border-color: rgb(82, 163, 190);
}

.hover\\:border-blumine-400\\/15:hover{
  border-color: rgba(82, 163, 190, 0.15);
}

.hover\\:border-blumine-400\\/20:hover{
  border-color: rgba(82, 163, 190, 0.2);
}

.hover\\:border-blumine-400\\/25:hover{
  border-color: rgba(82, 163, 190, 0.25);
}

.hover\\:border-blumine-400\\/30:hover{
  border-color: rgba(82, 163, 190, 0.3);
}

.hover\\:border-blumine-400\\/35:hover{
  border-color: rgba(82, 163, 190, 0.35);
}

.hover\\:border-blumine-400\\/40:hover{
  border-color: rgba(82, 163, 190, 0.4);
}

.hover\\:border-blumine-400\\/45:hover{
  border-color: rgba(82, 163, 190, 0.45);
}

.hover\\:border-blumine-400\\/5:hover{
  border-color: rgba(82, 163, 190, 0.05);
}

.hover\\:border-blumine-400\\/50:hover{
  border-color: rgba(82, 163, 190, 0.5);
}

.hover\\:border-blumine-400\\/55:hover{
  border-color: rgba(82, 163, 190, 0.55);
}

.hover\\:border-blumine-400\\/60:hover{
  border-color: rgba(82, 163, 190, 0.6);
}

.hover\\:border-blumine-400\\/65:hover{
  border-color: rgba(82, 163, 190, 0.65);
}

.hover\\:border-blumine-400\\/70:hover{
  border-color: rgba(82, 163, 190, 0.7);
}

.hover\\:border-blumine-400\\/75:hover{
  border-color: rgba(82, 163, 190, 0.75);
}

.hover\\:border-blumine-400\\/80:hover{
  border-color: rgba(82, 163, 190, 0.8);
}

.hover\\:border-blumine-400\\/85:hover{
  border-color: rgba(82, 163, 190, 0.85);
}

.hover\\:border-blumine-400\\/90:hover{
  border-color: rgba(82, 163, 190, 0.9);
}

.hover\\:border-blumine-400\\/95:hover{
  border-color: rgba(82, 163, 190, 0.95);
}

.hover\\:border-blumine-500:hover{
  --tw-border-opacity: 1;
  border-color: rgba(55, 135, 163, 1);
  border-color: rgba(55, 135, 163, var(--tw-border-opacity, 1));
}

.hover\\:border-blumine-500\\/0:hover{
  border-color: rgba(55, 135, 163, 0);
}

.hover\\:border-blumine-500\\/10:hover{
  border-color: rgba(55, 135, 163, 0.1);
}

.hover\\:border-blumine-500\\/100:hover{
  border-color: rgb(55, 135, 163);
}

.hover\\:border-blumine-500\\/15:hover{
  border-color: rgba(55, 135, 163, 0.15);
}

.hover\\:border-blumine-500\\/20:hover{
  border-color: rgba(55, 135, 163, 0.2);
}

.hover\\:border-blumine-500\\/25:hover{
  border-color: rgba(55, 135, 163, 0.25);
}

.hover\\:border-blumine-500\\/30:hover{
  border-color: rgba(55, 135, 163, 0.3);
}

.hover\\:border-blumine-500\\/35:hover{
  border-color: rgba(55, 135, 163, 0.35);
}

.hover\\:border-blumine-500\\/40:hover{
  border-color: rgba(55, 135, 163, 0.4);
}

.hover\\:border-blumine-500\\/45:hover{
  border-color: rgba(55, 135, 163, 0.45);
}

.hover\\:border-blumine-500\\/5:hover{
  border-color: rgba(55, 135, 163, 0.05);
}

.hover\\:border-blumine-500\\/50:hover{
  border-color: rgba(55, 135, 163, 0.5);
}

.hover\\:border-blumine-500\\/55:hover{
  border-color: rgba(55, 135, 163, 0.55);
}

.hover\\:border-blumine-500\\/60:hover{
  border-color: rgba(55, 135, 163, 0.6);
}

.hover\\:border-blumine-500\\/65:hover{
  border-color: rgba(55, 135, 163, 0.65);
}

.hover\\:border-blumine-500\\/70:hover{
  border-color: rgba(55, 135, 163, 0.7);
}

.hover\\:border-blumine-500\\/75:hover{
  border-color: rgba(55, 135, 163, 0.75);
}

.hover\\:border-blumine-500\\/80:hover{
  border-color: rgba(55, 135, 163, 0.8);
}

.hover\\:border-blumine-500\\/85:hover{
  border-color: rgba(55, 135, 163, 0.85);
}

.hover\\:border-blumine-500\\/90:hover{
  border-color: rgba(55, 135, 163, 0.9);
}

.hover\\:border-blumine-500\\/95:hover{
  border-color: rgba(55, 135, 163, 0.95);
}

.hover\\:border-blumine-600:hover{
  --tw-border-opacity: 1;
  border-color: rgba(48, 109, 138, 1);
  border-color: rgba(48, 109, 138, var(--tw-border-opacity, 1));
}

.hover\\:border-blumine-600\\/0:hover{
  border-color: rgba(48, 109, 138, 0);
}

.hover\\:border-blumine-600\\/10:hover{
  border-color: rgba(48, 109, 138, 0.1);
}

.hover\\:border-blumine-600\\/100:hover{
  border-color: rgb(48, 109, 138);
}

.hover\\:border-blumine-600\\/15:hover{
  border-color: rgba(48, 109, 138, 0.15);
}

.hover\\:border-blumine-600\\/20:hover{
  border-color: rgba(48, 109, 138, 0.2);
}

.hover\\:border-blumine-600\\/25:hover{
  border-color: rgba(48, 109, 138, 0.25);
}

.hover\\:border-blumine-600\\/30:hover{
  border-color: rgba(48, 109, 138, 0.3);
}

.hover\\:border-blumine-600\\/35:hover{
  border-color: rgba(48, 109, 138, 0.35);
}

.hover\\:border-blumine-600\\/40:hover{
  border-color: rgba(48, 109, 138, 0.4);
}

.hover\\:border-blumine-600\\/45:hover{
  border-color: rgba(48, 109, 138, 0.45);
}

.hover\\:border-blumine-600\\/5:hover{
  border-color: rgba(48, 109, 138, 0.05);
}

.hover\\:border-blumine-600\\/50:hover{
  border-color: rgba(48, 109, 138, 0.5);
}

.hover\\:border-blumine-600\\/55:hover{
  border-color: rgba(48, 109, 138, 0.55);
}

.hover\\:border-blumine-600\\/60:hover{
  border-color: rgba(48, 109, 138, 0.6);
}

.hover\\:border-blumine-600\\/65:hover{
  border-color: rgba(48, 109, 138, 0.65);
}

.hover\\:border-blumine-600\\/70:hover{
  border-color: rgba(48, 109, 138, 0.7);
}

.hover\\:border-blumine-600\\/75:hover{
  border-color: rgba(48, 109, 138, 0.75);
}

.hover\\:border-blumine-600\\/80:hover{
  border-color: rgba(48, 109, 138, 0.8);
}

.hover\\:border-blumine-600\\/85:hover{
  border-color: rgba(48, 109, 138, 0.85);
}

.hover\\:border-blumine-600\\/90:hover{
  border-color: rgba(48, 109, 138, 0.9);
}

.hover\\:border-blumine-600\\/95:hover{
  border-color: rgba(48, 109, 138, 0.95);
}

.hover\\:border-blumine-700:hover{
  --tw-border-opacity: 1;
  border-color: rgba(45, 91, 114, 1);
  border-color: rgba(45, 91, 114, var(--tw-border-opacity, 1));
}

.hover\\:border-blumine-700\\/0:hover{
  border-color: rgba(45, 91, 114, 0);
}

.hover\\:border-blumine-700\\/10:hover{
  border-color: rgba(45, 91, 114, 0.1);
}

.hover\\:border-blumine-700\\/100:hover{
  border-color: rgb(45, 91, 114);
}

.hover\\:border-blumine-700\\/15:hover{
  border-color: rgba(45, 91, 114, 0.15);
}

.hover\\:border-blumine-700\\/20:hover{
  border-color: rgba(45, 91, 114, 0.2);
}

.hover\\:border-blumine-700\\/25:hover{
  border-color: rgba(45, 91, 114, 0.25);
}

.hover\\:border-blumine-700\\/30:hover{
  border-color: rgba(45, 91, 114, 0.3);
}

.hover\\:border-blumine-700\\/35:hover{
  border-color: rgba(45, 91, 114, 0.35);
}

.hover\\:border-blumine-700\\/40:hover{
  border-color: rgba(45, 91, 114, 0.4);
}

.hover\\:border-blumine-700\\/45:hover{
  border-color: rgba(45, 91, 114, 0.45);
}

.hover\\:border-blumine-700\\/5:hover{
  border-color: rgba(45, 91, 114, 0.05);
}

.hover\\:border-blumine-700\\/50:hover{
  border-color: rgba(45, 91, 114, 0.5);
}

.hover\\:border-blumine-700\\/55:hover{
  border-color: rgba(45, 91, 114, 0.55);
}

.hover\\:border-blumine-700\\/60:hover{
  border-color: rgba(45, 91, 114, 0.6);
}

.hover\\:border-blumine-700\\/65:hover{
  border-color: rgba(45, 91, 114, 0.65);
}

.hover\\:border-blumine-700\\/70:hover{
  border-color: rgba(45, 91, 114, 0.7);
}

.hover\\:border-blumine-700\\/75:hover{
  border-color: rgba(45, 91, 114, 0.75);
}

.hover\\:border-blumine-700\\/80:hover{
  border-color: rgba(45, 91, 114, 0.8);
}

.hover\\:border-blumine-700\\/85:hover{
  border-color: rgba(45, 91, 114, 0.85);
}

.hover\\:border-blumine-700\\/90:hover{
  border-color: rgba(45, 91, 114, 0.9);
}

.hover\\:border-blumine-700\\/95:hover{
  border-color: rgba(45, 91, 114, 0.95);
}

.hover\\:border-blumine-800:hover{
  --tw-border-opacity: 1;
  border-color: rgba(44, 76, 94, 1);
  border-color: rgba(44, 76, 94, var(--tw-border-opacity, 1));
}

.hover\\:border-blumine-800\\/0:hover{
  border-color: rgba(44, 76, 94, 0);
}

.hover\\:border-blumine-800\\/10:hover{
  border-color: rgba(44, 76, 94, 0.1);
}

.hover\\:border-blumine-800\\/100:hover{
  border-color: rgb(44, 76, 94);
}

.hover\\:border-blumine-800\\/15:hover{
  border-color: rgba(44, 76, 94, 0.15);
}

.hover\\:border-blumine-800\\/20:hover{
  border-color: rgba(44, 76, 94, 0.2);
}

.hover\\:border-blumine-800\\/25:hover{
  border-color: rgba(44, 76, 94, 0.25);
}

.hover\\:border-blumine-800\\/30:hover{
  border-color: rgba(44, 76, 94, 0.3);
}

.hover\\:border-blumine-800\\/35:hover{
  border-color: rgba(44, 76, 94, 0.35);
}

.hover\\:border-blumine-800\\/40:hover{
  border-color: rgba(44, 76, 94, 0.4);
}

.hover\\:border-blumine-800\\/45:hover{
  border-color: rgba(44, 76, 94, 0.45);
}

.hover\\:border-blumine-800\\/5:hover{
  border-color: rgba(44, 76, 94, 0.05);
}

.hover\\:border-blumine-800\\/50:hover{
  border-color: rgba(44, 76, 94, 0.5);
}

.hover\\:border-blumine-800\\/55:hover{
  border-color: rgba(44, 76, 94, 0.55);
}

.hover\\:border-blumine-800\\/60:hover{
  border-color: rgba(44, 76, 94, 0.6);
}

.hover\\:border-blumine-800\\/65:hover{
  border-color: rgba(44, 76, 94, 0.65);
}

.hover\\:border-blumine-800\\/70:hover{
  border-color: rgba(44, 76, 94, 0.7);
}

.hover\\:border-blumine-800\\/75:hover{
  border-color: rgba(44, 76, 94, 0.75);
}

.hover\\:border-blumine-800\\/80:hover{
  border-color: rgba(44, 76, 94, 0.8);
}

.hover\\:border-blumine-800\\/85:hover{
  border-color: rgba(44, 76, 94, 0.85);
}

.hover\\:border-blumine-800\\/90:hover{
  border-color: rgba(44, 76, 94, 0.9);
}

.hover\\:border-blumine-800\\/95:hover{
  border-color: rgba(44, 76, 94, 0.95);
}

.hover\\:border-blumine-900:hover{
  --tw-border-opacity: 1;
  border-color: rgba(40, 65, 81, 1);
  border-color: rgba(40, 65, 81, var(--tw-border-opacity, 1));
}

.hover\\:border-blumine-900\\/0:hover{
  border-color: rgba(40, 65, 81, 0);
}

.hover\\:border-blumine-900\\/10:hover{
  border-color: rgba(40, 65, 81, 0.1);
}

.hover\\:border-blumine-900\\/100:hover{
  border-color: rgb(40, 65, 81);
}

.hover\\:border-blumine-900\\/15:hover{
  border-color: rgba(40, 65, 81, 0.15);
}

.hover\\:border-blumine-900\\/20:hover{
  border-color: rgba(40, 65, 81, 0.2);
}

.hover\\:border-blumine-900\\/25:hover{
  border-color: rgba(40, 65, 81, 0.25);
}

.hover\\:border-blumine-900\\/30:hover{
  border-color: rgba(40, 65, 81, 0.3);
}

.hover\\:border-blumine-900\\/35:hover{
  border-color: rgba(40, 65, 81, 0.35);
}

.hover\\:border-blumine-900\\/40:hover{
  border-color: rgba(40, 65, 81, 0.4);
}

.hover\\:border-blumine-900\\/45:hover{
  border-color: rgba(40, 65, 81, 0.45);
}

.hover\\:border-blumine-900\\/5:hover{
  border-color: rgba(40, 65, 81, 0.05);
}

.hover\\:border-blumine-900\\/50:hover{
  border-color: rgba(40, 65, 81, 0.5);
}

.hover\\:border-blumine-900\\/55:hover{
  border-color: rgba(40, 65, 81, 0.55);
}

.hover\\:border-blumine-900\\/60:hover{
  border-color: rgba(40, 65, 81, 0.6);
}

.hover\\:border-blumine-900\\/65:hover{
  border-color: rgba(40, 65, 81, 0.65);
}

.hover\\:border-blumine-900\\/70:hover{
  border-color: rgba(40, 65, 81, 0.7);
}

.hover\\:border-blumine-900\\/75:hover{
  border-color: rgba(40, 65, 81, 0.75);
}

.hover\\:border-blumine-900\\/80:hover{
  border-color: rgba(40, 65, 81, 0.8);
}

.hover\\:border-blumine-900\\/85:hover{
  border-color: rgba(40, 65, 81, 0.85);
}

.hover\\:border-blumine-900\\/90:hover{
  border-color: rgba(40, 65, 81, 0.9);
}

.hover\\:border-blumine-900\\/95:hover{
  border-color: rgba(40, 65, 81, 0.95);
}

.hover\\:border-blumine-950:hover{
  --tw-border-opacity: 1;
  border-color: rgba(22, 41, 54, 1);
  border-color: rgba(22, 41, 54, var(--tw-border-opacity, 1));
}

.hover\\:border-blumine-950\\/0:hover{
  border-color: rgba(22, 41, 54, 0);
}

.hover\\:border-blumine-950\\/10:hover{
  border-color: rgba(22, 41, 54, 0.1);
}

.hover\\:border-blumine-950\\/100:hover{
  border-color: rgb(22, 41, 54);
}

.hover\\:border-blumine-950\\/15:hover{
  border-color: rgba(22, 41, 54, 0.15);
}

.hover\\:border-blumine-950\\/20:hover{
  border-color: rgba(22, 41, 54, 0.2);
}

.hover\\:border-blumine-950\\/25:hover{
  border-color: rgba(22, 41, 54, 0.25);
}

.hover\\:border-blumine-950\\/30:hover{
  border-color: rgba(22, 41, 54, 0.3);
}

.hover\\:border-blumine-950\\/35:hover{
  border-color: rgba(22, 41, 54, 0.35);
}

.hover\\:border-blumine-950\\/40:hover{
  border-color: rgba(22, 41, 54, 0.4);
}

.hover\\:border-blumine-950\\/45:hover{
  border-color: rgba(22, 41, 54, 0.45);
}

.hover\\:border-blumine-950\\/5:hover{
  border-color: rgba(22, 41, 54, 0.05);
}

.hover\\:border-blumine-950\\/50:hover{
  border-color: rgba(22, 41, 54, 0.5);
}

.hover\\:border-blumine-950\\/55:hover{
  border-color: rgba(22, 41, 54, 0.55);
}

.hover\\:border-blumine-950\\/60:hover{
  border-color: rgba(22, 41, 54, 0.6);
}

.hover\\:border-blumine-950\\/65:hover{
  border-color: rgba(22, 41, 54, 0.65);
}

.hover\\:border-blumine-950\\/70:hover{
  border-color: rgba(22, 41, 54, 0.7);
}

.hover\\:border-blumine-950\\/75:hover{
  border-color: rgba(22, 41, 54, 0.75);
}

.hover\\:border-blumine-950\\/80:hover{
  border-color: rgba(22, 41, 54, 0.8);
}

.hover\\:border-blumine-950\\/85:hover{
  border-color: rgba(22, 41, 54, 0.85);
}

.hover\\:border-blumine-950\\/90:hover{
  border-color: rgba(22, 41, 54, 0.9);
}

.hover\\:border-blumine-950\\/95:hover{
  border-color: rgba(22, 41, 54, 0.95);
}

.hover\\:border-charcoal-100:hover{
  --tw-border-opacity: 1;
  border-color: rgba(230, 230, 231, 1);
  border-color: rgba(230, 230, 231, var(--tw-border-opacity, 1));
}

.hover\\:border-charcoal-100\\/0:hover{
  border-color: rgba(230, 230, 231, 0);
}

.hover\\:border-charcoal-100\\/10:hover{
  border-color: rgba(230, 230, 231, 0.1);
}

.hover\\:border-charcoal-100\\/100:hover{
  border-color: rgb(230, 230, 231);
}

.hover\\:border-charcoal-100\\/15:hover{
  border-color: rgba(230, 230, 231, 0.15);
}

.hover\\:border-charcoal-100\\/20:hover{
  border-color: rgba(230, 230, 231, 0.2);
}

.hover\\:border-charcoal-100\\/25:hover{
  border-color: rgba(230, 230, 231, 0.25);
}

.hover\\:border-charcoal-100\\/30:hover{
  border-color: rgba(230, 230, 231, 0.3);
}

.hover\\:border-charcoal-100\\/35:hover{
  border-color: rgba(230, 230, 231, 0.35);
}

.hover\\:border-charcoal-100\\/40:hover{
  border-color: rgba(230, 230, 231, 0.4);
}

.hover\\:border-charcoal-100\\/45:hover{
  border-color: rgba(230, 230, 231, 0.45);
}

.hover\\:border-charcoal-100\\/5:hover{
  border-color: rgba(230, 230, 231, 0.05);
}

.hover\\:border-charcoal-100\\/50:hover{
  border-color: rgba(230, 230, 231, 0.5);
}

.hover\\:border-charcoal-100\\/55:hover{
  border-color: rgba(230, 230, 231, 0.55);
}

.hover\\:border-charcoal-100\\/60:hover{
  border-color: rgba(230, 230, 231, 0.6);
}

.hover\\:border-charcoal-100\\/65:hover{
  border-color: rgba(230, 230, 231, 0.65);
}

.hover\\:border-charcoal-100\\/70:hover{
  border-color: rgba(230, 230, 231, 0.7);
}

.hover\\:border-charcoal-100\\/75:hover{
  border-color: rgba(230, 230, 231, 0.75);
}

.hover\\:border-charcoal-100\\/80:hover{
  border-color: rgba(230, 230, 231, 0.8);
}

.hover\\:border-charcoal-100\\/85:hover{
  border-color: rgba(230, 230, 231, 0.85);
}

.hover\\:border-charcoal-100\\/90:hover{
  border-color: rgba(230, 230, 231, 0.9);
}

.hover\\:border-charcoal-100\\/95:hover{
  border-color: rgba(230, 230, 231, 0.95);
}

.hover\\:border-charcoal-200:hover{
  --tw-border-opacity: 1;
  border-color: rgba(207, 208, 210, 1);
  border-color: rgba(207, 208, 210, var(--tw-border-opacity, 1));
}

.hover\\:border-charcoal-200\\/0:hover{
  border-color: rgba(207, 208, 210, 0);
}

.hover\\:border-charcoal-200\\/10:hover{
  border-color: rgba(207, 208, 210, 0.1);
}

.hover\\:border-charcoal-200\\/100:hover{
  border-color: rgb(207, 208, 210);
}

.hover\\:border-charcoal-200\\/15:hover{
  border-color: rgba(207, 208, 210, 0.15);
}

.hover\\:border-charcoal-200\\/20:hover{
  border-color: rgba(207, 208, 210, 0.2);
}

.hover\\:border-charcoal-200\\/25:hover{
  border-color: rgba(207, 208, 210, 0.25);
}

.hover\\:border-charcoal-200\\/30:hover{
  border-color: rgba(207, 208, 210, 0.3);
}

.hover\\:border-charcoal-200\\/35:hover{
  border-color: rgba(207, 208, 210, 0.35);
}

.hover\\:border-charcoal-200\\/40:hover{
  border-color: rgba(207, 208, 210, 0.4);
}

.hover\\:border-charcoal-200\\/45:hover{
  border-color: rgba(207, 208, 210, 0.45);
}

.hover\\:border-charcoal-200\\/5:hover{
  border-color: rgba(207, 208, 210, 0.05);
}

.hover\\:border-charcoal-200\\/50:hover{
  border-color: rgba(207, 208, 210, 0.5);
}

.hover\\:border-charcoal-200\\/55:hover{
  border-color: rgba(207, 208, 210, 0.55);
}

.hover\\:border-charcoal-200\\/60:hover{
  border-color: rgba(207, 208, 210, 0.6);
}

.hover\\:border-charcoal-200\\/65:hover{
  border-color: rgba(207, 208, 210, 0.65);
}

.hover\\:border-charcoal-200\\/70:hover{
  border-color: rgba(207, 208, 210, 0.7);
}

.hover\\:border-charcoal-200\\/75:hover{
  border-color: rgba(207, 208, 210, 0.75);
}

.hover\\:border-charcoal-200\\/80:hover{
  border-color: rgba(207, 208, 210, 0.8);
}

.hover\\:border-charcoal-200\\/85:hover{
  border-color: rgba(207, 208, 210, 0.85);
}

.hover\\:border-charcoal-200\\/90:hover{
  border-color: rgba(207, 208, 210, 0.9);
}

.hover\\:border-charcoal-200\\/95:hover{
  border-color: rgba(207, 208, 210, 0.95);
}

.hover\\:border-charcoal-300:hover{
  --tw-border-opacity: 1;
  border-color: rgba(174, 175, 178, 1);
  border-color: rgba(174, 175, 178, var(--tw-border-opacity, 1));
}

.hover\\:border-charcoal-300\\/0:hover{
  border-color: rgba(174, 175, 178, 0);
}

.hover\\:border-charcoal-300\\/10:hover{
  border-color: rgba(174, 175, 178, 0.1);
}

.hover\\:border-charcoal-300\\/100:hover{
  border-color: rgb(174, 175, 178);
}

.hover\\:border-charcoal-300\\/15:hover{
  border-color: rgba(174, 175, 178, 0.15);
}

.hover\\:border-charcoal-300\\/20:hover{
  border-color: rgba(174, 175, 178, 0.2);
}

.hover\\:border-charcoal-300\\/25:hover{
  border-color: rgba(174, 175, 178, 0.25);
}

.hover\\:border-charcoal-300\\/30:hover{
  border-color: rgba(174, 175, 178, 0.3);
}

.hover\\:border-charcoal-300\\/35:hover{
  border-color: rgba(174, 175, 178, 0.35);
}

.hover\\:border-charcoal-300\\/40:hover{
  border-color: rgba(174, 175, 178, 0.4);
}

.hover\\:border-charcoal-300\\/45:hover{
  border-color: rgba(174, 175, 178, 0.45);
}

.hover\\:border-charcoal-300\\/5:hover{
  border-color: rgba(174, 175, 178, 0.05);
}

.hover\\:border-charcoal-300\\/50:hover{
  border-color: rgba(174, 175, 178, 0.5);
}

.hover\\:border-charcoal-300\\/55:hover{
  border-color: rgba(174, 175, 178, 0.55);
}

.hover\\:border-charcoal-300\\/60:hover{
  border-color: rgba(174, 175, 178, 0.6);
}

.hover\\:border-charcoal-300\\/65:hover{
  border-color: rgba(174, 175, 178, 0.65);
}

.hover\\:border-charcoal-300\\/70:hover{
  border-color: rgba(174, 175, 178, 0.7);
}

.hover\\:border-charcoal-300\\/75:hover{
  border-color: rgba(174, 175, 178, 0.75);
}

.hover\\:border-charcoal-300\\/80:hover{
  border-color: rgba(174, 175, 178, 0.8);
}

.hover\\:border-charcoal-300\\/85:hover{
  border-color: rgba(174, 175, 178, 0.85);
}

.hover\\:border-charcoal-300\\/90:hover{
  border-color: rgba(174, 175, 178, 0.9);
}

.hover\\:border-charcoal-300\\/95:hover{
  border-color: rgba(174, 175, 178, 0.95);
}

.hover\\:border-charcoal-400:hover{
  --tw-border-opacity: 1;
  border-color: rgba(133, 134, 139, 1);
  border-color: rgba(133, 134, 139, var(--tw-border-opacity, 1));
}

.hover\\:border-charcoal-400\\/0:hover{
  border-color: rgba(133, 134, 139, 0);
}

.hover\\:border-charcoal-400\\/10:hover{
  border-color: rgba(133, 134, 139, 0.1);
}

.hover\\:border-charcoal-400\\/100:hover{
  border-color: rgb(133, 134, 139);
}

.hover\\:border-charcoal-400\\/15:hover{
  border-color: rgba(133, 134, 139, 0.15);
}

.hover\\:border-charcoal-400\\/20:hover{
  border-color: rgba(133, 134, 139, 0.2);
}

.hover\\:border-charcoal-400\\/25:hover{
  border-color: rgba(133, 134, 139, 0.25);
}

.hover\\:border-charcoal-400\\/30:hover{
  border-color: rgba(133, 134, 139, 0.3);
}

.hover\\:border-charcoal-400\\/35:hover{
  border-color: rgba(133, 134, 139, 0.35);
}

.hover\\:border-charcoal-400\\/40:hover{
  border-color: rgba(133, 134, 139, 0.4);
}

.hover\\:border-charcoal-400\\/45:hover{
  border-color: rgba(133, 134, 139, 0.45);
}

.hover\\:border-charcoal-400\\/5:hover{
  border-color: rgba(133, 134, 139, 0.05);
}

.hover\\:border-charcoal-400\\/50:hover{
  border-color: rgba(133, 134, 139, 0.5);
}

.hover\\:border-charcoal-400\\/55:hover{
  border-color: rgba(133, 134, 139, 0.55);
}

.hover\\:border-charcoal-400\\/60:hover{
  border-color: rgba(133, 134, 139, 0.6);
}

.hover\\:border-charcoal-400\\/65:hover{
  border-color: rgba(133, 134, 139, 0.65);
}

.hover\\:border-charcoal-400\\/70:hover{
  border-color: rgba(133, 134, 139, 0.7);
}

.hover\\:border-charcoal-400\\/75:hover{
  border-color: rgba(133, 134, 139, 0.75);
}

.hover\\:border-charcoal-400\\/80:hover{
  border-color: rgba(133, 134, 139, 0.8);
}

.hover\\:border-charcoal-400\\/85:hover{
  border-color: rgba(133, 134, 139, 0.85);
}

.hover\\:border-charcoal-400\\/90:hover{
  border-color: rgba(133, 134, 139, 0.9);
}

.hover\\:border-charcoal-400\\/95:hover{
  border-color: rgba(133, 134, 139, 0.95);
}

.hover\\:border-charcoal-500:hover{
  --tw-border-opacity: 1;
  border-color: rgba(106, 107, 112, 1);
  border-color: rgba(106, 107, 112, var(--tw-border-opacity, 1));
}

.hover\\:border-charcoal-500\\/0:hover{
  border-color: rgba(106, 107, 112, 0);
}

.hover\\:border-charcoal-500\\/10:hover{
  border-color: rgba(106, 107, 112, 0.1);
}

.hover\\:border-charcoal-500\\/100:hover{
  border-color: rgb(106, 107, 112);
}

.hover\\:border-charcoal-500\\/15:hover{
  border-color: rgba(106, 107, 112, 0.15);
}

.hover\\:border-charcoal-500\\/20:hover{
  border-color: rgba(106, 107, 112, 0.2);
}

.hover\\:border-charcoal-500\\/25:hover{
  border-color: rgba(106, 107, 112, 0.25);
}

.hover\\:border-charcoal-500\\/30:hover{
  border-color: rgba(106, 107, 112, 0.3);
}

.hover\\:border-charcoal-500\\/35:hover{
  border-color: rgba(106, 107, 112, 0.35);
}

.hover\\:border-charcoal-500\\/40:hover{
  border-color: rgba(106, 107, 112, 0.4);
}

.hover\\:border-charcoal-500\\/45:hover{
  border-color: rgba(106, 107, 112, 0.45);
}

.hover\\:border-charcoal-500\\/5:hover{
  border-color: rgba(106, 107, 112, 0.05);
}

.hover\\:border-charcoal-500\\/50:hover{
  border-color: rgba(106, 107, 112, 0.5);
}

.hover\\:border-charcoal-500\\/55:hover{
  border-color: rgba(106, 107, 112, 0.55);
}

.hover\\:border-charcoal-500\\/60:hover{
  border-color: rgba(106, 107, 112, 0.6);
}

.hover\\:border-charcoal-500\\/65:hover{
  border-color: rgba(106, 107, 112, 0.65);
}

.hover\\:border-charcoal-500\\/70:hover{
  border-color: rgba(106, 107, 112, 0.7);
}

.hover\\:border-charcoal-500\\/75:hover{
  border-color: rgba(106, 107, 112, 0.75);
}

.hover\\:border-charcoal-500\\/80:hover{
  border-color: rgba(106, 107, 112, 0.8);
}

.hover\\:border-charcoal-500\\/85:hover{
  border-color: rgba(106, 107, 112, 0.85);
}

.hover\\:border-charcoal-500\\/90:hover{
  border-color: rgba(106, 107, 112, 0.9);
}

.hover\\:border-charcoal-500\\/95:hover{
  border-color: rgba(106, 107, 112, 0.95);
}

.hover\\:border-charcoal-600:hover{
  --tw-border-opacity: 1;
  border-color: rgba(90, 91, 96, 1);
  border-color: rgba(90, 91, 96, var(--tw-border-opacity, 1));
}

.hover\\:border-charcoal-600\\/0:hover{
  border-color: rgba(90, 91, 96, 0);
}

.hover\\:border-charcoal-600\\/10:hover{
  border-color: rgba(90, 91, 96, 0.1);
}

.hover\\:border-charcoal-600\\/100:hover{
  border-color: rgb(90, 91, 96);
}

.hover\\:border-charcoal-600\\/15:hover{
  border-color: rgba(90, 91, 96, 0.15);
}

.hover\\:border-charcoal-600\\/20:hover{
  border-color: rgba(90, 91, 96, 0.2);
}

.hover\\:border-charcoal-600\\/25:hover{
  border-color: rgba(90, 91, 96, 0.25);
}

.hover\\:border-charcoal-600\\/30:hover{
  border-color: rgba(90, 91, 96, 0.3);
}

.hover\\:border-charcoal-600\\/35:hover{
  border-color: rgba(90, 91, 96, 0.35);
}

.hover\\:border-charcoal-600\\/40:hover{
  border-color: rgba(90, 91, 96, 0.4);
}

.hover\\:border-charcoal-600\\/45:hover{
  border-color: rgba(90, 91, 96, 0.45);
}

.hover\\:border-charcoal-600\\/5:hover{
  border-color: rgba(90, 91, 96, 0.05);
}

.hover\\:border-charcoal-600\\/50:hover{
  border-color: rgba(90, 91, 96, 0.5);
}

.hover\\:border-charcoal-600\\/55:hover{
  border-color: rgba(90, 91, 96, 0.55);
}

.hover\\:border-charcoal-600\\/60:hover{
  border-color: rgba(90, 91, 96, 0.6);
}

.hover\\:border-charcoal-600\\/65:hover{
  border-color: rgba(90, 91, 96, 0.65);
}

.hover\\:border-charcoal-600\\/70:hover{
  border-color: rgba(90, 91, 96, 0.7);
}

.hover\\:border-charcoal-600\\/75:hover{
  border-color: rgba(90, 91, 96, 0.75);
}

.hover\\:border-charcoal-600\\/80:hover{
  border-color: rgba(90, 91, 96, 0.8);
}

.hover\\:border-charcoal-600\\/85:hover{
  border-color: rgba(90, 91, 96, 0.85);
}

.hover\\:border-charcoal-600\\/90:hover{
  border-color: rgba(90, 91, 96, 0.9);
}

.hover\\:border-charcoal-600\\/95:hover{
  border-color: rgba(90, 91, 96, 0.95);
}

.hover\\:border-charcoal-700:hover{
  --tw-border-opacity: 1;
  border-color: rgba(77, 77, 81, 1);
  border-color: rgba(77, 77, 81, var(--tw-border-opacity, 1));
}

.hover\\:border-charcoal-700\\/0:hover{
  border-color: rgba(77, 77, 81, 0);
}

.hover\\:border-charcoal-700\\/10:hover{
  border-color: rgba(77, 77, 81, 0.1);
}

.hover\\:border-charcoal-700\\/100:hover{
  border-color: rgb(77, 77, 81);
}

.hover\\:border-charcoal-700\\/15:hover{
  border-color: rgba(77, 77, 81, 0.15);
}

.hover\\:border-charcoal-700\\/20:hover{
  border-color: rgba(77, 77, 81, 0.2);
}

.hover\\:border-charcoal-700\\/25:hover{
  border-color: rgba(77, 77, 81, 0.25);
}

.hover\\:border-charcoal-700\\/30:hover{
  border-color: rgba(77, 77, 81, 0.3);
}

.hover\\:border-charcoal-700\\/35:hover{
  border-color: rgba(77, 77, 81, 0.35);
}

.hover\\:border-charcoal-700\\/40:hover{
  border-color: rgba(77, 77, 81, 0.4);
}

.hover\\:border-charcoal-700\\/45:hover{
  border-color: rgba(77, 77, 81, 0.45);
}

.hover\\:border-charcoal-700\\/5:hover{
  border-color: rgba(77, 77, 81, 0.05);
}

.hover\\:border-charcoal-700\\/50:hover{
  border-color: rgba(77, 77, 81, 0.5);
}

.hover\\:border-charcoal-700\\/55:hover{
  border-color: rgba(77, 77, 81, 0.55);
}

.hover\\:border-charcoal-700\\/60:hover{
  border-color: rgba(77, 77, 81, 0.6);
}

.hover\\:border-charcoal-700\\/65:hover{
  border-color: rgba(77, 77, 81, 0.65);
}

.hover\\:border-charcoal-700\\/70:hover{
  border-color: rgba(77, 77, 81, 0.7);
}

.hover\\:border-charcoal-700\\/75:hover{
  border-color: rgba(77, 77, 81, 0.75);
}

.hover\\:border-charcoal-700\\/80:hover{
  border-color: rgba(77, 77, 81, 0.8);
}

.hover\\:border-charcoal-700\\/85:hover{
  border-color: rgba(77, 77, 81, 0.85);
}

.hover\\:border-charcoal-700\\/90:hover{
  border-color: rgba(77, 77, 81, 0.9);
}

.hover\\:border-charcoal-700\\/95:hover{
  border-color: rgba(77, 77, 81, 0.95);
}

.hover\\:border-charcoal-800:hover{
  --tw-border-opacity: 1;
  border-color: rgba(67, 67, 71, 1);
  border-color: rgba(67, 67, 71, var(--tw-border-opacity, 1));
}

.hover\\:border-charcoal-800\\/0:hover{
  border-color: rgba(67, 67, 71, 0);
}

.hover\\:border-charcoal-800\\/10:hover{
  border-color: rgba(67, 67, 71, 0.1);
}

.hover\\:border-charcoal-800\\/100:hover{
  border-color: rgb(67, 67, 71);
}

.hover\\:border-charcoal-800\\/15:hover{
  border-color: rgba(67, 67, 71, 0.15);
}

.hover\\:border-charcoal-800\\/20:hover{
  border-color: rgba(67, 67, 71, 0.2);
}

.hover\\:border-charcoal-800\\/25:hover{
  border-color: rgba(67, 67, 71, 0.25);
}

.hover\\:border-charcoal-800\\/30:hover{
  border-color: rgba(67, 67, 71, 0.3);
}

.hover\\:border-charcoal-800\\/35:hover{
  border-color: rgba(67, 67, 71, 0.35);
}

.hover\\:border-charcoal-800\\/40:hover{
  border-color: rgba(67, 67, 71, 0.4);
}

.hover\\:border-charcoal-800\\/45:hover{
  border-color: rgba(67, 67, 71, 0.45);
}

.hover\\:border-charcoal-800\\/5:hover{
  border-color: rgba(67, 67, 71, 0.05);
}

.hover\\:border-charcoal-800\\/50:hover{
  border-color: rgba(67, 67, 71, 0.5);
}

.hover\\:border-charcoal-800\\/55:hover{
  border-color: rgba(67, 67, 71, 0.55);
}

.hover\\:border-charcoal-800\\/60:hover{
  border-color: rgba(67, 67, 71, 0.6);
}

.hover\\:border-charcoal-800\\/65:hover{
  border-color: rgba(67, 67, 71, 0.65);
}

.hover\\:border-charcoal-800\\/70:hover{
  border-color: rgba(67, 67, 71, 0.7);
}

.hover\\:border-charcoal-800\\/75:hover{
  border-color: rgba(67, 67, 71, 0.75);
}

.hover\\:border-charcoal-800\\/80:hover{
  border-color: rgba(67, 67, 71, 0.8);
}

.hover\\:border-charcoal-800\\/85:hover{
  border-color: rgba(67, 67, 71, 0.85);
}

.hover\\:border-charcoal-800\\/90:hover{
  border-color: rgba(67, 67, 71, 0.9);
}

.hover\\:border-charcoal-800\\/95:hover{
  border-color: rgba(67, 67, 71, 0.95);
}

.hover\\:border-charcoal-900:hover{
  --tw-border-opacity: 1;
  border-color: rgba(49, 49, 51, 1);
  border-color: rgba(49, 49, 51, var(--tw-border-opacity, 1));
}

.hover\\:border-charcoal-900\\/0:hover{
  border-color: rgba(49, 49, 51, 0);
}

.hover\\:border-charcoal-900\\/10:hover{
  border-color: rgba(49, 49, 51, 0.1);
}

.hover\\:border-charcoal-900\\/100:hover{
  border-color: rgb(49, 49, 51);
}

.hover\\:border-charcoal-900\\/15:hover{
  border-color: rgba(49, 49, 51, 0.15);
}

.hover\\:border-charcoal-900\\/20:hover{
  border-color: rgba(49, 49, 51, 0.2);
}

.hover\\:border-charcoal-900\\/25:hover{
  border-color: rgba(49, 49, 51, 0.25);
}

.hover\\:border-charcoal-900\\/30:hover{
  border-color: rgba(49, 49, 51, 0.3);
}

.hover\\:border-charcoal-900\\/35:hover{
  border-color: rgba(49, 49, 51, 0.35);
}

.hover\\:border-charcoal-900\\/40:hover{
  border-color: rgba(49, 49, 51, 0.4);
}

.hover\\:border-charcoal-900\\/45:hover{
  border-color: rgba(49, 49, 51, 0.45);
}

.hover\\:border-charcoal-900\\/5:hover{
  border-color: rgba(49, 49, 51, 0.05);
}

.hover\\:border-charcoal-900\\/50:hover{
  border-color: rgba(49, 49, 51, 0.5);
}

.hover\\:border-charcoal-900\\/55:hover{
  border-color: rgba(49, 49, 51, 0.55);
}

.hover\\:border-charcoal-900\\/60:hover{
  border-color: rgba(49, 49, 51, 0.6);
}

.hover\\:border-charcoal-900\\/65:hover{
  border-color: rgba(49, 49, 51, 0.65);
}

.hover\\:border-charcoal-900\\/70:hover{
  border-color: rgba(49, 49, 51, 0.7);
}

.hover\\:border-charcoal-900\\/75:hover{
  border-color: rgba(49, 49, 51, 0.75);
}

.hover\\:border-charcoal-900\\/80:hover{
  border-color: rgba(49, 49, 51, 0.8);
}

.hover\\:border-charcoal-900\\/85:hover{
  border-color: rgba(49, 49, 51, 0.85);
}

.hover\\:border-charcoal-900\\/90:hover{
  border-color: rgba(49, 49, 51, 0.9);
}

.hover\\:border-charcoal-900\\/95:hover{
  border-color: rgba(49, 49, 51, 0.95);
}

.hover\\:border-charcoal-950:hover{
  --tw-border-opacity: 1;
  border-color: rgba(37, 37, 39, 1);
  border-color: rgba(37, 37, 39, var(--tw-border-opacity, 1));
}

.hover\\:border-charcoal-950\\/0:hover{
  border-color: rgba(37, 37, 39, 0);
}

.hover\\:border-charcoal-950\\/10:hover{
  border-color: rgba(37, 37, 39, 0.1);
}

.hover\\:border-charcoal-950\\/100:hover{
  border-color: rgb(37, 37, 39);
}

.hover\\:border-charcoal-950\\/15:hover{
  border-color: rgba(37, 37, 39, 0.15);
}

.hover\\:border-charcoal-950\\/20:hover{
  border-color: rgba(37, 37, 39, 0.2);
}

.hover\\:border-charcoal-950\\/25:hover{
  border-color: rgba(37, 37, 39, 0.25);
}

.hover\\:border-charcoal-950\\/30:hover{
  border-color: rgba(37, 37, 39, 0.3);
}

.hover\\:border-charcoal-950\\/35:hover{
  border-color: rgba(37, 37, 39, 0.35);
}

.hover\\:border-charcoal-950\\/40:hover{
  border-color: rgba(37, 37, 39, 0.4);
}

.hover\\:border-charcoal-950\\/45:hover{
  border-color: rgba(37, 37, 39, 0.45);
}

.hover\\:border-charcoal-950\\/5:hover{
  border-color: rgba(37, 37, 39, 0.05);
}

.hover\\:border-charcoal-950\\/50:hover{
  border-color: rgba(37, 37, 39, 0.5);
}

.hover\\:border-charcoal-950\\/55:hover{
  border-color: rgba(37, 37, 39, 0.55);
}

.hover\\:border-charcoal-950\\/60:hover{
  border-color: rgba(37, 37, 39, 0.6);
}

.hover\\:border-charcoal-950\\/65:hover{
  border-color: rgba(37, 37, 39, 0.65);
}

.hover\\:border-charcoal-950\\/70:hover{
  border-color: rgba(37, 37, 39, 0.7);
}

.hover\\:border-charcoal-950\\/75:hover{
  border-color: rgba(37, 37, 39, 0.75);
}

.hover\\:border-charcoal-950\\/80:hover{
  border-color: rgba(37, 37, 39, 0.8);
}

.hover\\:border-charcoal-950\\/85:hover{
  border-color: rgba(37, 37, 39, 0.85);
}

.hover\\:border-charcoal-950\\/90:hover{
  border-color: rgba(37, 37, 39, 0.9);
}

.hover\\:border-charcoal-950\\/95:hover{
  border-color: rgba(37, 37, 39, 0.95);
}

.hover\\:border-jade-100:hover{
  --tw-border-opacity: 1;
  border-color: rgba(217, 242, 230, 1);
  border-color: rgba(217, 242, 230, var(--tw-border-opacity, 1));
}

.hover\\:border-jade-100\\/0:hover{
  border-color: rgba(217, 242, 230, 0);
}

.hover\\:border-jade-100\\/10:hover{
  border-color: rgba(217, 242, 230, 0.1);
}

.hover\\:border-jade-100\\/100:hover{
  border-color: rgb(217, 242, 230);
}

.hover\\:border-jade-100\\/15:hover{
  border-color: rgba(217, 242, 230, 0.15);
}

.hover\\:border-jade-100\\/20:hover{
  border-color: rgba(217, 242, 230, 0.2);
}

.hover\\:border-jade-100\\/25:hover{
  border-color: rgba(217, 242, 230, 0.25);
}

.hover\\:border-jade-100\\/30:hover{
  border-color: rgba(217, 242, 230, 0.3);
}

.hover\\:border-jade-100\\/35:hover{
  border-color: rgba(217, 242, 230, 0.35);
}

.hover\\:border-jade-100\\/40:hover{
  border-color: rgba(217, 242, 230, 0.4);
}

.hover\\:border-jade-100\\/45:hover{
  border-color: rgba(217, 242, 230, 0.45);
}

.hover\\:border-jade-100\\/5:hover{
  border-color: rgba(217, 242, 230, 0.05);
}

.hover\\:border-jade-100\\/50:hover{
  border-color: rgba(217, 242, 230, 0.5);
}

.hover\\:border-jade-100\\/55:hover{
  border-color: rgba(217, 242, 230, 0.55);
}

.hover\\:border-jade-100\\/60:hover{
  border-color: rgba(217, 242, 230, 0.6);
}

.hover\\:border-jade-100\\/65:hover{
  border-color: rgba(217, 242, 230, 0.65);
}

.hover\\:border-jade-100\\/70:hover{
  border-color: rgba(217, 242, 230, 0.7);
}

.hover\\:border-jade-100\\/75:hover{
  border-color: rgba(217, 242, 230, 0.75);
}

.hover\\:border-jade-100\\/80:hover{
  border-color: rgba(217, 242, 230, 0.8);
}

.hover\\:border-jade-100\\/85:hover{
  border-color: rgba(217, 242, 230, 0.85);
}

.hover\\:border-jade-100\\/90:hover{
  border-color: rgba(217, 242, 230, 0.9);
}

.hover\\:border-jade-100\\/95:hover{
  border-color: rgba(217, 242, 230, 0.95);
}

.hover\\:border-jade-200:hover{
  --tw-border-opacity: 1;
  border-color: rgba(182, 228, 209, 1);
  border-color: rgba(182, 228, 209, var(--tw-border-opacity, 1));
}

.hover\\:border-jade-200\\/0:hover{
  border-color: rgba(182, 228, 209, 0);
}

.hover\\:border-jade-200\\/10:hover{
  border-color: rgba(182, 228, 209, 0.1);
}

.hover\\:border-jade-200\\/100:hover{
  border-color: rgb(182, 228, 209);
}

.hover\\:border-jade-200\\/15:hover{
  border-color: rgba(182, 228, 209, 0.15);
}

.hover\\:border-jade-200\\/20:hover{
  border-color: rgba(182, 228, 209, 0.2);
}

.hover\\:border-jade-200\\/25:hover{
  border-color: rgba(182, 228, 209, 0.25);
}

.hover\\:border-jade-200\\/30:hover{
  border-color: rgba(182, 228, 209, 0.3);
}

.hover\\:border-jade-200\\/35:hover{
  border-color: rgba(182, 228, 209, 0.35);
}

.hover\\:border-jade-200\\/40:hover{
  border-color: rgba(182, 228, 209, 0.4);
}

.hover\\:border-jade-200\\/45:hover{
  border-color: rgba(182, 228, 209, 0.45);
}

.hover\\:border-jade-200\\/5:hover{
  border-color: rgba(182, 228, 209, 0.05);
}

.hover\\:border-jade-200\\/50:hover{
  border-color: rgba(182, 228, 209, 0.5);
}

.hover\\:border-jade-200\\/55:hover{
  border-color: rgba(182, 228, 209, 0.55);
}

.hover\\:border-jade-200\\/60:hover{
  border-color: rgba(182, 228, 209, 0.6);
}

.hover\\:border-jade-200\\/65:hover{
  border-color: rgba(182, 228, 209, 0.65);
}

.hover\\:border-jade-200\\/70:hover{
  border-color: rgba(182, 228, 209, 0.7);
}

.hover\\:border-jade-200\\/75:hover{
  border-color: rgba(182, 228, 209, 0.75);
}

.hover\\:border-jade-200\\/80:hover{
  border-color: rgba(182, 228, 209, 0.8);
}

.hover\\:border-jade-200\\/85:hover{
  border-color: rgba(182, 228, 209, 0.85);
}

.hover\\:border-jade-200\\/90:hover{
  border-color: rgba(182, 228, 209, 0.9);
}

.hover\\:border-jade-200\\/95:hover{
  border-color: rgba(182, 228, 209, 0.95);
}

.hover\\:border-jade-300:hover{
  --tw-border-opacity: 1;
  border-color: rgba(134, 207, 181, 1);
  border-color: rgba(134, 207, 181, var(--tw-border-opacity, 1));
}

.hover\\:border-jade-300\\/0:hover{
  border-color: rgba(134, 207, 181, 0);
}

.hover\\:border-jade-300\\/10:hover{
  border-color: rgba(134, 207, 181, 0.1);
}

.hover\\:border-jade-300\\/100:hover{
  border-color: rgb(134, 207, 181);
}

.hover\\:border-jade-300\\/15:hover{
  border-color: rgba(134, 207, 181, 0.15);
}

.hover\\:border-jade-300\\/20:hover{
  border-color: rgba(134, 207, 181, 0.2);
}

.hover\\:border-jade-300\\/25:hover{
  border-color: rgba(134, 207, 181, 0.25);
}

.hover\\:border-jade-300\\/30:hover{
  border-color: rgba(134, 207, 181, 0.3);
}

.hover\\:border-jade-300\\/35:hover{
  border-color: rgba(134, 207, 181, 0.35);
}

.hover\\:border-jade-300\\/40:hover{
  border-color: rgba(134, 207, 181, 0.4);
}

.hover\\:border-jade-300\\/45:hover{
  border-color: rgba(134, 207, 181, 0.45);
}

.hover\\:border-jade-300\\/5:hover{
  border-color: rgba(134, 207, 181, 0.05);
}

.hover\\:border-jade-300\\/50:hover{
  border-color: rgba(134, 207, 181, 0.5);
}

.hover\\:border-jade-300\\/55:hover{
  border-color: rgba(134, 207, 181, 0.55);
}

.hover\\:border-jade-300\\/60:hover{
  border-color: rgba(134, 207, 181, 0.6);
}

.hover\\:border-jade-300\\/65:hover{
  border-color: rgba(134, 207, 181, 0.65);
}

.hover\\:border-jade-300\\/70:hover{
  border-color: rgba(134, 207, 181, 0.7);
}

.hover\\:border-jade-300\\/75:hover{
  border-color: rgba(134, 207, 181, 0.75);
}

.hover\\:border-jade-300\\/80:hover{
  border-color: rgba(134, 207, 181, 0.8);
}

.hover\\:border-jade-300\\/85:hover{
  border-color: rgba(134, 207, 181, 0.85);
}

.hover\\:border-jade-300\\/90:hover{
  border-color: rgba(134, 207, 181, 0.9);
}

.hover\\:border-jade-300\\/95:hover{
  border-color: rgba(134, 207, 181, 0.95);
}

.hover\\:border-jade-400:hover{
  --tw-border-opacity: 1;
  border-color: rgba(83, 180, 148, 1);
  border-color: rgba(83, 180, 148, var(--tw-border-opacity, 1));
}

.hover\\:border-jade-400\\/0:hover{
  border-color: rgba(83, 180, 148, 0);
}

.hover\\:border-jade-400\\/10:hover{
  border-color: rgba(83, 180, 148, 0.1);
}

.hover\\:border-jade-400\\/100:hover{
  border-color: rgb(83, 180, 148);
}

.hover\\:border-jade-400\\/15:hover{
  border-color: rgba(83, 180, 148, 0.15);
}

.hover\\:border-jade-400\\/20:hover{
  border-color: rgba(83, 180, 148, 0.2);
}

.hover\\:border-jade-400\\/25:hover{
  border-color: rgba(83, 180, 148, 0.25);
}

.hover\\:border-jade-400\\/30:hover{
  border-color: rgba(83, 180, 148, 0.3);
}

.hover\\:border-jade-400\\/35:hover{
  border-color: rgba(83, 180, 148, 0.35);
}

.hover\\:border-jade-400\\/40:hover{
  border-color: rgba(83, 180, 148, 0.4);
}

.hover\\:border-jade-400\\/45:hover{
  border-color: rgba(83, 180, 148, 0.45);
}

.hover\\:border-jade-400\\/5:hover{
  border-color: rgba(83, 180, 148, 0.05);
}

.hover\\:border-jade-400\\/50:hover{
  border-color: rgba(83, 180, 148, 0.5);
}

.hover\\:border-jade-400\\/55:hover{
  border-color: rgba(83, 180, 148, 0.55);
}

.hover\\:border-jade-400\\/60:hover{
  border-color: rgba(83, 180, 148, 0.6);
}

.hover\\:border-jade-400\\/65:hover{
  border-color: rgba(83, 180, 148, 0.65);
}

.hover\\:border-jade-400\\/70:hover{
  border-color: rgba(83, 180, 148, 0.7);
}

.hover\\:border-jade-400\\/75:hover{
  border-color: rgba(83, 180, 148, 0.75);
}

.hover\\:border-jade-400\\/80:hover{
  border-color: rgba(83, 180, 148, 0.8);
}

.hover\\:border-jade-400\\/85:hover{
  border-color: rgba(83, 180, 148, 0.85);
}

.hover\\:border-jade-400\\/90:hover{
  border-color: rgba(83, 180, 148, 0.9);
}

.hover\\:border-jade-400\\/95:hover{
  border-color: rgba(83, 180, 148, 0.95);
}

.hover\\:border-jade-500:hover{
  --tw-border-opacity: 1;
  border-color: rgba(44, 135, 109, 1);
  border-color: rgba(44, 135, 109, var(--tw-border-opacity, 1));
}

.hover\\:border-jade-500\\/0:hover{
  border-color: rgba(44, 135, 109, 0);
}

.hover\\:border-jade-500\\/10:hover{
  border-color: rgba(44, 135, 109, 0.1);
}

.hover\\:border-jade-500\\/100:hover{
  border-color: rgb(44, 135, 109);
}

.hover\\:border-jade-500\\/15:hover{
  border-color: rgba(44, 135, 109, 0.15);
}

.hover\\:border-jade-500\\/20:hover{
  border-color: rgba(44, 135, 109, 0.2);
}

.hover\\:border-jade-500\\/25:hover{
  border-color: rgba(44, 135, 109, 0.25);
}

.hover\\:border-jade-500\\/30:hover{
  border-color: rgba(44, 135, 109, 0.3);
}

.hover\\:border-jade-500\\/35:hover{
  border-color: rgba(44, 135, 109, 0.35);
}

.hover\\:border-jade-500\\/40:hover{
  border-color: rgba(44, 135, 109, 0.4);
}

.hover\\:border-jade-500\\/45:hover{
  border-color: rgba(44, 135, 109, 0.45);
}

.hover\\:border-jade-500\\/5:hover{
  border-color: rgba(44, 135, 109, 0.05);
}

.hover\\:border-jade-500\\/50:hover{
  border-color: rgba(44, 135, 109, 0.5);
}

.hover\\:border-jade-500\\/55:hover{
  border-color: rgba(44, 135, 109, 0.55);
}

.hover\\:border-jade-500\\/60:hover{
  border-color: rgba(44, 135, 109, 0.6);
}

.hover\\:border-jade-500\\/65:hover{
  border-color: rgba(44, 135, 109, 0.65);
}

.hover\\:border-jade-500\\/70:hover{
  border-color: rgba(44, 135, 109, 0.7);
}

.hover\\:border-jade-500\\/75:hover{
  border-color: rgba(44, 135, 109, 0.75);
}

.hover\\:border-jade-500\\/80:hover{
  border-color: rgba(44, 135, 109, 0.8);
}

.hover\\:border-jade-500\\/85:hover{
  border-color: rgba(44, 135, 109, 0.85);
}

.hover\\:border-jade-500\\/90:hover{
  border-color: rgba(44, 135, 109, 0.9);
}

.hover\\:border-jade-500\\/95:hover{
  border-color: rgba(44, 135, 109, 0.95);
}

.hover\\:border-jade-600:hover{
  --tw-border-opacity: 1;
  border-color: rgba(34, 121, 98, 1);
  border-color: rgba(34, 121, 98, var(--tw-border-opacity, 1));
}

.hover\\:border-jade-600\\/0:hover{
  border-color: rgba(34, 121, 98, 0);
}

.hover\\:border-jade-600\\/10:hover{
  border-color: rgba(34, 121, 98, 0.1);
}

.hover\\:border-jade-600\\/100:hover{
  border-color: rgb(34, 121, 98);
}

.hover\\:border-jade-600\\/15:hover{
  border-color: rgba(34, 121, 98, 0.15);
}

.hover\\:border-jade-600\\/20:hover{
  border-color: rgba(34, 121, 98, 0.2);
}

.hover\\:border-jade-600\\/25:hover{
  border-color: rgba(34, 121, 98, 0.25);
}

.hover\\:border-jade-600\\/30:hover{
  border-color: rgba(34, 121, 98, 0.3);
}

.hover\\:border-jade-600\\/35:hover{
  border-color: rgba(34, 121, 98, 0.35);
}

.hover\\:border-jade-600\\/40:hover{
  border-color: rgba(34, 121, 98, 0.4);
}

.hover\\:border-jade-600\\/45:hover{
  border-color: rgba(34, 121, 98, 0.45);
}

.hover\\:border-jade-600\\/5:hover{
  border-color: rgba(34, 121, 98, 0.05);
}

.hover\\:border-jade-600\\/50:hover{
  border-color: rgba(34, 121, 98, 0.5);
}

.hover\\:border-jade-600\\/55:hover{
  border-color: rgba(34, 121, 98, 0.55);
}

.hover\\:border-jade-600\\/60:hover{
  border-color: rgba(34, 121, 98, 0.6);
}

.hover\\:border-jade-600\\/65:hover{
  border-color: rgba(34, 121, 98, 0.65);
}

.hover\\:border-jade-600\\/70:hover{
  border-color: rgba(34, 121, 98, 0.7);
}

.hover\\:border-jade-600\\/75:hover{
  border-color: rgba(34, 121, 98, 0.75);
}

.hover\\:border-jade-600\\/80:hover{
  border-color: rgba(34, 121, 98, 0.8);
}

.hover\\:border-jade-600\\/85:hover{
  border-color: rgba(34, 121, 98, 0.85);
}

.hover\\:border-jade-600\\/90:hover{
  border-color: rgba(34, 121, 98, 0.9);
}

.hover\\:border-jade-600\\/95:hover{
  border-color: rgba(34, 121, 98, 0.95);
}

.hover\\:border-jade-700:hover{
  --tw-border-opacity: 1;
  border-color: rgba(27, 97, 80, 1);
  border-color: rgba(27, 97, 80, var(--tw-border-opacity, 1));
}

.hover\\:border-jade-700\\/0:hover{
  border-color: rgba(27, 97, 80, 0);
}

.hover\\:border-jade-700\\/10:hover{
  border-color: rgba(27, 97, 80, 0.1);
}

.hover\\:border-jade-700\\/100:hover{
  border-color: rgb(27, 97, 80);
}

.hover\\:border-jade-700\\/15:hover{
  border-color: rgba(27, 97, 80, 0.15);
}

.hover\\:border-jade-700\\/20:hover{
  border-color: rgba(27, 97, 80, 0.2);
}

.hover\\:border-jade-700\\/25:hover{
  border-color: rgba(27, 97, 80, 0.25);
}

.hover\\:border-jade-700\\/30:hover{
  border-color: rgba(27, 97, 80, 0.3);
}

.hover\\:border-jade-700\\/35:hover{
  border-color: rgba(27, 97, 80, 0.35);
}

.hover\\:border-jade-700\\/40:hover{
  border-color: rgba(27, 97, 80, 0.4);
}

.hover\\:border-jade-700\\/45:hover{
  border-color: rgba(27, 97, 80, 0.45);
}

.hover\\:border-jade-700\\/5:hover{
  border-color: rgba(27, 97, 80, 0.05);
}

.hover\\:border-jade-700\\/50:hover{
  border-color: rgba(27, 97, 80, 0.5);
}

.hover\\:border-jade-700\\/55:hover{
  border-color: rgba(27, 97, 80, 0.55);
}

.hover\\:border-jade-700\\/60:hover{
  border-color: rgba(27, 97, 80, 0.6);
}

.hover\\:border-jade-700\\/65:hover{
  border-color: rgba(27, 97, 80, 0.65);
}

.hover\\:border-jade-700\\/70:hover{
  border-color: rgba(27, 97, 80, 0.7);
}

.hover\\:border-jade-700\\/75:hover{
  border-color: rgba(27, 97, 80, 0.75);
}

.hover\\:border-jade-700\\/80:hover{
  border-color: rgba(27, 97, 80, 0.8);
}

.hover\\:border-jade-700\\/85:hover{
  border-color: rgba(27, 97, 80, 0.85);
}

.hover\\:border-jade-700\\/90:hover{
  border-color: rgba(27, 97, 80, 0.9);
}

.hover\\:border-jade-700\\/95:hover{
  border-color: rgba(27, 97, 80, 0.95);
}

.hover\\:border-jade-800:hover{
  --tw-border-opacity: 1;
  border-color: rgba(24, 77, 64, 1);
  border-color: rgba(24, 77, 64, var(--tw-border-opacity, 1));
}

.hover\\:border-jade-800\\/0:hover{
  border-color: rgba(24, 77, 64, 0);
}

.hover\\:border-jade-800\\/10:hover{
  border-color: rgba(24, 77, 64, 0.1);
}

.hover\\:border-jade-800\\/100:hover{
  border-color: rgb(24, 77, 64);
}

.hover\\:border-jade-800\\/15:hover{
  border-color: rgba(24, 77, 64, 0.15);
}

.hover\\:border-jade-800\\/20:hover{
  border-color: rgba(24, 77, 64, 0.2);
}

.hover\\:border-jade-800\\/25:hover{
  border-color: rgba(24, 77, 64, 0.25);
}

.hover\\:border-jade-800\\/30:hover{
  border-color: rgba(24, 77, 64, 0.3);
}

.hover\\:border-jade-800\\/35:hover{
  border-color: rgba(24, 77, 64, 0.35);
}

.hover\\:border-jade-800\\/40:hover{
  border-color: rgba(24, 77, 64, 0.4);
}

.hover\\:border-jade-800\\/45:hover{
  border-color: rgba(24, 77, 64, 0.45);
}

.hover\\:border-jade-800\\/5:hover{
  border-color: rgba(24, 77, 64, 0.05);
}

.hover\\:border-jade-800\\/50:hover{
  border-color: rgba(24, 77, 64, 0.5);
}

.hover\\:border-jade-800\\/55:hover{
  border-color: rgba(24, 77, 64, 0.55);
}

.hover\\:border-jade-800\\/60:hover{
  border-color: rgba(24, 77, 64, 0.6);
}

.hover\\:border-jade-800\\/65:hover{
  border-color: rgba(24, 77, 64, 0.65);
}

.hover\\:border-jade-800\\/70:hover{
  border-color: rgba(24, 77, 64, 0.7);
}

.hover\\:border-jade-800\\/75:hover{
  border-color: rgba(24, 77, 64, 0.75);
}

.hover\\:border-jade-800\\/80:hover{
  border-color: rgba(24, 77, 64, 0.8);
}

.hover\\:border-jade-800\\/85:hover{
  border-color: rgba(24, 77, 64, 0.85);
}

.hover\\:border-jade-800\\/90:hover{
  border-color: rgba(24, 77, 64, 0.9);
}

.hover\\:border-jade-800\\/95:hover{
  border-color: rgba(24, 77, 64, 0.95);
}

.hover\\:border-jade-900:hover{
  --tw-border-opacity: 1;
  border-color: rgba(20, 64, 54, 1);
  border-color: rgba(20, 64, 54, var(--tw-border-opacity, 1));
}

.hover\\:border-jade-900\\/0:hover{
  border-color: rgba(20, 64, 54, 0);
}

.hover\\:border-jade-900\\/10:hover{
  border-color: rgba(20, 64, 54, 0.1);
}

.hover\\:border-jade-900\\/100:hover{
  border-color: rgb(20, 64, 54);
}

.hover\\:border-jade-900\\/15:hover{
  border-color: rgba(20, 64, 54, 0.15);
}

.hover\\:border-jade-900\\/20:hover{
  border-color: rgba(20, 64, 54, 0.2);
}

.hover\\:border-jade-900\\/25:hover{
  border-color: rgba(20, 64, 54, 0.25);
}

.hover\\:border-jade-900\\/30:hover{
  border-color: rgba(20, 64, 54, 0.3);
}

.hover\\:border-jade-900\\/35:hover{
  border-color: rgba(20, 64, 54, 0.35);
}

.hover\\:border-jade-900\\/40:hover{
  border-color: rgba(20, 64, 54, 0.4);
}

.hover\\:border-jade-900\\/45:hover{
  border-color: rgba(20, 64, 54, 0.45);
}

.hover\\:border-jade-900\\/5:hover{
  border-color: rgba(20, 64, 54, 0.05);
}

.hover\\:border-jade-900\\/50:hover{
  border-color: rgba(20, 64, 54, 0.5);
}

.hover\\:border-jade-900\\/55:hover{
  border-color: rgba(20, 64, 54, 0.55);
}

.hover\\:border-jade-900\\/60:hover{
  border-color: rgba(20, 64, 54, 0.6);
}

.hover\\:border-jade-900\\/65:hover{
  border-color: rgba(20, 64, 54, 0.65);
}

.hover\\:border-jade-900\\/70:hover{
  border-color: rgba(20, 64, 54, 0.7);
}

.hover\\:border-jade-900\\/75:hover{
  border-color: rgba(20, 64, 54, 0.75);
}

.hover\\:border-jade-900\\/80:hover{
  border-color: rgba(20, 64, 54, 0.8);
}

.hover\\:border-jade-900\\/85:hover{
  border-color: rgba(20, 64, 54, 0.85);
}

.hover\\:border-jade-900\\/90:hover{
  border-color: rgba(20, 64, 54, 0.9);
}

.hover\\:border-jade-900\\/95:hover{
  border-color: rgba(20, 64, 54, 0.95);
}

.hover\\:border-jade-950:hover{
  --tw-border-opacity: 1;
  border-color: rgba(10, 36, 31, 1);
  border-color: rgba(10, 36, 31, var(--tw-border-opacity, 1));
}

.hover\\:border-jade-950\\/0:hover{
  border-color: rgba(10, 36, 31, 0);
}

.hover\\:border-jade-950\\/10:hover{
  border-color: rgba(10, 36, 31, 0.1);
}

.hover\\:border-jade-950\\/100:hover{
  border-color: rgb(10, 36, 31);
}

.hover\\:border-jade-950\\/15:hover{
  border-color: rgba(10, 36, 31, 0.15);
}

.hover\\:border-jade-950\\/20:hover{
  border-color: rgba(10, 36, 31, 0.2);
}

.hover\\:border-jade-950\\/25:hover{
  border-color: rgba(10, 36, 31, 0.25);
}

.hover\\:border-jade-950\\/30:hover{
  border-color: rgba(10, 36, 31, 0.3);
}

.hover\\:border-jade-950\\/35:hover{
  border-color: rgba(10, 36, 31, 0.35);
}

.hover\\:border-jade-950\\/40:hover{
  border-color: rgba(10, 36, 31, 0.4);
}

.hover\\:border-jade-950\\/45:hover{
  border-color: rgba(10, 36, 31, 0.45);
}

.hover\\:border-jade-950\\/5:hover{
  border-color: rgba(10, 36, 31, 0.05);
}

.hover\\:border-jade-950\\/50:hover{
  border-color: rgba(10, 36, 31, 0.5);
}

.hover\\:border-jade-950\\/55:hover{
  border-color: rgba(10, 36, 31, 0.55);
}

.hover\\:border-jade-950\\/60:hover{
  border-color: rgba(10, 36, 31, 0.6);
}

.hover\\:border-jade-950\\/65:hover{
  border-color: rgba(10, 36, 31, 0.65);
}

.hover\\:border-jade-950\\/70:hover{
  border-color: rgba(10, 36, 31, 0.7);
}

.hover\\:border-jade-950\\/75:hover{
  border-color: rgba(10, 36, 31, 0.75);
}

.hover\\:border-jade-950\\/80:hover{
  border-color: rgba(10, 36, 31, 0.8);
}

.hover\\:border-jade-950\\/85:hover{
  border-color: rgba(10, 36, 31, 0.85);
}

.hover\\:border-jade-950\\/90:hover{
  border-color: rgba(10, 36, 31, 0.9);
}

.hover\\:border-jade-950\\/95:hover{
  border-color: rgba(10, 36, 31, 0.95);
}

.hover\\:border-kids-alphabet-500:hover{
  --tw-border-opacity: 1;
  border-color: rgba(55, 135, 163, 1);
  border-color: rgba(55, 135, 163, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-alphabet-500\\/0:hover{
  border-color: rgba(55, 135, 163, 0);
}

.hover\\:border-kids-alphabet-500\\/10:hover{
  border-color: rgba(55, 135, 163, 0.1);
}

.hover\\:border-kids-alphabet-500\\/100:hover{
  border-color: rgb(55, 135, 163);
}

.hover\\:border-kids-alphabet-500\\/15:hover{
  border-color: rgba(55, 135, 163, 0.15);
}

.hover\\:border-kids-alphabet-500\\/20:hover{
  border-color: rgba(55, 135, 163, 0.2);
}

.hover\\:border-kids-alphabet-500\\/25:hover{
  border-color: rgba(55, 135, 163, 0.25);
}

.hover\\:border-kids-alphabet-500\\/30:hover{
  border-color: rgba(55, 135, 163, 0.3);
}

.hover\\:border-kids-alphabet-500\\/35:hover{
  border-color: rgba(55, 135, 163, 0.35);
}

.hover\\:border-kids-alphabet-500\\/40:hover{
  border-color: rgba(55, 135, 163, 0.4);
}

.hover\\:border-kids-alphabet-500\\/45:hover{
  border-color: rgba(55, 135, 163, 0.45);
}

.hover\\:border-kids-alphabet-500\\/5:hover{
  border-color: rgba(55, 135, 163, 0.05);
}

.hover\\:border-kids-alphabet-500\\/50:hover{
  border-color: rgba(55, 135, 163, 0.5);
}

.hover\\:border-kids-alphabet-500\\/55:hover{
  border-color: rgba(55, 135, 163, 0.55);
}

.hover\\:border-kids-alphabet-500\\/60:hover{
  border-color: rgba(55, 135, 163, 0.6);
}

.hover\\:border-kids-alphabet-500\\/65:hover{
  border-color: rgba(55, 135, 163, 0.65);
}

.hover\\:border-kids-alphabet-500\\/70:hover{
  border-color: rgba(55, 135, 163, 0.7);
}

.hover\\:border-kids-alphabet-500\\/75:hover{
  border-color: rgba(55, 135, 163, 0.75);
}

.hover\\:border-kids-alphabet-500\\/80:hover{
  border-color: rgba(55, 135, 163, 0.8);
}

.hover\\:border-kids-alphabet-500\\/85:hover{
  border-color: rgba(55, 135, 163, 0.85);
}

.hover\\:border-kids-alphabet-500\\/90:hover{
  border-color: rgba(55, 135, 163, 0.9);
}

.hover\\:border-kids-alphabet-500\\/95:hover{
  border-color: rgba(55, 135, 163, 0.95);
}

.hover\\:border-kids-alphabet-600:hover{
  --tw-border-opacity: 1;
  border-color: rgba(48, 109, 138, 1);
  border-color: rgba(48, 109, 138, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-alphabet-600\\/0:hover{
  border-color: rgba(48, 109, 138, 0);
}

.hover\\:border-kids-alphabet-600\\/10:hover{
  border-color: rgba(48, 109, 138, 0.1);
}

.hover\\:border-kids-alphabet-600\\/100:hover{
  border-color: rgb(48, 109, 138);
}

.hover\\:border-kids-alphabet-600\\/15:hover{
  border-color: rgba(48, 109, 138, 0.15);
}

.hover\\:border-kids-alphabet-600\\/20:hover{
  border-color: rgba(48, 109, 138, 0.2);
}

.hover\\:border-kids-alphabet-600\\/25:hover{
  border-color: rgba(48, 109, 138, 0.25);
}

.hover\\:border-kids-alphabet-600\\/30:hover{
  border-color: rgba(48, 109, 138, 0.3);
}

.hover\\:border-kids-alphabet-600\\/35:hover{
  border-color: rgba(48, 109, 138, 0.35);
}

.hover\\:border-kids-alphabet-600\\/40:hover{
  border-color: rgba(48, 109, 138, 0.4);
}

.hover\\:border-kids-alphabet-600\\/45:hover{
  border-color: rgba(48, 109, 138, 0.45);
}

.hover\\:border-kids-alphabet-600\\/5:hover{
  border-color: rgba(48, 109, 138, 0.05);
}

.hover\\:border-kids-alphabet-600\\/50:hover{
  border-color: rgba(48, 109, 138, 0.5);
}

.hover\\:border-kids-alphabet-600\\/55:hover{
  border-color: rgba(48, 109, 138, 0.55);
}

.hover\\:border-kids-alphabet-600\\/60:hover{
  border-color: rgba(48, 109, 138, 0.6);
}

.hover\\:border-kids-alphabet-600\\/65:hover{
  border-color: rgba(48, 109, 138, 0.65);
}

.hover\\:border-kids-alphabet-600\\/70:hover{
  border-color: rgba(48, 109, 138, 0.7);
}

.hover\\:border-kids-alphabet-600\\/75:hover{
  border-color: rgba(48, 109, 138, 0.75);
}

.hover\\:border-kids-alphabet-600\\/80:hover{
  border-color: rgba(48, 109, 138, 0.8);
}

.hover\\:border-kids-alphabet-600\\/85:hover{
  border-color: rgba(48, 109, 138, 0.85);
}

.hover\\:border-kids-alphabet-600\\/90:hover{
  border-color: rgba(48, 109, 138, 0.9);
}

.hover\\:border-kids-alphabet-600\\/95:hover{
  border-color: rgba(48, 109, 138, 0.95);
}

.hover\\:border-kids-alphabet-700:hover{
  --tw-border-opacity: 1;
  border-color: rgba(45, 91, 114, 1);
  border-color: rgba(45, 91, 114, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-alphabet-700\\/0:hover{
  border-color: rgba(45, 91, 114, 0);
}

.hover\\:border-kids-alphabet-700\\/10:hover{
  border-color: rgba(45, 91, 114, 0.1);
}

.hover\\:border-kids-alphabet-700\\/100:hover{
  border-color: rgb(45, 91, 114);
}

.hover\\:border-kids-alphabet-700\\/15:hover{
  border-color: rgba(45, 91, 114, 0.15);
}

.hover\\:border-kids-alphabet-700\\/20:hover{
  border-color: rgba(45, 91, 114, 0.2);
}

.hover\\:border-kids-alphabet-700\\/25:hover{
  border-color: rgba(45, 91, 114, 0.25);
}

.hover\\:border-kids-alphabet-700\\/30:hover{
  border-color: rgba(45, 91, 114, 0.3);
}

.hover\\:border-kids-alphabet-700\\/35:hover{
  border-color: rgba(45, 91, 114, 0.35);
}

.hover\\:border-kids-alphabet-700\\/40:hover{
  border-color: rgba(45, 91, 114, 0.4);
}

.hover\\:border-kids-alphabet-700\\/45:hover{
  border-color: rgba(45, 91, 114, 0.45);
}

.hover\\:border-kids-alphabet-700\\/5:hover{
  border-color: rgba(45, 91, 114, 0.05);
}

.hover\\:border-kids-alphabet-700\\/50:hover{
  border-color: rgba(45, 91, 114, 0.5);
}

.hover\\:border-kids-alphabet-700\\/55:hover{
  border-color: rgba(45, 91, 114, 0.55);
}

.hover\\:border-kids-alphabet-700\\/60:hover{
  border-color: rgba(45, 91, 114, 0.6);
}

.hover\\:border-kids-alphabet-700\\/65:hover{
  border-color: rgba(45, 91, 114, 0.65);
}

.hover\\:border-kids-alphabet-700\\/70:hover{
  border-color: rgba(45, 91, 114, 0.7);
}

.hover\\:border-kids-alphabet-700\\/75:hover{
  border-color: rgba(45, 91, 114, 0.75);
}

.hover\\:border-kids-alphabet-700\\/80:hover{
  border-color: rgba(45, 91, 114, 0.8);
}

.hover\\:border-kids-alphabet-700\\/85:hover{
  border-color: rgba(45, 91, 114, 0.85);
}

.hover\\:border-kids-alphabet-700\\/90:hover{
  border-color: rgba(45, 91, 114, 0.9);
}

.hover\\:border-kids-alphabet-700\\/95:hover{
  border-color: rgba(45, 91, 114, 0.95);
}

.hover\\:border-kids-alphabet-800:hover{
  --tw-border-opacity: 1;
  border-color: rgba(44, 76, 94, 1);
  border-color: rgba(44, 76, 94, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-alphabet-800\\/0:hover{
  border-color: rgba(44, 76, 94, 0);
}

.hover\\:border-kids-alphabet-800\\/10:hover{
  border-color: rgba(44, 76, 94, 0.1);
}

.hover\\:border-kids-alphabet-800\\/100:hover{
  border-color: rgb(44, 76, 94);
}

.hover\\:border-kids-alphabet-800\\/15:hover{
  border-color: rgba(44, 76, 94, 0.15);
}

.hover\\:border-kids-alphabet-800\\/20:hover{
  border-color: rgba(44, 76, 94, 0.2);
}

.hover\\:border-kids-alphabet-800\\/25:hover{
  border-color: rgba(44, 76, 94, 0.25);
}

.hover\\:border-kids-alphabet-800\\/30:hover{
  border-color: rgba(44, 76, 94, 0.3);
}

.hover\\:border-kids-alphabet-800\\/35:hover{
  border-color: rgba(44, 76, 94, 0.35);
}

.hover\\:border-kids-alphabet-800\\/40:hover{
  border-color: rgba(44, 76, 94, 0.4);
}

.hover\\:border-kids-alphabet-800\\/45:hover{
  border-color: rgba(44, 76, 94, 0.45);
}

.hover\\:border-kids-alphabet-800\\/5:hover{
  border-color: rgba(44, 76, 94, 0.05);
}

.hover\\:border-kids-alphabet-800\\/50:hover{
  border-color: rgba(44, 76, 94, 0.5);
}

.hover\\:border-kids-alphabet-800\\/55:hover{
  border-color: rgba(44, 76, 94, 0.55);
}

.hover\\:border-kids-alphabet-800\\/60:hover{
  border-color: rgba(44, 76, 94, 0.6);
}

.hover\\:border-kids-alphabet-800\\/65:hover{
  border-color: rgba(44, 76, 94, 0.65);
}

.hover\\:border-kids-alphabet-800\\/70:hover{
  border-color: rgba(44, 76, 94, 0.7);
}

.hover\\:border-kids-alphabet-800\\/75:hover{
  border-color: rgba(44, 76, 94, 0.75);
}

.hover\\:border-kids-alphabet-800\\/80:hover{
  border-color: rgba(44, 76, 94, 0.8);
}

.hover\\:border-kids-alphabet-800\\/85:hover{
  border-color: rgba(44, 76, 94, 0.85);
}

.hover\\:border-kids-alphabet-800\\/90:hover{
  border-color: rgba(44, 76, 94, 0.9);
}

.hover\\:border-kids-alphabet-800\\/95:hover{
  border-color: rgba(44, 76, 94, 0.95);
}

.hover\\:border-kids-alphabet-900:hover{
  --tw-border-opacity: 1;
  border-color: rgba(40, 65, 81, 1);
  border-color: rgba(40, 65, 81, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-alphabet-900\\/0:hover{
  border-color: rgba(40, 65, 81, 0);
}

.hover\\:border-kids-alphabet-900\\/10:hover{
  border-color: rgba(40, 65, 81, 0.1);
}

.hover\\:border-kids-alphabet-900\\/100:hover{
  border-color: rgb(40, 65, 81);
}

.hover\\:border-kids-alphabet-900\\/15:hover{
  border-color: rgba(40, 65, 81, 0.15);
}

.hover\\:border-kids-alphabet-900\\/20:hover{
  border-color: rgba(40, 65, 81, 0.2);
}

.hover\\:border-kids-alphabet-900\\/25:hover{
  border-color: rgba(40, 65, 81, 0.25);
}

.hover\\:border-kids-alphabet-900\\/30:hover{
  border-color: rgba(40, 65, 81, 0.3);
}

.hover\\:border-kids-alphabet-900\\/35:hover{
  border-color: rgba(40, 65, 81, 0.35);
}

.hover\\:border-kids-alphabet-900\\/40:hover{
  border-color: rgba(40, 65, 81, 0.4);
}

.hover\\:border-kids-alphabet-900\\/45:hover{
  border-color: rgba(40, 65, 81, 0.45);
}

.hover\\:border-kids-alphabet-900\\/5:hover{
  border-color: rgba(40, 65, 81, 0.05);
}

.hover\\:border-kids-alphabet-900\\/50:hover{
  border-color: rgba(40, 65, 81, 0.5);
}

.hover\\:border-kids-alphabet-900\\/55:hover{
  border-color: rgba(40, 65, 81, 0.55);
}

.hover\\:border-kids-alphabet-900\\/60:hover{
  border-color: rgba(40, 65, 81, 0.6);
}

.hover\\:border-kids-alphabet-900\\/65:hover{
  border-color: rgba(40, 65, 81, 0.65);
}

.hover\\:border-kids-alphabet-900\\/70:hover{
  border-color: rgba(40, 65, 81, 0.7);
}

.hover\\:border-kids-alphabet-900\\/75:hover{
  border-color: rgba(40, 65, 81, 0.75);
}

.hover\\:border-kids-alphabet-900\\/80:hover{
  border-color: rgba(40, 65, 81, 0.8);
}

.hover\\:border-kids-alphabet-900\\/85:hover{
  border-color: rgba(40, 65, 81, 0.85);
}

.hover\\:border-kids-alphabet-900\\/90:hover{
  border-color: rgba(40, 65, 81, 0.9);
}

.hover\\:border-kids-alphabet-900\\/95:hover{
  border-color: rgba(40, 65, 81, 0.95);
}

.hover\\:border-kids-categories-500:hover{
  --tw-border-opacity: 1;
  border-color: rgba(209, 145, 47, 1);
  border-color: rgba(209, 145, 47, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-categories-500\\/0:hover{
  border-color: rgba(209, 145, 47, 0);
}

.hover\\:border-kids-categories-500\\/10:hover{
  border-color: rgba(209, 145, 47, 0.1);
}

.hover\\:border-kids-categories-500\\/100:hover{
  border-color: rgb(209, 145, 47);
}

.hover\\:border-kids-categories-500\\/15:hover{
  border-color: rgba(209, 145, 47, 0.15);
}

.hover\\:border-kids-categories-500\\/20:hover{
  border-color: rgba(209, 145, 47, 0.2);
}

.hover\\:border-kids-categories-500\\/25:hover{
  border-color: rgba(209, 145, 47, 0.25);
}

.hover\\:border-kids-categories-500\\/30:hover{
  border-color: rgba(209, 145, 47, 0.3);
}

.hover\\:border-kids-categories-500\\/35:hover{
  border-color: rgba(209, 145, 47, 0.35);
}

.hover\\:border-kids-categories-500\\/40:hover{
  border-color: rgba(209, 145, 47, 0.4);
}

.hover\\:border-kids-categories-500\\/45:hover{
  border-color: rgba(209, 145, 47, 0.45);
}

.hover\\:border-kids-categories-500\\/5:hover{
  border-color: rgba(209, 145, 47, 0.05);
}

.hover\\:border-kids-categories-500\\/50:hover{
  border-color: rgba(209, 145, 47, 0.5);
}

.hover\\:border-kids-categories-500\\/55:hover{
  border-color: rgba(209, 145, 47, 0.55);
}

.hover\\:border-kids-categories-500\\/60:hover{
  border-color: rgba(209, 145, 47, 0.6);
}

.hover\\:border-kids-categories-500\\/65:hover{
  border-color: rgba(209, 145, 47, 0.65);
}

.hover\\:border-kids-categories-500\\/70:hover{
  border-color: rgba(209, 145, 47, 0.7);
}

.hover\\:border-kids-categories-500\\/75:hover{
  border-color: rgba(209, 145, 47, 0.75);
}

.hover\\:border-kids-categories-500\\/80:hover{
  border-color: rgba(209, 145, 47, 0.8);
}

.hover\\:border-kids-categories-500\\/85:hover{
  border-color: rgba(209, 145, 47, 0.85);
}

.hover\\:border-kids-categories-500\\/90:hover{
  border-color: rgba(209, 145, 47, 0.9);
}

.hover\\:border-kids-categories-500\\/95:hover{
  border-color: rgba(209, 145, 47, 0.95);
}

.hover\\:border-kids-categories-600:hover{
  --tw-border-opacity: 1;
  border-color: rgba(195, 120, 41, 1);
  border-color: rgba(195, 120, 41, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-categories-600\\/0:hover{
  border-color: rgba(195, 120, 41, 0);
}

.hover\\:border-kids-categories-600\\/10:hover{
  border-color: rgba(195, 120, 41, 0.1);
}

.hover\\:border-kids-categories-600\\/100:hover{
  border-color: rgb(195, 120, 41);
}

.hover\\:border-kids-categories-600\\/15:hover{
  border-color: rgba(195, 120, 41, 0.15);
}

.hover\\:border-kids-categories-600\\/20:hover{
  border-color: rgba(195, 120, 41, 0.2);
}

.hover\\:border-kids-categories-600\\/25:hover{
  border-color: rgba(195, 120, 41, 0.25);
}

.hover\\:border-kids-categories-600\\/30:hover{
  border-color: rgba(195, 120, 41, 0.3);
}

.hover\\:border-kids-categories-600\\/35:hover{
  border-color: rgba(195, 120, 41, 0.35);
}

.hover\\:border-kids-categories-600\\/40:hover{
  border-color: rgba(195, 120, 41, 0.4);
}

.hover\\:border-kids-categories-600\\/45:hover{
  border-color: rgba(195, 120, 41, 0.45);
}

.hover\\:border-kids-categories-600\\/5:hover{
  border-color: rgba(195, 120, 41, 0.05);
}

.hover\\:border-kids-categories-600\\/50:hover{
  border-color: rgba(195, 120, 41, 0.5);
}

.hover\\:border-kids-categories-600\\/55:hover{
  border-color: rgba(195, 120, 41, 0.55);
}

.hover\\:border-kids-categories-600\\/60:hover{
  border-color: rgba(195, 120, 41, 0.6);
}

.hover\\:border-kids-categories-600\\/65:hover{
  border-color: rgba(195, 120, 41, 0.65);
}

.hover\\:border-kids-categories-600\\/70:hover{
  border-color: rgba(195, 120, 41, 0.7);
}

.hover\\:border-kids-categories-600\\/75:hover{
  border-color: rgba(195, 120, 41, 0.75);
}

.hover\\:border-kids-categories-600\\/80:hover{
  border-color: rgba(195, 120, 41, 0.8);
}

.hover\\:border-kids-categories-600\\/85:hover{
  border-color: rgba(195, 120, 41, 0.85);
}

.hover\\:border-kids-categories-600\\/90:hover{
  border-color: rgba(195, 120, 41, 0.9);
}

.hover\\:border-kids-categories-600\\/95:hover{
  border-color: rgba(195, 120, 41, 0.95);
}

.hover\\:border-kids-categories-700:hover{
  --tw-border-opacity: 1;
  border-color: rgba(153, 84, 36, 1);
  border-color: rgba(153, 84, 36, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-categories-700\\/0:hover{
  border-color: rgba(153, 84, 36, 0);
}

.hover\\:border-kids-categories-700\\/10:hover{
  border-color: rgba(153, 84, 36, 0.1);
}

.hover\\:border-kids-categories-700\\/100:hover{
  border-color: rgb(153, 84, 36);
}

.hover\\:border-kids-categories-700\\/15:hover{
  border-color: rgba(153, 84, 36, 0.15);
}

.hover\\:border-kids-categories-700\\/20:hover{
  border-color: rgba(153, 84, 36, 0.2);
}

.hover\\:border-kids-categories-700\\/25:hover{
  border-color: rgba(153, 84, 36, 0.25);
}

.hover\\:border-kids-categories-700\\/30:hover{
  border-color: rgba(153, 84, 36, 0.3);
}

.hover\\:border-kids-categories-700\\/35:hover{
  border-color: rgba(153, 84, 36, 0.35);
}

.hover\\:border-kids-categories-700\\/40:hover{
  border-color: rgba(153, 84, 36, 0.4);
}

.hover\\:border-kids-categories-700\\/45:hover{
  border-color: rgba(153, 84, 36, 0.45);
}

.hover\\:border-kids-categories-700\\/5:hover{
  border-color: rgba(153, 84, 36, 0.05);
}

.hover\\:border-kids-categories-700\\/50:hover{
  border-color: rgba(153, 84, 36, 0.5);
}

.hover\\:border-kids-categories-700\\/55:hover{
  border-color: rgba(153, 84, 36, 0.55);
}

.hover\\:border-kids-categories-700\\/60:hover{
  border-color: rgba(153, 84, 36, 0.6);
}

.hover\\:border-kids-categories-700\\/65:hover{
  border-color: rgba(153, 84, 36, 0.65);
}

.hover\\:border-kids-categories-700\\/70:hover{
  border-color: rgba(153, 84, 36, 0.7);
}

.hover\\:border-kids-categories-700\\/75:hover{
  border-color: rgba(153, 84, 36, 0.75);
}

.hover\\:border-kids-categories-700\\/80:hover{
  border-color: rgba(153, 84, 36, 0.8);
}

.hover\\:border-kids-categories-700\\/85:hover{
  border-color: rgba(153, 84, 36, 0.85);
}

.hover\\:border-kids-categories-700\\/90:hover{
  border-color: rgba(153, 84, 36, 0.9);
}

.hover\\:border-kids-categories-700\\/95:hover{
  border-color: rgba(153, 84, 36, 0.95);
}

.hover\\:border-kids-categories-800:hover{
  --tw-border-opacity: 1;
  border-color: rgba(126, 67, 34, 1);
  border-color: rgba(126, 67, 34, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-categories-800\\/0:hover{
  border-color: rgba(126, 67, 34, 0);
}

.hover\\:border-kids-categories-800\\/10:hover{
  border-color: rgba(126, 67, 34, 0.1);
}

.hover\\:border-kids-categories-800\\/100:hover{
  border-color: rgb(126, 67, 34);
}

.hover\\:border-kids-categories-800\\/15:hover{
  border-color: rgba(126, 67, 34, 0.15);
}

.hover\\:border-kids-categories-800\\/20:hover{
  border-color: rgba(126, 67, 34, 0.2);
}

.hover\\:border-kids-categories-800\\/25:hover{
  border-color: rgba(126, 67, 34, 0.25);
}

.hover\\:border-kids-categories-800\\/30:hover{
  border-color: rgba(126, 67, 34, 0.3);
}

.hover\\:border-kids-categories-800\\/35:hover{
  border-color: rgba(126, 67, 34, 0.35);
}

.hover\\:border-kids-categories-800\\/40:hover{
  border-color: rgba(126, 67, 34, 0.4);
}

.hover\\:border-kids-categories-800\\/45:hover{
  border-color: rgba(126, 67, 34, 0.45);
}

.hover\\:border-kids-categories-800\\/5:hover{
  border-color: rgba(126, 67, 34, 0.05);
}

.hover\\:border-kids-categories-800\\/50:hover{
  border-color: rgba(126, 67, 34, 0.5);
}

.hover\\:border-kids-categories-800\\/55:hover{
  border-color: rgba(126, 67, 34, 0.55);
}

.hover\\:border-kids-categories-800\\/60:hover{
  border-color: rgba(126, 67, 34, 0.6);
}

.hover\\:border-kids-categories-800\\/65:hover{
  border-color: rgba(126, 67, 34, 0.65);
}

.hover\\:border-kids-categories-800\\/70:hover{
  border-color: rgba(126, 67, 34, 0.7);
}

.hover\\:border-kids-categories-800\\/75:hover{
  border-color: rgba(126, 67, 34, 0.75);
}

.hover\\:border-kids-categories-800\\/80:hover{
  border-color: rgba(126, 67, 34, 0.8);
}

.hover\\:border-kids-categories-800\\/85:hover{
  border-color: rgba(126, 67, 34, 0.85);
}

.hover\\:border-kids-categories-800\\/90:hover{
  border-color: rgba(126, 67, 34, 0.9);
}

.hover\\:border-kids-categories-800\\/95:hover{
  border-color: rgba(126, 67, 34, 0.95);
}

.hover\\:border-kids-categories-900:hover{
  --tw-border-opacity: 1;
  border-color: rgba(104, 56, 31, 1);
  border-color: rgba(104, 56, 31, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-categories-900\\/0:hover{
  border-color: rgba(104, 56, 31, 0);
}

.hover\\:border-kids-categories-900\\/10:hover{
  border-color: rgba(104, 56, 31, 0.1);
}

.hover\\:border-kids-categories-900\\/100:hover{
  border-color: rgb(104, 56, 31);
}

.hover\\:border-kids-categories-900\\/15:hover{
  border-color: rgba(104, 56, 31, 0.15);
}

.hover\\:border-kids-categories-900\\/20:hover{
  border-color: rgba(104, 56, 31, 0.2);
}

.hover\\:border-kids-categories-900\\/25:hover{
  border-color: rgba(104, 56, 31, 0.25);
}

.hover\\:border-kids-categories-900\\/30:hover{
  border-color: rgba(104, 56, 31, 0.3);
}

.hover\\:border-kids-categories-900\\/35:hover{
  border-color: rgba(104, 56, 31, 0.35);
}

.hover\\:border-kids-categories-900\\/40:hover{
  border-color: rgba(104, 56, 31, 0.4);
}

.hover\\:border-kids-categories-900\\/45:hover{
  border-color: rgba(104, 56, 31, 0.45);
}

.hover\\:border-kids-categories-900\\/5:hover{
  border-color: rgba(104, 56, 31, 0.05);
}

.hover\\:border-kids-categories-900\\/50:hover{
  border-color: rgba(104, 56, 31, 0.5);
}

.hover\\:border-kids-categories-900\\/55:hover{
  border-color: rgba(104, 56, 31, 0.55);
}

.hover\\:border-kids-categories-900\\/60:hover{
  border-color: rgba(104, 56, 31, 0.6);
}

.hover\\:border-kids-categories-900\\/65:hover{
  border-color: rgba(104, 56, 31, 0.65);
}

.hover\\:border-kids-categories-900\\/70:hover{
  border-color: rgba(104, 56, 31, 0.7);
}

.hover\\:border-kids-categories-900\\/75:hover{
  border-color: rgba(104, 56, 31, 0.75);
}

.hover\\:border-kids-categories-900\\/80:hover{
  border-color: rgba(104, 56, 31, 0.8);
}

.hover\\:border-kids-categories-900\\/85:hover{
  border-color: rgba(104, 56, 31, 0.85);
}

.hover\\:border-kids-categories-900\\/90:hover{
  border-color: rgba(104, 56, 31, 0.9);
}

.hover\\:border-kids-categories-900\\/95:hover{
  border-color: rgba(104, 56, 31, 0.95);
}

.hover\\:border-kids-dictionary-500:hover{
  --tw-border-opacity: 1;
  border-color: rgba(44, 135, 109, 1);
  border-color: rgba(44, 135, 109, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-dictionary-500\\/0:hover{
  border-color: rgba(44, 135, 109, 0);
}

.hover\\:border-kids-dictionary-500\\/10:hover{
  border-color: rgba(44, 135, 109, 0.1);
}

.hover\\:border-kids-dictionary-500\\/100:hover{
  border-color: rgb(44, 135, 109);
}

.hover\\:border-kids-dictionary-500\\/15:hover{
  border-color: rgba(44, 135, 109, 0.15);
}

.hover\\:border-kids-dictionary-500\\/20:hover{
  border-color: rgba(44, 135, 109, 0.2);
}

.hover\\:border-kids-dictionary-500\\/25:hover{
  border-color: rgba(44, 135, 109, 0.25);
}

.hover\\:border-kids-dictionary-500\\/30:hover{
  border-color: rgba(44, 135, 109, 0.3);
}

.hover\\:border-kids-dictionary-500\\/35:hover{
  border-color: rgba(44, 135, 109, 0.35);
}

.hover\\:border-kids-dictionary-500\\/40:hover{
  border-color: rgba(44, 135, 109, 0.4);
}

.hover\\:border-kids-dictionary-500\\/45:hover{
  border-color: rgba(44, 135, 109, 0.45);
}

.hover\\:border-kids-dictionary-500\\/5:hover{
  border-color: rgba(44, 135, 109, 0.05);
}

.hover\\:border-kids-dictionary-500\\/50:hover{
  border-color: rgba(44, 135, 109, 0.5);
}

.hover\\:border-kids-dictionary-500\\/55:hover{
  border-color: rgba(44, 135, 109, 0.55);
}

.hover\\:border-kids-dictionary-500\\/60:hover{
  border-color: rgba(44, 135, 109, 0.6);
}

.hover\\:border-kids-dictionary-500\\/65:hover{
  border-color: rgba(44, 135, 109, 0.65);
}

.hover\\:border-kids-dictionary-500\\/70:hover{
  border-color: rgba(44, 135, 109, 0.7);
}

.hover\\:border-kids-dictionary-500\\/75:hover{
  border-color: rgba(44, 135, 109, 0.75);
}

.hover\\:border-kids-dictionary-500\\/80:hover{
  border-color: rgba(44, 135, 109, 0.8);
}

.hover\\:border-kids-dictionary-500\\/85:hover{
  border-color: rgba(44, 135, 109, 0.85);
}

.hover\\:border-kids-dictionary-500\\/90:hover{
  border-color: rgba(44, 135, 109, 0.9);
}

.hover\\:border-kids-dictionary-500\\/95:hover{
  border-color: rgba(44, 135, 109, 0.95);
}

.hover\\:border-kids-dictionary-600:hover{
  --tw-border-opacity: 1;
  border-color: rgba(34, 121, 98, 1);
  border-color: rgba(34, 121, 98, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-dictionary-600\\/0:hover{
  border-color: rgba(34, 121, 98, 0);
}

.hover\\:border-kids-dictionary-600\\/10:hover{
  border-color: rgba(34, 121, 98, 0.1);
}

.hover\\:border-kids-dictionary-600\\/100:hover{
  border-color: rgb(34, 121, 98);
}

.hover\\:border-kids-dictionary-600\\/15:hover{
  border-color: rgba(34, 121, 98, 0.15);
}

.hover\\:border-kids-dictionary-600\\/20:hover{
  border-color: rgba(34, 121, 98, 0.2);
}

.hover\\:border-kids-dictionary-600\\/25:hover{
  border-color: rgba(34, 121, 98, 0.25);
}

.hover\\:border-kids-dictionary-600\\/30:hover{
  border-color: rgba(34, 121, 98, 0.3);
}

.hover\\:border-kids-dictionary-600\\/35:hover{
  border-color: rgba(34, 121, 98, 0.35);
}

.hover\\:border-kids-dictionary-600\\/40:hover{
  border-color: rgba(34, 121, 98, 0.4);
}

.hover\\:border-kids-dictionary-600\\/45:hover{
  border-color: rgba(34, 121, 98, 0.45);
}

.hover\\:border-kids-dictionary-600\\/5:hover{
  border-color: rgba(34, 121, 98, 0.05);
}

.hover\\:border-kids-dictionary-600\\/50:hover{
  border-color: rgba(34, 121, 98, 0.5);
}

.hover\\:border-kids-dictionary-600\\/55:hover{
  border-color: rgba(34, 121, 98, 0.55);
}

.hover\\:border-kids-dictionary-600\\/60:hover{
  border-color: rgba(34, 121, 98, 0.6);
}

.hover\\:border-kids-dictionary-600\\/65:hover{
  border-color: rgba(34, 121, 98, 0.65);
}

.hover\\:border-kids-dictionary-600\\/70:hover{
  border-color: rgba(34, 121, 98, 0.7);
}

.hover\\:border-kids-dictionary-600\\/75:hover{
  border-color: rgba(34, 121, 98, 0.75);
}

.hover\\:border-kids-dictionary-600\\/80:hover{
  border-color: rgba(34, 121, 98, 0.8);
}

.hover\\:border-kids-dictionary-600\\/85:hover{
  border-color: rgba(34, 121, 98, 0.85);
}

.hover\\:border-kids-dictionary-600\\/90:hover{
  border-color: rgba(34, 121, 98, 0.9);
}

.hover\\:border-kids-dictionary-600\\/95:hover{
  border-color: rgba(34, 121, 98, 0.95);
}

.hover\\:border-kids-dictionary-700:hover{
  --tw-border-opacity: 1;
  border-color: rgba(27, 97, 80, 1);
  border-color: rgba(27, 97, 80, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-dictionary-700\\/0:hover{
  border-color: rgba(27, 97, 80, 0);
}

.hover\\:border-kids-dictionary-700\\/10:hover{
  border-color: rgba(27, 97, 80, 0.1);
}

.hover\\:border-kids-dictionary-700\\/100:hover{
  border-color: rgb(27, 97, 80);
}

.hover\\:border-kids-dictionary-700\\/15:hover{
  border-color: rgba(27, 97, 80, 0.15);
}

.hover\\:border-kids-dictionary-700\\/20:hover{
  border-color: rgba(27, 97, 80, 0.2);
}

.hover\\:border-kids-dictionary-700\\/25:hover{
  border-color: rgba(27, 97, 80, 0.25);
}

.hover\\:border-kids-dictionary-700\\/30:hover{
  border-color: rgba(27, 97, 80, 0.3);
}

.hover\\:border-kids-dictionary-700\\/35:hover{
  border-color: rgba(27, 97, 80, 0.35);
}

.hover\\:border-kids-dictionary-700\\/40:hover{
  border-color: rgba(27, 97, 80, 0.4);
}

.hover\\:border-kids-dictionary-700\\/45:hover{
  border-color: rgba(27, 97, 80, 0.45);
}

.hover\\:border-kids-dictionary-700\\/5:hover{
  border-color: rgba(27, 97, 80, 0.05);
}

.hover\\:border-kids-dictionary-700\\/50:hover{
  border-color: rgba(27, 97, 80, 0.5);
}

.hover\\:border-kids-dictionary-700\\/55:hover{
  border-color: rgba(27, 97, 80, 0.55);
}

.hover\\:border-kids-dictionary-700\\/60:hover{
  border-color: rgba(27, 97, 80, 0.6);
}

.hover\\:border-kids-dictionary-700\\/65:hover{
  border-color: rgba(27, 97, 80, 0.65);
}

.hover\\:border-kids-dictionary-700\\/70:hover{
  border-color: rgba(27, 97, 80, 0.7);
}

.hover\\:border-kids-dictionary-700\\/75:hover{
  border-color: rgba(27, 97, 80, 0.75);
}

.hover\\:border-kids-dictionary-700\\/80:hover{
  border-color: rgba(27, 97, 80, 0.8);
}

.hover\\:border-kids-dictionary-700\\/85:hover{
  border-color: rgba(27, 97, 80, 0.85);
}

.hover\\:border-kids-dictionary-700\\/90:hover{
  border-color: rgba(27, 97, 80, 0.9);
}

.hover\\:border-kids-dictionary-700\\/95:hover{
  border-color: rgba(27, 97, 80, 0.95);
}

.hover\\:border-kids-dictionary-800:hover{
  --tw-border-opacity: 1;
  border-color: rgba(24, 77, 64, 1);
  border-color: rgba(24, 77, 64, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-dictionary-800\\/0:hover{
  border-color: rgba(24, 77, 64, 0);
}

.hover\\:border-kids-dictionary-800\\/10:hover{
  border-color: rgba(24, 77, 64, 0.1);
}

.hover\\:border-kids-dictionary-800\\/100:hover{
  border-color: rgb(24, 77, 64);
}

.hover\\:border-kids-dictionary-800\\/15:hover{
  border-color: rgba(24, 77, 64, 0.15);
}

.hover\\:border-kids-dictionary-800\\/20:hover{
  border-color: rgba(24, 77, 64, 0.2);
}

.hover\\:border-kids-dictionary-800\\/25:hover{
  border-color: rgba(24, 77, 64, 0.25);
}

.hover\\:border-kids-dictionary-800\\/30:hover{
  border-color: rgba(24, 77, 64, 0.3);
}

.hover\\:border-kids-dictionary-800\\/35:hover{
  border-color: rgba(24, 77, 64, 0.35);
}

.hover\\:border-kids-dictionary-800\\/40:hover{
  border-color: rgba(24, 77, 64, 0.4);
}

.hover\\:border-kids-dictionary-800\\/45:hover{
  border-color: rgba(24, 77, 64, 0.45);
}

.hover\\:border-kids-dictionary-800\\/5:hover{
  border-color: rgba(24, 77, 64, 0.05);
}

.hover\\:border-kids-dictionary-800\\/50:hover{
  border-color: rgba(24, 77, 64, 0.5);
}

.hover\\:border-kids-dictionary-800\\/55:hover{
  border-color: rgba(24, 77, 64, 0.55);
}

.hover\\:border-kids-dictionary-800\\/60:hover{
  border-color: rgba(24, 77, 64, 0.6);
}

.hover\\:border-kids-dictionary-800\\/65:hover{
  border-color: rgba(24, 77, 64, 0.65);
}

.hover\\:border-kids-dictionary-800\\/70:hover{
  border-color: rgba(24, 77, 64, 0.7);
}

.hover\\:border-kids-dictionary-800\\/75:hover{
  border-color: rgba(24, 77, 64, 0.75);
}

.hover\\:border-kids-dictionary-800\\/80:hover{
  border-color: rgba(24, 77, 64, 0.8);
}

.hover\\:border-kids-dictionary-800\\/85:hover{
  border-color: rgba(24, 77, 64, 0.85);
}

.hover\\:border-kids-dictionary-800\\/90:hover{
  border-color: rgba(24, 77, 64, 0.9);
}

.hover\\:border-kids-dictionary-800\\/95:hover{
  border-color: rgba(24, 77, 64, 0.95);
}

.hover\\:border-kids-dictionary-900:hover{
  --tw-border-opacity: 1;
  border-color: rgba(20, 64, 54, 1);
  border-color: rgba(20, 64, 54, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-dictionary-900\\/0:hover{
  border-color: rgba(20, 64, 54, 0);
}

.hover\\:border-kids-dictionary-900\\/10:hover{
  border-color: rgba(20, 64, 54, 0.1);
}

.hover\\:border-kids-dictionary-900\\/100:hover{
  border-color: rgb(20, 64, 54);
}

.hover\\:border-kids-dictionary-900\\/15:hover{
  border-color: rgba(20, 64, 54, 0.15);
}

.hover\\:border-kids-dictionary-900\\/20:hover{
  border-color: rgba(20, 64, 54, 0.2);
}

.hover\\:border-kids-dictionary-900\\/25:hover{
  border-color: rgba(20, 64, 54, 0.25);
}

.hover\\:border-kids-dictionary-900\\/30:hover{
  border-color: rgba(20, 64, 54, 0.3);
}

.hover\\:border-kids-dictionary-900\\/35:hover{
  border-color: rgba(20, 64, 54, 0.35);
}

.hover\\:border-kids-dictionary-900\\/40:hover{
  border-color: rgba(20, 64, 54, 0.4);
}

.hover\\:border-kids-dictionary-900\\/45:hover{
  border-color: rgba(20, 64, 54, 0.45);
}

.hover\\:border-kids-dictionary-900\\/5:hover{
  border-color: rgba(20, 64, 54, 0.05);
}

.hover\\:border-kids-dictionary-900\\/50:hover{
  border-color: rgba(20, 64, 54, 0.5);
}

.hover\\:border-kids-dictionary-900\\/55:hover{
  border-color: rgba(20, 64, 54, 0.55);
}

.hover\\:border-kids-dictionary-900\\/60:hover{
  border-color: rgba(20, 64, 54, 0.6);
}

.hover\\:border-kids-dictionary-900\\/65:hover{
  border-color: rgba(20, 64, 54, 0.65);
}

.hover\\:border-kids-dictionary-900\\/70:hover{
  border-color: rgba(20, 64, 54, 0.7);
}

.hover\\:border-kids-dictionary-900\\/75:hover{
  border-color: rgba(20, 64, 54, 0.75);
}

.hover\\:border-kids-dictionary-900\\/80:hover{
  border-color: rgba(20, 64, 54, 0.8);
}

.hover\\:border-kids-dictionary-900\\/85:hover{
  border-color: rgba(20, 64, 54, 0.85);
}

.hover\\:border-kids-dictionary-900\\/90:hover{
  border-color: rgba(20, 64, 54, 0.9);
}

.hover\\:border-kids-dictionary-900\\/95:hover{
  border-color: rgba(20, 64, 54, 0.95);
}

.hover\\:border-kids-games-500:hover{
  --tw-border-opacity: 1;
  border-color: rgba(81, 59, 86, 1);
  border-color: rgba(81, 59, 86, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-games-500\\/0:hover{
  border-color: rgba(81, 59, 86, 0);
}

.hover\\:border-kids-games-500\\/10:hover{
  border-color: rgba(81, 59, 86, 0.1);
}

.hover\\:border-kids-games-500\\/100:hover{
  border-color: rgb(81, 59, 86);
}

.hover\\:border-kids-games-500\\/15:hover{
  border-color: rgba(81, 59, 86, 0.15);
}

.hover\\:border-kids-games-500\\/20:hover{
  border-color: rgba(81, 59, 86, 0.2);
}

.hover\\:border-kids-games-500\\/25:hover{
  border-color: rgba(81, 59, 86, 0.25);
}

.hover\\:border-kids-games-500\\/30:hover{
  border-color: rgba(81, 59, 86, 0.3);
}

.hover\\:border-kids-games-500\\/35:hover{
  border-color: rgba(81, 59, 86, 0.35);
}

.hover\\:border-kids-games-500\\/40:hover{
  border-color: rgba(81, 59, 86, 0.4);
}

.hover\\:border-kids-games-500\\/45:hover{
  border-color: rgba(81, 59, 86, 0.45);
}

.hover\\:border-kids-games-500\\/5:hover{
  border-color: rgba(81, 59, 86, 0.05);
}

.hover\\:border-kids-games-500\\/50:hover{
  border-color: rgba(81, 59, 86, 0.5);
}

.hover\\:border-kids-games-500\\/55:hover{
  border-color: rgba(81, 59, 86, 0.55);
}

.hover\\:border-kids-games-500\\/60:hover{
  border-color: rgba(81, 59, 86, 0.6);
}

.hover\\:border-kids-games-500\\/65:hover{
  border-color: rgba(81, 59, 86, 0.65);
}

.hover\\:border-kids-games-500\\/70:hover{
  border-color: rgba(81, 59, 86, 0.7);
}

.hover\\:border-kids-games-500\\/75:hover{
  border-color: rgba(81, 59, 86, 0.75);
}

.hover\\:border-kids-games-500\\/80:hover{
  border-color: rgba(81, 59, 86, 0.8);
}

.hover\\:border-kids-games-500\\/85:hover{
  border-color: rgba(81, 59, 86, 0.85);
}

.hover\\:border-kids-games-500\\/90:hover{
  border-color: rgba(81, 59, 86, 0.9);
}

.hover\\:border-kids-games-500\\/95:hover{
  border-color: rgba(81, 59, 86, 0.95);
}

.hover\\:border-kids-games-900:hover{
  --tw-border-opacity: 1;
  border-color: rgba(57, 41, 60, 1);
  border-color: rgba(57, 41, 60, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-games-900\\/0:hover{
  border-color: rgba(57, 41, 60, 0);
}

.hover\\:border-kids-games-900\\/10:hover{
  border-color: rgba(57, 41, 60, 0.1);
}

.hover\\:border-kids-games-900\\/100:hover{
  border-color: rgb(57, 41, 60);
}

.hover\\:border-kids-games-900\\/15:hover{
  border-color: rgba(57, 41, 60, 0.15);
}

.hover\\:border-kids-games-900\\/20:hover{
  border-color: rgba(57, 41, 60, 0.2);
}

.hover\\:border-kids-games-900\\/25:hover{
  border-color: rgba(57, 41, 60, 0.25);
}

.hover\\:border-kids-games-900\\/30:hover{
  border-color: rgba(57, 41, 60, 0.3);
}

.hover\\:border-kids-games-900\\/35:hover{
  border-color: rgba(57, 41, 60, 0.35);
}

.hover\\:border-kids-games-900\\/40:hover{
  border-color: rgba(57, 41, 60, 0.4);
}

.hover\\:border-kids-games-900\\/45:hover{
  border-color: rgba(57, 41, 60, 0.45);
}

.hover\\:border-kids-games-900\\/5:hover{
  border-color: rgba(57, 41, 60, 0.05);
}

.hover\\:border-kids-games-900\\/50:hover{
  border-color: rgba(57, 41, 60, 0.5);
}

.hover\\:border-kids-games-900\\/55:hover{
  border-color: rgba(57, 41, 60, 0.55);
}

.hover\\:border-kids-games-900\\/60:hover{
  border-color: rgba(57, 41, 60, 0.6);
}

.hover\\:border-kids-games-900\\/65:hover{
  border-color: rgba(57, 41, 60, 0.65);
}

.hover\\:border-kids-games-900\\/70:hover{
  border-color: rgba(57, 41, 60, 0.7);
}

.hover\\:border-kids-games-900\\/75:hover{
  border-color: rgba(57, 41, 60, 0.75);
}

.hover\\:border-kids-games-900\\/80:hover{
  border-color: rgba(57, 41, 60, 0.8);
}

.hover\\:border-kids-games-900\\/85:hover{
  border-color: rgba(57, 41, 60, 0.85);
}

.hover\\:border-kids-games-900\\/90:hover{
  border-color: rgba(57, 41, 60, 0.9);
}

.hover\\:border-kids-games-900\\/95:hover{
  border-color: rgba(57, 41, 60, 0.95);
}

.hover\\:border-kids-songs-500:hover{
  --tw-border-opacity: 1;
  border-color: rgba(131, 0, 66, 1);
  border-color: rgba(131, 0, 66, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-songs-500\\/0:hover{
  border-color: rgba(131, 0, 66, 0);
}

.hover\\:border-kids-songs-500\\/10:hover{
  border-color: rgba(131, 0, 66, 0.1);
}

.hover\\:border-kids-songs-500\\/100:hover{
  border-color: rgb(131, 0, 66);
}

.hover\\:border-kids-songs-500\\/15:hover{
  border-color: rgba(131, 0, 66, 0.15);
}

.hover\\:border-kids-songs-500\\/20:hover{
  border-color: rgba(131, 0, 66, 0.2);
}

.hover\\:border-kids-songs-500\\/25:hover{
  border-color: rgba(131, 0, 66, 0.25);
}

.hover\\:border-kids-songs-500\\/30:hover{
  border-color: rgba(131, 0, 66, 0.3);
}

.hover\\:border-kids-songs-500\\/35:hover{
  border-color: rgba(131, 0, 66, 0.35);
}

.hover\\:border-kids-songs-500\\/40:hover{
  border-color: rgba(131, 0, 66, 0.4);
}

.hover\\:border-kids-songs-500\\/45:hover{
  border-color: rgba(131, 0, 66, 0.45);
}

.hover\\:border-kids-songs-500\\/5:hover{
  border-color: rgba(131, 0, 66, 0.05);
}

.hover\\:border-kids-songs-500\\/50:hover{
  border-color: rgba(131, 0, 66, 0.5);
}

.hover\\:border-kids-songs-500\\/55:hover{
  border-color: rgba(131, 0, 66, 0.55);
}

.hover\\:border-kids-songs-500\\/60:hover{
  border-color: rgba(131, 0, 66, 0.6);
}

.hover\\:border-kids-songs-500\\/65:hover{
  border-color: rgba(131, 0, 66, 0.65);
}

.hover\\:border-kids-songs-500\\/70:hover{
  border-color: rgba(131, 0, 66, 0.7);
}

.hover\\:border-kids-songs-500\\/75:hover{
  border-color: rgba(131, 0, 66, 0.75);
}

.hover\\:border-kids-songs-500\\/80:hover{
  border-color: rgba(131, 0, 66, 0.8);
}

.hover\\:border-kids-songs-500\\/85:hover{
  border-color: rgba(131, 0, 66, 0.85);
}

.hover\\:border-kids-songs-500\\/90:hover{
  border-color: rgba(131, 0, 66, 0.9);
}

.hover\\:border-kids-songs-500\\/95:hover{
  border-color: rgba(131, 0, 66, 0.95);
}

.hover\\:border-kids-songs-900:hover{
  --tw-border-opacity: 1;
  border-color: rgba(92, 0, 46, 1);
  border-color: rgba(92, 0, 46, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-songs-900\\/0:hover{
  border-color: rgba(92, 0, 46, 0);
}

.hover\\:border-kids-songs-900\\/10:hover{
  border-color: rgba(92, 0, 46, 0.1);
}

.hover\\:border-kids-songs-900\\/100:hover{
  border-color: rgb(92, 0, 46);
}

.hover\\:border-kids-songs-900\\/15:hover{
  border-color: rgba(92, 0, 46, 0.15);
}

.hover\\:border-kids-songs-900\\/20:hover{
  border-color: rgba(92, 0, 46, 0.2);
}

.hover\\:border-kids-songs-900\\/25:hover{
  border-color: rgba(92, 0, 46, 0.25);
}

.hover\\:border-kids-songs-900\\/30:hover{
  border-color: rgba(92, 0, 46, 0.3);
}

.hover\\:border-kids-songs-900\\/35:hover{
  border-color: rgba(92, 0, 46, 0.35);
}

.hover\\:border-kids-songs-900\\/40:hover{
  border-color: rgba(92, 0, 46, 0.4);
}

.hover\\:border-kids-songs-900\\/45:hover{
  border-color: rgba(92, 0, 46, 0.45);
}

.hover\\:border-kids-songs-900\\/5:hover{
  border-color: rgba(92, 0, 46, 0.05);
}

.hover\\:border-kids-songs-900\\/50:hover{
  border-color: rgba(92, 0, 46, 0.5);
}

.hover\\:border-kids-songs-900\\/55:hover{
  border-color: rgba(92, 0, 46, 0.55);
}

.hover\\:border-kids-songs-900\\/60:hover{
  border-color: rgba(92, 0, 46, 0.6);
}

.hover\\:border-kids-songs-900\\/65:hover{
  border-color: rgba(92, 0, 46, 0.65);
}

.hover\\:border-kids-songs-900\\/70:hover{
  border-color: rgba(92, 0, 46, 0.7);
}

.hover\\:border-kids-songs-900\\/75:hover{
  border-color: rgba(92, 0, 46, 0.75);
}

.hover\\:border-kids-songs-900\\/80:hover{
  border-color: rgba(92, 0, 46, 0.8);
}

.hover\\:border-kids-songs-900\\/85:hover{
  border-color: rgba(92, 0, 46, 0.85);
}

.hover\\:border-kids-songs-900\\/90:hover{
  border-color: rgba(92, 0, 46, 0.9);
}

.hover\\:border-kids-songs-900\\/95:hover{
  border-color: rgba(92, 0, 46, 0.95);
}

.hover\\:border-kids-stories-500:hover{
  --tw-border-opacity: 1;
  border-color: rgba(233, 196, 106, 1);
  border-color: rgba(233, 196, 106, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-stories-500\\/0:hover{
  border-color: rgba(233, 196, 106, 0);
}

.hover\\:border-kids-stories-500\\/10:hover{
  border-color: rgba(233, 196, 106, 0.1);
}

.hover\\:border-kids-stories-500\\/100:hover{
  border-color: rgb(233, 196, 106);
}

.hover\\:border-kids-stories-500\\/15:hover{
  border-color: rgba(233, 196, 106, 0.15);
}

.hover\\:border-kids-stories-500\\/20:hover{
  border-color: rgba(233, 196, 106, 0.2);
}

.hover\\:border-kids-stories-500\\/25:hover{
  border-color: rgba(233, 196, 106, 0.25);
}

.hover\\:border-kids-stories-500\\/30:hover{
  border-color: rgba(233, 196, 106, 0.3);
}

.hover\\:border-kids-stories-500\\/35:hover{
  border-color: rgba(233, 196, 106, 0.35);
}

.hover\\:border-kids-stories-500\\/40:hover{
  border-color: rgba(233, 196, 106, 0.4);
}

.hover\\:border-kids-stories-500\\/45:hover{
  border-color: rgba(233, 196, 106, 0.45);
}

.hover\\:border-kids-stories-500\\/5:hover{
  border-color: rgba(233, 196, 106, 0.05);
}

.hover\\:border-kids-stories-500\\/50:hover{
  border-color: rgba(233, 196, 106, 0.5);
}

.hover\\:border-kids-stories-500\\/55:hover{
  border-color: rgba(233, 196, 106, 0.55);
}

.hover\\:border-kids-stories-500\\/60:hover{
  border-color: rgba(233, 196, 106, 0.6);
}

.hover\\:border-kids-stories-500\\/65:hover{
  border-color: rgba(233, 196, 106, 0.65);
}

.hover\\:border-kids-stories-500\\/70:hover{
  border-color: rgba(233, 196, 106, 0.7);
}

.hover\\:border-kids-stories-500\\/75:hover{
  border-color: rgba(233, 196, 106, 0.75);
}

.hover\\:border-kids-stories-500\\/80:hover{
  border-color: rgba(233, 196, 106, 0.8);
}

.hover\\:border-kids-stories-500\\/85:hover{
  border-color: rgba(233, 196, 106, 0.85);
}

.hover\\:border-kids-stories-500\\/90:hover{
  border-color: rgba(233, 196, 106, 0.9);
}

.hover\\:border-kids-stories-500\\/95:hover{
  border-color: rgba(233, 196, 106, 0.95);
}

.hover\\:border-kids-stories-900:hover{
  --tw-border-opacity: 1;
  border-color: rgba(163, 137, 74, 1);
  border-color: rgba(163, 137, 74, var(--tw-border-opacity, 1));
}

.hover\\:border-kids-stories-900\\/0:hover{
  border-color: rgba(163, 137, 74, 0);
}

.hover\\:border-kids-stories-900\\/10:hover{
  border-color: rgba(163, 137, 74, 0.1);
}

.hover\\:border-kids-stories-900\\/100:hover{
  border-color: rgb(163, 137, 74);
}

.hover\\:border-kids-stories-900\\/15:hover{
  border-color: rgba(163, 137, 74, 0.15);
}

.hover\\:border-kids-stories-900\\/20:hover{
  border-color: rgba(163, 137, 74, 0.2);
}

.hover\\:border-kids-stories-900\\/25:hover{
  border-color: rgba(163, 137, 74, 0.25);
}

.hover\\:border-kids-stories-900\\/30:hover{
  border-color: rgba(163, 137, 74, 0.3);
}

.hover\\:border-kids-stories-900\\/35:hover{
  border-color: rgba(163, 137, 74, 0.35);
}

.hover\\:border-kids-stories-900\\/40:hover{
  border-color: rgba(163, 137, 74, 0.4);
}

.hover\\:border-kids-stories-900\\/45:hover{
  border-color: rgba(163, 137, 74, 0.45);
}

.hover\\:border-kids-stories-900\\/5:hover{
  border-color: rgba(163, 137, 74, 0.05);
}

.hover\\:border-kids-stories-900\\/50:hover{
  border-color: rgba(163, 137, 74, 0.5);
}

.hover\\:border-kids-stories-900\\/55:hover{
  border-color: rgba(163, 137, 74, 0.55);
}

.hover\\:border-kids-stories-900\\/60:hover{
  border-color: rgba(163, 137, 74, 0.6);
}

.hover\\:border-kids-stories-900\\/65:hover{
  border-color: rgba(163, 137, 74, 0.65);
}

.hover\\:border-kids-stories-900\\/70:hover{
  border-color: rgba(163, 137, 74, 0.7);
}

.hover\\:border-kids-stories-900\\/75:hover{
  border-color: rgba(163, 137, 74, 0.75);
}

.hover\\:border-kids-stories-900\\/80:hover{
  border-color: rgba(163, 137, 74, 0.8);
}

.hover\\:border-kids-stories-900\\/85:hover{
  border-color: rgba(163, 137, 74, 0.85);
}

.hover\\:border-kids-stories-900\\/90:hover{
  border-color: rgba(163, 137, 74, 0.9);
}

.hover\\:border-kids-stories-900\\/95:hover{
  border-color: rgba(163, 137, 74, 0.95);
}

.hover\\:border-ochre-100:hover{
  --tw-border-opacity: 1;
  border-color: rgba(245, 237, 208, 1);
  border-color: rgba(245, 237, 208, var(--tw-border-opacity, 1));
}

.hover\\:border-ochre-100\\/0:hover{
  border-color: rgba(245, 237, 208, 0);
}

.hover\\:border-ochre-100\\/10:hover{
  border-color: rgba(245, 237, 208, 0.1);
}

.hover\\:border-ochre-100\\/100:hover{
  border-color: rgb(245, 237, 208);
}

.hover\\:border-ochre-100\\/15:hover{
  border-color: rgba(245, 237, 208, 0.15);
}

.hover\\:border-ochre-100\\/20:hover{
  border-color: rgba(245, 237, 208, 0.2);
}

.hover\\:border-ochre-100\\/25:hover{
  border-color: rgba(245, 237, 208, 0.25);
}

.hover\\:border-ochre-100\\/30:hover{
  border-color: rgba(245, 237, 208, 0.3);
}

.hover\\:border-ochre-100\\/35:hover{
  border-color: rgba(245, 237, 208, 0.35);
}

.hover\\:border-ochre-100\\/40:hover{
  border-color: rgba(245, 237, 208, 0.4);
}

.hover\\:border-ochre-100\\/45:hover{
  border-color: rgba(245, 237, 208, 0.45);
}

.hover\\:border-ochre-100\\/5:hover{
  border-color: rgba(245, 237, 208, 0.05);
}

.hover\\:border-ochre-100\\/50:hover{
  border-color: rgba(245, 237, 208, 0.5);
}

.hover\\:border-ochre-100\\/55:hover{
  border-color: rgba(245, 237, 208, 0.55);
}

.hover\\:border-ochre-100\\/60:hover{
  border-color: rgba(245, 237, 208, 0.6);
}

.hover\\:border-ochre-100\\/65:hover{
  border-color: rgba(245, 237, 208, 0.65);
}

.hover\\:border-ochre-100\\/70:hover{
  border-color: rgba(245, 237, 208, 0.7);
}

.hover\\:border-ochre-100\\/75:hover{
  border-color: rgba(245, 237, 208, 0.75);
}

.hover\\:border-ochre-100\\/80:hover{
  border-color: rgba(245, 237, 208, 0.8);
}

.hover\\:border-ochre-100\\/85:hover{
  border-color: rgba(245, 237, 208, 0.85);
}

.hover\\:border-ochre-100\\/90:hover{
  border-color: rgba(245, 237, 208, 0.9);
}

.hover\\:border-ochre-100\\/95:hover{
  border-color: rgba(245, 237, 208, 0.95);
}

.hover\\:border-ochre-200:hover{
  --tw-border-opacity: 1;
  border-color: rgba(235, 217, 156, 1);
  border-color: rgba(235, 217, 156, var(--tw-border-opacity, 1));
}

.hover\\:border-ochre-200\\/0:hover{
  border-color: rgba(235, 217, 156, 0);
}

.hover\\:border-ochre-200\\/10:hover{
  border-color: rgba(235, 217, 156, 0.1);
}

.hover\\:border-ochre-200\\/100:hover{
  border-color: rgb(235, 217, 156);
}

.hover\\:border-ochre-200\\/15:hover{
  border-color: rgba(235, 217, 156, 0.15);
}

.hover\\:border-ochre-200\\/20:hover{
  border-color: rgba(235, 217, 156, 0.2);
}

.hover\\:border-ochre-200\\/25:hover{
  border-color: rgba(235, 217, 156, 0.25);
}

.hover\\:border-ochre-200\\/30:hover{
  border-color: rgba(235, 217, 156, 0.3);
}

.hover\\:border-ochre-200\\/35:hover{
  border-color: rgba(235, 217, 156, 0.35);
}

.hover\\:border-ochre-200\\/40:hover{
  border-color: rgba(235, 217, 156, 0.4);
}

.hover\\:border-ochre-200\\/45:hover{
  border-color: rgba(235, 217, 156, 0.45);
}

.hover\\:border-ochre-200\\/5:hover{
  border-color: rgba(235, 217, 156, 0.05);
}

.hover\\:border-ochre-200\\/50:hover{
  border-color: rgba(235, 217, 156, 0.5);
}

.hover\\:border-ochre-200\\/55:hover{
  border-color: rgba(235, 217, 156, 0.55);
}

.hover\\:border-ochre-200\\/60:hover{
  border-color: rgba(235, 217, 156, 0.6);
}

.hover\\:border-ochre-200\\/65:hover{
  border-color: rgba(235, 217, 156, 0.65);
}

.hover\\:border-ochre-200\\/70:hover{
  border-color: rgba(235, 217, 156, 0.7);
}

.hover\\:border-ochre-200\\/75:hover{
  border-color: rgba(235, 217, 156, 0.75);
}

.hover\\:border-ochre-200\\/80:hover{
  border-color: rgba(235, 217, 156, 0.8);
}

.hover\\:border-ochre-200\\/85:hover{
  border-color: rgba(235, 217, 156, 0.85);
}

.hover\\:border-ochre-200\\/90:hover{
  border-color: rgba(235, 217, 156, 0.9);
}

.hover\\:border-ochre-200\\/95:hover{
  border-color: rgba(235, 217, 156, 0.95);
}

.hover\\:border-ochre-300:hover{
  --tw-border-opacity: 1;
  border-color: rgba(225, 194, 104, 1);
  border-color: rgba(225, 194, 104, var(--tw-border-opacity, 1));
}

.hover\\:border-ochre-300\\/0:hover{
  border-color: rgba(225, 194, 104, 0);
}

.hover\\:border-ochre-300\\/10:hover{
  border-color: rgba(225, 194, 104, 0.1);
}

.hover\\:border-ochre-300\\/100:hover{
  border-color: rgb(225, 194, 104);
}

.hover\\:border-ochre-300\\/15:hover{
  border-color: rgba(225, 194, 104, 0.15);
}

.hover\\:border-ochre-300\\/20:hover{
  border-color: rgba(225, 194, 104, 0.2);
}

.hover\\:border-ochre-300\\/25:hover{
  border-color: rgba(225, 194, 104, 0.25);
}

.hover\\:border-ochre-300\\/30:hover{
  border-color: rgba(225, 194, 104, 0.3);
}

.hover\\:border-ochre-300\\/35:hover{
  border-color: rgba(225, 194, 104, 0.35);
}

.hover\\:border-ochre-300\\/40:hover{
  border-color: rgba(225, 194, 104, 0.4);
}

.hover\\:border-ochre-300\\/45:hover{
  border-color: rgba(225, 194, 104, 0.45);
}

.hover\\:border-ochre-300\\/5:hover{
  border-color: rgba(225, 194, 104, 0.05);
}

.hover\\:border-ochre-300\\/50:hover{
  border-color: rgba(225, 194, 104, 0.5);
}

.hover\\:border-ochre-300\\/55:hover{
  border-color: rgba(225, 194, 104, 0.55);
}

.hover\\:border-ochre-300\\/60:hover{
  border-color: rgba(225, 194, 104, 0.6);
}

.hover\\:border-ochre-300\\/65:hover{
  border-color: rgba(225, 194, 104, 0.65);
}

.hover\\:border-ochre-300\\/70:hover{
  border-color: rgba(225, 194, 104, 0.7);
}

.hover\\:border-ochre-300\\/75:hover{
  border-color: rgba(225, 194, 104, 0.75);
}

.hover\\:border-ochre-300\\/80:hover{
  border-color: rgba(225, 194, 104, 0.8);
}

.hover\\:border-ochre-300\\/85:hover{
  border-color: rgba(225, 194, 104, 0.85);
}

.hover\\:border-ochre-300\\/90:hover{
  border-color: rgba(225, 194, 104, 0.9);
}

.hover\\:border-ochre-300\\/95:hover{
  border-color: rgba(225, 194, 104, 0.95);
}

.hover\\:border-ochre-400:hover{
  --tw-border-opacity: 1;
  border-color: rgba(218, 173, 69, 1);
  border-color: rgba(218, 173, 69, var(--tw-border-opacity, 1));
}

.hover\\:border-ochre-400\\/0:hover{
  border-color: rgba(218, 173, 69, 0);
}

.hover\\:border-ochre-400\\/10:hover{
  border-color: rgba(218, 173, 69, 0.1);
}

.hover\\:border-ochre-400\\/100:hover{
  border-color: rgb(218, 173, 69);
}

.hover\\:border-ochre-400\\/15:hover{
  border-color: rgba(218, 173, 69, 0.15);
}

.hover\\:border-ochre-400\\/20:hover{
  border-color: rgba(218, 173, 69, 0.2);
}

.hover\\:border-ochre-400\\/25:hover{
  border-color: rgba(218, 173, 69, 0.25);
}

.hover\\:border-ochre-400\\/30:hover{
  border-color: rgba(218, 173, 69, 0.3);
}

.hover\\:border-ochre-400\\/35:hover{
  border-color: rgba(218, 173, 69, 0.35);
}

.hover\\:border-ochre-400\\/40:hover{
  border-color: rgba(218, 173, 69, 0.4);
}

.hover\\:border-ochre-400\\/45:hover{
  border-color: rgba(218, 173, 69, 0.45);
}

.hover\\:border-ochre-400\\/5:hover{
  border-color: rgba(218, 173, 69, 0.05);
}

.hover\\:border-ochre-400\\/50:hover{
  border-color: rgba(218, 173, 69, 0.5);
}

.hover\\:border-ochre-400\\/55:hover{
  border-color: rgba(218, 173, 69, 0.55);
}

.hover\\:border-ochre-400\\/60:hover{
  border-color: rgba(218, 173, 69, 0.6);
}

.hover\\:border-ochre-400\\/65:hover{
  border-color: rgba(218, 173, 69, 0.65);
}

.hover\\:border-ochre-400\\/70:hover{
  border-color: rgba(218, 173, 69, 0.7);
}

.hover\\:border-ochre-400\\/75:hover{
  border-color: rgba(218, 173, 69, 0.75);
}

.hover\\:border-ochre-400\\/80:hover{
  border-color: rgba(218, 173, 69, 0.8);
}

.hover\\:border-ochre-400\\/85:hover{
  border-color: rgba(218, 173, 69, 0.85);
}

.hover\\:border-ochre-400\\/90:hover{
  border-color: rgba(218, 173, 69, 0.9);
}

.hover\\:border-ochre-400\\/95:hover{
  border-color: rgba(218, 173, 69, 0.95);
}

.hover\\:border-ochre-500:hover{
  --tw-border-opacity: 1;
  border-color: rgba(209, 145, 47, 1);
  border-color: rgba(209, 145, 47, var(--tw-border-opacity, 1));
}

.hover\\:border-ochre-500\\/0:hover{
  border-color: rgba(209, 145, 47, 0);
}

.hover\\:border-ochre-500\\/10:hover{
  border-color: rgba(209, 145, 47, 0.1);
}

.hover\\:border-ochre-500\\/100:hover{
  border-color: rgb(209, 145, 47);
}

.hover\\:border-ochre-500\\/15:hover{
  border-color: rgba(209, 145, 47, 0.15);
}

.hover\\:border-ochre-500\\/20:hover{
  border-color: rgba(209, 145, 47, 0.2);
}

.hover\\:border-ochre-500\\/25:hover{
  border-color: rgba(209, 145, 47, 0.25);
}

.hover\\:border-ochre-500\\/30:hover{
  border-color: rgba(209, 145, 47, 0.3);
}

.hover\\:border-ochre-500\\/35:hover{
  border-color: rgba(209, 145, 47, 0.35);
}

.hover\\:border-ochre-500\\/40:hover{
  border-color: rgba(209, 145, 47, 0.4);
}

.hover\\:border-ochre-500\\/45:hover{
  border-color: rgba(209, 145, 47, 0.45);
}

.hover\\:border-ochre-500\\/5:hover{
  border-color: rgba(209, 145, 47, 0.05);
}

.hover\\:border-ochre-500\\/50:hover{
  border-color: rgba(209, 145, 47, 0.5);
}

.hover\\:border-ochre-500\\/55:hover{
  border-color: rgba(209, 145, 47, 0.55);
}

.hover\\:border-ochre-500\\/60:hover{
  border-color: rgba(209, 145, 47, 0.6);
}

.hover\\:border-ochre-500\\/65:hover{
  border-color: rgba(209, 145, 47, 0.65);
}

.hover\\:border-ochre-500\\/70:hover{
  border-color: rgba(209, 145, 47, 0.7);
}

.hover\\:border-ochre-500\\/75:hover{
  border-color: rgba(209, 145, 47, 0.75);
}

.hover\\:border-ochre-500\\/80:hover{
  border-color: rgba(209, 145, 47, 0.8);
}

.hover\\:border-ochre-500\\/85:hover{
  border-color: rgba(209, 145, 47, 0.85);
}

.hover\\:border-ochre-500\\/90:hover{
  border-color: rgba(209, 145, 47, 0.9);
}

.hover\\:border-ochre-500\\/95:hover{
  border-color: rgba(209, 145, 47, 0.95);
}

.hover\\:border-ochre-600:hover{
  --tw-border-opacity: 1;
  border-color: rgba(195, 120, 41, 1);
  border-color: rgba(195, 120, 41, var(--tw-border-opacity, 1));
}

.hover\\:border-ochre-600\\/0:hover{
  border-color: rgba(195, 120, 41, 0);
}

.hover\\:border-ochre-600\\/10:hover{
  border-color: rgba(195, 120, 41, 0.1);
}

.hover\\:border-ochre-600\\/100:hover{
  border-color: rgb(195, 120, 41);
}

.hover\\:border-ochre-600\\/15:hover{
  border-color: rgba(195, 120, 41, 0.15);
}

.hover\\:border-ochre-600\\/20:hover{
  border-color: rgba(195, 120, 41, 0.2);
}

.hover\\:border-ochre-600\\/25:hover{
  border-color: rgba(195, 120, 41, 0.25);
}

.hover\\:border-ochre-600\\/30:hover{
  border-color: rgba(195, 120, 41, 0.3);
}

.hover\\:border-ochre-600\\/35:hover{
  border-color: rgba(195, 120, 41, 0.35);
}

.hover\\:border-ochre-600\\/40:hover{
  border-color: rgba(195, 120, 41, 0.4);
}

.hover\\:border-ochre-600\\/45:hover{
  border-color: rgba(195, 120, 41, 0.45);
}

.hover\\:border-ochre-600\\/5:hover{
  border-color: rgba(195, 120, 41, 0.05);
}

.hover\\:border-ochre-600\\/50:hover{
  border-color: rgba(195, 120, 41, 0.5);
}

.hover\\:border-ochre-600\\/55:hover{
  border-color: rgba(195, 120, 41, 0.55);
}

.hover\\:border-ochre-600\\/60:hover{
  border-color: rgba(195, 120, 41, 0.6);
}

.hover\\:border-ochre-600\\/65:hover{
  border-color: rgba(195, 120, 41, 0.65);
}

.hover\\:border-ochre-600\\/70:hover{
  border-color: rgba(195, 120, 41, 0.7);
}

.hover\\:border-ochre-600\\/75:hover{
  border-color: rgba(195, 120, 41, 0.75);
}

.hover\\:border-ochre-600\\/80:hover{
  border-color: rgba(195, 120, 41, 0.8);
}

.hover\\:border-ochre-600\\/85:hover{
  border-color: rgba(195, 120, 41, 0.85);
}

.hover\\:border-ochre-600\\/90:hover{
  border-color: rgba(195, 120, 41, 0.9);
}

.hover\\:border-ochre-600\\/95:hover{
  border-color: rgba(195, 120, 41, 0.95);
}

.hover\\:border-ochre-700:hover{
  --tw-border-opacity: 1;
  border-color: rgba(153, 84, 36, 1);
  border-color: rgba(153, 84, 36, var(--tw-border-opacity, 1));
}

.hover\\:border-ochre-700\\/0:hover{
  border-color: rgba(153, 84, 36, 0);
}

.hover\\:border-ochre-700\\/10:hover{
  border-color: rgba(153, 84, 36, 0.1);
}

.hover\\:border-ochre-700\\/100:hover{
  border-color: rgb(153, 84, 36);
}

.hover\\:border-ochre-700\\/15:hover{
  border-color: rgba(153, 84, 36, 0.15);
}

.hover\\:border-ochre-700\\/20:hover{
  border-color: rgba(153, 84, 36, 0.2);
}

.hover\\:border-ochre-700\\/25:hover{
  border-color: rgba(153, 84, 36, 0.25);
}

.hover\\:border-ochre-700\\/30:hover{
  border-color: rgba(153, 84, 36, 0.3);
}

.hover\\:border-ochre-700\\/35:hover{
  border-color: rgba(153, 84, 36, 0.35);
}

.hover\\:border-ochre-700\\/40:hover{
  border-color: rgba(153, 84, 36, 0.4);
}

.hover\\:border-ochre-700\\/45:hover{
  border-color: rgba(153, 84, 36, 0.45);
}

.hover\\:border-ochre-700\\/5:hover{
  border-color: rgba(153, 84, 36, 0.05);
}

.hover\\:border-ochre-700\\/50:hover{
  border-color: rgba(153, 84, 36, 0.5);
}

.hover\\:border-ochre-700\\/55:hover{
  border-color: rgba(153, 84, 36, 0.55);
}

.hover\\:border-ochre-700\\/60:hover{
  border-color: rgba(153, 84, 36, 0.6);
}

.hover\\:border-ochre-700\\/65:hover{
  border-color: rgba(153, 84, 36, 0.65);
}

.hover\\:border-ochre-700\\/70:hover{
  border-color: rgba(153, 84, 36, 0.7);
}

.hover\\:border-ochre-700\\/75:hover{
  border-color: rgba(153, 84, 36, 0.75);
}

.hover\\:border-ochre-700\\/80:hover{
  border-color: rgba(153, 84, 36, 0.8);
}

.hover\\:border-ochre-700\\/85:hover{
  border-color: rgba(153, 84, 36, 0.85);
}

.hover\\:border-ochre-700\\/90:hover{
  border-color: rgba(153, 84, 36, 0.9);
}

.hover\\:border-ochre-700\\/95:hover{
  border-color: rgba(153, 84, 36, 0.95);
}

.hover\\:border-ochre-800:hover{
  --tw-border-opacity: 1;
  border-color: rgba(126, 67, 34, 1);
  border-color: rgba(126, 67, 34, var(--tw-border-opacity, 1));
}

.hover\\:border-ochre-800\\/0:hover{
  border-color: rgba(126, 67, 34, 0);
}

.hover\\:border-ochre-800\\/10:hover{
  border-color: rgba(126, 67, 34, 0.1);
}

.hover\\:border-ochre-800\\/100:hover{
  border-color: rgb(126, 67, 34);
}

.hover\\:border-ochre-800\\/15:hover{
  border-color: rgba(126, 67, 34, 0.15);
}

.hover\\:border-ochre-800\\/20:hover{
  border-color: rgba(126, 67, 34, 0.2);
}

.hover\\:border-ochre-800\\/25:hover{
  border-color: rgba(126, 67, 34, 0.25);
}

.hover\\:border-ochre-800\\/30:hover{
  border-color: rgba(126, 67, 34, 0.3);
}

.hover\\:border-ochre-800\\/35:hover{
  border-color: rgba(126, 67, 34, 0.35);
}

.hover\\:border-ochre-800\\/40:hover{
  border-color: rgba(126, 67, 34, 0.4);
}

.hover\\:border-ochre-800\\/45:hover{
  border-color: rgba(126, 67, 34, 0.45);
}

.hover\\:border-ochre-800\\/5:hover{
  border-color: rgba(126, 67, 34, 0.05);
}

.hover\\:border-ochre-800\\/50:hover{
  border-color: rgba(126, 67, 34, 0.5);
}

.hover\\:border-ochre-800\\/55:hover{
  border-color: rgba(126, 67, 34, 0.55);
}

.hover\\:border-ochre-800\\/60:hover{
  border-color: rgba(126, 67, 34, 0.6);
}

.hover\\:border-ochre-800\\/65:hover{
  border-color: rgba(126, 67, 34, 0.65);
}

.hover\\:border-ochre-800\\/70:hover{
  border-color: rgba(126, 67, 34, 0.7);
}

.hover\\:border-ochre-800\\/75:hover{
  border-color: rgba(126, 67, 34, 0.75);
}

.hover\\:border-ochre-800\\/80:hover{
  border-color: rgba(126, 67, 34, 0.8);
}

.hover\\:border-ochre-800\\/85:hover{
  border-color: rgba(126, 67, 34, 0.85);
}

.hover\\:border-ochre-800\\/90:hover{
  border-color: rgba(126, 67, 34, 0.9);
}

.hover\\:border-ochre-800\\/95:hover{
  border-color: rgba(126, 67, 34, 0.95);
}

.hover\\:border-ochre-900:hover{
  --tw-border-opacity: 1;
  border-color: rgba(104, 56, 31, 1);
  border-color: rgba(104, 56, 31, var(--tw-border-opacity, 1));
}

.hover\\:border-ochre-900\\/0:hover{
  border-color: rgba(104, 56, 31, 0);
}

.hover\\:border-ochre-900\\/10:hover{
  border-color: rgba(104, 56, 31, 0.1);
}

.hover\\:border-ochre-900\\/100:hover{
  border-color: rgb(104, 56, 31);
}

.hover\\:border-ochre-900\\/15:hover{
  border-color: rgba(104, 56, 31, 0.15);
}

.hover\\:border-ochre-900\\/20:hover{
  border-color: rgba(104, 56, 31, 0.2);
}

.hover\\:border-ochre-900\\/25:hover{
  border-color: rgba(104, 56, 31, 0.25);
}

.hover\\:border-ochre-900\\/30:hover{
  border-color: rgba(104, 56, 31, 0.3);
}

.hover\\:border-ochre-900\\/35:hover{
  border-color: rgba(104, 56, 31, 0.35);
}

.hover\\:border-ochre-900\\/40:hover{
  border-color: rgba(104, 56, 31, 0.4);
}

.hover\\:border-ochre-900\\/45:hover{
  border-color: rgba(104, 56, 31, 0.45);
}

.hover\\:border-ochre-900\\/5:hover{
  border-color: rgba(104, 56, 31, 0.05);
}

.hover\\:border-ochre-900\\/50:hover{
  border-color: rgba(104, 56, 31, 0.5);
}

.hover\\:border-ochre-900\\/55:hover{
  border-color: rgba(104, 56, 31, 0.55);
}

.hover\\:border-ochre-900\\/60:hover{
  border-color: rgba(104, 56, 31, 0.6);
}

.hover\\:border-ochre-900\\/65:hover{
  border-color: rgba(104, 56, 31, 0.65);
}

.hover\\:border-ochre-900\\/70:hover{
  border-color: rgba(104, 56, 31, 0.7);
}

.hover\\:border-ochre-900\\/75:hover{
  border-color: rgba(104, 56, 31, 0.75);
}

.hover\\:border-ochre-900\\/80:hover{
  border-color: rgba(104, 56, 31, 0.8);
}

.hover\\:border-ochre-900\\/85:hover{
  border-color: rgba(104, 56, 31, 0.85);
}

.hover\\:border-ochre-900\\/90:hover{
  border-color: rgba(104, 56, 31, 0.9);
}

.hover\\:border-ochre-900\\/95:hover{
  border-color: rgba(104, 56, 31, 0.95);
}

.hover\\:border-ochre-950:hover{
  --tw-border-opacity: 1;
  border-color: rgba(59, 28, 13, 1);
  border-color: rgba(59, 28, 13, var(--tw-border-opacity, 1));
}

.hover\\:border-ochre-950\\/0:hover{
  border-color: rgba(59, 28, 13, 0);
}

.hover\\:border-ochre-950\\/10:hover{
  border-color: rgba(59, 28, 13, 0.1);
}

.hover\\:border-ochre-950\\/100:hover{
  border-color: rgb(59, 28, 13);
}

.hover\\:border-ochre-950\\/15:hover{
  border-color: rgba(59, 28, 13, 0.15);
}

.hover\\:border-ochre-950\\/20:hover{
  border-color: rgba(59, 28, 13, 0.2);
}

.hover\\:border-ochre-950\\/25:hover{
  border-color: rgba(59, 28, 13, 0.25);
}

.hover\\:border-ochre-950\\/30:hover{
  border-color: rgba(59, 28, 13, 0.3);
}

.hover\\:border-ochre-950\\/35:hover{
  border-color: rgba(59, 28, 13, 0.35);
}

.hover\\:border-ochre-950\\/40:hover{
  border-color: rgba(59, 28, 13, 0.4);
}

.hover\\:border-ochre-950\\/45:hover{
  border-color: rgba(59, 28, 13, 0.45);
}

.hover\\:border-ochre-950\\/5:hover{
  border-color: rgba(59, 28, 13, 0.05);
}

.hover\\:border-ochre-950\\/50:hover{
  border-color: rgba(59, 28, 13, 0.5);
}

.hover\\:border-ochre-950\\/55:hover{
  border-color: rgba(59, 28, 13, 0.55);
}

.hover\\:border-ochre-950\\/60:hover{
  border-color: rgba(59, 28, 13, 0.6);
}

.hover\\:border-ochre-950\\/65:hover{
  border-color: rgba(59, 28, 13, 0.65);
}

.hover\\:border-ochre-950\\/70:hover{
  border-color: rgba(59, 28, 13, 0.7);
}

.hover\\:border-ochre-950\\/75:hover{
  border-color: rgba(59, 28, 13, 0.75);
}

.hover\\:border-ochre-950\\/80:hover{
  border-color: rgba(59, 28, 13, 0.8);
}

.hover\\:border-ochre-950\\/85:hover{
  border-color: rgba(59, 28, 13, 0.85);
}

.hover\\:border-ochre-950\\/90:hover{
  border-color: rgba(59, 28, 13, 0.9);
}

.hover\\:border-ochre-950\\/95:hover{
  border-color: rgba(59, 28, 13, 0.95);
}

.hover\\:border-phrase-color-100:hover{
  --tw-border-opacity: 1;
  border-color: rgba(245, 237, 208, 1);
  border-color: rgba(245, 237, 208, var(--tw-border-opacity, 1));
}

.hover\\:border-phrase-color-100\\/0:hover{
  border-color: rgba(245, 237, 208, 0);
}

.hover\\:border-phrase-color-100\\/10:hover{
  border-color: rgba(245, 237, 208, 0.1);
}

.hover\\:border-phrase-color-100\\/100:hover{
  border-color: rgb(245, 237, 208);
}

.hover\\:border-phrase-color-100\\/15:hover{
  border-color: rgba(245, 237, 208, 0.15);
}

.hover\\:border-phrase-color-100\\/20:hover{
  border-color: rgba(245, 237, 208, 0.2);
}

.hover\\:border-phrase-color-100\\/25:hover{
  border-color: rgba(245, 237, 208, 0.25);
}

.hover\\:border-phrase-color-100\\/30:hover{
  border-color: rgba(245, 237, 208, 0.3);
}

.hover\\:border-phrase-color-100\\/35:hover{
  border-color: rgba(245, 237, 208, 0.35);
}

.hover\\:border-phrase-color-100\\/40:hover{
  border-color: rgba(245, 237, 208, 0.4);
}

.hover\\:border-phrase-color-100\\/45:hover{
  border-color: rgba(245, 237, 208, 0.45);
}

.hover\\:border-phrase-color-100\\/5:hover{
  border-color: rgba(245, 237, 208, 0.05);
}

.hover\\:border-phrase-color-100\\/50:hover{
  border-color: rgba(245, 237, 208, 0.5);
}

.hover\\:border-phrase-color-100\\/55:hover{
  border-color: rgba(245, 237, 208, 0.55);
}

.hover\\:border-phrase-color-100\\/60:hover{
  border-color: rgba(245, 237, 208, 0.6);
}

.hover\\:border-phrase-color-100\\/65:hover{
  border-color: rgba(245, 237, 208, 0.65);
}

.hover\\:border-phrase-color-100\\/70:hover{
  border-color: rgba(245, 237, 208, 0.7);
}

.hover\\:border-phrase-color-100\\/75:hover{
  border-color: rgba(245, 237, 208, 0.75);
}

.hover\\:border-phrase-color-100\\/80:hover{
  border-color: rgba(245, 237, 208, 0.8);
}

.hover\\:border-phrase-color-100\\/85:hover{
  border-color: rgba(245, 237, 208, 0.85);
}

.hover\\:border-phrase-color-100\\/90:hover{
  border-color: rgba(245, 237, 208, 0.9);
}

.hover\\:border-phrase-color-100\\/95:hover{
  border-color: rgba(245, 237, 208, 0.95);
}

.hover\\:border-phrase-color-200:hover{
  --tw-border-opacity: 1;
  border-color: rgba(235, 217, 156, 1);
  border-color: rgba(235, 217, 156, var(--tw-border-opacity, 1));
}

.hover\\:border-phrase-color-200\\/0:hover{
  border-color: rgba(235, 217, 156, 0);
}

.hover\\:border-phrase-color-200\\/10:hover{
  border-color: rgba(235, 217, 156, 0.1);
}

.hover\\:border-phrase-color-200\\/100:hover{
  border-color: rgb(235, 217, 156);
}

.hover\\:border-phrase-color-200\\/15:hover{
  border-color: rgba(235, 217, 156, 0.15);
}

.hover\\:border-phrase-color-200\\/20:hover{
  border-color: rgba(235, 217, 156, 0.2);
}

.hover\\:border-phrase-color-200\\/25:hover{
  border-color: rgba(235, 217, 156, 0.25);
}

.hover\\:border-phrase-color-200\\/30:hover{
  border-color: rgba(235, 217, 156, 0.3);
}

.hover\\:border-phrase-color-200\\/35:hover{
  border-color: rgba(235, 217, 156, 0.35);
}

.hover\\:border-phrase-color-200\\/40:hover{
  border-color: rgba(235, 217, 156, 0.4);
}

.hover\\:border-phrase-color-200\\/45:hover{
  border-color: rgba(235, 217, 156, 0.45);
}

.hover\\:border-phrase-color-200\\/5:hover{
  border-color: rgba(235, 217, 156, 0.05);
}

.hover\\:border-phrase-color-200\\/50:hover{
  border-color: rgba(235, 217, 156, 0.5);
}

.hover\\:border-phrase-color-200\\/55:hover{
  border-color: rgba(235, 217, 156, 0.55);
}

.hover\\:border-phrase-color-200\\/60:hover{
  border-color: rgba(235, 217, 156, 0.6);
}

.hover\\:border-phrase-color-200\\/65:hover{
  border-color: rgba(235, 217, 156, 0.65);
}

.hover\\:border-phrase-color-200\\/70:hover{
  border-color: rgba(235, 217, 156, 0.7);
}

.hover\\:border-phrase-color-200\\/75:hover{
  border-color: rgba(235, 217, 156, 0.75);
}

.hover\\:border-phrase-color-200\\/80:hover{
  border-color: rgba(235, 217, 156, 0.8);
}

.hover\\:border-phrase-color-200\\/85:hover{
  border-color: rgba(235, 217, 156, 0.85);
}

.hover\\:border-phrase-color-200\\/90:hover{
  border-color: rgba(235, 217, 156, 0.9);
}

.hover\\:border-phrase-color-200\\/95:hover{
  border-color: rgba(235, 217, 156, 0.95);
}

.hover\\:border-phrase-color-300:hover{
  --tw-border-opacity: 1;
  border-color: rgba(225, 194, 104, 1);
  border-color: rgba(225, 194, 104, var(--tw-border-opacity, 1));
}

.hover\\:border-phrase-color-300\\/0:hover{
  border-color: rgba(225, 194, 104, 0);
}

.hover\\:border-phrase-color-300\\/10:hover{
  border-color: rgba(225, 194, 104, 0.1);
}

.hover\\:border-phrase-color-300\\/100:hover{
  border-color: rgb(225, 194, 104);
}

.hover\\:border-phrase-color-300\\/15:hover{
  border-color: rgba(225, 194, 104, 0.15);
}

.hover\\:border-phrase-color-300\\/20:hover{
  border-color: rgba(225, 194, 104, 0.2);
}

.hover\\:border-phrase-color-300\\/25:hover{
  border-color: rgba(225, 194, 104, 0.25);
}

.hover\\:border-phrase-color-300\\/30:hover{
  border-color: rgba(225, 194, 104, 0.3);
}

.hover\\:border-phrase-color-300\\/35:hover{
  border-color: rgba(225, 194, 104, 0.35);
}

.hover\\:border-phrase-color-300\\/40:hover{
  border-color: rgba(225, 194, 104, 0.4);
}

.hover\\:border-phrase-color-300\\/45:hover{
  border-color: rgba(225, 194, 104, 0.45);
}

.hover\\:border-phrase-color-300\\/5:hover{
  border-color: rgba(225, 194, 104, 0.05);
}

.hover\\:border-phrase-color-300\\/50:hover{
  border-color: rgba(225, 194, 104, 0.5);
}

.hover\\:border-phrase-color-300\\/55:hover{
  border-color: rgba(225, 194, 104, 0.55);
}

.hover\\:border-phrase-color-300\\/60:hover{
  border-color: rgba(225, 194, 104, 0.6);
}

.hover\\:border-phrase-color-300\\/65:hover{
  border-color: rgba(225, 194, 104, 0.65);
}

.hover\\:border-phrase-color-300\\/70:hover{
  border-color: rgba(225, 194, 104, 0.7);
}

.hover\\:border-phrase-color-300\\/75:hover{
  border-color: rgba(225, 194, 104, 0.75);
}

.hover\\:border-phrase-color-300\\/80:hover{
  border-color: rgba(225, 194, 104, 0.8);
}

.hover\\:border-phrase-color-300\\/85:hover{
  border-color: rgba(225, 194, 104, 0.85);
}

.hover\\:border-phrase-color-300\\/90:hover{
  border-color: rgba(225, 194, 104, 0.9);
}

.hover\\:border-phrase-color-300\\/95:hover{
  border-color: rgba(225, 194, 104, 0.95);
}

.hover\\:border-phrase-color-400:hover{
  --tw-border-opacity: 1;
  border-color: rgba(218, 173, 69, 1);
  border-color: rgba(218, 173, 69, var(--tw-border-opacity, 1));
}

.hover\\:border-phrase-color-400\\/0:hover{
  border-color: rgba(218, 173, 69, 0);
}

.hover\\:border-phrase-color-400\\/10:hover{
  border-color: rgba(218, 173, 69, 0.1);
}

.hover\\:border-phrase-color-400\\/100:hover{
  border-color: rgb(218, 173, 69);
}

.hover\\:border-phrase-color-400\\/15:hover{
  border-color: rgba(218, 173, 69, 0.15);
}

.hover\\:border-phrase-color-400\\/20:hover{
  border-color: rgba(218, 173, 69, 0.2);
}

.hover\\:border-phrase-color-400\\/25:hover{
  border-color: rgba(218, 173, 69, 0.25);
}

.hover\\:border-phrase-color-400\\/30:hover{
  border-color: rgba(218, 173, 69, 0.3);
}

.hover\\:border-phrase-color-400\\/35:hover{
  border-color: rgba(218, 173, 69, 0.35);
}

.hover\\:border-phrase-color-400\\/40:hover{
  border-color: rgba(218, 173, 69, 0.4);
}

.hover\\:border-phrase-color-400\\/45:hover{
  border-color: rgba(218, 173, 69, 0.45);
}

.hover\\:border-phrase-color-400\\/5:hover{
  border-color: rgba(218, 173, 69, 0.05);
}

.hover\\:border-phrase-color-400\\/50:hover{
  border-color: rgba(218, 173, 69, 0.5);
}

.hover\\:border-phrase-color-400\\/55:hover{
  border-color: rgba(218, 173, 69, 0.55);
}

.hover\\:border-phrase-color-400\\/60:hover{
  border-color: rgba(218, 173, 69, 0.6);
}

.hover\\:border-phrase-color-400\\/65:hover{
  border-color: rgba(218, 173, 69, 0.65);
}

.hover\\:border-phrase-color-400\\/70:hover{
  border-color: rgba(218, 173, 69, 0.7);
}

.hover\\:border-phrase-color-400\\/75:hover{
  border-color: rgba(218, 173, 69, 0.75);
}

.hover\\:border-phrase-color-400\\/80:hover{
  border-color: rgba(218, 173, 69, 0.8);
}

.hover\\:border-phrase-color-400\\/85:hover{
  border-color: rgba(218, 173, 69, 0.85);
}

.hover\\:border-phrase-color-400\\/90:hover{
  border-color: rgba(218, 173, 69, 0.9);
}

.hover\\:border-phrase-color-400\\/95:hover{
  border-color: rgba(218, 173, 69, 0.95);
}

.hover\\:border-phrase-color-500:hover{
  --tw-border-opacity: 1;
  border-color: rgba(209, 145, 47, 1);
  border-color: rgba(209, 145, 47, var(--tw-border-opacity, 1));
}

.hover\\:border-phrase-color-500\\/0:hover{
  border-color: rgba(209, 145, 47, 0);
}

.hover\\:border-phrase-color-500\\/10:hover{
  border-color: rgba(209, 145, 47, 0.1);
}

.hover\\:border-phrase-color-500\\/100:hover{
  border-color: rgb(209, 145, 47);
}

.hover\\:border-phrase-color-500\\/15:hover{
  border-color: rgba(209, 145, 47, 0.15);
}

.hover\\:border-phrase-color-500\\/20:hover{
  border-color: rgba(209, 145, 47, 0.2);
}

.hover\\:border-phrase-color-500\\/25:hover{
  border-color: rgba(209, 145, 47, 0.25);
}

.hover\\:border-phrase-color-500\\/30:hover{
  border-color: rgba(209, 145, 47, 0.3);
}

.hover\\:border-phrase-color-500\\/35:hover{
  border-color: rgba(209, 145, 47, 0.35);
}

.hover\\:border-phrase-color-500\\/40:hover{
  border-color: rgba(209, 145, 47, 0.4);
}

.hover\\:border-phrase-color-500\\/45:hover{
  border-color: rgba(209, 145, 47, 0.45);
}

.hover\\:border-phrase-color-500\\/5:hover{
  border-color: rgba(209, 145, 47, 0.05);
}

.hover\\:border-phrase-color-500\\/50:hover{
  border-color: rgba(209, 145, 47, 0.5);
}

.hover\\:border-phrase-color-500\\/55:hover{
  border-color: rgba(209, 145, 47, 0.55);
}

.hover\\:border-phrase-color-500\\/60:hover{
  border-color: rgba(209, 145, 47, 0.6);
}

.hover\\:border-phrase-color-500\\/65:hover{
  border-color: rgba(209, 145, 47, 0.65);
}

.hover\\:border-phrase-color-500\\/70:hover{
  border-color: rgba(209, 145, 47, 0.7);
}

.hover\\:border-phrase-color-500\\/75:hover{
  border-color: rgba(209, 145, 47, 0.75);
}

.hover\\:border-phrase-color-500\\/80:hover{
  border-color: rgba(209, 145, 47, 0.8);
}

.hover\\:border-phrase-color-500\\/85:hover{
  border-color: rgba(209, 145, 47, 0.85);
}

.hover\\:border-phrase-color-500\\/90:hover{
  border-color: rgba(209, 145, 47, 0.9);
}

.hover\\:border-phrase-color-500\\/95:hover{
  border-color: rgba(209, 145, 47, 0.95);
}

.hover\\:border-phrase-color-600:hover{
  --tw-border-opacity: 1;
  border-color: rgba(195, 120, 41, 1);
  border-color: rgba(195, 120, 41, var(--tw-border-opacity, 1));
}

.hover\\:border-phrase-color-600\\/0:hover{
  border-color: rgba(195, 120, 41, 0);
}

.hover\\:border-phrase-color-600\\/10:hover{
  border-color: rgba(195, 120, 41, 0.1);
}

.hover\\:border-phrase-color-600\\/100:hover{
  border-color: rgb(195, 120, 41);
}

.hover\\:border-phrase-color-600\\/15:hover{
  border-color: rgba(195, 120, 41, 0.15);
}

.hover\\:border-phrase-color-600\\/20:hover{
  border-color: rgba(195, 120, 41, 0.2);
}

.hover\\:border-phrase-color-600\\/25:hover{
  border-color: rgba(195, 120, 41, 0.25);
}

.hover\\:border-phrase-color-600\\/30:hover{
  border-color: rgba(195, 120, 41, 0.3);
}

.hover\\:border-phrase-color-600\\/35:hover{
  border-color: rgba(195, 120, 41, 0.35);
}

.hover\\:border-phrase-color-600\\/40:hover{
  border-color: rgba(195, 120, 41, 0.4);
}

.hover\\:border-phrase-color-600\\/45:hover{
  border-color: rgba(195, 120, 41, 0.45);
}

.hover\\:border-phrase-color-600\\/5:hover{
  border-color: rgba(195, 120, 41, 0.05);
}

.hover\\:border-phrase-color-600\\/50:hover{
  border-color: rgba(195, 120, 41, 0.5);
}

.hover\\:border-phrase-color-600\\/55:hover{
  border-color: rgba(195, 120, 41, 0.55);
}

.hover\\:border-phrase-color-600\\/60:hover{
  border-color: rgba(195, 120, 41, 0.6);
}

.hover\\:border-phrase-color-600\\/65:hover{
  border-color: rgba(195, 120, 41, 0.65);
}

.hover\\:border-phrase-color-600\\/70:hover{
  border-color: rgba(195, 120, 41, 0.7);
}

.hover\\:border-phrase-color-600\\/75:hover{
  border-color: rgba(195, 120, 41, 0.75);
}

.hover\\:border-phrase-color-600\\/80:hover{
  border-color: rgba(195, 120, 41, 0.8);
}

.hover\\:border-phrase-color-600\\/85:hover{
  border-color: rgba(195, 120, 41, 0.85);
}

.hover\\:border-phrase-color-600\\/90:hover{
  border-color: rgba(195, 120, 41, 0.9);
}

.hover\\:border-phrase-color-600\\/95:hover{
  border-color: rgba(195, 120, 41, 0.95);
}

.hover\\:border-phrase-color-700:hover{
  --tw-border-opacity: 1;
  border-color: rgba(153, 84, 36, 1);
  border-color: rgba(153, 84, 36, var(--tw-border-opacity, 1));
}

.hover\\:border-phrase-color-700\\/0:hover{
  border-color: rgba(153, 84, 36, 0);
}

.hover\\:border-phrase-color-700\\/10:hover{
  border-color: rgba(153, 84, 36, 0.1);
}

.hover\\:border-phrase-color-700\\/100:hover{
  border-color: rgb(153, 84, 36);
}

.hover\\:border-phrase-color-700\\/15:hover{
  border-color: rgba(153, 84, 36, 0.15);
}

.hover\\:border-phrase-color-700\\/20:hover{
  border-color: rgba(153, 84, 36, 0.2);
}

.hover\\:border-phrase-color-700\\/25:hover{
  border-color: rgba(153, 84, 36, 0.25);
}

.hover\\:border-phrase-color-700\\/30:hover{
  border-color: rgba(153, 84, 36, 0.3);
}

.hover\\:border-phrase-color-700\\/35:hover{
  border-color: rgba(153, 84, 36, 0.35);
}

.hover\\:border-phrase-color-700\\/40:hover{
  border-color: rgba(153, 84, 36, 0.4);
}

.hover\\:border-phrase-color-700\\/45:hover{
  border-color: rgba(153, 84, 36, 0.45);
}

.hover\\:border-phrase-color-700\\/5:hover{
  border-color: rgba(153, 84, 36, 0.05);
}

.hover\\:border-phrase-color-700\\/50:hover{
  border-color: rgba(153, 84, 36, 0.5);
}

.hover\\:border-phrase-color-700\\/55:hover{
  border-color: rgba(153, 84, 36, 0.55);
}

.hover\\:border-phrase-color-700\\/60:hover{
  border-color: rgba(153, 84, 36, 0.6);
}

.hover\\:border-phrase-color-700\\/65:hover{
  border-color: rgba(153, 84, 36, 0.65);
}

.hover\\:border-phrase-color-700\\/70:hover{
  border-color: rgba(153, 84, 36, 0.7);
}

.hover\\:border-phrase-color-700\\/75:hover{
  border-color: rgba(153, 84, 36, 0.75);
}

.hover\\:border-phrase-color-700\\/80:hover{
  border-color: rgba(153, 84, 36, 0.8);
}

.hover\\:border-phrase-color-700\\/85:hover{
  border-color: rgba(153, 84, 36, 0.85);
}

.hover\\:border-phrase-color-700\\/90:hover{
  border-color: rgba(153, 84, 36, 0.9);
}

.hover\\:border-phrase-color-700\\/95:hover{
  border-color: rgba(153, 84, 36, 0.95);
}

.hover\\:border-phrase-color-800:hover{
  --tw-border-opacity: 1;
  border-color: rgba(126, 67, 34, 1);
  border-color: rgba(126, 67, 34, var(--tw-border-opacity, 1));
}

.hover\\:border-phrase-color-800\\/0:hover{
  border-color: rgba(126, 67, 34, 0);
}

.hover\\:border-phrase-color-800\\/10:hover{
  border-color: rgba(126, 67, 34, 0.1);
}

.hover\\:border-phrase-color-800\\/100:hover{
  border-color: rgb(126, 67, 34);
}

.hover\\:border-phrase-color-800\\/15:hover{
  border-color: rgba(126, 67, 34, 0.15);
}

.hover\\:border-phrase-color-800\\/20:hover{
  border-color: rgba(126, 67, 34, 0.2);
}

.hover\\:border-phrase-color-800\\/25:hover{
  border-color: rgba(126, 67, 34, 0.25);
}

.hover\\:border-phrase-color-800\\/30:hover{
  border-color: rgba(126, 67, 34, 0.3);
}

.hover\\:border-phrase-color-800\\/35:hover{
  border-color: rgba(126, 67, 34, 0.35);
}

.hover\\:border-phrase-color-800\\/40:hover{
  border-color: rgba(126, 67, 34, 0.4);
}

.hover\\:border-phrase-color-800\\/45:hover{
  border-color: rgba(126, 67, 34, 0.45);
}

.hover\\:border-phrase-color-800\\/5:hover{
  border-color: rgba(126, 67, 34, 0.05);
}

.hover\\:border-phrase-color-800\\/50:hover{
  border-color: rgba(126, 67, 34, 0.5);
}

.hover\\:border-phrase-color-800\\/55:hover{
  border-color: rgba(126, 67, 34, 0.55);
}

.hover\\:border-phrase-color-800\\/60:hover{
  border-color: rgba(126, 67, 34, 0.6);
}

.hover\\:border-phrase-color-800\\/65:hover{
  border-color: rgba(126, 67, 34, 0.65);
}

.hover\\:border-phrase-color-800\\/70:hover{
  border-color: rgba(126, 67, 34, 0.7);
}

.hover\\:border-phrase-color-800\\/75:hover{
  border-color: rgba(126, 67, 34, 0.75);
}

.hover\\:border-phrase-color-800\\/80:hover{
  border-color: rgba(126, 67, 34, 0.8);
}

.hover\\:border-phrase-color-800\\/85:hover{
  border-color: rgba(126, 67, 34, 0.85);
}

.hover\\:border-phrase-color-800\\/90:hover{
  border-color: rgba(126, 67, 34, 0.9);
}

.hover\\:border-phrase-color-800\\/95:hover{
  border-color: rgba(126, 67, 34, 0.95);
}

.hover\\:border-phrase-color-900:hover{
  --tw-border-opacity: 1;
  border-color: rgba(104, 56, 31, 1);
  border-color: rgba(104, 56, 31, var(--tw-border-opacity, 1));
}

.hover\\:border-phrase-color-900\\/0:hover{
  border-color: rgba(104, 56, 31, 0);
}

.hover\\:border-phrase-color-900\\/10:hover{
  border-color: rgba(104, 56, 31, 0.1);
}

.hover\\:border-phrase-color-900\\/100:hover{
  border-color: rgb(104, 56, 31);
}

.hover\\:border-phrase-color-900\\/15:hover{
  border-color: rgba(104, 56, 31, 0.15);
}

.hover\\:border-phrase-color-900\\/20:hover{
  border-color: rgba(104, 56, 31, 0.2);
}

.hover\\:border-phrase-color-900\\/25:hover{
  border-color: rgba(104, 56, 31, 0.25);
}

.hover\\:border-phrase-color-900\\/30:hover{
  border-color: rgba(104, 56, 31, 0.3);
}

.hover\\:border-phrase-color-900\\/35:hover{
  border-color: rgba(104, 56, 31, 0.35);
}

.hover\\:border-phrase-color-900\\/40:hover{
  border-color: rgba(104, 56, 31, 0.4);
}

.hover\\:border-phrase-color-900\\/45:hover{
  border-color: rgba(104, 56, 31, 0.45);
}

.hover\\:border-phrase-color-900\\/5:hover{
  border-color: rgba(104, 56, 31, 0.05);
}

.hover\\:border-phrase-color-900\\/50:hover{
  border-color: rgba(104, 56, 31, 0.5);
}

.hover\\:border-phrase-color-900\\/55:hover{
  border-color: rgba(104, 56, 31, 0.55);
}

.hover\\:border-phrase-color-900\\/60:hover{
  border-color: rgba(104, 56, 31, 0.6);
}

.hover\\:border-phrase-color-900\\/65:hover{
  border-color: rgba(104, 56, 31, 0.65);
}

.hover\\:border-phrase-color-900\\/70:hover{
  border-color: rgba(104, 56, 31, 0.7);
}

.hover\\:border-phrase-color-900\\/75:hover{
  border-color: rgba(104, 56, 31, 0.75);
}

.hover\\:border-phrase-color-900\\/80:hover{
  border-color: rgba(104, 56, 31, 0.8);
}

.hover\\:border-phrase-color-900\\/85:hover{
  border-color: rgba(104, 56, 31, 0.85);
}

.hover\\:border-phrase-color-900\\/90:hover{
  border-color: rgba(104, 56, 31, 0.9);
}

.hover\\:border-phrase-color-900\\/95:hover{
  border-color: rgba(104, 56, 31, 0.95);
}

.hover\\:border-phrase-color-950:hover{
  --tw-border-opacity: 1;
  border-color: rgba(59, 28, 13, 1);
  border-color: rgba(59, 28, 13, var(--tw-border-opacity, 1));
}

.hover\\:border-phrase-color-950\\/0:hover{
  border-color: rgba(59, 28, 13, 0);
}

.hover\\:border-phrase-color-950\\/10:hover{
  border-color: rgba(59, 28, 13, 0.1);
}

.hover\\:border-phrase-color-950\\/100:hover{
  border-color: rgb(59, 28, 13);
}

.hover\\:border-phrase-color-950\\/15:hover{
  border-color: rgba(59, 28, 13, 0.15);
}

.hover\\:border-phrase-color-950\\/20:hover{
  border-color: rgba(59, 28, 13, 0.2);
}

.hover\\:border-phrase-color-950\\/25:hover{
  border-color: rgba(59, 28, 13, 0.25);
}

.hover\\:border-phrase-color-950\\/30:hover{
  border-color: rgba(59, 28, 13, 0.3);
}

.hover\\:border-phrase-color-950\\/35:hover{
  border-color: rgba(59, 28, 13, 0.35);
}

.hover\\:border-phrase-color-950\\/40:hover{
  border-color: rgba(59, 28, 13, 0.4);
}

.hover\\:border-phrase-color-950\\/45:hover{
  border-color: rgba(59, 28, 13, 0.45);
}

.hover\\:border-phrase-color-950\\/5:hover{
  border-color: rgba(59, 28, 13, 0.05);
}

.hover\\:border-phrase-color-950\\/50:hover{
  border-color: rgba(59, 28, 13, 0.5);
}

.hover\\:border-phrase-color-950\\/55:hover{
  border-color: rgba(59, 28, 13, 0.55);
}

.hover\\:border-phrase-color-950\\/60:hover{
  border-color: rgba(59, 28, 13, 0.6);
}

.hover\\:border-phrase-color-950\\/65:hover{
  border-color: rgba(59, 28, 13, 0.65);
}

.hover\\:border-phrase-color-950\\/70:hover{
  border-color: rgba(59, 28, 13, 0.7);
}

.hover\\:border-phrase-color-950\\/75:hover{
  border-color: rgba(59, 28, 13, 0.75);
}

.hover\\:border-phrase-color-950\\/80:hover{
  border-color: rgba(59, 28, 13, 0.8);
}

.hover\\:border-phrase-color-950\\/85:hover{
  border-color: rgba(59, 28, 13, 0.85);
}

.hover\\:border-phrase-color-950\\/90:hover{
  border-color: rgba(59, 28, 13, 0.9);
}

.hover\\:border-phrase-color-950\\/95:hover{
  border-color: rgba(59, 28, 13, 0.95);
}

.hover\\:border-scarlet-100:hover{
  --tw-border-opacity: 1;
  border-color: rgba(255, 220, 223, 1);
  border-color: rgba(255, 220, 223, var(--tw-border-opacity, 1));
}

.hover\\:border-scarlet-100\\/0:hover{
  border-color: rgba(255, 220, 223, 0);
}

.hover\\:border-scarlet-100\\/10:hover{
  border-color: rgba(255, 220, 223, 0.1);
}

.hover\\:border-scarlet-100\\/100:hover{
  border-color: rgb(255, 220, 223);
}

.hover\\:border-scarlet-100\\/15:hover{
  border-color: rgba(255, 220, 223, 0.15);
}

.hover\\:border-scarlet-100\\/20:hover{
  border-color: rgba(255, 220, 223, 0.2);
}

.hover\\:border-scarlet-100\\/25:hover{
  border-color: rgba(255, 220, 223, 0.25);
}

.hover\\:border-scarlet-100\\/30:hover{
  border-color: rgba(255, 220, 223, 0.3);
}

.hover\\:border-scarlet-100\\/35:hover{
  border-color: rgba(255, 220, 223, 0.35);
}

.hover\\:border-scarlet-100\\/40:hover{
  border-color: rgba(255, 220, 223, 0.4);
}

.hover\\:border-scarlet-100\\/45:hover{
  border-color: rgba(255, 220, 223, 0.45);
}

.hover\\:border-scarlet-100\\/5:hover{
  border-color: rgba(255, 220, 223, 0.05);
}

.hover\\:border-scarlet-100\\/50:hover{
  border-color: rgba(255, 220, 223, 0.5);
}

.hover\\:border-scarlet-100\\/55:hover{
  border-color: rgba(255, 220, 223, 0.55);
}

.hover\\:border-scarlet-100\\/60:hover{
  border-color: rgba(255, 220, 223, 0.6);
}

.hover\\:border-scarlet-100\\/65:hover{
  border-color: rgba(255, 220, 223, 0.65);
}

.hover\\:border-scarlet-100\\/70:hover{
  border-color: rgba(255, 220, 223, 0.7);
}

.hover\\:border-scarlet-100\\/75:hover{
  border-color: rgba(255, 220, 223, 0.75);
}

.hover\\:border-scarlet-100\\/80:hover{
  border-color: rgba(255, 220, 223, 0.8);
}

.hover\\:border-scarlet-100\\/85:hover{
  border-color: rgba(255, 220, 223, 0.85);
}

.hover\\:border-scarlet-100\\/90:hover{
  border-color: rgba(255, 220, 223, 0.9);
}

.hover\\:border-scarlet-100\\/95:hover{
  border-color: rgba(255, 220, 223, 0.95);
}

.hover\\:border-scarlet-200:hover{
  --tw-border-opacity: 1;
  border-color: rgba(255, 192, 198, 1);
  border-color: rgba(255, 192, 198, var(--tw-border-opacity, 1));
}

.hover\\:border-scarlet-200\\/0:hover{
  border-color: rgba(255, 192, 198, 0);
}

.hover\\:border-scarlet-200\\/10:hover{
  border-color: rgba(255, 192, 198, 0.1);
}

.hover\\:border-scarlet-200\\/100:hover{
  border-color: rgb(255, 192, 198);
}

.hover\\:border-scarlet-200\\/15:hover{
  border-color: rgba(255, 192, 198, 0.15);
}

.hover\\:border-scarlet-200\\/20:hover{
  border-color: rgba(255, 192, 198, 0.2);
}

.hover\\:border-scarlet-200\\/25:hover{
  border-color: rgba(255, 192, 198, 0.25);
}

.hover\\:border-scarlet-200\\/30:hover{
  border-color: rgba(255, 192, 198, 0.3);
}

.hover\\:border-scarlet-200\\/35:hover{
  border-color: rgba(255, 192, 198, 0.35);
}

.hover\\:border-scarlet-200\\/40:hover{
  border-color: rgba(255, 192, 198, 0.4);
}

.hover\\:border-scarlet-200\\/45:hover{
  border-color: rgba(255, 192, 198, 0.45);
}

.hover\\:border-scarlet-200\\/5:hover{
  border-color: rgba(255, 192, 198, 0.05);
}

.hover\\:border-scarlet-200\\/50:hover{
  border-color: rgba(255, 192, 198, 0.5);
}

.hover\\:border-scarlet-200\\/55:hover{
  border-color: rgba(255, 192, 198, 0.55);
}

.hover\\:border-scarlet-200\\/60:hover{
  border-color: rgba(255, 192, 198, 0.6);
}

.hover\\:border-scarlet-200\\/65:hover{
  border-color: rgba(255, 192, 198, 0.65);
}

.hover\\:border-scarlet-200\\/70:hover{
  border-color: rgba(255, 192, 198, 0.7);
}

.hover\\:border-scarlet-200\\/75:hover{
  border-color: rgba(255, 192, 198, 0.75);
}

.hover\\:border-scarlet-200\\/80:hover{
  border-color: rgba(255, 192, 198, 0.8);
}

.hover\\:border-scarlet-200\\/85:hover{
  border-color: rgba(255, 192, 198, 0.85);
}

.hover\\:border-scarlet-200\\/90:hover{
  border-color: rgba(255, 192, 198, 0.9);
}

.hover\\:border-scarlet-200\\/95:hover{
  border-color: rgba(255, 192, 198, 0.95);
}

.hover\\:border-scarlet-300:hover{
  --tw-border-opacity: 1;
  border-color: rgba(255, 148, 158, 1);
  border-color: rgba(255, 148, 158, var(--tw-border-opacity, 1));
}

.hover\\:border-scarlet-300\\/0:hover{
  border-color: rgba(255, 148, 158, 0);
}

.hover\\:border-scarlet-300\\/10:hover{
  border-color: rgba(255, 148, 158, 0.1);
}

.hover\\:border-scarlet-300\\/100:hover{
  border-color: rgb(255, 148, 158);
}

.hover\\:border-scarlet-300\\/15:hover{
  border-color: rgba(255, 148, 158, 0.15);
}

.hover\\:border-scarlet-300\\/20:hover{
  border-color: rgba(255, 148, 158, 0.2);
}

.hover\\:border-scarlet-300\\/25:hover{
  border-color: rgba(255, 148, 158, 0.25);
}

.hover\\:border-scarlet-300\\/30:hover{
  border-color: rgba(255, 148, 158, 0.3);
}

.hover\\:border-scarlet-300\\/35:hover{
  border-color: rgba(255, 148, 158, 0.35);
}

.hover\\:border-scarlet-300\\/40:hover{
  border-color: rgba(255, 148, 158, 0.4);
}

.hover\\:border-scarlet-300\\/45:hover{
  border-color: rgba(255, 148, 158, 0.45);
}

.hover\\:border-scarlet-300\\/5:hover{
  border-color: rgba(255, 148, 158, 0.05);
}

.hover\\:border-scarlet-300\\/50:hover{
  border-color: rgba(255, 148, 158, 0.5);
}

.hover\\:border-scarlet-300\\/55:hover{
  border-color: rgba(255, 148, 158, 0.55);
}

.hover\\:border-scarlet-300\\/60:hover{
  border-color: rgba(255, 148, 158, 0.6);
}

.hover\\:border-scarlet-300\\/65:hover{
  border-color: rgba(255, 148, 158, 0.65);
}

.hover\\:border-scarlet-300\\/70:hover{
  border-color: rgba(255, 148, 158, 0.7);
}

.hover\\:border-scarlet-300\\/75:hover{
  border-color: rgba(255, 148, 158, 0.75);
}

.hover\\:border-scarlet-300\\/80:hover{
  border-color: rgba(255, 148, 158, 0.8);
}

.hover\\:border-scarlet-300\\/85:hover{
  border-color: rgba(255, 148, 158, 0.85);
}

.hover\\:border-scarlet-300\\/90:hover{
  border-color: rgba(255, 148, 158, 0.9);
}

.hover\\:border-scarlet-300\\/95:hover{
  border-color: rgba(255, 148, 158, 0.95);
}

.hover\\:border-scarlet-400:hover{
  --tw-border-opacity: 1;
  border-color: rgba(255, 86, 101, 1);
  border-color: rgba(255, 86, 101, var(--tw-border-opacity, 1));
}

.hover\\:border-scarlet-400\\/0:hover{
  border-color: rgba(255, 86, 101, 0);
}

.hover\\:border-scarlet-400\\/10:hover{
  border-color: rgba(255, 86, 101, 0.1);
}

.hover\\:border-scarlet-400\\/100:hover{
  border-color: rgb(255, 86, 101);
}

.hover\\:border-scarlet-400\\/15:hover{
  border-color: rgba(255, 86, 101, 0.15);
}

.hover\\:border-scarlet-400\\/20:hover{
  border-color: rgba(255, 86, 101, 0.2);
}

.hover\\:border-scarlet-400\\/25:hover{
  border-color: rgba(255, 86, 101, 0.25);
}

.hover\\:border-scarlet-400\\/30:hover{
  border-color: rgba(255, 86, 101, 0.3);
}

.hover\\:border-scarlet-400\\/35:hover{
  border-color: rgba(255, 86, 101, 0.35);
}

.hover\\:border-scarlet-400\\/40:hover{
  border-color: rgba(255, 86, 101, 0.4);
}

.hover\\:border-scarlet-400\\/45:hover{
  border-color: rgba(255, 86, 101, 0.45);
}

.hover\\:border-scarlet-400\\/5:hover{
  border-color: rgba(255, 86, 101, 0.05);
}

.hover\\:border-scarlet-400\\/50:hover{
  border-color: rgba(255, 86, 101, 0.5);
}

.hover\\:border-scarlet-400\\/55:hover{
  border-color: rgba(255, 86, 101, 0.55);
}

.hover\\:border-scarlet-400\\/60:hover{
  border-color: rgba(255, 86, 101, 0.6);
}

.hover\\:border-scarlet-400\\/65:hover{
  border-color: rgba(255, 86, 101, 0.65);
}

.hover\\:border-scarlet-400\\/70:hover{
  border-color: rgba(255, 86, 101, 0.7);
}

.hover\\:border-scarlet-400\\/75:hover{
  border-color: rgba(255, 86, 101, 0.75);
}

.hover\\:border-scarlet-400\\/80:hover{
  border-color: rgba(255, 86, 101, 0.8);
}

.hover\\:border-scarlet-400\\/85:hover{
  border-color: rgba(255, 86, 101, 0.85);
}

.hover\\:border-scarlet-400\\/90:hover{
  border-color: rgba(255, 86, 101, 0.9);
}

.hover\\:border-scarlet-400\\/95:hover{
  border-color: rgba(255, 86, 101, 0.95);
}

.hover\\:border-scarlet-500:hover{
  --tw-border-opacity: 1;
  border-color: rgba(255, 34, 54, 1);
  border-color: rgba(255, 34, 54, var(--tw-border-opacity, 1));
}

.hover\\:border-scarlet-500\\/0:hover{
  border-color: rgba(255, 34, 54, 0);
}

.hover\\:border-scarlet-500\\/10:hover{
  border-color: rgba(255, 34, 54, 0.1);
}

.hover\\:border-scarlet-500\\/100:hover{
  border-color: rgb(255, 34, 54);
}

.hover\\:border-scarlet-500\\/15:hover{
  border-color: rgba(255, 34, 54, 0.15);
}

.hover\\:border-scarlet-500\\/20:hover{
  border-color: rgba(255, 34, 54, 0.2);
}

.hover\\:border-scarlet-500\\/25:hover{
  border-color: rgba(255, 34, 54, 0.25);
}

.hover\\:border-scarlet-500\\/30:hover{
  border-color: rgba(255, 34, 54, 0.3);
}

.hover\\:border-scarlet-500\\/35:hover{
  border-color: rgba(255, 34, 54, 0.35);
}

.hover\\:border-scarlet-500\\/40:hover{
  border-color: rgba(255, 34, 54, 0.4);
}

.hover\\:border-scarlet-500\\/45:hover{
  border-color: rgba(255, 34, 54, 0.45);
}

.hover\\:border-scarlet-500\\/5:hover{
  border-color: rgba(255, 34, 54, 0.05);
}

.hover\\:border-scarlet-500\\/50:hover{
  border-color: rgba(255, 34, 54, 0.5);
}

.hover\\:border-scarlet-500\\/55:hover{
  border-color: rgba(255, 34, 54, 0.55);
}

.hover\\:border-scarlet-500\\/60:hover{
  border-color: rgba(255, 34, 54, 0.6);
}

.hover\\:border-scarlet-500\\/65:hover{
  border-color: rgba(255, 34, 54, 0.65);
}

.hover\\:border-scarlet-500\\/70:hover{
  border-color: rgba(255, 34, 54, 0.7);
}

.hover\\:border-scarlet-500\\/75:hover{
  border-color: rgba(255, 34, 54, 0.75);
}

.hover\\:border-scarlet-500\\/80:hover{
  border-color: rgba(255, 34, 54, 0.8);
}

.hover\\:border-scarlet-500\\/85:hover{
  border-color: rgba(255, 34, 54, 0.85);
}

.hover\\:border-scarlet-500\\/90:hover{
  border-color: rgba(255, 34, 54, 0.9);
}

.hover\\:border-scarlet-500\\/95:hover{
  border-color: rgba(255, 34, 54, 0.95);
}

.hover\\:border-scarlet-600:hover{
  --tw-border-opacity: 1;
  border-color: rgba(255, 2, 25, 1);
  border-color: rgba(255, 2, 25, var(--tw-border-opacity, 1));
}

.hover\\:border-scarlet-600\\/0:hover{
  border-color: rgba(255, 2, 25, 0);
}

.hover\\:border-scarlet-600\\/10:hover{
  border-color: rgba(255, 2, 25, 0.1);
}

.hover\\:border-scarlet-600\\/100:hover{
  border-color: rgb(255, 2, 25);
}

.hover\\:border-scarlet-600\\/15:hover{
  border-color: rgba(255, 2, 25, 0.15);
}

.hover\\:border-scarlet-600\\/20:hover{
  border-color: rgba(255, 2, 25, 0.2);
}

.hover\\:border-scarlet-600\\/25:hover{
  border-color: rgba(255, 2, 25, 0.25);
}

.hover\\:border-scarlet-600\\/30:hover{
  border-color: rgba(255, 2, 25, 0.3);
}

.hover\\:border-scarlet-600\\/35:hover{
  border-color: rgba(255, 2, 25, 0.35);
}

.hover\\:border-scarlet-600\\/40:hover{
  border-color: rgba(255, 2, 25, 0.4);
}

.hover\\:border-scarlet-600\\/45:hover{
  border-color: rgba(255, 2, 25, 0.45);
}

.hover\\:border-scarlet-600\\/5:hover{
  border-color: rgba(255, 2, 25, 0.05);
}

.hover\\:border-scarlet-600\\/50:hover{
  border-color: rgba(255, 2, 25, 0.5);
}

.hover\\:border-scarlet-600\\/55:hover{
  border-color: rgba(255, 2, 25, 0.55);
}

.hover\\:border-scarlet-600\\/60:hover{
  border-color: rgba(255, 2, 25, 0.6);
}

.hover\\:border-scarlet-600\\/65:hover{
  border-color: rgba(255, 2, 25, 0.65);
}

.hover\\:border-scarlet-600\\/70:hover{
  border-color: rgba(255, 2, 25, 0.7);
}

.hover\\:border-scarlet-600\\/75:hover{
  border-color: rgba(255, 2, 25, 0.75);
}

.hover\\:border-scarlet-600\\/80:hover{
  border-color: rgba(255, 2, 25, 0.8);
}

.hover\\:border-scarlet-600\\/85:hover{
  border-color: rgba(255, 2, 25, 0.85);
}

.hover\\:border-scarlet-600\\/90:hover{
  border-color: rgba(255, 2, 25, 0.9);
}

.hover\\:border-scarlet-600\\/95:hover{
  border-color: rgba(255, 2, 25, 0.95);
}

.hover\\:border-scarlet-700:hover{
  --tw-border-opacity: 1;
  border-color: rgba(216, 0, 19, 1);
  border-color: rgba(216, 0, 19, var(--tw-border-opacity, 1));
}

.hover\\:border-scarlet-700\\/0:hover{
  border-color: rgba(216, 0, 19, 0);
}

.hover\\:border-scarlet-700\\/10:hover{
  border-color: rgba(216, 0, 19, 0.1);
}

.hover\\:border-scarlet-700\\/100:hover{
  border-color: rgb(216, 0, 19);
}

.hover\\:border-scarlet-700\\/15:hover{
  border-color: rgba(216, 0, 19, 0.15);
}

.hover\\:border-scarlet-700\\/20:hover{
  border-color: rgba(216, 0, 19, 0.2);
}

.hover\\:border-scarlet-700\\/25:hover{
  border-color: rgba(216, 0, 19, 0.25);
}

.hover\\:border-scarlet-700\\/30:hover{
  border-color: rgba(216, 0, 19, 0.3);
}

.hover\\:border-scarlet-700\\/35:hover{
  border-color: rgba(216, 0, 19, 0.35);
}

.hover\\:border-scarlet-700\\/40:hover{
  border-color: rgba(216, 0, 19, 0.4);
}

.hover\\:border-scarlet-700\\/45:hover{
  border-color: rgba(216, 0, 19, 0.45);
}

.hover\\:border-scarlet-700\\/5:hover{
  border-color: rgba(216, 0, 19, 0.05);
}

.hover\\:border-scarlet-700\\/50:hover{
  border-color: rgba(216, 0, 19, 0.5);
}

.hover\\:border-scarlet-700\\/55:hover{
  border-color: rgba(216, 0, 19, 0.55);
}

.hover\\:border-scarlet-700\\/60:hover{
  border-color: rgba(216, 0, 19, 0.6);
}

.hover\\:border-scarlet-700\\/65:hover{
  border-color: rgba(216, 0, 19, 0.65);
}

.hover\\:border-scarlet-700\\/70:hover{
  border-color: rgba(216, 0, 19, 0.7);
}

.hover\\:border-scarlet-700\\/75:hover{
  border-color: rgba(216, 0, 19, 0.75);
}

.hover\\:border-scarlet-700\\/80:hover{
  border-color: rgba(216, 0, 19, 0.8);
}

.hover\\:border-scarlet-700\\/85:hover{
  border-color: rgba(216, 0, 19, 0.85);
}

.hover\\:border-scarlet-700\\/90:hover{
  border-color: rgba(216, 0, 19, 0.9);
}

.hover\\:border-scarlet-700\\/95:hover{
  border-color: rgba(216, 0, 19, 0.95);
}

.hover\\:border-scarlet-800:hover{
  --tw-border-opacity: 1;
  border-color: rgba(180, 2, 18, 1);
  border-color: rgba(180, 2, 18, var(--tw-border-opacity, 1));
}

.hover\\:border-scarlet-800\\/0:hover{
  border-color: rgba(180, 2, 18, 0);
}

.hover\\:border-scarlet-800\\/10:hover{
  border-color: rgba(180, 2, 18, 0.1);
}

.hover\\:border-scarlet-800\\/100:hover{
  border-color: rgb(180, 2, 18);
}

.hover\\:border-scarlet-800\\/15:hover{
  border-color: rgba(180, 2, 18, 0.15);
}

.hover\\:border-scarlet-800\\/20:hover{
  border-color: rgba(180, 2, 18, 0.2);
}

.hover\\:border-scarlet-800\\/25:hover{
  border-color: rgba(180, 2, 18, 0.25);
}

.hover\\:border-scarlet-800\\/30:hover{
  border-color: rgba(180, 2, 18, 0.3);
}

.hover\\:border-scarlet-800\\/35:hover{
  border-color: rgba(180, 2, 18, 0.35);
}

.hover\\:border-scarlet-800\\/40:hover{
  border-color: rgba(180, 2, 18, 0.4);
}

.hover\\:border-scarlet-800\\/45:hover{
  border-color: rgba(180, 2, 18, 0.45);
}

.hover\\:border-scarlet-800\\/5:hover{
  border-color: rgba(180, 2, 18, 0.05);
}

.hover\\:border-scarlet-800\\/50:hover{
  border-color: rgba(180, 2, 18, 0.5);
}

.hover\\:border-scarlet-800\\/55:hover{
  border-color: rgba(180, 2, 18, 0.55);
}

.hover\\:border-scarlet-800\\/60:hover{
  border-color: rgba(180, 2, 18, 0.6);
}

.hover\\:border-scarlet-800\\/65:hover{
  border-color: rgba(180, 2, 18, 0.65);
}

.hover\\:border-scarlet-800\\/70:hover{
  border-color: rgba(180, 2, 18, 0.7);
}

.hover\\:border-scarlet-800\\/75:hover{
  border-color: rgba(180, 2, 18, 0.75);
}

.hover\\:border-scarlet-800\\/80:hover{
  border-color: rgba(180, 2, 18, 0.8);
}

.hover\\:border-scarlet-800\\/85:hover{
  border-color: rgba(180, 2, 18, 0.85);
}

.hover\\:border-scarlet-800\\/90:hover{
  border-color: rgba(180, 2, 18, 0.9);
}

.hover\\:border-scarlet-800\\/95:hover{
  border-color: rgba(180, 2, 18, 0.95);
}

.hover\\:border-scarlet-900:hover{
  --tw-border-opacity: 1;
  border-color: rgba(146, 10, 22, 1);
  border-color: rgba(146, 10, 22, var(--tw-border-opacity, 1));
}

.hover\\:border-scarlet-900\\/0:hover{
  border-color: rgba(146, 10, 22, 0);
}

.hover\\:border-scarlet-900\\/10:hover{
  border-color: rgba(146, 10, 22, 0.1);
}

.hover\\:border-scarlet-900\\/100:hover{
  border-color: rgb(146, 10, 22);
}

.hover\\:border-scarlet-900\\/15:hover{
  border-color: rgba(146, 10, 22, 0.15);
}

.hover\\:border-scarlet-900\\/20:hover{
  border-color: rgba(146, 10, 22, 0.2);
}

.hover\\:border-scarlet-900\\/25:hover{
  border-color: rgba(146, 10, 22, 0.25);
}

.hover\\:border-scarlet-900\\/30:hover{
  border-color: rgba(146, 10, 22, 0.3);
}

.hover\\:border-scarlet-900\\/35:hover{
  border-color: rgba(146, 10, 22, 0.35);
}

.hover\\:border-scarlet-900\\/40:hover{
  border-color: rgba(146, 10, 22, 0.4);
}

.hover\\:border-scarlet-900\\/45:hover{
  border-color: rgba(146, 10, 22, 0.45);
}

.hover\\:border-scarlet-900\\/5:hover{
  border-color: rgba(146, 10, 22, 0.05);
}

.hover\\:border-scarlet-900\\/50:hover{
  border-color: rgba(146, 10, 22, 0.5);
}

.hover\\:border-scarlet-900\\/55:hover{
  border-color: rgba(146, 10, 22, 0.55);
}

.hover\\:border-scarlet-900\\/60:hover{
  border-color: rgba(146, 10, 22, 0.6);
}

.hover\\:border-scarlet-900\\/65:hover{
  border-color: rgba(146, 10, 22, 0.65);
}

.hover\\:border-scarlet-900\\/70:hover{
  border-color: rgba(146, 10, 22, 0.7);
}

.hover\\:border-scarlet-900\\/75:hover{
  border-color: rgba(146, 10, 22, 0.75);
}

.hover\\:border-scarlet-900\\/80:hover{
  border-color: rgba(146, 10, 22, 0.8);
}

.hover\\:border-scarlet-900\\/85:hover{
  border-color: rgba(146, 10, 22, 0.85);
}

.hover\\:border-scarlet-900\\/90:hover{
  border-color: rgba(146, 10, 22, 0.9);
}

.hover\\:border-scarlet-900\\/95:hover{
  border-color: rgba(146, 10, 22, 0.95);
}

.hover\\:border-scarlet-950:hover{
  --tw-border-opacity: 1;
  border-color: rgba(81, 0, 7, 1);
  border-color: rgba(81, 0, 7, var(--tw-border-opacity, 1));
}

.hover\\:border-scarlet-950\\/0:hover{
  border-color: rgba(81, 0, 7, 0);
}

.hover\\:border-scarlet-950\\/10:hover{
  border-color: rgba(81, 0, 7, 0.1);
}

.hover\\:border-scarlet-950\\/100:hover{
  border-color: rgb(81, 0, 7);
}

.hover\\:border-scarlet-950\\/15:hover{
  border-color: rgba(81, 0, 7, 0.15);
}

.hover\\:border-scarlet-950\\/20:hover{
  border-color: rgba(81, 0, 7, 0.2);
}

.hover\\:border-scarlet-950\\/25:hover{
  border-color: rgba(81, 0, 7, 0.25);
}

.hover\\:border-scarlet-950\\/30:hover{
  border-color: rgba(81, 0, 7, 0.3);
}

.hover\\:border-scarlet-950\\/35:hover{
  border-color: rgba(81, 0, 7, 0.35);
}

.hover\\:border-scarlet-950\\/40:hover{
  border-color: rgba(81, 0, 7, 0.4);
}

.hover\\:border-scarlet-950\\/45:hover{
  border-color: rgba(81, 0, 7, 0.45);
}

.hover\\:border-scarlet-950\\/5:hover{
  border-color: rgba(81, 0, 7, 0.05);
}

.hover\\:border-scarlet-950\\/50:hover{
  border-color: rgba(81, 0, 7, 0.5);
}

.hover\\:border-scarlet-950\\/55:hover{
  border-color: rgba(81, 0, 7, 0.55);
}

.hover\\:border-scarlet-950\\/60:hover{
  border-color: rgba(81, 0, 7, 0.6);
}

.hover\\:border-scarlet-950\\/65:hover{
  border-color: rgba(81, 0, 7, 0.65);
}

.hover\\:border-scarlet-950\\/70:hover{
  border-color: rgba(81, 0, 7, 0.7);
}

.hover\\:border-scarlet-950\\/75:hover{
  border-color: rgba(81, 0, 7, 0.75);
}

.hover\\:border-scarlet-950\\/80:hover{
  border-color: rgba(81, 0, 7, 0.8);
}

.hover\\:border-scarlet-950\\/85:hover{
  border-color: rgba(81, 0, 7, 0.85);
}

.hover\\:border-scarlet-950\\/90:hover{
  border-color: rgba(81, 0, 7, 0.9);
}

.hover\\:border-scarlet-950\\/95:hover{
  border-color: rgba(81, 0, 7, 0.95);
}

.hover\\:border-song-color-100:hover{
  --tw-border-opacity: 1;
  border-color: rgba(255, 220, 223, 1);
  border-color: rgba(255, 220, 223, var(--tw-border-opacity, 1));
}

.hover\\:border-song-color-100\\/0:hover{
  border-color: rgba(255, 220, 223, 0);
}

.hover\\:border-song-color-100\\/10:hover{
  border-color: rgba(255, 220, 223, 0.1);
}

.hover\\:border-song-color-100\\/100:hover{
  border-color: rgb(255, 220, 223);
}

.hover\\:border-song-color-100\\/15:hover{
  border-color: rgba(255, 220, 223, 0.15);
}

.hover\\:border-song-color-100\\/20:hover{
  border-color: rgba(255, 220, 223, 0.2);
}

.hover\\:border-song-color-100\\/25:hover{
  border-color: rgba(255, 220, 223, 0.25);
}

.hover\\:border-song-color-100\\/30:hover{
  border-color: rgba(255, 220, 223, 0.3);
}

.hover\\:border-song-color-100\\/35:hover{
  border-color: rgba(255, 220, 223, 0.35);
}

.hover\\:border-song-color-100\\/40:hover{
  border-color: rgba(255, 220, 223, 0.4);
}

.hover\\:border-song-color-100\\/45:hover{
  border-color: rgba(255, 220, 223, 0.45);
}

.hover\\:border-song-color-100\\/5:hover{
  border-color: rgba(255, 220, 223, 0.05);
}

.hover\\:border-song-color-100\\/50:hover{
  border-color: rgba(255, 220, 223, 0.5);
}

.hover\\:border-song-color-100\\/55:hover{
  border-color: rgba(255, 220, 223, 0.55);
}

.hover\\:border-song-color-100\\/60:hover{
  border-color: rgba(255, 220, 223, 0.6);
}

.hover\\:border-song-color-100\\/65:hover{
  border-color: rgba(255, 220, 223, 0.65);
}

.hover\\:border-song-color-100\\/70:hover{
  border-color: rgba(255, 220, 223, 0.7);
}

.hover\\:border-song-color-100\\/75:hover{
  border-color: rgba(255, 220, 223, 0.75);
}

.hover\\:border-song-color-100\\/80:hover{
  border-color: rgba(255, 220, 223, 0.8);
}

.hover\\:border-song-color-100\\/85:hover{
  border-color: rgba(255, 220, 223, 0.85);
}

.hover\\:border-song-color-100\\/90:hover{
  border-color: rgba(255, 220, 223, 0.9);
}

.hover\\:border-song-color-100\\/95:hover{
  border-color: rgba(255, 220, 223, 0.95);
}

.hover\\:border-song-color-200:hover{
  --tw-border-opacity: 1;
  border-color: rgba(255, 192, 198, 1);
  border-color: rgba(255, 192, 198, var(--tw-border-opacity, 1));
}

.hover\\:border-song-color-200\\/0:hover{
  border-color: rgba(255, 192, 198, 0);
}

.hover\\:border-song-color-200\\/10:hover{
  border-color: rgba(255, 192, 198, 0.1);
}

.hover\\:border-song-color-200\\/100:hover{
  border-color: rgb(255, 192, 198);
}

.hover\\:border-song-color-200\\/15:hover{
  border-color: rgba(255, 192, 198, 0.15);
}

.hover\\:border-song-color-200\\/20:hover{
  border-color: rgba(255, 192, 198, 0.2);
}

.hover\\:border-song-color-200\\/25:hover{
  border-color: rgba(255, 192, 198, 0.25);
}

.hover\\:border-song-color-200\\/30:hover{
  border-color: rgba(255, 192, 198, 0.3);
}

.hover\\:border-song-color-200\\/35:hover{
  border-color: rgba(255, 192, 198, 0.35);
}

.hover\\:border-song-color-200\\/40:hover{
  border-color: rgba(255, 192, 198, 0.4);
}

.hover\\:border-song-color-200\\/45:hover{
  border-color: rgba(255, 192, 198, 0.45);
}

.hover\\:border-song-color-200\\/5:hover{
  border-color: rgba(255, 192, 198, 0.05);
}

.hover\\:border-song-color-200\\/50:hover{
  border-color: rgba(255, 192, 198, 0.5);
}

.hover\\:border-song-color-200\\/55:hover{
  border-color: rgba(255, 192, 198, 0.55);
}

.hover\\:border-song-color-200\\/60:hover{
  border-color: rgba(255, 192, 198, 0.6);
}

.hover\\:border-song-color-200\\/65:hover{
  border-color: rgba(255, 192, 198, 0.65);
}

.hover\\:border-song-color-200\\/70:hover{
  border-color: rgba(255, 192, 198, 0.7);
}

.hover\\:border-song-color-200\\/75:hover{
  border-color: rgba(255, 192, 198, 0.75);
}

.hover\\:border-song-color-200\\/80:hover{
  border-color: rgba(255, 192, 198, 0.8);
}

.hover\\:border-song-color-200\\/85:hover{
  border-color: rgba(255, 192, 198, 0.85);
}

.hover\\:border-song-color-200\\/90:hover{
  border-color: rgba(255, 192, 198, 0.9);
}

.hover\\:border-song-color-200\\/95:hover{
  border-color: rgba(255, 192, 198, 0.95);
}

.hover\\:border-song-color-300:hover{
  --tw-border-opacity: 1;
  border-color: rgba(255, 148, 158, 1);
  border-color: rgba(255, 148, 158, var(--tw-border-opacity, 1));
}

.hover\\:border-song-color-300\\/0:hover{
  border-color: rgba(255, 148, 158, 0);
}

.hover\\:border-song-color-300\\/10:hover{
  border-color: rgba(255, 148, 158, 0.1);
}

.hover\\:border-song-color-300\\/100:hover{
  border-color: rgb(255, 148, 158);
}

.hover\\:border-song-color-300\\/15:hover{
  border-color: rgba(255, 148, 158, 0.15);
}

.hover\\:border-song-color-300\\/20:hover{
  border-color: rgba(255, 148, 158, 0.2);
}

.hover\\:border-song-color-300\\/25:hover{
  border-color: rgba(255, 148, 158, 0.25);
}

.hover\\:border-song-color-300\\/30:hover{
  border-color: rgba(255, 148, 158, 0.3);
}

.hover\\:border-song-color-300\\/35:hover{
  border-color: rgba(255, 148, 158, 0.35);
}

.hover\\:border-song-color-300\\/40:hover{
  border-color: rgba(255, 148, 158, 0.4);
}

.hover\\:border-song-color-300\\/45:hover{
  border-color: rgba(255, 148, 158, 0.45);
}

.hover\\:border-song-color-300\\/5:hover{
  border-color: rgba(255, 148, 158, 0.05);
}

.hover\\:border-song-color-300\\/50:hover{
  border-color: rgba(255, 148, 158, 0.5);
}

.hover\\:border-song-color-300\\/55:hover{
  border-color: rgba(255, 148, 158, 0.55);
}

.hover\\:border-song-color-300\\/60:hover{
  border-color: rgba(255, 148, 158, 0.6);
}

.hover\\:border-song-color-300\\/65:hover{
  border-color: rgba(255, 148, 158, 0.65);
}

.hover\\:border-song-color-300\\/70:hover{
  border-color: rgba(255, 148, 158, 0.7);
}

.hover\\:border-song-color-300\\/75:hover{
  border-color: rgba(255, 148, 158, 0.75);
}

.hover\\:border-song-color-300\\/80:hover{
  border-color: rgba(255, 148, 158, 0.8);
}

.hover\\:border-song-color-300\\/85:hover{
  border-color: rgba(255, 148, 158, 0.85);
}

.hover\\:border-song-color-300\\/90:hover{
  border-color: rgba(255, 148, 158, 0.9);
}

.hover\\:border-song-color-300\\/95:hover{
  border-color: rgba(255, 148, 158, 0.95);
}

.hover\\:border-song-color-400:hover{
  --tw-border-opacity: 1;
  border-color: rgba(255, 86, 101, 1);
  border-color: rgba(255, 86, 101, var(--tw-border-opacity, 1));
}

.hover\\:border-song-color-400\\/0:hover{
  border-color: rgba(255, 86, 101, 0);
}

.hover\\:border-song-color-400\\/10:hover{
  border-color: rgba(255, 86, 101, 0.1);
}

.hover\\:border-song-color-400\\/100:hover{
  border-color: rgb(255, 86, 101);
}

.hover\\:border-song-color-400\\/15:hover{
  border-color: rgba(255, 86, 101, 0.15);
}

.hover\\:border-song-color-400\\/20:hover{
  border-color: rgba(255, 86, 101, 0.2);
}

.hover\\:border-song-color-400\\/25:hover{
  border-color: rgba(255, 86, 101, 0.25);
}

.hover\\:border-song-color-400\\/30:hover{
  border-color: rgba(255, 86, 101, 0.3);
}

.hover\\:border-song-color-400\\/35:hover{
  border-color: rgba(255, 86, 101, 0.35);
}

.hover\\:border-song-color-400\\/40:hover{
  border-color: rgba(255, 86, 101, 0.4);
}

.hover\\:border-song-color-400\\/45:hover{
  border-color: rgba(255, 86, 101, 0.45);
}

.hover\\:border-song-color-400\\/5:hover{
  border-color: rgba(255, 86, 101, 0.05);
}

.hover\\:border-song-color-400\\/50:hover{
  border-color: rgba(255, 86, 101, 0.5);
}

.hover\\:border-song-color-400\\/55:hover{
  border-color: rgba(255, 86, 101, 0.55);
}

.hover\\:border-song-color-400\\/60:hover{
  border-color: rgba(255, 86, 101, 0.6);
}

.hover\\:border-song-color-400\\/65:hover{
  border-color: rgba(255, 86, 101, 0.65);
}

.hover\\:border-song-color-400\\/70:hover{
  border-color: rgba(255, 86, 101, 0.7);
}

.hover\\:border-song-color-400\\/75:hover{
  border-color: rgba(255, 86, 101, 0.75);
}

.hover\\:border-song-color-400\\/80:hover{
  border-color: rgba(255, 86, 101, 0.8);
}

.hover\\:border-song-color-400\\/85:hover{
  border-color: rgba(255, 86, 101, 0.85);
}

.hover\\:border-song-color-400\\/90:hover{
  border-color: rgba(255, 86, 101, 0.9);
}

.hover\\:border-song-color-400\\/95:hover{
  border-color: rgba(255, 86, 101, 0.95);
}

.hover\\:border-song-color-500:hover{
  --tw-border-opacity: 1;
  border-color: rgba(255, 34, 54, 1);
  border-color: rgba(255, 34, 54, var(--tw-border-opacity, 1));
}

.hover\\:border-song-color-500\\/0:hover{
  border-color: rgba(255, 34, 54, 0);
}

.hover\\:border-song-color-500\\/10:hover{
  border-color: rgba(255, 34, 54, 0.1);
}

.hover\\:border-song-color-500\\/100:hover{
  border-color: rgb(255, 34, 54);
}

.hover\\:border-song-color-500\\/15:hover{
  border-color: rgba(255, 34, 54, 0.15);
}

.hover\\:border-song-color-500\\/20:hover{
  border-color: rgba(255, 34, 54, 0.2);
}

.hover\\:border-song-color-500\\/25:hover{
  border-color: rgba(255, 34, 54, 0.25);
}

.hover\\:border-song-color-500\\/30:hover{
  border-color: rgba(255, 34, 54, 0.3);
}

.hover\\:border-song-color-500\\/35:hover{
  border-color: rgba(255, 34, 54, 0.35);
}

.hover\\:border-song-color-500\\/40:hover{
  border-color: rgba(255, 34, 54, 0.4);
}

.hover\\:border-song-color-500\\/45:hover{
  border-color: rgba(255, 34, 54, 0.45);
}

.hover\\:border-song-color-500\\/5:hover{
  border-color: rgba(255, 34, 54, 0.05);
}

.hover\\:border-song-color-500\\/50:hover{
  border-color: rgba(255, 34, 54, 0.5);
}

.hover\\:border-song-color-500\\/55:hover{
  border-color: rgba(255, 34, 54, 0.55);
}

.hover\\:border-song-color-500\\/60:hover{
  border-color: rgba(255, 34, 54, 0.6);
}

.hover\\:border-song-color-500\\/65:hover{
  border-color: rgba(255, 34, 54, 0.65);
}

.hover\\:border-song-color-500\\/70:hover{
  border-color: rgba(255, 34, 54, 0.7);
}

.hover\\:border-song-color-500\\/75:hover{
  border-color: rgba(255, 34, 54, 0.75);
}

.hover\\:border-song-color-500\\/80:hover{
  border-color: rgba(255, 34, 54, 0.8);
}

.hover\\:border-song-color-500\\/85:hover{
  border-color: rgba(255, 34, 54, 0.85);
}

.hover\\:border-song-color-500\\/90:hover{
  border-color: rgba(255, 34, 54, 0.9);
}

.hover\\:border-song-color-500\\/95:hover{
  border-color: rgba(255, 34, 54, 0.95);
}

.hover\\:border-song-color-600:hover{
  --tw-border-opacity: 1;
  border-color: rgba(255, 2, 25, 1);
  border-color: rgba(255, 2, 25, var(--tw-border-opacity, 1));
}

.hover\\:border-song-color-600\\/0:hover{
  border-color: rgba(255, 2, 25, 0);
}

.hover\\:border-song-color-600\\/10:hover{
  border-color: rgba(255, 2, 25, 0.1);
}

.hover\\:border-song-color-600\\/100:hover{
  border-color: rgb(255, 2, 25);
}

.hover\\:border-song-color-600\\/15:hover{
  border-color: rgba(255, 2, 25, 0.15);
}

.hover\\:border-song-color-600\\/20:hover{
  border-color: rgba(255, 2, 25, 0.2);
}

.hover\\:border-song-color-600\\/25:hover{
  border-color: rgba(255, 2, 25, 0.25);
}

.hover\\:border-song-color-600\\/30:hover{
  border-color: rgba(255, 2, 25, 0.3);
}

.hover\\:border-song-color-600\\/35:hover{
  border-color: rgba(255, 2, 25, 0.35);
}

.hover\\:border-song-color-600\\/40:hover{
  border-color: rgba(255, 2, 25, 0.4);
}

.hover\\:border-song-color-600\\/45:hover{
  border-color: rgba(255, 2, 25, 0.45);
}

.hover\\:border-song-color-600\\/5:hover{
  border-color: rgba(255, 2, 25, 0.05);
}

.hover\\:border-song-color-600\\/50:hover{
  border-color: rgba(255, 2, 25, 0.5);
}

.hover\\:border-song-color-600\\/55:hover{
  border-color: rgba(255, 2, 25, 0.55);
}

.hover\\:border-song-color-600\\/60:hover{
  border-color: rgba(255, 2, 25, 0.6);
}

.hover\\:border-song-color-600\\/65:hover{
  border-color: rgba(255, 2, 25, 0.65);
}

.hover\\:border-song-color-600\\/70:hover{
  border-color: rgba(255, 2, 25, 0.7);
}

.hover\\:border-song-color-600\\/75:hover{
  border-color: rgba(255, 2, 25, 0.75);
}

.hover\\:border-song-color-600\\/80:hover{
  border-color: rgba(255, 2, 25, 0.8);
}

.hover\\:border-song-color-600\\/85:hover{
  border-color: rgba(255, 2, 25, 0.85);
}

.hover\\:border-song-color-600\\/90:hover{
  border-color: rgba(255, 2, 25, 0.9);
}

.hover\\:border-song-color-600\\/95:hover{
  border-color: rgba(255, 2, 25, 0.95);
}

.hover\\:border-song-color-700:hover{
  --tw-border-opacity: 1;
  border-color: rgba(216, 0, 19, 1);
  border-color: rgba(216, 0, 19, var(--tw-border-opacity, 1));
}

.hover\\:border-song-color-700\\/0:hover{
  border-color: rgba(216, 0, 19, 0);
}

.hover\\:border-song-color-700\\/10:hover{
  border-color: rgba(216, 0, 19, 0.1);
}

.hover\\:border-song-color-700\\/100:hover{
  border-color: rgb(216, 0, 19);
}

.hover\\:border-song-color-700\\/15:hover{
  border-color: rgba(216, 0, 19, 0.15);
}

.hover\\:border-song-color-700\\/20:hover{
  border-color: rgba(216, 0, 19, 0.2);
}

.hover\\:border-song-color-700\\/25:hover{
  border-color: rgba(216, 0, 19, 0.25);
}

.hover\\:border-song-color-700\\/30:hover{
  border-color: rgba(216, 0, 19, 0.3);
}

.hover\\:border-song-color-700\\/35:hover{
  border-color: rgba(216, 0, 19, 0.35);
}

.hover\\:border-song-color-700\\/40:hover{
  border-color: rgba(216, 0, 19, 0.4);
}

.hover\\:border-song-color-700\\/45:hover{
  border-color: rgba(216, 0, 19, 0.45);
}

.hover\\:border-song-color-700\\/5:hover{
  border-color: rgba(216, 0, 19, 0.05);
}

.hover\\:border-song-color-700\\/50:hover{
  border-color: rgba(216, 0, 19, 0.5);
}

.hover\\:border-song-color-700\\/55:hover{
  border-color: rgba(216, 0, 19, 0.55);
}

.hover\\:border-song-color-700\\/60:hover{
  border-color: rgba(216, 0, 19, 0.6);
}

.hover\\:border-song-color-700\\/65:hover{
  border-color: rgba(216, 0, 19, 0.65);
}

.hover\\:border-song-color-700\\/70:hover{
  border-color: rgba(216, 0, 19, 0.7);
}

.hover\\:border-song-color-700\\/75:hover{
  border-color: rgba(216, 0, 19, 0.75);
}

.hover\\:border-song-color-700\\/80:hover{
  border-color: rgba(216, 0, 19, 0.8);
}

.hover\\:border-song-color-700\\/85:hover{
  border-color: rgba(216, 0, 19, 0.85);
}

.hover\\:border-song-color-700\\/90:hover{
  border-color: rgba(216, 0, 19, 0.9);
}

.hover\\:border-song-color-700\\/95:hover{
  border-color: rgba(216, 0, 19, 0.95);
}

.hover\\:border-song-color-800:hover{
  --tw-border-opacity: 1;
  border-color: rgba(180, 2, 18, 1);
  border-color: rgba(180, 2, 18, var(--tw-border-opacity, 1));
}

.hover\\:border-song-color-800\\/0:hover{
  border-color: rgba(180, 2, 18, 0);
}

.hover\\:border-song-color-800\\/10:hover{
  border-color: rgba(180, 2, 18, 0.1);
}

.hover\\:border-song-color-800\\/100:hover{
  border-color: rgb(180, 2, 18);
}

.hover\\:border-song-color-800\\/15:hover{
  border-color: rgba(180, 2, 18, 0.15);
}

.hover\\:border-song-color-800\\/20:hover{
  border-color: rgba(180, 2, 18, 0.2);
}

.hover\\:border-song-color-800\\/25:hover{
  border-color: rgba(180, 2, 18, 0.25);
}

.hover\\:border-song-color-800\\/30:hover{
  border-color: rgba(180, 2, 18, 0.3);
}

.hover\\:border-song-color-800\\/35:hover{
  border-color: rgba(180, 2, 18, 0.35);
}

.hover\\:border-song-color-800\\/40:hover{
  border-color: rgba(180, 2, 18, 0.4);
}

.hover\\:border-song-color-800\\/45:hover{
  border-color: rgba(180, 2, 18, 0.45);
}

.hover\\:border-song-color-800\\/5:hover{
  border-color: rgba(180, 2, 18, 0.05);
}

.hover\\:border-song-color-800\\/50:hover{
  border-color: rgba(180, 2, 18, 0.5);
}

.hover\\:border-song-color-800\\/55:hover{
  border-color: rgba(180, 2, 18, 0.55);
}

.hover\\:border-song-color-800\\/60:hover{
  border-color: rgba(180, 2, 18, 0.6);
}

.hover\\:border-song-color-800\\/65:hover{
  border-color: rgba(180, 2, 18, 0.65);
}

.hover\\:border-song-color-800\\/70:hover{
  border-color: rgba(180, 2, 18, 0.7);
}

.hover\\:border-song-color-800\\/75:hover{
  border-color: rgba(180, 2, 18, 0.75);
}

.hover\\:border-song-color-800\\/80:hover{
  border-color: rgba(180, 2, 18, 0.8);
}

.hover\\:border-song-color-800\\/85:hover{
  border-color: rgba(180, 2, 18, 0.85);
}

.hover\\:border-song-color-800\\/90:hover{
  border-color: rgba(180, 2, 18, 0.9);
}

.hover\\:border-song-color-800\\/95:hover{
  border-color: rgba(180, 2, 18, 0.95);
}

.hover\\:border-song-color-900:hover{
  --tw-border-opacity: 1;
  border-color: rgba(146, 10, 22, 1);
  border-color: rgba(146, 10, 22, var(--tw-border-opacity, 1));
}

.hover\\:border-song-color-900\\/0:hover{
  border-color: rgba(146, 10, 22, 0);
}

.hover\\:border-song-color-900\\/10:hover{
  border-color: rgba(146, 10, 22, 0.1);
}

.hover\\:border-song-color-900\\/100:hover{
  border-color: rgb(146, 10, 22);
}

.hover\\:border-song-color-900\\/15:hover{
  border-color: rgba(146, 10, 22, 0.15);
}

.hover\\:border-song-color-900\\/20:hover{
  border-color: rgba(146, 10, 22, 0.2);
}

.hover\\:border-song-color-900\\/25:hover{
  border-color: rgba(146, 10, 22, 0.25);
}

.hover\\:border-song-color-900\\/30:hover{
  border-color: rgba(146, 10, 22, 0.3);
}

.hover\\:border-song-color-900\\/35:hover{
  border-color: rgba(146, 10, 22, 0.35);
}

.hover\\:border-song-color-900\\/40:hover{
  border-color: rgba(146, 10, 22, 0.4);
}

.hover\\:border-song-color-900\\/45:hover{
  border-color: rgba(146, 10, 22, 0.45);
}

.hover\\:border-song-color-900\\/5:hover{
  border-color: rgba(146, 10, 22, 0.05);
}

.hover\\:border-song-color-900\\/50:hover{
  border-color: rgba(146, 10, 22, 0.5);
}

.hover\\:border-song-color-900\\/55:hover{
  border-color: rgba(146, 10, 22, 0.55);
}

.hover\\:border-song-color-900\\/60:hover{
  border-color: rgba(146, 10, 22, 0.6);
}

.hover\\:border-song-color-900\\/65:hover{
  border-color: rgba(146, 10, 22, 0.65);
}

.hover\\:border-song-color-900\\/70:hover{
  border-color: rgba(146, 10, 22, 0.7);
}

.hover\\:border-song-color-900\\/75:hover{
  border-color: rgba(146, 10, 22, 0.75);
}

.hover\\:border-song-color-900\\/80:hover{
  border-color: rgba(146, 10, 22, 0.8);
}

.hover\\:border-song-color-900\\/85:hover{
  border-color: rgba(146, 10, 22, 0.85);
}

.hover\\:border-song-color-900\\/90:hover{
  border-color: rgba(146, 10, 22, 0.9);
}

.hover\\:border-song-color-900\\/95:hover{
  border-color: rgba(146, 10, 22, 0.95);
}

.hover\\:border-song-color-950:hover{
  --tw-border-opacity: 1;
  border-color: rgba(81, 0, 7, 1);
  border-color: rgba(81, 0, 7, var(--tw-border-opacity, 1));
}

.hover\\:border-song-color-950\\/0:hover{
  border-color: rgba(81, 0, 7, 0);
}

.hover\\:border-song-color-950\\/10:hover{
  border-color: rgba(81, 0, 7, 0.1);
}

.hover\\:border-song-color-950\\/100:hover{
  border-color: rgb(81, 0, 7);
}

.hover\\:border-song-color-950\\/15:hover{
  border-color: rgba(81, 0, 7, 0.15);
}

.hover\\:border-song-color-950\\/20:hover{
  border-color: rgba(81, 0, 7, 0.2);
}

.hover\\:border-song-color-950\\/25:hover{
  border-color: rgba(81, 0, 7, 0.25);
}

.hover\\:border-song-color-950\\/30:hover{
  border-color: rgba(81, 0, 7, 0.3);
}

.hover\\:border-song-color-950\\/35:hover{
  border-color: rgba(81, 0, 7, 0.35);
}

.hover\\:border-song-color-950\\/40:hover{
  border-color: rgba(81, 0, 7, 0.4);
}

.hover\\:border-song-color-950\\/45:hover{
  border-color: rgba(81, 0, 7, 0.45);
}

.hover\\:border-song-color-950\\/5:hover{
  border-color: rgba(81, 0, 7, 0.05);
}

.hover\\:border-song-color-950\\/50:hover{
  border-color: rgba(81, 0, 7, 0.5);
}

.hover\\:border-song-color-950\\/55:hover{
  border-color: rgba(81, 0, 7, 0.55);
}

.hover\\:border-song-color-950\\/60:hover{
  border-color: rgba(81, 0, 7, 0.6);
}

.hover\\:border-song-color-950\\/65:hover{
  border-color: rgba(81, 0, 7, 0.65);
}

.hover\\:border-song-color-950\\/70:hover{
  border-color: rgba(81, 0, 7, 0.7);
}

.hover\\:border-song-color-950\\/75:hover{
  border-color: rgba(81, 0, 7, 0.75);
}

.hover\\:border-song-color-950\\/80:hover{
  border-color: rgba(81, 0, 7, 0.8);
}

.hover\\:border-song-color-950\\/85:hover{
  border-color: rgba(81, 0, 7, 0.85);
}

.hover\\:border-song-color-950\\/90:hover{
  border-color: rgba(81, 0, 7, 0.9);
}

.hover\\:border-song-color-950\\/95:hover{
  border-color: rgba(81, 0, 7, 0.95);
}

.hover\\:border-story-color-100:hover{
  --tw-border-opacity: 1;
  border-color: rgba(218, 238, 243, 1);
  border-color: rgba(218, 238, 243, var(--tw-border-opacity, 1));
}

.hover\\:border-story-color-100\\/0:hover{
  border-color: rgba(218, 238, 243, 0);
}

.hover\\:border-story-color-100\\/10:hover{
  border-color: rgba(218, 238, 243, 0.1);
}

.hover\\:border-story-color-100\\/100:hover{
  border-color: rgb(218, 238, 243);
}

.hover\\:border-story-color-100\\/15:hover{
  border-color: rgba(218, 238, 243, 0.15);
}

.hover\\:border-story-color-100\\/20:hover{
  border-color: rgba(218, 238, 243, 0.2);
}

.hover\\:border-story-color-100\\/25:hover{
  border-color: rgba(218, 238, 243, 0.25);
}

.hover\\:border-story-color-100\\/30:hover{
  border-color: rgba(218, 238, 243, 0.3);
}

.hover\\:border-story-color-100\\/35:hover{
  border-color: rgba(218, 238, 243, 0.35);
}

.hover\\:border-story-color-100\\/40:hover{
  border-color: rgba(218, 238, 243, 0.4);
}

.hover\\:border-story-color-100\\/45:hover{
  border-color: rgba(218, 238, 243, 0.45);
}

.hover\\:border-story-color-100\\/5:hover{
  border-color: rgba(218, 238, 243, 0.05);
}

.hover\\:border-story-color-100\\/50:hover{
  border-color: rgba(218, 238, 243, 0.5);
}

.hover\\:border-story-color-100\\/55:hover{
  border-color: rgba(218, 238, 243, 0.55);
}

.hover\\:border-story-color-100\\/60:hover{
  border-color: rgba(218, 238, 243, 0.6);
}

.hover\\:border-story-color-100\\/65:hover{
  border-color: rgba(218, 238, 243, 0.65);
}

.hover\\:border-story-color-100\\/70:hover{
  border-color: rgba(218, 238, 243, 0.7);
}

.hover\\:border-story-color-100\\/75:hover{
  border-color: rgba(218, 238, 243, 0.75);
}

.hover\\:border-story-color-100\\/80:hover{
  border-color: rgba(218, 238, 243, 0.8);
}

.hover\\:border-story-color-100\\/85:hover{
  border-color: rgba(218, 238, 243, 0.85);
}

.hover\\:border-story-color-100\\/90:hover{
  border-color: rgba(218, 238, 243, 0.9);
}

.hover\\:border-story-color-100\\/95:hover{
  border-color: rgba(218, 238, 243, 0.95);
}

.hover\\:border-story-color-200:hover{
  --tw-border-opacity: 1;
  border-color: rgba(186, 222, 231, 1);
  border-color: rgba(186, 222, 231, var(--tw-border-opacity, 1));
}

.hover\\:border-story-color-200\\/0:hover{
  border-color: rgba(186, 222, 231, 0);
}

.hover\\:border-story-color-200\\/10:hover{
  border-color: rgba(186, 222, 231, 0.1);
}

.hover\\:border-story-color-200\\/100:hover{
  border-color: rgb(186, 222, 231);
}

.hover\\:border-story-color-200\\/15:hover{
  border-color: rgba(186, 222, 231, 0.15);
}

.hover\\:border-story-color-200\\/20:hover{
  border-color: rgba(186, 222, 231, 0.2);
}

.hover\\:border-story-color-200\\/25:hover{
  border-color: rgba(186, 222, 231, 0.25);
}

.hover\\:border-story-color-200\\/30:hover{
  border-color: rgba(186, 222, 231, 0.3);
}

.hover\\:border-story-color-200\\/35:hover{
  border-color: rgba(186, 222, 231, 0.35);
}

.hover\\:border-story-color-200\\/40:hover{
  border-color: rgba(186, 222, 231, 0.4);
}

.hover\\:border-story-color-200\\/45:hover{
  border-color: rgba(186, 222, 231, 0.45);
}

.hover\\:border-story-color-200\\/5:hover{
  border-color: rgba(186, 222, 231, 0.05);
}

.hover\\:border-story-color-200\\/50:hover{
  border-color: rgba(186, 222, 231, 0.5);
}

.hover\\:border-story-color-200\\/55:hover{
  border-color: rgba(186, 222, 231, 0.55);
}

.hover\\:border-story-color-200\\/60:hover{
  border-color: rgba(186, 222, 231, 0.6);
}

.hover\\:border-story-color-200\\/65:hover{
  border-color: rgba(186, 222, 231, 0.65);
}

.hover\\:border-story-color-200\\/70:hover{
  border-color: rgba(186, 222, 231, 0.7);
}

.hover\\:border-story-color-200\\/75:hover{
  border-color: rgba(186, 222, 231, 0.75);
}

.hover\\:border-story-color-200\\/80:hover{
  border-color: rgba(186, 222, 231, 0.8);
}

.hover\\:border-story-color-200\\/85:hover{
  border-color: rgba(186, 222, 231, 0.85);
}

.hover\\:border-story-color-200\\/90:hover{
  border-color: rgba(186, 222, 231, 0.9);
}

.hover\\:border-story-color-200\\/95:hover{
  border-color: rgba(186, 222, 231, 0.95);
}

.hover\\:border-story-color-300:hover{
  --tw-border-opacity: 1;
  border-color: rgba(137, 197, 215, 1);
  border-color: rgba(137, 197, 215, var(--tw-border-opacity, 1));
}

.hover\\:border-story-color-300\\/0:hover{
  border-color: rgba(137, 197, 215, 0);
}

.hover\\:border-story-color-300\\/10:hover{
  border-color: rgba(137, 197, 215, 0.1);
}

.hover\\:border-story-color-300\\/100:hover{
  border-color: rgb(137, 197, 215);
}

.hover\\:border-story-color-300\\/15:hover{
  border-color: rgba(137, 197, 215, 0.15);
}

.hover\\:border-story-color-300\\/20:hover{
  border-color: rgba(137, 197, 215, 0.2);
}

.hover\\:border-story-color-300\\/25:hover{
  border-color: rgba(137, 197, 215, 0.25);
}

.hover\\:border-story-color-300\\/30:hover{
  border-color: rgba(137, 197, 215, 0.3);
}

.hover\\:border-story-color-300\\/35:hover{
  border-color: rgba(137, 197, 215, 0.35);
}

.hover\\:border-story-color-300\\/40:hover{
  border-color: rgba(137, 197, 215, 0.4);
}

.hover\\:border-story-color-300\\/45:hover{
  border-color: rgba(137, 197, 215, 0.45);
}

.hover\\:border-story-color-300\\/5:hover{
  border-color: rgba(137, 197, 215, 0.05);
}

.hover\\:border-story-color-300\\/50:hover{
  border-color: rgba(137, 197, 215, 0.5);
}

.hover\\:border-story-color-300\\/55:hover{
  border-color: rgba(137, 197, 215, 0.55);
}

.hover\\:border-story-color-300\\/60:hover{
  border-color: rgba(137, 197, 215, 0.6);
}

.hover\\:border-story-color-300\\/65:hover{
  border-color: rgba(137, 197, 215, 0.65);
}

.hover\\:border-story-color-300\\/70:hover{
  border-color: rgba(137, 197, 215, 0.7);
}

.hover\\:border-story-color-300\\/75:hover{
  border-color: rgba(137, 197, 215, 0.75);
}

.hover\\:border-story-color-300\\/80:hover{
  border-color: rgba(137, 197, 215, 0.8);
}

.hover\\:border-story-color-300\\/85:hover{
  border-color: rgba(137, 197, 215, 0.85);
}

.hover\\:border-story-color-300\\/90:hover{
  border-color: rgba(137, 197, 215, 0.9);
}

.hover\\:border-story-color-300\\/95:hover{
  border-color: rgba(137, 197, 215, 0.95);
}

.hover\\:border-story-color-400:hover{
  --tw-border-opacity: 1;
  border-color: rgba(82, 163, 190, 1);
  border-color: rgba(82, 163, 190, var(--tw-border-opacity, 1));
}

.hover\\:border-story-color-400\\/0:hover{
  border-color: rgba(82, 163, 190, 0);
}

.hover\\:border-story-color-400\\/10:hover{
  border-color: rgba(82, 163, 190, 0.1);
}

.hover\\:border-story-color-400\\/100:hover{
  border-color: rgb(82, 163, 190);
}

.hover\\:border-story-color-400\\/15:hover{
  border-color: rgba(82, 163, 190, 0.15);
}

.hover\\:border-story-color-400\\/20:hover{
  border-color: rgba(82, 163, 190, 0.2);
}

.hover\\:border-story-color-400\\/25:hover{
  border-color: rgba(82, 163, 190, 0.25);
}

.hover\\:border-story-color-400\\/30:hover{
  border-color: rgba(82, 163, 190, 0.3);
}

.hover\\:border-story-color-400\\/35:hover{
  border-color: rgba(82, 163, 190, 0.35);
}

.hover\\:border-story-color-400\\/40:hover{
  border-color: rgba(82, 163, 190, 0.4);
}

.hover\\:border-story-color-400\\/45:hover{
  border-color: rgba(82, 163, 190, 0.45);
}

.hover\\:border-story-color-400\\/5:hover{
  border-color: rgba(82, 163, 190, 0.05);
}

.hover\\:border-story-color-400\\/50:hover{
  border-color: rgba(82, 163, 190, 0.5);
}

.hover\\:border-story-color-400\\/55:hover{
  border-color: rgba(82, 163, 190, 0.55);
}

.hover\\:border-story-color-400\\/60:hover{
  border-color: rgba(82, 163, 190, 0.6);
}

.hover\\:border-story-color-400\\/65:hover{
  border-color: rgba(82, 163, 190, 0.65);
}

.hover\\:border-story-color-400\\/70:hover{
  border-color: rgba(82, 163, 190, 0.7);
}

.hover\\:border-story-color-400\\/75:hover{
  border-color: rgba(82, 163, 190, 0.75);
}

.hover\\:border-story-color-400\\/80:hover{
  border-color: rgba(82, 163, 190, 0.8);
}

.hover\\:border-story-color-400\\/85:hover{
  border-color: rgba(82, 163, 190, 0.85);
}

.hover\\:border-story-color-400\\/90:hover{
  border-color: rgba(82, 163, 190, 0.9);
}

.hover\\:border-story-color-400\\/95:hover{
  border-color: rgba(82, 163, 190, 0.95);
}

.hover\\:border-story-color-500:hover{
  --tw-border-opacity: 1;
  border-color: rgba(55, 135, 163, 1);
  border-color: rgba(55, 135, 163, var(--tw-border-opacity, 1));
}

.hover\\:border-story-color-500\\/0:hover{
  border-color: rgba(55, 135, 163, 0);
}

.hover\\:border-story-color-500\\/10:hover{
  border-color: rgba(55, 135, 163, 0.1);
}

.hover\\:border-story-color-500\\/100:hover{
  border-color: rgb(55, 135, 163);
}

.hover\\:border-story-color-500\\/15:hover{
  border-color: rgba(55, 135, 163, 0.15);
}

.hover\\:border-story-color-500\\/20:hover{
  border-color: rgba(55, 135, 163, 0.2);
}

.hover\\:border-story-color-500\\/25:hover{
  border-color: rgba(55, 135, 163, 0.25);
}

.hover\\:border-story-color-500\\/30:hover{
  border-color: rgba(55, 135, 163, 0.3);
}

.hover\\:border-story-color-500\\/35:hover{
  border-color: rgba(55, 135, 163, 0.35);
}

.hover\\:border-story-color-500\\/40:hover{
  border-color: rgba(55, 135, 163, 0.4);
}

.hover\\:border-story-color-500\\/45:hover{
  border-color: rgba(55, 135, 163, 0.45);
}

.hover\\:border-story-color-500\\/5:hover{
  border-color: rgba(55, 135, 163, 0.05);
}

.hover\\:border-story-color-500\\/50:hover{
  border-color: rgba(55, 135, 163, 0.5);
}

.hover\\:border-story-color-500\\/55:hover{
  border-color: rgba(55, 135, 163, 0.55);
}

.hover\\:border-story-color-500\\/60:hover{
  border-color: rgba(55, 135, 163, 0.6);
}

.hover\\:border-story-color-500\\/65:hover{
  border-color: rgba(55, 135, 163, 0.65);
}

.hover\\:border-story-color-500\\/70:hover{
  border-color: rgba(55, 135, 163, 0.7);
}

.hover\\:border-story-color-500\\/75:hover{
  border-color: rgba(55, 135, 163, 0.75);
}

.hover\\:border-story-color-500\\/80:hover{
  border-color: rgba(55, 135, 163, 0.8);
}

.hover\\:border-story-color-500\\/85:hover{
  border-color: rgba(55, 135, 163, 0.85);
}

.hover\\:border-story-color-500\\/90:hover{
  border-color: rgba(55, 135, 163, 0.9);
}

.hover\\:border-story-color-500\\/95:hover{
  border-color: rgba(55, 135, 163, 0.95);
}

.hover\\:border-story-color-600:hover{
  --tw-border-opacity: 1;
  border-color: rgba(48, 109, 138, 1);
  border-color: rgba(48, 109, 138, var(--tw-border-opacity, 1));
}

.hover\\:border-story-color-600\\/0:hover{
  border-color: rgba(48, 109, 138, 0);
}

.hover\\:border-story-color-600\\/10:hover{
  border-color: rgba(48, 109, 138, 0.1);
}

.hover\\:border-story-color-600\\/100:hover{
  border-color: rgb(48, 109, 138);
}

.hover\\:border-story-color-600\\/15:hover{
  border-color: rgba(48, 109, 138, 0.15);
}

.hover\\:border-story-color-600\\/20:hover{
  border-color: rgba(48, 109, 138, 0.2);
}

.hover\\:border-story-color-600\\/25:hover{
  border-color: rgba(48, 109, 138, 0.25);
}

.hover\\:border-story-color-600\\/30:hover{
  border-color: rgba(48, 109, 138, 0.3);
}

.hover\\:border-story-color-600\\/35:hover{
  border-color: rgba(48, 109, 138, 0.35);
}

.hover\\:border-story-color-600\\/40:hover{
  border-color: rgba(48, 109, 138, 0.4);
}

.hover\\:border-story-color-600\\/45:hover{
  border-color: rgba(48, 109, 138, 0.45);
}

.hover\\:border-story-color-600\\/5:hover{
  border-color: rgba(48, 109, 138, 0.05);
}

.hover\\:border-story-color-600\\/50:hover{
  border-color: rgba(48, 109, 138, 0.5);
}

.hover\\:border-story-color-600\\/55:hover{
  border-color: rgba(48, 109, 138, 0.55);
}

.hover\\:border-story-color-600\\/60:hover{
  border-color: rgba(48, 109, 138, 0.6);
}

.hover\\:border-story-color-600\\/65:hover{
  border-color: rgba(48, 109, 138, 0.65);
}

.hover\\:border-story-color-600\\/70:hover{
  border-color: rgba(48, 109, 138, 0.7);
}

.hover\\:border-story-color-600\\/75:hover{
  border-color: rgba(48, 109, 138, 0.75);
}

.hover\\:border-story-color-600\\/80:hover{
  border-color: rgba(48, 109, 138, 0.8);
}

.hover\\:border-story-color-600\\/85:hover{
  border-color: rgba(48, 109, 138, 0.85);
}

.hover\\:border-story-color-600\\/90:hover{
  border-color: rgba(48, 109, 138, 0.9);
}

.hover\\:border-story-color-600\\/95:hover{
  border-color: rgba(48, 109, 138, 0.95);
}

.hover\\:border-story-color-700:hover{
  --tw-border-opacity: 1;
  border-color: rgba(45, 91, 114, 1);
  border-color: rgba(45, 91, 114, var(--tw-border-opacity, 1));
}

.hover\\:border-story-color-700\\/0:hover{
  border-color: rgba(45, 91, 114, 0);
}

.hover\\:border-story-color-700\\/10:hover{
  border-color: rgba(45, 91, 114, 0.1);
}

.hover\\:border-story-color-700\\/100:hover{
  border-color: rgb(45, 91, 114);
}

.hover\\:border-story-color-700\\/15:hover{
  border-color: rgba(45, 91, 114, 0.15);
}

.hover\\:border-story-color-700\\/20:hover{
  border-color: rgba(45, 91, 114, 0.2);
}

.hover\\:border-story-color-700\\/25:hover{
  border-color: rgba(45, 91, 114, 0.25);
}

.hover\\:border-story-color-700\\/30:hover{
  border-color: rgba(45, 91, 114, 0.3);
}

.hover\\:border-story-color-700\\/35:hover{
  border-color: rgba(45, 91, 114, 0.35);
}

.hover\\:border-story-color-700\\/40:hover{
  border-color: rgba(45, 91, 114, 0.4);
}

.hover\\:border-story-color-700\\/45:hover{
  border-color: rgba(45, 91, 114, 0.45);
}

.hover\\:border-story-color-700\\/5:hover{
  border-color: rgba(45, 91, 114, 0.05);
}

.hover\\:border-story-color-700\\/50:hover{
  border-color: rgba(45, 91, 114, 0.5);
}

.hover\\:border-story-color-700\\/55:hover{
  border-color: rgba(45, 91, 114, 0.55);
}

.hover\\:border-story-color-700\\/60:hover{
  border-color: rgba(45, 91, 114, 0.6);
}

.hover\\:border-story-color-700\\/65:hover{
  border-color: rgba(45, 91, 114, 0.65);
}

.hover\\:border-story-color-700\\/70:hover{
  border-color: rgba(45, 91, 114, 0.7);
}

.hover\\:border-story-color-700\\/75:hover{
  border-color: rgba(45, 91, 114, 0.75);
}

.hover\\:border-story-color-700\\/80:hover{
  border-color: rgba(45, 91, 114, 0.8);
}

.hover\\:border-story-color-700\\/85:hover{
  border-color: rgba(45, 91, 114, 0.85);
}

.hover\\:border-story-color-700\\/90:hover{
  border-color: rgba(45, 91, 114, 0.9);
}

.hover\\:border-story-color-700\\/95:hover{
  border-color: rgba(45, 91, 114, 0.95);
}

.hover\\:border-story-color-800:hover{
  --tw-border-opacity: 1;
  border-color: rgba(44, 76, 94, 1);
  border-color: rgba(44, 76, 94, var(--tw-border-opacity, 1));
}

.hover\\:border-story-color-800\\/0:hover{
  border-color: rgba(44, 76, 94, 0);
}

.hover\\:border-story-color-800\\/10:hover{
  border-color: rgba(44, 76, 94, 0.1);
}

.hover\\:border-story-color-800\\/100:hover{
  border-color: rgb(44, 76, 94);
}

.hover\\:border-story-color-800\\/15:hover{
  border-color: rgba(44, 76, 94, 0.15);
}

.hover\\:border-story-color-800\\/20:hover{
  border-color: rgba(44, 76, 94, 0.2);
}

.hover\\:border-story-color-800\\/25:hover{
  border-color: rgba(44, 76, 94, 0.25);
}

.hover\\:border-story-color-800\\/30:hover{
  border-color: rgba(44, 76, 94, 0.3);
}

.hover\\:border-story-color-800\\/35:hover{
  border-color: rgba(44, 76, 94, 0.35);
}

.hover\\:border-story-color-800\\/40:hover{
  border-color: rgba(44, 76, 94, 0.4);
}

.hover\\:border-story-color-800\\/45:hover{
  border-color: rgba(44, 76, 94, 0.45);
}

.hover\\:border-story-color-800\\/5:hover{
  border-color: rgba(44, 76, 94, 0.05);
}

.hover\\:border-story-color-800\\/50:hover{
  border-color: rgba(44, 76, 94, 0.5);
}

.hover\\:border-story-color-800\\/55:hover{
  border-color: rgba(44, 76, 94, 0.55);
}

.hover\\:border-story-color-800\\/60:hover{
  border-color: rgba(44, 76, 94, 0.6);
}

.hover\\:border-story-color-800\\/65:hover{
  border-color: rgba(44, 76, 94, 0.65);
}

.hover\\:border-story-color-800\\/70:hover{
  border-color: rgba(44, 76, 94, 0.7);
}

.hover\\:border-story-color-800\\/75:hover{
  border-color: rgba(44, 76, 94, 0.75);
}

.hover\\:border-story-color-800\\/80:hover{
  border-color: rgba(44, 76, 94, 0.8);
}

.hover\\:border-story-color-800\\/85:hover{
  border-color: rgba(44, 76, 94, 0.85);
}

.hover\\:border-story-color-800\\/90:hover{
  border-color: rgba(44, 76, 94, 0.9);
}

.hover\\:border-story-color-800\\/95:hover{
  border-color: rgba(44, 76, 94, 0.95);
}

.hover\\:border-story-color-900:hover{
  --tw-border-opacity: 1;
  border-color: rgba(40, 65, 81, 1);
  border-color: rgba(40, 65, 81, var(--tw-border-opacity, 1));
}

.hover\\:border-story-color-900\\/0:hover{
  border-color: rgba(40, 65, 81, 0);
}

.hover\\:border-story-color-900\\/10:hover{
  border-color: rgba(40, 65, 81, 0.1);
}

.hover\\:border-story-color-900\\/100:hover{
  border-color: rgb(40, 65, 81);
}

.hover\\:border-story-color-900\\/15:hover{
  border-color: rgba(40, 65, 81, 0.15);
}

.hover\\:border-story-color-900\\/20:hover{
  border-color: rgba(40, 65, 81, 0.2);
}

.hover\\:border-story-color-900\\/25:hover{
  border-color: rgba(40, 65, 81, 0.25);
}

.hover\\:border-story-color-900\\/30:hover{
  border-color: rgba(40, 65, 81, 0.3);
}

.hover\\:border-story-color-900\\/35:hover{
  border-color: rgba(40, 65, 81, 0.35);
}

.hover\\:border-story-color-900\\/40:hover{
  border-color: rgba(40, 65, 81, 0.4);
}

.hover\\:border-story-color-900\\/45:hover{
  border-color: rgba(40, 65, 81, 0.45);
}

.hover\\:border-story-color-900\\/5:hover{
  border-color: rgba(40, 65, 81, 0.05);
}

.hover\\:border-story-color-900\\/50:hover{
  border-color: rgba(40, 65, 81, 0.5);
}

.hover\\:border-story-color-900\\/55:hover{
  border-color: rgba(40, 65, 81, 0.55);
}

.hover\\:border-story-color-900\\/60:hover{
  border-color: rgba(40, 65, 81, 0.6);
}

.hover\\:border-story-color-900\\/65:hover{
  border-color: rgba(40, 65, 81, 0.65);
}

.hover\\:border-story-color-900\\/70:hover{
  border-color: rgba(40, 65, 81, 0.7);
}

.hover\\:border-story-color-900\\/75:hover{
  border-color: rgba(40, 65, 81, 0.75);
}

.hover\\:border-story-color-900\\/80:hover{
  border-color: rgba(40, 65, 81, 0.8);
}

.hover\\:border-story-color-900\\/85:hover{
  border-color: rgba(40, 65, 81, 0.85);
}

.hover\\:border-story-color-900\\/90:hover{
  border-color: rgba(40, 65, 81, 0.9);
}

.hover\\:border-story-color-900\\/95:hover{
  border-color: rgba(40, 65, 81, 0.95);
}

.hover\\:border-story-color-950:hover{
  --tw-border-opacity: 1;
  border-color: rgba(22, 41, 54, 1);
  border-color: rgba(22, 41, 54, var(--tw-border-opacity, 1));
}

.hover\\:border-story-color-950\\/0:hover{
  border-color: rgba(22, 41, 54, 0);
}

.hover\\:border-story-color-950\\/10:hover{
  border-color: rgba(22, 41, 54, 0.1);
}

.hover\\:border-story-color-950\\/100:hover{
  border-color: rgb(22, 41, 54);
}

.hover\\:border-story-color-950\\/15:hover{
  border-color: rgba(22, 41, 54, 0.15);
}

.hover\\:border-story-color-950\\/20:hover{
  border-color: rgba(22, 41, 54, 0.2);
}

.hover\\:border-story-color-950\\/25:hover{
  border-color: rgba(22, 41, 54, 0.25);
}

.hover\\:border-story-color-950\\/30:hover{
  border-color: rgba(22, 41, 54, 0.3);
}

.hover\\:border-story-color-950\\/35:hover{
  border-color: rgba(22, 41, 54, 0.35);
}

.hover\\:border-story-color-950\\/40:hover{
  border-color: rgba(22, 41, 54, 0.4);
}

.hover\\:border-story-color-950\\/45:hover{
  border-color: rgba(22, 41, 54, 0.45);
}

.hover\\:border-story-color-950\\/5:hover{
  border-color: rgba(22, 41, 54, 0.05);
}

.hover\\:border-story-color-950\\/50:hover{
  border-color: rgba(22, 41, 54, 0.5);
}

.hover\\:border-story-color-950\\/55:hover{
  border-color: rgba(22, 41, 54, 0.55);
}

.hover\\:border-story-color-950\\/60:hover{
  border-color: rgba(22, 41, 54, 0.6);
}

.hover\\:border-story-color-950\\/65:hover{
  border-color: rgba(22, 41, 54, 0.65);
}

.hover\\:border-story-color-950\\/70:hover{
  border-color: rgba(22, 41, 54, 0.7);
}

.hover\\:border-story-color-950\\/75:hover{
  border-color: rgba(22, 41, 54, 0.75);
}

.hover\\:border-story-color-950\\/80:hover{
  border-color: rgba(22, 41, 54, 0.8);
}

.hover\\:border-story-color-950\\/85:hover{
  border-color: rgba(22, 41, 54, 0.85);
}

.hover\\:border-story-color-950\\/90:hover{
  border-color: rgba(22, 41, 54, 0.9);
}

.hover\\:border-story-color-950\\/95:hover{
  border-color: rgba(22, 41, 54, 0.95);
}

.hover\\:border-word-color-100:hover{
  --tw-border-opacity: 1;
  border-color: rgba(217, 242, 230, 1);
  border-color: rgba(217, 242, 230, var(--tw-border-opacity, 1));
}

.hover\\:border-word-color-100\\/0:hover{
  border-color: rgba(217, 242, 230, 0);
}

.hover\\:border-word-color-100\\/10:hover{
  border-color: rgba(217, 242, 230, 0.1);
}

.hover\\:border-word-color-100\\/100:hover{
  border-color: rgb(217, 242, 230);
}

.hover\\:border-word-color-100\\/15:hover{
  border-color: rgba(217, 242, 230, 0.15);
}

.hover\\:border-word-color-100\\/20:hover{
  border-color: rgba(217, 242, 230, 0.2);
}

.hover\\:border-word-color-100\\/25:hover{
  border-color: rgba(217, 242, 230, 0.25);
}

.hover\\:border-word-color-100\\/30:hover{
  border-color: rgba(217, 242, 230, 0.3);
}

.hover\\:border-word-color-100\\/35:hover{
  border-color: rgba(217, 242, 230, 0.35);
}

.hover\\:border-word-color-100\\/40:hover{
  border-color: rgba(217, 242, 230, 0.4);
}

.hover\\:border-word-color-100\\/45:hover{
  border-color: rgba(217, 242, 230, 0.45);
}

.hover\\:border-word-color-100\\/5:hover{
  border-color: rgba(217, 242, 230, 0.05);
}

.hover\\:border-word-color-100\\/50:hover{
  border-color: rgba(217, 242, 230, 0.5);
}

.hover\\:border-word-color-100\\/55:hover{
  border-color: rgba(217, 242, 230, 0.55);
}

.hover\\:border-word-color-100\\/60:hover{
  border-color: rgba(217, 242, 230, 0.6);
}

.hover\\:border-word-color-100\\/65:hover{
  border-color: rgba(217, 242, 230, 0.65);
}

.hover\\:border-word-color-100\\/70:hover{
  border-color: rgba(217, 242, 230, 0.7);
}

.hover\\:border-word-color-100\\/75:hover{
  border-color: rgba(217, 242, 230, 0.75);
}

.hover\\:border-word-color-100\\/80:hover{
  border-color: rgba(217, 242, 230, 0.8);
}

.hover\\:border-word-color-100\\/85:hover{
  border-color: rgba(217, 242, 230, 0.85);
}

.hover\\:border-word-color-100\\/90:hover{
  border-color: rgba(217, 242, 230, 0.9);
}

.hover\\:border-word-color-100\\/95:hover{
  border-color: rgba(217, 242, 230, 0.95);
}

.hover\\:border-word-color-200:hover{
  --tw-border-opacity: 1;
  border-color: rgba(182, 228, 209, 1);
  border-color: rgba(182, 228, 209, var(--tw-border-opacity, 1));
}

.hover\\:border-word-color-200\\/0:hover{
  border-color: rgba(182, 228, 209, 0);
}

.hover\\:border-word-color-200\\/10:hover{
  border-color: rgba(182, 228, 209, 0.1);
}

.hover\\:border-word-color-200\\/100:hover{
  border-color: rgb(182, 228, 209);
}

.hover\\:border-word-color-200\\/15:hover{
  border-color: rgba(182, 228, 209, 0.15);
}

.hover\\:border-word-color-200\\/20:hover{
  border-color: rgba(182, 228, 209, 0.2);
}

.hover\\:border-word-color-200\\/25:hover{
  border-color: rgba(182, 228, 209, 0.25);
}

.hover\\:border-word-color-200\\/30:hover{
  border-color: rgba(182, 228, 209, 0.3);
}

.hover\\:border-word-color-200\\/35:hover{
  border-color: rgba(182, 228, 209, 0.35);
}

.hover\\:border-word-color-200\\/40:hover{
  border-color: rgba(182, 228, 209, 0.4);
}

.hover\\:border-word-color-200\\/45:hover{
  border-color: rgba(182, 228, 209, 0.45);
}

.hover\\:border-word-color-200\\/5:hover{
  border-color: rgba(182, 228, 209, 0.05);
}

.hover\\:border-word-color-200\\/50:hover{
  border-color: rgba(182, 228, 209, 0.5);
}

.hover\\:border-word-color-200\\/55:hover{
  border-color: rgba(182, 228, 209, 0.55);
}

.hover\\:border-word-color-200\\/60:hover{
  border-color: rgba(182, 228, 209, 0.6);
}

.hover\\:border-word-color-200\\/65:hover{
  border-color: rgba(182, 228, 209, 0.65);
}

.hover\\:border-word-color-200\\/70:hover{
  border-color: rgba(182, 228, 209, 0.7);
}

.hover\\:border-word-color-200\\/75:hover{
  border-color: rgba(182, 228, 209, 0.75);
}

.hover\\:border-word-color-200\\/80:hover{
  border-color: rgba(182, 228, 209, 0.8);
}

.hover\\:border-word-color-200\\/85:hover{
  border-color: rgba(182, 228, 209, 0.85);
}

.hover\\:border-word-color-200\\/90:hover{
  border-color: rgba(182, 228, 209, 0.9);
}

.hover\\:border-word-color-200\\/95:hover{
  border-color: rgba(182, 228, 209, 0.95);
}

.hover\\:border-word-color-300:hover{
  --tw-border-opacity: 1;
  border-color: rgba(134, 207, 181, 1);
  border-color: rgba(134, 207, 181, var(--tw-border-opacity, 1));
}

.hover\\:border-word-color-300\\/0:hover{
  border-color: rgba(134, 207, 181, 0);
}

.hover\\:border-word-color-300\\/10:hover{
  border-color: rgba(134, 207, 181, 0.1);
}

.hover\\:border-word-color-300\\/100:hover{
  border-color: rgb(134, 207, 181);
}

.hover\\:border-word-color-300\\/15:hover{
  border-color: rgba(134, 207, 181, 0.15);
}

.hover\\:border-word-color-300\\/20:hover{
  border-color: rgba(134, 207, 181, 0.2);
}

.hover\\:border-word-color-300\\/25:hover{
  border-color: rgba(134, 207, 181, 0.25);
}

.hover\\:border-word-color-300\\/30:hover{
  border-color: rgba(134, 207, 181, 0.3);
}

.hover\\:border-word-color-300\\/35:hover{
  border-color: rgba(134, 207, 181, 0.35);
}

.hover\\:border-word-color-300\\/40:hover{
  border-color: rgba(134, 207, 181, 0.4);
}

.hover\\:border-word-color-300\\/45:hover{
  border-color: rgba(134, 207, 181, 0.45);
}

.hover\\:border-word-color-300\\/5:hover{
  border-color: rgba(134, 207, 181, 0.05);
}

.hover\\:border-word-color-300\\/50:hover{
  border-color: rgba(134, 207, 181, 0.5);
}

.hover\\:border-word-color-300\\/55:hover{
  border-color: rgba(134, 207, 181, 0.55);
}

.hover\\:border-word-color-300\\/60:hover{
  border-color: rgba(134, 207, 181, 0.6);
}

.hover\\:border-word-color-300\\/65:hover{
  border-color: rgba(134, 207, 181, 0.65);
}

.hover\\:border-word-color-300\\/70:hover{
  border-color: rgba(134, 207, 181, 0.7);
}

.hover\\:border-word-color-300\\/75:hover{
  border-color: rgba(134, 207, 181, 0.75);
}

.hover\\:border-word-color-300\\/80:hover{
  border-color: rgba(134, 207, 181, 0.8);
}

.hover\\:border-word-color-300\\/85:hover{
  border-color: rgba(134, 207, 181, 0.85);
}

.hover\\:border-word-color-300\\/90:hover{
  border-color: rgba(134, 207, 181, 0.9);
}

.hover\\:border-word-color-300\\/95:hover{
  border-color: rgba(134, 207, 181, 0.95);
}

.hover\\:border-word-color-400:hover{
  --tw-border-opacity: 1;
  border-color: rgba(83, 180, 148, 1);
  border-color: rgba(83, 180, 148, var(--tw-border-opacity, 1));
}

.hover\\:border-word-color-400\\/0:hover{
  border-color: rgba(83, 180, 148, 0);
}

.hover\\:border-word-color-400\\/10:hover{
  border-color: rgba(83, 180, 148, 0.1);
}

.hover\\:border-word-color-400\\/100:hover{
  border-color: rgb(83, 180, 148);
}

.hover\\:border-word-color-400\\/15:hover{
  border-color: rgba(83, 180, 148, 0.15);
}

.hover\\:border-word-color-400\\/20:hover{
  border-color: rgba(83, 180, 148, 0.2);
}

.hover\\:border-word-color-400\\/25:hover{
  border-color: rgba(83, 180, 148, 0.25);
}

.hover\\:border-word-color-400\\/30:hover{
  border-color: rgba(83, 180, 148, 0.3);
}

.hover\\:border-word-color-400\\/35:hover{
  border-color: rgba(83, 180, 148, 0.35);
}

.hover\\:border-word-color-400\\/40:hover{
  border-color: rgba(83, 180, 148, 0.4);
}

.hover\\:border-word-color-400\\/45:hover{
  border-color: rgba(83, 180, 148, 0.45);
}

.hover\\:border-word-color-400\\/5:hover{
  border-color: rgba(83, 180, 148, 0.05);
}

.hover\\:border-word-color-400\\/50:hover{
  border-color: rgba(83, 180, 148, 0.5);
}

.hover\\:border-word-color-400\\/55:hover{
  border-color: rgba(83, 180, 148, 0.55);
}

.hover\\:border-word-color-400\\/60:hover{
  border-color: rgba(83, 180, 148, 0.6);
}

.hover\\:border-word-color-400\\/65:hover{
  border-color: rgba(83, 180, 148, 0.65);
}

.hover\\:border-word-color-400\\/70:hover{
  border-color: rgba(83, 180, 148, 0.7);
}

.hover\\:border-word-color-400\\/75:hover{
  border-color: rgba(83, 180, 148, 0.75);
}

.hover\\:border-word-color-400\\/80:hover{
  border-color: rgba(83, 180, 148, 0.8);
}

.hover\\:border-word-color-400\\/85:hover{
  border-color: rgba(83, 180, 148, 0.85);
}

.hover\\:border-word-color-400\\/90:hover{
  border-color: rgba(83, 180, 148, 0.9);
}

.hover\\:border-word-color-400\\/95:hover{
  border-color: rgba(83, 180, 148, 0.95);
}

.hover\\:border-word-color-500:hover{
  --tw-border-opacity: 1;
  border-color: rgba(44, 135, 109, 1);
  border-color: rgba(44, 135, 109, var(--tw-border-opacity, 1));
}

.hover\\:border-word-color-500\\/0:hover{
  border-color: rgba(44, 135, 109, 0);
}

.hover\\:border-word-color-500\\/10:hover{
  border-color: rgba(44, 135, 109, 0.1);
}

.hover\\:border-word-color-500\\/100:hover{
  border-color: rgb(44, 135, 109);
}

.hover\\:border-word-color-500\\/15:hover{
  border-color: rgba(44, 135, 109, 0.15);
}

.hover\\:border-word-color-500\\/20:hover{
  border-color: rgba(44, 135, 109, 0.2);
}

.hover\\:border-word-color-500\\/25:hover{
  border-color: rgba(44, 135, 109, 0.25);
}

.hover\\:border-word-color-500\\/30:hover{
  border-color: rgba(44, 135, 109, 0.3);
}

.hover\\:border-word-color-500\\/35:hover{
  border-color: rgba(44, 135, 109, 0.35);
}

.hover\\:border-word-color-500\\/40:hover{
  border-color: rgba(44, 135, 109, 0.4);
}

.hover\\:border-word-color-500\\/45:hover{
  border-color: rgba(44, 135, 109, 0.45);
}

.hover\\:border-word-color-500\\/5:hover{
  border-color: rgba(44, 135, 109, 0.05);
}

.hover\\:border-word-color-500\\/50:hover{
  border-color: rgba(44, 135, 109, 0.5);
}

.hover\\:border-word-color-500\\/55:hover{
  border-color: rgba(44, 135, 109, 0.55);
}

.hover\\:border-word-color-500\\/60:hover{
  border-color: rgba(44, 135, 109, 0.6);
}

.hover\\:border-word-color-500\\/65:hover{
  border-color: rgba(44, 135, 109, 0.65);
}

.hover\\:border-word-color-500\\/70:hover{
  border-color: rgba(44, 135, 109, 0.7);
}

.hover\\:border-word-color-500\\/75:hover{
  border-color: rgba(44, 135, 109, 0.75);
}

.hover\\:border-word-color-500\\/80:hover{
  border-color: rgba(44, 135, 109, 0.8);
}

.hover\\:border-word-color-500\\/85:hover{
  border-color: rgba(44, 135, 109, 0.85);
}

.hover\\:border-word-color-500\\/90:hover{
  border-color: rgba(44, 135, 109, 0.9);
}

.hover\\:border-word-color-500\\/95:hover{
  border-color: rgba(44, 135, 109, 0.95);
}

.hover\\:border-word-color-600:hover{
  --tw-border-opacity: 1;
  border-color: rgba(34, 121, 98, 1);
  border-color: rgba(34, 121, 98, var(--tw-border-opacity, 1));
}

.hover\\:border-word-color-600\\/0:hover{
  border-color: rgba(34, 121, 98, 0);
}

.hover\\:border-word-color-600\\/10:hover{
  border-color: rgba(34, 121, 98, 0.1);
}

.hover\\:border-word-color-600\\/100:hover{
  border-color: rgb(34, 121, 98);
}

.hover\\:border-word-color-600\\/15:hover{
  border-color: rgba(34, 121, 98, 0.15);
}

.hover\\:border-word-color-600\\/20:hover{
  border-color: rgba(34, 121, 98, 0.2);
}

.hover\\:border-word-color-600\\/25:hover{
  border-color: rgba(34, 121, 98, 0.25);
}

.hover\\:border-word-color-600\\/30:hover{
  border-color: rgba(34, 121, 98, 0.3);
}

.hover\\:border-word-color-600\\/35:hover{
  border-color: rgba(34, 121, 98, 0.35);
}

.hover\\:border-word-color-600\\/40:hover{
  border-color: rgba(34, 121, 98, 0.4);
}

.hover\\:border-word-color-600\\/45:hover{
  border-color: rgba(34, 121, 98, 0.45);
}

.hover\\:border-word-color-600\\/5:hover{
  border-color: rgba(34, 121, 98, 0.05);
}

.hover\\:border-word-color-600\\/50:hover{
  border-color: rgba(34, 121, 98, 0.5);
}

.hover\\:border-word-color-600\\/55:hover{
  border-color: rgba(34, 121, 98, 0.55);
}

.hover\\:border-word-color-600\\/60:hover{
  border-color: rgba(34, 121, 98, 0.6);
}

.hover\\:border-word-color-600\\/65:hover{
  border-color: rgba(34, 121, 98, 0.65);
}

.hover\\:border-word-color-600\\/70:hover{
  border-color: rgba(34, 121, 98, 0.7);
}

.hover\\:border-word-color-600\\/75:hover{
  border-color: rgba(34, 121, 98, 0.75);
}

.hover\\:border-word-color-600\\/80:hover{
  border-color: rgba(34, 121, 98, 0.8);
}

.hover\\:border-word-color-600\\/85:hover{
  border-color: rgba(34, 121, 98, 0.85);
}

.hover\\:border-word-color-600\\/90:hover{
  border-color: rgba(34, 121, 98, 0.9);
}

.hover\\:border-word-color-600\\/95:hover{
  border-color: rgba(34, 121, 98, 0.95);
}

.hover\\:border-word-color-700:hover{
  --tw-border-opacity: 1;
  border-color: rgba(27, 97, 80, 1);
  border-color: rgba(27, 97, 80, var(--tw-border-opacity, 1));
}

.hover\\:border-word-color-700\\/0:hover{
  border-color: rgba(27, 97, 80, 0);
}

.hover\\:border-word-color-700\\/10:hover{
  border-color: rgba(27, 97, 80, 0.1);
}

.hover\\:border-word-color-700\\/100:hover{
  border-color: rgb(27, 97, 80);
}

.hover\\:border-word-color-700\\/15:hover{
  border-color: rgba(27, 97, 80, 0.15);
}

.hover\\:border-word-color-700\\/20:hover{
  border-color: rgba(27, 97, 80, 0.2);
}

.hover\\:border-word-color-700\\/25:hover{
  border-color: rgba(27, 97, 80, 0.25);
}

.hover\\:border-word-color-700\\/30:hover{
  border-color: rgba(27, 97, 80, 0.3);
}

.hover\\:border-word-color-700\\/35:hover{
  border-color: rgba(27, 97, 80, 0.35);
}

.hover\\:border-word-color-700\\/40:hover{
  border-color: rgba(27, 97, 80, 0.4);
}

.hover\\:border-word-color-700\\/45:hover{
  border-color: rgba(27, 97, 80, 0.45);
}

.hover\\:border-word-color-700\\/5:hover{
  border-color: rgba(27, 97, 80, 0.05);
}

.hover\\:border-word-color-700\\/50:hover{
  border-color: rgba(27, 97, 80, 0.5);
}

.hover\\:border-word-color-700\\/55:hover{
  border-color: rgba(27, 97, 80, 0.55);
}

.hover\\:border-word-color-700\\/60:hover{
  border-color: rgba(27, 97, 80, 0.6);
}

.hover\\:border-word-color-700\\/65:hover{
  border-color: rgba(27, 97, 80, 0.65);
}

.hover\\:border-word-color-700\\/70:hover{
  border-color: rgba(27, 97, 80, 0.7);
}

.hover\\:border-word-color-700\\/75:hover{
  border-color: rgba(27, 97, 80, 0.75);
}

.hover\\:border-word-color-700\\/80:hover{
  border-color: rgba(27, 97, 80, 0.8);
}

.hover\\:border-word-color-700\\/85:hover{
  border-color: rgba(27, 97, 80, 0.85);
}

.hover\\:border-word-color-700\\/90:hover{
  border-color: rgba(27, 97, 80, 0.9);
}

.hover\\:border-word-color-700\\/95:hover{
  border-color: rgba(27, 97, 80, 0.95);
}

.hover\\:border-word-color-800:hover{
  --tw-border-opacity: 1;
  border-color: rgba(24, 77, 64, 1);
  border-color: rgba(24, 77, 64, var(--tw-border-opacity, 1));
}

.hover\\:border-word-color-800\\/0:hover{
  border-color: rgba(24, 77, 64, 0);
}

.hover\\:border-word-color-800\\/10:hover{
  border-color: rgba(24, 77, 64, 0.1);
}

.hover\\:border-word-color-800\\/100:hover{
  border-color: rgb(24, 77, 64);
}

.hover\\:border-word-color-800\\/15:hover{
  border-color: rgba(24, 77, 64, 0.15);
}

.hover\\:border-word-color-800\\/20:hover{
  border-color: rgba(24, 77, 64, 0.2);
}

.hover\\:border-word-color-800\\/25:hover{
  border-color: rgba(24, 77, 64, 0.25);
}

.hover\\:border-word-color-800\\/30:hover{
  border-color: rgba(24, 77, 64, 0.3);
}

.hover\\:border-word-color-800\\/35:hover{
  border-color: rgba(24, 77, 64, 0.35);
}

.hover\\:border-word-color-800\\/40:hover{
  border-color: rgba(24, 77, 64, 0.4);
}

.hover\\:border-word-color-800\\/45:hover{
  border-color: rgba(24, 77, 64, 0.45);
}

.hover\\:border-word-color-800\\/5:hover{
  border-color: rgba(24, 77, 64, 0.05);
}

.hover\\:border-word-color-800\\/50:hover{
  border-color: rgba(24, 77, 64, 0.5);
}

.hover\\:border-word-color-800\\/55:hover{
  border-color: rgba(24, 77, 64, 0.55);
}

.hover\\:border-word-color-800\\/60:hover{
  border-color: rgba(24, 77, 64, 0.6);
}

.hover\\:border-word-color-800\\/65:hover{
  border-color: rgba(24, 77, 64, 0.65);
}

.hover\\:border-word-color-800\\/70:hover{
  border-color: rgba(24, 77, 64, 0.7);
}

.hover\\:border-word-color-800\\/75:hover{
  border-color: rgba(24, 77, 64, 0.75);
}

.hover\\:border-word-color-800\\/80:hover{
  border-color: rgba(24, 77, 64, 0.8);
}

.hover\\:border-word-color-800\\/85:hover{
  border-color: rgba(24, 77, 64, 0.85);
}

.hover\\:border-word-color-800\\/90:hover{
  border-color: rgba(24, 77, 64, 0.9);
}

.hover\\:border-word-color-800\\/95:hover{
  border-color: rgba(24, 77, 64, 0.95);
}

.hover\\:border-word-color-900:hover{
  --tw-border-opacity: 1;
  border-color: rgba(20, 64, 54, 1);
  border-color: rgba(20, 64, 54, var(--tw-border-opacity, 1));
}

.hover\\:border-word-color-900\\/0:hover{
  border-color: rgba(20, 64, 54, 0);
}

.hover\\:border-word-color-900\\/10:hover{
  border-color: rgba(20, 64, 54, 0.1);
}

.hover\\:border-word-color-900\\/100:hover{
  border-color: rgb(20, 64, 54);
}

.hover\\:border-word-color-900\\/15:hover{
  border-color: rgba(20, 64, 54, 0.15);
}

.hover\\:border-word-color-900\\/20:hover{
  border-color: rgba(20, 64, 54, 0.2);
}

.hover\\:border-word-color-900\\/25:hover{
  border-color: rgba(20, 64, 54, 0.25);
}

.hover\\:border-word-color-900\\/30:hover{
  border-color: rgba(20, 64, 54, 0.3);
}

.hover\\:border-word-color-900\\/35:hover{
  border-color: rgba(20, 64, 54, 0.35);
}

.hover\\:border-word-color-900\\/40:hover{
  border-color: rgba(20, 64, 54, 0.4);
}

.hover\\:border-word-color-900\\/45:hover{
  border-color: rgba(20, 64, 54, 0.45);
}

.hover\\:border-word-color-900\\/5:hover{
  border-color: rgba(20, 64, 54, 0.05);
}

.hover\\:border-word-color-900\\/50:hover{
  border-color: rgba(20, 64, 54, 0.5);
}

.hover\\:border-word-color-900\\/55:hover{
  border-color: rgba(20, 64, 54, 0.55);
}

.hover\\:border-word-color-900\\/60:hover{
  border-color: rgba(20, 64, 54, 0.6);
}

.hover\\:border-word-color-900\\/65:hover{
  border-color: rgba(20, 64, 54, 0.65);
}

.hover\\:border-word-color-900\\/70:hover{
  border-color: rgba(20, 64, 54, 0.7);
}

.hover\\:border-word-color-900\\/75:hover{
  border-color: rgba(20, 64, 54, 0.75);
}

.hover\\:border-word-color-900\\/80:hover{
  border-color: rgba(20, 64, 54, 0.8);
}

.hover\\:border-word-color-900\\/85:hover{
  border-color: rgba(20, 64, 54, 0.85);
}

.hover\\:border-word-color-900\\/90:hover{
  border-color: rgba(20, 64, 54, 0.9);
}

.hover\\:border-word-color-900\\/95:hover{
  border-color: rgba(20, 64, 54, 0.95);
}

.hover\\:border-word-color-950:hover{
  --tw-border-opacity: 1;
  border-color: rgba(10, 36, 31, 1);
  border-color: rgba(10, 36, 31, var(--tw-border-opacity, 1));
}

.hover\\:border-word-color-950\\/0:hover{
  border-color: rgba(10, 36, 31, 0);
}

.hover\\:border-word-color-950\\/10:hover{
  border-color: rgba(10, 36, 31, 0.1);
}

.hover\\:border-word-color-950\\/100:hover{
  border-color: rgb(10, 36, 31);
}

.hover\\:border-word-color-950\\/15:hover{
  border-color: rgba(10, 36, 31, 0.15);
}

.hover\\:border-word-color-950\\/20:hover{
  border-color: rgba(10, 36, 31, 0.2);
}

.hover\\:border-word-color-950\\/25:hover{
  border-color: rgba(10, 36, 31, 0.25);
}

.hover\\:border-word-color-950\\/30:hover{
  border-color: rgba(10, 36, 31, 0.3);
}

.hover\\:border-word-color-950\\/35:hover{
  border-color: rgba(10, 36, 31, 0.35);
}

.hover\\:border-word-color-950\\/40:hover{
  border-color: rgba(10, 36, 31, 0.4);
}

.hover\\:border-word-color-950\\/45:hover{
  border-color: rgba(10, 36, 31, 0.45);
}

.hover\\:border-word-color-950\\/5:hover{
  border-color: rgba(10, 36, 31, 0.05);
}

.hover\\:border-word-color-950\\/50:hover{
  border-color: rgba(10, 36, 31, 0.5);
}

.hover\\:border-word-color-950\\/55:hover{
  border-color: rgba(10, 36, 31, 0.55);
}

.hover\\:border-word-color-950\\/60:hover{
  border-color: rgba(10, 36, 31, 0.6);
}

.hover\\:border-word-color-950\\/65:hover{
  border-color: rgba(10, 36, 31, 0.65);
}

.hover\\:border-word-color-950\\/70:hover{
  border-color: rgba(10, 36, 31, 0.7);
}

.hover\\:border-word-color-950\\/75:hover{
  border-color: rgba(10, 36, 31, 0.75);
}

.hover\\:border-word-color-950\\/80:hover{
  border-color: rgba(10, 36, 31, 0.8);
}

.hover\\:border-word-color-950\\/85:hover{
  border-color: rgba(10, 36, 31, 0.85);
}

.hover\\:border-word-color-950\\/90:hover{
  border-color: rgba(10, 36, 31, 0.9);
}

.hover\\:border-word-color-950\\/95:hover{
  border-color: rgba(10, 36, 31, 0.95);
}

.hover\\:bg-blumine-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(218, 238, 243, 1);
  background-color: rgba(218, 238, 243, var(--tw-bg-opacity, 1));
}

.hover\\:bg-blumine-100\\/0:hover{
  background-color: rgba(218, 238, 243, 0);
}

.hover\\:bg-blumine-100\\/10:hover{
  background-color: rgba(218, 238, 243, 0.1);
}

.hover\\:bg-blumine-100\\/100:hover{
  background-color: rgb(218, 238, 243);
}

.hover\\:bg-blumine-100\\/15:hover{
  background-color: rgba(218, 238, 243, 0.15);
}

.hover\\:bg-blumine-100\\/20:hover{
  background-color: rgba(218, 238, 243, 0.2);
}

.hover\\:bg-blumine-100\\/25:hover{
  background-color: rgba(218, 238, 243, 0.25);
}

.hover\\:bg-blumine-100\\/30:hover{
  background-color: rgba(218, 238, 243, 0.3);
}

.hover\\:bg-blumine-100\\/35:hover{
  background-color: rgba(218, 238, 243, 0.35);
}

.hover\\:bg-blumine-100\\/40:hover{
  background-color: rgba(218, 238, 243, 0.4);
}

.hover\\:bg-blumine-100\\/45:hover{
  background-color: rgba(218, 238, 243, 0.45);
}

.hover\\:bg-blumine-100\\/5:hover{
  background-color: rgba(218, 238, 243, 0.05);
}

.hover\\:bg-blumine-100\\/50:hover{
  background-color: rgba(218, 238, 243, 0.5);
}

.hover\\:bg-blumine-100\\/55:hover{
  background-color: rgba(218, 238, 243, 0.55);
}

.hover\\:bg-blumine-100\\/60:hover{
  background-color: rgba(218, 238, 243, 0.6);
}

.hover\\:bg-blumine-100\\/65:hover{
  background-color: rgba(218, 238, 243, 0.65);
}

.hover\\:bg-blumine-100\\/70:hover{
  background-color: rgba(218, 238, 243, 0.7);
}

.hover\\:bg-blumine-100\\/75:hover{
  background-color: rgba(218, 238, 243, 0.75);
}

.hover\\:bg-blumine-100\\/80:hover{
  background-color: rgba(218, 238, 243, 0.8);
}

.hover\\:bg-blumine-100\\/85:hover{
  background-color: rgba(218, 238, 243, 0.85);
}

.hover\\:bg-blumine-100\\/90:hover{
  background-color: rgba(218, 238, 243, 0.9);
}

.hover\\:bg-blumine-100\\/95:hover{
  background-color: rgba(218, 238, 243, 0.95);
}

.hover\\:bg-blumine-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(186, 222, 231, 1);
  background-color: rgba(186, 222, 231, var(--tw-bg-opacity, 1));
}

.hover\\:bg-blumine-200\\/0:hover{
  background-color: rgba(186, 222, 231, 0);
}

.hover\\:bg-blumine-200\\/10:hover{
  background-color: rgba(186, 222, 231, 0.1);
}

.hover\\:bg-blumine-200\\/100:hover{
  background-color: rgb(186, 222, 231);
}

.hover\\:bg-blumine-200\\/15:hover{
  background-color: rgba(186, 222, 231, 0.15);
}

.hover\\:bg-blumine-200\\/20:hover{
  background-color: rgba(186, 222, 231, 0.2);
}

.hover\\:bg-blumine-200\\/25:hover{
  background-color: rgba(186, 222, 231, 0.25);
}

.hover\\:bg-blumine-200\\/30:hover{
  background-color: rgba(186, 222, 231, 0.3);
}

.hover\\:bg-blumine-200\\/35:hover{
  background-color: rgba(186, 222, 231, 0.35);
}

.hover\\:bg-blumine-200\\/40:hover{
  background-color: rgba(186, 222, 231, 0.4);
}

.hover\\:bg-blumine-200\\/45:hover{
  background-color: rgba(186, 222, 231, 0.45);
}

.hover\\:bg-blumine-200\\/5:hover{
  background-color: rgba(186, 222, 231, 0.05);
}

.hover\\:bg-blumine-200\\/50:hover{
  background-color: rgba(186, 222, 231, 0.5);
}

.hover\\:bg-blumine-200\\/55:hover{
  background-color: rgba(186, 222, 231, 0.55);
}

.hover\\:bg-blumine-200\\/60:hover{
  background-color: rgba(186, 222, 231, 0.6);
}

.hover\\:bg-blumine-200\\/65:hover{
  background-color: rgba(186, 222, 231, 0.65);
}

.hover\\:bg-blumine-200\\/70:hover{
  background-color: rgba(186, 222, 231, 0.7);
}

.hover\\:bg-blumine-200\\/75:hover{
  background-color: rgba(186, 222, 231, 0.75);
}

.hover\\:bg-blumine-200\\/80:hover{
  background-color: rgba(186, 222, 231, 0.8);
}

.hover\\:bg-blumine-200\\/85:hover{
  background-color: rgba(186, 222, 231, 0.85);
}

.hover\\:bg-blumine-200\\/90:hover{
  background-color: rgba(186, 222, 231, 0.9);
}

.hover\\:bg-blumine-200\\/95:hover{
  background-color: rgba(186, 222, 231, 0.95);
}

.hover\\:bg-blumine-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(137, 197, 215, 1);
  background-color: rgba(137, 197, 215, var(--tw-bg-opacity, 1));
}

.hover\\:bg-blumine-300\\/0:hover{
  background-color: rgba(137, 197, 215, 0);
}

.hover\\:bg-blumine-300\\/10:hover{
  background-color: rgba(137, 197, 215, 0.1);
}

.hover\\:bg-blumine-300\\/100:hover{
  background-color: rgb(137, 197, 215);
}

.hover\\:bg-blumine-300\\/15:hover{
  background-color: rgba(137, 197, 215, 0.15);
}

.hover\\:bg-blumine-300\\/20:hover{
  background-color: rgba(137, 197, 215, 0.2);
}

.hover\\:bg-blumine-300\\/25:hover{
  background-color: rgba(137, 197, 215, 0.25);
}

.hover\\:bg-blumine-300\\/30:hover{
  background-color: rgba(137, 197, 215, 0.3);
}

.hover\\:bg-blumine-300\\/35:hover{
  background-color: rgba(137, 197, 215, 0.35);
}

.hover\\:bg-blumine-300\\/40:hover{
  background-color: rgba(137, 197, 215, 0.4);
}

.hover\\:bg-blumine-300\\/45:hover{
  background-color: rgba(137, 197, 215, 0.45);
}

.hover\\:bg-blumine-300\\/5:hover{
  background-color: rgba(137, 197, 215, 0.05);
}

.hover\\:bg-blumine-300\\/50:hover{
  background-color: rgba(137, 197, 215, 0.5);
}

.hover\\:bg-blumine-300\\/55:hover{
  background-color: rgba(137, 197, 215, 0.55);
}

.hover\\:bg-blumine-300\\/60:hover{
  background-color: rgba(137, 197, 215, 0.6);
}

.hover\\:bg-blumine-300\\/65:hover{
  background-color: rgba(137, 197, 215, 0.65);
}

.hover\\:bg-blumine-300\\/70:hover{
  background-color: rgba(137, 197, 215, 0.7);
}

.hover\\:bg-blumine-300\\/75:hover{
  background-color: rgba(137, 197, 215, 0.75);
}

.hover\\:bg-blumine-300\\/80:hover{
  background-color: rgba(137, 197, 215, 0.8);
}

.hover\\:bg-blumine-300\\/85:hover{
  background-color: rgba(137, 197, 215, 0.85);
}

.hover\\:bg-blumine-300\\/90:hover{
  background-color: rgba(137, 197, 215, 0.9);
}

.hover\\:bg-blumine-300\\/95:hover{
  background-color: rgba(137, 197, 215, 0.95);
}

.hover\\:bg-blumine-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(82, 163, 190, 1);
  background-color: rgba(82, 163, 190, var(--tw-bg-opacity, 1));
}

.hover\\:bg-blumine-400\\/0:hover{
  background-color: rgba(82, 163, 190, 0);
}

.hover\\:bg-blumine-400\\/10:hover{
  background-color: rgba(82, 163, 190, 0.1);
}

.hover\\:bg-blumine-400\\/100:hover{
  background-color: rgb(82, 163, 190);
}

.hover\\:bg-blumine-400\\/15:hover{
  background-color: rgba(82, 163, 190, 0.15);
}

.hover\\:bg-blumine-400\\/20:hover{
  background-color: rgba(82, 163, 190, 0.2);
}

.hover\\:bg-blumine-400\\/25:hover{
  background-color: rgba(82, 163, 190, 0.25);
}

.hover\\:bg-blumine-400\\/30:hover{
  background-color: rgba(82, 163, 190, 0.3);
}

.hover\\:bg-blumine-400\\/35:hover{
  background-color: rgba(82, 163, 190, 0.35);
}

.hover\\:bg-blumine-400\\/40:hover{
  background-color: rgba(82, 163, 190, 0.4);
}

.hover\\:bg-blumine-400\\/45:hover{
  background-color: rgba(82, 163, 190, 0.45);
}

.hover\\:bg-blumine-400\\/5:hover{
  background-color: rgba(82, 163, 190, 0.05);
}

.hover\\:bg-blumine-400\\/50:hover{
  background-color: rgba(82, 163, 190, 0.5);
}

.hover\\:bg-blumine-400\\/55:hover{
  background-color: rgba(82, 163, 190, 0.55);
}

.hover\\:bg-blumine-400\\/60:hover{
  background-color: rgba(82, 163, 190, 0.6);
}

.hover\\:bg-blumine-400\\/65:hover{
  background-color: rgba(82, 163, 190, 0.65);
}

.hover\\:bg-blumine-400\\/70:hover{
  background-color: rgba(82, 163, 190, 0.7);
}

.hover\\:bg-blumine-400\\/75:hover{
  background-color: rgba(82, 163, 190, 0.75);
}

.hover\\:bg-blumine-400\\/80:hover{
  background-color: rgba(82, 163, 190, 0.8);
}

.hover\\:bg-blumine-400\\/85:hover{
  background-color: rgba(82, 163, 190, 0.85);
}

.hover\\:bg-blumine-400\\/90:hover{
  background-color: rgba(82, 163, 190, 0.9);
}

.hover\\:bg-blumine-400\\/95:hover{
  background-color: rgba(82, 163, 190, 0.95);
}

.hover\\:bg-blumine-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(55, 135, 163, 1);
  background-color: rgba(55, 135, 163, var(--tw-bg-opacity, 1));
}

.hover\\:bg-blumine-500\\/0:hover{
  background-color: rgba(55, 135, 163, 0);
}

.hover\\:bg-blumine-500\\/10:hover{
  background-color: rgba(55, 135, 163, 0.1);
}

.hover\\:bg-blumine-500\\/100:hover{
  background-color: rgb(55, 135, 163);
}

.hover\\:bg-blumine-500\\/15:hover{
  background-color: rgba(55, 135, 163, 0.15);
}

.hover\\:bg-blumine-500\\/20:hover{
  background-color: rgba(55, 135, 163, 0.2);
}

.hover\\:bg-blumine-500\\/25:hover{
  background-color: rgba(55, 135, 163, 0.25);
}

.hover\\:bg-blumine-500\\/30:hover{
  background-color: rgba(55, 135, 163, 0.3);
}

.hover\\:bg-blumine-500\\/35:hover{
  background-color: rgba(55, 135, 163, 0.35);
}

.hover\\:bg-blumine-500\\/40:hover{
  background-color: rgba(55, 135, 163, 0.4);
}

.hover\\:bg-blumine-500\\/45:hover{
  background-color: rgba(55, 135, 163, 0.45);
}

.hover\\:bg-blumine-500\\/5:hover{
  background-color: rgba(55, 135, 163, 0.05);
}

.hover\\:bg-blumine-500\\/50:hover{
  background-color: rgba(55, 135, 163, 0.5);
}

.hover\\:bg-blumine-500\\/55:hover{
  background-color: rgba(55, 135, 163, 0.55);
}

.hover\\:bg-blumine-500\\/60:hover{
  background-color: rgba(55, 135, 163, 0.6);
}

.hover\\:bg-blumine-500\\/65:hover{
  background-color: rgba(55, 135, 163, 0.65);
}

.hover\\:bg-blumine-500\\/70:hover{
  background-color: rgba(55, 135, 163, 0.7);
}

.hover\\:bg-blumine-500\\/75:hover{
  background-color: rgba(55, 135, 163, 0.75);
}

.hover\\:bg-blumine-500\\/80:hover{
  background-color: rgba(55, 135, 163, 0.8);
}

.hover\\:bg-blumine-500\\/85:hover{
  background-color: rgba(55, 135, 163, 0.85);
}

.hover\\:bg-blumine-500\\/90:hover{
  background-color: rgba(55, 135, 163, 0.9);
}

.hover\\:bg-blumine-500\\/95:hover{
  background-color: rgba(55, 135, 163, 0.95);
}

.hover\\:bg-blumine-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(48, 109, 138, 1);
  background-color: rgba(48, 109, 138, var(--tw-bg-opacity, 1));
}

.hover\\:bg-blumine-600\\/0:hover{
  background-color: rgba(48, 109, 138, 0);
}

.hover\\:bg-blumine-600\\/10:hover{
  background-color: rgba(48, 109, 138, 0.1);
}

.hover\\:bg-blumine-600\\/100:hover{
  background-color: rgb(48, 109, 138);
}

.hover\\:bg-blumine-600\\/15:hover{
  background-color: rgba(48, 109, 138, 0.15);
}

.hover\\:bg-blumine-600\\/20:hover{
  background-color: rgba(48, 109, 138, 0.2);
}

.hover\\:bg-blumine-600\\/25:hover{
  background-color: rgba(48, 109, 138, 0.25);
}

.hover\\:bg-blumine-600\\/30:hover{
  background-color: rgba(48, 109, 138, 0.3);
}

.hover\\:bg-blumine-600\\/35:hover{
  background-color: rgba(48, 109, 138, 0.35);
}

.hover\\:bg-blumine-600\\/40:hover{
  background-color: rgba(48, 109, 138, 0.4);
}

.hover\\:bg-blumine-600\\/45:hover{
  background-color: rgba(48, 109, 138, 0.45);
}

.hover\\:bg-blumine-600\\/5:hover{
  background-color: rgba(48, 109, 138, 0.05);
}

.hover\\:bg-blumine-600\\/50:hover{
  background-color: rgba(48, 109, 138, 0.5);
}

.hover\\:bg-blumine-600\\/55:hover{
  background-color: rgba(48, 109, 138, 0.55);
}

.hover\\:bg-blumine-600\\/60:hover{
  background-color: rgba(48, 109, 138, 0.6);
}

.hover\\:bg-blumine-600\\/65:hover{
  background-color: rgba(48, 109, 138, 0.65);
}

.hover\\:bg-blumine-600\\/70:hover{
  background-color: rgba(48, 109, 138, 0.7);
}

.hover\\:bg-blumine-600\\/75:hover{
  background-color: rgba(48, 109, 138, 0.75);
}

.hover\\:bg-blumine-600\\/80:hover{
  background-color: rgba(48, 109, 138, 0.8);
}

.hover\\:bg-blumine-600\\/85:hover{
  background-color: rgba(48, 109, 138, 0.85);
}

.hover\\:bg-blumine-600\\/90:hover{
  background-color: rgba(48, 109, 138, 0.9);
}

.hover\\:bg-blumine-600\\/95:hover{
  background-color: rgba(48, 109, 138, 0.95);
}

.hover\\:bg-blumine-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(45, 91, 114, 1);
  background-color: rgba(45, 91, 114, var(--tw-bg-opacity, 1));
}

.hover\\:bg-blumine-700\\/0:hover{
  background-color: rgba(45, 91, 114, 0);
}

.hover\\:bg-blumine-700\\/10:hover{
  background-color: rgba(45, 91, 114, 0.1);
}

.hover\\:bg-blumine-700\\/100:hover{
  background-color: rgb(45, 91, 114);
}

.hover\\:bg-blumine-700\\/15:hover{
  background-color: rgba(45, 91, 114, 0.15);
}

.hover\\:bg-blumine-700\\/20:hover{
  background-color: rgba(45, 91, 114, 0.2);
}

.hover\\:bg-blumine-700\\/25:hover{
  background-color: rgba(45, 91, 114, 0.25);
}

.hover\\:bg-blumine-700\\/30:hover{
  background-color: rgba(45, 91, 114, 0.3);
}

.hover\\:bg-blumine-700\\/35:hover{
  background-color: rgba(45, 91, 114, 0.35);
}

.hover\\:bg-blumine-700\\/40:hover{
  background-color: rgba(45, 91, 114, 0.4);
}

.hover\\:bg-blumine-700\\/45:hover{
  background-color: rgba(45, 91, 114, 0.45);
}

.hover\\:bg-blumine-700\\/5:hover{
  background-color: rgba(45, 91, 114, 0.05);
}

.hover\\:bg-blumine-700\\/50:hover{
  background-color: rgba(45, 91, 114, 0.5);
}

.hover\\:bg-blumine-700\\/55:hover{
  background-color: rgba(45, 91, 114, 0.55);
}

.hover\\:bg-blumine-700\\/60:hover{
  background-color: rgba(45, 91, 114, 0.6);
}

.hover\\:bg-blumine-700\\/65:hover{
  background-color: rgba(45, 91, 114, 0.65);
}

.hover\\:bg-blumine-700\\/70:hover{
  background-color: rgba(45, 91, 114, 0.7);
}

.hover\\:bg-blumine-700\\/75:hover{
  background-color: rgba(45, 91, 114, 0.75);
}

.hover\\:bg-blumine-700\\/80:hover{
  background-color: rgba(45, 91, 114, 0.8);
}

.hover\\:bg-blumine-700\\/85:hover{
  background-color: rgba(45, 91, 114, 0.85);
}

.hover\\:bg-blumine-700\\/90:hover{
  background-color: rgba(45, 91, 114, 0.9);
}

.hover\\:bg-blumine-700\\/95:hover{
  background-color: rgba(45, 91, 114, 0.95);
}

.hover\\:bg-blumine-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(44, 76, 94, 1);
  background-color: rgba(44, 76, 94, var(--tw-bg-opacity, 1));
}

.hover\\:bg-blumine-800\\/0:hover{
  background-color: rgba(44, 76, 94, 0);
}

.hover\\:bg-blumine-800\\/10:hover{
  background-color: rgba(44, 76, 94, 0.1);
}

.hover\\:bg-blumine-800\\/100:hover{
  background-color: rgb(44, 76, 94);
}

.hover\\:bg-blumine-800\\/15:hover{
  background-color: rgba(44, 76, 94, 0.15);
}

.hover\\:bg-blumine-800\\/20:hover{
  background-color: rgba(44, 76, 94, 0.2);
}

.hover\\:bg-blumine-800\\/25:hover{
  background-color: rgba(44, 76, 94, 0.25);
}

.hover\\:bg-blumine-800\\/30:hover{
  background-color: rgba(44, 76, 94, 0.3);
}

.hover\\:bg-blumine-800\\/35:hover{
  background-color: rgba(44, 76, 94, 0.35);
}

.hover\\:bg-blumine-800\\/40:hover{
  background-color: rgba(44, 76, 94, 0.4);
}

.hover\\:bg-blumine-800\\/45:hover{
  background-color: rgba(44, 76, 94, 0.45);
}

.hover\\:bg-blumine-800\\/5:hover{
  background-color: rgba(44, 76, 94, 0.05);
}

.hover\\:bg-blumine-800\\/50:hover{
  background-color: rgba(44, 76, 94, 0.5);
}

.hover\\:bg-blumine-800\\/55:hover{
  background-color: rgba(44, 76, 94, 0.55);
}

.hover\\:bg-blumine-800\\/60:hover{
  background-color: rgba(44, 76, 94, 0.6);
}

.hover\\:bg-blumine-800\\/65:hover{
  background-color: rgba(44, 76, 94, 0.65);
}

.hover\\:bg-blumine-800\\/70:hover{
  background-color: rgba(44, 76, 94, 0.7);
}

.hover\\:bg-blumine-800\\/75:hover{
  background-color: rgba(44, 76, 94, 0.75);
}

.hover\\:bg-blumine-800\\/80:hover{
  background-color: rgba(44, 76, 94, 0.8);
}

.hover\\:bg-blumine-800\\/85:hover{
  background-color: rgba(44, 76, 94, 0.85);
}

.hover\\:bg-blumine-800\\/90:hover{
  background-color: rgba(44, 76, 94, 0.9);
}

.hover\\:bg-blumine-800\\/95:hover{
  background-color: rgba(44, 76, 94, 0.95);
}

.hover\\:bg-blumine-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(40, 65, 81, 1);
  background-color: rgba(40, 65, 81, var(--tw-bg-opacity, 1));
}

.hover\\:bg-blumine-900\\/0:hover{
  background-color: rgba(40, 65, 81, 0);
}

.hover\\:bg-blumine-900\\/10:hover{
  background-color: rgba(40, 65, 81, 0.1);
}

.hover\\:bg-blumine-900\\/100:hover{
  background-color: rgb(40, 65, 81);
}

.hover\\:bg-blumine-900\\/15:hover{
  background-color: rgba(40, 65, 81, 0.15);
}

.hover\\:bg-blumine-900\\/20:hover{
  background-color: rgba(40, 65, 81, 0.2);
}

.hover\\:bg-blumine-900\\/25:hover{
  background-color: rgba(40, 65, 81, 0.25);
}

.hover\\:bg-blumine-900\\/30:hover{
  background-color: rgba(40, 65, 81, 0.3);
}

.hover\\:bg-blumine-900\\/35:hover{
  background-color: rgba(40, 65, 81, 0.35);
}

.hover\\:bg-blumine-900\\/40:hover{
  background-color: rgba(40, 65, 81, 0.4);
}

.hover\\:bg-blumine-900\\/45:hover{
  background-color: rgba(40, 65, 81, 0.45);
}

.hover\\:bg-blumine-900\\/5:hover{
  background-color: rgba(40, 65, 81, 0.05);
}

.hover\\:bg-blumine-900\\/50:hover{
  background-color: rgba(40, 65, 81, 0.5);
}

.hover\\:bg-blumine-900\\/55:hover{
  background-color: rgba(40, 65, 81, 0.55);
}

.hover\\:bg-blumine-900\\/60:hover{
  background-color: rgba(40, 65, 81, 0.6);
}

.hover\\:bg-blumine-900\\/65:hover{
  background-color: rgba(40, 65, 81, 0.65);
}

.hover\\:bg-blumine-900\\/70:hover{
  background-color: rgba(40, 65, 81, 0.7);
}

.hover\\:bg-blumine-900\\/75:hover{
  background-color: rgba(40, 65, 81, 0.75);
}

.hover\\:bg-blumine-900\\/80:hover{
  background-color: rgba(40, 65, 81, 0.8);
}

.hover\\:bg-blumine-900\\/85:hover{
  background-color: rgba(40, 65, 81, 0.85);
}

.hover\\:bg-blumine-900\\/90:hover{
  background-color: rgba(40, 65, 81, 0.9);
}

.hover\\:bg-blumine-900\\/95:hover{
  background-color: rgba(40, 65, 81, 0.95);
}

.hover\\:bg-blumine-950:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(22, 41, 54, 1);
  background-color: rgba(22, 41, 54, var(--tw-bg-opacity, 1));
}

.hover\\:bg-blumine-950\\/0:hover{
  background-color: rgba(22, 41, 54, 0);
}

.hover\\:bg-blumine-950\\/10:hover{
  background-color: rgba(22, 41, 54, 0.1);
}

.hover\\:bg-blumine-950\\/100:hover{
  background-color: rgb(22, 41, 54);
}

.hover\\:bg-blumine-950\\/15:hover{
  background-color: rgba(22, 41, 54, 0.15);
}

.hover\\:bg-blumine-950\\/20:hover{
  background-color: rgba(22, 41, 54, 0.2);
}

.hover\\:bg-blumine-950\\/25:hover{
  background-color: rgba(22, 41, 54, 0.25);
}

.hover\\:bg-blumine-950\\/30:hover{
  background-color: rgba(22, 41, 54, 0.3);
}

.hover\\:bg-blumine-950\\/35:hover{
  background-color: rgba(22, 41, 54, 0.35);
}

.hover\\:bg-blumine-950\\/40:hover{
  background-color: rgba(22, 41, 54, 0.4);
}

.hover\\:bg-blumine-950\\/45:hover{
  background-color: rgba(22, 41, 54, 0.45);
}

.hover\\:bg-blumine-950\\/5:hover{
  background-color: rgba(22, 41, 54, 0.05);
}

.hover\\:bg-blumine-950\\/50:hover{
  background-color: rgba(22, 41, 54, 0.5);
}

.hover\\:bg-blumine-950\\/55:hover{
  background-color: rgba(22, 41, 54, 0.55);
}

.hover\\:bg-blumine-950\\/60:hover{
  background-color: rgba(22, 41, 54, 0.6);
}

.hover\\:bg-blumine-950\\/65:hover{
  background-color: rgba(22, 41, 54, 0.65);
}

.hover\\:bg-blumine-950\\/70:hover{
  background-color: rgba(22, 41, 54, 0.7);
}

.hover\\:bg-blumine-950\\/75:hover{
  background-color: rgba(22, 41, 54, 0.75);
}

.hover\\:bg-blumine-950\\/80:hover{
  background-color: rgba(22, 41, 54, 0.8);
}

.hover\\:bg-blumine-950\\/85:hover{
  background-color: rgba(22, 41, 54, 0.85);
}

.hover\\:bg-blumine-950\\/90:hover{
  background-color: rgba(22, 41, 54, 0.9);
}

.hover\\:bg-blumine-950\\/95:hover{
  background-color: rgba(22, 41, 54, 0.95);
}

.hover\\:bg-charcoal-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(230, 230, 231, 1);
  background-color: rgba(230, 230, 231, var(--tw-bg-opacity, 1));
}

.hover\\:bg-charcoal-100\\/0:hover{
  background-color: rgba(230, 230, 231, 0);
}

.hover\\:bg-charcoal-100\\/10:hover{
  background-color: rgba(230, 230, 231, 0.1);
}

.hover\\:bg-charcoal-100\\/100:hover{
  background-color: rgb(230, 230, 231);
}

.hover\\:bg-charcoal-100\\/15:hover{
  background-color: rgba(230, 230, 231, 0.15);
}

.hover\\:bg-charcoal-100\\/20:hover{
  background-color: rgba(230, 230, 231, 0.2);
}

.hover\\:bg-charcoal-100\\/25:hover{
  background-color: rgba(230, 230, 231, 0.25);
}

.hover\\:bg-charcoal-100\\/30:hover{
  background-color: rgba(230, 230, 231, 0.3);
}

.hover\\:bg-charcoal-100\\/35:hover{
  background-color: rgba(230, 230, 231, 0.35);
}

.hover\\:bg-charcoal-100\\/40:hover{
  background-color: rgba(230, 230, 231, 0.4);
}

.hover\\:bg-charcoal-100\\/45:hover{
  background-color: rgba(230, 230, 231, 0.45);
}

.hover\\:bg-charcoal-100\\/5:hover{
  background-color: rgba(230, 230, 231, 0.05);
}

.hover\\:bg-charcoal-100\\/50:hover{
  background-color: rgba(230, 230, 231, 0.5);
}

.hover\\:bg-charcoal-100\\/55:hover{
  background-color: rgba(230, 230, 231, 0.55);
}

.hover\\:bg-charcoal-100\\/60:hover{
  background-color: rgba(230, 230, 231, 0.6);
}

.hover\\:bg-charcoal-100\\/65:hover{
  background-color: rgba(230, 230, 231, 0.65);
}

.hover\\:bg-charcoal-100\\/70:hover{
  background-color: rgba(230, 230, 231, 0.7);
}

.hover\\:bg-charcoal-100\\/75:hover{
  background-color: rgba(230, 230, 231, 0.75);
}

.hover\\:bg-charcoal-100\\/80:hover{
  background-color: rgba(230, 230, 231, 0.8);
}

.hover\\:bg-charcoal-100\\/85:hover{
  background-color: rgba(230, 230, 231, 0.85);
}

.hover\\:bg-charcoal-100\\/90:hover{
  background-color: rgba(230, 230, 231, 0.9);
}

.hover\\:bg-charcoal-100\\/95:hover{
  background-color: rgba(230, 230, 231, 0.95);
}

.hover\\:bg-charcoal-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(207, 208, 210, 1);
  background-color: rgba(207, 208, 210, var(--tw-bg-opacity, 1));
}

.hover\\:bg-charcoal-200\\/0:hover{
  background-color: rgba(207, 208, 210, 0);
}

.hover\\:bg-charcoal-200\\/10:hover{
  background-color: rgba(207, 208, 210, 0.1);
}

.hover\\:bg-charcoal-200\\/100:hover{
  background-color: rgb(207, 208, 210);
}

.hover\\:bg-charcoal-200\\/15:hover{
  background-color: rgba(207, 208, 210, 0.15);
}

.hover\\:bg-charcoal-200\\/20:hover{
  background-color: rgba(207, 208, 210, 0.2);
}

.hover\\:bg-charcoal-200\\/25:hover{
  background-color: rgba(207, 208, 210, 0.25);
}

.hover\\:bg-charcoal-200\\/30:hover{
  background-color: rgba(207, 208, 210, 0.3);
}

.hover\\:bg-charcoal-200\\/35:hover{
  background-color: rgba(207, 208, 210, 0.35);
}

.hover\\:bg-charcoal-200\\/40:hover{
  background-color: rgba(207, 208, 210, 0.4);
}

.hover\\:bg-charcoal-200\\/45:hover{
  background-color: rgba(207, 208, 210, 0.45);
}

.hover\\:bg-charcoal-200\\/5:hover{
  background-color: rgba(207, 208, 210, 0.05);
}

.hover\\:bg-charcoal-200\\/50:hover{
  background-color: rgba(207, 208, 210, 0.5);
}

.hover\\:bg-charcoal-200\\/55:hover{
  background-color: rgba(207, 208, 210, 0.55);
}

.hover\\:bg-charcoal-200\\/60:hover{
  background-color: rgba(207, 208, 210, 0.6);
}

.hover\\:bg-charcoal-200\\/65:hover{
  background-color: rgba(207, 208, 210, 0.65);
}

.hover\\:bg-charcoal-200\\/70:hover{
  background-color: rgba(207, 208, 210, 0.7);
}

.hover\\:bg-charcoal-200\\/75:hover{
  background-color: rgba(207, 208, 210, 0.75);
}

.hover\\:bg-charcoal-200\\/80:hover{
  background-color: rgba(207, 208, 210, 0.8);
}

.hover\\:bg-charcoal-200\\/85:hover{
  background-color: rgba(207, 208, 210, 0.85);
}

.hover\\:bg-charcoal-200\\/90:hover{
  background-color: rgba(207, 208, 210, 0.9);
}

.hover\\:bg-charcoal-200\\/95:hover{
  background-color: rgba(207, 208, 210, 0.95);
}

.hover\\:bg-charcoal-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(174, 175, 178, 1);
  background-color: rgba(174, 175, 178, var(--tw-bg-opacity, 1));
}

.hover\\:bg-charcoal-300\\/0:hover{
  background-color: rgba(174, 175, 178, 0);
}

.hover\\:bg-charcoal-300\\/10:hover{
  background-color: rgba(174, 175, 178, 0.1);
}

.hover\\:bg-charcoal-300\\/100:hover{
  background-color: rgb(174, 175, 178);
}

.hover\\:bg-charcoal-300\\/15:hover{
  background-color: rgba(174, 175, 178, 0.15);
}

.hover\\:bg-charcoal-300\\/20:hover{
  background-color: rgba(174, 175, 178, 0.2);
}

.hover\\:bg-charcoal-300\\/25:hover{
  background-color: rgba(174, 175, 178, 0.25);
}

.hover\\:bg-charcoal-300\\/30:hover{
  background-color: rgba(174, 175, 178, 0.3);
}

.hover\\:bg-charcoal-300\\/35:hover{
  background-color: rgba(174, 175, 178, 0.35);
}

.hover\\:bg-charcoal-300\\/40:hover{
  background-color: rgba(174, 175, 178, 0.4);
}

.hover\\:bg-charcoal-300\\/45:hover{
  background-color: rgba(174, 175, 178, 0.45);
}

.hover\\:bg-charcoal-300\\/5:hover{
  background-color: rgba(174, 175, 178, 0.05);
}

.hover\\:bg-charcoal-300\\/50:hover{
  background-color: rgba(174, 175, 178, 0.5);
}

.hover\\:bg-charcoal-300\\/55:hover{
  background-color: rgba(174, 175, 178, 0.55);
}

.hover\\:bg-charcoal-300\\/60:hover{
  background-color: rgba(174, 175, 178, 0.6);
}

.hover\\:bg-charcoal-300\\/65:hover{
  background-color: rgba(174, 175, 178, 0.65);
}

.hover\\:bg-charcoal-300\\/70:hover{
  background-color: rgba(174, 175, 178, 0.7);
}

.hover\\:bg-charcoal-300\\/75:hover{
  background-color: rgba(174, 175, 178, 0.75);
}

.hover\\:bg-charcoal-300\\/80:hover{
  background-color: rgba(174, 175, 178, 0.8);
}

.hover\\:bg-charcoal-300\\/85:hover{
  background-color: rgba(174, 175, 178, 0.85);
}

.hover\\:bg-charcoal-300\\/90:hover{
  background-color: rgba(174, 175, 178, 0.9);
}

.hover\\:bg-charcoal-300\\/95:hover{
  background-color: rgba(174, 175, 178, 0.95);
}

.hover\\:bg-charcoal-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(133, 134, 139, 1);
  background-color: rgba(133, 134, 139, var(--tw-bg-opacity, 1));
}

.hover\\:bg-charcoal-400\\/0:hover{
  background-color: rgba(133, 134, 139, 0);
}

.hover\\:bg-charcoal-400\\/10:hover{
  background-color: rgba(133, 134, 139, 0.1);
}

.hover\\:bg-charcoal-400\\/100:hover{
  background-color: rgb(133, 134, 139);
}

.hover\\:bg-charcoal-400\\/15:hover{
  background-color: rgba(133, 134, 139, 0.15);
}

.hover\\:bg-charcoal-400\\/20:hover{
  background-color: rgba(133, 134, 139, 0.2);
}

.hover\\:bg-charcoal-400\\/25:hover{
  background-color: rgba(133, 134, 139, 0.25);
}

.hover\\:bg-charcoal-400\\/30:hover{
  background-color: rgba(133, 134, 139, 0.3);
}

.hover\\:bg-charcoal-400\\/35:hover{
  background-color: rgba(133, 134, 139, 0.35);
}

.hover\\:bg-charcoal-400\\/40:hover{
  background-color: rgba(133, 134, 139, 0.4);
}

.hover\\:bg-charcoal-400\\/45:hover{
  background-color: rgba(133, 134, 139, 0.45);
}

.hover\\:bg-charcoal-400\\/5:hover{
  background-color: rgba(133, 134, 139, 0.05);
}

.hover\\:bg-charcoal-400\\/50:hover{
  background-color: rgba(133, 134, 139, 0.5);
}

.hover\\:bg-charcoal-400\\/55:hover{
  background-color: rgba(133, 134, 139, 0.55);
}

.hover\\:bg-charcoal-400\\/60:hover{
  background-color: rgba(133, 134, 139, 0.6);
}

.hover\\:bg-charcoal-400\\/65:hover{
  background-color: rgba(133, 134, 139, 0.65);
}

.hover\\:bg-charcoal-400\\/70:hover{
  background-color: rgba(133, 134, 139, 0.7);
}

.hover\\:bg-charcoal-400\\/75:hover{
  background-color: rgba(133, 134, 139, 0.75);
}

.hover\\:bg-charcoal-400\\/80:hover{
  background-color: rgba(133, 134, 139, 0.8);
}

.hover\\:bg-charcoal-400\\/85:hover{
  background-color: rgba(133, 134, 139, 0.85);
}

.hover\\:bg-charcoal-400\\/90:hover{
  background-color: rgba(133, 134, 139, 0.9);
}

.hover\\:bg-charcoal-400\\/95:hover{
  background-color: rgba(133, 134, 139, 0.95);
}

.hover\\:bg-charcoal-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(245, 245, 246, 1);
  background-color: rgba(245, 245, 246, var(--tw-bg-opacity, 1));
}

.hover\\:bg-charcoal-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(106, 107, 112, 1);
  background-color: rgba(106, 107, 112, var(--tw-bg-opacity, 1));
}

.hover\\:bg-charcoal-500\\/0:hover{
  background-color: rgba(106, 107, 112, 0);
}

.hover\\:bg-charcoal-500\\/10:hover{
  background-color: rgba(106, 107, 112, 0.1);
}

.hover\\:bg-charcoal-500\\/100:hover{
  background-color: rgb(106, 107, 112);
}

.hover\\:bg-charcoal-500\\/15:hover{
  background-color: rgba(106, 107, 112, 0.15);
}

.hover\\:bg-charcoal-500\\/20:hover{
  background-color: rgba(106, 107, 112, 0.2);
}

.hover\\:bg-charcoal-500\\/25:hover{
  background-color: rgba(106, 107, 112, 0.25);
}

.hover\\:bg-charcoal-500\\/30:hover{
  background-color: rgba(106, 107, 112, 0.3);
}

.hover\\:bg-charcoal-500\\/35:hover{
  background-color: rgba(106, 107, 112, 0.35);
}

.hover\\:bg-charcoal-500\\/40:hover{
  background-color: rgba(106, 107, 112, 0.4);
}

.hover\\:bg-charcoal-500\\/45:hover{
  background-color: rgba(106, 107, 112, 0.45);
}

.hover\\:bg-charcoal-500\\/5:hover{
  background-color: rgba(106, 107, 112, 0.05);
}

.hover\\:bg-charcoal-500\\/50:hover{
  background-color: rgba(106, 107, 112, 0.5);
}

.hover\\:bg-charcoal-500\\/55:hover{
  background-color: rgba(106, 107, 112, 0.55);
}

.hover\\:bg-charcoal-500\\/60:hover{
  background-color: rgba(106, 107, 112, 0.6);
}

.hover\\:bg-charcoal-500\\/65:hover{
  background-color: rgba(106, 107, 112, 0.65);
}

.hover\\:bg-charcoal-500\\/70:hover{
  background-color: rgba(106, 107, 112, 0.7);
}

.hover\\:bg-charcoal-500\\/75:hover{
  background-color: rgba(106, 107, 112, 0.75);
}

.hover\\:bg-charcoal-500\\/80:hover{
  background-color: rgba(106, 107, 112, 0.8);
}

.hover\\:bg-charcoal-500\\/85:hover{
  background-color: rgba(106, 107, 112, 0.85);
}

.hover\\:bg-charcoal-500\\/90:hover{
  background-color: rgba(106, 107, 112, 0.9);
}

.hover\\:bg-charcoal-500\\/95:hover{
  background-color: rgba(106, 107, 112, 0.95);
}

.hover\\:bg-charcoal-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(90, 91, 96, 1);
  background-color: rgba(90, 91, 96, var(--tw-bg-opacity, 1));
}

.hover\\:bg-charcoal-600\\/0:hover{
  background-color: rgba(90, 91, 96, 0);
}

.hover\\:bg-charcoal-600\\/10:hover{
  background-color: rgba(90, 91, 96, 0.1);
}

.hover\\:bg-charcoal-600\\/100:hover{
  background-color: rgb(90, 91, 96);
}

.hover\\:bg-charcoal-600\\/15:hover{
  background-color: rgba(90, 91, 96, 0.15);
}

.hover\\:bg-charcoal-600\\/20:hover{
  background-color: rgba(90, 91, 96, 0.2);
}

.hover\\:bg-charcoal-600\\/25:hover{
  background-color: rgba(90, 91, 96, 0.25);
}

.hover\\:bg-charcoal-600\\/30:hover{
  background-color: rgba(90, 91, 96, 0.3);
}

.hover\\:bg-charcoal-600\\/35:hover{
  background-color: rgba(90, 91, 96, 0.35);
}

.hover\\:bg-charcoal-600\\/40:hover{
  background-color: rgba(90, 91, 96, 0.4);
}

.hover\\:bg-charcoal-600\\/45:hover{
  background-color: rgba(90, 91, 96, 0.45);
}

.hover\\:bg-charcoal-600\\/5:hover{
  background-color: rgba(90, 91, 96, 0.05);
}

.hover\\:bg-charcoal-600\\/50:hover{
  background-color: rgba(90, 91, 96, 0.5);
}

.hover\\:bg-charcoal-600\\/55:hover{
  background-color: rgba(90, 91, 96, 0.55);
}

.hover\\:bg-charcoal-600\\/60:hover{
  background-color: rgba(90, 91, 96, 0.6);
}

.hover\\:bg-charcoal-600\\/65:hover{
  background-color: rgba(90, 91, 96, 0.65);
}

.hover\\:bg-charcoal-600\\/70:hover{
  background-color: rgba(90, 91, 96, 0.7);
}

.hover\\:bg-charcoal-600\\/75:hover{
  background-color: rgba(90, 91, 96, 0.75);
}

.hover\\:bg-charcoal-600\\/80:hover{
  background-color: rgba(90, 91, 96, 0.8);
}

.hover\\:bg-charcoal-600\\/85:hover{
  background-color: rgba(90, 91, 96, 0.85);
}

.hover\\:bg-charcoal-600\\/90:hover{
  background-color: rgba(90, 91, 96, 0.9);
}

.hover\\:bg-charcoal-600\\/95:hover{
  background-color: rgba(90, 91, 96, 0.95);
}

.hover\\:bg-charcoal-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(77, 77, 81, 1);
  background-color: rgba(77, 77, 81, var(--tw-bg-opacity, 1));
}

.hover\\:bg-charcoal-700\\/0:hover{
  background-color: rgba(77, 77, 81, 0);
}

.hover\\:bg-charcoal-700\\/10:hover{
  background-color: rgba(77, 77, 81, 0.1);
}

.hover\\:bg-charcoal-700\\/100:hover{
  background-color: rgb(77, 77, 81);
}

.hover\\:bg-charcoal-700\\/15:hover{
  background-color: rgba(77, 77, 81, 0.15);
}

.hover\\:bg-charcoal-700\\/20:hover{
  background-color: rgba(77, 77, 81, 0.2);
}

.hover\\:bg-charcoal-700\\/25:hover{
  background-color: rgba(77, 77, 81, 0.25);
}

.hover\\:bg-charcoal-700\\/30:hover{
  background-color: rgba(77, 77, 81, 0.3);
}

.hover\\:bg-charcoal-700\\/35:hover{
  background-color: rgba(77, 77, 81, 0.35);
}

.hover\\:bg-charcoal-700\\/40:hover{
  background-color: rgba(77, 77, 81, 0.4);
}

.hover\\:bg-charcoal-700\\/45:hover{
  background-color: rgba(77, 77, 81, 0.45);
}

.hover\\:bg-charcoal-700\\/5:hover{
  background-color: rgba(77, 77, 81, 0.05);
}

.hover\\:bg-charcoal-700\\/50:hover{
  background-color: rgba(77, 77, 81, 0.5);
}

.hover\\:bg-charcoal-700\\/55:hover{
  background-color: rgba(77, 77, 81, 0.55);
}

.hover\\:bg-charcoal-700\\/60:hover{
  background-color: rgba(77, 77, 81, 0.6);
}

.hover\\:bg-charcoal-700\\/65:hover{
  background-color: rgba(77, 77, 81, 0.65);
}

.hover\\:bg-charcoal-700\\/70:hover{
  background-color: rgba(77, 77, 81, 0.7);
}

.hover\\:bg-charcoal-700\\/75:hover{
  background-color: rgba(77, 77, 81, 0.75);
}

.hover\\:bg-charcoal-700\\/80:hover{
  background-color: rgba(77, 77, 81, 0.8);
}

.hover\\:bg-charcoal-700\\/85:hover{
  background-color: rgba(77, 77, 81, 0.85);
}

.hover\\:bg-charcoal-700\\/90:hover{
  background-color: rgba(77, 77, 81, 0.9);
}

.hover\\:bg-charcoal-700\\/95:hover{
  background-color: rgba(77, 77, 81, 0.95);
}

.hover\\:bg-charcoal-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(67, 67, 71, 1);
  background-color: rgba(67, 67, 71, var(--tw-bg-opacity, 1));
}

.hover\\:bg-charcoal-800\\/0:hover{
  background-color: rgba(67, 67, 71, 0);
}

.hover\\:bg-charcoal-800\\/10:hover{
  background-color: rgba(67, 67, 71, 0.1);
}

.hover\\:bg-charcoal-800\\/100:hover{
  background-color: rgb(67, 67, 71);
}

.hover\\:bg-charcoal-800\\/15:hover{
  background-color: rgba(67, 67, 71, 0.15);
}

.hover\\:bg-charcoal-800\\/20:hover{
  background-color: rgba(67, 67, 71, 0.2);
}

.hover\\:bg-charcoal-800\\/25:hover{
  background-color: rgba(67, 67, 71, 0.25);
}

.hover\\:bg-charcoal-800\\/30:hover{
  background-color: rgba(67, 67, 71, 0.3);
}

.hover\\:bg-charcoal-800\\/35:hover{
  background-color: rgba(67, 67, 71, 0.35);
}

.hover\\:bg-charcoal-800\\/40:hover{
  background-color: rgba(67, 67, 71, 0.4);
}

.hover\\:bg-charcoal-800\\/45:hover{
  background-color: rgba(67, 67, 71, 0.45);
}

.hover\\:bg-charcoal-800\\/5:hover{
  background-color: rgba(67, 67, 71, 0.05);
}

.hover\\:bg-charcoal-800\\/50:hover{
  background-color: rgba(67, 67, 71, 0.5);
}

.hover\\:bg-charcoal-800\\/55:hover{
  background-color: rgba(67, 67, 71, 0.55);
}

.hover\\:bg-charcoal-800\\/60:hover{
  background-color: rgba(67, 67, 71, 0.6);
}

.hover\\:bg-charcoal-800\\/65:hover{
  background-color: rgba(67, 67, 71, 0.65);
}

.hover\\:bg-charcoal-800\\/70:hover{
  background-color: rgba(67, 67, 71, 0.7);
}

.hover\\:bg-charcoal-800\\/75:hover{
  background-color: rgba(67, 67, 71, 0.75);
}

.hover\\:bg-charcoal-800\\/80:hover{
  background-color: rgba(67, 67, 71, 0.8);
}

.hover\\:bg-charcoal-800\\/85:hover{
  background-color: rgba(67, 67, 71, 0.85);
}

.hover\\:bg-charcoal-800\\/90:hover{
  background-color: rgba(67, 67, 71, 0.9);
}

.hover\\:bg-charcoal-800\\/95:hover{
  background-color: rgba(67, 67, 71, 0.95);
}

.hover\\:bg-charcoal-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(49, 49, 51, 1);
  background-color: rgba(49, 49, 51, var(--tw-bg-opacity, 1));
}

.hover\\:bg-charcoal-900\\/0:hover{
  background-color: rgba(49, 49, 51, 0);
}

.hover\\:bg-charcoal-900\\/10:hover{
  background-color: rgba(49, 49, 51, 0.1);
}

.hover\\:bg-charcoal-900\\/100:hover{
  background-color: rgb(49, 49, 51);
}

.hover\\:bg-charcoal-900\\/15:hover{
  background-color: rgba(49, 49, 51, 0.15);
}

.hover\\:bg-charcoal-900\\/20:hover{
  background-color: rgba(49, 49, 51, 0.2);
}

.hover\\:bg-charcoal-900\\/25:hover{
  background-color: rgba(49, 49, 51, 0.25);
}

.hover\\:bg-charcoal-900\\/30:hover{
  background-color: rgba(49, 49, 51, 0.3);
}

.hover\\:bg-charcoal-900\\/35:hover{
  background-color: rgba(49, 49, 51, 0.35);
}

.hover\\:bg-charcoal-900\\/40:hover{
  background-color: rgba(49, 49, 51, 0.4);
}

.hover\\:bg-charcoal-900\\/45:hover{
  background-color: rgba(49, 49, 51, 0.45);
}

.hover\\:bg-charcoal-900\\/5:hover{
  background-color: rgba(49, 49, 51, 0.05);
}

.hover\\:bg-charcoal-900\\/50:hover{
  background-color: rgba(49, 49, 51, 0.5);
}

.hover\\:bg-charcoal-900\\/55:hover{
  background-color: rgba(49, 49, 51, 0.55);
}

.hover\\:bg-charcoal-900\\/60:hover{
  background-color: rgba(49, 49, 51, 0.6);
}

.hover\\:bg-charcoal-900\\/65:hover{
  background-color: rgba(49, 49, 51, 0.65);
}

.hover\\:bg-charcoal-900\\/70:hover{
  background-color: rgba(49, 49, 51, 0.7);
}

.hover\\:bg-charcoal-900\\/75:hover{
  background-color: rgba(49, 49, 51, 0.75);
}

.hover\\:bg-charcoal-900\\/80:hover{
  background-color: rgba(49, 49, 51, 0.8);
}

.hover\\:bg-charcoal-900\\/85:hover{
  background-color: rgba(49, 49, 51, 0.85);
}

.hover\\:bg-charcoal-900\\/90:hover{
  background-color: rgba(49, 49, 51, 0.9);
}

.hover\\:bg-charcoal-900\\/95:hover{
  background-color: rgba(49, 49, 51, 0.95);
}

.hover\\:bg-charcoal-950:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(37, 37, 39, 1);
  background-color: rgba(37, 37, 39, var(--tw-bg-opacity, 1));
}

.hover\\:bg-charcoal-950\\/0:hover{
  background-color: rgba(37, 37, 39, 0);
}

.hover\\:bg-charcoal-950\\/10:hover{
  background-color: rgba(37, 37, 39, 0.1);
}

.hover\\:bg-charcoal-950\\/100:hover{
  background-color: rgb(37, 37, 39);
}

.hover\\:bg-charcoal-950\\/15:hover{
  background-color: rgba(37, 37, 39, 0.15);
}

.hover\\:bg-charcoal-950\\/20:hover{
  background-color: rgba(37, 37, 39, 0.2);
}

.hover\\:bg-charcoal-950\\/25:hover{
  background-color: rgba(37, 37, 39, 0.25);
}

.hover\\:bg-charcoal-950\\/30:hover{
  background-color: rgba(37, 37, 39, 0.3);
}

.hover\\:bg-charcoal-950\\/35:hover{
  background-color: rgba(37, 37, 39, 0.35);
}

.hover\\:bg-charcoal-950\\/40:hover{
  background-color: rgba(37, 37, 39, 0.4);
}

.hover\\:bg-charcoal-950\\/45:hover{
  background-color: rgba(37, 37, 39, 0.45);
}

.hover\\:bg-charcoal-950\\/5:hover{
  background-color: rgba(37, 37, 39, 0.05);
}

.hover\\:bg-charcoal-950\\/50:hover{
  background-color: rgba(37, 37, 39, 0.5);
}

.hover\\:bg-charcoal-950\\/55:hover{
  background-color: rgba(37, 37, 39, 0.55);
}

.hover\\:bg-charcoal-950\\/60:hover{
  background-color: rgba(37, 37, 39, 0.6);
}

.hover\\:bg-charcoal-950\\/65:hover{
  background-color: rgba(37, 37, 39, 0.65);
}

.hover\\:bg-charcoal-950\\/70:hover{
  background-color: rgba(37, 37, 39, 0.7);
}

.hover\\:bg-charcoal-950\\/75:hover{
  background-color: rgba(37, 37, 39, 0.75);
}

.hover\\:bg-charcoal-950\\/80:hover{
  background-color: rgba(37, 37, 39, 0.8);
}

.hover\\:bg-charcoal-950\\/85:hover{
  background-color: rgba(37, 37, 39, 0.85);
}

.hover\\:bg-charcoal-950\\/90:hover{
  background-color: rgba(37, 37, 39, 0.9);
}

.hover\\:bg-charcoal-950\\/95:hover{
  background-color: rgba(37, 37, 39, 0.95);
}

.hover\\:bg-jade-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(217, 242, 230, 1);
  background-color: rgba(217, 242, 230, var(--tw-bg-opacity, 1));
}

.hover\\:bg-jade-100\\/0:hover{
  background-color: rgba(217, 242, 230, 0);
}

.hover\\:bg-jade-100\\/10:hover{
  background-color: rgba(217, 242, 230, 0.1);
}

.hover\\:bg-jade-100\\/100:hover{
  background-color: rgb(217, 242, 230);
}

.hover\\:bg-jade-100\\/15:hover{
  background-color: rgba(217, 242, 230, 0.15);
}

.hover\\:bg-jade-100\\/20:hover{
  background-color: rgba(217, 242, 230, 0.2);
}

.hover\\:bg-jade-100\\/25:hover{
  background-color: rgba(217, 242, 230, 0.25);
}

.hover\\:bg-jade-100\\/30:hover{
  background-color: rgba(217, 242, 230, 0.3);
}

.hover\\:bg-jade-100\\/35:hover{
  background-color: rgba(217, 242, 230, 0.35);
}

.hover\\:bg-jade-100\\/40:hover{
  background-color: rgba(217, 242, 230, 0.4);
}

.hover\\:bg-jade-100\\/45:hover{
  background-color: rgba(217, 242, 230, 0.45);
}

.hover\\:bg-jade-100\\/5:hover{
  background-color: rgba(217, 242, 230, 0.05);
}

.hover\\:bg-jade-100\\/50:hover{
  background-color: rgba(217, 242, 230, 0.5);
}

.hover\\:bg-jade-100\\/55:hover{
  background-color: rgba(217, 242, 230, 0.55);
}

.hover\\:bg-jade-100\\/60:hover{
  background-color: rgba(217, 242, 230, 0.6);
}

.hover\\:bg-jade-100\\/65:hover{
  background-color: rgba(217, 242, 230, 0.65);
}

.hover\\:bg-jade-100\\/70:hover{
  background-color: rgba(217, 242, 230, 0.7);
}

.hover\\:bg-jade-100\\/75:hover{
  background-color: rgba(217, 242, 230, 0.75);
}

.hover\\:bg-jade-100\\/80:hover{
  background-color: rgba(217, 242, 230, 0.8);
}

.hover\\:bg-jade-100\\/85:hover{
  background-color: rgba(217, 242, 230, 0.85);
}

.hover\\:bg-jade-100\\/90:hover{
  background-color: rgba(217, 242, 230, 0.9);
}

.hover\\:bg-jade-100\\/95:hover{
  background-color: rgba(217, 242, 230, 0.95);
}

.hover\\:bg-jade-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(182, 228, 209, 1);
  background-color: rgba(182, 228, 209, var(--tw-bg-opacity, 1));
}

.hover\\:bg-jade-200\\/0:hover{
  background-color: rgba(182, 228, 209, 0);
}

.hover\\:bg-jade-200\\/10:hover{
  background-color: rgba(182, 228, 209, 0.1);
}

.hover\\:bg-jade-200\\/100:hover{
  background-color: rgb(182, 228, 209);
}

.hover\\:bg-jade-200\\/15:hover{
  background-color: rgba(182, 228, 209, 0.15);
}

.hover\\:bg-jade-200\\/20:hover{
  background-color: rgba(182, 228, 209, 0.2);
}

.hover\\:bg-jade-200\\/25:hover{
  background-color: rgba(182, 228, 209, 0.25);
}

.hover\\:bg-jade-200\\/30:hover{
  background-color: rgba(182, 228, 209, 0.3);
}

.hover\\:bg-jade-200\\/35:hover{
  background-color: rgba(182, 228, 209, 0.35);
}

.hover\\:bg-jade-200\\/40:hover{
  background-color: rgba(182, 228, 209, 0.4);
}

.hover\\:bg-jade-200\\/45:hover{
  background-color: rgba(182, 228, 209, 0.45);
}

.hover\\:bg-jade-200\\/5:hover{
  background-color: rgba(182, 228, 209, 0.05);
}

.hover\\:bg-jade-200\\/50:hover{
  background-color: rgba(182, 228, 209, 0.5);
}

.hover\\:bg-jade-200\\/55:hover{
  background-color: rgba(182, 228, 209, 0.55);
}

.hover\\:bg-jade-200\\/60:hover{
  background-color: rgba(182, 228, 209, 0.6);
}

.hover\\:bg-jade-200\\/65:hover{
  background-color: rgba(182, 228, 209, 0.65);
}

.hover\\:bg-jade-200\\/70:hover{
  background-color: rgba(182, 228, 209, 0.7);
}

.hover\\:bg-jade-200\\/75:hover{
  background-color: rgba(182, 228, 209, 0.75);
}

.hover\\:bg-jade-200\\/80:hover{
  background-color: rgba(182, 228, 209, 0.8);
}

.hover\\:bg-jade-200\\/85:hover{
  background-color: rgba(182, 228, 209, 0.85);
}

.hover\\:bg-jade-200\\/90:hover{
  background-color: rgba(182, 228, 209, 0.9);
}

.hover\\:bg-jade-200\\/95:hover{
  background-color: rgba(182, 228, 209, 0.95);
}

.hover\\:bg-jade-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(134, 207, 181, 1);
  background-color: rgba(134, 207, 181, var(--tw-bg-opacity, 1));
}

.hover\\:bg-jade-300\\/0:hover{
  background-color: rgba(134, 207, 181, 0);
}

.hover\\:bg-jade-300\\/10:hover{
  background-color: rgba(134, 207, 181, 0.1);
}

.hover\\:bg-jade-300\\/100:hover{
  background-color: rgb(134, 207, 181);
}

.hover\\:bg-jade-300\\/15:hover{
  background-color: rgba(134, 207, 181, 0.15);
}

.hover\\:bg-jade-300\\/20:hover{
  background-color: rgba(134, 207, 181, 0.2);
}

.hover\\:bg-jade-300\\/25:hover{
  background-color: rgba(134, 207, 181, 0.25);
}

.hover\\:bg-jade-300\\/30:hover{
  background-color: rgba(134, 207, 181, 0.3);
}

.hover\\:bg-jade-300\\/35:hover{
  background-color: rgba(134, 207, 181, 0.35);
}

.hover\\:bg-jade-300\\/40:hover{
  background-color: rgba(134, 207, 181, 0.4);
}

.hover\\:bg-jade-300\\/45:hover{
  background-color: rgba(134, 207, 181, 0.45);
}

.hover\\:bg-jade-300\\/5:hover{
  background-color: rgba(134, 207, 181, 0.05);
}

.hover\\:bg-jade-300\\/50:hover{
  background-color: rgba(134, 207, 181, 0.5);
}

.hover\\:bg-jade-300\\/55:hover{
  background-color: rgba(134, 207, 181, 0.55);
}

.hover\\:bg-jade-300\\/60:hover{
  background-color: rgba(134, 207, 181, 0.6);
}

.hover\\:bg-jade-300\\/65:hover{
  background-color: rgba(134, 207, 181, 0.65);
}

.hover\\:bg-jade-300\\/70:hover{
  background-color: rgba(134, 207, 181, 0.7);
}

.hover\\:bg-jade-300\\/75:hover{
  background-color: rgba(134, 207, 181, 0.75);
}

.hover\\:bg-jade-300\\/80:hover{
  background-color: rgba(134, 207, 181, 0.8);
}

.hover\\:bg-jade-300\\/85:hover{
  background-color: rgba(134, 207, 181, 0.85);
}

.hover\\:bg-jade-300\\/90:hover{
  background-color: rgba(134, 207, 181, 0.9);
}

.hover\\:bg-jade-300\\/95:hover{
  background-color: rgba(134, 207, 181, 0.95);
}

.hover\\:bg-jade-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(83, 180, 148, 1);
  background-color: rgba(83, 180, 148, var(--tw-bg-opacity, 1));
}

.hover\\:bg-jade-400\\/0:hover{
  background-color: rgba(83, 180, 148, 0);
}

.hover\\:bg-jade-400\\/10:hover{
  background-color: rgba(83, 180, 148, 0.1);
}

.hover\\:bg-jade-400\\/100:hover{
  background-color: rgb(83, 180, 148);
}

.hover\\:bg-jade-400\\/15:hover{
  background-color: rgba(83, 180, 148, 0.15);
}

.hover\\:bg-jade-400\\/20:hover{
  background-color: rgba(83, 180, 148, 0.2);
}

.hover\\:bg-jade-400\\/25:hover{
  background-color: rgba(83, 180, 148, 0.25);
}

.hover\\:bg-jade-400\\/30:hover{
  background-color: rgba(83, 180, 148, 0.3);
}

.hover\\:bg-jade-400\\/35:hover{
  background-color: rgba(83, 180, 148, 0.35);
}

.hover\\:bg-jade-400\\/40:hover{
  background-color: rgba(83, 180, 148, 0.4);
}

.hover\\:bg-jade-400\\/45:hover{
  background-color: rgba(83, 180, 148, 0.45);
}

.hover\\:bg-jade-400\\/5:hover{
  background-color: rgba(83, 180, 148, 0.05);
}

.hover\\:bg-jade-400\\/50:hover{
  background-color: rgba(83, 180, 148, 0.5);
}

.hover\\:bg-jade-400\\/55:hover{
  background-color: rgba(83, 180, 148, 0.55);
}

.hover\\:bg-jade-400\\/60:hover{
  background-color: rgba(83, 180, 148, 0.6);
}

.hover\\:bg-jade-400\\/65:hover{
  background-color: rgba(83, 180, 148, 0.65);
}

.hover\\:bg-jade-400\\/70:hover{
  background-color: rgba(83, 180, 148, 0.7);
}

.hover\\:bg-jade-400\\/75:hover{
  background-color: rgba(83, 180, 148, 0.75);
}

.hover\\:bg-jade-400\\/80:hover{
  background-color: rgba(83, 180, 148, 0.8);
}

.hover\\:bg-jade-400\\/85:hover{
  background-color: rgba(83, 180, 148, 0.85);
}

.hover\\:bg-jade-400\\/90:hover{
  background-color: rgba(83, 180, 148, 0.9);
}

.hover\\:bg-jade-400\\/95:hover{
  background-color: rgba(83, 180, 148, 0.95);
}

.hover\\:bg-jade-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(44, 135, 109, 1);
  background-color: rgba(44, 135, 109, var(--tw-bg-opacity, 1));
}

.hover\\:bg-jade-500\\/0:hover{
  background-color: rgba(44, 135, 109, 0);
}

.hover\\:bg-jade-500\\/10:hover{
  background-color: rgba(44, 135, 109, 0.1);
}

.hover\\:bg-jade-500\\/100:hover{
  background-color: rgb(44, 135, 109);
}

.hover\\:bg-jade-500\\/15:hover{
  background-color: rgba(44, 135, 109, 0.15);
}

.hover\\:bg-jade-500\\/20:hover{
  background-color: rgba(44, 135, 109, 0.2);
}

.hover\\:bg-jade-500\\/25:hover{
  background-color: rgba(44, 135, 109, 0.25);
}

.hover\\:bg-jade-500\\/30:hover{
  background-color: rgba(44, 135, 109, 0.3);
}

.hover\\:bg-jade-500\\/35:hover{
  background-color: rgba(44, 135, 109, 0.35);
}

.hover\\:bg-jade-500\\/40:hover{
  background-color: rgba(44, 135, 109, 0.4);
}

.hover\\:bg-jade-500\\/45:hover{
  background-color: rgba(44, 135, 109, 0.45);
}

.hover\\:bg-jade-500\\/5:hover{
  background-color: rgba(44, 135, 109, 0.05);
}

.hover\\:bg-jade-500\\/50:hover{
  background-color: rgba(44, 135, 109, 0.5);
}

.hover\\:bg-jade-500\\/55:hover{
  background-color: rgba(44, 135, 109, 0.55);
}

.hover\\:bg-jade-500\\/60:hover{
  background-color: rgba(44, 135, 109, 0.6);
}

.hover\\:bg-jade-500\\/65:hover{
  background-color: rgba(44, 135, 109, 0.65);
}

.hover\\:bg-jade-500\\/70:hover{
  background-color: rgba(44, 135, 109, 0.7);
}

.hover\\:bg-jade-500\\/75:hover{
  background-color: rgba(44, 135, 109, 0.75);
}

.hover\\:bg-jade-500\\/80:hover{
  background-color: rgba(44, 135, 109, 0.8);
}

.hover\\:bg-jade-500\\/85:hover{
  background-color: rgba(44, 135, 109, 0.85);
}

.hover\\:bg-jade-500\\/90:hover{
  background-color: rgba(44, 135, 109, 0.9);
}

.hover\\:bg-jade-500\\/95:hover{
  background-color: rgba(44, 135, 109, 0.95);
}

.hover\\:bg-jade-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(34, 121, 98, 1);
  background-color: rgba(34, 121, 98, var(--tw-bg-opacity, 1));
}

.hover\\:bg-jade-600\\/0:hover{
  background-color: rgba(34, 121, 98, 0);
}

.hover\\:bg-jade-600\\/10:hover{
  background-color: rgba(34, 121, 98, 0.1);
}

.hover\\:bg-jade-600\\/100:hover{
  background-color: rgb(34, 121, 98);
}

.hover\\:bg-jade-600\\/15:hover{
  background-color: rgba(34, 121, 98, 0.15);
}

.hover\\:bg-jade-600\\/20:hover{
  background-color: rgba(34, 121, 98, 0.2);
}

.hover\\:bg-jade-600\\/25:hover{
  background-color: rgba(34, 121, 98, 0.25);
}

.hover\\:bg-jade-600\\/30:hover{
  background-color: rgba(34, 121, 98, 0.3);
}

.hover\\:bg-jade-600\\/35:hover{
  background-color: rgba(34, 121, 98, 0.35);
}

.hover\\:bg-jade-600\\/40:hover{
  background-color: rgba(34, 121, 98, 0.4);
}

.hover\\:bg-jade-600\\/45:hover{
  background-color: rgba(34, 121, 98, 0.45);
}

.hover\\:bg-jade-600\\/5:hover{
  background-color: rgba(34, 121, 98, 0.05);
}

.hover\\:bg-jade-600\\/50:hover{
  background-color: rgba(34, 121, 98, 0.5);
}

.hover\\:bg-jade-600\\/55:hover{
  background-color: rgba(34, 121, 98, 0.55);
}

.hover\\:bg-jade-600\\/60:hover{
  background-color: rgba(34, 121, 98, 0.6);
}

.hover\\:bg-jade-600\\/65:hover{
  background-color: rgba(34, 121, 98, 0.65);
}

.hover\\:bg-jade-600\\/70:hover{
  background-color: rgba(34, 121, 98, 0.7);
}

.hover\\:bg-jade-600\\/75:hover{
  background-color: rgba(34, 121, 98, 0.75);
}

.hover\\:bg-jade-600\\/80:hover{
  background-color: rgba(34, 121, 98, 0.8);
}

.hover\\:bg-jade-600\\/85:hover{
  background-color: rgba(34, 121, 98, 0.85);
}

.hover\\:bg-jade-600\\/90:hover{
  background-color: rgba(34, 121, 98, 0.9);
}

.hover\\:bg-jade-600\\/95:hover{
  background-color: rgba(34, 121, 98, 0.95);
}

.hover\\:bg-jade-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(27, 97, 80, 1);
  background-color: rgba(27, 97, 80, var(--tw-bg-opacity, 1));
}

.hover\\:bg-jade-700\\/0:hover{
  background-color: rgba(27, 97, 80, 0);
}

.hover\\:bg-jade-700\\/10:hover{
  background-color: rgba(27, 97, 80, 0.1);
}

.hover\\:bg-jade-700\\/100:hover{
  background-color: rgb(27, 97, 80);
}

.hover\\:bg-jade-700\\/15:hover{
  background-color: rgba(27, 97, 80, 0.15);
}

.hover\\:bg-jade-700\\/20:hover{
  background-color: rgba(27, 97, 80, 0.2);
}

.hover\\:bg-jade-700\\/25:hover{
  background-color: rgba(27, 97, 80, 0.25);
}

.hover\\:bg-jade-700\\/30:hover{
  background-color: rgba(27, 97, 80, 0.3);
}

.hover\\:bg-jade-700\\/35:hover{
  background-color: rgba(27, 97, 80, 0.35);
}

.hover\\:bg-jade-700\\/40:hover{
  background-color: rgba(27, 97, 80, 0.4);
}

.hover\\:bg-jade-700\\/45:hover{
  background-color: rgba(27, 97, 80, 0.45);
}

.hover\\:bg-jade-700\\/5:hover{
  background-color: rgba(27, 97, 80, 0.05);
}

.hover\\:bg-jade-700\\/50:hover{
  background-color: rgba(27, 97, 80, 0.5);
}

.hover\\:bg-jade-700\\/55:hover{
  background-color: rgba(27, 97, 80, 0.55);
}

.hover\\:bg-jade-700\\/60:hover{
  background-color: rgba(27, 97, 80, 0.6);
}

.hover\\:bg-jade-700\\/65:hover{
  background-color: rgba(27, 97, 80, 0.65);
}

.hover\\:bg-jade-700\\/70:hover{
  background-color: rgba(27, 97, 80, 0.7);
}

.hover\\:bg-jade-700\\/75:hover{
  background-color: rgba(27, 97, 80, 0.75);
}

.hover\\:bg-jade-700\\/80:hover{
  background-color: rgba(27, 97, 80, 0.8);
}

.hover\\:bg-jade-700\\/85:hover{
  background-color: rgba(27, 97, 80, 0.85);
}

.hover\\:bg-jade-700\\/90:hover{
  background-color: rgba(27, 97, 80, 0.9);
}

.hover\\:bg-jade-700\\/95:hover{
  background-color: rgba(27, 97, 80, 0.95);
}

.hover\\:bg-jade-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(24, 77, 64, 1);
  background-color: rgba(24, 77, 64, var(--tw-bg-opacity, 1));
}

.hover\\:bg-jade-800\\/0:hover{
  background-color: rgba(24, 77, 64, 0);
}

.hover\\:bg-jade-800\\/10:hover{
  background-color: rgba(24, 77, 64, 0.1);
}

.hover\\:bg-jade-800\\/100:hover{
  background-color: rgb(24, 77, 64);
}

.hover\\:bg-jade-800\\/15:hover{
  background-color: rgba(24, 77, 64, 0.15);
}

.hover\\:bg-jade-800\\/20:hover{
  background-color: rgba(24, 77, 64, 0.2);
}

.hover\\:bg-jade-800\\/25:hover{
  background-color: rgba(24, 77, 64, 0.25);
}

.hover\\:bg-jade-800\\/30:hover{
  background-color: rgba(24, 77, 64, 0.3);
}

.hover\\:bg-jade-800\\/35:hover{
  background-color: rgba(24, 77, 64, 0.35);
}

.hover\\:bg-jade-800\\/40:hover{
  background-color: rgba(24, 77, 64, 0.4);
}

.hover\\:bg-jade-800\\/45:hover{
  background-color: rgba(24, 77, 64, 0.45);
}

.hover\\:bg-jade-800\\/5:hover{
  background-color: rgba(24, 77, 64, 0.05);
}

.hover\\:bg-jade-800\\/50:hover{
  background-color: rgba(24, 77, 64, 0.5);
}

.hover\\:bg-jade-800\\/55:hover{
  background-color: rgba(24, 77, 64, 0.55);
}

.hover\\:bg-jade-800\\/60:hover{
  background-color: rgba(24, 77, 64, 0.6);
}

.hover\\:bg-jade-800\\/65:hover{
  background-color: rgba(24, 77, 64, 0.65);
}

.hover\\:bg-jade-800\\/70:hover{
  background-color: rgba(24, 77, 64, 0.7);
}

.hover\\:bg-jade-800\\/75:hover{
  background-color: rgba(24, 77, 64, 0.75);
}

.hover\\:bg-jade-800\\/80:hover{
  background-color: rgba(24, 77, 64, 0.8);
}

.hover\\:bg-jade-800\\/85:hover{
  background-color: rgba(24, 77, 64, 0.85);
}

.hover\\:bg-jade-800\\/90:hover{
  background-color: rgba(24, 77, 64, 0.9);
}

.hover\\:bg-jade-800\\/95:hover{
  background-color: rgba(24, 77, 64, 0.95);
}

.hover\\:bg-jade-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(20, 64, 54, 1);
  background-color: rgba(20, 64, 54, var(--tw-bg-opacity, 1));
}

.hover\\:bg-jade-900\\/0:hover{
  background-color: rgba(20, 64, 54, 0);
}

.hover\\:bg-jade-900\\/10:hover{
  background-color: rgba(20, 64, 54, 0.1);
}

.hover\\:bg-jade-900\\/100:hover{
  background-color: rgb(20, 64, 54);
}

.hover\\:bg-jade-900\\/15:hover{
  background-color: rgba(20, 64, 54, 0.15);
}

.hover\\:bg-jade-900\\/20:hover{
  background-color: rgba(20, 64, 54, 0.2);
}

.hover\\:bg-jade-900\\/25:hover{
  background-color: rgba(20, 64, 54, 0.25);
}

.hover\\:bg-jade-900\\/30:hover{
  background-color: rgba(20, 64, 54, 0.3);
}

.hover\\:bg-jade-900\\/35:hover{
  background-color: rgba(20, 64, 54, 0.35);
}

.hover\\:bg-jade-900\\/40:hover{
  background-color: rgba(20, 64, 54, 0.4);
}

.hover\\:bg-jade-900\\/45:hover{
  background-color: rgba(20, 64, 54, 0.45);
}

.hover\\:bg-jade-900\\/5:hover{
  background-color: rgba(20, 64, 54, 0.05);
}

.hover\\:bg-jade-900\\/50:hover{
  background-color: rgba(20, 64, 54, 0.5);
}

.hover\\:bg-jade-900\\/55:hover{
  background-color: rgba(20, 64, 54, 0.55);
}

.hover\\:bg-jade-900\\/60:hover{
  background-color: rgba(20, 64, 54, 0.6);
}

.hover\\:bg-jade-900\\/65:hover{
  background-color: rgba(20, 64, 54, 0.65);
}

.hover\\:bg-jade-900\\/70:hover{
  background-color: rgba(20, 64, 54, 0.7);
}

.hover\\:bg-jade-900\\/75:hover{
  background-color: rgba(20, 64, 54, 0.75);
}

.hover\\:bg-jade-900\\/80:hover{
  background-color: rgba(20, 64, 54, 0.8);
}

.hover\\:bg-jade-900\\/85:hover{
  background-color: rgba(20, 64, 54, 0.85);
}

.hover\\:bg-jade-900\\/90:hover{
  background-color: rgba(20, 64, 54, 0.9);
}

.hover\\:bg-jade-900\\/95:hover{
  background-color: rgba(20, 64, 54, 0.95);
}

.hover\\:bg-jade-950:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(10, 36, 31, 1);
  background-color: rgba(10, 36, 31, var(--tw-bg-opacity, 1));
}

.hover\\:bg-jade-950\\/0:hover{
  background-color: rgba(10, 36, 31, 0);
}

.hover\\:bg-jade-950\\/10:hover{
  background-color: rgba(10, 36, 31, 0.1);
}

.hover\\:bg-jade-950\\/100:hover{
  background-color: rgb(10, 36, 31);
}

.hover\\:bg-jade-950\\/15:hover{
  background-color: rgba(10, 36, 31, 0.15);
}

.hover\\:bg-jade-950\\/20:hover{
  background-color: rgba(10, 36, 31, 0.2);
}

.hover\\:bg-jade-950\\/25:hover{
  background-color: rgba(10, 36, 31, 0.25);
}

.hover\\:bg-jade-950\\/30:hover{
  background-color: rgba(10, 36, 31, 0.3);
}

.hover\\:bg-jade-950\\/35:hover{
  background-color: rgba(10, 36, 31, 0.35);
}

.hover\\:bg-jade-950\\/40:hover{
  background-color: rgba(10, 36, 31, 0.4);
}

.hover\\:bg-jade-950\\/45:hover{
  background-color: rgba(10, 36, 31, 0.45);
}

.hover\\:bg-jade-950\\/5:hover{
  background-color: rgba(10, 36, 31, 0.05);
}

.hover\\:bg-jade-950\\/50:hover{
  background-color: rgba(10, 36, 31, 0.5);
}

.hover\\:bg-jade-950\\/55:hover{
  background-color: rgba(10, 36, 31, 0.55);
}

.hover\\:bg-jade-950\\/60:hover{
  background-color: rgba(10, 36, 31, 0.6);
}

.hover\\:bg-jade-950\\/65:hover{
  background-color: rgba(10, 36, 31, 0.65);
}

.hover\\:bg-jade-950\\/70:hover{
  background-color: rgba(10, 36, 31, 0.7);
}

.hover\\:bg-jade-950\\/75:hover{
  background-color: rgba(10, 36, 31, 0.75);
}

.hover\\:bg-jade-950\\/80:hover{
  background-color: rgba(10, 36, 31, 0.8);
}

.hover\\:bg-jade-950\\/85:hover{
  background-color: rgba(10, 36, 31, 0.85);
}

.hover\\:bg-jade-950\\/90:hover{
  background-color: rgba(10, 36, 31, 0.9);
}

.hover\\:bg-jade-950\\/95:hover{
  background-color: rgba(10, 36, 31, 0.95);
}

.hover\\:bg-kids-alphabet-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(55, 135, 163, 1);
  background-color: rgba(55, 135, 163, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-alphabet-500\\/0:hover{
  background-color: rgba(55, 135, 163, 0);
}

.hover\\:bg-kids-alphabet-500\\/10:hover{
  background-color: rgba(55, 135, 163, 0.1);
}

.hover\\:bg-kids-alphabet-500\\/100:hover{
  background-color: rgb(55, 135, 163);
}

.hover\\:bg-kids-alphabet-500\\/15:hover{
  background-color: rgba(55, 135, 163, 0.15);
}

.hover\\:bg-kids-alphabet-500\\/20:hover{
  background-color: rgba(55, 135, 163, 0.2);
}

.hover\\:bg-kids-alphabet-500\\/25:hover{
  background-color: rgba(55, 135, 163, 0.25);
}

.hover\\:bg-kids-alphabet-500\\/30:hover{
  background-color: rgba(55, 135, 163, 0.3);
}

.hover\\:bg-kids-alphabet-500\\/35:hover{
  background-color: rgba(55, 135, 163, 0.35);
}

.hover\\:bg-kids-alphabet-500\\/40:hover{
  background-color: rgba(55, 135, 163, 0.4);
}

.hover\\:bg-kids-alphabet-500\\/45:hover{
  background-color: rgba(55, 135, 163, 0.45);
}

.hover\\:bg-kids-alphabet-500\\/5:hover{
  background-color: rgba(55, 135, 163, 0.05);
}

.hover\\:bg-kids-alphabet-500\\/50:hover{
  background-color: rgba(55, 135, 163, 0.5);
}

.hover\\:bg-kids-alphabet-500\\/55:hover{
  background-color: rgba(55, 135, 163, 0.55);
}

.hover\\:bg-kids-alphabet-500\\/60:hover{
  background-color: rgba(55, 135, 163, 0.6);
}

.hover\\:bg-kids-alphabet-500\\/65:hover{
  background-color: rgba(55, 135, 163, 0.65);
}

.hover\\:bg-kids-alphabet-500\\/70:hover{
  background-color: rgba(55, 135, 163, 0.7);
}

.hover\\:bg-kids-alphabet-500\\/75:hover{
  background-color: rgba(55, 135, 163, 0.75);
}

.hover\\:bg-kids-alphabet-500\\/80:hover{
  background-color: rgba(55, 135, 163, 0.8);
}

.hover\\:bg-kids-alphabet-500\\/85:hover{
  background-color: rgba(55, 135, 163, 0.85);
}

.hover\\:bg-kids-alphabet-500\\/90:hover{
  background-color: rgba(55, 135, 163, 0.9);
}

.hover\\:bg-kids-alphabet-500\\/95:hover{
  background-color: rgba(55, 135, 163, 0.95);
}

.hover\\:bg-kids-alphabet-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(48, 109, 138, 1);
  background-color: rgba(48, 109, 138, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-alphabet-600\\/0:hover{
  background-color: rgba(48, 109, 138, 0);
}

.hover\\:bg-kids-alphabet-600\\/10:hover{
  background-color: rgba(48, 109, 138, 0.1);
}

.hover\\:bg-kids-alphabet-600\\/100:hover{
  background-color: rgb(48, 109, 138);
}

.hover\\:bg-kids-alphabet-600\\/15:hover{
  background-color: rgba(48, 109, 138, 0.15);
}

.hover\\:bg-kids-alphabet-600\\/20:hover{
  background-color: rgba(48, 109, 138, 0.2);
}

.hover\\:bg-kids-alphabet-600\\/25:hover{
  background-color: rgba(48, 109, 138, 0.25);
}

.hover\\:bg-kids-alphabet-600\\/30:hover{
  background-color: rgba(48, 109, 138, 0.3);
}

.hover\\:bg-kids-alphabet-600\\/35:hover{
  background-color: rgba(48, 109, 138, 0.35);
}

.hover\\:bg-kids-alphabet-600\\/40:hover{
  background-color: rgba(48, 109, 138, 0.4);
}

.hover\\:bg-kids-alphabet-600\\/45:hover{
  background-color: rgba(48, 109, 138, 0.45);
}

.hover\\:bg-kids-alphabet-600\\/5:hover{
  background-color: rgba(48, 109, 138, 0.05);
}

.hover\\:bg-kids-alphabet-600\\/50:hover{
  background-color: rgba(48, 109, 138, 0.5);
}

.hover\\:bg-kids-alphabet-600\\/55:hover{
  background-color: rgba(48, 109, 138, 0.55);
}

.hover\\:bg-kids-alphabet-600\\/60:hover{
  background-color: rgba(48, 109, 138, 0.6);
}

.hover\\:bg-kids-alphabet-600\\/65:hover{
  background-color: rgba(48, 109, 138, 0.65);
}

.hover\\:bg-kids-alphabet-600\\/70:hover{
  background-color: rgba(48, 109, 138, 0.7);
}

.hover\\:bg-kids-alphabet-600\\/75:hover{
  background-color: rgba(48, 109, 138, 0.75);
}

.hover\\:bg-kids-alphabet-600\\/80:hover{
  background-color: rgba(48, 109, 138, 0.8);
}

.hover\\:bg-kids-alphabet-600\\/85:hover{
  background-color: rgba(48, 109, 138, 0.85);
}

.hover\\:bg-kids-alphabet-600\\/90:hover{
  background-color: rgba(48, 109, 138, 0.9);
}

.hover\\:bg-kids-alphabet-600\\/95:hover{
  background-color: rgba(48, 109, 138, 0.95);
}

.hover\\:bg-kids-alphabet-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(45, 91, 114, 1);
  background-color: rgba(45, 91, 114, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-alphabet-700\\/0:hover{
  background-color: rgba(45, 91, 114, 0);
}

.hover\\:bg-kids-alphabet-700\\/10:hover{
  background-color: rgba(45, 91, 114, 0.1);
}

.hover\\:bg-kids-alphabet-700\\/100:hover{
  background-color: rgb(45, 91, 114);
}

.hover\\:bg-kids-alphabet-700\\/15:hover{
  background-color: rgba(45, 91, 114, 0.15);
}

.hover\\:bg-kids-alphabet-700\\/20:hover{
  background-color: rgba(45, 91, 114, 0.2);
}

.hover\\:bg-kids-alphabet-700\\/25:hover{
  background-color: rgba(45, 91, 114, 0.25);
}

.hover\\:bg-kids-alphabet-700\\/30:hover{
  background-color: rgba(45, 91, 114, 0.3);
}

.hover\\:bg-kids-alphabet-700\\/35:hover{
  background-color: rgba(45, 91, 114, 0.35);
}

.hover\\:bg-kids-alphabet-700\\/40:hover{
  background-color: rgba(45, 91, 114, 0.4);
}

.hover\\:bg-kids-alphabet-700\\/45:hover{
  background-color: rgba(45, 91, 114, 0.45);
}

.hover\\:bg-kids-alphabet-700\\/5:hover{
  background-color: rgba(45, 91, 114, 0.05);
}

.hover\\:bg-kids-alphabet-700\\/50:hover{
  background-color: rgba(45, 91, 114, 0.5);
}

.hover\\:bg-kids-alphabet-700\\/55:hover{
  background-color: rgba(45, 91, 114, 0.55);
}

.hover\\:bg-kids-alphabet-700\\/60:hover{
  background-color: rgba(45, 91, 114, 0.6);
}

.hover\\:bg-kids-alphabet-700\\/65:hover{
  background-color: rgba(45, 91, 114, 0.65);
}

.hover\\:bg-kids-alphabet-700\\/70:hover{
  background-color: rgba(45, 91, 114, 0.7);
}

.hover\\:bg-kids-alphabet-700\\/75:hover{
  background-color: rgba(45, 91, 114, 0.75);
}

.hover\\:bg-kids-alphabet-700\\/80:hover{
  background-color: rgba(45, 91, 114, 0.8);
}

.hover\\:bg-kids-alphabet-700\\/85:hover{
  background-color: rgba(45, 91, 114, 0.85);
}

.hover\\:bg-kids-alphabet-700\\/90:hover{
  background-color: rgba(45, 91, 114, 0.9);
}

.hover\\:bg-kids-alphabet-700\\/95:hover{
  background-color: rgba(45, 91, 114, 0.95);
}

.hover\\:bg-kids-alphabet-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(44, 76, 94, 1);
  background-color: rgba(44, 76, 94, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-alphabet-800\\/0:hover{
  background-color: rgba(44, 76, 94, 0);
}

.hover\\:bg-kids-alphabet-800\\/10:hover{
  background-color: rgba(44, 76, 94, 0.1);
}

.hover\\:bg-kids-alphabet-800\\/100:hover{
  background-color: rgb(44, 76, 94);
}

.hover\\:bg-kids-alphabet-800\\/15:hover{
  background-color: rgba(44, 76, 94, 0.15);
}

.hover\\:bg-kids-alphabet-800\\/20:hover{
  background-color: rgba(44, 76, 94, 0.2);
}

.hover\\:bg-kids-alphabet-800\\/25:hover{
  background-color: rgba(44, 76, 94, 0.25);
}

.hover\\:bg-kids-alphabet-800\\/30:hover{
  background-color: rgba(44, 76, 94, 0.3);
}

.hover\\:bg-kids-alphabet-800\\/35:hover{
  background-color: rgba(44, 76, 94, 0.35);
}

.hover\\:bg-kids-alphabet-800\\/40:hover{
  background-color: rgba(44, 76, 94, 0.4);
}

.hover\\:bg-kids-alphabet-800\\/45:hover{
  background-color: rgba(44, 76, 94, 0.45);
}

.hover\\:bg-kids-alphabet-800\\/5:hover{
  background-color: rgba(44, 76, 94, 0.05);
}

.hover\\:bg-kids-alphabet-800\\/50:hover{
  background-color: rgba(44, 76, 94, 0.5);
}

.hover\\:bg-kids-alphabet-800\\/55:hover{
  background-color: rgba(44, 76, 94, 0.55);
}

.hover\\:bg-kids-alphabet-800\\/60:hover{
  background-color: rgba(44, 76, 94, 0.6);
}

.hover\\:bg-kids-alphabet-800\\/65:hover{
  background-color: rgba(44, 76, 94, 0.65);
}

.hover\\:bg-kids-alphabet-800\\/70:hover{
  background-color: rgba(44, 76, 94, 0.7);
}

.hover\\:bg-kids-alphabet-800\\/75:hover{
  background-color: rgba(44, 76, 94, 0.75);
}

.hover\\:bg-kids-alphabet-800\\/80:hover{
  background-color: rgba(44, 76, 94, 0.8);
}

.hover\\:bg-kids-alphabet-800\\/85:hover{
  background-color: rgba(44, 76, 94, 0.85);
}

.hover\\:bg-kids-alphabet-800\\/90:hover{
  background-color: rgba(44, 76, 94, 0.9);
}

.hover\\:bg-kids-alphabet-800\\/95:hover{
  background-color: rgba(44, 76, 94, 0.95);
}

.hover\\:bg-kids-alphabet-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(40, 65, 81, 1);
  background-color: rgba(40, 65, 81, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-alphabet-900\\/0:hover{
  background-color: rgba(40, 65, 81, 0);
}

.hover\\:bg-kids-alphabet-900\\/10:hover{
  background-color: rgba(40, 65, 81, 0.1);
}

.hover\\:bg-kids-alphabet-900\\/100:hover{
  background-color: rgb(40, 65, 81);
}

.hover\\:bg-kids-alphabet-900\\/15:hover{
  background-color: rgba(40, 65, 81, 0.15);
}

.hover\\:bg-kids-alphabet-900\\/20:hover{
  background-color: rgba(40, 65, 81, 0.2);
}

.hover\\:bg-kids-alphabet-900\\/25:hover{
  background-color: rgba(40, 65, 81, 0.25);
}

.hover\\:bg-kids-alphabet-900\\/30:hover{
  background-color: rgba(40, 65, 81, 0.3);
}

.hover\\:bg-kids-alphabet-900\\/35:hover{
  background-color: rgba(40, 65, 81, 0.35);
}

.hover\\:bg-kids-alphabet-900\\/40:hover{
  background-color: rgba(40, 65, 81, 0.4);
}

.hover\\:bg-kids-alphabet-900\\/45:hover{
  background-color: rgba(40, 65, 81, 0.45);
}

.hover\\:bg-kids-alphabet-900\\/5:hover{
  background-color: rgba(40, 65, 81, 0.05);
}

.hover\\:bg-kids-alphabet-900\\/50:hover{
  background-color: rgba(40, 65, 81, 0.5);
}

.hover\\:bg-kids-alphabet-900\\/55:hover{
  background-color: rgba(40, 65, 81, 0.55);
}

.hover\\:bg-kids-alphabet-900\\/60:hover{
  background-color: rgba(40, 65, 81, 0.6);
}

.hover\\:bg-kids-alphabet-900\\/65:hover{
  background-color: rgba(40, 65, 81, 0.65);
}

.hover\\:bg-kids-alphabet-900\\/70:hover{
  background-color: rgba(40, 65, 81, 0.7);
}

.hover\\:bg-kids-alphabet-900\\/75:hover{
  background-color: rgba(40, 65, 81, 0.75);
}

.hover\\:bg-kids-alphabet-900\\/80:hover{
  background-color: rgba(40, 65, 81, 0.8);
}

.hover\\:bg-kids-alphabet-900\\/85:hover{
  background-color: rgba(40, 65, 81, 0.85);
}

.hover\\:bg-kids-alphabet-900\\/90:hover{
  background-color: rgba(40, 65, 81, 0.9);
}

.hover\\:bg-kids-alphabet-900\\/95:hover{
  background-color: rgba(40, 65, 81, 0.95);
}

.hover\\:bg-kids-categories-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(209, 145, 47, 1);
  background-color: rgba(209, 145, 47, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-categories-500\\/0:hover{
  background-color: rgba(209, 145, 47, 0);
}

.hover\\:bg-kids-categories-500\\/10:hover{
  background-color: rgba(209, 145, 47, 0.1);
}

.hover\\:bg-kids-categories-500\\/100:hover{
  background-color: rgb(209, 145, 47);
}

.hover\\:bg-kids-categories-500\\/15:hover{
  background-color: rgba(209, 145, 47, 0.15);
}

.hover\\:bg-kids-categories-500\\/20:hover{
  background-color: rgba(209, 145, 47, 0.2);
}

.hover\\:bg-kids-categories-500\\/25:hover{
  background-color: rgba(209, 145, 47, 0.25);
}

.hover\\:bg-kids-categories-500\\/30:hover{
  background-color: rgba(209, 145, 47, 0.3);
}

.hover\\:bg-kids-categories-500\\/35:hover{
  background-color: rgba(209, 145, 47, 0.35);
}

.hover\\:bg-kids-categories-500\\/40:hover{
  background-color: rgba(209, 145, 47, 0.4);
}

.hover\\:bg-kids-categories-500\\/45:hover{
  background-color: rgba(209, 145, 47, 0.45);
}

.hover\\:bg-kids-categories-500\\/5:hover{
  background-color: rgba(209, 145, 47, 0.05);
}

.hover\\:bg-kids-categories-500\\/50:hover{
  background-color: rgba(209, 145, 47, 0.5);
}

.hover\\:bg-kids-categories-500\\/55:hover{
  background-color: rgba(209, 145, 47, 0.55);
}

.hover\\:bg-kids-categories-500\\/60:hover{
  background-color: rgba(209, 145, 47, 0.6);
}

.hover\\:bg-kids-categories-500\\/65:hover{
  background-color: rgba(209, 145, 47, 0.65);
}

.hover\\:bg-kids-categories-500\\/70:hover{
  background-color: rgba(209, 145, 47, 0.7);
}

.hover\\:bg-kids-categories-500\\/75:hover{
  background-color: rgba(209, 145, 47, 0.75);
}

.hover\\:bg-kids-categories-500\\/80:hover{
  background-color: rgba(209, 145, 47, 0.8);
}

.hover\\:bg-kids-categories-500\\/85:hover{
  background-color: rgba(209, 145, 47, 0.85);
}

.hover\\:bg-kids-categories-500\\/90:hover{
  background-color: rgba(209, 145, 47, 0.9);
}

.hover\\:bg-kids-categories-500\\/95:hover{
  background-color: rgba(209, 145, 47, 0.95);
}

.hover\\:bg-kids-categories-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(195, 120, 41, 1);
  background-color: rgba(195, 120, 41, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-categories-600\\/0:hover{
  background-color: rgba(195, 120, 41, 0);
}

.hover\\:bg-kids-categories-600\\/10:hover{
  background-color: rgba(195, 120, 41, 0.1);
}

.hover\\:bg-kids-categories-600\\/100:hover{
  background-color: rgb(195, 120, 41);
}

.hover\\:bg-kids-categories-600\\/15:hover{
  background-color: rgba(195, 120, 41, 0.15);
}

.hover\\:bg-kids-categories-600\\/20:hover{
  background-color: rgba(195, 120, 41, 0.2);
}

.hover\\:bg-kids-categories-600\\/25:hover{
  background-color: rgba(195, 120, 41, 0.25);
}

.hover\\:bg-kids-categories-600\\/30:hover{
  background-color: rgba(195, 120, 41, 0.3);
}

.hover\\:bg-kids-categories-600\\/35:hover{
  background-color: rgba(195, 120, 41, 0.35);
}

.hover\\:bg-kids-categories-600\\/40:hover{
  background-color: rgba(195, 120, 41, 0.4);
}

.hover\\:bg-kids-categories-600\\/45:hover{
  background-color: rgba(195, 120, 41, 0.45);
}

.hover\\:bg-kids-categories-600\\/5:hover{
  background-color: rgba(195, 120, 41, 0.05);
}

.hover\\:bg-kids-categories-600\\/50:hover{
  background-color: rgba(195, 120, 41, 0.5);
}

.hover\\:bg-kids-categories-600\\/55:hover{
  background-color: rgba(195, 120, 41, 0.55);
}

.hover\\:bg-kids-categories-600\\/60:hover{
  background-color: rgba(195, 120, 41, 0.6);
}

.hover\\:bg-kids-categories-600\\/65:hover{
  background-color: rgba(195, 120, 41, 0.65);
}

.hover\\:bg-kids-categories-600\\/70:hover{
  background-color: rgba(195, 120, 41, 0.7);
}

.hover\\:bg-kids-categories-600\\/75:hover{
  background-color: rgba(195, 120, 41, 0.75);
}

.hover\\:bg-kids-categories-600\\/80:hover{
  background-color: rgba(195, 120, 41, 0.8);
}

.hover\\:bg-kids-categories-600\\/85:hover{
  background-color: rgba(195, 120, 41, 0.85);
}

.hover\\:bg-kids-categories-600\\/90:hover{
  background-color: rgba(195, 120, 41, 0.9);
}

.hover\\:bg-kids-categories-600\\/95:hover{
  background-color: rgba(195, 120, 41, 0.95);
}

.hover\\:bg-kids-categories-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(153, 84, 36, 1);
  background-color: rgba(153, 84, 36, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-categories-700\\/0:hover{
  background-color: rgba(153, 84, 36, 0);
}

.hover\\:bg-kids-categories-700\\/10:hover{
  background-color: rgba(153, 84, 36, 0.1);
}

.hover\\:bg-kids-categories-700\\/100:hover{
  background-color: rgb(153, 84, 36);
}

.hover\\:bg-kids-categories-700\\/15:hover{
  background-color: rgba(153, 84, 36, 0.15);
}

.hover\\:bg-kids-categories-700\\/20:hover{
  background-color: rgba(153, 84, 36, 0.2);
}

.hover\\:bg-kids-categories-700\\/25:hover{
  background-color: rgba(153, 84, 36, 0.25);
}

.hover\\:bg-kids-categories-700\\/30:hover{
  background-color: rgba(153, 84, 36, 0.3);
}

.hover\\:bg-kids-categories-700\\/35:hover{
  background-color: rgba(153, 84, 36, 0.35);
}

.hover\\:bg-kids-categories-700\\/40:hover{
  background-color: rgba(153, 84, 36, 0.4);
}

.hover\\:bg-kids-categories-700\\/45:hover{
  background-color: rgba(153, 84, 36, 0.45);
}

.hover\\:bg-kids-categories-700\\/5:hover{
  background-color: rgba(153, 84, 36, 0.05);
}

.hover\\:bg-kids-categories-700\\/50:hover{
  background-color: rgba(153, 84, 36, 0.5);
}

.hover\\:bg-kids-categories-700\\/55:hover{
  background-color: rgba(153, 84, 36, 0.55);
}

.hover\\:bg-kids-categories-700\\/60:hover{
  background-color: rgba(153, 84, 36, 0.6);
}

.hover\\:bg-kids-categories-700\\/65:hover{
  background-color: rgba(153, 84, 36, 0.65);
}

.hover\\:bg-kids-categories-700\\/70:hover{
  background-color: rgba(153, 84, 36, 0.7);
}

.hover\\:bg-kids-categories-700\\/75:hover{
  background-color: rgba(153, 84, 36, 0.75);
}

.hover\\:bg-kids-categories-700\\/80:hover{
  background-color: rgba(153, 84, 36, 0.8);
}

.hover\\:bg-kids-categories-700\\/85:hover{
  background-color: rgba(153, 84, 36, 0.85);
}

.hover\\:bg-kids-categories-700\\/90:hover{
  background-color: rgba(153, 84, 36, 0.9);
}

.hover\\:bg-kids-categories-700\\/95:hover{
  background-color: rgba(153, 84, 36, 0.95);
}

.hover\\:bg-kids-categories-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(126, 67, 34, 1);
  background-color: rgba(126, 67, 34, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-categories-800\\/0:hover{
  background-color: rgba(126, 67, 34, 0);
}

.hover\\:bg-kids-categories-800\\/10:hover{
  background-color: rgba(126, 67, 34, 0.1);
}

.hover\\:bg-kids-categories-800\\/100:hover{
  background-color: rgb(126, 67, 34);
}

.hover\\:bg-kids-categories-800\\/15:hover{
  background-color: rgba(126, 67, 34, 0.15);
}

.hover\\:bg-kids-categories-800\\/20:hover{
  background-color: rgba(126, 67, 34, 0.2);
}

.hover\\:bg-kids-categories-800\\/25:hover{
  background-color: rgba(126, 67, 34, 0.25);
}

.hover\\:bg-kids-categories-800\\/30:hover{
  background-color: rgba(126, 67, 34, 0.3);
}

.hover\\:bg-kids-categories-800\\/35:hover{
  background-color: rgba(126, 67, 34, 0.35);
}

.hover\\:bg-kids-categories-800\\/40:hover{
  background-color: rgba(126, 67, 34, 0.4);
}

.hover\\:bg-kids-categories-800\\/45:hover{
  background-color: rgba(126, 67, 34, 0.45);
}

.hover\\:bg-kids-categories-800\\/5:hover{
  background-color: rgba(126, 67, 34, 0.05);
}

.hover\\:bg-kids-categories-800\\/50:hover{
  background-color: rgba(126, 67, 34, 0.5);
}

.hover\\:bg-kids-categories-800\\/55:hover{
  background-color: rgba(126, 67, 34, 0.55);
}

.hover\\:bg-kids-categories-800\\/60:hover{
  background-color: rgba(126, 67, 34, 0.6);
}

.hover\\:bg-kids-categories-800\\/65:hover{
  background-color: rgba(126, 67, 34, 0.65);
}

.hover\\:bg-kids-categories-800\\/70:hover{
  background-color: rgba(126, 67, 34, 0.7);
}

.hover\\:bg-kids-categories-800\\/75:hover{
  background-color: rgba(126, 67, 34, 0.75);
}

.hover\\:bg-kids-categories-800\\/80:hover{
  background-color: rgba(126, 67, 34, 0.8);
}

.hover\\:bg-kids-categories-800\\/85:hover{
  background-color: rgba(126, 67, 34, 0.85);
}

.hover\\:bg-kids-categories-800\\/90:hover{
  background-color: rgba(126, 67, 34, 0.9);
}

.hover\\:bg-kids-categories-800\\/95:hover{
  background-color: rgba(126, 67, 34, 0.95);
}

.hover\\:bg-kids-categories-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(104, 56, 31, 1);
  background-color: rgba(104, 56, 31, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-categories-900\\/0:hover{
  background-color: rgba(104, 56, 31, 0);
}

.hover\\:bg-kids-categories-900\\/10:hover{
  background-color: rgba(104, 56, 31, 0.1);
}

.hover\\:bg-kids-categories-900\\/100:hover{
  background-color: rgb(104, 56, 31);
}

.hover\\:bg-kids-categories-900\\/15:hover{
  background-color: rgba(104, 56, 31, 0.15);
}

.hover\\:bg-kids-categories-900\\/20:hover{
  background-color: rgba(104, 56, 31, 0.2);
}

.hover\\:bg-kids-categories-900\\/25:hover{
  background-color: rgba(104, 56, 31, 0.25);
}

.hover\\:bg-kids-categories-900\\/30:hover{
  background-color: rgba(104, 56, 31, 0.3);
}

.hover\\:bg-kids-categories-900\\/35:hover{
  background-color: rgba(104, 56, 31, 0.35);
}

.hover\\:bg-kids-categories-900\\/40:hover{
  background-color: rgba(104, 56, 31, 0.4);
}

.hover\\:bg-kids-categories-900\\/45:hover{
  background-color: rgba(104, 56, 31, 0.45);
}

.hover\\:bg-kids-categories-900\\/5:hover{
  background-color: rgba(104, 56, 31, 0.05);
}

.hover\\:bg-kids-categories-900\\/50:hover{
  background-color: rgba(104, 56, 31, 0.5);
}

.hover\\:bg-kids-categories-900\\/55:hover{
  background-color: rgba(104, 56, 31, 0.55);
}

.hover\\:bg-kids-categories-900\\/60:hover{
  background-color: rgba(104, 56, 31, 0.6);
}

.hover\\:bg-kids-categories-900\\/65:hover{
  background-color: rgba(104, 56, 31, 0.65);
}

.hover\\:bg-kids-categories-900\\/70:hover{
  background-color: rgba(104, 56, 31, 0.7);
}

.hover\\:bg-kids-categories-900\\/75:hover{
  background-color: rgba(104, 56, 31, 0.75);
}

.hover\\:bg-kids-categories-900\\/80:hover{
  background-color: rgba(104, 56, 31, 0.8);
}

.hover\\:bg-kids-categories-900\\/85:hover{
  background-color: rgba(104, 56, 31, 0.85);
}

.hover\\:bg-kids-categories-900\\/90:hover{
  background-color: rgba(104, 56, 31, 0.9);
}

.hover\\:bg-kids-categories-900\\/95:hover{
  background-color: rgba(104, 56, 31, 0.95);
}

.hover\\:bg-kids-dictionary-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(44, 135, 109, 1);
  background-color: rgba(44, 135, 109, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-dictionary-500\\/0:hover{
  background-color: rgba(44, 135, 109, 0);
}

.hover\\:bg-kids-dictionary-500\\/10:hover{
  background-color: rgba(44, 135, 109, 0.1);
}

.hover\\:bg-kids-dictionary-500\\/100:hover{
  background-color: rgb(44, 135, 109);
}

.hover\\:bg-kids-dictionary-500\\/15:hover{
  background-color: rgba(44, 135, 109, 0.15);
}

.hover\\:bg-kids-dictionary-500\\/20:hover{
  background-color: rgba(44, 135, 109, 0.2);
}

.hover\\:bg-kids-dictionary-500\\/25:hover{
  background-color: rgba(44, 135, 109, 0.25);
}

.hover\\:bg-kids-dictionary-500\\/30:hover{
  background-color: rgba(44, 135, 109, 0.3);
}

.hover\\:bg-kids-dictionary-500\\/35:hover{
  background-color: rgba(44, 135, 109, 0.35);
}

.hover\\:bg-kids-dictionary-500\\/40:hover{
  background-color: rgba(44, 135, 109, 0.4);
}

.hover\\:bg-kids-dictionary-500\\/45:hover{
  background-color: rgba(44, 135, 109, 0.45);
}

.hover\\:bg-kids-dictionary-500\\/5:hover{
  background-color: rgba(44, 135, 109, 0.05);
}

.hover\\:bg-kids-dictionary-500\\/50:hover{
  background-color: rgba(44, 135, 109, 0.5);
}

.hover\\:bg-kids-dictionary-500\\/55:hover{
  background-color: rgba(44, 135, 109, 0.55);
}

.hover\\:bg-kids-dictionary-500\\/60:hover{
  background-color: rgba(44, 135, 109, 0.6);
}

.hover\\:bg-kids-dictionary-500\\/65:hover{
  background-color: rgba(44, 135, 109, 0.65);
}

.hover\\:bg-kids-dictionary-500\\/70:hover{
  background-color: rgba(44, 135, 109, 0.7);
}

.hover\\:bg-kids-dictionary-500\\/75:hover{
  background-color: rgba(44, 135, 109, 0.75);
}

.hover\\:bg-kids-dictionary-500\\/80:hover{
  background-color: rgba(44, 135, 109, 0.8);
}

.hover\\:bg-kids-dictionary-500\\/85:hover{
  background-color: rgba(44, 135, 109, 0.85);
}

.hover\\:bg-kids-dictionary-500\\/90:hover{
  background-color: rgba(44, 135, 109, 0.9);
}

.hover\\:bg-kids-dictionary-500\\/95:hover{
  background-color: rgba(44, 135, 109, 0.95);
}

.hover\\:bg-kids-dictionary-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(34, 121, 98, 1);
  background-color: rgba(34, 121, 98, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-dictionary-600\\/0:hover{
  background-color: rgba(34, 121, 98, 0);
}

.hover\\:bg-kids-dictionary-600\\/10:hover{
  background-color: rgba(34, 121, 98, 0.1);
}

.hover\\:bg-kids-dictionary-600\\/100:hover{
  background-color: rgb(34, 121, 98);
}

.hover\\:bg-kids-dictionary-600\\/15:hover{
  background-color: rgba(34, 121, 98, 0.15);
}

.hover\\:bg-kids-dictionary-600\\/20:hover{
  background-color: rgba(34, 121, 98, 0.2);
}

.hover\\:bg-kids-dictionary-600\\/25:hover{
  background-color: rgba(34, 121, 98, 0.25);
}

.hover\\:bg-kids-dictionary-600\\/30:hover{
  background-color: rgba(34, 121, 98, 0.3);
}

.hover\\:bg-kids-dictionary-600\\/35:hover{
  background-color: rgba(34, 121, 98, 0.35);
}

.hover\\:bg-kids-dictionary-600\\/40:hover{
  background-color: rgba(34, 121, 98, 0.4);
}

.hover\\:bg-kids-dictionary-600\\/45:hover{
  background-color: rgba(34, 121, 98, 0.45);
}

.hover\\:bg-kids-dictionary-600\\/5:hover{
  background-color: rgba(34, 121, 98, 0.05);
}

.hover\\:bg-kids-dictionary-600\\/50:hover{
  background-color: rgba(34, 121, 98, 0.5);
}

.hover\\:bg-kids-dictionary-600\\/55:hover{
  background-color: rgba(34, 121, 98, 0.55);
}

.hover\\:bg-kids-dictionary-600\\/60:hover{
  background-color: rgba(34, 121, 98, 0.6);
}

.hover\\:bg-kids-dictionary-600\\/65:hover{
  background-color: rgba(34, 121, 98, 0.65);
}

.hover\\:bg-kids-dictionary-600\\/70:hover{
  background-color: rgba(34, 121, 98, 0.7);
}

.hover\\:bg-kids-dictionary-600\\/75:hover{
  background-color: rgba(34, 121, 98, 0.75);
}

.hover\\:bg-kids-dictionary-600\\/80:hover{
  background-color: rgba(34, 121, 98, 0.8);
}

.hover\\:bg-kids-dictionary-600\\/85:hover{
  background-color: rgba(34, 121, 98, 0.85);
}

.hover\\:bg-kids-dictionary-600\\/90:hover{
  background-color: rgba(34, 121, 98, 0.9);
}

.hover\\:bg-kids-dictionary-600\\/95:hover{
  background-color: rgba(34, 121, 98, 0.95);
}

.hover\\:bg-kids-dictionary-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(27, 97, 80, 1);
  background-color: rgba(27, 97, 80, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-dictionary-700\\/0:hover{
  background-color: rgba(27, 97, 80, 0);
}

.hover\\:bg-kids-dictionary-700\\/10:hover{
  background-color: rgba(27, 97, 80, 0.1);
}

.hover\\:bg-kids-dictionary-700\\/100:hover{
  background-color: rgb(27, 97, 80);
}

.hover\\:bg-kids-dictionary-700\\/15:hover{
  background-color: rgba(27, 97, 80, 0.15);
}

.hover\\:bg-kids-dictionary-700\\/20:hover{
  background-color: rgba(27, 97, 80, 0.2);
}

.hover\\:bg-kids-dictionary-700\\/25:hover{
  background-color: rgba(27, 97, 80, 0.25);
}

.hover\\:bg-kids-dictionary-700\\/30:hover{
  background-color: rgba(27, 97, 80, 0.3);
}

.hover\\:bg-kids-dictionary-700\\/35:hover{
  background-color: rgba(27, 97, 80, 0.35);
}

.hover\\:bg-kids-dictionary-700\\/40:hover{
  background-color: rgba(27, 97, 80, 0.4);
}

.hover\\:bg-kids-dictionary-700\\/45:hover{
  background-color: rgba(27, 97, 80, 0.45);
}

.hover\\:bg-kids-dictionary-700\\/5:hover{
  background-color: rgba(27, 97, 80, 0.05);
}

.hover\\:bg-kids-dictionary-700\\/50:hover{
  background-color: rgba(27, 97, 80, 0.5);
}

.hover\\:bg-kids-dictionary-700\\/55:hover{
  background-color: rgba(27, 97, 80, 0.55);
}

.hover\\:bg-kids-dictionary-700\\/60:hover{
  background-color: rgba(27, 97, 80, 0.6);
}

.hover\\:bg-kids-dictionary-700\\/65:hover{
  background-color: rgba(27, 97, 80, 0.65);
}

.hover\\:bg-kids-dictionary-700\\/70:hover{
  background-color: rgba(27, 97, 80, 0.7);
}

.hover\\:bg-kids-dictionary-700\\/75:hover{
  background-color: rgba(27, 97, 80, 0.75);
}

.hover\\:bg-kids-dictionary-700\\/80:hover{
  background-color: rgba(27, 97, 80, 0.8);
}

.hover\\:bg-kids-dictionary-700\\/85:hover{
  background-color: rgba(27, 97, 80, 0.85);
}

.hover\\:bg-kids-dictionary-700\\/90:hover{
  background-color: rgba(27, 97, 80, 0.9);
}

.hover\\:bg-kids-dictionary-700\\/95:hover{
  background-color: rgba(27, 97, 80, 0.95);
}

.hover\\:bg-kids-dictionary-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(24, 77, 64, 1);
  background-color: rgba(24, 77, 64, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-dictionary-800\\/0:hover{
  background-color: rgba(24, 77, 64, 0);
}

.hover\\:bg-kids-dictionary-800\\/10:hover{
  background-color: rgba(24, 77, 64, 0.1);
}

.hover\\:bg-kids-dictionary-800\\/100:hover{
  background-color: rgb(24, 77, 64);
}

.hover\\:bg-kids-dictionary-800\\/15:hover{
  background-color: rgba(24, 77, 64, 0.15);
}

.hover\\:bg-kids-dictionary-800\\/20:hover{
  background-color: rgba(24, 77, 64, 0.2);
}

.hover\\:bg-kids-dictionary-800\\/25:hover{
  background-color: rgba(24, 77, 64, 0.25);
}

.hover\\:bg-kids-dictionary-800\\/30:hover{
  background-color: rgba(24, 77, 64, 0.3);
}

.hover\\:bg-kids-dictionary-800\\/35:hover{
  background-color: rgba(24, 77, 64, 0.35);
}

.hover\\:bg-kids-dictionary-800\\/40:hover{
  background-color: rgba(24, 77, 64, 0.4);
}

.hover\\:bg-kids-dictionary-800\\/45:hover{
  background-color: rgba(24, 77, 64, 0.45);
}

.hover\\:bg-kids-dictionary-800\\/5:hover{
  background-color: rgba(24, 77, 64, 0.05);
}

.hover\\:bg-kids-dictionary-800\\/50:hover{
  background-color: rgba(24, 77, 64, 0.5);
}

.hover\\:bg-kids-dictionary-800\\/55:hover{
  background-color: rgba(24, 77, 64, 0.55);
}

.hover\\:bg-kids-dictionary-800\\/60:hover{
  background-color: rgba(24, 77, 64, 0.6);
}

.hover\\:bg-kids-dictionary-800\\/65:hover{
  background-color: rgba(24, 77, 64, 0.65);
}

.hover\\:bg-kids-dictionary-800\\/70:hover{
  background-color: rgba(24, 77, 64, 0.7);
}

.hover\\:bg-kids-dictionary-800\\/75:hover{
  background-color: rgba(24, 77, 64, 0.75);
}

.hover\\:bg-kids-dictionary-800\\/80:hover{
  background-color: rgba(24, 77, 64, 0.8);
}

.hover\\:bg-kids-dictionary-800\\/85:hover{
  background-color: rgba(24, 77, 64, 0.85);
}

.hover\\:bg-kids-dictionary-800\\/90:hover{
  background-color: rgba(24, 77, 64, 0.9);
}

.hover\\:bg-kids-dictionary-800\\/95:hover{
  background-color: rgba(24, 77, 64, 0.95);
}

.hover\\:bg-kids-dictionary-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(20, 64, 54, 1);
  background-color: rgba(20, 64, 54, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-dictionary-900\\/0:hover{
  background-color: rgba(20, 64, 54, 0);
}

.hover\\:bg-kids-dictionary-900\\/10:hover{
  background-color: rgba(20, 64, 54, 0.1);
}

.hover\\:bg-kids-dictionary-900\\/100:hover{
  background-color: rgb(20, 64, 54);
}

.hover\\:bg-kids-dictionary-900\\/15:hover{
  background-color: rgba(20, 64, 54, 0.15);
}

.hover\\:bg-kids-dictionary-900\\/20:hover{
  background-color: rgba(20, 64, 54, 0.2);
}

.hover\\:bg-kids-dictionary-900\\/25:hover{
  background-color: rgba(20, 64, 54, 0.25);
}

.hover\\:bg-kids-dictionary-900\\/30:hover{
  background-color: rgba(20, 64, 54, 0.3);
}

.hover\\:bg-kids-dictionary-900\\/35:hover{
  background-color: rgba(20, 64, 54, 0.35);
}

.hover\\:bg-kids-dictionary-900\\/40:hover{
  background-color: rgba(20, 64, 54, 0.4);
}

.hover\\:bg-kids-dictionary-900\\/45:hover{
  background-color: rgba(20, 64, 54, 0.45);
}

.hover\\:bg-kids-dictionary-900\\/5:hover{
  background-color: rgba(20, 64, 54, 0.05);
}

.hover\\:bg-kids-dictionary-900\\/50:hover{
  background-color: rgba(20, 64, 54, 0.5);
}

.hover\\:bg-kids-dictionary-900\\/55:hover{
  background-color: rgba(20, 64, 54, 0.55);
}

.hover\\:bg-kids-dictionary-900\\/60:hover{
  background-color: rgba(20, 64, 54, 0.6);
}

.hover\\:bg-kids-dictionary-900\\/65:hover{
  background-color: rgba(20, 64, 54, 0.65);
}

.hover\\:bg-kids-dictionary-900\\/70:hover{
  background-color: rgba(20, 64, 54, 0.7);
}

.hover\\:bg-kids-dictionary-900\\/75:hover{
  background-color: rgba(20, 64, 54, 0.75);
}

.hover\\:bg-kids-dictionary-900\\/80:hover{
  background-color: rgba(20, 64, 54, 0.8);
}

.hover\\:bg-kids-dictionary-900\\/85:hover{
  background-color: rgba(20, 64, 54, 0.85);
}

.hover\\:bg-kids-dictionary-900\\/90:hover{
  background-color: rgba(20, 64, 54, 0.9);
}

.hover\\:bg-kids-dictionary-900\\/95:hover{
  background-color: rgba(20, 64, 54, 0.95);
}

.hover\\:bg-kids-games-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(81, 59, 86, 1);
  background-color: rgba(81, 59, 86, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-games-500\\/0:hover{
  background-color: rgba(81, 59, 86, 0);
}

.hover\\:bg-kids-games-500\\/10:hover{
  background-color: rgba(81, 59, 86, 0.1);
}

.hover\\:bg-kids-games-500\\/100:hover{
  background-color: rgb(81, 59, 86);
}

.hover\\:bg-kids-games-500\\/15:hover{
  background-color: rgba(81, 59, 86, 0.15);
}

.hover\\:bg-kids-games-500\\/20:hover{
  background-color: rgba(81, 59, 86, 0.2);
}

.hover\\:bg-kids-games-500\\/25:hover{
  background-color: rgba(81, 59, 86, 0.25);
}

.hover\\:bg-kids-games-500\\/30:hover{
  background-color: rgba(81, 59, 86, 0.3);
}

.hover\\:bg-kids-games-500\\/35:hover{
  background-color: rgba(81, 59, 86, 0.35);
}

.hover\\:bg-kids-games-500\\/40:hover{
  background-color: rgba(81, 59, 86, 0.4);
}

.hover\\:bg-kids-games-500\\/45:hover{
  background-color: rgba(81, 59, 86, 0.45);
}

.hover\\:bg-kids-games-500\\/5:hover{
  background-color: rgba(81, 59, 86, 0.05);
}

.hover\\:bg-kids-games-500\\/50:hover{
  background-color: rgba(81, 59, 86, 0.5);
}

.hover\\:bg-kids-games-500\\/55:hover{
  background-color: rgba(81, 59, 86, 0.55);
}

.hover\\:bg-kids-games-500\\/60:hover{
  background-color: rgba(81, 59, 86, 0.6);
}

.hover\\:bg-kids-games-500\\/65:hover{
  background-color: rgba(81, 59, 86, 0.65);
}

.hover\\:bg-kids-games-500\\/70:hover{
  background-color: rgba(81, 59, 86, 0.7);
}

.hover\\:bg-kids-games-500\\/75:hover{
  background-color: rgba(81, 59, 86, 0.75);
}

.hover\\:bg-kids-games-500\\/80:hover{
  background-color: rgba(81, 59, 86, 0.8);
}

.hover\\:bg-kids-games-500\\/85:hover{
  background-color: rgba(81, 59, 86, 0.85);
}

.hover\\:bg-kids-games-500\\/90:hover{
  background-color: rgba(81, 59, 86, 0.9);
}

.hover\\:bg-kids-games-500\\/95:hover{
  background-color: rgba(81, 59, 86, 0.95);
}

.hover\\:bg-kids-games-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(57, 41, 60, 1);
  background-color: rgba(57, 41, 60, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-games-900\\/0:hover{
  background-color: rgba(57, 41, 60, 0);
}

.hover\\:bg-kids-games-900\\/10:hover{
  background-color: rgba(57, 41, 60, 0.1);
}

.hover\\:bg-kids-games-900\\/100:hover{
  background-color: rgb(57, 41, 60);
}

.hover\\:bg-kids-games-900\\/15:hover{
  background-color: rgba(57, 41, 60, 0.15);
}

.hover\\:bg-kids-games-900\\/20:hover{
  background-color: rgba(57, 41, 60, 0.2);
}

.hover\\:bg-kids-games-900\\/25:hover{
  background-color: rgba(57, 41, 60, 0.25);
}

.hover\\:bg-kids-games-900\\/30:hover{
  background-color: rgba(57, 41, 60, 0.3);
}

.hover\\:bg-kids-games-900\\/35:hover{
  background-color: rgba(57, 41, 60, 0.35);
}

.hover\\:bg-kids-games-900\\/40:hover{
  background-color: rgba(57, 41, 60, 0.4);
}

.hover\\:bg-kids-games-900\\/45:hover{
  background-color: rgba(57, 41, 60, 0.45);
}

.hover\\:bg-kids-games-900\\/5:hover{
  background-color: rgba(57, 41, 60, 0.05);
}

.hover\\:bg-kids-games-900\\/50:hover{
  background-color: rgba(57, 41, 60, 0.5);
}

.hover\\:bg-kids-games-900\\/55:hover{
  background-color: rgba(57, 41, 60, 0.55);
}

.hover\\:bg-kids-games-900\\/60:hover{
  background-color: rgba(57, 41, 60, 0.6);
}

.hover\\:bg-kids-games-900\\/65:hover{
  background-color: rgba(57, 41, 60, 0.65);
}

.hover\\:bg-kids-games-900\\/70:hover{
  background-color: rgba(57, 41, 60, 0.7);
}

.hover\\:bg-kids-games-900\\/75:hover{
  background-color: rgba(57, 41, 60, 0.75);
}

.hover\\:bg-kids-games-900\\/80:hover{
  background-color: rgba(57, 41, 60, 0.8);
}

.hover\\:bg-kids-games-900\\/85:hover{
  background-color: rgba(57, 41, 60, 0.85);
}

.hover\\:bg-kids-games-900\\/90:hover{
  background-color: rgba(57, 41, 60, 0.9);
}

.hover\\:bg-kids-games-900\\/95:hover{
  background-color: rgba(57, 41, 60, 0.95);
}

.hover\\:bg-kids-songs-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(131, 0, 66, 1);
  background-color: rgba(131, 0, 66, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-songs-500\\/0:hover{
  background-color: rgba(131, 0, 66, 0);
}

.hover\\:bg-kids-songs-500\\/10:hover{
  background-color: rgba(131, 0, 66, 0.1);
}

.hover\\:bg-kids-songs-500\\/100:hover{
  background-color: rgb(131, 0, 66);
}

.hover\\:bg-kids-songs-500\\/15:hover{
  background-color: rgba(131, 0, 66, 0.15);
}

.hover\\:bg-kids-songs-500\\/20:hover{
  background-color: rgba(131, 0, 66, 0.2);
}

.hover\\:bg-kids-songs-500\\/25:hover{
  background-color: rgba(131, 0, 66, 0.25);
}

.hover\\:bg-kids-songs-500\\/30:hover{
  background-color: rgba(131, 0, 66, 0.3);
}

.hover\\:bg-kids-songs-500\\/35:hover{
  background-color: rgba(131, 0, 66, 0.35);
}

.hover\\:bg-kids-songs-500\\/40:hover{
  background-color: rgba(131, 0, 66, 0.4);
}

.hover\\:bg-kids-songs-500\\/45:hover{
  background-color: rgba(131, 0, 66, 0.45);
}

.hover\\:bg-kids-songs-500\\/5:hover{
  background-color: rgba(131, 0, 66, 0.05);
}

.hover\\:bg-kids-songs-500\\/50:hover{
  background-color: rgba(131, 0, 66, 0.5);
}

.hover\\:bg-kids-songs-500\\/55:hover{
  background-color: rgba(131, 0, 66, 0.55);
}

.hover\\:bg-kids-songs-500\\/60:hover{
  background-color: rgba(131, 0, 66, 0.6);
}

.hover\\:bg-kids-songs-500\\/65:hover{
  background-color: rgba(131, 0, 66, 0.65);
}

.hover\\:bg-kids-songs-500\\/70:hover{
  background-color: rgba(131, 0, 66, 0.7);
}

.hover\\:bg-kids-songs-500\\/75:hover{
  background-color: rgba(131, 0, 66, 0.75);
}

.hover\\:bg-kids-songs-500\\/80:hover{
  background-color: rgba(131, 0, 66, 0.8);
}

.hover\\:bg-kids-songs-500\\/85:hover{
  background-color: rgba(131, 0, 66, 0.85);
}

.hover\\:bg-kids-songs-500\\/90:hover{
  background-color: rgba(131, 0, 66, 0.9);
}

.hover\\:bg-kids-songs-500\\/95:hover{
  background-color: rgba(131, 0, 66, 0.95);
}

.hover\\:bg-kids-songs-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(92, 0, 46, 1);
  background-color: rgba(92, 0, 46, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-songs-900\\/0:hover{
  background-color: rgba(92, 0, 46, 0);
}

.hover\\:bg-kids-songs-900\\/10:hover{
  background-color: rgba(92, 0, 46, 0.1);
}

.hover\\:bg-kids-songs-900\\/100:hover{
  background-color: rgb(92, 0, 46);
}

.hover\\:bg-kids-songs-900\\/15:hover{
  background-color: rgba(92, 0, 46, 0.15);
}

.hover\\:bg-kids-songs-900\\/20:hover{
  background-color: rgba(92, 0, 46, 0.2);
}

.hover\\:bg-kids-songs-900\\/25:hover{
  background-color: rgba(92, 0, 46, 0.25);
}

.hover\\:bg-kids-songs-900\\/30:hover{
  background-color: rgba(92, 0, 46, 0.3);
}

.hover\\:bg-kids-songs-900\\/35:hover{
  background-color: rgba(92, 0, 46, 0.35);
}

.hover\\:bg-kids-songs-900\\/40:hover{
  background-color: rgba(92, 0, 46, 0.4);
}

.hover\\:bg-kids-songs-900\\/45:hover{
  background-color: rgba(92, 0, 46, 0.45);
}

.hover\\:bg-kids-songs-900\\/5:hover{
  background-color: rgba(92, 0, 46, 0.05);
}

.hover\\:bg-kids-songs-900\\/50:hover{
  background-color: rgba(92, 0, 46, 0.5);
}

.hover\\:bg-kids-songs-900\\/55:hover{
  background-color: rgba(92, 0, 46, 0.55);
}

.hover\\:bg-kids-songs-900\\/60:hover{
  background-color: rgba(92, 0, 46, 0.6);
}

.hover\\:bg-kids-songs-900\\/65:hover{
  background-color: rgba(92, 0, 46, 0.65);
}

.hover\\:bg-kids-songs-900\\/70:hover{
  background-color: rgba(92, 0, 46, 0.7);
}

.hover\\:bg-kids-songs-900\\/75:hover{
  background-color: rgba(92, 0, 46, 0.75);
}

.hover\\:bg-kids-songs-900\\/80:hover{
  background-color: rgba(92, 0, 46, 0.8);
}

.hover\\:bg-kids-songs-900\\/85:hover{
  background-color: rgba(92, 0, 46, 0.85);
}

.hover\\:bg-kids-songs-900\\/90:hover{
  background-color: rgba(92, 0, 46, 0.9);
}

.hover\\:bg-kids-songs-900\\/95:hover{
  background-color: rgba(92, 0, 46, 0.95);
}

.hover\\:bg-kids-stories-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(233, 196, 106, 1);
  background-color: rgba(233, 196, 106, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-stories-500\\/0:hover{
  background-color: rgba(233, 196, 106, 0);
}

.hover\\:bg-kids-stories-500\\/10:hover{
  background-color: rgba(233, 196, 106, 0.1);
}

.hover\\:bg-kids-stories-500\\/100:hover{
  background-color: rgb(233, 196, 106);
}

.hover\\:bg-kids-stories-500\\/15:hover{
  background-color: rgba(233, 196, 106, 0.15);
}

.hover\\:bg-kids-stories-500\\/20:hover{
  background-color: rgba(233, 196, 106, 0.2);
}

.hover\\:bg-kids-stories-500\\/25:hover{
  background-color: rgba(233, 196, 106, 0.25);
}

.hover\\:bg-kids-stories-500\\/30:hover{
  background-color: rgba(233, 196, 106, 0.3);
}

.hover\\:bg-kids-stories-500\\/35:hover{
  background-color: rgba(233, 196, 106, 0.35);
}

.hover\\:bg-kids-stories-500\\/40:hover{
  background-color: rgba(233, 196, 106, 0.4);
}

.hover\\:bg-kids-stories-500\\/45:hover{
  background-color: rgba(233, 196, 106, 0.45);
}

.hover\\:bg-kids-stories-500\\/5:hover{
  background-color: rgba(233, 196, 106, 0.05);
}

.hover\\:bg-kids-stories-500\\/50:hover{
  background-color: rgba(233, 196, 106, 0.5);
}

.hover\\:bg-kids-stories-500\\/55:hover{
  background-color: rgba(233, 196, 106, 0.55);
}

.hover\\:bg-kids-stories-500\\/60:hover{
  background-color: rgba(233, 196, 106, 0.6);
}

.hover\\:bg-kids-stories-500\\/65:hover{
  background-color: rgba(233, 196, 106, 0.65);
}

.hover\\:bg-kids-stories-500\\/70:hover{
  background-color: rgba(233, 196, 106, 0.7);
}

.hover\\:bg-kids-stories-500\\/75:hover{
  background-color: rgba(233, 196, 106, 0.75);
}

.hover\\:bg-kids-stories-500\\/80:hover{
  background-color: rgba(233, 196, 106, 0.8);
}

.hover\\:bg-kids-stories-500\\/85:hover{
  background-color: rgba(233, 196, 106, 0.85);
}

.hover\\:bg-kids-stories-500\\/90:hover{
  background-color: rgba(233, 196, 106, 0.9);
}

.hover\\:bg-kids-stories-500\\/95:hover{
  background-color: rgba(233, 196, 106, 0.95);
}

.hover\\:bg-kids-stories-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(163, 137, 74, 1);
  background-color: rgba(163, 137, 74, var(--tw-bg-opacity, 1));
}

.hover\\:bg-kids-stories-900\\/0:hover{
  background-color: rgba(163, 137, 74, 0);
}

.hover\\:bg-kids-stories-900\\/10:hover{
  background-color: rgba(163, 137, 74, 0.1);
}

.hover\\:bg-kids-stories-900\\/100:hover{
  background-color: rgb(163, 137, 74);
}

.hover\\:bg-kids-stories-900\\/15:hover{
  background-color: rgba(163, 137, 74, 0.15);
}

.hover\\:bg-kids-stories-900\\/20:hover{
  background-color: rgba(163, 137, 74, 0.2);
}

.hover\\:bg-kids-stories-900\\/25:hover{
  background-color: rgba(163, 137, 74, 0.25);
}

.hover\\:bg-kids-stories-900\\/30:hover{
  background-color: rgba(163, 137, 74, 0.3);
}

.hover\\:bg-kids-stories-900\\/35:hover{
  background-color: rgba(163, 137, 74, 0.35);
}

.hover\\:bg-kids-stories-900\\/40:hover{
  background-color: rgba(163, 137, 74, 0.4);
}

.hover\\:bg-kids-stories-900\\/45:hover{
  background-color: rgba(163, 137, 74, 0.45);
}

.hover\\:bg-kids-stories-900\\/5:hover{
  background-color: rgba(163, 137, 74, 0.05);
}

.hover\\:bg-kids-stories-900\\/50:hover{
  background-color: rgba(163, 137, 74, 0.5);
}

.hover\\:bg-kids-stories-900\\/55:hover{
  background-color: rgba(163, 137, 74, 0.55);
}

.hover\\:bg-kids-stories-900\\/60:hover{
  background-color: rgba(163, 137, 74, 0.6);
}

.hover\\:bg-kids-stories-900\\/65:hover{
  background-color: rgba(163, 137, 74, 0.65);
}

.hover\\:bg-kids-stories-900\\/70:hover{
  background-color: rgba(163, 137, 74, 0.7);
}

.hover\\:bg-kids-stories-900\\/75:hover{
  background-color: rgba(163, 137, 74, 0.75);
}

.hover\\:bg-kids-stories-900\\/80:hover{
  background-color: rgba(163, 137, 74, 0.8);
}

.hover\\:bg-kids-stories-900\\/85:hover{
  background-color: rgba(163, 137, 74, 0.85);
}

.hover\\:bg-kids-stories-900\\/90:hover{
  background-color: rgba(163, 137, 74, 0.9);
}

.hover\\:bg-kids-stories-900\\/95:hover{
  background-color: rgba(163, 137, 74, 0.95);
}

.hover\\:bg-ochre-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(245, 237, 208, 1);
  background-color: rgba(245, 237, 208, var(--tw-bg-opacity, 1));
}

.hover\\:bg-ochre-100\\/0:hover{
  background-color: rgba(245, 237, 208, 0);
}

.hover\\:bg-ochre-100\\/10:hover{
  background-color: rgba(245, 237, 208, 0.1);
}

.hover\\:bg-ochre-100\\/100:hover{
  background-color: rgb(245, 237, 208);
}

.hover\\:bg-ochre-100\\/15:hover{
  background-color: rgba(245, 237, 208, 0.15);
}

.hover\\:bg-ochre-100\\/20:hover{
  background-color: rgba(245, 237, 208, 0.2);
}

.hover\\:bg-ochre-100\\/25:hover{
  background-color: rgba(245, 237, 208, 0.25);
}

.hover\\:bg-ochre-100\\/30:hover{
  background-color: rgba(245, 237, 208, 0.3);
}

.hover\\:bg-ochre-100\\/35:hover{
  background-color: rgba(245, 237, 208, 0.35);
}

.hover\\:bg-ochre-100\\/40:hover{
  background-color: rgba(245, 237, 208, 0.4);
}

.hover\\:bg-ochre-100\\/45:hover{
  background-color: rgba(245, 237, 208, 0.45);
}

.hover\\:bg-ochre-100\\/5:hover{
  background-color: rgba(245, 237, 208, 0.05);
}

.hover\\:bg-ochre-100\\/50:hover{
  background-color: rgba(245, 237, 208, 0.5);
}

.hover\\:bg-ochre-100\\/55:hover{
  background-color: rgba(245, 237, 208, 0.55);
}

.hover\\:bg-ochre-100\\/60:hover{
  background-color: rgba(245, 237, 208, 0.6);
}

.hover\\:bg-ochre-100\\/65:hover{
  background-color: rgba(245, 237, 208, 0.65);
}

.hover\\:bg-ochre-100\\/70:hover{
  background-color: rgba(245, 237, 208, 0.7);
}

.hover\\:bg-ochre-100\\/75:hover{
  background-color: rgba(245, 237, 208, 0.75);
}

.hover\\:bg-ochre-100\\/80:hover{
  background-color: rgba(245, 237, 208, 0.8);
}

.hover\\:bg-ochre-100\\/85:hover{
  background-color: rgba(245, 237, 208, 0.85);
}

.hover\\:bg-ochre-100\\/90:hover{
  background-color: rgba(245, 237, 208, 0.9);
}

.hover\\:bg-ochre-100\\/95:hover{
  background-color: rgba(245, 237, 208, 0.95);
}

.hover\\:bg-ochre-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(235, 217, 156, 1);
  background-color: rgba(235, 217, 156, var(--tw-bg-opacity, 1));
}

.hover\\:bg-ochre-200\\/0:hover{
  background-color: rgba(235, 217, 156, 0);
}

.hover\\:bg-ochre-200\\/10:hover{
  background-color: rgba(235, 217, 156, 0.1);
}

.hover\\:bg-ochre-200\\/100:hover{
  background-color: rgb(235, 217, 156);
}

.hover\\:bg-ochre-200\\/15:hover{
  background-color: rgba(235, 217, 156, 0.15);
}

.hover\\:bg-ochre-200\\/20:hover{
  background-color: rgba(235, 217, 156, 0.2);
}

.hover\\:bg-ochre-200\\/25:hover{
  background-color: rgba(235, 217, 156, 0.25);
}

.hover\\:bg-ochre-200\\/30:hover{
  background-color: rgba(235, 217, 156, 0.3);
}

.hover\\:bg-ochre-200\\/35:hover{
  background-color: rgba(235, 217, 156, 0.35);
}

.hover\\:bg-ochre-200\\/40:hover{
  background-color: rgba(235, 217, 156, 0.4);
}

.hover\\:bg-ochre-200\\/45:hover{
  background-color: rgba(235, 217, 156, 0.45);
}

.hover\\:bg-ochre-200\\/5:hover{
  background-color: rgba(235, 217, 156, 0.05);
}

.hover\\:bg-ochre-200\\/50:hover{
  background-color: rgba(235, 217, 156, 0.5);
}

.hover\\:bg-ochre-200\\/55:hover{
  background-color: rgba(235, 217, 156, 0.55);
}

.hover\\:bg-ochre-200\\/60:hover{
  background-color: rgba(235, 217, 156, 0.6);
}

.hover\\:bg-ochre-200\\/65:hover{
  background-color: rgba(235, 217, 156, 0.65);
}

.hover\\:bg-ochre-200\\/70:hover{
  background-color: rgba(235, 217, 156, 0.7);
}

.hover\\:bg-ochre-200\\/75:hover{
  background-color: rgba(235, 217, 156, 0.75);
}

.hover\\:bg-ochre-200\\/80:hover{
  background-color: rgba(235, 217, 156, 0.8);
}

.hover\\:bg-ochre-200\\/85:hover{
  background-color: rgba(235, 217, 156, 0.85);
}

.hover\\:bg-ochre-200\\/90:hover{
  background-color: rgba(235, 217, 156, 0.9);
}

.hover\\:bg-ochre-200\\/95:hover{
  background-color: rgba(235, 217, 156, 0.95);
}

.hover\\:bg-ochre-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(225, 194, 104, 1);
  background-color: rgba(225, 194, 104, var(--tw-bg-opacity, 1));
}

.hover\\:bg-ochre-300\\/0:hover{
  background-color: rgba(225, 194, 104, 0);
}

.hover\\:bg-ochre-300\\/10:hover{
  background-color: rgba(225, 194, 104, 0.1);
}

.hover\\:bg-ochre-300\\/100:hover{
  background-color: rgb(225, 194, 104);
}

.hover\\:bg-ochre-300\\/15:hover{
  background-color: rgba(225, 194, 104, 0.15);
}

.hover\\:bg-ochre-300\\/20:hover{
  background-color: rgba(225, 194, 104, 0.2);
}

.hover\\:bg-ochre-300\\/25:hover{
  background-color: rgba(225, 194, 104, 0.25);
}

.hover\\:bg-ochre-300\\/30:hover{
  background-color: rgba(225, 194, 104, 0.3);
}

.hover\\:bg-ochre-300\\/35:hover{
  background-color: rgba(225, 194, 104, 0.35);
}

.hover\\:bg-ochre-300\\/40:hover{
  background-color: rgba(225, 194, 104, 0.4);
}

.hover\\:bg-ochre-300\\/45:hover{
  background-color: rgba(225, 194, 104, 0.45);
}

.hover\\:bg-ochre-300\\/5:hover{
  background-color: rgba(225, 194, 104, 0.05);
}

.hover\\:bg-ochre-300\\/50:hover{
  background-color: rgba(225, 194, 104, 0.5);
}

.hover\\:bg-ochre-300\\/55:hover{
  background-color: rgba(225, 194, 104, 0.55);
}

.hover\\:bg-ochre-300\\/60:hover{
  background-color: rgba(225, 194, 104, 0.6);
}

.hover\\:bg-ochre-300\\/65:hover{
  background-color: rgba(225, 194, 104, 0.65);
}

.hover\\:bg-ochre-300\\/70:hover{
  background-color: rgba(225, 194, 104, 0.7);
}

.hover\\:bg-ochre-300\\/75:hover{
  background-color: rgba(225, 194, 104, 0.75);
}

.hover\\:bg-ochre-300\\/80:hover{
  background-color: rgba(225, 194, 104, 0.8);
}

.hover\\:bg-ochre-300\\/85:hover{
  background-color: rgba(225, 194, 104, 0.85);
}

.hover\\:bg-ochre-300\\/90:hover{
  background-color: rgba(225, 194, 104, 0.9);
}

.hover\\:bg-ochre-300\\/95:hover{
  background-color: rgba(225, 194, 104, 0.95);
}

.hover\\:bg-ochre-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(218, 173, 69, 1);
  background-color: rgba(218, 173, 69, var(--tw-bg-opacity, 1));
}

.hover\\:bg-ochre-400\\/0:hover{
  background-color: rgba(218, 173, 69, 0);
}

.hover\\:bg-ochre-400\\/10:hover{
  background-color: rgba(218, 173, 69, 0.1);
}

.hover\\:bg-ochre-400\\/100:hover{
  background-color: rgb(218, 173, 69);
}

.hover\\:bg-ochre-400\\/15:hover{
  background-color: rgba(218, 173, 69, 0.15);
}

.hover\\:bg-ochre-400\\/20:hover{
  background-color: rgba(218, 173, 69, 0.2);
}

.hover\\:bg-ochre-400\\/25:hover{
  background-color: rgba(218, 173, 69, 0.25);
}

.hover\\:bg-ochre-400\\/30:hover{
  background-color: rgba(218, 173, 69, 0.3);
}

.hover\\:bg-ochre-400\\/35:hover{
  background-color: rgba(218, 173, 69, 0.35);
}

.hover\\:bg-ochre-400\\/40:hover{
  background-color: rgba(218, 173, 69, 0.4);
}

.hover\\:bg-ochre-400\\/45:hover{
  background-color: rgba(218, 173, 69, 0.45);
}

.hover\\:bg-ochre-400\\/5:hover{
  background-color: rgba(218, 173, 69, 0.05);
}

.hover\\:bg-ochre-400\\/50:hover{
  background-color: rgba(218, 173, 69, 0.5);
}

.hover\\:bg-ochre-400\\/55:hover{
  background-color: rgba(218, 173, 69, 0.55);
}

.hover\\:bg-ochre-400\\/60:hover{
  background-color: rgba(218, 173, 69, 0.6);
}

.hover\\:bg-ochre-400\\/65:hover{
  background-color: rgba(218, 173, 69, 0.65);
}

.hover\\:bg-ochre-400\\/70:hover{
  background-color: rgba(218, 173, 69, 0.7);
}

.hover\\:bg-ochre-400\\/75:hover{
  background-color: rgba(218, 173, 69, 0.75);
}

.hover\\:bg-ochre-400\\/80:hover{
  background-color: rgba(218, 173, 69, 0.8);
}

.hover\\:bg-ochre-400\\/85:hover{
  background-color: rgba(218, 173, 69, 0.85);
}

.hover\\:bg-ochre-400\\/90:hover{
  background-color: rgba(218, 173, 69, 0.9);
}

.hover\\:bg-ochre-400\\/95:hover{
  background-color: rgba(218, 173, 69, 0.95);
}

.hover\\:bg-ochre-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(209, 145, 47, 1);
  background-color: rgba(209, 145, 47, var(--tw-bg-opacity, 1));
}

.hover\\:bg-ochre-500\\/0:hover{
  background-color: rgba(209, 145, 47, 0);
}

.hover\\:bg-ochre-500\\/10:hover{
  background-color: rgba(209, 145, 47, 0.1);
}

.hover\\:bg-ochre-500\\/100:hover{
  background-color: rgb(209, 145, 47);
}

.hover\\:bg-ochre-500\\/15:hover{
  background-color: rgba(209, 145, 47, 0.15);
}

.hover\\:bg-ochre-500\\/20:hover{
  background-color: rgba(209, 145, 47, 0.2);
}

.hover\\:bg-ochre-500\\/25:hover{
  background-color: rgba(209, 145, 47, 0.25);
}

.hover\\:bg-ochre-500\\/30:hover{
  background-color: rgba(209, 145, 47, 0.3);
}

.hover\\:bg-ochre-500\\/35:hover{
  background-color: rgba(209, 145, 47, 0.35);
}

.hover\\:bg-ochre-500\\/40:hover{
  background-color: rgba(209, 145, 47, 0.4);
}

.hover\\:bg-ochre-500\\/45:hover{
  background-color: rgba(209, 145, 47, 0.45);
}

.hover\\:bg-ochre-500\\/5:hover{
  background-color: rgba(209, 145, 47, 0.05);
}

.hover\\:bg-ochre-500\\/50:hover{
  background-color: rgba(209, 145, 47, 0.5);
}

.hover\\:bg-ochre-500\\/55:hover{
  background-color: rgba(209, 145, 47, 0.55);
}

.hover\\:bg-ochre-500\\/60:hover{
  background-color: rgba(209, 145, 47, 0.6);
}

.hover\\:bg-ochre-500\\/65:hover{
  background-color: rgba(209, 145, 47, 0.65);
}

.hover\\:bg-ochre-500\\/70:hover{
  background-color: rgba(209, 145, 47, 0.7);
}

.hover\\:bg-ochre-500\\/75:hover{
  background-color: rgba(209, 145, 47, 0.75);
}

.hover\\:bg-ochre-500\\/80:hover{
  background-color: rgba(209, 145, 47, 0.8);
}

.hover\\:bg-ochre-500\\/85:hover{
  background-color: rgba(209, 145, 47, 0.85);
}

.hover\\:bg-ochre-500\\/90:hover{
  background-color: rgba(209, 145, 47, 0.9);
}

.hover\\:bg-ochre-500\\/95:hover{
  background-color: rgba(209, 145, 47, 0.95);
}

.hover\\:bg-ochre-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(195, 120, 41, 1);
  background-color: rgba(195, 120, 41, var(--tw-bg-opacity, 1));
}

.hover\\:bg-ochre-600\\/0:hover{
  background-color: rgba(195, 120, 41, 0);
}

.hover\\:bg-ochre-600\\/10:hover{
  background-color: rgba(195, 120, 41, 0.1);
}

.hover\\:bg-ochre-600\\/100:hover{
  background-color: rgb(195, 120, 41);
}

.hover\\:bg-ochre-600\\/15:hover{
  background-color: rgba(195, 120, 41, 0.15);
}

.hover\\:bg-ochre-600\\/20:hover{
  background-color: rgba(195, 120, 41, 0.2);
}

.hover\\:bg-ochre-600\\/25:hover{
  background-color: rgba(195, 120, 41, 0.25);
}

.hover\\:bg-ochre-600\\/30:hover{
  background-color: rgba(195, 120, 41, 0.3);
}

.hover\\:bg-ochre-600\\/35:hover{
  background-color: rgba(195, 120, 41, 0.35);
}

.hover\\:bg-ochre-600\\/40:hover{
  background-color: rgba(195, 120, 41, 0.4);
}

.hover\\:bg-ochre-600\\/45:hover{
  background-color: rgba(195, 120, 41, 0.45);
}

.hover\\:bg-ochre-600\\/5:hover{
  background-color: rgba(195, 120, 41, 0.05);
}

.hover\\:bg-ochre-600\\/50:hover{
  background-color: rgba(195, 120, 41, 0.5);
}

.hover\\:bg-ochre-600\\/55:hover{
  background-color: rgba(195, 120, 41, 0.55);
}

.hover\\:bg-ochre-600\\/60:hover{
  background-color: rgba(195, 120, 41, 0.6);
}

.hover\\:bg-ochre-600\\/65:hover{
  background-color: rgba(195, 120, 41, 0.65);
}

.hover\\:bg-ochre-600\\/70:hover{
  background-color: rgba(195, 120, 41, 0.7);
}

.hover\\:bg-ochre-600\\/75:hover{
  background-color: rgba(195, 120, 41, 0.75);
}

.hover\\:bg-ochre-600\\/80:hover{
  background-color: rgba(195, 120, 41, 0.8);
}

.hover\\:bg-ochre-600\\/85:hover{
  background-color: rgba(195, 120, 41, 0.85);
}

.hover\\:bg-ochre-600\\/90:hover{
  background-color: rgba(195, 120, 41, 0.9);
}

.hover\\:bg-ochre-600\\/95:hover{
  background-color: rgba(195, 120, 41, 0.95);
}

.hover\\:bg-ochre-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(153, 84, 36, 1);
  background-color: rgba(153, 84, 36, var(--tw-bg-opacity, 1));
}

.hover\\:bg-ochre-700\\/0:hover{
  background-color: rgba(153, 84, 36, 0);
}

.hover\\:bg-ochre-700\\/10:hover{
  background-color: rgba(153, 84, 36, 0.1);
}

.hover\\:bg-ochre-700\\/100:hover{
  background-color: rgb(153, 84, 36);
}

.hover\\:bg-ochre-700\\/15:hover{
  background-color: rgba(153, 84, 36, 0.15);
}

.hover\\:bg-ochre-700\\/20:hover{
  background-color: rgba(153, 84, 36, 0.2);
}

.hover\\:bg-ochre-700\\/25:hover{
  background-color: rgba(153, 84, 36, 0.25);
}

.hover\\:bg-ochre-700\\/30:hover{
  background-color: rgba(153, 84, 36, 0.3);
}

.hover\\:bg-ochre-700\\/35:hover{
  background-color: rgba(153, 84, 36, 0.35);
}

.hover\\:bg-ochre-700\\/40:hover{
  background-color: rgba(153, 84, 36, 0.4);
}

.hover\\:bg-ochre-700\\/45:hover{
  background-color: rgba(153, 84, 36, 0.45);
}

.hover\\:bg-ochre-700\\/5:hover{
  background-color: rgba(153, 84, 36, 0.05);
}

.hover\\:bg-ochre-700\\/50:hover{
  background-color: rgba(153, 84, 36, 0.5);
}

.hover\\:bg-ochre-700\\/55:hover{
  background-color: rgba(153, 84, 36, 0.55);
}

.hover\\:bg-ochre-700\\/60:hover{
  background-color: rgba(153, 84, 36, 0.6);
}

.hover\\:bg-ochre-700\\/65:hover{
  background-color: rgba(153, 84, 36, 0.65);
}

.hover\\:bg-ochre-700\\/70:hover{
  background-color: rgba(153, 84, 36, 0.7);
}

.hover\\:bg-ochre-700\\/75:hover{
  background-color: rgba(153, 84, 36, 0.75);
}

.hover\\:bg-ochre-700\\/80:hover{
  background-color: rgba(153, 84, 36, 0.8);
}

.hover\\:bg-ochre-700\\/85:hover{
  background-color: rgba(153, 84, 36, 0.85);
}

.hover\\:bg-ochre-700\\/90:hover{
  background-color: rgba(153, 84, 36, 0.9);
}

.hover\\:bg-ochre-700\\/95:hover{
  background-color: rgba(153, 84, 36, 0.95);
}

.hover\\:bg-ochre-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(126, 67, 34, 1);
  background-color: rgba(126, 67, 34, var(--tw-bg-opacity, 1));
}

.hover\\:bg-ochre-800\\/0:hover{
  background-color: rgba(126, 67, 34, 0);
}

.hover\\:bg-ochre-800\\/10:hover{
  background-color: rgba(126, 67, 34, 0.1);
}

.hover\\:bg-ochre-800\\/100:hover{
  background-color: rgb(126, 67, 34);
}

.hover\\:bg-ochre-800\\/15:hover{
  background-color: rgba(126, 67, 34, 0.15);
}

.hover\\:bg-ochre-800\\/20:hover{
  background-color: rgba(126, 67, 34, 0.2);
}

.hover\\:bg-ochre-800\\/25:hover{
  background-color: rgba(126, 67, 34, 0.25);
}

.hover\\:bg-ochre-800\\/30:hover{
  background-color: rgba(126, 67, 34, 0.3);
}

.hover\\:bg-ochre-800\\/35:hover{
  background-color: rgba(126, 67, 34, 0.35);
}

.hover\\:bg-ochre-800\\/40:hover{
  background-color: rgba(126, 67, 34, 0.4);
}

.hover\\:bg-ochre-800\\/45:hover{
  background-color: rgba(126, 67, 34, 0.45);
}

.hover\\:bg-ochre-800\\/5:hover{
  background-color: rgba(126, 67, 34, 0.05);
}

.hover\\:bg-ochre-800\\/50:hover{
  background-color: rgba(126, 67, 34, 0.5);
}

.hover\\:bg-ochre-800\\/55:hover{
  background-color: rgba(126, 67, 34, 0.55);
}

.hover\\:bg-ochre-800\\/60:hover{
  background-color: rgba(126, 67, 34, 0.6);
}

.hover\\:bg-ochre-800\\/65:hover{
  background-color: rgba(126, 67, 34, 0.65);
}

.hover\\:bg-ochre-800\\/70:hover{
  background-color: rgba(126, 67, 34, 0.7);
}

.hover\\:bg-ochre-800\\/75:hover{
  background-color: rgba(126, 67, 34, 0.75);
}

.hover\\:bg-ochre-800\\/80:hover{
  background-color: rgba(126, 67, 34, 0.8);
}

.hover\\:bg-ochre-800\\/85:hover{
  background-color: rgba(126, 67, 34, 0.85);
}

.hover\\:bg-ochre-800\\/90:hover{
  background-color: rgba(126, 67, 34, 0.9);
}

.hover\\:bg-ochre-800\\/95:hover{
  background-color: rgba(126, 67, 34, 0.95);
}

.hover\\:bg-ochre-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(104, 56, 31, 1);
  background-color: rgba(104, 56, 31, var(--tw-bg-opacity, 1));
}

.hover\\:bg-ochre-900\\/0:hover{
  background-color: rgba(104, 56, 31, 0);
}

.hover\\:bg-ochre-900\\/10:hover{
  background-color: rgba(104, 56, 31, 0.1);
}

.hover\\:bg-ochre-900\\/100:hover{
  background-color: rgb(104, 56, 31);
}

.hover\\:bg-ochre-900\\/15:hover{
  background-color: rgba(104, 56, 31, 0.15);
}

.hover\\:bg-ochre-900\\/20:hover{
  background-color: rgba(104, 56, 31, 0.2);
}

.hover\\:bg-ochre-900\\/25:hover{
  background-color: rgba(104, 56, 31, 0.25);
}

.hover\\:bg-ochre-900\\/30:hover{
  background-color: rgba(104, 56, 31, 0.3);
}

.hover\\:bg-ochre-900\\/35:hover{
  background-color: rgba(104, 56, 31, 0.35);
}

.hover\\:bg-ochre-900\\/40:hover{
  background-color: rgba(104, 56, 31, 0.4);
}

.hover\\:bg-ochre-900\\/45:hover{
  background-color: rgba(104, 56, 31, 0.45);
}

.hover\\:bg-ochre-900\\/5:hover{
  background-color: rgba(104, 56, 31, 0.05);
}

.hover\\:bg-ochre-900\\/50:hover{
  background-color: rgba(104, 56, 31, 0.5);
}

.hover\\:bg-ochre-900\\/55:hover{
  background-color: rgba(104, 56, 31, 0.55);
}

.hover\\:bg-ochre-900\\/60:hover{
  background-color: rgba(104, 56, 31, 0.6);
}

.hover\\:bg-ochre-900\\/65:hover{
  background-color: rgba(104, 56, 31, 0.65);
}

.hover\\:bg-ochre-900\\/70:hover{
  background-color: rgba(104, 56, 31, 0.7);
}

.hover\\:bg-ochre-900\\/75:hover{
  background-color: rgba(104, 56, 31, 0.75);
}

.hover\\:bg-ochre-900\\/80:hover{
  background-color: rgba(104, 56, 31, 0.8);
}

.hover\\:bg-ochre-900\\/85:hover{
  background-color: rgba(104, 56, 31, 0.85);
}

.hover\\:bg-ochre-900\\/90:hover{
  background-color: rgba(104, 56, 31, 0.9);
}

.hover\\:bg-ochre-900\\/95:hover{
  background-color: rgba(104, 56, 31, 0.95);
}

.hover\\:bg-ochre-950:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(59, 28, 13, 1);
  background-color: rgba(59, 28, 13, var(--tw-bg-opacity, 1));
}

.hover\\:bg-ochre-950\\/0:hover{
  background-color: rgba(59, 28, 13, 0);
}

.hover\\:bg-ochre-950\\/10:hover{
  background-color: rgba(59, 28, 13, 0.1);
}

.hover\\:bg-ochre-950\\/100:hover{
  background-color: rgb(59, 28, 13);
}

.hover\\:bg-ochre-950\\/15:hover{
  background-color: rgba(59, 28, 13, 0.15);
}

.hover\\:bg-ochre-950\\/20:hover{
  background-color: rgba(59, 28, 13, 0.2);
}

.hover\\:bg-ochre-950\\/25:hover{
  background-color: rgba(59, 28, 13, 0.25);
}

.hover\\:bg-ochre-950\\/30:hover{
  background-color: rgba(59, 28, 13, 0.3);
}

.hover\\:bg-ochre-950\\/35:hover{
  background-color: rgba(59, 28, 13, 0.35);
}

.hover\\:bg-ochre-950\\/40:hover{
  background-color: rgba(59, 28, 13, 0.4);
}

.hover\\:bg-ochre-950\\/45:hover{
  background-color: rgba(59, 28, 13, 0.45);
}

.hover\\:bg-ochre-950\\/5:hover{
  background-color: rgba(59, 28, 13, 0.05);
}

.hover\\:bg-ochre-950\\/50:hover{
  background-color: rgba(59, 28, 13, 0.5);
}

.hover\\:bg-ochre-950\\/55:hover{
  background-color: rgba(59, 28, 13, 0.55);
}

.hover\\:bg-ochre-950\\/60:hover{
  background-color: rgba(59, 28, 13, 0.6);
}

.hover\\:bg-ochre-950\\/65:hover{
  background-color: rgba(59, 28, 13, 0.65);
}

.hover\\:bg-ochre-950\\/70:hover{
  background-color: rgba(59, 28, 13, 0.7);
}

.hover\\:bg-ochre-950\\/75:hover{
  background-color: rgba(59, 28, 13, 0.75);
}

.hover\\:bg-ochre-950\\/80:hover{
  background-color: rgba(59, 28, 13, 0.8);
}

.hover\\:bg-ochre-950\\/85:hover{
  background-color: rgba(59, 28, 13, 0.85);
}

.hover\\:bg-ochre-950\\/90:hover{
  background-color: rgba(59, 28, 13, 0.9);
}

.hover\\:bg-ochre-950\\/95:hover{
  background-color: rgba(59, 28, 13, 0.95);
}

.hover\\:bg-phrase-color-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(245, 237, 208, 1);
  background-color: rgba(245, 237, 208, var(--tw-bg-opacity, 1));
}

.hover\\:bg-phrase-color-100\\/0:hover{
  background-color: rgba(245, 237, 208, 0);
}

.hover\\:bg-phrase-color-100\\/10:hover{
  background-color: rgba(245, 237, 208, 0.1);
}

.hover\\:bg-phrase-color-100\\/100:hover{
  background-color: rgb(245, 237, 208);
}

.hover\\:bg-phrase-color-100\\/15:hover{
  background-color: rgba(245, 237, 208, 0.15);
}

.hover\\:bg-phrase-color-100\\/20:hover{
  background-color: rgba(245, 237, 208, 0.2);
}

.hover\\:bg-phrase-color-100\\/25:hover{
  background-color: rgba(245, 237, 208, 0.25);
}

.hover\\:bg-phrase-color-100\\/30:hover{
  background-color: rgba(245, 237, 208, 0.3);
}

.hover\\:bg-phrase-color-100\\/35:hover{
  background-color: rgba(245, 237, 208, 0.35);
}

.hover\\:bg-phrase-color-100\\/40:hover{
  background-color: rgba(245, 237, 208, 0.4);
}

.hover\\:bg-phrase-color-100\\/45:hover{
  background-color: rgba(245, 237, 208, 0.45);
}

.hover\\:bg-phrase-color-100\\/5:hover{
  background-color: rgba(245, 237, 208, 0.05);
}

.hover\\:bg-phrase-color-100\\/50:hover{
  background-color: rgba(245, 237, 208, 0.5);
}

.hover\\:bg-phrase-color-100\\/55:hover{
  background-color: rgba(245, 237, 208, 0.55);
}

.hover\\:bg-phrase-color-100\\/60:hover{
  background-color: rgba(245, 237, 208, 0.6);
}

.hover\\:bg-phrase-color-100\\/65:hover{
  background-color: rgba(245, 237, 208, 0.65);
}

.hover\\:bg-phrase-color-100\\/70:hover{
  background-color: rgba(245, 237, 208, 0.7);
}

.hover\\:bg-phrase-color-100\\/75:hover{
  background-color: rgba(245, 237, 208, 0.75);
}

.hover\\:bg-phrase-color-100\\/80:hover{
  background-color: rgba(245, 237, 208, 0.8);
}

.hover\\:bg-phrase-color-100\\/85:hover{
  background-color: rgba(245, 237, 208, 0.85);
}

.hover\\:bg-phrase-color-100\\/90:hover{
  background-color: rgba(245, 237, 208, 0.9);
}

.hover\\:bg-phrase-color-100\\/95:hover{
  background-color: rgba(245, 237, 208, 0.95);
}

.hover\\:bg-phrase-color-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(235, 217, 156, 1);
  background-color: rgba(235, 217, 156, var(--tw-bg-opacity, 1));
}

.hover\\:bg-phrase-color-200\\/0:hover{
  background-color: rgba(235, 217, 156, 0);
}

.hover\\:bg-phrase-color-200\\/10:hover{
  background-color: rgba(235, 217, 156, 0.1);
}

.hover\\:bg-phrase-color-200\\/100:hover{
  background-color: rgb(235, 217, 156);
}

.hover\\:bg-phrase-color-200\\/15:hover{
  background-color: rgba(235, 217, 156, 0.15);
}

.hover\\:bg-phrase-color-200\\/20:hover{
  background-color: rgba(235, 217, 156, 0.2);
}

.hover\\:bg-phrase-color-200\\/25:hover{
  background-color: rgba(235, 217, 156, 0.25);
}

.hover\\:bg-phrase-color-200\\/30:hover{
  background-color: rgba(235, 217, 156, 0.3);
}

.hover\\:bg-phrase-color-200\\/35:hover{
  background-color: rgba(235, 217, 156, 0.35);
}

.hover\\:bg-phrase-color-200\\/40:hover{
  background-color: rgba(235, 217, 156, 0.4);
}

.hover\\:bg-phrase-color-200\\/45:hover{
  background-color: rgba(235, 217, 156, 0.45);
}

.hover\\:bg-phrase-color-200\\/5:hover{
  background-color: rgba(235, 217, 156, 0.05);
}

.hover\\:bg-phrase-color-200\\/50:hover{
  background-color: rgba(235, 217, 156, 0.5);
}

.hover\\:bg-phrase-color-200\\/55:hover{
  background-color: rgba(235, 217, 156, 0.55);
}

.hover\\:bg-phrase-color-200\\/60:hover{
  background-color: rgba(235, 217, 156, 0.6);
}

.hover\\:bg-phrase-color-200\\/65:hover{
  background-color: rgba(235, 217, 156, 0.65);
}

.hover\\:bg-phrase-color-200\\/70:hover{
  background-color: rgba(235, 217, 156, 0.7);
}

.hover\\:bg-phrase-color-200\\/75:hover{
  background-color: rgba(235, 217, 156, 0.75);
}

.hover\\:bg-phrase-color-200\\/80:hover{
  background-color: rgba(235, 217, 156, 0.8);
}

.hover\\:bg-phrase-color-200\\/85:hover{
  background-color: rgba(235, 217, 156, 0.85);
}

.hover\\:bg-phrase-color-200\\/90:hover{
  background-color: rgba(235, 217, 156, 0.9);
}

.hover\\:bg-phrase-color-200\\/95:hover{
  background-color: rgba(235, 217, 156, 0.95);
}

.hover\\:bg-phrase-color-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(225, 194, 104, 1);
  background-color: rgba(225, 194, 104, var(--tw-bg-opacity, 1));
}

.hover\\:bg-phrase-color-300\\/0:hover{
  background-color: rgba(225, 194, 104, 0);
}

.hover\\:bg-phrase-color-300\\/10:hover{
  background-color: rgba(225, 194, 104, 0.1);
}

.hover\\:bg-phrase-color-300\\/100:hover{
  background-color: rgb(225, 194, 104);
}

.hover\\:bg-phrase-color-300\\/15:hover{
  background-color: rgba(225, 194, 104, 0.15);
}

.hover\\:bg-phrase-color-300\\/20:hover{
  background-color: rgba(225, 194, 104, 0.2);
}

.hover\\:bg-phrase-color-300\\/25:hover{
  background-color: rgba(225, 194, 104, 0.25);
}

.hover\\:bg-phrase-color-300\\/30:hover{
  background-color: rgba(225, 194, 104, 0.3);
}

.hover\\:bg-phrase-color-300\\/35:hover{
  background-color: rgba(225, 194, 104, 0.35);
}

.hover\\:bg-phrase-color-300\\/40:hover{
  background-color: rgba(225, 194, 104, 0.4);
}

.hover\\:bg-phrase-color-300\\/45:hover{
  background-color: rgba(225, 194, 104, 0.45);
}

.hover\\:bg-phrase-color-300\\/5:hover{
  background-color: rgba(225, 194, 104, 0.05);
}

.hover\\:bg-phrase-color-300\\/50:hover{
  background-color: rgba(225, 194, 104, 0.5);
}

.hover\\:bg-phrase-color-300\\/55:hover{
  background-color: rgba(225, 194, 104, 0.55);
}

.hover\\:bg-phrase-color-300\\/60:hover{
  background-color: rgba(225, 194, 104, 0.6);
}

.hover\\:bg-phrase-color-300\\/65:hover{
  background-color: rgba(225, 194, 104, 0.65);
}

.hover\\:bg-phrase-color-300\\/70:hover{
  background-color: rgba(225, 194, 104, 0.7);
}

.hover\\:bg-phrase-color-300\\/75:hover{
  background-color: rgba(225, 194, 104, 0.75);
}

.hover\\:bg-phrase-color-300\\/80:hover{
  background-color: rgba(225, 194, 104, 0.8);
}

.hover\\:bg-phrase-color-300\\/85:hover{
  background-color: rgba(225, 194, 104, 0.85);
}

.hover\\:bg-phrase-color-300\\/90:hover{
  background-color: rgba(225, 194, 104, 0.9);
}

.hover\\:bg-phrase-color-300\\/95:hover{
  background-color: rgba(225, 194, 104, 0.95);
}

.hover\\:bg-phrase-color-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(218, 173, 69, 1);
  background-color: rgba(218, 173, 69, var(--tw-bg-opacity, 1));
}

.hover\\:bg-phrase-color-400\\/0:hover{
  background-color: rgba(218, 173, 69, 0);
}

.hover\\:bg-phrase-color-400\\/10:hover{
  background-color: rgba(218, 173, 69, 0.1);
}

.hover\\:bg-phrase-color-400\\/100:hover{
  background-color: rgb(218, 173, 69);
}

.hover\\:bg-phrase-color-400\\/15:hover{
  background-color: rgba(218, 173, 69, 0.15);
}

.hover\\:bg-phrase-color-400\\/20:hover{
  background-color: rgba(218, 173, 69, 0.2);
}

.hover\\:bg-phrase-color-400\\/25:hover{
  background-color: rgba(218, 173, 69, 0.25);
}

.hover\\:bg-phrase-color-400\\/30:hover{
  background-color: rgba(218, 173, 69, 0.3);
}

.hover\\:bg-phrase-color-400\\/35:hover{
  background-color: rgba(218, 173, 69, 0.35);
}

.hover\\:bg-phrase-color-400\\/40:hover{
  background-color: rgba(218, 173, 69, 0.4);
}

.hover\\:bg-phrase-color-400\\/45:hover{
  background-color: rgba(218, 173, 69, 0.45);
}

.hover\\:bg-phrase-color-400\\/5:hover{
  background-color: rgba(218, 173, 69, 0.05);
}

.hover\\:bg-phrase-color-400\\/50:hover{
  background-color: rgba(218, 173, 69, 0.5);
}

.hover\\:bg-phrase-color-400\\/55:hover{
  background-color: rgba(218, 173, 69, 0.55);
}

.hover\\:bg-phrase-color-400\\/60:hover{
  background-color: rgba(218, 173, 69, 0.6);
}

.hover\\:bg-phrase-color-400\\/65:hover{
  background-color: rgba(218, 173, 69, 0.65);
}

.hover\\:bg-phrase-color-400\\/70:hover{
  background-color: rgba(218, 173, 69, 0.7);
}

.hover\\:bg-phrase-color-400\\/75:hover{
  background-color: rgba(218, 173, 69, 0.75);
}

.hover\\:bg-phrase-color-400\\/80:hover{
  background-color: rgba(218, 173, 69, 0.8);
}

.hover\\:bg-phrase-color-400\\/85:hover{
  background-color: rgba(218, 173, 69, 0.85);
}

.hover\\:bg-phrase-color-400\\/90:hover{
  background-color: rgba(218, 173, 69, 0.9);
}

.hover\\:bg-phrase-color-400\\/95:hover{
  background-color: rgba(218, 173, 69, 0.95);
}

.hover\\:bg-phrase-color-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(209, 145, 47, 1);
  background-color: rgba(209, 145, 47, var(--tw-bg-opacity, 1));
}

.hover\\:bg-phrase-color-500\\/0:hover{
  background-color: rgba(209, 145, 47, 0);
}

.hover\\:bg-phrase-color-500\\/10:hover{
  background-color: rgba(209, 145, 47, 0.1);
}

.hover\\:bg-phrase-color-500\\/100:hover{
  background-color: rgb(209, 145, 47);
}

.hover\\:bg-phrase-color-500\\/15:hover{
  background-color: rgba(209, 145, 47, 0.15);
}

.hover\\:bg-phrase-color-500\\/20:hover{
  background-color: rgba(209, 145, 47, 0.2);
}

.hover\\:bg-phrase-color-500\\/25:hover{
  background-color: rgba(209, 145, 47, 0.25);
}

.hover\\:bg-phrase-color-500\\/30:hover{
  background-color: rgba(209, 145, 47, 0.3);
}

.hover\\:bg-phrase-color-500\\/35:hover{
  background-color: rgba(209, 145, 47, 0.35);
}

.hover\\:bg-phrase-color-500\\/40:hover{
  background-color: rgba(209, 145, 47, 0.4);
}

.hover\\:bg-phrase-color-500\\/45:hover{
  background-color: rgba(209, 145, 47, 0.45);
}

.hover\\:bg-phrase-color-500\\/5:hover{
  background-color: rgba(209, 145, 47, 0.05);
}

.hover\\:bg-phrase-color-500\\/50:hover{
  background-color: rgba(209, 145, 47, 0.5);
}

.hover\\:bg-phrase-color-500\\/55:hover{
  background-color: rgba(209, 145, 47, 0.55);
}

.hover\\:bg-phrase-color-500\\/60:hover{
  background-color: rgba(209, 145, 47, 0.6);
}

.hover\\:bg-phrase-color-500\\/65:hover{
  background-color: rgba(209, 145, 47, 0.65);
}

.hover\\:bg-phrase-color-500\\/70:hover{
  background-color: rgba(209, 145, 47, 0.7);
}

.hover\\:bg-phrase-color-500\\/75:hover{
  background-color: rgba(209, 145, 47, 0.75);
}

.hover\\:bg-phrase-color-500\\/80:hover{
  background-color: rgba(209, 145, 47, 0.8);
}

.hover\\:bg-phrase-color-500\\/85:hover{
  background-color: rgba(209, 145, 47, 0.85);
}

.hover\\:bg-phrase-color-500\\/90:hover{
  background-color: rgba(209, 145, 47, 0.9);
}

.hover\\:bg-phrase-color-500\\/95:hover{
  background-color: rgba(209, 145, 47, 0.95);
}

.hover\\:bg-phrase-color-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(195, 120, 41, 1);
  background-color: rgba(195, 120, 41, var(--tw-bg-opacity, 1));
}

.hover\\:bg-phrase-color-600\\/0:hover{
  background-color: rgba(195, 120, 41, 0);
}

.hover\\:bg-phrase-color-600\\/10:hover{
  background-color: rgba(195, 120, 41, 0.1);
}

.hover\\:bg-phrase-color-600\\/100:hover{
  background-color: rgb(195, 120, 41);
}

.hover\\:bg-phrase-color-600\\/15:hover{
  background-color: rgba(195, 120, 41, 0.15);
}

.hover\\:bg-phrase-color-600\\/20:hover{
  background-color: rgba(195, 120, 41, 0.2);
}

.hover\\:bg-phrase-color-600\\/25:hover{
  background-color: rgba(195, 120, 41, 0.25);
}

.hover\\:bg-phrase-color-600\\/30:hover{
  background-color: rgba(195, 120, 41, 0.3);
}

.hover\\:bg-phrase-color-600\\/35:hover{
  background-color: rgba(195, 120, 41, 0.35);
}

.hover\\:bg-phrase-color-600\\/40:hover{
  background-color: rgba(195, 120, 41, 0.4);
}

.hover\\:bg-phrase-color-600\\/45:hover{
  background-color: rgba(195, 120, 41, 0.45);
}

.hover\\:bg-phrase-color-600\\/5:hover{
  background-color: rgba(195, 120, 41, 0.05);
}

.hover\\:bg-phrase-color-600\\/50:hover{
  background-color: rgba(195, 120, 41, 0.5);
}

.hover\\:bg-phrase-color-600\\/55:hover{
  background-color: rgba(195, 120, 41, 0.55);
}

.hover\\:bg-phrase-color-600\\/60:hover{
  background-color: rgba(195, 120, 41, 0.6);
}

.hover\\:bg-phrase-color-600\\/65:hover{
  background-color: rgba(195, 120, 41, 0.65);
}

.hover\\:bg-phrase-color-600\\/70:hover{
  background-color: rgba(195, 120, 41, 0.7);
}

.hover\\:bg-phrase-color-600\\/75:hover{
  background-color: rgba(195, 120, 41, 0.75);
}

.hover\\:bg-phrase-color-600\\/80:hover{
  background-color: rgba(195, 120, 41, 0.8);
}

.hover\\:bg-phrase-color-600\\/85:hover{
  background-color: rgba(195, 120, 41, 0.85);
}

.hover\\:bg-phrase-color-600\\/90:hover{
  background-color: rgba(195, 120, 41, 0.9);
}

.hover\\:bg-phrase-color-600\\/95:hover{
  background-color: rgba(195, 120, 41, 0.95);
}

.hover\\:bg-phrase-color-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(153, 84, 36, 1);
  background-color: rgba(153, 84, 36, var(--tw-bg-opacity, 1));
}

.hover\\:bg-phrase-color-700\\/0:hover{
  background-color: rgba(153, 84, 36, 0);
}

.hover\\:bg-phrase-color-700\\/10:hover{
  background-color: rgba(153, 84, 36, 0.1);
}

.hover\\:bg-phrase-color-700\\/100:hover{
  background-color: rgb(153, 84, 36);
}

.hover\\:bg-phrase-color-700\\/15:hover{
  background-color: rgba(153, 84, 36, 0.15);
}

.hover\\:bg-phrase-color-700\\/20:hover{
  background-color: rgba(153, 84, 36, 0.2);
}

.hover\\:bg-phrase-color-700\\/25:hover{
  background-color: rgba(153, 84, 36, 0.25);
}

.hover\\:bg-phrase-color-700\\/30:hover{
  background-color: rgba(153, 84, 36, 0.3);
}

.hover\\:bg-phrase-color-700\\/35:hover{
  background-color: rgba(153, 84, 36, 0.35);
}

.hover\\:bg-phrase-color-700\\/40:hover{
  background-color: rgba(153, 84, 36, 0.4);
}

.hover\\:bg-phrase-color-700\\/45:hover{
  background-color: rgba(153, 84, 36, 0.45);
}

.hover\\:bg-phrase-color-700\\/5:hover{
  background-color: rgba(153, 84, 36, 0.05);
}

.hover\\:bg-phrase-color-700\\/50:hover{
  background-color: rgba(153, 84, 36, 0.5);
}

.hover\\:bg-phrase-color-700\\/55:hover{
  background-color: rgba(153, 84, 36, 0.55);
}

.hover\\:bg-phrase-color-700\\/60:hover{
  background-color: rgba(153, 84, 36, 0.6);
}

.hover\\:bg-phrase-color-700\\/65:hover{
  background-color: rgba(153, 84, 36, 0.65);
}

.hover\\:bg-phrase-color-700\\/70:hover{
  background-color: rgba(153, 84, 36, 0.7);
}

.hover\\:bg-phrase-color-700\\/75:hover{
  background-color: rgba(153, 84, 36, 0.75);
}

.hover\\:bg-phrase-color-700\\/80:hover{
  background-color: rgba(153, 84, 36, 0.8);
}

.hover\\:bg-phrase-color-700\\/85:hover{
  background-color: rgba(153, 84, 36, 0.85);
}

.hover\\:bg-phrase-color-700\\/90:hover{
  background-color: rgba(153, 84, 36, 0.9);
}

.hover\\:bg-phrase-color-700\\/95:hover{
  background-color: rgba(153, 84, 36, 0.95);
}

.hover\\:bg-phrase-color-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(126, 67, 34, 1);
  background-color: rgba(126, 67, 34, var(--tw-bg-opacity, 1));
}

.hover\\:bg-phrase-color-800\\/0:hover{
  background-color: rgba(126, 67, 34, 0);
}

.hover\\:bg-phrase-color-800\\/10:hover{
  background-color: rgba(126, 67, 34, 0.1);
}

.hover\\:bg-phrase-color-800\\/100:hover{
  background-color: rgb(126, 67, 34);
}

.hover\\:bg-phrase-color-800\\/15:hover{
  background-color: rgba(126, 67, 34, 0.15);
}

.hover\\:bg-phrase-color-800\\/20:hover{
  background-color: rgba(126, 67, 34, 0.2);
}

.hover\\:bg-phrase-color-800\\/25:hover{
  background-color: rgba(126, 67, 34, 0.25);
}

.hover\\:bg-phrase-color-800\\/30:hover{
  background-color: rgba(126, 67, 34, 0.3);
}

.hover\\:bg-phrase-color-800\\/35:hover{
  background-color: rgba(126, 67, 34, 0.35);
}

.hover\\:bg-phrase-color-800\\/40:hover{
  background-color: rgba(126, 67, 34, 0.4);
}

.hover\\:bg-phrase-color-800\\/45:hover{
  background-color: rgba(126, 67, 34, 0.45);
}

.hover\\:bg-phrase-color-800\\/5:hover{
  background-color: rgba(126, 67, 34, 0.05);
}

.hover\\:bg-phrase-color-800\\/50:hover{
  background-color: rgba(126, 67, 34, 0.5);
}

.hover\\:bg-phrase-color-800\\/55:hover{
  background-color: rgba(126, 67, 34, 0.55);
}

.hover\\:bg-phrase-color-800\\/60:hover{
  background-color: rgba(126, 67, 34, 0.6);
}

.hover\\:bg-phrase-color-800\\/65:hover{
  background-color: rgba(126, 67, 34, 0.65);
}

.hover\\:bg-phrase-color-800\\/70:hover{
  background-color: rgba(126, 67, 34, 0.7);
}

.hover\\:bg-phrase-color-800\\/75:hover{
  background-color: rgba(126, 67, 34, 0.75);
}

.hover\\:bg-phrase-color-800\\/80:hover{
  background-color: rgba(126, 67, 34, 0.8);
}

.hover\\:bg-phrase-color-800\\/85:hover{
  background-color: rgba(126, 67, 34, 0.85);
}

.hover\\:bg-phrase-color-800\\/90:hover{
  background-color: rgba(126, 67, 34, 0.9);
}

.hover\\:bg-phrase-color-800\\/95:hover{
  background-color: rgba(126, 67, 34, 0.95);
}

.hover\\:bg-phrase-color-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(104, 56, 31, 1);
  background-color: rgba(104, 56, 31, var(--tw-bg-opacity, 1));
}

.hover\\:bg-phrase-color-900\\/0:hover{
  background-color: rgba(104, 56, 31, 0);
}

.hover\\:bg-phrase-color-900\\/10:hover{
  background-color: rgba(104, 56, 31, 0.1);
}

.hover\\:bg-phrase-color-900\\/100:hover{
  background-color: rgb(104, 56, 31);
}

.hover\\:bg-phrase-color-900\\/15:hover{
  background-color: rgba(104, 56, 31, 0.15);
}

.hover\\:bg-phrase-color-900\\/20:hover{
  background-color: rgba(104, 56, 31, 0.2);
}

.hover\\:bg-phrase-color-900\\/25:hover{
  background-color: rgba(104, 56, 31, 0.25);
}

.hover\\:bg-phrase-color-900\\/30:hover{
  background-color: rgba(104, 56, 31, 0.3);
}

.hover\\:bg-phrase-color-900\\/35:hover{
  background-color: rgba(104, 56, 31, 0.35);
}

.hover\\:bg-phrase-color-900\\/40:hover{
  background-color: rgba(104, 56, 31, 0.4);
}

.hover\\:bg-phrase-color-900\\/45:hover{
  background-color: rgba(104, 56, 31, 0.45);
}

.hover\\:bg-phrase-color-900\\/5:hover{
  background-color: rgba(104, 56, 31, 0.05);
}

.hover\\:bg-phrase-color-900\\/50:hover{
  background-color: rgba(104, 56, 31, 0.5);
}

.hover\\:bg-phrase-color-900\\/55:hover{
  background-color: rgba(104, 56, 31, 0.55);
}

.hover\\:bg-phrase-color-900\\/60:hover{
  background-color: rgba(104, 56, 31, 0.6);
}

.hover\\:bg-phrase-color-900\\/65:hover{
  background-color: rgba(104, 56, 31, 0.65);
}

.hover\\:bg-phrase-color-900\\/70:hover{
  background-color: rgba(104, 56, 31, 0.7);
}

.hover\\:bg-phrase-color-900\\/75:hover{
  background-color: rgba(104, 56, 31, 0.75);
}

.hover\\:bg-phrase-color-900\\/80:hover{
  background-color: rgba(104, 56, 31, 0.8);
}

.hover\\:bg-phrase-color-900\\/85:hover{
  background-color: rgba(104, 56, 31, 0.85);
}

.hover\\:bg-phrase-color-900\\/90:hover{
  background-color: rgba(104, 56, 31, 0.9);
}

.hover\\:bg-phrase-color-900\\/95:hover{
  background-color: rgba(104, 56, 31, 0.95);
}

.hover\\:bg-phrase-color-950:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(59, 28, 13, 1);
  background-color: rgba(59, 28, 13, var(--tw-bg-opacity, 1));
}

.hover\\:bg-phrase-color-950\\/0:hover{
  background-color: rgba(59, 28, 13, 0);
}

.hover\\:bg-phrase-color-950\\/10:hover{
  background-color: rgba(59, 28, 13, 0.1);
}

.hover\\:bg-phrase-color-950\\/100:hover{
  background-color: rgb(59, 28, 13);
}

.hover\\:bg-phrase-color-950\\/15:hover{
  background-color: rgba(59, 28, 13, 0.15);
}

.hover\\:bg-phrase-color-950\\/20:hover{
  background-color: rgba(59, 28, 13, 0.2);
}

.hover\\:bg-phrase-color-950\\/25:hover{
  background-color: rgba(59, 28, 13, 0.25);
}

.hover\\:bg-phrase-color-950\\/30:hover{
  background-color: rgba(59, 28, 13, 0.3);
}

.hover\\:bg-phrase-color-950\\/35:hover{
  background-color: rgba(59, 28, 13, 0.35);
}

.hover\\:bg-phrase-color-950\\/40:hover{
  background-color: rgba(59, 28, 13, 0.4);
}

.hover\\:bg-phrase-color-950\\/45:hover{
  background-color: rgba(59, 28, 13, 0.45);
}

.hover\\:bg-phrase-color-950\\/5:hover{
  background-color: rgba(59, 28, 13, 0.05);
}

.hover\\:bg-phrase-color-950\\/50:hover{
  background-color: rgba(59, 28, 13, 0.5);
}

.hover\\:bg-phrase-color-950\\/55:hover{
  background-color: rgba(59, 28, 13, 0.55);
}

.hover\\:bg-phrase-color-950\\/60:hover{
  background-color: rgba(59, 28, 13, 0.6);
}

.hover\\:bg-phrase-color-950\\/65:hover{
  background-color: rgba(59, 28, 13, 0.65);
}

.hover\\:bg-phrase-color-950\\/70:hover{
  background-color: rgba(59, 28, 13, 0.7);
}

.hover\\:bg-phrase-color-950\\/75:hover{
  background-color: rgba(59, 28, 13, 0.75);
}

.hover\\:bg-phrase-color-950\\/80:hover{
  background-color: rgba(59, 28, 13, 0.8);
}

.hover\\:bg-phrase-color-950\\/85:hover{
  background-color: rgba(59, 28, 13, 0.85);
}

.hover\\:bg-phrase-color-950\\/90:hover{
  background-color: rgba(59, 28, 13, 0.9);
}

.hover\\:bg-phrase-color-950\\/95:hover{
  background-color: rgba(59, 28, 13, 0.95);
}

.hover\\:bg-scarlet-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 220, 223, 1);
  background-color: rgba(255, 220, 223, var(--tw-bg-opacity, 1));
}

.hover\\:bg-scarlet-100\\/0:hover{
  background-color: rgba(255, 220, 223, 0);
}

.hover\\:bg-scarlet-100\\/10:hover{
  background-color: rgba(255, 220, 223, 0.1);
}

.hover\\:bg-scarlet-100\\/100:hover{
  background-color: rgb(255, 220, 223);
}

.hover\\:bg-scarlet-100\\/15:hover{
  background-color: rgba(255, 220, 223, 0.15);
}

.hover\\:bg-scarlet-100\\/20:hover{
  background-color: rgba(255, 220, 223, 0.2);
}

.hover\\:bg-scarlet-100\\/25:hover{
  background-color: rgba(255, 220, 223, 0.25);
}

.hover\\:bg-scarlet-100\\/30:hover{
  background-color: rgba(255, 220, 223, 0.3);
}

.hover\\:bg-scarlet-100\\/35:hover{
  background-color: rgba(255, 220, 223, 0.35);
}

.hover\\:bg-scarlet-100\\/40:hover{
  background-color: rgba(255, 220, 223, 0.4);
}

.hover\\:bg-scarlet-100\\/45:hover{
  background-color: rgba(255, 220, 223, 0.45);
}

.hover\\:bg-scarlet-100\\/5:hover{
  background-color: rgba(255, 220, 223, 0.05);
}

.hover\\:bg-scarlet-100\\/50:hover{
  background-color: rgba(255, 220, 223, 0.5);
}

.hover\\:bg-scarlet-100\\/55:hover{
  background-color: rgba(255, 220, 223, 0.55);
}

.hover\\:bg-scarlet-100\\/60:hover{
  background-color: rgba(255, 220, 223, 0.6);
}

.hover\\:bg-scarlet-100\\/65:hover{
  background-color: rgba(255, 220, 223, 0.65);
}

.hover\\:bg-scarlet-100\\/70:hover{
  background-color: rgba(255, 220, 223, 0.7);
}

.hover\\:bg-scarlet-100\\/75:hover{
  background-color: rgba(255, 220, 223, 0.75);
}

.hover\\:bg-scarlet-100\\/80:hover{
  background-color: rgba(255, 220, 223, 0.8);
}

.hover\\:bg-scarlet-100\\/85:hover{
  background-color: rgba(255, 220, 223, 0.85);
}

.hover\\:bg-scarlet-100\\/90:hover{
  background-color: rgba(255, 220, 223, 0.9);
}

.hover\\:bg-scarlet-100\\/95:hover{
  background-color: rgba(255, 220, 223, 0.95);
}

.hover\\:bg-scarlet-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 192, 198, 1);
  background-color: rgba(255, 192, 198, var(--tw-bg-opacity, 1));
}

.hover\\:bg-scarlet-200\\/0:hover{
  background-color: rgba(255, 192, 198, 0);
}

.hover\\:bg-scarlet-200\\/10:hover{
  background-color: rgba(255, 192, 198, 0.1);
}

.hover\\:bg-scarlet-200\\/100:hover{
  background-color: rgb(255, 192, 198);
}

.hover\\:bg-scarlet-200\\/15:hover{
  background-color: rgba(255, 192, 198, 0.15);
}

.hover\\:bg-scarlet-200\\/20:hover{
  background-color: rgba(255, 192, 198, 0.2);
}

.hover\\:bg-scarlet-200\\/25:hover{
  background-color: rgba(255, 192, 198, 0.25);
}

.hover\\:bg-scarlet-200\\/30:hover{
  background-color: rgba(255, 192, 198, 0.3);
}

.hover\\:bg-scarlet-200\\/35:hover{
  background-color: rgba(255, 192, 198, 0.35);
}

.hover\\:bg-scarlet-200\\/40:hover{
  background-color: rgba(255, 192, 198, 0.4);
}

.hover\\:bg-scarlet-200\\/45:hover{
  background-color: rgba(255, 192, 198, 0.45);
}

.hover\\:bg-scarlet-200\\/5:hover{
  background-color: rgba(255, 192, 198, 0.05);
}

.hover\\:bg-scarlet-200\\/50:hover{
  background-color: rgba(255, 192, 198, 0.5);
}

.hover\\:bg-scarlet-200\\/55:hover{
  background-color: rgba(255, 192, 198, 0.55);
}

.hover\\:bg-scarlet-200\\/60:hover{
  background-color: rgba(255, 192, 198, 0.6);
}

.hover\\:bg-scarlet-200\\/65:hover{
  background-color: rgba(255, 192, 198, 0.65);
}

.hover\\:bg-scarlet-200\\/70:hover{
  background-color: rgba(255, 192, 198, 0.7);
}

.hover\\:bg-scarlet-200\\/75:hover{
  background-color: rgba(255, 192, 198, 0.75);
}

.hover\\:bg-scarlet-200\\/80:hover{
  background-color: rgba(255, 192, 198, 0.8);
}

.hover\\:bg-scarlet-200\\/85:hover{
  background-color: rgba(255, 192, 198, 0.85);
}

.hover\\:bg-scarlet-200\\/90:hover{
  background-color: rgba(255, 192, 198, 0.9);
}

.hover\\:bg-scarlet-200\\/95:hover{
  background-color: rgba(255, 192, 198, 0.95);
}

.hover\\:bg-scarlet-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 148, 158, 1);
  background-color: rgba(255, 148, 158, var(--tw-bg-opacity, 1));
}

.hover\\:bg-scarlet-300\\/0:hover{
  background-color: rgba(255, 148, 158, 0);
}

.hover\\:bg-scarlet-300\\/10:hover{
  background-color: rgba(255, 148, 158, 0.1);
}

.hover\\:bg-scarlet-300\\/100:hover{
  background-color: rgb(255, 148, 158);
}

.hover\\:bg-scarlet-300\\/15:hover{
  background-color: rgba(255, 148, 158, 0.15);
}

.hover\\:bg-scarlet-300\\/20:hover{
  background-color: rgba(255, 148, 158, 0.2);
}

.hover\\:bg-scarlet-300\\/25:hover{
  background-color: rgba(255, 148, 158, 0.25);
}

.hover\\:bg-scarlet-300\\/30:hover{
  background-color: rgba(255, 148, 158, 0.3);
}

.hover\\:bg-scarlet-300\\/35:hover{
  background-color: rgba(255, 148, 158, 0.35);
}

.hover\\:bg-scarlet-300\\/40:hover{
  background-color: rgba(255, 148, 158, 0.4);
}

.hover\\:bg-scarlet-300\\/45:hover{
  background-color: rgba(255, 148, 158, 0.45);
}

.hover\\:bg-scarlet-300\\/5:hover{
  background-color: rgba(255, 148, 158, 0.05);
}

.hover\\:bg-scarlet-300\\/50:hover{
  background-color: rgba(255, 148, 158, 0.5);
}

.hover\\:bg-scarlet-300\\/55:hover{
  background-color: rgba(255, 148, 158, 0.55);
}

.hover\\:bg-scarlet-300\\/60:hover{
  background-color: rgba(255, 148, 158, 0.6);
}

.hover\\:bg-scarlet-300\\/65:hover{
  background-color: rgba(255, 148, 158, 0.65);
}

.hover\\:bg-scarlet-300\\/70:hover{
  background-color: rgba(255, 148, 158, 0.7);
}

.hover\\:bg-scarlet-300\\/75:hover{
  background-color: rgba(255, 148, 158, 0.75);
}

.hover\\:bg-scarlet-300\\/80:hover{
  background-color: rgba(255, 148, 158, 0.8);
}

.hover\\:bg-scarlet-300\\/85:hover{
  background-color: rgba(255, 148, 158, 0.85);
}

.hover\\:bg-scarlet-300\\/90:hover{
  background-color: rgba(255, 148, 158, 0.9);
}

.hover\\:bg-scarlet-300\\/95:hover{
  background-color: rgba(255, 148, 158, 0.95);
}

.hover\\:bg-scarlet-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 86, 101, 1);
  background-color: rgba(255, 86, 101, var(--tw-bg-opacity, 1));
}

.hover\\:bg-scarlet-400\\/0:hover{
  background-color: rgba(255, 86, 101, 0);
}

.hover\\:bg-scarlet-400\\/10:hover{
  background-color: rgba(255, 86, 101, 0.1);
}

.hover\\:bg-scarlet-400\\/100:hover{
  background-color: rgb(255, 86, 101);
}

.hover\\:bg-scarlet-400\\/15:hover{
  background-color: rgba(255, 86, 101, 0.15);
}

.hover\\:bg-scarlet-400\\/20:hover{
  background-color: rgba(255, 86, 101, 0.2);
}

.hover\\:bg-scarlet-400\\/25:hover{
  background-color: rgba(255, 86, 101, 0.25);
}

.hover\\:bg-scarlet-400\\/30:hover{
  background-color: rgba(255, 86, 101, 0.3);
}

.hover\\:bg-scarlet-400\\/35:hover{
  background-color: rgba(255, 86, 101, 0.35);
}

.hover\\:bg-scarlet-400\\/40:hover{
  background-color: rgba(255, 86, 101, 0.4);
}

.hover\\:bg-scarlet-400\\/45:hover{
  background-color: rgba(255, 86, 101, 0.45);
}

.hover\\:bg-scarlet-400\\/5:hover{
  background-color: rgba(255, 86, 101, 0.05);
}

.hover\\:bg-scarlet-400\\/50:hover{
  background-color: rgba(255, 86, 101, 0.5);
}

.hover\\:bg-scarlet-400\\/55:hover{
  background-color: rgba(255, 86, 101, 0.55);
}

.hover\\:bg-scarlet-400\\/60:hover{
  background-color: rgba(255, 86, 101, 0.6);
}

.hover\\:bg-scarlet-400\\/65:hover{
  background-color: rgba(255, 86, 101, 0.65);
}

.hover\\:bg-scarlet-400\\/70:hover{
  background-color: rgba(255, 86, 101, 0.7);
}

.hover\\:bg-scarlet-400\\/75:hover{
  background-color: rgba(255, 86, 101, 0.75);
}

.hover\\:bg-scarlet-400\\/80:hover{
  background-color: rgba(255, 86, 101, 0.8);
}

.hover\\:bg-scarlet-400\\/85:hover{
  background-color: rgba(255, 86, 101, 0.85);
}

.hover\\:bg-scarlet-400\\/90:hover{
  background-color: rgba(255, 86, 101, 0.9);
}

.hover\\:bg-scarlet-400\\/95:hover{
  background-color: rgba(255, 86, 101, 0.95);
}

.hover\\:bg-scarlet-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 34, 54, 1);
  background-color: rgba(255, 34, 54, var(--tw-bg-opacity, 1));
}

.hover\\:bg-scarlet-500\\/0:hover{
  background-color: rgba(255, 34, 54, 0);
}

.hover\\:bg-scarlet-500\\/10:hover{
  background-color: rgba(255, 34, 54, 0.1);
}

.hover\\:bg-scarlet-500\\/100:hover{
  background-color: rgb(255, 34, 54);
}

.hover\\:bg-scarlet-500\\/15:hover{
  background-color: rgba(255, 34, 54, 0.15);
}

.hover\\:bg-scarlet-500\\/20:hover{
  background-color: rgba(255, 34, 54, 0.2);
}

.hover\\:bg-scarlet-500\\/25:hover{
  background-color: rgba(255, 34, 54, 0.25);
}

.hover\\:bg-scarlet-500\\/30:hover{
  background-color: rgba(255, 34, 54, 0.3);
}

.hover\\:bg-scarlet-500\\/35:hover{
  background-color: rgba(255, 34, 54, 0.35);
}

.hover\\:bg-scarlet-500\\/40:hover{
  background-color: rgba(255, 34, 54, 0.4);
}

.hover\\:bg-scarlet-500\\/45:hover{
  background-color: rgba(255, 34, 54, 0.45);
}

.hover\\:bg-scarlet-500\\/5:hover{
  background-color: rgba(255, 34, 54, 0.05);
}

.hover\\:bg-scarlet-500\\/50:hover{
  background-color: rgba(255, 34, 54, 0.5);
}

.hover\\:bg-scarlet-500\\/55:hover{
  background-color: rgba(255, 34, 54, 0.55);
}

.hover\\:bg-scarlet-500\\/60:hover{
  background-color: rgba(255, 34, 54, 0.6);
}

.hover\\:bg-scarlet-500\\/65:hover{
  background-color: rgba(255, 34, 54, 0.65);
}

.hover\\:bg-scarlet-500\\/70:hover{
  background-color: rgba(255, 34, 54, 0.7);
}

.hover\\:bg-scarlet-500\\/75:hover{
  background-color: rgba(255, 34, 54, 0.75);
}

.hover\\:bg-scarlet-500\\/80:hover{
  background-color: rgba(255, 34, 54, 0.8);
}

.hover\\:bg-scarlet-500\\/85:hover{
  background-color: rgba(255, 34, 54, 0.85);
}

.hover\\:bg-scarlet-500\\/90:hover{
  background-color: rgba(255, 34, 54, 0.9);
}

.hover\\:bg-scarlet-500\\/95:hover{
  background-color: rgba(255, 34, 54, 0.95);
}

.hover\\:bg-scarlet-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 2, 25, 1);
  background-color: rgba(255, 2, 25, var(--tw-bg-opacity, 1));
}

.hover\\:bg-scarlet-600\\/0:hover{
  background-color: rgba(255, 2, 25, 0);
}

.hover\\:bg-scarlet-600\\/10:hover{
  background-color: rgba(255, 2, 25, 0.1);
}

.hover\\:bg-scarlet-600\\/100:hover{
  background-color: rgb(255, 2, 25);
}

.hover\\:bg-scarlet-600\\/15:hover{
  background-color: rgba(255, 2, 25, 0.15);
}

.hover\\:bg-scarlet-600\\/20:hover{
  background-color: rgba(255, 2, 25, 0.2);
}

.hover\\:bg-scarlet-600\\/25:hover{
  background-color: rgba(255, 2, 25, 0.25);
}

.hover\\:bg-scarlet-600\\/30:hover{
  background-color: rgba(255, 2, 25, 0.3);
}

.hover\\:bg-scarlet-600\\/35:hover{
  background-color: rgba(255, 2, 25, 0.35);
}

.hover\\:bg-scarlet-600\\/40:hover{
  background-color: rgba(255, 2, 25, 0.4);
}

.hover\\:bg-scarlet-600\\/45:hover{
  background-color: rgba(255, 2, 25, 0.45);
}

.hover\\:bg-scarlet-600\\/5:hover{
  background-color: rgba(255, 2, 25, 0.05);
}

.hover\\:bg-scarlet-600\\/50:hover{
  background-color: rgba(255, 2, 25, 0.5);
}

.hover\\:bg-scarlet-600\\/55:hover{
  background-color: rgba(255, 2, 25, 0.55);
}

.hover\\:bg-scarlet-600\\/60:hover{
  background-color: rgba(255, 2, 25, 0.6);
}

.hover\\:bg-scarlet-600\\/65:hover{
  background-color: rgba(255, 2, 25, 0.65);
}

.hover\\:bg-scarlet-600\\/70:hover{
  background-color: rgba(255, 2, 25, 0.7);
}

.hover\\:bg-scarlet-600\\/75:hover{
  background-color: rgba(255, 2, 25, 0.75);
}

.hover\\:bg-scarlet-600\\/80:hover{
  background-color: rgba(255, 2, 25, 0.8);
}

.hover\\:bg-scarlet-600\\/85:hover{
  background-color: rgba(255, 2, 25, 0.85);
}

.hover\\:bg-scarlet-600\\/90:hover{
  background-color: rgba(255, 2, 25, 0.9);
}

.hover\\:bg-scarlet-600\\/95:hover{
  background-color: rgba(255, 2, 25, 0.95);
}

.hover\\:bg-scarlet-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(216, 0, 19, 1);
  background-color: rgba(216, 0, 19, var(--tw-bg-opacity, 1));
}

.hover\\:bg-scarlet-700\\/0:hover{
  background-color: rgba(216, 0, 19, 0);
}

.hover\\:bg-scarlet-700\\/10:hover{
  background-color: rgba(216, 0, 19, 0.1);
}

.hover\\:bg-scarlet-700\\/100:hover{
  background-color: rgb(216, 0, 19);
}

.hover\\:bg-scarlet-700\\/15:hover{
  background-color: rgba(216, 0, 19, 0.15);
}

.hover\\:bg-scarlet-700\\/20:hover{
  background-color: rgba(216, 0, 19, 0.2);
}

.hover\\:bg-scarlet-700\\/25:hover{
  background-color: rgba(216, 0, 19, 0.25);
}

.hover\\:bg-scarlet-700\\/30:hover{
  background-color: rgba(216, 0, 19, 0.3);
}

.hover\\:bg-scarlet-700\\/35:hover{
  background-color: rgba(216, 0, 19, 0.35);
}

.hover\\:bg-scarlet-700\\/40:hover{
  background-color: rgba(216, 0, 19, 0.4);
}

.hover\\:bg-scarlet-700\\/45:hover{
  background-color: rgba(216, 0, 19, 0.45);
}

.hover\\:bg-scarlet-700\\/5:hover{
  background-color: rgba(216, 0, 19, 0.05);
}

.hover\\:bg-scarlet-700\\/50:hover{
  background-color: rgba(216, 0, 19, 0.5);
}

.hover\\:bg-scarlet-700\\/55:hover{
  background-color: rgba(216, 0, 19, 0.55);
}

.hover\\:bg-scarlet-700\\/60:hover{
  background-color: rgba(216, 0, 19, 0.6);
}

.hover\\:bg-scarlet-700\\/65:hover{
  background-color: rgba(216, 0, 19, 0.65);
}

.hover\\:bg-scarlet-700\\/70:hover{
  background-color: rgba(216, 0, 19, 0.7);
}

.hover\\:bg-scarlet-700\\/75:hover{
  background-color: rgba(216, 0, 19, 0.75);
}

.hover\\:bg-scarlet-700\\/80:hover{
  background-color: rgba(216, 0, 19, 0.8);
}

.hover\\:bg-scarlet-700\\/85:hover{
  background-color: rgba(216, 0, 19, 0.85);
}

.hover\\:bg-scarlet-700\\/90:hover{
  background-color: rgba(216, 0, 19, 0.9);
}

.hover\\:bg-scarlet-700\\/95:hover{
  background-color: rgba(216, 0, 19, 0.95);
}

.hover\\:bg-scarlet-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(180, 2, 18, 1);
  background-color: rgba(180, 2, 18, var(--tw-bg-opacity, 1));
}

.hover\\:bg-scarlet-800\\/0:hover{
  background-color: rgba(180, 2, 18, 0);
}

.hover\\:bg-scarlet-800\\/10:hover{
  background-color: rgba(180, 2, 18, 0.1);
}

.hover\\:bg-scarlet-800\\/100:hover{
  background-color: rgb(180, 2, 18);
}

.hover\\:bg-scarlet-800\\/15:hover{
  background-color: rgba(180, 2, 18, 0.15);
}

.hover\\:bg-scarlet-800\\/20:hover{
  background-color: rgba(180, 2, 18, 0.2);
}

.hover\\:bg-scarlet-800\\/25:hover{
  background-color: rgba(180, 2, 18, 0.25);
}

.hover\\:bg-scarlet-800\\/30:hover{
  background-color: rgba(180, 2, 18, 0.3);
}

.hover\\:bg-scarlet-800\\/35:hover{
  background-color: rgba(180, 2, 18, 0.35);
}

.hover\\:bg-scarlet-800\\/40:hover{
  background-color: rgba(180, 2, 18, 0.4);
}

.hover\\:bg-scarlet-800\\/45:hover{
  background-color: rgba(180, 2, 18, 0.45);
}

.hover\\:bg-scarlet-800\\/5:hover{
  background-color: rgba(180, 2, 18, 0.05);
}

.hover\\:bg-scarlet-800\\/50:hover{
  background-color: rgba(180, 2, 18, 0.5);
}

.hover\\:bg-scarlet-800\\/55:hover{
  background-color: rgba(180, 2, 18, 0.55);
}

.hover\\:bg-scarlet-800\\/60:hover{
  background-color: rgba(180, 2, 18, 0.6);
}

.hover\\:bg-scarlet-800\\/65:hover{
  background-color: rgba(180, 2, 18, 0.65);
}

.hover\\:bg-scarlet-800\\/70:hover{
  background-color: rgba(180, 2, 18, 0.7);
}

.hover\\:bg-scarlet-800\\/75:hover{
  background-color: rgba(180, 2, 18, 0.75);
}

.hover\\:bg-scarlet-800\\/80:hover{
  background-color: rgba(180, 2, 18, 0.8);
}

.hover\\:bg-scarlet-800\\/85:hover{
  background-color: rgba(180, 2, 18, 0.85);
}

.hover\\:bg-scarlet-800\\/90:hover{
  background-color: rgba(180, 2, 18, 0.9);
}

.hover\\:bg-scarlet-800\\/95:hover{
  background-color: rgba(180, 2, 18, 0.95);
}

.hover\\:bg-scarlet-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(146, 10, 22, 1);
  background-color: rgba(146, 10, 22, var(--tw-bg-opacity, 1));
}

.hover\\:bg-scarlet-900\\/0:hover{
  background-color: rgba(146, 10, 22, 0);
}

.hover\\:bg-scarlet-900\\/10:hover{
  background-color: rgba(146, 10, 22, 0.1);
}

.hover\\:bg-scarlet-900\\/100:hover{
  background-color: rgb(146, 10, 22);
}

.hover\\:bg-scarlet-900\\/15:hover{
  background-color: rgba(146, 10, 22, 0.15);
}

.hover\\:bg-scarlet-900\\/20:hover{
  background-color: rgba(146, 10, 22, 0.2);
}

.hover\\:bg-scarlet-900\\/25:hover{
  background-color: rgba(146, 10, 22, 0.25);
}

.hover\\:bg-scarlet-900\\/30:hover{
  background-color: rgba(146, 10, 22, 0.3);
}

.hover\\:bg-scarlet-900\\/35:hover{
  background-color: rgba(146, 10, 22, 0.35);
}

.hover\\:bg-scarlet-900\\/40:hover{
  background-color: rgba(146, 10, 22, 0.4);
}

.hover\\:bg-scarlet-900\\/45:hover{
  background-color: rgba(146, 10, 22, 0.45);
}

.hover\\:bg-scarlet-900\\/5:hover{
  background-color: rgba(146, 10, 22, 0.05);
}

.hover\\:bg-scarlet-900\\/50:hover{
  background-color: rgba(146, 10, 22, 0.5);
}

.hover\\:bg-scarlet-900\\/55:hover{
  background-color: rgba(146, 10, 22, 0.55);
}

.hover\\:bg-scarlet-900\\/60:hover{
  background-color: rgba(146, 10, 22, 0.6);
}

.hover\\:bg-scarlet-900\\/65:hover{
  background-color: rgba(146, 10, 22, 0.65);
}

.hover\\:bg-scarlet-900\\/70:hover{
  background-color: rgba(146, 10, 22, 0.7);
}

.hover\\:bg-scarlet-900\\/75:hover{
  background-color: rgba(146, 10, 22, 0.75);
}

.hover\\:bg-scarlet-900\\/80:hover{
  background-color: rgba(146, 10, 22, 0.8);
}

.hover\\:bg-scarlet-900\\/85:hover{
  background-color: rgba(146, 10, 22, 0.85);
}

.hover\\:bg-scarlet-900\\/90:hover{
  background-color: rgba(146, 10, 22, 0.9);
}

.hover\\:bg-scarlet-900\\/95:hover{
  background-color: rgba(146, 10, 22, 0.95);
}

.hover\\:bg-scarlet-950:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(81, 0, 7, 1);
  background-color: rgba(81, 0, 7, var(--tw-bg-opacity, 1));
}

.hover\\:bg-scarlet-950\\/0:hover{
  background-color: rgba(81, 0, 7, 0);
}

.hover\\:bg-scarlet-950\\/10:hover{
  background-color: rgba(81, 0, 7, 0.1);
}

.hover\\:bg-scarlet-950\\/100:hover{
  background-color: rgb(81, 0, 7);
}

.hover\\:bg-scarlet-950\\/15:hover{
  background-color: rgba(81, 0, 7, 0.15);
}

.hover\\:bg-scarlet-950\\/20:hover{
  background-color: rgba(81, 0, 7, 0.2);
}

.hover\\:bg-scarlet-950\\/25:hover{
  background-color: rgba(81, 0, 7, 0.25);
}

.hover\\:bg-scarlet-950\\/30:hover{
  background-color: rgba(81, 0, 7, 0.3);
}

.hover\\:bg-scarlet-950\\/35:hover{
  background-color: rgba(81, 0, 7, 0.35);
}

.hover\\:bg-scarlet-950\\/40:hover{
  background-color: rgba(81, 0, 7, 0.4);
}

.hover\\:bg-scarlet-950\\/45:hover{
  background-color: rgba(81, 0, 7, 0.45);
}

.hover\\:bg-scarlet-950\\/5:hover{
  background-color: rgba(81, 0, 7, 0.05);
}

.hover\\:bg-scarlet-950\\/50:hover{
  background-color: rgba(81, 0, 7, 0.5);
}

.hover\\:bg-scarlet-950\\/55:hover{
  background-color: rgba(81, 0, 7, 0.55);
}

.hover\\:bg-scarlet-950\\/60:hover{
  background-color: rgba(81, 0, 7, 0.6);
}

.hover\\:bg-scarlet-950\\/65:hover{
  background-color: rgba(81, 0, 7, 0.65);
}

.hover\\:bg-scarlet-950\\/70:hover{
  background-color: rgba(81, 0, 7, 0.7);
}

.hover\\:bg-scarlet-950\\/75:hover{
  background-color: rgba(81, 0, 7, 0.75);
}

.hover\\:bg-scarlet-950\\/80:hover{
  background-color: rgba(81, 0, 7, 0.8);
}

.hover\\:bg-scarlet-950\\/85:hover{
  background-color: rgba(81, 0, 7, 0.85);
}

.hover\\:bg-scarlet-950\\/90:hover{
  background-color: rgba(81, 0, 7, 0.9);
}

.hover\\:bg-scarlet-950\\/95:hover{
  background-color: rgba(81, 0, 7, 0.95);
}

.hover\\:bg-song-color-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 220, 223, 1);
  background-color: rgba(255, 220, 223, var(--tw-bg-opacity, 1));
}

.hover\\:bg-song-color-100\\/0:hover{
  background-color: rgba(255, 220, 223, 0);
}

.hover\\:bg-song-color-100\\/10:hover{
  background-color: rgba(255, 220, 223, 0.1);
}

.hover\\:bg-song-color-100\\/100:hover{
  background-color: rgb(255, 220, 223);
}

.hover\\:bg-song-color-100\\/15:hover{
  background-color: rgba(255, 220, 223, 0.15);
}

.hover\\:bg-song-color-100\\/20:hover{
  background-color: rgba(255, 220, 223, 0.2);
}

.hover\\:bg-song-color-100\\/25:hover{
  background-color: rgba(255, 220, 223, 0.25);
}

.hover\\:bg-song-color-100\\/30:hover{
  background-color: rgba(255, 220, 223, 0.3);
}

.hover\\:bg-song-color-100\\/35:hover{
  background-color: rgba(255, 220, 223, 0.35);
}

.hover\\:bg-song-color-100\\/40:hover{
  background-color: rgba(255, 220, 223, 0.4);
}

.hover\\:bg-song-color-100\\/45:hover{
  background-color: rgba(255, 220, 223, 0.45);
}

.hover\\:bg-song-color-100\\/5:hover{
  background-color: rgba(255, 220, 223, 0.05);
}

.hover\\:bg-song-color-100\\/50:hover{
  background-color: rgba(255, 220, 223, 0.5);
}

.hover\\:bg-song-color-100\\/55:hover{
  background-color: rgba(255, 220, 223, 0.55);
}

.hover\\:bg-song-color-100\\/60:hover{
  background-color: rgba(255, 220, 223, 0.6);
}

.hover\\:bg-song-color-100\\/65:hover{
  background-color: rgba(255, 220, 223, 0.65);
}

.hover\\:bg-song-color-100\\/70:hover{
  background-color: rgba(255, 220, 223, 0.7);
}

.hover\\:bg-song-color-100\\/75:hover{
  background-color: rgba(255, 220, 223, 0.75);
}

.hover\\:bg-song-color-100\\/80:hover{
  background-color: rgba(255, 220, 223, 0.8);
}

.hover\\:bg-song-color-100\\/85:hover{
  background-color: rgba(255, 220, 223, 0.85);
}

.hover\\:bg-song-color-100\\/90:hover{
  background-color: rgba(255, 220, 223, 0.9);
}

.hover\\:bg-song-color-100\\/95:hover{
  background-color: rgba(255, 220, 223, 0.95);
}

.hover\\:bg-song-color-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 192, 198, 1);
  background-color: rgba(255, 192, 198, var(--tw-bg-opacity, 1));
}

.hover\\:bg-song-color-200\\/0:hover{
  background-color: rgba(255, 192, 198, 0);
}

.hover\\:bg-song-color-200\\/10:hover{
  background-color: rgba(255, 192, 198, 0.1);
}

.hover\\:bg-song-color-200\\/100:hover{
  background-color: rgb(255, 192, 198);
}

.hover\\:bg-song-color-200\\/15:hover{
  background-color: rgba(255, 192, 198, 0.15);
}

.hover\\:bg-song-color-200\\/20:hover{
  background-color: rgba(255, 192, 198, 0.2);
}

.hover\\:bg-song-color-200\\/25:hover{
  background-color: rgba(255, 192, 198, 0.25);
}

.hover\\:bg-song-color-200\\/30:hover{
  background-color: rgba(255, 192, 198, 0.3);
}

.hover\\:bg-song-color-200\\/35:hover{
  background-color: rgba(255, 192, 198, 0.35);
}

.hover\\:bg-song-color-200\\/40:hover{
  background-color: rgba(255, 192, 198, 0.4);
}

.hover\\:bg-song-color-200\\/45:hover{
  background-color: rgba(255, 192, 198, 0.45);
}

.hover\\:bg-song-color-200\\/5:hover{
  background-color: rgba(255, 192, 198, 0.05);
}

.hover\\:bg-song-color-200\\/50:hover{
  background-color: rgba(255, 192, 198, 0.5);
}

.hover\\:bg-song-color-200\\/55:hover{
  background-color: rgba(255, 192, 198, 0.55);
}

.hover\\:bg-song-color-200\\/60:hover{
  background-color: rgba(255, 192, 198, 0.6);
}

.hover\\:bg-song-color-200\\/65:hover{
  background-color: rgba(255, 192, 198, 0.65);
}

.hover\\:bg-song-color-200\\/70:hover{
  background-color: rgba(255, 192, 198, 0.7);
}

.hover\\:bg-song-color-200\\/75:hover{
  background-color: rgba(255, 192, 198, 0.75);
}

.hover\\:bg-song-color-200\\/80:hover{
  background-color: rgba(255, 192, 198, 0.8);
}

.hover\\:bg-song-color-200\\/85:hover{
  background-color: rgba(255, 192, 198, 0.85);
}

.hover\\:bg-song-color-200\\/90:hover{
  background-color: rgba(255, 192, 198, 0.9);
}

.hover\\:bg-song-color-200\\/95:hover{
  background-color: rgba(255, 192, 198, 0.95);
}

.hover\\:bg-song-color-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 148, 158, 1);
  background-color: rgba(255, 148, 158, var(--tw-bg-opacity, 1));
}

.hover\\:bg-song-color-300\\/0:hover{
  background-color: rgba(255, 148, 158, 0);
}

.hover\\:bg-song-color-300\\/10:hover{
  background-color: rgba(255, 148, 158, 0.1);
}

.hover\\:bg-song-color-300\\/100:hover{
  background-color: rgb(255, 148, 158);
}

.hover\\:bg-song-color-300\\/15:hover{
  background-color: rgba(255, 148, 158, 0.15);
}

.hover\\:bg-song-color-300\\/20:hover{
  background-color: rgba(255, 148, 158, 0.2);
}

.hover\\:bg-song-color-300\\/25:hover{
  background-color: rgba(255, 148, 158, 0.25);
}

.hover\\:bg-song-color-300\\/30:hover{
  background-color: rgba(255, 148, 158, 0.3);
}

.hover\\:bg-song-color-300\\/35:hover{
  background-color: rgba(255, 148, 158, 0.35);
}

.hover\\:bg-song-color-300\\/40:hover{
  background-color: rgba(255, 148, 158, 0.4);
}

.hover\\:bg-song-color-300\\/45:hover{
  background-color: rgba(255, 148, 158, 0.45);
}

.hover\\:bg-song-color-300\\/5:hover{
  background-color: rgba(255, 148, 158, 0.05);
}

.hover\\:bg-song-color-300\\/50:hover{
  background-color: rgba(255, 148, 158, 0.5);
}

.hover\\:bg-song-color-300\\/55:hover{
  background-color: rgba(255, 148, 158, 0.55);
}

.hover\\:bg-song-color-300\\/60:hover{
  background-color: rgba(255, 148, 158, 0.6);
}

.hover\\:bg-song-color-300\\/65:hover{
  background-color: rgba(255, 148, 158, 0.65);
}

.hover\\:bg-song-color-300\\/70:hover{
  background-color: rgba(255, 148, 158, 0.7);
}

.hover\\:bg-song-color-300\\/75:hover{
  background-color: rgba(255, 148, 158, 0.75);
}

.hover\\:bg-song-color-300\\/80:hover{
  background-color: rgba(255, 148, 158, 0.8);
}

.hover\\:bg-song-color-300\\/85:hover{
  background-color: rgba(255, 148, 158, 0.85);
}

.hover\\:bg-song-color-300\\/90:hover{
  background-color: rgba(255, 148, 158, 0.9);
}

.hover\\:bg-song-color-300\\/95:hover{
  background-color: rgba(255, 148, 158, 0.95);
}

.hover\\:bg-song-color-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 86, 101, 1);
  background-color: rgba(255, 86, 101, var(--tw-bg-opacity, 1));
}

.hover\\:bg-song-color-400\\/0:hover{
  background-color: rgba(255, 86, 101, 0);
}

.hover\\:bg-song-color-400\\/10:hover{
  background-color: rgba(255, 86, 101, 0.1);
}

.hover\\:bg-song-color-400\\/100:hover{
  background-color: rgb(255, 86, 101);
}

.hover\\:bg-song-color-400\\/15:hover{
  background-color: rgba(255, 86, 101, 0.15);
}

.hover\\:bg-song-color-400\\/20:hover{
  background-color: rgba(255, 86, 101, 0.2);
}

.hover\\:bg-song-color-400\\/25:hover{
  background-color: rgba(255, 86, 101, 0.25);
}

.hover\\:bg-song-color-400\\/30:hover{
  background-color: rgba(255, 86, 101, 0.3);
}

.hover\\:bg-song-color-400\\/35:hover{
  background-color: rgba(255, 86, 101, 0.35);
}

.hover\\:bg-song-color-400\\/40:hover{
  background-color: rgba(255, 86, 101, 0.4);
}

.hover\\:bg-song-color-400\\/45:hover{
  background-color: rgba(255, 86, 101, 0.45);
}

.hover\\:bg-song-color-400\\/5:hover{
  background-color: rgba(255, 86, 101, 0.05);
}

.hover\\:bg-song-color-400\\/50:hover{
  background-color: rgba(255, 86, 101, 0.5);
}

.hover\\:bg-song-color-400\\/55:hover{
  background-color: rgba(255, 86, 101, 0.55);
}

.hover\\:bg-song-color-400\\/60:hover{
  background-color: rgba(255, 86, 101, 0.6);
}

.hover\\:bg-song-color-400\\/65:hover{
  background-color: rgba(255, 86, 101, 0.65);
}

.hover\\:bg-song-color-400\\/70:hover{
  background-color: rgba(255, 86, 101, 0.7);
}

.hover\\:bg-song-color-400\\/75:hover{
  background-color: rgba(255, 86, 101, 0.75);
}

.hover\\:bg-song-color-400\\/80:hover{
  background-color: rgba(255, 86, 101, 0.8);
}

.hover\\:bg-song-color-400\\/85:hover{
  background-color: rgba(255, 86, 101, 0.85);
}

.hover\\:bg-song-color-400\\/90:hover{
  background-color: rgba(255, 86, 101, 0.9);
}

.hover\\:bg-song-color-400\\/95:hover{
  background-color: rgba(255, 86, 101, 0.95);
}

.hover\\:bg-song-color-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 34, 54, 1);
  background-color: rgba(255, 34, 54, var(--tw-bg-opacity, 1));
}

.hover\\:bg-song-color-500\\/0:hover{
  background-color: rgba(255, 34, 54, 0);
}

.hover\\:bg-song-color-500\\/10:hover{
  background-color: rgba(255, 34, 54, 0.1);
}

.hover\\:bg-song-color-500\\/100:hover{
  background-color: rgb(255, 34, 54);
}

.hover\\:bg-song-color-500\\/15:hover{
  background-color: rgba(255, 34, 54, 0.15);
}

.hover\\:bg-song-color-500\\/20:hover{
  background-color: rgba(255, 34, 54, 0.2);
}

.hover\\:bg-song-color-500\\/25:hover{
  background-color: rgba(255, 34, 54, 0.25);
}

.hover\\:bg-song-color-500\\/30:hover{
  background-color: rgba(255, 34, 54, 0.3);
}

.hover\\:bg-song-color-500\\/35:hover{
  background-color: rgba(255, 34, 54, 0.35);
}

.hover\\:bg-song-color-500\\/40:hover{
  background-color: rgba(255, 34, 54, 0.4);
}

.hover\\:bg-song-color-500\\/45:hover{
  background-color: rgba(255, 34, 54, 0.45);
}

.hover\\:bg-song-color-500\\/5:hover{
  background-color: rgba(255, 34, 54, 0.05);
}

.hover\\:bg-song-color-500\\/50:hover{
  background-color: rgba(255, 34, 54, 0.5);
}

.hover\\:bg-song-color-500\\/55:hover{
  background-color: rgba(255, 34, 54, 0.55);
}

.hover\\:bg-song-color-500\\/60:hover{
  background-color: rgba(255, 34, 54, 0.6);
}

.hover\\:bg-song-color-500\\/65:hover{
  background-color: rgba(255, 34, 54, 0.65);
}

.hover\\:bg-song-color-500\\/70:hover{
  background-color: rgba(255, 34, 54, 0.7);
}

.hover\\:bg-song-color-500\\/75:hover{
  background-color: rgba(255, 34, 54, 0.75);
}

.hover\\:bg-song-color-500\\/80:hover{
  background-color: rgba(255, 34, 54, 0.8);
}

.hover\\:bg-song-color-500\\/85:hover{
  background-color: rgba(255, 34, 54, 0.85);
}

.hover\\:bg-song-color-500\\/90:hover{
  background-color: rgba(255, 34, 54, 0.9);
}

.hover\\:bg-song-color-500\\/95:hover{
  background-color: rgba(255, 34, 54, 0.95);
}

.hover\\:bg-song-color-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 2, 25, 1);
  background-color: rgba(255, 2, 25, var(--tw-bg-opacity, 1));
}

.hover\\:bg-song-color-600\\/0:hover{
  background-color: rgba(255, 2, 25, 0);
}

.hover\\:bg-song-color-600\\/10:hover{
  background-color: rgba(255, 2, 25, 0.1);
}

.hover\\:bg-song-color-600\\/100:hover{
  background-color: rgb(255, 2, 25);
}

.hover\\:bg-song-color-600\\/15:hover{
  background-color: rgba(255, 2, 25, 0.15);
}

.hover\\:bg-song-color-600\\/20:hover{
  background-color: rgba(255, 2, 25, 0.2);
}

.hover\\:bg-song-color-600\\/25:hover{
  background-color: rgba(255, 2, 25, 0.25);
}

.hover\\:bg-song-color-600\\/30:hover{
  background-color: rgba(255, 2, 25, 0.3);
}

.hover\\:bg-song-color-600\\/35:hover{
  background-color: rgba(255, 2, 25, 0.35);
}

.hover\\:bg-song-color-600\\/40:hover{
  background-color: rgba(255, 2, 25, 0.4);
}

.hover\\:bg-song-color-600\\/45:hover{
  background-color: rgba(255, 2, 25, 0.45);
}

.hover\\:bg-song-color-600\\/5:hover{
  background-color: rgba(255, 2, 25, 0.05);
}

.hover\\:bg-song-color-600\\/50:hover{
  background-color: rgba(255, 2, 25, 0.5);
}

.hover\\:bg-song-color-600\\/55:hover{
  background-color: rgba(255, 2, 25, 0.55);
}

.hover\\:bg-song-color-600\\/60:hover{
  background-color: rgba(255, 2, 25, 0.6);
}

.hover\\:bg-song-color-600\\/65:hover{
  background-color: rgba(255, 2, 25, 0.65);
}

.hover\\:bg-song-color-600\\/70:hover{
  background-color: rgba(255, 2, 25, 0.7);
}

.hover\\:bg-song-color-600\\/75:hover{
  background-color: rgba(255, 2, 25, 0.75);
}

.hover\\:bg-song-color-600\\/80:hover{
  background-color: rgba(255, 2, 25, 0.8);
}

.hover\\:bg-song-color-600\\/85:hover{
  background-color: rgba(255, 2, 25, 0.85);
}

.hover\\:bg-song-color-600\\/90:hover{
  background-color: rgba(255, 2, 25, 0.9);
}

.hover\\:bg-song-color-600\\/95:hover{
  background-color: rgba(255, 2, 25, 0.95);
}

.hover\\:bg-song-color-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(216, 0, 19, 1);
  background-color: rgba(216, 0, 19, var(--tw-bg-opacity, 1));
}

.hover\\:bg-song-color-700\\/0:hover{
  background-color: rgba(216, 0, 19, 0);
}

.hover\\:bg-song-color-700\\/10:hover{
  background-color: rgba(216, 0, 19, 0.1);
}

.hover\\:bg-song-color-700\\/100:hover{
  background-color: rgb(216, 0, 19);
}

.hover\\:bg-song-color-700\\/15:hover{
  background-color: rgba(216, 0, 19, 0.15);
}

.hover\\:bg-song-color-700\\/20:hover{
  background-color: rgba(216, 0, 19, 0.2);
}

.hover\\:bg-song-color-700\\/25:hover{
  background-color: rgba(216, 0, 19, 0.25);
}

.hover\\:bg-song-color-700\\/30:hover{
  background-color: rgba(216, 0, 19, 0.3);
}

.hover\\:bg-song-color-700\\/35:hover{
  background-color: rgba(216, 0, 19, 0.35);
}

.hover\\:bg-song-color-700\\/40:hover{
  background-color: rgba(216, 0, 19, 0.4);
}

.hover\\:bg-song-color-700\\/45:hover{
  background-color: rgba(216, 0, 19, 0.45);
}

.hover\\:bg-song-color-700\\/5:hover{
  background-color: rgba(216, 0, 19, 0.05);
}

.hover\\:bg-song-color-700\\/50:hover{
  background-color: rgba(216, 0, 19, 0.5);
}

.hover\\:bg-song-color-700\\/55:hover{
  background-color: rgba(216, 0, 19, 0.55);
}

.hover\\:bg-song-color-700\\/60:hover{
  background-color: rgba(216, 0, 19, 0.6);
}

.hover\\:bg-song-color-700\\/65:hover{
  background-color: rgba(216, 0, 19, 0.65);
}

.hover\\:bg-song-color-700\\/70:hover{
  background-color: rgba(216, 0, 19, 0.7);
}

.hover\\:bg-song-color-700\\/75:hover{
  background-color: rgba(216, 0, 19, 0.75);
}

.hover\\:bg-song-color-700\\/80:hover{
  background-color: rgba(216, 0, 19, 0.8);
}

.hover\\:bg-song-color-700\\/85:hover{
  background-color: rgba(216, 0, 19, 0.85);
}

.hover\\:bg-song-color-700\\/90:hover{
  background-color: rgba(216, 0, 19, 0.9);
}

.hover\\:bg-song-color-700\\/95:hover{
  background-color: rgba(216, 0, 19, 0.95);
}

.hover\\:bg-song-color-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(180, 2, 18, 1);
  background-color: rgba(180, 2, 18, var(--tw-bg-opacity, 1));
}

.hover\\:bg-song-color-800\\/0:hover{
  background-color: rgba(180, 2, 18, 0);
}

.hover\\:bg-song-color-800\\/10:hover{
  background-color: rgba(180, 2, 18, 0.1);
}

.hover\\:bg-song-color-800\\/100:hover{
  background-color: rgb(180, 2, 18);
}

.hover\\:bg-song-color-800\\/15:hover{
  background-color: rgba(180, 2, 18, 0.15);
}

.hover\\:bg-song-color-800\\/20:hover{
  background-color: rgba(180, 2, 18, 0.2);
}

.hover\\:bg-song-color-800\\/25:hover{
  background-color: rgba(180, 2, 18, 0.25);
}

.hover\\:bg-song-color-800\\/30:hover{
  background-color: rgba(180, 2, 18, 0.3);
}

.hover\\:bg-song-color-800\\/35:hover{
  background-color: rgba(180, 2, 18, 0.35);
}

.hover\\:bg-song-color-800\\/40:hover{
  background-color: rgba(180, 2, 18, 0.4);
}

.hover\\:bg-song-color-800\\/45:hover{
  background-color: rgba(180, 2, 18, 0.45);
}

.hover\\:bg-song-color-800\\/5:hover{
  background-color: rgba(180, 2, 18, 0.05);
}

.hover\\:bg-song-color-800\\/50:hover{
  background-color: rgba(180, 2, 18, 0.5);
}

.hover\\:bg-song-color-800\\/55:hover{
  background-color: rgba(180, 2, 18, 0.55);
}

.hover\\:bg-song-color-800\\/60:hover{
  background-color: rgba(180, 2, 18, 0.6);
}

.hover\\:bg-song-color-800\\/65:hover{
  background-color: rgba(180, 2, 18, 0.65);
}

.hover\\:bg-song-color-800\\/70:hover{
  background-color: rgba(180, 2, 18, 0.7);
}

.hover\\:bg-song-color-800\\/75:hover{
  background-color: rgba(180, 2, 18, 0.75);
}

.hover\\:bg-song-color-800\\/80:hover{
  background-color: rgba(180, 2, 18, 0.8);
}

.hover\\:bg-song-color-800\\/85:hover{
  background-color: rgba(180, 2, 18, 0.85);
}

.hover\\:bg-song-color-800\\/90:hover{
  background-color: rgba(180, 2, 18, 0.9);
}

.hover\\:bg-song-color-800\\/95:hover{
  background-color: rgba(180, 2, 18, 0.95);
}

.hover\\:bg-song-color-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(146, 10, 22, 1);
  background-color: rgba(146, 10, 22, var(--tw-bg-opacity, 1));
}

.hover\\:bg-song-color-900\\/0:hover{
  background-color: rgba(146, 10, 22, 0);
}

.hover\\:bg-song-color-900\\/10:hover{
  background-color: rgba(146, 10, 22, 0.1);
}

.hover\\:bg-song-color-900\\/100:hover{
  background-color: rgb(146, 10, 22);
}

.hover\\:bg-song-color-900\\/15:hover{
  background-color: rgba(146, 10, 22, 0.15);
}

.hover\\:bg-song-color-900\\/20:hover{
  background-color: rgba(146, 10, 22, 0.2);
}

.hover\\:bg-song-color-900\\/25:hover{
  background-color: rgba(146, 10, 22, 0.25);
}

.hover\\:bg-song-color-900\\/30:hover{
  background-color: rgba(146, 10, 22, 0.3);
}

.hover\\:bg-song-color-900\\/35:hover{
  background-color: rgba(146, 10, 22, 0.35);
}

.hover\\:bg-song-color-900\\/40:hover{
  background-color: rgba(146, 10, 22, 0.4);
}

.hover\\:bg-song-color-900\\/45:hover{
  background-color: rgba(146, 10, 22, 0.45);
}

.hover\\:bg-song-color-900\\/5:hover{
  background-color: rgba(146, 10, 22, 0.05);
}

.hover\\:bg-song-color-900\\/50:hover{
  background-color: rgba(146, 10, 22, 0.5);
}

.hover\\:bg-song-color-900\\/55:hover{
  background-color: rgba(146, 10, 22, 0.55);
}

.hover\\:bg-song-color-900\\/60:hover{
  background-color: rgba(146, 10, 22, 0.6);
}

.hover\\:bg-song-color-900\\/65:hover{
  background-color: rgba(146, 10, 22, 0.65);
}

.hover\\:bg-song-color-900\\/70:hover{
  background-color: rgba(146, 10, 22, 0.7);
}

.hover\\:bg-song-color-900\\/75:hover{
  background-color: rgba(146, 10, 22, 0.75);
}

.hover\\:bg-song-color-900\\/80:hover{
  background-color: rgba(146, 10, 22, 0.8);
}

.hover\\:bg-song-color-900\\/85:hover{
  background-color: rgba(146, 10, 22, 0.85);
}

.hover\\:bg-song-color-900\\/90:hover{
  background-color: rgba(146, 10, 22, 0.9);
}

.hover\\:bg-song-color-900\\/95:hover{
  background-color: rgba(146, 10, 22, 0.95);
}

.hover\\:bg-song-color-950:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(81, 0, 7, 1);
  background-color: rgba(81, 0, 7, var(--tw-bg-opacity, 1));
}

.hover\\:bg-song-color-950\\/0:hover{
  background-color: rgba(81, 0, 7, 0);
}

.hover\\:bg-song-color-950\\/10:hover{
  background-color: rgba(81, 0, 7, 0.1);
}

.hover\\:bg-song-color-950\\/100:hover{
  background-color: rgb(81, 0, 7);
}

.hover\\:bg-song-color-950\\/15:hover{
  background-color: rgba(81, 0, 7, 0.15);
}

.hover\\:bg-song-color-950\\/20:hover{
  background-color: rgba(81, 0, 7, 0.2);
}

.hover\\:bg-song-color-950\\/25:hover{
  background-color: rgba(81, 0, 7, 0.25);
}

.hover\\:bg-song-color-950\\/30:hover{
  background-color: rgba(81, 0, 7, 0.3);
}

.hover\\:bg-song-color-950\\/35:hover{
  background-color: rgba(81, 0, 7, 0.35);
}

.hover\\:bg-song-color-950\\/40:hover{
  background-color: rgba(81, 0, 7, 0.4);
}

.hover\\:bg-song-color-950\\/45:hover{
  background-color: rgba(81, 0, 7, 0.45);
}

.hover\\:bg-song-color-950\\/5:hover{
  background-color: rgba(81, 0, 7, 0.05);
}

.hover\\:bg-song-color-950\\/50:hover{
  background-color: rgba(81, 0, 7, 0.5);
}

.hover\\:bg-song-color-950\\/55:hover{
  background-color: rgba(81, 0, 7, 0.55);
}

.hover\\:bg-song-color-950\\/60:hover{
  background-color: rgba(81, 0, 7, 0.6);
}

.hover\\:bg-song-color-950\\/65:hover{
  background-color: rgba(81, 0, 7, 0.65);
}

.hover\\:bg-song-color-950\\/70:hover{
  background-color: rgba(81, 0, 7, 0.7);
}

.hover\\:bg-song-color-950\\/75:hover{
  background-color: rgba(81, 0, 7, 0.75);
}

.hover\\:bg-song-color-950\\/80:hover{
  background-color: rgba(81, 0, 7, 0.8);
}

.hover\\:bg-song-color-950\\/85:hover{
  background-color: rgba(81, 0, 7, 0.85);
}

.hover\\:bg-song-color-950\\/90:hover{
  background-color: rgba(81, 0, 7, 0.9);
}

.hover\\:bg-song-color-950\\/95:hover{
  background-color: rgba(81, 0, 7, 0.95);
}

.hover\\:bg-story-color-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(218, 238, 243, 1);
  background-color: rgba(218, 238, 243, var(--tw-bg-opacity, 1));
}

.hover\\:bg-story-color-100\\/0:hover{
  background-color: rgba(218, 238, 243, 0);
}

.hover\\:bg-story-color-100\\/10:hover{
  background-color: rgba(218, 238, 243, 0.1);
}

.hover\\:bg-story-color-100\\/100:hover{
  background-color: rgb(218, 238, 243);
}

.hover\\:bg-story-color-100\\/15:hover{
  background-color: rgba(218, 238, 243, 0.15);
}

.hover\\:bg-story-color-100\\/20:hover{
  background-color: rgba(218, 238, 243, 0.2);
}

.hover\\:bg-story-color-100\\/25:hover{
  background-color: rgba(218, 238, 243, 0.25);
}

.hover\\:bg-story-color-100\\/30:hover{
  background-color: rgba(218, 238, 243, 0.3);
}

.hover\\:bg-story-color-100\\/35:hover{
  background-color: rgba(218, 238, 243, 0.35);
}

.hover\\:bg-story-color-100\\/40:hover{
  background-color: rgba(218, 238, 243, 0.4);
}

.hover\\:bg-story-color-100\\/45:hover{
  background-color: rgba(218, 238, 243, 0.45);
}

.hover\\:bg-story-color-100\\/5:hover{
  background-color: rgba(218, 238, 243, 0.05);
}

.hover\\:bg-story-color-100\\/50:hover{
  background-color: rgba(218, 238, 243, 0.5);
}

.hover\\:bg-story-color-100\\/55:hover{
  background-color: rgba(218, 238, 243, 0.55);
}

.hover\\:bg-story-color-100\\/60:hover{
  background-color: rgba(218, 238, 243, 0.6);
}

.hover\\:bg-story-color-100\\/65:hover{
  background-color: rgba(218, 238, 243, 0.65);
}

.hover\\:bg-story-color-100\\/70:hover{
  background-color: rgba(218, 238, 243, 0.7);
}

.hover\\:bg-story-color-100\\/75:hover{
  background-color: rgba(218, 238, 243, 0.75);
}

.hover\\:bg-story-color-100\\/80:hover{
  background-color: rgba(218, 238, 243, 0.8);
}

.hover\\:bg-story-color-100\\/85:hover{
  background-color: rgba(218, 238, 243, 0.85);
}

.hover\\:bg-story-color-100\\/90:hover{
  background-color: rgba(218, 238, 243, 0.9);
}

.hover\\:bg-story-color-100\\/95:hover{
  background-color: rgba(218, 238, 243, 0.95);
}

.hover\\:bg-story-color-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(186, 222, 231, 1);
  background-color: rgba(186, 222, 231, var(--tw-bg-opacity, 1));
}

.hover\\:bg-story-color-200\\/0:hover{
  background-color: rgba(186, 222, 231, 0);
}

.hover\\:bg-story-color-200\\/10:hover{
  background-color: rgba(186, 222, 231, 0.1);
}

.hover\\:bg-story-color-200\\/100:hover{
  background-color: rgb(186, 222, 231);
}

.hover\\:bg-story-color-200\\/15:hover{
  background-color: rgba(186, 222, 231, 0.15);
}

.hover\\:bg-story-color-200\\/20:hover{
  background-color: rgba(186, 222, 231, 0.2);
}

.hover\\:bg-story-color-200\\/25:hover{
  background-color: rgba(186, 222, 231, 0.25);
}

.hover\\:bg-story-color-200\\/30:hover{
  background-color: rgba(186, 222, 231, 0.3);
}

.hover\\:bg-story-color-200\\/35:hover{
  background-color: rgba(186, 222, 231, 0.35);
}

.hover\\:bg-story-color-200\\/40:hover{
  background-color: rgba(186, 222, 231, 0.4);
}

.hover\\:bg-story-color-200\\/45:hover{
  background-color: rgba(186, 222, 231, 0.45);
}

.hover\\:bg-story-color-200\\/5:hover{
  background-color: rgba(186, 222, 231, 0.05);
}

.hover\\:bg-story-color-200\\/50:hover{
  background-color: rgba(186, 222, 231, 0.5);
}

.hover\\:bg-story-color-200\\/55:hover{
  background-color: rgba(186, 222, 231, 0.55);
}

.hover\\:bg-story-color-200\\/60:hover{
  background-color: rgba(186, 222, 231, 0.6);
}

.hover\\:bg-story-color-200\\/65:hover{
  background-color: rgba(186, 222, 231, 0.65);
}

.hover\\:bg-story-color-200\\/70:hover{
  background-color: rgba(186, 222, 231, 0.7);
}

.hover\\:bg-story-color-200\\/75:hover{
  background-color: rgba(186, 222, 231, 0.75);
}

.hover\\:bg-story-color-200\\/80:hover{
  background-color: rgba(186, 222, 231, 0.8);
}

.hover\\:bg-story-color-200\\/85:hover{
  background-color: rgba(186, 222, 231, 0.85);
}

.hover\\:bg-story-color-200\\/90:hover{
  background-color: rgba(186, 222, 231, 0.9);
}

.hover\\:bg-story-color-200\\/95:hover{
  background-color: rgba(186, 222, 231, 0.95);
}

.hover\\:bg-story-color-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(137, 197, 215, 1);
  background-color: rgba(137, 197, 215, var(--tw-bg-opacity, 1));
}

.hover\\:bg-story-color-300\\/0:hover{
  background-color: rgba(137, 197, 215, 0);
}

.hover\\:bg-story-color-300\\/10:hover{
  background-color: rgba(137, 197, 215, 0.1);
}

.hover\\:bg-story-color-300\\/100:hover{
  background-color: rgb(137, 197, 215);
}

.hover\\:bg-story-color-300\\/15:hover{
  background-color: rgba(137, 197, 215, 0.15);
}

.hover\\:bg-story-color-300\\/20:hover{
  background-color: rgba(137, 197, 215, 0.2);
}

.hover\\:bg-story-color-300\\/25:hover{
  background-color: rgba(137, 197, 215, 0.25);
}

.hover\\:bg-story-color-300\\/30:hover{
  background-color: rgba(137, 197, 215, 0.3);
}

.hover\\:bg-story-color-300\\/35:hover{
  background-color: rgba(137, 197, 215, 0.35);
}

.hover\\:bg-story-color-300\\/40:hover{
  background-color: rgba(137, 197, 215, 0.4);
}

.hover\\:bg-story-color-300\\/45:hover{
  background-color: rgba(137, 197, 215, 0.45);
}

.hover\\:bg-story-color-300\\/5:hover{
  background-color: rgba(137, 197, 215, 0.05);
}

.hover\\:bg-story-color-300\\/50:hover{
  background-color: rgba(137, 197, 215, 0.5);
}

.hover\\:bg-story-color-300\\/55:hover{
  background-color: rgba(137, 197, 215, 0.55);
}

.hover\\:bg-story-color-300\\/60:hover{
  background-color: rgba(137, 197, 215, 0.6);
}

.hover\\:bg-story-color-300\\/65:hover{
  background-color: rgba(137, 197, 215, 0.65);
}

.hover\\:bg-story-color-300\\/70:hover{
  background-color: rgba(137, 197, 215, 0.7);
}

.hover\\:bg-story-color-300\\/75:hover{
  background-color: rgba(137, 197, 215, 0.75);
}

.hover\\:bg-story-color-300\\/80:hover{
  background-color: rgba(137, 197, 215, 0.8);
}

.hover\\:bg-story-color-300\\/85:hover{
  background-color: rgba(137, 197, 215, 0.85);
}

.hover\\:bg-story-color-300\\/90:hover{
  background-color: rgba(137, 197, 215, 0.9);
}

.hover\\:bg-story-color-300\\/95:hover{
  background-color: rgba(137, 197, 215, 0.95);
}

.hover\\:bg-story-color-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(82, 163, 190, 1);
  background-color: rgba(82, 163, 190, var(--tw-bg-opacity, 1));
}

.hover\\:bg-story-color-400\\/0:hover{
  background-color: rgba(82, 163, 190, 0);
}

.hover\\:bg-story-color-400\\/10:hover{
  background-color: rgba(82, 163, 190, 0.1);
}

.hover\\:bg-story-color-400\\/100:hover{
  background-color: rgb(82, 163, 190);
}

.hover\\:bg-story-color-400\\/15:hover{
  background-color: rgba(82, 163, 190, 0.15);
}

.hover\\:bg-story-color-400\\/20:hover{
  background-color: rgba(82, 163, 190, 0.2);
}

.hover\\:bg-story-color-400\\/25:hover{
  background-color: rgba(82, 163, 190, 0.25);
}

.hover\\:bg-story-color-400\\/30:hover{
  background-color: rgba(82, 163, 190, 0.3);
}

.hover\\:bg-story-color-400\\/35:hover{
  background-color: rgba(82, 163, 190, 0.35);
}

.hover\\:bg-story-color-400\\/40:hover{
  background-color: rgba(82, 163, 190, 0.4);
}

.hover\\:bg-story-color-400\\/45:hover{
  background-color: rgba(82, 163, 190, 0.45);
}

.hover\\:bg-story-color-400\\/5:hover{
  background-color: rgba(82, 163, 190, 0.05);
}

.hover\\:bg-story-color-400\\/50:hover{
  background-color: rgba(82, 163, 190, 0.5);
}

.hover\\:bg-story-color-400\\/55:hover{
  background-color: rgba(82, 163, 190, 0.55);
}

.hover\\:bg-story-color-400\\/60:hover{
  background-color: rgba(82, 163, 190, 0.6);
}

.hover\\:bg-story-color-400\\/65:hover{
  background-color: rgba(82, 163, 190, 0.65);
}

.hover\\:bg-story-color-400\\/70:hover{
  background-color: rgba(82, 163, 190, 0.7);
}

.hover\\:bg-story-color-400\\/75:hover{
  background-color: rgba(82, 163, 190, 0.75);
}

.hover\\:bg-story-color-400\\/80:hover{
  background-color: rgba(82, 163, 190, 0.8);
}

.hover\\:bg-story-color-400\\/85:hover{
  background-color: rgba(82, 163, 190, 0.85);
}

.hover\\:bg-story-color-400\\/90:hover{
  background-color: rgba(82, 163, 190, 0.9);
}

.hover\\:bg-story-color-400\\/95:hover{
  background-color: rgba(82, 163, 190, 0.95);
}

.hover\\:bg-story-color-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(55, 135, 163, 1);
  background-color: rgba(55, 135, 163, var(--tw-bg-opacity, 1));
}

.hover\\:bg-story-color-500\\/0:hover{
  background-color: rgba(55, 135, 163, 0);
}

.hover\\:bg-story-color-500\\/10:hover{
  background-color: rgba(55, 135, 163, 0.1);
}

.hover\\:bg-story-color-500\\/100:hover{
  background-color: rgb(55, 135, 163);
}

.hover\\:bg-story-color-500\\/15:hover{
  background-color: rgba(55, 135, 163, 0.15);
}

.hover\\:bg-story-color-500\\/20:hover{
  background-color: rgba(55, 135, 163, 0.2);
}

.hover\\:bg-story-color-500\\/25:hover{
  background-color: rgba(55, 135, 163, 0.25);
}

.hover\\:bg-story-color-500\\/30:hover{
  background-color: rgba(55, 135, 163, 0.3);
}

.hover\\:bg-story-color-500\\/35:hover{
  background-color: rgba(55, 135, 163, 0.35);
}

.hover\\:bg-story-color-500\\/40:hover{
  background-color: rgba(55, 135, 163, 0.4);
}

.hover\\:bg-story-color-500\\/45:hover{
  background-color: rgba(55, 135, 163, 0.45);
}

.hover\\:bg-story-color-500\\/5:hover{
  background-color: rgba(55, 135, 163, 0.05);
}

.hover\\:bg-story-color-500\\/50:hover{
  background-color: rgba(55, 135, 163, 0.5);
}

.hover\\:bg-story-color-500\\/55:hover{
  background-color: rgba(55, 135, 163, 0.55);
}

.hover\\:bg-story-color-500\\/60:hover{
  background-color: rgba(55, 135, 163, 0.6);
}

.hover\\:bg-story-color-500\\/65:hover{
  background-color: rgba(55, 135, 163, 0.65);
}

.hover\\:bg-story-color-500\\/70:hover{
  background-color: rgba(55, 135, 163, 0.7);
}

.hover\\:bg-story-color-500\\/75:hover{
  background-color: rgba(55, 135, 163, 0.75);
}

.hover\\:bg-story-color-500\\/80:hover{
  background-color: rgba(55, 135, 163, 0.8);
}

.hover\\:bg-story-color-500\\/85:hover{
  background-color: rgba(55, 135, 163, 0.85);
}

.hover\\:bg-story-color-500\\/90:hover{
  background-color: rgba(55, 135, 163, 0.9);
}

.hover\\:bg-story-color-500\\/95:hover{
  background-color: rgba(55, 135, 163, 0.95);
}

.hover\\:bg-story-color-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(48, 109, 138, 1);
  background-color: rgba(48, 109, 138, var(--tw-bg-opacity, 1));
}

.hover\\:bg-story-color-600\\/0:hover{
  background-color: rgba(48, 109, 138, 0);
}

.hover\\:bg-story-color-600\\/10:hover{
  background-color: rgba(48, 109, 138, 0.1);
}

.hover\\:bg-story-color-600\\/100:hover{
  background-color: rgb(48, 109, 138);
}

.hover\\:bg-story-color-600\\/15:hover{
  background-color: rgba(48, 109, 138, 0.15);
}

.hover\\:bg-story-color-600\\/20:hover{
  background-color: rgba(48, 109, 138, 0.2);
}

.hover\\:bg-story-color-600\\/25:hover{
  background-color: rgba(48, 109, 138, 0.25);
}

.hover\\:bg-story-color-600\\/30:hover{
  background-color: rgba(48, 109, 138, 0.3);
}

.hover\\:bg-story-color-600\\/35:hover{
  background-color: rgba(48, 109, 138, 0.35);
}

.hover\\:bg-story-color-600\\/40:hover{
  background-color: rgba(48, 109, 138, 0.4);
}

.hover\\:bg-story-color-600\\/45:hover{
  background-color: rgba(48, 109, 138, 0.45);
}

.hover\\:bg-story-color-600\\/5:hover{
  background-color: rgba(48, 109, 138, 0.05);
}

.hover\\:bg-story-color-600\\/50:hover{
  background-color: rgba(48, 109, 138, 0.5);
}

.hover\\:bg-story-color-600\\/55:hover{
  background-color: rgba(48, 109, 138, 0.55);
}

.hover\\:bg-story-color-600\\/60:hover{
  background-color: rgba(48, 109, 138, 0.6);
}

.hover\\:bg-story-color-600\\/65:hover{
  background-color: rgba(48, 109, 138, 0.65);
}

.hover\\:bg-story-color-600\\/70:hover{
  background-color: rgba(48, 109, 138, 0.7);
}

.hover\\:bg-story-color-600\\/75:hover{
  background-color: rgba(48, 109, 138, 0.75);
}

.hover\\:bg-story-color-600\\/80:hover{
  background-color: rgba(48, 109, 138, 0.8);
}

.hover\\:bg-story-color-600\\/85:hover{
  background-color: rgba(48, 109, 138, 0.85);
}

.hover\\:bg-story-color-600\\/90:hover{
  background-color: rgba(48, 109, 138, 0.9);
}

.hover\\:bg-story-color-600\\/95:hover{
  background-color: rgba(48, 109, 138, 0.95);
}

.hover\\:bg-story-color-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(45, 91, 114, 1);
  background-color: rgba(45, 91, 114, var(--tw-bg-opacity, 1));
}

.hover\\:bg-story-color-700\\/0:hover{
  background-color: rgba(45, 91, 114, 0);
}

.hover\\:bg-story-color-700\\/10:hover{
  background-color: rgba(45, 91, 114, 0.1);
}

.hover\\:bg-story-color-700\\/100:hover{
  background-color: rgb(45, 91, 114);
}

.hover\\:bg-story-color-700\\/15:hover{
  background-color: rgba(45, 91, 114, 0.15);
}

.hover\\:bg-story-color-700\\/20:hover{
  background-color: rgba(45, 91, 114, 0.2);
}

.hover\\:bg-story-color-700\\/25:hover{
  background-color: rgba(45, 91, 114, 0.25);
}

.hover\\:bg-story-color-700\\/30:hover{
  background-color: rgba(45, 91, 114, 0.3);
}

.hover\\:bg-story-color-700\\/35:hover{
  background-color: rgba(45, 91, 114, 0.35);
}

.hover\\:bg-story-color-700\\/40:hover{
  background-color: rgba(45, 91, 114, 0.4);
}

.hover\\:bg-story-color-700\\/45:hover{
  background-color: rgba(45, 91, 114, 0.45);
}

.hover\\:bg-story-color-700\\/5:hover{
  background-color: rgba(45, 91, 114, 0.05);
}

.hover\\:bg-story-color-700\\/50:hover{
  background-color: rgba(45, 91, 114, 0.5);
}

.hover\\:bg-story-color-700\\/55:hover{
  background-color: rgba(45, 91, 114, 0.55);
}

.hover\\:bg-story-color-700\\/60:hover{
  background-color: rgba(45, 91, 114, 0.6);
}

.hover\\:bg-story-color-700\\/65:hover{
  background-color: rgba(45, 91, 114, 0.65);
}

.hover\\:bg-story-color-700\\/70:hover{
  background-color: rgba(45, 91, 114, 0.7);
}

.hover\\:bg-story-color-700\\/75:hover{
  background-color: rgba(45, 91, 114, 0.75);
}

.hover\\:bg-story-color-700\\/80:hover{
  background-color: rgba(45, 91, 114, 0.8);
}

.hover\\:bg-story-color-700\\/85:hover{
  background-color: rgba(45, 91, 114, 0.85);
}

.hover\\:bg-story-color-700\\/90:hover{
  background-color: rgba(45, 91, 114, 0.9);
}

.hover\\:bg-story-color-700\\/95:hover{
  background-color: rgba(45, 91, 114, 0.95);
}

.hover\\:bg-story-color-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(44, 76, 94, 1);
  background-color: rgba(44, 76, 94, var(--tw-bg-opacity, 1));
}

.hover\\:bg-story-color-800\\/0:hover{
  background-color: rgba(44, 76, 94, 0);
}

.hover\\:bg-story-color-800\\/10:hover{
  background-color: rgba(44, 76, 94, 0.1);
}

.hover\\:bg-story-color-800\\/100:hover{
  background-color: rgb(44, 76, 94);
}

.hover\\:bg-story-color-800\\/15:hover{
  background-color: rgba(44, 76, 94, 0.15);
}

.hover\\:bg-story-color-800\\/20:hover{
  background-color: rgba(44, 76, 94, 0.2);
}

.hover\\:bg-story-color-800\\/25:hover{
  background-color: rgba(44, 76, 94, 0.25);
}

.hover\\:bg-story-color-800\\/30:hover{
  background-color: rgba(44, 76, 94, 0.3);
}

.hover\\:bg-story-color-800\\/35:hover{
  background-color: rgba(44, 76, 94, 0.35);
}

.hover\\:bg-story-color-800\\/40:hover{
  background-color: rgba(44, 76, 94, 0.4);
}

.hover\\:bg-story-color-800\\/45:hover{
  background-color: rgba(44, 76, 94, 0.45);
}

.hover\\:bg-story-color-800\\/5:hover{
  background-color: rgba(44, 76, 94, 0.05);
}

.hover\\:bg-story-color-800\\/50:hover{
  background-color: rgba(44, 76, 94, 0.5);
}

.hover\\:bg-story-color-800\\/55:hover{
  background-color: rgba(44, 76, 94, 0.55);
}

.hover\\:bg-story-color-800\\/60:hover{
  background-color: rgba(44, 76, 94, 0.6);
}

.hover\\:bg-story-color-800\\/65:hover{
  background-color: rgba(44, 76, 94, 0.65);
}

.hover\\:bg-story-color-800\\/70:hover{
  background-color: rgba(44, 76, 94, 0.7);
}

.hover\\:bg-story-color-800\\/75:hover{
  background-color: rgba(44, 76, 94, 0.75);
}

.hover\\:bg-story-color-800\\/80:hover{
  background-color: rgba(44, 76, 94, 0.8);
}

.hover\\:bg-story-color-800\\/85:hover{
  background-color: rgba(44, 76, 94, 0.85);
}

.hover\\:bg-story-color-800\\/90:hover{
  background-color: rgba(44, 76, 94, 0.9);
}

.hover\\:bg-story-color-800\\/95:hover{
  background-color: rgba(44, 76, 94, 0.95);
}

.hover\\:bg-story-color-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(40, 65, 81, 1);
  background-color: rgba(40, 65, 81, var(--tw-bg-opacity, 1));
}

.hover\\:bg-story-color-900\\/0:hover{
  background-color: rgba(40, 65, 81, 0);
}

.hover\\:bg-story-color-900\\/10:hover{
  background-color: rgba(40, 65, 81, 0.1);
}

.hover\\:bg-story-color-900\\/100:hover{
  background-color: rgb(40, 65, 81);
}

.hover\\:bg-story-color-900\\/15:hover{
  background-color: rgba(40, 65, 81, 0.15);
}

.hover\\:bg-story-color-900\\/20:hover{
  background-color: rgba(40, 65, 81, 0.2);
}

.hover\\:bg-story-color-900\\/25:hover{
  background-color: rgba(40, 65, 81, 0.25);
}

.hover\\:bg-story-color-900\\/30:hover{
  background-color: rgba(40, 65, 81, 0.3);
}

.hover\\:bg-story-color-900\\/35:hover{
  background-color: rgba(40, 65, 81, 0.35);
}

.hover\\:bg-story-color-900\\/40:hover{
  background-color: rgba(40, 65, 81, 0.4);
}

.hover\\:bg-story-color-900\\/45:hover{
  background-color: rgba(40, 65, 81, 0.45);
}

.hover\\:bg-story-color-900\\/5:hover{
  background-color: rgba(40, 65, 81, 0.05);
}

.hover\\:bg-story-color-900\\/50:hover{
  background-color: rgba(40, 65, 81, 0.5);
}

.hover\\:bg-story-color-900\\/55:hover{
  background-color: rgba(40, 65, 81, 0.55);
}

.hover\\:bg-story-color-900\\/60:hover{
  background-color: rgba(40, 65, 81, 0.6);
}

.hover\\:bg-story-color-900\\/65:hover{
  background-color: rgba(40, 65, 81, 0.65);
}

.hover\\:bg-story-color-900\\/70:hover{
  background-color: rgba(40, 65, 81, 0.7);
}

.hover\\:bg-story-color-900\\/75:hover{
  background-color: rgba(40, 65, 81, 0.75);
}

.hover\\:bg-story-color-900\\/80:hover{
  background-color: rgba(40, 65, 81, 0.8);
}

.hover\\:bg-story-color-900\\/85:hover{
  background-color: rgba(40, 65, 81, 0.85);
}

.hover\\:bg-story-color-900\\/90:hover{
  background-color: rgba(40, 65, 81, 0.9);
}

.hover\\:bg-story-color-900\\/95:hover{
  background-color: rgba(40, 65, 81, 0.95);
}

.hover\\:bg-story-color-950:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(22, 41, 54, 1);
  background-color: rgba(22, 41, 54, var(--tw-bg-opacity, 1));
}

.hover\\:bg-story-color-950\\/0:hover{
  background-color: rgba(22, 41, 54, 0);
}

.hover\\:bg-story-color-950\\/10:hover{
  background-color: rgba(22, 41, 54, 0.1);
}

.hover\\:bg-story-color-950\\/100:hover{
  background-color: rgb(22, 41, 54);
}

.hover\\:bg-story-color-950\\/15:hover{
  background-color: rgba(22, 41, 54, 0.15);
}

.hover\\:bg-story-color-950\\/20:hover{
  background-color: rgba(22, 41, 54, 0.2);
}

.hover\\:bg-story-color-950\\/25:hover{
  background-color: rgba(22, 41, 54, 0.25);
}

.hover\\:bg-story-color-950\\/30:hover{
  background-color: rgba(22, 41, 54, 0.3);
}

.hover\\:bg-story-color-950\\/35:hover{
  background-color: rgba(22, 41, 54, 0.35);
}

.hover\\:bg-story-color-950\\/40:hover{
  background-color: rgba(22, 41, 54, 0.4);
}

.hover\\:bg-story-color-950\\/45:hover{
  background-color: rgba(22, 41, 54, 0.45);
}

.hover\\:bg-story-color-950\\/5:hover{
  background-color: rgba(22, 41, 54, 0.05);
}

.hover\\:bg-story-color-950\\/50:hover{
  background-color: rgba(22, 41, 54, 0.5);
}

.hover\\:bg-story-color-950\\/55:hover{
  background-color: rgba(22, 41, 54, 0.55);
}

.hover\\:bg-story-color-950\\/60:hover{
  background-color: rgba(22, 41, 54, 0.6);
}

.hover\\:bg-story-color-950\\/65:hover{
  background-color: rgba(22, 41, 54, 0.65);
}

.hover\\:bg-story-color-950\\/70:hover{
  background-color: rgba(22, 41, 54, 0.7);
}

.hover\\:bg-story-color-950\\/75:hover{
  background-color: rgba(22, 41, 54, 0.75);
}

.hover\\:bg-story-color-950\\/80:hover{
  background-color: rgba(22, 41, 54, 0.8);
}

.hover\\:bg-story-color-950\\/85:hover{
  background-color: rgba(22, 41, 54, 0.85);
}

.hover\\:bg-story-color-950\\/90:hover{
  background-color: rgba(22, 41, 54, 0.9);
}

.hover\\:bg-story-color-950\\/95:hover{
  background-color: rgba(22, 41, 54, 0.95);
}

.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
}

.hover\\:bg-word-color-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(217, 242, 230, 1);
  background-color: rgba(217, 242, 230, var(--tw-bg-opacity, 1));
}

.hover\\:bg-word-color-100\\/0:hover{
  background-color: rgba(217, 242, 230, 0);
}

.hover\\:bg-word-color-100\\/10:hover{
  background-color: rgba(217, 242, 230, 0.1);
}

.hover\\:bg-word-color-100\\/100:hover{
  background-color: rgb(217, 242, 230);
}

.hover\\:bg-word-color-100\\/15:hover{
  background-color: rgba(217, 242, 230, 0.15);
}

.hover\\:bg-word-color-100\\/20:hover{
  background-color: rgba(217, 242, 230, 0.2);
}

.hover\\:bg-word-color-100\\/25:hover{
  background-color: rgba(217, 242, 230, 0.25);
}

.hover\\:bg-word-color-100\\/30:hover{
  background-color: rgba(217, 242, 230, 0.3);
}

.hover\\:bg-word-color-100\\/35:hover{
  background-color: rgba(217, 242, 230, 0.35);
}

.hover\\:bg-word-color-100\\/40:hover{
  background-color: rgba(217, 242, 230, 0.4);
}

.hover\\:bg-word-color-100\\/45:hover{
  background-color: rgba(217, 242, 230, 0.45);
}

.hover\\:bg-word-color-100\\/5:hover{
  background-color: rgba(217, 242, 230, 0.05);
}

.hover\\:bg-word-color-100\\/50:hover{
  background-color: rgba(217, 242, 230, 0.5);
}

.hover\\:bg-word-color-100\\/55:hover{
  background-color: rgba(217, 242, 230, 0.55);
}

.hover\\:bg-word-color-100\\/60:hover{
  background-color: rgba(217, 242, 230, 0.6);
}

.hover\\:bg-word-color-100\\/65:hover{
  background-color: rgba(217, 242, 230, 0.65);
}

.hover\\:bg-word-color-100\\/70:hover{
  background-color: rgba(217, 242, 230, 0.7);
}

.hover\\:bg-word-color-100\\/75:hover{
  background-color: rgba(217, 242, 230, 0.75);
}

.hover\\:bg-word-color-100\\/80:hover{
  background-color: rgba(217, 242, 230, 0.8);
}

.hover\\:bg-word-color-100\\/85:hover{
  background-color: rgba(217, 242, 230, 0.85);
}

.hover\\:bg-word-color-100\\/90:hover{
  background-color: rgba(217, 242, 230, 0.9);
}

.hover\\:bg-word-color-100\\/95:hover{
  background-color: rgba(217, 242, 230, 0.95);
}

.hover\\:bg-word-color-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(182, 228, 209, 1);
  background-color: rgba(182, 228, 209, var(--tw-bg-opacity, 1));
}

.hover\\:bg-word-color-200\\/0:hover{
  background-color: rgba(182, 228, 209, 0);
}

.hover\\:bg-word-color-200\\/10:hover{
  background-color: rgba(182, 228, 209, 0.1);
}

.hover\\:bg-word-color-200\\/100:hover{
  background-color: rgb(182, 228, 209);
}

.hover\\:bg-word-color-200\\/15:hover{
  background-color: rgba(182, 228, 209, 0.15);
}

.hover\\:bg-word-color-200\\/20:hover{
  background-color: rgba(182, 228, 209, 0.2);
}

.hover\\:bg-word-color-200\\/25:hover{
  background-color: rgba(182, 228, 209, 0.25);
}

.hover\\:bg-word-color-200\\/30:hover{
  background-color: rgba(182, 228, 209, 0.3);
}

.hover\\:bg-word-color-200\\/35:hover{
  background-color: rgba(182, 228, 209, 0.35);
}

.hover\\:bg-word-color-200\\/40:hover{
  background-color: rgba(182, 228, 209, 0.4);
}

.hover\\:bg-word-color-200\\/45:hover{
  background-color: rgba(182, 228, 209, 0.45);
}

.hover\\:bg-word-color-200\\/5:hover{
  background-color: rgba(182, 228, 209, 0.05);
}

.hover\\:bg-word-color-200\\/50:hover{
  background-color: rgba(182, 228, 209, 0.5);
}

.hover\\:bg-word-color-200\\/55:hover{
  background-color: rgba(182, 228, 209, 0.55);
}

.hover\\:bg-word-color-200\\/60:hover{
  background-color: rgba(182, 228, 209, 0.6);
}

.hover\\:bg-word-color-200\\/65:hover{
  background-color: rgba(182, 228, 209, 0.65);
}

.hover\\:bg-word-color-200\\/70:hover{
  background-color: rgba(182, 228, 209, 0.7);
}

.hover\\:bg-word-color-200\\/75:hover{
  background-color: rgba(182, 228, 209, 0.75);
}

.hover\\:bg-word-color-200\\/80:hover{
  background-color: rgba(182, 228, 209, 0.8);
}

.hover\\:bg-word-color-200\\/85:hover{
  background-color: rgba(182, 228, 209, 0.85);
}

.hover\\:bg-word-color-200\\/90:hover{
  background-color: rgba(182, 228, 209, 0.9);
}

.hover\\:bg-word-color-200\\/95:hover{
  background-color: rgba(182, 228, 209, 0.95);
}

.hover\\:bg-word-color-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(134, 207, 181, 1);
  background-color: rgba(134, 207, 181, var(--tw-bg-opacity, 1));
}

.hover\\:bg-word-color-300\\/0:hover{
  background-color: rgba(134, 207, 181, 0);
}

.hover\\:bg-word-color-300\\/10:hover{
  background-color: rgba(134, 207, 181, 0.1);
}

.hover\\:bg-word-color-300\\/100:hover{
  background-color: rgb(134, 207, 181);
}

.hover\\:bg-word-color-300\\/15:hover{
  background-color: rgba(134, 207, 181, 0.15);
}

.hover\\:bg-word-color-300\\/20:hover{
  background-color: rgba(134, 207, 181, 0.2);
}

.hover\\:bg-word-color-300\\/25:hover{
  background-color: rgba(134, 207, 181, 0.25);
}

.hover\\:bg-word-color-300\\/30:hover{
  background-color: rgba(134, 207, 181, 0.3);
}

.hover\\:bg-word-color-300\\/35:hover{
  background-color: rgba(134, 207, 181, 0.35);
}

.hover\\:bg-word-color-300\\/40:hover{
  background-color: rgba(134, 207, 181, 0.4);
}

.hover\\:bg-word-color-300\\/45:hover{
  background-color: rgba(134, 207, 181, 0.45);
}

.hover\\:bg-word-color-300\\/5:hover{
  background-color: rgba(134, 207, 181, 0.05);
}

.hover\\:bg-word-color-300\\/50:hover{
  background-color: rgba(134, 207, 181, 0.5);
}

.hover\\:bg-word-color-300\\/55:hover{
  background-color: rgba(134, 207, 181, 0.55);
}

.hover\\:bg-word-color-300\\/60:hover{
  background-color: rgba(134, 207, 181, 0.6);
}

.hover\\:bg-word-color-300\\/65:hover{
  background-color: rgba(134, 207, 181, 0.65);
}

.hover\\:bg-word-color-300\\/70:hover{
  background-color: rgba(134, 207, 181, 0.7);
}

.hover\\:bg-word-color-300\\/75:hover{
  background-color: rgba(134, 207, 181, 0.75);
}

.hover\\:bg-word-color-300\\/80:hover{
  background-color: rgba(134, 207, 181, 0.8);
}

.hover\\:bg-word-color-300\\/85:hover{
  background-color: rgba(134, 207, 181, 0.85);
}

.hover\\:bg-word-color-300\\/90:hover{
  background-color: rgba(134, 207, 181, 0.9);
}

.hover\\:bg-word-color-300\\/95:hover{
  background-color: rgba(134, 207, 181, 0.95);
}

.hover\\:bg-word-color-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(83, 180, 148, 1);
  background-color: rgba(83, 180, 148, var(--tw-bg-opacity, 1));
}

.hover\\:bg-word-color-400\\/0:hover{
  background-color: rgba(83, 180, 148, 0);
}

.hover\\:bg-word-color-400\\/10:hover{
  background-color: rgba(83, 180, 148, 0.1);
}

.hover\\:bg-word-color-400\\/100:hover{
  background-color: rgb(83, 180, 148);
}

.hover\\:bg-word-color-400\\/15:hover{
  background-color: rgba(83, 180, 148, 0.15);
}

.hover\\:bg-word-color-400\\/20:hover{
  background-color: rgba(83, 180, 148, 0.2);
}

.hover\\:bg-word-color-400\\/25:hover{
  background-color: rgba(83, 180, 148, 0.25);
}

.hover\\:bg-word-color-400\\/30:hover{
  background-color: rgba(83, 180, 148, 0.3);
}

.hover\\:bg-word-color-400\\/35:hover{
  background-color: rgba(83, 180, 148, 0.35);
}

.hover\\:bg-word-color-400\\/40:hover{
  background-color: rgba(83, 180, 148, 0.4);
}

.hover\\:bg-word-color-400\\/45:hover{
  background-color: rgba(83, 180, 148, 0.45);
}

.hover\\:bg-word-color-400\\/5:hover{
  background-color: rgba(83, 180, 148, 0.05);
}

.hover\\:bg-word-color-400\\/50:hover{
  background-color: rgba(83, 180, 148, 0.5);
}

.hover\\:bg-word-color-400\\/55:hover{
  background-color: rgba(83, 180, 148, 0.55);
}

.hover\\:bg-word-color-400\\/60:hover{
  background-color: rgba(83, 180, 148, 0.6);
}

.hover\\:bg-word-color-400\\/65:hover{
  background-color: rgba(83, 180, 148, 0.65);
}

.hover\\:bg-word-color-400\\/70:hover{
  background-color: rgba(83, 180, 148, 0.7);
}

.hover\\:bg-word-color-400\\/75:hover{
  background-color: rgba(83, 180, 148, 0.75);
}

.hover\\:bg-word-color-400\\/80:hover{
  background-color: rgba(83, 180, 148, 0.8);
}

.hover\\:bg-word-color-400\\/85:hover{
  background-color: rgba(83, 180, 148, 0.85);
}

.hover\\:bg-word-color-400\\/90:hover{
  background-color: rgba(83, 180, 148, 0.9);
}

.hover\\:bg-word-color-400\\/95:hover{
  background-color: rgba(83, 180, 148, 0.95);
}

.hover\\:bg-word-color-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(44, 135, 109, 1);
  background-color: rgba(44, 135, 109, var(--tw-bg-opacity, 1));
}

.hover\\:bg-word-color-500\\/0:hover{
  background-color: rgba(44, 135, 109, 0);
}

.hover\\:bg-word-color-500\\/10:hover{
  background-color: rgba(44, 135, 109, 0.1);
}

.hover\\:bg-word-color-500\\/100:hover{
  background-color: rgb(44, 135, 109);
}

.hover\\:bg-word-color-500\\/15:hover{
  background-color: rgba(44, 135, 109, 0.15);
}

.hover\\:bg-word-color-500\\/20:hover{
  background-color: rgba(44, 135, 109, 0.2);
}

.hover\\:bg-word-color-500\\/25:hover{
  background-color: rgba(44, 135, 109, 0.25);
}

.hover\\:bg-word-color-500\\/30:hover{
  background-color: rgba(44, 135, 109, 0.3);
}

.hover\\:bg-word-color-500\\/35:hover{
  background-color: rgba(44, 135, 109, 0.35);
}

.hover\\:bg-word-color-500\\/40:hover{
  background-color: rgba(44, 135, 109, 0.4);
}

.hover\\:bg-word-color-500\\/45:hover{
  background-color: rgba(44, 135, 109, 0.45);
}

.hover\\:bg-word-color-500\\/5:hover{
  background-color: rgba(44, 135, 109, 0.05);
}

.hover\\:bg-word-color-500\\/50:hover{
  background-color: rgba(44, 135, 109, 0.5);
}

.hover\\:bg-word-color-500\\/55:hover{
  background-color: rgba(44, 135, 109, 0.55);
}

.hover\\:bg-word-color-500\\/60:hover{
  background-color: rgba(44, 135, 109, 0.6);
}

.hover\\:bg-word-color-500\\/65:hover{
  background-color: rgba(44, 135, 109, 0.65);
}

.hover\\:bg-word-color-500\\/70:hover{
  background-color: rgba(44, 135, 109, 0.7);
}

.hover\\:bg-word-color-500\\/75:hover{
  background-color: rgba(44, 135, 109, 0.75);
}

.hover\\:bg-word-color-500\\/80:hover{
  background-color: rgba(44, 135, 109, 0.8);
}

.hover\\:bg-word-color-500\\/85:hover{
  background-color: rgba(44, 135, 109, 0.85);
}

.hover\\:bg-word-color-500\\/90:hover{
  background-color: rgba(44, 135, 109, 0.9);
}

.hover\\:bg-word-color-500\\/95:hover{
  background-color: rgba(44, 135, 109, 0.95);
}

.hover\\:bg-word-color-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(34, 121, 98, 1);
  background-color: rgba(34, 121, 98, var(--tw-bg-opacity, 1));
}

.hover\\:bg-word-color-600\\/0:hover{
  background-color: rgba(34, 121, 98, 0);
}

.hover\\:bg-word-color-600\\/10:hover{
  background-color: rgba(34, 121, 98, 0.1);
}

.hover\\:bg-word-color-600\\/100:hover{
  background-color: rgb(34, 121, 98);
}

.hover\\:bg-word-color-600\\/15:hover{
  background-color: rgba(34, 121, 98, 0.15);
}

.hover\\:bg-word-color-600\\/20:hover{
  background-color: rgba(34, 121, 98, 0.2);
}

.hover\\:bg-word-color-600\\/25:hover{
  background-color: rgba(34, 121, 98, 0.25);
}

.hover\\:bg-word-color-600\\/30:hover{
  background-color: rgba(34, 121, 98, 0.3);
}

.hover\\:bg-word-color-600\\/35:hover{
  background-color: rgba(34, 121, 98, 0.35);
}

.hover\\:bg-word-color-600\\/40:hover{
  background-color: rgba(34, 121, 98, 0.4);
}

.hover\\:bg-word-color-600\\/45:hover{
  background-color: rgba(34, 121, 98, 0.45);
}

.hover\\:bg-word-color-600\\/5:hover{
  background-color: rgba(34, 121, 98, 0.05);
}

.hover\\:bg-word-color-600\\/50:hover{
  background-color: rgba(34, 121, 98, 0.5);
}

.hover\\:bg-word-color-600\\/55:hover{
  background-color: rgba(34, 121, 98, 0.55);
}

.hover\\:bg-word-color-600\\/60:hover{
  background-color: rgba(34, 121, 98, 0.6);
}

.hover\\:bg-word-color-600\\/65:hover{
  background-color: rgba(34, 121, 98, 0.65);
}

.hover\\:bg-word-color-600\\/70:hover{
  background-color: rgba(34, 121, 98, 0.7);
}

.hover\\:bg-word-color-600\\/75:hover{
  background-color: rgba(34, 121, 98, 0.75);
}

.hover\\:bg-word-color-600\\/80:hover{
  background-color: rgba(34, 121, 98, 0.8);
}

.hover\\:bg-word-color-600\\/85:hover{
  background-color: rgba(34, 121, 98, 0.85);
}

.hover\\:bg-word-color-600\\/90:hover{
  background-color: rgba(34, 121, 98, 0.9);
}

.hover\\:bg-word-color-600\\/95:hover{
  background-color: rgba(34, 121, 98, 0.95);
}

.hover\\:bg-word-color-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(27, 97, 80, 1);
  background-color: rgba(27, 97, 80, var(--tw-bg-opacity, 1));
}

.hover\\:bg-word-color-700\\/0:hover{
  background-color: rgba(27, 97, 80, 0);
}

.hover\\:bg-word-color-700\\/10:hover{
  background-color: rgba(27, 97, 80, 0.1);
}

.hover\\:bg-word-color-700\\/100:hover{
  background-color: rgb(27, 97, 80);
}

.hover\\:bg-word-color-700\\/15:hover{
  background-color: rgba(27, 97, 80, 0.15);
}

.hover\\:bg-word-color-700\\/20:hover{
  background-color: rgba(27, 97, 80, 0.2);
}

.hover\\:bg-word-color-700\\/25:hover{
  background-color: rgba(27, 97, 80, 0.25);
}

.hover\\:bg-word-color-700\\/30:hover{
  background-color: rgba(27, 97, 80, 0.3);
}

.hover\\:bg-word-color-700\\/35:hover{
  background-color: rgba(27, 97, 80, 0.35);
}

.hover\\:bg-word-color-700\\/40:hover{
  background-color: rgba(27, 97, 80, 0.4);
}

.hover\\:bg-word-color-700\\/45:hover{
  background-color: rgba(27, 97, 80, 0.45);
}

.hover\\:bg-word-color-700\\/5:hover{
  background-color: rgba(27, 97, 80, 0.05);
}

.hover\\:bg-word-color-700\\/50:hover{
  background-color: rgba(27, 97, 80, 0.5);
}

.hover\\:bg-word-color-700\\/55:hover{
  background-color: rgba(27, 97, 80, 0.55);
}

.hover\\:bg-word-color-700\\/60:hover{
  background-color: rgba(27, 97, 80, 0.6);
}

.hover\\:bg-word-color-700\\/65:hover{
  background-color: rgba(27, 97, 80, 0.65);
}

.hover\\:bg-word-color-700\\/70:hover{
  background-color: rgba(27, 97, 80, 0.7);
}

.hover\\:bg-word-color-700\\/75:hover{
  background-color: rgba(27, 97, 80, 0.75);
}

.hover\\:bg-word-color-700\\/80:hover{
  background-color: rgba(27, 97, 80, 0.8);
}

.hover\\:bg-word-color-700\\/85:hover{
  background-color: rgba(27, 97, 80, 0.85);
}

.hover\\:bg-word-color-700\\/90:hover{
  background-color: rgba(27, 97, 80, 0.9);
}

.hover\\:bg-word-color-700\\/95:hover{
  background-color: rgba(27, 97, 80, 0.95);
}

.hover\\:bg-word-color-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(24, 77, 64, 1);
  background-color: rgba(24, 77, 64, var(--tw-bg-opacity, 1));
}

.hover\\:bg-word-color-800\\/0:hover{
  background-color: rgba(24, 77, 64, 0);
}

.hover\\:bg-word-color-800\\/10:hover{
  background-color: rgba(24, 77, 64, 0.1);
}

.hover\\:bg-word-color-800\\/100:hover{
  background-color: rgb(24, 77, 64);
}

.hover\\:bg-word-color-800\\/15:hover{
  background-color: rgba(24, 77, 64, 0.15);
}

.hover\\:bg-word-color-800\\/20:hover{
  background-color: rgba(24, 77, 64, 0.2);
}

.hover\\:bg-word-color-800\\/25:hover{
  background-color: rgba(24, 77, 64, 0.25);
}

.hover\\:bg-word-color-800\\/30:hover{
  background-color: rgba(24, 77, 64, 0.3);
}

.hover\\:bg-word-color-800\\/35:hover{
  background-color: rgba(24, 77, 64, 0.35);
}

.hover\\:bg-word-color-800\\/40:hover{
  background-color: rgba(24, 77, 64, 0.4);
}

.hover\\:bg-word-color-800\\/45:hover{
  background-color: rgba(24, 77, 64, 0.45);
}

.hover\\:bg-word-color-800\\/5:hover{
  background-color: rgba(24, 77, 64, 0.05);
}

.hover\\:bg-word-color-800\\/50:hover{
  background-color: rgba(24, 77, 64, 0.5);
}

.hover\\:bg-word-color-800\\/55:hover{
  background-color: rgba(24, 77, 64, 0.55);
}

.hover\\:bg-word-color-800\\/60:hover{
  background-color: rgba(24, 77, 64, 0.6);
}

.hover\\:bg-word-color-800\\/65:hover{
  background-color: rgba(24, 77, 64, 0.65);
}

.hover\\:bg-word-color-800\\/70:hover{
  background-color: rgba(24, 77, 64, 0.7);
}

.hover\\:bg-word-color-800\\/75:hover{
  background-color: rgba(24, 77, 64, 0.75);
}

.hover\\:bg-word-color-800\\/80:hover{
  background-color: rgba(24, 77, 64, 0.8);
}

.hover\\:bg-word-color-800\\/85:hover{
  background-color: rgba(24, 77, 64, 0.85);
}

.hover\\:bg-word-color-800\\/90:hover{
  background-color: rgba(24, 77, 64, 0.9);
}

.hover\\:bg-word-color-800\\/95:hover{
  background-color: rgba(24, 77, 64, 0.95);
}

.hover\\:bg-word-color-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(20, 64, 54, 1);
  background-color: rgba(20, 64, 54, var(--tw-bg-opacity, 1));
}

.hover\\:bg-word-color-900\\/0:hover{
  background-color: rgba(20, 64, 54, 0);
}

.hover\\:bg-word-color-900\\/10:hover{
  background-color: rgba(20, 64, 54, 0.1);
}

.hover\\:bg-word-color-900\\/100:hover{
  background-color: rgb(20, 64, 54);
}

.hover\\:bg-word-color-900\\/15:hover{
  background-color: rgba(20, 64, 54, 0.15);
}

.hover\\:bg-word-color-900\\/20:hover{
  background-color: rgba(20, 64, 54, 0.2);
}

.hover\\:bg-word-color-900\\/25:hover{
  background-color: rgba(20, 64, 54, 0.25);
}

.hover\\:bg-word-color-900\\/30:hover{
  background-color: rgba(20, 64, 54, 0.3);
}

.hover\\:bg-word-color-900\\/35:hover{
  background-color: rgba(20, 64, 54, 0.35);
}

.hover\\:bg-word-color-900\\/40:hover{
  background-color: rgba(20, 64, 54, 0.4);
}

.hover\\:bg-word-color-900\\/45:hover{
  background-color: rgba(20, 64, 54, 0.45);
}

.hover\\:bg-word-color-900\\/5:hover{
  background-color: rgba(20, 64, 54, 0.05);
}

.hover\\:bg-word-color-900\\/50:hover{
  background-color: rgba(20, 64, 54, 0.5);
}

.hover\\:bg-word-color-900\\/55:hover{
  background-color: rgba(20, 64, 54, 0.55);
}

.hover\\:bg-word-color-900\\/60:hover{
  background-color: rgba(20, 64, 54, 0.6);
}

.hover\\:bg-word-color-900\\/65:hover{
  background-color: rgba(20, 64, 54, 0.65);
}

.hover\\:bg-word-color-900\\/70:hover{
  background-color: rgba(20, 64, 54, 0.7);
}

.hover\\:bg-word-color-900\\/75:hover{
  background-color: rgba(20, 64, 54, 0.75);
}

.hover\\:bg-word-color-900\\/80:hover{
  background-color: rgba(20, 64, 54, 0.8);
}

.hover\\:bg-word-color-900\\/85:hover{
  background-color: rgba(20, 64, 54, 0.85);
}

.hover\\:bg-word-color-900\\/90:hover{
  background-color: rgba(20, 64, 54, 0.9);
}

.hover\\:bg-word-color-900\\/95:hover{
  background-color: rgba(20, 64, 54, 0.95);
}

.hover\\:bg-word-color-950:hover{
  --tw-bg-opacity: 1;
  background-color: rgba(10, 36, 31, 1);
  background-color: rgba(10, 36, 31, var(--tw-bg-opacity, 1));
}

.hover\\:bg-word-color-950\\/0:hover{
  background-color: rgba(10, 36, 31, 0);
}

.hover\\:bg-word-color-950\\/10:hover{
  background-color: rgba(10, 36, 31, 0.1);
}

.hover\\:bg-word-color-950\\/100:hover{
  background-color: rgb(10, 36, 31);
}

.hover\\:bg-word-color-950\\/15:hover{
  background-color: rgba(10, 36, 31, 0.15);
}

.hover\\:bg-word-color-950\\/20:hover{
  background-color: rgba(10, 36, 31, 0.2);
}

.hover\\:bg-word-color-950\\/25:hover{
  background-color: rgba(10, 36, 31, 0.25);
}

.hover\\:bg-word-color-950\\/30:hover{
  background-color: rgba(10, 36, 31, 0.3);
}

.hover\\:bg-word-color-950\\/35:hover{
  background-color: rgba(10, 36, 31, 0.35);
}

.hover\\:bg-word-color-950\\/40:hover{
  background-color: rgba(10, 36, 31, 0.4);
}

.hover\\:bg-word-color-950\\/45:hover{
  background-color: rgba(10, 36, 31, 0.45);
}

.hover\\:bg-word-color-950\\/5:hover{
  background-color: rgba(10, 36, 31, 0.05);
}

.hover\\:bg-word-color-950\\/50:hover{
  background-color: rgba(10, 36, 31, 0.5);
}

.hover\\:bg-word-color-950\\/55:hover{
  background-color: rgba(10, 36, 31, 0.55);
}

.hover\\:bg-word-color-950\\/60:hover{
  background-color: rgba(10, 36, 31, 0.6);
}

.hover\\:bg-word-color-950\\/65:hover{
  background-color: rgba(10, 36, 31, 0.65);
}

.hover\\:bg-word-color-950\\/70:hover{
  background-color: rgba(10, 36, 31, 0.7);
}

.hover\\:bg-word-color-950\\/75:hover{
  background-color: rgba(10, 36, 31, 0.75);
}

.hover\\:bg-word-color-950\\/80:hover{
  background-color: rgba(10, 36, 31, 0.8);
}

.hover\\:bg-word-color-950\\/85:hover{
  background-color: rgba(10, 36, 31, 0.85);
}

.hover\\:bg-word-color-950\\/90:hover{
  background-color: rgba(10, 36, 31, 0.9);
}

.hover\\:bg-word-color-950\\/95:hover{
  background-color: rgba(10, 36, 31, 0.95);
}

.hover\\:from-blumine-100:hover{
  --tw-gradient-from: #daeef3 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/0:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/10:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/100:hover{
  --tw-gradient-from: rgb(218, 238, 243) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/15:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/20:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/25:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/30:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/35:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/40:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/45:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/5:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/50:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/55:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/60:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/65:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/70:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/75:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/80:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/85:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/90:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-100\\/95:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200:hover{
  --tw-gradient-from: #badee7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/0:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/10:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/100:hover{
  --tw-gradient-from: rgb(186, 222, 231) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/15:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/20:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/25:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/30:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/35:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/40:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/45:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/5:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/50:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/55:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/60:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/65:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/70:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/75:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/80:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/85:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/90:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-200\\/95:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300:hover{
  --tw-gradient-from: #89c5d7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/0:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/10:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/100:hover{
  --tw-gradient-from: rgb(137, 197, 215) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/15:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/20:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/25:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/30:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/35:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/40:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/45:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/5:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/50:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/55:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/60:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/65:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/70:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/75:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/80:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/85:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/90:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-300\\/95:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400:hover{
  --tw-gradient-from: #52a3be var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/0:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/10:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/100:hover{
  --tw-gradient-from: rgb(82, 163, 190) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/15:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/20:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/25:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/30:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/35:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/40:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/45:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/5:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/50:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/55:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/60:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/65:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/70:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/75:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/80:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/85:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/90:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-400\\/95:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500:hover{
  --tw-gradient-from: #3787a3 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/0:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/10:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/100:hover{
  --tw-gradient-from: rgb(55, 135, 163) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/15:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/20:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/25:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/30:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/35:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/40:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/45:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/5:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/50:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/55:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/60:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/65:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/70:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/75:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/80:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/85:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/90:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-500\\/95:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600:hover{
  --tw-gradient-from: #306d8a var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/0:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/10:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/100:hover{
  --tw-gradient-from: rgb(48, 109, 138) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/15:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/20:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/25:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/30:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/35:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/40:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/45:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/5:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/50:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/55:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/60:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/65:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/70:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/75:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/80:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/85:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/90:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-600\\/95:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700:hover{
  --tw-gradient-from: #2d5b72 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/0:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/10:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/100:hover{
  --tw-gradient-from: rgb(45, 91, 114) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/15:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/20:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/25:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/30:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/35:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/40:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/45:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/5:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/50:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/55:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/60:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/65:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/70:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/75:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/80:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/85:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/90:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-700\\/95:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800:hover{
  --tw-gradient-from: #2c4c5e var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/0:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/10:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/100:hover{
  --tw-gradient-from: rgb(44, 76, 94) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/15:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/20:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/25:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/30:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/35:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/40:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/45:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/5:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/50:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/55:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/60:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/65:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/70:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/75:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/80:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/85:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/90:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-800\\/95:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900:hover{
  --tw-gradient-from: #284151 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/0:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/10:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/100:hover{
  --tw-gradient-from: rgb(40, 65, 81) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/15:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/20:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/25:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/30:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/35:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/40:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/45:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/5:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/50:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/55:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/60:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/65:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/70:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/75:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/80:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/85:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/90:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-900\\/95:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950:hover{
  --tw-gradient-from: #162936 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/0:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/10:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/100:hover{
  --tw-gradient-from: rgb(22, 41, 54) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/15:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/20:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/25:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/30:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/35:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/40:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/45:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/5:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/50:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/55:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/60:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/65:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/70:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/75:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/80:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/85:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/90:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blumine-950\\/95:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100:hover{
  --tw-gradient-from: #e6e6e7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/0:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/10:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/100:hover{
  --tw-gradient-from: rgb(230, 230, 231) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/15:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/20:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/25:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/30:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/35:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/40:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/45:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/5:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/50:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/55:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/60:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/65:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/70:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/75:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/80:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/85:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/90:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-100\\/95:hover{
  --tw-gradient-from: rgba(230, 230, 231, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200:hover{
  --tw-gradient-from: #cfd0d2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/0:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/10:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/100:hover{
  --tw-gradient-from: rgb(207, 208, 210) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/15:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/20:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/25:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/30:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/35:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/40:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/45:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/5:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/50:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/55:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/60:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/65:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/70:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/75:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/80:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/85:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/90:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-200\\/95:hover{
  --tw-gradient-from: rgba(207, 208, 210, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300:hover{
  --tw-gradient-from: #aeafb2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/0:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/10:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/100:hover{
  --tw-gradient-from: rgb(174, 175, 178) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/15:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/20:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/25:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/30:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/35:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/40:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/45:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/5:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/50:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/55:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/60:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/65:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/70:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/75:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/80:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/85:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/90:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-300\\/95:hover{
  --tw-gradient-from: rgba(174, 175, 178, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400:hover{
  --tw-gradient-from: #85868b var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/0:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/10:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/100:hover{
  --tw-gradient-from: rgb(133, 134, 139) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/15:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/20:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/25:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/30:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/35:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/40:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/45:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/5:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/50:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/55:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/60:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/65:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/70:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/75:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/80:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/85:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/90:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-400\\/95:hover{
  --tw-gradient-from: rgba(133, 134, 139, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500:hover{
  --tw-gradient-from: #6a6b70 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/0:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/10:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/100:hover{
  --tw-gradient-from: rgb(106, 107, 112) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/15:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/20:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/25:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/30:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/35:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/40:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/45:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/5:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/50:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/55:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/60:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/65:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/70:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/75:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/80:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/85:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/90:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-500\\/95:hover{
  --tw-gradient-from: rgba(106, 107, 112, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600:hover{
  --tw-gradient-from: #5a5b60 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/0:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/10:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/100:hover{
  --tw-gradient-from: rgb(90, 91, 96) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/15:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/20:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/25:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/30:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/35:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/40:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/45:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/5:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/50:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/55:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/60:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/65:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/70:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/75:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/80:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/85:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/90:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-600\\/95:hover{
  --tw-gradient-from: rgba(90, 91, 96, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700:hover{
  --tw-gradient-from: #4d4d51 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/0:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/10:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/100:hover{
  --tw-gradient-from: rgb(77, 77, 81) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/15:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/20:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/25:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/30:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/35:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/40:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/45:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/5:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/50:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/55:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/60:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/65:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/70:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/75:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/80:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/85:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/90:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-700\\/95:hover{
  --tw-gradient-from: rgba(77, 77, 81, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800:hover{
  --tw-gradient-from: #434347 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/0:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/10:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/100:hover{
  --tw-gradient-from: rgb(67, 67, 71) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/15:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/20:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/25:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/30:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/35:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/40:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/45:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/5:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/50:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/55:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/60:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/65:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/70:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/75:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/80:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/85:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/90:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-800\\/95:hover{
  --tw-gradient-from: rgba(67, 67, 71, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900:hover{
  --tw-gradient-from: #313133 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/0:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/10:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/100:hover{
  --tw-gradient-from: rgb(49, 49, 51) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/15:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/20:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/25:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/30:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/35:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/40:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/45:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/5:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/50:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/55:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/60:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/65:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/70:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/75:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/80:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/85:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/90:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-900\\/95:hover{
  --tw-gradient-from: rgba(49, 49, 51, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950:hover{
  --tw-gradient-from: #252527 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/0:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/10:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/100:hover{
  --tw-gradient-from: rgb(37, 37, 39) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/15:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/20:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/25:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/30:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/35:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/40:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/45:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/5:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/50:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/55:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/60:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/65:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/70:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/75:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/80:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/85:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/90:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-charcoal-950\\/95:hover{
  --tw-gradient-from: rgba(37, 37, 39, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100:hover{
  --tw-gradient-from: #d9f2e6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/0:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/10:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/100:hover{
  --tw-gradient-from: rgb(217, 242, 230) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/15:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/20:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/25:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/30:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/35:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/40:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/45:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/5:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/50:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/55:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/60:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/65:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/70:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/75:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/80:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/85:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/90:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-100\\/95:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200:hover{
  --tw-gradient-from: #b6e4d1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/0:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/10:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/100:hover{
  --tw-gradient-from: rgb(182, 228, 209) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/15:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/20:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/25:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/30:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/35:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/40:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/45:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/5:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/50:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/55:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/60:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/65:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/70:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/75:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/80:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/85:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/90:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-200\\/95:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300:hover{
  --tw-gradient-from: #86cfb5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/0:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/10:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/100:hover{
  --tw-gradient-from: rgb(134, 207, 181) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/15:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/20:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/25:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/30:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/35:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/40:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/45:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/5:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/50:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/55:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/60:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/65:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/70:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/75:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/80:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/85:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/90:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-300\\/95:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400:hover{
  --tw-gradient-from: #53b494 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/0:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/10:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/100:hover{
  --tw-gradient-from: rgb(83, 180, 148) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/15:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/20:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/25:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/30:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/35:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/40:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/45:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/5:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/50:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/55:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/60:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/65:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/70:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/75:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/80:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/85:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/90:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-400\\/95:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500:hover{
  --tw-gradient-from: #2c876d var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/0:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/10:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/100:hover{
  --tw-gradient-from: rgb(44, 135, 109) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/15:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/20:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/25:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/30:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/35:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/40:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/45:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/5:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/50:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/55:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/60:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/65:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/70:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/75:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/80:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/85:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/90:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-500\\/95:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600:hover{
  --tw-gradient-from: #227962 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/0:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/10:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/100:hover{
  --tw-gradient-from: rgb(34, 121, 98) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/15:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/20:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/25:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/30:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/35:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/40:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/45:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/5:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/50:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/55:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/60:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/65:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/70:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/75:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/80:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/85:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/90:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-600\\/95:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700:hover{
  --tw-gradient-from: #1b6150 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/0:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/10:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/100:hover{
  --tw-gradient-from: rgb(27, 97, 80) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/15:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/20:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/25:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/30:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/35:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/40:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/45:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/5:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/50:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/55:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/60:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/65:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/70:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/75:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/80:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/85:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/90:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-700\\/95:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800:hover{
  --tw-gradient-from: #184d40 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/0:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/10:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/100:hover{
  --tw-gradient-from: rgb(24, 77, 64) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/15:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/20:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/25:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/30:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/35:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/40:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/45:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/5:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/50:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/55:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/60:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/65:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/70:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/75:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/80:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/85:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/90:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-800\\/95:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900:hover{
  --tw-gradient-from: #144036 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/0:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/10:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/100:hover{
  --tw-gradient-from: rgb(20, 64, 54) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/15:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/20:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/25:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/30:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/35:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/40:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/45:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/5:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/50:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/55:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/60:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/65:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/70:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/75:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/80:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/85:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/90:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-900\\/95:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950:hover{
  --tw-gradient-from: #0a241f var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/0:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/10:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/100:hover{
  --tw-gradient-from: rgb(10, 36, 31) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/15:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/20:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/25:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/30:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/35:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/40:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/45:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/5:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/50:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/55:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/60:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/65:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/70:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/75:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/80:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/85:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/90:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-jade-950\\/95:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500:hover{
  --tw-gradient-from: #3787a3 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/0:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/10:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/100:hover{
  --tw-gradient-from: rgb(55, 135, 163) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/15:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/20:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/25:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/30:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/35:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/40:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/45:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/5:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/50:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/55:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/60:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/65:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/70:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/75:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/80:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/85:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/90:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-500\\/95:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600:hover{
  --tw-gradient-from: #306d8a var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/0:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/10:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/100:hover{
  --tw-gradient-from: rgb(48, 109, 138) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/15:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/20:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/25:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/30:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/35:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/40:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/45:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/5:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/50:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/55:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/60:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/65:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/70:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/75:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/80:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/85:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/90:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-600\\/95:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700:hover{
  --tw-gradient-from: #2d5b72 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/0:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/10:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/100:hover{
  --tw-gradient-from: rgb(45, 91, 114) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/15:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/20:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/25:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/30:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/35:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/40:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/45:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/5:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/50:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/55:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/60:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/65:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/70:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/75:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/80:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/85:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/90:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-700\\/95:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800:hover{
  --tw-gradient-from: #2c4c5e var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/0:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/10:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/100:hover{
  --tw-gradient-from: rgb(44, 76, 94) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/15:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/20:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/25:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/30:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/35:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/40:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/45:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/5:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/50:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/55:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/60:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/65:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/70:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/75:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/80:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/85:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/90:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-800\\/95:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900:hover{
  --tw-gradient-from: #284151 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/0:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/10:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/100:hover{
  --tw-gradient-from: rgb(40, 65, 81) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/15:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/20:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/25:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/30:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/35:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/40:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/45:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/5:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/50:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/55:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/60:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/65:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/70:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/75:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/80:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/85:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/90:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-alphabet-900\\/95:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500:hover{
  --tw-gradient-from: #d1912f var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/0:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/10:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/100:hover{
  --tw-gradient-from: rgb(209, 145, 47) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/15:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/20:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/25:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/30:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/35:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/40:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/45:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/5:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/50:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/55:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/60:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/65:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/70:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/75:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/80:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/85:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/90:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-500\\/95:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600:hover{
  --tw-gradient-from: #c37829 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/0:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/10:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/100:hover{
  --tw-gradient-from: rgb(195, 120, 41) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/15:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/20:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/25:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/30:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/35:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/40:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/45:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/5:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/50:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/55:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/60:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/65:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/70:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/75:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/80:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/85:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/90:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-600\\/95:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700:hover{
  --tw-gradient-from: #995424 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/0:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/10:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/100:hover{
  --tw-gradient-from: rgb(153, 84, 36) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/15:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/20:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/25:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/30:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/35:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/40:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/45:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/5:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/50:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/55:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/60:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/65:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/70:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/75:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/80:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/85:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/90:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-700\\/95:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800:hover{
  --tw-gradient-from: #7e4322 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/0:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/10:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/100:hover{
  --tw-gradient-from: rgb(126, 67, 34) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/15:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/20:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/25:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/30:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/35:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/40:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/45:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/5:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/50:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/55:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/60:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/65:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/70:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/75:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/80:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/85:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/90:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-800\\/95:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900:hover{
  --tw-gradient-from: #68381f var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/0:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/10:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/100:hover{
  --tw-gradient-from: rgb(104, 56, 31) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/15:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/20:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/25:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/30:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/35:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/40:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/45:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/5:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/50:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/55:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/60:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/65:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/70:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/75:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/80:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/85:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/90:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-categories-900\\/95:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500:hover{
  --tw-gradient-from: #2c876d var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/0:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/10:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/100:hover{
  --tw-gradient-from: rgb(44, 135, 109) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/15:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/20:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/25:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/30:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/35:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/40:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/45:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/5:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/50:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/55:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/60:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/65:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/70:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/75:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/80:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/85:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/90:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-500\\/95:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600:hover{
  --tw-gradient-from: #227962 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/0:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/10:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/100:hover{
  --tw-gradient-from: rgb(34, 121, 98) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/15:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/20:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/25:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/30:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/35:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/40:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/45:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/5:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/50:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/55:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/60:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/65:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/70:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/75:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/80:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/85:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/90:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-600\\/95:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700:hover{
  --tw-gradient-from: #1b6150 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/0:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/10:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/100:hover{
  --tw-gradient-from: rgb(27, 97, 80) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/15:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/20:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/25:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/30:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/35:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/40:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/45:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/5:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/50:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/55:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/60:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/65:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/70:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/75:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/80:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/85:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/90:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-700\\/95:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800:hover{
  --tw-gradient-from: #184d40 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/0:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/10:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/100:hover{
  --tw-gradient-from: rgb(24, 77, 64) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/15:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/20:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/25:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/30:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/35:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/40:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/45:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/5:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/50:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/55:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/60:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/65:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/70:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/75:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/80:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/85:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/90:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-800\\/95:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900:hover{
  --tw-gradient-from: #144036 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/0:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/10:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/100:hover{
  --tw-gradient-from: rgb(20, 64, 54) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/15:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/20:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/25:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/30:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/35:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/40:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/45:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/5:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/50:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/55:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/60:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/65:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/70:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/75:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/80:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/85:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/90:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-dictionary-900\\/95:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500:hover{
  --tw-gradient-from: #513B56 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/0:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/10:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/100:hover{
  --tw-gradient-from: rgb(81, 59, 86) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/15:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/20:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/25:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/30:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/35:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/40:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/45:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/5:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/50:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/55:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/60:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/65:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/70:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/75:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/80:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/85:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/90:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-500\\/95:hover{
  --tw-gradient-from: rgba(81, 59, 86, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900:hover{
  --tw-gradient-from: #39293c var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/0:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/10:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/100:hover{
  --tw-gradient-from: rgb(57, 41, 60) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/15:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/20:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/25:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/30:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/35:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/40:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/45:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/5:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/50:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/55:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/60:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/65:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/70:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/75:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/80:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/85:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/90:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-games-900\\/95:hover{
  --tw-gradient-from: rgba(57, 41, 60, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500:hover{
  --tw-gradient-from: #830042 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/0:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/10:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/100:hover{
  --tw-gradient-from: rgb(131, 0, 66) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/15:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/20:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/25:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/30:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/35:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/40:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/45:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/5:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/50:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/55:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/60:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/65:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/70:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/75:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/80:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/85:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/90:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-500\\/95:hover{
  --tw-gradient-from: rgba(131, 0, 66, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900:hover{
  --tw-gradient-from: #5c002e var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/0:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/10:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/100:hover{
  --tw-gradient-from: rgb(92, 0, 46) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/15:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/20:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/25:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/30:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/35:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/40:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/45:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/5:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/50:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/55:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/60:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/65:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/70:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/75:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/80:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/85:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/90:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-songs-900\\/95:hover{
  --tw-gradient-from: rgba(92, 0, 46, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500:hover{
  --tw-gradient-from: #E9C46A var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/0:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/10:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/100:hover{
  --tw-gradient-from: rgb(233, 196, 106) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/15:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/20:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/25:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/30:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/35:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/40:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/45:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/5:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/50:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/55:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/60:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/65:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/70:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/75:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/80:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/85:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/90:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-500\\/95:hover{
  --tw-gradient-from: rgba(233, 196, 106, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900:hover{
  --tw-gradient-from: #a3894a var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/0:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/10:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/100:hover{
  --tw-gradient-from: rgb(163, 137, 74) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/15:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/20:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/25:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/30:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/35:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/40:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/45:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/5:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/50:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/55:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/60:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/65:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/70:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/75:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/80:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/85:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/90:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-kids-stories-900\\/95:hover{
  --tw-gradient-from: rgba(163, 137, 74, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100:hover{
  --tw-gradient-from: #f5edd0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/0:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/10:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/100:hover{
  --tw-gradient-from: rgb(245, 237, 208) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/15:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/20:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/25:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/30:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/35:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/40:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/45:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/5:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/50:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/55:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/60:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/65:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/70:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/75:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/80:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/85:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/90:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-100\\/95:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200:hover{
  --tw-gradient-from: #ebd99c var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/0:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/10:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/100:hover{
  --tw-gradient-from: rgb(235, 217, 156) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/15:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/20:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/25:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/30:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/35:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/40:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/45:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/5:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/50:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/55:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/60:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/65:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/70:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/75:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/80:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/85:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/90:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-200\\/95:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300:hover{
  --tw-gradient-from: #e1c268 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/0:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/10:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/100:hover{
  --tw-gradient-from: rgb(225, 194, 104) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/15:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/20:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/25:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/30:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/35:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/40:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/45:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/5:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/50:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/55:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/60:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/65:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/70:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/75:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/80:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/85:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/90:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-300\\/95:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400:hover{
  --tw-gradient-from: #daad45 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/0:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/10:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/100:hover{
  --tw-gradient-from: rgb(218, 173, 69) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/15:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/20:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/25:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/30:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/35:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/40:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/45:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/5:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/50:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/55:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/60:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/65:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/70:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/75:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/80:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/85:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/90:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-400\\/95:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500:hover{
  --tw-gradient-from: #d1912f var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/0:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/10:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/100:hover{
  --tw-gradient-from: rgb(209, 145, 47) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/15:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/20:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/25:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/30:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/35:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/40:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/45:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/5:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/50:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/55:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/60:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/65:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/70:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/75:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/80:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/85:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/90:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-500\\/95:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600:hover{
  --tw-gradient-from: #c37829 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/0:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/10:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/100:hover{
  --tw-gradient-from: rgb(195, 120, 41) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/15:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/20:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/25:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/30:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/35:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/40:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/45:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/5:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/50:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/55:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/60:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/65:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/70:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/75:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/80:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/85:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/90:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-600\\/95:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700:hover{
  --tw-gradient-from: #995424 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/0:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/10:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/100:hover{
  --tw-gradient-from: rgb(153, 84, 36) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/15:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/20:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/25:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/30:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/35:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/40:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/45:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/5:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/50:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/55:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/60:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/65:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/70:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/75:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/80:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/85:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/90:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-700\\/95:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800:hover{
  --tw-gradient-from: #7e4322 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/0:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/10:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/100:hover{
  --tw-gradient-from: rgb(126, 67, 34) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/15:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/20:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/25:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/30:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/35:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/40:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/45:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/5:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/50:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/55:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/60:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/65:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/70:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/75:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/80:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/85:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/90:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-800\\/95:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900:hover{
  --tw-gradient-from: #68381f var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/0:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/10:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/100:hover{
  --tw-gradient-from: rgb(104, 56, 31) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/15:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/20:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/25:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/30:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/35:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/40:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/45:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/5:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/50:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/55:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/60:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/65:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/70:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/75:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/80:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/85:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/90:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-900\\/95:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950:hover{
  --tw-gradient-from: #3b1c0d var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/0:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/10:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/100:hover{
  --tw-gradient-from: rgb(59, 28, 13) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/15:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/20:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/25:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/30:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/35:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/40:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/45:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/5:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/50:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/55:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/60:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/65:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/70:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/75:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/80:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/85:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/90:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-ochre-950\\/95:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100:hover{
  --tw-gradient-from: #f5edd0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/0:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/10:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/100:hover{
  --tw-gradient-from: rgb(245, 237, 208) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/15:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/20:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/25:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/30:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/35:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/40:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/45:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/5:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/50:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/55:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/60:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/65:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/70:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/75:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/80:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/85:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/90:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-100\\/95:hover{
  --tw-gradient-from: rgba(245, 237, 208, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200:hover{
  --tw-gradient-from: #ebd99c var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/0:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/10:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/100:hover{
  --tw-gradient-from: rgb(235, 217, 156) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/15:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/20:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/25:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/30:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/35:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/40:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/45:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/5:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/50:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/55:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/60:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/65:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/70:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/75:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/80:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/85:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/90:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-200\\/95:hover{
  --tw-gradient-from: rgba(235, 217, 156, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300:hover{
  --tw-gradient-from: #e1c268 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/0:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/10:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/100:hover{
  --tw-gradient-from: rgb(225, 194, 104) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/15:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/20:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/25:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/30:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/35:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/40:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/45:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/5:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/50:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/55:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/60:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/65:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/70:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/75:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/80:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/85:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/90:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-300\\/95:hover{
  --tw-gradient-from: rgba(225, 194, 104, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400:hover{
  --tw-gradient-from: #daad45 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/0:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/10:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/100:hover{
  --tw-gradient-from: rgb(218, 173, 69) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/15:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/20:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/25:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/30:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/35:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/40:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/45:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/5:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/50:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/55:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/60:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/65:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/70:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/75:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/80:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/85:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/90:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-400\\/95:hover{
  --tw-gradient-from: rgba(218, 173, 69, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500:hover{
  --tw-gradient-from: #d1912f var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/0:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/10:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/100:hover{
  --tw-gradient-from: rgb(209, 145, 47) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/15:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/20:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/25:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/30:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/35:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/40:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/45:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/5:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/50:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/55:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/60:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/65:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/70:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/75:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/80:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/85:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/90:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-500\\/95:hover{
  --tw-gradient-from: rgba(209, 145, 47, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600:hover{
  --tw-gradient-from: #c37829 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/0:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/10:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/100:hover{
  --tw-gradient-from: rgb(195, 120, 41) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/15:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/20:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/25:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/30:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/35:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/40:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/45:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/5:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/50:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/55:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/60:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/65:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/70:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/75:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/80:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/85:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/90:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-600\\/95:hover{
  --tw-gradient-from: rgba(195, 120, 41, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700:hover{
  --tw-gradient-from: #995424 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/0:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/10:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/100:hover{
  --tw-gradient-from: rgb(153, 84, 36) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/15:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/20:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/25:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/30:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/35:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/40:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/45:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/5:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/50:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/55:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/60:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/65:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/70:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/75:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/80:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/85:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/90:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-700\\/95:hover{
  --tw-gradient-from: rgba(153, 84, 36, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800:hover{
  --tw-gradient-from: #7e4322 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/0:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/10:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/100:hover{
  --tw-gradient-from: rgb(126, 67, 34) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/15:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/20:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/25:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/30:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/35:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/40:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/45:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/5:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/50:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/55:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/60:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/65:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/70:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/75:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/80:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/85:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/90:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-800\\/95:hover{
  --tw-gradient-from: rgba(126, 67, 34, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900:hover{
  --tw-gradient-from: #68381f var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/0:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/10:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/100:hover{
  --tw-gradient-from: rgb(104, 56, 31) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/15:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/20:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/25:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/30:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/35:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/40:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/45:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/5:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/50:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/55:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/60:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/65:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/70:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/75:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/80:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/85:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/90:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-900\\/95:hover{
  --tw-gradient-from: rgba(104, 56, 31, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950:hover{
  --tw-gradient-from: #3b1c0d var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/0:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/10:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/100:hover{
  --tw-gradient-from: rgb(59, 28, 13) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/15:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/20:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/25:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/30:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/35:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/40:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/45:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/5:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/50:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/55:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/60:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/65:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/70:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/75:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/80:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/85:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/90:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-phrase-color-950\\/95:hover{
  --tw-gradient-from: rgba(59, 28, 13, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100:hover{
  --tw-gradient-from: #ffdcdf var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/0:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/10:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/100:hover{
  --tw-gradient-from: rgb(255, 220, 223) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/15:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/20:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/25:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/30:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/35:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/40:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/45:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/5:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/50:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/55:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/60:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/65:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/70:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/75:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/80:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/85:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/90:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-100\\/95:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200:hover{
  --tw-gradient-from: #ffc0c6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/0:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/10:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/100:hover{
  --tw-gradient-from: rgb(255, 192, 198) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/15:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/20:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/25:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/30:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/35:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/40:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/45:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/5:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/50:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/55:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/60:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/65:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/70:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/75:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/80:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/85:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/90:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-200\\/95:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300:hover{
  --tw-gradient-from: #ff949e var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/0:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/10:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/100:hover{
  --tw-gradient-from: rgb(255, 148, 158) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/15:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/20:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/25:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/30:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/35:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/40:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/45:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/5:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/50:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/55:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/60:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/65:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/70:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/75:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/80:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/85:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/90:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-300\\/95:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400:hover{
  --tw-gradient-from: #ff5665 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/0:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/10:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/100:hover{
  --tw-gradient-from: rgb(255, 86, 101) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/15:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/20:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/25:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/30:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/35:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/40:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/45:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/5:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/50:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/55:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/60:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/65:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/70:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/75:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/80:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/85:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/90:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-400\\/95:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500:hover{
  --tw-gradient-from: #ff2236 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/0:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/10:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/100:hover{
  --tw-gradient-from: rgb(255, 34, 54) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/15:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/20:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/25:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/30:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/35:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/40:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/45:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/5:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/50:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/55:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/60:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/65:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/70:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/75:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/80:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/85:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/90:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-500\\/95:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600:hover{
  --tw-gradient-from: #ff0219 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/0:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/10:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/100:hover{
  --tw-gradient-from: rgb(255, 2, 25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/15:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/20:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/25:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/30:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/35:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/40:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/45:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/5:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/50:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/55:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/60:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/65:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/70:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/75:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/80:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/85:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/90:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-600\\/95:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700:hover{
  --tw-gradient-from: #d80013 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/0:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/10:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/100:hover{
  --tw-gradient-from: rgb(216, 0, 19) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/15:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/20:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/25:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/30:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/35:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/40:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/45:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/5:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/50:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/55:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/60:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/65:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/70:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/75:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/80:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/85:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/90:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-700\\/95:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800:hover{
  --tw-gradient-from: #b40212 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/0:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/10:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/100:hover{
  --tw-gradient-from: rgb(180, 2, 18) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/15:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/20:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/25:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/30:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/35:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/40:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/45:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/5:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/50:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/55:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/60:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/65:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/70:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/75:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/80:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/85:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/90:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-800\\/95:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900:hover{
  --tw-gradient-from: #920a16 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/0:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/10:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/100:hover{
  --tw-gradient-from: rgb(146, 10, 22) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/15:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/20:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/25:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/30:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/35:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/40:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/45:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/5:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/50:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/55:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/60:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/65:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/70:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/75:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/80:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/85:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/90:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-900\\/95:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950:hover{
  --tw-gradient-from: #510007 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/0:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/10:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/100:hover{
  --tw-gradient-from: rgb(81, 0, 7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/15:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/20:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/25:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/30:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/35:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/40:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/45:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/5:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/50:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/55:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/60:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/65:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/70:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/75:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/80:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/85:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/90:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-scarlet-950\\/95:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100:hover{
  --tw-gradient-from: #ffdcdf var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/0:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/10:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/100:hover{
  --tw-gradient-from: rgb(255, 220, 223) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/15:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/20:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/25:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/30:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/35:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/40:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/45:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/5:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/50:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/55:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/60:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/65:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/70:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/75:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/80:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/85:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/90:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-100\\/95:hover{
  --tw-gradient-from: rgba(255, 220, 223, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200:hover{
  --tw-gradient-from: #ffc0c6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/0:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/10:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/100:hover{
  --tw-gradient-from: rgb(255, 192, 198) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/15:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/20:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/25:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/30:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/35:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/40:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/45:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/5:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/50:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/55:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/60:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/65:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/70:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/75:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/80:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/85:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/90:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-200\\/95:hover{
  --tw-gradient-from: rgba(255, 192, 198, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300:hover{
  --tw-gradient-from: #ff949e var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/0:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/10:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/100:hover{
  --tw-gradient-from: rgb(255, 148, 158) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/15:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/20:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/25:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/30:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/35:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/40:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/45:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/5:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/50:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/55:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/60:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/65:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/70:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/75:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/80:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/85:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/90:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-300\\/95:hover{
  --tw-gradient-from: rgba(255, 148, 158, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400:hover{
  --tw-gradient-from: #ff5665 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/0:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/10:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/100:hover{
  --tw-gradient-from: rgb(255, 86, 101) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/15:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/20:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/25:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/30:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/35:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/40:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/45:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/5:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/50:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/55:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/60:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/65:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/70:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/75:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/80:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/85:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/90:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-400\\/95:hover{
  --tw-gradient-from: rgba(255, 86, 101, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500:hover{
  --tw-gradient-from: #ff2236 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/0:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/10:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/100:hover{
  --tw-gradient-from: rgb(255, 34, 54) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/15:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/20:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/25:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/30:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/35:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/40:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/45:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/5:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/50:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/55:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/60:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/65:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/70:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/75:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/80:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/85:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/90:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-500\\/95:hover{
  --tw-gradient-from: rgba(255, 34, 54, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600:hover{
  --tw-gradient-from: #ff0219 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/0:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/10:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/100:hover{
  --tw-gradient-from: rgb(255, 2, 25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/15:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/20:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/25:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/30:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/35:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/40:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/45:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/5:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/50:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/55:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/60:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/65:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/70:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/75:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/80:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/85:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/90:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-600\\/95:hover{
  --tw-gradient-from: rgba(255, 2, 25, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700:hover{
  --tw-gradient-from: #d80013 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/0:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/10:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/100:hover{
  --tw-gradient-from: rgb(216, 0, 19) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/15:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/20:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/25:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/30:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/35:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/40:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/45:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/5:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/50:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/55:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/60:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/65:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/70:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/75:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/80:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/85:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/90:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-700\\/95:hover{
  --tw-gradient-from: rgba(216, 0, 19, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800:hover{
  --tw-gradient-from: #b40212 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/0:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/10:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/100:hover{
  --tw-gradient-from: rgb(180, 2, 18) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/15:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/20:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/25:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/30:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/35:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/40:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/45:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/5:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/50:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/55:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/60:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/65:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/70:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/75:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/80:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/85:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/90:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-800\\/95:hover{
  --tw-gradient-from: rgba(180, 2, 18, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900:hover{
  --tw-gradient-from: #920a16 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/0:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/10:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/100:hover{
  --tw-gradient-from: rgb(146, 10, 22) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/15:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/20:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/25:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/30:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/35:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/40:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/45:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/5:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/50:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/55:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/60:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/65:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/70:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/75:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/80:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/85:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/90:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-900\\/95:hover{
  --tw-gradient-from: rgba(146, 10, 22, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950:hover{
  --tw-gradient-from: #510007 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/0:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/10:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/100:hover{
  --tw-gradient-from: rgb(81, 0, 7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/15:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/20:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/25:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/30:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/35:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/40:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/45:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/5:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/50:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/55:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/60:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/65:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/70:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/75:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/80:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/85:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/90:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-song-color-950\\/95:hover{
  --tw-gradient-from: rgba(81, 0, 7, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100:hover{
  --tw-gradient-from: #daeef3 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/0:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/10:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/100:hover{
  --tw-gradient-from: rgb(218, 238, 243) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/15:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/20:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/25:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/30:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/35:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/40:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/45:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/5:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/50:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/55:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/60:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/65:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/70:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/75:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/80:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/85:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/90:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-100\\/95:hover{
  --tw-gradient-from: rgba(218, 238, 243, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200:hover{
  --tw-gradient-from: #badee7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/0:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/10:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/100:hover{
  --tw-gradient-from: rgb(186, 222, 231) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/15:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/20:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/25:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/30:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/35:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/40:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/45:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/5:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/50:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/55:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/60:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/65:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/70:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/75:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/80:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/85:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/90:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-200\\/95:hover{
  --tw-gradient-from: rgba(186, 222, 231, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300:hover{
  --tw-gradient-from: #89c5d7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/0:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/10:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/100:hover{
  --tw-gradient-from: rgb(137, 197, 215) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/15:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/20:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/25:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/30:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/35:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/40:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/45:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/5:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/50:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/55:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/60:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/65:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/70:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/75:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/80:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/85:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/90:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-300\\/95:hover{
  --tw-gradient-from: rgba(137, 197, 215, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400:hover{
  --tw-gradient-from: #52a3be var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/0:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/10:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/100:hover{
  --tw-gradient-from: rgb(82, 163, 190) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/15:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/20:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/25:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/30:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/35:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/40:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/45:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/5:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/50:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/55:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/60:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/65:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/70:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/75:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/80:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/85:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/90:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-400\\/95:hover{
  --tw-gradient-from: rgba(82, 163, 190, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500:hover{
  --tw-gradient-from: #3787a3 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/0:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/10:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/100:hover{
  --tw-gradient-from: rgb(55, 135, 163) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/15:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/20:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/25:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/30:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/35:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/40:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/45:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/5:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/50:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/55:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/60:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/65:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/70:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/75:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/80:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/85:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/90:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-500\\/95:hover{
  --tw-gradient-from: rgba(55, 135, 163, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600:hover{
  --tw-gradient-from: #306d8a var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/0:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/10:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/100:hover{
  --tw-gradient-from: rgb(48, 109, 138) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/15:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/20:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/25:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/30:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/35:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/40:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/45:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/5:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/50:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/55:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/60:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/65:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/70:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/75:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/80:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/85:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/90:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-600\\/95:hover{
  --tw-gradient-from: rgba(48, 109, 138, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700:hover{
  --tw-gradient-from: #2d5b72 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/0:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/10:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/100:hover{
  --tw-gradient-from: rgb(45, 91, 114) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/15:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/20:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/25:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/30:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/35:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/40:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/45:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/5:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/50:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/55:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/60:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/65:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/70:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/75:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/80:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/85:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/90:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-700\\/95:hover{
  --tw-gradient-from: rgba(45, 91, 114, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800:hover{
  --tw-gradient-from: #2c4c5e var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/0:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/10:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/100:hover{
  --tw-gradient-from: rgb(44, 76, 94) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/15:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/20:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/25:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/30:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/35:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/40:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/45:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/5:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/50:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/55:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/60:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/65:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/70:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/75:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/80:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/85:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/90:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-800\\/95:hover{
  --tw-gradient-from: rgba(44, 76, 94, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900:hover{
  --tw-gradient-from: #284151 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/0:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/10:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/100:hover{
  --tw-gradient-from: rgb(40, 65, 81) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/15:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/20:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/25:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/30:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/35:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/40:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/45:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/5:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/50:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/55:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/60:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/65:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/70:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/75:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/80:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/85:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/90:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-900\\/95:hover{
  --tw-gradient-from: rgba(40, 65, 81, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950:hover{
  --tw-gradient-from: #162936 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/0:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/10:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/100:hover{
  --tw-gradient-from: rgb(22, 41, 54) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/15:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/20:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/25:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/30:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/35:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/40:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/45:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/5:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/50:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/55:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/60:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/65:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/70:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/75:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/80:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/85:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/90:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-story-color-950\\/95:hover{
  --tw-gradient-from: rgba(22, 41, 54, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100:hover{
  --tw-gradient-from: #d9f2e6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/0:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/10:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/100:hover{
  --tw-gradient-from: rgb(217, 242, 230) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/15:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/20:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/25:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/30:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/35:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/40:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/45:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/5:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/50:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/55:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/60:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/65:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/70:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/75:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/80:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/85:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/90:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-100\\/95:hover{
  --tw-gradient-from: rgba(217, 242, 230, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200:hover{
  --tw-gradient-from: #b6e4d1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/0:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/10:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/100:hover{
  --tw-gradient-from: rgb(182, 228, 209) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/15:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/20:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/25:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/30:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/35:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/40:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/45:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/5:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/50:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/55:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/60:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/65:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/70:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/75:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/80:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/85:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/90:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-200\\/95:hover{
  --tw-gradient-from: rgba(182, 228, 209, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300:hover{
  --tw-gradient-from: #86cfb5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/0:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/10:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/100:hover{
  --tw-gradient-from: rgb(134, 207, 181) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/15:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/20:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/25:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/30:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/35:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/40:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/45:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/5:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/50:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/55:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/60:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/65:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/70:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/75:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/80:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/85:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/90:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-300\\/95:hover{
  --tw-gradient-from: rgba(134, 207, 181, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400:hover{
  --tw-gradient-from: #53b494 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/0:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/10:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/100:hover{
  --tw-gradient-from: rgb(83, 180, 148) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/15:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/20:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/25:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/30:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/35:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/40:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/45:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/5:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/50:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/55:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/60:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/65:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/70:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/75:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/80:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/85:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/90:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-400\\/95:hover{
  --tw-gradient-from: rgba(83, 180, 148, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500:hover{
  --tw-gradient-from: #2c876d var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/0:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/10:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/100:hover{
  --tw-gradient-from: rgb(44, 135, 109) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/15:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/20:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/25:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/30:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/35:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/40:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/45:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/5:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/50:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/55:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/60:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/65:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/70:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/75:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/80:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/85:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/90:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-500\\/95:hover{
  --tw-gradient-from: rgba(44, 135, 109, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600:hover{
  --tw-gradient-from: #227962 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/0:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/10:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/100:hover{
  --tw-gradient-from: rgb(34, 121, 98) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/15:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/20:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/25:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/30:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/35:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/40:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/45:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/5:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/50:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/55:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/60:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/65:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/70:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/75:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/80:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/85:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/90:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-600\\/95:hover{
  --tw-gradient-from: rgba(34, 121, 98, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700:hover{
  --tw-gradient-from: #1b6150 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/0:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/10:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/100:hover{
  --tw-gradient-from: rgb(27, 97, 80) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/15:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/20:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/25:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/30:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/35:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/40:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/45:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/5:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/50:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/55:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/60:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/65:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/70:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/75:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/80:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/85:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/90:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-700\\/95:hover{
  --tw-gradient-from: rgba(27, 97, 80, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800:hover{
  --tw-gradient-from: #184d40 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/0:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/10:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/100:hover{
  --tw-gradient-from: rgb(24, 77, 64) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/15:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/20:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/25:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/30:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/35:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/40:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/45:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/5:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/50:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/55:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/60:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/65:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/70:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/75:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/80:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/85:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/90:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-800\\/95:hover{
  --tw-gradient-from: rgba(24, 77, 64, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900:hover{
  --tw-gradient-from: #144036 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/0:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/10:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/100:hover{
  --tw-gradient-from: rgb(20, 64, 54) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/15:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/20:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/25:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/30:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/35:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/40:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/45:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/5:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/50:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/55:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/60:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/65:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/70:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/75:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/80:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/85:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/90:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-900\\/95:hover{
  --tw-gradient-from: rgba(20, 64, 54, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950:hover{
  --tw-gradient-from: #0a241f var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/0:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/10:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/100:hover{
  --tw-gradient-from: rgb(10, 36, 31) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/15:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/20:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/25:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/30:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/35:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/40:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/45:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/5:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/50:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/55:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/60:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/65:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.65) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/70:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/75:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/80:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/85:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/90:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-word-color-950\\/95:hover{
  --tw-gradient-from: rgba(10, 36, 31, 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:to-blumine-100:hover{
  --tw-gradient-to: #daeef3 var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/0:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/10:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/100:hover{
  --tw-gradient-to: rgb(218, 238, 243) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/15:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/20:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/25:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/30:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/35:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/40:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/45:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/5:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/50:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/55:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/60:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/65:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/70:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/75:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/80:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/85:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/90:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-100\\/95:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200:hover{
  --tw-gradient-to: #badee7 var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/0:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/10:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/100:hover{
  --tw-gradient-to: rgb(186, 222, 231) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/15:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/20:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/25:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/30:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/35:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/40:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/45:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/5:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/50:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/55:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/60:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/65:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/70:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/75:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/80:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/85:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/90:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-200\\/95:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300:hover{
  --tw-gradient-to: #89c5d7 var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/0:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/10:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/100:hover{
  --tw-gradient-to: rgb(137, 197, 215) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/15:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/20:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/25:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/30:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/35:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/40:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/45:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/5:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/50:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/55:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/60:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/65:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/70:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/75:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/80:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/85:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/90:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-300\\/95:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400:hover{
  --tw-gradient-to: #52a3be var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/0:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/10:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/100:hover{
  --tw-gradient-to: rgb(82, 163, 190) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/15:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/20:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/25:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/30:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/35:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/40:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/45:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/5:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/50:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/55:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/60:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/65:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/70:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/75:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/80:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/85:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/90:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-400\\/95:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500:hover{
  --tw-gradient-to: #3787a3 var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/0:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/10:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/100:hover{
  --tw-gradient-to: rgb(55, 135, 163) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/15:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/20:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/25:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/30:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/35:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/40:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/45:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/5:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/50:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/55:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/60:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/65:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/70:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/75:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/80:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/85:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/90:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-500\\/95:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600:hover{
  --tw-gradient-to: #306d8a var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/0:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/10:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/100:hover{
  --tw-gradient-to: rgb(48, 109, 138) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/15:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/20:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/25:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/30:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/35:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/40:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/45:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/5:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/50:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/55:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/60:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/65:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/70:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/75:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/80:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/85:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/90:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-600\\/95:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700:hover{
  --tw-gradient-to: #2d5b72 var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/0:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/10:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/100:hover{
  --tw-gradient-to: rgb(45, 91, 114) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/15:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/20:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/25:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/30:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/35:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/40:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/45:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/5:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/50:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/55:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/60:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/65:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/70:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/75:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/80:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/85:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/90:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-700\\/95:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800:hover{
  --tw-gradient-to: #2c4c5e var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/0:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/10:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/100:hover{
  --tw-gradient-to: rgb(44, 76, 94) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/15:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/20:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/25:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/30:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/35:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/40:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/45:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/5:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/50:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/55:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/60:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/65:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/70:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/75:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/80:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/85:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/90:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-800\\/95:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900:hover{
  --tw-gradient-to: #284151 var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/0:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/10:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/100:hover{
  --tw-gradient-to: rgb(40, 65, 81) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/15:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/20:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/25:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/30:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/35:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/40:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/45:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/5:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/50:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/55:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/60:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/65:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/70:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/75:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/80:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/85:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/90:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-900\\/95:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950:hover{
  --tw-gradient-to: #162936 var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/0:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/10:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/100:hover{
  --tw-gradient-to: rgb(22, 41, 54) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/15:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/20:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/25:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/30:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/35:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/40:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/45:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/5:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/50:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/55:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/60:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/65:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/70:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/75:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/80:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/85:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/90:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-blumine-950\\/95:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100:hover{
  --tw-gradient-to: #e6e6e7 var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/0:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/10:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/100:hover{
  --tw-gradient-to: rgb(230, 230, 231) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/15:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/20:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/25:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/30:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/35:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/40:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/45:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/5:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/50:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/55:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/60:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/65:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/70:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/75:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/80:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/85:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/90:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-100\\/95:hover{
  --tw-gradient-to: rgba(230, 230, 231, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200:hover{
  --tw-gradient-to: #cfd0d2 var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/0:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/10:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/100:hover{
  --tw-gradient-to: rgb(207, 208, 210) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/15:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/20:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/25:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/30:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/35:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/40:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/45:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/5:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/50:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/55:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/60:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/65:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/70:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/75:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/80:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/85:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/90:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-200\\/95:hover{
  --tw-gradient-to: rgba(207, 208, 210, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300:hover{
  --tw-gradient-to: #aeafb2 var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/0:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/10:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/100:hover{
  --tw-gradient-to: rgb(174, 175, 178) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/15:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/20:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/25:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/30:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/35:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/40:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/45:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/5:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/50:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/55:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/60:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/65:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/70:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/75:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/80:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/85:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/90:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-300\\/95:hover{
  --tw-gradient-to: rgba(174, 175, 178, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400:hover{
  --tw-gradient-to: #85868b var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/0:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/10:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/100:hover{
  --tw-gradient-to: rgb(133, 134, 139) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/15:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/20:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/25:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/30:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/35:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/40:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/45:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/5:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/50:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/55:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/60:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/65:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/70:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/75:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/80:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/85:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/90:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-400\\/95:hover{
  --tw-gradient-to: rgba(133, 134, 139, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500:hover{
  --tw-gradient-to: #6a6b70 var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/0:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/10:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/100:hover{
  --tw-gradient-to: rgb(106, 107, 112) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/15:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/20:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/25:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/30:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/35:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/40:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/45:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/5:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/50:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/55:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/60:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/65:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/70:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/75:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/80:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/85:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/90:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-500\\/95:hover{
  --tw-gradient-to: rgba(106, 107, 112, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600:hover{
  --tw-gradient-to: #5a5b60 var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/0:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/10:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/100:hover{
  --tw-gradient-to: rgb(90, 91, 96) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/15:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/20:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/25:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/30:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/35:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/40:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/45:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/5:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/50:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/55:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/60:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/65:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/70:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/75:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/80:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/85:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/90:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-600\\/95:hover{
  --tw-gradient-to: rgba(90, 91, 96, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700:hover{
  --tw-gradient-to: #4d4d51 var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/0:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/10:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/100:hover{
  --tw-gradient-to: rgb(77, 77, 81) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/15:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/20:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/25:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/30:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/35:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/40:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/45:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/5:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/50:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/55:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/60:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/65:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/70:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/75:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/80:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/85:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/90:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-700\\/95:hover{
  --tw-gradient-to: rgba(77, 77, 81, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800:hover{
  --tw-gradient-to: #434347 var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/0:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/10:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/100:hover{
  --tw-gradient-to: rgb(67, 67, 71) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/15:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/20:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/25:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/30:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/35:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/40:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/45:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/5:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/50:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/55:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/60:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/65:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/70:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/75:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/80:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/85:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/90:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-800\\/95:hover{
  --tw-gradient-to: rgba(67, 67, 71, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900:hover{
  --tw-gradient-to: #313133 var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/0:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/10:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/100:hover{
  --tw-gradient-to: rgb(49, 49, 51) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/15:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/20:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/25:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/30:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/35:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/40:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/45:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/5:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/50:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/55:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/60:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/65:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/70:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/75:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/80:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/85:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/90:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-900\\/95:hover{
  --tw-gradient-to: rgba(49, 49, 51, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950:hover{
  --tw-gradient-to: #252527 var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/0:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/10:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/100:hover{
  --tw-gradient-to: rgb(37, 37, 39) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/15:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/20:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/25:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/30:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/35:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/40:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/45:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/5:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/50:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/55:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/60:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/65:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/70:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/75:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/80:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/85:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/90:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-charcoal-950\\/95:hover{
  --tw-gradient-to: rgba(37, 37, 39, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100:hover{
  --tw-gradient-to: #d9f2e6 var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/0:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/10:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/100:hover{
  --tw-gradient-to: rgb(217, 242, 230) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/15:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/20:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/25:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/30:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/35:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/40:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/45:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/5:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/50:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/55:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/60:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/65:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/70:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/75:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/80:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/85:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/90:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-jade-100\\/95:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200:hover{
  --tw-gradient-to: #b6e4d1 var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/0:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/10:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/100:hover{
  --tw-gradient-to: rgb(182, 228, 209) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/15:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/20:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/25:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/30:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/35:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/40:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/45:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/5:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/50:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/55:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/60:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/65:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/70:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/75:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/80:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/85:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/90:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-jade-200\\/95:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300:hover{
  --tw-gradient-to: #86cfb5 var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/0:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/10:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/100:hover{
  --tw-gradient-to: rgb(134, 207, 181) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/15:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/20:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/25:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/30:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/35:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/40:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/45:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/5:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/50:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/55:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/60:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/65:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/70:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/75:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/80:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/85:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/90:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-jade-300\\/95:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400:hover{
  --tw-gradient-to: #53b494 var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/0:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/10:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/100:hover{
  --tw-gradient-to: rgb(83, 180, 148) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/15:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/20:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/25:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/30:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/35:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/40:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/45:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/5:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/50:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/55:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/60:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/65:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/70:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/75:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/80:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/85:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/90:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-jade-400\\/95:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500:hover{
  --tw-gradient-to: #2c876d var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/0:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/10:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/100:hover{
  --tw-gradient-to: rgb(44, 135, 109) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/15:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/20:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/25:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/30:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/35:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/40:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/45:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/5:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/50:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/55:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/60:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/65:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/70:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/75:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/80:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/85:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/90:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-jade-500\\/95:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600:hover{
  --tw-gradient-to: #227962 var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/0:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/10:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/100:hover{
  --tw-gradient-to: rgb(34, 121, 98) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/15:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/20:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/25:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/30:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/35:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/40:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/45:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/5:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/50:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/55:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/60:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/65:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/70:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/75:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/80:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/85:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/90:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-jade-600\\/95:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700:hover{
  --tw-gradient-to: #1b6150 var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/0:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/10:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/100:hover{
  --tw-gradient-to: rgb(27, 97, 80) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/15:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/20:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/25:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/30:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/35:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/40:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/45:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/5:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/50:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/55:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/60:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/65:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/70:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/75:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/80:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/85:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/90:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-jade-700\\/95:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800:hover{
  --tw-gradient-to: #184d40 var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/0:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/10:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/100:hover{
  --tw-gradient-to: rgb(24, 77, 64) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/15:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/20:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/25:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/30:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/35:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/40:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/45:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/5:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/50:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/55:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/60:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/65:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/70:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/75:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/80:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/85:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/90:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-jade-800\\/95:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900:hover{
  --tw-gradient-to: #144036 var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/0:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/10:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/100:hover{
  --tw-gradient-to: rgb(20, 64, 54) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/15:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/20:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/25:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/30:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/35:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/40:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/45:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/5:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/50:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/55:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/60:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/65:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/70:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/75:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/80:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/85:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/90:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-jade-900\\/95:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950:hover{
  --tw-gradient-to: #0a241f var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/0:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/10:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/100:hover{
  --tw-gradient-to: rgb(10, 36, 31) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/15:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/20:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/25:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/30:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/35:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/40:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/45:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/5:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/50:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/55:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/60:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/65:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/70:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/75:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/80:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/85:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/90:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-jade-950\\/95:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500:hover{
  --tw-gradient-to: #3787a3 var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/0:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/10:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/100:hover{
  --tw-gradient-to: rgb(55, 135, 163) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/15:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/20:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/25:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/30:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/35:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/40:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/45:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/5:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/50:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/55:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/60:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/65:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/70:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/75:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/80:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/85:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/90:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-500\\/95:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600:hover{
  --tw-gradient-to: #306d8a var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/0:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/10:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/100:hover{
  --tw-gradient-to: rgb(48, 109, 138) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/15:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/20:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/25:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/30:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/35:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/40:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/45:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/5:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/50:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/55:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/60:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/65:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/70:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/75:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/80:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/85:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/90:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-600\\/95:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700:hover{
  --tw-gradient-to: #2d5b72 var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/0:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/10:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/100:hover{
  --tw-gradient-to: rgb(45, 91, 114) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/15:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/20:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/25:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/30:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/35:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/40:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/45:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/5:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/50:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/55:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/60:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/65:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/70:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/75:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/80:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/85:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/90:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-700\\/95:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800:hover{
  --tw-gradient-to: #2c4c5e var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/0:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/10:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/100:hover{
  --tw-gradient-to: rgb(44, 76, 94) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/15:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/20:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/25:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/30:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/35:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/40:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/45:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/5:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/50:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/55:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/60:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/65:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/70:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/75:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/80:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/85:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/90:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-800\\/95:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900:hover{
  --tw-gradient-to: #284151 var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/0:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/10:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/100:hover{
  --tw-gradient-to: rgb(40, 65, 81) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/15:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/20:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/25:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/30:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/35:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/40:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/45:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/5:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/50:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/55:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/60:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/65:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/70:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/75:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/80:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/85:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/90:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-alphabet-900\\/95:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500:hover{
  --tw-gradient-to: #d1912f var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/0:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/10:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/100:hover{
  --tw-gradient-to: rgb(209, 145, 47) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/15:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/20:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/25:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/30:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/35:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/40:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/45:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/5:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/50:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/55:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/60:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/65:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/70:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/75:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/80:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/85:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/90:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-500\\/95:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600:hover{
  --tw-gradient-to: #c37829 var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/0:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/10:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/100:hover{
  --tw-gradient-to: rgb(195, 120, 41) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/15:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/20:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/25:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/30:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/35:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/40:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/45:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/5:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/50:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/55:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/60:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/65:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/70:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/75:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/80:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/85:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/90:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-600\\/95:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700:hover{
  --tw-gradient-to: #995424 var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/0:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/10:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/100:hover{
  --tw-gradient-to: rgb(153, 84, 36) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/15:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/20:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/25:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/30:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/35:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/40:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/45:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/5:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/50:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/55:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/60:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/65:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/70:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/75:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/80:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/85:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/90:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-700\\/95:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800:hover{
  --tw-gradient-to: #7e4322 var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/0:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/10:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/100:hover{
  --tw-gradient-to: rgb(126, 67, 34) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/15:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/20:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/25:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/30:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/35:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/40:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/45:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/5:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/50:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/55:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/60:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/65:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/70:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/75:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/80:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/85:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/90:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-800\\/95:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900:hover{
  --tw-gradient-to: #68381f var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/0:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/10:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/100:hover{
  --tw-gradient-to: rgb(104, 56, 31) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/15:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/20:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/25:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/30:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/35:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/40:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/45:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/5:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/50:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/55:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/60:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/65:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/70:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/75:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/80:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/85:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/90:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-categories-900\\/95:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500:hover{
  --tw-gradient-to: #2c876d var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/0:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/10:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/100:hover{
  --tw-gradient-to: rgb(44, 135, 109) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/15:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/20:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/25:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/30:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/35:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/40:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/45:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/5:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/50:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/55:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/60:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/65:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/70:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/75:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/80:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/85:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/90:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-500\\/95:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600:hover{
  --tw-gradient-to: #227962 var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/0:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/10:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/100:hover{
  --tw-gradient-to: rgb(34, 121, 98) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/15:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/20:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/25:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/30:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/35:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/40:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/45:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/5:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/50:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/55:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/60:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/65:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/70:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/75:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/80:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/85:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/90:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-600\\/95:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700:hover{
  --tw-gradient-to: #1b6150 var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/0:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/10:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/100:hover{
  --tw-gradient-to: rgb(27, 97, 80) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/15:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/20:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/25:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/30:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/35:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/40:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/45:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/5:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/50:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/55:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/60:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/65:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/70:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/75:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/80:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/85:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/90:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-700\\/95:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800:hover{
  --tw-gradient-to: #184d40 var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/0:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/10:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/100:hover{
  --tw-gradient-to: rgb(24, 77, 64) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/15:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/20:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/25:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/30:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/35:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/40:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/45:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/5:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/50:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/55:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/60:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/65:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/70:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/75:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/80:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/85:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/90:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-800\\/95:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900:hover{
  --tw-gradient-to: #144036 var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/0:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/10:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/100:hover{
  --tw-gradient-to: rgb(20, 64, 54) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/15:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/20:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/25:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/30:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/35:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/40:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/45:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/5:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/50:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/55:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/60:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/65:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/70:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/75:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/80:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/85:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/90:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-dictionary-900\\/95:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500:hover{
  --tw-gradient-to: #513B56 var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/0:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/10:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/100:hover{
  --tw-gradient-to: rgb(81, 59, 86) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/15:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/20:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/25:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/30:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/35:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/40:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/45:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/5:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/50:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/55:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/60:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/65:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/70:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/75:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/80:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/85:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/90:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-500\\/95:hover{
  --tw-gradient-to: rgba(81, 59, 86, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900:hover{
  --tw-gradient-to: #39293c var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/0:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/10:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/100:hover{
  --tw-gradient-to: rgb(57, 41, 60) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/15:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/20:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/25:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/30:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/35:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/40:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/45:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/5:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/50:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/55:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/60:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/65:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/70:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/75:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/80:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/85:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/90:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-games-900\\/95:hover{
  --tw-gradient-to: rgba(57, 41, 60, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500:hover{
  --tw-gradient-to: #830042 var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/0:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/10:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/100:hover{
  --tw-gradient-to: rgb(131, 0, 66) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/15:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/20:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/25:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/30:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/35:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/40:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/45:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/5:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/50:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/55:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/60:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/65:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/70:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/75:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/80:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/85:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/90:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-500\\/95:hover{
  --tw-gradient-to: rgba(131, 0, 66, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900:hover{
  --tw-gradient-to: #5c002e var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/0:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/10:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/100:hover{
  --tw-gradient-to: rgb(92, 0, 46) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/15:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/20:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/25:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/30:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/35:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/40:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/45:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/5:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/50:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/55:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/60:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/65:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/70:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/75:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/80:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/85:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/90:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-songs-900\\/95:hover{
  --tw-gradient-to: rgba(92, 0, 46, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500:hover{
  --tw-gradient-to: #E9C46A var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/0:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/10:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/100:hover{
  --tw-gradient-to: rgb(233, 196, 106) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/15:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/20:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/25:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/30:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/35:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/40:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/45:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/5:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/50:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/55:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/60:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/65:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/70:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/75:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/80:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/85:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/90:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-500\\/95:hover{
  --tw-gradient-to: rgba(233, 196, 106, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900:hover{
  --tw-gradient-to: #a3894a var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/0:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/10:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/100:hover{
  --tw-gradient-to: rgb(163, 137, 74) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/15:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/20:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/25:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/30:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/35:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/40:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/45:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/5:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/50:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/55:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/60:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/65:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/70:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/75:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/80:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/85:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/90:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-kids-stories-900\\/95:hover{
  --tw-gradient-to: rgba(163, 137, 74, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100:hover{
  --tw-gradient-to: #f5edd0 var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/0:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/10:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/100:hover{
  --tw-gradient-to: rgb(245, 237, 208) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/15:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/20:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/25:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/30:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/35:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/40:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/45:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/5:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/50:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/55:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/60:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/65:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/70:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/75:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/80:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/85:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/90:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-100\\/95:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200:hover{
  --tw-gradient-to: #ebd99c var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/0:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/10:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/100:hover{
  --tw-gradient-to: rgb(235, 217, 156) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/15:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/20:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/25:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/30:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/35:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/40:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/45:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/5:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/50:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/55:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/60:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/65:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/70:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/75:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/80:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/85:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/90:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-200\\/95:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300:hover{
  --tw-gradient-to: #e1c268 var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/0:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/10:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/100:hover{
  --tw-gradient-to: rgb(225, 194, 104) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/15:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/20:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/25:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/30:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/35:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/40:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/45:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/5:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/50:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/55:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/60:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/65:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/70:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/75:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/80:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/85:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/90:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-300\\/95:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400:hover{
  --tw-gradient-to: #daad45 var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/0:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/10:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/100:hover{
  --tw-gradient-to: rgb(218, 173, 69) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/15:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/20:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/25:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/30:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/35:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/40:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/45:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/5:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/50:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/55:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/60:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/65:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/70:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/75:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/80:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/85:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/90:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-400\\/95:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500:hover{
  --tw-gradient-to: #d1912f var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/0:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/10:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/100:hover{
  --tw-gradient-to: rgb(209, 145, 47) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/15:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/20:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/25:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/30:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/35:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/40:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/45:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/5:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/50:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/55:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/60:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/65:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/70:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/75:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/80:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/85:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/90:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-500\\/95:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600:hover{
  --tw-gradient-to: #c37829 var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/0:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/10:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/100:hover{
  --tw-gradient-to: rgb(195, 120, 41) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/15:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/20:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/25:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/30:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/35:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/40:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/45:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/5:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/50:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/55:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/60:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/65:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/70:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/75:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/80:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/85:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/90:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-600\\/95:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700:hover{
  --tw-gradient-to: #995424 var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/0:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/10:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/100:hover{
  --tw-gradient-to: rgb(153, 84, 36) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/15:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/20:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/25:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/30:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/35:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/40:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/45:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/5:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/50:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/55:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/60:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/65:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/70:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/75:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/80:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/85:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/90:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-700\\/95:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800:hover{
  --tw-gradient-to: #7e4322 var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/0:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/10:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/100:hover{
  --tw-gradient-to: rgb(126, 67, 34) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/15:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/20:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/25:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/30:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/35:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/40:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/45:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/5:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/50:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/55:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/60:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/65:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/70:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/75:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/80:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/85:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/90:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-800\\/95:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900:hover{
  --tw-gradient-to: #68381f var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/0:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/10:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/100:hover{
  --tw-gradient-to: rgb(104, 56, 31) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/15:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/20:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/25:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/30:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/35:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/40:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/45:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/5:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/50:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/55:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/60:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/65:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/70:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/75:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/80:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/85:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/90:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-900\\/95:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950:hover{
  --tw-gradient-to: #3b1c0d var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/0:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/10:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/100:hover{
  --tw-gradient-to: rgb(59, 28, 13) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/15:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/20:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/25:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/30:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/35:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/40:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/45:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/5:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/50:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/55:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/60:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/65:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/70:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/75:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/80:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/85:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/90:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-ochre-950\\/95:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100:hover{
  --tw-gradient-to: #f5edd0 var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/0:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/10:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/100:hover{
  --tw-gradient-to: rgb(245, 237, 208) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/15:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/20:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/25:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/30:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/35:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/40:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/45:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/5:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/50:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/55:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/60:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/65:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/70:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/75:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/80:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/85:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/90:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-100\\/95:hover{
  --tw-gradient-to: rgba(245, 237, 208, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200:hover{
  --tw-gradient-to: #ebd99c var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/0:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/10:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/100:hover{
  --tw-gradient-to: rgb(235, 217, 156) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/15:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/20:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/25:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/30:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/35:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/40:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/45:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/5:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/50:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/55:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/60:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/65:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/70:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/75:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/80:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/85:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/90:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-200\\/95:hover{
  --tw-gradient-to: rgba(235, 217, 156, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300:hover{
  --tw-gradient-to: #e1c268 var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/0:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/10:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/100:hover{
  --tw-gradient-to: rgb(225, 194, 104) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/15:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/20:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/25:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/30:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/35:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/40:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/45:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/5:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/50:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/55:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/60:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/65:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/70:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/75:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/80:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/85:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/90:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-300\\/95:hover{
  --tw-gradient-to: rgba(225, 194, 104, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400:hover{
  --tw-gradient-to: #daad45 var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/0:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/10:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/100:hover{
  --tw-gradient-to: rgb(218, 173, 69) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/15:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/20:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/25:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/30:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/35:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/40:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/45:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/5:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/50:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/55:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/60:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/65:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/70:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/75:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/80:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/85:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/90:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-400\\/95:hover{
  --tw-gradient-to: rgba(218, 173, 69, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500:hover{
  --tw-gradient-to: #d1912f var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/0:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/10:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/100:hover{
  --tw-gradient-to: rgb(209, 145, 47) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/15:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/20:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/25:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/30:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/35:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/40:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/45:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/5:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/50:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/55:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/60:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/65:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/70:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/75:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/80:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/85:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/90:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-500\\/95:hover{
  --tw-gradient-to: rgba(209, 145, 47, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600:hover{
  --tw-gradient-to: #c37829 var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/0:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/10:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/100:hover{
  --tw-gradient-to: rgb(195, 120, 41) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/15:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/20:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/25:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/30:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/35:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/40:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/45:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/5:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/50:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/55:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/60:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/65:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/70:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/75:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/80:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/85:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/90:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-600\\/95:hover{
  --tw-gradient-to: rgba(195, 120, 41, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700:hover{
  --tw-gradient-to: #995424 var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/0:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/10:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/100:hover{
  --tw-gradient-to: rgb(153, 84, 36) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/15:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/20:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/25:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/30:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/35:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/40:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/45:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/5:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/50:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/55:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/60:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/65:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/70:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/75:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/80:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/85:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/90:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-700\\/95:hover{
  --tw-gradient-to: rgba(153, 84, 36, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800:hover{
  --tw-gradient-to: #7e4322 var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/0:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/10:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/100:hover{
  --tw-gradient-to: rgb(126, 67, 34) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/15:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/20:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/25:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/30:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/35:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/40:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/45:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/5:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/50:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/55:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/60:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/65:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/70:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/75:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/80:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/85:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/90:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-800\\/95:hover{
  --tw-gradient-to: rgba(126, 67, 34, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900:hover{
  --tw-gradient-to: #68381f var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/0:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/10:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/100:hover{
  --tw-gradient-to: rgb(104, 56, 31) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/15:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/20:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/25:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/30:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/35:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/40:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/45:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/5:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/50:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/55:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/60:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/65:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/70:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/75:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/80:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/85:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/90:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-900\\/95:hover{
  --tw-gradient-to: rgba(104, 56, 31, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950:hover{
  --tw-gradient-to: #3b1c0d var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/0:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/10:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/100:hover{
  --tw-gradient-to: rgb(59, 28, 13) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/15:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/20:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/25:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/30:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/35:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/40:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/45:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/5:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/50:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/55:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/60:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/65:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/70:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/75:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/80:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/85:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/90:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-phrase-color-950\\/95:hover{
  --tw-gradient-to: rgba(59, 28, 13, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100:hover{
  --tw-gradient-to: #ffdcdf var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/0:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/10:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/100:hover{
  --tw-gradient-to: rgb(255, 220, 223) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/15:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/20:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/25:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/30:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/35:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/40:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/45:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/5:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/50:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/55:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/60:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/65:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/70:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/75:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/80:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/85:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/90:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-100\\/95:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200:hover{
  --tw-gradient-to: #ffc0c6 var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/0:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/10:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/100:hover{
  --tw-gradient-to: rgb(255, 192, 198) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/15:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/20:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/25:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/30:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/35:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/40:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/45:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/5:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/50:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/55:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/60:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/65:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/70:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/75:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/80:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/85:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/90:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-200\\/95:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300:hover{
  --tw-gradient-to: #ff949e var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/0:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/10:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/100:hover{
  --tw-gradient-to: rgb(255, 148, 158) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/15:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/20:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/25:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/30:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/35:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/40:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/45:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/5:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/50:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/55:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/60:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/65:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/70:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/75:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/80:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/85:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/90:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-300\\/95:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400:hover{
  --tw-gradient-to: #ff5665 var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/0:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/10:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/100:hover{
  --tw-gradient-to: rgb(255, 86, 101) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/15:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/20:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/25:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/30:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/35:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/40:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/45:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/5:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/50:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/55:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/60:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/65:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/70:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/75:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/80:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/85:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/90:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-400\\/95:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500:hover{
  --tw-gradient-to: #ff2236 var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/0:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/10:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/100:hover{
  --tw-gradient-to: rgb(255, 34, 54) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/15:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/20:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/25:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/30:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/35:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/40:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/45:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/5:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/50:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/55:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/60:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/65:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/70:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/75:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/80:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/85:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/90:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-500\\/95:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600:hover{
  --tw-gradient-to: #ff0219 var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/0:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/10:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/100:hover{
  --tw-gradient-to: rgb(255, 2, 25) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/15:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/20:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/25:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/30:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/35:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/40:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/45:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/5:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/50:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/55:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/60:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/65:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/70:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/75:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/80:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/85:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/90:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-600\\/95:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700:hover{
  --tw-gradient-to: #d80013 var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/0:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/10:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/100:hover{
  --tw-gradient-to: rgb(216, 0, 19) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/15:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/20:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/25:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/30:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/35:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/40:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/45:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/5:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/50:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/55:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/60:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/65:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/70:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/75:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/80:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/85:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/90:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-700\\/95:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800:hover{
  --tw-gradient-to: #b40212 var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/0:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/10:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/100:hover{
  --tw-gradient-to: rgb(180, 2, 18) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/15:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/20:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/25:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/30:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/35:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/40:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/45:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/5:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/50:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/55:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/60:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/65:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/70:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/75:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/80:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/85:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/90:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-800\\/95:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900:hover{
  --tw-gradient-to: #920a16 var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/0:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/10:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/100:hover{
  --tw-gradient-to: rgb(146, 10, 22) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/15:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/20:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/25:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/30:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/35:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/40:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/45:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/5:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/50:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/55:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/60:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/65:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/70:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/75:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/80:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/85:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/90:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-900\\/95:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950:hover{
  --tw-gradient-to: #510007 var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/0:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/10:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/100:hover{
  --tw-gradient-to: rgb(81, 0, 7) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/15:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/20:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/25:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/30:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/35:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/40:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/45:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/5:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/50:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/55:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/60:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/65:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/70:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/75:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/80:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/85:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/90:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-scarlet-950\\/95:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100:hover{
  --tw-gradient-to: #ffdcdf var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/0:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/10:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/100:hover{
  --tw-gradient-to: rgb(255, 220, 223) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/15:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/20:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/25:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/30:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/35:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/40:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/45:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/5:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/50:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/55:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/60:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/65:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/70:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/75:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/80:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/85:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/90:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-100\\/95:hover{
  --tw-gradient-to: rgba(255, 220, 223, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200:hover{
  --tw-gradient-to: #ffc0c6 var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/0:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/10:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/100:hover{
  --tw-gradient-to: rgb(255, 192, 198) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/15:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/20:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/25:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/30:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/35:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/40:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/45:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/5:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/50:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/55:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/60:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/65:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/70:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/75:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/80:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/85:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/90:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-200\\/95:hover{
  --tw-gradient-to: rgba(255, 192, 198, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300:hover{
  --tw-gradient-to: #ff949e var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/0:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/10:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/100:hover{
  --tw-gradient-to: rgb(255, 148, 158) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/15:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/20:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/25:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/30:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/35:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/40:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/45:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/5:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/50:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/55:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/60:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/65:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/70:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/75:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/80:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/85:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/90:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-300\\/95:hover{
  --tw-gradient-to: rgba(255, 148, 158, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400:hover{
  --tw-gradient-to: #ff5665 var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/0:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/10:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/100:hover{
  --tw-gradient-to: rgb(255, 86, 101) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/15:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/20:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/25:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/30:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/35:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/40:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/45:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/5:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/50:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/55:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/60:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/65:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/70:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/75:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/80:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/85:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/90:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-400\\/95:hover{
  --tw-gradient-to: rgba(255, 86, 101, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500:hover{
  --tw-gradient-to: #ff2236 var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/0:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/10:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/100:hover{
  --tw-gradient-to: rgb(255, 34, 54) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/15:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/20:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/25:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/30:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/35:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/40:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/45:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/5:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/50:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/55:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/60:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/65:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/70:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/75:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/80:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/85:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/90:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-500\\/95:hover{
  --tw-gradient-to: rgba(255, 34, 54, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600:hover{
  --tw-gradient-to: #ff0219 var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/0:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/10:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/100:hover{
  --tw-gradient-to: rgb(255, 2, 25) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/15:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/20:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/25:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/30:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/35:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/40:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/45:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/5:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/50:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/55:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/60:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/65:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/70:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/75:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/80:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/85:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/90:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-600\\/95:hover{
  --tw-gradient-to: rgba(255, 2, 25, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700:hover{
  --tw-gradient-to: #d80013 var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/0:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/10:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/100:hover{
  --tw-gradient-to: rgb(216, 0, 19) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/15:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/20:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/25:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/30:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/35:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/40:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/45:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/5:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/50:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/55:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/60:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/65:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/70:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/75:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/80:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/85:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/90:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-700\\/95:hover{
  --tw-gradient-to: rgba(216, 0, 19, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800:hover{
  --tw-gradient-to: #b40212 var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/0:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/10:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/100:hover{
  --tw-gradient-to: rgb(180, 2, 18) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/15:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/20:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/25:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/30:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/35:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/40:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/45:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/5:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/50:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/55:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/60:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/65:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/70:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/75:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/80:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/85:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/90:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-800\\/95:hover{
  --tw-gradient-to: rgba(180, 2, 18, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900:hover{
  --tw-gradient-to: #920a16 var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/0:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/10:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/100:hover{
  --tw-gradient-to: rgb(146, 10, 22) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/15:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/20:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/25:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/30:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/35:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/40:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/45:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/5:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/50:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/55:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/60:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/65:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/70:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/75:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/80:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/85:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/90:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-900\\/95:hover{
  --tw-gradient-to: rgba(146, 10, 22, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950:hover{
  --tw-gradient-to: #510007 var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/0:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/10:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/100:hover{
  --tw-gradient-to: rgb(81, 0, 7) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/15:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/20:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/25:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/30:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/35:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/40:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/45:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/5:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/50:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/55:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/60:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/65:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/70:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/75:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/80:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/85:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/90:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-song-color-950\\/95:hover{
  --tw-gradient-to: rgba(81, 0, 7, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100:hover{
  --tw-gradient-to: #daeef3 var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/0:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/10:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/100:hover{
  --tw-gradient-to: rgb(218, 238, 243) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/15:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/20:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/25:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/30:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/35:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/40:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/45:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/5:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/50:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/55:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/60:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/65:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/70:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/75:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/80:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/85:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/90:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-100\\/95:hover{
  --tw-gradient-to: rgba(218, 238, 243, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200:hover{
  --tw-gradient-to: #badee7 var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/0:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/10:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/100:hover{
  --tw-gradient-to: rgb(186, 222, 231) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/15:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/20:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/25:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/30:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/35:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/40:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/45:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/5:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/50:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/55:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/60:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/65:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/70:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/75:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/80:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/85:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/90:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-200\\/95:hover{
  --tw-gradient-to: rgba(186, 222, 231, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300:hover{
  --tw-gradient-to: #89c5d7 var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/0:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/10:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/100:hover{
  --tw-gradient-to: rgb(137, 197, 215) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/15:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/20:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/25:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/30:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/35:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/40:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/45:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/5:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/50:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/55:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/60:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/65:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/70:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/75:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/80:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/85:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/90:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-300\\/95:hover{
  --tw-gradient-to: rgba(137, 197, 215, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400:hover{
  --tw-gradient-to: #52a3be var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/0:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/10:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/100:hover{
  --tw-gradient-to: rgb(82, 163, 190) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/15:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/20:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/25:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/30:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/35:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/40:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/45:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/5:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/50:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/55:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/60:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/65:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/70:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/75:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/80:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/85:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/90:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-400\\/95:hover{
  --tw-gradient-to: rgba(82, 163, 190, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500:hover{
  --tw-gradient-to: #3787a3 var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/0:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/10:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/100:hover{
  --tw-gradient-to: rgb(55, 135, 163) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/15:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/20:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/25:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/30:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/35:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/40:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/45:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/5:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/50:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/55:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/60:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/65:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/70:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/75:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/80:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/85:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/90:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-500\\/95:hover{
  --tw-gradient-to: rgba(55, 135, 163, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600:hover{
  --tw-gradient-to: #306d8a var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/0:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/10:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/100:hover{
  --tw-gradient-to: rgb(48, 109, 138) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/15:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/20:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/25:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/30:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/35:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/40:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/45:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/5:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/50:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/55:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/60:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/65:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/70:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/75:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/80:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/85:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/90:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-600\\/95:hover{
  --tw-gradient-to: rgba(48, 109, 138, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700:hover{
  --tw-gradient-to: #2d5b72 var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/0:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/10:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/100:hover{
  --tw-gradient-to: rgb(45, 91, 114) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/15:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/20:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/25:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/30:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/35:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/40:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/45:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/5:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/50:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/55:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/60:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/65:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/70:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/75:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/80:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/85:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/90:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-700\\/95:hover{
  --tw-gradient-to: rgba(45, 91, 114, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800:hover{
  --tw-gradient-to: #2c4c5e var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/0:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/10:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/100:hover{
  --tw-gradient-to: rgb(44, 76, 94) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/15:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/20:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/25:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/30:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/35:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/40:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/45:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/5:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/50:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/55:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/60:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/65:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/70:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/75:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/80:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/85:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/90:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-800\\/95:hover{
  --tw-gradient-to: rgba(44, 76, 94, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900:hover{
  --tw-gradient-to: #284151 var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/0:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/10:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/100:hover{
  --tw-gradient-to: rgb(40, 65, 81) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/15:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/20:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/25:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/30:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/35:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/40:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/45:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/5:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/50:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/55:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/60:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/65:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/70:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/75:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/80:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/85:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/90:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-900\\/95:hover{
  --tw-gradient-to: rgba(40, 65, 81, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950:hover{
  --tw-gradient-to: #162936 var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/0:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/10:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/100:hover{
  --tw-gradient-to: rgb(22, 41, 54) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/15:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/20:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/25:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/30:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/35:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/40:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/45:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/5:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/50:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/55:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/60:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/65:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/70:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/75:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/80:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/85:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/90:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-story-color-950\\/95:hover{
  --tw-gradient-to: rgba(22, 41, 54, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100:hover{
  --tw-gradient-to: #d9f2e6 var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/0:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/10:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/100:hover{
  --tw-gradient-to: rgb(217, 242, 230) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/15:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/20:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/25:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/30:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/35:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/40:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/45:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/5:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/50:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/55:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/60:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/65:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/70:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/75:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/80:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/85:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/90:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-100\\/95:hover{
  --tw-gradient-to: rgba(217, 242, 230, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200:hover{
  --tw-gradient-to: #b6e4d1 var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/0:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/10:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/100:hover{
  --tw-gradient-to: rgb(182, 228, 209) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/15:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/20:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/25:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/30:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/35:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/40:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/45:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/5:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/50:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/55:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/60:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/65:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/70:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/75:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/80:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/85:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/90:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-200\\/95:hover{
  --tw-gradient-to: rgba(182, 228, 209, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300:hover{
  --tw-gradient-to: #86cfb5 var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/0:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/10:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/100:hover{
  --tw-gradient-to: rgb(134, 207, 181) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/15:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/20:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/25:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/30:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/35:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/40:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/45:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/5:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/50:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/55:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/60:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/65:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/70:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/75:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/80:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/85:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/90:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-300\\/95:hover{
  --tw-gradient-to: rgba(134, 207, 181, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400:hover{
  --tw-gradient-to: #53b494 var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/0:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/10:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/100:hover{
  --tw-gradient-to: rgb(83, 180, 148) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/15:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/20:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/25:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/30:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/35:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/40:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/45:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/5:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/50:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/55:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/60:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/65:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/70:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/75:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/80:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/85:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/90:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-400\\/95:hover{
  --tw-gradient-to: rgba(83, 180, 148, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500:hover{
  --tw-gradient-to: #2c876d var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/0:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/10:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/100:hover{
  --tw-gradient-to: rgb(44, 135, 109) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/15:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/20:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/25:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/30:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/35:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/40:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/45:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/5:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/50:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/55:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/60:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/65:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/70:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/75:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/80:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/85:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/90:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-500\\/95:hover{
  --tw-gradient-to: rgba(44, 135, 109, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600:hover{
  --tw-gradient-to: #227962 var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/0:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/10:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/100:hover{
  --tw-gradient-to: rgb(34, 121, 98) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/15:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/20:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/25:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/30:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/35:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/40:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/45:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/5:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/50:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/55:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/60:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/65:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/70:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/75:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/80:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/85:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/90:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-600\\/95:hover{
  --tw-gradient-to: rgba(34, 121, 98, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700:hover{
  --tw-gradient-to: #1b6150 var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/0:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/10:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/100:hover{
  --tw-gradient-to: rgb(27, 97, 80) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/15:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/20:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/25:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/30:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/35:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/40:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/45:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/5:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/50:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/55:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/60:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/65:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/70:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/75:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/80:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/85:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/90:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-700\\/95:hover{
  --tw-gradient-to: rgba(27, 97, 80, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800:hover{
  --tw-gradient-to: #184d40 var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/0:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/10:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/100:hover{
  --tw-gradient-to: rgb(24, 77, 64) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/15:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/20:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/25:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/30:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/35:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/40:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/45:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/5:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/50:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/55:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/60:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/65:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/70:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/75:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/80:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/85:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/90:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-800\\/95:hover{
  --tw-gradient-to: rgba(24, 77, 64, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900:hover{
  --tw-gradient-to: #144036 var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/0:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/10:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/100:hover{
  --tw-gradient-to: rgb(20, 64, 54) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/15:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/20:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/25:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/30:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/35:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/40:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/45:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/5:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/50:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/55:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/60:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/65:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/70:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/75:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/80:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/85:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/90:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-900\\/95:hover{
  --tw-gradient-to: rgba(20, 64, 54, 0.95) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950:hover{
  --tw-gradient-to: #0a241f var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/0:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/10:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.1) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/100:hover{
  --tw-gradient-to: rgb(10, 36, 31) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/15:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.15) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/20:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.2) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/25:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.25) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/30:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/35:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.35) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/40:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/45:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.45) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/5:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.05) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/50:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.5) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/55:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.55) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/60:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.6) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/65:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.65) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/70:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.7) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/75:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.75) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/80:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/85:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.85) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/90:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.9) var(--tw-gradient-to-position);
}

.hover\\:to-word-color-950\\/95:hover{
  --tw-gradient-to: rgba(10, 36, 31, 0.95) var(--tw-gradient-to-position);
}

.hover\\:fill-blumine-100:hover{
  fill: #daeef3;
}

.hover\\:fill-blumine-100\\/0:hover{
  fill: rgba(218, 238, 243, 0);
}

.hover\\:fill-blumine-100\\/10:hover{
  fill: rgba(218, 238, 243, 0.1);
}

.hover\\:fill-blumine-100\\/100:hover{
  fill: rgb(218, 238, 243);
}

.hover\\:fill-blumine-100\\/15:hover{
  fill: rgba(218, 238, 243, 0.15);
}

.hover\\:fill-blumine-100\\/20:hover{
  fill: rgba(218, 238, 243, 0.2);
}

.hover\\:fill-blumine-100\\/25:hover{
  fill: rgba(218, 238, 243, 0.25);
}

.hover\\:fill-blumine-100\\/30:hover{
  fill: rgba(218, 238, 243, 0.3);
}

.hover\\:fill-blumine-100\\/35:hover{
  fill: rgba(218, 238, 243, 0.35);
}

.hover\\:fill-blumine-100\\/40:hover{
  fill: rgba(218, 238, 243, 0.4);
}

.hover\\:fill-blumine-100\\/45:hover{
  fill: rgba(218, 238, 243, 0.45);
}

.hover\\:fill-blumine-100\\/5:hover{
  fill: rgba(218, 238, 243, 0.05);
}

.hover\\:fill-blumine-100\\/50:hover{
  fill: rgba(218, 238, 243, 0.5);
}

.hover\\:fill-blumine-100\\/55:hover{
  fill: rgba(218, 238, 243, 0.55);
}

.hover\\:fill-blumine-100\\/60:hover{
  fill: rgba(218, 238, 243, 0.6);
}

.hover\\:fill-blumine-100\\/65:hover{
  fill: rgba(218, 238, 243, 0.65);
}

.hover\\:fill-blumine-100\\/70:hover{
  fill: rgba(218, 238, 243, 0.7);
}

.hover\\:fill-blumine-100\\/75:hover{
  fill: rgba(218, 238, 243, 0.75);
}

.hover\\:fill-blumine-100\\/80:hover{
  fill: rgba(218, 238, 243, 0.8);
}

.hover\\:fill-blumine-100\\/85:hover{
  fill: rgba(218, 238, 243, 0.85);
}

.hover\\:fill-blumine-100\\/90:hover{
  fill: rgba(218, 238, 243, 0.9);
}

.hover\\:fill-blumine-100\\/95:hover{
  fill: rgba(218, 238, 243, 0.95);
}

.hover\\:fill-blumine-200:hover{
  fill: #badee7;
}

.hover\\:fill-blumine-200\\/0:hover{
  fill: rgba(186, 222, 231, 0);
}

.hover\\:fill-blumine-200\\/10:hover{
  fill: rgba(186, 222, 231, 0.1);
}

.hover\\:fill-blumine-200\\/100:hover{
  fill: rgb(186, 222, 231);
}

.hover\\:fill-blumine-200\\/15:hover{
  fill: rgba(186, 222, 231, 0.15);
}

.hover\\:fill-blumine-200\\/20:hover{
  fill: rgba(186, 222, 231, 0.2);
}

.hover\\:fill-blumine-200\\/25:hover{
  fill: rgba(186, 222, 231, 0.25);
}

.hover\\:fill-blumine-200\\/30:hover{
  fill: rgba(186, 222, 231, 0.3);
}

.hover\\:fill-blumine-200\\/35:hover{
  fill: rgba(186, 222, 231, 0.35);
}

.hover\\:fill-blumine-200\\/40:hover{
  fill: rgba(186, 222, 231, 0.4);
}

.hover\\:fill-blumine-200\\/45:hover{
  fill: rgba(186, 222, 231, 0.45);
}

.hover\\:fill-blumine-200\\/5:hover{
  fill: rgba(186, 222, 231, 0.05);
}

.hover\\:fill-blumine-200\\/50:hover{
  fill: rgba(186, 222, 231, 0.5);
}

.hover\\:fill-blumine-200\\/55:hover{
  fill: rgba(186, 222, 231, 0.55);
}

.hover\\:fill-blumine-200\\/60:hover{
  fill: rgba(186, 222, 231, 0.6);
}

.hover\\:fill-blumine-200\\/65:hover{
  fill: rgba(186, 222, 231, 0.65);
}

.hover\\:fill-blumine-200\\/70:hover{
  fill: rgba(186, 222, 231, 0.7);
}

.hover\\:fill-blumine-200\\/75:hover{
  fill: rgba(186, 222, 231, 0.75);
}

.hover\\:fill-blumine-200\\/80:hover{
  fill: rgba(186, 222, 231, 0.8);
}

.hover\\:fill-blumine-200\\/85:hover{
  fill: rgba(186, 222, 231, 0.85);
}

.hover\\:fill-blumine-200\\/90:hover{
  fill: rgba(186, 222, 231, 0.9);
}

.hover\\:fill-blumine-200\\/95:hover{
  fill: rgba(186, 222, 231, 0.95);
}

.hover\\:fill-blumine-300:hover{
  fill: #89c5d7;
}

.hover\\:fill-blumine-300\\/0:hover{
  fill: rgba(137, 197, 215, 0);
}

.hover\\:fill-blumine-300\\/10:hover{
  fill: rgba(137, 197, 215, 0.1);
}

.hover\\:fill-blumine-300\\/100:hover{
  fill: rgb(137, 197, 215);
}

.hover\\:fill-blumine-300\\/15:hover{
  fill: rgba(137, 197, 215, 0.15);
}

.hover\\:fill-blumine-300\\/20:hover{
  fill: rgba(137, 197, 215, 0.2);
}

.hover\\:fill-blumine-300\\/25:hover{
  fill: rgba(137, 197, 215, 0.25);
}

.hover\\:fill-blumine-300\\/30:hover{
  fill: rgba(137, 197, 215, 0.3);
}

.hover\\:fill-blumine-300\\/35:hover{
  fill: rgba(137, 197, 215, 0.35);
}

.hover\\:fill-blumine-300\\/40:hover{
  fill: rgba(137, 197, 215, 0.4);
}

.hover\\:fill-blumine-300\\/45:hover{
  fill: rgba(137, 197, 215, 0.45);
}

.hover\\:fill-blumine-300\\/5:hover{
  fill: rgba(137, 197, 215, 0.05);
}

.hover\\:fill-blumine-300\\/50:hover{
  fill: rgba(137, 197, 215, 0.5);
}

.hover\\:fill-blumine-300\\/55:hover{
  fill: rgba(137, 197, 215, 0.55);
}

.hover\\:fill-blumine-300\\/60:hover{
  fill: rgba(137, 197, 215, 0.6);
}

.hover\\:fill-blumine-300\\/65:hover{
  fill: rgba(137, 197, 215, 0.65);
}

.hover\\:fill-blumine-300\\/70:hover{
  fill: rgba(137, 197, 215, 0.7);
}

.hover\\:fill-blumine-300\\/75:hover{
  fill: rgba(137, 197, 215, 0.75);
}

.hover\\:fill-blumine-300\\/80:hover{
  fill: rgba(137, 197, 215, 0.8);
}

.hover\\:fill-blumine-300\\/85:hover{
  fill: rgba(137, 197, 215, 0.85);
}

.hover\\:fill-blumine-300\\/90:hover{
  fill: rgba(137, 197, 215, 0.9);
}

.hover\\:fill-blumine-300\\/95:hover{
  fill: rgba(137, 197, 215, 0.95);
}

.hover\\:fill-blumine-400:hover{
  fill: #52a3be;
}

.hover\\:fill-blumine-400\\/0:hover{
  fill: rgba(82, 163, 190, 0);
}

.hover\\:fill-blumine-400\\/10:hover{
  fill: rgba(82, 163, 190, 0.1);
}

.hover\\:fill-blumine-400\\/100:hover{
  fill: rgb(82, 163, 190);
}

.hover\\:fill-blumine-400\\/15:hover{
  fill: rgba(82, 163, 190, 0.15);
}

.hover\\:fill-blumine-400\\/20:hover{
  fill: rgba(82, 163, 190, 0.2);
}

.hover\\:fill-blumine-400\\/25:hover{
  fill: rgba(82, 163, 190, 0.25);
}

.hover\\:fill-blumine-400\\/30:hover{
  fill: rgba(82, 163, 190, 0.3);
}

.hover\\:fill-blumine-400\\/35:hover{
  fill: rgba(82, 163, 190, 0.35);
}

.hover\\:fill-blumine-400\\/40:hover{
  fill: rgba(82, 163, 190, 0.4);
}

.hover\\:fill-blumine-400\\/45:hover{
  fill: rgba(82, 163, 190, 0.45);
}

.hover\\:fill-blumine-400\\/5:hover{
  fill: rgba(82, 163, 190, 0.05);
}

.hover\\:fill-blumine-400\\/50:hover{
  fill: rgba(82, 163, 190, 0.5);
}

.hover\\:fill-blumine-400\\/55:hover{
  fill: rgba(82, 163, 190, 0.55);
}

.hover\\:fill-blumine-400\\/60:hover{
  fill: rgba(82, 163, 190, 0.6);
}

.hover\\:fill-blumine-400\\/65:hover{
  fill: rgba(82, 163, 190, 0.65);
}

.hover\\:fill-blumine-400\\/70:hover{
  fill: rgba(82, 163, 190, 0.7);
}

.hover\\:fill-blumine-400\\/75:hover{
  fill: rgba(82, 163, 190, 0.75);
}

.hover\\:fill-blumine-400\\/80:hover{
  fill: rgba(82, 163, 190, 0.8);
}

.hover\\:fill-blumine-400\\/85:hover{
  fill: rgba(82, 163, 190, 0.85);
}

.hover\\:fill-blumine-400\\/90:hover{
  fill: rgba(82, 163, 190, 0.9);
}

.hover\\:fill-blumine-400\\/95:hover{
  fill: rgba(82, 163, 190, 0.95);
}

.hover\\:fill-blumine-500:hover{
  fill: #3787a3;
}

.hover\\:fill-blumine-500\\/0:hover{
  fill: rgba(55, 135, 163, 0);
}

.hover\\:fill-blumine-500\\/10:hover{
  fill: rgba(55, 135, 163, 0.1);
}

.hover\\:fill-blumine-500\\/100:hover{
  fill: rgb(55, 135, 163);
}

.hover\\:fill-blumine-500\\/15:hover{
  fill: rgba(55, 135, 163, 0.15);
}

.hover\\:fill-blumine-500\\/20:hover{
  fill: rgba(55, 135, 163, 0.2);
}

.hover\\:fill-blumine-500\\/25:hover{
  fill: rgba(55, 135, 163, 0.25);
}

.hover\\:fill-blumine-500\\/30:hover{
  fill: rgba(55, 135, 163, 0.3);
}

.hover\\:fill-blumine-500\\/35:hover{
  fill: rgba(55, 135, 163, 0.35);
}

.hover\\:fill-blumine-500\\/40:hover{
  fill: rgba(55, 135, 163, 0.4);
}

.hover\\:fill-blumine-500\\/45:hover{
  fill: rgba(55, 135, 163, 0.45);
}

.hover\\:fill-blumine-500\\/5:hover{
  fill: rgba(55, 135, 163, 0.05);
}

.hover\\:fill-blumine-500\\/50:hover{
  fill: rgba(55, 135, 163, 0.5);
}

.hover\\:fill-blumine-500\\/55:hover{
  fill: rgba(55, 135, 163, 0.55);
}

.hover\\:fill-blumine-500\\/60:hover{
  fill: rgba(55, 135, 163, 0.6);
}

.hover\\:fill-blumine-500\\/65:hover{
  fill: rgba(55, 135, 163, 0.65);
}

.hover\\:fill-blumine-500\\/70:hover{
  fill: rgba(55, 135, 163, 0.7);
}

.hover\\:fill-blumine-500\\/75:hover{
  fill: rgba(55, 135, 163, 0.75);
}

.hover\\:fill-blumine-500\\/80:hover{
  fill: rgba(55, 135, 163, 0.8);
}

.hover\\:fill-blumine-500\\/85:hover{
  fill: rgba(55, 135, 163, 0.85);
}

.hover\\:fill-blumine-500\\/90:hover{
  fill: rgba(55, 135, 163, 0.9);
}

.hover\\:fill-blumine-500\\/95:hover{
  fill: rgba(55, 135, 163, 0.95);
}

.hover\\:fill-blumine-600:hover{
  fill: #306d8a;
}

.hover\\:fill-blumine-600\\/0:hover{
  fill: rgba(48, 109, 138, 0);
}

.hover\\:fill-blumine-600\\/10:hover{
  fill: rgba(48, 109, 138, 0.1);
}

.hover\\:fill-blumine-600\\/100:hover{
  fill: rgb(48, 109, 138);
}

.hover\\:fill-blumine-600\\/15:hover{
  fill: rgba(48, 109, 138, 0.15);
}

.hover\\:fill-blumine-600\\/20:hover{
  fill: rgba(48, 109, 138, 0.2);
}

.hover\\:fill-blumine-600\\/25:hover{
  fill: rgba(48, 109, 138, 0.25);
}

.hover\\:fill-blumine-600\\/30:hover{
  fill: rgba(48, 109, 138, 0.3);
}

.hover\\:fill-blumine-600\\/35:hover{
  fill: rgba(48, 109, 138, 0.35);
}

.hover\\:fill-blumine-600\\/40:hover{
  fill: rgba(48, 109, 138, 0.4);
}

.hover\\:fill-blumine-600\\/45:hover{
  fill: rgba(48, 109, 138, 0.45);
}

.hover\\:fill-blumine-600\\/5:hover{
  fill: rgba(48, 109, 138, 0.05);
}

.hover\\:fill-blumine-600\\/50:hover{
  fill: rgba(48, 109, 138, 0.5);
}

.hover\\:fill-blumine-600\\/55:hover{
  fill: rgba(48, 109, 138, 0.55);
}

.hover\\:fill-blumine-600\\/60:hover{
  fill: rgba(48, 109, 138, 0.6);
}

.hover\\:fill-blumine-600\\/65:hover{
  fill: rgba(48, 109, 138, 0.65);
}

.hover\\:fill-blumine-600\\/70:hover{
  fill: rgba(48, 109, 138, 0.7);
}

.hover\\:fill-blumine-600\\/75:hover{
  fill: rgba(48, 109, 138, 0.75);
}

.hover\\:fill-blumine-600\\/80:hover{
  fill: rgba(48, 109, 138, 0.8);
}

.hover\\:fill-blumine-600\\/85:hover{
  fill: rgba(48, 109, 138, 0.85);
}

.hover\\:fill-blumine-600\\/90:hover{
  fill: rgba(48, 109, 138, 0.9);
}

.hover\\:fill-blumine-600\\/95:hover{
  fill: rgba(48, 109, 138, 0.95);
}

.hover\\:fill-blumine-700:hover{
  fill: #2d5b72;
}

.hover\\:fill-blumine-700\\/0:hover{
  fill: rgba(45, 91, 114, 0);
}

.hover\\:fill-blumine-700\\/10:hover{
  fill: rgba(45, 91, 114, 0.1);
}

.hover\\:fill-blumine-700\\/100:hover{
  fill: rgb(45, 91, 114);
}

.hover\\:fill-blumine-700\\/15:hover{
  fill: rgba(45, 91, 114, 0.15);
}

.hover\\:fill-blumine-700\\/20:hover{
  fill: rgba(45, 91, 114, 0.2);
}

.hover\\:fill-blumine-700\\/25:hover{
  fill: rgba(45, 91, 114, 0.25);
}

.hover\\:fill-blumine-700\\/30:hover{
  fill: rgba(45, 91, 114, 0.3);
}

.hover\\:fill-blumine-700\\/35:hover{
  fill: rgba(45, 91, 114, 0.35);
}

.hover\\:fill-blumine-700\\/40:hover{
  fill: rgba(45, 91, 114, 0.4);
}

.hover\\:fill-blumine-700\\/45:hover{
  fill: rgba(45, 91, 114, 0.45);
}

.hover\\:fill-blumine-700\\/5:hover{
  fill: rgba(45, 91, 114, 0.05);
}

.hover\\:fill-blumine-700\\/50:hover{
  fill: rgba(45, 91, 114, 0.5);
}

.hover\\:fill-blumine-700\\/55:hover{
  fill: rgba(45, 91, 114, 0.55);
}

.hover\\:fill-blumine-700\\/60:hover{
  fill: rgba(45, 91, 114, 0.6);
}

.hover\\:fill-blumine-700\\/65:hover{
  fill: rgba(45, 91, 114, 0.65);
}

.hover\\:fill-blumine-700\\/70:hover{
  fill: rgba(45, 91, 114, 0.7);
}

.hover\\:fill-blumine-700\\/75:hover{
  fill: rgba(45, 91, 114, 0.75);
}

.hover\\:fill-blumine-700\\/80:hover{
  fill: rgba(45, 91, 114, 0.8);
}

.hover\\:fill-blumine-700\\/85:hover{
  fill: rgba(45, 91, 114, 0.85);
}

.hover\\:fill-blumine-700\\/90:hover{
  fill: rgba(45, 91, 114, 0.9);
}

.hover\\:fill-blumine-700\\/95:hover{
  fill: rgba(45, 91, 114, 0.95);
}

.hover\\:fill-blumine-800:hover{
  fill: #2c4c5e;
}

.hover\\:fill-blumine-800\\/0:hover{
  fill: rgba(44, 76, 94, 0);
}

.hover\\:fill-blumine-800\\/10:hover{
  fill: rgba(44, 76, 94, 0.1);
}

.hover\\:fill-blumine-800\\/100:hover{
  fill: rgb(44, 76, 94);
}

.hover\\:fill-blumine-800\\/15:hover{
  fill: rgba(44, 76, 94, 0.15);
}

.hover\\:fill-blumine-800\\/20:hover{
  fill: rgba(44, 76, 94, 0.2);
}

.hover\\:fill-blumine-800\\/25:hover{
  fill: rgba(44, 76, 94, 0.25);
}

.hover\\:fill-blumine-800\\/30:hover{
  fill: rgba(44, 76, 94, 0.3);
}

.hover\\:fill-blumine-800\\/35:hover{
  fill: rgba(44, 76, 94, 0.35);
}

.hover\\:fill-blumine-800\\/40:hover{
  fill: rgba(44, 76, 94, 0.4);
}

.hover\\:fill-blumine-800\\/45:hover{
  fill: rgba(44, 76, 94, 0.45);
}

.hover\\:fill-blumine-800\\/5:hover{
  fill: rgba(44, 76, 94, 0.05);
}

.hover\\:fill-blumine-800\\/50:hover{
  fill: rgba(44, 76, 94, 0.5);
}

.hover\\:fill-blumine-800\\/55:hover{
  fill: rgba(44, 76, 94, 0.55);
}

.hover\\:fill-blumine-800\\/60:hover{
  fill: rgba(44, 76, 94, 0.6);
}

.hover\\:fill-blumine-800\\/65:hover{
  fill: rgba(44, 76, 94, 0.65);
}

.hover\\:fill-blumine-800\\/70:hover{
  fill: rgba(44, 76, 94, 0.7);
}

.hover\\:fill-blumine-800\\/75:hover{
  fill: rgba(44, 76, 94, 0.75);
}

.hover\\:fill-blumine-800\\/80:hover{
  fill: rgba(44, 76, 94, 0.8);
}

.hover\\:fill-blumine-800\\/85:hover{
  fill: rgba(44, 76, 94, 0.85);
}

.hover\\:fill-blumine-800\\/90:hover{
  fill: rgba(44, 76, 94, 0.9);
}

.hover\\:fill-blumine-800\\/95:hover{
  fill: rgba(44, 76, 94, 0.95);
}

.hover\\:fill-blumine-900:hover{
  fill: #284151;
}

.hover\\:fill-blumine-900\\/0:hover{
  fill: rgba(40, 65, 81, 0);
}

.hover\\:fill-blumine-900\\/10:hover{
  fill: rgba(40, 65, 81, 0.1);
}

.hover\\:fill-blumine-900\\/100:hover{
  fill: rgb(40, 65, 81);
}

.hover\\:fill-blumine-900\\/15:hover{
  fill: rgba(40, 65, 81, 0.15);
}

.hover\\:fill-blumine-900\\/20:hover{
  fill: rgba(40, 65, 81, 0.2);
}

.hover\\:fill-blumine-900\\/25:hover{
  fill: rgba(40, 65, 81, 0.25);
}

.hover\\:fill-blumine-900\\/30:hover{
  fill: rgba(40, 65, 81, 0.3);
}

.hover\\:fill-blumine-900\\/35:hover{
  fill: rgba(40, 65, 81, 0.35);
}

.hover\\:fill-blumine-900\\/40:hover{
  fill: rgba(40, 65, 81, 0.4);
}

.hover\\:fill-blumine-900\\/45:hover{
  fill: rgba(40, 65, 81, 0.45);
}

.hover\\:fill-blumine-900\\/5:hover{
  fill: rgba(40, 65, 81, 0.05);
}

.hover\\:fill-blumine-900\\/50:hover{
  fill: rgba(40, 65, 81, 0.5);
}

.hover\\:fill-blumine-900\\/55:hover{
  fill: rgba(40, 65, 81, 0.55);
}

.hover\\:fill-blumine-900\\/60:hover{
  fill: rgba(40, 65, 81, 0.6);
}

.hover\\:fill-blumine-900\\/65:hover{
  fill: rgba(40, 65, 81, 0.65);
}

.hover\\:fill-blumine-900\\/70:hover{
  fill: rgba(40, 65, 81, 0.7);
}

.hover\\:fill-blumine-900\\/75:hover{
  fill: rgba(40, 65, 81, 0.75);
}

.hover\\:fill-blumine-900\\/80:hover{
  fill: rgba(40, 65, 81, 0.8);
}

.hover\\:fill-blumine-900\\/85:hover{
  fill: rgba(40, 65, 81, 0.85);
}

.hover\\:fill-blumine-900\\/90:hover{
  fill: rgba(40, 65, 81, 0.9);
}

.hover\\:fill-blumine-900\\/95:hover{
  fill: rgba(40, 65, 81, 0.95);
}

.hover\\:fill-blumine-950:hover{
  fill: #162936;
}

.hover\\:fill-blumine-950\\/0:hover{
  fill: rgba(22, 41, 54, 0);
}

.hover\\:fill-blumine-950\\/10:hover{
  fill: rgba(22, 41, 54, 0.1);
}

.hover\\:fill-blumine-950\\/100:hover{
  fill: rgb(22, 41, 54);
}

.hover\\:fill-blumine-950\\/15:hover{
  fill: rgba(22, 41, 54, 0.15);
}

.hover\\:fill-blumine-950\\/20:hover{
  fill: rgba(22, 41, 54, 0.2);
}

.hover\\:fill-blumine-950\\/25:hover{
  fill: rgba(22, 41, 54, 0.25);
}

.hover\\:fill-blumine-950\\/30:hover{
  fill: rgba(22, 41, 54, 0.3);
}

.hover\\:fill-blumine-950\\/35:hover{
  fill: rgba(22, 41, 54, 0.35);
}

.hover\\:fill-blumine-950\\/40:hover{
  fill: rgba(22, 41, 54, 0.4);
}

.hover\\:fill-blumine-950\\/45:hover{
  fill: rgba(22, 41, 54, 0.45);
}

.hover\\:fill-blumine-950\\/5:hover{
  fill: rgba(22, 41, 54, 0.05);
}

.hover\\:fill-blumine-950\\/50:hover{
  fill: rgba(22, 41, 54, 0.5);
}

.hover\\:fill-blumine-950\\/55:hover{
  fill: rgba(22, 41, 54, 0.55);
}

.hover\\:fill-blumine-950\\/60:hover{
  fill: rgba(22, 41, 54, 0.6);
}

.hover\\:fill-blumine-950\\/65:hover{
  fill: rgba(22, 41, 54, 0.65);
}

.hover\\:fill-blumine-950\\/70:hover{
  fill: rgba(22, 41, 54, 0.7);
}

.hover\\:fill-blumine-950\\/75:hover{
  fill: rgba(22, 41, 54, 0.75);
}

.hover\\:fill-blumine-950\\/80:hover{
  fill: rgba(22, 41, 54, 0.8);
}

.hover\\:fill-blumine-950\\/85:hover{
  fill: rgba(22, 41, 54, 0.85);
}

.hover\\:fill-blumine-950\\/90:hover{
  fill: rgba(22, 41, 54, 0.9);
}

.hover\\:fill-blumine-950\\/95:hover{
  fill: rgba(22, 41, 54, 0.95);
}

.hover\\:fill-charcoal-100:hover{
  fill: #e6e6e7;
}

.hover\\:fill-charcoal-100\\/0:hover{
  fill: rgba(230, 230, 231, 0);
}

.hover\\:fill-charcoal-100\\/10:hover{
  fill: rgba(230, 230, 231, 0.1);
}

.hover\\:fill-charcoal-100\\/100:hover{
  fill: rgb(230, 230, 231);
}

.hover\\:fill-charcoal-100\\/15:hover{
  fill: rgba(230, 230, 231, 0.15);
}

.hover\\:fill-charcoal-100\\/20:hover{
  fill: rgba(230, 230, 231, 0.2);
}

.hover\\:fill-charcoal-100\\/25:hover{
  fill: rgba(230, 230, 231, 0.25);
}

.hover\\:fill-charcoal-100\\/30:hover{
  fill: rgba(230, 230, 231, 0.3);
}

.hover\\:fill-charcoal-100\\/35:hover{
  fill: rgba(230, 230, 231, 0.35);
}

.hover\\:fill-charcoal-100\\/40:hover{
  fill: rgba(230, 230, 231, 0.4);
}

.hover\\:fill-charcoal-100\\/45:hover{
  fill: rgba(230, 230, 231, 0.45);
}

.hover\\:fill-charcoal-100\\/5:hover{
  fill: rgba(230, 230, 231, 0.05);
}

.hover\\:fill-charcoal-100\\/50:hover{
  fill: rgba(230, 230, 231, 0.5);
}

.hover\\:fill-charcoal-100\\/55:hover{
  fill: rgba(230, 230, 231, 0.55);
}

.hover\\:fill-charcoal-100\\/60:hover{
  fill: rgba(230, 230, 231, 0.6);
}

.hover\\:fill-charcoal-100\\/65:hover{
  fill: rgba(230, 230, 231, 0.65);
}

.hover\\:fill-charcoal-100\\/70:hover{
  fill: rgba(230, 230, 231, 0.7);
}

.hover\\:fill-charcoal-100\\/75:hover{
  fill: rgba(230, 230, 231, 0.75);
}

.hover\\:fill-charcoal-100\\/80:hover{
  fill: rgba(230, 230, 231, 0.8);
}

.hover\\:fill-charcoal-100\\/85:hover{
  fill: rgba(230, 230, 231, 0.85);
}

.hover\\:fill-charcoal-100\\/90:hover{
  fill: rgba(230, 230, 231, 0.9);
}

.hover\\:fill-charcoal-100\\/95:hover{
  fill: rgba(230, 230, 231, 0.95);
}

.hover\\:fill-charcoal-200:hover{
  fill: #cfd0d2;
}

.hover\\:fill-charcoal-200\\/0:hover{
  fill: rgba(207, 208, 210, 0);
}

.hover\\:fill-charcoal-200\\/10:hover{
  fill: rgba(207, 208, 210, 0.1);
}

.hover\\:fill-charcoal-200\\/100:hover{
  fill: rgb(207, 208, 210);
}

.hover\\:fill-charcoal-200\\/15:hover{
  fill: rgba(207, 208, 210, 0.15);
}

.hover\\:fill-charcoal-200\\/20:hover{
  fill: rgba(207, 208, 210, 0.2);
}

.hover\\:fill-charcoal-200\\/25:hover{
  fill: rgba(207, 208, 210, 0.25);
}

.hover\\:fill-charcoal-200\\/30:hover{
  fill: rgba(207, 208, 210, 0.3);
}

.hover\\:fill-charcoal-200\\/35:hover{
  fill: rgba(207, 208, 210, 0.35);
}

.hover\\:fill-charcoal-200\\/40:hover{
  fill: rgba(207, 208, 210, 0.4);
}

.hover\\:fill-charcoal-200\\/45:hover{
  fill: rgba(207, 208, 210, 0.45);
}

.hover\\:fill-charcoal-200\\/5:hover{
  fill: rgba(207, 208, 210, 0.05);
}

.hover\\:fill-charcoal-200\\/50:hover{
  fill: rgba(207, 208, 210, 0.5);
}

.hover\\:fill-charcoal-200\\/55:hover{
  fill: rgba(207, 208, 210, 0.55);
}

.hover\\:fill-charcoal-200\\/60:hover{
  fill: rgba(207, 208, 210, 0.6);
}

.hover\\:fill-charcoal-200\\/65:hover{
  fill: rgba(207, 208, 210, 0.65);
}

.hover\\:fill-charcoal-200\\/70:hover{
  fill: rgba(207, 208, 210, 0.7);
}

.hover\\:fill-charcoal-200\\/75:hover{
  fill: rgba(207, 208, 210, 0.75);
}

.hover\\:fill-charcoal-200\\/80:hover{
  fill: rgba(207, 208, 210, 0.8);
}

.hover\\:fill-charcoal-200\\/85:hover{
  fill: rgba(207, 208, 210, 0.85);
}

.hover\\:fill-charcoal-200\\/90:hover{
  fill: rgba(207, 208, 210, 0.9);
}

.hover\\:fill-charcoal-200\\/95:hover{
  fill: rgba(207, 208, 210, 0.95);
}

.hover\\:fill-charcoal-300:hover{
  fill: #aeafb2;
}

.hover\\:fill-charcoal-300\\/0:hover{
  fill: rgba(174, 175, 178, 0);
}

.hover\\:fill-charcoal-300\\/10:hover{
  fill: rgba(174, 175, 178, 0.1);
}

.hover\\:fill-charcoal-300\\/100:hover{
  fill: rgb(174, 175, 178);
}

.hover\\:fill-charcoal-300\\/15:hover{
  fill: rgba(174, 175, 178, 0.15);
}

.hover\\:fill-charcoal-300\\/20:hover{
  fill: rgba(174, 175, 178, 0.2);
}

.hover\\:fill-charcoal-300\\/25:hover{
  fill: rgba(174, 175, 178, 0.25);
}

.hover\\:fill-charcoal-300\\/30:hover{
  fill: rgba(174, 175, 178, 0.3);
}

.hover\\:fill-charcoal-300\\/35:hover{
  fill: rgba(174, 175, 178, 0.35);
}

.hover\\:fill-charcoal-300\\/40:hover{
  fill: rgba(174, 175, 178, 0.4);
}

.hover\\:fill-charcoal-300\\/45:hover{
  fill: rgba(174, 175, 178, 0.45);
}

.hover\\:fill-charcoal-300\\/5:hover{
  fill: rgba(174, 175, 178, 0.05);
}

.hover\\:fill-charcoal-300\\/50:hover{
  fill: rgba(174, 175, 178, 0.5);
}

.hover\\:fill-charcoal-300\\/55:hover{
  fill: rgba(174, 175, 178, 0.55);
}

.hover\\:fill-charcoal-300\\/60:hover{
  fill: rgba(174, 175, 178, 0.6);
}

.hover\\:fill-charcoal-300\\/65:hover{
  fill: rgba(174, 175, 178, 0.65);
}

.hover\\:fill-charcoal-300\\/70:hover{
  fill: rgba(174, 175, 178, 0.7);
}

.hover\\:fill-charcoal-300\\/75:hover{
  fill: rgba(174, 175, 178, 0.75);
}

.hover\\:fill-charcoal-300\\/80:hover{
  fill: rgba(174, 175, 178, 0.8);
}

.hover\\:fill-charcoal-300\\/85:hover{
  fill: rgba(174, 175, 178, 0.85);
}

.hover\\:fill-charcoal-300\\/90:hover{
  fill: rgba(174, 175, 178, 0.9);
}

.hover\\:fill-charcoal-300\\/95:hover{
  fill: rgba(174, 175, 178, 0.95);
}

.hover\\:fill-charcoal-400:hover{
  fill: #85868b;
}

.hover\\:fill-charcoal-400\\/0:hover{
  fill: rgba(133, 134, 139, 0);
}

.hover\\:fill-charcoal-400\\/10:hover{
  fill: rgba(133, 134, 139, 0.1);
}

.hover\\:fill-charcoal-400\\/100:hover{
  fill: rgb(133, 134, 139);
}

.hover\\:fill-charcoal-400\\/15:hover{
  fill: rgba(133, 134, 139, 0.15);
}

.hover\\:fill-charcoal-400\\/20:hover{
  fill: rgba(133, 134, 139, 0.2);
}

.hover\\:fill-charcoal-400\\/25:hover{
  fill: rgba(133, 134, 139, 0.25);
}

.hover\\:fill-charcoal-400\\/30:hover{
  fill: rgba(133, 134, 139, 0.3);
}

.hover\\:fill-charcoal-400\\/35:hover{
  fill: rgba(133, 134, 139, 0.35);
}

.hover\\:fill-charcoal-400\\/40:hover{
  fill: rgba(133, 134, 139, 0.4);
}

.hover\\:fill-charcoal-400\\/45:hover{
  fill: rgba(133, 134, 139, 0.45);
}

.hover\\:fill-charcoal-400\\/5:hover{
  fill: rgba(133, 134, 139, 0.05);
}

.hover\\:fill-charcoal-400\\/50:hover{
  fill: rgba(133, 134, 139, 0.5);
}

.hover\\:fill-charcoal-400\\/55:hover{
  fill: rgba(133, 134, 139, 0.55);
}

.hover\\:fill-charcoal-400\\/60:hover{
  fill: rgba(133, 134, 139, 0.6);
}

.hover\\:fill-charcoal-400\\/65:hover{
  fill: rgba(133, 134, 139, 0.65);
}

.hover\\:fill-charcoal-400\\/70:hover{
  fill: rgba(133, 134, 139, 0.7);
}

.hover\\:fill-charcoal-400\\/75:hover{
  fill: rgba(133, 134, 139, 0.75);
}

.hover\\:fill-charcoal-400\\/80:hover{
  fill: rgba(133, 134, 139, 0.8);
}

.hover\\:fill-charcoal-400\\/85:hover{
  fill: rgba(133, 134, 139, 0.85);
}

.hover\\:fill-charcoal-400\\/90:hover{
  fill: rgba(133, 134, 139, 0.9);
}

.hover\\:fill-charcoal-400\\/95:hover{
  fill: rgba(133, 134, 139, 0.95);
}

.hover\\:fill-charcoal-500:hover{
  fill: #6a6b70;
}

.hover\\:fill-charcoal-500\\/0:hover{
  fill: rgba(106, 107, 112, 0);
}

.hover\\:fill-charcoal-500\\/10:hover{
  fill: rgba(106, 107, 112, 0.1);
}

.hover\\:fill-charcoal-500\\/100:hover{
  fill: rgb(106, 107, 112);
}

.hover\\:fill-charcoal-500\\/15:hover{
  fill: rgba(106, 107, 112, 0.15);
}

.hover\\:fill-charcoal-500\\/20:hover{
  fill: rgba(106, 107, 112, 0.2);
}

.hover\\:fill-charcoal-500\\/25:hover{
  fill: rgba(106, 107, 112, 0.25);
}

.hover\\:fill-charcoal-500\\/30:hover{
  fill: rgba(106, 107, 112, 0.3);
}

.hover\\:fill-charcoal-500\\/35:hover{
  fill: rgba(106, 107, 112, 0.35);
}

.hover\\:fill-charcoal-500\\/40:hover{
  fill: rgba(106, 107, 112, 0.4);
}

.hover\\:fill-charcoal-500\\/45:hover{
  fill: rgba(106, 107, 112, 0.45);
}

.hover\\:fill-charcoal-500\\/5:hover{
  fill: rgba(106, 107, 112, 0.05);
}

.hover\\:fill-charcoal-500\\/50:hover{
  fill: rgba(106, 107, 112, 0.5);
}

.hover\\:fill-charcoal-500\\/55:hover{
  fill: rgba(106, 107, 112, 0.55);
}

.hover\\:fill-charcoal-500\\/60:hover{
  fill: rgba(106, 107, 112, 0.6);
}

.hover\\:fill-charcoal-500\\/65:hover{
  fill: rgba(106, 107, 112, 0.65);
}

.hover\\:fill-charcoal-500\\/70:hover{
  fill: rgba(106, 107, 112, 0.7);
}

.hover\\:fill-charcoal-500\\/75:hover{
  fill: rgba(106, 107, 112, 0.75);
}

.hover\\:fill-charcoal-500\\/80:hover{
  fill: rgba(106, 107, 112, 0.8);
}

.hover\\:fill-charcoal-500\\/85:hover{
  fill: rgba(106, 107, 112, 0.85);
}

.hover\\:fill-charcoal-500\\/90:hover{
  fill: rgba(106, 107, 112, 0.9);
}

.hover\\:fill-charcoal-500\\/95:hover{
  fill: rgba(106, 107, 112, 0.95);
}

.hover\\:fill-charcoal-600:hover{
  fill: #5a5b60;
}

.hover\\:fill-charcoal-600\\/0:hover{
  fill: rgba(90, 91, 96, 0);
}

.hover\\:fill-charcoal-600\\/10:hover{
  fill: rgba(90, 91, 96, 0.1);
}

.hover\\:fill-charcoal-600\\/100:hover{
  fill: rgb(90, 91, 96);
}

.hover\\:fill-charcoal-600\\/15:hover{
  fill: rgba(90, 91, 96, 0.15);
}

.hover\\:fill-charcoal-600\\/20:hover{
  fill: rgba(90, 91, 96, 0.2);
}

.hover\\:fill-charcoal-600\\/25:hover{
  fill: rgba(90, 91, 96, 0.25);
}

.hover\\:fill-charcoal-600\\/30:hover{
  fill: rgba(90, 91, 96, 0.3);
}

.hover\\:fill-charcoal-600\\/35:hover{
  fill: rgba(90, 91, 96, 0.35);
}

.hover\\:fill-charcoal-600\\/40:hover{
  fill: rgba(90, 91, 96, 0.4);
}

.hover\\:fill-charcoal-600\\/45:hover{
  fill: rgba(90, 91, 96, 0.45);
}

.hover\\:fill-charcoal-600\\/5:hover{
  fill: rgba(90, 91, 96, 0.05);
}

.hover\\:fill-charcoal-600\\/50:hover{
  fill: rgba(90, 91, 96, 0.5);
}

.hover\\:fill-charcoal-600\\/55:hover{
  fill: rgba(90, 91, 96, 0.55);
}

.hover\\:fill-charcoal-600\\/60:hover{
  fill: rgba(90, 91, 96, 0.6);
}

.hover\\:fill-charcoal-600\\/65:hover{
  fill: rgba(90, 91, 96, 0.65);
}

.hover\\:fill-charcoal-600\\/70:hover{
  fill: rgba(90, 91, 96, 0.7);
}

.hover\\:fill-charcoal-600\\/75:hover{
  fill: rgba(90, 91, 96, 0.75);
}

.hover\\:fill-charcoal-600\\/80:hover{
  fill: rgba(90, 91, 96, 0.8);
}

.hover\\:fill-charcoal-600\\/85:hover{
  fill: rgba(90, 91, 96, 0.85);
}

.hover\\:fill-charcoal-600\\/90:hover{
  fill: rgba(90, 91, 96, 0.9);
}

.hover\\:fill-charcoal-600\\/95:hover{
  fill: rgba(90, 91, 96, 0.95);
}

.hover\\:fill-charcoal-700:hover{
  fill: #4d4d51;
}

.hover\\:fill-charcoal-700\\/0:hover{
  fill: rgba(77, 77, 81, 0);
}

.hover\\:fill-charcoal-700\\/10:hover{
  fill: rgba(77, 77, 81, 0.1);
}

.hover\\:fill-charcoal-700\\/100:hover{
  fill: rgb(77, 77, 81);
}

.hover\\:fill-charcoal-700\\/15:hover{
  fill: rgba(77, 77, 81, 0.15);
}

.hover\\:fill-charcoal-700\\/20:hover{
  fill: rgba(77, 77, 81, 0.2);
}

.hover\\:fill-charcoal-700\\/25:hover{
  fill: rgba(77, 77, 81, 0.25);
}

.hover\\:fill-charcoal-700\\/30:hover{
  fill: rgba(77, 77, 81, 0.3);
}

.hover\\:fill-charcoal-700\\/35:hover{
  fill: rgba(77, 77, 81, 0.35);
}

.hover\\:fill-charcoal-700\\/40:hover{
  fill: rgba(77, 77, 81, 0.4);
}

.hover\\:fill-charcoal-700\\/45:hover{
  fill: rgba(77, 77, 81, 0.45);
}

.hover\\:fill-charcoal-700\\/5:hover{
  fill: rgba(77, 77, 81, 0.05);
}

.hover\\:fill-charcoal-700\\/50:hover{
  fill: rgba(77, 77, 81, 0.5);
}

.hover\\:fill-charcoal-700\\/55:hover{
  fill: rgba(77, 77, 81, 0.55);
}

.hover\\:fill-charcoal-700\\/60:hover{
  fill: rgba(77, 77, 81, 0.6);
}

.hover\\:fill-charcoal-700\\/65:hover{
  fill: rgba(77, 77, 81, 0.65);
}

.hover\\:fill-charcoal-700\\/70:hover{
  fill: rgba(77, 77, 81, 0.7);
}

.hover\\:fill-charcoal-700\\/75:hover{
  fill: rgba(77, 77, 81, 0.75);
}

.hover\\:fill-charcoal-700\\/80:hover{
  fill: rgba(77, 77, 81, 0.8);
}

.hover\\:fill-charcoal-700\\/85:hover{
  fill: rgba(77, 77, 81, 0.85);
}

.hover\\:fill-charcoal-700\\/90:hover{
  fill: rgba(77, 77, 81, 0.9);
}

.hover\\:fill-charcoal-700\\/95:hover{
  fill: rgba(77, 77, 81, 0.95);
}

.hover\\:fill-charcoal-800:hover{
  fill: #434347;
}

.hover\\:fill-charcoal-800\\/0:hover{
  fill: rgba(67, 67, 71, 0);
}

.hover\\:fill-charcoal-800\\/10:hover{
  fill: rgba(67, 67, 71, 0.1);
}

.hover\\:fill-charcoal-800\\/100:hover{
  fill: rgb(67, 67, 71);
}

.hover\\:fill-charcoal-800\\/15:hover{
  fill: rgba(67, 67, 71, 0.15);
}

.hover\\:fill-charcoal-800\\/20:hover{
  fill: rgba(67, 67, 71, 0.2);
}

.hover\\:fill-charcoal-800\\/25:hover{
  fill: rgba(67, 67, 71, 0.25);
}

.hover\\:fill-charcoal-800\\/30:hover{
  fill: rgba(67, 67, 71, 0.3);
}

.hover\\:fill-charcoal-800\\/35:hover{
  fill: rgba(67, 67, 71, 0.35);
}

.hover\\:fill-charcoal-800\\/40:hover{
  fill: rgba(67, 67, 71, 0.4);
}

.hover\\:fill-charcoal-800\\/45:hover{
  fill: rgba(67, 67, 71, 0.45);
}

.hover\\:fill-charcoal-800\\/5:hover{
  fill: rgba(67, 67, 71, 0.05);
}

.hover\\:fill-charcoal-800\\/50:hover{
  fill: rgba(67, 67, 71, 0.5);
}

.hover\\:fill-charcoal-800\\/55:hover{
  fill: rgba(67, 67, 71, 0.55);
}

.hover\\:fill-charcoal-800\\/60:hover{
  fill: rgba(67, 67, 71, 0.6);
}

.hover\\:fill-charcoal-800\\/65:hover{
  fill: rgba(67, 67, 71, 0.65);
}

.hover\\:fill-charcoal-800\\/70:hover{
  fill: rgba(67, 67, 71, 0.7);
}

.hover\\:fill-charcoal-800\\/75:hover{
  fill: rgba(67, 67, 71, 0.75);
}

.hover\\:fill-charcoal-800\\/80:hover{
  fill: rgba(67, 67, 71, 0.8);
}

.hover\\:fill-charcoal-800\\/85:hover{
  fill: rgba(67, 67, 71, 0.85);
}

.hover\\:fill-charcoal-800\\/90:hover{
  fill: rgba(67, 67, 71, 0.9);
}

.hover\\:fill-charcoal-800\\/95:hover{
  fill: rgba(67, 67, 71, 0.95);
}

.hover\\:fill-charcoal-900:hover{
  fill: #313133;
}

.hover\\:fill-charcoal-900\\/0:hover{
  fill: rgba(49, 49, 51, 0);
}

.hover\\:fill-charcoal-900\\/10:hover{
  fill: rgba(49, 49, 51, 0.1);
}

.hover\\:fill-charcoal-900\\/100:hover{
  fill: rgb(49, 49, 51);
}

.hover\\:fill-charcoal-900\\/15:hover{
  fill: rgba(49, 49, 51, 0.15);
}

.hover\\:fill-charcoal-900\\/20:hover{
  fill: rgba(49, 49, 51, 0.2);
}

.hover\\:fill-charcoal-900\\/25:hover{
  fill: rgba(49, 49, 51, 0.25);
}

.hover\\:fill-charcoal-900\\/30:hover{
  fill: rgba(49, 49, 51, 0.3);
}

.hover\\:fill-charcoal-900\\/35:hover{
  fill: rgba(49, 49, 51, 0.35);
}

.hover\\:fill-charcoal-900\\/40:hover{
  fill: rgba(49, 49, 51, 0.4);
}

.hover\\:fill-charcoal-900\\/45:hover{
  fill: rgba(49, 49, 51, 0.45);
}

.hover\\:fill-charcoal-900\\/5:hover{
  fill: rgba(49, 49, 51, 0.05);
}

.hover\\:fill-charcoal-900\\/50:hover{
  fill: rgba(49, 49, 51, 0.5);
}

.hover\\:fill-charcoal-900\\/55:hover{
  fill: rgba(49, 49, 51, 0.55);
}

.hover\\:fill-charcoal-900\\/60:hover{
  fill: rgba(49, 49, 51, 0.6);
}

.hover\\:fill-charcoal-900\\/65:hover{
  fill: rgba(49, 49, 51, 0.65);
}

.hover\\:fill-charcoal-900\\/70:hover{
  fill: rgba(49, 49, 51, 0.7);
}

.hover\\:fill-charcoal-900\\/75:hover{
  fill: rgba(49, 49, 51, 0.75);
}

.hover\\:fill-charcoal-900\\/80:hover{
  fill: rgba(49, 49, 51, 0.8);
}

.hover\\:fill-charcoal-900\\/85:hover{
  fill: rgba(49, 49, 51, 0.85);
}

.hover\\:fill-charcoal-900\\/90:hover{
  fill: rgba(49, 49, 51, 0.9);
}

.hover\\:fill-charcoal-900\\/95:hover{
  fill: rgba(49, 49, 51, 0.95);
}

.hover\\:fill-charcoal-950:hover{
  fill: #252527;
}

.hover\\:fill-charcoal-950\\/0:hover{
  fill: rgba(37, 37, 39, 0);
}

.hover\\:fill-charcoal-950\\/10:hover{
  fill: rgba(37, 37, 39, 0.1);
}

.hover\\:fill-charcoal-950\\/100:hover{
  fill: rgb(37, 37, 39);
}

.hover\\:fill-charcoal-950\\/15:hover{
  fill: rgba(37, 37, 39, 0.15);
}

.hover\\:fill-charcoal-950\\/20:hover{
  fill: rgba(37, 37, 39, 0.2);
}

.hover\\:fill-charcoal-950\\/25:hover{
  fill: rgba(37, 37, 39, 0.25);
}

.hover\\:fill-charcoal-950\\/30:hover{
  fill: rgba(37, 37, 39, 0.3);
}

.hover\\:fill-charcoal-950\\/35:hover{
  fill: rgba(37, 37, 39, 0.35);
}

.hover\\:fill-charcoal-950\\/40:hover{
  fill: rgba(37, 37, 39, 0.4);
}

.hover\\:fill-charcoal-950\\/45:hover{
  fill: rgba(37, 37, 39, 0.45);
}

.hover\\:fill-charcoal-950\\/5:hover{
  fill: rgba(37, 37, 39, 0.05);
}

.hover\\:fill-charcoal-950\\/50:hover{
  fill: rgba(37, 37, 39, 0.5);
}

.hover\\:fill-charcoal-950\\/55:hover{
  fill: rgba(37, 37, 39, 0.55);
}

.hover\\:fill-charcoal-950\\/60:hover{
  fill: rgba(37, 37, 39, 0.6);
}

.hover\\:fill-charcoal-950\\/65:hover{
  fill: rgba(37, 37, 39, 0.65);
}

.hover\\:fill-charcoal-950\\/70:hover{
  fill: rgba(37, 37, 39, 0.7);
}

.hover\\:fill-charcoal-950\\/75:hover{
  fill: rgba(37, 37, 39, 0.75);
}

.hover\\:fill-charcoal-950\\/80:hover{
  fill: rgba(37, 37, 39, 0.8);
}

.hover\\:fill-charcoal-950\\/85:hover{
  fill: rgba(37, 37, 39, 0.85);
}

.hover\\:fill-charcoal-950\\/90:hover{
  fill: rgba(37, 37, 39, 0.9);
}

.hover\\:fill-charcoal-950\\/95:hover{
  fill: rgba(37, 37, 39, 0.95);
}

.hover\\:fill-jade-100:hover{
  fill: #d9f2e6;
}

.hover\\:fill-jade-100\\/0:hover{
  fill: rgba(217, 242, 230, 0);
}

.hover\\:fill-jade-100\\/10:hover{
  fill: rgba(217, 242, 230, 0.1);
}

.hover\\:fill-jade-100\\/100:hover{
  fill: rgb(217, 242, 230);
}

.hover\\:fill-jade-100\\/15:hover{
  fill: rgba(217, 242, 230, 0.15);
}

.hover\\:fill-jade-100\\/20:hover{
  fill: rgba(217, 242, 230, 0.2);
}

.hover\\:fill-jade-100\\/25:hover{
  fill: rgba(217, 242, 230, 0.25);
}

.hover\\:fill-jade-100\\/30:hover{
  fill: rgba(217, 242, 230, 0.3);
}

.hover\\:fill-jade-100\\/35:hover{
  fill: rgba(217, 242, 230, 0.35);
}

.hover\\:fill-jade-100\\/40:hover{
  fill: rgba(217, 242, 230, 0.4);
}

.hover\\:fill-jade-100\\/45:hover{
  fill: rgba(217, 242, 230, 0.45);
}

.hover\\:fill-jade-100\\/5:hover{
  fill: rgba(217, 242, 230, 0.05);
}

.hover\\:fill-jade-100\\/50:hover{
  fill: rgba(217, 242, 230, 0.5);
}

.hover\\:fill-jade-100\\/55:hover{
  fill: rgba(217, 242, 230, 0.55);
}

.hover\\:fill-jade-100\\/60:hover{
  fill: rgba(217, 242, 230, 0.6);
}

.hover\\:fill-jade-100\\/65:hover{
  fill: rgba(217, 242, 230, 0.65);
}

.hover\\:fill-jade-100\\/70:hover{
  fill: rgba(217, 242, 230, 0.7);
}

.hover\\:fill-jade-100\\/75:hover{
  fill: rgba(217, 242, 230, 0.75);
}

.hover\\:fill-jade-100\\/80:hover{
  fill: rgba(217, 242, 230, 0.8);
}

.hover\\:fill-jade-100\\/85:hover{
  fill: rgba(217, 242, 230, 0.85);
}

.hover\\:fill-jade-100\\/90:hover{
  fill: rgba(217, 242, 230, 0.9);
}

.hover\\:fill-jade-100\\/95:hover{
  fill: rgba(217, 242, 230, 0.95);
}

.hover\\:fill-jade-200:hover{
  fill: #b6e4d1;
}

.hover\\:fill-jade-200\\/0:hover{
  fill: rgba(182, 228, 209, 0);
}

.hover\\:fill-jade-200\\/10:hover{
  fill: rgba(182, 228, 209, 0.1);
}

.hover\\:fill-jade-200\\/100:hover{
  fill: rgb(182, 228, 209);
}

.hover\\:fill-jade-200\\/15:hover{
  fill: rgba(182, 228, 209, 0.15);
}

.hover\\:fill-jade-200\\/20:hover{
  fill: rgba(182, 228, 209, 0.2);
}

.hover\\:fill-jade-200\\/25:hover{
  fill: rgba(182, 228, 209, 0.25);
}

.hover\\:fill-jade-200\\/30:hover{
  fill: rgba(182, 228, 209, 0.3);
}

.hover\\:fill-jade-200\\/35:hover{
  fill: rgba(182, 228, 209, 0.35);
}

.hover\\:fill-jade-200\\/40:hover{
  fill: rgba(182, 228, 209, 0.4);
}

.hover\\:fill-jade-200\\/45:hover{
  fill: rgba(182, 228, 209, 0.45);
}

.hover\\:fill-jade-200\\/5:hover{
  fill: rgba(182, 228, 209, 0.05);
}

.hover\\:fill-jade-200\\/50:hover{
  fill: rgba(182, 228, 209, 0.5);
}

.hover\\:fill-jade-200\\/55:hover{
  fill: rgba(182, 228, 209, 0.55);
}

.hover\\:fill-jade-200\\/60:hover{
  fill: rgba(182, 228, 209, 0.6);
}

.hover\\:fill-jade-200\\/65:hover{
  fill: rgba(182, 228, 209, 0.65);
}

.hover\\:fill-jade-200\\/70:hover{
  fill: rgba(182, 228, 209, 0.7);
}

.hover\\:fill-jade-200\\/75:hover{
  fill: rgba(182, 228, 209, 0.75);
}

.hover\\:fill-jade-200\\/80:hover{
  fill: rgba(182, 228, 209, 0.8);
}

.hover\\:fill-jade-200\\/85:hover{
  fill: rgba(182, 228, 209, 0.85);
}

.hover\\:fill-jade-200\\/90:hover{
  fill: rgba(182, 228, 209, 0.9);
}

.hover\\:fill-jade-200\\/95:hover{
  fill: rgba(182, 228, 209, 0.95);
}

.hover\\:fill-jade-300:hover{
  fill: #86cfb5;
}

.hover\\:fill-jade-300\\/0:hover{
  fill: rgba(134, 207, 181, 0);
}

.hover\\:fill-jade-300\\/10:hover{
  fill: rgba(134, 207, 181, 0.1);
}

.hover\\:fill-jade-300\\/100:hover{
  fill: rgb(134, 207, 181);
}

.hover\\:fill-jade-300\\/15:hover{
  fill: rgba(134, 207, 181, 0.15);
}

.hover\\:fill-jade-300\\/20:hover{
  fill: rgba(134, 207, 181, 0.2);
}

.hover\\:fill-jade-300\\/25:hover{
  fill: rgba(134, 207, 181, 0.25);
}

.hover\\:fill-jade-300\\/30:hover{
  fill: rgba(134, 207, 181, 0.3);
}

.hover\\:fill-jade-300\\/35:hover{
  fill: rgba(134, 207, 181, 0.35);
}

.hover\\:fill-jade-300\\/40:hover{
  fill: rgba(134, 207, 181, 0.4);
}

.hover\\:fill-jade-300\\/45:hover{
  fill: rgba(134, 207, 181, 0.45);
}

.hover\\:fill-jade-300\\/5:hover{
  fill: rgba(134, 207, 181, 0.05);
}

.hover\\:fill-jade-300\\/50:hover{
  fill: rgba(134, 207, 181, 0.5);
}

.hover\\:fill-jade-300\\/55:hover{
  fill: rgba(134, 207, 181, 0.55);
}

.hover\\:fill-jade-300\\/60:hover{
  fill: rgba(134, 207, 181, 0.6);
}

.hover\\:fill-jade-300\\/65:hover{
  fill: rgba(134, 207, 181, 0.65);
}

.hover\\:fill-jade-300\\/70:hover{
  fill: rgba(134, 207, 181, 0.7);
}

.hover\\:fill-jade-300\\/75:hover{
  fill: rgba(134, 207, 181, 0.75);
}

.hover\\:fill-jade-300\\/80:hover{
  fill: rgba(134, 207, 181, 0.8);
}

.hover\\:fill-jade-300\\/85:hover{
  fill: rgba(134, 207, 181, 0.85);
}

.hover\\:fill-jade-300\\/90:hover{
  fill: rgba(134, 207, 181, 0.9);
}

.hover\\:fill-jade-300\\/95:hover{
  fill: rgba(134, 207, 181, 0.95);
}

.hover\\:fill-jade-400:hover{
  fill: #53b494;
}

.hover\\:fill-jade-400\\/0:hover{
  fill: rgba(83, 180, 148, 0);
}

.hover\\:fill-jade-400\\/10:hover{
  fill: rgba(83, 180, 148, 0.1);
}

.hover\\:fill-jade-400\\/100:hover{
  fill: rgb(83, 180, 148);
}

.hover\\:fill-jade-400\\/15:hover{
  fill: rgba(83, 180, 148, 0.15);
}

.hover\\:fill-jade-400\\/20:hover{
  fill: rgba(83, 180, 148, 0.2);
}

.hover\\:fill-jade-400\\/25:hover{
  fill: rgba(83, 180, 148, 0.25);
}

.hover\\:fill-jade-400\\/30:hover{
  fill: rgba(83, 180, 148, 0.3);
}

.hover\\:fill-jade-400\\/35:hover{
  fill: rgba(83, 180, 148, 0.35);
}

.hover\\:fill-jade-400\\/40:hover{
  fill: rgba(83, 180, 148, 0.4);
}

.hover\\:fill-jade-400\\/45:hover{
  fill: rgba(83, 180, 148, 0.45);
}

.hover\\:fill-jade-400\\/5:hover{
  fill: rgba(83, 180, 148, 0.05);
}

.hover\\:fill-jade-400\\/50:hover{
  fill: rgba(83, 180, 148, 0.5);
}

.hover\\:fill-jade-400\\/55:hover{
  fill: rgba(83, 180, 148, 0.55);
}

.hover\\:fill-jade-400\\/60:hover{
  fill: rgba(83, 180, 148, 0.6);
}

.hover\\:fill-jade-400\\/65:hover{
  fill: rgba(83, 180, 148, 0.65);
}

.hover\\:fill-jade-400\\/70:hover{
  fill: rgba(83, 180, 148, 0.7);
}

.hover\\:fill-jade-400\\/75:hover{
  fill: rgba(83, 180, 148, 0.75);
}

.hover\\:fill-jade-400\\/80:hover{
  fill: rgba(83, 180, 148, 0.8);
}

.hover\\:fill-jade-400\\/85:hover{
  fill: rgba(83, 180, 148, 0.85);
}

.hover\\:fill-jade-400\\/90:hover{
  fill: rgba(83, 180, 148, 0.9);
}

.hover\\:fill-jade-400\\/95:hover{
  fill: rgba(83, 180, 148, 0.95);
}

.hover\\:fill-jade-500:hover{
  fill: #2c876d;
}

.hover\\:fill-jade-500\\/0:hover{
  fill: rgba(44, 135, 109, 0);
}

.hover\\:fill-jade-500\\/10:hover{
  fill: rgba(44, 135, 109, 0.1);
}

.hover\\:fill-jade-500\\/100:hover{
  fill: rgb(44, 135, 109);
}

.hover\\:fill-jade-500\\/15:hover{
  fill: rgba(44, 135, 109, 0.15);
}

.hover\\:fill-jade-500\\/20:hover{
  fill: rgba(44, 135, 109, 0.2);
}

.hover\\:fill-jade-500\\/25:hover{
  fill: rgba(44, 135, 109, 0.25);
}

.hover\\:fill-jade-500\\/30:hover{
  fill: rgba(44, 135, 109, 0.3);
}

.hover\\:fill-jade-500\\/35:hover{
  fill: rgba(44, 135, 109, 0.35);
}

.hover\\:fill-jade-500\\/40:hover{
  fill: rgba(44, 135, 109, 0.4);
}

.hover\\:fill-jade-500\\/45:hover{
  fill: rgba(44, 135, 109, 0.45);
}

.hover\\:fill-jade-500\\/5:hover{
  fill: rgba(44, 135, 109, 0.05);
}

.hover\\:fill-jade-500\\/50:hover{
  fill: rgba(44, 135, 109, 0.5);
}

.hover\\:fill-jade-500\\/55:hover{
  fill: rgba(44, 135, 109, 0.55);
}

.hover\\:fill-jade-500\\/60:hover{
  fill: rgba(44, 135, 109, 0.6);
}

.hover\\:fill-jade-500\\/65:hover{
  fill: rgba(44, 135, 109, 0.65);
}

.hover\\:fill-jade-500\\/70:hover{
  fill: rgba(44, 135, 109, 0.7);
}

.hover\\:fill-jade-500\\/75:hover{
  fill: rgba(44, 135, 109, 0.75);
}

.hover\\:fill-jade-500\\/80:hover{
  fill: rgba(44, 135, 109, 0.8);
}

.hover\\:fill-jade-500\\/85:hover{
  fill: rgba(44, 135, 109, 0.85);
}

.hover\\:fill-jade-500\\/90:hover{
  fill: rgba(44, 135, 109, 0.9);
}

.hover\\:fill-jade-500\\/95:hover{
  fill: rgba(44, 135, 109, 0.95);
}

.hover\\:fill-jade-600:hover{
  fill: #227962;
}

.hover\\:fill-jade-600\\/0:hover{
  fill: rgba(34, 121, 98, 0);
}

.hover\\:fill-jade-600\\/10:hover{
  fill: rgba(34, 121, 98, 0.1);
}

.hover\\:fill-jade-600\\/100:hover{
  fill: rgb(34, 121, 98);
}

.hover\\:fill-jade-600\\/15:hover{
  fill: rgba(34, 121, 98, 0.15);
}

.hover\\:fill-jade-600\\/20:hover{
  fill: rgba(34, 121, 98, 0.2);
}

.hover\\:fill-jade-600\\/25:hover{
  fill: rgba(34, 121, 98, 0.25);
}

.hover\\:fill-jade-600\\/30:hover{
  fill: rgba(34, 121, 98, 0.3);
}

.hover\\:fill-jade-600\\/35:hover{
  fill: rgba(34, 121, 98, 0.35);
}

.hover\\:fill-jade-600\\/40:hover{
  fill: rgba(34, 121, 98, 0.4);
}

.hover\\:fill-jade-600\\/45:hover{
  fill: rgba(34, 121, 98, 0.45);
}

.hover\\:fill-jade-600\\/5:hover{
  fill: rgba(34, 121, 98, 0.05);
}

.hover\\:fill-jade-600\\/50:hover{
  fill: rgba(34, 121, 98, 0.5);
}

.hover\\:fill-jade-600\\/55:hover{
  fill: rgba(34, 121, 98, 0.55);
}

.hover\\:fill-jade-600\\/60:hover{
  fill: rgba(34, 121, 98, 0.6);
}

.hover\\:fill-jade-600\\/65:hover{
  fill: rgba(34, 121, 98, 0.65);
}

.hover\\:fill-jade-600\\/70:hover{
  fill: rgba(34, 121, 98, 0.7);
}

.hover\\:fill-jade-600\\/75:hover{
  fill: rgba(34, 121, 98, 0.75);
}

.hover\\:fill-jade-600\\/80:hover{
  fill: rgba(34, 121, 98, 0.8);
}

.hover\\:fill-jade-600\\/85:hover{
  fill: rgba(34, 121, 98, 0.85);
}

.hover\\:fill-jade-600\\/90:hover{
  fill: rgba(34, 121, 98, 0.9);
}

.hover\\:fill-jade-600\\/95:hover{
  fill: rgba(34, 121, 98, 0.95);
}

.hover\\:fill-jade-700:hover{
  fill: #1b6150;
}

.hover\\:fill-jade-700\\/0:hover{
  fill: rgba(27, 97, 80, 0);
}

.hover\\:fill-jade-700\\/10:hover{
  fill: rgba(27, 97, 80, 0.1);
}

.hover\\:fill-jade-700\\/100:hover{
  fill: rgb(27, 97, 80);
}

.hover\\:fill-jade-700\\/15:hover{
  fill: rgba(27, 97, 80, 0.15);
}

.hover\\:fill-jade-700\\/20:hover{
  fill: rgba(27, 97, 80, 0.2);
}

.hover\\:fill-jade-700\\/25:hover{
  fill: rgba(27, 97, 80, 0.25);
}

.hover\\:fill-jade-700\\/30:hover{
  fill: rgba(27, 97, 80, 0.3);
}

.hover\\:fill-jade-700\\/35:hover{
  fill: rgba(27, 97, 80, 0.35);
}

.hover\\:fill-jade-700\\/40:hover{
  fill: rgba(27, 97, 80, 0.4);
}

.hover\\:fill-jade-700\\/45:hover{
  fill: rgba(27, 97, 80, 0.45);
}

.hover\\:fill-jade-700\\/5:hover{
  fill: rgba(27, 97, 80, 0.05);
}

.hover\\:fill-jade-700\\/50:hover{
  fill: rgba(27, 97, 80, 0.5);
}

.hover\\:fill-jade-700\\/55:hover{
  fill: rgba(27, 97, 80, 0.55);
}

.hover\\:fill-jade-700\\/60:hover{
  fill: rgba(27, 97, 80, 0.6);
}

.hover\\:fill-jade-700\\/65:hover{
  fill: rgba(27, 97, 80, 0.65);
}

.hover\\:fill-jade-700\\/70:hover{
  fill: rgba(27, 97, 80, 0.7);
}

.hover\\:fill-jade-700\\/75:hover{
  fill: rgba(27, 97, 80, 0.75);
}

.hover\\:fill-jade-700\\/80:hover{
  fill: rgba(27, 97, 80, 0.8);
}

.hover\\:fill-jade-700\\/85:hover{
  fill: rgba(27, 97, 80, 0.85);
}

.hover\\:fill-jade-700\\/90:hover{
  fill: rgba(27, 97, 80, 0.9);
}

.hover\\:fill-jade-700\\/95:hover{
  fill: rgba(27, 97, 80, 0.95);
}

.hover\\:fill-jade-800:hover{
  fill: #184d40;
}

.hover\\:fill-jade-800\\/0:hover{
  fill: rgba(24, 77, 64, 0);
}

.hover\\:fill-jade-800\\/10:hover{
  fill: rgba(24, 77, 64, 0.1);
}

.hover\\:fill-jade-800\\/100:hover{
  fill: rgb(24, 77, 64);
}

.hover\\:fill-jade-800\\/15:hover{
  fill: rgba(24, 77, 64, 0.15);
}

.hover\\:fill-jade-800\\/20:hover{
  fill: rgba(24, 77, 64, 0.2);
}

.hover\\:fill-jade-800\\/25:hover{
  fill: rgba(24, 77, 64, 0.25);
}

.hover\\:fill-jade-800\\/30:hover{
  fill: rgba(24, 77, 64, 0.3);
}

.hover\\:fill-jade-800\\/35:hover{
  fill: rgba(24, 77, 64, 0.35);
}

.hover\\:fill-jade-800\\/40:hover{
  fill: rgba(24, 77, 64, 0.4);
}

.hover\\:fill-jade-800\\/45:hover{
  fill: rgba(24, 77, 64, 0.45);
}

.hover\\:fill-jade-800\\/5:hover{
  fill: rgba(24, 77, 64, 0.05);
}

.hover\\:fill-jade-800\\/50:hover{
  fill: rgba(24, 77, 64, 0.5);
}

.hover\\:fill-jade-800\\/55:hover{
  fill: rgba(24, 77, 64, 0.55);
}

.hover\\:fill-jade-800\\/60:hover{
  fill: rgba(24, 77, 64, 0.6);
}

.hover\\:fill-jade-800\\/65:hover{
  fill: rgba(24, 77, 64, 0.65);
}

.hover\\:fill-jade-800\\/70:hover{
  fill: rgba(24, 77, 64, 0.7);
}

.hover\\:fill-jade-800\\/75:hover{
  fill: rgba(24, 77, 64, 0.75);
}

.hover\\:fill-jade-800\\/80:hover{
  fill: rgba(24, 77, 64, 0.8);
}

.hover\\:fill-jade-800\\/85:hover{
  fill: rgba(24, 77, 64, 0.85);
}

.hover\\:fill-jade-800\\/90:hover{
  fill: rgba(24, 77, 64, 0.9);
}

.hover\\:fill-jade-800\\/95:hover{
  fill: rgba(24, 77, 64, 0.95);
}

.hover\\:fill-jade-900:hover{
  fill: #144036;
}

.hover\\:fill-jade-900\\/0:hover{
  fill: rgba(20, 64, 54, 0);
}

.hover\\:fill-jade-900\\/10:hover{
  fill: rgba(20, 64, 54, 0.1);
}

.hover\\:fill-jade-900\\/100:hover{
  fill: rgb(20, 64, 54);
}

.hover\\:fill-jade-900\\/15:hover{
  fill: rgba(20, 64, 54, 0.15);
}

.hover\\:fill-jade-900\\/20:hover{
  fill: rgba(20, 64, 54, 0.2);
}

.hover\\:fill-jade-900\\/25:hover{
  fill: rgba(20, 64, 54, 0.25);
}

.hover\\:fill-jade-900\\/30:hover{
  fill: rgba(20, 64, 54, 0.3);
}

.hover\\:fill-jade-900\\/35:hover{
  fill: rgba(20, 64, 54, 0.35);
}

.hover\\:fill-jade-900\\/40:hover{
  fill: rgba(20, 64, 54, 0.4);
}

.hover\\:fill-jade-900\\/45:hover{
  fill: rgba(20, 64, 54, 0.45);
}

.hover\\:fill-jade-900\\/5:hover{
  fill: rgba(20, 64, 54, 0.05);
}

.hover\\:fill-jade-900\\/50:hover{
  fill: rgba(20, 64, 54, 0.5);
}

.hover\\:fill-jade-900\\/55:hover{
  fill: rgba(20, 64, 54, 0.55);
}

.hover\\:fill-jade-900\\/60:hover{
  fill: rgba(20, 64, 54, 0.6);
}

.hover\\:fill-jade-900\\/65:hover{
  fill: rgba(20, 64, 54, 0.65);
}

.hover\\:fill-jade-900\\/70:hover{
  fill: rgba(20, 64, 54, 0.7);
}

.hover\\:fill-jade-900\\/75:hover{
  fill: rgba(20, 64, 54, 0.75);
}

.hover\\:fill-jade-900\\/80:hover{
  fill: rgba(20, 64, 54, 0.8);
}

.hover\\:fill-jade-900\\/85:hover{
  fill: rgba(20, 64, 54, 0.85);
}

.hover\\:fill-jade-900\\/90:hover{
  fill: rgba(20, 64, 54, 0.9);
}

.hover\\:fill-jade-900\\/95:hover{
  fill: rgba(20, 64, 54, 0.95);
}

.hover\\:fill-jade-950:hover{
  fill: #0a241f;
}

.hover\\:fill-jade-950\\/0:hover{
  fill: rgba(10, 36, 31, 0);
}

.hover\\:fill-jade-950\\/10:hover{
  fill: rgba(10, 36, 31, 0.1);
}

.hover\\:fill-jade-950\\/100:hover{
  fill: rgb(10, 36, 31);
}

.hover\\:fill-jade-950\\/15:hover{
  fill: rgba(10, 36, 31, 0.15);
}

.hover\\:fill-jade-950\\/20:hover{
  fill: rgba(10, 36, 31, 0.2);
}

.hover\\:fill-jade-950\\/25:hover{
  fill: rgba(10, 36, 31, 0.25);
}

.hover\\:fill-jade-950\\/30:hover{
  fill: rgba(10, 36, 31, 0.3);
}

.hover\\:fill-jade-950\\/35:hover{
  fill: rgba(10, 36, 31, 0.35);
}

.hover\\:fill-jade-950\\/40:hover{
  fill: rgba(10, 36, 31, 0.4);
}

.hover\\:fill-jade-950\\/45:hover{
  fill: rgba(10, 36, 31, 0.45);
}

.hover\\:fill-jade-950\\/5:hover{
  fill: rgba(10, 36, 31, 0.05);
}

.hover\\:fill-jade-950\\/50:hover{
  fill: rgba(10, 36, 31, 0.5);
}

.hover\\:fill-jade-950\\/55:hover{
  fill: rgba(10, 36, 31, 0.55);
}

.hover\\:fill-jade-950\\/60:hover{
  fill: rgba(10, 36, 31, 0.6);
}

.hover\\:fill-jade-950\\/65:hover{
  fill: rgba(10, 36, 31, 0.65);
}

.hover\\:fill-jade-950\\/70:hover{
  fill: rgba(10, 36, 31, 0.7);
}

.hover\\:fill-jade-950\\/75:hover{
  fill: rgba(10, 36, 31, 0.75);
}

.hover\\:fill-jade-950\\/80:hover{
  fill: rgba(10, 36, 31, 0.8);
}

.hover\\:fill-jade-950\\/85:hover{
  fill: rgba(10, 36, 31, 0.85);
}

.hover\\:fill-jade-950\\/90:hover{
  fill: rgba(10, 36, 31, 0.9);
}

.hover\\:fill-jade-950\\/95:hover{
  fill: rgba(10, 36, 31, 0.95);
}

.hover\\:fill-kids-alphabet-500:hover{
  fill: #3787a3;
}

.hover\\:fill-kids-alphabet-500\\/0:hover{
  fill: rgba(55, 135, 163, 0);
}

.hover\\:fill-kids-alphabet-500\\/10:hover{
  fill: rgba(55, 135, 163, 0.1);
}

.hover\\:fill-kids-alphabet-500\\/100:hover{
  fill: rgb(55, 135, 163);
}

.hover\\:fill-kids-alphabet-500\\/15:hover{
  fill: rgba(55, 135, 163, 0.15);
}

.hover\\:fill-kids-alphabet-500\\/20:hover{
  fill: rgba(55, 135, 163, 0.2);
}

.hover\\:fill-kids-alphabet-500\\/25:hover{
  fill: rgba(55, 135, 163, 0.25);
}

.hover\\:fill-kids-alphabet-500\\/30:hover{
  fill: rgba(55, 135, 163, 0.3);
}

.hover\\:fill-kids-alphabet-500\\/35:hover{
  fill: rgba(55, 135, 163, 0.35);
}

.hover\\:fill-kids-alphabet-500\\/40:hover{
  fill: rgba(55, 135, 163, 0.4);
}

.hover\\:fill-kids-alphabet-500\\/45:hover{
  fill: rgba(55, 135, 163, 0.45);
}

.hover\\:fill-kids-alphabet-500\\/5:hover{
  fill: rgba(55, 135, 163, 0.05);
}

.hover\\:fill-kids-alphabet-500\\/50:hover{
  fill: rgba(55, 135, 163, 0.5);
}

.hover\\:fill-kids-alphabet-500\\/55:hover{
  fill: rgba(55, 135, 163, 0.55);
}

.hover\\:fill-kids-alphabet-500\\/60:hover{
  fill: rgba(55, 135, 163, 0.6);
}

.hover\\:fill-kids-alphabet-500\\/65:hover{
  fill: rgba(55, 135, 163, 0.65);
}

.hover\\:fill-kids-alphabet-500\\/70:hover{
  fill: rgba(55, 135, 163, 0.7);
}

.hover\\:fill-kids-alphabet-500\\/75:hover{
  fill: rgba(55, 135, 163, 0.75);
}

.hover\\:fill-kids-alphabet-500\\/80:hover{
  fill: rgba(55, 135, 163, 0.8);
}

.hover\\:fill-kids-alphabet-500\\/85:hover{
  fill: rgba(55, 135, 163, 0.85);
}

.hover\\:fill-kids-alphabet-500\\/90:hover{
  fill: rgba(55, 135, 163, 0.9);
}

.hover\\:fill-kids-alphabet-500\\/95:hover{
  fill: rgba(55, 135, 163, 0.95);
}

.hover\\:fill-kids-alphabet-600:hover{
  fill: #306d8a;
}

.hover\\:fill-kids-alphabet-600\\/0:hover{
  fill: rgba(48, 109, 138, 0);
}

.hover\\:fill-kids-alphabet-600\\/10:hover{
  fill: rgba(48, 109, 138, 0.1);
}

.hover\\:fill-kids-alphabet-600\\/100:hover{
  fill: rgb(48, 109, 138);
}

.hover\\:fill-kids-alphabet-600\\/15:hover{
  fill: rgba(48, 109, 138, 0.15);
}

.hover\\:fill-kids-alphabet-600\\/20:hover{
  fill: rgba(48, 109, 138, 0.2);
}

.hover\\:fill-kids-alphabet-600\\/25:hover{
  fill: rgba(48, 109, 138, 0.25);
}

.hover\\:fill-kids-alphabet-600\\/30:hover{
  fill: rgba(48, 109, 138, 0.3);
}

.hover\\:fill-kids-alphabet-600\\/35:hover{
  fill: rgba(48, 109, 138, 0.35);
}

.hover\\:fill-kids-alphabet-600\\/40:hover{
  fill: rgba(48, 109, 138, 0.4);
}

.hover\\:fill-kids-alphabet-600\\/45:hover{
  fill: rgba(48, 109, 138, 0.45);
}

.hover\\:fill-kids-alphabet-600\\/5:hover{
  fill: rgba(48, 109, 138, 0.05);
}

.hover\\:fill-kids-alphabet-600\\/50:hover{
  fill: rgba(48, 109, 138, 0.5);
}

.hover\\:fill-kids-alphabet-600\\/55:hover{
  fill: rgba(48, 109, 138, 0.55);
}

.hover\\:fill-kids-alphabet-600\\/60:hover{
  fill: rgba(48, 109, 138, 0.6);
}

.hover\\:fill-kids-alphabet-600\\/65:hover{
  fill: rgba(48, 109, 138, 0.65);
}

.hover\\:fill-kids-alphabet-600\\/70:hover{
  fill: rgba(48, 109, 138, 0.7);
}

.hover\\:fill-kids-alphabet-600\\/75:hover{
  fill: rgba(48, 109, 138, 0.75);
}

.hover\\:fill-kids-alphabet-600\\/80:hover{
  fill: rgba(48, 109, 138, 0.8);
}

.hover\\:fill-kids-alphabet-600\\/85:hover{
  fill: rgba(48, 109, 138, 0.85);
}

.hover\\:fill-kids-alphabet-600\\/90:hover{
  fill: rgba(48, 109, 138, 0.9);
}

.hover\\:fill-kids-alphabet-600\\/95:hover{
  fill: rgba(48, 109, 138, 0.95);
}

.hover\\:fill-kids-alphabet-700:hover{
  fill: #2d5b72;
}

.hover\\:fill-kids-alphabet-700\\/0:hover{
  fill: rgba(45, 91, 114, 0);
}

.hover\\:fill-kids-alphabet-700\\/10:hover{
  fill: rgba(45, 91, 114, 0.1);
}

.hover\\:fill-kids-alphabet-700\\/100:hover{
  fill: rgb(45, 91, 114);
}

.hover\\:fill-kids-alphabet-700\\/15:hover{
  fill: rgba(45, 91, 114, 0.15);
}

.hover\\:fill-kids-alphabet-700\\/20:hover{
  fill: rgba(45, 91, 114, 0.2);
}

.hover\\:fill-kids-alphabet-700\\/25:hover{
  fill: rgba(45, 91, 114, 0.25);
}

.hover\\:fill-kids-alphabet-700\\/30:hover{
  fill: rgba(45, 91, 114, 0.3);
}

.hover\\:fill-kids-alphabet-700\\/35:hover{
  fill: rgba(45, 91, 114, 0.35);
}

.hover\\:fill-kids-alphabet-700\\/40:hover{
  fill: rgba(45, 91, 114, 0.4);
}

.hover\\:fill-kids-alphabet-700\\/45:hover{
  fill: rgba(45, 91, 114, 0.45);
}

.hover\\:fill-kids-alphabet-700\\/5:hover{
  fill: rgba(45, 91, 114, 0.05);
}

.hover\\:fill-kids-alphabet-700\\/50:hover{
  fill: rgba(45, 91, 114, 0.5);
}

.hover\\:fill-kids-alphabet-700\\/55:hover{
  fill: rgba(45, 91, 114, 0.55);
}

.hover\\:fill-kids-alphabet-700\\/60:hover{
  fill: rgba(45, 91, 114, 0.6);
}

.hover\\:fill-kids-alphabet-700\\/65:hover{
  fill: rgba(45, 91, 114, 0.65);
}

.hover\\:fill-kids-alphabet-700\\/70:hover{
  fill: rgba(45, 91, 114, 0.7);
}

.hover\\:fill-kids-alphabet-700\\/75:hover{
  fill: rgba(45, 91, 114, 0.75);
}

.hover\\:fill-kids-alphabet-700\\/80:hover{
  fill: rgba(45, 91, 114, 0.8);
}

.hover\\:fill-kids-alphabet-700\\/85:hover{
  fill: rgba(45, 91, 114, 0.85);
}

.hover\\:fill-kids-alphabet-700\\/90:hover{
  fill: rgba(45, 91, 114, 0.9);
}

.hover\\:fill-kids-alphabet-700\\/95:hover{
  fill: rgba(45, 91, 114, 0.95);
}

.hover\\:fill-kids-alphabet-800:hover{
  fill: #2c4c5e;
}

.hover\\:fill-kids-alphabet-800\\/0:hover{
  fill: rgba(44, 76, 94, 0);
}

.hover\\:fill-kids-alphabet-800\\/10:hover{
  fill: rgba(44, 76, 94, 0.1);
}

.hover\\:fill-kids-alphabet-800\\/100:hover{
  fill: rgb(44, 76, 94);
}

.hover\\:fill-kids-alphabet-800\\/15:hover{
  fill: rgba(44, 76, 94, 0.15);
}

.hover\\:fill-kids-alphabet-800\\/20:hover{
  fill: rgba(44, 76, 94, 0.2);
}

.hover\\:fill-kids-alphabet-800\\/25:hover{
  fill: rgba(44, 76, 94, 0.25);
}

.hover\\:fill-kids-alphabet-800\\/30:hover{
  fill: rgba(44, 76, 94, 0.3);
}

.hover\\:fill-kids-alphabet-800\\/35:hover{
  fill: rgba(44, 76, 94, 0.35);
}

.hover\\:fill-kids-alphabet-800\\/40:hover{
  fill: rgba(44, 76, 94, 0.4);
}

.hover\\:fill-kids-alphabet-800\\/45:hover{
  fill: rgba(44, 76, 94, 0.45);
}

.hover\\:fill-kids-alphabet-800\\/5:hover{
  fill: rgba(44, 76, 94, 0.05);
}

.hover\\:fill-kids-alphabet-800\\/50:hover{
  fill: rgba(44, 76, 94, 0.5);
}

.hover\\:fill-kids-alphabet-800\\/55:hover{
  fill: rgba(44, 76, 94, 0.55);
}

.hover\\:fill-kids-alphabet-800\\/60:hover{
  fill: rgba(44, 76, 94, 0.6);
}

.hover\\:fill-kids-alphabet-800\\/65:hover{
  fill: rgba(44, 76, 94, 0.65);
}

.hover\\:fill-kids-alphabet-800\\/70:hover{
  fill: rgba(44, 76, 94, 0.7);
}

.hover\\:fill-kids-alphabet-800\\/75:hover{
  fill: rgba(44, 76, 94, 0.75);
}

.hover\\:fill-kids-alphabet-800\\/80:hover{
  fill: rgba(44, 76, 94, 0.8);
}

.hover\\:fill-kids-alphabet-800\\/85:hover{
  fill: rgba(44, 76, 94, 0.85);
}

.hover\\:fill-kids-alphabet-800\\/90:hover{
  fill: rgba(44, 76, 94, 0.9);
}

.hover\\:fill-kids-alphabet-800\\/95:hover{
  fill: rgba(44, 76, 94, 0.95);
}

.hover\\:fill-kids-alphabet-900:hover{
  fill: #284151;
}

.hover\\:fill-kids-alphabet-900\\/0:hover{
  fill: rgba(40, 65, 81, 0);
}

.hover\\:fill-kids-alphabet-900\\/10:hover{
  fill: rgba(40, 65, 81, 0.1);
}

.hover\\:fill-kids-alphabet-900\\/100:hover{
  fill: rgb(40, 65, 81);
}

.hover\\:fill-kids-alphabet-900\\/15:hover{
  fill: rgba(40, 65, 81, 0.15);
}

.hover\\:fill-kids-alphabet-900\\/20:hover{
  fill: rgba(40, 65, 81, 0.2);
}

.hover\\:fill-kids-alphabet-900\\/25:hover{
  fill: rgba(40, 65, 81, 0.25);
}

.hover\\:fill-kids-alphabet-900\\/30:hover{
  fill: rgba(40, 65, 81, 0.3);
}

.hover\\:fill-kids-alphabet-900\\/35:hover{
  fill: rgba(40, 65, 81, 0.35);
}

.hover\\:fill-kids-alphabet-900\\/40:hover{
  fill: rgba(40, 65, 81, 0.4);
}

.hover\\:fill-kids-alphabet-900\\/45:hover{
  fill: rgba(40, 65, 81, 0.45);
}

.hover\\:fill-kids-alphabet-900\\/5:hover{
  fill: rgba(40, 65, 81, 0.05);
}

.hover\\:fill-kids-alphabet-900\\/50:hover{
  fill: rgba(40, 65, 81, 0.5);
}

.hover\\:fill-kids-alphabet-900\\/55:hover{
  fill: rgba(40, 65, 81, 0.55);
}

.hover\\:fill-kids-alphabet-900\\/60:hover{
  fill: rgba(40, 65, 81, 0.6);
}

.hover\\:fill-kids-alphabet-900\\/65:hover{
  fill: rgba(40, 65, 81, 0.65);
}

.hover\\:fill-kids-alphabet-900\\/70:hover{
  fill: rgba(40, 65, 81, 0.7);
}

.hover\\:fill-kids-alphabet-900\\/75:hover{
  fill: rgba(40, 65, 81, 0.75);
}

.hover\\:fill-kids-alphabet-900\\/80:hover{
  fill: rgba(40, 65, 81, 0.8);
}

.hover\\:fill-kids-alphabet-900\\/85:hover{
  fill: rgba(40, 65, 81, 0.85);
}

.hover\\:fill-kids-alphabet-900\\/90:hover{
  fill: rgba(40, 65, 81, 0.9);
}

.hover\\:fill-kids-alphabet-900\\/95:hover{
  fill: rgba(40, 65, 81, 0.95);
}

.hover\\:fill-kids-categories-500:hover{
  fill: #d1912f;
}

.hover\\:fill-kids-categories-500\\/0:hover{
  fill: rgba(209, 145, 47, 0);
}

.hover\\:fill-kids-categories-500\\/10:hover{
  fill: rgba(209, 145, 47, 0.1);
}

.hover\\:fill-kids-categories-500\\/100:hover{
  fill: rgb(209, 145, 47);
}

.hover\\:fill-kids-categories-500\\/15:hover{
  fill: rgba(209, 145, 47, 0.15);
}

.hover\\:fill-kids-categories-500\\/20:hover{
  fill: rgba(209, 145, 47, 0.2);
}

.hover\\:fill-kids-categories-500\\/25:hover{
  fill: rgba(209, 145, 47, 0.25);
}

.hover\\:fill-kids-categories-500\\/30:hover{
  fill: rgba(209, 145, 47, 0.3);
}

.hover\\:fill-kids-categories-500\\/35:hover{
  fill: rgba(209, 145, 47, 0.35);
}

.hover\\:fill-kids-categories-500\\/40:hover{
  fill: rgba(209, 145, 47, 0.4);
}

.hover\\:fill-kids-categories-500\\/45:hover{
  fill: rgba(209, 145, 47, 0.45);
}

.hover\\:fill-kids-categories-500\\/5:hover{
  fill: rgba(209, 145, 47, 0.05);
}

.hover\\:fill-kids-categories-500\\/50:hover{
  fill: rgba(209, 145, 47, 0.5);
}

.hover\\:fill-kids-categories-500\\/55:hover{
  fill: rgba(209, 145, 47, 0.55);
}

.hover\\:fill-kids-categories-500\\/60:hover{
  fill: rgba(209, 145, 47, 0.6);
}

.hover\\:fill-kids-categories-500\\/65:hover{
  fill: rgba(209, 145, 47, 0.65);
}

.hover\\:fill-kids-categories-500\\/70:hover{
  fill: rgba(209, 145, 47, 0.7);
}

.hover\\:fill-kids-categories-500\\/75:hover{
  fill: rgba(209, 145, 47, 0.75);
}

.hover\\:fill-kids-categories-500\\/80:hover{
  fill: rgba(209, 145, 47, 0.8);
}

.hover\\:fill-kids-categories-500\\/85:hover{
  fill: rgba(209, 145, 47, 0.85);
}

.hover\\:fill-kids-categories-500\\/90:hover{
  fill: rgba(209, 145, 47, 0.9);
}

.hover\\:fill-kids-categories-500\\/95:hover{
  fill: rgba(209, 145, 47, 0.95);
}

.hover\\:fill-kids-categories-600:hover{
  fill: #c37829;
}

.hover\\:fill-kids-categories-600\\/0:hover{
  fill: rgba(195, 120, 41, 0);
}

.hover\\:fill-kids-categories-600\\/10:hover{
  fill: rgba(195, 120, 41, 0.1);
}

.hover\\:fill-kids-categories-600\\/100:hover{
  fill: rgb(195, 120, 41);
}

.hover\\:fill-kids-categories-600\\/15:hover{
  fill: rgba(195, 120, 41, 0.15);
}

.hover\\:fill-kids-categories-600\\/20:hover{
  fill: rgba(195, 120, 41, 0.2);
}

.hover\\:fill-kids-categories-600\\/25:hover{
  fill: rgba(195, 120, 41, 0.25);
}

.hover\\:fill-kids-categories-600\\/30:hover{
  fill: rgba(195, 120, 41, 0.3);
}

.hover\\:fill-kids-categories-600\\/35:hover{
  fill: rgba(195, 120, 41, 0.35);
}

.hover\\:fill-kids-categories-600\\/40:hover{
  fill: rgba(195, 120, 41, 0.4);
}

.hover\\:fill-kids-categories-600\\/45:hover{
  fill: rgba(195, 120, 41, 0.45);
}

.hover\\:fill-kids-categories-600\\/5:hover{
  fill: rgba(195, 120, 41, 0.05);
}

.hover\\:fill-kids-categories-600\\/50:hover{
  fill: rgba(195, 120, 41, 0.5);
}

.hover\\:fill-kids-categories-600\\/55:hover{
  fill: rgba(195, 120, 41, 0.55);
}

.hover\\:fill-kids-categories-600\\/60:hover{
  fill: rgba(195, 120, 41, 0.6);
}

.hover\\:fill-kids-categories-600\\/65:hover{
  fill: rgba(195, 120, 41, 0.65);
}

.hover\\:fill-kids-categories-600\\/70:hover{
  fill: rgba(195, 120, 41, 0.7);
}

.hover\\:fill-kids-categories-600\\/75:hover{
  fill: rgba(195, 120, 41, 0.75);
}

.hover\\:fill-kids-categories-600\\/80:hover{
  fill: rgba(195, 120, 41, 0.8);
}

.hover\\:fill-kids-categories-600\\/85:hover{
  fill: rgba(195, 120, 41, 0.85);
}

.hover\\:fill-kids-categories-600\\/90:hover{
  fill: rgba(195, 120, 41, 0.9);
}

.hover\\:fill-kids-categories-600\\/95:hover{
  fill: rgba(195, 120, 41, 0.95);
}

.hover\\:fill-kids-categories-700:hover{
  fill: #995424;
}

.hover\\:fill-kids-categories-700\\/0:hover{
  fill: rgba(153, 84, 36, 0);
}

.hover\\:fill-kids-categories-700\\/10:hover{
  fill: rgba(153, 84, 36, 0.1);
}

.hover\\:fill-kids-categories-700\\/100:hover{
  fill: rgb(153, 84, 36);
}

.hover\\:fill-kids-categories-700\\/15:hover{
  fill: rgba(153, 84, 36, 0.15);
}

.hover\\:fill-kids-categories-700\\/20:hover{
  fill: rgba(153, 84, 36, 0.2);
}

.hover\\:fill-kids-categories-700\\/25:hover{
  fill: rgba(153, 84, 36, 0.25);
}

.hover\\:fill-kids-categories-700\\/30:hover{
  fill: rgba(153, 84, 36, 0.3);
}

.hover\\:fill-kids-categories-700\\/35:hover{
  fill: rgba(153, 84, 36, 0.35);
}

.hover\\:fill-kids-categories-700\\/40:hover{
  fill: rgba(153, 84, 36, 0.4);
}

.hover\\:fill-kids-categories-700\\/45:hover{
  fill: rgba(153, 84, 36, 0.45);
}

.hover\\:fill-kids-categories-700\\/5:hover{
  fill: rgba(153, 84, 36, 0.05);
}

.hover\\:fill-kids-categories-700\\/50:hover{
  fill: rgba(153, 84, 36, 0.5);
}

.hover\\:fill-kids-categories-700\\/55:hover{
  fill: rgba(153, 84, 36, 0.55);
}

.hover\\:fill-kids-categories-700\\/60:hover{
  fill: rgba(153, 84, 36, 0.6);
}

.hover\\:fill-kids-categories-700\\/65:hover{
  fill: rgba(153, 84, 36, 0.65);
}

.hover\\:fill-kids-categories-700\\/70:hover{
  fill: rgba(153, 84, 36, 0.7);
}

.hover\\:fill-kids-categories-700\\/75:hover{
  fill: rgba(153, 84, 36, 0.75);
}

.hover\\:fill-kids-categories-700\\/80:hover{
  fill: rgba(153, 84, 36, 0.8);
}

.hover\\:fill-kids-categories-700\\/85:hover{
  fill: rgba(153, 84, 36, 0.85);
}

.hover\\:fill-kids-categories-700\\/90:hover{
  fill: rgba(153, 84, 36, 0.9);
}

.hover\\:fill-kids-categories-700\\/95:hover{
  fill: rgba(153, 84, 36, 0.95);
}

.hover\\:fill-kids-categories-800:hover{
  fill: #7e4322;
}

.hover\\:fill-kids-categories-800\\/0:hover{
  fill: rgba(126, 67, 34, 0);
}

.hover\\:fill-kids-categories-800\\/10:hover{
  fill: rgba(126, 67, 34, 0.1);
}

.hover\\:fill-kids-categories-800\\/100:hover{
  fill: rgb(126, 67, 34);
}

.hover\\:fill-kids-categories-800\\/15:hover{
  fill: rgba(126, 67, 34, 0.15);
}

.hover\\:fill-kids-categories-800\\/20:hover{
  fill: rgba(126, 67, 34, 0.2);
}

.hover\\:fill-kids-categories-800\\/25:hover{
  fill: rgba(126, 67, 34, 0.25);
}

.hover\\:fill-kids-categories-800\\/30:hover{
  fill: rgba(126, 67, 34, 0.3);
}

.hover\\:fill-kids-categories-800\\/35:hover{
  fill: rgba(126, 67, 34, 0.35);
}

.hover\\:fill-kids-categories-800\\/40:hover{
  fill: rgba(126, 67, 34, 0.4);
}

.hover\\:fill-kids-categories-800\\/45:hover{
  fill: rgba(126, 67, 34, 0.45);
}

.hover\\:fill-kids-categories-800\\/5:hover{
  fill: rgba(126, 67, 34, 0.05);
}

.hover\\:fill-kids-categories-800\\/50:hover{
  fill: rgba(126, 67, 34, 0.5);
}

.hover\\:fill-kids-categories-800\\/55:hover{
  fill: rgba(126, 67, 34, 0.55);
}

.hover\\:fill-kids-categories-800\\/60:hover{
  fill: rgba(126, 67, 34, 0.6);
}

.hover\\:fill-kids-categories-800\\/65:hover{
  fill: rgba(126, 67, 34, 0.65);
}

.hover\\:fill-kids-categories-800\\/70:hover{
  fill: rgba(126, 67, 34, 0.7);
}

.hover\\:fill-kids-categories-800\\/75:hover{
  fill: rgba(126, 67, 34, 0.75);
}

.hover\\:fill-kids-categories-800\\/80:hover{
  fill: rgba(126, 67, 34, 0.8);
}

.hover\\:fill-kids-categories-800\\/85:hover{
  fill: rgba(126, 67, 34, 0.85);
}

.hover\\:fill-kids-categories-800\\/90:hover{
  fill: rgba(126, 67, 34, 0.9);
}

.hover\\:fill-kids-categories-800\\/95:hover{
  fill: rgba(126, 67, 34, 0.95);
}

.hover\\:fill-kids-categories-900:hover{
  fill: #68381f;
}

.hover\\:fill-kids-categories-900\\/0:hover{
  fill: rgba(104, 56, 31, 0);
}

.hover\\:fill-kids-categories-900\\/10:hover{
  fill: rgba(104, 56, 31, 0.1);
}

.hover\\:fill-kids-categories-900\\/100:hover{
  fill: rgb(104, 56, 31);
}

.hover\\:fill-kids-categories-900\\/15:hover{
  fill: rgba(104, 56, 31, 0.15);
}

.hover\\:fill-kids-categories-900\\/20:hover{
  fill: rgba(104, 56, 31, 0.2);
}

.hover\\:fill-kids-categories-900\\/25:hover{
  fill: rgba(104, 56, 31, 0.25);
}

.hover\\:fill-kids-categories-900\\/30:hover{
  fill: rgba(104, 56, 31, 0.3);
}

.hover\\:fill-kids-categories-900\\/35:hover{
  fill: rgba(104, 56, 31, 0.35);
}

.hover\\:fill-kids-categories-900\\/40:hover{
  fill: rgba(104, 56, 31, 0.4);
}

.hover\\:fill-kids-categories-900\\/45:hover{
  fill: rgba(104, 56, 31, 0.45);
}

.hover\\:fill-kids-categories-900\\/5:hover{
  fill: rgba(104, 56, 31, 0.05);
}

.hover\\:fill-kids-categories-900\\/50:hover{
  fill: rgba(104, 56, 31, 0.5);
}

.hover\\:fill-kids-categories-900\\/55:hover{
  fill: rgba(104, 56, 31, 0.55);
}

.hover\\:fill-kids-categories-900\\/60:hover{
  fill: rgba(104, 56, 31, 0.6);
}

.hover\\:fill-kids-categories-900\\/65:hover{
  fill: rgba(104, 56, 31, 0.65);
}

.hover\\:fill-kids-categories-900\\/70:hover{
  fill: rgba(104, 56, 31, 0.7);
}

.hover\\:fill-kids-categories-900\\/75:hover{
  fill: rgba(104, 56, 31, 0.75);
}

.hover\\:fill-kids-categories-900\\/80:hover{
  fill: rgba(104, 56, 31, 0.8);
}

.hover\\:fill-kids-categories-900\\/85:hover{
  fill: rgba(104, 56, 31, 0.85);
}

.hover\\:fill-kids-categories-900\\/90:hover{
  fill: rgba(104, 56, 31, 0.9);
}

.hover\\:fill-kids-categories-900\\/95:hover{
  fill: rgba(104, 56, 31, 0.95);
}

.hover\\:fill-kids-dictionary-500:hover{
  fill: #2c876d;
}

.hover\\:fill-kids-dictionary-500\\/0:hover{
  fill: rgba(44, 135, 109, 0);
}

.hover\\:fill-kids-dictionary-500\\/10:hover{
  fill: rgba(44, 135, 109, 0.1);
}

.hover\\:fill-kids-dictionary-500\\/100:hover{
  fill: rgb(44, 135, 109);
}

.hover\\:fill-kids-dictionary-500\\/15:hover{
  fill: rgba(44, 135, 109, 0.15);
}

.hover\\:fill-kids-dictionary-500\\/20:hover{
  fill: rgba(44, 135, 109, 0.2);
}

.hover\\:fill-kids-dictionary-500\\/25:hover{
  fill: rgba(44, 135, 109, 0.25);
}

.hover\\:fill-kids-dictionary-500\\/30:hover{
  fill: rgba(44, 135, 109, 0.3);
}

.hover\\:fill-kids-dictionary-500\\/35:hover{
  fill: rgba(44, 135, 109, 0.35);
}

.hover\\:fill-kids-dictionary-500\\/40:hover{
  fill: rgba(44, 135, 109, 0.4);
}

.hover\\:fill-kids-dictionary-500\\/45:hover{
  fill: rgba(44, 135, 109, 0.45);
}

.hover\\:fill-kids-dictionary-500\\/5:hover{
  fill: rgba(44, 135, 109, 0.05);
}

.hover\\:fill-kids-dictionary-500\\/50:hover{
  fill: rgba(44, 135, 109, 0.5);
}

.hover\\:fill-kids-dictionary-500\\/55:hover{
  fill: rgba(44, 135, 109, 0.55);
}

.hover\\:fill-kids-dictionary-500\\/60:hover{
  fill: rgba(44, 135, 109, 0.6);
}

.hover\\:fill-kids-dictionary-500\\/65:hover{
  fill: rgba(44, 135, 109, 0.65);
}

.hover\\:fill-kids-dictionary-500\\/70:hover{
  fill: rgba(44, 135, 109, 0.7);
}

.hover\\:fill-kids-dictionary-500\\/75:hover{
  fill: rgba(44, 135, 109, 0.75);
}

.hover\\:fill-kids-dictionary-500\\/80:hover{
  fill: rgba(44, 135, 109, 0.8);
}

.hover\\:fill-kids-dictionary-500\\/85:hover{
  fill: rgba(44, 135, 109, 0.85);
}

.hover\\:fill-kids-dictionary-500\\/90:hover{
  fill: rgba(44, 135, 109, 0.9);
}

.hover\\:fill-kids-dictionary-500\\/95:hover{
  fill: rgba(44, 135, 109, 0.95);
}

.hover\\:fill-kids-dictionary-600:hover{
  fill: #227962;
}

.hover\\:fill-kids-dictionary-600\\/0:hover{
  fill: rgba(34, 121, 98, 0);
}

.hover\\:fill-kids-dictionary-600\\/10:hover{
  fill: rgba(34, 121, 98, 0.1);
}

.hover\\:fill-kids-dictionary-600\\/100:hover{
  fill: rgb(34, 121, 98);
}

.hover\\:fill-kids-dictionary-600\\/15:hover{
  fill: rgba(34, 121, 98, 0.15);
}

.hover\\:fill-kids-dictionary-600\\/20:hover{
  fill: rgba(34, 121, 98, 0.2);
}

.hover\\:fill-kids-dictionary-600\\/25:hover{
  fill: rgba(34, 121, 98, 0.25);
}

.hover\\:fill-kids-dictionary-600\\/30:hover{
  fill: rgba(34, 121, 98, 0.3);
}

.hover\\:fill-kids-dictionary-600\\/35:hover{
  fill: rgba(34, 121, 98, 0.35);
}

.hover\\:fill-kids-dictionary-600\\/40:hover{
  fill: rgba(34, 121, 98, 0.4);
}

.hover\\:fill-kids-dictionary-600\\/45:hover{
  fill: rgba(34, 121, 98, 0.45);
}

.hover\\:fill-kids-dictionary-600\\/5:hover{
  fill: rgba(34, 121, 98, 0.05);
}

.hover\\:fill-kids-dictionary-600\\/50:hover{
  fill: rgba(34, 121, 98, 0.5);
}

.hover\\:fill-kids-dictionary-600\\/55:hover{
  fill: rgba(34, 121, 98, 0.55);
}

.hover\\:fill-kids-dictionary-600\\/60:hover{
  fill: rgba(34, 121, 98, 0.6);
}

.hover\\:fill-kids-dictionary-600\\/65:hover{
  fill: rgba(34, 121, 98, 0.65);
}

.hover\\:fill-kids-dictionary-600\\/70:hover{
  fill: rgba(34, 121, 98, 0.7);
}

.hover\\:fill-kids-dictionary-600\\/75:hover{
  fill: rgba(34, 121, 98, 0.75);
}

.hover\\:fill-kids-dictionary-600\\/80:hover{
  fill: rgba(34, 121, 98, 0.8);
}

.hover\\:fill-kids-dictionary-600\\/85:hover{
  fill: rgba(34, 121, 98, 0.85);
}

.hover\\:fill-kids-dictionary-600\\/90:hover{
  fill: rgba(34, 121, 98, 0.9);
}

.hover\\:fill-kids-dictionary-600\\/95:hover{
  fill: rgba(34, 121, 98, 0.95);
}

.hover\\:fill-kids-dictionary-700:hover{
  fill: #1b6150;
}

.hover\\:fill-kids-dictionary-700\\/0:hover{
  fill: rgba(27, 97, 80, 0);
}

.hover\\:fill-kids-dictionary-700\\/10:hover{
  fill: rgba(27, 97, 80, 0.1);
}

.hover\\:fill-kids-dictionary-700\\/100:hover{
  fill: rgb(27, 97, 80);
}

.hover\\:fill-kids-dictionary-700\\/15:hover{
  fill: rgba(27, 97, 80, 0.15);
}

.hover\\:fill-kids-dictionary-700\\/20:hover{
  fill: rgba(27, 97, 80, 0.2);
}

.hover\\:fill-kids-dictionary-700\\/25:hover{
  fill: rgba(27, 97, 80, 0.25);
}

.hover\\:fill-kids-dictionary-700\\/30:hover{
  fill: rgba(27, 97, 80, 0.3);
}

.hover\\:fill-kids-dictionary-700\\/35:hover{
  fill: rgba(27, 97, 80, 0.35);
}

.hover\\:fill-kids-dictionary-700\\/40:hover{
  fill: rgba(27, 97, 80, 0.4);
}

.hover\\:fill-kids-dictionary-700\\/45:hover{
  fill: rgba(27, 97, 80, 0.45);
}

.hover\\:fill-kids-dictionary-700\\/5:hover{
  fill: rgba(27, 97, 80, 0.05);
}

.hover\\:fill-kids-dictionary-700\\/50:hover{
  fill: rgba(27, 97, 80, 0.5);
}

.hover\\:fill-kids-dictionary-700\\/55:hover{
  fill: rgba(27, 97, 80, 0.55);
}

.hover\\:fill-kids-dictionary-700\\/60:hover{
  fill: rgba(27, 97, 80, 0.6);
}

.hover\\:fill-kids-dictionary-700\\/65:hover{
  fill: rgba(27, 97, 80, 0.65);
}

.hover\\:fill-kids-dictionary-700\\/70:hover{
  fill: rgba(27, 97, 80, 0.7);
}

.hover\\:fill-kids-dictionary-700\\/75:hover{
  fill: rgba(27, 97, 80, 0.75);
}

.hover\\:fill-kids-dictionary-700\\/80:hover{
  fill: rgba(27, 97, 80, 0.8);
}

.hover\\:fill-kids-dictionary-700\\/85:hover{
  fill: rgba(27, 97, 80, 0.85);
}

.hover\\:fill-kids-dictionary-700\\/90:hover{
  fill: rgba(27, 97, 80, 0.9);
}

.hover\\:fill-kids-dictionary-700\\/95:hover{
  fill: rgba(27, 97, 80, 0.95);
}

.hover\\:fill-kids-dictionary-800:hover{
  fill: #184d40;
}

.hover\\:fill-kids-dictionary-800\\/0:hover{
  fill: rgba(24, 77, 64, 0);
}

.hover\\:fill-kids-dictionary-800\\/10:hover{
  fill: rgba(24, 77, 64, 0.1);
}

.hover\\:fill-kids-dictionary-800\\/100:hover{
  fill: rgb(24, 77, 64);
}

.hover\\:fill-kids-dictionary-800\\/15:hover{
  fill: rgba(24, 77, 64, 0.15);
}

.hover\\:fill-kids-dictionary-800\\/20:hover{
  fill: rgba(24, 77, 64, 0.2);
}

.hover\\:fill-kids-dictionary-800\\/25:hover{
  fill: rgba(24, 77, 64, 0.25);
}

.hover\\:fill-kids-dictionary-800\\/30:hover{
  fill: rgba(24, 77, 64, 0.3);
}

.hover\\:fill-kids-dictionary-800\\/35:hover{
  fill: rgba(24, 77, 64, 0.35);
}

.hover\\:fill-kids-dictionary-800\\/40:hover{
  fill: rgba(24, 77, 64, 0.4);
}

.hover\\:fill-kids-dictionary-800\\/45:hover{
  fill: rgba(24, 77, 64, 0.45);
}

.hover\\:fill-kids-dictionary-800\\/5:hover{
  fill: rgba(24, 77, 64, 0.05);
}

.hover\\:fill-kids-dictionary-800\\/50:hover{
  fill: rgba(24, 77, 64, 0.5);
}

.hover\\:fill-kids-dictionary-800\\/55:hover{
  fill: rgba(24, 77, 64, 0.55);
}

.hover\\:fill-kids-dictionary-800\\/60:hover{
  fill: rgba(24, 77, 64, 0.6);
}

.hover\\:fill-kids-dictionary-800\\/65:hover{
  fill: rgba(24, 77, 64, 0.65);
}

.hover\\:fill-kids-dictionary-800\\/70:hover{
  fill: rgba(24, 77, 64, 0.7);
}

.hover\\:fill-kids-dictionary-800\\/75:hover{
  fill: rgba(24, 77, 64, 0.75);
}

.hover\\:fill-kids-dictionary-800\\/80:hover{
  fill: rgba(24, 77, 64, 0.8);
}

.hover\\:fill-kids-dictionary-800\\/85:hover{
  fill: rgba(24, 77, 64, 0.85);
}

.hover\\:fill-kids-dictionary-800\\/90:hover{
  fill: rgba(24, 77, 64, 0.9);
}

.hover\\:fill-kids-dictionary-800\\/95:hover{
  fill: rgba(24, 77, 64, 0.95);
}

.hover\\:fill-kids-dictionary-900:hover{
  fill: #144036;
}

.hover\\:fill-kids-dictionary-900\\/0:hover{
  fill: rgba(20, 64, 54, 0);
}

.hover\\:fill-kids-dictionary-900\\/10:hover{
  fill: rgba(20, 64, 54, 0.1);
}

.hover\\:fill-kids-dictionary-900\\/100:hover{
  fill: rgb(20, 64, 54);
}

.hover\\:fill-kids-dictionary-900\\/15:hover{
  fill: rgba(20, 64, 54, 0.15);
}

.hover\\:fill-kids-dictionary-900\\/20:hover{
  fill: rgba(20, 64, 54, 0.2);
}

.hover\\:fill-kids-dictionary-900\\/25:hover{
  fill: rgba(20, 64, 54, 0.25);
}

.hover\\:fill-kids-dictionary-900\\/30:hover{
  fill: rgba(20, 64, 54, 0.3);
}

.hover\\:fill-kids-dictionary-900\\/35:hover{
  fill: rgba(20, 64, 54, 0.35);
}

.hover\\:fill-kids-dictionary-900\\/40:hover{
  fill: rgba(20, 64, 54, 0.4);
}

.hover\\:fill-kids-dictionary-900\\/45:hover{
  fill: rgba(20, 64, 54, 0.45);
}

.hover\\:fill-kids-dictionary-900\\/5:hover{
  fill: rgba(20, 64, 54, 0.05);
}

.hover\\:fill-kids-dictionary-900\\/50:hover{
  fill: rgba(20, 64, 54, 0.5);
}

.hover\\:fill-kids-dictionary-900\\/55:hover{
  fill: rgba(20, 64, 54, 0.55);
}

.hover\\:fill-kids-dictionary-900\\/60:hover{
  fill: rgba(20, 64, 54, 0.6);
}

.hover\\:fill-kids-dictionary-900\\/65:hover{
  fill: rgba(20, 64, 54, 0.65);
}

.hover\\:fill-kids-dictionary-900\\/70:hover{
  fill: rgba(20, 64, 54, 0.7);
}

.hover\\:fill-kids-dictionary-900\\/75:hover{
  fill: rgba(20, 64, 54, 0.75);
}

.hover\\:fill-kids-dictionary-900\\/80:hover{
  fill: rgba(20, 64, 54, 0.8);
}

.hover\\:fill-kids-dictionary-900\\/85:hover{
  fill: rgba(20, 64, 54, 0.85);
}

.hover\\:fill-kids-dictionary-900\\/90:hover{
  fill: rgba(20, 64, 54, 0.9);
}

.hover\\:fill-kids-dictionary-900\\/95:hover{
  fill: rgba(20, 64, 54, 0.95);
}

.hover\\:fill-kids-games-500:hover{
  fill: #513B56;
}

.hover\\:fill-kids-games-500\\/0:hover{
  fill: rgba(81, 59, 86, 0);
}

.hover\\:fill-kids-games-500\\/10:hover{
  fill: rgba(81, 59, 86, 0.1);
}

.hover\\:fill-kids-games-500\\/100:hover{
  fill: rgb(81, 59, 86);
}

.hover\\:fill-kids-games-500\\/15:hover{
  fill: rgba(81, 59, 86, 0.15);
}

.hover\\:fill-kids-games-500\\/20:hover{
  fill: rgba(81, 59, 86, 0.2);
}

.hover\\:fill-kids-games-500\\/25:hover{
  fill: rgba(81, 59, 86, 0.25);
}

.hover\\:fill-kids-games-500\\/30:hover{
  fill: rgba(81, 59, 86, 0.3);
}

.hover\\:fill-kids-games-500\\/35:hover{
  fill: rgba(81, 59, 86, 0.35);
}

.hover\\:fill-kids-games-500\\/40:hover{
  fill: rgba(81, 59, 86, 0.4);
}

.hover\\:fill-kids-games-500\\/45:hover{
  fill: rgba(81, 59, 86, 0.45);
}

.hover\\:fill-kids-games-500\\/5:hover{
  fill: rgba(81, 59, 86, 0.05);
}

.hover\\:fill-kids-games-500\\/50:hover{
  fill: rgba(81, 59, 86, 0.5);
}

.hover\\:fill-kids-games-500\\/55:hover{
  fill: rgba(81, 59, 86, 0.55);
}

.hover\\:fill-kids-games-500\\/60:hover{
  fill: rgba(81, 59, 86, 0.6);
}

.hover\\:fill-kids-games-500\\/65:hover{
  fill: rgba(81, 59, 86, 0.65);
}

.hover\\:fill-kids-games-500\\/70:hover{
  fill: rgba(81, 59, 86, 0.7);
}

.hover\\:fill-kids-games-500\\/75:hover{
  fill: rgba(81, 59, 86, 0.75);
}

.hover\\:fill-kids-games-500\\/80:hover{
  fill: rgba(81, 59, 86, 0.8);
}

.hover\\:fill-kids-games-500\\/85:hover{
  fill: rgba(81, 59, 86, 0.85);
}

.hover\\:fill-kids-games-500\\/90:hover{
  fill: rgba(81, 59, 86, 0.9);
}

.hover\\:fill-kids-games-500\\/95:hover{
  fill: rgba(81, 59, 86, 0.95);
}

.hover\\:fill-kids-games-900:hover{
  fill: #39293c;
}

.hover\\:fill-kids-games-900\\/0:hover{
  fill: rgba(57, 41, 60, 0);
}

.hover\\:fill-kids-games-900\\/10:hover{
  fill: rgba(57, 41, 60, 0.1);
}

.hover\\:fill-kids-games-900\\/100:hover{
  fill: rgb(57, 41, 60);
}

.hover\\:fill-kids-games-900\\/15:hover{
  fill: rgba(57, 41, 60, 0.15);
}

.hover\\:fill-kids-games-900\\/20:hover{
  fill: rgba(57, 41, 60, 0.2);
}

.hover\\:fill-kids-games-900\\/25:hover{
  fill: rgba(57, 41, 60, 0.25);
}

.hover\\:fill-kids-games-900\\/30:hover{
  fill: rgba(57, 41, 60, 0.3);
}

.hover\\:fill-kids-games-900\\/35:hover{
  fill: rgba(57, 41, 60, 0.35);
}

.hover\\:fill-kids-games-900\\/40:hover{
  fill: rgba(57, 41, 60, 0.4);
}

.hover\\:fill-kids-games-900\\/45:hover{
  fill: rgba(57, 41, 60, 0.45);
}

.hover\\:fill-kids-games-900\\/5:hover{
  fill: rgba(57, 41, 60, 0.05);
}

.hover\\:fill-kids-games-900\\/50:hover{
  fill: rgba(57, 41, 60, 0.5);
}

.hover\\:fill-kids-games-900\\/55:hover{
  fill: rgba(57, 41, 60, 0.55);
}

.hover\\:fill-kids-games-900\\/60:hover{
  fill: rgba(57, 41, 60, 0.6);
}

.hover\\:fill-kids-games-900\\/65:hover{
  fill: rgba(57, 41, 60, 0.65);
}

.hover\\:fill-kids-games-900\\/70:hover{
  fill: rgba(57, 41, 60, 0.7);
}

.hover\\:fill-kids-games-900\\/75:hover{
  fill: rgba(57, 41, 60, 0.75);
}

.hover\\:fill-kids-games-900\\/80:hover{
  fill: rgba(57, 41, 60, 0.8);
}

.hover\\:fill-kids-games-900\\/85:hover{
  fill: rgba(57, 41, 60, 0.85);
}

.hover\\:fill-kids-games-900\\/90:hover{
  fill: rgba(57, 41, 60, 0.9);
}

.hover\\:fill-kids-games-900\\/95:hover{
  fill: rgba(57, 41, 60, 0.95);
}

.hover\\:fill-kids-songs-500:hover{
  fill: #830042;
}

.hover\\:fill-kids-songs-500\\/0:hover{
  fill: rgba(131, 0, 66, 0);
}

.hover\\:fill-kids-songs-500\\/10:hover{
  fill: rgba(131, 0, 66, 0.1);
}

.hover\\:fill-kids-songs-500\\/100:hover{
  fill: rgb(131, 0, 66);
}

.hover\\:fill-kids-songs-500\\/15:hover{
  fill: rgba(131, 0, 66, 0.15);
}

.hover\\:fill-kids-songs-500\\/20:hover{
  fill: rgba(131, 0, 66, 0.2);
}

.hover\\:fill-kids-songs-500\\/25:hover{
  fill: rgba(131, 0, 66, 0.25);
}

.hover\\:fill-kids-songs-500\\/30:hover{
  fill: rgba(131, 0, 66, 0.3);
}

.hover\\:fill-kids-songs-500\\/35:hover{
  fill: rgba(131, 0, 66, 0.35);
}

.hover\\:fill-kids-songs-500\\/40:hover{
  fill: rgba(131, 0, 66, 0.4);
}

.hover\\:fill-kids-songs-500\\/45:hover{
  fill: rgba(131, 0, 66, 0.45);
}

.hover\\:fill-kids-songs-500\\/5:hover{
  fill: rgba(131, 0, 66, 0.05);
}

.hover\\:fill-kids-songs-500\\/50:hover{
  fill: rgba(131, 0, 66, 0.5);
}

.hover\\:fill-kids-songs-500\\/55:hover{
  fill: rgba(131, 0, 66, 0.55);
}

.hover\\:fill-kids-songs-500\\/60:hover{
  fill: rgba(131, 0, 66, 0.6);
}

.hover\\:fill-kids-songs-500\\/65:hover{
  fill: rgba(131, 0, 66, 0.65);
}

.hover\\:fill-kids-songs-500\\/70:hover{
  fill: rgba(131, 0, 66, 0.7);
}

.hover\\:fill-kids-songs-500\\/75:hover{
  fill: rgba(131, 0, 66, 0.75);
}

.hover\\:fill-kids-songs-500\\/80:hover{
  fill: rgba(131, 0, 66, 0.8);
}

.hover\\:fill-kids-songs-500\\/85:hover{
  fill: rgba(131, 0, 66, 0.85);
}

.hover\\:fill-kids-songs-500\\/90:hover{
  fill: rgba(131, 0, 66, 0.9);
}

.hover\\:fill-kids-songs-500\\/95:hover{
  fill: rgba(131, 0, 66, 0.95);
}

.hover\\:fill-kids-songs-900:hover{
  fill: #5c002e;
}

.hover\\:fill-kids-songs-900\\/0:hover{
  fill: rgba(92, 0, 46, 0);
}

.hover\\:fill-kids-songs-900\\/10:hover{
  fill: rgba(92, 0, 46, 0.1);
}

.hover\\:fill-kids-songs-900\\/100:hover{
  fill: rgb(92, 0, 46);
}

.hover\\:fill-kids-songs-900\\/15:hover{
  fill: rgba(92, 0, 46, 0.15);
}

.hover\\:fill-kids-songs-900\\/20:hover{
  fill: rgba(92, 0, 46, 0.2);
}

.hover\\:fill-kids-songs-900\\/25:hover{
  fill: rgba(92, 0, 46, 0.25);
}

.hover\\:fill-kids-songs-900\\/30:hover{
  fill: rgba(92, 0, 46, 0.3);
}

.hover\\:fill-kids-songs-900\\/35:hover{
  fill: rgba(92, 0, 46, 0.35);
}

.hover\\:fill-kids-songs-900\\/40:hover{
  fill: rgba(92, 0, 46, 0.4);
}

.hover\\:fill-kids-songs-900\\/45:hover{
  fill: rgba(92, 0, 46, 0.45);
}

.hover\\:fill-kids-songs-900\\/5:hover{
  fill: rgba(92, 0, 46, 0.05);
}

.hover\\:fill-kids-songs-900\\/50:hover{
  fill: rgba(92, 0, 46, 0.5);
}

.hover\\:fill-kids-songs-900\\/55:hover{
  fill: rgba(92, 0, 46, 0.55);
}

.hover\\:fill-kids-songs-900\\/60:hover{
  fill: rgba(92, 0, 46, 0.6);
}

.hover\\:fill-kids-songs-900\\/65:hover{
  fill: rgba(92, 0, 46, 0.65);
}

.hover\\:fill-kids-songs-900\\/70:hover{
  fill: rgba(92, 0, 46, 0.7);
}

.hover\\:fill-kids-songs-900\\/75:hover{
  fill: rgba(92, 0, 46, 0.75);
}

.hover\\:fill-kids-songs-900\\/80:hover{
  fill: rgba(92, 0, 46, 0.8);
}

.hover\\:fill-kids-songs-900\\/85:hover{
  fill: rgba(92, 0, 46, 0.85);
}

.hover\\:fill-kids-songs-900\\/90:hover{
  fill: rgba(92, 0, 46, 0.9);
}

.hover\\:fill-kids-songs-900\\/95:hover{
  fill: rgba(92, 0, 46, 0.95);
}

.hover\\:fill-kids-stories-500:hover{
  fill: #E9C46A;
}

.hover\\:fill-kids-stories-500\\/0:hover{
  fill: rgba(233, 196, 106, 0);
}

.hover\\:fill-kids-stories-500\\/10:hover{
  fill: rgba(233, 196, 106, 0.1);
}

.hover\\:fill-kids-stories-500\\/100:hover{
  fill: rgb(233, 196, 106);
}

.hover\\:fill-kids-stories-500\\/15:hover{
  fill: rgba(233, 196, 106, 0.15);
}

.hover\\:fill-kids-stories-500\\/20:hover{
  fill: rgba(233, 196, 106, 0.2);
}

.hover\\:fill-kids-stories-500\\/25:hover{
  fill: rgba(233, 196, 106, 0.25);
}

.hover\\:fill-kids-stories-500\\/30:hover{
  fill: rgba(233, 196, 106, 0.3);
}

.hover\\:fill-kids-stories-500\\/35:hover{
  fill: rgba(233, 196, 106, 0.35);
}

.hover\\:fill-kids-stories-500\\/40:hover{
  fill: rgba(233, 196, 106, 0.4);
}

.hover\\:fill-kids-stories-500\\/45:hover{
  fill: rgba(233, 196, 106, 0.45);
}

.hover\\:fill-kids-stories-500\\/5:hover{
  fill: rgba(233, 196, 106, 0.05);
}

.hover\\:fill-kids-stories-500\\/50:hover{
  fill: rgba(233, 196, 106, 0.5);
}

.hover\\:fill-kids-stories-500\\/55:hover{
  fill: rgba(233, 196, 106, 0.55);
}

.hover\\:fill-kids-stories-500\\/60:hover{
  fill: rgba(233, 196, 106, 0.6);
}

.hover\\:fill-kids-stories-500\\/65:hover{
  fill: rgba(233, 196, 106, 0.65);
}

.hover\\:fill-kids-stories-500\\/70:hover{
  fill: rgba(233, 196, 106, 0.7);
}

.hover\\:fill-kids-stories-500\\/75:hover{
  fill: rgba(233, 196, 106, 0.75);
}

.hover\\:fill-kids-stories-500\\/80:hover{
  fill: rgba(233, 196, 106, 0.8);
}

.hover\\:fill-kids-stories-500\\/85:hover{
  fill: rgba(233, 196, 106, 0.85);
}

.hover\\:fill-kids-stories-500\\/90:hover{
  fill: rgba(233, 196, 106, 0.9);
}

.hover\\:fill-kids-stories-500\\/95:hover{
  fill: rgba(233, 196, 106, 0.95);
}

.hover\\:fill-kids-stories-900:hover{
  fill: #a3894a;
}

.hover\\:fill-kids-stories-900\\/0:hover{
  fill: rgba(163, 137, 74, 0);
}

.hover\\:fill-kids-stories-900\\/10:hover{
  fill: rgba(163, 137, 74, 0.1);
}

.hover\\:fill-kids-stories-900\\/100:hover{
  fill: rgb(163, 137, 74);
}

.hover\\:fill-kids-stories-900\\/15:hover{
  fill: rgba(163, 137, 74, 0.15);
}

.hover\\:fill-kids-stories-900\\/20:hover{
  fill: rgba(163, 137, 74, 0.2);
}

.hover\\:fill-kids-stories-900\\/25:hover{
  fill: rgba(163, 137, 74, 0.25);
}

.hover\\:fill-kids-stories-900\\/30:hover{
  fill: rgba(163, 137, 74, 0.3);
}

.hover\\:fill-kids-stories-900\\/35:hover{
  fill: rgba(163, 137, 74, 0.35);
}

.hover\\:fill-kids-stories-900\\/40:hover{
  fill: rgba(163, 137, 74, 0.4);
}

.hover\\:fill-kids-stories-900\\/45:hover{
  fill: rgba(163, 137, 74, 0.45);
}

.hover\\:fill-kids-stories-900\\/5:hover{
  fill: rgba(163, 137, 74, 0.05);
}

.hover\\:fill-kids-stories-900\\/50:hover{
  fill: rgba(163, 137, 74, 0.5);
}

.hover\\:fill-kids-stories-900\\/55:hover{
  fill: rgba(163, 137, 74, 0.55);
}

.hover\\:fill-kids-stories-900\\/60:hover{
  fill: rgba(163, 137, 74, 0.6);
}

.hover\\:fill-kids-stories-900\\/65:hover{
  fill: rgba(163, 137, 74, 0.65);
}

.hover\\:fill-kids-stories-900\\/70:hover{
  fill: rgba(163, 137, 74, 0.7);
}

.hover\\:fill-kids-stories-900\\/75:hover{
  fill: rgba(163, 137, 74, 0.75);
}

.hover\\:fill-kids-stories-900\\/80:hover{
  fill: rgba(163, 137, 74, 0.8);
}

.hover\\:fill-kids-stories-900\\/85:hover{
  fill: rgba(163, 137, 74, 0.85);
}

.hover\\:fill-kids-stories-900\\/90:hover{
  fill: rgba(163, 137, 74, 0.9);
}

.hover\\:fill-kids-stories-900\\/95:hover{
  fill: rgba(163, 137, 74, 0.95);
}

.hover\\:fill-ochre-100:hover{
  fill: #f5edd0;
}

.hover\\:fill-ochre-100\\/0:hover{
  fill: rgba(245, 237, 208, 0);
}

.hover\\:fill-ochre-100\\/10:hover{
  fill: rgba(245, 237, 208, 0.1);
}

.hover\\:fill-ochre-100\\/100:hover{
  fill: rgb(245, 237, 208);
}

.hover\\:fill-ochre-100\\/15:hover{
  fill: rgba(245, 237, 208, 0.15);
}

.hover\\:fill-ochre-100\\/20:hover{
  fill: rgba(245, 237, 208, 0.2);
}

.hover\\:fill-ochre-100\\/25:hover{
  fill: rgba(245, 237, 208, 0.25);
}

.hover\\:fill-ochre-100\\/30:hover{
  fill: rgba(245, 237, 208, 0.3);
}

.hover\\:fill-ochre-100\\/35:hover{
  fill: rgba(245, 237, 208, 0.35);
}

.hover\\:fill-ochre-100\\/40:hover{
  fill: rgba(245, 237, 208, 0.4);
}

.hover\\:fill-ochre-100\\/45:hover{
  fill: rgba(245, 237, 208, 0.45);
}

.hover\\:fill-ochre-100\\/5:hover{
  fill: rgba(245, 237, 208, 0.05);
}

.hover\\:fill-ochre-100\\/50:hover{
  fill: rgba(245, 237, 208, 0.5);
}

.hover\\:fill-ochre-100\\/55:hover{
  fill: rgba(245, 237, 208, 0.55);
}

.hover\\:fill-ochre-100\\/60:hover{
  fill: rgba(245, 237, 208, 0.6);
}

.hover\\:fill-ochre-100\\/65:hover{
  fill: rgba(245, 237, 208, 0.65);
}

.hover\\:fill-ochre-100\\/70:hover{
  fill: rgba(245, 237, 208, 0.7);
}

.hover\\:fill-ochre-100\\/75:hover{
  fill: rgba(245, 237, 208, 0.75);
}

.hover\\:fill-ochre-100\\/80:hover{
  fill: rgba(245, 237, 208, 0.8);
}

.hover\\:fill-ochre-100\\/85:hover{
  fill: rgba(245, 237, 208, 0.85);
}

.hover\\:fill-ochre-100\\/90:hover{
  fill: rgba(245, 237, 208, 0.9);
}

.hover\\:fill-ochre-100\\/95:hover{
  fill: rgba(245, 237, 208, 0.95);
}

.hover\\:fill-ochre-200:hover{
  fill: #ebd99c;
}

.hover\\:fill-ochre-200\\/0:hover{
  fill: rgba(235, 217, 156, 0);
}

.hover\\:fill-ochre-200\\/10:hover{
  fill: rgba(235, 217, 156, 0.1);
}

.hover\\:fill-ochre-200\\/100:hover{
  fill: rgb(235, 217, 156);
}

.hover\\:fill-ochre-200\\/15:hover{
  fill: rgba(235, 217, 156, 0.15);
}

.hover\\:fill-ochre-200\\/20:hover{
  fill: rgba(235, 217, 156, 0.2);
}

.hover\\:fill-ochre-200\\/25:hover{
  fill: rgba(235, 217, 156, 0.25);
}

.hover\\:fill-ochre-200\\/30:hover{
  fill: rgba(235, 217, 156, 0.3);
}

.hover\\:fill-ochre-200\\/35:hover{
  fill: rgba(235, 217, 156, 0.35);
}

.hover\\:fill-ochre-200\\/40:hover{
  fill: rgba(235, 217, 156, 0.4);
}

.hover\\:fill-ochre-200\\/45:hover{
  fill: rgba(235, 217, 156, 0.45);
}

.hover\\:fill-ochre-200\\/5:hover{
  fill: rgba(235, 217, 156, 0.05);
}

.hover\\:fill-ochre-200\\/50:hover{
  fill: rgba(235, 217, 156, 0.5);
}

.hover\\:fill-ochre-200\\/55:hover{
  fill: rgba(235, 217, 156, 0.55);
}

.hover\\:fill-ochre-200\\/60:hover{
  fill: rgba(235, 217, 156, 0.6);
}

.hover\\:fill-ochre-200\\/65:hover{
  fill: rgba(235, 217, 156, 0.65);
}

.hover\\:fill-ochre-200\\/70:hover{
  fill: rgba(235, 217, 156, 0.7);
}

.hover\\:fill-ochre-200\\/75:hover{
  fill: rgba(235, 217, 156, 0.75);
}

.hover\\:fill-ochre-200\\/80:hover{
  fill: rgba(235, 217, 156, 0.8);
}

.hover\\:fill-ochre-200\\/85:hover{
  fill: rgba(235, 217, 156, 0.85);
}

.hover\\:fill-ochre-200\\/90:hover{
  fill: rgba(235, 217, 156, 0.9);
}

.hover\\:fill-ochre-200\\/95:hover{
  fill: rgba(235, 217, 156, 0.95);
}

.hover\\:fill-ochre-300:hover{
  fill: #e1c268;
}

.hover\\:fill-ochre-300\\/0:hover{
  fill: rgba(225, 194, 104, 0);
}

.hover\\:fill-ochre-300\\/10:hover{
  fill: rgba(225, 194, 104, 0.1);
}

.hover\\:fill-ochre-300\\/100:hover{
  fill: rgb(225, 194, 104);
}

.hover\\:fill-ochre-300\\/15:hover{
  fill: rgba(225, 194, 104, 0.15);
}

.hover\\:fill-ochre-300\\/20:hover{
  fill: rgba(225, 194, 104, 0.2);
}

.hover\\:fill-ochre-300\\/25:hover{
  fill: rgba(225, 194, 104, 0.25);
}

.hover\\:fill-ochre-300\\/30:hover{
  fill: rgba(225, 194, 104, 0.3);
}

.hover\\:fill-ochre-300\\/35:hover{
  fill: rgba(225, 194, 104, 0.35);
}

.hover\\:fill-ochre-300\\/40:hover{
  fill: rgba(225, 194, 104, 0.4);
}

.hover\\:fill-ochre-300\\/45:hover{
  fill: rgba(225, 194, 104, 0.45);
}

.hover\\:fill-ochre-300\\/5:hover{
  fill: rgba(225, 194, 104, 0.05);
}

.hover\\:fill-ochre-300\\/50:hover{
  fill: rgba(225, 194, 104, 0.5);
}

.hover\\:fill-ochre-300\\/55:hover{
  fill: rgba(225, 194, 104, 0.55);
}

.hover\\:fill-ochre-300\\/60:hover{
  fill: rgba(225, 194, 104, 0.6);
}

.hover\\:fill-ochre-300\\/65:hover{
  fill: rgba(225, 194, 104, 0.65);
}

.hover\\:fill-ochre-300\\/70:hover{
  fill: rgba(225, 194, 104, 0.7);
}

.hover\\:fill-ochre-300\\/75:hover{
  fill: rgba(225, 194, 104, 0.75);
}

.hover\\:fill-ochre-300\\/80:hover{
  fill: rgba(225, 194, 104, 0.8);
}

.hover\\:fill-ochre-300\\/85:hover{
  fill: rgba(225, 194, 104, 0.85);
}

.hover\\:fill-ochre-300\\/90:hover{
  fill: rgba(225, 194, 104, 0.9);
}

.hover\\:fill-ochre-300\\/95:hover{
  fill: rgba(225, 194, 104, 0.95);
}

.hover\\:fill-ochre-400:hover{
  fill: #daad45;
}

.hover\\:fill-ochre-400\\/0:hover{
  fill: rgba(218, 173, 69, 0);
}

.hover\\:fill-ochre-400\\/10:hover{
  fill: rgba(218, 173, 69, 0.1);
}

.hover\\:fill-ochre-400\\/100:hover{
  fill: rgb(218, 173, 69);
}

.hover\\:fill-ochre-400\\/15:hover{
  fill: rgba(218, 173, 69, 0.15);
}

.hover\\:fill-ochre-400\\/20:hover{
  fill: rgba(218, 173, 69, 0.2);
}

.hover\\:fill-ochre-400\\/25:hover{
  fill: rgba(218, 173, 69, 0.25);
}

.hover\\:fill-ochre-400\\/30:hover{
  fill: rgba(218, 173, 69, 0.3);
}

.hover\\:fill-ochre-400\\/35:hover{
  fill: rgba(218, 173, 69, 0.35);
}

.hover\\:fill-ochre-400\\/40:hover{
  fill: rgba(218, 173, 69, 0.4);
}

.hover\\:fill-ochre-400\\/45:hover{
  fill: rgba(218, 173, 69, 0.45);
}

.hover\\:fill-ochre-400\\/5:hover{
  fill: rgba(218, 173, 69, 0.05);
}

.hover\\:fill-ochre-400\\/50:hover{
  fill: rgba(218, 173, 69, 0.5);
}

.hover\\:fill-ochre-400\\/55:hover{
  fill: rgba(218, 173, 69, 0.55);
}

.hover\\:fill-ochre-400\\/60:hover{
  fill: rgba(218, 173, 69, 0.6);
}

.hover\\:fill-ochre-400\\/65:hover{
  fill: rgba(218, 173, 69, 0.65);
}

.hover\\:fill-ochre-400\\/70:hover{
  fill: rgba(218, 173, 69, 0.7);
}

.hover\\:fill-ochre-400\\/75:hover{
  fill: rgba(218, 173, 69, 0.75);
}

.hover\\:fill-ochre-400\\/80:hover{
  fill: rgba(218, 173, 69, 0.8);
}

.hover\\:fill-ochre-400\\/85:hover{
  fill: rgba(218, 173, 69, 0.85);
}

.hover\\:fill-ochre-400\\/90:hover{
  fill: rgba(218, 173, 69, 0.9);
}

.hover\\:fill-ochre-400\\/95:hover{
  fill: rgba(218, 173, 69, 0.95);
}

.hover\\:fill-ochre-500:hover{
  fill: #d1912f;
}

.hover\\:fill-ochre-500\\/0:hover{
  fill: rgba(209, 145, 47, 0);
}

.hover\\:fill-ochre-500\\/10:hover{
  fill: rgba(209, 145, 47, 0.1);
}

.hover\\:fill-ochre-500\\/100:hover{
  fill: rgb(209, 145, 47);
}

.hover\\:fill-ochre-500\\/15:hover{
  fill: rgba(209, 145, 47, 0.15);
}

.hover\\:fill-ochre-500\\/20:hover{
  fill: rgba(209, 145, 47, 0.2);
}

.hover\\:fill-ochre-500\\/25:hover{
  fill: rgba(209, 145, 47, 0.25);
}

.hover\\:fill-ochre-500\\/30:hover{
  fill: rgba(209, 145, 47, 0.3);
}

.hover\\:fill-ochre-500\\/35:hover{
  fill: rgba(209, 145, 47, 0.35);
}

.hover\\:fill-ochre-500\\/40:hover{
  fill: rgba(209, 145, 47, 0.4);
}

.hover\\:fill-ochre-500\\/45:hover{
  fill: rgba(209, 145, 47, 0.45);
}

.hover\\:fill-ochre-500\\/5:hover{
  fill: rgba(209, 145, 47, 0.05);
}

.hover\\:fill-ochre-500\\/50:hover{
  fill: rgba(209, 145, 47, 0.5);
}

.hover\\:fill-ochre-500\\/55:hover{
  fill: rgba(209, 145, 47, 0.55);
}

.hover\\:fill-ochre-500\\/60:hover{
  fill: rgba(209, 145, 47, 0.6);
}

.hover\\:fill-ochre-500\\/65:hover{
  fill: rgba(209, 145, 47, 0.65);
}

.hover\\:fill-ochre-500\\/70:hover{
  fill: rgba(209, 145, 47, 0.7);
}

.hover\\:fill-ochre-500\\/75:hover{
  fill: rgba(209, 145, 47, 0.75);
}

.hover\\:fill-ochre-500\\/80:hover{
  fill: rgba(209, 145, 47, 0.8);
}

.hover\\:fill-ochre-500\\/85:hover{
  fill: rgba(209, 145, 47, 0.85);
}

.hover\\:fill-ochre-500\\/90:hover{
  fill: rgba(209, 145, 47, 0.9);
}

.hover\\:fill-ochre-500\\/95:hover{
  fill: rgba(209, 145, 47, 0.95);
}

.hover\\:fill-ochre-600:hover{
  fill: #c37829;
}

.hover\\:fill-ochre-600\\/0:hover{
  fill: rgba(195, 120, 41, 0);
}

.hover\\:fill-ochre-600\\/10:hover{
  fill: rgba(195, 120, 41, 0.1);
}

.hover\\:fill-ochre-600\\/100:hover{
  fill: rgb(195, 120, 41);
}

.hover\\:fill-ochre-600\\/15:hover{
  fill: rgba(195, 120, 41, 0.15);
}

.hover\\:fill-ochre-600\\/20:hover{
  fill: rgba(195, 120, 41, 0.2);
}

.hover\\:fill-ochre-600\\/25:hover{
  fill: rgba(195, 120, 41, 0.25);
}

.hover\\:fill-ochre-600\\/30:hover{
  fill: rgba(195, 120, 41, 0.3);
}

.hover\\:fill-ochre-600\\/35:hover{
  fill: rgba(195, 120, 41, 0.35);
}

.hover\\:fill-ochre-600\\/40:hover{
  fill: rgba(195, 120, 41, 0.4);
}

.hover\\:fill-ochre-600\\/45:hover{
  fill: rgba(195, 120, 41, 0.45);
}

.hover\\:fill-ochre-600\\/5:hover{
  fill: rgba(195, 120, 41, 0.05);
}

.hover\\:fill-ochre-600\\/50:hover{
  fill: rgba(195, 120, 41, 0.5);
}

.hover\\:fill-ochre-600\\/55:hover{
  fill: rgba(195, 120, 41, 0.55);
}

.hover\\:fill-ochre-600\\/60:hover{
  fill: rgba(195, 120, 41, 0.6);
}

.hover\\:fill-ochre-600\\/65:hover{
  fill: rgba(195, 120, 41, 0.65);
}

.hover\\:fill-ochre-600\\/70:hover{
  fill: rgba(195, 120, 41, 0.7);
}

.hover\\:fill-ochre-600\\/75:hover{
  fill: rgba(195, 120, 41, 0.75);
}

.hover\\:fill-ochre-600\\/80:hover{
  fill: rgba(195, 120, 41, 0.8);
}

.hover\\:fill-ochre-600\\/85:hover{
  fill: rgba(195, 120, 41, 0.85);
}

.hover\\:fill-ochre-600\\/90:hover{
  fill: rgba(195, 120, 41, 0.9);
}

.hover\\:fill-ochre-600\\/95:hover{
  fill: rgba(195, 120, 41, 0.95);
}

.hover\\:fill-ochre-700:hover{
  fill: #995424;
}

.hover\\:fill-ochre-700\\/0:hover{
  fill: rgba(153, 84, 36, 0);
}

.hover\\:fill-ochre-700\\/10:hover{
  fill: rgba(153, 84, 36, 0.1);
}

.hover\\:fill-ochre-700\\/100:hover{
  fill: rgb(153, 84, 36);
}

.hover\\:fill-ochre-700\\/15:hover{
  fill: rgba(153, 84, 36, 0.15);
}

.hover\\:fill-ochre-700\\/20:hover{
  fill: rgba(153, 84, 36, 0.2);
}

.hover\\:fill-ochre-700\\/25:hover{
  fill: rgba(153, 84, 36, 0.25);
}

.hover\\:fill-ochre-700\\/30:hover{
  fill: rgba(153, 84, 36, 0.3);
}

.hover\\:fill-ochre-700\\/35:hover{
  fill: rgba(153, 84, 36, 0.35);
}

.hover\\:fill-ochre-700\\/40:hover{
  fill: rgba(153, 84, 36, 0.4);
}

.hover\\:fill-ochre-700\\/45:hover{
  fill: rgba(153, 84, 36, 0.45);
}

.hover\\:fill-ochre-700\\/5:hover{
  fill: rgba(153, 84, 36, 0.05);
}

.hover\\:fill-ochre-700\\/50:hover{
  fill: rgba(153, 84, 36, 0.5);
}

.hover\\:fill-ochre-700\\/55:hover{
  fill: rgba(153, 84, 36, 0.55);
}

.hover\\:fill-ochre-700\\/60:hover{
  fill: rgba(153, 84, 36, 0.6);
}

.hover\\:fill-ochre-700\\/65:hover{
  fill: rgba(153, 84, 36, 0.65);
}

.hover\\:fill-ochre-700\\/70:hover{
  fill: rgba(153, 84, 36, 0.7);
}

.hover\\:fill-ochre-700\\/75:hover{
  fill: rgba(153, 84, 36, 0.75);
}

.hover\\:fill-ochre-700\\/80:hover{
  fill: rgba(153, 84, 36, 0.8);
}

.hover\\:fill-ochre-700\\/85:hover{
  fill: rgba(153, 84, 36, 0.85);
}

.hover\\:fill-ochre-700\\/90:hover{
  fill: rgba(153, 84, 36, 0.9);
}

.hover\\:fill-ochre-700\\/95:hover{
  fill: rgba(153, 84, 36, 0.95);
}

.hover\\:fill-ochre-800:hover{
  fill: #7e4322;
}

.hover\\:fill-ochre-800\\/0:hover{
  fill: rgba(126, 67, 34, 0);
}

.hover\\:fill-ochre-800\\/10:hover{
  fill: rgba(126, 67, 34, 0.1);
}

.hover\\:fill-ochre-800\\/100:hover{
  fill: rgb(126, 67, 34);
}

.hover\\:fill-ochre-800\\/15:hover{
  fill: rgba(126, 67, 34, 0.15);
}

.hover\\:fill-ochre-800\\/20:hover{
  fill: rgba(126, 67, 34, 0.2);
}

.hover\\:fill-ochre-800\\/25:hover{
  fill: rgba(126, 67, 34, 0.25);
}

.hover\\:fill-ochre-800\\/30:hover{
  fill: rgba(126, 67, 34, 0.3);
}

.hover\\:fill-ochre-800\\/35:hover{
  fill: rgba(126, 67, 34, 0.35);
}

.hover\\:fill-ochre-800\\/40:hover{
  fill: rgba(126, 67, 34, 0.4);
}

.hover\\:fill-ochre-800\\/45:hover{
  fill: rgba(126, 67, 34, 0.45);
}

.hover\\:fill-ochre-800\\/5:hover{
  fill: rgba(126, 67, 34, 0.05);
}

.hover\\:fill-ochre-800\\/50:hover{
  fill: rgba(126, 67, 34, 0.5);
}

.hover\\:fill-ochre-800\\/55:hover{
  fill: rgba(126, 67, 34, 0.55);
}

.hover\\:fill-ochre-800\\/60:hover{
  fill: rgba(126, 67, 34, 0.6);
}

.hover\\:fill-ochre-800\\/65:hover{
  fill: rgba(126, 67, 34, 0.65);
}

.hover\\:fill-ochre-800\\/70:hover{
  fill: rgba(126, 67, 34, 0.7);
}

.hover\\:fill-ochre-800\\/75:hover{
  fill: rgba(126, 67, 34, 0.75);
}

.hover\\:fill-ochre-800\\/80:hover{
  fill: rgba(126, 67, 34, 0.8);
}

.hover\\:fill-ochre-800\\/85:hover{
  fill: rgba(126, 67, 34, 0.85);
}

.hover\\:fill-ochre-800\\/90:hover{
  fill: rgba(126, 67, 34, 0.9);
}

.hover\\:fill-ochre-800\\/95:hover{
  fill: rgba(126, 67, 34, 0.95);
}

.hover\\:fill-ochre-900:hover{
  fill: #68381f;
}

.hover\\:fill-ochre-900\\/0:hover{
  fill: rgba(104, 56, 31, 0);
}

.hover\\:fill-ochre-900\\/10:hover{
  fill: rgba(104, 56, 31, 0.1);
}

.hover\\:fill-ochre-900\\/100:hover{
  fill: rgb(104, 56, 31);
}

.hover\\:fill-ochre-900\\/15:hover{
  fill: rgba(104, 56, 31, 0.15);
}

.hover\\:fill-ochre-900\\/20:hover{
  fill: rgba(104, 56, 31, 0.2);
}

.hover\\:fill-ochre-900\\/25:hover{
  fill: rgba(104, 56, 31, 0.25);
}

.hover\\:fill-ochre-900\\/30:hover{
  fill: rgba(104, 56, 31, 0.3);
}

.hover\\:fill-ochre-900\\/35:hover{
  fill: rgba(104, 56, 31, 0.35);
}

.hover\\:fill-ochre-900\\/40:hover{
  fill: rgba(104, 56, 31, 0.4);
}

.hover\\:fill-ochre-900\\/45:hover{
  fill: rgba(104, 56, 31, 0.45);
}

.hover\\:fill-ochre-900\\/5:hover{
  fill: rgba(104, 56, 31, 0.05);
}

.hover\\:fill-ochre-900\\/50:hover{
  fill: rgba(104, 56, 31, 0.5);
}

.hover\\:fill-ochre-900\\/55:hover{
  fill: rgba(104, 56, 31, 0.55);
}

.hover\\:fill-ochre-900\\/60:hover{
  fill: rgba(104, 56, 31, 0.6);
}

.hover\\:fill-ochre-900\\/65:hover{
  fill: rgba(104, 56, 31, 0.65);
}

.hover\\:fill-ochre-900\\/70:hover{
  fill: rgba(104, 56, 31, 0.7);
}

.hover\\:fill-ochre-900\\/75:hover{
  fill: rgba(104, 56, 31, 0.75);
}

.hover\\:fill-ochre-900\\/80:hover{
  fill: rgba(104, 56, 31, 0.8);
}

.hover\\:fill-ochre-900\\/85:hover{
  fill: rgba(104, 56, 31, 0.85);
}

.hover\\:fill-ochre-900\\/90:hover{
  fill: rgba(104, 56, 31, 0.9);
}

.hover\\:fill-ochre-900\\/95:hover{
  fill: rgba(104, 56, 31, 0.95);
}

.hover\\:fill-ochre-950:hover{
  fill: #3b1c0d;
}

.hover\\:fill-ochre-950\\/0:hover{
  fill: rgba(59, 28, 13, 0);
}

.hover\\:fill-ochre-950\\/10:hover{
  fill: rgba(59, 28, 13, 0.1);
}

.hover\\:fill-ochre-950\\/100:hover{
  fill: rgb(59, 28, 13);
}

.hover\\:fill-ochre-950\\/15:hover{
  fill: rgba(59, 28, 13, 0.15);
}

.hover\\:fill-ochre-950\\/20:hover{
  fill: rgba(59, 28, 13, 0.2);
}

.hover\\:fill-ochre-950\\/25:hover{
  fill: rgba(59, 28, 13, 0.25);
}

.hover\\:fill-ochre-950\\/30:hover{
  fill: rgba(59, 28, 13, 0.3);
}

.hover\\:fill-ochre-950\\/35:hover{
  fill: rgba(59, 28, 13, 0.35);
}

.hover\\:fill-ochre-950\\/40:hover{
  fill: rgba(59, 28, 13, 0.4);
}

.hover\\:fill-ochre-950\\/45:hover{
  fill: rgba(59, 28, 13, 0.45);
}

.hover\\:fill-ochre-950\\/5:hover{
  fill: rgba(59, 28, 13, 0.05);
}

.hover\\:fill-ochre-950\\/50:hover{
  fill: rgba(59, 28, 13, 0.5);
}

.hover\\:fill-ochre-950\\/55:hover{
  fill: rgba(59, 28, 13, 0.55);
}

.hover\\:fill-ochre-950\\/60:hover{
  fill: rgba(59, 28, 13, 0.6);
}

.hover\\:fill-ochre-950\\/65:hover{
  fill: rgba(59, 28, 13, 0.65);
}

.hover\\:fill-ochre-950\\/70:hover{
  fill: rgba(59, 28, 13, 0.7);
}

.hover\\:fill-ochre-950\\/75:hover{
  fill: rgba(59, 28, 13, 0.75);
}

.hover\\:fill-ochre-950\\/80:hover{
  fill: rgba(59, 28, 13, 0.8);
}

.hover\\:fill-ochre-950\\/85:hover{
  fill: rgba(59, 28, 13, 0.85);
}

.hover\\:fill-ochre-950\\/90:hover{
  fill: rgba(59, 28, 13, 0.9);
}

.hover\\:fill-ochre-950\\/95:hover{
  fill: rgba(59, 28, 13, 0.95);
}

.hover\\:fill-phrase-color-100:hover{
  fill: #f5edd0;
}

.hover\\:fill-phrase-color-100\\/0:hover{
  fill: rgba(245, 237, 208, 0);
}

.hover\\:fill-phrase-color-100\\/10:hover{
  fill: rgba(245, 237, 208, 0.1);
}

.hover\\:fill-phrase-color-100\\/100:hover{
  fill: rgb(245, 237, 208);
}

.hover\\:fill-phrase-color-100\\/15:hover{
  fill: rgba(245, 237, 208, 0.15);
}

.hover\\:fill-phrase-color-100\\/20:hover{
  fill: rgba(245, 237, 208, 0.2);
}

.hover\\:fill-phrase-color-100\\/25:hover{
  fill: rgba(245, 237, 208, 0.25);
}

.hover\\:fill-phrase-color-100\\/30:hover{
  fill: rgba(245, 237, 208, 0.3);
}

.hover\\:fill-phrase-color-100\\/35:hover{
  fill: rgba(245, 237, 208, 0.35);
}

.hover\\:fill-phrase-color-100\\/40:hover{
  fill: rgba(245, 237, 208, 0.4);
}

.hover\\:fill-phrase-color-100\\/45:hover{
  fill: rgba(245, 237, 208, 0.45);
}

.hover\\:fill-phrase-color-100\\/5:hover{
  fill: rgba(245, 237, 208, 0.05);
}

.hover\\:fill-phrase-color-100\\/50:hover{
  fill: rgba(245, 237, 208, 0.5);
}

.hover\\:fill-phrase-color-100\\/55:hover{
  fill: rgba(245, 237, 208, 0.55);
}

.hover\\:fill-phrase-color-100\\/60:hover{
  fill: rgba(245, 237, 208, 0.6);
}

.hover\\:fill-phrase-color-100\\/65:hover{
  fill: rgba(245, 237, 208, 0.65);
}

.hover\\:fill-phrase-color-100\\/70:hover{
  fill: rgba(245, 237, 208, 0.7);
}

.hover\\:fill-phrase-color-100\\/75:hover{
  fill: rgba(245, 237, 208, 0.75);
}

.hover\\:fill-phrase-color-100\\/80:hover{
  fill: rgba(245, 237, 208, 0.8);
}

.hover\\:fill-phrase-color-100\\/85:hover{
  fill: rgba(245, 237, 208, 0.85);
}

.hover\\:fill-phrase-color-100\\/90:hover{
  fill: rgba(245, 237, 208, 0.9);
}

.hover\\:fill-phrase-color-100\\/95:hover{
  fill: rgba(245, 237, 208, 0.95);
}

.hover\\:fill-phrase-color-200:hover{
  fill: #ebd99c;
}

.hover\\:fill-phrase-color-200\\/0:hover{
  fill: rgba(235, 217, 156, 0);
}

.hover\\:fill-phrase-color-200\\/10:hover{
  fill: rgba(235, 217, 156, 0.1);
}

.hover\\:fill-phrase-color-200\\/100:hover{
  fill: rgb(235, 217, 156);
}

.hover\\:fill-phrase-color-200\\/15:hover{
  fill: rgba(235, 217, 156, 0.15);
}

.hover\\:fill-phrase-color-200\\/20:hover{
  fill: rgba(235, 217, 156, 0.2);
}

.hover\\:fill-phrase-color-200\\/25:hover{
  fill: rgba(235, 217, 156, 0.25);
}

.hover\\:fill-phrase-color-200\\/30:hover{
  fill: rgba(235, 217, 156, 0.3);
}

.hover\\:fill-phrase-color-200\\/35:hover{
  fill: rgba(235, 217, 156, 0.35);
}

.hover\\:fill-phrase-color-200\\/40:hover{
  fill: rgba(235, 217, 156, 0.4);
}

.hover\\:fill-phrase-color-200\\/45:hover{
  fill: rgba(235, 217, 156, 0.45);
}

.hover\\:fill-phrase-color-200\\/5:hover{
  fill: rgba(235, 217, 156, 0.05);
}

.hover\\:fill-phrase-color-200\\/50:hover{
  fill: rgba(235, 217, 156, 0.5);
}

.hover\\:fill-phrase-color-200\\/55:hover{
  fill: rgba(235, 217, 156, 0.55);
}

.hover\\:fill-phrase-color-200\\/60:hover{
  fill: rgba(235, 217, 156, 0.6);
}

.hover\\:fill-phrase-color-200\\/65:hover{
  fill: rgba(235, 217, 156, 0.65);
}

.hover\\:fill-phrase-color-200\\/70:hover{
  fill: rgba(235, 217, 156, 0.7);
}

.hover\\:fill-phrase-color-200\\/75:hover{
  fill: rgba(235, 217, 156, 0.75);
}

.hover\\:fill-phrase-color-200\\/80:hover{
  fill: rgba(235, 217, 156, 0.8);
}

.hover\\:fill-phrase-color-200\\/85:hover{
  fill: rgba(235, 217, 156, 0.85);
}

.hover\\:fill-phrase-color-200\\/90:hover{
  fill: rgba(235, 217, 156, 0.9);
}

.hover\\:fill-phrase-color-200\\/95:hover{
  fill: rgba(235, 217, 156, 0.95);
}

.hover\\:fill-phrase-color-300:hover{
  fill: #e1c268;
}

.hover\\:fill-phrase-color-300\\/0:hover{
  fill: rgba(225, 194, 104, 0);
}

.hover\\:fill-phrase-color-300\\/10:hover{
  fill: rgba(225, 194, 104, 0.1);
}

.hover\\:fill-phrase-color-300\\/100:hover{
  fill: rgb(225, 194, 104);
}

.hover\\:fill-phrase-color-300\\/15:hover{
  fill: rgba(225, 194, 104, 0.15);
}

.hover\\:fill-phrase-color-300\\/20:hover{
  fill: rgba(225, 194, 104, 0.2);
}

.hover\\:fill-phrase-color-300\\/25:hover{
  fill: rgba(225, 194, 104, 0.25);
}

.hover\\:fill-phrase-color-300\\/30:hover{
  fill: rgba(225, 194, 104, 0.3);
}

.hover\\:fill-phrase-color-300\\/35:hover{
  fill: rgba(225, 194, 104, 0.35);
}

.hover\\:fill-phrase-color-300\\/40:hover{
  fill: rgba(225, 194, 104, 0.4);
}

.hover\\:fill-phrase-color-300\\/45:hover{
  fill: rgba(225, 194, 104, 0.45);
}

.hover\\:fill-phrase-color-300\\/5:hover{
  fill: rgba(225, 194, 104, 0.05);
}

.hover\\:fill-phrase-color-300\\/50:hover{
  fill: rgba(225, 194, 104, 0.5);
}

.hover\\:fill-phrase-color-300\\/55:hover{
  fill: rgba(225, 194, 104, 0.55);
}

.hover\\:fill-phrase-color-300\\/60:hover{
  fill: rgba(225, 194, 104, 0.6);
}

.hover\\:fill-phrase-color-300\\/65:hover{
  fill: rgba(225, 194, 104, 0.65);
}

.hover\\:fill-phrase-color-300\\/70:hover{
  fill: rgba(225, 194, 104, 0.7);
}

.hover\\:fill-phrase-color-300\\/75:hover{
  fill: rgba(225, 194, 104, 0.75);
}

.hover\\:fill-phrase-color-300\\/80:hover{
  fill: rgba(225, 194, 104, 0.8);
}

.hover\\:fill-phrase-color-300\\/85:hover{
  fill: rgba(225, 194, 104, 0.85);
}

.hover\\:fill-phrase-color-300\\/90:hover{
  fill: rgba(225, 194, 104, 0.9);
}

.hover\\:fill-phrase-color-300\\/95:hover{
  fill: rgba(225, 194, 104, 0.95);
}

.hover\\:fill-phrase-color-400:hover{
  fill: #daad45;
}

.hover\\:fill-phrase-color-400\\/0:hover{
  fill: rgba(218, 173, 69, 0);
}

.hover\\:fill-phrase-color-400\\/10:hover{
  fill: rgba(218, 173, 69, 0.1);
}

.hover\\:fill-phrase-color-400\\/100:hover{
  fill: rgb(218, 173, 69);
}

.hover\\:fill-phrase-color-400\\/15:hover{
  fill: rgba(218, 173, 69, 0.15);
}

.hover\\:fill-phrase-color-400\\/20:hover{
  fill: rgba(218, 173, 69, 0.2);
}

.hover\\:fill-phrase-color-400\\/25:hover{
  fill: rgba(218, 173, 69, 0.25);
}

.hover\\:fill-phrase-color-400\\/30:hover{
  fill: rgba(218, 173, 69, 0.3);
}

.hover\\:fill-phrase-color-400\\/35:hover{
  fill: rgba(218, 173, 69, 0.35);
}

.hover\\:fill-phrase-color-400\\/40:hover{
  fill: rgba(218, 173, 69, 0.4);
}

.hover\\:fill-phrase-color-400\\/45:hover{
  fill: rgba(218, 173, 69, 0.45);
}

.hover\\:fill-phrase-color-400\\/5:hover{
  fill: rgba(218, 173, 69, 0.05);
}

.hover\\:fill-phrase-color-400\\/50:hover{
  fill: rgba(218, 173, 69, 0.5);
}

.hover\\:fill-phrase-color-400\\/55:hover{
  fill: rgba(218, 173, 69, 0.55);
}

.hover\\:fill-phrase-color-400\\/60:hover{
  fill: rgba(218, 173, 69, 0.6);
}

.hover\\:fill-phrase-color-400\\/65:hover{
  fill: rgba(218, 173, 69, 0.65);
}

.hover\\:fill-phrase-color-400\\/70:hover{
  fill: rgba(218, 173, 69, 0.7);
}

.hover\\:fill-phrase-color-400\\/75:hover{
  fill: rgba(218, 173, 69, 0.75);
}

.hover\\:fill-phrase-color-400\\/80:hover{
  fill: rgba(218, 173, 69, 0.8);
}

.hover\\:fill-phrase-color-400\\/85:hover{
  fill: rgba(218, 173, 69, 0.85);
}

.hover\\:fill-phrase-color-400\\/90:hover{
  fill: rgba(218, 173, 69, 0.9);
}

.hover\\:fill-phrase-color-400\\/95:hover{
  fill: rgba(218, 173, 69, 0.95);
}

.hover\\:fill-phrase-color-500:hover{
  fill: #d1912f;
}

.hover\\:fill-phrase-color-500\\/0:hover{
  fill: rgba(209, 145, 47, 0);
}

.hover\\:fill-phrase-color-500\\/10:hover{
  fill: rgba(209, 145, 47, 0.1);
}

.hover\\:fill-phrase-color-500\\/100:hover{
  fill: rgb(209, 145, 47);
}

.hover\\:fill-phrase-color-500\\/15:hover{
  fill: rgba(209, 145, 47, 0.15);
}

.hover\\:fill-phrase-color-500\\/20:hover{
  fill: rgba(209, 145, 47, 0.2);
}

.hover\\:fill-phrase-color-500\\/25:hover{
  fill: rgba(209, 145, 47, 0.25);
}

.hover\\:fill-phrase-color-500\\/30:hover{
  fill: rgba(209, 145, 47, 0.3);
}

.hover\\:fill-phrase-color-500\\/35:hover{
  fill: rgba(209, 145, 47, 0.35);
}

.hover\\:fill-phrase-color-500\\/40:hover{
  fill: rgba(209, 145, 47, 0.4);
}

.hover\\:fill-phrase-color-500\\/45:hover{
  fill: rgba(209, 145, 47, 0.45);
}

.hover\\:fill-phrase-color-500\\/5:hover{
  fill: rgba(209, 145, 47, 0.05);
}

.hover\\:fill-phrase-color-500\\/50:hover{
  fill: rgba(209, 145, 47, 0.5);
}

.hover\\:fill-phrase-color-500\\/55:hover{
  fill: rgba(209, 145, 47, 0.55);
}

.hover\\:fill-phrase-color-500\\/60:hover{
  fill: rgba(209, 145, 47, 0.6);
}

.hover\\:fill-phrase-color-500\\/65:hover{
  fill: rgba(209, 145, 47, 0.65);
}

.hover\\:fill-phrase-color-500\\/70:hover{
  fill: rgba(209, 145, 47, 0.7);
}

.hover\\:fill-phrase-color-500\\/75:hover{
  fill: rgba(209, 145, 47, 0.75);
}

.hover\\:fill-phrase-color-500\\/80:hover{
  fill: rgba(209, 145, 47, 0.8);
}

.hover\\:fill-phrase-color-500\\/85:hover{
  fill: rgba(209, 145, 47, 0.85);
}

.hover\\:fill-phrase-color-500\\/90:hover{
  fill: rgba(209, 145, 47, 0.9);
}

.hover\\:fill-phrase-color-500\\/95:hover{
  fill: rgba(209, 145, 47, 0.95);
}

.hover\\:fill-phrase-color-600:hover{
  fill: #c37829;
}

.hover\\:fill-phrase-color-600\\/0:hover{
  fill: rgba(195, 120, 41, 0);
}

.hover\\:fill-phrase-color-600\\/10:hover{
  fill: rgba(195, 120, 41, 0.1);
}

.hover\\:fill-phrase-color-600\\/100:hover{
  fill: rgb(195, 120, 41);
}

.hover\\:fill-phrase-color-600\\/15:hover{
  fill: rgba(195, 120, 41, 0.15);
}

.hover\\:fill-phrase-color-600\\/20:hover{
  fill: rgba(195, 120, 41, 0.2);
}

.hover\\:fill-phrase-color-600\\/25:hover{
  fill: rgba(195, 120, 41, 0.25);
}

.hover\\:fill-phrase-color-600\\/30:hover{
  fill: rgba(195, 120, 41, 0.3);
}

.hover\\:fill-phrase-color-600\\/35:hover{
  fill: rgba(195, 120, 41, 0.35);
}

.hover\\:fill-phrase-color-600\\/40:hover{
  fill: rgba(195, 120, 41, 0.4);
}

.hover\\:fill-phrase-color-600\\/45:hover{
  fill: rgba(195, 120, 41, 0.45);
}

.hover\\:fill-phrase-color-600\\/5:hover{
  fill: rgba(195, 120, 41, 0.05);
}

.hover\\:fill-phrase-color-600\\/50:hover{
  fill: rgba(195, 120, 41, 0.5);
}

.hover\\:fill-phrase-color-600\\/55:hover{
  fill: rgba(195, 120, 41, 0.55);
}

.hover\\:fill-phrase-color-600\\/60:hover{
  fill: rgba(195, 120, 41, 0.6);
}

.hover\\:fill-phrase-color-600\\/65:hover{
  fill: rgba(195, 120, 41, 0.65);
}

.hover\\:fill-phrase-color-600\\/70:hover{
  fill: rgba(195, 120, 41, 0.7);
}

.hover\\:fill-phrase-color-600\\/75:hover{
  fill: rgba(195, 120, 41, 0.75);
}

.hover\\:fill-phrase-color-600\\/80:hover{
  fill: rgba(195, 120, 41, 0.8);
}

.hover\\:fill-phrase-color-600\\/85:hover{
  fill: rgba(195, 120, 41, 0.85);
}

.hover\\:fill-phrase-color-600\\/90:hover{
  fill: rgba(195, 120, 41, 0.9);
}

.hover\\:fill-phrase-color-600\\/95:hover{
  fill: rgba(195, 120, 41, 0.95);
}

.hover\\:fill-phrase-color-700:hover{
  fill: #995424;
}

.hover\\:fill-phrase-color-700\\/0:hover{
  fill: rgba(153, 84, 36, 0);
}

.hover\\:fill-phrase-color-700\\/10:hover{
  fill: rgba(153, 84, 36, 0.1);
}

.hover\\:fill-phrase-color-700\\/100:hover{
  fill: rgb(153, 84, 36);
}

.hover\\:fill-phrase-color-700\\/15:hover{
  fill: rgba(153, 84, 36, 0.15);
}

.hover\\:fill-phrase-color-700\\/20:hover{
  fill: rgba(153, 84, 36, 0.2);
}

.hover\\:fill-phrase-color-700\\/25:hover{
  fill: rgba(153, 84, 36, 0.25);
}

.hover\\:fill-phrase-color-700\\/30:hover{
  fill: rgba(153, 84, 36, 0.3);
}

.hover\\:fill-phrase-color-700\\/35:hover{
  fill: rgba(153, 84, 36, 0.35);
}

.hover\\:fill-phrase-color-700\\/40:hover{
  fill: rgba(153, 84, 36, 0.4);
}

.hover\\:fill-phrase-color-700\\/45:hover{
  fill: rgba(153, 84, 36, 0.45);
}

.hover\\:fill-phrase-color-700\\/5:hover{
  fill: rgba(153, 84, 36, 0.05);
}

.hover\\:fill-phrase-color-700\\/50:hover{
  fill: rgba(153, 84, 36, 0.5);
}

.hover\\:fill-phrase-color-700\\/55:hover{
  fill: rgba(153, 84, 36, 0.55);
}

.hover\\:fill-phrase-color-700\\/60:hover{
  fill: rgba(153, 84, 36, 0.6);
}

.hover\\:fill-phrase-color-700\\/65:hover{
  fill: rgba(153, 84, 36, 0.65);
}

.hover\\:fill-phrase-color-700\\/70:hover{
  fill: rgba(153, 84, 36, 0.7);
}

.hover\\:fill-phrase-color-700\\/75:hover{
  fill: rgba(153, 84, 36, 0.75);
}

.hover\\:fill-phrase-color-700\\/80:hover{
  fill: rgba(153, 84, 36, 0.8);
}

.hover\\:fill-phrase-color-700\\/85:hover{
  fill: rgba(153, 84, 36, 0.85);
}

.hover\\:fill-phrase-color-700\\/90:hover{
  fill: rgba(153, 84, 36, 0.9);
}

.hover\\:fill-phrase-color-700\\/95:hover{
  fill: rgba(153, 84, 36, 0.95);
}

.hover\\:fill-phrase-color-800:hover{
  fill: #7e4322;
}

.hover\\:fill-phrase-color-800\\/0:hover{
  fill: rgba(126, 67, 34, 0);
}

.hover\\:fill-phrase-color-800\\/10:hover{
  fill: rgba(126, 67, 34, 0.1);
}

.hover\\:fill-phrase-color-800\\/100:hover{
  fill: rgb(126, 67, 34);
}

.hover\\:fill-phrase-color-800\\/15:hover{
  fill: rgba(126, 67, 34, 0.15);
}

.hover\\:fill-phrase-color-800\\/20:hover{
  fill: rgba(126, 67, 34, 0.2);
}

.hover\\:fill-phrase-color-800\\/25:hover{
  fill: rgba(126, 67, 34, 0.25);
}

.hover\\:fill-phrase-color-800\\/30:hover{
  fill: rgba(126, 67, 34, 0.3);
}

.hover\\:fill-phrase-color-800\\/35:hover{
  fill: rgba(126, 67, 34, 0.35);
}

.hover\\:fill-phrase-color-800\\/40:hover{
  fill: rgba(126, 67, 34, 0.4);
}

.hover\\:fill-phrase-color-800\\/45:hover{
  fill: rgba(126, 67, 34, 0.45);
}

.hover\\:fill-phrase-color-800\\/5:hover{
  fill: rgba(126, 67, 34, 0.05);
}

.hover\\:fill-phrase-color-800\\/50:hover{
  fill: rgba(126, 67, 34, 0.5);
}

.hover\\:fill-phrase-color-800\\/55:hover{
  fill: rgba(126, 67, 34, 0.55);
}

.hover\\:fill-phrase-color-800\\/60:hover{
  fill: rgba(126, 67, 34, 0.6);
}

.hover\\:fill-phrase-color-800\\/65:hover{
  fill: rgba(126, 67, 34, 0.65);
}

.hover\\:fill-phrase-color-800\\/70:hover{
  fill: rgba(126, 67, 34, 0.7);
}

.hover\\:fill-phrase-color-800\\/75:hover{
  fill: rgba(126, 67, 34, 0.75);
}

.hover\\:fill-phrase-color-800\\/80:hover{
  fill: rgba(126, 67, 34, 0.8);
}

.hover\\:fill-phrase-color-800\\/85:hover{
  fill: rgba(126, 67, 34, 0.85);
}

.hover\\:fill-phrase-color-800\\/90:hover{
  fill: rgba(126, 67, 34, 0.9);
}

.hover\\:fill-phrase-color-800\\/95:hover{
  fill: rgba(126, 67, 34, 0.95);
}

.hover\\:fill-phrase-color-900:hover{
  fill: #68381f;
}

.hover\\:fill-phrase-color-900\\/0:hover{
  fill: rgba(104, 56, 31, 0);
}

.hover\\:fill-phrase-color-900\\/10:hover{
  fill: rgba(104, 56, 31, 0.1);
}

.hover\\:fill-phrase-color-900\\/100:hover{
  fill: rgb(104, 56, 31);
}

.hover\\:fill-phrase-color-900\\/15:hover{
  fill: rgba(104, 56, 31, 0.15);
}

.hover\\:fill-phrase-color-900\\/20:hover{
  fill: rgba(104, 56, 31, 0.2);
}

.hover\\:fill-phrase-color-900\\/25:hover{
  fill: rgba(104, 56, 31, 0.25);
}

.hover\\:fill-phrase-color-900\\/30:hover{
  fill: rgba(104, 56, 31, 0.3);
}

.hover\\:fill-phrase-color-900\\/35:hover{
  fill: rgba(104, 56, 31, 0.35);
}

.hover\\:fill-phrase-color-900\\/40:hover{
  fill: rgba(104, 56, 31, 0.4);
}

.hover\\:fill-phrase-color-900\\/45:hover{
  fill: rgba(104, 56, 31, 0.45);
}

.hover\\:fill-phrase-color-900\\/5:hover{
  fill: rgba(104, 56, 31, 0.05);
}

.hover\\:fill-phrase-color-900\\/50:hover{
  fill: rgba(104, 56, 31, 0.5);
}

.hover\\:fill-phrase-color-900\\/55:hover{
  fill: rgba(104, 56, 31, 0.55);
}

.hover\\:fill-phrase-color-900\\/60:hover{
  fill: rgba(104, 56, 31, 0.6);
}

.hover\\:fill-phrase-color-900\\/65:hover{
  fill: rgba(104, 56, 31, 0.65);
}

.hover\\:fill-phrase-color-900\\/70:hover{
  fill: rgba(104, 56, 31, 0.7);
}

.hover\\:fill-phrase-color-900\\/75:hover{
  fill: rgba(104, 56, 31, 0.75);
}

.hover\\:fill-phrase-color-900\\/80:hover{
  fill: rgba(104, 56, 31, 0.8);
}

.hover\\:fill-phrase-color-900\\/85:hover{
  fill: rgba(104, 56, 31, 0.85);
}

.hover\\:fill-phrase-color-900\\/90:hover{
  fill: rgba(104, 56, 31, 0.9);
}

.hover\\:fill-phrase-color-900\\/95:hover{
  fill: rgba(104, 56, 31, 0.95);
}

.hover\\:fill-phrase-color-950:hover{
  fill: #3b1c0d;
}

.hover\\:fill-phrase-color-950\\/0:hover{
  fill: rgba(59, 28, 13, 0);
}

.hover\\:fill-phrase-color-950\\/10:hover{
  fill: rgba(59, 28, 13, 0.1);
}

.hover\\:fill-phrase-color-950\\/100:hover{
  fill: rgb(59, 28, 13);
}

.hover\\:fill-phrase-color-950\\/15:hover{
  fill: rgba(59, 28, 13, 0.15);
}

.hover\\:fill-phrase-color-950\\/20:hover{
  fill: rgba(59, 28, 13, 0.2);
}

.hover\\:fill-phrase-color-950\\/25:hover{
  fill: rgba(59, 28, 13, 0.25);
}

.hover\\:fill-phrase-color-950\\/30:hover{
  fill: rgba(59, 28, 13, 0.3);
}

.hover\\:fill-phrase-color-950\\/35:hover{
  fill: rgba(59, 28, 13, 0.35);
}

.hover\\:fill-phrase-color-950\\/40:hover{
  fill: rgba(59, 28, 13, 0.4);
}

.hover\\:fill-phrase-color-950\\/45:hover{
  fill: rgba(59, 28, 13, 0.45);
}

.hover\\:fill-phrase-color-950\\/5:hover{
  fill: rgba(59, 28, 13, 0.05);
}

.hover\\:fill-phrase-color-950\\/50:hover{
  fill: rgba(59, 28, 13, 0.5);
}

.hover\\:fill-phrase-color-950\\/55:hover{
  fill: rgba(59, 28, 13, 0.55);
}

.hover\\:fill-phrase-color-950\\/60:hover{
  fill: rgba(59, 28, 13, 0.6);
}

.hover\\:fill-phrase-color-950\\/65:hover{
  fill: rgba(59, 28, 13, 0.65);
}

.hover\\:fill-phrase-color-950\\/70:hover{
  fill: rgba(59, 28, 13, 0.7);
}

.hover\\:fill-phrase-color-950\\/75:hover{
  fill: rgba(59, 28, 13, 0.75);
}

.hover\\:fill-phrase-color-950\\/80:hover{
  fill: rgba(59, 28, 13, 0.8);
}

.hover\\:fill-phrase-color-950\\/85:hover{
  fill: rgba(59, 28, 13, 0.85);
}

.hover\\:fill-phrase-color-950\\/90:hover{
  fill: rgba(59, 28, 13, 0.9);
}

.hover\\:fill-phrase-color-950\\/95:hover{
  fill: rgba(59, 28, 13, 0.95);
}

.hover\\:fill-scarlet-100:hover{
  fill: #ffdcdf;
}

.hover\\:fill-scarlet-100\\/0:hover{
  fill: rgba(255, 220, 223, 0);
}

.hover\\:fill-scarlet-100\\/10:hover{
  fill: rgba(255, 220, 223, 0.1);
}

.hover\\:fill-scarlet-100\\/100:hover{
  fill: rgb(255, 220, 223);
}

.hover\\:fill-scarlet-100\\/15:hover{
  fill: rgba(255, 220, 223, 0.15);
}

.hover\\:fill-scarlet-100\\/20:hover{
  fill: rgba(255, 220, 223, 0.2);
}

.hover\\:fill-scarlet-100\\/25:hover{
  fill: rgba(255, 220, 223, 0.25);
}

.hover\\:fill-scarlet-100\\/30:hover{
  fill: rgba(255, 220, 223, 0.3);
}

.hover\\:fill-scarlet-100\\/35:hover{
  fill: rgba(255, 220, 223, 0.35);
}

.hover\\:fill-scarlet-100\\/40:hover{
  fill: rgba(255, 220, 223, 0.4);
}

.hover\\:fill-scarlet-100\\/45:hover{
  fill: rgba(255, 220, 223, 0.45);
}

.hover\\:fill-scarlet-100\\/5:hover{
  fill: rgba(255, 220, 223, 0.05);
}

.hover\\:fill-scarlet-100\\/50:hover{
  fill: rgba(255, 220, 223, 0.5);
}

.hover\\:fill-scarlet-100\\/55:hover{
  fill: rgba(255, 220, 223, 0.55);
}

.hover\\:fill-scarlet-100\\/60:hover{
  fill: rgba(255, 220, 223, 0.6);
}

.hover\\:fill-scarlet-100\\/65:hover{
  fill: rgba(255, 220, 223, 0.65);
}

.hover\\:fill-scarlet-100\\/70:hover{
  fill: rgba(255, 220, 223, 0.7);
}

.hover\\:fill-scarlet-100\\/75:hover{
  fill: rgba(255, 220, 223, 0.75);
}

.hover\\:fill-scarlet-100\\/80:hover{
  fill: rgba(255, 220, 223, 0.8);
}

.hover\\:fill-scarlet-100\\/85:hover{
  fill: rgba(255, 220, 223, 0.85);
}

.hover\\:fill-scarlet-100\\/90:hover{
  fill: rgba(255, 220, 223, 0.9);
}

.hover\\:fill-scarlet-100\\/95:hover{
  fill: rgba(255, 220, 223, 0.95);
}

.hover\\:fill-scarlet-200:hover{
  fill: #ffc0c6;
}

.hover\\:fill-scarlet-200\\/0:hover{
  fill: rgba(255, 192, 198, 0);
}

.hover\\:fill-scarlet-200\\/10:hover{
  fill: rgba(255, 192, 198, 0.1);
}

.hover\\:fill-scarlet-200\\/100:hover{
  fill: rgb(255, 192, 198);
}

.hover\\:fill-scarlet-200\\/15:hover{
  fill: rgba(255, 192, 198, 0.15);
}

.hover\\:fill-scarlet-200\\/20:hover{
  fill: rgba(255, 192, 198, 0.2);
}

.hover\\:fill-scarlet-200\\/25:hover{
  fill: rgba(255, 192, 198, 0.25);
}

.hover\\:fill-scarlet-200\\/30:hover{
  fill: rgba(255, 192, 198, 0.3);
}

.hover\\:fill-scarlet-200\\/35:hover{
  fill: rgba(255, 192, 198, 0.35);
}

.hover\\:fill-scarlet-200\\/40:hover{
  fill: rgba(255, 192, 198, 0.4);
}

.hover\\:fill-scarlet-200\\/45:hover{
  fill: rgba(255, 192, 198, 0.45);
}

.hover\\:fill-scarlet-200\\/5:hover{
  fill: rgba(255, 192, 198, 0.05);
}

.hover\\:fill-scarlet-200\\/50:hover{
  fill: rgba(255, 192, 198, 0.5);
}

.hover\\:fill-scarlet-200\\/55:hover{
  fill: rgba(255, 192, 198, 0.55);
}

.hover\\:fill-scarlet-200\\/60:hover{
  fill: rgba(255, 192, 198, 0.6);
}

.hover\\:fill-scarlet-200\\/65:hover{
  fill: rgba(255, 192, 198, 0.65);
}

.hover\\:fill-scarlet-200\\/70:hover{
  fill: rgba(255, 192, 198, 0.7);
}

.hover\\:fill-scarlet-200\\/75:hover{
  fill: rgba(255, 192, 198, 0.75);
}

.hover\\:fill-scarlet-200\\/80:hover{
  fill: rgba(255, 192, 198, 0.8);
}

.hover\\:fill-scarlet-200\\/85:hover{
  fill: rgba(255, 192, 198, 0.85);
}

.hover\\:fill-scarlet-200\\/90:hover{
  fill: rgba(255, 192, 198, 0.9);
}

.hover\\:fill-scarlet-200\\/95:hover{
  fill: rgba(255, 192, 198, 0.95);
}

.hover\\:fill-scarlet-300:hover{
  fill: #ff949e;
}

.hover\\:fill-scarlet-300\\/0:hover{
  fill: rgba(255, 148, 158, 0);
}

.hover\\:fill-scarlet-300\\/10:hover{
  fill: rgba(255, 148, 158, 0.1);
}

.hover\\:fill-scarlet-300\\/100:hover{
  fill: rgb(255, 148, 158);
}

.hover\\:fill-scarlet-300\\/15:hover{
  fill: rgba(255, 148, 158, 0.15);
}

.hover\\:fill-scarlet-300\\/20:hover{
  fill: rgba(255, 148, 158, 0.2);
}

.hover\\:fill-scarlet-300\\/25:hover{
  fill: rgba(255, 148, 158, 0.25);
}

.hover\\:fill-scarlet-300\\/30:hover{
  fill: rgba(255, 148, 158, 0.3);
}

.hover\\:fill-scarlet-300\\/35:hover{
  fill: rgba(255, 148, 158, 0.35);
}

.hover\\:fill-scarlet-300\\/40:hover{
  fill: rgba(255, 148, 158, 0.4);
}

.hover\\:fill-scarlet-300\\/45:hover{
  fill: rgba(255, 148, 158, 0.45);
}

.hover\\:fill-scarlet-300\\/5:hover{
  fill: rgba(255, 148, 158, 0.05);
}

.hover\\:fill-scarlet-300\\/50:hover{
  fill: rgba(255, 148, 158, 0.5);
}

.hover\\:fill-scarlet-300\\/55:hover{
  fill: rgba(255, 148, 158, 0.55);
}

.hover\\:fill-scarlet-300\\/60:hover{
  fill: rgba(255, 148, 158, 0.6);
}

.hover\\:fill-scarlet-300\\/65:hover{
  fill: rgba(255, 148, 158, 0.65);
}

.hover\\:fill-scarlet-300\\/70:hover{
  fill: rgba(255, 148, 158, 0.7);
}

.hover\\:fill-scarlet-300\\/75:hover{
  fill: rgba(255, 148, 158, 0.75);
}

.hover\\:fill-scarlet-300\\/80:hover{
  fill: rgba(255, 148, 158, 0.8);
}

.hover\\:fill-scarlet-300\\/85:hover{
  fill: rgba(255, 148, 158, 0.85);
}

.hover\\:fill-scarlet-300\\/90:hover{
  fill: rgba(255, 148, 158, 0.9);
}

.hover\\:fill-scarlet-300\\/95:hover{
  fill: rgba(255, 148, 158, 0.95);
}

.hover\\:fill-scarlet-400:hover{
  fill: #ff5665;
}

.hover\\:fill-scarlet-400\\/0:hover{
  fill: rgba(255, 86, 101, 0);
}

.hover\\:fill-scarlet-400\\/10:hover{
  fill: rgba(255, 86, 101, 0.1);
}

.hover\\:fill-scarlet-400\\/100:hover{
  fill: rgb(255, 86, 101);
}

.hover\\:fill-scarlet-400\\/15:hover{
  fill: rgba(255, 86, 101, 0.15);
}

.hover\\:fill-scarlet-400\\/20:hover{
  fill: rgba(255, 86, 101, 0.2);
}

.hover\\:fill-scarlet-400\\/25:hover{
  fill: rgba(255, 86, 101, 0.25);
}

.hover\\:fill-scarlet-400\\/30:hover{
  fill: rgba(255, 86, 101, 0.3);
}

.hover\\:fill-scarlet-400\\/35:hover{
  fill: rgba(255, 86, 101, 0.35);
}

.hover\\:fill-scarlet-400\\/40:hover{
  fill: rgba(255, 86, 101, 0.4);
}

.hover\\:fill-scarlet-400\\/45:hover{
  fill: rgba(255, 86, 101, 0.45);
}

.hover\\:fill-scarlet-400\\/5:hover{
  fill: rgba(255, 86, 101, 0.05);
}

.hover\\:fill-scarlet-400\\/50:hover{
  fill: rgba(255, 86, 101, 0.5);
}

.hover\\:fill-scarlet-400\\/55:hover{
  fill: rgba(255, 86, 101, 0.55);
}

.hover\\:fill-scarlet-400\\/60:hover{
  fill: rgba(255, 86, 101, 0.6);
}

.hover\\:fill-scarlet-400\\/65:hover{
  fill: rgba(255, 86, 101, 0.65);
}

.hover\\:fill-scarlet-400\\/70:hover{
  fill: rgba(255, 86, 101, 0.7);
}

.hover\\:fill-scarlet-400\\/75:hover{
  fill: rgba(255, 86, 101, 0.75);
}

.hover\\:fill-scarlet-400\\/80:hover{
  fill: rgba(255, 86, 101, 0.8);
}

.hover\\:fill-scarlet-400\\/85:hover{
  fill: rgba(255, 86, 101, 0.85);
}

.hover\\:fill-scarlet-400\\/90:hover{
  fill: rgba(255, 86, 101, 0.9);
}

.hover\\:fill-scarlet-400\\/95:hover{
  fill: rgba(255, 86, 101, 0.95);
}

.hover\\:fill-scarlet-500:hover{
  fill: #ff2236;
}

.hover\\:fill-scarlet-500\\/0:hover{
  fill: rgba(255, 34, 54, 0);
}

.hover\\:fill-scarlet-500\\/10:hover{
  fill: rgba(255, 34, 54, 0.1);
}

.hover\\:fill-scarlet-500\\/100:hover{
  fill: rgb(255, 34, 54);
}

.hover\\:fill-scarlet-500\\/15:hover{
  fill: rgba(255, 34, 54, 0.15);
}

.hover\\:fill-scarlet-500\\/20:hover{
  fill: rgba(255, 34, 54, 0.2);
}

.hover\\:fill-scarlet-500\\/25:hover{
  fill: rgba(255, 34, 54, 0.25);
}

.hover\\:fill-scarlet-500\\/30:hover{
  fill: rgba(255, 34, 54, 0.3);
}

.hover\\:fill-scarlet-500\\/35:hover{
  fill: rgba(255, 34, 54, 0.35);
}

.hover\\:fill-scarlet-500\\/40:hover{
  fill: rgba(255, 34, 54, 0.4);
}

.hover\\:fill-scarlet-500\\/45:hover{
  fill: rgba(255, 34, 54, 0.45);
}

.hover\\:fill-scarlet-500\\/5:hover{
  fill: rgba(255, 34, 54, 0.05);
}

.hover\\:fill-scarlet-500\\/50:hover{
  fill: rgba(255, 34, 54, 0.5);
}

.hover\\:fill-scarlet-500\\/55:hover{
  fill: rgba(255, 34, 54, 0.55);
}

.hover\\:fill-scarlet-500\\/60:hover{
  fill: rgba(255, 34, 54, 0.6);
}

.hover\\:fill-scarlet-500\\/65:hover{
  fill: rgba(255, 34, 54, 0.65);
}

.hover\\:fill-scarlet-500\\/70:hover{
  fill: rgba(255, 34, 54, 0.7);
}

.hover\\:fill-scarlet-500\\/75:hover{
  fill: rgba(255, 34, 54, 0.75);
}

.hover\\:fill-scarlet-500\\/80:hover{
  fill: rgba(255, 34, 54, 0.8);
}

.hover\\:fill-scarlet-500\\/85:hover{
  fill: rgba(255, 34, 54, 0.85);
}

.hover\\:fill-scarlet-500\\/90:hover{
  fill: rgba(255, 34, 54, 0.9);
}

.hover\\:fill-scarlet-500\\/95:hover{
  fill: rgba(255, 34, 54, 0.95);
}

.hover\\:fill-scarlet-600:hover{
  fill: #ff0219;
}

.hover\\:fill-scarlet-600\\/0:hover{
  fill: rgba(255, 2, 25, 0);
}

.hover\\:fill-scarlet-600\\/10:hover{
  fill: rgba(255, 2, 25, 0.1);
}

.hover\\:fill-scarlet-600\\/100:hover{
  fill: rgb(255, 2, 25);
}

.hover\\:fill-scarlet-600\\/15:hover{
  fill: rgba(255, 2, 25, 0.15);
}

.hover\\:fill-scarlet-600\\/20:hover{
  fill: rgba(255, 2, 25, 0.2);
}

.hover\\:fill-scarlet-600\\/25:hover{
  fill: rgba(255, 2, 25, 0.25);
}

.hover\\:fill-scarlet-600\\/30:hover{
  fill: rgba(255, 2, 25, 0.3);
}

.hover\\:fill-scarlet-600\\/35:hover{
  fill: rgba(255, 2, 25, 0.35);
}

.hover\\:fill-scarlet-600\\/40:hover{
  fill: rgba(255, 2, 25, 0.4);
}

.hover\\:fill-scarlet-600\\/45:hover{
  fill: rgba(255, 2, 25, 0.45);
}

.hover\\:fill-scarlet-600\\/5:hover{
  fill: rgba(255, 2, 25, 0.05);
}

.hover\\:fill-scarlet-600\\/50:hover{
  fill: rgba(255, 2, 25, 0.5);
}

.hover\\:fill-scarlet-600\\/55:hover{
  fill: rgba(255, 2, 25, 0.55);
}

.hover\\:fill-scarlet-600\\/60:hover{
  fill: rgba(255, 2, 25, 0.6);
}

.hover\\:fill-scarlet-600\\/65:hover{
  fill: rgba(255, 2, 25, 0.65);
}

.hover\\:fill-scarlet-600\\/70:hover{
  fill: rgba(255, 2, 25, 0.7);
}

.hover\\:fill-scarlet-600\\/75:hover{
  fill: rgba(255, 2, 25, 0.75);
}

.hover\\:fill-scarlet-600\\/80:hover{
  fill: rgba(255, 2, 25, 0.8);
}

.hover\\:fill-scarlet-600\\/85:hover{
  fill: rgba(255, 2, 25, 0.85);
}

.hover\\:fill-scarlet-600\\/90:hover{
  fill: rgba(255, 2, 25, 0.9);
}

.hover\\:fill-scarlet-600\\/95:hover{
  fill: rgba(255, 2, 25, 0.95);
}

.hover\\:fill-scarlet-700:hover{
  fill: #d80013;
}

.hover\\:fill-scarlet-700\\/0:hover{
  fill: rgba(216, 0, 19, 0);
}

.hover\\:fill-scarlet-700\\/10:hover{
  fill: rgba(216, 0, 19, 0.1);
}

.hover\\:fill-scarlet-700\\/100:hover{
  fill: rgb(216, 0, 19);
}

.hover\\:fill-scarlet-700\\/15:hover{
  fill: rgba(216, 0, 19, 0.15);
}

.hover\\:fill-scarlet-700\\/20:hover{
  fill: rgba(216, 0, 19, 0.2);
}

.hover\\:fill-scarlet-700\\/25:hover{
  fill: rgba(216, 0, 19, 0.25);
}

.hover\\:fill-scarlet-700\\/30:hover{
  fill: rgba(216, 0, 19, 0.3);
}

.hover\\:fill-scarlet-700\\/35:hover{
  fill: rgba(216, 0, 19, 0.35);
}

.hover\\:fill-scarlet-700\\/40:hover{
  fill: rgba(216, 0, 19, 0.4);
}

.hover\\:fill-scarlet-700\\/45:hover{
  fill: rgba(216, 0, 19, 0.45);
}

.hover\\:fill-scarlet-700\\/5:hover{
  fill: rgba(216, 0, 19, 0.05);
}

.hover\\:fill-scarlet-700\\/50:hover{
  fill: rgba(216, 0, 19, 0.5);
}

.hover\\:fill-scarlet-700\\/55:hover{
  fill: rgba(216, 0, 19, 0.55);
}

.hover\\:fill-scarlet-700\\/60:hover{
  fill: rgba(216, 0, 19, 0.6);
}

.hover\\:fill-scarlet-700\\/65:hover{
  fill: rgba(216, 0, 19, 0.65);
}

.hover\\:fill-scarlet-700\\/70:hover{
  fill: rgba(216, 0, 19, 0.7);
}

.hover\\:fill-scarlet-700\\/75:hover{
  fill: rgba(216, 0, 19, 0.75);
}

.hover\\:fill-scarlet-700\\/80:hover{
  fill: rgba(216, 0, 19, 0.8);
}

.hover\\:fill-scarlet-700\\/85:hover{
  fill: rgba(216, 0, 19, 0.85);
}

.hover\\:fill-scarlet-700\\/90:hover{
  fill: rgba(216, 0, 19, 0.9);
}

.hover\\:fill-scarlet-700\\/95:hover{
  fill: rgba(216, 0, 19, 0.95);
}

.hover\\:fill-scarlet-800:hover{
  fill: #b40212;
}

.hover\\:fill-scarlet-800\\/0:hover{
  fill: rgba(180, 2, 18, 0);
}

.hover\\:fill-scarlet-800\\/10:hover{
  fill: rgba(180, 2, 18, 0.1);
}

.hover\\:fill-scarlet-800\\/100:hover{
  fill: rgb(180, 2, 18);
}

.hover\\:fill-scarlet-800\\/15:hover{
  fill: rgba(180, 2, 18, 0.15);
}

.hover\\:fill-scarlet-800\\/20:hover{
  fill: rgba(180, 2, 18, 0.2);
}

.hover\\:fill-scarlet-800\\/25:hover{
  fill: rgba(180, 2, 18, 0.25);
}

.hover\\:fill-scarlet-800\\/30:hover{
  fill: rgba(180, 2, 18, 0.3);
}

.hover\\:fill-scarlet-800\\/35:hover{
  fill: rgba(180, 2, 18, 0.35);
}

.hover\\:fill-scarlet-800\\/40:hover{
  fill: rgba(180, 2, 18, 0.4);
}

.hover\\:fill-scarlet-800\\/45:hover{
  fill: rgba(180, 2, 18, 0.45);
}

.hover\\:fill-scarlet-800\\/5:hover{
  fill: rgba(180, 2, 18, 0.05);
}

.hover\\:fill-scarlet-800\\/50:hover{
  fill: rgba(180, 2, 18, 0.5);
}

.hover\\:fill-scarlet-800\\/55:hover{
  fill: rgba(180, 2, 18, 0.55);
}

.hover\\:fill-scarlet-800\\/60:hover{
  fill: rgba(180, 2, 18, 0.6);
}

.hover\\:fill-scarlet-800\\/65:hover{
  fill: rgba(180, 2, 18, 0.65);
}

.hover\\:fill-scarlet-800\\/70:hover{
  fill: rgba(180, 2, 18, 0.7);
}

.hover\\:fill-scarlet-800\\/75:hover{
  fill: rgba(180, 2, 18, 0.75);
}

.hover\\:fill-scarlet-800\\/80:hover{
  fill: rgba(180, 2, 18, 0.8);
}

.hover\\:fill-scarlet-800\\/85:hover{
  fill: rgba(180, 2, 18, 0.85);
}

.hover\\:fill-scarlet-800\\/90:hover{
  fill: rgba(180, 2, 18, 0.9);
}

.hover\\:fill-scarlet-800\\/95:hover{
  fill: rgba(180, 2, 18, 0.95);
}

.hover\\:fill-scarlet-900:hover{
  fill: #920a16;
}

.hover\\:fill-scarlet-900\\/0:hover{
  fill: rgba(146, 10, 22, 0);
}

.hover\\:fill-scarlet-900\\/10:hover{
  fill: rgba(146, 10, 22, 0.1);
}

.hover\\:fill-scarlet-900\\/100:hover{
  fill: rgb(146, 10, 22);
}

.hover\\:fill-scarlet-900\\/15:hover{
  fill: rgba(146, 10, 22, 0.15);
}

.hover\\:fill-scarlet-900\\/20:hover{
  fill: rgba(146, 10, 22, 0.2);
}

.hover\\:fill-scarlet-900\\/25:hover{
  fill: rgba(146, 10, 22, 0.25);
}

.hover\\:fill-scarlet-900\\/30:hover{
  fill: rgba(146, 10, 22, 0.3);
}

.hover\\:fill-scarlet-900\\/35:hover{
  fill: rgba(146, 10, 22, 0.35);
}

.hover\\:fill-scarlet-900\\/40:hover{
  fill: rgba(146, 10, 22, 0.4);
}

.hover\\:fill-scarlet-900\\/45:hover{
  fill: rgba(146, 10, 22, 0.45);
}

.hover\\:fill-scarlet-900\\/5:hover{
  fill: rgba(146, 10, 22, 0.05);
}

.hover\\:fill-scarlet-900\\/50:hover{
  fill: rgba(146, 10, 22, 0.5);
}

.hover\\:fill-scarlet-900\\/55:hover{
  fill: rgba(146, 10, 22, 0.55);
}

.hover\\:fill-scarlet-900\\/60:hover{
  fill: rgba(146, 10, 22, 0.6);
}

.hover\\:fill-scarlet-900\\/65:hover{
  fill: rgba(146, 10, 22, 0.65);
}

.hover\\:fill-scarlet-900\\/70:hover{
  fill: rgba(146, 10, 22, 0.7);
}

.hover\\:fill-scarlet-900\\/75:hover{
  fill: rgba(146, 10, 22, 0.75);
}

.hover\\:fill-scarlet-900\\/80:hover{
  fill: rgba(146, 10, 22, 0.8);
}

.hover\\:fill-scarlet-900\\/85:hover{
  fill: rgba(146, 10, 22, 0.85);
}

.hover\\:fill-scarlet-900\\/90:hover{
  fill: rgba(146, 10, 22, 0.9);
}

.hover\\:fill-scarlet-900\\/95:hover{
  fill: rgba(146, 10, 22, 0.95);
}

.hover\\:fill-scarlet-950:hover{
  fill: #510007;
}

.hover\\:fill-scarlet-950\\/0:hover{
  fill: rgba(81, 0, 7, 0);
}

.hover\\:fill-scarlet-950\\/10:hover{
  fill: rgba(81, 0, 7, 0.1);
}

.hover\\:fill-scarlet-950\\/100:hover{
  fill: rgb(81, 0, 7);
}

.hover\\:fill-scarlet-950\\/15:hover{
  fill: rgba(81, 0, 7, 0.15);
}

.hover\\:fill-scarlet-950\\/20:hover{
  fill: rgba(81, 0, 7, 0.2);
}

.hover\\:fill-scarlet-950\\/25:hover{
  fill: rgba(81, 0, 7, 0.25);
}

.hover\\:fill-scarlet-950\\/30:hover{
  fill: rgba(81, 0, 7, 0.3);
}

.hover\\:fill-scarlet-950\\/35:hover{
  fill: rgba(81, 0, 7, 0.35);
}

.hover\\:fill-scarlet-950\\/40:hover{
  fill: rgba(81, 0, 7, 0.4);
}

.hover\\:fill-scarlet-950\\/45:hover{
  fill: rgba(81, 0, 7, 0.45);
}

.hover\\:fill-scarlet-950\\/5:hover{
  fill: rgba(81, 0, 7, 0.05);
}

.hover\\:fill-scarlet-950\\/50:hover{
  fill: rgba(81, 0, 7, 0.5);
}

.hover\\:fill-scarlet-950\\/55:hover{
  fill: rgba(81, 0, 7, 0.55);
}

.hover\\:fill-scarlet-950\\/60:hover{
  fill: rgba(81, 0, 7, 0.6);
}

.hover\\:fill-scarlet-950\\/65:hover{
  fill: rgba(81, 0, 7, 0.65);
}

.hover\\:fill-scarlet-950\\/70:hover{
  fill: rgba(81, 0, 7, 0.7);
}

.hover\\:fill-scarlet-950\\/75:hover{
  fill: rgba(81, 0, 7, 0.75);
}

.hover\\:fill-scarlet-950\\/80:hover{
  fill: rgba(81, 0, 7, 0.8);
}

.hover\\:fill-scarlet-950\\/85:hover{
  fill: rgba(81, 0, 7, 0.85);
}

.hover\\:fill-scarlet-950\\/90:hover{
  fill: rgba(81, 0, 7, 0.9);
}

.hover\\:fill-scarlet-950\\/95:hover{
  fill: rgba(81, 0, 7, 0.95);
}

.hover\\:fill-song-color-100:hover{
  fill: #ffdcdf;
}

.hover\\:fill-song-color-100\\/0:hover{
  fill: rgba(255, 220, 223, 0);
}

.hover\\:fill-song-color-100\\/10:hover{
  fill: rgba(255, 220, 223, 0.1);
}

.hover\\:fill-song-color-100\\/100:hover{
  fill: rgb(255, 220, 223);
}

.hover\\:fill-song-color-100\\/15:hover{
  fill: rgba(255, 220, 223, 0.15);
}

.hover\\:fill-song-color-100\\/20:hover{
  fill: rgba(255, 220, 223, 0.2);
}

.hover\\:fill-song-color-100\\/25:hover{
  fill: rgba(255, 220, 223, 0.25);
}

.hover\\:fill-song-color-100\\/30:hover{
  fill: rgba(255, 220, 223, 0.3);
}

.hover\\:fill-song-color-100\\/35:hover{
  fill: rgba(255, 220, 223, 0.35);
}

.hover\\:fill-song-color-100\\/40:hover{
  fill: rgba(255, 220, 223, 0.4);
}

.hover\\:fill-song-color-100\\/45:hover{
  fill: rgba(255, 220, 223, 0.45);
}

.hover\\:fill-song-color-100\\/5:hover{
  fill: rgba(255, 220, 223, 0.05);
}

.hover\\:fill-song-color-100\\/50:hover{
  fill: rgba(255, 220, 223, 0.5);
}

.hover\\:fill-song-color-100\\/55:hover{
  fill: rgba(255, 220, 223, 0.55);
}

.hover\\:fill-song-color-100\\/60:hover{
  fill: rgba(255, 220, 223, 0.6);
}

.hover\\:fill-song-color-100\\/65:hover{
  fill: rgba(255, 220, 223, 0.65);
}

.hover\\:fill-song-color-100\\/70:hover{
  fill: rgba(255, 220, 223, 0.7);
}

.hover\\:fill-song-color-100\\/75:hover{
  fill: rgba(255, 220, 223, 0.75);
}

.hover\\:fill-song-color-100\\/80:hover{
  fill: rgba(255, 220, 223, 0.8);
}

.hover\\:fill-song-color-100\\/85:hover{
  fill: rgba(255, 220, 223, 0.85);
}

.hover\\:fill-song-color-100\\/90:hover{
  fill: rgba(255, 220, 223, 0.9);
}

.hover\\:fill-song-color-100\\/95:hover{
  fill: rgba(255, 220, 223, 0.95);
}

.hover\\:fill-song-color-200:hover{
  fill: #ffc0c6;
}

.hover\\:fill-song-color-200\\/0:hover{
  fill: rgba(255, 192, 198, 0);
}

.hover\\:fill-song-color-200\\/10:hover{
  fill: rgba(255, 192, 198, 0.1);
}

.hover\\:fill-song-color-200\\/100:hover{
  fill: rgb(255, 192, 198);
}

.hover\\:fill-song-color-200\\/15:hover{
  fill: rgba(255, 192, 198, 0.15);
}

.hover\\:fill-song-color-200\\/20:hover{
  fill: rgba(255, 192, 198, 0.2);
}

.hover\\:fill-song-color-200\\/25:hover{
  fill: rgba(255, 192, 198, 0.25);
}

.hover\\:fill-song-color-200\\/30:hover{
  fill: rgba(255, 192, 198, 0.3);
}

.hover\\:fill-song-color-200\\/35:hover{
  fill: rgba(255, 192, 198, 0.35);
}

.hover\\:fill-song-color-200\\/40:hover{
  fill: rgba(255, 192, 198, 0.4);
}

.hover\\:fill-song-color-200\\/45:hover{
  fill: rgba(255, 192, 198, 0.45);
}

.hover\\:fill-song-color-200\\/5:hover{
  fill: rgba(255, 192, 198, 0.05);
}

.hover\\:fill-song-color-200\\/50:hover{
  fill: rgba(255, 192, 198, 0.5);
}

.hover\\:fill-song-color-200\\/55:hover{
  fill: rgba(255, 192, 198, 0.55);
}

.hover\\:fill-song-color-200\\/60:hover{
  fill: rgba(255, 192, 198, 0.6);
}

.hover\\:fill-song-color-200\\/65:hover{
  fill: rgba(255, 192, 198, 0.65);
}

.hover\\:fill-song-color-200\\/70:hover{
  fill: rgba(255, 192, 198, 0.7);
}

.hover\\:fill-song-color-200\\/75:hover{
  fill: rgba(255, 192, 198, 0.75);
}

.hover\\:fill-song-color-200\\/80:hover{
  fill: rgba(255, 192, 198, 0.8);
}

.hover\\:fill-song-color-200\\/85:hover{
  fill: rgba(255, 192, 198, 0.85);
}

.hover\\:fill-song-color-200\\/90:hover{
  fill: rgba(255, 192, 198, 0.9);
}

.hover\\:fill-song-color-200\\/95:hover{
  fill: rgba(255, 192, 198, 0.95);
}

.hover\\:fill-song-color-300:hover{
  fill: #ff949e;
}

.hover\\:fill-song-color-300\\/0:hover{
  fill: rgba(255, 148, 158, 0);
}

.hover\\:fill-song-color-300\\/10:hover{
  fill: rgba(255, 148, 158, 0.1);
}

.hover\\:fill-song-color-300\\/100:hover{
  fill: rgb(255, 148, 158);
}

.hover\\:fill-song-color-300\\/15:hover{
  fill: rgba(255, 148, 158, 0.15);
}

.hover\\:fill-song-color-300\\/20:hover{
  fill: rgba(255, 148, 158, 0.2);
}

.hover\\:fill-song-color-300\\/25:hover{
  fill: rgba(255, 148, 158, 0.25);
}

.hover\\:fill-song-color-300\\/30:hover{
  fill: rgba(255, 148, 158, 0.3);
}

.hover\\:fill-song-color-300\\/35:hover{
  fill: rgba(255, 148, 158, 0.35);
}

.hover\\:fill-song-color-300\\/40:hover{
  fill: rgba(255, 148, 158, 0.4);
}

.hover\\:fill-song-color-300\\/45:hover{
  fill: rgba(255, 148, 158, 0.45);
}

.hover\\:fill-song-color-300\\/5:hover{
  fill: rgba(255, 148, 158, 0.05);
}

.hover\\:fill-song-color-300\\/50:hover{
  fill: rgba(255, 148, 158, 0.5);
}

.hover\\:fill-song-color-300\\/55:hover{
  fill: rgba(255, 148, 158, 0.55);
}

.hover\\:fill-song-color-300\\/60:hover{
  fill: rgba(255, 148, 158, 0.6);
}

.hover\\:fill-song-color-300\\/65:hover{
  fill: rgba(255, 148, 158, 0.65);
}

.hover\\:fill-song-color-300\\/70:hover{
  fill: rgba(255, 148, 158, 0.7);
}

.hover\\:fill-song-color-300\\/75:hover{
  fill: rgba(255, 148, 158, 0.75);
}

.hover\\:fill-song-color-300\\/80:hover{
  fill: rgba(255, 148, 158, 0.8);
}

.hover\\:fill-song-color-300\\/85:hover{
  fill: rgba(255, 148, 158, 0.85);
}

.hover\\:fill-song-color-300\\/90:hover{
  fill: rgba(255, 148, 158, 0.9);
}

.hover\\:fill-song-color-300\\/95:hover{
  fill: rgba(255, 148, 158, 0.95);
}

.hover\\:fill-song-color-400:hover{
  fill: #ff5665;
}

.hover\\:fill-song-color-400\\/0:hover{
  fill: rgba(255, 86, 101, 0);
}

.hover\\:fill-song-color-400\\/10:hover{
  fill: rgba(255, 86, 101, 0.1);
}

.hover\\:fill-song-color-400\\/100:hover{
  fill: rgb(255, 86, 101);
}

.hover\\:fill-song-color-400\\/15:hover{
  fill: rgba(255, 86, 101, 0.15);
}

.hover\\:fill-song-color-400\\/20:hover{
  fill: rgba(255, 86, 101, 0.2);
}

.hover\\:fill-song-color-400\\/25:hover{
  fill: rgba(255, 86, 101, 0.25);
}

.hover\\:fill-song-color-400\\/30:hover{
  fill: rgba(255, 86, 101, 0.3);
}

.hover\\:fill-song-color-400\\/35:hover{
  fill: rgba(255, 86, 101, 0.35);
}

.hover\\:fill-song-color-400\\/40:hover{
  fill: rgba(255, 86, 101, 0.4);
}

.hover\\:fill-song-color-400\\/45:hover{
  fill: rgba(255, 86, 101, 0.45);
}

.hover\\:fill-song-color-400\\/5:hover{
  fill: rgba(255, 86, 101, 0.05);
}

.hover\\:fill-song-color-400\\/50:hover{
  fill: rgba(255, 86, 101, 0.5);
}

.hover\\:fill-song-color-400\\/55:hover{
  fill: rgba(255, 86, 101, 0.55);
}

.hover\\:fill-song-color-400\\/60:hover{
  fill: rgba(255, 86, 101, 0.6);
}

.hover\\:fill-song-color-400\\/65:hover{
  fill: rgba(255, 86, 101, 0.65);
}

.hover\\:fill-song-color-400\\/70:hover{
  fill: rgba(255, 86, 101, 0.7);
}

.hover\\:fill-song-color-400\\/75:hover{
  fill: rgba(255, 86, 101, 0.75);
}

.hover\\:fill-song-color-400\\/80:hover{
  fill: rgba(255, 86, 101, 0.8);
}

.hover\\:fill-song-color-400\\/85:hover{
  fill: rgba(255, 86, 101, 0.85);
}

.hover\\:fill-song-color-400\\/90:hover{
  fill: rgba(255, 86, 101, 0.9);
}

.hover\\:fill-song-color-400\\/95:hover{
  fill: rgba(255, 86, 101, 0.95);
}

.hover\\:fill-song-color-500:hover{
  fill: #ff2236;
}

.hover\\:fill-song-color-500\\/0:hover{
  fill: rgba(255, 34, 54, 0);
}

.hover\\:fill-song-color-500\\/10:hover{
  fill: rgba(255, 34, 54, 0.1);
}

.hover\\:fill-song-color-500\\/100:hover{
  fill: rgb(255, 34, 54);
}

.hover\\:fill-song-color-500\\/15:hover{
  fill: rgba(255, 34, 54, 0.15);
}

.hover\\:fill-song-color-500\\/20:hover{
  fill: rgba(255, 34, 54, 0.2);
}

.hover\\:fill-song-color-500\\/25:hover{
  fill: rgba(255, 34, 54, 0.25);
}

.hover\\:fill-song-color-500\\/30:hover{
  fill: rgba(255, 34, 54, 0.3);
}

.hover\\:fill-song-color-500\\/35:hover{
  fill: rgba(255, 34, 54, 0.35);
}

.hover\\:fill-song-color-500\\/40:hover{
  fill: rgba(255, 34, 54, 0.4);
}

.hover\\:fill-song-color-500\\/45:hover{
  fill: rgba(255, 34, 54, 0.45);
}

.hover\\:fill-song-color-500\\/5:hover{
  fill: rgba(255, 34, 54, 0.05);
}

.hover\\:fill-song-color-500\\/50:hover{
  fill: rgba(255, 34, 54, 0.5);
}

.hover\\:fill-song-color-500\\/55:hover{
  fill: rgba(255, 34, 54, 0.55);
}

.hover\\:fill-song-color-500\\/60:hover{
  fill: rgba(255, 34, 54, 0.6);
}

.hover\\:fill-song-color-500\\/65:hover{
  fill: rgba(255, 34, 54, 0.65);
}

.hover\\:fill-song-color-500\\/70:hover{
  fill: rgba(255, 34, 54, 0.7);
}

.hover\\:fill-song-color-500\\/75:hover{
  fill: rgba(255, 34, 54, 0.75);
}

.hover\\:fill-song-color-500\\/80:hover{
  fill: rgba(255, 34, 54, 0.8);
}

.hover\\:fill-song-color-500\\/85:hover{
  fill: rgba(255, 34, 54, 0.85);
}

.hover\\:fill-song-color-500\\/90:hover{
  fill: rgba(255, 34, 54, 0.9);
}

.hover\\:fill-song-color-500\\/95:hover{
  fill: rgba(255, 34, 54, 0.95);
}

.hover\\:fill-song-color-600:hover{
  fill: #ff0219;
}

.hover\\:fill-song-color-600\\/0:hover{
  fill: rgba(255, 2, 25, 0);
}

.hover\\:fill-song-color-600\\/10:hover{
  fill: rgba(255, 2, 25, 0.1);
}

.hover\\:fill-song-color-600\\/100:hover{
  fill: rgb(255, 2, 25);
}

.hover\\:fill-song-color-600\\/15:hover{
  fill: rgba(255, 2, 25, 0.15);
}

.hover\\:fill-song-color-600\\/20:hover{
  fill: rgba(255, 2, 25, 0.2);
}

.hover\\:fill-song-color-600\\/25:hover{
  fill: rgba(255, 2, 25, 0.25);
}

.hover\\:fill-song-color-600\\/30:hover{
  fill: rgba(255, 2, 25, 0.3);
}

.hover\\:fill-song-color-600\\/35:hover{
  fill: rgba(255, 2, 25, 0.35);
}

.hover\\:fill-song-color-600\\/40:hover{
  fill: rgba(255, 2, 25, 0.4);
}

.hover\\:fill-song-color-600\\/45:hover{
  fill: rgba(255, 2, 25, 0.45);
}

.hover\\:fill-song-color-600\\/5:hover{
  fill: rgba(255, 2, 25, 0.05);
}

.hover\\:fill-song-color-600\\/50:hover{
  fill: rgba(255, 2, 25, 0.5);
}

.hover\\:fill-song-color-600\\/55:hover{
  fill: rgba(255, 2, 25, 0.55);
}

.hover\\:fill-song-color-600\\/60:hover{
  fill: rgba(255, 2, 25, 0.6);
}

.hover\\:fill-song-color-600\\/65:hover{
  fill: rgba(255, 2, 25, 0.65);
}

.hover\\:fill-song-color-600\\/70:hover{
  fill: rgba(255, 2, 25, 0.7);
}

.hover\\:fill-song-color-600\\/75:hover{
  fill: rgba(255, 2, 25, 0.75);
}

.hover\\:fill-song-color-600\\/80:hover{
  fill: rgba(255, 2, 25, 0.8);
}

.hover\\:fill-song-color-600\\/85:hover{
  fill: rgba(255, 2, 25, 0.85);
}

.hover\\:fill-song-color-600\\/90:hover{
  fill: rgba(255, 2, 25, 0.9);
}

.hover\\:fill-song-color-600\\/95:hover{
  fill: rgba(255, 2, 25, 0.95);
}

.hover\\:fill-song-color-700:hover{
  fill: #d80013;
}

.hover\\:fill-song-color-700\\/0:hover{
  fill: rgba(216, 0, 19, 0);
}

.hover\\:fill-song-color-700\\/10:hover{
  fill: rgba(216, 0, 19, 0.1);
}

.hover\\:fill-song-color-700\\/100:hover{
  fill: rgb(216, 0, 19);
}

.hover\\:fill-song-color-700\\/15:hover{
  fill: rgba(216, 0, 19, 0.15);
}

.hover\\:fill-song-color-700\\/20:hover{
  fill: rgba(216, 0, 19, 0.2);
}

.hover\\:fill-song-color-700\\/25:hover{
  fill: rgba(216, 0, 19, 0.25);
}

.hover\\:fill-song-color-700\\/30:hover{
  fill: rgba(216, 0, 19, 0.3);
}

.hover\\:fill-song-color-700\\/35:hover{
  fill: rgba(216, 0, 19, 0.35);
}

.hover\\:fill-song-color-700\\/40:hover{
  fill: rgba(216, 0, 19, 0.4);
}

.hover\\:fill-song-color-700\\/45:hover{
  fill: rgba(216, 0, 19, 0.45);
}

.hover\\:fill-song-color-700\\/5:hover{
  fill: rgba(216, 0, 19, 0.05);
}

.hover\\:fill-song-color-700\\/50:hover{
  fill: rgba(216, 0, 19, 0.5);
}

.hover\\:fill-song-color-700\\/55:hover{
  fill: rgba(216, 0, 19, 0.55);
}

.hover\\:fill-song-color-700\\/60:hover{
  fill: rgba(216, 0, 19, 0.6);
}

.hover\\:fill-song-color-700\\/65:hover{
  fill: rgba(216, 0, 19, 0.65);
}

.hover\\:fill-song-color-700\\/70:hover{
  fill: rgba(216, 0, 19, 0.7);
}

.hover\\:fill-song-color-700\\/75:hover{
  fill: rgba(216, 0, 19, 0.75);
}

.hover\\:fill-song-color-700\\/80:hover{
  fill: rgba(216, 0, 19, 0.8);
}

.hover\\:fill-song-color-700\\/85:hover{
  fill: rgba(216, 0, 19, 0.85);
}

.hover\\:fill-song-color-700\\/90:hover{
  fill: rgba(216, 0, 19, 0.9);
}

.hover\\:fill-song-color-700\\/95:hover{
  fill: rgba(216, 0, 19, 0.95);
}

.hover\\:fill-song-color-800:hover{
  fill: #b40212;
}

.hover\\:fill-song-color-800\\/0:hover{
  fill: rgba(180, 2, 18, 0);
}

.hover\\:fill-song-color-800\\/10:hover{
  fill: rgba(180, 2, 18, 0.1);
}

.hover\\:fill-song-color-800\\/100:hover{
  fill: rgb(180, 2, 18);
}

.hover\\:fill-song-color-800\\/15:hover{
  fill: rgba(180, 2, 18, 0.15);
}

.hover\\:fill-song-color-800\\/20:hover{
  fill: rgba(180, 2, 18, 0.2);
}

.hover\\:fill-song-color-800\\/25:hover{
  fill: rgba(180, 2, 18, 0.25);
}

.hover\\:fill-song-color-800\\/30:hover{
  fill: rgba(180, 2, 18, 0.3);
}

.hover\\:fill-song-color-800\\/35:hover{
  fill: rgba(180, 2, 18, 0.35);
}

.hover\\:fill-song-color-800\\/40:hover{
  fill: rgba(180, 2, 18, 0.4);
}

.hover\\:fill-song-color-800\\/45:hover{
  fill: rgba(180, 2, 18, 0.45);
}

.hover\\:fill-song-color-800\\/5:hover{
  fill: rgba(180, 2, 18, 0.05);
}

.hover\\:fill-song-color-800\\/50:hover{
  fill: rgba(180, 2, 18, 0.5);
}

.hover\\:fill-song-color-800\\/55:hover{
  fill: rgba(180, 2, 18, 0.55);
}

.hover\\:fill-song-color-800\\/60:hover{
  fill: rgba(180, 2, 18, 0.6);
}

.hover\\:fill-song-color-800\\/65:hover{
  fill: rgba(180, 2, 18, 0.65);
}

.hover\\:fill-song-color-800\\/70:hover{
  fill: rgba(180, 2, 18, 0.7);
}

.hover\\:fill-song-color-800\\/75:hover{
  fill: rgba(180, 2, 18, 0.75);
}

.hover\\:fill-song-color-800\\/80:hover{
  fill: rgba(180, 2, 18, 0.8);
}

.hover\\:fill-song-color-800\\/85:hover{
  fill: rgba(180, 2, 18, 0.85);
}

.hover\\:fill-song-color-800\\/90:hover{
  fill: rgba(180, 2, 18, 0.9);
}

.hover\\:fill-song-color-800\\/95:hover{
  fill: rgba(180, 2, 18, 0.95);
}

.hover\\:fill-song-color-900:hover{
  fill: #920a16;
}

.hover\\:fill-song-color-900\\/0:hover{
  fill: rgba(146, 10, 22, 0);
}

.hover\\:fill-song-color-900\\/10:hover{
  fill: rgba(146, 10, 22, 0.1);
}

.hover\\:fill-song-color-900\\/100:hover{
  fill: rgb(146, 10, 22);
}

.hover\\:fill-song-color-900\\/15:hover{
  fill: rgba(146, 10, 22, 0.15);
}

.hover\\:fill-song-color-900\\/20:hover{
  fill: rgba(146, 10, 22, 0.2);
}

.hover\\:fill-song-color-900\\/25:hover{
  fill: rgba(146, 10, 22, 0.25);
}

.hover\\:fill-song-color-900\\/30:hover{
  fill: rgba(146, 10, 22, 0.3);
}

.hover\\:fill-song-color-900\\/35:hover{
  fill: rgba(146, 10, 22, 0.35);
}

.hover\\:fill-song-color-900\\/40:hover{
  fill: rgba(146, 10, 22, 0.4);
}

.hover\\:fill-song-color-900\\/45:hover{
  fill: rgba(146, 10, 22, 0.45);
}

.hover\\:fill-song-color-900\\/5:hover{
  fill: rgba(146, 10, 22, 0.05);
}

.hover\\:fill-song-color-900\\/50:hover{
  fill: rgba(146, 10, 22, 0.5);
}

.hover\\:fill-song-color-900\\/55:hover{
  fill: rgba(146, 10, 22, 0.55);
}

.hover\\:fill-song-color-900\\/60:hover{
  fill: rgba(146, 10, 22, 0.6);
}

.hover\\:fill-song-color-900\\/65:hover{
  fill: rgba(146, 10, 22, 0.65);
}

.hover\\:fill-song-color-900\\/70:hover{
  fill: rgba(146, 10, 22, 0.7);
}

.hover\\:fill-song-color-900\\/75:hover{
  fill: rgba(146, 10, 22, 0.75);
}

.hover\\:fill-song-color-900\\/80:hover{
  fill: rgba(146, 10, 22, 0.8);
}

.hover\\:fill-song-color-900\\/85:hover{
  fill: rgba(146, 10, 22, 0.85);
}

.hover\\:fill-song-color-900\\/90:hover{
  fill: rgba(146, 10, 22, 0.9);
}

.hover\\:fill-song-color-900\\/95:hover{
  fill: rgba(146, 10, 22, 0.95);
}

.hover\\:fill-song-color-950:hover{
  fill: #510007;
}

.hover\\:fill-song-color-950\\/0:hover{
  fill: rgba(81, 0, 7, 0);
}

.hover\\:fill-song-color-950\\/10:hover{
  fill: rgba(81, 0, 7, 0.1);
}

.hover\\:fill-song-color-950\\/100:hover{
  fill: rgb(81, 0, 7);
}

.hover\\:fill-song-color-950\\/15:hover{
  fill: rgba(81, 0, 7, 0.15);
}

.hover\\:fill-song-color-950\\/20:hover{
  fill: rgba(81, 0, 7, 0.2);
}

.hover\\:fill-song-color-950\\/25:hover{
  fill: rgba(81, 0, 7, 0.25);
}

.hover\\:fill-song-color-950\\/30:hover{
  fill: rgba(81, 0, 7, 0.3);
}

.hover\\:fill-song-color-950\\/35:hover{
  fill: rgba(81, 0, 7, 0.35);
}

.hover\\:fill-song-color-950\\/40:hover{
  fill: rgba(81, 0, 7, 0.4);
}

.hover\\:fill-song-color-950\\/45:hover{
  fill: rgba(81, 0, 7, 0.45);
}

.hover\\:fill-song-color-950\\/5:hover{
  fill: rgba(81, 0, 7, 0.05);
}

.hover\\:fill-song-color-950\\/50:hover{
  fill: rgba(81, 0, 7, 0.5);
}

.hover\\:fill-song-color-950\\/55:hover{
  fill: rgba(81, 0, 7, 0.55);
}

.hover\\:fill-song-color-950\\/60:hover{
  fill: rgba(81, 0, 7, 0.6);
}

.hover\\:fill-song-color-950\\/65:hover{
  fill: rgba(81, 0, 7, 0.65);
}

.hover\\:fill-song-color-950\\/70:hover{
  fill: rgba(81, 0, 7, 0.7);
}

.hover\\:fill-song-color-950\\/75:hover{
  fill: rgba(81, 0, 7, 0.75);
}

.hover\\:fill-song-color-950\\/80:hover{
  fill: rgba(81, 0, 7, 0.8);
}

.hover\\:fill-song-color-950\\/85:hover{
  fill: rgba(81, 0, 7, 0.85);
}

.hover\\:fill-song-color-950\\/90:hover{
  fill: rgba(81, 0, 7, 0.9);
}

.hover\\:fill-song-color-950\\/95:hover{
  fill: rgba(81, 0, 7, 0.95);
}

.hover\\:fill-story-color-100:hover{
  fill: #daeef3;
}

.hover\\:fill-story-color-100\\/0:hover{
  fill: rgba(218, 238, 243, 0);
}

.hover\\:fill-story-color-100\\/10:hover{
  fill: rgba(218, 238, 243, 0.1);
}

.hover\\:fill-story-color-100\\/100:hover{
  fill: rgb(218, 238, 243);
}

.hover\\:fill-story-color-100\\/15:hover{
  fill: rgba(218, 238, 243, 0.15);
}

.hover\\:fill-story-color-100\\/20:hover{
  fill: rgba(218, 238, 243, 0.2);
}

.hover\\:fill-story-color-100\\/25:hover{
  fill: rgba(218, 238, 243, 0.25);
}

.hover\\:fill-story-color-100\\/30:hover{
  fill: rgba(218, 238, 243, 0.3);
}

.hover\\:fill-story-color-100\\/35:hover{
  fill: rgba(218, 238, 243, 0.35);
}

.hover\\:fill-story-color-100\\/40:hover{
  fill: rgba(218, 238, 243, 0.4);
}

.hover\\:fill-story-color-100\\/45:hover{
  fill: rgba(218, 238, 243, 0.45);
}

.hover\\:fill-story-color-100\\/5:hover{
  fill: rgba(218, 238, 243, 0.05);
}

.hover\\:fill-story-color-100\\/50:hover{
  fill: rgba(218, 238, 243, 0.5);
}

.hover\\:fill-story-color-100\\/55:hover{
  fill: rgba(218, 238, 243, 0.55);
}

.hover\\:fill-story-color-100\\/60:hover{
  fill: rgba(218, 238, 243, 0.6);
}

.hover\\:fill-story-color-100\\/65:hover{
  fill: rgba(218, 238, 243, 0.65);
}

.hover\\:fill-story-color-100\\/70:hover{
  fill: rgba(218, 238, 243, 0.7);
}

.hover\\:fill-story-color-100\\/75:hover{
  fill: rgba(218, 238, 243, 0.75);
}

.hover\\:fill-story-color-100\\/80:hover{
  fill: rgba(218, 238, 243, 0.8);
}

.hover\\:fill-story-color-100\\/85:hover{
  fill: rgba(218, 238, 243, 0.85);
}

.hover\\:fill-story-color-100\\/90:hover{
  fill: rgba(218, 238, 243, 0.9);
}

.hover\\:fill-story-color-100\\/95:hover{
  fill: rgba(218, 238, 243, 0.95);
}

.hover\\:fill-story-color-200:hover{
  fill: #badee7;
}

.hover\\:fill-story-color-200\\/0:hover{
  fill: rgba(186, 222, 231, 0);
}

.hover\\:fill-story-color-200\\/10:hover{
  fill: rgba(186, 222, 231, 0.1);
}

.hover\\:fill-story-color-200\\/100:hover{
  fill: rgb(186, 222, 231);
}

.hover\\:fill-story-color-200\\/15:hover{
  fill: rgba(186, 222, 231, 0.15);
}

.hover\\:fill-story-color-200\\/20:hover{
  fill: rgba(186, 222, 231, 0.2);
}

.hover\\:fill-story-color-200\\/25:hover{
  fill: rgba(186, 222, 231, 0.25);
}

.hover\\:fill-story-color-200\\/30:hover{
  fill: rgba(186, 222, 231, 0.3);
}

.hover\\:fill-story-color-200\\/35:hover{
  fill: rgba(186, 222, 231, 0.35);
}

.hover\\:fill-story-color-200\\/40:hover{
  fill: rgba(186, 222, 231, 0.4);
}

.hover\\:fill-story-color-200\\/45:hover{
  fill: rgba(186, 222, 231, 0.45);
}

.hover\\:fill-story-color-200\\/5:hover{
  fill: rgba(186, 222, 231, 0.05);
}

.hover\\:fill-story-color-200\\/50:hover{
  fill: rgba(186, 222, 231, 0.5);
}

.hover\\:fill-story-color-200\\/55:hover{
  fill: rgba(186, 222, 231, 0.55);
}

.hover\\:fill-story-color-200\\/60:hover{
  fill: rgba(186, 222, 231, 0.6);
}

.hover\\:fill-story-color-200\\/65:hover{
  fill: rgba(186, 222, 231, 0.65);
}

.hover\\:fill-story-color-200\\/70:hover{
  fill: rgba(186, 222, 231, 0.7);
}

.hover\\:fill-story-color-200\\/75:hover{
  fill: rgba(186, 222, 231, 0.75);
}

.hover\\:fill-story-color-200\\/80:hover{
  fill: rgba(186, 222, 231, 0.8);
}

.hover\\:fill-story-color-200\\/85:hover{
  fill: rgba(186, 222, 231, 0.85);
}

.hover\\:fill-story-color-200\\/90:hover{
  fill: rgba(186, 222, 231, 0.9);
}

.hover\\:fill-story-color-200\\/95:hover{
  fill: rgba(186, 222, 231, 0.95);
}

.hover\\:fill-story-color-300:hover{
  fill: #89c5d7;
}

.hover\\:fill-story-color-300\\/0:hover{
  fill: rgba(137, 197, 215, 0);
}

.hover\\:fill-story-color-300\\/10:hover{
  fill: rgba(137, 197, 215, 0.1);
}

.hover\\:fill-story-color-300\\/100:hover{
  fill: rgb(137, 197, 215);
}

.hover\\:fill-story-color-300\\/15:hover{
  fill: rgba(137, 197, 215, 0.15);
}

.hover\\:fill-story-color-300\\/20:hover{
  fill: rgba(137, 197, 215, 0.2);
}

.hover\\:fill-story-color-300\\/25:hover{
  fill: rgba(137, 197, 215, 0.25);
}

.hover\\:fill-story-color-300\\/30:hover{
  fill: rgba(137, 197, 215, 0.3);
}

.hover\\:fill-story-color-300\\/35:hover{
  fill: rgba(137, 197, 215, 0.35);
}

.hover\\:fill-story-color-300\\/40:hover{
  fill: rgba(137, 197, 215, 0.4);
}

.hover\\:fill-story-color-300\\/45:hover{
  fill: rgba(137, 197, 215, 0.45);
}

.hover\\:fill-story-color-300\\/5:hover{
  fill: rgba(137, 197, 215, 0.05);
}

.hover\\:fill-story-color-300\\/50:hover{
  fill: rgba(137, 197, 215, 0.5);
}

.hover\\:fill-story-color-300\\/55:hover{
  fill: rgba(137, 197, 215, 0.55);
}

.hover\\:fill-story-color-300\\/60:hover{
  fill: rgba(137, 197, 215, 0.6);
}

.hover\\:fill-story-color-300\\/65:hover{
  fill: rgba(137, 197, 215, 0.65);
}

.hover\\:fill-story-color-300\\/70:hover{
  fill: rgba(137, 197, 215, 0.7);
}

.hover\\:fill-story-color-300\\/75:hover{
  fill: rgba(137, 197, 215, 0.75);
}

.hover\\:fill-story-color-300\\/80:hover{
  fill: rgba(137, 197, 215, 0.8);
}

.hover\\:fill-story-color-300\\/85:hover{
  fill: rgba(137, 197, 215, 0.85);
}

.hover\\:fill-story-color-300\\/90:hover{
  fill: rgba(137, 197, 215, 0.9);
}

.hover\\:fill-story-color-300\\/95:hover{
  fill: rgba(137, 197, 215, 0.95);
}

.hover\\:fill-story-color-400:hover{
  fill: #52a3be;
}

.hover\\:fill-story-color-400\\/0:hover{
  fill: rgba(82, 163, 190, 0);
}

.hover\\:fill-story-color-400\\/10:hover{
  fill: rgba(82, 163, 190, 0.1);
}

.hover\\:fill-story-color-400\\/100:hover{
  fill: rgb(82, 163, 190);
}

.hover\\:fill-story-color-400\\/15:hover{
  fill: rgba(82, 163, 190, 0.15);
}

.hover\\:fill-story-color-400\\/20:hover{
  fill: rgba(82, 163, 190, 0.2);
}

.hover\\:fill-story-color-400\\/25:hover{
  fill: rgba(82, 163, 190, 0.25);
}

.hover\\:fill-story-color-400\\/30:hover{
  fill: rgba(82, 163, 190, 0.3);
}

.hover\\:fill-story-color-400\\/35:hover{
  fill: rgba(82, 163, 190, 0.35);
}

.hover\\:fill-story-color-400\\/40:hover{
  fill: rgba(82, 163, 190, 0.4);
}

.hover\\:fill-story-color-400\\/45:hover{
  fill: rgba(82, 163, 190, 0.45);
}

.hover\\:fill-story-color-400\\/5:hover{
  fill: rgba(82, 163, 190, 0.05);
}

.hover\\:fill-story-color-400\\/50:hover{
  fill: rgba(82, 163, 190, 0.5);
}

.hover\\:fill-story-color-400\\/55:hover{
  fill: rgba(82, 163, 190, 0.55);
}

.hover\\:fill-story-color-400\\/60:hover{
  fill: rgba(82, 163, 190, 0.6);
}

.hover\\:fill-story-color-400\\/65:hover{
  fill: rgba(82, 163, 190, 0.65);
}

.hover\\:fill-story-color-400\\/70:hover{
  fill: rgba(82, 163, 190, 0.7);
}

.hover\\:fill-story-color-400\\/75:hover{
  fill: rgba(82, 163, 190, 0.75);
}

.hover\\:fill-story-color-400\\/80:hover{
  fill: rgba(82, 163, 190, 0.8);
}

.hover\\:fill-story-color-400\\/85:hover{
  fill: rgba(82, 163, 190, 0.85);
}

.hover\\:fill-story-color-400\\/90:hover{
  fill: rgba(82, 163, 190, 0.9);
}

.hover\\:fill-story-color-400\\/95:hover{
  fill: rgba(82, 163, 190, 0.95);
}

.hover\\:fill-story-color-500:hover{
  fill: #3787a3;
}

.hover\\:fill-story-color-500\\/0:hover{
  fill: rgba(55, 135, 163, 0);
}

.hover\\:fill-story-color-500\\/10:hover{
  fill: rgba(55, 135, 163, 0.1);
}

.hover\\:fill-story-color-500\\/100:hover{
  fill: rgb(55, 135, 163);
}

.hover\\:fill-story-color-500\\/15:hover{
  fill: rgba(55, 135, 163, 0.15);
}

.hover\\:fill-story-color-500\\/20:hover{
  fill: rgba(55, 135, 163, 0.2);
}

.hover\\:fill-story-color-500\\/25:hover{
  fill: rgba(55, 135, 163, 0.25);
}

.hover\\:fill-story-color-500\\/30:hover{
  fill: rgba(55, 135, 163, 0.3);
}

.hover\\:fill-story-color-500\\/35:hover{
  fill: rgba(55, 135, 163, 0.35);
}

.hover\\:fill-story-color-500\\/40:hover{
  fill: rgba(55, 135, 163, 0.4);
}

.hover\\:fill-story-color-500\\/45:hover{
  fill: rgba(55, 135, 163, 0.45);
}

.hover\\:fill-story-color-500\\/5:hover{
  fill: rgba(55, 135, 163, 0.05);
}

.hover\\:fill-story-color-500\\/50:hover{
  fill: rgba(55, 135, 163, 0.5);
}

.hover\\:fill-story-color-500\\/55:hover{
  fill: rgba(55, 135, 163, 0.55);
}

.hover\\:fill-story-color-500\\/60:hover{
  fill: rgba(55, 135, 163, 0.6);
}

.hover\\:fill-story-color-500\\/65:hover{
  fill: rgba(55, 135, 163, 0.65);
}

.hover\\:fill-story-color-500\\/70:hover{
  fill: rgba(55, 135, 163, 0.7);
}

.hover\\:fill-story-color-500\\/75:hover{
  fill: rgba(55, 135, 163, 0.75);
}

.hover\\:fill-story-color-500\\/80:hover{
  fill: rgba(55, 135, 163, 0.8);
}

.hover\\:fill-story-color-500\\/85:hover{
  fill: rgba(55, 135, 163, 0.85);
}

.hover\\:fill-story-color-500\\/90:hover{
  fill: rgba(55, 135, 163, 0.9);
}

.hover\\:fill-story-color-500\\/95:hover{
  fill: rgba(55, 135, 163, 0.95);
}

.hover\\:fill-story-color-600:hover{
  fill: #306d8a;
}

.hover\\:fill-story-color-600\\/0:hover{
  fill: rgba(48, 109, 138, 0);
}

.hover\\:fill-story-color-600\\/10:hover{
  fill: rgba(48, 109, 138, 0.1);
}

.hover\\:fill-story-color-600\\/100:hover{
  fill: rgb(48, 109, 138);
}

.hover\\:fill-story-color-600\\/15:hover{
  fill: rgba(48, 109, 138, 0.15);
}

.hover\\:fill-story-color-600\\/20:hover{
  fill: rgba(48, 109, 138, 0.2);
}

.hover\\:fill-story-color-600\\/25:hover{
  fill: rgba(48, 109, 138, 0.25);
}

.hover\\:fill-story-color-600\\/30:hover{
  fill: rgba(48, 109, 138, 0.3);
}

.hover\\:fill-story-color-600\\/35:hover{
  fill: rgba(48, 109, 138, 0.35);
}

.hover\\:fill-story-color-600\\/40:hover{
  fill: rgba(48, 109, 138, 0.4);
}

.hover\\:fill-story-color-600\\/45:hover{
  fill: rgba(48, 109, 138, 0.45);
}

.hover\\:fill-story-color-600\\/5:hover{
  fill: rgba(48, 109, 138, 0.05);
}

.hover\\:fill-story-color-600\\/50:hover{
  fill: rgba(48, 109, 138, 0.5);
}

.hover\\:fill-story-color-600\\/55:hover{
  fill: rgba(48, 109, 138, 0.55);
}

.hover\\:fill-story-color-600\\/60:hover{
  fill: rgba(48, 109, 138, 0.6);
}

.hover\\:fill-story-color-600\\/65:hover{
  fill: rgba(48, 109, 138, 0.65);
}

.hover\\:fill-story-color-600\\/70:hover{
  fill: rgba(48, 109, 138, 0.7);
}

.hover\\:fill-story-color-600\\/75:hover{
  fill: rgba(48, 109, 138, 0.75);
}

.hover\\:fill-story-color-600\\/80:hover{
  fill: rgba(48, 109, 138, 0.8);
}

.hover\\:fill-story-color-600\\/85:hover{
  fill: rgba(48, 109, 138, 0.85);
}

.hover\\:fill-story-color-600\\/90:hover{
  fill: rgba(48, 109, 138, 0.9);
}

.hover\\:fill-story-color-600\\/95:hover{
  fill: rgba(48, 109, 138, 0.95);
}

.hover\\:fill-story-color-700:hover{
  fill: #2d5b72;
}

.hover\\:fill-story-color-700\\/0:hover{
  fill: rgba(45, 91, 114, 0);
}

.hover\\:fill-story-color-700\\/10:hover{
  fill: rgba(45, 91, 114, 0.1);
}

.hover\\:fill-story-color-700\\/100:hover{
  fill: rgb(45, 91, 114);
}

.hover\\:fill-story-color-700\\/15:hover{
  fill: rgba(45, 91, 114, 0.15);
}

.hover\\:fill-story-color-700\\/20:hover{
  fill: rgba(45, 91, 114, 0.2);
}

.hover\\:fill-story-color-700\\/25:hover{
  fill: rgba(45, 91, 114, 0.25);
}

.hover\\:fill-story-color-700\\/30:hover{
  fill: rgba(45, 91, 114, 0.3);
}

.hover\\:fill-story-color-700\\/35:hover{
  fill: rgba(45, 91, 114, 0.35);
}

.hover\\:fill-story-color-700\\/40:hover{
  fill: rgba(45, 91, 114, 0.4);
}

.hover\\:fill-story-color-700\\/45:hover{
  fill: rgba(45, 91, 114, 0.45);
}

.hover\\:fill-story-color-700\\/5:hover{
  fill: rgba(45, 91, 114, 0.05);
}

.hover\\:fill-story-color-700\\/50:hover{
  fill: rgba(45, 91, 114, 0.5);
}

.hover\\:fill-story-color-700\\/55:hover{
  fill: rgba(45, 91, 114, 0.55);
}

.hover\\:fill-story-color-700\\/60:hover{
  fill: rgba(45, 91, 114, 0.6);
}

.hover\\:fill-story-color-700\\/65:hover{
  fill: rgba(45, 91, 114, 0.65);
}

.hover\\:fill-story-color-700\\/70:hover{
  fill: rgba(45, 91, 114, 0.7);
}

.hover\\:fill-story-color-700\\/75:hover{
  fill: rgba(45, 91, 114, 0.75);
}

.hover\\:fill-story-color-700\\/80:hover{
  fill: rgba(45, 91, 114, 0.8);
}

.hover\\:fill-story-color-700\\/85:hover{
  fill: rgba(45, 91, 114, 0.85);
}

.hover\\:fill-story-color-700\\/90:hover{
  fill: rgba(45, 91, 114, 0.9);
}

.hover\\:fill-story-color-700\\/95:hover{
  fill: rgba(45, 91, 114, 0.95);
}

.hover\\:fill-story-color-800:hover{
  fill: #2c4c5e;
}

.hover\\:fill-story-color-800\\/0:hover{
  fill: rgba(44, 76, 94, 0);
}

.hover\\:fill-story-color-800\\/10:hover{
  fill: rgba(44, 76, 94, 0.1);
}

.hover\\:fill-story-color-800\\/100:hover{
  fill: rgb(44, 76, 94);
}

.hover\\:fill-story-color-800\\/15:hover{
  fill: rgba(44, 76, 94, 0.15);
}

.hover\\:fill-story-color-800\\/20:hover{
  fill: rgba(44, 76, 94, 0.2);
}

.hover\\:fill-story-color-800\\/25:hover{
  fill: rgba(44, 76, 94, 0.25);
}

.hover\\:fill-story-color-800\\/30:hover{
  fill: rgba(44, 76, 94, 0.3);
}

.hover\\:fill-story-color-800\\/35:hover{
  fill: rgba(44, 76, 94, 0.35);
}

.hover\\:fill-story-color-800\\/40:hover{
  fill: rgba(44, 76, 94, 0.4);
}

.hover\\:fill-story-color-800\\/45:hover{
  fill: rgba(44, 76, 94, 0.45);
}

.hover\\:fill-story-color-800\\/5:hover{
  fill: rgba(44, 76, 94, 0.05);
}

.hover\\:fill-story-color-800\\/50:hover{
  fill: rgba(44, 76, 94, 0.5);
}

.hover\\:fill-story-color-800\\/55:hover{
  fill: rgba(44, 76, 94, 0.55);
}

.hover\\:fill-story-color-800\\/60:hover{
  fill: rgba(44, 76, 94, 0.6);
}

.hover\\:fill-story-color-800\\/65:hover{
  fill: rgba(44, 76, 94, 0.65);
}

.hover\\:fill-story-color-800\\/70:hover{
  fill: rgba(44, 76, 94, 0.7);
}

.hover\\:fill-story-color-800\\/75:hover{
  fill: rgba(44, 76, 94, 0.75);
}

.hover\\:fill-story-color-800\\/80:hover{
  fill: rgba(44, 76, 94, 0.8);
}

.hover\\:fill-story-color-800\\/85:hover{
  fill: rgba(44, 76, 94, 0.85);
}

.hover\\:fill-story-color-800\\/90:hover{
  fill: rgba(44, 76, 94, 0.9);
}

.hover\\:fill-story-color-800\\/95:hover{
  fill: rgba(44, 76, 94, 0.95);
}

.hover\\:fill-story-color-900:hover{
  fill: #284151;
}

.hover\\:fill-story-color-900\\/0:hover{
  fill: rgba(40, 65, 81, 0);
}

.hover\\:fill-story-color-900\\/10:hover{
  fill: rgba(40, 65, 81, 0.1);
}

.hover\\:fill-story-color-900\\/100:hover{
  fill: rgb(40, 65, 81);
}

.hover\\:fill-story-color-900\\/15:hover{
  fill: rgba(40, 65, 81, 0.15);
}

.hover\\:fill-story-color-900\\/20:hover{
  fill: rgba(40, 65, 81, 0.2);
}

.hover\\:fill-story-color-900\\/25:hover{
  fill: rgba(40, 65, 81, 0.25);
}

.hover\\:fill-story-color-900\\/30:hover{
  fill: rgba(40, 65, 81, 0.3);
}

.hover\\:fill-story-color-900\\/35:hover{
  fill: rgba(40, 65, 81, 0.35);
}

.hover\\:fill-story-color-900\\/40:hover{
  fill: rgba(40, 65, 81, 0.4);
}

.hover\\:fill-story-color-900\\/45:hover{
  fill: rgba(40, 65, 81, 0.45);
}

.hover\\:fill-story-color-900\\/5:hover{
  fill: rgba(40, 65, 81, 0.05);
}

.hover\\:fill-story-color-900\\/50:hover{
  fill: rgba(40, 65, 81, 0.5);
}

.hover\\:fill-story-color-900\\/55:hover{
  fill: rgba(40, 65, 81, 0.55);
}

.hover\\:fill-story-color-900\\/60:hover{
  fill: rgba(40, 65, 81, 0.6);
}

.hover\\:fill-story-color-900\\/65:hover{
  fill: rgba(40, 65, 81, 0.65);
}

.hover\\:fill-story-color-900\\/70:hover{
  fill: rgba(40, 65, 81, 0.7);
}

.hover\\:fill-story-color-900\\/75:hover{
  fill: rgba(40, 65, 81, 0.75);
}

.hover\\:fill-story-color-900\\/80:hover{
  fill: rgba(40, 65, 81, 0.8);
}

.hover\\:fill-story-color-900\\/85:hover{
  fill: rgba(40, 65, 81, 0.85);
}

.hover\\:fill-story-color-900\\/90:hover{
  fill: rgba(40, 65, 81, 0.9);
}

.hover\\:fill-story-color-900\\/95:hover{
  fill: rgba(40, 65, 81, 0.95);
}

.hover\\:fill-story-color-950:hover{
  fill: #162936;
}

.hover\\:fill-story-color-950\\/0:hover{
  fill: rgba(22, 41, 54, 0);
}

.hover\\:fill-story-color-950\\/10:hover{
  fill: rgba(22, 41, 54, 0.1);
}

.hover\\:fill-story-color-950\\/100:hover{
  fill: rgb(22, 41, 54);
}

.hover\\:fill-story-color-950\\/15:hover{
  fill: rgba(22, 41, 54, 0.15);
}

.hover\\:fill-story-color-950\\/20:hover{
  fill: rgba(22, 41, 54, 0.2);
}

.hover\\:fill-story-color-950\\/25:hover{
  fill: rgba(22, 41, 54, 0.25);
}

.hover\\:fill-story-color-950\\/30:hover{
  fill: rgba(22, 41, 54, 0.3);
}

.hover\\:fill-story-color-950\\/35:hover{
  fill: rgba(22, 41, 54, 0.35);
}

.hover\\:fill-story-color-950\\/40:hover{
  fill: rgba(22, 41, 54, 0.4);
}

.hover\\:fill-story-color-950\\/45:hover{
  fill: rgba(22, 41, 54, 0.45);
}

.hover\\:fill-story-color-950\\/5:hover{
  fill: rgba(22, 41, 54, 0.05);
}

.hover\\:fill-story-color-950\\/50:hover{
  fill: rgba(22, 41, 54, 0.5);
}

.hover\\:fill-story-color-950\\/55:hover{
  fill: rgba(22, 41, 54, 0.55);
}

.hover\\:fill-story-color-950\\/60:hover{
  fill: rgba(22, 41, 54, 0.6);
}

.hover\\:fill-story-color-950\\/65:hover{
  fill: rgba(22, 41, 54, 0.65);
}

.hover\\:fill-story-color-950\\/70:hover{
  fill: rgba(22, 41, 54, 0.7);
}

.hover\\:fill-story-color-950\\/75:hover{
  fill: rgba(22, 41, 54, 0.75);
}

.hover\\:fill-story-color-950\\/80:hover{
  fill: rgba(22, 41, 54, 0.8);
}

.hover\\:fill-story-color-950\\/85:hover{
  fill: rgba(22, 41, 54, 0.85);
}

.hover\\:fill-story-color-950\\/90:hover{
  fill: rgba(22, 41, 54, 0.9);
}

.hover\\:fill-story-color-950\\/95:hover{
  fill: rgba(22, 41, 54, 0.95);
}

.hover\\:fill-word-color-100:hover{
  fill: #d9f2e6;
}

.hover\\:fill-word-color-100\\/0:hover{
  fill: rgba(217, 242, 230, 0);
}

.hover\\:fill-word-color-100\\/10:hover{
  fill: rgba(217, 242, 230, 0.1);
}

.hover\\:fill-word-color-100\\/100:hover{
  fill: rgb(217, 242, 230);
}

.hover\\:fill-word-color-100\\/15:hover{
  fill: rgba(217, 242, 230, 0.15);
}

.hover\\:fill-word-color-100\\/20:hover{
  fill: rgba(217, 242, 230, 0.2);
}

.hover\\:fill-word-color-100\\/25:hover{
  fill: rgba(217, 242, 230, 0.25);
}

.hover\\:fill-word-color-100\\/30:hover{
  fill: rgba(217, 242, 230, 0.3);
}

.hover\\:fill-word-color-100\\/35:hover{
  fill: rgba(217, 242, 230, 0.35);
}

.hover\\:fill-word-color-100\\/40:hover{
  fill: rgba(217, 242, 230, 0.4);
}

.hover\\:fill-word-color-100\\/45:hover{
  fill: rgba(217, 242, 230, 0.45);
}

.hover\\:fill-word-color-100\\/5:hover{
  fill: rgba(217, 242, 230, 0.05);
}

.hover\\:fill-word-color-100\\/50:hover{
  fill: rgba(217, 242, 230, 0.5);
}

.hover\\:fill-word-color-100\\/55:hover{
  fill: rgba(217, 242, 230, 0.55);
}

.hover\\:fill-word-color-100\\/60:hover{
  fill: rgba(217, 242, 230, 0.6);
}

.hover\\:fill-word-color-100\\/65:hover{
  fill: rgba(217, 242, 230, 0.65);
}

.hover\\:fill-word-color-100\\/70:hover{
  fill: rgba(217, 242, 230, 0.7);
}

.hover\\:fill-word-color-100\\/75:hover{
  fill: rgba(217, 242, 230, 0.75);
}

.hover\\:fill-word-color-100\\/80:hover{
  fill: rgba(217, 242, 230, 0.8);
}

.hover\\:fill-word-color-100\\/85:hover{
  fill: rgba(217, 242, 230, 0.85);
}

.hover\\:fill-word-color-100\\/90:hover{
  fill: rgba(217, 242, 230, 0.9);
}

.hover\\:fill-word-color-100\\/95:hover{
  fill: rgba(217, 242, 230, 0.95);
}

.hover\\:fill-word-color-200:hover{
  fill: #b6e4d1;
}

.hover\\:fill-word-color-200\\/0:hover{
  fill: rgba(182, 228, 209, 0);
}

.hover\\:fill-word-color-200\\/10:hover{
  fill: rgba(182, 228, 209, 0.1);
}

.hover\\:fill-word-color-200\\/100:hover{
  fill: rgb(182, 228, 209);
}

.hover\\:fill-word-color-200\\/15:hover{
  fill: rgba(182, 228, 209, 0.15);
}

.hover\\:fill-word-color-200\\/20:hover{
  fill: rgba(182, 228, 209, 0.2);
}

.hover\\:fill-word-color-200\\/25:hover{
  fill: rgba(182, 228, 209, 0.25);
}

.hover\\:fill-word-color-200\\/30:hover{
  fill: rgba(182, 228, 209, 0.3);
}

.hover\\:fill-word-color-200\\/35:hover{
  fill: rgba(182, 228, 209, 0.35);
}

.hover\\:fill-word-color-200\\/40:hover{
  fill: rgba(182, 228, 209, 0.4);
}

.hover\\:fill-word-color-200\\/45:hover{
  fill: rgba(182, 228, 209, 0.45);
}

.hover\\:fill-word-color-200\\/5:hover{
  fill: rgba(182, 228, 209, 0.05);
}

.hover\\:fill-word-color-200\\/50:hover{
  fill: rgba(182, 228, 209, 0.5);
}

.hover\\:fill-word-color-200\\/55:hover{
  fill: rgba(182, 228, 209, 0.55);
}

.hover\\:fill-word-color-200\\/60:hover{
  fill: rgba(182, 228, 209, 0.6);
}

.hover\\:fill-word-color-200\\/65:hover{
  fill: rgba(182, 228, 209, 0.65);
}

.hover\\:fill-word-color-200\\/70:hover{
  fill: rgba(182, 228, 209, 0.7);
}

.hover\\:fill-word-color-200\\/75:hover{
  fill: rgba(182, 228, 209, 0.75);
}

.hover\\:fill-word-color-200\\/80:hover{
  fill: rgba(182, 228, 209, 0.8);
}

.hover\\:fill-word-color-200\\/85:hover{
  fill: rgba(182, 228, 209, 0.85);
}

.hover\\:fill-word-color-200\\/90:hover{
  fill: rgba(182, 228, 209, 0.9);
}

.hover\\:fill-word-color-200\\/95:hover{
  fill: rgba(182, 228, 209, 0.95);
}

.hover\\:fill-word-color-300:hover{
  fill: #86cfb5;
}

.hover\\:fill-word-color-300\\/0:hover{
  fill: rgba(134, 207, 181, 0);
}

.hover\\:fill-word-color-300\\/10:hover{
  fill: rgba(134, 207, 181, 0.1);
}

.hover\\:fill-word-color-300\\/100:hover{
  fill: rgb(134, 207, 181);
}

.hover\\:fill-word-color-300\\/15:hover{
  fill: rgba(134, 207, 181, 0.15);
}

.hover\\:fill-word-color-300\\/20:hover{
  fill: rgba(134, 207, 181, 0.2);
}

.hover\\:fill-word-color-300\\/25:hover{
  fill: rgba(134, 207, 181, 0.25);
}

.hover\\:fill-word-color-300\\/30:hover{
  fill: rgba(134, 207, 181, 0.3);
}

.hover\\:fill-word-color-300\\/35:hover{
  fill: rgba(134, 207, 181, 0.35);
}

.hover\\:fill-word-color-300\\/40:hover{
  fill: rgba(134, 207, 181, 0.4);
}

.hover\\:fill-word-color-300\\/45:hover{
  fill: rgba(134, 207, 181, 0.45);
}

.hover\\:fill-word-color-300\\/5:hover{
  fill: rgba(134, 207, 181, 0.05);
}

.hover\\:fill-word-color-300\\/50:hover{
  fill: rgba(134, 207, 181, 0.5);
}

.hover\\:fill-word-color-300\\/55:hover{
  fill: rgba(134, 207, 181, 0.55);
}

.hover\\:fill-word-color-300\\/60:hover{
  fill: rgba(134, 207, 181, 0.6);
}

.hover\\:fill-word-color-300\\/65:hover{
  fill: rgba(134, 207, 181, 0.65);
}

.hover\\:fill-word-color-300\\/70:hover{
  fill: rgba(134, 207, 181, 0.7);
}

.hover\\:fill-word-color-300\\/75:hover{
  fill: rgba(134, 207, 181, 0.75);
}

.hover\\:fill-word-color-300\\/80:hover{
  fill: rgba(134, 207, 181, 0.8);
}

.hover\\:fill-word-color-300\\/85:hover{
  fill: rgba(134, 207, 181, 0.85);
}

.hover\\:fill-word-color-300\\/90:hover{
  fill: rgba(134, 207, 181, 0.9);
}

.hover\\:fill-word-color-300\\/95:hover{
  fill: rgba(134, 207, 181, 0.95);
}

.hover\\:fill-word-color-400:hover{
  fill: #53b494;
}

.hover\\:fill-word-color-400\\/0:hover{
  fill: rgba(83, 180, 148, 0);
}

.hover\\:fill-word-color-400\\/10:hover{
  fill: rgba(83, 180, 148, 0.1);
}

.hover\\:fill-word-color-400\\/100:hover{
  fill: rgb(83, 180, 148);
}

.hover\\:fill-word-color-400\\/15:hover{
  fill: rgba(83, 180, 148, 0.15);
}

.hover\\:fill-word-color-400\\/20:hover{
  fill: rgba(83, 180, 148, 0.2);
}

.hover\\:fill-word-color-400\\/25:hover{
  fill: rgba(83, 180, 148, 0.25);
}

.hover\\:fill-word-color-400\\/30:hover{
  fill: rgba(83, 180, 148, 0.3);
}

.hover\\:fill-word-color-400\\/35:hover{
  fill: rgba(83, 180, 148, 0.35);
}

.hover\\:fill-word-color-400\\/40:hover{
  fill: rgba(83, 180, 148, 0.4);
}

.hover\\:fill-word-color-400\\/45:hover{
  fill: rgba(83, 180, 148, 0.45);
}

.hover\\:fill-word-color-400\\/5:hover{
  fill: rgba(83, 180, 148, 0.05);
}

.hover\\:fill-word-color-400\\/50:hover{
  fill: rgba(83, 180, 148, 0.5);
}

.hover\\:fill-word-color-400\\/55:hover{
  fill: rgba(83, 180, 148, 0.55);
}

.hover\\:fill-word-color-400\\/60:hover{
  fill: rgba(83, 180, 148, 0.6);
}

.hover\\:fill-word-color-400\\/65:hover{
  fill: rgba(83, 180, 148, 0.65);
}

.hover\\:fill-word-color-400\\/70:hover{
  fill: rgba(83, 180, 148, 0.7);
}

.hover\\:fill-word-color-400\\/75:hover{
  fill: rgba(83, 180, 148, 0.75);
}

.hover\\:fill-word-color-400\\/80:hover{
  fill: rgba(83, 180, 148, 0.8);
}

.hover\\:fill-word-color-400\\/85:hover{
  fill: rgba(83, 180, 148, 0.85);
}

.hover\\:fill-word-color-400\\/90:hover{
  fill: rgba(83, 180, 148, 0.9);
}

.hover\\:fill-word-color-400\\/95:hover{
  fill: rgba(83, 180, 148, 0.95);
}

.hover\\:fill-word-color-500:hover{
  fill: #2c876d;
}

.hover\\:fill-word-color-500\\/0:hover{
  fill: rgba(44, 135, 109, 0);
}

.hover\\:fill-word-color-500\\/10:hover{
  fill: rgba(44, 135, 109, 0.1);
}

.hover\\:fill-word-color-500\\/100:hover{
  fill: rgb(44, 135, 109);
}

.hover\\:fill-word-color-500\\/15:hover{
  fill: rgba(44, 135, 109, 0.15);
}

.hover\\:fill-word-color-500\\/20:hover{
  fill: rgba(44, 135, 109, 0.2);
}

.hover\\:fill-word-color-500\\/25:hover{
  fill: rgba(44, 135, 109, 0.25);
}

.hover\\:fill-word-color-500\\/30:hover{
  fill: rgba(44, 135, 109, 0.3);
}

.hover\\:fill-word-color-500\\/35:hover{
  fill: rgba(44, 135, 109, 0.35);
}

.hover\\:fill-word-color-500\\/40:hover{
  fill: rgba(44, 135, 109, 0.4);
}

.hover\\:fill-word-color-500\\/45:hover{
  fill: rgba(44, 135, 109, 0.45);
}

.hover\\:fill-word-color-500\\/5:hover{
  fill: rgba(44, 135, 109, 0.05);
}

.hover\\:fill-word-color-500\\/50:hover{
  fill: rgba(44, 135, 109, 0.5);
}

.hover\\:fill-word-color-500\\/55:hover{
  fill: rgba(44, 135, 109, 0.55);
}

.hover\\:fill-word-color-500\\/60:hover{
  fill: rgba(44, 135, 109, 0.6);
}

.hover\\:fill-word-color-500\\/65:hover{
  fill: rgba(44, 135, 109, 0.65);
}

.hover\\:fill-word-color-500\\/70:hover{
  fill: rgba(44, 135, 109, 0.7);
}

.hover\\:fill-word-color-500\\/75:hover{
  fill: rgba(44, 135, 109, 0.75);
}

.hover\\:fill-word-color-500\\/80:hover{
  fill: rgba(44, 135, 109, 0.8);
}

.hover\\:fill-word-color-500\\/85:hover{
  fill: rgba(44, 135, 109, 0.85);
}

.hover\\:fill-word-color-500\\/90:hover{
  fill: rgba(44, 135, 109, 0.9);
}

.hover\\:fill-word-color-500\\/95:hover{
  fill: rgba(44, 135, 109, 0.95);
}

.hover\\:fill-word-color-600:hover{
  fill: #227962;
}

.hover\\:fill-word-color-600\\/0:hover{
  fill: rgba(34, 121, 98, 0);
}

.hover\\:fill-word-color-600\\/10:hover{
  fill: rgba(34, 121, 98, 0.1);
}

.hover\\:fill-word-color-600\\/100:hover{
  fill: rgb(34, 121, 98);
}

.hover\\:fill-word-color-600\\/15:hover{
  fill: rgba(34, 121, 98, 0.15);
}

.hover\\:fill-word-color-600\\/20:hover{
  fill: rgba(34, 121, 98, 0.2);
}

.hover\\:fill-word-color-600\\/25:hover{
  fill: rgba(34, 121, 98, 0.25);
}

.hover\\:fill-word-color-600\\/30:hover{
  fill: rgba(34, 121, 98, 0.3);
}

.hover\\:fill-word-color-600\\/35:hover{
  fill: rgba(34, 121, 98, 0.35);
}

.hover\\:fill-word-color-600\\/40:hover{
  fill: rgba(34, 121, 98, 0.4);
}

.hover\\:fill-word-color-600\\/45:hover{
  fill: rgba(34, 121, 98, 0.45);
}

.hover\\:fill-word-color-600\\/5:hover{
  fill: rgba(34, 121, 98, 0.05);
}

.hover\\:fill-word-color-600\\/50:hover{
  fill: rgba(34, 121, 98, 0.5);
}

.hover\\:fill-word-color-600\\/55:hover{
  fill: rgba(34, 121, 98, 0.55);
}

.hover\\:fill-word-color-600\\/60:hover{
  fill: rgba(34, 121, 98, 0.6);
}

.hover\\:fill-word-color-600\\/65:hover{
  fill: rgba(34, 121, 98, 0.65);
}

.hover\\:fill-word-color-600\\/70:hover{
  fill: rgba(34, 121, 98, 0.7);
}

.hover\\:fill-word-color-600\\/75:hover{
  fill: rgba(34, 121, 98, 0.75);
}

.hover\\:fill-word-color-600\\/80:hover{
  fill: rgba(34, 121, 98, 0.8);
}

.hover\\:fill-word-color-600\\/85:hover{
  fill: rgba(34, 121, 98, 0.85);
}

.hover\\:fill-word-color-600\\/90:hover{
  fill: rgba(34, 121, 98, 0.9);
}

.hover\\:fill-word-color-600\\/95:hover{
  fill: rgba(34, 121, 98, 0.95);
}

.hover\\:fill-word-color-700:hover{
  fill: #1b6150;
}

.hover\\:fill-word-color-700\\/0:hover{
  fill: rgba(27, 97, 80, 0);
}

.hover\\:fill-word-color-700\\/10:hover{
  fill: rgba(27, 97, 80, 0.1);
}

.hover\\:fill-word-color-700\\/100:hover{
  fill: rgb(27, 97, 80);
}

.hover\\:fill-word-color-700\\/15:hover{
  fill: rgba(27, 97, 80, 0.15);
}

.hover\\:fill-word-color-700\\/20:hover{
  fill: rgba(27, 97, 80, 0.2);
}

.hover\\:fill-word-color-700\\/25:hover{
  fill: rgba(27, 97, 80, 0.25);
}

.hover\\:fill-word-color-700\\/30:hover{
  fill: rgba(27, 97, 80, 0.3);
}

.hover\\:fill-word-color-700\\/35:hover{
  fill: rgba(27, 97, 80, 0.35);
}

.hover\\:fill-word-color-700\\/40:hover{
  fill: rgba(27, 97, 80, 0.4);
}

.hover\\:fill-word-color-700\\/45:hover{
  fill: rgba(27, 97, 80, 0.45);
}

.hover\\:fill-word-color-700\\/5:hover{
  fill: rgba(27, 97, 80, 0.05);
}

.hover\\:fill-word-color-700\\/50:hover{
  fill: rgba(27, 97, 80, 0.5);
}

.hover\\:fill-word-color-700\\/55:hover{
  fill: rgba(27, 97, 80, 0.55);
}

.hover\\:fill-word-color-700\\/60:hover{
  fill: rgba(27, 97, 80, 0.6);
}

.hover\\:fill-word-color-700\\/65:hover{
  fill: rgba(27, 97, 80, 0.65);
}

.hover\\:fill-word-color-700\\/70:hover{
  fill: rgba(27, 97, 80, 0.7);
}

.hover\\:fill-word-color-700\\/75:hover{
  fill: rgba(27, 97, 80, 0.75);
}

.hover\\:fill-word-color-700\\/80:hover{
  fill: rgba(27, 97, 80, 0.8);
}

.hover\\:fill-word-color-700\\/85:hover{
  fill: rgba(27, 97, 80, 0.85);
}

.hover\\:fill-word-color-700\\/90:hover{
  fill: rgba(27, 97, 80, 0.9);
}

.hover\\:fill-word-color-700\\/95:hover{
  fill: rgba(27, 97, 80, 0.95);
}

.hover\\:fill-word-color-800:hover{
  fill: #184d40;
}

.hover\\:fill-word-color-800\\/0:hover{
  fill: rgba(24, 77, 64, 0);
}

.hover\\:fill-word-color-800\\/10:hover{
  fill: rgba(24, 77, 64, 0.1);
}

.hover\\:fill-word-color-800\\/100:hover{
  fill: rgb(24, 77, 64);
}

.hover\\:fill-word-color-800\\/15:hover{
  fill: rgba(24, 77, 64, 0.15);
}

.hover\\:fill-word-color-800\\/20:hover{
  fill: rgba(24, 77, 64, 0.2);
}

.hover\\:fill-word-color-800\\/25:hover{
  fill: rgba(24, 77, 64, 0.25);
}

.hover\\:fill-word-color-800\\/30:hover{
  fill: rgba(24, 77, 64, 0.3);
}

.hover\\:fill-word-color-800\\/35:hover{
  fill: rgba(24, 77, 64, 0.35);
}

.hover\\:fill-word-color-800\\/40:hover{
  fill: rgba(24, 77, 64, 0.4);
}

.hover\\:fill-word-color-800\\/45:hover{
  fill: rgba(24, 77, 64, 0.45);
}

.hover\\:fill-word-color-800\\/5:hover{
  fill: rgba(24, 77, 64, 0.05);
}

.hover\\:fill-word-color-800\\/50:hover{
  fill: rgba(24, 77, 64, 0.5);
}

.hover\\:fill-word-color-800\\/55:hover{
  fill: rgba(24, 77, 64, 0.55);
}

.hover\\:fill-word-color-800\\/60:hover{
  fill: rgba(24, 77, 64, 0.6);
}

.hover\\:fill-word-color-800\\/65:hover{
  fill: rgba(24, 77, 64, 0.65);
}

.hover\\:fill-word-color-800\\/70:hover{
  fill: rgba(24, 77, 64, 0.7);
}

.hover\\:fill-word-color-800\\/75:hover{
  fill: rgba(24, 77, 64, 0.75);
}

.hover\\:fill-word-color-800\\/80:hover{
  fill: rgba(24, 77, 64, 0.8);
}

.hover\\:fill-word-color-800\\/85:hover{
  fill: rgba(24, 77, 64, 0.85);
}

.hover\\:fill-word-color-800\\/90:hover{
  fill: rgba(24, 77, 64, 0.9);
}

.hover\\:fill-word-color-800\\/95:hover{
  fill: rgba(24, 77, 64, 0.95);
}

.hover\\:fill-word-color-900:hover{
  fill: #144036;
}

.hover\\:fill-word-color-900\\/0:hover{
  fill: rgba(20, 64, 54, 0);
}

.hover\\:fill-word-color-900\\/10:hover{
  fill: rgba(20, 64, 54, 0.1);
}

.hover\\:fill-word-color-900\\/100:hover{
  fill: rgb(20, 64, 54);
}

.hover\\:fill-word-color-900\\/15:hover{
  fill: rgba(20, 64, 54, 0.15);
}

.hover\\:fill-word-color-900\\/20:hover{
  fill: rgba(20, 64, 54, 0.2);
}

.hover\\:fill-word-color-900\\/25:hover{
  fill: rgba(20, 64, 54, 0.25);
}

.hover\\:fill-word-color-900\\/30:hover{
  fill: rgba(20, 64, 54, 0.3);
}

.hover\\:fill-word-color-900\\/35:hover{
  fill: rgba(20, 64, 54, 0.35);
}

.hover\\:fill-word-color-900\\/40:hover{
  fill: rgba(20, 64, 54, 0.4);
}

.hover\\:fill-word-color-900\\/45:hover{
  fill: rgba(20, 64, 54, 0.45);
}

.hover\\:fill-word-color-900\\/5:hover{
  fill: rgba(20, 64, 54, 0.05);
}

.hover\\:fill-word-color-900\\/50:hover{
  fill: rgba(20, 64, 54, 0.5);
}

.hover\\:fill-word-color-900\\/55:hover{
  fill: rgba(20, 64, 54, 0.55);
}

.hover\\:fill-word-color-900\\/60:hover{
  fill: rgba(20, 64, 54, 0.6);
}

.hover\\:fill-word-color-900\\/65:hover{
  fill: rgba(20, 64, 54, 0.65);
}

.hover\\:fill-word-color-900\\/70:hover{
  fill: rgba(20, 64, 54, 0.7);
}

.hover\\:fill-word-color-900\\/75:hover{
  fill: rgba(20, 64, 54, 0.75);
}

.hover\\:fill-word-color-900\\/80:hover{
  fill: rgba(20, 64, 54, 0.8);
}

.hover\\:fill-word-color-900\\/85:hover{
  fill: rgba(20, 64, 54, 0.85);
}

.hover\\:fill-word-color-900\\/90:hover{
  fill: rgba(20, 64, 54, 0.9);
}

.hover\\:fill-word-color-900\\/95:hover{
  fill: rgba(20, 64, 54, 0.95);
}

.hover\\:fill-word-color-950:hover{
  fill: #0a241f;
}

.hover\\:fill-word-color-950\\/0:hover{
  fill: rgba(10, 36, 31, 0);
}

.hover\\:fill-word-color-950\\/10:hover{
  fill: rgba(10, 36, 31, 0.1);
}

.hover\\:fill-word-color-950\\/100:hover{
  fill: rgb(10, 36, 31);
}

.hover\\:fill-word-color-950\\/15:hover{
  fill: rgba(10, 36, 31, 0.15);
}

.hover\\:fill-word-color-950\\/20:hover{
  fill: rgba(10, 36, 31, 0.2);
}

.hover\\:fill-word-color-950\\/25:hover{
  fill: rgba(10, 36, 31, 0.25);
}

.hover\\:fill-word-color-950\\/30:hover{
  fill: rgba(10, 36, 31, 0.3);
}

.hover\\:fill-word-color-950\\/35:hover{
  fill: rgba(10, 36, 31, 0.35);
}

.hover\\:fill-word-color-950\\/40:hover{
  fill: rgba(10, 36, 31, 0.4);
}

.hover\\:fill-word-color-950\\/45:hover{
  fill: rgba(10, 36, 31, 0.45);
}

.hover\\:fill-word-color-950\\/5:hover{
  fill: rgba(10, 36, 31, 0.05);
}

.hover\\:fill-word-color-950\\/50:hover{
  fill: rgba(10, 36, 31, 0.5);
}

.hover\\:fill-word-color-950\\/55:hover{
  fill: rgba(10, 36, 31, 0.55);
}

.hover\\:fill-word-color-950\\/60:hover{
  fill: rgba(10, 36, 31, 0.6);
}

.hover\\:fill-word-color-950\\/65:hover{
  fill: rgba(10, 36, 31, 0.65);
}

.hover\\:fill-word-color-950\\/70:hover{
  fill: rgba(10, 36, 31, 0.7);
}

.hover\\:fill-word-color-950\\/75:hover{
  fill: rgba(10, 36, 31, 0.75);
}

.hover\\:fill-word-color-950\\/80:hover{
  fill: rgba(10, 36, 31, 0.8);
}

.hover\\:fill-word-color-950\\/85:hover{
  fill: rgba(10, 36, 31, 0.85);
}

.hover\\:fill-word-color-950\\/90:hover{
  fill: rgba(10, 36, 31, 0.9);
}

.hover\\:fill-word-color-950\\/95:hover{
  fill: rgba(10, 36, 31, 0.95);
}

.hover\\:text-blumine-100:hover{
  --tw-text-opacity: 1;
  color: rgba(218, 238, 243, 1);
  color: rgba(218, 238, 243, var(--tw-text-opacity, 1));
}

.hover\\:text-blumine-100\\/0:hover{
  color: rgba(218, 238, 243, 0);
}

.hover\\:text-blumine-100\\/10:hover{
  color: rgba(218, 238, 243, 0.1);
}

.hover\\:text-blumine-100\\/100:hover{
  color: rgb(218, 238, 243);
}

.hover\\:text-blumine-100\\/15:hover{
  color: rgba(218, 238, 243, 0.15);
}

.hover\\:text-blumine-100\\/20:hover{
  color: rgba(218, 238, 243, 0.2);
}

.hover\\:text-blumine-100\\/25:hover{
  color: rgba(218, 238, 243, 0.25);
}

.hover\\:text-blumine-100\\/30:hover{
  color: rgba(218, 238, 243, 0.3);
}

.hover\\:text-blumine-100\\/35:hover{
  color: rgba(218, 238, 243, 0.35);
}

.hover\\:text-blumine-100\\/40:hover{
  color: rgba(218, 238, 243, 0.4);
}

.hover\\:text-blumine-100\\/45:hover{
  color: rgba(218, 238, 243, 0.45);
}

.hover\\:text-blumine-100\\/5:hover{
  color: rgba(218, 238, 243, 0.05);
}

.hover\\:text-blumine-100\\/50:hover{
  color: rgba(218, 238, 243, 0.5);
}

.hover\\:text-blumine-100\\/55:hover{
  color: rgba(218, 238, 243, 0.55);
}

.hover\\:text-blumine-100\\/60:hover{
  color: rgba(218, 238, 243, 0.6);
}

.hover\\:text-blumine-100\\/65:hover{
  color: rgba(218, 238, 243, 0.65);
}

.hover\\:text-blumine-100\\/70:hover{
  color: rgba(218, 238, 243, 0.7);
}

.hover\\:text-blumine-100\\/75:hover{
  color: rgba(218, 238, 243, 0.75);
}

.hover\\:text-blumine-100\\/80:hover{
  color: rgba(218, 238, 243, 0.8);
}

.hover\\:text-blumine-100\\/85:hover{
  color: rgba(218, 238, 243, 0.85);
}

.hover\\:text-blumine-100\\/90:hover{
  color: rgba(218, 238, 243, 0.9);
}

.hover\\:text-blumine-100\\/95:hover{
  color: rgba(218, 238, 243, 0.95);
}

.hover\\:text-blumine-200:hover{
  --tw-text-opacity: 1;
  color: rgba(186, 222, 231, 1);
  color: rgba(186, 222, 231, var(--tw-text-opacity, 1));
}

.hover\\:text-blumine-200\\/0:hover{
  color: rgba(186, 222, 231, 0);
}

.hover\\:text-blumine-200\\/10:hover{
  color: rgba(186, 222, 231, 0.1);
}

.hover\\:text-blumine-200\\/100:hover{
  color: rgb(186, 222, 231);
}

.hover\\:text-blumine-200\\/15:hover{
  color: rgba(186, 222, 231, 0.15);
}

.hover\\:text-blumine-200\\/20:hover{
  color: rgba(186, 222, 231, 0.2);
}

.hover\\:text-blumine-200\\/25:hover{
  color: rgba(186, 222, 231, 0.25);
}

.hover\\:text-blumine-200\\/30:hover{
  color: rgba(186, 222, 231, 0.3);
}

.hover\\:text-blumine-200\\/35:hover{
  color: rgba(186, 222, 231, 0.35);
}

.hover\\:text-blumine-200\\/40:hover{
  color: rgba(186, 222, 231, 0.4);
}

.hover\\:text-blumine-200\\/45:hover{
  color: rgba(186, 222, 231, 0.45);
}

.hover\\:text-blumine-200\\/5:hover{
  color: rgba(186, 222, 231, 0.05);
}

.hover\\:text-blumine-200\\/50:hover{
  color: rgba(186, 222, 231, 0.5);
}

.hover\\:text-blumine-200\\/55:hover{
  color: rgba(186, 222, 231, 0.55);
}

.hover\\:text-blumine-200\\/60:hover{
  color: rgba(186, 222, 231, 0.6);
}

.hover\\:text-blumine-200\\/65:hover{
  color: rgba(186, 222, 231, 0.65);
}

.hover\\:text-blumine-200\\/70:hover{
  color: rgba(186, 222, 231, 0.7);
}

.hover\\:text-blumine-200\\/75:hover{
  color: rgba(186, 222, 231, 0.75);
}

.hover\\:text-blumine-200\\/80:hover{
  color: rgba(186, 222, 231, 0.8);
}

.hover\\:text-blumine-200\\/85:hover{
  color: rgba(186, 222, 231, 0.85);
}

.hover\\:text-blumine-200\\/90:hover{
  color: rgba(186, 222, 231, 0.9);
}

.hover\\:text-blumine-200\\/95:hover{
  color: rgba(186, 222, 231, 0.95);
}

.hover\\:text-blumine-300:hover{
  --tw-text-opacity: 1;
  color: rgba(137, 197, 215, 1);
  color: rgba(137, 197, 215, var(--tw-text-opacity, 1));
}

.hover\\:text-blumine-300\\/0:hover{
  color: rgba(137, 197, 215, 0);
}

.hover\\:text-blumine-300\\/10:hover{
  color: rgba(137, 197, 215, 0.1);
}

.hover\\:text-blumine-300\\/100:hover{
  color: rgb(137, 197, 215);
}

.hover\\:text-blumine-300\\/15:hover{
  color: rgba(137, 197, 215, 0.15);
}

.hover\\:text-blumine-300\\/20:hover{
  color: rgba(137, 197, 215, 0.2);
}

.hover\\:text-blumine-300\\/25:hover{
  color: rgba(137, 197, 215, 0.25);
}

.hover\\:text-blumine-300\\/30:hover{
  color: rgba(137, 197, 215, 0.3);
}

.hover\\:text-blumine-300\\/35:hover{
  color: rgba(137, 197, 215, 0.35);
}

.hover\\:text-blumine-300\\/40:hover{
  color: rgba(137, 197, 215, 0.4);
}

.hover\\:text-blumine-300\\/45:hover{
  color: rgba(137, 197, 215, 0.45);
}

.hover\\:text-blumine-300\\/5:hover{
  color: rgba(137, 197, 215, 0.05);
}

.hover\\:text-blumine-300\\/50:hover{
  color: rgba(137, 197, 215, 0.5);
}

.hover\\:text-blumine-300\\/55:hover{
  color: rgba(137, 197, 215, 0.55);
}

.hover\\:text-blumine-300\\/60:hover{
  color: rgba(137, 197, 215, 0.6);
}

.hover\\:text-blumine-300\\/65:hover{
  color: rgba(137, 197, 215, 0.65);
}

.hover\\:text-blumine-300\\/70:hover{
  color: rgba(137, 197, 215, 0.7);
}

.hover\\:text-blumine-300\\/75:hover{
  color: rgba(137, 197, 215, 0.75);
}

.hover\\:text-blumine-300\\/80:hover{
  color: rgba(137, 197, 215, 0.8);
}

.hover\\:text-blumine-300\\/85:hover{
  color: rgba(137, 197, 215, 0.85);
}

.hover\\:text-blumine-300\\/90:hover{
  color: rgba(137, 197, 215, 0.9);
}

.hover\\:text-blumine-300\\/95:hover{
  color: rgba(137, 197, 215, 0.95);
}

.hover\\:text-blumine-400:hover{
  --tw-text-opacity: 1;
  color: rgba(82, 163, 190, 1);
  color: rgba(82, 163, 190, var(--tw-text-opacity, 1));
}

.hover\\:text-blumine-400\\/0:hover{
  color: rgba(82, 163, 190, 0);
}

.hover\\:text-blumine-400\\/10:hover{
  color: rgba(82, 163, 190, 0.1);
}

.hover\\:text-blumine-400\\/100:hover{
  color: rgb(82, 163, 190);
}

.hover\\:text-blumine-400\\/15:hover{
  color: rgba(82, 163, 190, 0.15);
}

.hover\\:text-blumine-400\\/20:hover{
  color: rgba(82, 163, 190, 0.2);
}

.hover\\:text-blumine-400\\/25:hover{
  color: rgba(82, 163, 190, 0.25);
}

.hover\\:text-blumine-400\\/30:hover{
  color: rgba(82, 163, 190, 0.3);
}

.hover\\:text-blumine-400\\/35:hover{
  color: rgba(82, 163, 190, 0.35);
}

.hover\\:text-blumine-400\\/40:hover{
  color: rgba(82, 163, 190, 0.4);
}

.hover\\:text-blumine-400\\/45:hover{
  color: rgba(82, 163, 190, 0.45);
}

.hover\\:text-blumine-400\\/5:hover{
  color: rgba(82, 163, 190, 0.05);
}

.hover\\:text-blumine-400\\/50:hover{
  color: rgba(82, 163, 190, 0.5);
}

.hover\\:text-blumine-400\\/55:hover{
  color: rgba(82, 163, 190, 0.55);
}

.hover\\:text-blumine-400\\/60:hover{
  color: rgba(82, 163, 190, 0.6);
}

.hover\\:text-blumine-400\\/65:hover{
  color: rgba(82, 163, 190, 0.65);
}

.hover\\:text-blumine-400\\/70:hover{
  color: rgba(82, 163, 190, 0.7);
}

.hover\\:text-blumine-400\\/75:hover{
  color: rgba(82, 163, 190, 0.75);
}

.hover\\:text-blumine-400\\/80:hover{
  color: rgba(82, 163, 190, 0.8);
}

.hover\\:text-blumine-400\\/85:hover{
  color: rgba(82, 163, 190, 0.85);
}

.hover\\:text-blumine-400\\/90:hover{
  color: rgba(82, 163, 190, 0.9);
}

.hover\\:text-blumine-400\\/95:hover{
  color: rgba(82, 163, 190, 0.95);
}

.hover\\:text-blumine-500:hover{
  --tw-text-opacity: 1;
  color: rgba(55, 135, 163, 1);
  color: rgba(55, 135, 163, var(--tw-text-opacity, 1));
}

.hover\\:text-blumine-500\\/0:hover{
  color: rgba(55, 135, 163, 0);
}

.hover\\:text-blumine-500\\/10:hover{
  color: rgba(55, 135, 163, 0.1);
}

.hover\\:text-blumine-500\\/100:hover{
  color: rgb(55, 135, 163);
}

.hover\\:text-blumine-500\\/15:hover{
  color: rgba(55, 135, 163, 0.15);
}

.hover\\:text-blumine-500\\/20:hover{
  color: rgba(55, 135, 163, 0.2);
}

.hover\\:text-blumine-500\\/25:hover{
  color: rgba(55, 135, 163, 0.25);
}

.hover\\:text-blumine-500\\/30:hover{
  color: rgba(55, 135, 163, 0.3);
}

.hover\\:text-blumine-500\\/35:hover{
  color: rgba(55, 135, 163, 0.35);
}

.hover\\:text-blumine-500\\/40:hover{
  color: rgba(55, 135, 163, 0.4);
}

.hover\\:text-blumine-500\\/45:hover{
  color: rgba(55, 135, 163, 0.45);
}

.hover\\:text-blumine-500\\/5:hover{
  color: rgba(55, 135, 163, 0.05);
}

.hover\\:text-blumine-500\\/50:hover{
  color: rgba(55, 135, 163, 0.5);
}

.hover\\:text-blumine-500\\/55:hover{
  color: rgba(55, 135, 163, 0.55);
}

.hover\\:text-blumine-500\\/60:hover{
  color: rgba(55, 135, 163, 0.6);
}

.hover\\:text-blumine-500\\/65:hover{
  color: rgba(55, 135, 163, 0.65);
}

.hover\\:text-blumine-500\\/70:hover{
  color: rgba(55, 135, 163, 0.7);
}

.hover\\:text-blumine-500\\/75:hover{
  color: rgba(55, 135, 163, 0.75);
}

.hover\\:text-blumine-500\\/80:hover{
  color: rgba(55, 135, 163, 0.8);
}

.hover\\:text-blumine-500\\/85:hover{
  color: rgba(55, 135, 163, 0.85);
}

.hover\\:text-blumine-500\\/90:hover{
  color: rgba(55, 135, 163, 0.9);
}

.hover\\:text-blumine-500\\/95:hover{
  color: rgba(55, 135, 163, 0.95);
}

.hover\\:text-blumine-600:hover{
  --tw-text-opacity: 1;
  color: rgba(48, 109, 138, 1);
  color: rgba(48, 109, 138, var(--tw-text-opacity, 1));
}

.hover\\:text-blumine-600\\/0:hover{
  color: rgba(48, 109, 138, 0);
}

.hover\\:text-blumine-600\\/10:hover{
  color: rgba(48, 109, 138, 0.1);
}

.hover\\:text-blumine-600\\/100:hover{
  color: rgb(48, 109, 138);
}

.hover\\:text-blumine-600\\/15:hover{
  color: rgba(48, 109, 138, 0.15);
}

.hover\\:text-blumine-600\\/20:hover{
  color: rgba(48, 109, 138, 0.2);
}

.hover\\:text-blumine-600\\/25:hover{
  color: rgba(48, 109, 138, 0.25);
}

.hover\\:text-blumine-600\\/30:hover{
  color: rgba(48, 109, 138, 0.3);
}

.hover\\:text-blumine-600\\/35:hover{
  color: rgba(48, 109, 138, 0.35);
}

.hover\\:text-blumine-600\\/40:hover{
  color: rgba(48, 109, 138, 0.4);
}

.hover\\:text-blumine-600\\/45:hover{
  color: rgba(48, 109, 138, 0.45);
}

.hover\\:text-blumine-600\\/5:hover{
  color: rgba(48, 109, 138, 0.05);
}

.hover\\:text-blumine-600\\/50:hover{
  color: rgba(48, 109, 138, 0.5);
}

.hover\\:text-blumine-600\\/55:hover{
  color: rgba(48, 109, 138, 0.55);
}

.hover\\:text-blumine-600\\/60:hover{
  color: rgba(48, 109, 138, 0.6);
}

.hover\\:text-blumine-600\\/65:hover{
  color: rgba(48, 109, 138, 0.65);
}

.hover\\:text-blumine-600\\/70:hover{
  color: rgba(48, 109, 138, 0.7);
}

.hover\\:text-blumine-600\\/75:hover{
  color: rgba(48, 109, 138, 0.75);
}

.hover\\:text-blumine-600\\/80:hover{
  color: rgba(48, 109, 138, 0.8);
}

.hover\\:text-blumine-600\\/85:hover{
  color: rgba(48, 109, 138, 0.85);
}

.hover\\:text-blumine-600\\/90:hover{
  color: rgba(48, 109, 138, 0.9);
}

.hover\\:text-blumine-600\\/95:hover{
  color: rgba(48, 109, 138, 0.95);
}

.hover\\:text-blumine-700:hover{
  --tw-text-opacity: 1;
  color: rgba(45, 91, 114, 1);
  color: rgba(45, 91, 114, var(--tw-text-opacity, 1));
}

.hover\\:text-blumine-700\\/0:hover{
  color: rgba(45, 91, 114, 0);
}

.hover\\:text-blumine-700\\/10:hover{
  color: rgba(45, 91, 114, 0.1);
}

.hover\\:text-blumine-700\\/100:hover{
  color: rgb(45, 91, 114);
}

.hover\\:text-blumine-700\\/15:hover{
  color: rgba(45, 91, 114, 0.15);
}

.hover\\:text-blumine-700\\/20:hover{
  color: rgba(45, 91, 114, 0.2);
}

.hover\\:text-blumine-700\\/25:hover{
  color: rgba(45, 91, 114, 0.25);
}

.hover\\:text-blumine-700\\/30:hover{
  color: rgba(45, 91, 114, 0.3);
}

.hover\\:text-blumine-700\\/35:hover{
  color: rgba(45, 91, 114, 0.35);
}

.hover\\:text-blumine-700\\/40:hover{
  color: rgba(45, 91, 114, 0.4);
}

.hover\\:text-blumine-700\\/45:hover{
  color: rgba(45, 91, 114, 0.45);
}

.hover\\:text-blumine-700\\/5:hover{
  color: rgba(45, 91, 114, 0.05);
}

.hover\\:text-blumine-700\\/50:hover{
  color: rgba(45, 91, 114, 0.5);
}

.hover\\:text-blumine-700\\/55:hover{
  color: rgba(45, 91, 114, 0.55);
}

.hover\\:text-blumine-700\\/60:hover{
  color: rgba(45, 91, 114, 0.6);
}

.hover\\:text-blumine-700\\/65:hover{
  color: rgba(45, 91, 114, 0.65);
}

.hover\\:text-blumine-700\\/70:hover{
  color: rgba(45, 91, 114, 0.7);
}

.hover\\:text-blumine-700\\/75:hover{
  color: rgba(45, 91, 114, 0.75);
}

.hover\\:text-blumine-700\\/80:hover{
  color: rgba(45, 91, 114, 0.8);
}

.hover\\:text-blumine-700\\/85:hover{
  color: rgba(45, 91, 114, 0.85);
}

.hover\\:text-blumine-700\\/90:hover{
  color: rgba(45, 91, 114, 0.9);
}

.hover\\:text-blumine-700\\/95:hover{
  color: rgba(45, 91, 114, 0.95);
}

.hover\\:text-blumine-800:hover{
  --tw-text-opacity: 1;
  color: rgba(44, 76, 94, 1);
  color: rgba(44, 76, 94, var(--tw-text-opacity, 1));
}

.hover\\:text-blumine-800\\/0:hover{
  color: rgba(44, 76, 94, 0);
}

.hover\\:text-blumine-800\\/10:hover{
  color: rgba(44, 76, 94, 0.1);
}

.hover\\:text-blumine-800\\/100:hover{
  color: rgb(44, 76, 94);
}

.hover\\:text-blumine-800\\/15:hover{
  color: rgba(44, 76, 94, 0.15);
}

.hover\\:text-blumine-800\\/20:hover{
  color: rgba(44, 76, 94, 0.2);
}

.hover\\:text-blumine-800\\/25:hover{
  color: rgba(44, 76, 94, 0.25);
}

.hover\\:text-blumine-800\\/30:hover{
  color: rgba(44, 76, 94, 0.3);
}

.hover\\:text-blumine-800\\/35:hover{
  color: rgba(44, 76, 94, 0.35);
}

.hover\\:text-blumine-800\\/40:hover{
  color: rgba(44, 76, 94, 0.4);
}

.hover\\:text-blumine-800\\/45:hover{
  color: rgba(44, 76, 94, 0.45);
}

.hover\\:text-blumine-800\\/5:hover{
  color: rgba(44, 76, 94, 0.05);
}

.hover\\:text-blumine-800\\/50:hover{
  color: rgba(44, 76, 94, 0.5);
}

.hover\\:text-blumine-800\\/55:hover{
  color: rgba(44, 76, 94, 0.55);
}

.hover\\:text-blumine-800\\/60:hover{
  color: rgba(44, 76, 94, 0.6);
}

.hover\\:text-blumine-800\\/65:hover{
  color: rgba(44, 76, 94, 0.65);
}

.hover\\:text-blumine-800\\/70:hover{
  color: rgba(44, 76, 94, 0.7);
}

.hover\\:text-blumine-800\\/75:hover{
  color: rgba(44, 76, 94, 0.75);
}

.hover\\:text-blumine-800\\/80:hover{
  color: rgba(44, 76, 94, 0.8);
}

.hover\\:text-blumine-800\\/85:hover{
  color: rgba(44, 76, 94, 0.85);
}

.hover\\:text-blumine-800\\/90:hover{
  color: rgba(44, 76, 94, 0.9);
}

.hover\\:text-blumine-800\\/95:hover{
  color: rgba(44, 76, 94, 0.95);
}

.hover\\:text-blumine-900:hover{
  --tw-text-opacity: 1;
  color: rgba(40, 65, 81, 1);
  color: rgba(40, 65, 81, var(--tw-text-opacity, 1));
}

.hover\\:text-blumine-900\\/0:hover{
  color: rgba(40, 65, 81, 0);
}

.hover\\:text-blumine-900\\/10:hover{
  color: rgba(40, 65, 81, 0.1);
}

.hover\\:text-blumine-900\\/100:hover{
  color: rgb(40, 65, 81);
}

.hover\\:text-blumine-900\\/15:hover{
  color: rgba(40, 65, 81, 0.15);
}

.hover\\:text-blumine-900\\/20:hover{
  color: rgba(40, 65, 81, 0.2);
}

.hover\\:text-blumine-900\\/25:hover{
  color: rgba(40, 65, 81, 0.25);
}

.hover\\:text-blumine-900\\/30:hover{
  color: rgba(40, 65, 81, 0.3);
}

.hover\\:text-blumine-900\\/35:hover{
  color: rgba(40, 65, 81, 0.35);
}

.hover\\:text-blumine-900\\/40:hover{
  color: rgba(40, 65, 81, 0.4);
}

.hover\\:text-blumine-900\\/45:hover{
  color: rgba(40, 65, 81, 0.45);
}

.hover\\:text-blumine-900\\/5:hover{
  color: rgba(40, 65, 81, 0.05);
}

.hover\\:text-blumine-900\\/50:hover{
  color: rgba(40, 65, 81, 0.5);
}

.hover\\:text-blumine-900\\/55:hover{
  color: rgba(40, 65, 81, 0.55);
}

.hover\\:text-blumine-900\\/60:hover{
  color: rgba(40, 65, 81, 0.6);
}

.hover\\:text-blumine-900\\/65:hover{
  color: rgba(40, 65, 81, 0.65);
}

.hover\\:text-blumine-900\\/70:hover{
  color: rgba(40, 65, 81, 0.7);
}

.hover\\:text-blumine-900\\/75:hover{
  color: rgba(40, 65, 81, 0.75);
}

.hover\\:text-blumine-900\\/80:hover{
  color: rgba(40, 65, 81, 0.8);
}

.hover\\:text-blumine-900\\/85:hover{
  color: rgba(40, 65, 81, 0.85);
}

.hover\\:text-blumine-900\\/90:hover{
  color: rgba(40, 65, 81, 0.9);
}

.hover\\:text-blumine-900\\/95:hover{
  color: rgba(40, 65, 81, 0.95);
}

.hover\\:text-blumine-950:hover{
  --tw-text-opacity: 1;
  color: rgba(22, 41, 54, 1);
  color: rgba(22, 41, 54, var(--tw-text-opacity, 1));
}

.hover\\:text-blumine-950\\/0:hover{
  color: rgba(22, 41, 54, 0);
}

.hover\\:text-blumine-950\\/10:hover{
  color: rgba(22, 41, 54, 0.1);
}

.hover\\:text-blumine-950\\/100:hover{
  color: rgb(22, 41, 54);
}

.hover\\:text-blumine-950\\/15:hover{
  color: rgba(22, 41, 54, 0.15);
}

.hover\\:text-blumine-950\\/20:hover{
  color: rgba(22, 41, 54, 0.2);
}

.hover\\:text-blumine-950\\/25:hover{
  color: rgba(22, 41, 54, 0.25);
}

.hover\\:text-blumine-950\\/30:hover{
  color: rgba(22, 41, 54, 0.3);
}

.hover\\:text-blumine-950\\/35:hover{
  color: rgba(22, 41, 54, 0.35);
}

.hover\\:text-blumine-950\\/40:hover{
  color: rgba(22, 41, 54, 0.4);
}

.hover\\:text-blumine-950\\/45:hover{
  color: rgba(22, 41, 54, 0.45);
}

.hover\\:text-blumine-950\\/5:hover{
  color: rgba(22, 41, 54, 0.05);
}

.hover\\:text-blumine-950\\/50:hover{
  color: rgba(22, 41, 54, 0.5);
}

.hover\\:text-blumine-950\\/55:hover{
  color: rgba(22, 41, 54, 0.55);
}

.hover\\:text-blumine-950\\/60:hover{
  color: rgba(22, 41, 54, 0.6);
}

.hover\\:text-blumine-950\\/65:hover{
  color: rgba(22, 41, 54, 0.65);
}

.hover\\:text-blumine-950\\/70:hover{
  color: rgba(22, 41, 54, 0.7);
}

.hover\\:text-blumine-950\\/75:hover{
  color: rgba(22, 41, 54, 0.75);
}

.hover\\:text-blumine-950\\/80:hover{
  color: rgba(22, 41, 54, 0.8);
}

.hover\\:text-blumine-950\\/85:hover{
  color: rgba(22, 41, 54, 0.85);
}

.hover\\:text-blumine-950\\/90:hover{
  color: rgba(22, 41, 54, 0.9);
}

.hover\\:text-blumine-950\\/95:hover{
  color: rgba(22, 41, 54, 0.95);
}

.hover\\:text-charcoal-100:hover{
  --tw-text-opacity: 1;
  color: rgba(230, 230, 231, 1);
  color: rgba(230, 230, 231, var(--tw-text-opacity, 1));
}

.hover\\:text-charcoal-100\\/0:hover{
  color: rgba(230, 230, 231, 0);
}

.hover\\:text-charcoal-100\\/10:hover{
  color: rgba(230, 230, 231, 0.1);
}

.hover\\:text-charcoal-100\\/100:hover{
  color: rgb(230, 230, 231);
}

.hover\\:text-charcoal-100\\/15:hover{
  color: rgba(230, 230, 231, 0.15);
}

.hover\\:text-charcoal-100\\/20:hover{
  color: rgba(230, 230, 231, 0.2);
}

.hover\\:text-charcoal-100\\/25:hover{
  color: rgba(230, 230, 231, 0.25);
}

.hover\\:text-charcoal-100\\/30:hover{
  color: rgba(230, 230, 231, 0.3);
}

.hover\\:text-charcoal-100\\/35:hover{
  color: rgba(230, 230, 231, 0.35);
}

.hover\\:text-charcoal-100\\/40:hover{
  color: rgba(230, 230, 231, 0.4);
}

.hover\\:text-charcoal-100\\/45:hover{
  color: rgba(230, 230, 231, 0.45);
}

.hover\\:text-charcoal-100\\/5:hover{
  color: rgba(230, 230, 231, 0.05);
}

.hover\\:text-charcoal-100\\/50:hover{
  color: rgba(230, 230, 231, 0.5);
}

.hover\\:text-charcoal-100\\/55:hover{
  color: rgba(230, 230, 231, 0.55);
}

.hover\\:text-charcoal-100\\/60:hover{
  color: rgba(230, 230, 231, 0.6);
}

.hover\\:text-charcoal-100\\/65:hover{
  color: rgba(230, 230, 231, 0.65);
}

.hover\\:text-charcoal-100\\/70:hover{
  color: rgba(230, 230, 231, 0.7);
}

.hover\\:text-charcoal-100\\/75:hover{
  color: rgba(230, 230, 231, 0.75);
}

.hover\\:text-charcoal-100\\/80:hover{
  color: rgba(230, 230, 231, 0.8);
}

.hover\\:text-charcoal-100\\/85:hover{
  color: rgba(230, 230, 231, 0.85);
}

.hover\\:text-charcoal-100\\/90:hover{
  color: rgba(230, 230, 231, 0.9);
}

.hover\\:text-charcoal-100\\/95:hover{
  color: rgba(230, 230, 231, 0.95);
}

.hover\\:text-charcoal-200:hover{
  --tw-text-opacity: 1;
  color: rgba(207, 208, 210, 1);
  color: rgba(207, 208, 210, var(--tw-text-opacity, 1));
}

.hover\\:text-charcoal-200\\/0:hover{
  color: rgba(207, 208, 210, 0);
}

.hover\\:text-charcoal-200\\/10:hover{
  color: rgba(207, 208, 210, 0.1);
}

.hover\\:text-charcoal-200\\/100:hover{
  color: rgb(207, 208, 210);
}

.hover\\:text-charcoal-200\\/15:hover{
  color: rgba(207, 208, 210, 0.15);
}

.hover\\:text-charcoal-200\\/20:hover{
  color: rgba(207, 208, 210, 0.2);
}

.hover\\:text-charcoal-200\\/25:hover{
  color: rgba(207, 208, 210, 0.25);
}

.hover\\:text-charcoal-200\\/30:hover{
  color: rgba(207, 208, 210, 0.3);
}

.hover\\:text-charcoal-200\\/35:hover{
  color: rgba(207, 208, 210, 0.35);
}

.hover\\:text-charcoal-200\\/40:hover{
  color: rgba(207, 208, 210, 0.4);
}

.hover\\:text-charcoal-200\\/45:hover{
  color: rgba(207, 208, 210, 0.45);
}

.hover\\:text-charcoal-200\\/5:hover{
  color: rgba(207, 208, 210, 0.05);
}

.hover\\:text-charcoal-200\\/50:hover{
  color: rgba(207, 208, 210, 0.5);
}

.hover\\:text-charcoal-200\\/55:hover{
  color: rgba(207, 208, 210, 0.55);
}

.hover\\:text-charcoal-200\\/60:hover{
  color: rgba(207, 208, 210, 0.6);
}

.hover\\:text-charcoal-200\\/65:hover{
  color: rgba(207, 208, 210, 0.65);
}

.hover\\:text-charcoal-200\\/70:hover{
  color: rgba(207, 208, 210, 0.7);
}

.hover\\:text-charcoal-200\\/75:hover{
  color: rgba(207, 208, 210, 0.75);
}

.hover\\:text-charcoal-200\\/80:hover{
  color: rgba(207, 208, 210, 0.8);
}

.hover\\:text-charcoal-200\\/85:hover{
  color: rgba(207, 208, 210, 0.85);
}

.hover\\:text-charcoal-200\\/90:hover{
  color: rgba(207, 208, 210, 0.9);
}

.hover\\:text-charcoal-200\\/95:hover{
  color: rgba(207, 208, 210, 0.95);
}

.hover\\:text-charcoal-300:hover{
  --tw-text-opacity: 1;
  color: rgba(174, 175, 178, 1);
  color: rgba(174, 175, 178, var(--tw-text-opacity, 1));
}

.hover\\:text-charcoal-300\\/0:hover{
  color: rgba(174, 175, 178, 0);
}

.hover\\:text-charcoal-300\\/10:hover{
  color: rgba(174, 175, 178, 0.1);
}

.hover\\:text-charcoal-300\\/100:hover{
  color: rgb(174, 175, 178);
}

.hover\\:text-charcoal-300\\/15:hover{
  color: rgba(174, 175, 178, 0.15);
}

.hover\\:text-charcoal-300\\/20:hover{
  color: rgba(174, 175, 178, 0.2);
}

.hover\\:text-charcoal-300\\/25:hover{
  color: rgba(174, 175, 178, 0.25);
}

.hover\\:text-charcoal-300\\/30:hover{
  color: rgba(174, 175, 178, 0.3);
}

.hover\\:text-charcoal-300\\/35:hover{
  color: rgba(174, 175, 178, 0.35);
}

.hover\\:text-charcoal-300\\/40:hover{
  color: rgba(174, 175, 178, 0.4);
}

.hover\\:text-charcoal-300\\/45:hover{
  color: rgba(174, 175, 178, 0.45);
}

.hover\\:text-charcoal-300\\/5:hover{
  color: rgba(174, 175, 178, 0.05);
}

.hover\\:text-charcoal-300\\/50:hover{
  color: rgba(174, 175, 178, 0.5);
}

.hover\\:text-charcoal-300\\/55:hover{
  color: rgba(174, 175, 178, 0.55);
}

.hover\\:text-charcoal-300\\/60:hover{
  color: rgba(174, 175, 178, 0.6);
}

.hover\\:text-charcoal-300\\/65:hover{
  color: rgba(174, 175, 178, 0.65);
}

.hover\\:text-charcoal-300\\/70:hover{
  color: rgba(174, 175, 178, 0.7);
}

.hover\\:text-charcoal-300\\/75:hover{
  color: rgba(174, 175, 178, 0.75);
}

.hover\\:text-charcoal-300\\/80:hover{
  color: rgba(174, 175, 178, 0.8);
}

.hover\\:text-charcoal-300\\/85:hover{
  color: rgba(174, 175, 178, 0.85);
}

.hover\\:text-charcoal-300\\/90:hover{
  color: rgba(174, 175, 178, 0.9);
}

.hover\\:text-charcoal-300\\/95:hover{
  color: rgba(174, 175, 178, 0.95);
}

.hover\\:text-charcoal-400:hover{
  --tw-text-opacity: 1;
  color: rgba(133, 134, 139, 1);
  color: rgba(133, 134, 139, var(--tw-text-opacity, 1));
}

.hover\\:text-charcoal-400\\/0:hover{
  color: rgba(133, 134, 139, 0);
}

.hover\\:text-charcoal-400\\/10:hover{
  color: rgba(133, 134, 139, 0.1);
}

.hover\\:text-charcoal-400\\/100:hover{
  color: rgb(133, 134, 139);
}

.hover\\:text-charcoal-400\\/15:hover{
  color: rgba(133, 134, 139, 0.15);
}

.hover\\:text-charcoal-400\\/20:hover{
  color: rgba(133, 134, 139, 0.2);
}

.hover\\:text-charcoal-400\\/25:hover{
  color: rgba(133, 134, 139, 0.25);
}

.hover\\:text-charcoal-400\\/30:hover{
  color: rgba(133, 134, 139, 0.3);
}

.hover\\:text-charcoal-400\\/35:hover{
  color: rgba(133, 134, 139, 0.35);
}

.hover\\:text-charcoal-400\\/40:hover{
  color: rgba(133, 134, 139, 0.4);
}

.hover\\:text-charcoal-400\\/45:hover{
  color: rgba(133, 134, 139, 0.45);
}

.hover\\:text-charcoal-400\\/5:hover{
  color: rgba(133, 134, 139, 0.05);
}

.hover\\:text-charcoal-400\\/50:hover{
  color: rgba(133, 134, 139, 0.5);
}

.hover\\:text-charcoal-400\\/55:hover{
  color: rgba(133, 134, 139, 0.55);
}

.hover\\:text-charcoal-400\\/60:hover{
  color: rgba(133, 134, 139, 0.6);
}

.hover\\:text-charcoal-400\\/65:hover{
  color: rgba(133, 134, 139, 0.65);
}

.hover\\:text-charcoal-400\\/70:hover{
  color: rgba(133, 134, 139, 0.7);
}

.hover\\:text-charcoal-400\\/75:hover{
  color: rgba(133, 134, 139, 0.75);
}

.hover\\:text-charcoal-400\\/80:hover{
  color: rgba(133, 134, 139, 0.8);
}

.hover\\:text-charcoal-400\\/85:hover{
  color: rgba(133, 134, 139, 0.85);
}

.hover\\:text-charcoal-400\\/90:hover{
  color: rgba(133, 134, 139, 0.9);
}

.hover\\:text-charcoal-400\\/95:hover{
  color: rgba(133, 134, 139, 0.95);
}

.hover\\:text-charcoal-50:hover{
  --tw-text-opacity: 1;
  color: rgba(245, 245, 246, 1);
  color: rgba(245, 245, 246, var(--tw-text-opacity, 1));
}

.hover\\:text-charcoal-500:hover{
  --tw-text-opacity: 1;
  color: rgba(106, 107, 112, 1);
  color: rgba(106, 107, 112, var(--tw-text-opacity, 1));
}

.hover\\:text-charcoal-500\\/0:hover{
  color: rgba(106, 107, 112, 0);
}

.hover\\:text-charcoal-500\\/10:hover{
  color: rgba(106, 107, 112, 0.1);
}

.hover\\:text-charcoal-500\\/100:hover{
  color: rgb(106, 107, 112);
}

.hover\\:text-charcoal-500\\/15:hover{
  color: rgba(106, 107, 112, 0.15);
}

.hover\\:text-charcoal-500\\/20:hover{
  color: rgba(106, 107, 112, 0.2);
}

.hover\\:text-charcoal-500\\/25:hover{
  color: rgba(106, 107, 112, 0.25);
}

.hover\\:text-charcoal-500\\/30:hover{
  color: rgba(106, 107, 112, 0.3);
}

.hover\\:text-charcoal-500\\/35:hover{
  color: rgba(106, 107, 112, 0.35);
}

.hover\\:text-charcoal-500\\/40:hover{
  color: rgba(106, 107, 112, 0.4);
}

.hover\\:text-charcoal-500\\/45:hover{
  color: rgba(106, 107, 112, 0.45);
}

.hover\\:text-charcoal-500\\/5:hover{
  color: rgba(106, 107, 112, 0.05);
}

.hover\\:text-charcoal-500\\/50:hover{
  color: rgba(106, 107, 112, 0.5);
}

.hover\\:text-charcoal-500\\/55:hover{
  color: rgba(106, 107, 112, 0.55);
}

.hover\\:text-charcoal-500\\/60:hover{
  color: rgba(106, 107, 112, 0.6);
}

.hover\\:text-charcoal-500\\/65:hover{
  color: rgba(106, 107, 112, 0.65);
}

.hover\\:text-charcoal-500\\/70:hover{
  color: rgba(106, 107, 112, 0.7);
}

.hover\\:text-charcoal-500\\/75:hover{
  color: rgba(106, 107, 112, 0.75);
}

.hover\\:text-charcoal-500\\/80:hover{
  color: rgba(106, 107, 112, 0.8);
}

.hover\\:text-charcoal-500\\/85:hover{
  color: rgba(106, 107, 112, 0.85);
}

.hover\\:text-charcoal-500\\/90:hover{
  color: rgba(106, 107, 112, 0.9);
}

.hover\\:text-charcoal-500\\/95:hover{
  color: rgba(106, 107, 112, 0.95);
}

.hover\\:text-charcoal-600:hover{
  --tw-text-opacity: 1;
  color: rgba(90, 91, 96, 1);
  color: rgba(90, 91, 96, var(--tw-text-opacity, 1));
}

.hover\\:text-charcoal-600\\/0:hover{
  color: rgba(90, 91, 96, 0);
}

.hover\\:text-charcoal-600\\/10:hover{
  color: rgba(90, 91, 96, 0.1);
}

.hover\\:text-charcoal-600\\/100:hover{
  color: rgb(90, 91, 96);
}

.hover\\:text-charcoal-600\\/15:hover{
  color: rgba(90, 91, 96, 0.15);
}

.hover\\:text-charcoal-600\\/20:hover{
  color: rgba(90, 91, 96, 0.2);
}

.hover\\:text-charcoal-600\\/25:hover{
  color: rgba(90, 91, 96, 0.25);
}

.hover\\:text-charcoal-600\\/30:hover{
  color: rgba(90, 91, 96, 0.3);
}

.hover\\:text-charcoal-600\\/35:hover{
  color: rgba(90, 91, 96, 0.35);
}

.hover\\:text-charcoal-600\\/40:hover{
  color: rgba(90, 91, 96, 0.4);
}

.hover\\:text-charcoal-600\\/45:hover{
  color: rgba(90, 91, 96, 0.45);
}

.hover\\:text-charcoal-600\\/5:hover{
  color: rgba(90, 91, 96, 0.05);
}

.hover\\:text-charcoal-600\\/50:hover{
  color: rgba(90, 91, 96, 0.5);
}

.hover\\:text-charcoal-600\\/55:hover{
  color: rgba(90, 91, 96, 0.55);
}

.hover\\:text-charcoal-600\\/60:hover{
  color: rgba(90, 91, 96, 0.6);
}

.hover\\:text-charcoal-600\\/65:hover{
  color: rgba(90, 91, 96, 0.65);
}

.hover\\:text-charcoal-600\\/70:hover{
  color: rgba(90, 91, 96, 0.7);
}

.hover\\:text-charcoal-600\\/75:hover{
  color: rgba(90, 91, 96, 0.75);
}

.hover\\:text-charcoal-600\\/80:hover{
  color: rgba(90, 91, 96, 0.8);
}

.hover\\:text-charcoal-600\\/85:hover{
  color: rgba(90, 91, 96, 0.85);
}

.hover\\:text-charcoal-600\\/90:hover{
  color: rgba(90, 91, 96, 0.9);
}

.hover\\:text-charcoal-600\\/95:hover{
  color: rgba(90, 91, 96, 0.95);
}

.hover\\:text-charcoal-700:hover{
  --tw-text-opacity: 1;
  color: rgba(77, 77, 81, 1);
  color: rgba(77, 77, 81, var(--tw-text-opacity, 1));
}

.hover\\:text-charcoal-700\\/0:hover{
  color: rgba(77, 77, 81, 0);
}

.hover\\:text-charcoal-700\\/10:hover{
  color: rgba(77, 77, 81, 0.1);
}

.hover\\:text-charcoal-700\\/100:hover{
  color: rgb(77, 77, 81);
}

.hover\\:text-charcoal-700\\/15:hover{
  color: rgba(77, 77, 81, 0.15);
}

.hover\\:text-charcoal-700\\/20:hover{
  color: rgba(77, 77, 81, 0.2);
}

.hover\\:text-charcoal-700\\/25:hover{
  color: rgba(77, 77, 81, 0.25);
}

.hover\\:text-charcoal-700\\/30:hover{
  color: rgba(77, 77, 81, 0.3);
}

.hover\\:text-charcoal-700\\/35:hover{
  color: rgba(77, 77, 81, 0.35);
}

.hover\\:text-charcoal-700\\/40:hover{
  color: rgba(77, 77, 81, 0.4);
}

.hover\\:text-charcoal-700\\/45:hover{
  color: rgba(77, 77, 81, 0.45);
}

.hover\\:text-charcoal-700\\/5:hover{
  color: rgba(77, 77, 81, 0.05);
}

.hover\\:text-charcoal-700\\/50:hover{
  color: rgba(77, 77, 81, 0.5);
}

.hover\\:text-charcoal-700\\/55:hover{
  color: rgba(77, 77, 81, 0.55);
}

.hover\\:text-charcoal-700\\/60:hover{
  color: rgba(77, 77, 81, 0.6);
}

.hover\\:text-charcoal-700\\/65:hover{
  color: rgba(77, 77, 81, 0.65);
}

.hover\\:text-charcoal-700\\/70:hover{
  color: rgba(77, 77, 81, 0.7);
}

.hover\\:text-charcoal-700\\/75:hover{
  color: rgba(77, 77, 81, 0.75);
}

.hover\\:text-charcoal-700\\/80:hover{
  color: rgba(77, 77, 81, 0.8);
}

.hover\\:text-charcoal-700\\/85:hover{
  color: rgba(77, 77, 81, 0.85);
}

.hover\\:text-charcoal-700\\/90:hover{
  color: rgba(77, 77, 81, 0.9);
}

.hover\\:text-charcoal-700\\/95:hover{
  color: rgba(77, 77, 81, 0.95);
}

.hover\\:text-charcoal-800:hover{
  --tw-text-opacity: 1;
  color: rgba(67, 67, 71, 1);
  color: rgba(67, 67, 71, var(--tw-text-opacity, 1));
}

.hover\\:text-charcoal-800\\/0:hover{
  color: rgba(67, 67, 71, 0);
}

.hover\\:text-charcoal-800\\/10:hover{
  color: rgba(67, 67, 71, 0.1);
}

.hover\\:text-charcoal-800\\/100:hover{
  color: rgb(67, 67, 71);
}

.hover\\:text-charcoal-800\\/15:hover{
  color: rgba(67, 67, 71, 0.15);
}

.hover\\:text-charcoal-800\\/20:hover{
  color: rgba(67, 67, 71, 0.2);
}

.hover\\:text-charcoal-800\\/25:hover{
  color: rgba(67, 67, 71, 0.25);
}

.hover\\:text-charcoal-800\\/30:hover{
  color: rgba(67, 67, 71, 0.3);
}

.hover\\:text-charcoal-800\\/35:hover{
  color: rgba(67, 67, 71, 0.35);
}

.hover\\:text-charcoal-800\\/40:hover{
  color: rgba(67, 67, 71, 0.4);
}

.hover\\:text-charcoal-800\\/45:hover{
  color: rgba(67, 67, 71, 0.45);
}

.hover\\:text-charcoal-800\\/5:hover{
  color: rgba(67, 67, 71, 0.05);
}

.hover\\:text-charcoal-800\\/50:hover{
  color: rgba(67, 67, 71, 0.5);
}

.hover\\:text-charcoal-800\\/55:hover{
  color: rgba(67, 67, 71, 0.55);
}

.hover\\:text-charcoal-800\\/60:hover{
  color: rgba(67, 67, 71, 0.6);
}

.hover\\:text-charcoal-800\\/65:hover{
  color: rgba(67, 67, 71, 0.65);
}

.hover\\:text-charcoal-800\\/70:hover{
  color: rgba(67, 67, 71, 0.7);
}

.hover\\:text-charcoal-800\\/75:hover{
  color: rgba(67, 67, 71, 0.75);
}

.hover\\:text-charcoal-800\\/80:hover{
  color: rgba(67, 67, 71, 0.8);
}

.hover\\:text-charcoal-800\\/85:hover{
  color: rgba(67, 67, 71, 0.85);
}

.hover\\:text-charcoal-800\\/90:hover{
  color: rgba(67, 67, 71, 0.9);
}

.hover\\:text-charcoal-800\\/95:hover{
  color: rgba(67, 67, 71, 0.95);
}

.hover\\:text-charcoal-900:hover{
  --tw-text-opacity: 1;
  color: rgba(49, 49, 51, 1);
  color: rgba(49, 49, 51, var(--tw-text-opacity, 1));
}

.hover\\:text-charcoal-900\\/0:hover{
  color: rgba(49, 49, 51, 0);
}

.hover\\:text-charcoal-900\\/10:hover{
  color: rgba(49, 49, 51, 0.1);
}

.hover\\:text-charcoal-900\\/100:hover{
  color: rgb(49, 49, 51);
}

.hover\\:text-charcoal-900\\/15:hover{
  color: rgba(49, 49, 51, 0.15);
}

.hover\\:text-charcoal-900\\/20:hover{
  color: rgba(49, 49, 51, 0.2);
}

.hover\\:text-charcoal-900\\/25:hover{
  color: rgba(49, 49, 51, 0.25);
}

.hover\\:text-charcoal-900\\/30:hover{
  color: rgba(49, 49, 51, 0.3);
}

.hover\\:text-charcoal-900\\/35:hover{
  color: rgba(49, 49, 51, 0.35);
}

.hover\\:text-charcoal-900\\/40:hover{
  color: rgba(49, 49, 51, 0.4);
}

.hover\\:text-charcoal-900\\/45:hover{
  color: rgba(49, 49, 51, 0.45);
}

.hover\\:text-charcoal-900\\/5:hover{
  color: rgba(49, 49, 51, 0.05);
}

.hover\\:text-charcoal-900\\/50:hover{
  color: rgba(49, 49, 51, 0.5);
}

.hover\\:text-charcoal-900\\/55:hover{
  color: rgba(49, 49, 51, 0.55);
}

.hover\\:text-charcoal-900\\/60:hover{
  color: rgba(49, 49, 51, 0.6);
}

.hover\\:text-charcoal-900\\/65:hover{
  color: rgba(49, 49, 51, 0.65);
}

.hover\\:text-charcoal-900\\/70:hover{
  color: rgba(49, 49, 51, 0.7);
}

.hover\\:text-charcoal-900\\/75:hover{
  color: rgba(49, 49, 51, 0.75);
}

.hover\\:text-charcoal-900\\/80:hover{
  color: rgba(49, 49, 51, 0.8);
}

.hover\\:text-charcoal-900\\/85:hover{
  color: rgba(49, 49, 51, 0.85);
}

.hover\\:text-charcoal-900\\/90:hover{
  color: rgba(49, 49, 51, 0.9);
}

.hover\\:text-charcoal-900\\/95:hover{
  color: rgba(49, 49, 51, 0.95);
}

.hover\\:text-charcoal-950:hover{
  --tw-text-opacity: 1;
  color: rgba(37, 37, 39, 1);
  color: rgba(37, 37, 39, var(--tw-text-opacity, 1));
}

.hover\\:text-charcoal-950\\/0:hover{
  color: rgba(37, 37, 39, 0);
}

.hover\\:text-charcoal-950\\/10:hover{
  color: rgba(37, 37, 39, 0.1);
}

.hover\\:text-charcoal-950\\/100:hover{
  color: rgb(37, 37, 39);
}

.hover\\:text-charcoal-950\\/15:hover{
  color: rgba(37, 37, 39, 0.15);
}

.hover\\:text-charcoal-950\\/20:hover{
  color: rgba(37, 37, 39, 0.2);
}

.hover\\:text-charcoal-950\\/25:hover{
  color: rgba(37, 37, 39, 0.25);
}

.hover\\:text-charcoal-950\\/30:hover{
  color: rgba(37, 37, 39, 0.3);
}

.hover\\:text-charcoal-950\\/35:hover{
  color: rgba(37, 37, 39, 0.35);
}

.hover\\:text-charcoal-950\\/40:hover{
  color: rgba(37, 37, 39, 0.4);
}

.hover\\:text-charcoal-950\\/45:hover{
  color: rgba(37, 37, 39, 0.45);
}

.hover\\:text-charcoal-950\\/5:hover{
  color: rgba(37, 37, 39, 0.05);
}

.hover\\:text-charcoal-950\\/50:hover{
  color: rgba(37, 37, 39, 0.5);
}

.hover\\:text-charcoal-950\\/55:hover{
  color: rgba(37, 37, 39, 0.55);
}

.hover\\:text-charcoal-950\\/60:hover{
  color: rgba(37, 37, 39, 0.6);
}

.hover\\:text-charcoal-950\\/65:hover{
  color: rgba(37, 37, 39, 0.65);
}

.hover\\:text-charcoal-950\\/70:hover{
  color: rgba(37, 37, 39, 0.7);
}

.hover\\:text-charcoal-950\\/75:hover{
  color: rgba(37, 37, 39, 0.75);
}

.hover\\:text-charcoal-950\\/80:hover{
  color: rgba(37, 37, 39, 0.8);
}

.hover\\:text-charcoal-950\\/85:hover{
  color: rgba(37, 37, 39, 0.85);
}

.hover\\:text-charcoal-950\\/90:hover{
  color: rgba(37, 37, 39, 0.9);
}

.hover\\:text-charcoal-950\\/95:hover{
  color: rgba(37, 37, 39, 0.95);
}

.hover\\:text-jade-100:hover{
  --tw-text-opacity: 1;
  color: rgba(217, 242, 230, 1);
  color: rgba(217, 242, 230, var(--tw-text-opacity, 1));
}

.hover\\:text-jade-100\\/0:hover{
  color: rgba(217, 242, 230, 0);
}

.hover\\:text-jade-100\\/10:hover{
  color: rgba(217, 242, 230, 0.1);
}

.hover\\:text-jade-100\\/100:hover{
  color: rgb(217, 242, 230);
}

.hover\\:text-jade-100\\/15:hover{
  color: rgba(217, 242, 230, 0.15);
}

.hover\\:text-jade-100\\/20:hover{
  color: rgba(217, 242, 230, 0.2);
}

.hover\\:text-jade-100\\/25:hover{
  color: rgba(217, 242, 230, 0.25);
}

.hover\\:text-jade-100\\/30:hover{
  color: rgba(217, 242, 230, 0.3);
}

.hover\\:text-jade-100\\/35:hover{
  color: rgba(217, 242, 230, 0.35);
}

.hover\\:text-jade-100\\/40:hover{
  color: rgba(217, 242, 230, 0.4);
}

.hover\\:text-jade-100\\/45:hover{
  color: rgba(217, 242, 230, 0.45);
}

.hover\\:text-jade-100\\/5:hover{
  color: rgba(217, 242, 230, 0.05);
}

.hover\\:text-jade-100\\/50:hover{
  color: rgba(217, 242, 230, 0.5);
}

.hover\\:text-jade-100\\/55:hover{
  color: rgba(217, 242, 230, 0.55);
}

.hover\\:text-jade-100\\/60:hover{
  color: rgba(217, 242, 230, 0.6);
}

.hover\\:text-jade-100\\/65:hover{
  color: rgba(217, 242, 230, 0.65);
}

.hover\\:text-jade-100\\/70:hover{
  color: rgba(217, 242, 230, 0.7);
}

.hover\\:text-jade-100\\/75:hover{
  color: rgba(217, 242, 230, 0.75);
}

.hover\\:text-jade-100\\/80:hover{
  color: rgba(217, 242, 230, 0.8);
}

.hover\\:text-jade-100\\/85:hover{
  color: rgba(217, 242, 230, 0.85);
}

.hover\\:text-jade-100\\/90:hover{
  color: rgba(217, 242, 230, 0.9);
}

.hover\\:text-jade-100\\/95:hover{
  color: rgba(217, 242, 230, 0.95);
}

.hover\\:text-jade-200:hover{
  --tw-text-opacity: 1;
  color: rgba(182, 228, 209, 1);
  color: rgba(182, 228, 209, var(--tw-text-opacity, 1));
}

.hover\\:text-jade-200\\/0:hover{
  color: rgba(182, 228, 209, 0);
}

.hover\\:text-jade-200\\/10:hover{
  color: rgba(182, 228, 209, 0.1);
}

.hover\\:text-jade-200\\/100:hover{
  color: rgb(182, 228, 209);
}

.hover\\:text-jade-200\\/15:hover{
  color: rgba(182, 228, 209, 0.15);
}

.hover\\:text-jade-200\\/20:hover{
  color: rgba(182, 228, 209, 0.2);
}

.hover\\:text-jade-200\\/25:hover{
  color: rgba(182, 228, 209, 0.25);
}

.hover\\:text-jade-200\\/30:hover{
  color: rgba(182, 228, 209, 0.3);
}

.hover\\:text-jade-200\\/35:hover{
  color: rgba(182, 228, 209, 0.35);
}

.hover\\:text-jade-200\\/40:hover{
  color: rgba(182, 228, 209, 0.4);
}

.hover\\:text-jade-200\\/45:hover{
  color: rgba(182, 228, 209, 0.45);
}

.hover\\:text-jade-200\\/5:hover{
  color: rgba(182, 228, 209, 0.05);
}

.hover\\:text-jade-200\\/50:hover{
  color: rgba(182, 228, 209, 0.5);
}

.hover\\:text-jade-200\\/55:hover{
  color: rgba(182, 228, 209, 0.55);
}

.hover\\:text-jade-200\\/60:hover{
  color: rgba(182, 228, 209, 0.6);
}

.hover\\:text-jade-200\\/65:hover{
  color: rgba(182, 228, 209, 0.65);
}

.hover\\:text-jade-200\\/70:hover{
  color: rgba(182, 228, 209, 0.7);
}

.hover\\:text-jade-200\\/75:hover{
  color: rgba(182, 228, 209, 0.75);
}

.hover\\:text-jade-200\\/80:hover{
  color: rgba(182, 228, 209, 0.8);
}

.hover\\:text-jade-200\\/85:hover{
  color: rgba(182, 228, 209, 0.85);
}

.hover\\:text-jade-200\\/90:hover{
  color: rgba(182, 228, 209, 0.9);
}

.hover\\:text-jade-200\\/95:hover{
  color: rgba(182, 228, 209, 0.95);
}

.hover\\:text-jade-300:hover{
  --tw-text-opacity: 1;
  color: rgba(134, 207, 181, 1);
  color: rgba(134, 207, 181, var(--tw-text-opacity, 1));
}

.hover\\:text-jade-300\\/0:hover{
  color: rgba(134, 207, 181, 0);
}

.hover\\:text-jade-300\\/10:hover{
  color: rgba(134, 207, 181, 0.1);
}

.hover\\:text-jade-300\\/100:hover{
  color: rgb(134, 207, 181);
}

.hover\\:text-jade-300\\/15:hover{
  color: rgba(134, 207, 181, 0.15);
}

.hover\\:text-jade-300\\/20:hover{
  color: rgba(134, 207, 181, 0.2);
}

.hover\\:text-jade-300\\/25:hover{
  color: rgba(134, 207, 181, 0.25);
}

.hover\\:text-jade-300\\/30:hover{
  color: rgba(134, 207, 181, 0.3);
}

.hover\\:text-jade-300\\/35:hover{
  color: rgba(134, 207, 181, 0.35);
}

.hover\\:text-jade-300\\/40:hover{
  color: rgba(134, 207, 181, 0.4);
}

.hover\\:text-jade-300\\/45:hover{
  color: rgba(134, 207, 181, 0.45);
}

.hover\\:text-jade-300\\/5:hover{
  color: rgba(134, 207, 181, 0.05);
}

.hover\\:text-jade-300\\/50:hover{
  color: rgba(134, 207, 181, 0.5);
}

.hover\\:text-jade-300\\/55:hover{
  color: rgba(134, 207, 181, 0.55);
}

.hover\\:text-jade-300\\/60:hover{
  color: rgba(134, 207, 181, 0.6);
}

.hover\\:text-jade-300\\/65:hover{
  color: rgba(134, 207, 181, 0.65);
}

.hover\\:text-jade-300\\/70:hover{
  color: rgba(134, 207, 181, 0.7);
}

.hover\\:text-jade-300\\/75:hover{
  color: rgba(134, 207, 181, 0.75);
}

.hover\\:text-jade-300\\/80:hover{
  color: rgba(134, 207, 181, 0.8);
}

.hover\\:text-jade-300\\/85:hover{
  color: rgba(134, 207, 181, 0.85);
}

.hover\\:text-jade-300\\/90:hover{
  color: rgba(134, 207, 181, 0.9);
}

.hover\\:text-jade-300\\/95:hover{
  color: rgba(134, 207, 181, 0.95);
}

.hover\\:text-jade-400:hover{
  --tw-text-opacity: 1;
  color: rgba(83, 180, 148, 1);
  color: rgba(83, 180, 148, var(--tw-text-opacity, 1));
}

.hover\\:text-jade-400\\/0:hover{
  color: rgba(83, 180, 148, 0);
}

.hover\\:text-jade-400\\/10:hover{
  color: rgba(83, 180, 148, 0.1);
}

.hover\\:text-jade-400\\/100:hover{
  color: rgb(83, 180, 148);
}

.hover\\:text-jade-400\\/15:hover{
  color: rgba(83, 180, 148, 0.15);
}

.hover\\:text-jade-400\\/20:hover{
  color: rgba(83, 180, 148, 0.2);
}

.hover\\:text-jade-400\\/25:hover{
  color: rgba(83, 180, 148, 0.25);
}

.hover\\:text-jade-400\\/30:hover{
  color: rgba(83, 180, 148, 0.3);
}

.hover\\:text-jade-400\\/35:hover{
  color: rgba(83, 180, 148, 0.35);
}

.hover\\:text-jade-400\\/40:hover{
  color: rgba(83, 180, 148, 0.4);
}

.hover\\:text-jade-400\\/45:hover{
  color: rgba(83, 180, 148, 0.45);
}

.hover\\:text-jade-400\\/5:hover{
  color: rgba(83, 180, 148, 0.05);
}

.hover\\:text-jade-400\\/50:hover{
  color: rgba(83, 180, 148, 0.5);
}

.hover\\:text-jade-400\\/55:hover{
  color: rgba(83, 180, 148, 0.55);
}

.hover\\:text-jade-400\\/60:hover{
  color: rgba(83, 180, 148, 0.6);
}

.hover\\:text-jade-400\\/65:hover{
  color: rgba(83, 180, 148, 0.65);
}

.hover\\:text-jade-400\\/70:hover{
  color: rgba(83, 180, 148, 0.7);
}

.hover\\:text-jade-400\\/75:hover{
  color: rgba(83, 180, 148, 0.75);
}

.hover\\:text-jade-400\\/80:hover{
  color: rgba(83, 180, 148, 0.8);
}

.hover\\:text-jade-400\\/85:hover{
  color: rgba(83, 180, 148, 0.85);
}

.hover\\:text-jade-400\\/90:hover{
  color: rgba(83, 180, 148, 0.9);
}

.hover\\:text-jade-400\\/95:hover{
  color: rgba(83, 180, 148, 0.95);
}

.hover\\:text-jade-500:hover{
  --tw-text-opacity: 1;
  color: rgba(44, 135, 109, 1);
  color: rgba(44, 135, 109, var(--tw-text-opacity, 1));
}

.hover\\:text-jade-500\\/0:hover{
  color: rgba(44, 135, 109, 0);
}

.hover\\:text-jade-500\\/10:hover{
  color: rgba(44, 135, 109, 0.1);
}

.hover\\:text-jade-500\\/100:hover{
  color: rgb(44, 135, 109);
}

.hover\\:text-jade-500\\/15:hover{
  color: rgba(44, 135, 109, 0.15);
}

.hover\\:text-jade-500\\/20:hover{
  color: rgba(44, 135, 109, 0.2);
}

.hover\\:text-jade-500\\/25:hover{
  color: rgba(44, 135, 109, 0.25);
}

.hover\\:text-jade-500\\/30:hover{
  color: rgba(44, 135, 109, 0.3);
}

.hover\\:text-jade-500\\/35:hover{
  color: rgba(44, 135, 109, 0.35);
}

.hover\\:text-jade-500\\/40:hover{
  color: rgba(44, 135, 109, 0.4);
}

.hover\\:text-jade-500\\/45:hover{
  color: rgba(44, 135, 109, 0.45);
}

.hover\\:text-jade-500\\/5:hover{
  color: rgba(44, 135, 109, 0.05);
}

.hover\\:text-jade-500\\/50:hover{
  color: rgba(44, 135, 109, 0.5);
}

.hover\\:text-jade-500\\/55:hover{
  color: rgba(44, 135, 109, 0.55);
}

.hover\\:text-jade-500\\/60:hover{
  color: rgba(44, 135, 109, 0.6);
}

.hover\\:text-jade-500\\/65:hover{
  color: rgba(44, 135, 109, 0.65);
}

.hover\\:text-jade-500\\/70:hover{
  color: rgba(44, 135, 109, 0.7);
}

.hover\\:text-jade-500\\/75:hover{
  color: rgba(44, 135, 109, 0.75);
}

.hover\\:text-jade-500\\/80:hover{
  color: rgba(44, 135, 109, 0.8);
}

.hover\\:text-jade-500\\/85:hover{
  color: rgba(44, 135, 109, 0.85);
}

.hover\\:text-jade-500\\/90:hover{
  color: rgba(44, 135, 109, 0.9);
}

.hover\\:text-jade-500\\/95:hover{
  color: rgba(44, 135, 109, 0.95);
}

.hover\\:text-jade-600:hover{
  --tw-text-opacity: 1;
  color: rgba(34, 121, 98, 1);
  color: rgba(34, 121, 98, var(--tw-text-opacity, 1));
}

.hover\\:text-jade-600\\/0:hover{
  color: rgba(34, 121, 98, 0);
}

.hover\\:text-jade-600\\/10:hover{
  color: rgba(34, 121, 98, 0.1);
}

.hover\\:text-jade-600\\/100:hover{
  color: rgb(34, 121, 98);
}

.hover\\:text-jade-600\\/15:hover{
  color: rgba(34, 121, 98, 0.15);
}

.hover\\:text-jade-600\\/20:hover{
  color: rgba(34, 121, 98, 0.2);
}

.hover\\:text-jade-600\\/25:hover{
  color: rgba(34, 121, 98, 0.25);
}

.hover\\:text-jade-600\\/30:hover{
  color: rgba(34, 121, 98, 0.3);
}

.hover\\:text-jade-600\\/35:hover{
  color: rgba(34, 121, 98, 0.35);
}

.hover\\:text-jade-600\\/40:hover{
  color: rgba(34, 121, 98, 0.4);
}

.hover\\:text-jade-600\\/45:hover{
  color: rgba(34, 121, 98, 0.45);
}

.hover\\:text-jade-600\\/5:hover{
  color: rgba(34, 121, 98, 0.05);
}

.hover\\:text-jade-600\\/50:hover{
  color: rgba(34, 121, 98, 0.5);
}

.hover\\:text-jade-600\\/55:hover{
  color: rgba(34, 121, 98, 0.55);
}

.hover\\:text-jade-600\\/60:hover{
  color: rgba(34, 121, 98, 0.6);
}

.hover\\:text-jade-600\\/65:hover{
  color: rgba(34, 121, 98, 0.65);
}

.hover\\:text-jade-600\\/70:hover{
  color: rgba(34, 121, 98, 0.7);
}

.hover\\:text-jade-600\\/75:hover{
  color: rgba(34, 121, 98, 0.75);
}

.hover\\:text-jade-600\\/80:hover{
  color: rgba(34, 121, 98, 0.8);
}

.hover\\:text-jade-600\\/85:hover{
  color: rgba(34, 121, 98, 0.85);
}

.hover\\:text-jade-600\\/90:hover{
  color: rgba(34, 121, 98, 0.9);
}

.hover\\:text-jade-600\\/95:hover{
  color: rgba(34, 121, 98, 0.95);
}

.hover\\:text-jade-700:hover{
  --tw-text-opacity: 1;
  color: rgba(27, 97, 80, 1);
  color: rgba(27, 97, 80, var(--tw-text-opacity, 1));
}

.hover\\:text-jade-700\\/0:hover{
  color: rgba(27, 97, 80, 0);
}

.hover\\:text-jade-700\\/10:hover{
  color: rgba(27, 97, 80, 0.1);
}

.hover\\:text-jade-700\\/100:hover{
  color: rgb(27, 97, 80);
}

.hover\\:text-jade-700\\/15:hover{
  color: rgba(27, 97, 80, 0.15);
}

.hover\\:text-jade-700\\/20:hover{
  color: rgba(27, 97, 80, 0.2);
}

.hover\\:text-jade-700\\/25:hover{
  color: rgba(27, 97, 80, 0.25);
}

.hover\\:text-jade-700\\/30:hover{
  color: rgba(27, 97, 80, 0.3);
}

.hover\\:text-jade-700\\/35:hover{
  color: rgba(27, 97, 80, 0.35);
}

.hover\\:text-jade-700\\/40:hover{
  color: rgba(27, 97, 80, 0.4);
}

.hover\\:text-jade-700\\/45:hover{
  color: rgba(27, 97, 80, 0.45);
}

.hover\\:text-jade-700\\/5:hover{
  color: rgba(27, 97, 80, 0.05);
}

.hover\\:text-jade-700\\/50:hover{
  color: rgba(27, 97, 80, 0.5);
}

.hover\\:text-jade-700\\/55:hover{
  color: rgba(27, 97, 80, 0.55);
}

.hover\\:text-jade-700\\/60:hover{
  color: rgba(27, 97, 80, 0.6);
}

.hover\\:text-jade-700\\/65:hover{
  color: rgba(27, 97, 80, 0.65);
}

.hover\\:text-jade-700\\/70:hover{
  color: rgba(27, 97, 80, 0.7);
}

.hover\\:text-jade-700\\/75:hover{
  color: rgba(27, 97, 80, 0.75);
}

.hover\\:text-jade-700\\/80:hover{
  color: rgba(27, 97, 80, 0.8);
}

.hover\\:text-jade-700\\/85:hover{
  color: rgba(27, 97, 80, 0.85);
}

.hover\\:text-jade-700\\/90:hover{
  color: rgba(27, 97, 80, 0.9);
}

.hover\\:text-jade-700\\/95:hover{
  color: rgba(27, 97, 80, 0.95);
}

.hover\\:text-jade-800:hover{
  --tw-text-opacity: 1;
  color: rgba(24, 77, 64, 1);
  color: rgba(24, 77, 64, var(--tw-text-opacity, 1));
}

.hover\\:text-jade-800\\/0:hover{
  color: rgba(24, 77, 64, 0);
}

.hover\\:text-jade-800\\/10:hover{
  color: rgba(24, 77, 64, 0.1);
}

.hover\\:text-jade-800\\/100:hover{
  color: rgb(24, 77, 64);
}

.hover\\:text-jade-800\\/15:hover{
  color: rgba(24, 77, 64, 0.15);
}

.hover\\:text-jade-800\\/20:hover{
  color: rgba(24, 77, 64, 0.2);
}

.hover\\:text-jade-800\\/25:hover{
  color: rgba(24, 77, 64, 0.25);
}

.hover\\:text-jade-800\\/30:hover{
  color: rgba(24, 77, 64, 0.3);
}

.hover\\:text-jade-800\\/35:hover{
  color: rgba(24, 77, 64, 0.35);
}

.hover\\:text-jade-800\\/40:hover{
  color: rgba(24, 77, 64, 0.4);
}

.hover\\:text-jade-800\\/45:hover{
  color: rgba(24, 77, 64, 0.45);
}

.hover\\:text-jade-800\\/5:hover{
  color: rgba(24, 77, 64, 0.05);
}

.hover\\:text-jade-800\\/50:hover{
  color: rgba(24, 77, 64, 0.5);
}

.hover\\:text-jade-800\\/55:hover{
  color: rgba(24, 77, 64, 0.55);
}

.hover\\:text-jade-800\\/60:hover{
  color: rgba(24, 77, 64, 0.6);
}

.hover\\:text-jade-800\\/65:hover{
  color: rgba(24, 77, 64, 0.65);
}

.hover\\:text-jade-800\\/70:hover{
  color: rgba(24, 77, 64, 0.7);
}

.hover\\:text-jade-800\\/75:hover{
  color: rgba(24, 77, 64, 0.75);
}

.hover\\:text-jade-800\\/80:hover{
  color: rgba(24, 77, 64, 0.8);
}

.hover\\:text-jade-800\\/85:hover{
  color: rgba(24, 77, 64, 0.85);
}

.hover\\:text-jade-800\\/90:hover{
  color: rgba(24, 77, 64, 0.9);
}

.hover\\:text-jade-800\\/95:hover{
  color: rgba(24, 77, 64, 0.95);
}

.hover\\:text-jade-900:hover{
  --tw-text-opacity: 1;
  color: rgba(20, 64, 54, 1);
  color: rgba(20, 64, 54, var(--tw-text-opacity, 1));
}

.hover\\:text-jade-900\\/0:hover{
  color: rgba(20, 64, 54, 0);
}

.hover\\:text-jade-900\\/10:hover{
  color: rgba(20, 64, 54, 0.1);
}

.hover\\:text-jade-900\\/100:hover{
  color: rgb(20, 64, 54);
}

.hover\\:text-jade-900\\/15:hover{
  color: rgba(20, 64, 54, 0.15);
}

.hover\\:text-jade-900\\/20:hover{
  color: rgba(20, 64, 54, 0.2);
}

.hover\\:text-jade-900\\/25:hover{
  color: rgba(20, 64, 54, 0.25);
}

.hover\\:text-jade-900\\/30:hover{
  color: rgba(20, 64, 54, 0.3);
}

.hover\\:text-jade-900\\/35:hover{
  color: rgba(20, 64, 54, 0.35);
}

.hover\\:text-jade-900\\/40:hover{
  color: rgba(20, 64, 54, 0.4);
}

.hover\\:text-jade-900\\/45:hover{
  color: rgba(20, 64, 54, 0.45);
}

.hover\\:text-jade-900\\/5:hover{
  color: rgba(20, 64, 54, 0.05);
}

.hover\\:text-jade-900\\/50:hover{
  color: rgba(20, 64, 54, 0.5);
}

.hover\\:text-jade-900\\/55:hover{
  color: rgba(20, 64, 54, 0.55);
}

.hover\\:text-jade-900\\/60:hover{
  color: rgba(20, 64, 54, 0.6);
}

.hover\\:text-jade-900\\/65:hover{
  color: rgba(20, 64, 54, 0.65);
}

.hover\\:text-jade-900\\/70:hover{
  color: rgba(20, 64, 54, 0.7);
}

.hover\\:text-jade-900\\/75:hover{
  color: rgba(20, 64, 54, 0.75);
}

.hover\\:text-jade-900\\/80:hover{
  color: rgba(20, 64, 54, 0.8);
}

.hover\\:text-jade-900\\/85:hover{
  color: rgba(20, 64, 54, 0.85);
}

.hover\\:text-jade-900\\/90:hover{
  color: rgba(20, 64, 54, 0.9);
}

.hover\\:text-jade-900\\/95:hover{
  color: rgba(20, 64, 54, 0.95);
}

.hover\\:text-jade-950:hover{
  --tw-text-opacity: 1;
  color: rgba(10, 36, 31, 1);
  color: rgba(10, 36, 31, var(--tw-text-opacity, 1));
}

.hover\\:text-jade-950\\/0:hover{
  color: rgba(10, 36, 31, 0);
}

.hover\\:text-jade-950\\/10:hover{
  color: rgba(10, 36, 31, 0.1);
}

.hover\\:text-jade-950\\/100:hover{
  color: rgb(10, 36, 31);
}

.hover\\:text-jade-950\\/15:hover{
  color: rgba(10, 36, 31, 0.15);
}

.hover\\:text-jade-950\\/20:hover{
  color: rgba(10, 36, 31, 0.2);
}

.hover\\:text-jade-950\\/25:hover{
  color: rgba(10, 36, 31, 0.25);
}

.hover\\:text-jade-950\\/30:hover{
  color: rgba(10, 36, 31, 0.3);
}

.hover\\:text-jade-950\\/35:hover{
  color: rgba(10, 36, 31, 0.35);
}

.hover\\:text-jade-950\\/40:hover{
  color: rgba(10, 36, 31, 0.4);
}

.hover\\:text-jade-950\\/45:hover{
  color: rgba(10, 36, 31, 0.45);
}

.hover\\:text-jade-950\\/5:hover{
  color: rgba(10, 36, 31, 0.05);
}

.hover\\:text-jade-950\\/50:hover{
  color: rgba(10, 36, 31, 0.5);
}

.hover\\:text-jade-950\\/55:hover{
  color: rgba(10, 36, 31, 0.55);
}

.hover\\:text-jade-950\\/60:hover{
  color: rgba(10, 36, 31, 0.6);
}

.hover\\:text-jade-950\\/65:hover{
  color: rgba(10, 36, 31, 0.65);
}

.hover\\:text-jade-950\\/70:hover{
  color: rgba(10, 36, 31, 0.7);
}

.hover\\:text-jade-950\\/75:hover{
  color: rgba(10, 36, 31, 0.75);
}

.hover\\:text-jade-950\\/80:hover{
  color: rgba(10, 36, 31, 0.8);
}

.hover\\:text-jade-950\\/85:hover{
  color: rgba(10, 36, 31, 0.85);
}

.hover\\:text-jade-950\\/90:hover{
  color: rgba(10, 36, 31, 0.9);
}

.hover\\:text-jade-950\\/95:hover{
  color: rgba(10, 36, 31, 0.95);
}

.hover\\:text-kids-alphabet-500:hover{
  --tw-text-opacity: 1;
  color: rgba(55, 135, 163, 1);
  color: rgba(55, 135, 163, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-alphabet-500\\/0:hover{
  color: rgba(55, 135, 163, 0);
}

.hover\\:text-kids-alphabet-500\\/10:hover{
  color: rgba(55, 135, 163, 0.1);
}

.hover\\:text-kids-alphabet-500\\/100:hover{
  color: rgb(55, 135, 163);
}

.hover\\:text-kids-alphabet-500\\/15:hover{
  color: rgba(55, 135, 163, 0.15);
}

.hover\\:text-kids-alphabet-500\\/20:hover{
  color: rgba(55, 135, 163, 0.2);
}

.hover\\:text-kids-alphabet-500\\/25:hover{
  color: rgba(55, 135, 163, 0.25);
}

.hover\\:text-kids-alphabet-500\\/30:hover{
  color: rgba(55, 135, 163, 0.3);
}

.hover\\:text-kids-alphabet-500\\/35:hover{
  color: rgba(55, 135, 163, 0.35);
}

.hover\\:text-kids-alphabet-500\\/40:hover{
  color: rgba(55, 135, 163, 0.4);
}

.hover\\:text-kids-alphabet-500\\/45:hover{
  color: rgba(55, 135, 163, 0.45);
}

.hover\\:text-kids-alphabet-500\\/5:hover{
  color: rgba(55, 135, 163, 0.05);
}

.hover\\:text-kids-alphabet-500\\/50:hover{
  color: rgba(55, 135, 163, 0.5);
}

.hover\\:text-kids-alphabet-500\\/55:hover{
  color: rgba(55, 135, 163, 0.55);
}

.hover\\:text-kids-alphabet-500\\/60:hover{
  color: rgba(55, 135, 163, 0.6);
}

.hover\\:text-kids-alphabet-500\\/65:hover{
  color: rgba(55, 135, 163, 0.65);
}

.hover\\:text-kids-alphabet-500\\/70:hover{
  color: rgba(55, 135, 163, 0.7);
}

.hover\\:text-kids-alphabet-500\\/75:hover{
  color: rgba(55, 135, 163, 0.75);
}

.hover\\:text-kids-alphabet-500\\/80:hover{
  color: rgba(55, 135, 163, 0.8);
}

.hover\\:text-kids-alphabet-500\\/85:hover{
  color: rgba(55, 135, 163, 0.85);
}

.hover\\:text-kids-alphabet-500\\/90:hover{
  color: rgba(55, 135, 163, 0.9);
}

.hover\\:text-kids-alphabet-500\\/95:hover{
  color: rgba(55, 135, 163, 0.95);
}

.hover\\:text-kids-alphabet-600:hover{
  --tw-text-opacity: 1;
  color: rgba(48, 109, 138, 1);
  color: rgba(48, 109, 138, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-alphabet-600\\/0:hover{
  color: rgba(48, 109, 138, 0);
}

.hover\\:text-kids-alphabet-600\\/10:hover{
  color: rgba(48, 109, 138, 0.1);
}

.hover\\:text-kids-alphabet-600\\/100:hover{
  color: rgb(48, 109, 138);
}

.hover\\:text-kids-alphabet-600\\/15:hover{
  color: rgba(48, 109, 138, 0.15);
}

.hover\\:text-kids-alphabet-600\\/20:hover{
  color: rgba(48, 109, 138, 0.2);
}

.hover\\:text-kids-alphabet-600\\/25:hover{
  color: rgba(48, 109, 138, 0.25);
}

.hover\\:text-kids-alphabet-600\\/30:hover{
  color: rgba(48, 109, 138, 0.3);
}

.hover\\:text-kids-alphabet-600\\/35:hover{
  color: rgba(48, 109, 138, 0.35);
}

.hover\\:text-kids-alphabet-600\\/40:hover{
  color: rgba(48, 109, 138, 0.4);
}

.hover\\:text-kids-alphabet-600\\/45:hover{
  color: rgba(48, 109, 138, 0.45);
}

.hover\\:text-kids-alphabet-600\\/5:hover{
  color: rgba(48, 109, 138, 0.05);
}

.hover\\:text-kids-alphabet-600\\/50:hover{
  color: rgba(48, 109, 138, 0.5);
}

.hover\\:text-kids-alphabet-600\\/55:hover{
  color: rgba(48, 109, 138, 0.55);
}

.hover\\:text-kids-alphabet-600\\/60:hover{
  color: rgba(48, 109, 138, 0.6);
}

.hover\\:text-kids-alphabet-600\\/65:hover{
  color: rgba(48, 109, 138, 0.65);
}

.hover\\:text-kids-alphabet-600\\/70:hover{
  color: rgba(48, 109, 138, 0.7);
}

.hover\\:text-kids-alphabet-600\\/75:hover{
  color: rgba(48, 109, 138, 0.75);
}

.hover\\:text-kids-alphabet-600\\/80:hover{
  color: rgba(48, 109, 138, 0.8);
}

.hover\\:text-kids-alphabet-600\\/85:hover{
  color: rgba(48, 109, 138, 0.85);
}

.hover\\:text-kids-alphabet-600\\/90:hover{
  color: rgba(48, 109, 138, 0.9);
}

.hover\\:text-kids-alphabet-600\\/95:hover{
  color: rgba(48, 109, 138, 0.95);
}

.hover\\:text-kids-alphabet-700:hover{
  --tw-text-opacity: 1;
  color: rgba(45, 91, 114, 1);
  color: rgba(45, 91, 114, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-alphabet-700\\/0:hover{
  color: rgba(45, 91, 114, 0);
}

.hover\\:text-kids-alphabet-700\\/10:hover{
  color: rgba(45, 91, 114, 0.1);
}

.hover\\:text-kids-alphabet-700\\/100:hover{
  color: rgb(45, 91, 114);
}

.hover\\:text-kids-alphabet-700\\/15:hover{
  color: rgba(45, 91, 114, 0.15);
}

.hover\\:text-kids-alphabet-700\\/20:hover{
  color: rgba(45, 91, 114, 0.2);
}

.hover\\:text-kids-alphabet-700\\/25:hover{
  color: rgba(45, 91, 114, 0.25);
}

.hover\\:text-kids-alphabet-700\\/30:hover{
  color: rgba(45, 91, 114, 0.3);
}

.hover\\:text-kids-alphabet-700\\/35:hover{
  color: rgba(45, 91, 114, 0.35);
}

.hover\\:text-kids-alphabet-700\\/40:hover{
  color: rgba(45, 91, 114, 0.4);
}

.hover\\:text-kids-alphabet-700\\/45:hover{
  color: rgba(45, 91, 114, 0.45);
}

.hover\\:text-kids-alphabet-700\\/5:hover{
  color: rgba(45, 91, 114, 0.05);
}

.hover\\:text-kids-alphabet-700\\/50:hover{
  color: rgba(45, 91, 114, 0.5);
}

.hover\\:text-kids-alphabet-700\\/55:hover{
  color: rgba(45, 91, 114, 0.55);
}

.hover\\:text-kids-alphabet-700\\/60:hover{
  color: rgba(45, 91, 114, 0.6);
}

.hover\\:text-kids-alphabet-700\\/65:hover{
  color: rgba(45, 91, 114, 0.65);
}

.hover\\:text-kids-alphabet-700\\/70:hover{
  color: rgba(45, 91, 114, 0.7);
}

.hover\\:text-kids-alphabet-700\\/75:hover{
  color: rgba(45, 91, 114, 0.75);
}

.hover\\:text-kids-alphabet-700\\/80:hover{
  color: rgba(45, 91, 114, 0.8);
}

.hover\\:text-kids-alphabet-700\\/85:hover{
  color: rgba(45, 91, 114, 0.85);
}

.hover\\:text-kids-alphabet-700\\/90:hover{
  color: rgba(45, 91, 114, 0.9);
}

.hover\\:text-kids-alphabet-700\\/95:hover{
  color: rgba(45, 91, 114, 0.95);
}

.hover\\:text-kids-alphabet-800:hover{
  --tw-text-opacity: 1;
  color: rgba(44, 76, 94, 1);
  color: rgba(44, 76, 94, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-alphabet-800\\/0:hover{
  color: rgba(44, 76, 94, 0);
}

.hover\\:text-kids-alphabet-800\\/10:hover{
  color: rgba(44, 76, 94, 0.1);
}

.hover\\:text-kids-alphabet-800\\/100:hover{
  color: rgb(44, 76, 94);
}

.hover\\:text-kids-alphabet-800\\/15:hover{
  color: rgba(44, 76, 94, 0.15);
}

.hover\\:text-kids-alphabet-800\\/20:hover{
  color: rgba(44, 76, 94, 0.2);
}

.hover\\:text-kids-alphabet-800\\/25:hover{
  color: rgba(44, 76, 94, 0.25);
}

.hover\\:text-kids-alphabet-800\\/30:hover{
  color: rgba(44, 76, 94, 0.3);
}

.hover\\:text-kids-alphabet-800\\/35:hover{
  color: rgba(44, 76, 94, 0.35);
}

.hover\\:text-kids-alphabet-800\\/40:hover{
  color: rgba(44, 76, 94, 0.4);
}

.hover\\:text-kids-alphabet-800\\/45:hover{
  color: rgba(44, 76, 94, 0.45);
}

.hover\\:text-kids-alphabet-800\\/5:hover{
  color: rgba(44, 76, 94, 0.05);
}

.hover\\:text-kids-alphabet-800\\/50:hover{
  color: rgba(44, 76, 94, 0.5);
}

.hover\\:text-kids-alphabet-800\\/55:hover{
  color: rgba(44, 76, 94, 0.55);
}

.hover\\:text-kids-alphabet-800\\/60:hover{
  color: rgba(44, 76, 94, 0.6);
}

.hover\\:text-kids-alphabet-800\\/65:hover{
  color: rgba(44, 76, 94, 0.65);
}

.hover\\:text-kids-alphabet-800\\/70:hover{
  color: rgba(44, 76, 94, 0.7);
}

.hover\\:text-kids-alphabet-800\\/75:hover{
  color: rgba(44, 76, 94, 0.75);
}

.hover\\:text-kids-alphabet-800\\/80:hover{
  color: rgba(44, 76, 94, 0.8);
}

.hover\\:text-kids-alphabet-800\\/85:hover{
  color: rgba(44, 76, 94, 0.85);
}

.hover\\:text-kids-alphabet-800\\/90:hover{
  color: rgba(44, 76, 94, 0.9);
}

.hover\\:text-kids-alphabet-800\\/95:hover{
  color: rgba(44, 76, 94, 0.95);
}

.hover\\:text-kids-alphabet-900:hover{
  --tw-text-opacity: 1;
  color: rgba(40, 65, 81, 1);
  color: rgba(40, 65, 81, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-alphabet-900\\/0:hover{
  color: rgba(40, 65, 81, 0);
}

.hover\\:text-kids-alphabet-900\\/10:hover{
  color: rgba(40, 65, 81, 0.1);
}

.hover\\:text-kids-alphabet-900\\/100:hover{
  color: rgb(40, 65, 81);
}

.hover\\:text-kids-alphabet-900\\/15:hover{
  color: rgba(40, 65, 81, 0.15);
}

.hover\\:text-kids-alphabet-900\\/20:hover{
  color: rgba(40, 65, 81, 0.2);
}

.hover\\:text-kids-alphabet-900\\/25:hover{
  color: rgba(40, 65, 81, 0.25);
}

.hover\\:text-kids-alphabet-900\\/30:hover{
  color: rgba(40, 65, 81, 0.3);
}

.hover\\:text-kids-alphabet-900\\/35:hover{
  color: rgba(40, 65, 81, 0.35);
}

.hover\\:text-kids-alphabet-900\\/40:hover{
  color: rgba(40, 65, 81, 0.4);
}

.hover\\:text-kids-alphabet-900\\/45:hover{
  color: rgba(40, 65, 81, 0.45);
}

.hover\\:text-kids-alphabet-900\\/5:hover{
  color: rgba(40, 65, 81, 0.05);
}

.hover\\:text-kids-alphabet-900\\/50:hover{
  color: rgba(40, 65, 81, 0.5);
}

.hover\\:text-kids-alphabet-900\\/55:hover{
  color: rgba(40, 65, 81, 0.55);
}

.hover\\:text-kids-alphabet-900\\/60:hover{
  color: rgba(40, 65, 81, 0.6);
}

.hover\\:text-kids-alphabet-900\\/65:hover{
  color: rgba(40, 65, 81, 0.65);
}

.hover\\:text-kids-alphabet-900\\/70:hover{
  color: rgba(40, 65, 81, 0.7);
}

.hover\\:text-kids-alphabet-900\\/75:hover{
  color: rgba(40, 65, 81, 0.75);
}

.hover\\:text-kids-alphabet-900\\/80:hover{
  color: rgba(40, 65, 81, 0.8);
}

.hover\\:text-kids-alphabet-900\\/85:hover{
  color: rgba(40, 65, 81, 0.85);
}

.hover\\:text-kids-alphabet-900\\/90:hover{
  color: rgba(40, 65, 81, 0.9);
}

.hover\\:text-kids-alphabet-900\\/95:hover{
  color: rgba(40, 65, 81, 0.95);
}

.hover\\:text-kids-categories-500:hover{
  --tw-text-opacity: 1;
  color: rgba(209, 145, 47, 1);
  color: rgba(209, 145, 47, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-categories-500\\/0:hover{
  color: rgba(209, 145, 47, 0);
}

.hover\\:text-kids-categories-500\\/10:hover{
  color: rgba(209, 145, 47, 0.1);
}

.hover\\:text-kids-categories-500\\/100:hover{
  color: rgb(209, 145, 47);
}

.hover\\:text-kids-categories-500\\/15:hover{
  color: rgba(209, 145, 47, 0.15);
}

.hover\\:text-kids-categories-500\\/20:hover{
  color: rgba(209, 145, 47, 0.2);
}

.hover\\:text-kids-categories-500\\/25:hover{
  color: rgba(209, 145, 47, 0.25);
}

.hover\\:text-kids-categories-500\\/30:hover{
  color: rgba(209, 145, 47, 0.3);
}

.hover\\:text-kids-categories-500\\/35:hover{
  color: rgba(209, 145, 47, 0.35);
}

.hover\\:text-kids-categories-500\\/40:hover{
  color: rgba(209, 145, 47, 0.4);
}

.hover\\:text-kids-categories-500\\/45:hover{
  color: rgba(209, 145, 47, 0.45);
}

.hover\\:text-kids-categories-500\\/5:hover{
  color: rgba(209, 145, 47, 0.05);
}

.hover\\:text-kids-categories-500\\/50:hover{
  color: rgba(209, 145, 47, 0.5);
}

.hover\\:text-kids-categories-500\\/55:hover{
  color: rgba(209, 145, 47, 0.55);
}

.hover\\:text-kids-categories-500\\/60:hover{
  color: rgba(209, 145, 47, 0.6);
}

.hover\\:text-kids-categories-500\\/65:hover{
  color: rgba(209, 145, 47, 0.65);
}

.hover\\:text-kids-categories-500\\/70:hover{
  color: rgba(209, 145, 47, 0.7);
}

.hover\\:text-kids-categories-500\\/75:hover{
  color: rgba(209, 145, 47, 0.75);
}

.hover\\:text-kids-categories-500\\/80:hover{
  color: rgba(209, 145, 47, 0.8);
}

.hover\\:text-kids-categories-500\\/85:hover{
  color: rgba(209, 145, 47, 0.85);
}

.hover\\:text-kids-categories-500\\/90:hover{
  color: rgba(209, 145, 47, 0.9);
}

.hover\\:text-kids-categories-500\\/95:hover{
  color: rgba(209, 145, 47, 0.95);
}

.hover\\:text-kids-categories-600:hover{
  --tw-text-opacity: 1;
  color: rgba(195, 120, 41, 1);
  color: rgba(195, 120, 41, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-categories-600\\/0:hover{
  color: rgba(195, 120, 41, 0);
}

.hover\\:text-kids-categories-600\\/10:hover{
  color: rgba(195, 120, 41, 0.1);
}

.hover\\:text-kids-categories-600\\/100:hover{
  color: rgb(195, 120, 41);
}

.hover\\:text-kids-categories-600\\/15:hover{
  color: rgba(195, 120, 41, 0.15);
}

.hover\\:text-kids-categories-600\\/20:hover{
  color: rgba(195, 120, 41, 0.2);
}

.hover\\:text-kids-categories-600\\/25:hover{
  color: rgba(195, 120, 41, 0.25);
}

.hover\\:text-kids-categories-600\\/30:hover{
  color: rgba(195, 120, 41, 0.3);
}

.hover\\:text-kids-categories-600\\/35:hover{
  color: rgba(195, 120, 41, 0.35);
}

.hover\\:text-kids-categories-600\\/40:hover{
  color: rgba(195, 120, 41, 0.4);
}

.hover\\:text-kids-categories-600\\/45:hover{
  color: rgba(195, 120, 41, 0.45);
}

.hover\\:text-kids-categories-600\\/5:hover{
  color: rgba(195, 120, 41, 0.05);
}

.hover\\:text-kids-categories-600\\/50:hover{
  color: rgba(195, 120, 41, 0.5);
}

.hover\\:text-kids-categories-600\\/55:hover{
  color: rgba(195, 120, 41, 0.55);
}

.hover\\:text-kids-categories-600\\/60:hover{
  color: rgba(195, 120, 41, 0.6);
}

.hover\\:text-kids-categories-600\\/65:hover{
  color: rgba(195, 120, 41, 0.65);
}

.hover\\:text-kids-categories-600\\/70:hover{
  color: rgba(195, 120, 41, 0.7);
}

.hover\\:text-kids-categories-600\\/75:hover{
  color: rgba(195, 120, 41, 0.75);
}

.hover\\:text-kids-categories-600\\/80:hover{
  color: rgba(195, 120, 41, 0.8);
}

.hover\\:text-kids-categories-600\\/85:hover{
  color: rgba(195, 120, 41, 0.85);
}

.hover\\:text-kids-categories-600\\/90:hover{
  color: rgba(195, 120, 41, 0.9);
}

.hover\\:text-kids-categories-600\\/95:hover{
  color: rgba(195, 120, 41, 0.95);
}

.hover\\:text-kids-categories-700:hover{
  --tw-text-opacity: 1;
  color: rgba(153, 84, 36, 1);
  color: rgba(153, 84, 36, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-categories-700\\/0:hover{
  color: rgba(153, 84, 36, 0);
}

.hover\\:text-kids-categories-700\\/10:hover{
  color: rgba(153, 84, 36, 0.1);
}

.hover\\:text-kids-categories-700\\/100:hover{
  color: rgb(153, 84, 36);
}

.hover\\:text-kids-categories-700\\/15:hover{
  color: rgba(153, 84, 36, 0.15);
}

.hover\\:text-kids-categories-700\\/20:hover{
  color: rgba(153, 84, 36, 0.2);
}

.hover\\:text-kids-categories-700\\/25:hover{
  color: rgba(153, 84, 36, 0.25);
}

.hover\\:text-kids-categories-700\\/30:hover{
  color: rgba(153, 84, 36, 0.3);
}

.hover\\:text-kids-categories-700\\/35:hover{
  color: rgba(153, 84, 36, 0.35);
}

.hover\\:text-kids-categories-700\\/40:hover{
  color: rgba(153, 84, 36, 0.4);
}

.hover\\:text-kids-categories-700\\/45:hover{
  color: rgba(153, 84, 36, 0.45);
}

.hover\\:text-kids-categories-700\\/5:hover{
  color: rgba(153, 84, 36, 0.05);
}

.hover\\:text-kids-categories-700\\/50:hover{
  color: rgba(153, 84, 36, 0.5);
}

.hover\\:text-kids-categories-700\\/55:hover{
  color: rgba(153, 84, 36, 0.55);
}

.hover\\:text-kids-categories-700\\/60:hover{
  color: rgba(153, 84, 36, 0.6);
}

.hover\\:text-kids-categories-700\\/65:hover{
  color: rgba(153, 84, 36, 0.65);
}

.hover\\:text-kids-categories-700\\/70:hover{
  color: rgba(153, 84, 36, 0.7);
}

.hover\\:text-kids-categories-700\\/75:hover{
  color: rgba(153, 84, 36, 0.75);
}

.hover\\:text-kids-categories-700\\/80:hover{
  color: rgba(153, 84, 36, 0.8);
}

.hover\\:text-kids-categories-700\\/85:hover{
  color: rgba(153, 84, 36, 0.85);
}

.hover\\:text-kids-categories-700\\/90:hover{
  color: rgba(153, 84, 36, 0.9);
}

.hover\\:text-kids-categories-700\\/95:hover{
  color: rgba(153, 84, 36, 0.95);
}

.hover\\:text-kids-categories-800:hover{
  --tw-text-opacity: 1;
  color: rgba(126, 67, 34, 1);
  color: rgba(126, 67, 34, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-categories-800\\/0:hover{
  color: rgba(126, 67, 34, 0);
}

.hover\\:text-kids-categories-800\\/10:hover{
  color: rgba(126, 67, 34, 0.1);
}

.hover\\:text-kids-categories-800\\/100:hover{
  color: rgb(126, 67, 34);
}

.hover\\:text-kids-categories-800\\/15:hover{
  color: rgba(126, 67, 34, 0.15);
}

.hover\\:text-kids-categories-800\\/20:hover{
  color: rgba(126, 67, 34, 0.2);
}

.hover\\:text-kids-categories-800\\/25:hover{
  color: rgba(126, 67, 34, 0.25);
}

.hover\\:text-kids-categories-800\\/30:hover{
  color: rgba(126, 67, 34, 0.3);
}

.hover\\:text-kids-categories-800\\/35:hover{
  color: rgba(126, 67, 34, 0.35);
}

.hover\\:text-kids-categories-800\\/40:hover{
  color: rgba(126, 67, 34, 0.4);
}

.hover\\:text-kids-categories-800\\/45:hover{
  color: rgba(126, 67, 34, 0.45);
}

.hover\\:text-kids-categories-800\\/5:hover{
  color: rgba(126, 67, 34, 0.05);
}

.hover\\:text-kids-categories-800\\/50:hover{
  color: rgba(126, 67, 34, 0.5);
}

.hover\\:text-kids-categories-800\\/55:hover{
  color: rgba(126, 67, 34, 0.55);
}

.hover\\:text-kids-categories-800\\/60:hover{
  color: rgba(126, 67, 34, 0.6);
}

.hover\\:text-kids-categories-800\\/65:hover{
  color: rgba(126, 67, 34, 0.65);
}

.hover\\:text-kids-categories-800\\/70:hover{
  color: rgba(126, 67, 34, 0.7);
}

.hover\\:text-kids-categories-800\\/75:hover{
  color: rgba(126, 67, 34, 0.75);
}

.hover\\:text-kids-categories-800\\/80:hover{
  color: rgba(126, 67, 34, 0.8);
}

.hover\\:text-kids-categories-800\\/85:hover{
  color: rgba(126, 67, 34, 0.85);
}

.hover\\:text-kids-categories-800\\/90:hover{
  color: rgba(126, 67, 34, 0.9);
}

.hover\\:text-kids-categories-800\\/95:hover{
  color: rgba(126, 67, 34, 0.95);
}

.hover\\:text-kids-categories-900:hover{
  --tw-text-opacity: 1;
  color: rgba(104, 56, 31, 1);
  color: rgba(104, 56, 31, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-categories-900\\/0:hover{
  color: rgba(104, 56, 31, 0);
}

.hover\\:text-kids-categories-900\\/10:hover{
  color: rgba(104, 56, 31, 0.1);
}

.hover\\:text-kids-categories-900\\/100:hover{
  color: rgb(104, 56, 31);
}

.hover\\:text-kids-categories-900\\/15:hover{
  color: rgba(104, 56, 31, 0.15);
}

.hover\\:text-kids-categories-900\\/20:hover{
  color: rgba(104, 56, 31, 0.2);
}

.hover\\:text-kids-categories-900\\/25:hover{
  color: rgba(104, 56, 31, 0.25);
}

.hover\\:text-kids-categories-900\\/30:hover{
  color: rgba(104, 56, 31, 0.3);
}

.hover\\:text-kids-categories-900\\/35:hover{
  color: rgba(104, 56, 31, 0.35);
}

.hover\\:text-kids-categories-900\\/40:hover{
  color: rgba(104, 56, 31, 0.4);
}

.hover\\:text-kids-categories-900\\/45:hover{
  color: rgba(104, 56, 31, 0.45);
}

.hover\\:text-kids-categories-900\\/5:hover{
  color: rgba(104, 56, 31, 0.05);
}

.hover\\:text-kids-categories-900\\/50:hover{
  color: rgba(104, 56, 31, 0.5);
}

.hover\\:text-kids-categories-900\\/55:hover{
  color: rgba(104, 56, 31, 0.55);
}

.hover\\:text-kids-categories-900\\/60:hover{
  color: rgba(104, 56, 31, 0.6);
}

.hover\\:text-kids-categories-900\\/65:hover{
  color: rgba(104, 56, 31, 0.65);
}

.hover\\:text-kids-categories-900\\/70:hover{
  color: rgba(104, 56, 31, 0.7);
}

.hover\\:text-kids-categories-900\\/75:hover{
  color: rgba(104, 56, 31, 0.75);
}

.hover\\:text-kids-categories-900\\/80:hover{
  color: rgba(104, 56, 31, 0.8);
}

.hover\\:text-kids-categories-900\\/85:hover{
  color: rgba(104, 56, 31, 0.85);
}

.hover\\:text-kids-categories-900\\/90:hover{
  color: rgba(104, 56, 31, 0.9);
}

.hover\\:text-kids-categories-900\\/95:hover{
  color: rgba(104, 56, 31, 0.95);
}

.hover\\:text-kids-dictionary-500:hover{
  --tw-text-opacity: 1;
  color: rgba(44, 135, 109, 1);
  color: rgba(44, 135, 109, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-dictionary-500\\/0:hover{
  color: rgba(44, 135, 109, 0);
}

.hover\\:text-kids-dictionary-500\\/10:hover{
  color: rgba(44, 135, 109, 0.1);
}

.hover\\:text-kids-dictionary-500\\/100:hover{
  color: rgb(44, 135, 109);
}

.hover\\:text-kids-dictionary-500\\/15:hover{
  color: rgba(44, 135, 109, 0.15);
}

.hover\\:text-kids-dictionary-500\\/20:hover{
  color: rgba(44, 135, 109, 0.2);
}

.hover\\:text-kids-dictionary-500\\/25:hover{
  color: rgba(44, 135, 109, 0.25);
}

.hover\\:text-kids-dictionary-500\\/30:hover{
  color: rgba(44, 135, 109, 0.3);
}

.hover\\:text-kids-dictionary-500\\/35:hover{
  color: rgba(44, 135, 109, 0.35);
}

.hover\\:text-kids-dictionary-500\\/40:hover{
  color: rgba(44, 135, 109, 0.4);
}

.hover\\:text-kids-dictionary-500\\/45:hover{
  color: rgba(44, 135, 109, 0.45);
}

.hover\\:text-kids-dictionary-500\\/5:hover{
  color: rgba(44, 135, 109, 0.05);
}

.hover\\:text-kids-dictionary-500\\/50:hover{
  color: rgba(44, 135, 109, 0.5);
}

.hover\\:text-kids-dictionary-500\\/55:hover{
  color: rgba(44, 135, 109, 0.55);
}

.hover\\:text-kids-dictionary-500\\/60:hover{
  color: rgba(44, 135, 109, 0.6);
}

.hover\\:text-kids-dictionary-500\\/65:hover{
  color: rgba(44, 135, 109, 0.65);
}

.hover\\:text-kids-dictionary-500\\/70:hover{
  color: rgba(44, 135, 109, 0.7);
}

.hover\\:text-kids-dictionary-500\\/75:hover{
  color: rgba(44, 135, 109, 0.75);
}

.hover\\:text-kids-dictionary-500\\/80:hover{
  color: rgba(44, 135, 109, 0.8);
}

.hover\\:text-kids-dictionary-500\\/85:hover{
  color: rgba(44, 135, 109, 0.85);
}

.hover\\:text-kids-dictionary-500\\/90:hover{
  color: rgba(44, 135, 109, 0.9);
}

.hover\\:text-kids-dictionary-500\\/95:hover{
  color: rgba(44, 135, 109, 0.95);
}

.hover\\:text-kids-dictionary-600:hover{
  --tw-text-opacity: 1;
  color: rgba(34, 121, 98, 1);
  color: rgba(34, 121, 98, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-dictionary-600\\/0:hover{
  color: rgba(34, 121, 98, 0);
}

.hover\\:text-kids-dictionary-600\\/10:hover{
  color: rgba(34, 121, 98, 0.1);
}

.hover\\:text-kids-dictionary-600\\/100:hover{
  color: rgb(34, 121, 98);
}

.hover\\:text-kids-dictionary-600\\/15:hover{
  color: rgba(34, 121, 98, 0.15);
}

.hover\\:text-kids-dictionary-600\\/20:hover{
  color: rgba(34, 121, 98, 0.2);
}

.hover\\:text-kids-dictionary-600\\/25:hover{
  color: rgba(34, 121, 98, 0.25);
}

.hover\\:text-kids-dictionary-600\\/30:hover{
  color: rgba(34, 121, 98, 0.3);
}

.hover\\:text-kids-dictionary-600\\/35:hover{
  color: rgba(34, 121, 98, 0.35);
}

.hover\\:text-kids-dictionary-600\\/40:hover{
  color: rgba(34, 121, 98, 0.4);
}

.hover\\:text-kids-dictionary-600\\/45:hover{
  color: rgba(34, 121, 98, 0.45);
}

.hover\\:text-kids-dictionary-600\\/5:hover{
  color: rgba(34, 121, 98, 0.05);
}

.hover\\:text-kids-dictionary-600\\/50:hover{
  color: rgba(34, 121, 98, 0.5);
}

.hover\\:text-kids-dictionary-600\\/55:hover{
  color: rgba(34, 121, 98, 0.55);
}

.hover\\:text-kids-dictionary-600\\/60:hover{
  color: rgba(34, 121, 98, 0.6);
}

.hover\\:text-kids-dictionary-600\\/65:hover{
  color: rgba(34, 121, 98, 0.65);
}

.hover\\:text-kids-dictionary-600\\/70:hover{
  color: rgba(34, 121, 98, 0.7);
}

.hover\\:text-kids-dictionary-600\\/75:hover{
  color: rgba(34, 121, 98, 0.75);
}

.hover\\:text-kids-dictionary-600\\/80:hover{
  color: rgba(34, 121, 98, 0.8);
}

.hover\\:text-kids-dictionary-600\\/85:hover{
  color: rgba(34, 121, 98, 0.85);
}

.hover\\:text-kids-dictionary-600\\/90:hover{
  color: rgba(34, 121, 98, 0.9);
}

.hover\\:text-kids-dictionary-600\\/95:hover{
  color: rgba(34, 121, 98, 0.95);
}

.hover\\:text-kids-dictionary-700:hover{
  --tw-text-opacity: 1;
  color: rgba(27, 97, 80, 1);
  color: rgba(27, 97, 80, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-dictionary-700\\/0:hover{
  color: rgba(27, 97, 80, 0);
}

.hover\\:text-kids-dictionary-700\\/10:hover{
  color: rgba(27, 97, 80, 0.1);
}

.hover\\:text-kids-dictionary-700\\/100:hover{
  color: rgb(27, 97, 80);
}

.hover\\:text-kids-dictionary-700\\/15:hover{
  color: rgba(27, 97, 80, 0.15);
}

.hover\\:text-kids-dictionary-700\\/20:hover{
  color: rgba(27, 97, 80, 0.2);
}

.hover\\:text-kids-dictionary-700\\/25:hover{
  color: rgba(27, 97, 80, 0.25);
}

.hover\\:text-kids-dictionary-700\\/30:hover{
  color: rgba(27, 97, 80, 0.3);
}

.hover\\:text-kids-dictionary-700\\/35:hover{
  color: rgba(27, 97, 80, 0.35);
}

.hover\\:text-kids-dictionary-700\\/40:hover{
  color: rgba(27, 97, 80, 0.4);
}

.hover\\:text-kids-dictionary-700\\/45:hover{
  color: rgba(27, 97, 80, 0.45);
}

.hover\\:text-kids-dictionary-700\\/5:hover{
  color: rgba(27, 97, 80, 0.05);
}

.hover\\:text-kids-dictionary-700\\/50:hover{
  color: rgba(27, 97, 80, 0.5);
}

.hover\\:text-kids-dictionary-700\\/55:hover{
  color: rgba(27, 97, 80, 0.55);
}

.hover\\:text-kids-dictionary-700\\/60:hover{
  color: rgba(27, 97, 80, 0.6);
}

.hover\\:text-kids-dictionary-700\\/65:hover{
  color: rgba(27, 97, 80, 0.65);
}

.hover\\:text-kids-dictionary-700\\/70:hover{
  color: rgba(27, 97, 80, 0.7);
}

.hover\\:text-kids-dictionary-700\\/75:hover{
  color: rgba(27, 97, 80, 0.75);
}

.hover\\:text-kids-dictionary-700\\/80:hover{
  color: rgba(27, 97, 80, 0.8);
}

.hover\\:text-kids-dictionary-700\\/85:hover{
  color: rgba(27, 97, 80, 0.85);
}

.hover\\:text-kids-dictionary-700\\/90:hover{
  color: rgba(27, 97, 80, 0.9);
}

.hover\\:text-kids-dictionary-700\\/95:hover{
  color: rgba(27, 97, 80, 0.95);
}

.hover\\:text-kids-dictionary-800:hover{
  --tw-text-opacity: 1;
  color: rgba(24, 77, 64, 1);
  color: rgba(24, 77, 64, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-dictionary-800\\/0:hover{
  color: rgba(24, 77, 64, 0);
}

.hover\\:text-kids-dictionary-800\\/10:hover{
  color: rgba(24, 77, 64, 0.1);
}

.hover\\:text-kids-dictionary-800\\/100:hover{
  color: rgb(24, 77, 64);
}

.hover\\:text-kids-dictionary-800\\/15:hover{
  color: rgba(24, 77, 64, 0.15);
}

.hover\\:text-kids-dictionary-800\\/20:hover{
  color: rgba(24, 77, 64, 0.2);
}

.hover\\:text-kids-dictionary-800\\/25:hover{
  color: rgba(24, 77, 64, 0.25);
}

.hover\\:text-kids-dictionary-800\\/30:hover{
  color: rgba(24, 77, 64, 0.3);
}

.hover\\:text-kids-dictionary-800\\/35:hover{
  color: rgba(24, 77, 64, 0.35);
}

.hover\\:text-kids-dictionary-800\\/40:hover{
  color: rgba(24, 77, 64, 0.4);
}

.hover\\:text-kids-dictionary-800\\/45:hover{
  color: rgba(24, 77, 64, 0.45);
}

.hover\\:text-kids-dictionary-800\\/5:hover{
  color: rgba(24, 77, 64, 0.05);
}

.hover\\:text-kids-dictionary-800\\/50:hover{
  color: rgba(24, 77, 64, 0.5);
}

.hover\\:text-kids-dictionary-800\\/55:hover{
  color: rgba(24, 77, 64, 0.55);
}

.hover\\:text-kids-dictionary-800\\/60:hover{
  color: rgba(24, 77, 64, 0.6);
}

.hover\\:text-kids-dictionary-800\\/65:hover{
  color: rgba(24, 77, 64, 0.65);
}

.hover\\:text-kids-dictionary-800\\/70:hover{
  color: rgba(24, 77, 64, 0.7);
}

.hover\\:text-kids-dictionary-800\\/75:hover{
  color: rgba(24, 77, 64, 0.75);
}

.hover\\:text-kids-dictionary-800\\/80:hover{
  color: rgba(24, 77, 64, 0.8);
}

.hover\\:text-kids-dictionary-800\\/85:hover{
  color: rgba(24, 77, 64, 0.85);
}

.hover\\:text-kids-dictionary-800\\/90:hover{
  color: rgba(24, 77, 64, 0.9);
}

.hover\\:text-kids-dictionary-800\\/95:hover{
  color: rgba(24, 77, 64, 0.95);
}

.hover\\:text-kids-dictionary-900:hover{
  --tw-text-opacity: 1;
  color: rgba(20, 64, 54, 1);
  color: rgba(20, 64, 54, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-dictionary-900\\/0:hover{
  color: rgba(20, 64, 54, 0);
}

.hover\\:text-kids-dictionary-900\\/10:hover{
  color: rgba(20, 64, 54, 0.1);
}

.hover\\:text-kids-dictionary-900\\/100:hover{
  color: rgb(20, 64, 54);
}

.hover\\:text-kids-dictionary-900\\/15:hover{
  color: rgba(20, 64, 54, 0.15);
}

.hover\\:text-kids-dictionary-900\\/20:hover{
  color: rgba(20, 64, 54, 0.2);
}

.hover\\:text-kids-dictionary-900\\/25:hover{
  color: rgba(20, 64, 54, 0.25);
}

.hover\\:text-kids-dictionary-900\\/30:hover{
  color: rgba(20, 64, 54, 0.3);
}

.hover\\:text-kids-dictionary-900\\/35:hover{
  color: rgba(20, 64, 54, 0.35);
}

.hover\\:text-kids-dictionary-900\\/40:hover{
  color: rgba(20, 64, 54, 0.4);
}

.hover\\:text-kids-dictionary-900\\/45:hover{
  color: rgba(20, 64, 54, 0.45);
}

.hover\\:text-kids-dictionary-900\\/5:hover{
  color: rgba(20, 64, 54, 0.05);
}

.hover\\:text-kids-dictionary-900\\/50:hover{
  color: rgba(20, 64, 54, 0.5);
}

.hover\\:text-kids-dictionary-900\\/55:hover{
  color: rgba(20, 64, 54, 0.55);
}

.hover\\:text-kids-dictionary-900\\/60:hover{
  color: rgba(20, 64, 54, 0.6);
}

.hover\\:text-kids-dictionary-900\\/65:hover{
  color: rgba(20, 64, 54, 0.65);
}

.hover\\:text-kids-dictionary-900\\/70:hover{
  color: rgba(20, 64, 54, 0.7);
}

.hover\\:text-kids-dictionary-900\\/75:hover{
  color: rgba(20, 64, 54, 0.75);
}

.hover\\:text-kids-dictionary-900\\/80:hover{
  color: rgba(20, 64, 54, 0.8);
}

.hover\\:text-kids-dictionary-900\\/85:hover{
  color: rgba(20, 64, 54, 0.85);
}

.hover\\:text-kids-dictionary-900\\/90:hover{
  color: rgba(20, 64, 54, 0.9);
}

.hover\\:text-kids-dictionary-900\\/95:hover{
  color: rgba(20, 64, 54, 0.95);
}

.hover\\:text-kids-games-500:hover{
  --tw-text-opacity: 1;
  color: rgba(81, 59, 86, 1);
  color: rgba(81, 59, 86, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-games-500\\/0:hover{
  color: rgba(81, 59, 86, 0);
}

.hover\\:text-kids-games-500\\/10:hover{
  color: rgba(81, 59, 86, 0.1);
}

.hover\\:text-kids-games-500\\/100:hover{
  color: rgb(81, 59, 86);
}

.hover\\:text-kids-games-500\\/15:hover{
  color: rgba(81, 59, 86, 0.15);
}

.hover\\:text-kids-games-500\\/20:hover{
  color: rgba(81, 59, 86, 0.2);
}

.hover\\:text-kids-games-500\\/25:hover{
  color: rgba(81, 59, 86, 0.25);
}

.hover\\:text-kids-games-500\\/30:hover{
  color: rgba(81, 59, 86, 0.3);
}

.hover\\:text-kids-games-500\\/35:hover{
  color: rgba(81, 59, 86, 0.35);
}

.hover\\:text-kids-games-500\\/40:hover{
  color: rgba(81, 59, 86, 0.4);
}

.hover\\:text-kids-games-500\\/45:hover{
  color: rgba(81, 59, 86, 0.45);
}

.hover\\:text-kids-games-500\\/5:hover{
  color: rgba(81, 59, 86, 0.05);
}

.hover\\:text-kids-games-500\\/50:hover{
  color: rgba(81, 59, 86, 0.5);
}

.hover\\:text-kids-games-500\\/55:hover{
  color: rgba(81, 59, 86, 0.55);
}

.hover\\:text-kids-games-500\\/60:hover{
  color: rgba(81, 59, 86, 0.6);
}

.hover\\:text-kids-games-500\\/65:hover{
  color: rgba(81, 59, 86, 0.65);
}

.hover\\:text-kids-games-500\\/70:hover{
  color: rgba(81, 59, 86, 0.7);
}

.hover\\:text-kids-games-500\\/75:hover{
  color: rgba(81, 59, 86, 0.75);
}

.hover\\:text-kids-games-500\\/80:hover{
  color: rgba(81, 59, 86, 0.8);
}

.hover\\:text-kids-games-500\\/85:hover{
  color: rgba(81, 59, 86, 0.85);
}

.hover\\:text-kids-games-500\\/90:hover{
  color: rgba(81, 59, 86, 0.9);
}

.hover\\:text-kids-games-500\\/95:hover{
  color: rgba(81, 59, 86, 0.95);
}

.hover\\:text-kids-games-900:hover{
  --tw-text-opacity: 1;
  color: rgba(57, 41, 60, 1);
  color: rgba(57, 41, 60, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-games-900\\/0:hover{
  color: rgba(57, 41, 60, 0);
}

.hover\\:text-kids-games-900\\/10:hover{
  color: rgba(57, 41, 60, 0.1);
}

.hover\\:text-kids-games-900\\/100:hover{
  color: rgb(57, 41, 60);
}

.hover\\:text-kids-games-900\\/15:hover{
  color: rgba(57, 41, 60, 0.15);
}

.hover\\:text-kids-games-900\\/20:hover{
  color: rgba(57, 41, 60, 0.2);
}

.hover\\:text-kids-games-900\\/25:hover{
  color: rgba(57, 41, 60, 0.25);
}

.hover\\:text-kids-games-900\\/30:hover{
  color: rgba(57, 41, 60, 0.3);
}

.hover\\:text-kids-games-900\\/35:hover{
  color: rgba(57, 41, 60, 0.35);
}

.hover\\:text-kids-games-900\\/40:hover{
  color: rgba(57, 41, 60, 0.4);
}

.hover\\:text-kids-games-900\\/45:hover{
  color: rgba(57, 41, 60, 0.45);
}

.hover\\:text-kids-games-900\\/5:hover{
  color: rgba(57, 41, 60, 0.05);
}

.hover\\:text-kids-games-900\\/50:hover{
  color: rgba(57, 41, 60, 0.5);
}

.hover\\:text-kids-games-900\\/55:hover{
  color: rgba(57, 41, 60, 0.55);
}

.hover\\:text-kids-games-900\\/60:hover{
  color: rgba(57, 41, 60, 0.6);
}

.hover\\:text-kids-games-900\\/65:hover{
  color: rgba(57, 41, 60, 0.65);
}

.hover\\:text-kids-games-900\\/70:hover{
  color: rgba(57, 41, 60, 0.7);
}

.hover\\:text-kids-games-900\\/75:hover{
  color: rgba(57, 41, 60, 0.75);
}

.hover\\:text-kids-games-900\\/80:hover{
  color: rgba(57, 41, 60, 0.8);
}

.hover\\:text-kids-games-900\\/85:hover{
  color: rgba(57, 41, 60, 0.85);
}

.hover\\:text-kids-games-900\\/90:hover{
  color: rgba(57, 41, 60, 0.9);
}

.hover\\:text-kids-games-900\\/95:hover{
  color: rgba(57, 41, 60, 0.95);
}

.hover\\:text-kids-songs-500:hover{
  --tw-text-opacity: 1;
  color: rgba(131, 0, 66, 1);
  color: rgba(131, 0, 66, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-songs-500\\/0:hover{
  color: rgba(131, 0, 66, 0);
}

.hover\\:text-kids-songs-500\\/10:hover{
  color: rgba(131, 0, 66, 0.1);
}

.hover\\:text-kids-songs-500\\/100:hover{
  color: rgb(131, 0, 66);
}

.hover\\:text-kids-songs-500\\/15:hover{
  color: rgba(131, 0, 66, 0.15);
}

.hover\\:text-kids-songs-500\\/20:hover{
  color: rgba(131, 0, 66, 0.2);
}

.hover\\:text-kids-songs-500\\/25:hover{
  color: rgba(131, 0, 66, 0.25);
}

.hover\\:text-kids-songs-500\\/30:hover{
  color: rgba(131, 0, 66, 0.3);
}

.hover\\:text-kids-songs-500\\/35:hover{
  color: rgba(131, 0, 66, 0.35);
}

.hover\\:text-kids-songs-500\\/40:hover{
  color: rgba(131, 0, 66, 0.4);
}

.hover\\:text-kids-songs-500\\/45:hover{
  color: rgba(131, 0, 66, 0.45);
}

.hover\\:text-kids-songs-500\\/5:hover{
  color: rgba(131, 0, 66, 0.05);
}

.hover\\:text-kids-songs-500\\/50:hover{
  color: rgba(131, 0, 66, 0.5);
}

.hover\\:text-kids-songs-500\\/55:hover{
  color: rgba(131, 0, 66, 0.55);
}

.hover\\:text-kids-songs-500\\/60:hover{
  color: rgba(131, 0, 66, 0.6);
}

.hover\\:text-kids-songs-500\\/65:hover{
  color: rgba(131, 0, 66, 0.65);
}

.hover\\:text-kids-songs-500\\/70:hover{
  color: rgba(131, 0, 66, 0.7);
}

.hover\\:text-kids-songs-500\\/75:hover{
  color: rgba(131, 0, 66, 0.75);
}

.hover\\:text-kids-songs-500\\/80:hover{
  color: rgba(131, 0, 66, 0.8);
}

.hover\\:text-kids-songs-500\\/85:hover{
  color: rgba(131, 0, 66, 0.85);
}

.hover\\:text-kids-songs-500\\/90:hover{
  color: rgba(131, 0, 66, 0.9);
}

.hover\\:text-kids-songs-500\\/95:hover{
  color: rgba(131, 0, 66, 0.95);
}

.hover\\:text-kids-songs-900:hover{
  --tw-text-opacity: 1;
  color: rgba(92, 0, 46, 1);
  color: rgba(92, 0, 46, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-songs-900\\/0:hover{
  color: rgba(92, 0, 46, 0);
}

.hover\\:text-kids-songs-900\\/10:hover{
  color: rgba(92, 0, 46, 0.1);
}

.hover\\:text-kids-songs-900\\/100:hover{
  color: rgb(92, 0, 46);
}

.hover\\:text-kids-songs-900\\/15:hover{
  color: rgba(92, 0, 46, 0.15);
}

.hover\\:text-kids-songs-900\\/20:hover{
  color: rgba(92, 0, 46, 0.2);
}

.hover\\:text-kids-songs-900\\/25:hover{
  color: rgba(92, 0, 46, 0.25);
}

.hover\\:text-kids-songs-900\\/30:hover{
  color: rgba(92, 0, 46, 0.3);
}

.hover\\:text-kids-songs-900\\/35:hover{
  color: rgba(92, 0, 46, 0.35);
}

.hover\\:text-kids-songs-900\\/40:hover{
  color: rgba(92, 0, 46, 0.4);
}

.hover\\:text-kids-songs-900\\/45:hover{
  color: rgba(92, 0, 46, 0.45);
}

.hover\\:text-kids-songs-900\\/5:hover{
  color: rgba(92, 0, 46, 0.05);
}

.hover\\:text-kids-songs-900\\/50:hover{
  color: rgba(92, 0, 46, 0.5);
}

.hover\\:text-kids-songs-900\\/55:hover{
  color: rgba(92, 0, 46, 0.55);
}

.hover\\:text-kids-songs-900\\/60:hover{
  color: rgba(92, 0, 46, 0.6);
}

.hover\\:text-kids-songs-900\\/65:hover{
  color: rgba(92, 0, 46, 0.65);
}

.hover\\:text-kids-songs-900\\/70:hover{
  color: rgba(92, 0, 46, 0.7);
}

.hover\\:text-kids-songs-900\\/75:hover{
  color: rgba(92, 0, 46, 0.75);
}

.hover\\:text-kids-songs-900\\/80:hover{
  color: rgba(92, 0, 46, 0.8);
}

.hover\\:text-kids-songs-900\\/85:hover{
  color: rgba(92, 0, 46, 0.85);
}

.hover\\:text-kids-songs-900\\/90:hover{
  color: rgba(92, 0, 46, 0.9);
}

.hover\\:text-kids-songs-900\\/95:hover{
  color: rgba(92, 0, 46, 0.95);
}

.hover\\:text-kids-stories-500:hover{
  --tw-text-opacity: 1;
  color: rgba(233, 196, 106, 1);
  color: rgba(233, 196, 106, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-stories-500\\/0:hover{
  color: rgba(233, 196, 106, 0);
}

.hover\\:text-kids-stories-500\\/10:hover{
  color: rgba(233, 196, 106, 0.1);
}

.hover\\:text-kids-stories-500\\/100:hover{
  color: rgb(233, 196, 106);
}

.hover\\:text-kids-stories-500\\/15:hover{
  color: rgba(233, 196, 106, 0.15);
}

.hover\\:text-kids-stories-500\\/20:hover{
  color: rgba(233, 196, 106, 0.2);
}

.hover\\:text-kids-stories-500\\/25:hover{
  color: rgba(233, 196, 106, 0.25);
}

.hover\\:text-kids-stories-500\\/30:hover{
  color: rgba(233, 196, 106, 0.3);
}

.hover\\:text-kids-stories-500\\/35:hover{
  color: rgba(233, 196, 106, 0.35);
}

.hover\\:text-kids-stories-500\\/40:hover{
  color: rgba(233, 196, 106, 0.4);
}

.hover\\:text-kids-stories-500\\/45:hover{
  color: rgba(233, 196, 106, 0.45);
}

.hover\\:text-kids-stories-500\\/5:hover{
  color: rgba(233, 196, 106, 0.05);
}

.hover\\:text-kids-stories-500\\/50:hover{
  color: rgba(233, 196, 106, 0.5);
}

.hover\\:text-kids-stories-500\\/55:hover{
  color: rgba(233, 196, 106, 0.55);
}

.hover\\:text-kids-stories-500\\/60:hover{
  color: rgba(233, 196, 106, 0.6);
}

.hover\\:text-kids-stories-500\\/65:hover{
  color: rgba(233, 196, 106, 0.65);
}

.hover\\:text-kids-stories-500\\/70:hover{
  color: rgba(233, 196, 106, 0.7);
}

.hover\\:text-kids-stories-500\\/75:hover{
  color: rgba(233, 196, 106, 0.75);
}

.hover\\:text-kids-stories-500\\/80:hover{
  color: rgba(233, 196, 106, 0.8);
}

.hover\\:text-kids-stories-500\\/85:hover{
  color: rgba(233, 196, 106, 0.85);
}

.hover\\:text-kids-stories-500\\/90:hover{
  color: rgba(233, 196, 106, 0.9);
}

.hover\\:text-kids-stories-500\\/95:hover{
  color: rgba(233, 196, 106, 0.95);
}

.hover\\:text-kids-stories-900:hover{
  --tw-text-opacity: 1;
  color: rgba(163, 137, 74, 1);
  color: rgba(163, 137, 74, var(--tw-text-opacity, 1));
}

.hover\\:text-kids-stories-900\\/0:hover{
  color: rgba(163, 137, 74, 0);
}

.hover\\:text-kids-stories-900\\/10:hover{
  color: rgba(163, 137, 74, 0.1);
}

.hover\\:text-kids-stories-900\\/100:hover{
  color: rgb(163, 137, 74);
}

.hover\\:text-kids-stories-900\\/15:hover{
  color: rgba(163, 137, 74, 0.15);
}

.hover\\:text-kids-stories-900\\/20:hover{
  color: rgba(163, 137, 74, 0.2);
}

.hover\\:text-kids-stories-900\\/25:hover{
  color: rgba(163, 137, 74, 0.25);
}

.hover\\:text-kids-stories-900\\/30:hover{
  color: rgba(163, 137, 74, 0.3);
}

.hover\\:text-kids-stories-900\\/35:hover{
  color: rgba(163, 137, 74, 0.35);
}

.hover\\:text-kids-stories-900\\/40:hover{
  color: rgba(163, 137, 74, 0.4);
}

.hover\\:text-kids-stories-900\\/45:hover{
  color: rgba(163, 137, 74, 0.45);
}

.hover\\:text-kids-stories-900\\/5:hover{
  color: rgba(163, 137, 74, 0.05);
}

.hover\\:text-kids-stories-900\\/50:hover{
  color: rgba(163, 137, 74, 0.5);
}

.hover\\:text-kids-stories-900\\/55:hover{
  color: rgba(163, 137, 74, 0.55);
}

.hover\\:text-kids-stories-900\\/60:hover{
  color: rgba(163, 137, 74, 0.6);
}

.hover\\:text-kids-stories-900\\/65:hover{
  color: rgba(163, 137, 74, 0.65);
}

.hover\\:text-kids-stories-900\\/70:hover{
  color: rgba(163, 137, 74, 0.7);
}

.hover\\:text-kids-stories-900\\/75:hover{
  color: rgba(163, 137, 74, 0.75);
}

.hover\\:text-kids-stories-900\\/80:hover{
  color: rgba(163, 137, 74, 0.8);
}

.hover\\:text-kids-stories-900\\/85:hover{
  color: rgba(163, 137, 74, 0.85);
}

.hover\\:text-kids-stories-900\\/90:hover{
  color: rgba(163, 137, 74, 0.9);
}

.hover\\:text-kids-stories-900\\/95:hover{
  color: rgba(163, 137, 74, 0.95);
}

.hover\\:text-ochre-100:hover{
  --tw-text-opacity: 1;
  color: rgba(245, 237, 208, 1);
  color: rgba(245, 237, 208, var(--tw-text-opacity, 1));
}

.hover\\:text-ochre-100\\/0:hover{
  color: rgba(245, 237, 208, 0);
}

.hover\\:text-ochre-100\\/10:hover{
  color: rgba(245, 237, 208, 0.1);
}

.hover\\:text-ochre-100\\/100:hover{
  color: rgb(245, 237, 208);
}

.hover\\:text-ochre-100\\/15:hover{
  color: rgba(245, 237, 208, 0.15);
}

.hover\\:text-ochre-100\\/20:hover{
  color: rgba(245, 237, 208, 0.2);
}

.hover\\:text-ochre-100\\/25:hover{
  color: rgba(245, 237, 208, 0.25);
}

.hover\\:text-ochre-100\\/30:hover{
  color: rgba(245, 237, 208, 0.3);
}

.hover\\:text-ochre-100\\/35:hover{
  color: rgba(245, 237, 208, 0.35);
}

.hover\\:text-ochre-100\\/40:hover{
  color: rgba(245, 237, 208, 0.4);
}

.hover\\:text-ochre-100\\/45:hover{
  color: rgba(245, 237, 208, 0.45);
}

.hover\\:text-ochre-100\\/5:hover{
  color: rgba(245, 237, 208, 0.05);
}

.hover\\:text-ochre-100\\/50:hover{
  color: rgba(245, 237, 208, 0.5);
}

.hover\\:text-ochre-100\\/55:hover{
  color: rgba(245, 237, 208, 0.55);
}

.hover\\:text-ochre-100\\/60:hover{
  color: rgba(245, 237, 208, 0.6);
}

.hover\\:text-ochre-100\\/65:hover{
  color: rgba(245, 237, 208, 0.65);
}

.hover\\:text-ochre-100\\/70:hover{
  color: rgba(245, 237, 208, 0.7);
}

.hover\\:text-ochre-100\\/75:hover{
  color: rgba(245, 237, 208, 0.75);
}

.hover\\:text-ochre-100\\/80:hover{
  color: rgba(245, 237, 208, 0.8);
}

.hover\\:text-ochre-100\\/85:hover{
  color: rgba(245, 237, 208, 0.85);
}

.hover\\:text-ochre-100\\/90:hover{
  color: rgba(245, 237, 208, 0.9);
}

.hover\\:text-ochre-100\\/95:hover{
  color: rgba(245, 237, 208, 0.95);
}

.hover\\:text-ochre-200:hover{
  --tw-text-opacity: 1;
  color: rgba(235, 217, 156, 1);
  color: rgba(235, 217, 156, var(--tw-text-opacity, 1));
}

.hover\\:text-ochre-200\\/0:hover{
  color: rgba(235, 217, 156, 0);
}

.hover\\:text-ochre-200\\/10:hover{
  color: rgba(235, 217, 156, 0.1);
}

.hover\\:text-ochre-200\\/100:hover{
  color: rgb(235, 217, 156);
}

.hover\\:text-ochre-200\\/15:hover{
  color: rgba(235, 217, 156, 0.15);
}

.hover\\:text-ochre-200\\/20:hover{
  color: rgba(235, 217, 156, 0.2);
}

.hover\\:text-ochre-200\\/25:hover{
  color: rgba(235, 217, 156, 0.25);
}

.hover\\:text-ochre-200\\/30:hover{
  color: rgba(235, 217, 156, 0.3);
}

.hover\\:text-ochre-200\\/35:hover{
  color: rgba(235, 217, 156, 0.35);
}

.hover\\:text-ochre-200\\/40:hover{
  color: rgba(235, 217, 156, 0.4);
}

.hover\\:text-ochre-200\\/45:hover{
  color: rgba(235, 217, 156, 0.45);
}

.hover\\:text-ochre-200\\/5:hover{
  color: rgba(235, 217, 156, 0.05);
}

.hover\\:text-ochre-200\\/50:hover{
  color: rgba(235, 217, 156, 0.5);
}

.hover\\:text-ochre-200\\/55:hover{
  color: rgba(235, 217, 156, 0.55);
}

.hover\\:text-ochre-200\\/60:hover{
  color: rgba(235, 217, 156, 0.6);
}

.hover\\:text-ochre-200\\/65:hover{
  color: rgba(235, 217, 156, 0.65);
}

.hover\\:text-ochre-200\\/70:hover{
  color: rgba(235, 217, 156, 0.7);
}

.hover\\:text-ochre-200\\/75:hover{
  color: rgba(235, 217, 156, 0.75);
}

.hover\\:text-ochre-200\\/80:hover{
  color: rgba(235, 217, 156, 0.8);
}

.hover\\:text-ochre-200\\/85:hover{
  color: rgba(235, 217, 156, 0.85);
}

.hover\\:text-ochre-200\\/90:hover{
  color: rgba(235, 217, 156, 0.9);
}

.hover\\:text-ochre-200\\/95:hover{
  color: rgba(235, 217, 156, 0.95);
}

.hover\\:text-ochre-300:hover{
  --tw-text-opacity: 1;
  color: rgba(225, 194, 104, 1);
  color: rgba(225, 194, 104, var(--tw-text-opacity, 1));
}

.hover\\:text-ochre-300\\/0:hover{
  color: rgba(225, 194, 104, 0);
}

.hover\\:text-ochre-300\\/10:hover{
  color: rgba(225, 194, 104, 0.1);
}

.hover\\:text-ochre-300\\/100:hover{
  color: rgb(225, 194, 104);
}

.hover\\:text-ochre-300\\/15:hover{
  color: rgba(225, 194, 104, 0.15);
}

.hover\\:text-ochre-300\\/20:hover{
  color: rgba(225, 194, 104, 0.2);
}

.hover\\:text-ochre-300\\/25:hover{
  color: rgba(225, 194, 104, 0.25);
}

.hover\\:text-ochre-300\\/30:hover{
  color: rgba(225, 194, 104, 0.3);
}

.hover\\:text-ochre-300\\/35:hover{
  color: rgba(225, 194, 104, 0.35);
}

.hover\\:text-ochre-300\\/40:hover{
  color: rgba(225, 194, 104, 0.4);
}

.hover\\:text-ochre-300\\/45:hover{
  color: rgba(225, 194, 104, 0.45);
}

.hover\\:text-ochre-300\\/5:hover{
  color: rgba(225, 194, 104, 0.05);
}

.hover\\:text-ochre-300\\/50:hover{
  color: rgba(225, 194, 104, 0.5);
}

.hover\\:text-ochre-300\\/55:hover{
  color: rgba(225, 194, 104, 0.55);
}

.hover\\:text-ochre-300\\/60:hover{
  color: rgba(225, 194, 104, 0.6);
}

.hover\\:text-ochre-300\\/65:hover{
  color: rgba(225, 194, 104, 0.65);
}

.hover\\:text-ochre-300\\/70:hover{
  color: rgba(225, 194, 104, 0.7);
}

.hover\\:text-ochre-300\\/75:hover{
  color: rgba(225, 194, 104, 0.75);
}

.hover\\:text-ochre-300\\/80:hover{
  color: rgba(225, 194, 104, 0.8);
}

.hover\\:text-ochre-300\\/85:hover{
  color: rgba(225, 194, 104, 0.85);
}

.hover\\:text-ochre-300\\/90:hover{
  color: rgba(225, 194, 104, 0.9);
}

.hover\\:text-ochre-300\\/95:hover{
  color: rgba(225, 194, 104, 0.95);
}

.hover\\:text-ochre-400:hover{
  --tw-text-opacity: 1;
  color: rgba(218, 173, 69, 1);
  color: rgba(218, 173, 69, var(--tw-text-opacity, 1));
}

.hover\\:text-ochre-400\\/0:hover{
  color: rgba(218, 173, 69, 0);
}

.hover\\:text-ochre-400\\/10:hover{
  color: rgba(218, 173, 69, 0.1);
}

.hover\\:text-ochre-400\\/100:hover{
  color: rgb(218, 173, 69);
}

.hover\\:text-ochre-400\\/15:hover{
  color: rgba(218, 173, 69, 0.15);
}

.hover\\:text-ochre-400\\/20:hover{
  color: rgba(218, 173, 69, 0.2);
}

.hover\\:text-ochre-400\\/25:hover{
  color: rgba(218, 173, 69, 0.25);
}

.hover\\:text-ochre-400\\/30:hover{
  color: rgba(218, 173, 69, 0.3);
}

.hover\\:text-ochre-400\\/35:hover{
  color: rgba(218, 173, 69, 0.35);
}

.hover\\:text-ochre-400\\/40:hover{
  color: rgba(218, 173, 69, 0.4);
}

.hover\\:text-ochre-400\\/45:hover{
  color: rgba(218, 173, 69, 0.45);
}

.hover\\:text-ochre-400\\/5:hover{
  color: rgba(218, 173, 69, 0.05);
}

.hover\\:text-ochre-400\\/50:hover{
  color: rgba(218, 173, 69, 0.5);
}

.hover\\:text-ochre-400\\/55:hover{
  color: rgba(218, 173, 69, 0.55);
}

.hover\\:text-ochre-400\\/60:hover{
  color: rgba(218, 173, 69, 0.6);
}

.hover\\:text-ochre-400\\/65:hover{
  color: rgba(218, 173, 69, 0.65);
}

.hover\\:text-ochre-400\\/70:hover{
  color: rgba(218, 173, 69, 0.7);
}

.hover\\:text-ochre-400\\/75:hover{
  color: rgba(218, 173, 69, 0.75);
}

.hover\\:text-ochre-400\\/80:hover{
  color: rgba(218, 173, 69, 0.8);
}

.hover\\:text-ochre-400\\/85:hover{
  color: rgba(218, 173, 69, 0.85);
}

.hover\\:text-ochre-400\\/90:hover{
  color: rgba(218, 173, 69, 0.9);
}

.hover\\:text-ochre-400\\/95:hover{
  color: rgba(218, 173, 69, 0.95);
}

.hover\\:text-ochre-500:hover{
  --tw-text-opacity: 1;
  color: rgba(209, 145, 47, 1);
  color: rgba(209, 145, 47, var(--tw-text-opacity, 1));
}

.hover\\:text-ochre-500\\/0:hover{
  color: rgba(209, 145, 47, 0);
}

.hover\\:text-ochre-500\\/10:hover{
  color: rgba(209, 145, 47, 0.1);
}

.hover\\:text-ochre-500\\/100:hover{
  color: rgb(209, 145, 47);
}

.hover\\:text-ochre-500\\/15:hover{
  color: rgba(209, 145, 47, 0.15);
}

.hover\\:text-ochre-500\\/20:hover{
  color: rgba(209, 145, 47, 0.2);
}

.hover\\:text-ochre-500\\/25:hover{
  color: rgba(209, 145, 47, 0.25);
}

.hover\\:text-ochre-500\\/30:hover{
  color: rgba(209, 145, 47, 0.3);
}

.hover\\:text-ochre-500\\/35:hover{
  color: rgba(209, 145, 47, 0.35);
}

.hover\\:text-ochre-500\\/40:hover{
  color: rgba(209, 145, 47, 0.4);
}

.hover\\:text-ochre-500\\/45:hover{
  color: rgba(209, 145, 47, 0.45);
}

.hover\\:text-ochre-500\\/5:hover{
  color: rgba(209, 145, 47, 0.05);
}

.hover\\:text-ochre-500\\/50:hover{
  color: rgba(209, 145, 47, 0.5);
}

.hover\\:text-ochre-500\\/55:hover{
  color: rgba(209, 145, 47, 0.55);
}

.hover\\:text-ochre-500\\/60:hover{
  color: rgba(209, 145, 47, 0.6);
}

.hover\\:text-ochre-500\\/65:hover{
  color: rgba(209, 145, 47, 0.65);
}

.hover\\:text-ochre-500\\/70:hover{
  color: rgba(209, 145, 47, 0.7);
}

.hover\\:text-ochre-500\\/75:hover{
  color: rgba(209, 145, 47, 0.75);
}

.hover\\:text-ochre-500\\/80:hover{
  color: rgba(209, 145, 47, 0.8);
}

.hover\\:text-ochre-500\\/85:hover{
  color: rgba(209, 145, 47, 0.85);
}

.hover\\:text-ochre-500\\/90:hover{
  color: rgba(209, 145, 47, 0.9);
}

.hover\\:text-ochre-500\\/95:hover{
  color: rgba(209, 145, 47, 0.95);
}

.hover\\:text-ochre-600:hover{
  --tw-text-opacity: 1;
  color: rgba(195, 120, 41, 1);
  color: rgba(195, 120, 41, var(--tw-text-opacity, 1));
}

.hover\\:text-ochre-600\\/0:hover{
  color: rgba(195, 120, 41, 0);
}

.hover\\:text-ochre-600\\/10:hover{
  color: rgba(195, 120, 41, 0.1);
}

.hover\\:text-ochre-600\\/100:hover{
  color: rgb(195, 120, 41);
}

.hover\\:text-ochre-600\\/15:hover{
  color: rgba(195, 120, 41, 0.15);
}

.hover\\:text-ochre-600\\/20:hover{
  color: rgba(195, 120, 41, 0.2);
}

.hover\\:text-ochre-600\\/25:hover{
  color: rgba(195, 120, 41, 0.25);
}

.hover\\:text-ochre-600\\/30:hover{
  color: rgba(195, 120, 41, 0.3);
}

.hover\\:text-ochre-600\\/35:hover{
  color: rgba(195, 120, 41, 0.35);
}

.hover\\:text-ochre-600\\/40:hover{
  color: rgba(195, 120, 41, 0.4);
}

.hover\\:text-ochre-600\\/45:hover{
  color: rgba(195, 120, 41, 0.45);
}

.hover\\:text-ochre-600\\/5:hover{
  color: rgba(195, 120, 41, 0.05);
}

.hover\\:text-ochre-600\\/50:hover{
  color: rgba(195, 120, 41, 0.5);
}

.hover\\:text-ochre-600\\/55:hover{
  color: rgba(195, 120, 41, 0.55);
}

.hover\\:text-ochre-600\\/60:hover{
  color: rgba(195, 120, 41, 0.6);
}

.hover\\:text-ochre-600\\/65:hover{
  color: rgba(195, 120, 41, 0.65);
}

.hover\\:text-ochre-600\\/70:hover{
  color: rgba(195, 120, 41, 0.7);
}

.hover\\:text-ochre-600\\/75:hover{
  color: rgba(195, 120, 41, 0.75);
}

.hover\\:text-ochre-600\\/80:hover{
  color: rgba(195, 120, 41, 0.8);
}

.hover\\:text-ochre-600\\/85:hover{
  color: rgba(195, 120, 41, 0.85);
}

.hover\\:text-ochre-600\\/90:hover{
  color: rgba(195, 120, 41, 0.9);
}

.hover\\:text-ochre-600\\/95:hover{
  color: rgba(195, 120, 41, 0.95);
}

.hover\\:text-ochre-700:hover{
  --tw-text-opacity: 1;
  color: rgba(153, 84, 36, 1);
  color: rgba(153, 84, 36, var(--tw-text-opacity, 1));
}

.hover\\:text-ochre-700\\/0:hover{
  color: rgba(153, 84, 36, 0);
}

.hover\\:text-ochre-700\\/10:hover{
  color: rgba(153, 84, 36, 0.1);
}

.hover\\:text-ochre-700\\/100:hover{
  color: rgb(153, 84, 36);
}

.hover\\:text-ochre-700\\/15:hover{
  color: rgba(153, 84, 36, 0.15);
}

.hover\\:text-ochre-700\\/20:hover{
  color: rgba(153, 84, 36, 0.2);
}

.hover\\:text-ochre-700\\/25:hover{
  color: rgba(153, 84, 36, 0.25);
}

.hover\\:text-ochre-700\\/30:hover{
  color: rgba(153, 84, 36, 0.3);
}

.hover\\:text-ochre-700\\/35:hover{
  color: rgba(153, 84, 36, 0.35);
}

.hover\\:text-ochre-700\\/40:hover{
  color: rgba(153, 84, 36, 0.4);
}

.hover\\:text-ochre-700\\/45:hover{
  color: rgba(153, 84, 36, 0.45);
}

.hover\\:text-ochre-700\\/5:hover{
  color: rgba(153, 84, 36, 0.05);
}

.hover\\:text-ochre-700\\/50:hover{
  color: rgba(153, 84, 36, 0.5);
}

.hover\\:text-ochre-700\\/55:hover{
  color: rgba(153, 84, 36, 0.55);
}

.hover\\:text-ochre-700\\/60:hover{
  color: rgba(153, 84, 36, 0.6);
}

.hover\\:text-ochre-700\\/65:hover{
  color: rgba(153, 84, 36, 0.65);
}

.hover\\:text-ochre-700\\/70:hover{
  color: rgba(153, 84, 36, 0.7);
}

.hover\\:text-ochre-700\\/75:hover{
  color: rgba(153, 84, 36, 0.75);
}

.hover\\:text-ochre-700\\/80:hover{
  color: rgba(153, 84, 36, 0.8);
}

.hover\\:text-ochre-700\\/85:hover{
  color: rgba(153, 84, 36, 0.85);
}

.hover\\:text-ochre-700\\/90:hover{
  color: rgba(153, 84, 36, 0.9);
}

.hover\\:text-ochre-700\\/95:hover{
  color: rgba(153, 84, 36, 0.95);
}

.hover\\:text-ochre-800:hover{
  --tw-text-opacity: 1;
  color: rgba(126, 67, 34, 1);
  color: rgba(126, 67, 34, var(--tw-text-opacity, 1));
}

.hover\\:text-ochre-800\\/0:hover{
  color: rgba(126, 67, 34, 0);
}

.hover\\:text-ochre-800\\/10:hover{
  color: rgba(126, 67, 34, 0.1);
}

.hover\\:text-ochre-800\\/100:hover{
  color: rgb(126, 67, 34);
}

.hover\\:text-ochre-800\\/15:hover{
  color: rgba(126, 67, 34, 0.15);
}

.hover\\:text-ochre-800\\/20:hover{
  color: rgba(126, 67, 34, 0.2);
}

.hover\\:text-ochre-800\\/25:hover{
  color: rgba(126, 67, 34, 0.25);
}

.hover\\:text-ochre-800\\/30:hover{
  color: rgba(126, 67, 34, 0.3);
}

.hover\\:text-ochre-800\\/35:hover{
  color: rgba(126, 67, 34, 0.35);
}

.hover\\:text-ochre-800\\/40:hover{
  color: rgba(126, 67, 34, 0.4);
}

.hover\\:text-ochre-800\\/45:hover{
  color: rgba(126, 67, 34, 0.45);
}

.hover\\:text-ochre-800\\/5:hover{
  color: rgba(126, 67, 34, 0.05);
}

.hover\\:text-ochre-800\\/50:hover{
  color: rgba(126, 67, 34, 0.5);
}

.hover\\:text-ochre-800\\/55:hover{
  color: rgba(126, 67, 34, 0.55);
}

.hover\\:text-ochre-800\\/60:hover{
  color: rgba(126, 67, 34, 0.6);
}

.hover\\:text-ochre-800\\/65:hover{
  color: rgba(126, 67, 34, 0.65);
}

.hover\\:text-ochre-800\\/70:hover{
  color: rgba(126, 67, 34, 0.7);
}

.hover\\:text-ochre-800\\/75:hover{
  color: rgba(126, 67, 34, 0.75);
}

.hover\\:text-ochre-800\\/80:hover{
  color: rgba(126, 67, 34, 0.8);
}

.hover\\:text-ochre-800\\/85:hover{
  color: rgba(126, 67, 34, 0.85);
}

.hover\\:text-ochre-800\\/90:hover{
  color: rgba(126, 67, 34, 0.9);
}

.hover\\:text-ochre-800\\/95:hover{
  color: rgba(126, 67, 34, 0.95);
}

.hover\\:text-ochre-900:hover{
  --tw-text-opacity: 1;
  color: rgba(104, 56, 31, 1);
  color: rgba(104, 56, 31, var(--tw-text-opacity, 1));
}

.hover\\:text-ochre-900\\/0:hover{
  color: rgba(104, 56, 31, 0);
}

.hover\\:text-ochre-900\\/10:hover{
  color: rgba(104, 56, 31, 0.1);
}

.hover\\:text-ochre-900\\/100:hover{
  color: rgb(104, 56, 31);
}

.hover\\:text-ochre-900\\/15:hover{
  color: rgba(104, 56, 31, 0.15);
}

.hover\\:text-ochre-900\\/20:hover{
  color: rgba(104, 56, 31, 0.2);
}

.hover\\:text-ochre-900\\/25:hover{
  color: rgba(104, 56, 31, 0.25);
}

.hover\\:text-ochre-900\\/30:hover{
  color: rgba(104, 56, 31, 0.3);
}

.hover\\:text-ochre-900\\/35:hover{
  color: rgba(104, 56, 31, 0.35);
}

.hover\\:text-ochre-900\\/40:hover{
  color: rgba(104, 56, 31, 0.4);
}

.hover\\:text-ochre-900\\/45:hover{
  color: rgba(104, 56, 31, 0.45);
}

.hover\\:text-ochre-900\\/5:hover{
  color: rgba(104, 56, 31, 0.05);
}

.hover\\:text-ochre-900\\/50:hover{
  color: rgba(104, 56, 31, 0.5);
}

.hover\\:text-ochre-900\\/55:hover{
  color: rgba(104, 56, 31, 0.55);
}

.hover\\:text-ochre-900\\/60:hover{
  color: rgba(104, 56, 31, 0.6);
}

.hover\\:text-ochre-900\\/65:hover{
  color: rgba(104, 56, 31, 0.65);
}

.hover\\:text-ochre-900\\/70:hover{
  color: rgba(104, 56, 31, 0.7);
}

.hover\\:text-ochre-900\\/75:hover{
  color: rgba(104, 56, 31, 0.75);
}

.hover\\:text-ochre-900\\/80:hover{
  color: rgba(104, 56, 31, 0.8);
}

.hover\\:text-ochre-900\\/85:hover{
  color: rgba(104, 56, 31, 0.85);
}

.hover\\:text-ochre-900\\/90:hover{
  color: rgba(104, 56, 31, 0.9);
}

.hover\\:text-ochre-900\\/95:hover{
  color: rgba(104, 56, 31, 0.95);
}

.hover\\:text-ochre-950:hover{
  --tw-text-opacity: 1;
  color: rgba(59, 28, 13, 1);
  color: rgba(59, 28, 13, var(--tw-text-opacity, 1));
}

.hover\\:text-ochre-950\\/0:hover{
  color: rgba(59, 28, 13, 0);
}

.hover\\:text-ochre-950\\/10:hover{
  color: rgba(59, 28, 13, 0.1);
}

.hover\\:text-ochre-950\\/100:hover{
  color: rgb(59, 28, 13);
}

.hover\\:text-ochre-950\\/15:hover{
  color: rgba(59, 28, 13, 0.15);
}

.hover\\:text-ochre-950\\/20:hover{
  color: rgba(59, 28, 13, 0.2);
}

.hover\\:text-ochre-950\\/25:hover{
  color: rgba(59, 28, 13, 0.25);
}

.hover\\:text-ochre-950\\/30:hover{
  color: rgba(59, 28, 13, 0.3);
}

.hover\\:text-ochre-950\\/35:hover{
  color: rgba(59, 28, 13, 0.35);
}

.hover\\:text-ochre-950\\/40:hover{
  color: rgba(59, 28, 13, 0.4);
}

.hover\\:text-ochre-950\\/45:hover{
  color: rgba(59, 28, 13, 0.45);
}

.hover\\:text-ochre-950\\/5:hover{
  color: rgba(59, 28, 13, 0.05);
}

.hover\\:text-ochre-950\\/50:hover{
  color: rgba(59, 28, 13, 0.5);
}

.hover\\:text-ochre-950\\/55:hover{
  color: rgba(59, 28, 13, 0.55);
}

.hover\\:text-ochre-950\\/60:hover{
  color: rgba(59, 28, 13, 0.6);
}

.hover\\:text-ochre-950\\/65:hover{
  color: rgba(59, 28, 13, 0.65);
}

.hover\\:text-ochre-950\\/70:hover{
  color: rgba(59, 28, 13, 0.7);
}

.hover\\:text-ochre-950\\/75:hover{
  color: rgba(59, 28, 13, 0.75);
}

.hover\\:text-ochre-950\\/80:hover{
  color: rgba(59, 28, 13, 0.8);
}

.hover\\:text-ochre-950\\/85:hover{
  color: rgba(59, 28, 13, 0.85);
}

.hover\\:text-ochre-950\\/90:hover{
  color: rgba(59, 28, 13, 0.9);
}

.hover\\:text-ochre-950\\/95:hover{
  color: rgba(59, 28, 13, 0.95);
}

.hover\\:text-phrase-color-100:hover{
  --tw-text-opacity: 1;
  color: rgba(245, 237, 208, 1);
  color: rgba(245, 237, 208, var(--tw-text-opacity, 1));
}

.hover\\:text-phrase-color-100\\/0:hover{
  color: rgba(245, 237, 208, 0);
}

.hover\\:text-phrase-color-100\\/10:hover{
  color: rgba(245, 237, 208, 0.1);
}

.hover\\:text-phrase-color-100\\/100:hover{
  color: rgb(245, 237, 208);
}

.hover\\:text-phrase-color-100\\/15:hover{
  color: rgba(245, 237, 208, 0.15);
}

.hover\\:text-phrase-color-100\\/20:hover{
  color: rgba(245, 237, 208, 0.2);
}

.hover\\:text-phrase-color-100\\/25:hover{
  color: rgba(245, 237, 208, 0.25);
}

.hover\\:text-phrase-color-100\\/30:hover{
  color: rgba(245, 237, 208, 0.3);
}

.hover\\:text-phrase-color-100\\/35:hover{
  color: rgba(245, 237, 208, 0.35);
}

.hover\\:text-phrase-color-100\\/40:hover{
  color: rgba(245, 237, 208, 0.4);
}

.hover\\:text-phrase-color-100\\/45:hover{
  color: rgba(245, 237, 208, 0.45);
}

.hover\\:text-phrase-color-100\\/5:hover{
  color: rgba(245, 237, 208, 0.05);
}

.hover\\:text-phrase-color-100\\/50:hover{
  color: rgba(245, 237, 208, 0.5);
}

.hover\\:text-phrase-color-100\\/55:hover{
  color: rgba(245, 237, 208, 0.55);
}

.hover\\:text-phrase-color-100\\/60:hover{
  color: rgba(245, 237, 208, 0.6);
}

.hover\\:text-phrase-color-100\\/65:hover{
  color: rgba(245, 237, 208, 0.65);
}

.hover\\:text-phrase-color-100\\/70:hover{
  color: rgba(245, 237, 208, 0.7);
}

.hover\\:text-phrase-color-100\\/75:hover{
  color: rgba(245, 237, 208, 0.75);
}

.hover\\:text-phrase-color-100\\/80:hover{
  color: rgba(245, 237, 208, 0.8);
}

.hover\\:text-phrase-color-100\\/85:hover{
  color: rgba(245, 237, 208, 0.85);
}

.hover\\:text-phrase-color-100\\/90:hover{
  color: rgba(245, 237, 208, 0.9);
}

.hover\\:text-phrase-color-100\\/95:hover{
  color: rgba(245, 237, 208, 0.95);
}

.hover\\:text-phrase-color-200:hover{
  --tw-text-opacity: 1;
  color: rgba(235, 217, 156, 1);
  color: rgba(235, 217, 156, var(--tw-text-opacity, 1));
}

.hover\\:text-phrase-color-200\\/0:hover{
  color: rgba(235, 217, 156, 0);
}

.hover\\:text-phrase-color-200\\/10:hover{
  color: rgba(235, 217, 156, 0.1);
}

.hover\\:text-phrase-color-200\\/100:hover{
  color: rgb(235, 217, 156);
}

.hover\\:text-phrase-color-200\\/15:hover{
  color: rgba(235, 217, 156, 0.15);
}

.hover\\:text-phrase-color-200\\/20:hover{
  color: rgba(235, 217, 156, 0.2);
}

.hover\\:text-phrase-color-200\\/25:hover{
  color: rgba(235, 217, 156, 0.25);
}

.hover\\:text-phrase-color-200\\/30:hover{
  color: rgba(235, 217, 156, 0.3);
}

.hover\\:text-phrase-color-200\\/35:hover{
  color: rgba(235, 217, 156, 0.35);
}

.hover\\:text-phrase-color-200\\/40:hover{
  color: rgba(235, 217, 156, 0.4);
}

.hover\\:text-phrase-color-200\\/45:hover{
  color: rgba(235, 217, 156, 0.45);
}

.hover\\:text-phrase-color-200\\/5:hover{
  color: rgba(235, 217, 156, 0.05);
}

.hover\\:text-phrase-color-200\\/50:hover{
  color: rgba(235, 217, 156, 0.5);
}

.hover\\:text-phrase-color-200\\/55:hover{
  color: rgba(235, 217, 156, 0.55);
}

.hover\\:text-phrase-color-200\\/60:hover{
  color: rgba(235, 217, 156, 0.6);
}

.hover\\:text-phrase-color-200\\/65:hover{
  color: rgba(235, 217, 156, 0.65);
}

.hover\\:text-phrase-color-200\\/70:hover{
  color: rgba(235, 217, 156, 0.7);
}

.hover\\:text-phrase-color-200\\/75:hover{
  color: rgba(235, 217, 156, 0.75);
}

.hover\\:text-phrase-color-200\\/80:hover{
  color: rgba(235, 217, 156, 0.8);
}

.hover\\:text-phrase-color-200\\/85:hover{
  color: rgba(235, 217, 156, 0.85);
}

.hover\\:text-phrase-color-200\\/90:hover{
  color: rgba(235, 217, 156, 0.9);
}

.hover\\:text-phrase-color-200\\/95:hover{
  color: rgba(235, 217, 156, 0.95);
}

.hover\\:text-phrase-color-300:hover{
  --tw-text-opacity: 1;
  color: rgba(225, 194, 104, 1);
  color: rgba(225, 194, 104, var(--tw-text-opacity, 1));
}

.hover\\:text-phrase-color-300\\/0:hover{
  color: rgba(225, 194, 104, 0);
}

.hover\\:text-phrase-color-300\\/10:hover{
  color: rgba(225, 194, 104, 0.1);
}

.hover\\:text-phrase-color-300\\/100:hover{
  color: rgb(225, 194, 104);
}

.hover\\:text-phrase-color-300\\/15:hover{
  color: rgba(225, 194, 104, 0.15);
}

.hover\\:text-phrase-color-300\\/20:hover{
  color: rgba(225, 194, 104, 0.2);
}

.hover\\:text-phrase-color-300\\/25:hover{
  color: rgba(225, 194, 104, 0.25);
}

.hover\\:text-phrase-color-300\\/30:hover{
  color: rgba(225, 194, 104, 0.3);
}

.hover\\:text-phrase-color-300\\/35:hover{
  color: rgba(225, 194, 104, 0.35);
}

.hover\\:text-phrase-color-300\\/40:hover{
  color: rgba(225, 194, 104, 0.4);
}

.hover\\:text-phrase-color-300\\/45:hover{
  color: rgba(225, 194, 104, 0.45);
}

.hover\\:text-phrase-color-300\\/5:hover{
  color: rgba(225, 194, 104, 0.05);
}

.hover\\:text-phrase-color-300\\/50:hover{
  color: rgba(225, 194, 104, 0.5);
}

.hover\\:text-phrase-color-300\\/55:hover{
  color: rgba(225, 194, 104, 0.55);
}

.hover\\:text-phrase-color-300\\/60:hover{
  color: rgba(225, 194, 104, 0.6);
}

.hover\\:text-phrase-color-300\\/65:hover{
  color: rgba(225, 194, 104, 0.65);
}

.hover\\:text-phrase-color-300\\/70:hover{
  color: rgba(225, 194, 104, 0.7);
}

.hover\\:text-phrase-color-300\\/75:hover{
  color: rgba(225, 194, 104, 0.75);
}

.hover\\:text-phrase-color-300\\/80:hover{
  color: rgba(225, 194, 104, 0.8);
}

.hover\\:text-phrase-color-300\\/85:hover{
  color: rgba(225, 194, 104, 0.85);
}

.hover\\:text-phrase-color-300\\/90:hover{
  color: rgba(225, 194, 104, 0.9);
}

.hover\\:text-phrase-color-300\\/95:hover{
  color: rgba(225, 194, 104, 0.95);
}

.hover\\:text-phrase-color-400:hover{
  --tw-text-opacity: 1;
  color: rgba(218, 173, 69, 1);
  color: rgba(218, 173, 69, var(--tw-text-opacity, 1));
}

.hover\\:text-phrase-color-400\\/0:hover{
  color: rgba(218, 173, 69, 0);
}

.hover\\:text-phrase-color-400\\/10:hover{
  color: rgba(218, 173, 69, 0.1);
}

.hover\\:text-phrase-color-400\\/100:hover{
  color: rgb(218, 173, 69);
}

.hover\\:text-phrase-color-400\\/15:hover{
  color: rgba(218, 173, 69, 0.15);
}

.hover\\:text-phrase-color-400\\/20:hover{
  color: rgba(218, 173, 69, 0.2);
}

.hover\\:text-phrase-color-400\\/25:hover{
  color: rgba(218, 173, 69, 0.25);
}

.hover\\:text-phrase-color-400\\/30:hover{
  color: rgba(218, 173, 69, 0.3);
}

.hover\\:text-phrase-color-400\\/35:hover{
  color: rgba(218, 173, 69, 0.35);
}

.hover\\:text-phrase-color-400\\/40:hover{
  color: rgba(218, 173, 69, 0.4);
}

.hover\\:text-phrase-color-400\\/45:hover{
  color: rgba(218, 173, 69, 0.45);
}

.hover\\:text-phrase-color-400\\/5:hover{
  color: rgba(218, 173, 69, 0.05);
}

.hover\\:text-phrase-color-400\\/50:hover{
  color: rgba(218, 173, 69, 0.5);
}

.hover\\:text-phrase-color-400\\/55:hover{
  color: rgba(218, 173, 69, 0.55);
}

.hover\\:text-phrase-color-400\\/60:hover{
  color: rgba(218, 173, 69, 0.6);
}

.hover\\:text-phrase-color-400\\/65:hover{
  color: rgba(218, 173, 69, 0.65);
}

.hover\\:text-phrase-color-400\\/70:hover{
  color: rgba(218, 173, 69, 0.7);
}

.hover\\:text-phrase-color-400\\/75:hover{
  color: rgba(218, 173, 69, 0.75);
}

.hover\\:text-phrase-color-400\\/80:hover{
  color: rgba(218, 173, 69, 0.8);
}

.hover\\:text-phrase-color-400\\/85:hover{
  color: rgba(218, 173, 69, 0.85);
}

.hover\\:text-phrase-color-400\\/90:hover{
  color: rgba(218, 173, 69, 0.9);
}

.hover\\:text-phrase-color-400\\/95:hover{
  color: rgba(218, 173, 69, 0.95);
}

.hover\\:text-phrase-color-500:hover{
  --tw-text-opacity: 1;
  color: rgba(209, 145, 47, 1);
  color: rgba(209, 145, 47, var(--tw-text-opacity, 1));
}

.hover\\:text-phrase-color-500\\/0:hover{
  color: rgba(209, 145, 47, 0);
}

.hover\\:text-phrase-color-500\\/10:hover{
  color: rgba(209, 145, 47, 0.1);
}

.hover\\:text-phrase-color-500\\/100:hover{
  color: rgb(209, 145, 47);
}

.hover\\:text-phrase-color-500\\/15:hover{
  color: rgba(209, 145, 47, 0.15);
}

.hover\\:text-phrase-color-500\\/20:hover{
  color: rgba(209, 145, 47, 0.2);
}

.hover\\:text-phrase-color-500\\/25:hover{
  color: rgba(209, 145, 47, 0.25);
}

.hover\\:text-phrase-color-500\\/30:hover{
  color: rgba(209, 145, 47, 0.3);
}

.hover\\:text-phrase-color-500\\/35:hover{
  color: rgba(209, 145, 47, 0.35);
}

.hover\\:text-phrase-color-500\\/40:hover{
  color: rgba(209, 145, 47, 0.4);
}

.hover\\:text-phrase-color-500\\/45:hover{
  color: rgba(209, 145, 47, 0.45);
}

.hover\\:text-phrase-color-500\\/5:hover{
  color: rgba(209, 145, 47, 0.05);
}

.hover\\:text-phrase-color-500\\/50:hover{
  color: rgba(209, 145, 47, 0.5);
}

.hover\\:text-phrase-color-500\\/55:hover{
  color: rgba(209, 145, 47, 0.55);
}

.hover\\:text-phrase-color-500\\/60:hover{
  color: rgba(209, 145, 47, 0.6);
}

.hover\\:text-phrase-color-500\\/65:hover{
  color: rgba(209, 145, 47, 0.65);
}

.hover\\:text-phrase-color-500\\/70:hover{
  color: rgba(209, 145, 47, 0.7);
}

.hover\\:text-phrase-color-500\\/75:hover{
  color: rgba(209, 145, 47, 0.75);
}

.hover\\:text-phrase-color-500\\/80:hover{
  color: rgba(209, 145, 47, 0.8);
}

.hover\\:text-phrase-color-500\\/85:hover{
  color: rgba(209, 145, 47, 0.85);
}

.hover\\:text-phrase-color-500\\/90:hover{
  color: rgba(209, 145, 47, 0.9);
}

.hover\\:text-phrase-color-500\\/95:hover{
  color: rgba(209, 145, 47, 0.95);
}

.hover\\:text-phrase-color-600:hover{
  --tw-text-opacity: 1;
  color: rgba(195, 120, 41, 1);
  color: rgba(195, 120, 41, var(--tw-text-opacity, 1));
}

.hover\\:text-phrase-color-600\\/0:hover{
  color: rgba(195, 120, 41, 0);
}

.hover\\:text-phrase-color-600\\/10:hover{
  color: rgba(195, 120, 41, 0.1);
}

.hover\\:text-phrase-color-600\\/100:hover{
  color: rgb(195, 120, 41);
}

.hover\\:text-phrase-color-600\\/15:hover{
  color: rgba(195, 120, 41, 0.15);
}

.hover\\:text-phrase-color-600\\/20:hover{
  color: rgba(195, 120, 41, 0.2);
}

.hover\\:text-phrase-color-600\\/25:hover{
  color: rgba(195, 120, 41, 0.25);
}

.hover\\:text-phrase-color-600\\/30:hover{
  color: rgba(195, 120, 41, 0.3);
}

.hover\\:text-phrase-color-600\\/35:hover{
  color: rgba(195, 120, 41, 0.35);
}

.hover\\:text-phrase-color-600\\/40:hover{
  color: rgba(195, 120, 41, 0.4);
}

.hover\\:text-phrase-color-600\\/45:hover{
  color: rgba(195, 120, 41, 0.45);
}

.hover\\:text-phrase-color-600\\/5:hover{
  color: rgba(195, 120, 41, 0.05);
}

.hover\\:text-phrase-color-600\\/50:hover{
  color: rgba(195, 120, 41, 0.5);
}

.hover\\:text-phrase-color-600\\/55:hover{
  color: rgba(195, 120, 41, 0.55);
}

.hover\\:text-phrase-color-600\\/60:hover{
  color: rgba(195, 120, 41, 0.6);
}

.hover\\:text-phrase-color-600\\/65:hover{
  color: rgba(195, 120, 41, 0.65);
}

.hover\\:text-phrase-color-600\\/70:hover{
  color: rgba(195, 120, 41, 0.7);
}

.hover\\:text-phrase-color-600\\/75:hover{
  color: rgba(195, 120, 41, 0.75);
}

.hover\\:text-phrase-color-600\\/80:hover{
  color: rgba(195, 120, 41, 0.8);
}

.hover\\:text-phrase-color-600\\/85:hover{
  color: rgba(195, 120, 41, 0.85);
}

.hover\\:text-phrase-color-600\\/90:hover{
  color: rgba(195, 120, 41, 0.9);
}

.hover\\:text-phrase-color-600\\/95:hover{
  color: rgba(195, 120, 41, 0.95);
}

.hover\\:text-phrase-color-700:hover{
  --tw-text-opacity: 1;
  color: rgba(153, 84, 36, 1);
  color: rgba(153, 84, 36, var(--tw-text-opacity, 1));
}

.hover\\:text-phrase-color-700\\/0:hover{
  color: rgba(153, 84, 36, 0);
}

.hover\\:text-phrase-color-700\\/10:hover{
  color: rgba(153, 84, 36, 0.1);
}

.hover\\:text-phrase-color-700\\/100:hover{
  color: rgb(153, 84, 36);
}

.hover\\:text-phrase-color-700\\/15:hover{
  color: rgba(153, 84, 36, 0.15);
}

.hover\\:text-phrase-color-700\\/20:hover{
  color: rgba(153, 84, 36, 0.2);
}

.hover\\:text-phrase-color-700\\/25:hover{
  color: rgba(153, 84, 36, 0.25);
}

.hover\\:text-phrase-color-700\\/30:hover{
  color: rgba(153, 84, 36, 0.3);
}

.hover\\:text-phrase-color-700\\/35:hover{
  color: rgba(153, 84, 36, 0.35);
}

.hover\\:text-phrase-color-700\\/40:hover{
  color: rgba(153, 84, 36, 0.4);
}

.hover\\:text-phrase-color-700\\/45:hover{
  color: rgba(153, 84, 36, 0.45);
}

.hover\\:text-phrase-color-700\\/5:hover{
  color: rgba(153, 84, 36, 0.05);
}

.hover\\:text-phrase-color-700\\/50:hover{
  color: rgba(153, 84, 36, 0.5);
}

.hover\\:text-phrase-color-700\\/55:hover{
  color: rgba(153, 84, 36, 0.55);
}

.hover\\:text-phrase-color-700\\/60:hover{
  color: rgba(153, 84, 36, 0.6);
}

.hover\\:text-phrase-color-700\\/65:hover{
  color: rgba(153, 84, 36, 0.65);
}

.hover\\:text-phrase-color-700\\/70:hover{
  color: rgba(153, 84, 36, 0.7);
}

.hover\\:text-phrase-color-700\\/75:hover{
  color: rgba(153, 84, 36, 0.75);
}

.hover\\:text-phrase-color-700\\/80:hover{
  color: rgba(153, 84, 36, 0.8);
}

.hover\\:text-phrase-color-700\\/85:hover{
  color: rgba(153, 84, 36, 0.85);
}

.hover\\:text-phrase-color-700\\/90:hover{
  color: rgba(153, 84, 36, 0.9);
}

.hover\\:text-phrase-color-700\\/95:hover{
  color: rgba(153, 84, 36, 0.95);
}

.hover\\:text-phrase-color-800:hover{
  --tw-text-opacity: 1;
  color: rgba(126, 67, 34, 1);
  color: rgba(126, 67, 34, var(--tw-text-opacity, 1));
}

.hover\\:text-phrase-color-800\\/0:hover{
  color: rgba(126, 67, 34, 0);
}

.hover\\:text-phrase-color-800\\/10:hover{
  color: rgba(126, 67, 34, 0.1);
}

.hover\\:text-phrase-color-800\\/100:hover{
  color: rgb(126, 67, 34);
}

.hover\\:text-phrase-color-800\\/15:hover{
  color: rgba(126, 67, 34, 0.15);
}

.hover\\:text-phrase-color-800\\/20:hover{
  color: rgba(126, 67, 34, 0.2);
}

.hover\\:text-phrase-color-800\\/25:hover{
  color: rgba(126, 67, 34, 0.25);
}

.hover\\:text-phrase-color-800\\/30:hover{
  color: rgba(126, 67, 34, 0.3);
}

.hover\\:text-phrase-color-800\\/35:hover{
  color: rgba(126, 67, 34, 0.35);
}

.hover\\:text-phrase-color-800\\/40:hover{
  color: rgba(126, 67, 34, 0.4);
}

.hover\\:text-phrase-color-800\\/45:hover{
  color: rgba(126, 67, 34, 0.45);
}

.hover\\:text-phrase-color-800\\/5:hover{
  color: rgba(126, 67, 34, 0.05);
}

.hover\\:text-phrase-color-800\\/50:hover{
  color: rgba(126, 67, 34, 0.5);
}

.hover\\:text-phrase-color-800\\/55:hover{
  color: rgba(126, 67, 34, 0.55);
}

.hover\\:text-phrase-color-800\\/60:hover{
  color: rgba(126, 67, 34, 0.6);
}

.hover\\:text-phrase-color-800\\/65:hover{
  color: rgba(126, 67, 34, 0.65);
}

.hover\\:text-phrase-color-800\\/70:hover{
  color: rgba(126, 67, 34, 0.7);
}

.hover\\:text-phrase-color-800\\/75:hover{
  color: rgba(126, 67, 34, 0.75);
}

.hover\\:text-phrase-color-800\\/80:hover{
  color: rgba(126, 67, 34, 0.8);
}

.hover\\:text-phrase-color-800\\/85:hover{
  color: rgba(126, 67, 34, 0.85);
}

.hover\\:text-phrase-color-800\\/90:hover{
  color: rgba(126, 67, 34, 0.9);
}

.hover\\:text-phrase-color-800\\/95:hover{
  color: rgba(126, 67, 34, 0.95);
}

.hover\\:text-phrase-color-900:hover{
  --tw-text-opacity: 1;
  color: rgba(104, 56, 31, 1);
  color: rgba(104, 56, 31, var(--tw-text-opacity, 1));
}

.hover\\:text-phrase-color-900\\/0:hover{
  color: rgba(104, 56, 31, 0);
}

.hover\\:text-phrase-color-900\\/10:hover{
  color: rgba(104, 56, 31, 0.1);
}

.hover\\:text-phrase-color-900\\/100:hover{
  color: rgb(104, 56, 31);
}

.hover\\:text-phrase-color-900\\/15:hover{
  color: rgba(104, 56, 31, 0.15);
}

.hover\\:text-phrase-color-900\\/20:hover{
  color: rgba(104, 56, 31, 0.2);
}

.hover\\:text-phrase-color-900\\/25:hover{
  color: rgba(104, 56, 31, 0.25);
}

.hover\\:text-phrase-color-900\\/30:hover{
  color: rgba(104, 56, 31, 0.3);
}

.hover\\:text-phrase-color-900\\/35:hover{
  color: rgba(104, 56, 31, 0.35);
}

.hover\\:text-phrase-color-900\\/40:hover{
  color: rgba(104, 56, 31, 0.4);
}

.hover\\:text-phrase-color-900\\/45:hover{
  color: rgba(104, 56, 31, 0.45);
}

.hover\\:text-phrase-color-900\\/5:hover{
  color: rgba(104, 56, 31, 0.05);
}

.hover\\:text-phrase-color-900\\/50:hover{
  color: rgba(104, 56, 31, 0.5);
}

.hover\\:text-phrase-color-900\\/55:hover{
  color: rgba(104, 56, 31, 0.55);
}

.hover\\:text-phrase-color-900\\/60:hover{
  color: rgba(104, 56, 31, 0.6);
}

.hover\\:text-phrase-color-900\\/65:hover{
  color: rgba(104, 56, 31, 0.65);
}

.hover\\:text-phrase-color-900\\/70:hover{
  color: rgba(104, 56, 31, 0.7);
}

.hover\\:text-phrase-color-900\\/75:hover{
  color: rgba(104, 56, 31, 0.75);
}

.hover\\:text-phrase-color-900\\/80:hover{
  color: rgba(104, 56, 31, 0.8);
}

.hover\\:text-phrase-color-900\\/85:hover{
  color: rgba(104, 56, 31, 0.85);
}

.hover\\:text-phrase-color-900\\/90:hover{
  color: rgba(104, 56, 31, 0.9);
}

.hover\\:text-phrase-color-900\\/95:hover{
  color: rgba(104, 56, 31, 0.95);
}

.hover\\:text-phrase-color-950:hover{
  --tw-text-opacity: 1;
  color: rgba(59, 28, 13, 1);
  color: rgba(59, 28, 13, var(--tw-text-opacity, 1));
}

.hover\\:text-phrase-color-950\\/0:hover{
  color: rgba(59, 28, 13, 0);
}

.hover\\:text-phrase-color-950\\/10:hover{
  color: rgba(59, 28, 13, 0.1);
}

.hover\\:text-phrase-color-950\\/100:hover{
  color: rgb(59, 28, 13);
}

.hover\\:text-phrase-color-950\\/15:hover{
  color: rgba(59, 28, 13, 0.15);
}

.hover\\:text-phrase-color-950\\/20:hover{
  color: rgba(59, 28, 13, 0.2);
}

.hover\\:text-phrase-color-950\\/25:hover{
  color: rgba(59, 28, 13, 0.25);
}

.hover\\:text-phrase-color-950\\/30:hover{
  color: rgba(59, 28, 13, 0.3);
}

.hover\\:text-phrase-color-950\\/35:hover{
  color: rgba(59, 28, 13, 0.35);
}

.hover\\:text-phrase-color-950\\/40:hover{
  color: rgba(59, 28, 13, 0.4);
}

.hover\\:text-phrase-color-950\\/45:hover{
  color: rgba(59, 28, 13, 0.45);
}

.hover\\:text-phrase-color-950\\/5:hover{
  color: rgba(59, 28, 13, 0.05);
}

.hover\\:text-phrase-color-950\\/50:hover{
  color: rgba(59, 28, 13, 0.5);
}

.hover\\:text-phrase-color-950\\/55:hover{
  color: rgba(59, 28, 13, 0.55);
}

.hover\\:text-phrase-color-950\\/60:hover{
  color: rgba(59, 28, 13, 0.6);
}

.hover\\:text-phrase-color-950\\/65:hover{
  color: rgba(59, 28, 13, 0.65);
}

.hover\\:text-phrase-color-950\\/70:hover{
  color: rgba(59, 28, 13, 0.7);
}

.hover\\:text-phrase-color-950\\/75:hover{
  color: rgba(59, 28, 13, 0.75);
}

.hover\\:text-phrase-color-950\\/80:hover{
  color: rgba(59, 28, 13, 0.8);
}

.hover\\:text-phrase-color-950\\/85:hover{
  color: rgba(59, 28, 13, 0.85);
}

.hover\\:text-phrase-color-950\\/90:hover{
  color: rgba(59, 28, 13, 0.9);
}

.hover\\:text-phrase-color-950\\/95:hover{
  color: rgba(59, 28, 13, 0.95);
}

.hover\\:text-scarlet-100:hover{
  --tw-text-opacity: 1;
  color: rgba(255, 220, 223, 1);
  color: rgba(255, 220, 223, var(--tw-text-opacity, 1));
}

.hover\\:text-scarlet-100\\/0:hover{
  color: rgba(255, 220, 223, 0);
}

.hover\\:text-scarlet-100\\/10:hover{
  color: rgba(255, 220, 223, 0.1);
}

.hover\\:text-scarlet-100\\/100:hover{
  color: rgb(255, 220, 223);
}

.hover\\:text-scarlet-100\\/15:hover{
  color: rgba(255, 220, 223, 0.15);
}

.hover\\:text-scarlet-100\\/20:hover{
  color: rgba(255, 220, 223, 0.2);
}

.hover\\:text-scarlet-100\\/25:hover{
  color: rgba(255, 220, 223, 0.25);
}

.hover\\:text-scarlet-100\\/30:hover{
  color: rgba(255, 220, 223, 0.3);
}

.hover\\:text-scarlet-100\\/35:hover{
  color: rgba(255, 220, 223, 0.35);
}

.hover\\:text-scarlet-100\\/40:hover{
  color: rgba(255, 220, 223, 0.4);
}

.hover\\:text-scarlet-100\\/45:hover{
  color: rgba(255, 220, 223, 0.45);
}

.hover\\:text-scarlet-100\\/5:hover{
  color: rgba(255, 220, 223, 0.05);
}

.hover\\:text-scarlet-100\\/50:hover{
  color: rgba(255, 220, 223, 0.5);
}

.hover\\:text-scarlet-100\\/55:hover{
  color: rgba(255, 220, 223, 0.55);
}

.hover\\:text-scarlet-100\\/60:hover{
  color: rgba(255, 220, 223, 0.6);
}

.hover\\:text-scarlet-100\\/65:hover{
  color: rgba(255, 220, 223, 0.65);
}

.hover\\:text-scarlet-100\\/70:hover{
  color: rgba(255, 220, 223, 0.7);
}

.hover\\:text-scarlet-100\\/75:hover{
  color: rgba(255, 220, 223, 0.75);
}

.hover\\:text-scarlet-100\\/80:hover{
  color: rgba(255, 220, 223, 0.8);
}

.hover\\:text-scarlet-100\\/85:hover{
  color: rgba(255, 220, 223, 0.85);
}

.hover\\:text-scarlet-100\\/90:hover{
  color: rgba(255, 220, 223, 0.9);
}

.hover\\:text-scarlet-100\\/95:hover{
  color: rgba(255, 220, 223, 0.95);
}

.hover\\:text-scarlet-200:hover{
  --tw-text-opacity: 1;
  color: rgba(255, 192, 198, 1);
  color: rgba(255, 192, 198, var(--tw-text-opacity, 1));
}

.hover\\:text-scarlet-200\\/0:hover{
  color: rgba(255, 192, 198, 0);
}

.hover\\:text-scarlet-200\\/10:hover{
  color: rgba(255, 192, 198, 0.1);
}

.hover\\:text-scarlet-200\\/100:hover{
  color: rgb(255, 192, 198);
}

.hover\\:text-scarlet-200\\/15:hover{
  color: rgba(255, 192, 198, 0.15);
}

.hover\\:text-scarlet-200\\/20:hover{
  color: rgba(255, 192, 198, 0.2);
}

.hover\\:text-scarlet-200\\/25:hover{
  color: rgba(255, 192, 198, 0.25);
}

.hover\\:text-scarlet-200\\/30:hover{
  color: rgba(255, 192, 198, 0.3);
}

.hover\\:text-scarlet-200\\/35:hover{
  color: rgba(255, 192, 198, 0.35);
}

.hover\\:text-scarlet-200\\/40:hover{
  color: rgba(255, 192, 198, 0.4);
}

.hover\\:text-scarlet-200\\/45:hover{
  color: rgba(255, 192, 198, 0.45);
}

.hover\\:text-scarlet-200\\/5:hover{
  color: rgba(255, 192, 198, 0.05);
}

.hover\\:text-scarlet-200\\/50:hover{
  color: rgba(255, 192, 198, 0.5);
}

.hover\\:text-scarlet-200\\/55:hover{
  color: rgba(255, 192, 198, 0.55);
}

.hover\\:text-scarlet-200\\/60:hover{
  color: rgba(255, 192, 198, 0.6);
}

.hover\\:text-scarlet-200\\/65:hover{
  color: rgba(255, 192, 198, 0.65);
}

.hover\\:text-scarlet-200\\/70:hover{
  color: rgba(255, 192, 198, 0.7);
}

.hover\\:text-scarlet-200\\/75:hover{
  color: rgba(255, 192, 198, 0.75);
}

.hover\\:text-scarlet-200\\/80:hover{
  color: rgba(255, 192, 198, 0.8);
}

.hover\\:text-scarlet-200\\/85:hover{
  color: rgba(255, 192, 198, 0.85);
}

.hover\\:text-scarlet-200\\/90:hover{
  color: rgba(255, 192, 198, 0.9);
}

.hover\\:text-scarlet-200\\/95:hover{
  color: rgba(255, 192, 198, 0.95);
}

.hover\\:text-scarlet-300:hover{
  --tw-text-opacity: 1;
  color: rgba(255, 148, 158, 1);
  color: rgba(255, 148, 158, var(--tw-text-opacity, 1));
}

.hover\\:text-scarlet-300\\/0:hover{
  color: rgba(255, 148, 158, 0);
}

.hover\\:text-scarlet-300\\/10:hover{
  color: rgba(255, 148, 158, 0.1);
}

.hover\\:text-scarlet-300\\/100:hover{
  color: rgb(255, 148, 158);
}

.hover\\:text-scarlet-300\\/15:hover{
  color: rgba(255, 148, 158, 0.15);
}

.hover\\:text-scarlet-300\\/20:hover{
  color: rgba(255, 148, 158, 0.2);
}

.hover\\:text-scarlet-300\\/25:hover{
  color: rgba(255, 148, 158, 0.25);
}

.hover\\:text-scarlet-300\\/30:hover{
  color: rgba(255, 148, 158, 0.3);
}

.hover\\:text-scarlet-300\\/35:hover{
  color: rgba(255, 148, 158, 0.35);
}

.hover\\:text-scarlet-300\\/40:hover{
  color: rgba(255, 148, 158, 0.4);
}

.hover\\:text-scarlet-300\\/45:hover{
  color: rgba(255, 148, 158, 0.45);
}

.hover\\:text-scarlet-300\\/5:hover{
  color: rgba(255, 148, 158, 0.05);
}

.hover\\:text-scarlet-300\\/50:hover{
  color: rgba(255, 148, 158, 0.5);
}

.hover\\:text-scarlet-300\\/55:hover{
  color: rgba(255, 148, 158, 0.55);
}

.hover\\:text-scarlet-300\\/60:hover{
  color: rgba(255, 148, 158, 0.6);
}

.hover\\:text-scarlet-300\\/65:hover{
  color: rgba(255, 148, 158, 0.65);
}

.hover\\:text-scarlet-300\\/70:hover{
  color: rgba(255, 148, 158, 0.7);
}

.hover\\:text-scarlet-300\\/75:hover{
  color: rgba(255, 148, 158, 0.75);
}

.hover\\:text-scarlet-300\\/80:hover{
  color: rgba(255, 148, 158, 0.8);
}

.hover\\:text-scarlet-300\\/85:hover{
  color: rgba(255, 148, 158, 0.85);
}

.hover\\:text-scarlet-300\\/90:hover{
  color: rgba(255, 148, 158, 0.9);
}

.hover\\:text-scarlet-300\\/95:hover{
  color: rgba(255, 148, 158, 0.95);
}

.hover\\:text-scarlet-400:hover{
  --tw-text-opacity: 1;
  color: rgba(255, 86, 101, 1);
  color: rgba(255, 86, 101, var(--tw-text-opacity, 1));
}

.hover\\:text-scarlet-400\\/0:hover{
  color: rgba(255, 86, 101, 0);
}

.hover\\:text-scarlet-400\\/10:hover{
  color: rgba(255, 86, 101, 0.1);
}

.hover\\:text-scarlet-400\\/100:hover{
  color: rgb(255, 86, 101);
}

.hover\\:text-scarlet-400\\/15:hover{
  color: rgba(255, 86, 101, 0.15);
}

.hover\\:text-scarlet-400\\/20:hover{
  color: rgba(255, 86, 101, 0.2);
}

.hover\\:text-scarlet-400\\/25:hover{
  color: rgba(255, 86, 101, 0.25);
}

.hover\\:text-scarlet-400\\/30:hover{
  color: rgba(255, 86, 101, 0.3);
}

.hover\\:text-scarlet-400\\/35:hover{
  color: rgba(255, 86, 101, 0.35);
}

.hover\\:text-scarlet-400\\/40:hover{
  color: rgba(255, 86, 101, 0.4);
}

.hover\\:text-scarlet-400\\/45:hover{
  color: rgba(255, 86, 101, 0.45);
}

.hover\\:text-scarlet-400\\/5:hover{
  color: rgba(255, 86, 101, 0.05);
}

.hover\\:text-scarlet-400\\/50:hover{
  color: rgba(255, 86, 101, 0.5);
}

.hover\\:text-scarlet-400\\/55:hover{
  color: rgba(255, 86, 101, 0.55);
}

.hover\\:text-scarlet-400\\/60:hover{
  color: rgba(255, 86, 101, 0.6);
}

.hover\\:text-scarlet-400\\/65:hover{
  color: rgba(255, 86, 101, 0.65);
}

.hover\\:text-scarlet-400\\/70:hover{
  color: rgba(255, 86, 101, 0.7);
}

.hover\\:text-scarlet-400\\/75:hover{
  color: rgba(255, 86, 101, 0.75);
}

.hover\\:text-scarlet-400\\/80:hover{
  color: rgba(255, 86, 101, 0.8);
}

.hover\\:text-scarlet-400\\/85:hover{
  color: rgba(255, 86, 101, 0.85);
}

.hover\\:text-scarlet-400\\/90:hover{
  color: rgba(255, 86, 101, 0.9);
}

.hover\\:text-scarlet-400\\/95:hover{
  color: rgba(255, 86, 101, 0.95);
}

.hover\\:text-scarlet-500:hover{
  --tw-text-opacity: 1;
  color: rgba(255, 34, 54, 1);
  color: rgba(255, 34, 54, var(--tw-text-opacity, 1));
}

.hover\\:text-scarlet-500\\/0:hover{
  color: rgba(255, 34, 54, 0);
}

.hover\\:text-scarlet-500\\/10:hover{
  color: rgba(255, 34, 54, 0.1);
}

.hover\\:text-scarlet-500\\/100:hover{
  color: rgb(255, 34, 54);
}

.hover\\:text-scarlet-500\\/15:hover{
  color: rgba(255, 34, 54, 0.15);
}

.hover\\:text-scarlet-500\\/20:hover{
  color: rgba(255, 34, 54, 0.2);
}

.hover\\:text-scarlet-500\\/25:hover{
  color: rgba(255, 34, 54, 0.25);
}

.hover\\:text-scarlet-500\\/30:hover{
  color: rgba(255, 34, 54, 0.3);
}

.hover\\:text-scarlet-500\\/35:hover{
  color: rgba(255, 34, 54, 0.35);
}

.hover\\:text-scarlet-500\\/40:hover{
  color: rgba(255, 34, 54, 0.4);
}

.hover\\:text-scarlet-500\\/45:hover{
  color: rgba(255, 34, 54, 0.45);
}

.hover\\:text-scarlet-500\\/5:hover{
  color: rgba(255, 34, 54, 0.05);
}

.hover\\:text-scarlet-500\\/50:hover{
  color: rgba(255, 34, 54, 0.5);
}

.hover\\:text-scarlet-500\\/55:hover{
  color: rgba(255, 34, 54, 0.55);
}

.hover\\:text-scarlet-500\\/60:hover{
  color: rgba(255, 34, 54, 0.6);
}

.hover\\:text-scarlet-500\\/65:hover{
  color: rgba(255, 34, 54, 0.65);
}

.hover\\:text-scarlet-500\\/70:hover{
  color: rgba(255, 34, 54, 0.7);
}

.hover\\:text-scarlet-500\\/75:hover{
  color: rgba(255, 34, 54, 0.75);
}

.hover\\:text-scarlet-500\\/80:hover{
  color: rgba(255, 34, 54, 0.8);
}

.hover\\:text-scarlet-500\\/85:hover{
  color: rgba(255, 34, 54, 0.85);
}

.hover\\:text-scarlet-500\\/90:hover{
  color: rgba(255, 34, 54, 0.9);
}

.hover\\:text-scarlet-500\\/95:hover{
  color: rgba(255, 34, 54, 0.95);
}

.hover\\:text-scarlet-600:hover{
  --tw-text-opacity: 1;
  color: rgba(255, 2, 25, 1);
  color: rgba(255, 2, 25, var(--tw-text-opacity, 1));
}

.hover\\:text-scarlet-600\\/0:hover{
  color: rgba(255, 2, 25, 0);
}

.hover\\:text-scarlet-600\\/10:hover{
  color: rgba(255, 2, 25, 0.1);
}

.hover\\:text-scarlet-600\\/100:hover{
  color: rgb(255, 2, 25);
}

.hover\\:text-scarlet-600\\/15:hover{
  color: rgba(255, 2, 25, 0.15);
}

.hover\\:text-scarlet-600\\/20:hover{
  color: rgba(255, 2, 25, 0.2);
}

.hover\\:text-scarlet-600\\/25:hover{
  color: rgba(255, 2, 25, 0.25);
}

.hover\\:text-scarlet-600\\/30:hover{
  color: rgba(255, 2, 25, 0.3);
}

.hover\\:text-scarlet-600\\/35:hover{
  color: rgba(255, 2, 25, 0.35);
}

.hover\\:text-scarlet-600\\/40:hover{
  color: rgba(255, 2, 25, 0.4);
}

.hover\\:text-scarlet-600\\/45:hover{
  color: rgba(255, 2, 25, 0.45);
}

.hover\\:text-scarlet-600\\/5:hover{
  color: rgba(255, 2, 25, 0.05);
}

.hover\\:text-scarlet-600\\/50:hover{
  color: rgba(255, 2, 25, 0.5);
}

.hover\\:text-scarlet-600\\/55:hover{
  color: rgba(255, 2, 25, 0.55);
}

.hover\\:text-scarlet-600\\/60:hover{
  color: rgba(255, 2, 25, 0.6);
}

.hover\\:text-scarlet-600\\/65:hover{
  color: rgba(255, 2, 25, 0.65);
}

.hover\\:text-scarlet-600\\/70:hover{
  color: rgba(255, 2, 25, 0.7);
}

.hover\\:text-scarlet-600\\/75:hover{
  color: rgba(255, 2, 25, 0.75);
}

.hover\\:text-scarlet-600\\/80:hover{
  color: rgba(255, 2, 25, 0.8);
}

.hover\\:text-scarlet-600\\/85:hover{
  color: rgba(255, 2, 25, 0.85);
}

.hover\\:text-scarlet-600\\/90:hover{
  color: rgba(255, 2, 25, 0.9);
}

.hover\\:text-scarlet-600\\/95:hover{
  color: rgba(255, 2, 25, 0.95);
}

.hover\\:text-scarlet-700:hover{
  --tw-text-opacity: 1;
  color: rgba(216, 0, 19, 1);
  color: rgba(216, 0, 19, var(--tw-text-opacity, 1));
}

.hover\\:text-scarlet-700\\/0:hover{
  color: rgba(216, 0, 19, 0);
}

.hover\\:text-scarlet-700\\/10:hover{
  color: rgba(216, 0, 19, 0.1);
}

.hover\\:text-scarlet-700\\/100:hover{
  color: rgb(216, 0, 19);
}

.hover\\:text-scarlet-700\\/15:hover{
  color: rgba(216, 0, 19, 0.15);
}

.hover\\:text-scarlet-700\\/20:hover{
  color: rgba(216, 0, 19, 0.2);
}

.hover\\:text-scarlet-700\\/25:hover{
  color: rgba(216, 0, 19, 0.25);
}

.hover\\:text-scarlet-700\\/30:hover{
  color: rgba(216, 0, 19, 0.3);
}

.hover\\:text-scarlet-700\\/35:hover{
  color: rgba(216, 0, 19, 0.35);
}

.hover\\:text-scarlet-700\\/40:hover{
  color: rgba(216, 0, 19, 0.4);
}

.hover\\:text-scarlet-700\\/45:hover{
  color: rgba(216, 0, 19, 0.45);
}

.hover\\:text-scarlet-700\\/5:hover{
  color: rgba(216, 0, 19, 0.05);
}

.hover\\:text-scarlet-700\\/50:hover{
  color: rgba(216, 0, 19, 0.5);
}

.hover\\:text-scarlet-700\\/55:hover{
  color: rgba(216, 0, 19, 0.55);
}

.hover\\:text-scarlet-700\\/60:hover{
  color: rgba(216, 0, 19, 0.6);
}

.hover\\:text-scarlet-700\\/65:hover{
  color: rgba(216, 0, 19, 0.65);
}

.hover\\:text-scarlet-700\\/70:hover{
  color: rgba(216, 0, 19, 0.7);
}

.hover\\:text-scarlet-700\\/75:hover{
  color: rgba(216, 0, 19, 0.75);
}

.hover\\:text-scarlet-700\\/80:hover{
  color: rgba(216, 0, 19, 0.8);
}

.hover\\:text-scarlet-700\\/85:hover{
  color: rgba(216, 0, 19, 0.85);
}

.hover\\:text-scarlet-700\\/90:hover{
  color: rgba(216, 0, 19, 0.9);
}

.hover\\:text-scarlet-700\\/95:hover{
  color: rgba(216, 0, 19, 0.95);
}

.hover\\:text-scarlet-800:hover{
  --tw-text-opacity: 1;
  color: rgba(180, 2, 18, 1);
  color: rgba(180, 2, 18, var(--tw-text-opacity, 1));
}

.hover\\:text-scarlet-800\\/0:hover{
  color: rgba(180, 2, 18, 0);
}

.hover\\:text-scarlet-800\\/10:hover{
  color: rgba(180, 2, 18, 0.1);
}

.hover\\:text-scarlet-800\\/100:hover{
  color: rgb(180, 2, 18);
}

.hover\\:text-scarlet-800\\/15:hover{
  color: rgba(180, 2, 18, 0.15);
}

.hover\\:text-scarlet-800\\/20:hover{
  color: rgba(180, 2, 18, 0.2);
}

.hover\\:text-scarlet-800\\/25:hover{
  color: rgba(180, 2, 18, 0.25);
}

.hover\\:text-scarlet-800\\/30:hover{
  color: rgba(180, 2, 18, 0.3);
}

.hover\\:text-scarlet-800\\/35:hover{
  color: rgba(180, 2, 18, 0.35);
}

.hover\\:text-scarlet-800\\/40:hover{
  color: rgba(180, 2, 18, 0.4);
}

.hover\\:text-scarlet-800\\/45:hover{
  color: rgba(180, 2, 18, 0.45);
}

.hover\\:text-scarlet-800\\/5:hover{
  color: rgba(180, 2, 18, 0.05);
}

.hover\\:text-scarlet-800\\/50:hover{
  color: rgba(180, 2, 18, 0.5);
}

.hover\\:text-scarlet-800\\/55:hover{
  color: rgba(180, 2, 18, 0.55);
}

.hover\\:text-scarlet-800\\/60:hover{
  color: rgba(180, 2, 18, 0.6);
}

.hover\\:text-scarlet-800\\/65:hover{
  color: rgba(180, 2, 18, 0.65);
}

.hover\\:text-scarlet-800\\/70:hover{
  color: rgba(180, 2, 18, 0.7);
}

.hover\\:text-scarlet-800\\/75:hover{
  color: rgba(180, 2, 18, 0.75);
}

.hover\\:text-scarlet-800\\/80:hover{
  color: rgba(180, 2, 18, 0.8);
}

.hover\\:text-scarlet-800\\/85:hover{
  color: rgba(180, 2, 18, 0.85);
}

.hover\\:text-scarlet-800\\/90:hover{
  color: rgba(180, 2, 18, 0.9);
}

.hover\\:text-scarlet-800\\/95:hover{
  color: rgba(180, 2, 18, 0.95);
}

.hover\\:text-scarlet-900:hover{
  --tw-text-opacity: 1;
  color: rgba(146, 10, 22, 1);
  color: rgba(146, 10, 22, var(--tw-text-opacity, 1));
}

.hover\\:text-scarlet-900\\/0:hover{
  color: rgba(146, 10, 22, 0);
}

.hover\\:text-scarlet-900\\/10:hover{
  color: rgba(146, 10, 22, 0.1);
}

.hover\\:text-scarlet-900\\/100:hover{
  color: rgb(146, 10, 22);
}

.hover\\:text-scarlet-900\\/15:hover{
  color: rgba(146, 10, 22, 0.15);
}

.hover\\:text-scarlet-900\\/20:hover{
  color: rgba(146, 10, 22, 0.2);
}

.hover\\:text-scarlet-900\\/25:hover{
  color: rgba(146, 10, 22, 0.25);
}

.hover\\:text-scarlet-900\\/30:hover{
  color: rgba(146, 10, 22, 0.3);
}

.hover\\:text-scarlet-900\\/35:hover{
  color: rgba(146, 10, 22, 0.35);
}

.hover\\:text-scarlet-900\\/40:hover{
  color: rgba(146, 10, 22, 0.4);
}

.hover\\:text-scarlet-900\\/45:hover{
  color: rgba(146, 10, 22, 0.45);
}

.hover\\:text-scarlet-900\\/5:hover{
  color: rgba(146, 10, 22, 0.05);
}

.hover\\:text-scarlet-900\\/50:hover{
  color: rgba(146, 10, 22, 0.5);
}

.hover\\:text-scarlet-900\\/55:hover{
  color: rgba(146, 10, 22, 0.55);
}

.hover\\:text-scarlet-900\\/60:hover{
  color: rgba(146, 10, 22, 0.6);
}

.hover\\:text-scarlet-900\\/65:hover{
  color: rgba(146, 10, 22, 0.65);
}

.hover\\:text-scarlet-900\\/70:hover{
  color: rgba(146, 10, 22, 0.7);
}

.hover\\:text-scarlet-900\\/75:hover{
  color: rgba(146, 10, 22, 0.75);
}

.hover\\:text-scarlet-900\\/80:hover{
  color: rgba(146, 10, 22, 0.8);
}

.hover\\:text-scarlet-900\\/85:hover{
  color: rgba(146, 10, 22, 0.85);
}

.hover\\:text-scarlet-900\\/90:hover{
  color: rgba(146, 10, 22, 0.9);
}

.hover\\:text-scarlet-900\\/95:hover{
  color: rgba(146, 10, 22, 0.95);
}

.hover\\:text-scarlet-950:hover{
  --tw-text-opacity: 1;
  color: rgba(81, 0, 7, 1);
  color: rgba(81, 0, 7, var(--tw-text-opacity, 1));
}

.hover\\:text-scarlet-950\\/0:hover{
  color: rgba(81, 0, 7, 0);
}

.hover\\:text-scarlet-950\\/10:hover{
  color: rgba(81, 0, 7, 0.1);
}

.hover\\:text-scarlet-950\\/100:hover{
  color: rgb(81, 0, 7);
}

.hover\\:text-scarlet-950\\/15:hover{
  color: rgba(81, 0, 7, 0.15);
}

.hover\\:text-scarlet-950\\/20:hover{
  color: rgba(81, 0, 7, 0.2);
}

.hover\\:text-scarlet-950\\/25:hover{
  color: rgba(81, 0, 7, 0.25);
}

.hover\\:text-scarlet-950\\/30:hover{
  color: rgba(81, 0, 7, 0.3);
}

.hover\\:text-scarlet-950\\/35:hover{
  color: rgba(81, 0, 7, 0.35);
}

.hover\\:text-scarlet-950\\/40:hover{
  color: rgba(81, 0, 7, 0.4);
}

.hover\\:text-scarlet-950\\/45:hover{
  color: rgba(81, 0, 7, 0.45);
}

.hover\\:text-scarlet-950\\/5:hover{
  color: rgba(81, 0, 7, 0.05);
}

.hover\\:text-scarlet-950\\/50:hover{
  color: rgba(81, 0, 7, 0.5);
}

.hover\\:text-scarlet-950\\/55:hover{
  color: rgba(81, 0, 7, 0.55);
}

.hover\\:text-scarlet-950\\/60:hover{
  color: rgba(81, 0, 7, 0.6);
}

.hover\\:text-scarlet-950\\/65:hover{
  color: rgba(81, 0, 7, 0.65);
}

.hover\\:text-scarlet-950\\/70:hover{
  color: rgba(81, 0, 7, 0.7);
}

.hover\\:text-scarlet-950\\/75:hover{
  color: rgba(81, 0, 7, 0.75);
}

.hover\\:text-scarlet-950\\/80:hover{
  color: rgba(81, 0, 7, 0.8);
}

.hover\\:text-scarlet-950\\/85:hover{
  color: rgba(81, 0, 7, 0.85);
}

.hover\\:text-scarlet-950\\/90:hover{
  color: rgba(81, 0, 7, 0.9);
}

.hover\\:text-scarlet-950\\/95:hover{
  color: rgba(81, 0, 7, 0.95);
}

.hover\\:text-song-color-100:hover{
  --tw-text-opacity: 1;
  color: rgba(255, 220, 223, 1);
  color: rgba(255, 220, 223, var(--tw-text-opacity, 1));
}

.hover\\:text-song-color-100\\/0:hover{
  color: rgba(255, 220, 223, 0);
}

.hover\\:text-song-color-100\\/10:hover{
  color: rgba(255, 220, 223, 0.1);
}

.hover\\:text-song-color-100\\/100:hover{
  color: rgb(255, 220, 223);
}

.hover\\:text-song-color-100\\/15:hover{
  color: rgba(255, 220, 223, 0.15);
}

.hover\\:text-song-color-100\\/20:hover{
  color: rgba(255, 220, 223, 0.2);
}

.hover\\:text-song-color-100\\/25:hover{
  color: rgba(255, 220, 223, 0.25);
}

.hover\\:text-song-color-100\\/30:hover{
  color: rgba(255, 220, 223, 0.3);
}

.hover\\:text-song-color-100\\/35:hover{
  color: rgba(255, 220, 223, 0.35);
}

.hover\\:text-song-color-100\\/40:hover{
  color: rgba(255, 220, 223, 0.4);
}

.hover\\:text-song-color-100\\/45:hover{
  color: rgba(255, 220, 223, 0.45);
}

.hover\\:text-song-color-100\\/5:hover{
  color: rgba(255, 220, 223, 0.05);
}

.hover\\:text-song-color-100\\/50:hover{
  color: rgba(255, 220, 223, 0.5);
}

.hover\\:text-song-color-100\\/55:hover{
  color: rgba(255, 220, 223, 0.55);
}

.hover\\:text-song-color-100\\/60:hover{
  color: rgba(255, 220, 223, 0.6);
}

.hover\\:text-song-color-100\\/65:hover{
  color: rgba(255, 220, 223, 0.65);
}

.hover\\:text-song-color-100\\/70:hover{
  color: rgba(255, 220, 223, 0.7);
}

.hover\\:text-song-color-100\\/75:hover{
  color: rgba(255, 220, 223, 0.75);
}

.hover\\:text-song-color-100\\/80:hover{
  color: rgba(255, 220, 223, 0.8);
}

.hover\\:text-song-color-100\\/85:hover{
  color: rgba(255, 220, 223, 0.85);
}

.hover\\:text-song-color-100\\/90:hover{
  color: rgba(255, 220, 223, 0.9);
}

.hover\\:text-song-color-100\\/95:hover{
  color: rgba(255, 220, 223, 0.95);
}

.hover\\:text-song-color-200:hover{
  --tw-text-opacity: 1;
  color: rgba(255, 192, 198, 1);
  color: rgba(255, 192, 198, var(--tw-text-opacity, 1));
}

.hover\\:text-song-color-200\\/0:hover{
  color: rgba(255, 192, 198, 0);
}

.hover\\:text-song-color-200\\/10:hover{
  color: rgba(255, 192, 198, 0.1);
}

.hover\\:text-song-color-200\\/100:hover{
  color: rgb(255, 192, 198);
}

.hover\\:text-song-color-200\\/15:hover{
  color: rgba(255, 192, 198, 0.15);
}

.hover\\:text-song-color-200\\/20:hover{
  color: rgba(255, 192, 198, 0.2);
}

.hover\\:text-song-color-200\\/25:hover{
  color: rgba(255, 192, 198, 0.25);
}

.hover\\:text-song-color-200\\/30:hover{
  color: rgba(255, 192, 198, 0.3);
}

.hover\\:text-song-color-200\\/35:hover{
  color: rgba(255, 192, 198, 0.35);
}

.hover\\:text-song-color-200\\/40:hover{
  color: rgba(255, 192, 198, 0.4);
}

.hover\\:text-song-color-200\\/45:hover{
  color: rgba(255, 192, 198, 0.45);
}

.hover\\:text-song-color-200\\/5:hover{
  color: rgba(255, 192, 198, 0.05);
}

.hover\\:text-song-color-200\\/50:hover{
  color: rgba(255, 192, 198, 0.5);
}

.hover\\:text-song-color-200\\/55:hover{
  color: rgba(255, 192, 198, 0.55);
}

.hover\\:text-song-color-200\\/60:hover{
  color: rgba(255, 192, 198, 0.6);
}

.hover\\:text-song-color-200\\/65:hover{
  color: rgba(255, 192, 198, 0.65);
}

.hover\\:text-song-color-200\\/70:hover{
  color: rgba(255, 192, 198, 0.7);
}

.hover\\:text-song-color-200\\/75:hover{
  color: rgba(255, 192, 198, 0.75);
}

.hover\\:text-song-color-200\\/80:hover{
  color: rgba(255, 192, 198, 0.8);
}

.hover\\:text-song-color-200\\/85:hover{
  color: rgba(255, 192, 198, 0.85);
}

.hover\\:text-song-color-200\\/90:hover{
  color: rgba(255, 192, 198, 0.9);
}

.hover\\:text-song-color-200\\/95:hover{
  color: rgba(255, 192, 198, 0.95);
}

.hover\\:text-song-color-300:hover{
  --tw-text-opacity: 1;
  color: rgba(255, 148, 158, 1);
  color: rgba(255, 148, 158, var(--tw-text-opacity, 1));
}

.hover\\:text-song-color-300\\/0:hover{
  color: rgba(255, 148, 158, 0);
}

.hover\\:text-song-color-300\\/10:hover{
  color: rgba(255, 148, 158, 0.1);
}

.hover\\:text-song-color-300\\/100:hover{
  color: rgb(255, 148, 158);
}

.hover\\:text-song-color-300\\/15:hover{
  color: rgba(255, 148, 158, 0.15);
}

.hover\\:text-song-color-300\\/20:hover{
  color: rgba(255, 148, 158, 0.2);
}

.hover\\:text-song-color-300\\/25:hover{
  color: rgba(255, 148, 158, 0.25);
}

.hover\\:text-song-color-300\\/30:hover{
  color: rgba(255, 148, 158, 0.3);
}

.hover\\:text-song-color-300\\/35:hover{
  color: rgba(255, 148, 158, 0.35);
}

.hover\\:text-song-color-300\\/40:hover{
  color: rgba(255, 148, 158, 0.4);
}

.hover\\:text-song-color-300\\/45:hover{
  color: rgba(255, 148, 158, 0.45);
}

.hover\\:text-song-color-300\\/5:hover{
  color: rgba(255, 148, 158, 0.05);
}

.hover\\:text-song-color-300\\/50:hover{
  color: rgba(255, 148, 158, 0.5);
}

.hover\\:text-song-color-300\\/55:hover{
  color: rgba(255, 148, 158, 0.55);
}

.hover\\:text-song-color-300\\/60:hover{
  color: rgba(255, 148, 158, 0.6);
}

.hover\\:text-song-color-300\\/65:hover{
  color: rgba(255, 148, 158, 0.65);
}

.hover\\:text-song-color-300\\/70:hover{
  color: rgba(255, 148, 158, 0.7);
}

.hover\\:text-song-color-300\\/75:hover{
  color: rgba(255, 148, 158, 0.75);
}

.hover\\:text-song-color-300\\/80:hover{
  color: rgba(255, 148, 158, 0.8);
}

.hover\\:text-song-color-300\\/85:hover{
  color: rgba(255, 148, 158, 0.85);
}

.hover\\:text-song-color-300\\/90:hover{
  color: rgba(255, 148, 158, 0.9);
}

.hover\\:text-song-color-300\\/95:hover{
  color: rgba(255, 148, 158, 0.95);
}

.hover\\:text-song-color-400:hover{
  --tw-text-opacity: 1;
  color: rgba(255, 86, 101, 1);
  color: rgba(255, 86, 101, var(--tw-text-opacity, 1));
}

.hover\\:text-song-color-400\\/0:hover{
  color: rgba(255, 86, 101, 0);
}

.hover\\:text-song-color-400\\/10:hover{
  color: rgba(255, 86, 101, 0.1);
}

.hover\\:text-song-color-400\\/100:hover{
  color: rgb(255, 86, 101);
}

.hover\\:text-song-color-400\\/15:hover{
  color: rgba(255, 86, 101, 0.15);
}

.hover\\:text-song-color-400\\/20:hover{
  color: rgba(255, 86, 101, 0.2);
}

.hover\\:text-song-color-400\\/25:hover{
  color: rgba(255, 86, 101, 0.25);
}

.hover\\:text-song-color-400\\/30:hover{
  color: rgba(255, 86, 101, 0.3);
}

.hover\\:text-song-color-400\\/35:hover{
  color: rgba(255, 86, 101, 0.35);
}

.hover\\:text-song-color-400\\/40:hover{
  color: rgba(255, 86, 101, 0.4);
}

.hover\\:text-song-color-400\\/45:hover{
  color: rgba(255, 86, 101, 0.45);
}

.hover\\:text-song-color-400\\/5:hover{
  color: rgba(255, 86, 101, 0.05);
}

.hover\\:text-song-color-400\\/50:hover{
  color: rgba(255, 86, 101, 0.5);
}

.hover\\:text-song-color-400\\/55:hover{
  color: rgba(255, 86, 101, 0.55);
}

.hover\\:text-song-color-400\\/60:hover{
  color: rgba(255, 86, 101, 0.6);
}

.hover\\:text-song-color-400\\/65:hover{
  color: rgba(255, 86, 101, 0.65);
}

.hover\\:text-song-color-400\\/70:hover{
  color: rgba(255, 86, 101, 0.7);
}

.hover\\:text-song-color-400\\/75:hover{
  color: rgba(255, 86, 101, 0.75);
}

.hover\\:text-song-color-400\\/80:hover{
  color: rgba(255, 86, 101, 0.8);
}

.hover\\:text-song-color-400\\/85:hover{
  color: rgba(255, 86, 101, 0.85);
}

.hover\\:text-song-color-400\\/90:hover{
  color: rgba(255, 86, 101, 0.9);
}

.hover\\:text-song-color-400\\/95:hover{
  color: rgba(255, 86, 101, 0.95);
}

.hover\\:text-song-color-500:hover{
  --tw-text-opacity: 1;
  color: rgba(255, 34, 54, 1);
  color: rgba(255, 34, 54, var(--tw-text-opacity, 1));
}

.hover\\:text-song-color-500\\/0:hover{
  color: rgba(255, 34, 54, 0);
}

.hover\\:text-song-color-500\\/10:hover{
  color: rgba(255, 34, 54, 0.1);
}

.hover\\:text-song-color-500\\/100:hover{
  color: rgb(255, 34, 54);
}

.hover\\:text-song-color-500\\/15:hover{
  color: rgba(255, 34, 54, 0.15);
}

.hover\\:text-song-color-500\\/20:hover{
  color: rgba(255, 34, 54, 0.2);
}

.hover\\:text-song-color-500\\/25:hover{
  color: rgba(255, 34, 54, 0.25);
}

.hover\\:text-song-color-500\\/30:hover{
  color: rgba(255, 34, 54, 0.3);
}

.hover\\:text-song-color-500\\/35:hover{
  color: rgba(255, 34, 54, 0.35);
}

.hover\\:text-song-color-500\\/40:hover{
  color: rgba(255, 34, 54, 0.4);
}

.hover\\:text-song-color-500\\/45:hover{
  color: rgba(255, 34, 54, 0.45);
}

.hover\\:text-song-color-500\\/5:hover{
  color: rgba(255, 34, 54, 0.05);
}

.hover\\:text-song-color-500\\/50:hover{
  color: rgba(255, 34, 54, 0.5);
}

.hover\\:text-song-color-500\\/55:hover{
  color: rgba(255, 34, 54, 0.55);
}

.hover\\:text-song-color-500\\/60:hover{
  color: rgba(255, 34, 54, 0.6);
}

.hover\\:text-song-color-500\\/65:hover{
  color: rgba(255, 34, 54, 0.65);
}

.hover\\:text-song-color-500\\/70:hover{
  color: rgba(255, 34, 54, 0.7);
}

.hover\\:text-song-color-500\\/75:hover{
  color: rgba(255, 34, 54, 0.75);
}

.hover\\:text-song-color-500\\/80:hover{
  color: rgba(255, 34, 54, 0.8);
}

.hover\\:text-song-color-500\\/85:hover{
  color: rgba(255, 34, 54, 0.85);
}

.hover\\:text-song-color-500\\/90:hover{
  color: rgba(255, 34, 54, 0.9);
}

.hover\\:text-song-color-500\\/95:hover{
  color: rgba(255, 34, 54, 0.95);
}

.hover\\:text-song-color-600:hover{
  --tw-text-opacity: 1;
  color: rgba(255, 2, 25, 1);
  color: rgba(255, 2, 25, var(--tw-text-opacity, 1));
}

.hover\\:text-song-color-600\\/0:hover{
  color: rgba(255, 2, 25, 0);
}

.hover\\:text-song-color-600\\/10:hover{
  color: rgba(255, 2, 25, 0.1);
}

.hover\\:text-song-color-600\\/100:hover{
  color: rgb(255, 2, 25);
}

.hover\\:text-song-color-600\\/15:hover{
  color: rgba(255, 2, 25, 0.15);
}

.hover\\:text-song-color-600\\/20:hover{
  color: rgba(255, 2, 25, 0.2);
}

.hover\\:text-song-color-600\\/25:hover{
  color: rgba(255, 2, 25, 0.25);
}

.hover\\:text-song-color-600\\/30:hover{
  color: rgba(255, 2, 25, 0.3);
}

.hover\\:text-song-color-600\\/35:hover{
  color: rgba(255, 2, 25, 0.35);
}

.hover\\:text-song-color-600\\/40:hover{
  color: rgba(255, 2, 25, 0.4);
}

.hover\\:text-song-color-600\\/45:hover{
  color: rgba(255, 2, 25, 0.45);
}

.hover\\:text-song-color-600\\/5:hover{
  color: rgba(255, 2, 25, 0.05);
}

.hover\\:text-song-color-600\\/50:hover{
  color: rgba(255, 2, 25, 0.5);
}

.hover\\:text-song-color-600\\/55:hover{
  color: rgba(255, 2, 25, 0.55);
}

.hover\\:text-song-color-600\\/60:hover{
  color: rgba(255, 2, 25, 0.6);
}

.hover\\:text-song-color-600\\/65:hover{
  color: rgba(255, 2, 25, 0.65);
}

.hover\\:text-song-color-600\\/70:hover{
  color: rgba(255, 2, 25, 0.7);
}

.hover\\:text-song-color-600\\/75:hover{
  color: rgba(255, 2, 25, 0.75);
}

.hover\\:text-song-color-600\\/80:hover{
  color: rgba(255, 2, 25, 0.8);
}

.hover\\:text-song-color-600\\/85:hover{
  color: rgba(255, 2, 25, 0.85);
}

.hover\\:text-song-color-600\\/90:hover{
  color: rgba(255, 2, 25, 0.9);
}

.hover\\:text-song-color-600\\/95:hover{
  color: rgba(255, 2, 25, 0.95);
}

.hover\\:text-song-color-700:hover{
  --tw-text-opacity: 1;
  color: rgba(216, 0, 19, 1);
  color: rgba(216, 0, 19, var(--tw-text-opacity, 1));
}

.hover\\:text-song-color-700\\/0:hover{
  color: rgba(216, 0, 19, 0);
}

.hover\\:text-song-color-700\\/10:hover{
  color: rgba(216, 0, 19, 0.1);
}

.hover\\:text-song-color-700\\/100:hover{
  color: rgb(216, 0, 19);
}

.hover\\:text-song-color-700\\/15:hover{
  color: rgba(216, 0, 19, 0.15);
}

.hover\\:text-song-color-700\\/20:hover{
  color: rgba(216, 0, 19, 0.2);
}

.hover\\:text-song-color-700\\/25:hover{
  color: rgba(216, 0, 19, 0.25);
}

.hover\\:text-song-color-700\\/30:hover{
  color: rgba(216, 0, 19, 0.3);
}

.hover\\:text-song-color-700\\/35:hover{
  color: rgba(216, 0, 19, 0.35);
}

.hover\\:text-song-color-700\\/40:hover{
  color: rgba(216, 0, 19, 0.4);
}

.hover\\:text-song-color-700\\/45:hover{
  color: rgba(216, 0, 19, 0.45);
}

.hover\\:text-song-color-700\\/5:hover{
  color: rgba(216, 0, 19, 0.05);
}

.hover\\:text-song-color-700\\/50:hover{
  color: rgba(216, 0, 19, 0.5);
}

.hover\\:text-song-color-700\\/55:hover{
  color: rgba(216, 0, 19, 0.55);
}

.hover\\:text-song-color-700\\/60:hover{
  color: rgba(216, 0, 19, 0.6);
}

.hover\\:text-song-color-700\\/65:hover{
  color: rgba(216, 0, 19, 0.65);
}

.hover\\:text-song-color-700\\/70:hover{
  color: rgba(216, 0, 19, 0.7);
}

.hover\\:text-song-color-700\\/75:hover{
  color: rgba(216, 0, 19, 0.75);
}

.hover\\:text-song-color-700\\/80:hover{
  color: rgba(216, 0, 19, 0.8);
}

.hover\\:text-song-color-700\\/85:hover{
  color: rgba(216, 0, 19, 0.85);
}

.hover\\:text-song-color-700\\/90:hover{
  color: rgba(216, 0, 19, 0.9);
}

.hover\\:text-song-color-700\\/95:hover{
  color: rgba(216, 0, 19, 0.95);
}

.hover\\:text-song-color-800:hover{
  --tw-text-opacity: 1;
  color: rgba(180, 2, 18, 1);
  color: rgba(180, 2, 18, var(--tw-text-opacity, 1));
}

.hover\\:text-song-color-800\\/0:hover{
  color: rgba(180, 2, 18, 0);
}

.hover\\:text-song-color-800\\/10:hover{
  color: rgba(180, 2, 18, 0.1);
}

.hover\\:text-song-color-800\\/100:hover{
  color: rgb(180, 2, 18);
}

.hover\\:text-song-color-800\\/15:hover{
  color: rgba(180, 2, 18, 0.15);
}

.hover\\:text-song-color-800\\/20:hover{
  color: rgba(180, 2, 18, 0.2);
}

.hover\\:text-song-color-800\\/25:hover{
  color: rgba(180, 2, 18, 0.25);
}

.hover\\:text-song-color-800\\/30:hover{
  color: rgba(180, 2, 18, 0.3);
}

.hover\\:text-song-color-800\\/35:hover{
  color: rgba(180, 2, 18, 0.35);
}

.hover\\:text-song-color-800\\/40:hover{
  color: rgba(180, 2, 18, 0.4);
}

.hover\\:text-song-color-800\\/45:hover{
  color: rgba(180, 2, 18, 0.45);
}

.hover\\:text-song-color-800\\/5:hover{
  color: rgba(180, 2, 18, 0.05);
}

.hover\\:text-song-color-800\\/50:hover{
  color: rgba(180, 2, 18, 0.5);
}

.hover\\:text-song-color-800\\/55:hover{
  color: rgba(180, 2, 18, 0.55);
}

.hover\\:text-song-color-800\\/60:hover{
  color: rgba(180, 2, 18, 0.6);
}

.hover\\:text-song-color-800\\/65:hover{
  color: rgba(180, 2, 18, 0.65);
}

.hover\\:text-song-color-800\\/70:hover{
  color: rgba(180, 2, 18, 0.7);
}

.hover\\:text-song-color-800\\/75:hover{
  color: rgba(180, 2, 18, 0.75);
}

.hover\\:text-song-color-800\\/80:hover{
  color: rgba(180, 2, 18, 0.8);
}

.hover\\:text-song-color-800\\/85:hover{
  color: rgba(180, 2, 18, 0.85);
}

.hover\\:text-song-color-800\\/90:hover{
  color: rgba(180, 2, 18, 0.9);
}

.hover\\:text-song-color-800\\/95:hover{
  color: rgba(180, 2, 18, 0.95);
}

.hover\\:text-song-color-900:hover{
  --tw-text-opacity: 1;
  color: rgba(146, 10, 22, 1);
  color: rgba(146, 10, 22, var(--tw-text-opacity, 1));
}

.hover\\:text-song-color-900\\/0:hover{
  color: rgba(146, 10, 22, 0);
}

.hover\\:text-song-color-900\\/10:hover{
  color: rgba(146, 10, 22, 0.1);
}

.hover\\:text-song-color-900\\/100:hover{
  color: rgb(146, 10, 22);
}

.hover\\:text-song-color-900\\/15:hover{
  color: rgba(146, 10, 22, 0.15);
}

.hover\\:text-song-color-900\\/20:hover{
  color: rgba(146, 10, 22, 0.2);
}

.hover\\:text-song-color-900\\/25:hover{
  color: rgba(146, 10, 22, 0.25);
}

.hover\\:text-song-color-900\\/30:hover{
  color: rgba(146, 10, 22, 0.3);
}

.hover\\:text-song-color-900\\/35:hover{
  color: rgba(146, 10, 22, 0.35);
}

.hover\\:text-song-color-900\\/40:hover{
  color: rgba(146, 10, 22, 0.4);
}

.hover\\:text-song-color-900\\/45:hover{
  color: rgba(146, 10, 22, 0.45);
}

.hover\\:text-song-color-900\\/5:hover{
  color: rgba(146, 10, 22, 0.05);
}

.hover\\:text-song-color-900\\/50:hover{
  color: rgba(146, 10, 22, 0.5);
}

.hover\\:text-song-color-900\\/55:hover{
  color: rgba(146, 10, 22, 0.55);
}

.hover\\:text-song-color-900\\/60:hover{
  color: rgba(146, 10, 22, 0.6);
}

.hover\\:text-song-color-900\\/65:hover{
  color: rgba(146, 10, 22, 0.65);
}

.hover\\:text-song-color-900\\/70:hover{
  color: rgba(146, 10, 22, 0.7);
}

.hover\\:text-song-color-900\\/75:hover{
  color: rgba(146, 10, 22, 0.75);
}

.hover\\:text-song-color-900\\/80:hover{
  color: rgba(146, 10, 22, 0.8);
}

.hover\\:text-song-color-900\\/85:hover{
  color: rgba(146, 10, 22, 0.85);
}

.hover\\:text-song-color-900\\/90:hover{
  color: rgba(146, 10, 22, 0.9);
}

.hover\\:text-song-color-900\\/95:hover{
  color: rgba(146, 10, 22, 0.95);
}

.hover\\:text-song-color-950:hover{
  --tw-text-opacity: 1;
  color: rgba(81, 0, 7, 1);
  color: rgba(81, 0, 7, var(--tw-text-opacity, 1));
}

.hover\\:text-song-color-950\\/0:hover{
  color: rgba(81, 0, 7, 0);
}

.hover\\:text-song-color-950\\/10:hover{
  color: rgba(81, 0, 7, 0.1);
}

.hover\\:text-song-color-950\\/100:hover{
  color: rgb(81, 0, 7);
}

.hover\\:text-song-color-950\\/15:hover{
  color: rgba(81, 0, 7, 0.15);
}

.hover\\:text-song-color-950\\/20:hover{
  color: rgba(81, 0, 7, 0.2);
}

.hover\\:text-song-color-950\\/25:hover{
  color: rgba(81, 0, 7, 0.25);
}

.hover\\:text-song-color-950\\/30:hover{
  color: rgba(81, 0, 7, 0.3);
}

.hover\\:text-song-color-950\\/35:hover{
  color: rgba(81, 0, 7, 0.35);
}

.hover\\:text-song-color-950\\/40:hover{
  color: rgba(81, 0, 7, 0.4);
}

.hover\\:text-song-color-950\\/45:hover{
  color: rgba(81, 0, 7, 0.45);
}

.hover\\:text-song-color-950\\/5:hover{
  color: rgba(81, 0, 7, 0.05);
}

.hover\\:text-song-color-950\\/50:hover{
  color: rgba(81, 0, 7, 0.5);
}

.hover\\:text-song-color-950\\/55:hover{
  color: rgba(81, 0, 7, 0.55);
}

.hover\\:text-song-color-950\\/60:hover{
  color: rgba(81, 0, 7, 0.6);
}

.hover\\:text-song-color-950\\/65:hover{
  color: rgba(81, 0, 7, 0.65);
}

.hover\\:text-song-color-950\\/70:hover{
  color: rgba(81, 0, 7, 0.7);
}

.hover\\:text-song-color-950\\/75:hover{
  color: rgba(81, 0, 7, 0.75);
}

.hover\\:text-song-color-950\\/80:hover{
  color: rgba(81, 0, 7, 0.8);
}

.hover\\:text-song-color-950\\/85:hover{
  color: rgba(81, 0, 7, 0.85);
}

.hover\\:text-song-color-950\\/90:hover{
  color: rgba(81, 0, 7, 0.9);
}

.hover\\:text-song-color-950\\/95:hover{
  color: rgba(81, 0, 7, 0.95);
}

.hover\\:text-story-color-100:hover{
  --tw-text-opacity: 1;
  color: rgba(218, 238, 243, 1);
  color: rgba(218, 238, 243, var(--tw-text-opacity, 1));
}

.hover\\:text-story-color-100\\/0:hover{
  color: rgba(218, 238, 243, 0);
}

.hover\\:text-story-color-100\\/10:hover{
  color: rgba(218, 238, 243, 0.1);
}

.hover\\:text-story-color-100\\/100:hover{
  color: rgb(218, 238, 243);
}

.hover\\:text-story-color-100\\/15:hover{
  color: rgba(218, 238, 243, 0.15);
}

.hover\\:text-story-color-100\\/20:hover{
  color: rgba(218, 238, 243, 0.2);
}

.hover\\:text-story-color-100\\/25:hover{
  color: rgba(218, 238, 243, 0.25);
}

.hover\\:text-story-color-100\\/30:hover{
  color: rgba(218, 238, 243, 0.3);
}

.hover\\:text-story-color-100\\/35:hover{
  color: rgba(218, 238, 243, 0.35);
}

.hover\\:text-story-color-100\\/40:hover{
  color: rgba(218, 238, 243, 0.4);
}

.hover\\:text-story-color-100\\/45:hover{
  color: rgba(218, 238, 243, 0.45);
}

.hover\\:text-story-color-100\\/5:hover{
  color: rgba(218, 238, 243, 0.05);
}

.hover\\:text-story-color-100\\/50:hover{
  color: rgba(218, 238, 243, 0.5);
}

.hover\\:text-story-color-100\\/55:hover{
  color: rgba(218, 238, 243, 0.55);
}

.hover\\:text-story-color-100\\/60:hover{
  color: rgba(218, 238, 243, 0.6);
}

.hover\\:text-story-color-100\\/65:hover{
  color: rgba(218, 238, 243, 0.65);
}

.hover\\:text-story-color-100\\/70:hover{
  color: rgba(218, 238, 243, 0.7);
}

.hover\\:text-story-color-100\\/75:hover{
  color: rgba(218, 238, 243, 0.75);
}

.hover\\:text-story-color-100\\/80:hover{
  color: rgba(218, 238, 243, 0.8);
}

.hover\\:text-story-color-100\\/85:hover{
  color: rgba(218, 238, 243, 0.85);
}

.hover\\:text-story-color-100\\/90:hover{
  color: rgba(218, 238, 243, 0.9);
}

.hover\\:text-story-color-100\\/95:hover{
  color: rgba(218, 238, 243, 0.95);
}

.hover\\:text-story-color-200:hover{
  --tw-text-opacity: 1;
  color: rgba(186, 222, 231, 1);
  color: rgba(186, 222, 231, var(--tw-text-opacity, 1));
}

.hover\\:text-story-color-200\\/0:hover{
  color: rgba(186, 222, 231, 0);
}

.hover\\:text-story-color-200\\/10:hover{
  color: rgba(186, 222, 231, 0.1);
}

.hover\\:text-story-color-200\\/100:hover{
  color: rgb(186, 222, 231);
}

.hover\\:text-story-color-200\\/15:hover{
  color: rgba(186, 222, 231, 0.15);
}

.hover\\:text-story-color-200\\/20:hover{
  color: rgba(186, 222, 231, 0.2);
}

.hover\\:text-story-color-200\\/25:hover{
  color: rgba(186, 222, 231, 0.25);
}

.hover\\:text-story-color-200\\/30:hover{
  color: rgba(186, 222, 231, 0.3);
}

.hover\\:text-story-color-200\\/35:hover{
  color: rgba(186, 222, 231, 0.35);
}

.hover\\:text-story-color-200\\/40:hover{
  color: rgba(186, 222, 231, 0.4);
}

.hover\\:text-story-color-200\\/45:hover{
  color: rgba(186, 222, 231, 0.45);
}

.hover\\:text-story-color-200\\/5:hover{
  color: rgba(186, 222, 231, 0.05);
}

.hover\\:text-story-color-200\\/50:hover{
  color: rgba(186, 222, 231, 0.5);
}

.hover\\:text-story-color-200\\/55:hover{
  color: rgba(186, 222, 231, 0.55);
}

.hover\\:text-story-color-200\\/60:hover{
  color: rgba(186, 222, 231, 0.6);
}

.hover\\:text-story-color-200\\/65:hover{
  color: rgba(186, 222, 231, 0.65);
}

.hover\\:text-story-color-200\\/70:hover{
  color: rgba(186, 222, 231, 0.7);
}

.hover\\:text-story-color-200\\/75:hover{
  color: rgba(186, 222, 231, 0.75);
}

.hover\\:text-story-color-200\\/80:hover{
  color: rgba(186, 222, 231, 0.8);
}

.hover\\:text-story-color-200\\/85:hover{
  color: rgba(186, 222, 231, 0.85);
}

.hover\\:text-story-color-200\\/90:hover{
  color: rgba(186, 222, 231, 0.9);
}

.hover\\:text-story-color-200\\/95:hover{
  color: rgba(186, 222, 231, 0.95);
}

.hover\\:text-story-color-300:hover{
  --tw-text-opacity: 1;
  color: rgba(137, 197, 215, 1);
  color: rgba(137, 197, 215, var(--tw-text-opacity, 1));
}

.hover\\:text-story-color-300\\/0:hover{
  color: rgba(137, 197, 215, 0);
}

.hover\\:text-story-color-300\\/10:hover{
  color: rgba(137, 197, 215, 0.1);
}

.hover\\:text-story-color-300\\/100:hover{
  color: rgb(137, 197, 215);
}

.hover\\:text-story-color-300\\/15:hover{
  color: rgba(137, 197, 215, 0.15);
}

.hover\\:text-story-color-300\\/20:hover{
  color: rgba(137, 197, 215, 0.2);
}

.hover\\:text-story-color-300\\/25:hover{
  color: rgba(137, 197, 215, 0.25);
}

.hover\\:text-story-color-300\\/30:hover{
  color: rgba(137, 197, 215, 0.3);
}

.hover\\:text-story-color-300\\/35:hover{
  color: rgba(137, 197, 215, 0.35);
}

.hover\\:text-story-color-300\\/40:hover{
  color: rgba(137, 197, 215, 0.4);
}

.hover\\:text-story-color-300\\/45:hover{
  color: rgba(137, 197, 215, 0.45);
}

.hover\\:text-story-color-300\\/5:hover{
  color: rgba(137, 197, 215, 0.05);
}

.hover\\:text-story-color-300\\/50:hover{
  color: rgba(137, 197, 215, 0.5);
}

.hover\\:text-story-color-300\\/55:hover{
  color: rgba(137, 197, 215, 0.55);
}

.hover\\:text-story-color-300\\/60:hover{
  color: rgba(137, 197, 215, 0.6);
}

.hover\\:text-story-color-300\\/65:hover{
  color: rgba(137, 197, 215, 0.65);
}

.hover\\:text-story-color-300\\/70:hover{
  color: rgba(137, 197, 215, 0.7);
}

.hover\\:text-story-color-300\\/75:hover{
  color: rgba(137, 197, 215, 0.75);
}

.hover\\:text-story-color-300\\/80:hover{
  color: rgba(137, 197, 215, 0.8);
}

.hover\\:text-story-color-300\\/85:hover{
  color: rgba(137, 197, 215, 0.85);
}

.hover\\:text-story-color-300\\/90:hover{
  color: rgba(137, 197, 215, 0.9);
}

.hover\\:text-story-color-300\\/95:hover{
  color: rgba(137, 197, 215, 0.95);
}

.hover\\:text-story-color-400:hover{
  --tw-text-opacity: 1;
  color: rgba(82, 163, 190, 1);
  color: rgba(82, 163, 190, var(--tw-text-opacity, 1));
}

.hover\\:text-story-color-400\\/0:hover{
  color: rgba(82, 163, 190, 0);
}

.hover\\:text-story-color-400\\/10:hover{
  color: rgba(82, 163, 190, 0.1);
}

.hover\\:text-story-color-400\\/100:hover{
  color: rgb(82, 163, 190);
}

.hover\\:text-story-color-400\\/15:hover{
  color: rgba(82, 163, 190, 0.15);
}

.hover\\:text-story-color-400\\/20:hover{
  color: rgba(82, 163, 190, 0.2);
}

.hover\\:text-story-color-400\\/25:hover{
  color: rgba(82, 163, 190, 0.25);
}

.hover\\:text-story-color-400\\/30:hover{
  color: rgba(82, 163, 190, 0.3);
}

.hover\\:text-story-color-400\\/35:hover{
  color: rgba(82, 163, 190, 0.35);
}

.hover\\:text-story-color-400\\/40:hover{
  color: rgba(82, 163, 190, 0.4);
}

.hover\\:text-story-color-400\\/45:hover{
  color: rgba(82, 163, 190, 0.45);
}

.hover\\:text-story-color-400\\/5:hover{
  color: rgba(82, 163, 190, 0.05);
}

.hover\\:text-story-color-400\\/50:hover{
  color: rgba(82, 163, 190, 0.5);
}

.hover\\:text-story-color-400\\/55:hover{
  color: rgba(82, 163, 190, 0.55);
}

.hover\\:text-story-color-400\\/60:hover{
  color: rgba(82, 163, 190, 0.6);
}

.hover\\:text-story-color-400\\/65:hover{
  color: rgba(82, 163, 190, 0.65);
}

.hover\\:text-story-color-400\\/70:hover{
  color: rgba(82, 163, 190, 0.7);
}

.hover\\:text-story-color-400\\/75:hover{
  color: rgba(82, 163, 190, 0.75);
}

.hover\\:text-story-color-400\\/80:hover{
  color: rgba(82, 163, 190, 0.8);
}

.hover\\:text-story-color-400\\/85:hover{
  color: rgba(82, 163, 190, 0.85);
}

.hover\\:text-story-color-400\\/90:hover{
  color: rgba(82, 163, 190, 0.9);
}

.hover\\:text-story-color-400\\/95:hover{
  color: rgba(82, 163, 190, 0.95);
}

.hover\\:text-story-color-500:hover{
  --tw-text-opacity: 1;
  color: rgba(55, 135, 163, 1);
  color: rgba(55, 135, 163, var(--tw-text-opacity, 1));
}

.hover\\:text-story-color-500\\/0:hover{
  color: rgba(55, 135, 163, 0);
}

.hover\\:text-story-color-500\\/10:hover{
  color: rgba(55, 135, 163, 0.1);
}

.hover\\:text-story-color-500\\/100:hover{
  color: rgb(55, 135, 163);
}

.hover\\:text-story-color-500\\/15:hover{
  color: rgba(55, 135, 163, 0.15);
}

.hover\\:text-story-color-500\\/20:hover{
  color: rgba(55, 135, 163, 0.2);
}

.hover\\:text-story-color-500\\/25:hover{
  color: rgba(55, 135, 163, 0.25);
}

.hover\\:text-story-color-500\\/30:hover{
  color: rgba(55, 135, 163, 0.3);
}

.hover\\:text-story-color-500\\/35:hover{
  color: rgba(55, 135, 163, 0.35);
}

.hover\\:text-story-color-500\\/40:hover{
  color: rgba(55, 135, 163, 0.4);
}

.hover\\:text-story-color-500\\/45:hover{
  color: rgba(55, 135, 163, 0.45);
}

.hover\\:text-story-color-500\\/5:hover{
  color: rgba(55, 135, 163, 0.05);
}

.hover\\:text-story-color-500\\/50:hover{
  color: rgba(55, 135, 163, 0.5);
}

.hover\\:text-story-color-500\\/55:hover{
  color: rgba(55, 135, 163, 0.55);
}

.hover\\:text-story-color-500\\/60:hover{
  color: rgba(55, 135, 163, 0.6);
}

.hover\\:text-story-color-500\\/65:hover{
  color: rgba(55, 135, 163, 0.65);
}

.hover\\:text-story-color-500\\/70:hover{
  color: rgba(55, 135, 163, 0.7);
}

.hover\\:text-story-color-500\\/75:hover{
  color: rgba(55, 135, 163, 0.75);
}

.hover\\:text-story-color-500\\/80:hover{
  color: rgba(55, 135, 163, 0.8);
}

.hover\\:text-story-color-500\\/85:hover{
  color: rgba(55, 135, 163, 0.85);
}

.hover\\:text-story-color-500\\/90:hover{
  color: rgba(55, 135, 163, 0.9);
}

.hover\\:text-story-color-500\\/95:hover{
  color: rgba(55, 135, 163, 0.95);
}

.hover\\:text-story-color-600:hover{
  --tw-text-opacity: 1;
  color: rgba(48, 109, 138, 1);
  color: rgba(48, 109, 138, var(--tw-text-opacity, 1));
}

.hover\\:text-story-color-600\\/0:hover{
  color: rgba(48, 109, 138, 0);
}

.hover\\:text-story-color-600\\/10:hover{
  color: rgba(48, 109, 138, 0.1);
}

.hover\\:text-story-color-600\\/100:hover{
  color: rgb(48, 109, 138);
}

.hover\\:text-story-color-600\\/15:hover{
  color: rgba(48, 109, 138, 0.15);
}

.hover\\:text-story-color-600\\/20:hover{
  color: rgba(48, 109, 138, 0.2);
}

.hover\\:text-story-color-600\\/25:hover{
  color: rgba(48, 109, 138, 0.25);
}

.hover\\:text-story-color-600\\/30:hover{
  color: rgba(48, 109, 138, 0.3);
}

.hover\\:text-story-color-600\\/35:hover{
  color: rgba(48, 109, 138, 0.35);
}

.hover\\:text-story-color-600\\/40:hover{
  color: rgba(48, 109, 138, 0.4);
}

.hover\\:text-story-color-600\\/45:hover{
  color: rgba(48, 109, 138, 0.45);
}

.hover\\:text-story-color-600\\/5:hover{
  color: rgba(48, 109, 138, 0.05);
}

.hover\\:text-story-color-600\\/50:hover{
  color: rgba(48, 109, 138, 0.5);
}

.hover\\:text-story-color-600\\/55:hover{
  color: rgba(48, 109, 138, 0.55);
}

.hover\\:text-story-color-600\\/60:hover{
  color: rgba(48, 109, 138, 0.6);
}

.hover\\:text-story-color-600\\/65:hover{
  color: rgba(48, 109, 138, 0.65);
}

.hover\\:text-story-color-600\\/70:hover{
  color: rgba(48, 109, 138, 0.7);
}

.hover\\:text-story-color-600\\/75:hover{
  color: rgba(48, 109, 138, 0.75);
}

.hover\\:text-story-color-600\\/80:hover{
  color: rgba(48, 109, 138, 0.8);
}

.hover\\:text-story-color-600\\/85:hover{
  color: rgba(48, 109, 138, 0.85);
}

.hover\\:text-story-color-600\\/90:hover{
  color: rgba(48, 109, 138, 0.9);
}

.hover\\:text-story-color-600\\/95:hover{
  color: rgba(48, 109, 138, 0.95);
}

.hover\\:text-story-color-700:hover{
  --tw-text-opacity: 1;
  color: rgba(45, 91, 114, 1);
  color: rgba(45, 91, 114, var(--tw-text-opacity, 1));
}

.hover\\:text-story-color-700\\/0:hover{
  color: rgba(45, 91, 114, 0);
}

.hover\\:text-story-color-700\\/10:hover{
  color: rgba(45, 91, 114, 0.1);
}

.hover\\:text-story-color-700\\/100:hover{
  color: rgb(45, 91, 114);
}

.hover\\:text-story-color-700\\/15:hover{
  color: rgba(45, 91, 114, 0.15);
}

.hover\\:text-story-color-700\\/20:hover{
  color: rgba(45, 91, 114, 0.2);
}

.hover\\:text-story-color-700\\/25:hover{
  color: rgba(45, 91, 114, 0.25);
}

.hover\\:text-story-color-700\\/30:hover{
  color: rgba(45, 91, 114, 0.3);
}

.hover\\:text-story-color-700\\/35:hover{
  color: rgba(45, 91, 114, 0.35);
}

.hover\\:text-story-color-700\\/40:hover{
  color: rgba(45, 91, 114, 0.4);
}

.hover\\:text-story-color-700\\/45:hover{
  color: rgba(45, 91, 114, 0.45);
}

.hover\\:text-story-color-700\\/5:hover{
  color: rgba(45, 91, 114, 0.05);
}

.hover\\:text-story-color-700\\/50:hover{
  color: rgba(45, 91, 114, 0.5);
}

.hover\\:text-story-color-700\\/55:hover{
  color: rgba(45, 91, 114, 0.55);
}

.hover\\:text-story-color-700\\/60:hover{
  color: rgba(45, 91, 114, 0.6);
}

.hover\\:text-story-color-700\\/65:hover{
  color: rgba(45, 91, 114, 0.65);
}

.hover\\:text-story-color-700\\/70:hover{
  color: rgba(45, 91, 114, 0.7);
}

.hover\\:text-story-color-700\\/75:hover{
  color: rgba(45, 91, 114, 0.75);
}

.hover\\:text-story-color-700\\/80:hover{
  color: rgba(45, 91, 114, 0.8);
}

.hover\\:text-story-color-700\\/85:hover{
  color: rgba(45, 91, 114, 0.85);
}

.hover\\:text-story-color-700\\/90:hover{
  color: rgba(45, 91, 114, 0.9);
}

.hover\\:text-story-color-700\\/95:hover{
  color: rgba(45, 91, 114, 0.95);
}

.hover\\:text-story-color-800:hover{
  --tw-text-opacity: 1;
  color: rgba(44, 76, 94, 1);
  color: rgba(44, 76, 94, var(--tw-text-opacity, 1));
}

.hover\\:text-story-color-800\\/0:hover{
  color: rgba(44, 76, 94, 0);
}

.hover\\:text-story-color-800\\/10:hover{
  color: rgba(44, 76, 94, 0.1);
}

.hover\\:text-story-color-800\\/100:hover{
  color: rgb(44, 76, 94);
}

.hover\\:text-story-color-800\\/15:hover{
  color: rgba(44, 76, 94, 0.15);
}

.hover\\:text-story-color-800\\/20:hover{
  color: rgba(44, 76, 94, 0.2);
}

.hover\\:text-story-color-800\\/25:hover{
  color: rgba(44, 76, 94, 0.25);
}

.hover\\:text-story-color-800\\/30:hover{
  color: rgba(44, 76, 94, 0.3);
}

.hover\\:text-story-color-800\\/35:hover{
  color: rgba(44, 76, 94, 0.35);
}

.hover\\:text-story-color-800\\/40:hover{
  color: rgba(44, 76, 94, 0.4);
}

.hover\\:text-story-color-800\\/45:hover{
  color: rgba(44, 76, 94, 0.45);
}

.hover\\:text-story-color-800\\/5:hover{
  color: rgba(44, 76, 94, 0.05);
}

.hover\\:text-story-color-800\\/50:hover{
  color: rgba(44, 76, 94, 0.5);
}

.hover\\:text-story-color-800\\/55:hover{
  color: rgba(44, 76, 94, 0.55);
}

.hover\\:text-story-color-800\\/60:hover{
  color: rgba(44, 76, 94, 0.6);
}

.hover\\:text-story-color-800\\/65:hover{
  color: rgba(44, 76, 94, 0.65);
}

.hover\\:text-story-color-800\\/70:hover{
  color: rgba(44, 76, 94, 0.7);
}

.hover\\:text-story-color-800\\/75:hover{
  color: rgba(44, 76, 94, 0.75);
}

.hover\\:text-story-color-800\\/80:hover{
  color: rgba(44, 76, 94, 0.8);
}

.hover\\:text-story-color-800\\/85:hover{
  color: rgba(44, 76, 94, 0.85);
}

.hover\\:text-story-color-800\\/90:hover{
  color: rgba(44, 76, 94, 0.9);
}

.hover\\:text-story-color-800\\/95:hover{
  color: rgba(44, 76, 94, 0.95);
}

.hover\\:text-story-color-900:hover{
  --tw-text-opacity: 1;
  color: rgba(40, 65, 81, 1);
  color: rgba(40, 65, 81, var(--tw-text-opacity, 1));
}

.hover\\:text-story-color-900\\/0:hover{
  color: rgba(40, 65, 81, 0);
}

.hover\\:text-story-color-900\\/10:hover{
  color: rgba(40, 65, 81, 0.1);
}

.hover\\:text-story-color-900\\/100:hover{
  color: rgb(40, 65, 81);
}

.hover\\:text-story-color-900\\/15:hover{
  color: rgba(40, 65, 81, 0.15);
}

.hover\\:text-story-color-900\\/20:hover{
  color: rgba(40, 65, 81, 0.2);
}

.hover\\:text-story-color-900\\/25:hover{
  color: rgba(40, 65, 81, 0.25);
}

.hover\\:text-story-color-900\\/30:hover{
  color: rgba(40, 65, 81, 0.3);
}

.hover\\:text-story-color-900\\/35:hover{
  color: rgba(40, 65, 81, 0.35);
}

.hover\\:text-story-color-900\\/40:hover{
  color: rgba(40, 65, 81, 0.4);
}

.hover\\:text-story-color-900\\/45:hover{
  color: rgba(40, 65, 81, 0.45);
}

.hover\\:text-story-color-900\\/5:hover{
  color: rgba(40, 65, 81, 0.05);
}

.hover\\:text-story-color-900\\/50:hover{
  color: rgba(40, 65, 81, 0.5);
}

.hover\\:text-story-color-900\\/55:hover{
  color: rgba(40, 65, 81, 0.55);
}

.hover\\:text-story-color-900\\/60:hover{
  color: rgba(40, 65, 81, 0.6);
}

.hover\\:text-story-color-900\\/65:hover{
  color: rgba(40, 65, 81, 0.65);
}

.hover\\:text-story-color-900\\/70:hover{
  color: rgba(40, 65, 81, 0.7);
}

.hover\\:text-story-color-900\\/75:hover{
  color: rgba(40, 65, 81, 0.75);
}

.hover\\:text-story-color-900\\/80:hover{
  color: rgba(40, 65, 81, 0.8);
}

.hover\\:text-story-color-900\\/85:hover{
  color: rgba(40, 65, 81, 0.85);
}

.hover\\:text-story-color-900\\/90:hover{
  color: rgba(40, 65, 81, 0.9);
}

.hover\\:text-story-color-900\\/95:hover{
  color: rgba(40, 65, 81, 0.95);
}

.hover\\:text-story-color-950:hover{
  --tw-text-opacity: 1;
  color: rgba(22, 41, 54, 1);
  color: rgba(22, 41, 54, var(--tw-text-opacity, 1));
}

.hover\\:text-story-color-950\\/0:hover{
  color: rgba(22, 41, 54, 0);
}

.hover\\:text-story-color-950\\/10:hover{
  color: rgba(22, 41, 54, 0.1);
}

.hover\\:text-story-color-950\\/100:hover{
  color: rgb(22, 41, 54);
}

.hover\\:text-story-color-950\\/15:hover{
  color: rgba(22, 41, 54, 0.15);
}

.hover\\:text-story-color-950\\/20:hover{
  color: rgba(22, 41, 54, 0.2);
}

.hover\\:text-story-color-950\\/25:hover{
  color: rgba(22, 41, 54, 0.25);
}

.hover\\:text-story-color-950\\/30:hover{
  color: rgba(22, 41, 54, 0.3);
}

.hover\\:text-story-color-950\\/35:hover{
  color: rgba(22, 41, 54, 0.35);
}

.hover\\:text-story-color-950\\/40:hover{
  color: rgba(22, 41, 54, 0.4);
}

.hover\\:text-story-color-950\\/45:hover{
  color: rgba(22, 41, 54, 0.45);
}

.hover\\:text-story-color-950\\/5:hover{
  color: rgba(22, 41, 54, 0.05);
}

.hover\\:text-story-color-950\\/50:hover{
  color: rgba(22, 41, 54, 0.5);
}

.hover\\:text-story-color-950\\/55:hover{
  color: rgba(22, 41, 54, 0.55);
}

.hover\\:text-story-color-950\\/60:hover{
  color: rgba(22, 41, 54, 0.6);
}

.hover\\:text-story-color-950\\/65:hover{
  color: rgba(22, 41, 54, 0.65);
}

.hover\\:text-story-color-950\\/70:hover{
  color: rgba(22, 41, 54, 0.7);
}

.hover\\:text-story-color-950\\/75:hover{
  color: rgba(22, 41, 54, 0.75);
}

.hover\\:text-story-color-950\\/80:hover{
  color: rgba(22, 41, 54, 0.8);
}

.hover\\:text-story-color-950\\/85:hover{
  color: rgba(22, 41, 54, 0.85);
}

.hover\\:text-story-color-950\\/90:hover{
  color: rgba(22, 41, 54, 0.9);
}

.hover\\:text-story-color-950\\/95:hover{
  color: rgba(22, 41, 54, 0.95);
}

.hover\\:text-violet-100:hover{
  --tw-text-opacity: 1;
  color: rgba(237, 233, 254, 1);
  color: rgba(237, 233, 254, var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity, 1));
}

.hover\\:text-word-color-100:hover{
  --tw-text-opacity: 1;
  color: rgba(217, 242, 230, 1);
  color: rgba(217, 242, 230, var(--tw-text-opacity, 1));
}

.hover\\:text-word-color-100\\/0:hover{
  color: rgba(217, 242, 230, 0);
}

.hover\\:text-word-color-100\\/10:hover{
  color: rgba(217, 242, 230, 0.1);
}

.hover\\:text-word-color-100\\/100:hover{
  color: rgb(217, 242, 230);
}

.hover\\:text-word-color-100\\/15:hover{
  color: rgba(217, 242, 230, 0.15);
}

.hover\\:text-word-color-100\\/20:hover{
  color: rgba(217, 242, 230, 0.2);
}

.hover\\:text-word-color-100\\/25:hover{
  color: rgba(217, 242, 230, 0.25);
}

.hover\\:text-word-color-100\\/30:hover{
  color: rgba(217, 242, 230, 0.3);
}

.hover\\:text-word-color-100\\/35:hover{
  color: rgba(217, 242, 230, 0.35);
}

.hover\\:text-word-color-100\\/40:hover{
  color: rgba(217, 242, 230, 0.4);
}

.hover\\:text-word-color-100\\/45:hover{
  color: rgba(217, 242, 230, 0.45);
}

.hover\\:text-word-color-100\\/5:hover{
  color: rgba(217, 242, 230, 0.05);
}

.hover\\:text-word-color-100\\/50:hover{
  color: rgba(217, 242, 230, 0.5);
}

.hover\\:text-word-color-100\\/55:hover{
  color: rgba(217, 242, 230, 0.55);
}

.hover\\:text-word-color-100\\/60:hover{
  color: rgba(217, 242, 230, 0.6);
}

.hover\\:text-word-color-100\\/65:hover{
  color: rgba(217, 242, 230, 0.65);
}

.hover\\:text-word-color-100\\/70:hover{
  color: rgba(217, 242, 230, 0.7);
}

.hover\\:text-word-color-100\\/75:hover{
  color: rgba(217, 242, 230, 0.75);
}

.hover\\:text-word-color-100\\/80:hover{
  color: rgba(217, 242, 230, 0.8);
}

.hover\\:text-word-color-100\\/85:hover{
  color: rgba(217, 242, 230, 0.85);
}

.hover\\:text-word-color-100\\/90:hover{
  color: rgba(217, 242, 230, 0.9);
}

.hover\\:text-word-color-100\\/95:hover{
  color: rgba(217, 242, 230, 0.95);
}

.hover\\:text-word-color-200:hover{
  --tw-text-opacity: 1;
  color: rgba(182, 228, 209, 1);
  color: rgba(182, 228, 209, var(--tw-text-opacity, 1));
}

.hover\\:text-word-color-200\\/0:hover{
  color: rgba(182, 228, 209, 0);
}

.hover\\:text-word-color-200\\/10:hover{
  color: rgba(182, 228, 209, 0.1);
}

.hover\\:text-word-color-200\\/100:hover{
  color: rgb(182, 228, 209);
}

.hover\\:text-word-color-200\\/15:hover{
  color: rgba(182, 228, 209, 0.15);
}

.hover\\:text-word-color-200\\/20:hover{
  color: rgba(182, 228, 209, 0.2);
}

.hover\\:text-word-color-200\\/25:hover{
  color: rgba(182, 228, 209, 0.25);
}

.hover\\:text-word-color-200\\/30:hover{
  color: rgba(182, 228, 209, 0.3);
}

.hover\\:text-word-color-200\\/35:hover{
  color: rgba(182, 228, 209, 0.35);
}

.hover\\:text-word-color-200\\/40:hover{
  color: rgba(182, 228, 209, 0.4);
}

.hover\\:text-word-color-200\\/45:hover{
  color: rgba(182, 228, 209, 0.45);
}

.hover\\:text-word-color-200\\/5:hover{
  color: rgba(182, 228, 209, 0.05);
}

.hover\\:text-word-color-200\\/50:hover{
  color: rgba(182, 228, 209, 0.5);
}

.hover\\:text-word-color-200\\/55:hover{
  color: rgba(182, 228, 209, 0.55);
}

.hover\\:text-word-color-200\\/60:hover{
  color: rgba(182, 228, 209, 0.6);
}

.hover\\:text-word-color-200\\/65:hover{
  color: rgba(182, 228, 209, 0.65);
}

.hover\\:text-word-color-200\\/70:hover{
  color: rgba(182, 228, 209, 0.7);
}

.hover\\:text-word-color-200\\/75:hover{
  color: rgba(182, 228, 209, 0.75);
}

.hover\\:text-word-color-200\\/80:hover{
  color: rgba(182, 228, 209, 0.8);
}

.hover\\:text-word-color-200\\/85:hover{
  color: rgba(182, 228, 209, 0.85);
}

.hover\\:text-word-color-200\\/90:hover{
  color: rgba(182, 228, 209, 0.9);
}

.hover\\:text-word-color-200\\/95:hover{
  color: rgba(182, 228, 209, 0.95);
}

.hover\\:text-word-color-300:hover{
  --tw-text-opacity: 1;
  color: rgba(134, 207, 181, 1);
  color: rgba(134, 207, 181, var(--tw-text-opacity, 1));
}

.hover\\:text-word-color-300\\/0:hover{
  color: rgba(134, 207, 181, 0);
}

.hover\\:text-word-color-300\\/10:hover{
  color: rgba(134, 207, 181, 0.1);
}

.hover\\:text-word-color-300\\/100:hover{
  color: rgb(134, 207, 181);
}

.hover\\:text-word-color-300\\/15:hover{
  color: rgba(134, 207, 181, 0.15);
}

.hover\\:text-word-color-300\\/20:hover{
  color: rgba(134, 207, 181, 0.2);
}

.hover\\:text-word-color-300\\/25:hover{
  color: rgba(134, 207, 181, 0.25);
}

.hover\\:text-word-color-300\\/30:hover{
  color: rgba(134, 207, 181, 0.3);
}

.hover\\:text-word-color-300\\/35:hover{
  color: rgba(134, 207, 181, 0.35);
}

.hover\\:text-word-color-300\\/40:hover{
  color: rgba(134, 207, 181, 0.4);
}

.hover\\:text-word-color-300\\/45:hover{
  color: rgba(134, 207, 181, 0.45);
}

.hover\\:text-word-color-300\\/5:hover{
  color: rgba(134, 207, 181, 0.05);
}

.hover\\:text-word-color-300\\/50:hover{
  color: rgba(134, 207, 181, 0.5);
}

.hover\\:text-word-color-300\\/55:hover{
  color: rgba(134, 207, 181, 0.55);
}

.hover\\:text-word-color-300\\/60:hover{
  color: rgba(134, 207, 181, 0.6);
}

.hover\\:text-word-color-300\\/65:hover{
  color: rgba(134, 207, 181, 0.65);
}

.hover\\:text-word-color-300\\/70:hover{
  color: rgba(134, 207, 181, 0.7);
}

.hover\\:text-word-color-300\\/75:hover{
  color: rgba(134, 207, 181, 0.75);
}

.hover\\:text-word-color-300\\/80:hover{
  color: rgba(134, 207, 181, 0.8);
}

.hover\\:text-word-color-300\\/85:hover{
  color: rgba(134, 207, 181, 0.85);
}

.hover\\:text-word-color-300\\/90:hover{
  color: rgba(134, 207, 181, 0.9);
}

.hover\\:text-word-color-300\\/95:hover{
  color: rgba(134, 207, 181, 0.95);
}

.hover\\:text-word-color-400:hover{
  --tw-text-opacity: 1;
  color: rgba(83, 180, 148, 1);
  color: rgba(83, 180, 148, var(--tw-text-opacity, 1));
}

.hover\\:text-word-color-400\\/0:hover{
  color: rgba(83, 180, 148, 0);
}

.hover\\:text-word-color-400\\/10:hover{
  color: rgba(83, 180, 148, 0.1);
}

.hover\\:text-word-color-400\\/100:hover{
  color: rgb(83, 180, 148);
}

.hover\\:text-word-color-400\\/15:hover{
  color: rgba(83, 180, 148, 0.15);
}

.hover\\:text-word-color-400\\/20:hover{
  color: rgba(83, 180, 148, 0.2);
}

.hover\\:text-word-color-400\\/25:hover{
  color: rgba(83, 180, 148, 0.25);
}

.hover\\:text-word-color-400\\/30:hover{
  color: rgba(83, 180, 148, 0.3);
}

.hover\\:text-word-color-400\\/35:hover{
  color: rgba(83, 180, 148, 0.35);
}

.hover\\:text-word-color-400\\/40:hover{
  color: rgba(83, 180, 148, 0.4);
}

.hover\\:text-word-color-400\\/45:hover{
  color: rgba(83, 180, 148, 0.45);
}

.hover\\:text-word-color-400\\/5:hover{
  color: rgba(83, 180, 148, 0.05);
}

.hover\\:text-word-color-400\\/50:hover{
  color: rgba(83, 180, 148, 0.5);
}

.hover\\:text-word-color-400\\/55:hover{
  color: rgba(83, 180, 148, 0.55);
}

.hover\\:text-word-color-400\\/60:hover{
  color: rgba(83, 180, 148, 0.6);
}

.hover\\:text-word-color-400\\/65:hover{
  color: rgba(83, 180, 148, 0.65);
}

.hover\\:text-word-color-400\\/70:hover{
  color: rgba(83, 180, 148, 0.7);
}

.hover\\:text-word-color-400\\/75:hover{
  color: rgba(83, 180, 148, 0.75);
}

.hover\\:text-word-color-400\\/80:hover{
  color: rgba(83, 180, 148, 0.8);
}

.hover\\:text-word-color-400\\/85:hover{
  color: rgba(83, 180, 148, 0.85);
}

.hover\\:text-word-color-400\\/90:hover{
  color: rgba(83, 180, 148, 0.9);
}

.hover\\:text-word-color-400\\/95:hover{
  color: rgba(83, 180, 148, 0.95);
}

.hover\\:text-word-color-500:hover{
  --tw-text-opacity: 1;
  color: rgba(44, 135, 109, 1);
  color: rgba(44, 135, 109, var(--tw-text-opacity, 1));
}

.hover\\:text-word-color-500\\/0:hover{
  color: rgba(44, 135, 109, 0);
}

.hover\\:text-word-color-500\\/10:hover{
  color: rgba(44, 135, 109, 0.1);
}

.hover\\:text-word-color-500\\/100:hover{
  color: rgb(44, 135, 109);
}

.hover\\:text-word-color-500\\/15:hover{
  color: rgba(44, 135, 109, 0.15);
}

.hover\\:text-word-color-500\\/20:hover{
  color: rgba(44, 135, 109, 0.2);
}

.hover\\:text-word-color-500\\/25:hover{
  color: rgba(44, 135, 109, 0.25);
}

.hover\\:text-word-color-500\\/30:hover{
  color: rgba(44, 135, 109, 0.3);
}

.hover\\:text-word-color-500\\/35:hover{
  color: rgba(44, 135, 109, 0.35);
}

.hover\\:text-word-color-500\\/40:hover{
  color: rgba(44, 135, 109, 0.4);
}

.hover\\:text-word-color-500\\/45:hover{
  color: rgba(44, 135, 109, 0.45);
}

.hover\\:text-word-color-500\\/5:hover{
  color: rgba(44, 135, 109, 0.05);
}

.hover\\:text-word-color-500\\/50:hover{
  color: rgba(44, 135, 109, 0.5);
}

.hover\\:text-word-color-500\\/55:hover{
  color: rgba(44, 135, 109, 0.55);
}

.hover\\:text-word-color-500\\/60:hover{
  color: rgba(44, 135, 109, 0.6);
}

.hover\\:text-word-color-500\\/65:hover{
  color: rgba(44, 135, 109, 0.65);
}

.hover\\:text-word-color-500\\/70:hover{
  color: rgba(44, 135, 109, 0.7);
}

.hover\\:text-word-color-500\\/75:hover{
  color: rgba(44, 135, 109, 0.75);
}

.hover\\:text-word-color-500\\/80:hover{
  color: rgba(44, 135, 109, 0.8);
}

.hover\\:text-word-color-500\\/85:hover{
  color: rgba(44, 135, 109, 0.85);
}

.hover\\:text-word-color-500\\/90:hover{
  color: rgba(44, 135, 109, 0.9);
}

.hover\\:text-word-color-500\\/95:hover{
  color: rgba(44, 135, 109, 0.95);
}

.hover\\:text-word-color-600:hover{
  --tw-text-opacity: 1;
  color: rgba(34, 121, 98, 1);
  color: rgba(34, 121, 98, var(--tw-text-opacity, 1));
}

.hover\\:text-word-color-600\\/0:hover{
  color: rgba(34, 121, 98, 0);
}

.hover\\:text-word-color-600\\/10:hover{
  color: rgba(34, 121, 98, 0.1);
}

.hover\\:text-word-color-600\\/100:hover{
  color: rgb(34, 121, 98);
}

.hover\\:text-word-color-600\\/15:hover{
  color: rgba(34, 121, 98, 0.15);
}

.hover\\:text-word-color-600\\/20:hover{
  color: rgba(34, 121, 98, 0.2);
}

.hover\\:text-word-color-600\\/25:hover{
  color: rgba(34, 121, 98, 0.25);
}

.hover\\:text-word-color-600\\/30:hover{
  color: rgba(34, 121, 98, 0.3);
}

.hover\\:text-word-color-600\\/35:hover{
  color: rgba(34, 121, 98, 0.35);
}

.hover\\:text-word-color-600\\/40:hover{
  color: rgba(34, 121, 98, 0.4);
}

.hover\\:text-word-color-600\\/45:hover{
  color: rgba(34, 121, 98, 0.45);
}

.hover\\:text-word-color-600\\/5:hover{
  color: rgba(34, 121, 98, 0.05);
}

.hover\\:text-word-color-600\\/50:hover{
  color: rgba(34, 121, 98, 0.5);
}

.hover\\:text-word-color-600\\/55:hover{
  color: rgba(34, 121, 98, 0.55);
}

.hover\\:text-word-color-600\\/60:hover{
  color: rgba(34, 121, 98, 0.6);
}

.hover\\:text-word-color-600\\/65:hover{
  color: rgba(34, 121, 98, 0.65);
}

.hover\\:text-word-color-600\\/70:hover{
  color: rgba(34, 121, 98, 0.7);
}

.hover\\:text-word-color-600\\/75:hover{
  color: rgba(34, 121, 98, 0.75);
}

.hover\\:text-word-color-600\\/80:hover{
  color: rgba(34, 121, 98, 0.8);
}

.hover\\:text-word-color-600\\/85:hover{
  color: rgba(34, 121, 98, 0.85);
}

.hover\\:text-word-color-600\\/90:hover{
  color: rgba(34, 121, 98, 0.9);
}

.hover\\:text-word-color-600\\/95:hover{
  color: rgba(34, 121, 98, 0.95);
}

.hover\\:text-word-color-700:hover{
  --tw-text-opacity: 1;
  color: rgba(27, 97, 80, 1);
  color: rgba(27, 97, 80, var(--tw-text-opacity, 1));
}

.hover\\:text-word-color-700\\/0:hover{
  color: rgba(27, 97, 80, 0);
}

.hover\\:text-word-color-700\\/10:hover{
  color: rgba(27, 97, 80, 0.1);
}

.hover\\:text-word-color-700\\/100:hover{
  color: rgb(27, 97, 80);
}

.hover\\:text-word-color-700\\/15:hover{
  color: rgba(27, 97, 80, 0.15);
}

.hover\\:text-word-color-700\\/20:hover{
  color: rgba(27, 97, 80, 0.2);
}

.hover\\:text-word-color-700\\/25:hover{
  color: rgba(27, 97, 80, 0.25);
}

.hover\\:text-word-color-700\\/30:hover{
  color: rgba(27, 97, 80, 0.3);
}

.hover\\:text-word-color-700\\/35:hover{
  color: rgba(27, 97, 80, 0.35);
}

.hover\\:text-word-color-700\\/40:hover{
  color: rgba(27, 97, 80, 0.4);
}

.hover\\:text-word-color-700\\/45:hover{
  color: rgba(27, 97, 80, 0.45);
}

.hover\\:text-word-color-700\\/5:hover{
  color: rgba(27, 97, 80, 0.05);
}

.hover\\:text-word-color-700\\/50:hover{
  color: rgba(27, 97, 80, 0.5);
}

.hover\\:text-word-color-700\\/55:hover{
  color: rgba(27, 97, 80, 0.55);
}

.hover\\:text-word-color-700\\/60:hover{
  color: rgba(27, 97, 80, 0.6);
}

.hover\\:text-word-color-700\\/65:hover{
  color: rgba(27, 97, 80, 0.65);
}

.hover\\:text-word-color-700\\/70:hover{
  color: rgba(27, 97, 80, 0.7);
}

.hover\\:text-word-color-700\\/75:hover{
  color: rgba(27, 97, 80, 0.75);
}

.hover\\:text-word-color-700\\/80:hover{
  color: rgba(27, 97, 80, 0.8);
}

.hover\\:text-word-color-700\\/85:hover{
  color: rgba(27, 97, 80, 0.85);
}

.hover\\:text-word-color-700\\/90:hover{
  color: rgba(27, 97, 80, 0.9);
}

.hover\\:text-word-color-700\\/95:hover{
  color: rgba(27, 97, 80, 0.95);
}

.hover\\:text-word-color-800:hover{
  --tw-text-opacity: 1;
  color: rgba(24, 77, 64, 1);
  color: rgba(24, 77, 64, var(--tw-text-opacity, 1));
}

.hover\\:text-word-color-800\\/0:hover{
  color: rgba(24, 77, 64, 0);
}

.hover\\:text-word-color-800\\/10:hover{
  color: rgba(24, 77, 64, 0.1);
}

.hover\\:text-word-color-800\\/100:hover{
  color: rgb(24, 77, 64);
}

.hover\\:text-word-color-800\\/15:hover{
  color: rgba(24, 77, 64, 0.15);
}

.hover\\:text-word-color-800\\/20:hover{
  color: rgba(24, 77, 64, 0.2);
}

.hover\\:text-word-color-800\\/25:hover{
  color: rgba(24, 77, 64, 0.25);
}

.hover\\:text-word-color-800\\/30:hover{
  color: rgba(24, 77, 64, 0.3);
}

.hover\\:text-word-color-800\\/35:hover{
  color: rgba(24, 77, 64, 0.35);
}

.hover\\:text-word-color-800\\/40:hover{
  color: rgba(24, 77, 64, 0.4);
}

.hover\\:text-word-color-800\\/45:hover{
  color: rgba(24, 77, 64, 0.45);
}

.hover\\:text-word-color-800\\/5:hover{
  color: rgba(24, 77, 64, 0.05);
}

.hover\\:text-word-color-800\\/50:hover{
  color: rgba(24, 77, 64, 0.5);
}

.hover\\:text-word-color-800\\/55:hover{
  color: rgba(24, 77, 64, 0.55);
}

.hover\\:text-word-color-800\\/60:hover{
  color: rgba(24, 77, 64, 0.6);
}

.hover\\:text-word-color-800\\/65:hover{
  color: rgba(24, 77, 64, 0.65);
}

.hover\\:text-word-color-800\\/70:hover{
  color: rgba(24, 77, 64, 0.7);
}

.hover\\:text-word-color-800\\/75:hover{
  color: rgba(24, 77, 64, 0.75);
}

.hover\\:text-word-color-800\\/80:hover{
  color: rgba(24, 77, 64, 0.8);
}

.hover\\:text-word-color-800\\/85:hover{
  color: rgba(24, 77, 64, 0.85);
}

.hover\\:text-word-color-800\\/90:hover{
  color: rgba(24, 77, 64, 0.9);
}

.hover\\:text-word-color-800\\/95:hover{
  color: rgba(24, 77, 64, 0.95);
}

.hover\\:text-word-color-900:hover{
  --tw-text-opacity: 1;
  color: rgba(20, 64, 54, 1);
  color: rgba(20, 64, 54, var(--tw-text-opacity, 1));
}

.hover\\:text-word-color-900\\/0:hover{
  color: rgba(20, 64, 54, 0);
}

.hover\\:text-word-color-900\\/10:hover{
  color: rgba(20, 64, 54, 0.1);
}

.hover\\:text-word-color-900\\/100:hover{
  color: rgb(20, 64, 54);
}

.hover\\:text-word-color-900\\/15:hover{
  color: rgba(20, 64, 54, 0.15);
}

.hover\\:text-word-color-900\\/20:hover{
  color: rgba(20, 64, 54, 0.2);
}

.hover\\:text-word-color-900\\/25:hover{
  color: rgba(20, 64, 54, 0.25);
}

.hover\\:text-word-color-900\\/30:hover{
  color: rgba(20, 64, 54, 0.3);
}

.hover\\:text-word-color-900\\/35:hover{
  color: rgba(20, 64, 54, 0.35);
}

.hover\\:text-word-color-900\\/40:hover{
  color: rgba(20, 64, 54, 0.4);
}

.hover\\:text-word-color-900\\/45:hover{
  color: rgba(20, 64, 54, 0.45);
}

.hover\\:text-word-color-900\\/5:hover{
  color: rgba(20, 64, 54, 0.05);
}

.hover\\:text-word-color-900\\/50:hover{
  color: rgba(20, 64, 54, 0.5);
}

.hover\\:text-word-color-900\\/55:hover{
  color: rgba(20, 64, 54, 0.55);
}

.hover\\:text-word-color-900\\/60:hover{
  color: rgba(20, 64, 54, 0.6);
}

.hover\\:text-word-color-900\\/65:hover{
  color: rgba(20, 64, 54, 0.65);
}

.hover\\:text-word-color-900\\/70:hover{
  color: rgba(20, 64, 54, 0.7);
}

.hover\\:text-word-color-900\\/75:hover{
  color: rgba(20, 64, 54, 0.75);
}

.hover\\:text-word-color-900\\/80:hover{
  color: rgba(20, 64, 54, 0.8);
}

.hover\\:text-word-color-900\\/85:hover{
  color: rgba(20, 64, 54, 0.85);
}

.hover\\:text-word-color-900\\/90:hover{
  color: rgba(20, 64, 54, 0.9);
}

.hover\\:text-word-color-900\\/95:hover{
  color: rgba(20, 64, 54, 0.95);
}

.hover\\:text-word-color-950:hover{
  --tw-text-opacity: 1;
  color: rgba(10, 36, 31, 1);
  color: rgba(10, 36, 31, var(--tw-text-opacity, 1));
}

.hover\\:text-word-color-950\\/0:hover{
  color: rgba(10, 36, 31, 0);
}

.hover\\:text-word-color-950\\/10:hover{
  color: rgba(10, 36, 31, 0.1);
}

.hover\\:text-word-color-950\\/100:hover{
  color: rgb(10, 36, 31);
}

.hover\\:text-word-color-950\\/15:hover{
  color: rgba(10, 36, 31, 0.15);
}

.hover\\:text-word-color-950\\/20:hover{
  color: rgba(10, 36, 31, 0.2);
}

.hover\\:text-word-color-950\\/25:hover{
  color: rgba(10, 36, 31, 0.25);
}

.hover\\:text-word-color-950\\/30:hover{
  color: rgba(10, 36, 31, 0.3);
}

.hover\\:text-word-color-950\\/35:hover{
  color: rgba(10, 36, 31, 0.35);
}

.hover\\:text-word-color-950\\/40:hover{
  color: rgba(10, 36, 31, 0.4);
}

.hover\\:text-word-color-950\\/45:hover{
  color: rgba(10, 36, 31, 0.45);
}

.hover\\:text-word-color-950\\/5:hover{
  color: rgba(10, 36, 31, 0.05);
}

.hover\\:text-word-color-950\\/50:hover{
  color: rgba(10, 36, 31, 0.5);
}

.hover\\:text-word-color-950\\/55:hover{
  color: rgba(10, 36, 31, 0.55);
}

.hover\\:text-word-color-950\\/60:hover{
  color: rgba(10, 36, 31, 0.6);
}

.hover\\:text-word-color-950\\/65:hover{
  color: rgba(10, 36, 31, 0.65);
}

.hover\\:text-word-color-950\\/70:hover{
  color: rgba(10, 36, 31, 0.7);
}

.hover\\:text-word-color-950\\/75:hover{
  color: rgba(10, 36, 31, 0.75);
}

.hover\\:text-word-color-950\\/80:hover{
  color: rgba(10, 36, 31, 0.8);
}

.hover\\:text-word-color-950\\/85:hover{
  color: rgba(10, 36, 31, 0.85);
}

.hover\\:text-word-color-950\\/90:hover{
  color: rgba(10, 36, 31, 0.9);
}

.hover\\:text-word-color-950\\/95:hover{
  color: rgba(10, 36, 31, 0.95);
}

.hover\\:opacity-75:hover{
  opacity: 0.75;
}

.hover\\:opacity-80:hover{
  opacity: 0.8;
}

.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}

.focus\\:border-blumine-800:focus{
  --tw-border-opacity: 1;
  border-color: rgba(44, 76, 94, 1);
  border-color: rgba(44, 76, 94, var(--tw-border-opacity, 1));
}

.focus\\:border-charcoal-500:focus{
  --tw-border-opacity: 1;
  border-color: rgba(106, 107, 112, 1);
  border-color: rgba(106, 107, 112, var(--tw-border-opacity, 1));
}

.focus\\:border-scarlet-800:focus{
  --tw-border-opacity: 1;
  border-color: rgba(180, 2, 18, 1);
  border-color: rgba(180, 2, 18, var(--tw-border-opacity, 1));
}

.focus\\:border-transparent:focus{
  border-color: transparent;
}

.focus\\:bg-white:focus{
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
}

.focus\\:placeholder-charcoal-300:focus::-moz-placeholder{
  --tw-placeholder-opacity: 1;
  color: rgba(174, 175, 178, 1);
  color: rgba(174, 175, 178, var(--tw-placeholder-opacity, 1));
}

.focus\\:placeholder-charcoal-300:focus::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgba(174, 175, 178, 1);
  color: rgba(174, 175, 178, var(--tw-placeholder-opacity, 1));
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(2px + 2px) #2563eb, 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus\\:ring-inset:focus{
  --tw-ring-inset: inset;
}

.focus\\:ring-blumine-800:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(44, 76, 94, var(--tw-ring-opacity, 1));
}

.focus\\:ring-charcoal-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(174, 175, 178, var(--tw-ring-opacity, 1));
}

.focus\\:ring-charcoal-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(106, 107, 112, var(--tw-ring-opacity, 1));
}

.focus\\:ring-scarlet-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(255, 86, 101, var(--tw-ring-opacity, 1));
}

.focus\\:ring-scarlet-800:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(180, 2, 18, var(--tw-ring-opacity, 1));
}

.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(2px + 2px) #2563eb, 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus-visible\\:ring-white:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(255, 255, 255, var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-opacity-75:focus-visible{
  --tw-ring-opacity: 0.75;
}

.active\\:bg-charcoal-300:active{
  --tw-bg-opacity: 1;
  background-color: rgba(174, 175, 178, 1);
  background-color: rgba(174, 175, 178, var(--tw-bg-opacity, 1));
}

.active\\:text-blumine-900:active{
  --tw-text-opacity: 1;
  color: rgba(40, 65, 81, 1);
  color: rgba(40, 65, 81, var(--tw-text-opacity, 1));
}

.active\\:opacity-100:active{
  opacity: 1;
}

.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}

.disabled\\:bg-charcoal-50:disabled{
  --tw-bg-opacity: 1;
  background-color: rgba(245, 245, 246, 1);
  background-color: rgba(245, 245, 246, var(--tw-bg-opacity, 1));
}

.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.group:hover .group-hover\\:block{
  display: block;
}

.group:hover .group-hover\\:inline-flex{
  display: inline-flex;
}

.group:hover .group-hover\\:hidden{
  display: none;
}

.group:hover .group-hover\\:scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1) scaleY(1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:border-charcoal-500{
  --tw-border-opacity: 1;
  border-color: rgba(106, 107, 112, 1);
  border-color: rgba(106, 107, 112, var(--tw-border-opacity, 1));
}

.group:hover .group-hover\\:bg-blumine-900{
  --tw-bg-opacity: 1;
  background-color: rgba(40, 65, 81, 1);
  background-color: rgba(40, 65, 81, var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:fill-white{
  fill: #fff;
}

.group:hover .group-hover\\:text-charcoal-100{
  --tw-text-opacity: 1;
  color: rgba(230, 230, 231, 1);
  color: rgba(230, 230, 231, var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-charcoal-200{
  --tw-text-opacity: 1;
  color: rgba(207, 208, 210, 1);
  color: rgba(207, 208, 210, var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-charcoal-500{
  --tw-text-opacity: 1;
  color: rgba(106, 107, 112, 1);
  color: rgba(106, 107, 112, var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-charcoal-900{
  --tw-text-opacity: 1;
  color: rgba(49, 49, 51, 1);
  color: rgba(49, 49, 51, var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

.group:hover .group-hover\\:opacity-75{
  opacity: 0.75;
}

.group:focus .group-focus\\:text-charcoal-900{
  --tw-text-opacity: 1;
  color: rgba(49, 49, 51, 1);
  color: rgba(49, 49, 51, var(--tw-text-opacity, 1));
}

.data-\\[closed\\]\\:translate-x-full[data-closed]{
  --tw-translate-x: 100%;
  transform: translate(100%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[closed\\]\\:translate-y-4[data-closed]{
  --tw-translate-y: 1rem;
  transform: translate(var(--tw-translate-x), 1rem) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[focus\\]\\:bg-charcoal-100[data-focus]{
  --tw-bg-opacity: 1;
  background-color: rgba(230, 230, 231, 1);
  background-color: rgba(230, 230, 231, var(--tw-bg-opacity, 1));
}

.data-\\[focus\\]\\:font-bold[data-focus]{
  font-weight: 700;
}

.data-\\[closed\\]\\:opacity-0[data-closed]{
  opacity: 0;
}

.data-\\[enter\\]\\:duration-300[data-enter]{
  transition-duration: 300ms;
}

.data-\\[leave\\]\\:duration-200[data-leave]{
  transition-duration: 200ms;
}

.data-\\[enter\\]\\:ease-out[data-enter]{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.data-\\[leave\\]\\:ease-in[data-leave]{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

@media (min-width: 640px){
  .sm\\:-right-7{
    right: -1.75rem;
  }
  .sm\\:col-span-1{
    grid-column: span 1 / span 1;
  }
  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .sm\\:col-span-6{
    grid-column: span 6 / span 6;
  }
  .sm\\:col-start-2{
    grid-column-start: 2;
  }
  .sm\\:col-start-4{
    grid-column-start: 4;
  }
  .sm\\:col-start-5{
    grid-column-start: 5;
  }
  .sm\\:m-10{
    margin: 2.5rem;
  }
  .sm\\:-mx-6{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  .sm\\:ml-6{
    margin-left: 1.5rem;
  }
  .sm\\:mt-0{
    margin-top: 0px;
  }
  .sm\\:mt-6{
    margin-top: 1.5rem;
  }
  .sm\\:block{
    display: block;
  }
  .sm\\:inline{
    display: inline;
  }
  .sm\\:flex{
    display: flex;
  }
  .sm\\:hidden{
    display: none;
  }
  .sm\\:h-10{
    height: 2.5rem;
  }
  .sm\\:h-12{
    height: 3rem;
  }
  .sm\\:h-72{
    height: 18rem;
  }
  .sm\\:h-8{
    height: 2rem;
  }
  .sm\\:w-12{
    width: 3rem;
  }
  .sm\\:w-16{
    width: 4rem;
  }
  .sm\\:w-28{
    width: 7rem;
  }
  .sm\\:w-40{
    width: 10rem;
  }
  .sm\\:w-8{
    width: 2rem;
  }
  .sm\\:w-full{
    width: 100%;
  }
  .sm\\:max-w-2xl{
    max-width: 42rem;
  }
  .sm\\:max-w-3xl{
    max-width: 48rem;
  }
  .sm\\:max-w-md{
    max-width: 28rem;
  }
  .sm\\:max-w-sm{
    max-width: 24rem;
  }
  .sm\\:flex-1{
    flex: 1 1 0%;
  }
  .sm\\:shrink-0{
    flex-shrink: 0;
  }
  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:grid-cols-8{
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  .sm\\:flex-row-reverse{
    flex-direction: row-reverse;
  }
  .sm\\:items-end{
    align-items: flex-end;
  }
  .sm\\:items-center{
    align-items: center;
  }
  .sm\\:justify-end{
    justify-content: flex-end;
  }
  .sm\\:justify-center{
    justify-content: center;
  }
  .sm\\:justify-between{
    justify-content: space-between;
  }
  .sm\\:gap-4{
    gap: 1rem;
  }
  .sm\\:space-x-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(2.5rem * 0);
    margin-right: calc(2.5rem * var(--tw-space-x-reverse));
    margin-left: calc(2.5rem * (1 - 0));
    margin-left: calc(2.5rem * (1 - var(--tw-space-x-reverse)));
    margin-left: calc(2.5rem * calc(1 - 0));
    margin-left: calc(2.5rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .sm\\:space-x-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * 0);
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * (1 - 0));
    margin-left: calc(0.75rem * (1 - var(--tw-space-x-reverse)));
    margin-left: calc(0.75rem * calc(1 - 0));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .sm\\:space-x-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1.25rem * 0);
    margin-right: calc(1.25rem * var(--tw-space-x-reverse));
    margin-left: calc(1.25rem * (1 - 0));
    margin-left: calc(1.25rem * (1 - var(--tw-space-x-reverse)));
    margin-left: calc(1.25rem * calc(1 - 0));
    margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * (1 - 0));
    margin-top: calc(0px * (1 - var(--tw-space-y-reverse)));
    margin-top: calc(0px * calc(1 - 0));
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * 0);
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }
  .sm\\:space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * (1 - 0));
    margin-top: calc(1rem * (1 - var(--tw-space-y-reverse)));
    margin-top: calc(1rem * calc(1 - 0));
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * 0);
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }
  .sm\\:space-y-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * (1 - 0));
    margin-top: calc(1.5rem * (1 - var(--tw-space-y-reverse)));
    margin-top: calc(1.5rem * calc(1 - 0));
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * 0);
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }
  .sm\\:space-x-reverse > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 1;
  }
  .sm\\:rounded-lg{
    border-radius: 0.5rem;
  }
  .sm\\:p-0{
    padding: 0px;
  }
  .sm\\:p-5{
    padding: 1.25rem;
  }
  .sm\\:p-6{
    padding: 1.5rem;
  }
  .sm\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }
  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .sm\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .sm\\:py-32{
    padding-top: 8rem;
    padding-bottom: 8rem;
  }
  .sm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .sm\\:pl-16{
    padding-left: 4rem;
  }
  .sm\\:pt-0{
    padding-top: 0px;
  }
  .sm\\:pt-1{
    padding-top: 0.25rem;
  }
  .sm\\:text-left{
    text-align: left;
  }
  .sm\\:align-middle{
    vertical-align: middle;
  }
  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .sm\\:duration-200{
    transition-duration: 200ms;
  }
  .data-\\[closed\\]\\:sm\\:translate-y-0[data-closed]{
    --tw-translate-y: 0px;
    transform: translate(var(--tw-translate-x), 0px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .data-\\[closed\\]\\:sm\\:scale-95[data-closed]{
    --tw-scale-x: .95;
    --tw-scale-y: .95;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(.95) scaleY(.95);
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}

@media (min-width: 768px){
  .md\\:-left-10{
    left: -2.5rem;
  }
  .md\\:order-last{
    order: 9999;
  }
  .md\\:col-span-1{
    grid-column: span 1 / span 1;
  }
  .md\\:col-span-10{
    grid-column: span 10 / span 10;
  }
  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .md\\:col-span-3{
    grid-column: span 3 / span 3;
  }
  .md\\:col-span-4{
    grid-column: span 4 / span 4;
  }
  .md\\:col-span-5{
    grid-column: span 5 / span 5;
  }
  .md\\:col-span-7{
    grid-column: span 7 / span 7;
  }
  .md\\:col-start-3{
    grid-column-start: 3;
  }
  .md\\:m-4{
    margin: 1rem;
  }
  .md\\:m-5{
    margin: 1.25rem;
  }
  .md\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }
  .md\\:my-10{
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }
  .md\\:my-20{
    margin-top: 5rem;
    margin-bottom: 5rem;
  }
  .md\\:my-4{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .md\\:my-6{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .md\\:-mt-20{
    margin-top: -5rem;
  }
  .md\\:mb-0{
    margin-bottom: 0px;
  }
  .md\\:mb-10{
    margin-bottom: 2.5rem;
  }
  .md\\:mb-2{
    margin-bottom: 0.5rem;
  }
  .md\\:mb-4{
    margin-bottom: 1rem;
  }
  .md\\:mb-6{
    margin-bottom: 1.5rem;
  }
  .md\\:ml-12{
    margin-left: 3rem;
  }
  .md\\:ml-4{
    margin-left: 1rem;
  }
  .md\\:mr-3{
    margin-right: 0.75rem;
  }
  .md\\:mr-4{
    margin-right: 1rem;
  }
  .md\\:mt-0{
    margin-top: 0px;
  }
  .md\\:mt-1{
    margin-top: 0.25rem;
  }
  .md\\:mt-10{
    margin-top: 2.5rem;
  }
  .md\\:mt-2{
    margin-top: 0.5rem;
  }
  .md\\:mt-20{
    margin-top: 5rem;
  }
  .md\\:mt-3\\.5{
    margin-top: 0.875rem;
  }
  .md\\:mt-5{
    margin-top: 1.25rem;
  }
  .md\\:mt-6{
    margin-top: 1.5rem;
  }
  .md\\:block{
    display: block;
  }
  .md\\:flex{
    display: flex;
  }
  .md\\:inline-flex{
    display: inline-flex;
  }
  .md\\:hidden{
    display: none;
  }
  .md\\:h-1\\/3-screen{
    height: 33vh;
  }
  .md\\:h-12{
    height: 3rem;
  }
  .md\\:h-16{
    height: 4rem;
  }
  .md\\:h-20{
    height: 5rem;
  }
  .md\\:h-24{
    height: 6rem;
  }
  .md\\:h-32{
    height: 8rem;
  }
  .md\\:h-4{
    height: 1rem;
  }
  .md\\:h-40{
    height: 10rem;
  }
  .md\\:h-52{
    height: 13rem;
  }
  .md\\:h-6{
    height: 1.5rem;
  }
  .md\\:h-7{
    height: 1.75rem;
  }
  .md\\:h-96{
    height: 24rem;
  }
  .md\\:w-1\\/2{
    width: 50%;
  }
  .md\\:w-1\\/3{
    width: 33.333333%;
  }
  .md\\:w-10\\/12{
    width: 83.333333%;
  }
  .md\\:w-2\\/3{
    width: 66.666667%;
  }
  .md\\:w-20{
    width: 5rem;
  }
  .md\\:w-24{
    width: 6rem;
  }
  .md\\:w-3\\/4{
    width: 75%;
  }
  .md\\:w-32{
    width: 8rem;
  }
  .md\\:w-4{
    width: 1rem;
  }
  .md\\:w-40{
    width: 10rem;
  }
  .md\\:w-52{
    width: 13rem;
  }
  .md\\:w-6{
    width: 1.5rem;
  }
  .md\\:w-6\\/12{
    width: 50%;
  }
  .md\\:w-7\\/12{
    width: 58.333333%;
  }
  .md\\:w-72{
    width: 18rem;
  }
  .md\\:w-\\[30\\%\\]{
    width: 30%;
  }
  .md\\:w-auto{
    width: auto;
  }
  .md\\:w-full{
    width: 100%;
  }
  .md\\:max-w-4xl{
    max-width: 56rem;
  }
  .md\\:max-w-md{
    max-width: 28rem;
  }
  .md\\:flex-1{
    flex: 1 1 0%;
  }
  .md\\:list-disc{
    list-style-type: disc;
  }
  .md\\:columns-3{
    -moz-columns: 3;
         columns: 3;
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .md\\:flex-row{
    flex-direction: row;
  }
  .md\\:flex-row-reverse{
    flex-direction: row-reverse;
  }
  .md\\:items-center{
    align-items: center;
  }
  .md\\:justify-end{
    justify-content: flex-end;
  }
  .md\\:justify-center{
    justify-content: center;
  }
  .md\\:justify-between{
    justify-content: space-between;
  }
  .md\\:gap-4{
    gap: 1rem;
  }
  .md\\:gap-6{
    gap: 1.5rem;
  }
  .md\\:gap-8{
    gap: 2rem;
  }
  .md\\:gap-x-6{
    -moz-column-gap: 1.5rem;
         column-gap: 1.5rem;
  }
  .md\\:space-x-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * 0);
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * (1 - 0));
    margin-left: calc(0.75rem * (1 - var(--tw-space-x-reverse)));
    margin-left: calc(0.75rem * calc(1 - 0));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .md\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * 0);
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * (1 - 0));
    margin-left: calc(1rem * (1 - var(--tw-space-x-reverse)));
    margin-left: calc(1rem * calc(1 - 0));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .md\\:space-y-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(2.5rem * (1 - 0));
    margin-top: calc(2.5rem * (1 - var(--tw-space-y-reverse)));
    margin-top: calc(2.5rem * calc(1 - 0));
    margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2.5rem * 0);
    margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
  }
  .md\\:space-y-20 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(5rem * (1 - 0));
    margin-top: calc(5rem * (1 - var(--tw-space-y-reverse)));
    margin-top: calc(5rem * calc(1 - 0));
    margin-top: calc(5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(5rem * 0);
    margin-bottom: calc(5rem * var(--tw-space-y-reverse));
  }
  .md\\:space-y-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(2rem * (1 - 0));
    margin-top: calc(2rem * (1 - var(--tw-space-y-reverse)));
    margin-top: calc(2rem * calc(1 - 0));
    margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2rem * 0);
    margin-bottom: calc(2rem * var(--tw-space-y-reverse));
  }
  .md\\:divide-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-divide-x-reverse: 0;
    border-right-width: calc(2px * 0);
    border-right-width: calc(2px * var(--tw-divide-x-reverse));
    border-left-width: calc(2px * (1 - 0));
    border-left-width: calc(2px * (1 - var(--tw-divide-x-reverse)));
    border-left-width: calc(2px * calc(1 - 0));
    border-left-width: calc(2px * calc(1 - var(--tw-divide-x-reverse)));
  }
  .md\\:divide-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-divide-y-reverse: 0;
    border-top-width: calc(0px * (1 - 0));
    border-top-width: calc(0px * (1 - var(--tw-divide-y-reverse)));
    border-top-width: calc(0px * calc(1 - 0));
    border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(0px * 0);
    border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
  }
  .md\\:rounded-r-\\[78px\\]{
    border-top-right-radius: 78px;
    border-bottom-right-radius: 78px;
  }
  .md\\:border-0{
    border-width: 0px;
  }
  .md\\:border-b{
    border-bottom-width: 1px;
  }
  .md\\:border-l-0{
    border-left-width: 0px;
  }
  .md\\:border-l-\\[8px\\]{
    border-left-width: 8px;
  }
  .md\\:border-t-2{
    border-top-width: 2px;
  }
  .md\\:border-charcoal-200{
    --tw-border-opacity: 1;
    border-color: rgba(207, 208, 210, 1);
    border-color: rgba(207, 208, 210, var(--tw-border-opacity, 1));
  }
  .md\\:p-0{
    padding: 0px;
  }
  .md\\:p-10{
    padding: 2.5rem;
  }
  .md\\:p-2{
    padding: 0.5rem;
  }
  .md\\:p-3{
    padding: 0.75rem;
  }
  .md\\:p-4{
    padding: 1rem;
  }
  .md\\:p-5{
    padding: 1.25rem;
  }
  .md\\:p-6{
    padding: 1.5rem;
  }
  .md\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }
  .md\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .md\\:px-14{
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }
  .md\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .md\\:px-20{
    padding-left: 5rem;
    padding-right: 5rem;
  }
  .md\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .md\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .md\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .md\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .md\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .md\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .md\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .md\\:pb-0{
    padding-bottom: 0px;
  }
  .md\\:pb-12{
    padding-bottom: 3rem;
  }
  .md\\:pb-14{
    padding-bottom: 3.5rem;
  }
  .md\\:pb-2{
    padding-bottom: 0.5rem;
  }
  .md\\:pb-20{
    padding-bottom: 5rem;
  }
  .md\\:pb-4{
    padding-bottom: 1rem;
  }
  .md\\:pb-6{
    padding-bottom: 1.5rem;
  }
  .md\\:pt-4{
    padding-top: 1rem;
  }
  .md\\:pt-5{
    padding-top: 1.25rem;
  }
  .md\\:pt-6{
    padding-top: 1.5rem;
  }
  .md\\:pt-8{
    padding-top: 2rem;
  }
  .md\\:text-right{
    text-align: right;
  }
  .md\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .md\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }
  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .md\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .md\\:text-white{
    --tw-text-opacity: 1;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--tw-text-opacity, 1));
  }
}

@media (min-width: 1024px){
  .lg\\:relative{
    position: relative;
  }
  .lg\\:z-10{
    z-index: 10;
  }
  .lg\\:order-last{
    order: 9999;
  }
  .lg\\:col-span-10{
    grid-column: span 10 / span 10;
  }
  .lg\\:col-span-12{
    grid-column: span 12 / span 12;
  }
  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .lg\\:col-span-3{
    grid-column: span 3 / span 3;
  }
  .lg\\:col-span-4{
    grid-column: span 4 / span 4;
  }
  .lg\\:col-span-6{
    grid-column: span 6 / span 6;
  }
  .lg\\:col-span-8{
    grid-column: span 8 / span 8;
  }
  .lg\\:col-span-9{
    grid-column: span 9 / span 9;
  }
  .lg\\:col-start-1{
    grid-column-start: 1;
  }
  .lg\\:col-start-2{
    grid-column-start: 2;
  }
  .lg\\:col-start-3{
    grid-column-start: 3;
  }
  .lg\\:col-start-4{
    grid-column-start: 4;
  }
  .lg\\:col-start-7{
    grid-column-start: 7;
  }
  .lg\\:row-start-1{
    grid-row-start: 1;
  }
  .lg\\:m-0{
    margin: 0px;
  }
  .lg\\:m-8{
    margin: 2rem;
  }
  .lg\\:-mx-8{
    margin-left: -2rem;
    margin-right: -2rem;
  }
  .lg\\:-my-8{
    margin-top: -2rem;
    margin-bottom: -2rem;
  }
  .lg\\:mx-10{
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }
  .lg\\:mx-5{
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }
  .lg\\:my-2{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .lg\\:my-20{
    margin-top: 5rem;
    margin-bottom: 5rem;
  }
  .lg\\:my-4{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .lg\\:mb-3{
    margin-bottom: 0.75rem;
  }
  .lg\\:mb-8{
    margin-bottom: 2rem;
  }
  .lg\\:ml-0{
    margin-left: 0px;
  }
  .lg\\:ml-16{
    margin-left: 4rem;
  }
  .lg\\:ml-5{
    margin-left: 1.25rem;
  }
  .lg\\:ml-8{
    margin-left: 2rem;
  }
  .lg\\:mr-0{
    margin-right: 0px;
  }
  .lg\\:mr-2{
    margin-right: 0.5rem;
  }
  .lg\\:mt-0{
    margin-top: 0px;
  }
  .lg\\:mt-2{
    margin-top: 0.5rem;
  }
  .lg\\:mt-4{
    margin-top: 1rem;
  }
  .lg\\:mt-5{
    margin-top: 1.25rem;
  }
  .lg\\:mt-6{
    margin-top: 1.5rem;
  }
  .lg\\:mt-8{
    margin-top: 2rem;
  }
  .lg\\:block{
    display: block;
  }
  .lg\\:inline{
    display: inline;
  }
  .lg\\:flex{
    display: flex;
  }
  .lg\\:inline-flex{
    display: inline-flex;
  }
  .lg\\:grid{
    display: grid;
  }
  .lg\\:hidden{
    display: none;
  }
  .lg\\:h-10{
    height: 2.5rem;
  }
  .lg\\:h-12{
    height: 3rem;
  }
  .lg\\:h-14{
    height: 3.5rem;
  }
  .lg\\:h-3\\/4-screen{
    height: 75vh;
  }
  .lg\\:h-48{
    height: 12rem;
  }
  .lg\\:h-60{
    height: 15rem;
  }
  .lg\\:h-72{
    height: 18rem;
  }
  .lg\\:h-80{
    height: 20rem;
  }
  .lg\\:h-fit{
    height: -moz-fit-content;
    height: fit-content;
  }
  .lg\\:h-full{
    height: 100%;
  }
  .lg\\:w-1\\/3-screen{
    width: 33vw;
  }
  .lg\\:w-10{
    width: 2.5rem;
  }
  .lg\\:w-12{
    width: 3rem;
  }
  .lg\\:w-3\\/5{
    width: 60%;
  }
  .lg\\:w-4\\/5{
    width: 80%;
  }
  .lg\\:w-52{
    width: 13rem;
  }
  .lg\\:w-60{
    width: 15rem;
  }
  .lg\\:w-72{
    width: 18rem;
  }
  .lg\\:w-96{
    width: 24rem;
  }
  .lg\\:w-full{
    width: 100%;
  }
  .lg\\:max-w-4xl{
    max-width: 56rem;
  }
  .lg\\:max-w-7xl{
    max-width: 80rem;
  }
  .lg\\:max-w-none{
    max-width: none;
  }
  .lg\\:-translate-x-0{
    --tw-translate-x: -0px;
    transform: translate(-0px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .lg\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .lg\\:grid-cols-10{
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .lg\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  .lg\\:items-center{
    align-items: center;
  }
  .lg\\:justify-start{
    justify-content: flex-start;
  }
  .lg\\:justify-end{
    justify-content: flex-end;
  }
  .lg\\:gap-10{
    gap: 2.5rem;
  }
  .lg\\:gap-3{
    gap: 0.75rem;
  }
  .lg\\:gap-6{
    gap: 1.5rem;
  }
  .lg\\:gap-8{
    gap: 2rem;
  }
  .lg\\:gap-x-16{
    -moz-column-gap: 4rem;
         column-gap: 4rem;
  }
  .lg\\:gap-x-8{
    -moz-column-gap: 2rem;
         column-gap: 2rem;
  }
  .lg\\:space-x-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.25rem * 0);
    margin-right: calc(0.25rem * var(--tw-space-x-reverse));
    margin-left: calc(0.25rem * (1 - 0));
    margin-left: calc(0.25rem * (1 - var(--tw-space-x-reverse)));
    margin-left: calc(0.25rem * calc(1 - 0));
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .lg\\:space-x-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(2.5rem * 0);
    margin-right: calc(2.5rem * var(--tw-space-x-reverse));
    margin-left: calc(2.5rem * (1 - 0));
    margin-left: calc(2.5rem * (1 - var(--tw-space-x-reverse)));
    margin-left: calc(2.5rem * calc(1 - 0));
    margin-left: calc(2.5rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .lg\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * 0);
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * (1 - 0));
    margin-left: calc(1rem * (1 - var(--tw-space-x-reverse)));
    margin-left: calc(1rem * calc(1 - 0));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .lg\\:space-y-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.5rem * (1 - 0));
    margin-top: calc(0.5rem * (1 - var(--tw-space-y-reverse)));
    margin-top: calc(0.5rem * calc(1 - 0));
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.5rem * 0);
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
  }
  .lg\\:space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * (1 - 0));
    margin-top: calc(1rem * (1 - var(--tw-space-y-reverse)));
    margin-top: calc(1rem * calc(1 - 0));
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * 0);
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }
  .lg\\:space-y-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * (1 - 0));
    margin-top: calc(1.5rem * (1 - var(--tw-space-y-reverse)));
    margin-top: calc(1.5rem * calc(1 - 0));
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * 0);
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }
  .lg\\:rounded-lg{
    border-radius: 0.5rem;
  }
  .lg\\:rounded-xl{
    border-radius: 0.75rem;
  }
  .lg\\:border-l-4{
    border-left-width: 4px;
  }
  .lg\\:bg-charcoal-50{
    --tw-bg-opacity: 1;
    background-color: rgba(245, 245, 246, 1);
    background-color: rgba(245, 245, 246, var(--tw-bg-opacity, 1));
  }
  .lg\\:bg-transparent{
    background-color: transparent;
  }
  .lg\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgba(255, 255, 255, 1);
    background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
  }
  .lg\\:p-0{
    padding: 0px;
  }
  .lg\\:p-10{
    padding: 2.5rem;
  }
  .lg\\:p-2{
    padding: 0.5rem;
  }
  .lg\\:p-20{
    padding: 5rem;
  }
  .lg\\:p-3{
    padding: 0.75rem;
  }
  .lg\\:p-6{
    padding: 1.5rem;
  }
  .lg\\:p-8{
    padding: 2rem;
  }
  .lg\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }
  .lg\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .lg\\:px-16{
    padding-left: 4rem;
    padding-right: 4rem;
  }
  .lg\\:px-20{
    padding-left: 5rem;
    padding-right: 5rem;
  }
  .lg\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .lg\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .lg\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .lg\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .lg\\:py-0{
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .lg\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .lg\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .lg\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .lg\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .lg\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .lg\\:pb-10{
    padding-bottom: 2.5rem;
  }
  .lg\\:pb-5{
    padding-bottom: 1.25rem;
  }
  .lg\\:pb-8{
    padding-bottom: 2rem;
  }
  .lg\\:pl-14{
    padding-left: 3.5rem;
  }
  .lg\\:pl-3{
    padding-left: 0.75rem;
  }
  .lg\\:pl-7{
    padding-left: 1.75rem;
  }
  .lg\\:pl-8{
    padding-left: 2rem;
  }
  .lg\\:pt-12{
    padding-top: 3rem;
  }
  .lg\\:pt-3{
    padding-top: 0.75rem;
  }
  .lg\\:pt-8{
    padding-top: 2rem;
  }
  .lg\\:text-left{
    text-align: left;
  }
  .lg\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .lg\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .lg\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .lg\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }
  .lg\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }
  .lg\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .lg\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .lg\\:shadow-lg{
    --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
  }
}

@media (min-width: 1280px){
  .xl\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .xl\\:col-span-3{
    grid-column: span 3 / span 3;
  }
  .xl\\:col-span-4{
    grid-column: span 4 / span 4;
  }
  .xl\\:col-span-5{
    grid-column: span 5 / span 5;
  }
  .xl\\:col-span-8{
    grid-column: span 8 / span 8;
  }
  .xl\\:col-span-9{
    grid-column: span 9 / span 9;
  }
  .xl\\:col-start-2{
    grid-column-start: 2;
  }
  .xl\\:mb-12{
    margin-bottom: 3rem;
  }
  .xl\\:ml-2{
    margin-left: 0.5rem;
  }
  .xl\\:ml-3{
    margin-left: 0.75rem;
  }
  .xl\\:ml-7{
    margin-left: 1.75rem;
  }
  .xl\\:ml-8{
    margin-left: 2rem;
  }
  .xl\\:mr-2{
    margin-right: 0.5rem;
  }
  .xl\\:mr-5{
    margin-right: 1.25rem;
  }
  .xl\\:h-10{
    height: 2.5rem;
  }
  .xl\\:h-2\\/5-screen{
    height: 40vh;
  }
  .xl\\:h-20{
    height: 5rem;
  }
  .xl\\:h-44{
    height: 11rem;
  }
  .xl\\:h-8{
    height: 2rem;
  }
  .xl\\:h-screen{
    height: 100vh;
  }
  .xl\\:w-4\\/5{
    width: 80%;
  }
  .xl\\:w-44{
    width: 11rem;
  }
  .xl\\:w-8{
    width: 2rem;
  }
  .xl\\:max-w-2xl{
    max-width: 42rem;
  }
  .xl\\:max-w-7xl{
    max-width: 80rem;
  }
  .xl\\:columns-4{
    -moz-columns: 4;
         columns: 4;
  }
  .xl\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .xl\\:gap-8{
    gap: 2rem;
  }
  .xl\\:gap-x-8{
    -moz-column-gap: 2rem;
         column-gap: 2rem;
  }
  .xl\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * 0);
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * (1 - 0));
    margin-left: calc(1rem * (1 - var(--tw-space-x-reverse)));
    margin-left: calc(1rem * calc(1 - 0));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .xl\\:p-2{
    padding: 0.5rem;
  }
  .xl\\:p-3{
    padding: 0.75rem;
  }
  .xl\\:p-4{
    padding: 1rem;
  }
  .xl\\:px-16{
    padding-left: 4rem;
    padding-right: 4rem;
  }
  .xl\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .xl\\:pl-20{
    padding-left: 5rem;
  }
  .xl\\:pl-6{
    padding-left: 1.5rem;
  }
  .xl\\:pr-8{
    padding-right: 2rem;
  }
  .xl\\:pt-3{
    padding-top: 0.75rem;
  }
  .xl\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .xl\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .xl\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .xl\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }
  .xl\\:text-7xl{
    font-size: 4.5rem;
    line-height: 1;
  }
  .xl\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .xl\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .xl\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media print{
  .print\\:block{
    display: block;
  }
  .print\\:hidden{
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/main.css"],"names":[],"mappings":"AAEA,sJAAsJ;AACtJ;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,wCAA0B;EAA1B,0CAA0B;EAA1B,mCAA0B;EAA1B,8BAA0B;EAA1B,sCAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,wCAA0B;EAA1B,0CAA0B;EAA1B,mCAA0B;EAA1B,8BAA0B;EAA1B,sCAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;AAA1B,kEAA0B;AAA1B;;;CAA0B;AAA1B;;;EAAA,sBAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,mBAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;EAAA,gBAA0B;AAAA;AAA1B;;;;;;;;CAA0B;AAA1B;;EAAA,gBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gBAA0B,EAA1B,MAA0B;EAA1B,cAA0B;KAA1B,WAA0B,EAA1B,MAA0B;EAA1B,sMAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,wCAA0B,EAA1B,MAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,0BAA0B;EAA1B,yCAA0B;UAA1B,iCAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;;;;;EAAA,kBAA0B;EAA1B,oBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,cAA0B;EAA1B,wBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,mBAA0B;AAAA;AAA1B;;;;;CAA0B;AAA1B;;;;EAAA,+GAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,cAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,cAA0B;EAA1B,cAA0B;EAA1B,kBAA0B;EAA1B,wBAA0B;AAAA;AAA1B;EAAA,eAA0B;AAAA;AAA1B;EAAA,WAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;EAA1B,yBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;;;;;EAAA,oBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gCAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,uBAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,SAA0B,EAA1B,MAA0B;EAA1B,UAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,oBAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;;;;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,aAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,gBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,wBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,YAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;EAAA,6BAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,wBAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,aAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,kBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;;;;;;;;;;;;EAAA,SAA0B;AAAA;AAA1B;EAAA,SAA0B;EAA1B,UAA0B;AAAA;AAA1B;EAAA,UAA0B;AAAA;AAA1B;;;EAAA,gBAA0B;EAA1B,SAA0B;EAA1B,UAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,UAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,gBAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;AAA1B;;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,eAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,eAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;;;;;;;;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,eAA0B;EAA1B,YAA0B;AAAA;AAA1B,wEAA0B;AAA1B;EAAA,aAA0B;AAAA;AAA1B;EAAA,wBAA0B;KAA1B,qBAA0B;UAA1B,gBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,mBAA0B;EAA1B,sBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B,eAA0B;EAA1B,mBAA0B;EAA1B,8BAA0B;AAAA;AAA1B;EAAA,8BAA0B;EAA1B,mBAA0B;EAA1B,4CAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,wBAA0B;EAA1B,2GAA0B;EAA1B,yGAA0B;EAA1B,mGAA0B;EAA1B,iFAA0B;EAA1B;AAA0B;AAA1B;EAAA,cAA0B;EAA1B;AAA0B;AAA1B;EAAA,cAA0B;EAA1B;AAA0B;AAA1B;EAAA;AAA0B;AAA1B;EAAA,iBAA0B;EAA1B;AAA0B;AAA1B;EAAA;AAA0B;AAA1B;EAAA,cAA0B;EAA1B;AAA0B;AAA1B;EAAA,yDAA0B;EAA1B,wCAA0B;EAA1B,4BAA0B;EAA1B,4BAA0B;EAA1B,qBAA0B;EAA1B,iCAA0B;UAA1B;AAA0B;AAA1B;EAAA,sBAA0B;EAA1B,yBAA0B;EAA1B,wBAA0B;EAA1B,4BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,0BAA0B;EAA1B,wBAA0B;EAA1B,sBAA0B;EAA1B,mCAA0B;UAA1B;AAA0B;AAA1B;EAAA,wBAA0B;KAA1B,qBAA0B;UAA1B,gBAA0B;EAA1B,UAA0B;EAA1B,iCAA0B;UAA1B,yBAA0B;EAA1B,qBAA0B;EAA1B,sBAA0B;EAA1B,6BAA0B;EAA1B,yBAA0B;KAA1B,sBAA0B;UAA1B,iBAA0B;EAA1B,cAA0B;EAA1B,YAA0B;EAA1B,WAA0B;EAA1B,cAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B,iBAA0B;EAA1B;AAA0B;AAA1B;EAAA;AAA0B;AAA1B;EAAA;AAA0B;AAA1B;EAAA,8BAA0B;EAA1B,mBAA0B;EAA1B,4CAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,wBAA0B;EAA1B,2GAA0B;EAA1B,yGAA0B;EAA1B,mGAA0B;EAA1B;AAA0B;AAA1B;EAAA,yBAA0B;EAA1B,8BAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B;AAA0B;AAA1B;EAAA,yDAA0B;AAAA;AAA1B;EAAA;IAAA,wBAA0B;OAA1B,qBAA0B;YAA1B;EAA0B;AAAA;AAA1B;EAAA,yDAA0B;AAAA;AAA1B;EAAA;IAAA,wBAA0B;OAA1B,qBAA0B;YAA1B;EAA0B;AAAA;AAA1B;EAAA,yBAA0B;EAA1B;AAA0B;AAA1B;EAAA,yDAA0B;EAA1B,yBAA0B;EAA1B,8BAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;AAAA;AAA1B;EAAA;IAAA,wBAA0B;OAA1B,qBAA0B;YAA1B;EAA0B;AAAA;AAA1B;EAAA,yBAA0B;EAA1B;AAA0B;AAA1B;EAAA,iFAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,eAA0B;EAA1B,gBAA0B;EAA1B,UAA0B;EAA1B,kBAA0B;EAA1B;AAA0B;AAA1B;EAAA,6BAA0B;EAA1B;AAA0B;AAA1B;EAAA;AAA0B;AAA1B;EAAA,kBAA0B;EAA1B,qBAA0B;EAA1B,wBAA0B;EAA1B,sBAA0B;EAA1B,oCAA0B;EAA1B,8DAA0B;EAA1B,oBAA0B;EAA1B,uBAA0B;EAA1B,iBAA0B;EAA1B,iBAA0B;EAA1B,gBAA0B;EAA1B,oBAA0B;EAA1B,0BAA0B;EAA1B;AAA0B;AAA1B;EAAA,gBAA0B;EAA1B,mBAA0B;EAA1B,kBAA0B;EAA1B,oBAA0B;EAA1B,gBAA0B;EAA1B,oBAA0B;EAA1B,0BAA0B;EAA1B;AAA0B;AAA1B;EAAA,wBAA0B;EAA1B;AAA0B;AAA1B;EAAA,qBAA0B;EAA1B;AAA0B;AAA1B;EAAA,gBAA0B;EAA1B;AAA0B;AAA1B;EAAA,gBAA0B;EAA1B;AAA0B;AAA1B;EAAA,oBAA0B;EAA1B,2BAA0B;EAA1B,mDAA0B;EAA1B,+BAA0B;EAA1B;AAA0B;AAA1B;EAAA;AAA0B;AAC1B;EAAA;AAAgC;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;AAAgC;AAAhC;EAAA;AAAgC;AAAhC;EAAA,kBAAgC;EAAhC,oDAAgC;EAAhC,oEAAgC;EAAhC;AAAgC;AAAhC;EAAA,kBAAgC;EAAhC,YAAgC;EAAhC,WAAgC;EAAhC,MAAgC;EAAhC,QAAgC;EAAhC,SAAgC;EAAhC;AAAgC;AAAhC;EAAA,kBAAgC;EAAhC,mDAAgC;EAAhC,oEAAgC;EAAhC;AAAgC;AAAhC;EAAA,kBAAgC;EAAhC,YAAgC;EAAhC,WAAgC;EAAhC,MAAgC;EAAhC,QAAgC;EAAhC,SAAgC;EAAhC;AAAgC;AAyC5B;EAAA,aAAkB;EAAlB;AAAkB;AAGlB;EAAA,oBAAyE;EAAzE,2BAAyE;EAAzE,mDAAyE;EAAzE,+BAAyE;EAAzE;AAAyE;AAAzE;EAAA;AAAyE;AAGzE;EAAA,oBAAmM;EAAnM,mBAAmM;EAAnM;AAAmM;AAAnM;EAAA,uBAAmM;EAAnM,8BAAmM;EAAnM,sDAAmM;EAAnM,mCAAmM;EAAnM,2DAAmM;EAAnM,uCAAmM;EAAnM;AAAmM;AAAnM;EAAA,qBAAmM;EAAnM,iBAAmM;EAAnM,yBAAmM;EAAnM,kBAAmM;EAAnM,qCAAmM;EAAnM,2DAAmM;EAAnM,mBAAmM;EAAnM,sBAAmM;EAAnM,kBAAmM;EAAnM,mBAAmM;EAAnM,mBAAmM;EAAnM,oBAAmM;EAAnM,gBAAmM;EAAnM,oBAAmM;EAAnM,6BAAmM;EAAnM,qDAAmM;EAAnM,4CAAmM;EAAnM,uDAAmM;EAAnM,iFAAmM;EAAnM;AAAmM;AAAnM;EAAA;AAAmM;AAAnM;EAAA;AAAmM;AAGnM;EAAA,oBAAoM;EAApM,mBAAoM;EAApM;AAAoM;AAApM;EAAA,uBAAoM;EAApM,8BAAoM;EAApM,sDAAoM;EAApM,mCAAoM;EAApM,2DAAoM;EAApM,uCAAoM;EAApM;AAAoM;AAApM;EAAA,qBAAoM;EAApM,iBAAoM;EAApM,sBAAoM;EAApM,iCAAoM;EAApM,2DAAoM;EAApM,kBAAoM;EAApM,wCAAoM;EAApM,8DAAoM;EAApM,mBAAoM;EAApM,sBAAoM;EAApM,kBAAoM;EAApM,mBAAoM;EAApM,mBAAoM;EAApM,oBAAoM;EAApM,gBAAoM;EAApM,oBAAoM;EAApM,0BAAoM;EAApM,kDAAoM;EAApM,4CAAoM;EAApM,uDAAoM;EAApM,iFAAoM;EAApM;AAAoM;AAApM;EAAA,kBAAoM;EAApM,wCAAoM;EAApM;AAAoM;AAApM;EAAA,kBAAoM;EAApM,wCAAoM;EAApM;AAAoM;AAGpM;EAAA,eAA2B;EAA3B,cAA2B;EAA3B;AAA2B;AAG7B,sBAAsB;AAEpB;EAAA,oBAAoE;EAApE,mBAAoE;EAApE;AAAoE;AAApE;EAAA,uBAAoE;EAApE,8BAAoE;EAApE,sDAAoE;EAApE,mCAAoE;EAApE,2DAAoE;EAApE,uCAAoE;EAApE;AAAoE;AAApE;EAAA;AAAoE;AAGtE,4CAA4C;AAK5C,kBAAkB;AAEhB;EAAA,oBAAsH;EAAtH,mBAAsH;EAAtH;AAAsH;AAAtH;EAAA,uBAAsH;EAAtH,8BAAsH;EAAtH,sDAAsH;EAAtH,mCAAsH;EAAtH,2DAAsH;EAAtH,uCAAsH;EAAtH;AAAsH;AAAtH;EAAA,qBAAsH;EAAtH,kBAAsH;EAAtH,uCAAsH;EAAtH,6DAAsH;EAAtH,oBAAsH;EAAtH,6BAAsH;EAAtH;AAAsH;AAAtH;EAAA,kBAAsH;EAAtH,qCAAsH;EAAtH;AAAsH;AAAtH;EAAA,8BAAsH;EAAtH,mBAAsH;EAAtH,2GAAsH;EAAtH,yGAAsH;EAAtH,oGAAsH;EAAtH,oGAAsH;EAAtH,oBAAsH;EAAtH;AAAsH;AAGtH;EAAA,oBAA+J;EAA/J,mBAA+J;EAA/J;AAA+J;AAA/J;EAAA,uBAA+J;EAA/J,8BAA+J;EAA/J,sDAA+J;EAA/J,mCAA+J;EAA/J,2DAA+J;EAA/J,uCAA+J;EAA/J;AAA+J;AAA/J;EAAA,qBAA+J;EAA/J,iBAA+J;EAA/J,sBAA+J;EAA/J,iCAA+J;EAA/J,2DAA+J;EAA/J,kBAA+J;EAA/J,wCAA+J;EAA/J,8DAA+J;EAA/J,oBAA+J;EAA/J,0BAA+J;EAA/J;AAA+J;AAA/J;EAAA,kBAA+J;EAA/J,wCAA+J;EAA/J;AAA+J;AAA/J;EAAA,kBAA+J;EAA/J,wCAA+J;EAA/J,8DAA+J;EAA/J,8BAA+J;EAA/J,mBAA+J;EAA/J,2GAA+J;EAA/J,yGAA+J;EAA/J,oGAA+J;EAA/J,oGAA+J;EAA/J,oBAA+J;EAA/J;AAA+J;AAG/J;EAAA,oBAAyI;EAAzI,mBAAyI;EAAzI;AAAyI;AAAzI;EAAA,uBAAyI;EAAzI,8BAAyI;EAAzI,sDAAyI;EAAzI,mCAAyI;EAAzI,2DAAyI;EAAzI,uCAAyI;EAAzI;AAAyI;AAAzI;EAAA,qBAAyI;EAAzI,eAAyI;EAAzI,kBAAyI;EAAzI,wCAAyI;EAAzI,8DAAyI;EAAzI,oBAAyI;EAAzI,0BAAyI;EAAzI;AAAyI;AAAzI;EAAA,kBAAyI;EAAzI,wCAAyI;EAAzI;AAAyI;AAAzI;EAAA,kBAAyI;EAAzI,wCAAyI;EAAzI,8DAAyI;EAAzI,8BAAyI;EAAzI,mBAAyI;EAAzI,2GAAyI;EAAzI,yGAAyI;EAAzI,oGAAyI;EAAzI,oGAAyI;EAAzI,oBAAyI;EAAzI;AAAyI;AAG3I,iBAAiB;AACjB,6DAA6D;AAE3D;EAAA,eAEoC;EAFpC,eAEoC;EAFpC,qBAEoC;EAFpC,wBAEoC;EAFpC,qBAEoC;EAFpC,sBAEoC;EAFpC,kBAEoC;EAFpC;AAEoC;AAFpC;EAAA;IAAA,YAEoC;IAFpC,eAEoC;IAFpC,mBAEoC;IAFpC;EAEoC;AAAA;AAHtC,UAGwC,gCAAgC;EACxE;AAEE;EAAA,eAEuC;EAFvC,eAEuC;EAFvC,mBAEuC;EAFvC,sBAEuC;EAFvC,qBAEuC;EAFvC,sBAEuC;EAFvC,eAEuC;EAFvC;AAEuC;AAFvC;EAAA;IAAA,cAEuC;IAFvC,gBAEuC;IAFvC,eAEuC;IAFvC;EAEuC;AAAA;AAHzC,UAG2C,gCAAgC;EAC3E;AAEE;EAAA,cAEqC;EAFrC,gBAEqC;EAFrC,mBAEqC;EAFrC,sBAEqC;EAFrC,qBAEqC;EAFrC,sBAEqC;EAFrC,eAEqC;EAFrC;AAEqC;AAFrC;EAAA;IAAA,YAEqC;IAFrC,gBAEqC;IAFrC,mBAEqC;IAFrC;EAEqC;AAAA;AAHvC,UAGyC,gCAAgC;EACzE;AAOA,sBAAsB;AAEpB;EAAA,oBAEoB;EAFpB,mBAEoB;EAFpB,uBAEoB;EAFpB;AAEoB;AAFpB;EAAA,WAEoB;EAFpB,cAEoB;EAFpB,YAEoB;EAFpB,WAEoB;EAFpB,YAEoB;EAFpB;AAEoB;AAFpB;EAAA,eAEoB;EAFpB;AAEoB;AAFpB;EAAA;IAAA,YAEoB;IAFpB;EAEoB;AAAA;AAHtB,eAGwB,mBAAmB;EAC3C;AAEE;EAAA,oBAGsB;EAHtB,mBAGsB;EAHtB,uBAGsB;EAHtB;AAGsB;AAHtB;EAAA,WAGsB;EAHtB,cAGsB;EAHtB,YAGsB;EAHtB,WAGsB;EAHtB,YAGsB;EAHtB;AAGsB;AAHtB;EAAA,YAGsB;EAHtB;AAGsB;AAHtB;EAAA;IAAA,cAGsB;IAHtB;EAGsB;AAAA;AAHtB;EAAA;IAAA,cAGsB;IAHtB;EAGsB;AAAA;AAJxB,eAI0B,mBAAmB;EAC7C;AAEE;EAAA,oBAGsB;EAHtB,mBAGsB;EAHtB,uBAGsB;EAHtB;AAGsB;AAHtB;EAAA,WAGsB;EAHtB,cAGsB;EAHtB,YAGsB;EAHtB,WAGsB;EAHtB,YAGsB;EAHtB;AAGsB;AAHtB;EAAA,cAGsB;EAHtB;AAGsB;AAHtB;EAAA;IAAA,YAGsB;IAHtB;EAGsB;AAAA;AAHtB;EAAA;IAAA,YAGsB;IAHtB;EAGsB;AAAA;AAJxB,eAI0B,mBAAmB;EAC7C;AAEE;EAAA,oBAG2C;EAH3C,mBAG2C;EAH3C,uBAG2C;EAH3C;AAG2C;AAH3C;EAAA,WAG2C;EAH3C,cAG2C;EAH3C,YAG2C;EAH3C,WAG2C;EAH3C,YAG2C;EAH3C;AAG2C;AAH3C;EAAA,YAG2C;EAH3C;AAG2C;AAH3C;EAAA;IAAA,YAG2C;IAH3C;EAG2C;AAAA;AAH3C;EAAA;IAAA,cAG2C;IAH3C;EAG2C;AAAA;AAG7C,yEAAyE;AAEvE;EAAA,gBAA+B;EAA/B,eAA+B;EAA/B,kBAA+B,EAAE,cAAc;AAAhB;AAG/B;EAAA,YAA2B;EAA3B,WAA2B;EAA3B,kBAA2B,EAAE,cAAc;AAAhB;AAG3B;EAAA,eAA2B;EAA3B,cAA2B;EAA3B,kBAA2B,EAAE,cAAc;AAAhB;AAQ7B,gEAAgE;AAK9D;EAAA,eAEoB;EAFpB,cAEoB;EAFpB;AAEoB;AAFpB;EAAA;IAAA,eAEoB;IAFpB;EAEoB;AAAA;AAHtB,mBAGwB,kBAAkB;EAC1C;AAEE;EAAA,cAA2B;EAA3B,aAA2B;EAA3B,kBAA2B,EAAE,cAAc;AAAhB;AAG3B;EAAA,eAA2B;EAA3B,cAA2B;EAA3B,kBAA2B,EAAE,cAAc;AAAhB;AAG3B;EAAA,YAA2B;EAA3B,WAA2B;EAA3B,kBAA2B,EAAE,cAAc;AAAhB;AA5J/B;EAAA,kBAA+B;EAA/B,UAA+B;EAA/B,WAA+B;EAA/B,UAA+B;EAA/B,YAA+B;EAA/B,gBAA+B;EAA/B,sBAA+B;EAA/B,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,QAA+B;EAA/B,UAA+B;EAA/B,WAA+B;EAA/B;AAA+B;AAA/B;EAAA,SAA+B;EAA/B;AAA+B;AAA/B;EAAA,QAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,aAA+B;EAA/B;AAA+B;AAA/B;EAAA,WAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,8KAA+B;EAA/B;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B,kLAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+KAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B,6KAA+B;EAA/B;AAA+B;AAA/B;EAAA,yBAA+B;EAA/B,iLAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,gLAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,8KAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,oLAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B,qLAA+B;EAA/B;AAA+B;AAA/B;EAAA,eAA+B;EAA/B,eAA+B;EAA/B,+JAA+B;EAA/B;AAA+B;AAA/B;EAAA,eAA+B;EAA/B,eAA+B;EAA/B,+JAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,iBAA+B;EAA/B,mKAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;IAAA,mBAA+B;IAA/B;EAA+B;EAA/B;IAAA,qBAA+B;IAA/B;EAA+B;EAA/B;IAAA,qBAA+B;IAA/B;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,yBAA+B;KAA/B,sBAA+B;UAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,wBAA+B;KAA/B,qBAA+B;UAA/B;AAA+B;AAA/B;EAAA,eAA+B;OAA/B;AAA+B;AAA/B;EAAA,eAA+B;OAA/B;AAA+B;AAA/B;EAAA,+BAA+B;OAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uBAA+B;OAA/B;AAA+B;AAA/B;EAAA,wBAA+B;OAA/B;AAA+B;AAA/B;EAAA,qBAA+B;OAA/B;AAA+B;AAA/B;EAAA,uBAA+B;OAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+BAA+B;EAA/B,uDAA+B;EAA/B,oCAA+B;EAA/B,4DAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,8BAA+B;EAA/B,sDAA+B;EAA/B,mCAA+B;EAA/B,2DAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,8BAA+B;EAA/B,sDAA+B;EAA/B,mCAA+B;EAA/B,2DAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+BAA+B;EAA/B,uDAA+B;EAA/B,oCAA+B;EAA/B,4DAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,4BAA+B;EAA/B,oDAA+B;EAA/B,iCAA+B;EAA/B,yDAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+BAA+B;EAA/B,uDAA+B;EAA/B,oCAA+B;EAA/B,4DAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,4BAA+B;EAA/B,oDAA+B;EAA/B,iCAA+B;EAA/B,yDAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,mCAA+B;EAA/B,2DAA+B;EAA/B,uCAA+B;EAA/B,+DAA+B;EAA/B,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,kCAA+B;EAA/B,0DAA+B;EAA/B,sCAA+B;EAA/B,8DAA+B;EAA/B,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,gCAA+B;EAA/B,wDAA+B;EAA/B,oCAA+B;EAA/B,4DAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,kCAA+B;EAA/B,0DAA+B;EAA/B,sCAA+B;EAA/B,8DAA+B;EAA/B,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,mCAA+B;EAA/B,2DAA+B;EAA/B,uCAA+B;EAA/B,+DAA+B;EAA/B,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,gCAA+B;EAA/B,wDAA+B;EAA/B,oCAA+B;EAA/B,4DAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,mCAA+B;EAA/B,2DAA+B;EAA/B,uCAA+B;EAA/B,+DAA+B;EAA/B,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,kCAA+B;EAA/B,0DAA+B;EAA/B,sCAA+B;EAA/B,8DAA+B;EAA/B,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,gCAA+B;EAA/B,wDAA+B;EAA/B,oCAA+B;EAA/B,4DAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,iCAA+B;EAA/B,0DAA+B;EAA/B,sCAA+B;EAA/B,+DAA+B;EAA/B,0CAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,qCAA+B;EAA/B,8DAA+B;EAA/B,yCAA+B;EAA/B,kEAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,qCAA+B;EAA/B,8DAA+B;EAA/B,yCAA+B;EAA/B,kEAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,qCAA+B;EAA/B,8DAA+B;EAA/B,yCAA+B;EAA/B,kEAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,yCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,mEAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,kEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,kEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yDAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uEAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;KAA/B;AAA+B;AAA/B;EAAA,oBAA+B;KAA/B;AAA+B;AAA/B;EAAA,0BAA+B;KAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,yBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,wBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,wBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,8EAA+B;EAA/B,8FAA+B;EAA/B,mHAA+B;EAA/B;AAA+B;AAA/B;EAAA,kDAA+B;EAA/B,6DAA+B;EAA/B,uFAA+B;EAA/B;AAA+B;AAA/B;EAAA,mFAA+B;EAA/B,mGAA+B;EAA/B,wHAA+B;EAA/B;AAA+B;AAA/B;EAAA,iFAA+B;EAA/B,iGAA+B;EAA/B,sHAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B,sCAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4CAA+B;EAA/B,uDAA+B;EAA/B,iFAA+B;EAA/B;AAA+B;AAA/B;EAAA,oFAA+B;EAA/B,oGAA+B;EAA/B,yHAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B,oGAA+B;EAA/B;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B,oGAA+B;EAA/B;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B,gFAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,4KAA+B;EAA/B;AAA+B;AAA/B;EAAA,uGAA+B;EAA/B,iPAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,yCAA+B;EAA/B,iQAA+B;EAA/B,+QAA+B;EAA/B,yPAA+B;EAA/B;AAA+B;AAA/B;EAAA,gKAA+B;EAA/B,wJAA+B;EAA/B,iLAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,+FAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAiK7B;IACE,wBAAwB;EAC1B;AAEE;EAAA,kBAAyB;EAAzB;AAAyB;AAGzB;EAAA,mBAAmB;EAAnB;AAAmB;;AAtKvB,kJAAkJ;;AA4BlJ,gDAAgD;AAChD;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;sFACsF;;AA8BlF;EAAA,oBAAsH;EAAtH,mBAAsH;EAAtH;AAAsH;;AAAtH;EAAA,uBAAsH;EAAtH,8BAAsH;EAAtH,sDAAsH;EAAtH,mCAAsH;EAAtH,2DAAsH;EAAtH,uCAAsH;EAAtH;AAAsH;;AAAtH;EAAA,qBAAsH;EAAtH,kBAAsH;EAAtH,uCAAsH;EAAtH,6DAAsH;EAAtH,oBAAsH;EAAtH,6BAAsH;EAAtH;AAAsH;;AAAtH;EAAA,kBAAsH;EAAtH,qCAAsH;EAAtH;AAAsH;;AAAtH;EAAA,8BAAsH;EAAtH,mBAAsH;EAAtH,2GAAsH;EAAtH,yGAAsH;EAAtH,oGAAsH;EAAtH,oGAAsH;EAAtH,oBAAsH;EAAtH;AAAsH;;AAxE1H;EAAA;IAAA,kBAsLA;IAtLA,mDAsLA;IAtLA,oEAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA,YAsLA;IAtLA,WAsLA;IAtLA,MAsLA;IAtLA,QAsLA;IAtLA,SAsLA;IAtLA;EAsLA;AAAA;;AAtLA;EAAA;IAAA,kBAsLA;IAtLA,mDAsLA;IAtLA,oEAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA,YAsLA;IAtLA,WAsLA;IAtLA,MAsLA;IAtLA,QAsLA;IAtLA,SAsLA;IAtLA;EAsLA;AAAA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2GAsLA;EAtLA,yGAsLA;EAtLA,oGAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,iBAsLA;EAtLA,iBAsLA;EAtLA,mKAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,gCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,+BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,+BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,kCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,mCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,uCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,sCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,mEAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,mEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,kEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,kEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,kEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,uEAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8EAsLA;EAtLA,uEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sEAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,6EAsLA;EAtLA,sEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,yEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,qEAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4EAsLA;EAtLA,qEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,4DAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,wEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oEAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,0EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2EAsLA;EAtLA,oEAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,yBAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,wBAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,wBAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,4BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,2BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,4CAsLA;EAtLA,uDAsLA;EAtLA,iFAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,iCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2BAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2BAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA,8BAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2GAsLA;EAtLA,yGAsLA;EAtLA,gFAsLA;EAtLA;AAsLA;;AAtLA;EAAA,2GAsLA;EAtLA,yGAsLA;EAtLA,oGAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,2GAsLA;EAtLA,yGAsLA;EAtLA,oGAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,eAsLA;EAtLA,eAsLA;EAtLA,+JAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,oCAsLA;EAtLA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,qCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,6BAsLA;EAtLA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA,oBAsLA;EAtLA,0BAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,8KAsLA;EAtLA;AAsLA;;AAtLA;EAAA,sBAsLA;EAtLA,8KAsLA;EAtLA;AAsLA;;AAtLA;EAAA,kBAsLA;EAtLA,wCAsLA;EAtLA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;AAsLA;;AAtLA;EAAA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,oBAsLA;IAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,8BAsLA;IAtLA,sDAsLA;IAtLA,mCAsLA;IAtLA,2DAsLA;IAtLA,uCAsLA;IAtLA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,+BAsLA;IAtLA,uDAsLA;IAtLA,oCAsLA;IAtLA,4DAsLA;IAtLA,wCAsLA;IAtLA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,+BAsLA;IAtLA,uDAsLA;IAtLA,oCAsLA;IAtLA,4DAsLA;IAtLA,wCAsLA;IAtLA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,+BAsLA;IAtLA,uDAsLA;IAtLA,mCAsLA;IAtLA,2DAsLA;IAtLA,4BAsLA;IAtLA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,gCAsLA;IAtLA,wDAsLA;IAtLA,oCAsLA;IAtLA,4DAsLA;IAtLA,6BAsLA;IAtLA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,kCAsLA;IAtLA,0DAsLA;IAtLA,sCAsLA;IAtLA,8DAsLA;IAtLA,+BAsLA;IAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA;EAsLA;EAtLA;IAAA,oBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,mBAsLA;IAtLA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA;EAsLA;EAtLA;IAAA,mBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,mBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,qBAsLA;IAtLA,6KAsLA;IAtLA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA,iBAsLA;IAtLA,mKAsLA;IAtLA;EAsLA;AAAA;;AAtLA;EAAA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,gBAsLA;IAtLA;EAsLA;EAtLA;IAAA,gBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,eAsLA;SAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,uBAsLA;SAtLA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,+BAsLA;IAtLA,uDAsLA;IAtLA,oCAsLA;IAtLA,4DAsLA;IAtLA,wCAsLA;IAtLA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,4BAsLA;IAtLA,oDAsLA;IAtLA,iCAsLA;IAtLA,yDAsLA;IAtLA,qCAsLA;IAtLA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,kCAsLA;IAtLA,0DAsLA;IAtLA,sCAsLA;IAtLA,8DAsLA;IAtLA,+BAsLA;IAtLA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,gCAsLA;IAtLA,wDAsLA;IAtLA,oCAsLA;IAtLA,4DAsLA;IAtLA,6BAsLA;IAtLA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,gCAsLA;IAtLA,wDAsLA;IAtLA,oCAsLA;IAtLA,4DAsLA;IAtLA,6BAsLA;IAtLA;EAsLA;EAtLA;IAAA,wBAsLA;IAtLA,iCAsLA;IAtLA,0DAsLA;IAtLA,sCAsLA;IAtLA,+DAsLA;IAtLA,0CAsLA;IAtLA;EAsLA;EAtLA;IAAA,wBAsLA;IAtLA,qCAsLA;IAtLA,8DAsLA;IAtLA,yCAsLA;IAtLA,kEAsLA;IAtLA,kCAsLA;IAtLA;EAsLA;EAtLA;IAAA,6BAsLA;IAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,sBAsLA;IAtLA,oCAsLA;IAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,oBAsLA;IAtLA;EAsLA;EAtLA;IAAA,oBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,qBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,qBAsLA;IAtLA;EAsLA;EAtLA;IAAA,oBAsLA;IAtLA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA;EAsLA;EAtLA;IAAA,mBAsLA;IAtLA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA;EAsLA;EAtLA;IAAA,mBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,eAsLA;IAtLA;EAsLA;EAtLA;IAAA,eAsLA;IAtLA;EAsLA;EAtLA;IAAA,mBAsLA;IAtLA;EAsLA;EAtLA;IAAA,mBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,oBAsLA;IAtLA,6BAsLA;IAtLA;EAsLA;AAAA;;AAtLA;EAAA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA;EAsLA;EAtLA;IAAA,mBAsLA;IAtLA;EAsLA;EAtLA;IAAA,oBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,gBAsLA;IAtLA;EAsLA;EAtLA;IAAA,gBAsLA;IAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,wBAsLA;IAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,sBAsLA;IAtLA,8KAsLA;IAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,qBAsLA;SAtLA;EAsLA;EAtLA;IAAA,qBAsLA;SAtLA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,+BAsLA;IAtLA,uDAsLA;IAtLA,oCAsLA;IAtLA,4DAsLA;IAtLA,wCAsLA;IAtLA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,8BAsLA;IAtLA,sDAsLA;IAtLA,mCAsLA;IAtLA,2DAsLA;IAtLA,uCAsLA;IAtLA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,4BAsLA;IAtLA,oDAsLA;IAtLA,iCAsLA;IAtLA,yDAsLA;IAtLA,qCAsLA;IAtLA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,kCAsLA;IAtLA,0DAsLA;IAtLA,sCAsLA;IAtLA,8DAsLA;IAtLA,+BAsLA;IAtLA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,gCAsLA;IAtLA,wDAsLA;IAtLA,oCAsLA;IAtLA,4DAsLA;IAtLA,6BAsLA;IAtLA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,kCAsLA;IAtLA,0DAsLA;IAtLA,sCAsLA;IAtLA,8DAsLA;IAtLA,+BAsLA;IAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA,wCAsLA;IAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA,wCAsLA;IAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA;EAsLA;EAtLA;IAAA,oBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,qBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,qBAsLA;IAtLA;EAsLA;EAtLA;IAAA,oBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,gBAsLA;IAtLA;EAsLA;EAtLA;IAAA,mBAsLA;IAtLA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA;EAsLA;EAtLA;IAAA,oBAsLA;IAtLA;EAsLA;EAtLA;IAAA,mBAsLA;IAtLA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA;EAsLA;EAtLA;IAAA,mBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,eAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,mBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,mFAsLA;IAtLA,mGAsLA;IAtLA,wHAsLA;IAtLA;EAsLA;AAAA;;AAtLA;EAAA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,eAsLA;SAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,qBAsLA;SAtLA;EAsLA;EAtLA;IAAA,uBAsLA;IAtLA,4BAsLA;IAtLA,oDAsLA;IAtLA,iCAsLA;IAtLA,yDAsLA;IAtLA,qCAsLA;IAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA;EAsLA;EAtLA;IAAA,mBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;EAtLA;IAAA,iBAsLA;IAtLA;EAsLA;EAtLA;IAAA,eAsLA;IAtLA;EAsLA;EAtLA;IAAA,mBAsLA;IAtLA;EAsLA;EAtLA;IAAA,kBAsLA;IAtLA;EAsLA;AAAA;;AAtLA;EAAA;IAAA;EAsLA;EAtLA;IAAA;EAsLA;AAAA","sourcesContent":["@import '@bcgov/bc-sans/css/BCSans.css';\n\n/* See Tailwind docs for distinction between base, components, and utilities - https://tailwindcss.com/docs/adding-custom-styles#using-css-and-layer */\n@import 'tailwindcss/base';\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n\n/* Changes to wysiwyg classes need to be mirrored in the function passed to the editor e.g.`frontend/app_v2/src/components/Form/WysiwygField.js` */\n@layer base {\n  .wysiwyg {\n    @apply text-left;\n  }\n  .wysiwyg h2 {\n    @apply border-b border-charcoal-500 font-bold my-6 py-5 text-2xl text-blumine-800;\n  }\n  .wysiwyg h3 {\n    @apply font-bold my-4 text-xl text-blumine-800;\n  }\n  .wysiwyg ol {\n    @apply list-decimal pl-6;\n  }\n  .wysiwyg ul {\n    @apply list-disc pl-6;\n  }\n  .wysiwyg div {\n    @apply my-4;\n  }\n  .wysiwyg p {\n    @apply my-4;\n  }\n  .wysiwyg a {\n    @apply text-blue-600 visited:text-purple-600 underline underline-offset-2;\n  }\n}\n\n/* Prevent blue focus outline in tiptap editor */\n.wysiwyg .ProseMirror:focus {\n  outline: none;\n  box-shadow: none;\n}\n\n/* These component rules can be over-ridden using utility classes. \nFor example over-ride the colour of the btn-contained backgound using bg-scarlet-800 */\n@layer components {\n  .ql-video {\n    @apply w-full h-96;\n  }\n  .inline-url {\n    @apply text-blue-600 visited:text-purple-600 underline underline-offset-2;\n  }\n  .btn-contained {\n    @apply rounded-lg shadow-sm py-2 px-4 inline-flex justify-center items-center space-x-2 text-sm font-medium bg-blumine-800 border border-transparent text-white hover:opacity-80 active:opacity-100;\n  }\n  .btn-outlined {\n    @apply rounded-lg shadow-sm py-2 px-4 inline-flex justify-center items-center space-x-2 text-sm font-medium bg-white border border-blumine-800 text-blumine-800 hover:bg-charcoal-50 active:bg-white;\n  }\n  .btn-icon {\n    @apply fill-current h-5 w-5;\n  }\n\n  /* Button base class */\n  .btn {\n    @apply rounded-3xl inline-flex justify-center items-center space-x-2;\n  }\n\n  /* Button base class for icon only buttons */\n  .btn-icon-base {\n    @apply rounded-full inline-flex justify-center items-center;\n  }\n\n  /* Button styles */\n  .btn-primary {\n    @apply btn bg-blumine-600 text-blumine-100 hover:bg-blumine-800 focus:outline-none focus:ring-2 focus:ring-blumine-300;\n  }\n  .btn-secondary {\n    @apply btn bg-white border border-blumine-900 text-blumine-900 hover:bg-blumine-100 focus:bg-blumine-200 focus:outline-none focus:ring-2 focus:ring-blumine-900;\n  }\n  .btn-tertiary {\n    @apply btn bg-white text-blumine-900 hover:bg-blumine-100 focus:bg-blumine-200 focus:outline-none focus:ring-2 focus:ring-blumine-900 m-1;\n  }\n\n  /* Button sizes */\n  /* Combine with btn-primary, btn-secondary, or btn-tertiary */\n  .btn-sm {\n    @apply py-1.5 px-3\n           text-xs min-w-24 h-9 /* Mobile and tablet ~(88x36) 12px font */\n           xl:text-sm xl:min-w-32 xl:h-8; /* Desktop ~(120x32) 14px font */\n  }\n  .btn-md {\n    @apply py-2 px-3\n           text-base min-w-32 h-11 /* Mobile and tablet ~(120x44) 16px font */\n           xl:text-base xl:min-w-40 xl:h-10; /* Desktop ~(160x40) 16px font */\n  }\n  .btn-lg {\n    @apply py-2 px-3\n           text-base min-w-40 h-14 /* Mobile and tablet ~(160x52) 16px font */\n           xl:text-lg xl:min-w-52 xl:h-12; /* Desktop ~(200x48) 18px font */\n  }\n  .btn-xl {\n    @apply py-3 px-5\n           text-lg min-w-52 h-16 /* Mobile and tablet ~(200x60) 18px font */\n           xl:text-xl xl:min-w-80 xl:h-14; /* Desktop ~(300x56) 22px font */\n  }\n\n  /* Icon only buttons */\n  .btn-sm-icon {\n    @apply btn-icon-base\n           w-11 h-11 /* Mobile and tablet ~44x44 */\n           xl:w-8 xl:h-8; /* Desktop ~32x32 */\n  }\n  .btn-md-icon {\n    @apply btn-icon-base\n           w-12 h-12 /* Mobile ~48x48 */\n           md:w-14 md:h-14 /* Tablet ~56x56 */\n           xl:w-10 xl:h-10; /* Desktop ~40x40 */\n  }\n  .btn-lg-icon {\n    @apply btn-icon-base\n           w-14 h-14 /* Mobile ~56x56 */\n           md:w-16 md:h-16 /* Tablet ~64x64 */\n           xl:w-12 xl:h-12; /* Desktop ~48x48 */\n  }\n  .btn-xl-icon {\n    @apply btn-icon-base\n           w-16 h-16 /* Mobile ~64x64 */\n           md:w-20 md:h-20 /* Tablet ~72x72 */\n           xl:w-14 xl:h-14 /* Desktop ~56x56 */;\n  }\n\n  /* Auto-formatting for icons on buttons with text (Do not use directly) */\n  .btn-sm svg {\n    @apply fill-current w-3.5 h-3.5; /* All ~14px */\n  }\n  .btn-md svg {\n    @apply fill-current w-4 h-4; /* All ~16px */\n  }\n  .btn-lg svg {\n    @apply fill-current w-5 h-5; /* All ~20px */\n  }\n  .btn-xl svg {\n    @apply fill-current\n           w-5 h-5 /* Mobile and tablet ~18px */\n           xl:w-6 xl:h-6; /* Desktop ~22px */\n  }\n\n  /* Auto-formatting for icon-only buttons (Do not use directly) */\n  .btn-icon-base svg {\n    @apply block align-middle w-full h-full p-0 m-0;\n  }\n  .btn-sm-icon svg {\n    @apply fill-current\n           w-5 h-5 /* Mobile and tablet ~20px */\n           xl:w-3 xl:h-3; /* Desktop ~12px */\n  }\n  .btn-md-icon svg {\n    @apply fill-current w-6 h-6; /* All ~24px */\n  }\n  .btn-lg-icon svg {\n    @apply fill-current w-7 h-7; /* All ~28px */\n  }\n  .btn-xl-icon svg {\n    @apply fill-current w-8 h-8; /* All ~32px */\n  }\n}\n\n@layer utilities {\n  .breakAfter {\n    page-break-after: always;\n  }\n  .tooltip {\n    @apply invisible absolute;\n  }\n  .has-tooltip:hover .tooltip {\n    @apply visible z-50;\n  }\n  .uppy-Root label {\n    font-family: 'BCSans', sans-serif;\n  }\n  .uppy-Root .uppy-u-reset {\n    font-family: 'BCSans', sans-serif;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
